import * as React$2 from 'react';
import React__default, { Component, useState, forwardRef, useEffect, useMemo, useCallback, createRef, PureComponent, Children, isValidElement, cloneElement, useRef, createContext, createElement, useContext, useLayoutEffect, Fragment, memo, useDebugValue } from 'react';
import reactIs, { Memo, ForwardRef, isFragment } from 'react-is';
import HomeIcon from '@material-ui/icons/Home';
import moment from 'moment';
import * as ReactDOM from 'react-dom';
import ReactDOM__default from 'react-dom';
import get from 'lodash/get';
import { ResponsiveContainer, AreaChart, CartesianGrid, XAxis, YAxis, Tooltip as Tooltip$2, Area, PieChart, Pie, Sector, BarChart, Bar, Legend, Text, Cell } from 'recharts';
import _, { get as get$1 } from 'lodash';
import PersonIcon from '@material-ui/icons/Person';
import { HttpService as HttpService$1, API as API$1 } from '@piiqtechnologies/components-library';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var defineProperty$2 = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _defineProperty$1 = unwrapExports(defineProperty$2);

var classCallCheck$1 = createCommonjsModule(function (module) {
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _classCallCheck$1 = unwrapExports(classCallCheck$1);

var createClass$1 = createCommonjsModule(function (module) {
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _createClass$1 = unwrapExports(createClass$1);

var assertThisInitialized = createCommonjsModule(function (module) {
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _assertThisInitialized$3 = unwrapExports(assertThisInitialized);

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(setPrototypeOf);

var inherits = createCommonjsModule(function (module) {
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _inherits$1 = unwrapExports(inherits);

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _typeof$2 = unwrapExports(_typeof_1);

var possibleConstructorReturn = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _possibleConstructorReturn$1 = unwrapExports(possibleConstructorReturn);

var getPrototypeOf$1 = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _getPrototypeOf$1 = unwrapExports(getPrototypeOf$1);

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$1.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$1) {
			symbols = getOwnPropertySymbols$1(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

var printWarning$2 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$2(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var require$$1 = factoryWithTypeCheckers;

var require$$2 = factoryWithThrowingShims;

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2();
}
});

var PropTypes = propTypes;
var propTypes_1 = propTypes.func;
var propTypes_2 = propTypes.oneOfType;
var propTypes_3 = propTypes.object;
var propTypes_4 = propTypes.string;
var propTypes_5 = propTypes.element;
var propTypes_6 = propTypes.arrayOf;
var propTypes_7 = propTypes.node;
var propTypes_8 = propTypes.bool;
propTypes.isFragment;
var propTypes_10 = propTypes.oneOf;
var propTypes_11 = propTypes.number;
var propTypes_12 = propTypes.any;
var propTypes_13 = propTypes.instanceOf;
var propTypes_14 = propTypes.elementType;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$K = ".icon {\n  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(2deg) brightness(102%) contrast(104%); }\n\n.selected svg g {\n  fill: \"#04d2c6\"; }\n\n.dimensions {\n  width: 33px;\n  height: 22px;\n  margin-right: 2.09%; }\n";
styleInject(css_248z$K);

var img$6 = "data:image/svg+xml,%3csvg width='2' height='35' viewBox='0 0 2 35' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 0L1 35' stroke='%23C5C5C5' strokeWidth='0.5'/%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3csvg width='63' height='12' viewBox='0 0 63 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d)'%3e%3cpath d='M3.76 1H1.14V8H1.88V5.79H3.76C5.54 5.79 6.62 4.89 6.62 3.4C6.62 1.9 5.54 1 3.76 1ZM3.74 5.14H1.88V1.64H3.74C5.14 1.64 5.88 2.28 5.88 3.4C5.88 4.5 5.14 5.14 3.74 5.14ZM10.4908 8.05C12.0308 8.05 13.1608 6.93 13.1608 5.37C13.1608 3.81 12.0308 2.7 10.4908 2.7C8.95078 2.7 7.81078 3.81 7.81078 5.37C7.81078 6.93 8.95078 8.05 10.4908 8.05ZM10.4908 7.42C9.37078 7.42 8.53078 6.6 8.53078 5.37C8.53078 4.14 9.37078 3.32 10.4908 3.32C11.6108 3.32 12.4408 4.14 12.4408 5.37C12.4408 6.6 11.6108 7.42 10.4908 7.42ZM21.8338 2.74L20.1638 7.21L18.4838 2.74H17.8738L16.1838 7.21L14.5338 2.74H13.8538L15.8338 8H16.5038L18.1638 3.69L19.8238 8H20.4938L22.4838 2.74H21.8338ZM28.2964 5.37C28.2964 3.79 27.2264 2.7 25.7464 2.7C24.2664 2.7 23.1764 3.81 23.1764 5.37C23.1764 6.93 24.2964 8.05 25.9364 8.05C26.7664 8.05 27.4964 7.75 27.9664 7.19L27.5664 6.73C27.1664 7.19 26.5964 7.42 25.9564 7.42C24.8064 7.42 23.9664 6.69 23.8864 5.59H28.2864C28.2864 5.51 28.2964 5.43 28.2964 5.37ZM25.7464 3.31C26.7764 3.31 27.5264 4.03 27.6164 5.06H23.8864C23.9764 4.03 24.7264 3.31 25.7464 3.31ZM30.7216 3.77V2.74H30.0416V8H30.7516V5.32C30.7516 4.08 31.4216 3.38 32.5216 3.38C32.5716 3.38 32.6316 3.39 32.6916 3.39V2.7C31.7216 2.7 31.0516 3.07 30.7216 3.77ZM38.8183 5.37C38.8183 3.79 37.7483 2.7 36.2683 2.7C34.7883 2.7 33.6983 3.81 33.6983 5.37C33.6983 6.93 34.8183 8.05 36.4583 8.05C37.2883 8.05 38.0183 7.75 38.4883 7.19L38.0883 6.73C37.6883 7.19 37.1183 7.42 36.4783 7.42C35.3283 7.42 34.4883 6.69 34.4083 5.59H38.8083C38.8083 5.51 38.8183 5.43 38.8183 5.37ZM36.2683 3.31C37.2983 3.31 38.0483 4.03 38.1383 5.06H34.4083C34.4983 4.03 35.2483 3.31 36.2683 3.31ZM44.6534 0.58V3.74C44.2134 3.06 43.4934 2.7 42.6534 2.7C41.1534 2.7 40.0334 3.78 40.0334 5.37C40.0334 6.96 41.1534 8.05 42.6534 8.05C43.5234 8.05 44.2534 7.67 44.6834 6.96V8H45.3634V0.58H44.6534ZM42.7134 7.42C41.5934 7.42 40.7534 6.6 40.7534 5.37C40.7534 4.14 41.5934 3.32 42.7134 3.32C43.8234 3.32 44.6634 4.14 44.6634 5.37C44.6634 6.6 43.8234 7.42 42.7134 7.42ZM53.268 2.7C52.428 2.7 51.708 3.06 51.268 3.74V0.58H50.558V8H51.238V6.96C51.668 7.67 52.398 8.05 53.268 8.05C54.768 8.05 55.888 6.96 55.888 5.37C55.888 3.78 54.768 2.7 53.268 2.7ZM53.218 7.42C52.098 7.42 51.258 6.6 51.258 5.37C51.258 4.14 52.098 3.32 53.218 3.32C54.328 3.32 55.178 4.14 55.178 5.37C55.178 6.6 54.328 7.42 53.218 7.42ZM61.2088 2.74L59.2288 7.21L57.2488 2.74H56.5088L58.8588 7.99L58.6288 8.5C58.3288 9.16 58.0088 9.38 57.5388 9.38C57.1588 9.38 56.8388 9.24 56.5788 8.98L56.2488 9.51C56.5688 9.83 57.0388 9.99 57.5288 9.99C58.2788 9.99 58.8388 9.66 59.2788 8.63L61.9088 2.74H61.2088Z' fill='white' fillOpacity='0.66'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d' x='0.139893' y='0.579956' width='62.7688' height='11.41' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'%3e%3cfeFlood floodOpacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3e%3cfeOffset dy='1'/%3e%3cfeGaussianBlur stdDeviation='0.5'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M6.00354 10.8013C8.81624 10.8013 11.0964 8.56951 11.0964 5.81645C11.0964 3.06339 8.81624 0.831596 6.00354 0.831596C3.19085 0.831596 0.910706 3.06339 0.910706 5.81645C0.910706 8.56951 3.19085 10.8013 6.00354 10.8013Z' fill='white' stroke='white' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/%3e%3c/svg%3e";

var getIconSourceBase64Image = function getIconSourceBase64Image(name, color, width, height, fillOpacity, isActive) {
  switch (name) {
    case "bar":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "33",
        height: height && height || "22",
        viewBox: "0 0 33 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M0 22H33V18.3333H0V22ZM0 12.8333H33V9.16667H0V12.8333ZM0 0V3.66667H33V0H0Z",
        fill: color && color || "white"
      }));

    case "expand":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "49",
        height: height && height || "36",
        viewBox: "0 0 49 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("g", {
        filter: "url(#filter0_d)"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M44.0196 24.1176V29.0812C44.0196 30.6933 42.726 32 41.13 32H34.3932",
        stroke: "white",
        strokeWidth: "2",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M34.5361 4H41.1301C42.7261 4 44.0197 5.30667 44.0197 6.91879V12.8667",
        stroke: "white",
        strokeWidth: "2",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M4.54004 12.8667V6.91879C4.54004 5.30667 5.83364 4 7.42964 4H12.352",
        stroke: "white",
        strokeWidth: "2",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M12.352 31.9999H7.42964C5.83364 31.9999 4.54004 30.6932 4.54004 29.0811V24.2617",
        stroke: "white",
        strokeWidth: "2",
        strokeMiterlimit: "10"
      })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("filter", {
        id: "filter0_d",
        x: "0.540039",
        y: "0",
        width: "47.4797",
        height: "36",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      }, /*#__PURE__*/React__default.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/React__default.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), /*#__PURE__*/React__default.createElement("feOffset", null), /*#__PURE__*/React__default.createElement("feGaussianBlur", {
        stdDeviation: "1.5"
      }), /*#__PURE__*/React__default.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
      }), /*#__PURE__*/React__default.createElement("feBlend", {
        mode: "multiply",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
      }), /*#__PURE__*/React__default.createElement("feBlend", {
        mode: "normal",
        "in": "SourceGraphic",
        in2: "effect1_dropShadow",
        result: "shape"
      }))));

    case "info":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "17",
        height: height || "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z",
        stroke: color || "white",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M8.5 5.5V8.5",
        stroke: color || "white",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("circle", {
        cx: "8.5",
        cy: "11.5",
        r: "0.75",
        fill: color || "white"
      }));

    case "location":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "24",
        height: height && height || "33",
        viewBox: "0 0 24 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("g", {
        clipPath: "url(#clip0)"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M23.2927 12.0934C23.2927 5.98694 18.2423 1.03671 12.0035 1.03671C5.76481 1.03671 0.707336 5.98694 0.707336 12.0934C0.707336 14.0181 1.20955 15.8251 2.09372 17.4036L2.10787 17.4521L12.0035 31.6589L21.8851 17.4452V17.4383C22.7834 15.8528 23.2927 14.0319 23.2927 12.0934Z",
        stroke: color && color || "white",
        strokeWidth: "2",
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M12.0035 16.8013C14.8162 16.8013 17.0964 14.5695 17.0964 11.8165C17.0964 9.06339 14.8162 6.8316 12.0035 6.8316C9.19085 6.8316 6.91071 9.06339 6.91071 11.8165C6.91071 14.5695 9.19085 16.8013 12.0035 16.8013Z",
        fill: color && color || "white",
        stroke: color && color || "white",
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
        id: "clip0"
      }, /*#__PURE__*/React__default.createElement("rect", {
        width: width && width || "24",
        height: height && height || "33",
        fill: color && color || "white",
        transform: "translate(0 0.34436)"
      }))));

    case "mobileLocation":
      {
        var viewbox = "0 0 ".concat(width && width || "13").concat(" ").concat(height && height || "17");
        return /*#__PURE__*/React__default.createElement("svg", {
          width: width && width || "13",
          height: height && height || "17",
          viewBox: viewbox,
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React__default.createElement("path", {
          d: "M12 6.41595C12 3.42476 9.54024 0.999939 6.50172 0.999939C3.4632 0.999939 1 3.42476 1 6.41595C1 7.35874 1.2446 8.24389 1.67523 9.01712L1.68212 9.04086L6.50172 15.9999L11.3144 9.03747V9.03408C11.752 8.25746 12 7.36553 12 6.41595Z",
          stroke: "white",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/React__default.createElement("path", {
          d: "M6.5 8.99994C7.88071 8.99994 9 7.88065 9 6.49994C9 5.11923 7.88071 3.99994 6.5 3.99994C5.11929 3.99994 4 5.11923 4 6.49994C4 7.88065 5.11929 8.99994 6.5 8.99994Z",
          fill: "white",
          stroke: "white",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }

    case "seperator":
      return img$6;

    case "crop":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "35",
        height: "35",
        viewBox: "0 0 35 35",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M25.4545 22.2727H28.6364V9.54545C28.6364 7.79545 27.2045 6.36364 25.4545 6.36364H12.7273V9.54545H25.4545V22.2727ZM9.54545 25.4545V0H6.36364V6.36364H0V9.54545H6.36364V25.4545C6.36364 27.2045 7.79545 28.6364 9.54545 28.6364H25.4545V35H28.6364V28.6364H35V25.4545H9.54545Z",
        fill: "white"
      }));

    case "powered":
      return img$5;

    case "brand":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "59",
        height: height && height || "23",
        viewBox: "0 0 59 23",
        fill: color || "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M44.4294 10.0317C44.3274 9.44228 44.1595 8.86646 43.9258 8.30084C43.3942 7.04219 42.5268 6.0774 41.3221 5.40816C40.1173 4.73892 38.6492 4.4043 36.9129 4.4043C35.2555 4.4043 33.8088 4.71853 32.5744 5.34871C31.3384 5.97888 30.4562 6.9063 29.9246 8.13268C29.737 8.53694 29.6004 8.96838 29.5148 9.42699C29.5132 9.43888 29.5115 9.45077 29.5099 9.46266C29.4128 9.07029 29.286 8.68302 29.128 8.30254C28.5964 7.04389 27.7291 6.0791 26.5243 5.40986C25.3196 4.74062 23.8515 4.406 22.1151 4.406C20.4578 4.406 19.0111 4.72023 17.7767 5.35041C16.5407 5.98058 15.6585 6.908 15.1269 8.13438C14.9903 8.42823 14.8817 8.73737 14.7994 9.0601C14.699 8.5828 14.5591 8.13607 14.3764 7.72332C13.9221 6.65831 13.2473 5.8396 12.3471 5.26717C11.4484 4.69475 10.3885 4.40769 9.16896 4.40769C7.7486 4.40769 6.56689 4.80516 5.62383 5.60179C5.34239 5.8396 4.92435 5.63747 4.92435 5.26208C4.92435 5.01748 4.73178 4.81875 4.49478 4.81875H1.264C0.566168 4.81535 0 5.39966 0 6.11986V20.6971C0 21.4173 0.566168 22.0016 1.264 22.0016H3.78049C4.47832 22.0016 5.04449 21.4173 5.04449 20.6971V18.2528C5.04449 17.2999 5.9892 16.7003 6.8401 17.0706C7.52971 17.3712 8.30819 17.5224 9.17225 17.5224C10.377 17.5224 11.432 17.232 12.3388 16.6511C13.2457 16.0701 13.9254 15.248 14.3797 14.183C14.564 13.7652 14.7039 13.315 14.806 12.8343C14.885 13.1554 14.9837 13.4594 15.1071 13.7465C15.6388 14.9729 16.5489 15.9088 17.8392 16.5542C19.1296 17.1997 20.6569 17.5224 22.4245 17.5224C25.0974 17.5224 27.0674 16.9092 28.3347 15.6829C28.5783 15.4468 28.7906 15.1971 28.9717 14.9338C29.5 14.1609 28.97 13.0942 28.055 13.0942H25.1369C24.8258 13.0942 24.551 13.259 24.3485 13.5019C24.314 13.5443 24.2745 13.5851 24.2317 13.6259C24.0589 13.7872 23.8136 13.9078 23.4927 13.9894C23.1718 14.0709 22.8245 14.11 22.4492 14.11C21.7925 14.11 21.2445 14.0098 20.8083 13.8076C20.3705 13.6055 20.0578 13.2879 19.8702 12.8513C19.8077 12.707 19.7451 12.4725 19.6826 12.1498H28.6211C28.9404 12.1498 29.2268 12.0122 29.4325 11.7931C29.5016 12.5116 29.658 13.1639 29.9082 13.7465C30.4398 14.9729 31.3499 15.9088 32.6403 16.5542C33.9306 17.1997 35.4579 17.5224 37.2256 17.5224C39.8984 17.5224 41.8685 16.9092 43.1358 15.6829C43.5209 15.3109 43.827 14.9015 44.0558 14.4582C44.3734 13.8399 43.9077 13.0942 43.2296 13.0942H39.905C39.6153 13.0942 39.3536 13.2437 39.1709 13.4764C39.1298 13.5274 39.0837 13.5783 39.0327 13.6259C38.8599 13.7872 38.6146 13.9078 38.2937 13.9894C37.9728 14.0709 37.6255 14.11 37.2502 14.11C36.5936 14.11 36.0455 14.0098 35.6093 13.8076C35.1716 13.6055 34.8588 13.2879 34.6712 12.8513C34.6087 12.707 34.5461 12.4725 34.4836 12.1498H43.6443C44.1776 12.1498 44.5956 11.6793 44.5611 11.129C44.5265 10.7264 44.4854 10.3612 44.4294 10.0317ZM9.4504 12.3927C9.07515 13.2148 8.36415 13.6276 7.31575 13.6276C6.59652 13.6276 6.02541 13.4102 5.60408 12.9736C5.1811 12.5371 4.97043 11.9239 4.97043 11.1341V10.7468C4.97043 9.93997 5.1811 9.32338 5.60408 8.89534C6.02541 8.4673 6.59652 8.25328 7.31575 8.25328C8.3625 8.25328 9.07515 8.66433 9.4504 9.48814C9.60676 9.82616 9.68576 10.3187 9.68576 10.9642C9.68576 11.5774 9.60676 12.053 9.4504 12.3927ZM19.676 9.6563C19.7073 9.41341 19.778 9.16371 19.8867 8.90553C20.0743 8.51825 20.3672 8.21931 20.7655 8.01038C21.1638 7.80145 21.6362 7.69614 22.1842 7.69614C22.7619 7.69614 23.2557 7.80145 23.6622 8.01038C24.0687 8.221 24.3584 8.52675 24.5296 8.92931C24.6382 9.17221 24.7007 9.41341 24.7172 9.6563H19.676ZM34.4737 9.6563C34.505 9.41341 34.5758 9.16371 34.6844 8.90553C34.872 8.51825 35.165 8.21931 35.5633 8.01038C35.9616 7.80145 36.4339 7.69614 36.982 7.69614C37.5597 7.69614 38.0534 7.80145 38.4599 8.01038C38.8665 8.221 39.1561 8.52675 39.3273 8.92931C39.4359 9.17221 39.4985 9.41341 39.5149 9.6563H34.4737Z",
        fill: color || "white",
        fillOpacity: fillOpacity && fillOpacity || "0.51"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M58.8289 15.914L54.4987 10.8064C54.2617 10.5261 54.2748 10.1065 54.5283 9.84157L58.1969 6.02146C58.6264 5.57474 58.3187 4.81547 57.7097 4.81547H53.3005C53.1096 4.81547 52.9269 4.8987 52.7969 5.04308L50.8844 7.18499C50.4614 7.65889 49.6945 7.34975 49.6945 6.70599V0.708308C49.6945 0.317634 49.3883 0 49.0081 0H45.3379C44.9594 0 44.6516 0.317634 44.6516 0.708308V16.3811C44.6516 16.7718 44.9594 17.0894 45.3379 17.0894H49.0081C49.3867 17.0894 49.6945 16.7718 49.6945 16.3811V14.3326C49.6945 13.6634 50.5091 13.3678 50.9157 13.8893L53.1952 16.821C53.3252 16.9892 53.5227 17.086 53.7301 17.086H58.3154C58.9029 17.0877 59.2173 16.3709 58.8289 15.914Z",
        fill: color || "white",
        fillOpacity: fillOpacity && fillOpacity || "0.51"
      }));

    case "round":
      return img$4;

    case "hotspot":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "38",
        height: height && height || "38",
        viewBox: "0 0 38 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("circle", {
        cx: "19",
        cy: "19",
        r: "19",
        transform: "rotate(-180 19 19)",
        fill: "#04D2C6",
        fillOpacity: "0.7"
      }), /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.9167 17.9082V24.4166H18.0833V17.9082C15.9913 17.4836 14.4167 15.634 14.4167 13.4166C14.4167 10.8853 16.4687 8.83325 19 8.83325C21.5313 8.83325 23.5833 10.8853 23.5833 13.4166C23.5833 15.634 22.0087 17.4836 19.9167 17.9082ZM16.25 19.9774V21.8356C13.5616 22.1712 11.6667 22.9378 11.6667 23.4999C11.6667 24.2396 14.9476 25.3333 19 25.3333C23.0525 25.3333 26.3333 24.2396 26.3333 23.4999C26.3333 22.9378 24.4384 22.1712 21.75 21.8356V19.9774C25.4679 20.3848 28.1667 21.6371 28.1667 23.4999C28.1667 25.7978 24.0603 27.1666 19 27.1666C13.9398 27.1666 9.83334 25.7978 9.83334 23.4999C9.83334 21.6371 12.5321 20.3848 16.25 19.9774ZM21.75 13.4166C21.75 14.9354 20.5188 16.1666 19 16.1666C17.4812 16.1666 16.25 14.9354 16.25 13.4166C16.25 11.8978 17.4812 10.6666 19 10.6666C20.5188 10.6666 21.75 11.8978 21.75 13.4166Z",
        fill: color && color || "white"
      }));

    case "bathroom":
      return /*#__PURE__*/React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width && width || "19",
        height: height && height || "16",
        viewBox: "0 0 19 16",
        fill: "none"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M13.1619 16H5.26385C2.47868 16 0.212891 13.5529 0.212891 10.5449V8H18.2129V10.5449C18.2129 13.5529 15.9471 16 13.1619 16ZM1.1659 9.02927V10.5449C1.1659 12.9868 3.00521 14.9707 5.26385 14.9707H13.1595C15.4206 14.9707 17.2575 12.9842 17.2575 10.5449V9.02927H1.1659Z",
        fill: color && color || "#04D2C6"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M16.8784 8.12411H15.7604V1.07747H12.6523C11.7775 1.07747 11.0648 1.76435 11.0648 2.60747H9.94678C9.94678 1.16905 11.1598 0 12.6523 0H16.8784V8.12411Z",
        fill: color && color || "#04D2C6"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M11.3968 3.42627H10.2788V6.39739H11.3968V3.42627Z",
        fill: color && color || "#04D2C6"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M8.90133 3.22023L7.79907 5.79492L8.83255 6.20587L9.93481 3.63118L8.90133 3.22023Z",
        fill: color && color || "#04D2C6"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M12.726 3.22127L11.6926 3.63232L12.7952 6.20673L13.8285 5.79568L12.726 3.22127Z",
        fill: color && color || "#04D2C6"
      }));

    case "bedroom":
      return /*#__PURE__*/React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width && width || "23",
        height: height && height || "14",
        viewBox: "0 0 23 14",
        fill: "none"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M19.7197 6.53876H2.84375V1.50547C2.84375 0.67506 3.49012 0 4.28523 0H18.2809C19.076 0 19.7224 0.67506 19.7224 1.50547V6.53876H19.7197ZM3.92554 5.40895H18.6379V1.50547C18.6379 1.29928 18.4783 1.12981 18.2782 1.12981H4.28523C4.08781 1.12981 3.92554 1.29645 3.92554 1.50547V5.40895Z",
        fill: color && color || "#04D2C6"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M9.55106 6.86348H6.27324C5.57549 6.86348 5.01025 6.27033 5.01025 5.54443V4.43721C5.01025 3.70849 5.57819 3.11816 6.27324 3.11816H9.55376C10.2515 3.11816 10.8168 3.71131 10.8168 4.43721V5.54443C10.8168 6.27315 10.2488 6.86348 9.55106 6.86348ZM6.27324 4.24515C6.17318 4.24515 6.09204 4.32988 6.09204 4.43439V5.5416C6.09204 5.64611 6.17318 5.73084 6.27324 5.73084H9.55376C9.65383 5.73084 9.73496 5.64611 9.73496 5.5416V4.43439C9.73496 4.32988 9.65383 4.24515 9.55376 4.24515H6.27324Z",
        fill: color && color || "#04D2C6"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M16.3716 6.86348H13.0938C12.396 6.86348 11.8308 6.27033 11.8308 5.54443V4.43721C11.8308 3.70849 12.3988 3.11816 13.0938 3.11816H16.3743C17.0721 3.11816 17.6373 3.71131 17.6373 4.43721V5.54443C17.6373 6.27315 17.0694 6.86348 16.3716 6.86348ZM13.0938 4.24515C12.9937 4.24515 12.9126 4.32988 12.9126 4.43439V5.5416C12.9126 5.64611 12.9937 5.73084 13.0938 5.73084H16.3743C16.4744 5.73084 16.5555 5.64611 16.5555 5.5416V4.43439C16.5555 4.32988 16.4744 4.24515 16.3743 4.24515H13.0938Z",
        fill: color && color || "#04D2C6"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M21.6698 13.3571V9.09493C21.6698 7.45388 20.496 6.12354 19.0519 6.12354H3.51197C2.06778 6.12354 0.894043 7.45388 0.894043 9.09493V13.3571",
        fill: color && color || "#04D2C6"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M22.2106 13.3571H21.1288V9.09489C21.1288 7.76737 20.1957 6.6884 19.049 6.6884H3.51185C2.36786 6.6884 1.43482 7.76737 1.43482 9.09489V13.3571H0.353027V9.09489C0.353027 7.14315 1.77017 5.55859 3.51185 5.55859H19.0517C20.7934 5.55859 22.2133 7.14597 22.2133 9.09489V13.3571H22.2106Z",
        fill: color && color || "#04D2C6"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M21.6698 10.7388H0.894043V11.8686H21.6698V10.7388Z",
        fill: color && color || "#04D2C6"
      }));

    case "pinlocation":
      return /*#__PURE__*/React__default.createElement("svg", {
        "_ngcontent-dqd-c5": "",
        fill: "none",
        width: width && width || "20",
        height: height && height || "20",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        "_ngcontent-dqd-c5": "",
        clipRule: "evenodd",
        d: "M10.9167 9.9083V16.4166H9.08335V9.9083C6.9913 9.48363 5.41668 7.63402 5.41668 5.41665C5.41668 2.88534 7.46871 0.833313 10 0.833313C12.5313 0.833313 14.5833 2.88534 14.5833 5.41665C14.5833 7.63402 13.0087 9.48363 10.9167 9.9083ZM7.25001 11.9775V13.8356C4.5616 14.1712 2.66668 14.9378 2.66668 15.5C2.66668 16.2397 5.94756 17.3333 10 17.3333C14.0525 17.3333 17.3333 16.2397 17.3333 15.5C17.3333 14.9378 15.4384 14.1712 12.75 13.8356V11.9775C16.4679 12.3849 19.1667 13.6371 19.1667 15.5C19.1667 17.7978 15.0603 19.1666 10 19.1666C4.93977 19.1666 0.833344 17.7978 0.833344 15.5C0.833344 13.6371 3.53212 12.3849 7.25001 11.9775ZM12.75 5.41665C12.75 6.93544 11.5188 8.16665 10 8.16665C8.48122 8.16665 7.25 6.93544 7.25 5.41665C7.25 3.89787 8.48122 2.66665 10 2.66665C11.5188 2.66665 12.75 3.89787 12.75 5.41665Z",
        fillRule: "evenodd",
        fill: color && color || "#04d2c6"
      }));

    case "train":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "25",
        height: height && height || "32",
        viewBox: "0 0 25 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M21.0709 0H3.59685C1.6126 0 0 1.6126 0 3.59685V21.0709C0 23.0551 1.6126 24.6677 3.59685 24.6677H4.47244L2.58898 31.7291L3.57795 32L3.88661 30.8409H20.7811L21.0898 32L22.085 31.7354L20.2016 24.674H21.0772C23.0614 24.674 24.674 23.0614 24.674 21.0772V3.59685C24.6677 1.6126 23.0551 0 21.0709 0ZM20.5039 29.8142H4.16378L4.71181 27.7606H19.9559L20.5039 29.8142ZM4.98268 26.7276L5.53071 24.674H19.137L19.685 26.7276H4.98268ZM23.6409 21.0709C23.6409 22.4882 22.4882 23.6409 21.0709 23.6409H3.59685C2.17953 23.6409 1.02677 22.4882 1.02677 21.0709V3.59685C1.02677 2.17953 2.17953 1.02677 3.59685 1.02677H21.0709C22.4882 1.02677 23.6409 2.17953 23.6409 3.59685V21.0709Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M20.5701 2.96057H4.11655C3.26616 2.96057 2.57324 3.80018 2.57324 4.83061V12.3031C2.57324 13.3336 3.26616 14.1732 4.11655 14.1732H20.5638C21.4142 14.1732 22.1071 13.3336 22.1071 12.3031V4.83061C22.1071 3.80018 21.4205 2.96057 20.5701 2.96057ZM11.8331 12.9214H4.11655C3.83308 12.929 3.60631 12.6466 3.60631 12.3031V4.83061C3.60631 4.48713 3.83938 4.20472 4.12285 4.20472H11.8331V12.9214ZM21.0866 12.3031H21.0803C21.0803 12.6466 20.8473 12.929 20.5638 12.929H12.8599V4.20472H20.5701C20.8536 4.20472 21.0866 4.48713 21.0866 4.83061V12.3031Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M7.19374 16.4471C5.77641 16.4471 4.62366 17.5999 4.62366 19.0172C4.62366 20.4345 5.77641 21.5873 7.19374 21.5873C8.61106 21.5873 9.76381 20.4345 9.76381 19.0172C9.76381 17.5999 8.61106 16.4471 7.19374 16.4471ZM7.19374 20.5605C6.34334 20.5605 5.65043 19.8676 5.65043 19.0172C5.65043 18.1668 6.34334 17.4739 7.19374 17.4739C8.04413 17.4739 8.73704 18.1668 8.73704 19.0172C8.73704 19.8676 8.04413 20.5605 7.19374 20.5605Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M17.4741 16.4471C16.0567 16.4471 14.904 17.5999 14.904 19.0172C14.904 20.4345 16.0567 21.5873 17.4741 21.5873C18.8914 21.5873 20.0441 20.4345 20.0441 19.0172C20.0441 17.5999 18.8914 16.4471 17.4741 16.4471ZM17.4741 20.5605C16.6237 20.5605 15.9308 19.8676 15.9308 19.0172C15.9308 18.1668 16.6237 17.4739 17.4741 17.4739C18.3245 17.4739 19.0174 18.1668 19.0174 19.0172C19.0174 19.8676 18.3245 20.5605 17.4741 20.5605Z",
        fill: color && color || "white"
      }));

    case "food":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "34",
        height: height && height || "36",
        viewBox: "0 0 34 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M27.588 5.58547L28.7291 5.21399L29.901 8.81428L28.7599 9.18547L27.588 5.58547Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M25.8293 9.78604L26.9705 9.41455L28.1426 13.0143L27.0015 13.386L25.8293 9.78604Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M5.59697 11.5362C5.47041 12.4529 5.73789 13.3805 6.33379 14.0886L7.2001 15.1752V25.2H8.4001V16.1215L9.26699 16.6992C9.46885 16.8337 9.73135 16.8337 9.9332 16.6992L11.4001 15.7201L12.867 16.6981C13.0688 16.8325 13.3313 16.8325 13.5332 16.6981L15.0001 15.7201L16.467 16.6981C16.6688 16.8325 16.9313 16.8325 17.1332 16.6981L18.6001 15.7201L20.067 16.6981C20.2688 16.8325 20.5313 16.8325 20.7332 16.6981L22.2001 15.7201L23.4001 16.5199V34.8H10.2001V36H27.0001C28.6563 35.998 29.998 34.6562 30.0001 33V15C29.9986 14.8682 29.9532 14.7404 29.8712 14.637L33.3385 5.40617C33.8052 4.16603 33.6344 2.77619 32.8814 1.68605C32.166 0.628435 30.9713 -0.00379148 29.6948 1.71101e-05C28.0677 0.0152515 26.6184 1.03185 26.0503 2.55676L25.1096 5.06105L24.0001 3.95158V1.80002C24.0001 1.46867 23.7314 1.20002 23.4001 1.20002H16.8001C16.4688 1.20002 16.2001 1.46867 16.2001 1.80002V2.82951C15.5219 2.21486 14.4988 2.18 13.7802 2.74748V1.80002C13.7802 0.817986 12.9842 0.0216968 12.0019 0.0216968C11.0198 0.0216968 10.2235 0.817986 10.2235 1.80002V2.74806C9.89512 2.4759 9.48174 2.32707 9.05518 2.32795C8.56006 2.32677 8.08545 2.52658 7.74004 2.88195C7.02842 3.61525 7.02402 4.7801 7.72979 5.51896L8.28848 6.09552C8.08516 6.18869 7.90059 6.31818 7.74385 6.47756L7.74004 6.4799L7.73418 6.48605C7.59443 6.62961 7.47871 6.79484 7.39199 6.9756L6.7082 5.71261L5.65264 6.2839L7.2042 9.14767C7.13477 9.18722 7.06504 9.2256 6.99912 9.27072C6.97451 9.28742 6.95283 9.30676 6.92881 9.32345L4.60703 7.1839L3.79346 8.06633L6.09971 10.1927C5.83486 10.5979 5.66318 11.0567 5.59697 11.5362ZM18.267 14.5008L16.8001 15.4799L15.3332 14.502C15.1313 14.3675 14.8688 14.3675 14.667 14.502L13.2139 15.4711C13.2104 15.4111 13.2001 15.3589 13.2001 15.3012C13.1963 13.9825 14.1481 12.8549 15.4486 12.6375C16.7494 12.4198 18.0162 13.1763 18.4416 14.4246C18.3798 14.4407 18.3209 14.4662 18.267 14.5008ZM19.8001 15.0791L19.7887 15.0715C19.7166 13.8103 19.0372 12.6624 17.9661 11.9924C16.8953 11.3224 15.5658 11.2134 14.4001 11.7V7.80002H19.8001V15.0791ZM28.8001 33C28.8001 33.9941 27.9941 34.8 27.0001 34.8H24.6001V16.5211L25.8001 15.7201L27.267 16.6981C27.4688 16.8325 27.7313 16.8325 27.9332 16.6981L28.8001 16.1215V33ZM27.1735 2.97834C27.5646 1.92072 28.5672 1.21379 29.6948 1.20002C30.5767 1.19826 31.4014 1.63566 31.895 2.36633C32.4247 3.13361 32.5442 4.11183 32.2152 4.98429L28.5001 14.8799L27.6001 15.4799L26.1332 14.502C25.9313 14.3675 25.6688 14.3675 25.467 14.502L24.0001 15.4799L22.7828 14.6684L27.1735 2.97834ZM24.6464 6.29474L21.4621 14.7709L21.0001 15.0791V7.44845L23.4001 5.04845L24.6464 6.29474ZM17.4001 2.40002H22.8001V3.60002H17.4001V2.40002ZM17.0485 4.80002H21.9517L20.1517 6.60002H15.2485L17.0485 4.80002ZM8.59639 3.72365C8.7168 3.59943 8.88232 3.52912 9.05518 3.52912C9.22832 3.52941 9.39385 3.59943 9.51426 3.72365L10.3952 4.62365C10.5663 4.79826 10.8262 4.85129 11.0521 4.75842C11.2779 4.66525 11.425 4.44435 11.4235 4.20002V1.80002C11.4139 1.58703 11.522 1.38605 11.7048 1.27677C11.8879 1.1672 12.1161 1.1672 12.2989 1.27677C12.482 1.38605 12.5901 1.58703 12.5802 1.80002V4.20002C12.5805 4.44347 12.7278 4.66261 12.9534 4.75461C13.1787 4.84689 13.4374 4.79357 13.6082 4.62013L14.4918 3.72013C14.7449 3.47082 15.151 3.47082 15.4038 3.72013C15.6646 3.98703 15.6646 4.41301 15.4038 4.6799L13.6363 6.4799L13.6542 6.49806L13.3759 6.77638C13.3275 6.82619 13.2886 6.8842 13.2602 6.94748C13.2517 6.96593 13.247 6.98468 13.2402 7.00373C13.2224 7.055 13.2115 7.10832 13.208 7.16222C13.208 7.17541 13.2007 7.18625 13.2007 7.19943V12.4919C13.0642 12.6226 12.9373 12.7629 12.8216 12.912L11.6881 10.5C11.2697 9.66769 10.5136 9.05539 9.61211 8.82013C9.40234 8.76593 9.1873 8.73312 8.9708 8.72287L8.81699 8.54269C8.69717 8.40529 8.60664 8.29806 8.59199 8.28312C8.43701 8.12082 8.36992 7.89347 8.41211 7.67287C8.43438 7.54748 8.49209 7.43146 8.57822 7.33801L8.58906 7.32775L8.604 7.31164C8.82139 7.09865 9.15801 7.0673 9.41113 7.23605C9.66572 7.40627 10.0073 7.35734 10.2042 7.12297C10.4011 6.8883 10.3896 6.54347 10.1778 6.32228L8.59199 4.68547C8.33447 4.41594 8.33652 3.99084 8.59639 3.72365ZM6.78613 11.7C6.86436 11.1185 7.18633 10.5976 7.67178 10.2677C8.15313 9.9422 8.75107 9.83908 9.31387 9.98468C9.87637 10.1306 10.3492 10.5111 10.6117 11.0297L12.141 14.2872C12.1032 14.4276 12.0733 14.5699 12.0517 14.7138L11.7355 14.5026C11.534 14.3681 11.2712 14.3681 11.0696 14.5026L9.6001 15.4799L8.26943 14.5919L8.14082 14.4308L9.6877 13.2349L8.95322 12.2857L7.39346 13.4921L7.26016 13.326C6.87842 12.876 6.70615 12.2848 6.78613 11.7Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M1.28115 34.5035C1.73701 35.4231 2.67627 36.0035 3.70254 36C4.12295 35.9994 4.53721 35.9016 4.91338 35.7144L5.4 35.4709L5.88721 35.7144C6.26309 35.9016 6.67734 35.9994 7.09746 36C8.12402 36.0035 9.06299 35.4231 9.51914 34.5035L9.72832 34.0837C10.4309 32.6739 10.7977 31.1209 10.8 29.5459C10.798 27.8092 9.39082 26.4021 7.6541 26.4C7.06875 26.4018 6.49541 26.5679 6 26.8799V26.4C6 25.0746 4.92539 24 3.6 24V25.2C4.2627 25.2 4.8 25.7373 4.8 26.4V26.8799C4.30459 26.5679 3.73125 26.4018 3.1459 26.4C1.40918 26.4021 0.00205079 27.8092 0 29.5459C0.00205079 31.1212 0.368848 32.6748 1.07168 34.0849L1.28115 34.5035ZM3.1459 27.6C3.66211 27.5985 4.15752 27.8039 4.52168 28.1701L4.97578 28.6242C5.21016 28.8583 5.58984 28.8583 5.82422 28.6242L6.27832 28.1701C6.83496 27.6135 7.67168 27.4471 8.39883 27.7482C9.12598 28.0494 9.6 28.759 9.6 29.5459C9.59854 30.9352 9.2751 32.3051 8.65488 33.5484L8.4457 33.9686C8.19111 34.4798 7.66846 34.8021 7.09746 34.8C6.86367 34.7997 6.63311 34.7452 6.42363 34.6409L5.66836 34.263C5.49932 34.1786 5.30068 34.1786 5.13193 34.263L4.37695 34.6409C4.16748 34.7452 3.93662 34.7997 3.70254 34.8C3.13125 34.8018 2.6083 34.4786 2.3543 33.9665L2.14512 33.5467C1.5252 32.3039 1.20176 30.9346 1.2 29.5459C1.20147 28.4719 2.07188 27.6015 3.1459 27.6Z",
        fill: color && color || "white"
      }));

    case "park":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "35",
        height: height && height || "35",
        viewBox: "0 0 35 35",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M34.9982 13.5565C34.9995 13.4431 35 13.3296 35 13.2161C35 11.2154 34.2957 9.3163 33.0054 7.80736C33.094 7.37714 33.1388 6.9379 33.1388 6.49544C33.1388 2.91383 30.2165 0 26.6247 0C23.0327 0 20.1105 2.91383 20.1105 6.49544C20.1105 6.93797 20.1552 7.37714 20.2438 7.80736C19.7247 8.41443 19.3007 9.08475 18.979 9.79929C18.8316 9.86554 18.6882 9.93985 18.5493 10.0221C17.7625 9.62346 16.893 9.41529 15.9985 9.41529C14.2847 9.41529 12.6659 10.2033 11.6009 11.5159C11.2697 11.4367 10.9292 11.3968 10.5819 11.3968C10.2077 11.3968 9.84191 11.4429 9.4876 11.5344C8.42332 10.21 6.8 9.41536 5.07448 9.41536C3.02255 9.41536 1.12777 10.5306 0.12946 12.3257C-0.145822 12.8207 0.0323216 13.445 0.527172 13.7203C0.685013 13.808 0.855979 13.8498 1.02462 13.8498C1.3848 13.8498 1.73419 13.6597 1.9217 13.3226C2.55846 12.1776 3.76657 11.4663 5.07455 11.4663C6.36305 11.4663 7.56227 12.1617 8.20423 13.281C8.47425 13.7519 9.06446 13.9306 9.55029 13.689C9.87212 13.5289 10.2192 13.4478 10.5819 13.4478C10.9255 13.4478 11.2562 13.521 11.5646 13.6654C12.0446 13.8902 12.6169 13.7121 12.8844 13.2545C13.5296 12.1515 14.7229 11.4664 15.9985 11.4664C16.7255 11.4664 17.4259 11.6816 18.0241 12.089C18.113 12.1496 18.209 12.1939 18.308 12.2235C18.2693 12.5507 18.2492 12.882 18.2492 13.2161C18.2492 14.4691 18.3791 15.738 18.8217 16.9182C19.0136 17.4298 19.2512 17.9159 19.5845 18.349C19.7209 18.5261 20.2945 19.0595 20.2438 19.3058C20.1552 19.7361 20.1104 20.1753 20.1104 20.6178C20.1104 23.8515 22.4927 26.5406 25.5992 27.0325V32.9491H18.8672V30.8298H19.1406C19.7069 30.8298 20.166 30.3706 20.166 29.8043C20.166 29.238 19.7069 28.7788 19.1406 28.7788H18.9356V24.2668C18.9356 23.7005 18.4765 23.2413 17.9102 23.2413H2.25597C1.68969 23.2413 1.23059 23.7005 1.23059 24.2668V28.7788H1.02551C0.459223 28.7788 0.000124451 29.238 0.000124451 29.8043C0.000124451 30.3706 0.459223 30.8298 1.02551 30.8298H1.29895V32.9491H1.02551C0.459223 32.9491 0.000124451 33.4082 0.000124451 33.9745C0.000124451 34.5409 0.459223 35 1.02551 35H33.9745C34.5408 35 34.9999 34.5409 34.9999 33.9745C34.9999 33.4082 34.5408 32.9491 33.9745 32.9491H27.6499V27.0325C30.7563 26.5406 33.1387 23.8515 33.1387 20.6178C33.1387 20.1752 33.0939 19.7361 33.0053 19.3058C33.7816 18.3979 34.3595 17.3255 34.6851 16.1758C34.9278 15.3194 34.9877 14.4401 34.9982 13.5565ZM3.28142 25.2922H16.8849V28.7788H3.28142V25.2922ZM3.34985 30.8297H16.8165V32.949H3.34985V30.8297ZM32.9624 13.8976C32.8883 15.5368 32.2812 17.146 31.1444 18.3026C30.8809 18.5708 30.7852 18.9617 30.8952 19.3212C31.0232 19.74 31.0881 20.1761 31.0881 20.6177C31.0881 22.717 29.6184 24.4797 27.6501 24.9425V15.351C27.7559 15.3017 27.8555 15.2346 27.9428 15.1473L30.3932 12.6967C30.7936 12.2963 30.7936 11.647 30.3932 11.2465C29.9928 10.8461 29.3435 10.8461 28.9431 11.2465L27.6501 12.5395V10.5669C27.6501 10.0006 27.191 9.54142 26.6247 9.54142C26.0584 9.54142 25.5993 10.0006 25.5993 10.5669V16.6176L24.5392 15.5574C24.1389 15.157 23.4896 15.157 23.0891 15.5574C22.6887 15.9578 22.6887 16.6072 23.0891 17.0076L25.5395 19.4582C25.5587 19.4774 25.579 19.4949 25.5993 19.5123V24.9424C23.631 24.4797 22.1613 22.717 22.1613 20.6176C22.1613 20.1761 22.2262 19.7399 22.3542 19.3212C22.4641 18.9616 22.3685 18.5707 22.105 18.3025C20.9411 17.1183 20.3002 15.5537 20.3002 13.897C20.3002 13.67 20.3002 13.443 20.3002 13.2161C20.3002 11.5594 20.9411 9.99475 22.105 8.81054C22.3685 8.54234 22.4642 8.15143 22.3542 7.79191C22.2262 7.37317 22.1613 6.93701 22.1613 6.49544C22.1613 4.04471 24.1636 2.05093 26.6247 2.05093C29.0859 2.05093 31.0881 4.04471 31.0881 6.49544C31.0881 6.93701 31.0232 7.37317 30.8952 7.79191C30.7853 8.15143 30.8809 8.54234 31.1444 8.81047C32.4423 10.1315 33.0467 12.034 32.9624 13.8976Z",
        fill: color && color || "white"
      }));

    case "gym":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "32",
        height: height && height || "21",
        viewBox: "0 0 32 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M30.125 6.8855H29.5V4.0687C29.5 2.68794 28.3782 1.56489 27 1.56489C26.5181 1.56489 26.0674 1.70206 25.6855 1.93972C25.4299 0.829389 24.4343 0 23.25 0H23.2493C21.8713 0 20.7493 1.12305 20.7493 2.50382V6.8855H11.2507V2.50382C11.2507 1.12305 10.1287 0 8.75 0C7.56567 0 6.57007 0.829389 6.31445 1.93972C5.93262 1.70206 5.48193 1.56489 5 1.56489C3.62183 1.56489 2.5 2.68794 2.5 4.0687V6.8855H1.875C0.841309 6.8855 0 7.72809 0 8.76336V11.2672C0 12.3024 0.841309 13.145 1.875 13.145H2.5V15.9618C2.5 17.3426 3.62183 18.4656 5 18.4656C5.48193 18.4656 5.93262 18.3285 6.31445 18.0908C6.57007 19.2011 7.56567 20.0305 8.75 20.0305H8.75073C10.1287 20.0305 11.2507 18.9075 11.2507 17.5267V13.145H20.7493V17.5267C20.7493 18.9075 21.8713 20.0305 23.25 20.0305C24.4343 20.0305 25.4299 19.2011 25.6855 18.0908C26.0674 18.3285 26.5181 18.4656 27 18.4656C28.3782 18.4656 29.5 17.3426 29.5 15.9618V13.145H30.125C31.1587 13.145 32 12.3024 32 11.2672V8.76336C32 7.72809 31.1587 6.8855 30.125 6.8855ZM2.5 11.8931H1.875C1.53052 11.8931 1.25 11.6122 1.25 11.2672V8.76336C1.25 8.41835 1.53052 8.1374 1.875 8.1374H2.5V11.8931ZM6.25 15.9618C6.25 16.3073 6.11011 16.6203 5.88379 16.847C5.65747 17.0736 5.34497 17.2137 5 17.2137C4.31055 17.2137 3.75 16.6523 3.75 15.9618V4.0687C3.75 3.3782 4.31055 2.81679 5 2.81679C5.68945 2.81679 6.25 3.3782 6.25 4.0687V15.9618ZM10.0007 17.5267C10.0007 18.2172 9.43945 18.7786 8.75073 18.7786H8.75C8.06128 18.7786 7.5 18.2172 7.5 17.5267V2.50382C7.5 1.81331 8.06128 1.25191 8.75073 1.25191C9.43945 1.25191 10.0007 1.81331 10.0007 2.50382V17.5267ZM20.7456 9.38931H16.375C16.03 9.38931 15.75 9.66977 15.75 10.0153C15.75 10.3608 16.03 10.6412 16.375 10.6412H20.7456V11.8931H11.2476V8.1374H20.7456V9.38931ZM24.5 17.5267C24.5 18.2172 23.9387 18.7786 23.2493 18.7786C22.5605 18.7786 21.9993 18.2172 21.9993 17.5267V10.0473C21.9988 10.061 21.9976 10.0747 21.9956 10.0879V9.94265C21.9976 9.95585 21.9988 9.96954 21.9993 9.98324V2.50382C21.9993 1.81331 22.5605 1.25191 23.2493 1.25191H23.25C23.9387 1.25191 24.5 1.81331 24.5 2.50382V17.5267ZM28.25 15.9618C28.25 16.6523 27.6895 17.2137 27 17.2137C26.3105 17.2137 25.75 16.6523 25.75 15.9618V4.0687C25.75 3.3782 26.3105 2.81679 27 2.81679C27.6895 2.81679 28.25 3.3782 28.25 4.0687V15.9618ZM30.75 11.2672C30.75 11.6122 30.4695 11.8931 30.125 11.8931H29.5V8.1374H30.125C30.4695 8.1374 30.75 8.41835 30.75 8.76336V11.2672Z",
        fill: color && color || "white"
      }));

    case "back":
      return /*#__PURE__*/React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width && width || "10",
        height: height && height || "17",
        viewBox: "0 0 10 17",
        fill: "none"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.14307 14.7246L7.86557 16.0206L0.000239159 8.00016L7.86557 0.0206053L9.14307 1.32329L2.55522 8.0068L9.14307 14.7246Z",
        fill: color && color || "white"
      }));

    case "rightArrow":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "10",
        height: height && height || "17",
        viewBox: "0 0 10 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.554321 1.74439L1.79779 0.446319L9.45365 8.4543L1.79779 16.4463L0.554321 15.1457L6.96671 8.45171L0.554321 1.74439Z",
        fill: color && color || "white"
      }));

    case "downArrow":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "17",
        height: height && height || "9",
        viewBox: "0 0 17 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.7171 0L16.0152 1.24347L8.0072 8.89933L0.0151827 1.24347L1.31584 0L8.00979 6.41239L14.7171 0Z",
        fill: color && color || "white"
      }));

    case "upArrow":
      return /*#__PURE__*/React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width && width || "10",
        height: height && height || "5",
        viewBox: "0 0 10 5",
        fill: "none"
      }, /*#__PURE__*/React__default.createElement("path", {
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.73107 5L-1.77328e-05 4.30137L4.50118 1.18067e-07L9.00238 4.30137L8.27129 5L4.50118 1.39726L0.73107 5Z",
        fill: color && color || "white"
      }));

    case "close":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "8",
        height: height && height || "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M8 0.805714L7.19429 0L4 3.19429L0.805714 0L0 0.805714L3.19429 4L0 7.19429L0.805714 8L4 4.80571L7.19429 8L8 7.19429L4.80571 4L8 0.805714Z",
        fill: color && color || "white"
      }));

    case "link":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "14",
        height: height && height || "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M5.49756 7.30132C5.67917 7.50311 6.27108 8.09503 6.47287 8.28336C6.82264 8.60623 7.23967 8.7542 7.73742 8.76766C7.79796 8.76093 7.8854 8.76093 7.97284 8.74748C8.34279 8.69367 8.6791 8.54569 8.95488 8.29009C9.22393 8.03449 9.48626 7.76544 9.74859 7.49639C10.0513 7.1937 10.354 6.88429 10.6566 6.58161C10.9324 6.30583 11.2015 6.03678 11.4772 5.76772C11.8068 5.43814 12.1297 5.11527 12.4593 4.78568C12.7552 4.48973 12.9301 4.13996 12.9839 3.72965C13.0579 3.12429 12.8763 2.60636 12.4458 2.17588C12.1768 1.9001 11.901 1.63104 11.6252 1.35527C11.4234 1.15348 11.2149 0.958414 10.9459 0.830614C10.5625 0.65573 10.1723 0.622099 9.76876 0.709541C9.45935 0.776804 9.18358 0.918056 8.95488 1.14002C8.79345 1.29473 8.63874 1.45616 8.47731 1.61087C8.25534 1.83283 8.02665 2.0548 7.80468 2.2835C7.55581 2.53237 7.30694 2.78124 7.05806 3.03012",
        stroke: "#1D1C38",
        strokeMiterlimit: "10",
        strokeLinecap: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M8.17465 6.17801C7.99303 5.97622 7.40112 5.3843 7.19933 5.19596C6.84956 4.8731 6.43253 4.72512 5.93478 4.71167C5.87425 4.7184 5.78681 4.7184 5.69936 4.73185C5.32942 4.78566 4.9931 4.93364 4.71732 5.19596C4.44827 5.45156 4.18594 5.72062 3.92362 5.98967C3.62093 6.29235 3.31825 6.60176 3.01557 6.90445C2.73979 7.18023 2.47074 7.44928 2.19496 7.71833C1.86537 8.04792 1.54251 8.37078 1.21292 8.70037C0.916959 8.99633 0.742075 9.3461 0.688264 9.7564C0.614275 10.3618 0.795885 10.8797 1.22637 11.3102C1.49542 11.586 1.7712 11.855 2.04698 12.1308C2.24877 12.3326 2.45728 12.5276 2.72634 12.6554C3.10973 12.8303 3.49986 12.864 3.90344 12.7765C4.21285 12.7092 4.48863 12.568 4.71732 12.346C4.87875 12.1913 5.03346 12.0299 5.19489 11.8752C5.41686 11.6532 5.64555 11.4313 5.86752 11.2026C6.11639 10.9537 6.36527 10.7048 6.61414 10.4559",
        stroke: "#1D1C38",
        strokeMiterlimit: "10",
        strokeLinecap: "round"
      }));

    case "staged":
      return /*#__PURE__*/React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width && width || "33",
        height: height && height || "33",
        viewBox: "0 0 33 33",
        fill: "none"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M32.3265 14.8163H20.2041V0.673469C20.2041 0.30158 19.9026 0 19.5306 0H0.673469C0.301512 0 0 0.30158 0 0.673469V32.3265C0 32.6984 0.301512 33 0.673469 33H18.5204C18.8924 33 19.1939 32.6984 19.1939 32.3265V30.3061H27.2755V32.3265C27.2755 32.6984 27.577 33 27.949 33H30.3061C30.6781 33 30.9796 32.6984 30.9796 32.3265V30.3061H31.3163C31.6883 30.3061 31.9898 30.0045 31.9898 29.6327V18.5204H32.3265C32.6985 18.5204 33 18.2188 33 17.8469V15.4898C33 15.1179 32.6985 14.8163 32.3265 14.8163ZM9.42857 31.6531H1.34694V25.9286H9.42857V31.6531ZM9.42857 24.5816H1.34694V1.34694H9.42857V24.5816ZM15.4898 31.6531H10.7755V1.34694H18.8571V14.8163H13.8061C13.4342 14.8163 13.1327 15.1179 13.1327 15.4898V17.8469C13.1327 18.2188 13.4342 18.5204 13.8061 18.5204H14.4796V29.6327C14.4796 30.0045 14.7811 30.3061 15.1531 30.3061H15.4898V31.6531ZM17.8469 31.6531H16.8367V30.3061H17.8469V31.6531ZM29.6327 31.6531H28.6224V30.3061H29.6327V31.6531ZM30.6429 28.9592H15.8265V24.2449H30.6429V28.9592ZM30.6429 22.898H15.8265V18.5204H30.6429V22.898ZM31.6531 17.1735H14.4796V16.1633H31.6531V17.1735Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M24.2448 19.8667H22.2244V21.2136H24.2448V19.8667Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M24.2448 25.5913H22.2244V26.9382H24.2448V25.5913Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M13.4693 10.7754H12.1223V13.4693H13.4693V10.7754Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M8.08156 10.7754H6.73462V13.4693H8.08156V10.7754Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M6.39809 27.9487H4.37769V29.2957H6.39809V27.9487Z",
        fill: color && color || "white"
      }));

    case "floorplan":
      return /*#__PURE__*/React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width && width || "33",
        height: height && height || "33",
        viewBox: "0 0 34 28",
        fill: "none"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M33 14.33V22.5705C32.9912 22.8066 32.8907 23.03 32.7199 23.1932C32.5491 23.3565 32.3214 23.4467 32.0851 23.4448H9.62685C9.5076 23.4448 9.38952 23.4682 9.27934 23.5139C9.16917 23.5595 9.06906 23.6264 8.98474 23.7107C8.90041 23.795 8.83352 23.8952 8.78789 24.0053C8.74225 24.1155 8.71876 24.2336 8.71876 24.3528V26.0064C8.71878 26.1259 8.69502 26.2442 8.64888 26.3545C8.60274 26.4647 8.53514 26.5647 8.45 26.6485C8.36487 26.7324 8.2639 26.7985 8.15298 26.843C8.04206 26.8875 7.92339 26.9095 7.8039 26.9077H1.90809C1.6725 26.9096 1.44554 26.8191 1.27581 26.6557C1.10608 26.4923 1.00708 26.269 1 26.0335V1.90134C0.999997 1.7824 1.02353 1.66464 1.06925 1.55485C1.11497 1.44505 1.18197 1.34539 1.26638 1.26161C1.35079 1.17782 1.45096 1.11157 1.56109 1.06668C1.67123 1.02178 1.78916 0.999131 1.90809 1.00003H22.0894C22.3249 1.00534 22.5489 1.10264 22.7136 1.2711C22.8782 1.43955 22.9704 1.66578 22.9704 1.90134V5.54047C22.9704 5.78132 23.066 6.01229 23.2363 6.18259C23.4066 6.35289 23.6376 6.44857 23.8784 6.44857H32.0851C32.205 6.44767 32.3238 6.4705 32.4347 6.51573C32.5457 6.56097 32.6466 6.62772 32.7316 6.71213C32.8167 6.79654 32.8842 6.89695 32.9302 7.00757C32.9763 7.11819 33 7.23683 33 7.35665V11.8022",
        stroke: color && color || "white",
        strokeWidth: "1.75",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M1 12.2088H15.1161",
        stroke: color && color || "white",
        strokeWidth: "1.75",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M22.9702 23.8514V16.5595H26.8601",
        stroke: color && color || "white",
        strokeWidth: "1.75",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M29.1035 16.5595H33.0002",
        stroke: color && color || "white",
        strokeWidth: "1.75",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M8.84766 12.2088V16.5595",
        stroke: color && color || "white",
        strokeWidth: "1.75",
        strokeMiterlimit: "10"
      }));

    case "flash":
      return /*#__PURE__*/React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width && width || "12",
        height: height && height || "17",
        viewBox: "0 0 12 17",
        fill: "none"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M10.724 5.66454H7.46298L11.302 1.24497C11.4974 1.01863 11.5439 0.708982 11.419 0.436624C11.2946 0.164737 11.0225 0 10.724 0H5.29709C5.0101 0 4.74741 0.160017 4.61666 0.414439L0.0845098 9.21583C-0.0372727 9.45326 -0.026888 9.76338 0.112123 9.99113C0.250191 10.2189 0.497532 10.3848 0.765171 10.3848H3.10878H3.1135H3.11775H4.09625L2.38115 16.0345C2.27542 16.3866 2.4352 16.7522 2.76207 16.9209C2.87371 16.979 2.9936 17 3.11326 17C3.3429 17 3.56735 16.8938 3.71675 16.7026L11.3275 6.94208C11.5068 6.71126 11.5394 6.37707 11.411 6.11485C11.2826 5.85194 11.0166 5.66454 10.724 5.66454Z",
        fill: color && color || "white"
      }));

    case "refresh":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "16",
        height: height && height || "19",
        viewBox: "0 0 16 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M12.136 4.854C12.7642 5.24928 13.3218 5.77867 13.7665 6.42805C15.5523 9.02557 14.9029 12.576 12.3054 14.3688C11.0419 15.237 9.55257 15.5335 8.14793 15.3006",
        stroke: "#231F20",
        strokeWidth: "1.45",
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M10.5549 11.8208L8.14088 15.2936L11.6137 17.7076",
        stroke: "#231F20",
        strokeWidth: "1.45",
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M4.01397 14.4606C3.39988 14.0442 2.85638 13.5007 2.43287 12.8372C0.717655 10.1903 1.47291 6.66102 4.11279 4.94581C5.39743 4.11291 6.90089 3.8588 8.29142 4.12702",
        stroke: "#231F20",
        strokeWidth: "1.45",
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M5.70095 7.45157L8.29848 4.10585L4.95275 1.51538",
        stroke: "#231F20",
        strokeWidth: "1.45",
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "spread":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "18",
        height: height && height || "4",
        viewBox: "0 0 18 4",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("circle", {
        cx: "16",
        cy: "2",
        r: "2",
        fill: color && color || "#333333",
        fillOpacity: "0.8"
      }), /*#__PURE__*/React__default.createElement("circle", {
        cx: "9",
        cy: "2",
        r: "2",
        fill: color && color || "#333333",
        fillOpacity: "0.8"
      }), /*#__PURE__*/React__default.createElement("circle", {
        cx: "2",
        cy: "2",
        r: "2",
        fill: color && color || "#333333",
        fillOpacity: "0.8"
      }));

    case "peeklogo":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M14.0558 0.341156V15.2719L21.8941 22.7145",
        stroke: "white",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M14.0558 15.2719H0.880959",
        stroke: "white",
        strokeMiterlimit: "10"
      }));

    case "gear":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "25",
        height: height && height || "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0078 15C13.6647 15 15.0078 13.6569 15.0078 12C15.0078 10.3431 13.6647 9 12.0078 9C10.351 9 9.00781 10.3431 9.00781 12C9.00781 13.6569 10.351 15 12.0078 15Z",
        stroke: color && color || "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.4078 15C19.1355 15.6171 19.2661 16.3378 19.7378 16.82L19.7978 16.88C20.1734 17.2551 20.3844 17.7642 20.3844 18.295C20.3844 18.8258 20.1734 19.3349 19.7978 19.71C19.4227 20.0856 18.9136 20.2966 18.3828 20.2966C17.852 20.2966 17.3429 20.0856 16.9678 19.71L16.9078 19.65C16.4256 19.1783 15.7049 19.0477 15.0878 19.32C14.4833 19.5791 14.0904 20.1724 14.0878 20.83V21C14.0878 22.1046 13.1924 23 12.0878 23C10.9832 23 10.0878 22.1046 10.0878 21V20.91C10.072 20.2327 9.64368 19.6339 9.00781 19.4C8.39072 19.1277 7.67 19.2583 7.18781 19.73L7.12781 19.79C6.75268 20.1656 6.24363 20.3766 5.71281 20.3766C5.18199 20.3766 4.67295 20.1656 4.29781 19.79C3.92226 19.4149 3.71124 18.9058 3.71124 18.375C3.71124 17.8442 3.92226 17.3351 4.29781 16.96L4.35781 16.9C4.82948 16.4178 4.96016 15.6971 4.68781 15.08C4.42874 14.4755 3.83546 14.0826 3.17781 14.08H3.00781C1.90324 14.08 1.00781 13.1846 1.00781 12.08C1.00781 10.9754 1.90324 10.08 3.00781 10.08H3.09781C3.77514 10.0642 4.37395 9.63587 4.60781 9C4.88016 8.38291 4.74948 7.66219 4.27781 7.18L4.21781 7.12C3.84226 6.74486 3.63124 6.23582 3.63124 5.705C3.63124 5.17418 3.84226 4.66514 4.21781 4.29C4.59295 3.91445 5.10199 3.70343 5.63281 3.70343C6.16363 3.70343 6.67268 3.91445 7.04781 4.29L7.10781 4.35C7.59 4.82167 8.31072 4.95235 8.92781 4.68H9.00781C9.61228 4.42093 10.0052 3.82764 10.0078 3.17V3C10.0078 1.89543 10.9032 1 12.0078 1C13.1124 1 14.0078 1.89543 14.0078 3V3.09C14.0104 3.74764 14.4033 4.34093 15.0078 4.6C15.6249 4.87235 16.3456 4.74167 16.8278 4.27L16.8878 4.21C17.2629 3.83445 17.772 3.62343 18.3028 3.62343C18.8336 3.62343 19.3427 3.83445 19.7178 4.21C20.0934 4.58514 20.3044 5.09418 20.3044 5.625C20.3044 6.15582 20.0934 6.66486 19.7178 7.04L19.6578 7.1C19.1861 7.58219 19.0555 8.30291 19.3278 8.92V9C19.5869 9.60447 20.1802 9.99738 20.8378 10H21.0078C22.1124 10 23.0078 10.8954 23.0078 12C23.0078 13.1046 22.1124 14 21.0078 14H20.9178C20.2602 14.0026 19.6669 14.3955 19.4078 15Z",
        stroke: color && color || "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "notifications":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "32",
        height: height && height || "33",
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M27 23.4004C27.0029 22.2331 26.6937 21.0856 26.1036 20.0737C25.5134 19.0618 24.6632 18.2211 23.6386 17.6364V10.2255C23.6386 4.7785 19.2583 0.196108 13.8716 0.00671942C12.5079 -0.0426063 11.148 0.180038 9.87365 0.661311C8.59925 1.14258 7.43651 1.87258 6.4551 2.80755C5.4737 3.74252 4.69384 4.86321 4.16225 6.10248C3.63066 7.34175 3.35828 8.67408 3.36145 10.0196V17.6446C2.33652 18.229 1.48606 19.0696 0.89588 20.0816C0.305703 21.0936 -0.00330867 22.2412 2.67173e-05 23.4086V24.7467H8.76896C8.87423 25.9084 9.41668 26.9891 10.2895 27.7763C11.1624 28.5635 12.3025 29 13.4854 29C14.6683 29 15.8084 28.5635 16.6812 27.7763C17.5541 26.9891 18.0965 25.9084 18.2018 24.7467H26.9707L27 23.4004ZM13.5 28.1721C12.5382 28.1707 11.6107 27.8196 10.895 27.1861C10.1793 26.5526 9.72561 25.6811 9.62079 24.7384H17.3792C17.2744 25.6811 16.8207 26.5526 16.105 27.1861C15.3893 27.8196 14.4618 28.1707 13.5 28.1721ZM26.1648 23.915H0.835163V23.4004C0.8338 22.3456 1.12333 21.3102 1.67276 20.4052C2.2222 19.5001 3.01087 18.7593 3.9544 18.2622L4.19659 18.1675V10.0196C4.19688 8.78712 4.44908 7.56731 4.93813 6.43304C5.42718 5.29878 6.14304 4.27331 7.04297 3.41789C7.94291 2.56247 9.00844 1.89464 10.176 1.45427C11.3435 1.01391 12.589 0.810044 13.8382 0.854852C18.7781 1.02777 22.7992 5.24373 22.7992 10.2502V18.1345L23.0206 18.2498C23.9699 18.7452 24.764 19.4867 25.3173 20.3944C25.8707 21.302 26.1623 22.3414 26.1607 23.4004L26.1648 23.915Z",
        fill: "white"
      }), isActive && /*#__PURE__*/React__default.createElement("circle", {
        cx: "25.5",
        cy: "6.5",
        r: "6.5",
        fill: "#04D2C6"
      }));

    case "separator":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "1",
        height: "26",
        viewBox: "0 0 1 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("line", {
        x1: "0.25",
        y1: "0.604736",
        x2: "0.249998",
        y2: "26.0001",
        stroke: "#979797",
        strokeWidth: "0.5"
      }));

    case "pen":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("rect", {
        x: "20.7418",
        y: "5.56363",
        width: "4.66667",
        height: "20.6667",
        transform: "rotate(45 20.7418 5.56363)",
        stroke: "#424242",
        strokeWidth: "2"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M24.9844 9.33523C25.294 9.0257 25.5395 8.65824 25.707 8.25382C25.8745 7.8494 25.9607 7.41594 25.9607 6.97821C25.9607 6.54047 25.8745 6.10701 25.707 5.70259C25.5395 5.29818 25.294 4.93071 24.9844 4.62118C24.6749 4.31165 24.3074 4.06612 23.903 3.89861C23.4986 3.73109 23.0651 3.64487 22.6274 3.64487C22.1897 3.64487 21.7562 3.73109 21.3518 3.89861C20.9474 4.06612 20.5799 4.31165 20.2704 4.62118L22.6274 6.97821L24.9844 9.33523Z",
        fill: "#424242"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M7.07106 23.9485L6.2461 24.7734C5.92066 25.0989 5.39303 25.0989 5.06759 24.7734C4.74215 24.448 4.74215 23.9204 5.06759 23.5949L5.89255 22.77L7.07106 23.9485Z",
        fill: "#424242",
        stroke: "#424242",
        strokeWidth: "2"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M13.1993 7.9209L21.6846 16.4062",
        stroke: "#424242",
        strokeWidth: "2",
        strokeLinecap: "round"
      }), /*#__PURE__*/React__default.createElement("rect", {
        x: "19.799",
        y: "5.09229",
        width: "6.66667",
        height: "6.66667",
        transform: "rotate(45 19.799 5.09229)",
        fill: "#424242"
      }));

    case "edit_photo":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || "25",
        height: height && height || "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.34 1.60986L23.39 7.65986L7.65998 23.3899H1.60999V17.3399L17.34 1.60986V1.60986Z",
        stroke: color && color || "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "checkmark":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "19",
        height: "14",
        viewBox: "0 0 19 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M18 1L6.3125 13L1 7.54545",
        stroke: color && color || "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "doorman":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "24",
        height: "29",
        viewBox: "0 0 24 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M11.7268 21.6333C11.4144 21.6333 11.1588 21.3851 11.1588 21.0818C11.1588 20.7785 11.4144 20.5303 11.7268 20.5303C12.0391 20.5303 12.2947 20.7785 12.2947 21.0818C12.2947 21.3943 12.0391 21.6333 11.7268 21.6333Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M22.6402 19.7214C22.129 19.1055 21.4191 18.6551 20.6051 18.4345L20.4725 18.4069C18.9107 17.9841 17.311 17.6716 15.7019 17.4785V14.0499C15.7019 13.8845 15.6261 13.7282 15.4936 13.6271C15.4084 13.5627 15.3043 13.5168 15.2002 13.5076C16.0332 12.6619 16.5443 11.5221 16.5443 10.2628V1.67751C16.5443 0.7675 15.7776 0.0229492 14.8405 0.0229492H8.59316C7.65606 0.0229492 6.88934 0.7675 6.88934 1.67751V10.2536C6.88934 11.5129 7.40048 12.6619 8.23346 13.4984C8.12934 13.5076 8.02522 13.5536 7.94003 13.6179C7.80751 13.719 7.73178 13.8753 7.73178 14.0407V17.4601C6.08476 17.6532 4.43774 17.9749 2.84751 18.4161L2.81911 18.4253C1.14369 18.8941 0.0078125 20.2821 0.0078125 21.8723V27.7368C0.0078125 28.0401 0.263385 28.2883 0.575751 28.2883H22.8674C23.1797 28.2883 23.4353 28.0401 23.4353 27.7368V21.8723C23.4353 21.1002 23.1608 20.3464 22.6402 19.7214C22.129 19.1055 23.1608 20.3464 22.6402 19.7214ZM15.4179 6.77906C13.6857 6.66875 11.9629 5.95178 11.0542 4.44429H15.4179V6.77906ZM8.02522 1.67751C8.02522 1.37417 8.28079 1.12599 8.59316 1.12599H14.8499C15.1623 1.12599 15.4179 1.37417 15.4179 1.67751V3.34126H8.02522V1.67751ZM8.02522 4.44429H9.30308C9.00018 5.005 8.54583 5.66683 8.02522 5.97936V4.44429ZM8.02522 10.2536V7.17431C9.01911 6.89855 9.7101 5.99774 10.1929 5.17046C10.3254 5.54733 10.8176 5.97016 11.1016 6.22754C11.4991 6.58603 11.944 6.88017 12.4173 7.12835C13.3449 7.59714 14.3861 7.82694 15.4179 7.8821V10.2536C15.4179 12.2299 13.7614 13.8385 11.7168 13.8385C9.68171 13.8477 8.02522 12.2299 8.02522 10.2536ZM14.566 14.7117V17.3958L11.6979 17.9106L8.87712 17.3958V14.7117C9.7385 14.868 10.7229 14.9415 11.7263 14.9415H11.7358C12.7202 14.9507 13.7046 14.868 14.566 14.7117ZM22.2994 27.1945H12.2942V23.2971C12.2942 22.9937 12.0387 22.7455 11.7263 22.7455C11.4139 22.7455 11.1583 22.9937 11.1583 23.2971V27.1945H1.14369V21.8815C1.14369 20.7876 1.94827 19.8317 3.14094 19.5008L3.16934 19.4916C4.95835 19.0044 6.81361 18.6643 8.66888 18.4896L11.5843 19.0228C11.6032 19.0228 11.6222 19.032 11.6316 19.032C11.6506 19.032 11.6695 19.032 11.6884 19.032C11.7263 19.032 11.7547 19.032 11.7925 19.0228L14.7553 18.4896C16.5822 18.6643 18.3996 18.9952 20.1696 19.4732L20.2927 19.51C21.4948 19.8317 22.2994 20.7876 22.2994 21.8907V27.1945Z",
        fill: color && color || "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M11.7163 12.7353C10.4669 12.7353 9.44458 11.8896 9.44458 10.8601C9.44458 10.5568 9.70015 10.3086 10.0125 10.3086C10.3249 10.3086 10.5805 10.5568 10.5805 10.8601C10.5805 11.2829 11.1011 11.6322 11.7163 11.6322C12.3316 11.6322 12.8522 11.2738 12.8522 10.8601C12.8522 10.5568 13.1078 10.3086 13.4202 10.3086C13.7325 10.3086 13.9881 10.5568 13.9881 10.8601C13.9976 11.8896 12.9753 12.7353 11.7163 12.7353Z",
        fill: color && color || "white"
      }));

    case "laundry":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "20",
        height: "27",
        viewBox: "0 0 20 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("g", {
        clipPath: "url(#clip0)"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M18.4059 0.890625H2.41896C1.55935 0.890625 0.86792 1.572 0.86792 2.41912V25.4019C0.86792 26.2398 1.55935 26.9304 2.41896 26.9304H18.4153C19.2655 26.9304 19.9663 26.249 19.9663 25.4019V2.41912C19.957 1.572 19.2655 0.890625 18.4059 0.890625ZM11.23 1.90349H15.8738V3.34912C15.8738 3.62535 15.6402 3.85555 15.3599 3.85555H11.7533C11.473 3.85555 11.2394 3.62535 11.2394 3.34912V1.90349H11.23ZM18.9198 25.3927C18.9198 25.6689 18.6862 25.8991 18.4059 25.8991H2.41896C2.13866 25.8991 1.90506 25.6689 1.90506 25.3927V6.88492H11.1926C11.473 6.88492 11.7065 6.65473 11.7065 6.37849C11.7065 6.10226 11.473 5.87206 11.1926 5.87206H1.89572V2.41912C1.89572 2.14289 2.12931 1.91269 2.40962 1.91269H10.1929V3.35832C10.1929 4.19624 10.8843 4.88682 11.7439 4.88682H15.3506C16.2008 4.88682 16.9016 4.20544 16.9016 3.35832V1.90349H18.4059C18.6862 1.90349 18.9198 2.13368 18.9198 2.40992V5.86285H15.3132C15.0329 5.86285 14.7993 6.09305 14.7993 6.36928C14.7993 6.64552 15.0329 6.87571 15.3132 6.87571H18.9198V25.3927Z",
        fill: color && color || "#fff"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M7.57619 3.89226H4.47411C4.1938 3.89226 3.96021 3.66206 3.96021 3.38583C3.96021 3.10959 4.1938 2.87939 4.47411 2.87939H7.56685C7.84716 2.87939 8.08075 3.10959 8.08075 3.38583C8.0901 3.67127 7.8565 3.89226 7.57619 3.89226Z",
        fill: color && color || "#fff"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M10.427 22.004C7.29684 22.004 4.75537 19.4995 4.75537 16.4148C4.75537 13.3302 7.29684 10.8257 10.427 10.8257C12.2303 10.8257 13.8841 11.6452 14.968 13.0632C15.7061 14.0392 16.0986 15.1994 16.0986 16.4148C16.0986 17.6395 15.7061 18.7997 14.968 19.7665C13.8841 21.1845 12.2303 22.004 10.427 22.004ZM10.427 11.8385C7.8668 11.8385 5.78317 13.8919 5.78317 16.4148C5.78317 18.9378 7.8668 20.9911 10.427 20.9911C11.9033 20.9911 13.2581 20.3282 14.1457 19.1588C14.7531 18.3669 15.0708 17.4093 15.0708 16.4148C15.0708 15.4112 14.7531 14.4628 14.1457 13.6709C13.2581 12.5015 11.9033 11.8385 10.427 11.8385ZM10.427 19.9691C8.43677 19.9691 6.82032 18.3761 6.82032 16.4148C6.82032 14.4536 8.43677 12.8606 10.427 12.8606C11.3146 12.8606 12.1742 13.1829 12.8376 13.763C12.9497 13.8551 13.0058 13.9932 13.0058 14.1405C13.0058 14.2878 12.9404 14.4259 12.8376 14.518C12.2863 14.9968 11.978 15.6874 11.978 16.4148C11.978 17.133 12.2957 17.8236 12.8376 18.3116C12.9497 18.4037 13.0058 18.5418 13.0058 18.6892C13.0058 18.8365 12.9404 18.9746 12.8376 19.0667C12.1742 19.6468 11.324 19.9691 10.427 19.9691ZM10.427 13.8643C9.00673 13.8643 7.84812 15.006 7.84812 16.4056C7.84812 17.8052 9.00673 18.947 10.427 18.947C10.8848 18.947 11.324 18.8273 11.7164 18.6063C11.2212 17.9802 10.9409 17.2067 10.9409 16.4056C10.9409 15.6045 11.2212 14.8311 11.7164 14.205C11.3333 13.984 10.8848 13.8643 10.427 13.8643Z",
        fill: color && color || "#fff"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M13.2485 6.88493C12.9682 6.88493 12.7346 6.65474 12.7346 6.3785C12.7346 6.10227 12.9682 5.87207 13.2485 5.87207C13.5288 5.87207 13.7624 6.10227 13.7624 6.3785C13.7624 6.65474 13.5382 6.88493 13.2485 6.88493Z",
        fill: color && color || "#fff"
      })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
        id: "clip0"
      }, /*#__PURE__*/React__default.createElement("rect", {
        width: "19.0891",
        height: "26.0305",
        fill: "white",
        transform: "translate(0.86792 0.890625)"
      }))));

    case "outdoor_space":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "35",
        height: "25",
        viewBox: "0 0 35 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M34.5625 20.1423C34.5625 19.1307 33.6891 18.3153 32.6168 18.2947C32.8379 17.9335 32.9705 17.5103 32.9705 17.0665C32.9705 15.704 31.7876 14.5996 30.3284 14.5996H18.024L15.5808 10.6465C15.3929 10.3472 14.9949 10.2543 14.6743 10.4194C14.3537 10.5949 14.2542 10.9665 14.4311 11.2658L16.4984 14.5996H9.77691L6.83625 11.8541C5.80813 10.8942 4.12775 10.8942 3.09963 11.8541C2.60215 12.3186 2.32577 12.9379 2.32577 13.5984C2.32577 14.259 2.60215 14.8783 3.09963 15.3428L6.27244 18.2947H2.70164C1.60719 18.2947 0.722778 19.1204 0.722778 20.1423C0.722778 21.1641 1.60719 21.9898 2.70164 21.9898H3.35389L2.51371 23.5587C2.41421 23.7548 2.42527 23.9818 2.54687 24.1573C2.66848 24.3431 2.87853 24.4463 3.11068 24.4463H5.75285C6.00712 24.4463 6.22822 24.3121 6.33877 24.1057L7.47745 21.9795H27.8078L28.9465 24.1057C29.057 24.3121 29.2892 24.4463 29.5324 24.4463H32.1746C32.4067 24.4463 32.6168 24.3328 32.7384 24.1573C32.86 23.9715 32.871 23.7444 32.7715 23.5587L31.9314 21.9898H32.5836C33.6781 21.9898 34.5625 21.1641 34.5625 20.1423ZM4.02826 14.4654C3.77399 14.2384 3.64133 13.9287 3.64133 13.5984C3.64133 13.2682 3.77399 12.9585 4.02826 12.7314C4.54785 12.2463 5.38803 12.2463 5.89657 12.7314L9.03622 15.6524C9.15783 15.7659 9.32365 15.8279 9.50054 15.8279H30.3284C31.058 15.8279 31.655 16.3852 31.655 17.0561C31.655 17.727 31.058 18.2844 30.3284 18.2844H8.1297L4.02826 14.4654ZM5.33276 23.218H4.17197L4.83528 21.9898H5.99607L5.33276 23.218ZM29.9525 23.218L29.2892 21.9898H30.45L31.1133 23.218H29.9525ZM2.70164 20.7512C2.33682 20.7512 2.03834 20.4725 2.03834 20.1319C2.03834 19.7913 2.33682 19.5126 2.70164 19.5126H32.5836C32.9484 19.5126 33.2469 19.7913 33.2469 20.1319C33.2469 20.4725 32.9484 20.7512 32.5836 20.7512H2.70164Z",
        fill: color && color || "#fff"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M13.6908 9.43877C13.326 9.43877 13.0275 9.16009 13.0275 8.81948C13.0275 8.47887 13.326 8.2002 13.6908 8.2002C14.0556 8.2002 14.3541 8.47887 14.3541 8.81948C14.3541 9.16009 14.0556 9.43877 13.6908 9.43877Z",
        fill: color && color || "#fff"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M17.5596 3.89603C15.9676 1.32598 12.4742 0.386728 9.67729 1.73884C9.61096 1.84205 9.58885 1.79045 9.43407 1.87302C9.52251 1.83173 9.5999 1.79045 9.67729 1.74916C9.99788 1.34662 9.68834 0.758301 9.14664 0.758301C8.25118 0.758301 8.33962 2.10009 9.22403 1.98656C7.9748 2.7297 7.04617 3.89603 6.6703 5.23782C6.44919 5.99128 6.40497 6.77572 6.53763 7.5395C6.63713 8.11751 6.86929 9.23223 7.42204 9.61412C7.89741 9.94441 8.417 9.53155 8.8371 9.30447C9.55568 8.92258 10.2632 8.54069 10.9818 8.14847C12.0762 7.56015 13.1818 6.9615 14.2873 6.37318C14.9174 6.03257 18.1344 4.82496 17.5596 3.89603C15.9676 1.32598 17.648 4.04053 17.5596 3.89603ZM8.11852 8.27233C7.49943 6.85829 7.76475 5.18621 8.78182 3.98892C8.78182 5.06235 9.46724 6.33189 9.98683 7.26083L8.11852 8.27233ZM11.1366 6.64154C10.6833 5.81582 9.62201 3.95796 10.0974 2.94645C11.3245 3.23545 12.3637 4.7011 13.0159 5.63003L11.1366 6.64154ZM14.1657 5.01075C13.4802 4.05085 12.7174 3.1116 11.7335 2.39941C13.3476 2.18266 15.0058 2.77099 16.045 3.99924L14.1657 5.01075Z",
        fill: color && color || "#fff"
      }));

    case "pet":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "47",
        height: "29",
        viewBox: "28 0 22 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M18.0985 23.1652C18.0985 23.1652 21.9279 20.6929 22.7678 13.1655C23.5584 6.01944 29.6606 6.03174 30.2783 6.03174C30.8959 6.03174 35.3923 6.10554 38.2705 9.96763C39.1599 11.1607 39.3081 12.2554 40.741 12.5875C42.1739 12.9195 44.0639 13.5714 44.0639 13.5714C44.0639 13.5714 45.8674 13.8051 45.6574 15.3672C45.5709 16.0191 45.188 16.4372 44.941 16.634C44.8051 16.7447 44.7063 16.88 44.6568 17.0399C44.4345 17.7041 44.0145 19.2785 42.5198 19.8934C40.8399 20.5699 38.3446 20.1271 36.0594 20.3116C34.8982 20.41 33.4406 20.7667 32.5018 23.0914C31.6988 25.0716 31.2789 26.7321 31.4394 28.8722",
        stroke: color && color || "#fff",
        strokeWidth: "1.5",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M28.6848 8.39307C28.6848 8.39307 28.1907 10.853 30.0683 12.4642C31.9459 14.0755 33.1071 14.5183 32.9094 16.191C32.7118 17.8638 30.7477 18.7617 29.426 18.5895C28.1042 18.4173 26.9678 18.036 25.4484 16.2525C23.3114 13.7311 23.7561 9.74603 23.7561 9.74603",
        stroke: color && color || "#fff",
        strokeWidth: "1.5",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M44.2245 2.85801C44.1998 1.81254 43.3722 0.963867 42.3222 0.963867C41.2722 0.963867 40.4199 1.81254 40.4199 2.85801C40.4199 3.03021 40.4199 3.03021 40.4199 2.85801C40.4199 1.81254 39.5675 0.963867 38.5176 0.963867C37.4676 0.963867 36.6152 1.81254 36.6152 2.85801C36.6152 3.3746 36.7882 3.78049 37.1711 4.19868C37.554 4.61686 40.4322 7.67948 40.4322 7.67948C40.4322 7.67948 43.5698 4.33397 43.7057 4.19868C43.8292 4.03878 44.2369 3.62059 44.2245 2.85801Z",
        stroke: color && color || "#fff",
        strokeWidth: "1.5",
        strokeMiterlimit: "10"
      }));

    case "zoomin":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "23",
        height: "23",
        viewBox: "0 0 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M15.9353 14.0624H14.9301L14.5739 13.7189C15.8208 12.2685 16.5714 10.3854 16.5714 8.33698C16.5714 3.76935 12.869 0.0668945 8.30134 0.0668945C3.73371 0.0668945 0.03125 3.76935 0.03125 8.33698C0.03125 12.9046 3.73371 16.6071 8.30134 16.6071C10.3498 16.6071 12.2328 15.8564 13.6833 14.6095L14.0268 14.9658V15.9709L20.3884 22.3198L22.2842 20.424L15.9353 14.0624ZM8.30134 14.0624C5.13326 14.0624 2.57589 11.5051 2.57589 8.33698C2.57589 5.1689 5.13326 2.61154 8.30134 2.61154C11.4694 2.61154 14.0268 5.1689 14.0268 8.33698C14.0268 11.5051 11.4694 14.0624 8.30134 14.0624Z",
        fill: "white"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M11.4822 8.97321H8.93757V11.5179H7.66525V8.97321H5.12061V7.70089H7.66525V5.15625H8.93757V7.70089H11.4822V8.97321Z",
        fill: "white"
      }));

    case "zoomout":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M16.614 14.7768H15.6088L15.2526 14.4333C16.4995 12.9828 17.2501 11.0998 17.2501 9.05134C17.2501 4.48371 13.5477 0.78125 8.98005 0.78125C4.41242 0.78125 0.709961 4.48371 0.709961 9.05134C0.709961 13.619 4.41242 17.3214 8.98005 17.3214C11.0285 17.3214 12.9115 16.5708 14.362 15.3239L14.7055 15.6801V16.6853L21.0671 23.0342L22.9629 21.1384L16.614 14.7768ZM8.98005 14.7768C5.81197 14.7768 3.2546 12.2194 3.2546 9.05134C3.2546 5.88326 5.81197 3.32589 8.98005 3.32589C12.1481 3.32589 14.7055 5.88326 14.7055 9.05134C14.7055 12.2194 12.1481 14.7768 8.98005 14.7768ZM5.79925 8.41518H12.1609V9.6875H5.79925V8.41518Z",
        fill: "white"
      }));

    case "search_icon":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || 17,
        height: height && height || 17,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M10.6637 2.22033C8.33716 -0.106171 4.54928 -0.10617 2.22044 2.22267C-0.106062 4.54918 -0.106062 8.33705 2.22044 10.6636C4.2991 12.7422 7.5375 12.9597 9.86868 11.3253C9.89206 11.3533 9.91077 11.3814 9.93883 11.4094L14.8373 16.308C15.2442 16.7148 15.9036 16.7148 16.3104 16.308C16.7173 15.9011 16.7173 15.2417 16.3104 14.8349L11.4096 9.93404C11.3838 9.90832 11.3534 9.88728 11.3277 9.86623C12.9598 7.54207 12.7423 4.29899 10.6637 2.22033ZM9.72839 9.73062C7.91629 11.5427 4.96782 11.5404 3.15572 9.72828C1.34362 7.91618 1.34362 4.97005 3.15572 3.15795C4.96782 1.34585 7.91395 1.34585 9.72605 3.15795C11.5382 4.97005 11.5405 7.91852 9.72839 9.73062Z",
        fill: color && color || "white"
      }));

    case "folder":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || 23,
        height: height && height || 22,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("rect", {
        x: "1.93164",
        y: "1.37842",
        width: "19.1105",
        height: "19",
        rx: "1",
        stroke: color && color || "#424242",
        strokeWidth: "2"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M9.98422 7.37842C9.98422 8.47804 9.08667 9.37842 7.96843 9.37842C6.85018 9.37842 5.95264 8.47804 5.95264 7.37842C5.95264 6.27879 6.85018 5.37842 7.96843 5.37842C9.08667 5.37842 9.98422 6.27879 9.98422 7.37842Z",
        stroke: color && color || "#424242",
        strokeWidth: "2"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M2.43945 19.3784L16.0105 8.37842L20.5342 11.3784",
        stroke: color && color || "#424242",
        strokeWidth: "2",
        strokeLinejoin: "round"
      }));

    case "elevator":
      return /*#__PURE__*/React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width && width || 27,
        height: height && height || 28,
        viewBox: "0 0 27 28",
        fill: "none"
      }, /*#__PURE__*/React__default.createElement("rect", {
        x: "0.5",
        y: "6.97815",
        width: "26",
        height: "20.5217",
        rx: "0.5",
        stroke: color && color || "#1D1C38"
      }), /*#__PURE__*/React__default.createElement("circle", {
        cx: "8.21765",
        cy: "13.1304",
        r: "2.23913",
        stroke: color && color || "#1D1C38"
      }), /*#__PURE__*/React__default.createElement("circle", {
        cx: "18.3915",
        cy: "13.1304",
        r: "2.23913",
        stroke: color && color || "#1D1C38"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M5.97852 20.1739C5.97852 18.9373 6.98101 17.9348 8.21765 17.9348C9.45428 17.9348 10.4568 18.9373 10.4568 20.1739V27.5H5.97852V20.1739Z",
        stroke: color && color || "#1D1C38"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M6.65234 3.54348L8.84227 1.35355C9.03753 1.15829 9.35411 1.15829 9.54938 1.35355L11.7393 3.54348",
        stroke: color && color || "#1D1C38",
        strokeLinecap: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M19.8145 1.00004L17.6245 3.18996C17.4293 3.38523 17.1127 3.38523 16.9174 3.18996L14.7275 1.00004",
        stroke: color && color || "#1D1C38",
        strokeLinecap: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M16.1523 20.1739C16.1523 18.9373 17.1548 17.9348 18.3915 17.9348C19.6281 17.9348 20.6306 18.9373 20.6306 20.1739V27.5H16.1523V20.1739Z",
        stroke: color && color || "#1D1C38"
      }));

    case "email":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "15",
        height: height || 11,
        viewBox: "0 0 15 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 0.5H12.5C13.1875 0.5 13.75 1.0625 13.75 1.75V9.25C13.75 9.9375 13.1875 10.5 12.5 10.5H2.5C1.8125 10.5 1.25 9.9375 1.25 9.25V1.75C1.25 1.0625 1.8125 0.5 2.5 0.5Z",
        stroke: color || "#1D1C38",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M13.75 1.75L7.5 6.125L1.25 1.75",
        stroke: color || "#1D1C38",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "emailV2":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "20",
        height: "17",
        viewBox: "0 0 20 17",
        fill: "none"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.34521 1.60498H17.0288C17.9695 1.60498 18.7393 2.37468 18.7393 3.31543V13.5781C18.7393 14.5189 17.9695 15.2886 17.0288 15.2886H3.34521C2.40447 15.2886 1.63477 14.5189 1.63477 13.5781V3.31543C1.63477 2.37468 2.40447 1.60498 3.34521 1.60498Z",
        stroke: "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M18.7393 3.31543L10.187 9.302L1.63477 3.31543",
        stroke: "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "csvdownload":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "17",
        height: "18",
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M1 13V15.4C1 16.2837 1.71634 17 2.6 17H13.8C14.6837 17 15.4 16.2837 15.4 15.4V13",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M5 9L8.2 12.2L11.4 9",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M8.2002 1V12.2",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "infoIcon":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
        stroke: "#979797",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M8 11V9",
        stroke: "#979797",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("circle", {
        cx: "8",
        cy: "6",
        r: "1",
        fill: "#979797"
      }));

    case "image-hotspot":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width && width || 15,
        height: height && height || 14,
        viewBox: "0 0 15 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.72188 11.645V6.78149C9.32401 6.46415 10.5299 5.08199 10.5299 3.425C10.5299 1.53342 8.9584 0 7.01988 0C5.08136 0 3.50988 1.53342 3.50988 3.425C3.50988 5.08199 4.71575 6.46415 6.31788 6.78149V11.645H7.72188ZM4.914 9.71625V8.32771C2.06677 8.63213 0 9.56791 0 10.96C0 12.6771 3.14477 13.7 7.02 13.7C10.8952 13.7 14.04 12.6771 14.04 10.96C14.04 9.56791 11.9732 8.63213 9.126 8.32771V9.71625C11.1848 9.96704 12.636 10.5399 12.636 10.96C12.636 11.5127 10.1234 12.33 7.02 12.33C3.91656 12.33 1.404 11.5127 1.404 10.96C1.404 10.5399 2.85516 9.96704 4.914 9.71625Z",
        fill: "#DADADA"
      }));

    case "trash":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "15",
        height: height || "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M1.875 3.75H3.125H13.125",
        stroke: "#1D1C38",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M12.375 3.75C12.375 3.47386 12.1511 3.25 11.875 3.25C11.5989 3.25 11.375 3.47386 11.375 3.75H12.375ZM3.625 3.75C3.625 3.47386 3.40114 3.25 3.125 3.25C2.84886 3.25 2.625 3.47386 2.625 3.75H3.625ZM4.5 3.75C4.5 4.02614 4.72386 4.25 5 4.25C5.27614 4.25 5.5 4.02614 5.5 3.75H4.5ZM9.5 3.75C9.5 4.02614 9.72386 4.25 10 4.25C10.2761 4.25 10.5 4.02614 10.5 3.75H9.5ZM11.375 3.75V12.5H12.375V3.75H11.375ZM11.375 12.5C11.375 12.9142 11.0392 13.25 10.625 13.25V14.25C11.5915 14.25 12.375 13.4665 12.375 12.5H11.375ZM10.625 13.25H4.375V14.25H10.625V13.25ZM4.375 13.25C3.96079 13.25 3.625 12.9142 3.625 12.5H2.625C2.625 13.4665 3.4085 14.25 4.375 14.25V13.25ZM3.625 12.5V3.75H2.625V12.5H3.625ZM5.5 3.75V2.5H4.5V3.75H5.5ZM5.5 2.5C5.5 2.08579 5.83579 1.75 6.25 1.75V0.75C5.2835 0.75 4.5 1.5335 4.5 2.5H5.5ZM6.25 1.75H8.75V0.75H6.25V1.75ZM8.75 1.75C9.16421 1.75 9.5 2.08579 9.5 2.5H10.5C10.5 1.5335 9.7165 0.75 8.75 0.75V1.75ZM9.5 2.5V3.75H10.5V2.5H9.5Z",
        fill: "#1D1C38"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M6.25 6.875V10.625",
        stroke: "#1D1C38",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M8.75 6.875V10.625",
        stroke: "#1D1C38",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "plus":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "18",
        height: height || "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M9 3.75V14.25",
        stroke: color || "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M3.75 9H14.25",
        stroke: color || "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "check":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "16",
        height: height || "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color || "#1D1C38",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-check"
      }, /*#__PURE__*/React__default.createElement("polyline", {
        points: "20 6 9 17 4 12"
      }));

    case "x":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "16",
        height: height || "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color || "#EA6767",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-x"
      }, /*#__PURE__*/React__default.createElement("line", {
        x1: "18",
        y1: "6",
        x2: "6",
        y2: "18"
      }), /*#__PURE__*/React__default.createElement("line", {
        x1: "6",
        y1: "6",
        x2: "18",
        y2: "18"
      }));

    case "view":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "19",
        height: height || "16",
        viewBox: "0 0 19 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "13.6818",
        height: "10.5556",
        rx: "0.5",
        stroke: color || "#1D1C38"
      }), /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.7128 12.6667C13.9487 12.6667 15.7611 10.8012 15.7611 8.50004C15.7611 6.19885 13.9487 4.33337 11.7128 4.33337C9.47703 4.33337 7.66455 6.19885 7.66455 8.50004C7.66455 10.8012 9.47703 12.6667 11.7128 12.6667Z",
        fill: "#F5F5FA",
        stroke: color || "#1D1C38",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M17.3805 14.3333L14.5737 11.4445",
        stroke: color || "#1D1C38",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("ellipse", {
        cx: "2.15887",
        cy: "2.22222",
        rx: "0.431818",
        ry: "0.444444",
        fill: "#1D1C38"
      }), /*#__PURE__*/React__default.createElement("ellipse", {
        cx: "3.88641",
        cy: "2.22222",
        rx: "0.431818",
        ry: "0.444444",
        fill: "#1D1C38"
      }), /*#__PURE__*/React__default.createElement("ellipse", {
        cx: "5.61346",
        cy: "2.22222",
        rx: "0.431818",
        ry: "0.444444",
        fill: "#1D1C38"
      }));

    case "car_duration":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "34",
        height: "23",
        viewBox: "0 0 34 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5858 4.62616C13.1603 4.66499 12.8843 4.80193 12.5261 5.152C12.1361 5.5331 12.0862 5.6211 11.5151 6.935L10.9988 8.12262L10.2009 8.13001C9.6421 8.13519 9.39157 8.14718 9.36484 8.16995C9.22736 8.28713 9.15921 8.65287 9.23255 8.87964C9.28015 9.02686 9.46624 9.23836 9.61596 9.31545C9.74839 9.38363 10.0042 9.45172 10.1991 9.4707L10.3808 9.48837L10.1089 10.1434L9.83709 10.7984L9.84448 13.4741C9.85167 16.0866 9.85313 16.153 9.9066 16.2821C9.9712 16.4379 10.123 16.5878 10.2703 16.6413C10.3532 16.6714 10.6235 16.6795 11.5427 16.6795C12.8661 16.6795 12.8905 16.6761 13.0488 16.4709C13.2079 16.2645 13.212 16.2375 13.212 15.3843V14.603H17.2427H21.2733V15.3593C21.2733 15.8583 21.2842 16.1528 21.3052 16.225C21.3511 16.3821 21.5209 16.5678 21.6742 16.6286C21.7915 16.675 21.9052 16.6795 22.9833 16.6795H24.164L24.2937 16.6114C24.4298 16.54 24.5356 16.4202 24.5969 16.2683C24.6261 16.1959 24.6372 15.6465 24.6526 13.5159L24.6719 10.8541L24.3976 10.1852C24.2468 9.81727 24.1234 9.50685 24.1233 9.49534C24.1233 9.48383 24.1714 9.47444 24.2301 9.47444C24.4013 9.47444 24.7221 9.39559 24.8777 9.31529C25.1936 9.1522 25.3544 8.84438 25.295 8.51638C25.2785 8.42546 25.234 8.30298 25.1962 8.24423L25.1273 8.13739L24.321 8.13001L23.5147 8.12262L23.0086 6.95287C22.4489 5.65934 22.3856 5.54676 22.0071 5.1721C21.6291 4.79791 21.3623 4.66825 20.8803 4.62443C20.5263 4.59224 13.9403 4.5938 13.5858 4.62616ZM20.9748 5.82585C21.1613 5.91632 21.31 6.06416 21.4901 6.33828C21.6458 6.57512 21.68 6.64714 22.2515 7.94145L22.6515 8.84731L19.9539 8.85441C18.4702 8.85832 16.0419 8.85832 14.5577 8.85441L11.8591 8.84731L12.2601 7.94145C12.8353 6.64181 12.8677 6.57347 13.0163 6.34773C13.2508 5.99116 13.4369 5.83229 13.6933 5.7696C13.7514 5.75541 15.3151 5.74652 17.3105 5.74903L20.8255 5.75346L20.9748 5.82585ZM12.5802 11.0755C12.7749 11.1657 12.9788 11.3702 13.072 11.5689C13.3171 12.0917 13.0906 12.7122 12.5606 12.9697C12.4066 13.0445 12.3547 13.0554 12.1534 13.0554C11.9507 13.0554 11.9006 13.0447 11.7402 12.9669C11.5201 12.8603 11.3302 12.6693 11.2329 12.4568C11.1721 12.3239 11.1627 12.2664 11.1627 12.0248C11.1627 11.7779 11.1714 11.7269 11.2388 11.5788C11.4183 11.1839 11.7621 10.9715 12.1942 10.9887C12.3613 10.9953 12.4502 11.0153 12.5802 11.0755ZM22.7797 11.0732C23.1229 11.2341 23.3388 11.5635 23.3581 11.9556C23.3814 12.4275 23.1727 12.7765 22.7452 12.9807C22.6155 13.0425 22.5515 13.0549 22.359 13.0551C22.1559 13.0554 22.1065 13.0448 21.9458 12.9669C21.0849 12.5496 21.1654 11.3265 22.074 11.017C22.2529 10.9561 22.5867 10.9826 22.7797 11.0732ZM19.6838 11.9937C19.7969 12.0823 19.8879 12.2576 19.8879 12.3871C19.8879 12.5166 19.7969 12.6919 19.6838 12.7806L19.5812 12.8609L17.2882 12.8684C15.0026 12.8758 14.9949 12.8756 14.8768 12.8169C14.5993 12.679 14.5372 12.2942 14.7541 12.0562C14.9018 11.894 14.7923 11.9005 17.2855 11.9071L19.5812 11.9133L19.6838 11.9937Z",
        fill: color || "white"
      }), /*#__PURE__*/React__default.createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "32.7428",
        height: "21.2396",
        rx: "10.6198",
        stroke: color || "white"
      }));

    case "walk_duration":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "35",
        height: "23",
        viewBox: "0 0 35 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.6142 3.87055C16.126 3.99849 15.7262 4.38316 15.5737 4.87148C15.5044 5.09318 15.5004 5.46408 15.5649 5.67769C15.6934 6.10316 15.9886 6.4447 16.3802 6.62091C16.592 6.71624 16.7672 6.75122 17.023 6.74933C17.8137 6.74351 18.4591 6.09046 18.4606 5.29465C18.4611 5.03893 18.4251 4.88418 18.3091 4.64286C18.1311 4.2725 17.7648 3.97396 17.3616 3.8706C17.1737 3.82246 16.7978 3.82241 16.6142 3.87055ZM15.8631 7.13726C15.6179 7.22077 15.2016 7.42826 14.6689 7.7324C14.0766 8.07059 13.8795 8.20944 13.7004 8.41466C13.4996 8.64468 13.4428 8.73812 13.0299 9.51788C12.5959 10.3374 12.5653 10.426 12.6343 10.662C12.7443 11.0379 13.1252 11.2362 13.488 11.1066C13.7251 11.0219 13.7627 10.9711 14.1895 10.1563C14.4058 9.7435 14.6144 9.36749 14.6532 9.32067C14.7326 9.2249 14.9728 9.0552 14.9836 9.0873C14.9874 9.09879 14.8832 9.57495 14.752 10.1455C14.5546 11.0035 14.5135 11.217 14.5138 11.3811C14.5143 11.6195 14.5823 11.8634 14.6973 12.0393C14.7411 12.1064 15.2873 12.6731 15.911 13.2988L17.0451 14.4363L17.5101 15.7939C17.7659 16.5406 18.0008 17.1965 18.032 17.2515C18.2698 17.6693 18.8236 17.7662 19.2003 17.4559C19.3953 17.2953 19.5049 16.985 19.4478 16.7551C19.3911 16.5271 18.4812 13.9204 18.4087 13.7785C18.2925 13.5511 18.2445 13.4964 17.5479 12.7973L16.8898 12.1368L17.0233 11.7209C17.0967 11.4922 17.2853 10.8978 17.4425 10.4C17.5996 9.90216 17.7358 9.4808 17.7451 9.46363C17.756 9.44337 17.8032 9.49244 17.8794 9.60326C18.1117 9.94098 18.4768 10.2027 18.8326 10.2865C19.0073 10.3276 20.3653 10.5345 20.4606 10.5345C20.6902 10.5345 20.95 10.3603 21.0439 10.1435C21.1872 9.81256 21.0511 9.44151 20.7248 9.2739C20.6666 9.24403 19.3125 9.01937 19.1831 9.01812C19.122 9.01753 18.9954 8.88079 18.813 8.61816C18.1343 7.64135 17.7253 7.20923 17.4445 7.17229C17.2973 7.15291 16.2579 7.08515 16.1231 7.08613C16.0614 7.0866 15.9444 7.10959 15.8631 7.13726ZM14.2255 14.9561C13.5857 16.6595 13.5754 16.6897 13.576 16.8703C13.577 17.1721 13.719 17.3992 13.9894 17.5314C14.2689 17.6681 14.6006 17.6275 14.828 17.4286C14.8906 17.3739 14.9651 17.2837 14.9937 17.2281C15.0222 17.1726 15.2758 16.5107 15.5571 15.7572L16.0688 14.3873L15.486 13.8064C15.1655 13.4868 14.897 13.2254 14.8894 13.2254C14.8819 13.2254 14.5831 14.0042 14.2255 14.9561Z",
        fill: color || "white"
      }), /*#__PURE__*/React__default.createElement("rect", {
        x: "0.835815",
        y: "0.5",
        width: "32.7428",
        height: "21.2396",
        rx: "10.6198",
        stroke: color || "white"
      }));

    case "eye":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "24",
        height: "19",
        viewBox: "0 0 24 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 9.40002C1 9.40002 5 1.40002 12 1.40002C19 1.40002 23 9.40002 23 9.40002C23 9.40002 19 17.4 12 17.4C5 17.4 1 9.40002 1 9.40002Z",
        stroke: "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 12.4C13.6569 12.4 15 11.0569 15 9.40002C15 7.74317 13.6569 6.40002 12 6.40002C10.3431 6.40002 9 7.74317 9 9.40002C9 11.0569 10.3431 12.4 12 12.4Z",
        stroke: "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "disabled_eye":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.94 18.34C16.2306 19.643 14.1491 20.3649 12 20.4C5 20.4 1 12.4 1 12.4C2.24389 10.0819 3.96914 8.05663 6.06 6.46002",
        stroke: "#979797",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.8999 4.64005C10.5882 4.47893 11.293 4.39839 11.9999 4.40005C18.9999 4.40005 22.9999 12.4 22.9999 12.4C22.3929 13.5357 21.669 14.6048 20.8399 15.59",
        stroke: "#979797",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.12 14.52C13.3721 15.3226 12.2457 15.653 11.1828 15.3816C10.1199 15.1101 9.28988 14.2801 9.01842 13.2172C8.74697 12.1543 9.07735 11.0279 9.87996 10.28",
        stroke: "#979797",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M1 1.40002L23 23.4",
        stroke: "#979797",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "video_cam":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "24",
        height: height || "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23 7.40002L16 12.4L23 17.4V7.40002Z",
        stroke: color || "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 7.40002C1 6.29545 1.89543 5.40002 3 5.40002H14C15.1046 5.40002 16 6.29546 16 7.40002V17.4C16 18.5046 15.1046 19.4 14 19.4H3C1.89543 19.4 1 18.5046 1 17.4V7.40002Z",
        stroke: color || "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "dump":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "24",
        height: height || "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M22 13.4H16L14 16.4H10L8 13.4H2",
        stroke: color || "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.47 5.59002L2 13.4V18.4C2 19.5046 2.89543 20.4 4 20.4H20C21.1046 20.4 22 19.5046 22 18.4V13.4L18.53 5.59002C18.2093 4.86609 17.4918 4.39948 16.7 4.40002H7.3C6.50822 4.39948 5.79067 4.86609 5.47 5.59002Z",
        stroke: color || "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "edit":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "20",
        height: height || "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 1L19 6L6 19H1V14L14 1Z",
        stroke: "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "embed":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "25",
        height: height || "16",
        viewBox: "0 0 25 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M7 4L2 8L7 12",
        stroke: "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M18 12L23 8L18 4",
        stroke: "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M15 1.5L10 15",
        stroke: "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round"
      }));

    case "share":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "24",
        height: height || "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M15 6C14.4477 6 14 6.44772 14 7C14 7.55228 14.4477 8 15 8V6ZM18 7V6V7ZM15 16C14.4477 16 14 16.4477 14 17C14 17.5523 14.4477 18 15 18V16ZM9 18C9.55229 18 10 17.5523 10 17C10 16.4477 9.55229 16 9 16V18ZM9 8C9.55229 8 10 7.55228 10 7C10 6.44772 9.55229 6 9 6V8ZM15 8H18V6H15V8ZM18 8C19.0609 8 20.0783 8.42143 20.8284 9.17157L22.2426 7.75736C21.1174 6.63214 19.5913 6 18 6V8ZM20.8284 9.17157C21.5786 9.92172 22 10.9391 22 12H24C24 10.4087 23.3679 8.88258 22.2426 7.75736L20.8284 9.17157ZM22 12C22 14.2091 20.2091 16 18 16V18C21.3137 18 24 15.3137 24 12H22ZM18 16H15V18H18V16ZM9 16H6V18H9V16ZM6 16C4.93913 16 3.92172 15.5786 3.17157 14.8284L1.75736 16.2426C2.88258 17.3679 4.4087 18 6 18V16ZM3.17157 14.8284C2.42143 14.0783 2 13.0609 2 12H0C0 13.5913 0.632141 15.1174 1.75736 16.2426L3.17157 14.8284ZM2 12C2 9.79086 3.79086 8 6 8V6C2.68629 6 0 8.68629 0 12H2ZM6 8H9V6H6V8Z",
        fill: "#04D2C6"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M8 12H16",
        stroke: "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "folio":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: "21",
        height: "20",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 17.4C21 18.5046 20.1046 19.4 19 19.4H3C1.89543 19.4 1 18.5046 1 17.4V3.40002C1 2.29545 1.89543 1.40002 3 1.40002H8L10 4.40002H19C20.1046 4.40002 21 5.29545 21 6.40002V17.4Z",
        stroke: "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "property":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "26",
        height: height || "26",
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M15.087 25H2C1.44772 25 1 24.5523 1 24V6.2196C1 5.89146 1.16099 5.5842 1.43079 5.39741L7.23396 1.37983C7.56614 1.14986 8.00407 1.14237 8.34393 1.36085L14.6277 5.40043C14.9139 5.58443 15.087 5.90134 15.087 6.2416V11.9565M15.087 25V11.9565M15.087 25H23.4783C24.0305 25 24.4783 24.5523 24.4783 24V12.4917C24.4783 12.1574 24.3112 11.8451 24.033 11.6597L20.3373 9.19589C20.0014 8.97195 19.5638 8.97195 19.2279 9.19589L15.087 11.9565",
        stroke: color || "#424242",
        strokeWidth: "2"
      }), /*#__PURE__*/React__default.createElement("rect", {
        x: "6.73926",
        y: "9.86963",
        width: "2.08696",
        height: "2.08696",
        rx: "1",
        fill: color || "#424242"
      }), /*#__PURE__*/React__default.createElement("rect", {
        x: "6.73926",
        y: "15.0869",
        width: "2.08696",
        height: "2.08696",
        rx: "1",
        fill: color || "#424242"
      }));

    case "prospect":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "24",
        height: height || "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M17 21V19C17 16.7909 15.2091 15 13 15H5C2.79086 15 1 16.7909 1 19V21",
        stroke: color || "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z",
        stroke: color || "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M23 20.9999V18.9999C22.9986 17.177 21.765 15.5856 20 15.1299",
        stroke: color || "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M16 3.12988C17.7699 3.58305 19.0078 5.17787 19.0078 7.00488C19.0078 8.83189 17.7699 10.4267 16 10.8799",
        stroke: color || "#04D2C6",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case "calendar":
      return /*#__PURE__*/React__default.createElement("svg", {
        width: width || "17",
        height: height || "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.125 4.83301C2.125 3.72844 3.02043 2.83301 4.125 2.83301H12.875C13.9796 2.83301 14.875 3.72844 14.875 4.83301V13.583C14.875 14.6876 13.9796 15.583 12.875 15.583H4.125C3.02043 15.583 2.125 14.6876 2.125 13.583V4.83301Z",
        stroke: color || "#1D1C38",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M11.3335 1.41699V4.25033",
        stroke: color || "#1D1C38",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M5.6665 1.41699V4.25033",
        stroke: color || "#1D1C38",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M2.125 7.08301H14.875",
        stroke: color || "#1D1C38",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    default:
      return "";
  }
};

var Icon = function Icon(props) {
  return /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    style: props.style
  }, getIconSourceBase64Image(props.name, props.color, props.width, props.height, props.fillOpacity, props.isActive));
};

Icon.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  fillOpacity: PropTypes.string,
  isActive: PropTypes.bool
};

var css_248z$J = ".button {\n  background-color: #04d2c6;\n  color: white;\n  border-radius: 8px;\n  box-sizing: border-box;\n  text-align: center;\n  height: 42px;\n  cursor: pointer;\n  border: 0;\n  font-family: \"Roboto-Regular\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  z-index: 1305;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.button:focus {\n  box-shadow: 0px 0px 11px #fff !important;\n  border: solid 2px #02d4c6 !important;\n  outline: 0;\n  border-radius: 6px !important;\n  -webkit-transition: border .10s ease-in-out;\n  transition: border .10s ease-in-out; }\n\n.default {\n  background-color: #fff;\n  color: #000;\n  min-width: 153px;\n  font-weight: 500;\n  border: solid 1px #D9D9D9; }\n\n.disabled {\n  background-color: #D9D9D9;\n  color: #000;\n  min-width: 153px;\n  font-weight: 500;\n  cursor: not-allowed;\n  pointer-events: none; }\n\n.disabled-button {\n  background-color: #04d2c6;\n  width: 100%;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 24px;\n  padding: 5px 35px;\n  border-radius: 10px;\n  letter-spacing: 0.02em;\n  font-weight: normal;\n  opacity: 0.5;\n  pointer-events: none; }\n\n.standard {\n  min-width: 153px;\n  font-weight: 500; }\n\n.footer {\n  width: 100%;\n  font-weight: 600;\n  line-height: 15px;\n  padding: 5px 35px;\n  border-radius: 10px;\n  letter-spacing: 0.02em;\n  font-weight: normal; }\n\n.login_footer {\n  width: 100%;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 23.44px;\n  padding: 5px 35px;\n  border-radius: 10px;\n  letter-spacing: 0.02em;\n  font-weight: normal; }\n\n.share_link {\n  min-width: 121px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 15px;\n  padding: 5px 35px;\n  border-radius: 10px;\n  letter-spacing: 0.02em;\n  font-weight: normal;\n  border: 1px solid #D9D9D9; }\n\n.tour_like {\n  display: inline-block;\n  padding: 16px 40px;\n  height: auto;\n  font-weight: 500;\n  font-size: 1.5em;\n  line-height: 1.2em;\n  letter-spacing: 0.02em; }\n\n.basic {\n  font-size: 18px;\n  line-height: 21px;\n  padding: 8px 15px;\n  border-radius: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em; }\n\n.small {\n  min-width: 70px;\n  padding: 5px 8px; }\n\n.medium {\n  min-width: 100px;\n  padding: 8px 10px; }\n\n.large {\n  min-width: 130px;\n  padding: 10px; }\n\n.capsule {\n  border-radius: 33px;\n  border: none;\n  min-width: 95px;\n  padding: 8px 10px;\n  max-height: 30px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16px; }\n\n.embed_link {\n  min-width: 112px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16px;\n  padding: 5px 32px;\n  border-radius: 5px;\n  letter-spacing: 0.02em;\n  border: 1px solid #D9D9D9; }\n\n.admin_control {\n  background-color: #1d1c38;\n  color: white;\n  margin: 10px 0; }\n\n.logout {\n  background-color: #979797;\n  color: white;\n  margin: 10px 0; }\n\n@media only screen and (max-width: 767px) {\n  .tour_like {\n    font-size: 1.3em;\n    padding: 16px 28px; } }\n";
styleInject(css_248z$J);

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$A(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$A(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$A() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Button$2 = /*#__PURE__*/function (_React$Component) {
  _inherits$1(Button, _React$Component);

  var _super = _createSuper$A(Button);

  function Button(props) {
    var _this;

    _classCallCheck$1(this, Button);

    _this = _super.call(this, props);
    _this.buttonClickEvent = _this.buttonClickEvent.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(Button, [{
    key: "buttonClickEvent",
    value: function buttonClickEvent(e) {
      e.stopPropagation();
      var _this$props = this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;
      !disabled && onClick(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          type = _this$props2.type,
          label = _this$props2.label,
          disabled = _this$props2.disabled,
          color = _this$props2.color,
          textColor = _this$props2.textColor,
          isIcon = _this$props2.isIcon,
          iconName = _this$props2.iconName,
          iconColor = _this$props2.iconColor,
          iconWidth = _this$props2.iconWidth,
          iconHeight = _this$props2.iconHeight,
          isFullWidth = _this$props2.isFullWidth,
          _onKeyUp = _this$props2.onKeyUp,
          customStyle = _this$props2.customStyle;
      var style = {};

      if (!type) {
        type = "standard";
      } else if (disabled) {
        type = "disabled";
      }

      if (color) style.backgroundColor = color;
      if (textColor) style.color = textColor;
      if (isFullWidth) style.width = "100%";
      return /*#__PURE__*/React__default.createElement("div", {
        className: "button ".concat(type),
        style: _objectSpread$h(_objectSpread$h({}, customStyle), style),
        tabIndex: 0,
        onKeyUp: function onKeyUp(e) {
          return !disabled && _onKeyUp && _onKeyUp(e);
        },
        onClick: function onClick(e) {
          return !disabled && _this2.props.onClick(e) || false;
        }
      }, isIcon && /*#__PURE__*/React__default.createElement(Icon, {
        name: iconName,
        color: iconColor,
        width: iconWidth,
        height: iconHeight,
        style: {
          margin: "3px 10px 0 0"
        }
      }), /*#__PURE__*/React__default.createElement("span", null, label));
    }
  }]);

  return Button;
}(React__default.Component);

Button$2.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  textColor: PropTypes.string,
  isIcon: PropTypes.bool,
  iconName: PropTypes.string,
  iconColor: PropTypes.string,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
  isFullWidth: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyUp: PropTypes.func,
  customStyle: PropTypes.object
};

var img$3 = "data:image/gif;base64,R0lGODlhkAJyAvf/ACjZzlnh2YLp40Hd1ITp403f18r18xLUyfT9/BPVya7x7QbSxgXSxvn+/vz+/gfTx/3//wvTyHHm3w3UyPj+/YHo4gnTx+r7+vr+/gjTx2Lj2zLa0ff+/fv+/vX9/fb9/RnWyxvWy6Hu6vD8/O38+7jy71Lg2AzTyA/UyA7UyBjWyu/8+77z8PP9/Nr49wrTxxrWy+z8++78+y/a0Mj18tb49nbm4MD08cn18yfYzs/29BXVytP39R7XzPH9/JHr5lfh2ULd1Evf1uv7+5fs5x/XzG3l3i7a0Nf49un7+hDUyUzf1izZzxbVyirZz9z597vz8B3WzHnn4b/08MT08pjs6E/f1+f7+sX18tT39SDXzGnk3Zbs5/T9/TDa0Gvl3Vrh2fL9/Lzz8Eje1Urf1nfn4CHXzLrz77Lx7k7f12Tj3FPg2NX39ej7+p/u6bfy77Dx7dj49t759+D5+G/l3kne1t/5+Nn49hfVyuP6+ajv63Dl3+H6+NH39Dbb0dD39JLr5iPXzTjb0kTd1VXg2CbYzsP08bPx7hzWy+X6+cL08Znt6C3Zz4nq5BHUyXXm4DPa0SPYzZvt6DXb0aPv6kbe1eD6+H3o4Xvn4Z7u6cH08Ufe1XPm38z28zrc0pTs53jn4Ob7+c329JDr5o/r5nLm3+T6+Zzt6M729I3r5d359xTVymfk3SXYzlHg15Ps5nTm34zq5b3z8J3t6aTv6mbk3CLXzdv49yTYzTnc0j7c01Tg2NL39cf18qXv66vw7Gzl3m7l3q3w7LXy7lDg1zzc04fp5Dvc07Ty7qzw7F/i21bh2SvZz2Pj3D3c08b18nzo4anw7Fzi2obp5Lny7z/d037o4sv28+L6+ZXs50Xe1UPd1GXj3Kbv6zTb0bby7l3i2q/x7YXp42Hj2zHa0H/o4mjk3Y7r5Yvq5Vvi2nrn4Tfb0qDu6afv62Di24jq5KLu6qrw7F7i2mrk3dv594rq5Jrt6LHx7YDo4v3//uv7+rTx7tD29Jrs6ATSxv///yH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDA2IDc5LjE2NDY0OCwgMjAyMS8wMS8xMi0xNTo1MjoyOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjIgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTg2M0QyRkQ3RTM2MTFFQkJDRjJENjc4MDE2QUE3RjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTg2M0QyRkU3RTM2MTFFQkJDRjJENjc4MDE2QUE3RjAiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxQkNBOEU2Qzc4ODcxMUVCQkNGMkQ2NzgwMTZBQTdGMCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBODYzRDJGQzdFMzYxMUVCQkNGMkQ2NzgwMTZBQTdGMCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgH//v38+/r5+Pf29fTz8vHw7+7t7Ovq6ejn5uXk4+Lh4N/e3dzb2tnY19bV1NPS0dDPzs3My8rJyMfGxcTDwsHAv769vLu6ubi3trW0s7KxsK+urayrqqmop6alpKOioaCfnp2cm5qZmJeWlZSTkpGQj46NjIuKiYiHhoWEg4KBgH9+fXx7enl4d3Z1dHNycXBvbm1sa2ppaGdmZWRjYmFgX15dXFtaWVhXVlVUU1JRUE9OTUxLSklIR0ZFRENCQUA/Pj08Ozo5ODc2NTQzMjEwLy4tLCsqKSgnJiUkIyIhIB8eHRwbGhkYFxYVFBMSERAPDg0MCwoJCAcGBQQDAgEAACH5BAUDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrX868ufPn0KNLn069uvXr2LNr3869u/fv4MOL/x9Pvrz58+jTq1/Pvr379/Djy59Pv779+/jz69/Pv7///wAGKOCABBZo4IEIJqjgggw26OCDEEYo4YQUVmjhhRhmqOGGHHbo4YcghijiiCSWaOKJKKao4oostujiizDGKOOMNNZo44045qjjjjz26OOPQAYp5JBEFmnkkUgmqeSSTDbp5JNQRinllFRWaeWVWGap5ZZcdunll2CGKeaYZJZp5plopqnmmmy26eabcMYp55x01mnnnXjmqeeefPbp55+ABirooIQWauihiCaq6KKMNuroo5BGKumklFZq6aWYZqrpppx26umnoIYq6qiklmrqqaimquqqrLbq6quwxv8q66y01mrrrbjmquuuvPbq66/ABivssMQWa+yxyCar7LLMNuvss9BGK+201FZr7bXYZqvtttx26+234IYr7rjklmvuueimq+667Lbr7rvwxivvvPTWa++9+Oar77789uvvvwAHLPDABBds8MEIJ6zwwgw37PDDDwKRwMQUV2zxxRTHArFZBfjj8ccghyzyxwRsXFbHI6eccskmj4WyyjCT3LLLMdfsD8szg/WyzSvnHNbOPIuMs89dAR00yEMTvZXRR3uctNJZMd3001BfJfXRVFdd1dVBZ631VFzz7PXXUYVt89hkP2V2zWin3dTaMbft9lJwwyz33EnVrfLdeB//pXfPfYPd9Mh8B07U34QbLhXiQite9uCNO6425CEXLvlPjFd+uVOZI73525R7/jndocs8ulKdm346Uqk7vXrepbv+ut+x3zw77bFbfntNrdu+++G16/67TL0LPzxMxR8vVPLKA8V88z49Dz1P0k+vU/XW44R99jZtzz1N3n9PfPDi5xR++S+dj35L6q+/UvvupwR//CfNT39J9t8/Uv76h8R//x/5HwA7IsABbqSABswIAhN4kQUysCIOfOBEIijBiFCwgg+5IAYbosENLqSDHkwICEN4kBGSsCAmPOFAUqjCf7BQhS88YQxJOMMQ1tCDN9xgDjG4wwr2UII/fGAQ/xk4xAQW0YBHHGASAbjE/jVRf0+8XxTpN8X4VdF9V1xfFtG3xfJ1UXxf/F4YuTfG7JXRemecXhqht8bmtVF5bzxeHIc3x9/VcXd3vF0eZ7fHaHUAAYAMpCAHSchCGvKQiEykIheJgDqQT2mHOIAkJ0nJSlrykpjMpCY3yclOHiADjySaAmpHylKasmtQG+UpV8nKVRqvYKpspSxnCblXEiyWtMylLveWyl368peq8xkugUlMWYKil8VMZisjAIh8iFKZ0FzlAr7wAWFG85qmrIM+cjZMbHoTck7Iwsy6+c1yBg0GJWgZOc3Jzphl4BMO2Ng620nPkU2zARCbZz33Cf8yIVzgYfrkp0CPIM6GBVSg/ISBGAyK0IamLAJcYNhBHVpPBnACnwmbKEXrKYQhZHSjIAWZF2qAMI2GtJ0hgMLBTHpSdkagChCAZUtb+oA9xHNgLJ0pO5fwT4HJwABADapQh0rUohr1qEhNqlKXelQiRGCXXnBBCyWiiR7sUgVnmGpE6LGBXU5AElqFCAnWsMsFPAKjYWUIBsrwAF0yIA0xSKtDZvFUXUJCqnJliCKsqksY3CCvDHFBV3WZgkwAdiE+cAUDdLkAG6D1sAZpQBkWsMs1kACyCenHBHa5ATlgFiEsiMIuETGFzx4kDjPYZQrcYFqDrMAKZbUBBVpLkAb/0IGyuWSACVZAW4Is4gScpUdvBwKFEOwyBFQYrkCQkFpdooC1ypVBARabywxIYbbD5UApfAmEESj3H1VIwS4nYYfvQgEEu9RCcpV7h+bmcgKU+G4MlrDLDGACA8qlgBGom8vuKtcBRACuLv1QXuWWAL26LAIWvosEJuxSCSL4bhLGsMsHXAK/w9Uvf2lJiDD8FxACzqUgLPHdEjQhvQtWLhscrEsQJOK7F9hELhcQ0e/+gwNGwG0r92DjgTjgFXVdpRCq2eOBvEEFq2TEZYtMkBrkwJQgQAKTDdIGCtcuAgudskE8sAUdQ+4BRNAyQiAwiiAPTgIxFTNC9rEDyFkB/7tqRgg/nny0I8Q1zgq5wCCCFgK84lkhCGCFl1OWAhb82SGpeAHMHnCKQz8EDSdOmQ3S7OiG9IHOIUvDYyvNkCtUImQbkAGnI/IBNVAXBn4eNURI8QIUlFbVE4FDhGFN61rb+ta4zrWud83rXvv618AOtrCHTexiG/vYyE62spfN7GY7+9nQjra0p03talv72tjOtra3ze1ue/vb4A63uMdN7nKb+9zoTre6183udrv73fCOt7znTe962/ve+M63vvfN7377+98AD7jAB07wghv84AhPuMIXzvCGO/zhEI+4xCdO8Ypb/OIYz7jGN87xjnv84yAPuchHTvKSm/zkKHdPucpXzvKWu/zlMI+5zGdO85rb/OY4z7nOd87znvv850APutCHTvSiG/3oSE+60pfO9KY7/elQj7rUp071qlv96ljPuta3zvWue/3rYA+72MdO9rKb/exoT7va1872trv97XCPu9znTve62/3ueM+73vfOd8gEBAAh+QQJAwD/ACxKABIA9AFAAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsSJFPRYzatzIsaPHjyBDihxJsqTJkx1NoFzJsqXLlzBjypxJk6PKmjhz6tzJs6fPnxW1AR1KtKjRo0iTHgyitKnTp1CjSoXIdKrVq1izao1ZdavXr2DDikW4bazZs2jTIr2ptq3bt3BPso1Lt67duwvn4t3Lt29avX4DCx4sFTDhw4gT9zSsuLHjxygZQ55MuXLFTJYza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu7fv38CDCx9OvLjx48iTK1/OvLnz59CjS59Ovbr169iza9/Ovbv37+DDi/8fT768+fPo06tfz769+/fw48ufT7++/fv48+vfz7+///8ABijggAQWaOCBCCao4IIMNujggxBGKOGEFFZo4YUYZqjhhhx26OGHIIYo4ogklmjiiSimqOKKLLbo4oswxijjjDTWaOONOOao44489ujjj0AGKeSQRBZp5JFIJqnkkkw26eSTUEYp5ZRUVmnllVhmqeWWXHbp5ZdghinmmGSWaeaZaKap5ppstunmm3DGKeecdNZp55145qnnnnz26eefgAYq6KCEFmrooYgmquiijDbq6KOQRirppJRWaimKSRhy6WYXaACOKZtqRsM2jVAQqmUQZKILMqcqRsIPBo3/AIsrt7Q6WAevOPMGQkhYIUUYtvZVgjOvdLDQPQP4Euxdd5iwBwkOcWBMHTosC5cMEphwh0SmiGNtWx1wMQA13yZGTRBVGFsuYXyswckK6yLWhgvx1mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXbPPNOOes88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VhnrfXWXHft9ddghy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744ow37vjjkEcu+eSUV2755ZhnrvnmnHfu+eeghy766KSXbvrpqKeu+uqst+7667DHLvvstNdu++2456777rz37vvvwAcv/PDEF2/88cgnr/zyzDfv/PPQRy/99NRXb/312Gev/fbcd+/99+CHL/745Jdv/vnop6/++uy37/778Mcv//z012+/rS60EfYKnKzBx9cdqEIQyPU1agyAC+pKmjhAFZFmSUAGTdNBHYzBAYeQYA/aipovBnCPheBKV1QLgxSsgASEvIFYCaTaLVwBixEY5AfQ0hoydJEJCIiNAo3YBg3GZgpwaOACYzNEEqzuR8QiGvGISEyiEpfIxCY68YlQjKIUp0jFKlrxiljMoha3yMUuevGLYAyjGMdIxjKa8YxoTKMa18jGNrrxjXCMoxznSMc62vGOeMyjHvfIxz768Y+ADKQgB0nIQhrykIhMpCIXychGOvKRkIykJCdJyUpa8pKYzKQmN8nJTkIKM2OTzNZEqTVSZs2UWEPl1VRpNVZWrSxj60rYZAk2Wn7Nll5zBdlcSTWMaCggACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3vwy2Q9anEOLHn3xmL8epFOrXn1wg79ArGPLFu0awOzbuCu73pC7t2/Ggfx5+028+ODgQYwrX64XOfPn0OPC8GcluvXraBP4M4G9u/ev2tN9/x9P3qoSfxrKq1/f1J8/buzjyyfqXsL8+/h31s/Pv3/MBhq4045/BBZo4IEIJqjgggw26OCDEEYo4YQUVmjhhRhmqOGGHHbo4YcghijiiCSWaOKJKKao4oostujiizDGKOOMNNZo44045qjjjjz26OOPQAYp5JBEFmnkkUgmqeSSTDbp5JNQRinllFRWaeWVWGap5ZZcdunll2CGKeaYZJZp5plopqnmmmy26eabcMYp55x01mnnnXjmqeeefPbp55+ABirooIQWauihiCaq6KKMNuroo5BGKumklFZq6aWYZqrpppx26umnoIYq6qiklmrqqaimquqqrLbq6quwxv8q66y01mrrrbjmquuuvPbq66/ABivssMQWa+yxyCar7LLMNuvss9BGK+201FZr7bXYZqvtttx26+234IYr7rjklmvuueimq+667Lbr7rvwxivvvPTWa++9mSVxD74GukOdJfz2FwcD7qWADgYB56cJI+75cwQVCeOHQSznuafGEBHfZwoYDeORScb3QeFEw7pkAbJ8DTSSgnsZlNHFyfHxsUvDAcAsXwk5PMCDzfJRIAbPQF/oQ9DrmaJBEzIQPV4L1kzgHixKd9eBJCE0bMuAUVuHDMPu7ZAKB1lHp4M2DZ9QxgphQ5fHOAT7w4AG2KT9nA/QnNBwATvL/ZwvDQv/coPe0UEASSG/AH4dHwgbrvjijDfu+OOQRy755JRXbvnlmGeu+eacd+7556CHLvropJdu+umop6766qy37vrrsMcu++y012777QYCkcDuvPfu+++8x4J7XAU0bPzxyCNPwPBwFZ/8888vz7xbzkNvfcPST89W9ddbn732anHfffTgbz/+9d+Xf5b45x+fvvplsd8+9vCnJf/8/rxfv1j3z6///mDpX/v+B0CvCPB8BCwgVw44vgQqUCsM7J4DH4iVCKKPgvzDX/ImiMGqWNB7HQygBpUXwq98EHocLGFUTkg+FS5whO5z4QthSD8ZQpCGNbRhBXHonhTqcCks3OAP/3fIQx8OESlBJOERPcjD/C2RiUV8IlWSGEMpSoWKxjOiFYWCxRxu0Sld7OEXoRJGJ44RjE3U4hl7UkY1rnEnbXwjU+IoR6XQsY5ITCMek3LHPRalj34cCiADGZRBEvInhjwkG/WoSC4yspFASSQkcyLJSd6kkpasCSYzOZNNcjImnvzkS0IpypaQspQrOSUqU6LKVZ6kla4sCSxjOZJZ0jIktrzlR3Kpy47wspcb+SUwMyLMYV6kmMasCDKTOZFlMjMiznzmQ6IpzYZQs5oLuSY2E6LNbR6km94sCDjDOZBxkvMf5iRnOsO5Tm+2c5vvxGY8qzlPadbzmfdkZj6Tuf9PY/ZzmP8EZkB7OVBdFvSWB6VlQmO5UFc2dJUPRWVESzlRUVb0kxflZEYzuVFLdnSSH4VkSBs5UkWW9JAn1VsHEMDSlrr0pTCNqUxnStOa2vSmCKjDIzt4iAP49KdADapQh0rUohr1qEhN6gEysFMMKqCJUI2qVAeowqdO9apYvaobh2fVrHr1qyPcKu66CtaymhWFVT2rWtfqRaey9a1mBUVa4UrXrEYAEPkIIVnryleoLuALH+jgXvtKWBzWQR9uLaxieegEkz1wsIuNbPtgUILHSvayGszAJxxQQMhi9rPP+2sDAOhZ0Jr2eEK4wP5Ke9rWOsyx6mOta08Lg5//xXa2uEVeBLhw29z61j0M4MRotSfb34JWCBibXnGN+1kv1EC5zGVuCKDAvOVGF7MRqAIExnpd5j5gD5y1nXW7i9klqLZ2MjCAetfL3va6973wja9850vf+saXCBE4qxdccE6LaKIHZ1XBGfpbEXq4xqwTkASBKUKCNZx1AY8Y7oIhgoEyPMCsDEhDDCYskVnk16yQ4C+HIaIIAJsVBn8b8UNccOCypuBjKnaID1zRNrAuwAYSjrFCGlCGBZx1DSTQcUP64TSzbkAOQmYIC6JwVkRMIckLicMMzpoCN0BZISuwwoNtQIErI6QBdPBxWRlgArR5+SCLsJuR6XHmg0Ch/2pmDQHE2lwQJEzZrCiwMp0JIoMC1PirGZBCl/csEA6UQq1AGAGhB1KFlZl1EnZYtECgAIKzamHOi77Dncs6AUpI+h8xWMJZM4CJxBGaAkb481cTLWkHEEHNZfVDpCVdgkqbtQhY+DQSmHBWJYjg00kYw1kfcAlT7xnVqvYqIcLQakDAGqyCABitm2DpXEuaDbw2KwgS8ekLbKKsC+Dtp//BASOIOat7GPdAHPCKD19VCIFV90DeoIKrMiLI8iZIDXIgVRAgId8GaYOwmxgB2wK8IB7YwrlH+AAiHBwhEBiFuzUoge0+HCH72MEIrTDoiyOEH/ye3xE27HGFXGAQ7f8LgYhLrhAEsGLhz0sBC1jukFS8wHoPOAXNH4IGaj/PBhbfeUP6EPLjpSHHQmfIFSpxvA0kLekQ+YAa2gaDlUMdIqR4AQqefPWJwOHXXQ+72MdO9rKb/exoT7va1872trv97XCPu9znTve62/3ueM+73vfO9777/e+AD7zgbYcBPsz9F4WARNDbfgNBNMwXbudB9U4AjaGtHRsaaBsDxpEHtq+gDLDWhg7YzoFUaNw9jEBG29thi4aFQBIdcDss3DMBa7QA7jJoggZMMXfLDx5wYug43HnwgBxUNu4BaNguDP/2LpSBqf5IQSOQvvYs6KJhTqAu3DOBh4aBgfdvH4L/GhqmhFgYm+1UOELDGKEJuGMAHY5mwL/hbgktu4Pu90jC7/fP//77//8AGIACOIAEWIAGeIAImIAKuIAM2IAO+IAQGIESOIEUWIEWeIEYmIEauIEc2IEe+IEgGIIiOIIkWIImeIIomIIquIIs2IIu+IIwGIMyOIM0WIM2eIM4mIM6uIM82IM++INAGIRCOIREWIRGeIRImIRKuIRM2IRO+IRQGIVSOIVUWIVWeIVYmIVauIVc2IVe+IVgGIZiOIZkWIZmeIZT0Q7joAHUx3YS4B5z94b+MHfcAIdypwH+oARzlw7+kABzZwJ9OHdaBgNzFwSvUYiHKHfekIhxtxtzPgcA/sAbchcckhh3AHYMc0cLP5AMaNiJnviJoBiKojiKpFiKpniKqJiKqriKrNiKrviKsBiLsjiLtFiLMBgQACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3lyzRa8sc1Y44Ey6tGmKivypVg3utOvXsAdCWa2aVezbuDXDoe2vTO7fwCNT4m0suPHjiE/x5oK8ufO/P3j7ek69ul1xvJFZ38697SXeVLqL/x9PVgLvLOTTq9/KjTe29fDjS1XGO4z8+/iTmqDNIL///0FtQtsOABZoIE7V0IbLgQw2+FIAkahwgj+QOGjhhSp10AKGHHbo4YcghijiiCSWaOKJKKao4oostujiizDGKOOMNNZo44045qjjjjz26OOPQAYp5JBEFmnkkUgmqeSSTDbp5JNQRinllFRWaeWVWGap5ZZcdunll2CGKeaYZJZp5plopqnmmmy26eabcMYp55x01mnnnXjmqeeefPbp55+ABirooIQWauihiCaq6KKMNuroo5BGKumklFZq6aWYZqrpppx26umnoIYq6qiklmrqqaimquqqrLbq6quwxv8q66y01mrrrbjmquuuvPbq66/ABivssMQWa+yxyCar7LLMNuvss9BGK+201FZr7bXYZqvtttx26+234IYr7rjklmvuueimq+667Lbr7rvwxivvvPTWa++9+Oar77789uvvvwBv1kItpgRsonkJiGDwiL0wsFoBBS/sIQVM8JawxB1aw9tqdfCB8YWzJLCxao6c8rGFoRAysmpjeHxyg/cUsXLJLzfoQzAOj/xFzQ32csTGDBjCc4MYiBMBbUYMbaELQahmxoZKW5jJKtREjaEPVmet9dZcd+3112CHLfbYZJdt9tlop52X0GqT9wYk/ojSdneGJKgaGXNbp4MQG9P/kLdzdwSw8iB/H8eHGg+srJoBhf92gQQvKO6PJyU0nls8KEhOueW/1ZDzxptzDhwYoFcuenC3JK5a6Kcbp8Hkprd+nByxy2777bjnrvvuvPfu++/ABy/88MQXb/zxyCev/PLMN+/889BHL/301Fdv/fXYGwlEAtx37/334HcfS/ZzFSD5+asRQL5c5qN/vvrrw9W++4rDH79b89M/sv33s5W//rzhX//U8j8Apm+AbSmgAf0hQASeRYEGbKADywJBAEpwgmOpoP4uiMGwaJB+HOzgVz7ovhCKsCskRJ8JT7iVFL6PhRRc4MZWCEOsuFByNKyhVW5YPx2KhYcry6EP/6cCxP0NESxFnOERRyjDAC7RK0l04hO5EkXaCHGKTaniAbGoFS2q5opcVIoXGRjGrIwRjGU8yhnTeJU1srEqbnwjEZtoRTlSJY52hAoe8+iUPfKRKX78oxjpuEVBZpGQXzRkHxFJRkUCkpFodKROAilJolCykkK5JCaBoslN+qSTnuQJKEM5SUiSsiijPOVNUqnKmrCylTN5JSxjIstZvqSWtmwJLnO5kl3yMiW+/OVJginMkhCzmCM5JjJDosxlfqSZzuwINKO5kWlSMyPWvOZFsqnNinCzmxP5JjgjIs5xPqSc5mwIOtO5kHWyMyHufOdB4inPgtCzngO5Jz7/of9PfPaznv+UZ0DfOVB2FjSdBzVnQse5UHA2tJsP1WZErzlRalY0mhd1ZkaXuVFkdrSYHxVmSH85Ul6WNJcntWVKZ7lSWLa0lS9VZUxPOVNS1jSUN/VkTje5U0z2tJI/LVsHEEDUohr1qEhNqlKXytSmOvWpCKiDKZd4iANY9apYzapWt8rVrnr1q2AN6wEyMNUjKoCRaE2rWjf4xLOu9a1wfWsk4+fWuNr1rjKc6/rqite++rWHS+TrXwc7WL2ST7CETexdQdFWxToWrxEARD7M+tjKxnUBX/jAEBFr2c4isg768CFnPUtaGToBPTUcbWlXqz8Y1E6EqmWtbM+XgU//jOaEsZ2tbkeG2QbgdrfA1Z8QLgDb4BoXfUdA7QRze1zjwkAMGGRuc4MbAeY4ULrTBS4DOOHbAWI3u8AVwhC8C97ybswLNejfd82r2xBA4X7rZe9sI1AFCOxVvvj1xwP2cFvsxTe/sl0CcbEnAwMY+MAITrCCF8zgBjv4wRCOcIOJcDS/esEF+9SIJnrwVxWcIcMZoccG/joBSYAYIyRYw18X8IjunpgiGCiD6vDKgDTE4MUWmUWF+woJDOMYNRz2Kwxu8GOKuGDEfk1BJoo8ER+44nN3XYANXMxkhzSgDAv46xpIUOWI9GMCf92AHLoMERZE4a+ImAKZHxKHGfw1/wVuWLNDVmCFFduAAnJmSAPokOW+MsAEK8gzQxYxIb9ugB6CXggUQvDXEIQn0QlBgpv9ioI4QxohMigAlO2aASng+dIG4UApBguEEYD6IFVIwV8nYYdTGwQKIPirFh7t6oHcYdJ9nQAlak2QGCzhrxnABAZ4LRAKGGHTdi01sf/hACIUuq9+aPWySxBrvxYBC8v+BxIq5lclKGzZSRjDXx9wiWET29jIjish7ENsBwDi2XgVhCWyXYImyBrby2YDt/sKgkRk+wICwusCrJttDhihz3HdQ7YJ4oBX7HitQtDswgnyBhW8lRFcnnhBapADtYIACRo/SBvEzcgIQDfkB//xwBYQLsMHEAHlCYHAKB5uQAnYF+YJ2ccOZGiFT+M8IfzoOACPcOOfL+QCg9BfCHxs9IUggBUsX1kKWND0h6Qicop7gMmq/hA02HtlNrg51x3SB6HzJg1UHntDrlAJ3mxABmqXyAfUkDMYMD3uESHFC1CgZrxTBA7f9rvgB0/4whv+8IhPvOIXz/jGO/7xkI+85CdP+cpb/vKYz7zmNy/oEox58iXwhD80IPnQr+YBt3i86XkDhsavHmjpTfzrR4aCeCB+9ht7gQQGbHgDSO4BanBZ4pM+sgDcofE02JgQdAB5MqymGmyDvCgo9IbKR5/z2M++9rfP/e57//vgD7//+HmFtcpTYxVLnnwLzKCaINzd8UagTQTEYe7GUwHZR+iF47+wMgYYofyLdwqOsDJFcA+NxwckNzKEEAqNJ4ArcwCzcIBSNTLW8HgiIDK0wQQ+13imMD8MoH+Sd4H+IAGVZwq1ADXjl4IquIIs2IIu+IIwGIMyOIM0WIM2eIM4mIM6uIM82IM++INAGIRCOIREWIRGeIRImIRKuIRM2IRO+IRQGIVSOIVUWIVWeIVYmIVauIVc2IVe+IVgGIZiOIZkWIZmeIZomIZquIZs2IZu+IZwGIdyOId0WId2eId4mId6uId82Id++IeAGIiCOIiEWIiGeIiImIiKuIiM2IjIlNEC/TV5cHMCKhAJASB5uEAb1SB5O7camyB5LGcCkRcGvKEMkYcNvMENkZcFvEGCkEcFvHEJkYcMUvR4vsAbPxB5XMAbW/d4xsAbuwZ5ZcAbcBB5rMAbHwZ54MAbiiB5DrACc5AFvYCCjliN1niN2JiN2riN3NiN3viN4BiO4jiO5FiO5niO6JiO6riO7NiO7jgVAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz589YSbiqpe4cLWpZhoBezbr1vzj+YsuO/SKQJde4c1fGMru3vy66gwtnfMi37FXDkysnLMJ4bEbLo0vfm8q5PzLTs2uXi8k6t+3gw6f/3WIdn/jz6MECsS4pvfv3V7VZfwO/vn2nG6zzuM+/f9Ei1sXg34AE8jSBcycUqOCCM3FgHQAMRiihSolYt82EGGYYUgt6ZHPJPEAUg0sE/sij4YkohkSCaim26OKLMMYo44w01mjjjTjmqOOOPPbo449ABinkkEQWaeSRSCap5JJMNunkk1BGKeWUVFZp5ZVYZqnlllx26eWXYIYp5phklmnmmWimqeaabLbp5ptwxinnnHTWaeedeOap55589unnn4AGKuighBZq6KGIJqrooow26uijkEYq6aSUVmrppZhmqummnHbq6aeghirqqKSWauqpqKaq6qqsturqq7DG/yrrrLTWauutuOaq66689urrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfghivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvz229kZzQDn75AXIOKPE30MLGQBskXAhcI/vuLbGjJAvGMWJPpmBhYW49hAfs49MA0EHdcohXWyaZNIyTJSsQDKsoFAH8svagBzb49gQHOLEPxw4M3+kEPBzi7G4cnNEyBB9IsOTPMCyvYsHeMfIE8stYwNQPNAb1EIeLWMODgx28xfy/iBBAz4M0/ZNt5Qh8Bsxy333HTXbffdeOet99589//t99+ABy744IQXbvjhiCeu+OKMN+7445BHLvnklFdu+eWY9xdK5tndocEDnXC+HA9gpO0PIaIP14kJvTGgdOq4YUGGcxrA3posQaBsATa2f/bG0Tc/0ntnJwPtzwE+DL8ZD8bHlorym1nRvBYdQJ8ZDcbP4Eb11mM2AMwFiNH9ZsM4N8E8d4zfGSO99fCO1+pzNotsfvjSQPyfURDFLorgzxrc/gugAAdIwAIa8IAITKACF8jABjrwgRCMoAQnOCMgJOCCGMygBjeIwVhQ0C4Ma55zCPDBuoRQhL4hYQnnckIUzkaFK4xLC10YGxjG8C0zpKENb9iWHLpwhzxciw//UQjEIKZliCIsohHPgsTmKXGJZWmi8Z4IxbFIEWhUrGJYrnizLGrxK1yEmRe/2JUwomyMZNyKGa2DxjRmZY0jdKNZ4GicNsrRKnRM4R3Jksfe2HGPU+njCwEpFkHK5o+EhIoha5hIsCzSH4hsZFMeGUlJLoWSliwjDf2YSa5gspNa+SQosSLKUeJxk4M05VVKqcpAovKQrTzlKyEZy6qwspZPuSUuJzlLWu4yKrr8pVKCKUykELOYRjkmMomizGUKpZnOBAo0o+mTaVKTJ9a8pk6yqU2ccLObNvkmOGkiznHKpJzmhAk60+mSdbKTJe58p0riKU+U0LOeJrknPkmi/899iqSf/gQJQAPqkYESlCMGPahGEqpQjDC0oRZ5KEQpItGJSqSiFoUIRjPqkI1ylCEe/ahCQipShJC0pAY5KUoJotKVCqSlLoXpSmWKUpqW1KYixelHdcpRnmbUpxYF6kSFClGiNtSoCkXqQZVKUKYG1Kn+hOo+pYpPqtbTqvLE6ju1yk6uptOr5gTrOMUKTrJ206zaROs11UpNtkbTrc6E6zLliky6Hq4DCMirXvfK17769a+ADaxgB0tYBNShl5W84SEOwNjGOvaxkI2sZCdL2cpa9rIHyABiLamAXnr2s6B1ImdDS9rSljaxMeysaVfL2k2idoWqba1sZ3vG0f/S9ra4ZaQkY5vb3rIWFLb1rXBLGwFA5KORvB2ucj27gC98IJHJXa50X1kHfRAyutPNrgudkAVAYle74DUeDEqwx++G97woy8AnHCBH86L3vb5p7v3S6F742lc2QrgAfe/LX5QdobtfrG9/7QsD8WlRwAOGr8MOnOAGt44T8zUigh38XiGwKIgTpjB6vVADCWv4w/4IARQwDOIPR6AKJEttiT/8gD2wF7YrBvES9FtCGRjgxjjOsY53zOMe+/jHQA6ykH1MhIzJ1gsucKlHNNED2qrgDEruCD2q1toJtCfKGyHBGmi7gEdEGMsXwUAZtiZbBqQBfmC+yCyM3FpIJDn/zRhRRJNnC4MbwBkjLqAya1OQiTtfxAeuMF1rF2CDL/s5Ig0ow8tmuwYSHLoi/fiZbDcgh0dThAVRoC0ipmDpicRhBrRNgRs6LZEVSG+2hB4aqR/SADosurUMMMEKVg2RRZyAthugB60fAoUQ0DYEVNi1Q5AA6tmiYNTCZogMCiBo1mZACqpOdkI4UIrbAmEE0l5IFVJA20nYIdsKgQIIaKuFYIMbIXcotmwnQIlzIyQGS6BtBjChM3cXhAJGaDZrr23vgjiACLeerR++3W+ClGDcsy0Cxwo+ECQwgbZKEAHDB5KEMdD2AZeoN8Pxre/VEiIME/+HAwARcNkK4jYh/y9BE8i98Imz4eGzBcHKQn6BTch2AQ8LuUA4YIRXl3YPOieIA17BZtAK4blBJ8gbVEBaRjg66QWpQQ5AC4LXQb0gbbB4LyNg4KsbxANb8LkLH0AErycEAqMougglkGKzI2QfO6ChFaLtdoTwY+oiPAKa646QCwyieSF4M98XggBWiN04KWDB4B+SiqdZ5wGnWDxE0LBy59ig7ZJvSB/w3ps0GDrzDLlCJXqzgYqBPiIfUIPpYCD400eEFC9AAaddTxE4SJz2uM+97nfP+977/vfAD77wh0/84gcUgMb/hyJ2EQW6D78BvvCDbGZR/Bi8Y86ygY7w7zAPSfdmGMAXg/8UB9D7DrhB3TCjAe87oIXmWaH31WnefnbvgwM0Twq9fwTQPEG23WPDAigTBLIQfDZjHGTQcsCHBPpmAqFTfIQQGwwABvNnfJ3wABqQPsk3EJuTgRzYgR74gSAYgiI4giRYgiZ4giiYgiq4gizYgi74gjAYgzI4gzRYgzaoJl1QB3bWgfPgDwwgAUhnfG8wG06AA8YXA5k2Gw8ADZ/ne1tmHBvwB8JnDyjzAtPwYr2HBN7nHJ4QB71HAeRgPBPwA5hHexigf81TO7z3BggHMwtgbryXCPIBM/j3exAwDWQGhU24e1hgBsYRAQAmfDLwhLPxCsnHBUZWABzYB2KDCDT/loFd0AxQdoOUWImWeImYmImauImc2Ime+ImgGIqiOIqkWIqmeIqomIqquIqs2Iqu+IqwGIuyOIu0WIu2eIu4mIu6uIu82Iu++IvAGIzCOIzEWIzGeIzImIzKuIzM2IzO+IzQGI3SOI3UWI3WeI3YmI3auI3c2I3e+I3gGI7iOI7kWI7meI7omI7quI7s2I4LMgRP14Hy4A8RgAvFAATzcAnZoActMHzbYB0zF3wAYB0cMHwl1xsTMHwxYB1FMHzM4xwbMHxD6BzaMHySYB1AMHz4YB1bMHzcYB2YMHyz4xzPI3zs4xy3F3yrYB2HIHxdgDII6Ht8EAiO5xteSHxDOpAF1EAL56AOteAK8eiOQjmURFmURnmUSJmUSrmUTNmUTvmUUBmVUjmVVFmVVnmVWJmVWrmVXHkVAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4se7bZEGS7IsnQhzbr1ZlD+YseGUUyZAD06WrjezXsxGNnAg5shU4pE7+PI/ToLzlw2Aw/Jo0uva6Z5c1zTs2tn6+CBdeYmtov/Hz/W1Hfm0MirX6+11/ngvtjLnx812nvgf+jr34801f3YD3DA34AE/rTHf/44UeCCDN5ECIK7NCjhhC6tg2A5FGaoYUkhIKjHhiCGuBEFCPqThYgopigRB/ZIAYYgIHyXAQYq1mjjQx5kgUYqalTTRGyM3CjkkA7FQMUURCap5JJMNunkk1BGKeWUVFZp5ZVYZqnlllx26eWXYIYp5phklmnmmWimqeaabLbp5ptwxinnnHTWaeedeOap55589unnn4AGKuighBZq6KGIJqrooow26uijkEYq6aSUVmrppZhmqummnHbq6aeghirqqKSWauqpqKaq6qqsturqq7DG/yrrrLTWauutuOaq66689urrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfghivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvxCioMD/cpJwwubyBDwm6YgEhsAdxzMJgcWyraKGA6rqQFzC3xS8ZmffLcFjRuLSYUF5w0SQ8hgXqHwe60ggXKXHQSB4AFvvLylDSX6swApNmN5SM6xRaJbz1TysQPQKfBCNJUd5AK0P78sXeUsJ+SMidRWZsEIgmlAgLWVXTRzHwArfI0lLSh8lwIbZmfpwgbW0dK2lhx8wZw5c3OZzAGyTf8iYN5b2iGIP6uoAniXDcASzuGMN+7445BHLvnklFdu+eWYZ6755px37vnnoIcu+uikl2766ainrvrqrLfu+uuwxy777LTXbvvtuOeu++689+7778AHL/zwxBdv/PHIJ6/88sw37/zz0HOLzSvRs/ZMAN51Uj1oDfgyuGzjbN/ZBeL0wNwLSYifGQ9qRPDdNOpXBsE9g9xnC8DxR+YAEyWikb9k8ijREv4XGRqUiAGWICBkvFEiDCnQMewokRbw98DFfOBoCEJGBRuDMwQtY4OMUUWJLDAEEC6mfggChAkV44v/5IIIBlshYjiQgO8UQR1xkCFjjMCcCYDjDF7TIWP/UAGcAczCB0JcYCQqYLgkRuYKKANCAqZIxSpa8YpUjIUT91KApzGHAFvUSxe9CBwwhhEvYyRjbMx4RrukUY1sbCNd3kjGOMpRLnT0oh3vCJc8Pm2PfHSLH4EGyECyZZA5K6Qh1YLIEilykWhpJIIeCUmzSPI/lKwkWS55n0xqUiycfI8nPwmWUJ5nlKT0iim/g8pUcmWV1mmlK7UCy+bIcpZYqeUXcRlJNcrmlrysii6DA8xgTmWYZTRmWZD5S2Vu0pdrdOZYmBlNaYaFmv4opjWbgk1tbnMp3fzmV8Ipzq6Qs5xbOSc6s6LOdV6lne4UJjSzGU92ztOb9RQKPPMZ/5V98vMp/vwnN+8pUKoEtKBKOShCkaLQhRqloQ4lCkQjqk+CUnSg0MTnRW0y0Y36pKMe5QlIQ6qTkZIUJyY9KUctqtKipLSlM3kpTGMi05m+pKY2bQlOc7qSnfI0JT796UmCKtSSELWoIzkqUkOi1KV+pKlO7QhUo7qRqVI1I1a96kWyqtWKcLWrE/kqWCMi1rE+pKxmbQha07qQtbI1IW5960HiKteC0LWuA7krXv+hV7z2ta5/lWtg3zpYthY2rYc1a2LHuliwNrarj9VqZK86WapWNqqXdWpml7pZpHa2qJ8Vamh/Olqeljanp7Vpame6Wpi2tqWvVWlsTzpbkv/WNqS3xV0HEMDb3vr2t8ANrnCHS9ziGve4CKgDS7d5iAM497nQja50p0vd6lr3utjN7gEysFxrKmCe4A2veB1Zzu+O97zoPa9G72je9Lr3vXosL3znS99Oyre++M1vNb/ZXv36972guO9/B4zeCAAiH/wlsILPu4AvfGCb/V2whKFZB314d8IYnqcTTuTMCGf4wzmDQQk6DOISPy0Dn6AgLj1s4hZ/p8ENCCaLXUxj5gjhAryccY13HJsjcNiVOubxjmFAMSAL+cjMiQAXjIzkJseGAZyI8SeD7GQaC6GEmqRylV3shRpkectbDgEUKqllMLc4AlUIYiDLbGYTP2D/DyqWI5vbbOIl4JiPMjCAnvfM5z77+c+ADrSgB03oQgeaCO6jrxdcsFePaMJ89FXBGRrdEXrAjb4TkASlOUKCNdR3AY+Q8qYxgoEyeGe+DEjDyUadkVkker6QYDSrMaIISM8XBjeYNUbeVt8UZELXF/GBKxhA3wXYQNTAlkgDyrCA+q7BOMmmSD8mUN8NyCHaFGFBFOqLCCRhWyJxmEGv3fBtiazACp+2AQXKDZEG0KHZqDZB2dj9kEVUjb4boAe9HwKFDtE3BFTYt0OQIG76ooDcAmeIDApA7PlmQArrTrhCOFAK/AJhBBJfSBVSUN9J2CHjCoFCjOirhYCDHCF3/yj4fCdAiZMjJAZLqG8GMAEylxOEAkZo+HwvbvOCOIAI956vHz7ec4KUYOTzLQIWik4QJPCPvkoQAdMHkoQx1PcBl6h50XGuc/gSIgxT/4cDABF0+AoigWEvwY9IvvSws+Hp8wVBIsL+jwtsYr4LWDLd/8EBI8A7vXvY+0Ac8IpXj1cIDxb8QN6ggvMyAtqKH0gNciBeELgs8gVpg9XnGYEiY74gHtjC3734ACJ8HiEQGIXhgSYBNZ/eIPvAINCsEPHXI4QflM/ZEVZt+4RcAIX/CYGse68QBLBi9NZJAQuI75BUvOA8DzgF8x+ChrU3xwaun/5C+pD74KQB2dpnyP8VKhGcDcQw/A/5gBoaDoPhox8ipHgBCrz9fonAQeq2gmL9I6KKCkTCG/vnED6QCQMAHKgQgAkBAWcADtQWHEaAgAYRB+pQBN+RAH+DgDJABE5zH/EBgYBQIoMAgf8wBCSDIE2EgMtQIjYggshQIjuQeAHoAFpQIuwgguVQIgAIgZbQde9BAyIYcwgiDyKIBiXCBHH2fg5gC/cxCPeQffs3Dd8RAWrAAyJIEEnwfMHRA+JwZ1VIEOMAHILgC+DXhQLRCf7wAAHwDGSoEK+ADWv4hnAYh3I4h3RYh3Z4h3iYh3q4h3zYh374h4AYiII4iIRYiIZ4iIiYiIq4iIzYiI7/+IiQGImSOImUWImWeImYmImauImcWIhwAAtjGIeqsAr+IAhEN4ccMAmycQDJQIfmwBxfcIFrSAvWsQHuV4VswHHWgQJy04UrAAD30QyrAYEQkAYIwgg/tn+YkDMnMAsB+AtPkwsdUH+8oIsuyAf11wKR8DSHEICkgHzvsYII+AZ88x9BMI0QiAStcB+IoH8iGAPA1xwWYHJdiAFb8B0aA4efAI4aMIdiQIqysQ6yCId3AIz+gAimYIcysAkv4IN36AA40IkSOZEUWZEWeZEYmZEauZEc2ZEe+ZEgGZIiOZIkWZImeZIomZIquZIs2ZIu+ZIwGZMyOZM0WZM2eZM4+pmTOrmTPNmTPvmTQBmUQjmURFmURnmUSJmUSrmUTNmUTvmUUBmVUjmVVFmVVnmVWJmVWrmVXKkhU0AFvFeHW+MPTVANapAKaMAG0PGGGMBd1gECggAGUmAPA1l/WVAitReAeoAgIVCFN/gf61CFu4AghFCFToAggQeBHHBq95EKIvgHJRINIthCCNILIggNJZKQEGgCCPIAR/h+uIAgZiCCHsCD3+EMIkgCpUAG1fEeYLCGLaADeiAAylAMMBAcZVCHXZAFyMAFZTBiXRmcwjmcxFmcxnmcyJmcyrmczNmczvmc0Bmd0jmd1Fmd1nmd2Jmd2rmd3PkSAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6teDRbNIxGoPrCeTZvwFn+4FwAAYqxEm9rAg9sdgLu48R4FCFAjIby5c7R4jEuXDkAeEV4QnmvfnvXC9O/TDwj/mfabu/nzTG+AXy89D/r38IlyYU8/Uvz7+HnSoc9eQ/7/AM40CH/ruRHggQiqFAKB4D2R4IMQgkQCg9/1EOGFGGKEBYXTgZHhhyA+dAqH0i0S4okoGiQBicaxkeKLKI7BIm4qwGgjiKIsYkQQO3C4y41AhpjIMATsEgh9PwSp5IkklCDAEipMp8OSVKKoCiXmMOLPAQ5U6SWKJFzz5ZhklmnmmWimqeaabLbp5ptwxinnnHTWaeedeOap55589unnn4AGKuighBZq6KGIJqrooow26uijkEYq6aSUVmrppZhmqummnHbq6aeghirqqKSWauqpqKaq6qqsturqq7DG/yrrrLTWauutuOaq66689urrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfghivuuOSWa+656Kar7rrstuvuu/DGK6+elljT5byeXlGIP+Dci6+mJMxQHCEN/JtpC7lIR4wHBlvaQCXfDcJww5JCEMB6xYxAcaT7sZfLBRs7Og2BM4AcsqLsUJiDeycfCoUFHBbiYMuE8nAAi7YUTHOgiWgxIy07B9oFJDMSETSgELgy4ztHAyrFjDY0/Sc8M/ondZ9ZwEziEh1c3ScET3N4zMRe99nNCQwCMETZgF7TA38qyMF2oKEkvN4ENMwtKAfugP+3gAJ6ExrLAtOlEnih39xcXC2HGxoHALgFoXPjhMqwSSsxUH6oA4lo7vnnoIcu+uikl2766ainrvrqrLfu+uuwxy777LTXbvvtuOeu++689+7778AHL/zwxBdv/PHIJ6/88sw37/zz0Ecv/fTUV2/99dhnr/323Hfv/ffghy/++OSXb/756Kev/vrst+/++/DHL//89Ndv//3456///vz37///AAygAAdIwAJ+CQP3YI4BL5MFTsDAH0Zb4GRkkA0/GCcXEoSMA0oQgBd85w4ZZIwLpPC29UAjhImZRTEIZAsUImYDFDKECw0zCgoBg21ASIAOd8jDHvpwh7Eo0xX/HsAgEPhLagWYkXQIYKYlUOgMZUuiEovDxDJFg0JqiOIUqWimD6CAQTvAgNekuMUqlgkcFKLGGLeIGzOS6RAU2sIa2ejGMTWgRwQy4tXIOMU6jkkNFFLEHtnoDz9+qQQUksAg6YgmDKyCQbhYZBnTpAwKuahpfFSiIb8ERwYxDZOE3KSXvMigYiAxlGoiBIESEIDsHC2TMxKll0TAHiY84gZiPCUj0zQEwhnnBELIxhzmBksWydJLzsCNGeaBDLIRE5Vq0kMjeOC5YpLomDOMizU5hM1svmWbFOqmN9sCTgaJc5xrKSeBzonOtKiTP+xs51neSZ94yrMs9GSPPe85/5Z8rmef/AyLP8ED0IB+ZaDfKahBu4LQ6Sh0oVtp6BIhCheJGuehFMWKRbmYUXJCs6Pp/ChI3SnSkc6zpCbFJ0pT2s+VslSgLn3pQWMqU4bStKYRvSlOs7LRNu60pbv8KVh6WkihwjSoRrUpUpOa06Uylac6fWpUiIpRqRKFqlZt6iSzClWncnUqWP3qVcIq1qqQtaxgjSpakXLWtUKlrW51ClzjypS50lUpdr0rW9Wq16Dkta9F+StghyLYwfqVr4blSWET65PFMlaxiH0sThwr2ZxQtrI3uSxma6LZzc6ks56NCWhD+5LRkrYlpj3tSlKr2pSwtrUneS1sSyLb2f+OpLa2DQluc/uR3fK2I7797UaCK9yMELe4Fzkuciui3OVOpLnOjQh0o/uQ6VK3Ida97kKyq92EcLe7B/kueAsi3vEOpLzm/Qd6zbve8bYXvO/tbny1O9/r1pe6941ufp27X/x1AAEADrCAB0zgAhv4wAhOsIIXjIA6RDajhziAhCdM4Qpb+MIYzrCGN8zhDh8gAw+mqAIISeISmzicTx3xiVfM4hVXVZ4qbrGMZxzLFNP4xjiGp41zzOMe+5SpMfaxkGcMih0P+cgsjgAg8pHUICP5ySRewBdkI1QnQ/nKW6yDPqqM5S4T0glZ+KmVvUxmCsGgBDsdc5nXTJ8MfOL/iClVM5vn/B0pTy7OdM4zgYRgMjzr+c/rOUKY/QzoQksHBmIgtKEX7Y8IcMGkcmZ0nhnAiTtDNNKSzrMQ1pZRTGeazl6oQac//ekQQEHEpP50BKrgyoB6OtVzfsAe4NzOV8N6zkvoszxlYIBe+/rXwA62sIdN7GIb+9jIJjYRIpBjL7ggvRzRRAlvrAIoQlsj9IAhjicgiWtrhARryPECHmFpb08EA2Ug4o0ZkIbMmfsis2A2jiHx7HdbRBHTpjEMbmBvi7hA2zdOQSb6XREfuIIBOF6ADcpN8IY0oAy+vPEaFNjwiPRjAjnegNwqHhEWRCHHiJgCxyMSB4HhOAUG/xr5Q1ZgBXHbgAIqd0gD6BDxGTPABCuIuUMWgTYcb4AeOm8IFBaE4xBQIegMQYLJb4yClCM9ITIoAMJvnAEpwPzpCOFAKXgMBI1hHSFVSEGOJ2GHryMECiDIsRaObnaD3GHpNJ4AJdpukBg4EccZwEQu6S4QChhh6jfuOt8H4gAi9PzGfij74AVSgrTjuAhYWLxAkMCEHCtBBJL/RxJkhOMHXGLvfPc74GlMiDBI3gGAODyNBWGJzJegCWqPvOTZUHkcg6Bzkr/AJm68gEfHigeN0MOuOGCEmq94D6/yADLmYQbcOINXDniFvFcsBCqrag7ZEILq/bEATu/qDVE6Mf8jKG4qDNzgEbUHD+Z7VYMcmBgESECVxRJAIEL8qg2cZ2MEEp2qFRIIBdbHKx6wBcZHIg8QQanyDhRyCMACAaMwfSwiAa2GKmxAIcogLPuARyRiBVe3KrjAIKsAer7CD+7HIUfgbqyyIgyCZsJyAQPCICFQb62iCFhELAjACgU4HSnAArDiAI7HHzvAcL6SCh60Hg9wCrJyGwzCgMWCBrAHHjYwga5CDRQCDsfSByUoHWkghKuCARpIHwB4LFcAMcaxATJQK4DEINGALB+gBlMHAzI4K2dAIUugLKTwAiggcrbigwzyAFegLHCwfrdiBBQyCpl3EYZAIRtwiBdhCwT/UgyzwIgWAQ3s0QNSEIeSOBF38B0vEAAlQGuZOBF2gxt+kA1nGIoaQQT+AAOcMGiouBEkcA8i+Iq0WIu2eIu4mIu6uIu82Iu++IvAGIzCOIzEWIzGeIzImIzKuIzM2IzO+IzQGI3SOI3UWI3WeI3YmI3auI3c2I3e+I3gGI7iOI7kWI7meI7omI7quI7s2I7u+I7wGI/yOI/0WI/2eI/4mI/NkgigqIwx0AqbcIrN2ABBgBsAEAfOWAvGcQDfwIypMB0LEETJqAA56A/uwAHHSAMYtx65EArFKAfhV4liIoxDADkEcgLdEIwecAwkIgVSmIsdcHccYgGuuIsaMCPw/+CLNjAjUuCLCsgirvCSt6iKLAIJXdCLtDAjWoB7u9gAjkgiB0BNvvgE+0IhFnBqwJgHWcgf7DCMFwB36zENxXgBowgedHCMI+B/39FKyOgBLygdlcCFKkkM0pELLcCMDaBKuDED5KeMDoBGhfCHz+gAl9B6+niYiJmYirmYjNmYjvmYkBmZkjmZlFmZlnmZmJmZmrmZnNmZnvmZoBmaojmapFmapnmaqJmaqrmarNmarvmasBmbsjmbtFmbtnmbuJmburmbvNmbvvmbwPku19CXzOgAN8MI5kAJqtCMOjAdKrAEAlACxCmMP0AfgbALBDAMTAmMu8AhOxAERrAIoqbgiyFJImPQixWoRIrEi4swRUjIi2AwRbK3i/lGItNZi08wRSHQi24wRYPQizepRGfJi5EwRb6ni3mwRfy2i20wDUKgOCSia7sIAbxABPJgkvzRBMVIAtRAAAVQn8YxAMrYBiVgDEAAABEnR874AaggAo+ABsEZozI6ozRaozZ6oziaozq6ozzaoz76o0AapEI6pERapEZ6pEiapEq6pEzapE56HgEBACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3Cbewhuc27d9l2/vypMJEKRwffyJNfDRa8ub8Jm+p1gqC8unWlfpxr97eDUJVb18OL/+/p4cH28/4CAUP2Ybz79zAVoZ/v78SSbHPg699Psh79//4cYQ0q/BVoIEauAKhgJLAYQt2BEEaoEAgKVuhPERRIqOGGT1hYIRkbhhghLR4qmImIKBb4RYn/ZUBCijDCBwmL9IEY443htbAAjfOdiOOPyrHAI3ouAmmkbxe40UwOQzpn45FQ9nZFMntAwgCPPkapZW8x/GJOIR4WueWYvs2RSQAJAPgkmWzy1oEmoMzQY5t0IscHEWRk4JyYdfbJ2wi0EJKCP2v6aahtH4SjyaGMNuroo5BGKumklFZq6aWYZqrpppx26umnoIYq6qiklmrqqaimquqqrLbq6quwxv8q66y01mrrrbjmquuuvPbq66/ABivssMQWa+yxyCar7LLMNuvss9BGK+201FZr7bXYZqvtttx26+234IYr7rjklmvuueimq+667E4WQ7vhnoPHHfB6C0twkVxRr7YYjOPcJC3se60HQmxHxnECTzuEJ+g1k7C0F8g5XwUPP5sHmP9lWXGyT0Si4ANvbJxsDUVYmIIoIhvLgwolwiBHysOuTCMAQ8AMrMw0+nGBzb7izOImYfDcq88lgtGA0LwS7eEeSPP6BMs0itP0rnyUTGMVU+t6BcYlLiBC1rkOIXGJFugBNq4j5ELjC2icjesNE7A4AQtu56rJAR7OXbeuOkD/DaDee+v6RCB/0x34rnkcQR/gh+8ag9rnWXBG4756UMd2C8BB+a8NBKCdL5sD68A8zWEderDW+NPI6cNSwfrrsMcu++y012777bjnrvvuvPfu++/ABy/88MQXb/zxyCev/PLMN+/889BHL/301Fdv/fXYZ6/99tx37/334Icv/vjkl2/++einr/767Lfv/vvwxy///PTXb//9+Oev//789+///wAMoAAHSMACGvCACEygAhfIwAY68IEQjKAEJ0jBClrwghjMoAY3yMEOevCDIAyhCEdIwhKa8IQoTKEKV8jCFrrwhTCMoQxnSMMa2vCGMAJCAnbIwx768Ic8jAUO/wFTgCYFhwBD/EsRjYjEJPZliU1qohP3AsUhSXGKeakij66IxbtokUZc7GJdvsiiMIpxLmQskRkPBQEaSGEUwkujh9ZYpwZQYx5RCA4A4mhEf9CRTGGIRzrwph0XBE+OFvpjlNogiSW8YD7nOGQfFWmkbDjjSv8JgiSZWCcTVOgBMgAeIitESSBlwkLdEOUk63QFTAJIGarkZJ0EUSEYxDKKfRKAhfrwu1EqqJRA0oGFhOg7XwIImEDqQYU20ctV9kkDFToBB4rpzDp1w0JQoKYs63QBC0lBm7j004wU5AlwWtFQZfhkwHhnzP8gE0iysJAYetdO+rzzRxyIQIUuQf/PavZJFxWqRj+32adLVCgC09xdPedzzx+JwUKKYKc/69QC8yioHhIlaJ8YpqBdZDSchpJChaLw0XMeCg4WwoZCJ8pKC8VjpRrtE+EU9AiYgtRQnvvPAyBBzNwtFD0NBdIPzrMARrgjGzRoT0m32KheNCcH6SCFItZ5S5MeigKNgMIIjvfT8wT1jGXp6na+CtaxiFU7ZC1rWM7qnLSq9StsbY5b39qVuB6RrmhkKV7ZYlc/7jUufZ3rX7ES2MG+pbCGbQtiE7uWxTI2LY597FkiK9mw6rWyYqEsZjN72c3CtbOerStoQ7sVzZJWtDE9LWpvqlqvmLa1WXktbK8i29n/VqW2tp0KbnMbld3y9im+/W1TgivcpRC3uEk5LnKPotzlFqW5zh0KdKMblOlS9yfWvW5PsqvdnXC3uzn5LnhvIt7x1qS85p0JetMbk/Wy9yXufW9L4ivfldC3vim5L35Pot/9lqS//h0JgAMckgET+CMGPnBHEqzgjTC4wRl5MIQvIuEJV6TCFp4IhjMckQ1z+CEe/nBDQizihZC4xAk5MYoPouIVF6TFLh4IjGP8jxnH2MYl7AACdszjHvv4x0AOspCHTOQiGxkBl0staQ9xgCY7+clQjrKUp0zlKlv5ylg+gJ6UHFoF9PHLYA5zInPrZTGb+cxmFmxZy4zmNrsZ/4xkfrOc53zMONP5zni+q23ZnOc+uxkUdvazoM8cAUDkY7Z8HrSiv7yALyhVtYletKSbVAd9tDbSk840i5yQBUhr+tNDgkEJTotpUJu6RZ9wQJdPzWoLNfpomy11q2etHSHsDLOyprWuA9TpyuZ617SGwTwl+2tgzzoCXCC2sZetHQZwAtaGLTazWy2EmkV72tgOjhdqcO1sYzsE2fyrtL196ghU4UF0HTe5Tf2APag63ev29hJurVYZGODe+M63vvfN7377+98AD7jA/U0Efc7ZC4akcUk0ocw5q2ByCicJPTZA5wlIIuIkIcEa6LyAR0Ab4x/BQBks+mYGpOFdIP8PySwMLmdIJDzlH1FEw+UMgxvAHCQuoPicU6Cxm2/EB65wpZsXYIOP+zwjDSjDjua8hhcdnSP9iNucN/Cyp2+EBXmcMyKmEK4RiKERGRJWHMb25hS4YVstUAQp0sGk4PSCWCuwAsdtEHZpfYAG2XAHI5aunR8UqwF04LubGWCCFUQrFpAg+XwCcKxFnIDOG6AHtB5RoUAgCwohoHMIXOeseFhIX8dCAtndjIKzNwsbFtIcsmRQAKG3OQNSqLuysg6gbyaLA6W4MxC2uqxdVKicy6rCoOY8CTssyz8fo2qyoEChOWuB88iST4WGvaw7jL7NE6DE7Vn+H342KwZLoHP/BjCBAWRVo0K6eBYFjOD6Nu/+WAZVEEKf5QAiPH7OfjB+sR5aIVlEqwTNJ2dFgAXFUlEVUgbSggRMQGdK8DXEwlEAAgnTkgRjQGcPcAnlJywiVSFJMC3r135oRghBEyxQgErU4gCAcH9yJgiWECwcoIL/oQHWUgJNQGdaQIDAsgkV0gPXwgYLOGcgkAjAEgsWogPXcgE6+GYLkGzA0gcWIgDYwgFGIHhmxjTCAgMVIgjZ4gCvwH1hJgSPBizKUCEMAHrY8gZ+A2aM4HTCck0V0nPWUgNt92UgsBvEIgOKRx8mwC1tUIF9FAHURyxBACAM4AzZ0C0esAVUWCIPQATI/3IO8/ECSyAJbQAuEDAKXughEoBuxeIC23EA6RAPIzgu+7ADNGIFsmcsABAcUTAP1GB05MIPc1ghR4ByyTIKUkADnJguFzAIFhICL2d1LoEArLCI25EChiOMMZEKjzQfD3AKykgTaFCD6GEDuxiNL9EHs9gcaQCL2PgSV1AJ2rEBofSNNfEBaoBJMBCM5kgTpPACKMB17YgTcOCA83iP+JiP+riP/NiP/viPABmQAjmQBFmQBnmQCJmQCrmQDNmQDvmQEBmREjmRFFmRFnmRGJmRGrmRHNmRHvmRIBmSIjmSJFmSJnmSKJmSKrmSLNmSLvmSMBmTMjmTNFmTNnmTOP+Zkzq5kzzZkz75k0AZlEI5lERZlEZ5lEiZlEq5lEzZlE75lFAZlVJZEdDHko3gD9bQklXQHPPwbijpC9oRAN4YknCwiHXgASZ5BhaAHrlgiyHJAlKHHkeQByIJlwASCE8AknapICpghB25lxVyAIuykYBpIRNgcxmJBs1YIrnAexepB2vJIjNgbRcpAsYIIIVghha5lTRSBHyQkeLAIyqQlxi5B6LJAxjZAGBwmhgZBn7IIiqAmhd5AdlBI7GZkUOwirApmxkpB1joIbfJkaIwfApSBNzmkW+Qh+gRCaT5kaf0H4VAlyJZAfQxA/Qmks2AHp5AmSPZAWSwHUKAlif/2QKT4BzjkIEoeQUe4w+w0JJ3gAeR5JJuOZX0WZ/2eZ/4mZ/6uZ/82Z/++Z8AGqACOqAEWqAGeqAImqAKuqAM2qAO+qAQGqESOqEUWqEWeqEYmqGzognhEIYq+Z0pQAi04JgnSQJbFhwZQAZE8Jkm+ZznMQOgoAkIE5Lf+R8JEACZkB8eaaIeUgjm8AvzaZEuWiIMAAl7kAyaOZE1akQ50AxucJ0OyaNhlowPOaR9tADK55BL+mUSGJFSCmZfIJFW2ke0IJFb+mXN6ZAUYDVgBgITCQGGAAvraUSucJGoYA2KMyQYlZFzkA1LAIMVElEc+QHIAAwzBSAPIJ4feQtVW0AIpjgfflCSENAJ9bAJcdkcwZCSHYADqWACeBAc7eCSSGAPlaihpnqqqJqqqrqqrNqqrvqqsBqrsjqrtFqrtnqruJqrurqrvNqrvvqrwBqswjqsxFqsxnqRAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48eO5pRHBhry585ii/EmHhE/H8+vYSwqQzt0fLlhYIGT/H08eo6Du6KMEo1G+vXuGbRign+/PDCxU7/PrF0G/vz9m4sih34DjLePfgdXM4gOBDB6HwQEHRjiBPLI0aGFwU0SooXStGBPKhSDqBsuGJD5gQgnihaiibE6Q6KI/rcQyxIo0sqbKizhGoIF1NfZYGiA4BulPNfH4aCRoYwgZZCVHNrkZBJMoiSMyTlaZmR2AVJKBlBECkKKVYFq2AiW7nMAlfVyEqSZmHggDBgpnSrdKC2vWeVkLehDyApdl2OnnZSNkMoh8OD7Ax5+IWmZKIy26GECikFpGwxYJbNhLpJhS5oEI1RzoSaagUnZHKTvQp0eoqErmATvrdKdFB6nG/xqZAdJY4E89suYKWSgVyKDrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfghivuuOSWa255DlRgzbns5pTIIP4wAEW79M50BgjchZBEvfyyBEEFhHJHRr8EnzREHf3FUvDCIeFghn8ZXMPwxBtlsueBrSxI8cYTNcAKidJwLPJDoRzzohsjp5xQJz3gmEIcKsc8UDdmBrkBBzKrjAmXRuQssgdAnFmLzxtf0aqUSvhCNMU8PCzlBrcsPbEYEEqpBs5SL0yJrUqewE7WDE/DJS59gF2wA8FwKYSvZvfbQNBSYuJA2/2OoI2UKQhDd78XnP+npC1l711vHkdIOcC+gtN7AS5SatBA4vzOo+Q7kBMsD44TJFM5wQ7s4qIK7G1OcANCbJjDE6Iv7ME2ERZzQeoMj5CLfwV4APvEJMxAnwZz3z7xBYWgJ4XvHOdhC3foEC/yEz0sIInyI/PwC/TUV2/99dhnr/323Hfv/ffghy/++OSXb/756Kev/vrst+/++/DHL//89Ndv//3456///vz37///AAygAAdIwAIa8IAITKACF8jABjrwgRCMoAQnSMEKWvCCGMygBjfIwQ568IMgDKEIR0jCEprwhChMoQpXyMIWuvCFMIyhDGdIwxra8IY4zKEOd8jDHvrwh0AMohD/h0jEIhrxiEhMohKXyMQmOvGJUIyiFKdIxSpa8YpYzKIWt8jFLnrxi2AMoxjHSMYymvGMaEyjGtfIxja68Y1wjKMc50jHwQAhAXjMox73yMc8KqyOfilAnAgAyEAOspB9EeSZCInIvSiSS4xsZF4eKaVISvIulFSSJS9Zl0wKaZOcnIsngwTKUMZllDgqpSnfgsoXqXKVbWmli14Jy7XIkkS0rGVabrmhXOryLLzUkC9/WZZgRmiYxByLMQ+EzGSGZZn+aaYzvwLN/khzml2pJn2uic2taHM+3OxmVr6JnnCK8yrk7I45z1mVdHJnneycijulA894RmWe/qinPZ+C/099rmgOtIBD/vqZqDjMQh6BkE41BnrINUGgD9kAQgjmE4HH3Y+gVoIADlJhhVId6Bn4w2iVPLClDeHqog210uw2ZIKQprRKI9oQIly6yDCFw0WWQGlNwdQGF0VDp5BUUyRIBAugVlJN6SDRAIyqSTX9gERK+NL8RGolGrgIZvWjapU+8AASKS2rL7WSF0j0CPtptUrNINEYzBrWKnGBRCBg607D9AwXfYh+Z3VSGFxEDbDONUzB2xAp/BrUNRGCRM0g7FHXVAESfQqvba3SL0jkCMU2dU1scFEeIPtXMGGgpBqaAmcLuyZGkGgRo13smtZAolKk9rJrkgKJ0vDaT//aiR0kYkZtSWknKpDoBVJ9X16r1FMSMUd+w61SCkikialG1kq625AInNvZMLmCRAKgLmnXJAESDQ25z60SKUhUB+2qdk2T3dAkzAvbNeEAPXggRwHMQQB2nAEJYdhtKv20gkb4Ygq3wNr+krtPrhC4wFo5MIKxouAFW6XBDqYKhCMslQlTGCoWvrBTMqxhpnC4w0r5MIiRIuIRG6XEJiYKilMslBWzGCgufrFPYixjntC4xjq5MY5xouMd26THPqYJkIMskyETGSZGPrJLkqxkljC5ySp5MpRRIuUpm6TKViYJlrMski1zGSRe/rJHwixmjpC5zBo5M5oxouY1W6T/zW6mCJzjLJE50xkidr6zQ/KsZ4bwuc8K+TOgESLoQRuk0GLsAAIWzehGO/rRkI60pCdN6UpbGgEIqy6CD3GATnv606AOtahHTepSm/rUqD4AaM/rYAXE6dWwjvUsNexqWdv61rb2pylrjete+9q2F+b1r4dN7GjSutjITvY7j63sZg8bFMx2trRvHQFA5IPCwp62tl+9gC98IMLZ3ra4uVQHfbR63OiOkxOysOBwp/vdLoJBCa7HgVtMwReNWAFt3A3vfkcoA5/oXeXCgIQzsIMA5igAOfCAHhzs298Qd1G3LZq4KG1oerPhd8Q3jh4hvC5xmdbQYDPO8ZIf6Ajs/xZcLUgkgYeb/OXzgYEYBEcAErnC5TDPuXQikCa68WdDM8C5znPOAE5QPGuaIFEKhD70nAthRmDDhovaQPKmN90LNQAbBC6mISpU3epDD8G8ssYMEn1NNhoHO8cjUIXgyiwNJBoe2tVu9QfsQeA5KwWJ1vB1ug99CR/P2SJIxIjZyMAAiE+84hfP+MY7/vGQj7zkJ/94IkSg2F5wgc8ytKEMYMBammgZsVVwhpzlwUVsuBY9NlDsCTxPZo4gEcatRQLWEnsBjzi6yDxBogpkCwNl6OqwGZCGGKgsrRsixLZmcXliQ0LzIxvvhgrBLUWIftgwuMHIqOGi/G7LBawndv8KMiGyULgIpNzygSsC5usF2ED3C8PXhnrOrQaUYQHFXgMJNpakDSX2W/0wAcW2AQIyMY9AIl4QLiwQBcWGCKLFML5QIt8GLnEQXcOWAiizMHHgIqEDLitgBcXmfhRQMBCgBCTyA+PSAHSAf8NnAvpGMANAIulQLotQM8O2AfRAMDGlIZFgLlAwUcQWAl7HL9EwdeaCBBb4ayiQgfRiCS4SDuciAwXAfr2WAVIwgvSCCETFLhygd8UGBCNALyZAIrlAL1WwXMQ2CXbQLvVQIrbTLlAgf8OmBUNoLnV1IDtgBamAA25XLneQhL42AZRwLg3QfN0RAkCQDX3Qh+0SA0v/UGwZgAmfVy6d4g+BIA+zgFUbQwFGQIW9BoblAgeUMAcy4wBEYIO/5gdraGgqUQJy+GtFgAWsqBJIwATFpgTTNYsokQT9N2wPcAmTqIslwYmeiGuE4H3CSBIOAAio6GuCkFPJWBIl0ATFpgWyGI0kwQa2SGwgkAjYSBIXsAnDtgD0940iwQFGwIK4tgfmaBIO8AqGKGtCMIHtWBJvoAK2xgj7V48nUQM5EGsggAT8mBJt0ItcEgEzN5Ap4QFboI5C8gBEoJArAQGjEI84IgGMKJEksQ8ehSNWgIUauRL88I8vcgTGF5ItcQHwQiIhAH0o2RIIwAoO2R8pwAIvGROp/8B19PEAp3CTMoEG1NgfNpCRPpkSfUCS6JEG8FeULXEFlYAeG8A2TCkTH6AGhAIDLjmVM0EKL4ACD6iVNQEHuQiWZFmWZnmWaJmWarmWbNmWbvmWcBmXcjmXdFmXdnmXeJmXermXfNmXfvmXgBmYgjmYhFmYhnmYiJmYirmYjNmYjvmYkBmZkjmZlFmZlnmZmJmZmrmZnNmZnvmZoBmaojmapFmapnmaqJmaqrmarNmarvmasBmbsjmbtFmbtnmbuJmburmbvNmbvvmbwBmcwjmcxFmcxnmcyJmcynmbv8ADmSkJC9ADqGOZ6MAdtrBZlClb3VEIgfeYDqAB9DED+//omB7QSrkQho15AcUQIdvwhor5BEh5IEKwlINJA/hIIruAd4SZDAL4IvJwmO+gJPNAmA0AnkqCC93pl0kQg0pyBNgJmH1wPEoiCAnal8KAhkKiDej5lw6wM1ICBPSZlzJQOlISDPrJl33AOFIyDYLJDs34IhYwiIDJAWrAJQeQkH95C+GnJGbgnIDpCyYoJetwBYG5clwCBO75l0bAJZhAmBywoy9yAt1gmHGAoSRSBJ2AmG7wIsdwV4iZVBvCCiEqmD7QChHyAuTXmNewauhhBg73mLHQH3UAdZBJBujBABVAlImZBEDoDyBQepUJBfIxCN54mdZQASe6nIq6qIz/2qiO+qiQGqmSOqmUWqmWeqmYehkyUAFeapltaAHS8KaU2QFa0B3rwA5J+ph6QB87UAp3EJm85x/VIAKpipi9sCEJsAUdiJgB8CJO0AimcJh8IHwvwgCDkAkbGphlwCUvQAh6QCd/2QKr8GopAAbCUKt3+VaydgK7QAkveJcQAABVWAmAsIp0iQzFNgl6mpZPSWxrRZfxUIm/Bgh3qQMaYJGypgp5OQSxYKa25gR8CQElYALEGidF5ZehYAz+eiZf+ZeyIA/9KSQHEIyB6QOzIK8vsgyIKQfTUHYuMpaIiQqw4DQHwgBU15g0QAcM2B+CEJkQgAWwoKLdkV2UqQP4SQAJ3CEKmIkNRBAymfqzQBu0Qju0RFu0Rnu0SJu0Sru0TNu0Tvu0UBu1Uju1VFu1Vnu1WJu1Wru1XNu1Xvu1YBu2Yju2ZMtGAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48ePIkytfzry58+fQo0ufTr269evYs2tX7WC79+sfiqj/wfK9fPRu/tIzS5XEvHvlY9LLtxDgxvv7w/MwkM/fHxNAK+AnIG/G9GfgBKywMeCCtgFg4IP+VHIIBAxW6NozEGbYyiddWOghaqxkKGITl7Tx4YmhfXCAiCyewIoLKMa4GXos1sgAGH3IqGNl8dXooz/E0LDjkI7p9+ORZAhJ5JKHFXjkk0kyKaVgDj5pJRkGTKklX1RokIKVVu5Sw5Zk4hXGKZ6AeeQDGvBR5pt18fKFEmr6+AInJMCpZ1xhLLJBnTWuck4DexbqliHLPACoiLjEY+ija/EByg6LQhhFC5BmipYHRLRSaX8iaKoWPMzEUCgEyaT56SQUimqWDsek/zcPpIaQUakirpa1AjALyLfAH5nqsMx+YC6TK1l6hGDgAKLWMI6iR74gx7FhyWErhO24+oQG0NYICrVfYdDIBCIW0aGrNYBBbIYgjABuVzr8WSM01Nawhoj2vLsVBdB0y2IE01KLwyAPztCdvljR4ISVrugLxST9QYHwVRTY0CuY1OgLASVapGfFxFaJcgSgzGCA8AfGNHEHyFN1UEEGlZ4DMgcsS+XCOp/6c0B7NffM1Cwo5LwKFwf7bHRRMdybczM8H+20UCz0kDMkvTxtNVAO4HPxoiiQ0sHVYPOUyAA5E+Nm2Gjj9AYen0ahQNpw1+SANTlrEGDceMN0wSafBv9yRt6Au9RLEZ8Cg2ngiKdEhAWVmiFx4pCXRIEan2rgbuSYhxRKLpWqcE/moH8UByKVCnFF6KhzxAHndUYASOqwbxRKFGrOkEXsuGdkQARW1vJB7sBfRMuRjugR/PEW2eDjJKog7/xEDizBojkUPG99RCss/OAEoV7v/UMurGJgDjx8b75D1GztTxp3n+++QqTIZ02r79eP0DhKhGP//ghRACP/AAygAAdIwAIa8IAITKACF8jABjrwgRCMoAQnSMEKWvCCGMygBjfIwQ568IMgDKEIR0jCEprwhChMoQpXyMIWuvCFMIyhDGdIwxra8IY4zKEOd8jDHvrwh0AMohD/h0jEIhrxiEhMohKXyMQmOvGJUIyiFKdIxSpa8YpYzKIWt8jFLnrxi2AMoxjHSMYymvGMaEyjGtfIxja68Y1wjKMc50jHOtrxjnjMox73yMc++vGPgAykIAdJyEIa8pCITKQiF8nIRjrykZCMpCQnSclKWvKSmMykJjfJyU568pOgDKUoR0nKUprylKhMpSpXycpWuvKVsIylLGdJy1raspJASIAud8nLXvpyl7G4pV4K8CkCCDMvxKyUMY95l2QuapnMrIszAQXNaM5lmnWqpjXjgk01aXObb+kmmL4JzraI00rkLOdazvmkdKozLew8kjvfeZZ4/mie9CyLPX2E/898jmWfNeqnP8MCUBYJdKBfKaiIDorQrig0Qwxt6FYeCqGISjQrFH2QRS96lYwaaKMcrYpH+wPSkE5lpPwpqUmjglL5qHSlT2lpel4K06bI1B80relSbppTnSaFpz4FC1CD6pWhEpUrRj2qVpKqVKwwtalWeSpUqSLVqUqlqlaFClaz6pStcpUpXv2qUsIqVqSQtaxGOStaiaLWtQqlrW4FClzj6pO50pUndr2rTvKqV5zwVUAYYMMvKgAEecjwr98J7GCBwAiYyWcHhy2mjHxQjl0ww7EZapoLEYudBvhLRLiCIWexU4gfSSKGo70OMX7ECdRKVkaP+FHDRPvaGP9l4kdHcK0ydaSJH51At8/UUR6OlAja7lZHvPORIYwbXB0x4UfwYC41d2SFH01DutncUTB+ZA7senNHsfiRELw7zh1F40eMIC86d9SLHzlCve3ckSmOdK4WpvY6Dvhshv5n39rKiHbKfeF9r+OHH0VDwP6NkfR89AoEH1dHtfiROhzcXB1B40esoPB0d/SJHxFCw9ndEY1qxKzNJhhFJUAviL+7o2v8KAQrLu+O7PAjC8R4vTtawZFo1t8H6+hImlXhgK/jiB89wcQ+llHHfIQKJFdYR4z4kX16/GQZxcpHn6PyhncUhB8Jw8lb1tFqfdQ9Fg7ZOrv4Ub60HOIdaeD/Rz8Ac5t1FCIfXZfNLN6RBH5UATnnWUd79lGf8SxjPfPZz4XWUTl+JAFE43hHFWC0o+M7pDnc4NKYRsUfNs3pP5hi0vLs605PjEBTdJrTqMA0pufQszMfL9A1GjTLXB08WLOoHK0m9QEj7aNG14zWwON1jXw9a10bUNgsIjbIgJ27aWA410lO4A9+pAFoVzmB9vjRLqwdZgWK4EfE4PacFSiMHwVB3H9WIBp+dAx0J1qBN1Dxr41dQFT8SAvufvQCn+DefFOagUk4km06gICCG/zgCE+4whfO8IY7/OEQR0Ad6E1ADhypfbI5xAE2zvGOe/zjIA+5yEdO8pKb/ACY/+22AhnnIzvURgE5i7nMZ27QByrLR9d4Oc13znOZ99R7UfZRCXTe86IbXd8LJJuPfEH0ozv96Rp9ICF+9ImmQ/3qT//59eo8L6tj/es9/5YD1fGjWngd7GiXuevy0cBX/GgJZ0+73Cu1gC/8boHn9ZEf4j73vtepDvpYoCF+FAW++/3wT3LC7RLogh89oGixgTniJ18nGAwdgV040qdnI3nKe/5JGfgE5AlYZB9VjfOfT/2R6k4oAwa9RgdGvepnXyMhXMCAQvhRMGVP+95D6AiLH6A5fhQM2nTe98jnDwzEQEBn++hjvE++9P0RAS4MEB4/YoLxp899fzCAE63n3//gfRSB7Xef+0IYAgATcaQ8RP/8yffCmPh3gh9p4v3wR34IHme/kfkoE/iXf74XAVVAP+7jCj/yCAEogL33AHswet/DCeC2gAzYe0twe+4jCT9SCLMhAwbwgSAYgiI4giRYgiZ4giiYgipogkSQXEfnBfz1PYrgeOFnNJogNU6nAn9jPgEnIg/gBLtQDj5gNfQgL0c3AadlPpQiHxnACEBQAb/ABiaDNiSgNEe3AI9Qg88jD08YhVMIOBhQBvq1cwyQBqYiajsxCy5odJAQg2h4E4qAg0cHA1P2hjjhAkZodCkAgHaIEz7gCutSdAtgA1rYhzLRAGWgPkW3BnliiDb/0Q/k4nQbEDCOSBMsAGBHhwhTUIk1EQcz8HQp4AacSBMrUF1ON4jVM4ox0QB0oIg8xwAmgHGq6BKLUH+SSA+zGBNQcHNHFwJUkIswgQSf6HQoIIrA6BIyUACB2HMZIAWpeIwrwQGlAHVAcDnQuBJV8CVONwkud40rAQUg8HRa8IveqBJ3MIxHSAnlqBIxsGBHlwGY8IXrKDlGsIw9V43zeBIOQAS2eHR+0I35WBIlEI5OVwTkEZAlgQTP5XRKUGYIKRJJ0CNH9wCXII8P+REUUI9PRwhhcJEi4QCA0I9GJwiW4JEiUQJNII4HaZIfwQYLeXQgUFws+RF7c4XWN5Mg/8EBRuCKMrcHOPmRr7CGMicEd/eTIfEGKkBzjNCIRikSNZADMgcCSNCUJdEGErkoEcB8VFkSHrAFPLkmRLCVJwEBoyCUTyIBBiiWJLEPS2glVvCMamkS/ACVT3IEZxiXKHEBBPNiboiXJoEArPCV/JECLOCXLZEKL+CDp2CYLoEGKQkhNpCWjJkSfUCX/ZEGhTiZKXEFldAfGyADmgkTH6AGxAIDfRmaLEEKL4ACm4iaMgEHDumasjmbtFmbtnmbuJmburmbvNmbvvmbwBmcwjmcxFmcxnmcyJmcyrmczNmczvmc0Bmd0jmd1Fmd1nmd2Jmd2rmd3Nmd3vmd4Bme4v85nuRZnuZ5nuiZnuq5nuzZnu75nvAZn/I5n/RZn/Z5n/iZn/q5n/zZn/75nwAaoAI6oARaoAZ6oAiaoAq6oAzaoA76oBAaoRI6oRRaoRZ6oRiaoRq6oRzaoR76oSAaoiI6oiQqIC4Al98ZDkowDuEJAXSTHqTwnSuQBvyxABnDnTxgmfKxCqdJnSIQiQbiBLI4nRQwfCKyBBAInaoAMTViA9WpB6XnI7QgnR8QYU8SAVnynFmAjk8SBaHgnIBglkeSCzyWnFeQe4uCCHGgnPeQlIuSC1+KnCPwZpWiBihKnFBgBpViAWGJnC0ADJ9SBKd3nGcQCJ+yCRhonCtAp5X/Yg1JGpwKgImAggdvgJx8MGaVMgAyWZwdQApBQ3f48Ki/2QuQkDM9UJjGmQTNEHNrcJfD6QBcID6fggKzgJxJsCKfsg49akFlqi/nUCkZUAFf00F30ATGUJTgggHMAChHIAogZIpaQAmS6SrUoCaD2KscBAX9MQn8Ry0ImHhK8kEOwKXyMQg4AC5yIKYP8gDQgK0dlG0ZsgbzlyuY4CMboAMjNAIEmSE3Mq+a0gWEkyET0AgW+UGg4HgacGSi0g4ZQgaUKEJykJhrMg7++ihKxx8hYDwmtAxqwgDLgK+Q8gdbswDAMKQhNIOLQgbL9ShbkB7HALImBAFMWimekAzT/7olMcAM7KBC3yZzrUAEHlCcLSCpMbcDoHA2whkPuMBzD7AMKxucDXAOsrpz5FAFHRmcJMAJErtzSvAFvCCcfMAtRecJp3C1v1kDaVZ0KaABT+ubBnAtPQcAw0kDcEtzxlCcdEtzDOB+xkkDmPopY6CcfaAun9INzOkCrCCSVnIAyKqcbXAJj2klGQadXZANnvIkzzCdEHAInekjcmudbMAKQAohd4udKwAIL9kfe8udNxAALCcfgeudSZAKy5oehhuez6AGRdC43ymqJfq7wBu8wju8xFu8xnu8yJu8yru8zNu8zvu80Bu90ju91Fu91nu92Ju92ru93Nu93vu94BEbvuI7vuRbvuZ7vuibvtgZEAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu7fv38CDCx9OvLjx48iTK1/OvLnz59CjS59Ovbr169iza9/Ovbv37+DDi/8fT768+fPo06tfz769dA6/3Mt/vcJYCH9Y5utHjQ0WCn8ALrPfgKK5oEEGACbIgBztleJODQSCVgMYDCRooT90sDfECf4wAIYOEW6mAyEVXmghCiusd8mFJtAQomV9mGDijP7Uo14LCcxYAIgvQuYChTTOWAQG6cUSpD9rQNjjYpZo8MCRNPqCXgOIQMlAOk8sedgFRlgAZZDeoCfJlwA+YE4oWgrmgTiOkHnkDeZBUIibAKZgTRhp9uVAJj3QeaQV5kXjZ4IgZENknniVcMSgRzJwR3mQMJpgDnAgWpcLaUgK5TzklaCphZvwYClcI9jg5ac0mlEFeUGgmuADX8T/MOpaEMwCg6szzkDJoeLRgKuFq7zSwaxnoZLLrxcG8c15AiBrITm9EDvWCEYs4CyAZLiYHg2ZXutPM0NI+5Uv911rwjXu6bBMicjuYA8E4mp1yyDe7sLjfBOy++sxWcRrVQeNRHDtjiHyIqOzGZRDgb9SiRKps9to26MoZFzrhCEMO+XBI08iK8gUlj6jy7Vb+JCxUljk4Gwh8RGLBjPOmgHFyUZxYIO1v+LxSgPxdnBKlcgC0wLNQnXiBLIRYDLCyV0IkAKykYBMtE+xdIwrIXZM/Y8p4Di7Bwda75TMr17AGbZANAiC7BF9nJ2TMqjiUYUDbhMED9CuvnBO3Tat/2CGpAzUQgLfBY1Ah9WoamMK4TOxwCgk0TJu0B/H/FqO5DKVQqcjwmKO0Cx4oCoIr563xAETZO6CZukIXQC3pEqowjpMqCAYJCIKzL5QCYEwSovuMIkTZC0pAq9QF6XgTKY8xr/kQOUXFmJ28wtdg/qXreBJfUu3/Jeg0Ns3ZLPyM2ZgQPguLQKgLVKj3xANR9Noo/stFVCLyfQ7xEEp+gJYCbz5WwnpAtgQFhTBQnhIBAEXyBMZBCBByGCgBHcCD0cEY4IYzMkcwJbBDnrwgyAMoQhHSMISmvCEKEyhClfIwha68IUwjKEMZ0jDGtrwhjjMoQ53yMMe+vCHQAyiEP+HSMQiGvGISEyiEpfIxCY68YlQjKIUp0jFKlrxiljMoha3yMUuevGLYAyjGMdIxjKa8YxoTKMa18jGNrrxjXCMoxznSMc62vGOeMyjHvfIxz768Y+ADKQgB0nIQhrykIhMpCIXychGOvKRkIykJCdJyUpa8pKYzKQmN8nJTnryk6AMpShHScpSmvKUqEylKlfJyla68pWwjKUsZ0nLWtrylrjMpS53ycte+vKXwAymMIdJzGIa85jITKYyl8nMZjrzmdCMpjSnSc1qWvOa2MymNrfJzW5685vgDKc4x0nOcprznOhMp3uAkIB2uvOd8IynO2OhTr4UAFcEqOde7un/qnzqMy/8RJU//3mXgH5qoASti0E1hdCEzmWhkmqoQ+MCUUZJdKJvqeigLorRtmjUTxzt6Fo+SqeQijQtJHWTSU96lpSSaaUsLYtLvwTTmI5lplCqqU3DgtMj6XSnX+lpkH4K1K4IlUZELepWjjqjpCo1K0w1kVOfepWoXmiqVK2KVS2E1axOZasJ6qpXowJWAIl1rE8pqz/OitamqJWtbV3KW+MqlrnSFSx2vatX8qpXrvC1r1r5K2CxItjBWqWwhqUKYhMrlcUyFiqOfaxTIitZplC2skq5LGaRotnNGqWzniUKaEMrlNGSFiimPa1PUqtanrC2tTp5LWxxItvZ/9qktralCW5zK5Pd8hYmvv2tS4IrXJYQt7gqOS5yUaLc5Zqkuc4lCXSjK5LpUhck1r2uR7KrXY5wt7sa+e4Hu2CCL7xDBGdAwtJmJ14P3mJGEwDANsABCkD84nx8a28HseCmKBBOvxn8hZsm8V98EpEIbhJCgftJxBWRqRkLFigRWeEmdUT4oD3qwBWyIAY9ZOMSW1gGPaOyBjcB4sIM3c8zQqwLJ4SORkCQygDc1A4UR3Q/tHCTNqQyAzdRw8YW3c833LQBqRyQTPitG4CT4ysyaUEqE3DTLYC80f24wE0TiAoF6CSr/BpYP0OgEwedEgo6AVDJX54PBOiUBKi8l/9MCWDckpNzADdl7Sl/cJMt5Jzm+UTBTX+AiiLcxAw+M3g/AHATFaDiKTKFicogHdDDvlQCqCjATUEwtIT30yoyCQMqInBTGjSN4f1YwU0igEo23BQAUqd4P4RwkySg8gM3acDVN96PBtz0A1rbGtdB1jWvoVIBN2UI0iUdEDDcJABiu0kCwK7yfiTgpgpApRzPjnak9wMLN2ECKtQmEz60nez9FJtM0H5KuL9kbWSrdEDn/lK6nbJuKLXby4fWT7yhNO+m1PtI90Zzvuez7yP1myn/DlLA3TZn5BQ8SAdfSsJptPCzNfw4D6dRxJUy8RlVPGwXN07GZ7TxpHTcRB//11rIizNyE5UcKZhwEyzI/e5pu+lyT2n5hV5OtJUT5+QXSjlSmkUmYND8pQOiQ7V9TaZbuxvpwibTKJj+Jafje9P62TWZev2UMaXu6DQd0APJlA1QuwlQTw/7frr1pVQ/RRiYBntOB9TpL+XuKY3+EiTk7tMBecNNlX4KFdwEAL4PdUAwI5MmoJJnMvk37XPfjy0ADRU7uOkAhkfqgHJEpik/JQlmrk0HEED60pv+9KhPvepXz/rWu/71CKhDn92zZjetzikcoFO4aHOIA/j+98APvvCHT/ziG//4yE/+AWyHdfnEgE4Lg0qUyeSC2lzaW9jPPrLgmp0nYFkqWnCT/8Rkc33tm//8256PAdxUBKlswE3Lok350U//+kt1P9Rw0wykog03/U7+9heAAsh92NEObjIAUgEEQYIHTqALy7AFz2B9AjiB9EeA1wEIbrIGUhELD3gJ2aAHYpAFVzAsujF/FHiC1wIK+6EObsIKpWOCKBiDrhIBgJAP89EMbnIJLyiDPPgrC/AFHyAfQuAmRLCDPXiEqFIH+uAek+AmLYM5MIiEUugmTtAv7PFnZJIfnhOFU9iFRwIDgaceBvALgAAK4LANADB9F+J5UOiFbugmGfAJdKMfI4AEZyAC7/AFJtAFRviGfhgkP8gzWcWFf1iI/iAEFzCIhriIJnIEVv+oVITIiH4IA2LwVJEoiW8YAVwAiZjYiR3CCYJoU5foiW4oBLsXU6NIil7oBUrCUqmoil0YAjPjirDoiRFQBWeGUa9Yi1P4AHswh7rIi6S4BImIUTJgAMiYjMq4jMzYjM74jNAYjdI4jc9IBAJDf15QfeDlEprQJ/SnAmewjS5BD+9HfxMwa+LIEiRQYvS3AI8QiumIEhhQBoijfQyQBl0WjykxC9eIfpCgjfqIEorgjegHA9MTkCbhAuWIfimQCQiJEj7gCv2TfQtgA/D4kCLRAGVAPua3BoODkSXRD2p4fhvAICBJEiyAheiHCO1zkiERBz1GfyngBi45Eitwau3/aAPRV5Mf0QB0wJHZxwAmUDw8+RGLwCH0twH0UJQgAQXlgn4hsGhM6RFIEJPohwI0OZUdIQMFMJHYlwFSsJNamRH7Y39AsF5jqRFV8DT0Nwl3lpYZAQUgUH9aIJVwiRF3YJXnNwGUcJcZEQNLUH8ZgAkD5JcSQQFG4JXYd5aGaREOQARIiX5+8JaNORElMJf0VwRaWJkTgQTXg35K4HacKRFJMAb19wCXUJijyRCIqZjeQgjas5oP4QCAEJnnJwiWIJsRUQJNQJebqZsNwQafeX4goEDA6RAXsAnotwCbeJwPwQHVYn574JwR4QCv0I/XIgRBSJ0R8QYq4C2M8JHc/xkRNaAyyAICSDCeFNEGpokrEVCJ6kkRHrAFQOknD1CE8VkREDAK2DkoEpCL+TkR+7ADkmIFYhmgFMEP5kknR5CPCGoRF0AvbhICAPmgF4EArFCfF5ICLGChHJEKL3AkD3AKHtoRaNCbNGIDAFqiGNEHC2ohaXCRLJoRV1AJF7IBMjCjH/EBalAiMFChOtoRpPACKNCSQeoRcCCaR7qkTNqkTvqkUBqlUjqlVFqlVnqlWJqlWrqlXNqlXvqlYBqmYjqmZFqmZnqmaJqmarqmbNqmbvqmcBqncjqndFqndnqneJqnerqnfNqnfvqngBqogjqohFqohnqoiJqoirqojP/aqI76qJAaqZI6qZRaqZZ6qZiaqZq6qZzaqZ76qaAaqqI6qqRaqqZ6qqiaqqq6qqzaqq76qrAaq7I6q7Raq7Z6q7iaq7q6q7zaq776q8AarMI6rDXBAXPApsHgCPCgpsiQIAGQo2aaCC8GIEXQoSWkmjkEATZ6IQxQCmP2QT5QCwUARPUQJE4wfhk0BZPnD4vgQwbAfDNSkd/KQC2wbAmCAmyYQ2HQCmTCBOgiQTcwJxdyDMCIQ/JAJwtQCnwYQCtQC0EiDjqUY4MSCGGIPgqAN+WDCjikCkqgKcpQjNSTCLvQr/MaQxigNp+CB7PQPB0ACG3iJqVgQ9iGK8cQaLP/0wuTRifWOkOm0H+48gB0gJaMEwO14JpHYgZEOUPnEKK4ggjLSjgOUAXTKinKcEN9sCi/IgjoOjU34AW/kgw3xAF74CzgsDhTYwex9isPMGI3NAWRgCwpIAALyzAjgAn9+SlO0Ak7VK/OgginQILS0gCvMLWoIq8+BAV/gyzMgAbS8gsC+ys58Js95ANbcC26EIGIMgUoq7aP4AFEZAjxgyxkIApaQgPbcC2QQLpGRAHlAK+4YgK8ECI6oFYWEgGNALhHlAXQgywe0oryoQMjey2DkK9JBAH2QKDOwgDLcC/rcQ0H4ywwICVQNAQ46C1psLXkQQMVcy0LYARCC0W9/0AO2Nds5vENdecsuaCxVtQBr7AK14K93YEBlKCXyAIDs7CiVBQDX1CPmpJp41EFiXstFmAD35tFPKCcrlKx4DEP2JcGQNpFcPCig7J35HEHRjsoR6DAYIQB2YCZgxIN5oGTrtIDmVCwZBQG1sCWblII+PsdN+AqjiAOnrtGoWAO/Esj6GgefycpFmAEINtGT5AOF4wIMioevsAoD6ABuTlHNcCONMK25oEBR0YmHvLAcjS7M5IAQ5Me5UomJtA2e0QDzwsgOqgeK+A9NMIAhMC8fKQDQHICp5geSjcjvUtINeAOMcsectA/GaABVuyly3CvsIANZ8pfIWAMSWumv09QssTayI78yJAcyZI8yZRcyZZ8yZicyZq8yZzcyZ78yaAcyqI8yqRcyqZ8yqicyqq8yqzcyq78yrAcy7I8y7Rcy7Z8y7icy7q8y7wcFAEBACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrN8rD1PLn0E+KgubEX4Xo2LNvNCCllb/v/jZo/x9P/mGcS7jAq/c3p7z79wJDjfKzvv4P+Pixe4A3ZkH9/0HkJ2ByncxzwH8I+rPAEAM2GBwJn5CT4IT+sOPghbsZIk0EFFLoCoYg0taFJBJ22OEJHoSoYmu3lJKAiTD6E86KNJ5WQh0x5jhOjTyC1gA7M+Qo5A4O9GhkZiRMg4iQTPrDwpFQTsaHESg02SQdUWbZ2BMaWGClkC8UkAkJWpZ5GBtgMPBljBFYQckIZsZJmCgmrAljBkt004KcfAamQ512dpjLK0n0aahfSKQZ6IStVHDLoZDuJYcGDyyKYATyPBnppnddMY+XltYHSTYrcGoqXV0IUGWo6qVgDiqnxv8alwOzLMkqeDn8UKqsvLb1zRG3fseAK9T0aixbWATrjxKltHfss2rhGGoRsewqK5zQssVGpYFuQAsGxvqChyQQZLvWF3YGAcWzXfTwnR84mJvWBS82SQYW2WKiHgOskCmvWaQwaYIo5srB4XoqWPgvWQ0AEGMANfwL6H8DxLHwWPeYaIUOC59B4QsVUHBxWINMWAkNF3fAhIlMoDyyV7z4V58zN7z8Q4wMSLDny1yZsx4ACvCcRL0xRmIIz1u14ch3KmQDLs+sNJkzB0hnVc8JmPhQNSpqWumEy1VXRUEeYf/jjJ0LQCNy2WxLhYalXvDQ9txOQbDIDotGkA3dfC//NUQtXduZxgV9F34UDvQFikixhjculANcEL3mIw04bvlPoeyyqCB2XO45T+G4a+cOh3xuOk4jbLEoKB2c7jpNijhsZzWJvG47TB5IELiVIMhy++8tTREJ2qQAb3xKLdQSqDIfHO98SdSI/uUkljxvfUgxrGGnCjVf731Hi0ywZgZEfG++RkhsYCcdRZ7vPkUUlGJnAWG8b79EyOD9pRd83O+/Q3wQxJpCYID/GVAhDdjDmiYQtAM60CDJWJqVFlC+B1pQILcA1pesccELtmAZa2pG6zr4QGPsTkhLSBEJHYgMyQmJEyt8oAtWxiRB1C+GDvQBGYTkBMLh8IEOAEaM/4pAth9e8BMym5AKkGBEEn5DgghCQQGbSEJemAFBFhADFWOYhyCtZwG/2CIORzCA9UhCjD+kABDAIw40GtEBCpSAG6lYujna8Y54zKMe98jHPvrxj4AMpCAHSchCGvKQiEykIhfJyEY68pGQjKQkJ0nJSlrykpjMpCY3yclOevKToAylKEdJylKa8pSoTKUqV8nKVrrylbCMpSxnScta2vKWuMylLnfJy1768pfADKYwh0nMYhrzmMhMpjKXycxmOvOZ0IymNKdJzWpa85rYzKY2t8nNbnrzm+AMpzjHSc5ymvOc6EynOtfJzna6853wjKc850nPetrznvjMpz73yf/PfvrznwANqEAHStCCGvSgCE2oQhfK0IY69KEQjahEJ0rRilr0ohjNqEY3ytGOrgQICQipSEdK0pKKNBYeHUwBAkWAlApmpXZqqUsBA9M1yXSmfqnpl26KU77o1Eo87aleftqkoAoVL0RlklGPapekCmmpTKWLU3ME1ajKZaoxqqpV4YJVGGl1q27pqom+Cla2iLVDZC2rWs5KobSqFS1snZBb32qWuCZornQli10RhNe8imWv/+mrX8EC2PoIdrBeKex6DotYrihWPYxtrFYeC57IShYrlP2OZS9rlcz6Y7OcpYpnQRtaqYy2tGk5LWrPotrVlqW1rh0LbANZi13/xOIZVOvbbAFpK39Y4Bic+EXt2rZbP84hQWZIxyuuMUKeFbeP0TDRBAaQ25E9l4+PgJEtkHbdPZbRREDgLksHCQElwAilzh2vIOMQI02IN6aD9AWMFtCF99p0kDaA0Qyq1t08bgJGauCvegOJBxh9QsDwDWQo2ovg+wbSYzCy1sv6e8eAmWi7Dd6pIDUAow9lGKiC9ASMOPjhogoSihRKRtgoPEdTxChiJVZqIGUBowdULsZPDWQVYFSIsrHYjfLTmI8H7Mc0wAgWQ07wH6tjolkk2cF/PFiHjrZiIvNxwTC6wpM1/MdnwGgCbPuxGLsBIyaE2cp7NAaMlnBmJfcx/2om+kKbodzHMcAIHXPmsh+ZASMVbxnEf3RhgqZYZTfv8QMxGm6h6bxHOcCIAc3FMVW7DKMQEBfNeYwHjLxxaUPr8RVr7jSj9agOGHFD1HrmI5w7BA1UA7qPIDTRK1xtYj+WzES0oLWM/egFGL1B1zn2YxFgFK88v5qP4jPRo4xdaz5yIEYxAPak+3iFGM1NzE10tIkScG1M3/EPMCpCtz2NRyrAKAfjHjUeoQAj8Ug7q36EA4wGkO5U61EEMBJCvY+txx2biBD7bvYeb2YiDQR813wkeIcM/m6v+vEdMDLHwYPNxwrASI4NH6sfLW4ijDMb4Xu0xsUnPm0+SgBG1//JOFr9yIIKuPzlMHf5JSRQApLDO7Z69TbOHavznU+250cqgQQuEfOiV0BTnMT2ijjeIY9vUukqOrmJSJx0oBtJ6h1KedXJnSWsU0jrT7d6j3xmond4Euoh4rCJ7tNJtINI7R1i+9bVnSVCwKgKZxc7j4QAIxHknetR+m6H4PB3ukdJfSZaV9v1XqMcwIgKhbd3mYZtoj9Ent9lEjSC5NC3DiDg86APvehHT/rSm/70qE+96hEgLcNDKUZa5tshDkD72tv+9rjPve53z/ve+/73B8gA41cUgxhVd24KUJbyly/5LN3iy4VLPvOnT/228gkH4Y5+9bfP/cry6Q0w8oL/9rtP/umTNj+0gNEgxl/+9gfr/PgBtYmWwX732391fIIGjFhR//v730oRAAj5ECfcACPq0H//l4A5sgBf0DxlsgQwMmt9I30KWIFCUgf6UCbeACPxgIAW+IET4gRZoCUhACPP4IEgmIL1AQM1ByUdcEIJwnkTqII0OCEZ8Ant0yOJECMOyDcUWINAqB4MeGM8YgAwwm0oGIQ1KAQ+VCPJACPMYDg/qIRUeAQjWCPoACNjIIVU2IXgAQNaRCPoYiL8l4ReqIIRwAU0AoEmYgxceIZeyACcQIQYQkMd0g1vCIdeKAQMAiLJ1iEnaIZ6qIJeAGMOUm0wEgp5OIhdGAKK/9cghgAjEdA4U8iIShgBVVAuAzILMOIElGiJcPgAe5CD+AELMJIGnwiKcLgETQgfVgAjpdA4MmAAtFiLtniLuJiLuriLvNiLvviLu0gEUsZ8XuAC+VEId6dKmiA9zKcCZwAfDcAtHeI7qkQPiDd9E3BG7lEDMeIcq0QC2kN9C0A55fGEJuIIroQBZSCNy8cAaRBt4yFyJuIJsDQLw7h8kGCM2uEKMMJwr6QIzLh8MNA92GELMFI8seQC18h8KZAJ2LECMfKMsuQDrgCDwbIANkCHyaEJMaKIs9QAZZBEzLcG/qIcnwAjeHBL/fCHzLcBMpgcagAjm4BLLBAF1YcIU/+gHF7UITaQS3GwkwzpBsjRBSI5Ib6gSyvwiuJoA2tDHIoQIxajSw1AB0WpLAxgAhIWHLEAI0qgibu0CCdQfRtAD8SxRiZCb74EBSVIfSEAecJhkCbyCMCEBEC5fCgglMDBAQPAkgkSDcEkAwVgkbeSAVLQlL7RAdfwCulwRQhSPcHEAUFGfUCALcORCL/ACccAKv6ACMVUBSlQfZPQOcfBAc8QC7tQC8YEBSBQfVrglj4nFXdQl8o3AZTwmlMRA2w4fRmACU9jm09BAUYgmLcymb4JFQ5ABGFJfX4gmsXpFCWwmtRXBPjSnE6BBHbIfErgd9TZFElgZ9T3AJfQm9v/mRTAKZysQgg3NJ5J4QCAkJzTJwiOqZ5JUQJNwJrTKZ9IwQbXuXwgoGj4aRQX8F/MtwBq+J9JwQFGUJWhsgcGuhQO8Ar3aClC0IMNmhRvoAK3wgglWaFKUQOOZykgwEQc2hRt4J12EgFhOKJN4QFboKAx8gAVpKJ1MwoRGiMS4JUy6hT7oD9CYgWGmaNOwQ8fGiNHAI9AGhUXcGsmEgL6eKRSgQCs4KKtgnROOhWp8AIT8gCnUKVXgQb1iSA2gKNcOhV9MKTqkQYaOaZTcQWVsB4bIANqmhUfoAZdAwNNGqdYQQovgAI5iadbAQfa6aeCOqiEWqiGeqiImqiKuqiM/9qojvqokBqpkjqplFqplnqpmJqpmrqpnNqpnvqpoBqqojqqpFqqpnqqqJqqqrqqrNqqrvqqsBqrsjqrtFqrtnqruJqrurqrvNqrvvqrwBqswjqsxFqsxnqsyJqsyrqszNqszvqs0Bqt0jqt1Fqt1nqt2Jqt2rqt3Nqt3vqt4Bqu4jqu5Fqu5nqu6Jqu6rqu7Nqu7vqu8BqvYVFH23py7KOt4gAeQPCj0yoJ6zEAlDmtv1CVM1BE0ioGmrkeZsAL0moAq4IgjvAN0IoEGEohC3BgzZoHlGciwECKx3oBTBYjZKA1yBoGAsQkTHCnxMoJX5IAyHCsHpCbTMIAbmisHf/QDGuyDDtTrPJoJUewbMVKBFLaIUrgZ8WqAHwpJHSQpsBqAGtpJfBprHzQa1+yAy9brGGQWaXAr7/qAHRgJ+QgosRKBML3JROwCMZ6AxX7JWtgpMJqCZNgJz3QgsP6AcoQKLWws8JKCkNrIpHQp8MqC9D5JTmjQsKaCNUQKACgCMTaAaCwKFsQsMB6CDz6JT0wI8NqBydrJ7vgkcHaANkVKAnABR7rq9TQW2sCL8N6AUYWKAxQC30YrNlQo0yyA4sgpr3KA1QbKGgwrBQADX3bIc5QNnnAtYlEAyE7s7CCNCOACSdQD5HEAbrTJGX4MhiQDRXrCG0gSYYwPDmSAIX/8jIKIDvgIXGS1ALTCyNytzA3cDb1sQAMO0k0sJ8IwgSRZi400KYJsn6URAEVgKUTIpHyogNKSSH3YElxIHj1YQL/UgMBECMAwLSQxA4Fth4R8JLPQidMgpCWRAKssDuYkC1YsENNkgCtWEmI8x09UF/HAgVBYCdylkkQIAl4kGu90gC0sJBf8gBssEmSayorEAsbuyh10KtzUArmFSz3eavUUJHKcgTDgKsr8ANmyiqIMAulG6uoYA6fqSwoIAAsTKsrkA2QsHwWMA+xR6ssAA60uygPoAEYHKu3UAHe0Y5gILaxmgSvkAvUZwIcI6st0A1CwI7KNzCyOgKUYAVt1xwqDAAGPQyrJJAJBQDAuqkBTzCrX1t9KGAE/aPG1IcI07Chs+oAlXsrM8AOEiyr46AsdUC3uhoOrJIAEgC0vOoB7rkm5CAJYfyr/PglESANVDas7GAl5PAJoiysQxC86nEA89AJy/rCHbIAYwAPhqusCocgfjAKntusx/UfuHAJUSmtC9kKUkBo1GpxTgANBJOtpiA38vrO8BzP8jzP9FzP9nzP+JzP+rzP/NzP/vzPAB3QAj3QBF3QBn3QCJ3QCr3QDN3QDv3QEB3REj3RFF3RFn3RQBoQACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevBV94YA0Lkte3bdmVQm+aqh7/f/kzgHk4cLQQ2kpoxA878d6Ti0KNv7UADnZUdzbMD9yG9u/emDjo1/yKDQrt54Ia+q18fVM4iQqvOyweejb39+zQ/vKFTaL5/4KzgJ+CAKOWxyBIn/Kfgb7kQ6OCDHPEgwCQLVvhbChBAqOGGD9FQRn8WhujPHRyWaOJANMBihogs+hPPiTA+yIMUtrRo4yUx5mgfNo3MYOOP/lih45DStQBPJQwACaQtRDaJGxbNlKfklDI4aaVqSaTixJRLEiLOMKZcKWZpN4BhAZcsNrGEAN9cMOabo40ACABohuhELSKQCOeeobExj5R1/jeDBMIkweehn0GATCWB/tfKF8m4ieiknFHABZ2NnufILpLYQemnnTXgW6bZMQLKDRiAqmpnjZD6Wwbb/P+gyqq0diYDoGieQIwIJNTqa2d05EqIHi38aixndiwApAXEEHvss5wBYeMA9vQK7bWa9SJiDgLMge23mzmzIArNUAHuuZoJ818us4SB7ruYQdCKpl/8Ae+9mGWj3Qz2uIvvv5V1gd1vDyyjCcAIWwaNP6vYgE3CEFMWSjbFRmzxxRhnrPHGHHfs8ccghyzyyCSXbPLJKKes8sost+zyyzDHLPPMNNds880455xVIpLq7LNRDlQTBQs/Fz2UOL8xgEkHRjfNEw0PMFcMH05XbZMPuGSHxxtWdx2TPOdJwbTXZKfky3xBXFH22iTJ4Yh/UWDB9twedVCMghkAQvfeGV3/YqEyH/AtuESGKGuhHw8PrvhCMtQoIgzpLS65QcrYaEEmk2cuEBs+2siJA5pPzsE8Py7hb+iLKxBfi+RQjfriqlDYIiKivL44BUbYOAEyti+uB64WLmBP74qzgSmLmBA/eBhr2KgB6MrzTUCSLKbhQfR8I3NAi85UiT3dceTQ4gxqfz83CYyyWIi35rPdwRctFoFE+3N/YniIKvBAP9vIAL8gHjjY39p0MKoQHSCAAiQbHxjBogMmkGwrCEIDn/FArzUgACyaANEqaDUHBINFjkAgB6smgAaKcIRNI0ID+4DCqvkiavhjQwudhoYXiKgIT5hh01gwAREVIg86NBoL/94WIkbEIIhFw8H2QuSJ6yHRZ0oUERka8EQoLtFC4KiiFUVkAy3qLIoh0psXcXaDHgYvGWPEGQ9DNIFepPFmaDiThUDgqTfWrB33W5ATTmdHmZ0iRNboo82MsaAX0EKQNyvFf/BgLkTeDGzycYIcHImzBmziPJVYASVzNoINaIcVqdpkzhLhuN8sIBai/FkWlpiCe6SyaFDIQA9Q8UqjCSNMtcylLnfJy1768pfADKYwh0nMYhrzmMhMpjKXycxmOvOZ0IymNKdJzWpa85rYzKY2t8nNbnrzm+AMpzjHSc5ymvOc6EynOtfJzna6853wjKc850nPetrznvjMpz73yf/PfvrznwANqEAHStCCGvSgCE2oQhfK0IY69KEQjahEJ0rRilr0ohjNqEY3ytGOevSjIA2pSEdK0pKa9KQoTalKV8rSlrr0pTCNqUzFpIZoBG6mqNGWPw6gATFkCKek+SBzemADewEVNA4AgXkY0QjXdQwICYiqVKdK1apKFZWIpMZ8GBCEU2hyYwUAEgEcqQYFvSByGQvrj8YqSAc0QUEpqFhaxYpIWSwIDBxTq43Y2sctLOgQeaVrHyGg1P/sgIpgFawdDbEgNXRMry3i6xthsaASPFaxb8yaYUOZ2LX2kQ0LGofHIMsiyY6xVQqCw2gxO0Zx/WcCNw2sZ984hDz/ymcXHyOtiEyrRVosSAS5Za0WK/efBQwhuLMdI2EVVAyQ6TZEvH1iJxZkDOcK94nTWBAvrJtcL25DQT0I2XMtFN0gesCG/2mGeK8bRK0qCI3c3WsabaCgBXgPufIdox8UJAiRjbdC5Z3hCGx7nuStt7tPRMaCNhjfyI6Rvv+JAAf8y94ZHkNBQRjZfxcUYBRyQI7+qYCGK4xCRSzoBiNGcBDfYdYJU1jFOkwDc0m2YQV1eISF9Q8oaExiDqpiQWjgMYxb2I4FHTfF+X3iHhSUg5LV+D83rqBr/SMPJ/f4gQ5IgYLqI+QkBxG0CjKAlYc8QnjgjQJj9rIOKfsfb5js/8n+iXICtaGgWrz5ygnEg4IWcWcyVzAPC3Jjmh2MxBIoiAFd6LOaW0gKBQHgZHCej5z31wwFAQHSeN7fOhQkYkUTOohKeC+m/ZxAQCsoDqNe9AhZoCALjG3QpUWiCv/DBJRFWj6Tbt+S/7MGW2e6fVZQkDp8TWoBLuc/wE31p1sIAfT6B62w3m0Q+bCgUBBb1RU08X9SkLJbnyfX3zPzf7zQ7V9/jwAKIka5i00/biiIDuvG9gProKBzxHvZKGSCqK+N7xFecT4njDZ0ddiFBeFS2bGeoQe6gQ5OgGEAADBjcxYAPYRLe4w+iAMLGO5w3N474Ud1jLfNA+6Q/2Xk2v8pucn7gvLsqHzle2l5c14O87zInDk0r/ldbg6cnOu8Ljz/jc9/Ppeg+2PoRI+L0ZGe9LcsvemGeTrUCSP1qQum6lYHDNaz7petc50vXv+6XsIudryQvex2OTva6aL2tcul7W6HC9zj7pa5050tdr+7WvKud7Twve9m+TvgySL4wYul8IYHC+IT75XFM54rjn+8ViIveaxQvvJWuTzmqaL5zUul856HCuhD75TRk54ppj+9UlKveqSwvvVGeX3ZO4CA2tv+9rjPve53z/ve+/73wEcAvdkd+kMc4PjIT77yl8/85jv/+dCPvvQPkAFzY14Brsq+9uMMe4Rgf/vgD7//0Lt/kO+L//yuYnrfzY/+9tdJ/Xpnv/vnb/3Ky5/++BfRjslfkPvn//8KEgGAkA/8NxD+B4AIKB8L8AWxRX4HmIAQqB11oA8F+IAReIHA4QRZAC27AAacgA7dwAJxwB02Y4EYiIEwYFnG4gAE5g8TAAAD4IEg6EQtY4IneIEZ8AkVRyumsCCJ5jI2eIMRuICIRSs4oCAHADNBKIQRKAQ9oyrJoCC19jJLyIQQeAQbuCrnoCB1oIRW+IXNAQNisCrB8h/c4IVgmIb+EAFcoCrEoCDigIZqCIYMwAlFiCheoCDwIIdzCIZCcGSIomX/oQh82Idf6AU1gCihsCBOVYOG/ziHIQAFh8JY//ECPwWEjziHEVAFlzgmIqAgzBAzVZiJCPgAe7CDV6IOCiIkhUiKX7gET2glzfMfexAzMmAAuJiLuriLvNiLvviLwBiMwjiMv0gEEbB9XuACY6Jv/1EbzqQJBeQqKnAGV9IBIDYfDNZM9OBJ2jcBkmAlcbAgQARNJDCL2bcAj3CHORKF/6EE04QBZQBDrsIAaXBEQ1IBCrIO1TQLx6h9kKCMOiIt6WVNihCNpAIDKJYjxzMfpHBNLsCN2ZcCmAMjXUA9/qGC1uQDrmCRpLIANqCOGqJT/3Fw1tQAZdCCgbIG1sIhi6AgeMBN/SBxrrIBk8QhtaAg2v/QTSwQBduHCFPAId6gILDgTXHQORHpBhpCAdX3H3voTSsQbNrnkWjmIAawIDL0TQ1AByiJJgxgAl81IPqybajYTYuQINq3AfRAIJDkH85ATlAQAtsXAo2EH+JDi+WEBEbpKiiAlPcxBAvSDuYkAwXAkZmSAVIwleuBBgsyK+bEAYq0fUAwAuwBCgoCAupUBYKYfZNQR99xN/+RBusEBTnmKlowl9LBAc42H+/ATneQl6QyAZTgHTewIITITjGwBNuXAZjAWcWBj/9hAS7GTrhDmJkSmdEhQf9xDPDkAERgltnnB5yJGxzQj/7RRfFUAqNJKkUgN8PBagrCO/KEBMz/mH1KkGy3gQn1JZnzlARjsH0PcAm82Rqb9h9+YE/DuX2EwEerIQNb2RzWWU8OAAjO6SqCYAmuwY7/QQ35VAJvpX1awJ2rUWmVSIP3xAbj6SogkAisYZDnsQ38dAGX5CoL0IarwQsLEof8xAFG0J8/UousQUgK0gn+5ACvQJ1oIgQNmBqe6R8g0In89AYqUCeMsJKqMQTEaR5VFlA1UJdKAgLz0xqfqCCHJFBt0J5AEgFj6Bq7UF+AGFAesAUsOh8P4Iyt8QEyKR9tWVAQMAo2aiES4KOqAQcL0ggItQ8DYyFWgJitQVz/cZUHxQ9MqiBHYI+ugQF3Oh+4sFAXMAgL/xICAPkahiaUDIUArBCmKZCNrlFWCgJtCpUKqZkdD3AKuNEAhyofPfpQaNCg2mEDcMoah7AgWxBRfRCowJEGINkaYLAgsiBRV5A+wLEB92UbLZCZ87EDY9lQH6AG1AMDj3obhvCp5+FYFUUKL4ACP1kcK3AKA3CkzKGgFgUH5hkdfNAIDKQdIHCsBagWf2ADBhkM6ToXECAGGrBEgvauc/EB0SCt9rqv/Nqv/vqvABuwAjuwBFuwBnuwCJuwCruwDNuwDvuwEBuxEjuxFFuxFnuxGJuxGruxHNuxHvuxIBuyIjuyJFuyJnuyKJuyKruyLNuyLvuyMBuzMjuzNFuzNv97szibszq7szzbsz77s0AbtEI7tERbtEZ7tEibtEq7tEzbtE77tFAbtVKrTKYgDFPLEajQAxkgiVeLEfcgiAeQhV1LEbGQR7agoWMbERjACtqxAeqZtg2xAr6aHZtwq3BbEHKwJfKRpHeLEFSgZ/5RCn17ELQAredRXYM7ENYQIqKauGGgtxWyAICZuHaQnb8ZZInbC2f6WpgKt8kQptkxAQk5uIAgIg6UuBBmIac7uOBgugGXtg1ABq6buB7gCbM7uDFQrhbiCJ07tnkAIhaiQYn7BEUgIi+AuX3LBkEaIg/gC4nLC/9WIWR6t2AUIgKQuDhARCESDOg6tWskIgH/YLdT+wzRuyBB8JVwW70WwgiNmLbqWyE9oAODiwOqaiEoAJ53ywPLGyIL8AmDWwPFyyJf8GppawfAGyKVQKRjewWuWSE5gGp3KwNTZkD4m7YeIGMswgDw97MOoAE2sgb62bXo2SIA4Kdpaw+gax4ooAd9iwybWyFGoKddKwqIYCOTwJhpywfkYCOroAB3Gwa4aSPzEJxd6wCc8CMzYMJdmwnXGCLK0LeGAAMsYgvBmrbYsF/Bw6lw+wF8qiA4krgDAQhL6R/FQMBgjAU8OR+OUJNgTBBXgJzn4bxtbBAdIAXnwbdzbBBvALjMgQskmMcHwQc76g8PQAOArBAdgAnU/4Oih6wQO1kN3dvIA3EBaCvJlnzJmJzJmrzJnNzJnvzJoBzKojzKzNQC2WBtnYwNNhAf0MDJmrAM8rgDP2jJYWAPDewPXNbIf/AF2psdrdCqfRsGs5AL/2G1bUwFUbIgadq3cyAAtKog9dq1JGAPA2Ajl3a1LaAHxNDEIrIA0dm02UwIAwok8Na0JCACxDDOU4ICVVy0qvAD2zDGmUKnRYsBNwAKuqt9PSC+OWsHkrALvbx9AMAFMpyzF5AMXzAv6FcJyADMNHsBwiABedh+KDAPSmyzdyACtQC57QcAgPC2NXsB3yAAS1C/7WcBYDC6M2sKwyAOhFBK+OcEqWAoNs4rAwlILqZ5szDtfgxQCfAgVzoLle43A42QOD7rN+hnC1KgP0IbD+JnBrBgyEV7B9tXCGUg1UcLAcRaJ5MgAEy9tMScK0uwCOPotGyrJIVAB2+Qo04bliyyCoSwCGx8tZRYIShABo3QCZEMtT6gIDtgBehAA2bct5FwHszQDJLABg7dtyYwVK4wDdTQzodMBEBgDG9QPqSc2Zq92Zzd2Z792aAd2qI92qRd2qZ92qid2qq92qzd2q792rAd27I927Rd27Z927id27q92yATEAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza96ckYMPzqBDi2aYJAs1eOhAcbNyzEmICP60jZ5N27IHNsg+gUqny1YGf8CDCw++rrbx44Y99Pk1bZyzEMOjSxfuBLn163c/dBJho0AkBtPDi//3FwW7+fNpL5QwFoDZgvHwxytBT7/+1hVnxO0yE79/f/sABuhUDfZowAx4/iUY3woCNujgTx3QUI8VOyhooX98PKjhhjI5gEMjZKBw4Yj+ZcHhiSiapEoVu6xC4ov+9ZLijDRm9AEyRuAC447+UVPjj0A2hA0XQpzA45H9JRPkkkz+g0oFkCApZX9uNGklihDQAEskU3YZ3w9XhvlgElF4aSZ8jYippoBOnDnlCYUUAwQwAnARjRg62CHDmnwCaI2bI0bhjDyX2PMGDyP0qSiHPAAKXwgD1BLLPWxwsOilNLbpaHCrBEHHIoqQgOmoQP7pphlrCIAMNqS2umSjU+7/QEYFb1zg6q1NagqjE2qwcweuwFpp6oUbSACHrcEm2ySs/uXwRTLIKittrvAlsMwpdkyr7ZXDRucFKDd0sO24VjILXAaVADIHuexe2eYJhNDCYLv0NvmLMC3Uq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXbPPNOOes88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VhnrfXWXHft9VLZfo21LC+II7bVvBwAnBEOnC11HkUIt4ylbjs9wgzRDZJo3Us3/zDIdOtEy/fR4IjHRB6DHw0KfLY8kTjRXPRXRA2PBw3He/2pwEPlPvcygYI74MD5zk+ocOEBoo+O8xDHjIi66jh7UIDrqcNeswNq0G77zZi4vvnuNacyoubA1zwL5gqq4ELxNP9iwYVFZMi8zGg8b2EhSUwvsyyfWzjD3tq/zEL3ChbjQfgwa6K2hQWIi77LOKyvoAbvvxz/hVLU7/IN5CeYjf4tG5+FFnAPALLsDdZL0AQMYMCVXc5CIAhbA1FGiQsxAXwTNFk2LlSHtmXwZAK40Bc+iLJgXOh/JCyZAwJgoQewIIUl85uFmiAHGJJsBOSw0BHCYMORwc1ChOjhyP/6ID//pEmIIaPGAxS0ACggMWRVmOG6nvixUlhIEA2goscckAYLGUGLHvMBEyykBzB27AkVShAKfmXGjYkBef3ZAN3amLEfeJGOG5OGhcKBx4x1wQsKWgWr+ngxObgoQQPwICErdggLHXGRFZOCgjLQCUhWzAEDUBAAzmfJiV0BBgoKRicpdgYE+UcMo5yYJBOkhXml8mEdaF2C6PdKiM2hiPEZRi0h1g0F9cCVu2SYPBRUi2A6zAeB8M8D8mfMhinClOLZQCWb6bBHjKdsGKDmwzhwhPB4gnLahJgOfjOcFPwAAuGUGD6GUwkJphNiFOimPxKQiXdWrBMPMEEi7Gn/MRPx858ADahAB0rQghr0oAhNqEIXytCGOvShEI2oRCdK0Ypa9KIYhZgpPpDRfZFBC4vIYkfZRYPgmOEU7huptsgwnEKIIKUqDVZJpZMDPaAzpsASguHKiFNX6SA+kIBDT0nFwv5MggJDXdQdoDkeMCR1Uc3wDwPA+dQ1JSKB8HFqVflUBqlSdathCkMC/KNVsIpJeP7RgVnF1AH+9GcJaxXTLxL0jLiGyRn+0YVdr3SNBB1ir1ZShn+ccFPABikJL/DPLAzLpHf4BwRIZSyQHGAL/+BDskG6h38s0AbMAmkJ/nGHZ39kCaaKRxSjrVE5/OOJ1NLIAVrwDzxcOyNk//hHBZGl7YkI4R9m6pZDQ8DqeFTx2xO9wj+yKS6HvOGfeCh3Q1l4rEif66BVxocT1H0QBNwaH15k10Ga8I83vusgVvjnE+QVEAbSCJ8MxOBiQEiAfOdL3/rad76xqF8J/EMMjM0ORgSoX+76Ew3/7ijA6KMALsPjCI5e7L8vQnD4huEfWj74wO8bcHxKkDEIk0jC03OA6eKzg2waGMDom4J/itlhDIfPhP2RhcY8PCIQM6+y8WmCIi+MYu31wT/N2BiNL2Rj4E3DP3+dsYun54n+oCC3J46w9pJg2ukEgGNDtlCRbQcP/1ACy0sunh7js4D3CjnMu4MAHvozgI5lWf9BW1YdDvyTXzD3uHgEKJGb0Wy7TMZHCx57c4LizDkPCDc83Ag0n1X3Bv8oQNF33p01yQxMJUfadn7oTy4+Jmj/EPpxI4CjeC7B6UVzzrb9mUKpL606645nAlA+M6tH1+T4bANkne7Ppwf3gUNPpwK4NvXjDOGfGwR71pVrRH8iMMc9I/txVuiPM0KW6/jsmm8jhg8oqC3swdnBP2jg9rMHpwf/CM7ZUrYdLPoDAJFVGz7Xdlsp2CsecLi724mTwy/KMIgFA+cV9x636m7RDU4MQAnBoUHA010/CNQAHnuINbo/nF7svHs88a74Zi4unoxrPDMcD4/HP36ZkE9n5CT/r4zJpYPylE9m5dFpucsjA/PhyHzmj6m5cG6O88boPDg87/lifg6coAs9MUT3h9GPfpikL53phXE61Dkj9alrpupWxwzWs26ZrXOdMl7/umTCLnbIkL3sjjk72hmj9rUrpu1uRwzc426YudOdMHa/u2DyrnfA8L3vfvk74Pki+MHrpfCGxwviE2+XxTOeLo5/vFwiL3m4UL7ybrk85tmi+c2rpfOeRwvoQ2+W0ZOeLKY/vVhSr3qwsL71Xnk97Lki+9lrpfa2xwruc2+V3fOeKr7/vVSCL3yoEL/4Tjk+8pmi/OUrpfnORwr0o2+U6VOfKNa/vlCyr32gcL/7Pvk+//h5Iv7x66T85scJ+tNvk/Wznybuf79M4i9/mNC//i65P/5Zon+xdwABABiAAjiABFiABniACJiACriACFAH+MZ+h3AAEjiBFFiBFniBGJiBGriBHNiBB0BODLd/A6EAm1KCJgh0IlgQJHiCLAgoTyd8K9iCMtglL/h7MTiDOMgjNch7N5iDPlhjKUgQPfiDROgf2xaEAjGERbiE4hEBgJAPSKiETDiF0bEAX+BgIiiFVLiFwVEH+pCCWsiFXOgE/oR/YSiGWwgDHGaGaNiG0ZEBn7Bj6XeGbjiFVjhdc1iHehgcQnBu4EeHe8iER1CG4weIgbiEMIBK5meIh1iEEf/ABYvYiIHIAJyAh9THiJJYhEIwBN2HiZlIhF7wVc7niZ/4gyHgRJdYiocYAVVQWMhHiqrogw+wB3Jog7HYiEvgh7knAwbQi774i8AYjMI4jMRYjMZ4jMhIjEQAG47iBcuDhFChCT2wKSpwBtAIFfSwAZsyAZJwjU9BAmuwKQvwCJbojUiBAWWwRIDCAGlgZua4FLPAjIACCc/4jkqhCNPoKDBgbPaoFC6gjY6SAvXUj0nhA65QZVOyADZQjgQpFA1QBqJmJmsgKg15FP3QP2eyATVUkUbBAmXiKIigahxZFHGANwFZJWFCAXsADzXgigi1AtHmKAopcUAyU/6gBAP/wAndcAsJ1QB0EJFdwgAmUGlAclzScQCDUAa/sJEEtQhG4igbQA9NUjjwsQOlUFBQAB2OEgJUwCQA0B+wYFBIYJKAggIo+SMX4B88VVAyUAAIKSUZIAU0ySFo4B/uRFAcYEWbAgQYhCKLEx8qsFBVkAKbMgl3ySF4FR9WwFBQAAKbogVdiSIcII/j8UgKdQdk6SYT8GUncgP+YQgOFQOg5SgZgAkmpiEV0B8WgIUMRQFG8JZSwpcbsg390VoQ5QBE8JSA4geHaR8UgJHh4VsQVQKO6ShFgAUOomL9gQwUhQRj5ChKIAINcgn9sQB9CVFJMAab8gCXcJr1kQv94QcX/+WasIkkhMBD9RFq/fEIGOUAgKCbbiIIllAfjPgGHVUCTfCYyIke3KCanJRRbPCcgAIC+3QesRUfbaZSF7AJgLIAkHge0aVrOMUBRgCUR7IH9BEL/lE7KuUAr0CZSCIErIkdfgYfeOCSKvUG2XYkjECR5xEDFhod0lBVNZADSAICSFAfFdQfs1VVbaCdOxIBikgfRQUfDJA9W+UBWxCj8fEAROCbCBcftglWEDAKIJogEoCi2NFI/TENdrUP9OYfVjCX16Fh8NEHe8UPNpogR+CO9OEA+RkftmBYF/A3/REC9VgfsuAfomRYCMAKTAocKfBCAVIL/iGSjJUKiRUeD/9wCuoVpuGhArW4V2gQp9JhA1p6HvvVH2qQWn2wpsORBgyJHhrgH7qUWldQCcOxAXsiIB/gCP1xAGQKWB+gBggCA3kKINEAZMVFCi+AAogqIMTgH2v4W3AgnQ4SAyA4HiU2klvxCf7BCs66FczVH5owrVnBC/5hBpmKrVDBCb3lrVfRAMUZH4QorlIRD+KFrlahDf4BcOw6FXKwWZwYr1LhauMRRPYaFRSwouPBnPsKFV3WH1owqQGbFLUWH+VwsE8hClI1nwzbFO7gH3AVsUzRBr42HQVksUuxTv1hCwbLsUJBAeUKH+8gskoxC/7xAkiKskYBAboCH8rgskjBpf3/cQ00exS64B/TlrNF8QwJ8gs+WxQcZwYwNbQ/8VP+kQpIOxRg4B8JgJ5N+xM1UJ7CUQZTGxRPq5oFmrU9UbW86rU+sbXxwQBsJLY7QQGT4B9XhrY+AQdRAh9q5bY/oQcCKh1CQLdBAQF6AKrDoXB6GxQdIAKFMBxkELhE0QGnwF2Ai7hD0QCLoAWH67hG8QGmQLmYm7mau7mc27me+7mgG7qiO7qkW7qme7qom7o3ca6q2xKJYAIPME2t2xKZMFb+cASzOrshYQeqKhyXpbsnAQE/QJjDkQFzC7wjUQMJGx1H0GzI2xEYIA6LGh7s+bwe0QkAOR4MoAjWyxFSoI7x/xEIn9G9GWGoCSIP5JsRK5CP/tEN6YsRFJYgBzBF71sRpZogx3C09QsRK3Cg4bq/FCEGCsIA1gjAEwFj/gEDV2DAEuEBX4lIIcvACNEJyxofwinBDaFsCpJkGNwQmBRITNnBC4ENh+QfXtAFItwQ4WAhM5rCDGEEFgImLqwQHJC91TmkM3wQdyAiCbIDjpPDCFFuCsIE4wvEBgHDCpIGEezCDSAIFnKVRmwQc2Cp/lEFUWwQUBCo0fEAPnLFBKHB8oumXjwQvKUgRYA4Y/wPYSBPCUIO12nEckDF/TEIo5rDLAC+bLvEKbxBFtKnafwFFyIAafwPDuCAFoJCYzwCd//rZYNsByVbnUKVxgYAnPBhAfaZxvegxdExAYQ6xnysIBPAj2OMr7HKoVd8vwryOmPcATB3ANc6xh5QDBfCyWl8N7MsY2OcBIVrIRYQbmPMB3HDy0I7xi7gr9W5WGPMA8bcH0ybzP4WH5iQxvdzIWqgxxg8zezzn1GMzQpyDPV6xdx8Wz/sxTgAqa8mI4OszP6xAJE8yP9QA8EMHw/qzgLxBDgmHkdIzwORB4s8HC2szwRxAeswHXQM0AYxAnYqHN9j0AfBAcsgHGfM0AjhAEh8AN4l0QkhvbiM0QnRmxz90SAd0iI90iRd0iZ90iid0iq90izd0i790jAd0zI90zT/XdM2fdM4ndM6vdM83dM+/dNAHdRCPdREXdRGfdQu2wLCMMwivQK0QAhGUh0gPQeAUAkV/DsG3QE3AAqANB3WANB2cArLYLviIdVjfAHJ8AV+Gx9YncMXAAcSYMMK8tUufAfswA0xSyJmbcAX8AYVQAbmDCNt3b3YgAwCsB+AQtfASwKKsAh0EAQlvCl7XbocwAb3EAu1MABaiYODvbkjwANvYA+XIA/O8JFMqNhuKwN2oANiEA1cIADAAATFUAjwiYaTnbVgHItR0LJea0eqGAmwQAPdOrRu8ImQUAGo4LjJcIgnIARcMEiUSw16iAtGgAwjSrm9gIarsAtVQFyfsxuhTIgCZNAIOGDNjssHRbgDVlAPNKC/obsCOMgAzKAB9iCKqMuCZrAL03AGRNm6UWomC8AMAWAMJaCLyGvaPMIAkVAANiACnXDd75vXChICzjAO0/ALfaDNHTzQ7WULupAOoPAJyMAGGg7E7hoBIeAEx2AF3AAK6AAP1JAFvK3PPuC8SH3jOJ7jOr7jPN7jPv7jQB7kQj7kRF7kRn7kSJ7kSr7kTN7kTv7kUB7lUj7lNBMQACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3pyxQ4w5fXDcuKdHhIhXP2JVWM26AoEfsCWJiAaHmqE/dpJ44My79+IYNc74SqWO1RpdjHqg8Me8ufPn0KNDtwDDybElpnxr3z73AxtkVaRI/6sW6IX08+jTq/fXhrv792M/9IlHwJ2uKOvz69/PvAP8/wBS5YEoIjxCRiAM8KfggumtEuCDEB51xRvGAJFDggxmqGF0OUTo4Yc5kUCNOMSEsOGJKD7nCYgstvjSHinGKKM/Bbho440m/TDjjhuOg+OPQHbUC49ELvhIkEgmSREF5hXp5HrGKCnllAzl8uSV6NlD5ZZcDiQBlmBCl0yXZE6pR5hoMqdJmWwiOUeaaLLR5pw/mginPykgEskGxwxiggngaNCMBIQWKgEwGiS6iwmDBOENAD0cAN0VdFbqogk8RhDJMYTMY80n7ZwhyhNDYPBRGHzowIIwplrqqoeNbP8YhS7yqLPINzyQ8OquvD50w34gDMDNOWhksVuvyCbbUBcLnIdHEHQsgsUKylZrbUMbOIfLLgQgk9214Iab0CUFCPDGEOKmq+667Lbr7rvwxivvvPTWa++9+Oar77789uvvvwAHLPDABBds8MEIJ6zwwgw37PDDEEcs8cQUV2zxxRhnrPHGHHfs8ccghyzyyCSXbPLJKKes8sost+zyyzDHLPPMNNds880456zzzjz37PPPQAct9NBEF2300UgnrfTSTDft9NNQRy311FRXbfXVWGet9dZcd+3112CHLfbYZJdt9tlop6322my37fbbcMct99x012333XjnrffefPf/7fffgAcu+OCEF2744YgnrjhRfWzhwOIlKyLpF5CPfM8EzQlQOchuNOucG5t3jE50C5QQusawnKfEH6db3IEG6fXwbesRe5DGehuEQTvEI+iiXwGP786wKTPwB4vwDF+yYCbIK+yAFQpaoEjzCXtQjIIqzEE9wjEwo+AGx25f8Bx27ieN+Ad3gjl/56BvMBye67cAC+4XDIiCIMxef8BfKFhMq/sDWAe0oSAJBFBgJMiBguJxwIDFIQH8OYAqGgiwN8QvP5OgAAX/ZYwCbvBfy1AQHD7YrxYcgT9N0B8J8XULR/BHGxBY4b6EoSB0yHBfqduPBVBxw3x1oBr8ccIH/3qIrzzggT97+FEfnkDEl7xBQfSzEQecgIJFNNElj+CPGXxgIxs0hwwqvKJJMHAM/mjARYa44A7aIUaVyMGF+xkGizygQOgEIAZtRAkt+KMFLn6IE+eJghzzaBJp8KcWHzLABaPDihYQkiQjCAR/zhAhDJxQPbgwxCNHcgMM5ScS4QOQAORXBg1uEiSA3I8NHlSDJn1Sd6f8CAeYsJ8H8BBAA+DPFGIZkk5kYD+TCN572MEfYPBSJPjgzyjgM4Qj6icHjjwmSChwyfw4IhHvgd1+pifNXj5gP2BwDxb4s4VujkQd/IHCdhwAif0UwY/mBAkHALAfJzRAO1zgzyHiyf9J/tTDN0NYBTj5SRI17EcJoegNK/aTAEoRVCQkgMF+fMSZP3hyPUR4KEm6wR8acCYI+/FEDDU6kkHsRxCbUUAtWUfSkcTBAvvpRmYagIv90KGlJUGnfmwxxMucYz8wGAFOSeIBW+ynEZdZwQ72w46hliQe+3FEEizjRf0cw6kmAal+glEZS0RAPwzoBFZLwotv5scCcqCMMvZzxrGWpH/6Acdk2HDR9KAAm24lyRAgmB8GsBQymNLPNPJqklTsRwiRMcB+zNBTwo6EApHYj0cfs4n9wMOxJoGqfoLwmF/phxwjxSxJrKSfGzhGq/mhhmhNMoX9DKAxns1PJVZ7EiH/7Eedi0HtekRBW5NYdLOLie16dtHbk6RjP6ZNDAH7WoPimuQJZl3PbBFDg4k69yTazM8tDRPY9TyAidctiSpgqh5nvAExbGBreE+yhfSQIbmIAYd+vrtek/CBvM9hwC7EqhhLRFc9ba1vSbjxnAe4o7mMKcV8wStgkkCXORHYgh0cs4Ll5McdDcYuCh6R0MfEirkZNkkb0AWZBvRAP2sIcZL2qJ9rqBhJgtDPdF/8o+rqx3Q0/tFx8zODHP8oEb/Mjwh8jKNR5qcH9ySyizpQBP1ESckugoN+InABKLtoDPpphpVbpIr99GHLLIKGfl4L5g85AD/50UOZP3QI/YAg/8lrhlB31YOJOEeoDUFWDwMsYWcI6Sg/iO3zg9qZH2EIOkA8cDOcD/2eqq7neIyGDwTQvB4kRBo+wk0PSi/9nvbmhwucdg8GlroeC5BYYkBIgKpXzepWu3rVsaDbMPRjgooV4EQEoNtaC21rXM8NA3xVzwE40OsN5VpuJdAPRSl2a2PPzaD5wTGzfR03B5BaPSDwT7E1dGy4QQALj2iFesppsWZz2268EAA5zkPJclP7bnI4hy4uugMATtvZe2uDPchgHjVgzNwZ6jbfRtCN7W474KHWDMAZJPCEV2bhC2q4wycDcQVJfOKRqTh/Lo7xx2h8PxzveGM+rp+Qi3wxJP/Pj8lPnpiUr2flLD+My9UD85gXZubpqbnNB4Nz9Oh854Hp+Xl+DvS/CF06RC96X44enaQrfS9Mh47Tn56XqD9n6lS/i9Wdg/Ws12Xrzem61+cCduaIfexxKbs/zo72t6id7W1vy9vjTpi5010wdr87YPKud7/wve98+Tvg9SL4weOl8Ia3C+ITT5fFM14ujn88XCIvebdQvvJsuTzm1aL5zaOl8543C+hDT5bRk14spj89WFKveq+wvvVceT3stSL72WOl9ra3Cu5zT5Xd814qvv89VIIvfKcQv/hMOT7ylaL85SOl+c43CvSjT5TpU18o1r8+ULKvfZ9wv/s8+T7/+HUi/vHjpPzmtwn600+T9bNfJu5/P0ziL3+X0L/+LLk//lWi//2jpP/+ZxIAGIAkMYAEKBIGeIAgkYAK6BEM2IAc8YAQqBESOIEYUYEWaBEYmIEUsYEcKBEe+IEQEYIi6BAkWIIMcYIoqBAquIII0YIuaBAwGIMEMYM0KBA2eIM5SIM7GIM96II/uIJBiIJDWIJFKIJH+IFJyIFLCGUdgABQGIVSOIVUWIVWeIVYmIVauIUIUAfv1n2HcABiOIZkWIZmeIZomIZquIZs2IYHkGcIN34qdSd0OCNwt3lzWId6+IXal4d7+IcRZ35+CIiEqHKCWIiIaIhymIiMiB6g/3CIjRiJzxEBgJAP4DeIkhiJC/AFjUV9mJiJkVgH+tCHoFiKzOEEWXB9n2iKjAgD0rZ8q8iKiZgBnyBMxReLsoiIm7hov4eLuYiIQlBlt/iLrHgEqSh8vkiMhQgDYoCMysiKEQBqvJeMz0iIDMAJvKh61FiNhCgEp9Z628iNgOgFCAaO4iiLIYBb2niOshgBVRBaoReO7PiHD7AHtoiH85iLSyCMnicDBvCPABmQAjmQBFmQBnmQCJmQCmmQRPBVV+IFLnCDNKEJJ3YlKtBuEhkT9JAtVzIBkpCRMkECa4AlC/AI2QiSKoEBZfBfRMIAaYBHKPkSs+CQTwIJERmTLv+hCBX5JDAAXzi5Ei7AkU+SAszzkyzhA65QVzyyADZwkkZJEg1QBotEJGugK0+pEv2wPk+yAWl1lSnBApTmJIiwS16JEnFQPFeSAqBTliexAtBzJUxpSmwJlXQwlTvCACZALXNZEotwAliyAfSwlyUBBeXjJCFABYJJEkiAlk+CAmuZmCEhAwWglDuSAVIgl5DpERygYFgCBEKVmSBRBSmAJZMwYaD5EVAAAliiBYh5mh5xB4zpJBNACa7pETGwBFiSAZhgb7WJERRgBJS5I57ZmxvhAETgl1fiB6ZJnBlRAqp5JUWABcypEUhAS1eiBEM2nRiRBFh2JQ9wCbypnRL/8ZvBOSOEAEviSREOAAjI+SSCwGfpWREl0ASrKZ3xSRFsYJ1PAgJ4dZ8ScQGV5SQLII3+OREcYAR2mSJJVKAV4QCvQJMyIgSdyKAT8QYqMCOMYJUUahE1UEcoAgKWtqEY0QbduSER0IwimhEesAUJmh8PkFEpqhEQMAoQyh8SAI8Rggrd8JkZtg/Xth9WgJkeYlAvQAb20B4Nxg8emh9HAJMgMmrOwQC6cA5duV4XYFL5EQI3ySJncB7kIAC8sF4IwAot2hwpEEUt4mno0QqPgAU4ulqp4ErR8QCnYCMd8JzqsQP3SFtoQJ/SYQNv6iHJlh/+tl59sKTNkQZOGSHj/3BjAnYFlfAcGyADN8IBkrIeCRCezvUBaoAhMLClLkJD+aEMKkYKL4ACZHkjc5YegxRicJCdNzIE+JUe9RajIpFP+UFutgoSMZYfPrmrHIEE+hEFgQqsGJFD67FKxtoRDYCn6sEDy9oRoroekBCtHWFb+fED1roRllCez5EBSLqtGIEJtCauGdGs+rFP5noRZ5IfUbCn6xoRuZQf0BCvFtEH+zFB9koRzaAfY7CvFHEBNYoeIwSwEtFB+VEE2mawD2Fi+qE5DAsRIqAfGdCfEdsQsZke6XCxDzGo+TFZHMsQkZofmxayC3EN+0ELJssQI3lki4oYQxCuO1cD3vocSP/1GKHwCCgQYDvnDvqBAnrJGHawBQ5JXzv3YPlRCo1RA+7AktwAdNmlHg8An4khCrtAmRbABzaHtOshV4lxA2SQHrp6clGrHnJyGG/gDKWmryLHtepRa4eBCup1co2qHyBrGCPrXQw2cTSrH9qgGJmmsSK3C8iVW2D1VwknCvvBWYsBBYeFcXm7Hr+KGPOaH6nKadSwuI4RuOiRCwkHAetWWo+hW+rBQJwGD/uxCZBhY58kpH32AWawHwYQGdiaH6lwadOwH3ALGb+VHwnwjXaWCBa2HgxwtpEhX/pBOYdWtulBqpMhB7OaHg8Qpn3WCTXrHCdAtZIRDJrbZ2WkH8r/ShlJAEf5YbprRkz6sQNBSxkflh+2EEpWNgISpR/tcxkfYFT6oQ5rRgf7UQgv+xgcpR8WEAdg9gcsmR4KsBm9mh+DsGUQ4Andqxmsmx8yBWVEsB9+xRt1mx8woKE5dgXBth6s0BuhoAT7Uag+Bgb7sQrAqxn1wB+Tm2Ftth8EyhsN4AT7AQDE9mI+0GT6AQnwqhmOux/6+2Jqmh/2uR0qPF/8lWGKYEbvkQjkux5H4LrX1QKImh540MK+MQr8gQ8ZBgz80VTw4QCTsB8ZwFv11VquFSCocMDowQQ7fF1hEFn68QLl+B+Olh+csF4UIJUPCyEeYMd9tSbrZQg1pR5H/6Cp79Gl+xEIPHrFC4UeCzC7HlIL/HE+AjYMYfkcffwhPqAF/KGyAhYDAcAh8AshsxZVVVpf7fCjC6BJLcK86XEMjFxcphC2zBG+LOIDsbsfRxJii4ACTjDHLcICCnJeIfYEX4YjMLIfeJAHK5sQHoDD+1ENCzvNBYEK0asekKbNBjE6/GFo4FwQELBc+uEIt1DOBWEKfqofRxBN7CwQUsYfyzDPBPEl/PFk+EwBZ7wfC6DM+KwKl6ofCUDA+PwPmrUfOeDB7KzP+1EJ2VzOGHA9/KG8+GwKzpofgJDQ/8ACZUo6BYvPP8UfE9DE82xI/BEC2oPPHiCU+sEMTsrOc/9wofxRDKmszYrQzephBUG8spmwIJfg0cjKY2EEzg7Qc7oQyfgcBjB9HmmQ0/NsCjspHRow0R79D39gwtLxzVldECVglzb01QjhBs+xAI9J1gdhZP4wAfeg1gvRPwfATXCdEA6wBc1c13q913zd137914Ad2II92IRd2IZ92Iid2Iq92Izd2I792JAd2ZI92ZRd2ZZ92Zid2Zq92Zzd2Z792aAd2qI92qRd2qZ92qid2qq92qzd2q792rAd27I927Rd27Z927id27q927zd277921QxBG8gAAUw1HxtCshAALuQyMyxAWq9AliwCHQQBM40p13Azh6QBWhwDtwwABv/nR4xbK8kwAPfsAjqIA/3sSE3a5QYIAwsoAOWgJ4c0QFD8ASicAbt8AnWMA/LcAyRMLAosrs/eQXQcQA9AADeEAR+sguJogHAYCiF0gwaAA5/MgjHsAGRgAijeSchcJXplY/P0dI/qQkg/hxqZpTJUOLOYUBGaQ8q3hyea5QI++IvYMUSWdQq3gtGucEvrq0/qXaZuKA4CcEgHgLEIA7U4NAomcW/yAA5AATG8AYOVZYClYsMEAhkYAMiIApSfZUdUIqzMg4E8At9MKGZ2QaF+AKBUA3SIAVVgAxsYObEaQpLcAxOAAM8HSMo0AOMoAtrwArqkAq+cAY1MNO76gFJVSAHf2AIJQAH0SACkgAbP0AArcEasfADgGAaegAHN4ADfTAHMYDVwD3qpF7qpn7qqJ7qqr7qrN7qrv7qsB7rsj7rtF7rtn7ruJ7rur7rvN7rvs4uAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2venNGBjDl9et04FE4Eux+oU1VYzVoAai4iRERDc8MArzlDOnDezXtxkixnaKEDVWtNNSaIUvhbzry58+fQn6MowsgZsVrqUtEqwetC7+/g6X7/yBC9vPnz6KO/CHQsQJlsyHj5CE+//tgE6fPr319eRTFlAvjSSQv2FWjgVEzwp+CCDJpRhwSS9BLGgRRWSFQdDGaoIX+trFFBONhYKOKINmmw4YkophdCAeWwQOKLMKaESYo01ghdADHmqCNIVdjoo43n7CjkkBfd8+ORKFJB5JJMOmQAklAy+EAXTVZpZUGhRKnlfhtc6aWVDjyw5ZjnsfLlmUz2QOaa0J2C5ptC5sLmnMzxAOedMe6S3gkwFLKBJ0GkYcI4GhQqwaGIAlNoACaYsM0xGwQSAgpzpuAAnpiOCMwErRSzzBcVZNMONZ3YEQMGHnUwxBOiiKFHNuXM/wOELoWcYOMAmeZaoW43kVADNZJcoswAZjDAoA26JqssRxTEccgowAyiZnq/LGvttRqNQAM7sGwCQ3SWYCvuuBe1cUYsYOSwXAjktusuRSOwkMy79NZr77345qvvvvz26++/AAcs8MAEF2zwwQgnrPDCDDfs8MMQRyzxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLMMcs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dVYZ6311lx37fXXYIct9thkl2322WinrfbabLft9ttwxy333HTXbffdeOet99589//t99+ABy744IQXbvjhiCeu+OKMN+7445BHLvnklFfet52Wz3zOApJkHnM8zFXgucuKvNDcFpeOnnIN+Dm3yweqn9xGINFVM0LsJH/giXkz5IG7yGCgZwYSv398SX549FI8x77sN8Ewy2d8ja37LfBG9BZfUYSCkxCI/cQUHKNgJFd8T3EzCjZxh/kT98jfCViwLzEOFigYjfwRJ7E9f+LgD7ED21CQMvwHMSkoqBoNIKDD3qCgQHhHgQzLAx74k4I+QJBhGHCGgqp1wYXZQEHl6ODCqKEgK4hQYUkIAX8KsYITsoQFG2iDlQpAQV64UCUdwISxhFAlQCiIFjdMiR3/xMecbDCJF6bbjxGCiJJ4HMA5EcgCkShADv5MggJMLEkXahEdL3BgSKDgzypUkUWS9IEZ5kHWjgyxAP6Eo4wj+UQEzrMAQ+ioBbjgzx7gGJIYECM/rfAejLi4H0hgkY8eocH+8rOFGLGAgsRDpEfuoJz9nOFFLYgEfzonyY9Igj+2EKSFgMGfZXQyJGvgDzBGNAX+9IAEpwRJDKalHztWiAPq2g81YhkSKPAnB7Cj0Iz28wVeioSU+5EChXhAHv0AwAPGDIkHcpmfDNiwQBCQk34WQINoiuQZbdSPJyBQoE/wR43eDIkB90ME+1zhifpxwhfTGRIKOGE/BwhFfcBR/71u0lMkNDCWfsBAn1buB53/DIkE+OOi72AgQfppBTQTKhIPtGI/R+AVb2LBHzFQlCSy4A8penMFR+zHHR8tyTj24wh97sZE+lHBEFJKkiFMUD8a2I0BBJofStC0JCLgjwE4Q8T84OqnJQmgfoqxmW7sJwM1QGpJatDM/LQjMxygnX4QKlWRfFA/ZgimZdCxHy2IsqshCQMt0/OOywyhdfm5H1pLoof9JGCmlQnGfo4616TuRwKVeUL98rOAP/TVJLwIZ3osIAfK8FM/5jjsScyxn3RMpg88RU8CHihZkiQBnvnRgWTSsJ9UdPYkHNVPGiJDhf0E4pCnJUkD8qgff/86Jgj76UZsT9KO/QThMTfYzzp2ixI/7MejjcGtfjRB3JM8UpyNMWh+eNjck9BQPzdgzO70I9rqmuQPmT3PbxXz3PwQ1LsnCR52FTMI/TzgCeg9iQvElJ/xHoYG+8lpfE8C0/zE7zCkzY8F+LDfk/BhsOlZrWF0sJ9GFvgkW9gP5ggjDf0M+MEGRjB6wFEYS9A3PQ7GsEkinJ8H2IEwe3DvHER8kjl8GD3BGIwMKJUf/bLYJP1FDwpkIBhj6IcBkbxxSe4QXvPUQzBsaEYSz4MjIZ9kGfrpQQIF04ZyqOA8qHDySTqxHyAS5gOngOhzKqFllGxCP5NAzDcq8ZxLltn/JGLYj/IQwwsNDNYLb0aJF/QjjcVc4RJ48GmeTQIPC5dvMR/Q6KBH0oAo6EcAi96Rj/MTBUVHmkQxoF564HDpHKlBP0vodIwYnB8GhEvUL6qGfqyB6hfVldKpa7WFMKDC/CBD1iMaZnpMiWsLyaHI0bEAXntNoTHo5xXErpAw9AOJZFMIA1fODxucfSBO6Ecd1DYQL/QTiGwbaBL6UZK365MN/YS4eEBIgLrXze52u3vdsQDYEKp6HhBYOnbX1RABAhbg9JQgevnO0L4B9ur0qAHgJxr4vz6ghPzsAFXFCziDFP4vd+jn3xFPuMBKkJ4Z4GPFGd8Qxf2FgR2UZxKN/4jD9yS+oJH769PNYYAzzkFg9rFcQS7vF8f9sQBtZCMRBLw5f3LOLwwQIhOcDbrGx60Zoe+H6EyXjNP1A/WoQ2bq+am61R2D9fRofeuM6Tp6vg52xYj9PGQvO2LObp60q90wbC+P299OmLhHZ+50F4zdoYP3vANm78/pu9/9AnjnCH7wfCl8cw6PeL0onjmMbzxeHr+cyEveLpT3h+UvT5fMb57zcvE86BMj+tEfpvSmLwzqUz+Y1bM+MK5//V9iL/u+0L72e7k97vOi+93fpfe+rwvwgz+X4RM/LsY//luSr/y2ML/5a3k+9NMi/emfpfrWLwv2sz+W7XM/LN7//v9Xwi/+rpC//Fs5P/qzov71X6X97q8K/OM/lfnTPyr2v/9T8q//pvC//0vxfwCYFAI4gEdRgAZYFAiYgEOxgAwYFA74gD8RgRLYExRYgTtxgRiYExq4gTfRgR5YEyAYgjMxgiQYEyZ4gi+RgirYEizYgivxgjCYEjI4g9a1dDYofziYg/W3gzyIfz74g/sXhELof0RYhAF4hEhIgEq4hAfYhE6ogFAYhQ04hVQIgVZ4hROYhVpogVzYhRn4hWDIgWI4hh9YhmYogmiYhiW4hmyIgm74hisYh3LognRYhzF4h3hIg3q4hzcocn64hYAYiF44iIQYhoZ4iGSYiIp4hoz/2Ihq+IiQ2IaS+IAdgACYmImauImc2Ime+ImgGIqiOIoIgCGVyICHcACquIqs2Iqu+IqwGIuyOIu0WIsHQG8TR4IKQCe86COfl3272IvCiCK/aH3BOIzImIsheIzJ2IxUp4vOGI1ZB43SWI3lAQrUaI3a2BwRAAj54IHMuI3buABfIFYSGI7iuI11oA8YiI7pqI1OIEXn+I706A8wgHEM6I71WI0Z8AmxNoD6uI/SSI5TBpACWY9CkHT6F5AHKY1HII/9x5ANGY0wgFwLOZH1GAFcEJEYWY8MwAkF6X4S2ZHRKATDtn4jSZLO6AVRJZIquY8hAAUu+ZIZWQXkVH4p/0mTzfgAe/CPwKiTArkECjl9MmAARnmUSJmUSrmUTNmUTvmUUBmVTUkEc6QlXuACk6gSmrBWSKICbpaVJ0EPG7AlE8BJYGkSJJBKWrIAjxCSZykSGFAGL3YkDJAGMfCWJjELVRklkICVeEkSisCVRwID2fWXI+ECY6klKZAJhjkSPuAKwGYjC2ADbtmYHNEAZaBYULIGsGSZINEPE7AlG9BYnvkRLOBoWoIIU1CaHxEHM7AlKeAGrOkRK2AFWzKZsDWbGdEAdKCZdGkCLaSbG7EImgYlG0APwrkRUFBrURIC4pacGIEEr6klKCCb0IkRMlAAkVkjGSAFuXmdE8EBpf8wJkBwO+BpEVVQSVEyCSd2nhUBBSCwJVrwnO4pEXcwnVEyAYJWnxIRA0uwJRmACRDHnxBBAUawnTVSngQaEQ5ABMWJJH7Qngv6ECUQn1pSBP81oQ6BBGIGJUogAhr6EElgbFryAJcwoCGqEAaKoDRCCBOSogvhAIDwoEciCKcGowpRAk0gnxmKowjBBh2KJCAAdD6aEBdwZlCyABtZpArBAUbgmzWyR0wao6+wlzUiBOY4pQnxBtFGI4zQmVrKEDVATScCAkEWpgzRBiS6IRFgkWjaEB6wBVC6Hw/QTm8KERAwClbKHxJwk3cKEftgciX0nVBzAZlACCiaNfxApun/cQR3KTWJkA3aEE74uDUX0F75EQJ++TR8cA7OEF4H5zUIwApz6hwp0FBNEweNAG7R8XBgkwpLBh0P4CZMMwf4gJ/mUaldgwY7Gh024KdKs3PpgVJh0weMuhxpUJlIU3L5oQRZ2jVXwGbNsQE89jQwlx56MDYfoAYCBQOb6jTCih4KNjak8AIosJpR0wEWih4ZcJJhAwcgOjUklh5G9KcX0Vr5kWb2ehFalR7XtK8UoQ76wQkAWxFsEFOJWrAPAQn6IQwKOxGvoB9j8LASMQQaZh4MQJoU+xBQlh+YsLEQgQz6EQIJC7II4QCoia0m6xDWoB/VsLINYQks2hzdBbMK//Gf+RGqNpsQcKAfJ/CoO3sQHZCy6GEMQZsQAqAfUaCsjdcBz2oYV3Cx5gEPqUcJeHAJh5YYFZYfeGZ6e+YPFqAB/2oYvXBco3cGYwY9h8Gq6bEJoyetz8EEp/C0fkEL+9EJnIcK56EC5SBDgtEAglkevCZ5AZAeL9AM0xYY9fBj69N4SDCzzGG0gTFjOCV5OXYeOzYYelViIOd3HqYfUioYdjCX5nFudDev6PEANyoYj7VYNUd3B8ZnhsEDDeZ3qIseNUsY/YYeF/Z2sZsf41oYWJBfdHe552FbhqFc6fEA32p1T0C65bENihFcA6V26pUfqIoYyoseDGBYW0dq+f/hCYwhXelRAGAnBPuRvYmxXdhrdZrgW44RZ/rhB1a3DvtRmMm1H1c1bk6lH/bVGPilH7jAtLJGAf2aHvTZGLuLHvGWbamwH8HrGOCbHgeQBNR2AXDFvRYkGVubH5HlbJSlHxw2GXIgteWxAGMra39QqtBhAfBFGQulH9JLbAOwHzFWGW+1H9mKa9FgV+4qGe+wHz3woqjWBVqwH+iAGR9gBgcla1+VH4EwT5fRW/oBVahGVbm1GcWwHzPcaTWsH8fAGU+yH/EaaZSwHwwwVJyxUvqBBz+sZUPQpelhY5sRCiZVuYtmcfrhCFnLGaTAH7IwaPKrHw3MGx1wBPshUW//ZlH7wQQlqxnllR+AVWZPnB/oCh7Xmx4MgLwsRgMsDB0jHB6hAFrp4QSEWmAccE/6cQB9DB5EwB/KdGOVnB6fgE3smx4L8Ayd/MnPkQvASh+8gIvnkQMTVWAeAABPNWEFsk76sUoP9gX88bEU8gHHeh4yuV8ktB85IMUHYgiuBLTVRQKBax6XXCHIpB9rEF8d28wk0gK2sEne9Un7EQlnVSFoux8p0Li7hQTq2b4wcrvnUQScLFkUwLD7UQs50gIXlR7EAM6nlWL7gQv1PCJsdB4RUMvNFQ78UUdCMsvOwQwbTFxysAr8gY1CwgFf+xy1QCXNRQFsmx/kcMowkgV7/3oAclVdRsAfL5DCO1JuzHEMEtpcdssfgFAl6MsAmHBvscUL/Vy+VtIGG6C+xLUChcAfIWDBRzsQtskfu5TVAlEOCsJVQfsLClIMj7yyfdDU6IEHvuPVF3DA+XE9Xt0AqgbLXi0QyqAg2+CTOysOClIEWJ3VPcwfFoADd40FNIoeVXDXd9Cr+9EMd30FmsQfxyDTJtsCL50fRdDKO/sGvPwcJ3ANdy0QwxCa+uELoz0QveDY53EJqU0QSMDE53Ferz0QeYCrz+EJdDvaI1DXzxEIflvbBfEBeuIcCdCSwm0QDoC6L6AIya0QFcAc8fDcCyEJCxAk1L0Qypzd3N3d3v/93eAd3uI93uRd3uZ93uid3uq93uzd3u793vAd3/I93/Rd3/Z93/id3/q93/zd3/793wAe4AI+4ARe4AZ+4Aie4Aq+4Aze4A7+4BAe4RI+4RRe4RZ+4Rie4Rq+4Rze4R7+4SAe4oORDCxgnuNdazkABrFwBsHN3ZYQHTCwCbDADjRg4rVN1unRA4MADKNwCHFg2Sbr0aVmBgOgDJcgCdRQA2BaE0r9hl9MIydQCLoABPNQDtmgB2IgCk+QGx6BASRgB51ADe2QDRXwBctQDK0wAc68hw6g1tQZAoGwAcewDY0CBoUCDIiCKIWiAeNgAmkQBJ6wAYUAA4n9HLsQiLT/C5TmkQuBeAqKbh49EIis8Ojl8QB8zYaJSenQ4VJ12AXQq+n+oMZ1iK+g/hz3sIfnUOrQsdh4WLiq7hzSXIcsUA4FwJyqTsd7iA3hUAFrsNCUXgdZGQbPIAkSUAey/ZJMYJgt0Am+IADKUAxyvI8JoJs+wAvIkA1lEADHEAixyo+7PZsXwAslQAupoA61QAzOwAg9QGNHkgKIwATVsAa1AAroQAtnkAWBXaSqMge8YAA3gAbREBtcgBoCwBqskQqo8QPsIALhcAg30At9MAcycOkiXvEWf/EYn/Eav/Ec3/Ee//EgH/IiP/IkX/Imf/Ion/Iqv/Is3/Iu//IwbyUBAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2ve3FLEjx+fRIiIhuaGAR5zhnTgzLq1a4ZB/MmeTXs2Ci0zqplghelHtzNZYrweTnxy7NrIkyOPUGhAujJESsThULy69cCTlGvfnjyELg3ThPX/8XC9vPm4G7irX187UAEbIkSRP0+/ftj07PPrZwAgQKMSV9gn4IBU4affgQeGQMw0Z8hA4IMQGmUgghQeCIAyi2QBQYQcdogTABWGWOEqSxhDRQMepqjiSoGI6GKFE1TSCA2rrWjjjR21+OKOFKJAzCe34CjkkBLpyOORCEayRThhEOnkkwUZieSU+r0wxidzQKmlkD1Q6SWFjKjTyZZkepjAl2giaMYehjhQ5psClqGBBtKYYMI2x2wQCAwopOknciBsociGcBYKIQYX3HINFHp8Ao05uziDywt/ThkFJzQYqqmNF/TxhiSYSFMMIpW6mMqmqArJQRbhxKLGACGU/5rfHanW6iQJiixCxyB4yJrcOrYGqyU2hxCwCy6++vODsMxuecE3FSyhgp8LhNLstWTeIgIrzHg5BrbglhnDIaVswACPIoSrbpkkwEEHEyKe4MO69JaJTSYB7IBgAPX2W6YDNEAzIXdo+GuwvUQUQKl2O6B48MNb+qBHAH0itwXEGJP5ARrKOEKbIRmHvOUHwgBxgi0ip7xlC32o7PLLMMcs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dVYZ6311lx37fXXYIct9thkl2322WinrfbabLft9ttwxy333HTXbffdeOet99589//t99+ABy744IQXLuAF1Xxj+OILudCKP0rwwvjkBVHRxGxmBEj55HosPNs6821eOCnKLSN64TZsp87pgWMwjnrssO63B0KsZ8ENsu89gif57UBr7ndf4IWFwgFPdx4gIjiAw8bD/YQtIR7SPNw8dEmhBbRM/zYP01K4iibau819hZEgEX7b41M4SRvns91HrxRuMm/7aqe/L/P0n51F9wjukb/aTyhChQjwv7QFsEKAKCDaTFEICi0gdgo0WwxmcL1fRNBsYcjF9Qp2QbJRYBAUmgAyOkg2BxAihCwgIdm+gEIVjk0cLXRh2NxwPSjIMGxveACCLMDBG3pNB0rYYQ//fcg1U1hPPwvwBRG91gJIUGgRS+yaA9JAoUZEsWsSoBAorsi1TFCIG1zcGhUsgCBiuCmMWLMEDBBUjNChsWpdGNh6nDCEN2ItHQhChCXseLVRIGgCouCj1W6gQyTCQZBVy8MaD0QKRFKtARo8EDAcSbUsHqgSZ6Qk1BSAoBw4SJNQU8UBDnSAOIASahTIDhIVd8qnBQNB9Wjl0w6BINPJsmmJgF9+mNCCWzINAto4kCNc4EumvQNB9yjm0lCRgQM9QplK4wC89FMMDEAzaZbMDx7ycE2kyQJBb+jm0VaghQNtUZxG08CB1mFNdBLtDAdSgircSTQfmOFA2aPn0Gpx/yB56HNoUDiQGVbwz6B5AFn5YcAUChq0MhyIEwwFmg4KyR5GUCeiPXOAH/TzgDFhtGd+1A80PtqzUHgsP0egAEl5BgaOenSlOfumfjABU501wAn6AcBFa3qzLJAqPwvlac58AItmqqcZQuVZDSrBHRiQIKk9+wX0lNMNqPrMA5eIAHIGYVWgqcIKtLGA+boKtGHkQDZSIKtUkrEJ/BWHAu9gQhfU+pRr6EI2yzJPJumqlDwogzZNIChfcdaCcpwAOWUYrM0g4IYoKOcEe1SszKYgx9qMQ7Iwc4Er1sOAGmBWZVAw6nrW8NmUfUCA+XlpaTEmAv3UYbUhgwA59IM72P9ijBr6CYJtM7YJ2u4WYtfI7W8hZgLfDtdgNTgXe157XIO5Qz+Zam6/nkBR9bhCuv5SZ348i116UTc/l+0uvbS7ngzwQbzr+i57/IdedZFXPSgQbHuxldz8xGK+4VpDfrRQI/w2Cwf6aYd/sbWN/ABrwM3CbX6egeBmDY890mgws1rLHguwT8K2akCs2ENADNsKhuwpQn89vKkhHJY9CiBxrbiRn2+pGFV/SGiWXrwpZ+THGjTeVDvyE4UR57hMDVjkeqT340JZIz8mKHKh7KBc9WTgAkqG0xjyk8Aol0kY+fGGlYEMgvzwYMtkSh17bADmLdUgPz0gVJmftFH2gG//zU/KRn4uxlAgJODOeM6znveM5/tCbAhkXE8T2vnPAryowxDTL3tYWehDZwzL7FEGQw3tIkQ/7AOjXE8CCE1PSovI0g97LntKUFBPhwjUBytBfsDY6EqHDANdXg8I9opOUw9QZFvIjyxa/WmRwXO9vD61yDCgr/VEIti3Flkz8pMFfdqaQqh+GC3ZYwxnO1pkFAjieophbVenbBnsYQCU3flsBEX7YRReTz5rfW2RDWEBke50u0V2V1nL29spQ0d+UEHueYeMF/mpNrvxnbIjcke3A++1y5a9ngi4EZrlPtC5IRaN/Igh4cJ2GQngvZ6RijPi+pk4xCKpHk9gPNku/5MCex4wv2uCPD8if5gY8kPqbr6cwzDzQKDV43GX+ztlA2DPAD7+c5FVgD0ncKsvb76emD9MputhsM8JrrIuVHc7sZy6wmEmCPYQwuZFFxkn2NMDsFNdZeHIjym0nnGYXSE/wmA7ymE2VfWcU5lMV4/TIRYA9nAV4mEXWSrYcwC5Q3tmVMiPHAB/dpV54OraSQbjtx4zRrCn50sPvMj+up4lTL7tMSPddgLhCmuEE++aD9kUapOCXLAiG4YYwckPP7MR2MIK1kiGC9R8b8rDmUN5587ef3+e4G9n+MQvj/G1g/zkW2f5ymm+84sD/eRIf/rDqT5yro9912i/NtzvPv9rvk+b8It/M+SfjfnPn5n0y2b97L+M+/0B//hXZv71t/9k8K9/+vC//+bxfwB4HQI4gNVRgAZIHAiYgK+xgAzYGg74gJwRgRKoGRRYgZhxgRhoGRq4gZTRgR4oGSAYgpAxgiToGCZ4goyRgiqoGCzYgojxgjBoGDI4g4RRgzYoGDiYg4CxgzzoFz74g3wRhEKoF0RYhHhxhEhoF0q4hHTRhE4oF1AYhXAxhVToFlZ4hWyRhVqoFlzYhWjxhWBoFmI4hmRRhmYoFmiYhmCxhmzoFW74hlwRh3KoFXRYh1hxh3hoFXq4h1TRh34oFYAYiFAxiIToFIZ4iEyRiIqoFIz/2IhI8YiQaBSSiIQdgACYmImauImc2Ime+ImgGIqiOIoIUAepN4kPcQgHsIqs2Iqu+IqwGIuyOIu0WIu2eACiBXqoWBGclCy+iCb5h4q9+IvEiCTBOInDWIzK2Hi7GBHJuIzQaG7NeBHPGI3W2HTTaBHVeI3cqBx3l40SsY3dOI6zEQGAkA/gGI7kuI7JsQBf8AHpCBHiyI7kWAf6EI8OMY/0OI5O0Gz4uBD6uI/dCAM1948IEZACyY0Z8Am0ZpACgZAJeY3uqHQGCZEReY1CMG4O+ZAX2ZFH4I8baZEdaY0wcHEhOZIdGQFccJIoeZEMwAkUOY0i2ZLWKAR1hI8z/0mT0egF3JWOOamT0BgCNuSTQDmSEVAFvLeLP1mUy/gAe9CQkLiUTLmMS6CRqCgDBpCVWrmVXNmVXvmVYBmWYjmWZAmWRKBVf+IFxLSRW6EJBocmKnAGbLkV9FBZVDIBkjCXWkECikYtjxCTegkVGFAGkEclDJAGxROYVjELaOknkLCWilkVivCWXwIDtbU4EOACyWANxGALsjc2LmCXU5ICmTA4I2AI2cAKuZACtRFUY+MDrtBkaLIANgCYdPMG1uAKUpIcjVQ2DVAGHOcna/BUe7ME8XY2/TABlbIBi6c30FBRacMCjvUniOCad5MMK/dwZBMHFPQnKeAGeSMH+f9BBWqzAmD1J7SpUneTaepxKmrTAHQQnGjCACYgX3QDQuvBL2yzCCfmJxtAD3YDCuyBMm0DBRvmJyFAnnQDaeuhOWyDBN3pJygAnnNjCvkRDm8jAwUgm1+SAVKgnnFDmcoBUW/DAaVQKkDwmXBzQushCHJTBaz5J5NgB3FTDys3V3EDBbHmJ1qgoG7zDLo2N3cQoWkyAZTwNg3QmNxRAXQTA8b5JxmACZymNkG3HkNHNxRgBBz6JSnaNs9pO9r5Ng5ABP2ZJn5Ao2ujauxhknVTAjuaJkWABWvjA4WZHGl1N0gwTX6iBOmiNryzHrmQN0kwZX/yAJcwpWSDCeyxAMT/eTdZuqVeQghNcjYzxx7RoDcOAAhliiaCEFll4wFKuh1ItTclcDl/ogVyajbHoR5lxzdsoKdpAgKJYDbGkB+SwzcX0FtpsgAraTaokB/o4DccYATyOSXsdTZvuh268DcO8AqhyiNCAI9ow3nqsQA36TdvwD88wgiNeja0kB99+jc1cFY8AgJjlTYXAKnJYUuA0waE6iIRwKZqUwzsoQQg+jcesAXFeiAPQARuU6vsQWSBAwGj8Kz5IQFJmTZZkB+jOjj7UGwHYgX3yjaRwB47gKh/ww/kilKJ6TZ7kB9yWTgXgJ/rEQKQ+TZQpx50VjgIwAr7ihwpkEJy4wDJqh0g/4CxgZMKnpMcD3AKdaMGNDc5aGCqyWEDCfs2aroe7kA5fbCxtJEGtsk2GHAm63EA0so4V8BUtLEBn2Q31KoecUc5H6AGygUDJ1s335AfpCU6pPACKGCddoMBRMsdFnCtlAMH4Zo3ucYe2RCZbaEJ+eEHfssWEIBa69GTg4sWYrYeZJa4abGw7AECUeu4XuENcEe5aAEILYa5Z3EBubgdDICmnEsWxcUeODa6ZDFt6wEDk4u6V9EB07keAua6YnFk7OEMtCsWc6CuyfEHuRsW76oerPa7XiGSJ2C3xKsVHWC46iEOyesVBJAfIdC6z/sUbbBz6pG31YsV0pAfXrC9W/8BpPlBDeCrFeuQH9tQvlmxY/mBA+r7uuXEHmv7vlURCwmFuPQbFStQMeuhAflbFR+7ck/wv1PBB5+7Hf5LwFLxOgKswFFxZvmRwA78FJvVwBPsFDSgH0t7wU5hiuGGvxyMFDegH/MbwkqxqutxDSa8FCOcH5uwwkuBwupBvjAswvpBDkdbw0HhweyhvTosFJ2gH0VwtT88FH3pZENZxENRX9Z1tkocFAysHRsAt08sFJawqbMRBW6Qw1UMFA5VGydgDb3UxUixAnOrDNwEg1BJHD8gG7qgwjPYBUzwDhNLHA2wCZKXgyrnDznAaGScFEiAvVYwT3+MFCRbjpcQpoX/7BPdoB22YEGLHBQkIGTKUQkgHMk5wXDckQGw0HKYjBOrlx+IAJKfXBMckDzs4QTUW8opoaj6sWusXBOdUKfKAQaxXBMUcAT64QjWcssz8aX5MQq+PBOzrB9+sMbDnBIcYHn58QA6kMwxMXb6kVjQ/BJTwLvJgQuKXM0msQL3pB9JzM0rIQ8HUgvi3BLfqh9m4MnnfBKqoG0g284qgQHnqx8SLM8nIaD6oQX2ic8k8QYIAsv+XBJ5oEvsIQEDbRIYQK/6wQQ7ldAi8QgHkgH8BtEjcQ8I8g4WPRIucFL5oQ1cvNEY0QKwuh54MKsiDRLgdiACm9IdYaMHEgwu/RHf//Cy2zEJdTzTFxEH7El4hKzTGiEDTotiQL0RDqC1+oHQRa0RwIAgubDKS60QoqcfMJDGUW0RcGDT2vEAl3nVFCEKynkgwuzVFWEJP6Uf6UDWFTEEOHUgG4Cjah0RHsDQVO2pcf0QDkAMO+Sjd/0QLIYgpdnXEKHPB6LUgu0QjUAhaYDMh10Qi0AhkDDGjb0QvqDV2tEDazfZC4EG2Fuvz6zZCsHZCPIApwfaCAEFnc0eFGraB8ECYX0gzsvarf3a+vEFsj3bFEIIjK3Zh0Db+TEIOc3aou3Uk3rbA/ELqb0eM9Cxxs0Olq0dhZDZxi0Qr1AhRTDA0y0Q0Ush153dAv8RwAiiAqR82w3QdxSiAl+W3T6gqwiCBy2T3W2gSuGd3tONBBV73vRt3JqwChWC3t5NC8m9Hj2Q37etughiC9id3Q1QpRZi1d4dA6jMHuRgld79D3cAsSWnohU+EDcQ4LUhBNvs3eygHuOAsxv+D+qwHY174gmx0sjRmyyeEB5Qz7PxAnoQ4wxxBd/sD03A1zieELwQRK3gxD+OEN9QDRRe5Eq+5Eze5E7+5FAe5VI+5VRe5VZ+5Vie5Vq+5Vze5V7+5WAe5mI+5mRe5mZ+5mie5mq+5mze5tPTB5Jd5bZwAkAgDEQM5YZAG46gDGhw50y+t7WBAgGgB+z84w2A4cj/8QIFQATYoORokB8bAA00sNusbd76sQMBkAmN7t0+gMUNTQdw0K2mnW4uwgAbUAqHwNyHHbxHwgysIAJBItih8NwvogJLUAHfkORF3ca+ggu7QACHsOlATeO/iAeDQAeLoAiiPtB30I0hMABqEAvhkAUPLc6Dt49RUAzSgAmS8AZ9oOulTAOcELsR+QK44Ay7YA7Q8Al6AAXXcAsX4GNVDAGKsAU1q5MoEAKBsAHHsA12Ig1zQs017ACGsAc7PpXJkQBV3AnqwMwITxut2sVz8AljsLNMGQiRHAbhsAX3XZQYX8q38AnEwL8o+fGx3AE00AiV4NsCafLD3ABUYAxLssDfAgkA7QwBWbAIyhDh3bgBCS0DZzANxHCg0ejzIn0FJfAOAQAA2PwnRq/THtAJImADBbCbTq/WXdAHwjANGqALRE8lkzDZHBAHJUAEZZAOA1AIBosgCGfcMcADZ9ANP4AJrGAC1TADWkDy2tH2Rd4BQzAHPGAAN3AP0SAan/AZPuzmir/4jN/4jv/4kB/5kj/5lF/5ln/5mJ/5mr/5nN/5nv/5oB/6oj/6pF/6pq/TAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dNt4YWopmHaLx0eUMue3biCv9u4GeAiJkXEtdi0gwvv6w638eMLmKWrR63N8OfQ4eo6Tr16j12NZI2Izr272CjVw1f/Z+BEw6w43tOrp/pBvHvxeIjVo9Fhvf37Rtm83y8exZJUnTiA34AE5oQMfwiKd8Aui9hR4IMQtvRKghSKBwAdyAAX4YYceiRBhSCGd0IBi+TR4YkoUkRMiCyG500Ff6Qo44wIHdHijdW1AgoNNPYo4wQ4BkmdGcH04uOREIYi5JLUBSIFL0hGad81TFZ5HBPTzCHlltx9wEM4sdQShApWLsnAICK0wOWa3F2gySJ0bLNKmTeioMENbObJnSX3CLCGGXSGCAA6SehpKHRXHGINGTsEmqAFAZwBwaGUDhdHJhoA4Ch/hYyyQqWgBpdEOEbYuKl4KZgDZaisynZBPFvk/3BqeAOEM2mruJomRxUmODLrcYVko2auxI6GgSJlMPErbjuok0ix0Iqmyg/aZLCsBbU8Ee22n61ACTEn/MoAGDpway5nLegBRgq/CsHjufBilq4VL8xKxrvx5ksZCbNsw8Cp9+or8GSWiCPrprMMrHBkz7Dia5koDLHwxI91kckxVlpD8caP8RBMAkIm8CnHJDPmwSnk4ChAySw3ZkgA1oKIx7At15yYKdA0UWEjNvesWBdcaMofIh/4bDRiEMDhzH4/HO00YoqQIZ4ZRT9tdWE6BPDvcYtc7XVhT2jwAG6RNPD12YOFPbYIaLct2BOP1Od2W3+8M/fde1EAzdgs4P/td100KHtbIRr+bfhaFKizwHE2HO54Wn94Ud0DnTxuuVgdTGOBeBvIffnnWqmC8Xt2g266VewowV8Ed5zuOlQyBEDhAK/XvpQiWoDYte28D+UAAYuD6IgpvRfv0xXa3EiM8cznJEYIQSbT/PQyQYDP1jdqMDL13K8UQx1BmnFG9+SrdI0tQW7hQ/nsmyRJvTf2UEL79IvUQC1BgrN9/fxvdMXSN8KDMPpHwI1cowg42sSzCshAi9AiXC16QSoaSEGKYAJHzChXBTfoEA8AAUfN6AIHR7iQUKyjTrQgoQoR0gdAtYgc6FmhDAcChQPciBscmKEORbA5FkXADTrUoTj/bhQJVARRhg4wx40KIIMjrrABhLgRJm7lxBH6IHksSkE8qqjCC/ihRYHoAxdJmAehhWgAEhsjB58QiBaNw2xq3GANEMii0sWxgjwgU4gmMMA7VhAHNgyRCgzgxz8GEkQAUEUhKQhIFhXjAotsYCNDZILCRZJ/kwSRGgR0SQL+4ZAVkkInC5hHFp1jlAR8AgxCtAC2oZJ/cqBjhSwQjVfy7wqFCNEL0GDL+o1AciCaQN962T4PTAdEKRgmMcvXgAKE6AA4WGb7igMiaEqTfep4ZjSvSb4q7PEZ3CQfHIJHIWGGs3s0ANIsh3FO7s1hlRV6AC/bOb0RCK5CKaRn8zoA/z4QfUKf09tCiCoA0OZlI0TBKCjzWDC2CoFBocazg84qtA04QtR2LZgBiGawnYvybhcgKoKJPGq7RlSTByS1nRjIiaAFzC+lr+MDHkBUBZjWbnQUKoVNa2cI8CTICpzcqeuusA0EMWF9Qq2dA7L5nlVoK6m8Q8OcwrMAKEC1eHLwRnhGcVXjcQB/xwFHV5snAnX6wwsiHCvzeCArp6p1ej4AwiHeSte62vWueM2rXvfK17769a+ADaxgB0vYwhr2sIhNrGIXy9jGOvaxkI2sZCdL2cpa9rKYzaxmN8vZznr2s6ANrWhHS9rSmva0qE2talfL2ta69rWwja1sZ0vb2v/a9ra4za1ud8vb3vr2t8ANrnCHS9ziGve4yE2ucpfL3OY690QfYIcrqPhcCD2BE43yxzeq+yAH3KMO2PPH8riLnyRMA33UWQA2yLseKkijh+EhKHu5w4FFpGw/WgjqfIdDgZkiaLv7hQ4sEhSAAEPnDgl6QRMNPJwgJIgIDB6OHhLkhwgLpwH+5Q8bLBycPSRIlByezR8SZIsQ02YDCaKCiWXzgwR9QbFASICMZ0zjGtt4xrGA1gVith8VYCCxzsQRAaK1IgS9AchBGjK0JowgNSBZyNHyAAoQtIMfHzbIN1IytOSRoJcaFsst0nKxvpEgViAWzCwSM7EwkOH3gED/v4NFc4jUTCw1JEiZhJUziOicqxIkSAJXTjK3MJDd/UQi0FDmlgYStOHC6rlCfM7VIRJkjC8LmlsUUB1/jmHpRHMrivxhQKHyfGluiSBB8HB0qbc1BJa6Rx6q9jS3jrkfEFAXsI+mUKSJhY4EiYLUst4WDxIkDmBnOV6yfA/t4rxqbjUDQRawpF9znaBdE+sXCaIGs4O9LRm4WjwgDiy1EWRtYhUDQYLY9rHjdYmWdhTXzeaWGBKEDMGOmz/lzhUHIoAgUNg73txyMH+c8W9uc0sACHpBDuFt8G0pIsXiBvi2PgDf9/CM4evOF07fY4WIN3xbNkAQCDye8XjdI0Fa//rrvfeTb2JdIEG1VLnEuXWw/TwC42EemDQQVA2cp3lgLeZPCuCs15W/p+XE6kWCkCDzj0+cx+9pR9NLni+t8sff0545t+zMnzFMPecD+4TIv/7zgVEhQQvkq9Hdg3RihSFBVu3r2sXTdmLlkj9Nk7vWuQVS/tQi607nVjkQRHC9B35bTN5PAgBP9XzxAu2Gb3y8GtDQ/Uwh8mBXmBMQdArMl11ha0BQ49S+d26FnD9r8PycJ3YKBM1A9Xue2BQQdALYQ3pi2ID8XucenroXC4L7MdLuS8+te75HD6Q/PLeEgKCLF5342xIof+aRfMnny6T8WUL1M6+wxL/HC9v/vP/CnjH24St/W3NIEAXMb/3Jo5z93FcYCBAk/Lzyvjq+LxYw9yO9559/W1LDHzXlf+0XL4uGb/AnfgpTBghiBAm4ehRTDwiSDg8YexSTCQjidQQYfwMzafwBCRV4exSjdPwRCCGoaxuDYPyxeBuogAOjJAhygtW2MR6QIEiFV/dHHflXLFDnHutlf9DHLW3mHo2Gg0G4LdoACUFQAAGgARJwCe/wCiIgDCVgCH+wcEb4fysGGTl4HDu4hYvRhcbxhWCYGGKIG2RYhodxhreRhmpYGGzoD274hoMRh3NIh4Fhh3iIGXq4h5bRh35IGYAYiJIxiITIhUd4iHWYiIqYh4z/2Ih/YYiQGIaPOIl8IYmWiBiYmImGsYmcSBie+ImCEYqiCBikWIp+cYqoeImVuIpzoYqFxAF/YAglIAwi8ArvcAkSoAEBkAZBAAna8Dmw6Ef6wR94IIyt6ES5xx8ZgIxaGEc+kCDS9hwdgADWeI3YmI3auI3c2I3e+I3gGI4I0E8F2EkJEgrpcQgHsI7s2I7u+I7wGI/yOI/0WI/2eAA9CIHSBDL80TreoQDLEpACeYc61Eb8UX/cAZACuZCnQpAzBAkIMlf/yJAUGSgOKUNjgCCZkB4KWZEeuSQXuULpgCD1wJEfeZLJ6ERGgCBlYJIo+ZIhgnXSRAAIogEuCZM4/4kgEQAI+SBN3sQfZHCTOTmU7rEAX1A1vZQMCAJ+E0mUTukedaAPxESCtSaUT3mVxuEEWdBL6YcgFhUdHYmVYnkbMOBlo0QB79cdYTmWYpkBn0B0izR//AFOasmWdukPRvmVkbR/x9eUd8mWQgBJnbQEzeeXfzmWR7CVlzQPCLIFhnmYYgkDYnBJ2LcfQvCYkImVEcAFkeR97sEEmJmZV8kAnKCXY0SV71F7dSmadykEaRRHiZAgPwiWrPmXXlADfgR873F5CVmbfxkCcadGGsUfndebvnmXEVAFt3ZEoccfo0ebx3mXD7AHcDlDp7cfqWec0XmXSyCYTtR6/OEE3f8hAwZQnuZ5nuiZnuq5nuzZnu75nvDJnkTAb7PiBS5QRbPHHw9gmpejCT3wKyowPkcUmwiyKq5DDyg2KxMgCU7Ej/uBfLVDAs15KgvwCPw5QgC0H+XAOxhQBpXnKAyQBjGgQ2C1H7tQPLNAn6cCCfcpQ0G3H4VgPIrwn7MCA3iyQlCQIGFgPC6QoKeSAhupQgTKHypmPD7gCuEVKAtgAxfKQHK5H//EPA1QBt9GJ2tAAiSUkfzhZNPTD2a1KRsgByMECgjiDdzDAj51KojAmxXUDgiSAUjZPHEwnD8KRBWEBAmCkM2zAlbwK0u6fg3kAOyCd+TTAHRQpVbCACawPwT/VA0IIg3sswi66SgbQA8N9AgIkgPtAwXQMyshUKQEFA0J4p3kgwR0uikoYKf905X8cQ/0IwMFkKR0kgFSAKj886Tv8ZzswwGlsCxA8G7006eb1j9VMKinMgkOUj+V+R4WEKebiquOogWgyj5nhyCKQEB3cKqOMgGUQD8cAD/7sTIEFAOEOSsZgAlWVj4Z+h5BwEAUYASySie/yj5kujpY2D8OQASTGih+kKzdcyAIMpkNVALQGihFgAXkMwKISh2XcKfG5yhK4ErcIwgIUgwblARaeioPcAnp2jxS0FILRkHvGq9lQgg7Oj3UkCC/wEEOAAj7SieCYAnT4wEV5x7N/0BCJTBRp6IFCNs8A4AgRaBCbPCwgQICaVc8Q4QgKEVCF7AJFMqZzSMKCYIOK8QBRrCwQbIH1AMBBRseuoBEr6CiVSIEzmo8XMYfC/CaKvQGesQkjICl3EMJCSKxK1QDNRckIMB03ZMEJEsdhBBEbZCxNxIBAks+58YfSmCrMuQBW4C1+/EAEMY+xpAgEqlDEDAKYlshErCc1FOM/GGTTrQPhUYhVqC45RMJVNaxOsQPd8sfRzCi9fMhCGKWQXQBg5AgIdCi9cMCCcKlVYQArOC4/pBMBOQAXVsdeKC6R5QK4Do5xUlArJAgADZGaKCz1GEDnNs+foYgsBZHfdC6t/+RBk3KPoSGICgwjUd0BZVwHBsQsgzEdfwBoXH0AWqwNTCguw30BgkyXn5ECi+AAmxKQRjQtu+RAaQaR3BAtxX0BQmSd67YGNXKHxvwwI+BXvwRIxTMGB+LIFqbwYvhufuBB+PrwYHxRQgivyR8GESQIO2awoghA837Hv7owoYhOwgCCzR8GGSGIHhgujkMGA6QO/tBDotwrz8cGLYhHhYgDdN6xIOBDVVqC9Mwak58GEV2GwxQB/dQnVUsGDu8A5zwVF2sGBDgCuxQtmOcxmq8xmzcxm78xnAcx3I8x3Rcx3Z8x3icx3q8x3zcx378x4AcyII8yIRcyIZ8yIicyIr/vMiM3MiO/MiQHMmSPMmUXMmWfMmYnMmavMmc3Mme/MmgHMqiPMqkXMqmfMqonMqqvMqs/DWHAAQ32MpF8QRzkgNLK8tD0QX7NwEKjMs+AQ7UUQtG7Ms6MQouIqbEvBNQsLCrME/JfBO0vB/qwMXPzBI+QLThsQ1XUM0y4QDCiiBRYAjcDBO9WiGcNs4t8ZMUggd8gM4sUQLCixyF684owQOgVJj0nBJ5kGwIcqL5jBIjoK38MQM0888k0QBFVSFN4K8GTRJgACIPgGcNLRLBECLZMNElkcQV4pgYPRJiByJ14Dkd/RG+ECJMAKwj3RFo8KEIAgMpl9IeMQw1yx8T/4AvMM0RLPClLQUHN+0Rz6DTCDKAPb0RmUQh6jDUHFHUCeIOSE3U94wgBTDCTe0QLGCsFKIL6DvVEJHTIeIFKK3VEoEGMYwghbDNYF0R0TDT/FEEyHzWEyEC8UwdMCDGbh0R58AiKnDLdQ0RG1xNGLzXD+EA8Fsh1gTYD+EBJsAihW3YDXEBh1tN28TYDKEKZkTYkS3ZCmEABEwhi43ZCSEMQI0gee3ZC/EOLVIEuEnaCNEA4wBGdK3aBDEEP8siADBSsF0Qf2CQIeIHB3zb/xAPVl0hgxDLvg0BF9QihCDVjA2rN2IO1IzZqIC6LVJsvk0QbpC5FGIBvQzbHMANN/9yAMFZ3XFwXyxiBmJU3QJBC1PWIuuAjujdBc92I0CQ1ZitA8yAI5iA3gLBvDdyAvlU3YngtDdSBNeg38IwhCDiDGbt2ysAzDhSC8q919RAoxHEoNUdBtJ3I7ZQ4NV9Bi50I3UAu7e9Agd4IwyAD9mL2UqJIyEwz9V9xSGiDQuu36bwMBWyAATw3Kq9CCCiBdeq3wcx2wgSAO4L5ARxB9hdHUrADkauEKb9HsegSE2eEB3go9RhAdMg0lN+EJ3A0rfhBX+95QqBqcaxAOrgw2J+EB5wd/7ABDad5gvBuw8ADWgO5wnxDmGOVx3wCK9t5wtxag+gAX3u5wbRANLtD4H/PuiELhA8fhzjokGLPhAf8OHUQQY/HukvKh7OAAcpbuQfgAgIAgBckFZpvqz80QTQQDxb3gIIzowBIM5NjnA3Qg6nQN+SvQIOeiMJEAx6rdrWYCXHkAmkjtlDsN5W4gisQJeSPQunkgPiILOMTQMBCKLbMAtwC9jSPisvYAV6UNBuTQPMNysoAAbdDtg6AAZ9WyUnQAyUwKha/QS1oNazqg0/IOVnnQjqMLqzwgRloAhajtQtkA1sviyOYAJV0NZNDQHhIOQCmQNb8Au9fdO8YA7BHZBHEAzhQMU9vQKjAL4CCQAakAkxdNMQAAUBIO8BuQNkYA2HMOMdnQToUNkf/2kGayAA9wDtHX0DGmDsL7kK20AHi6AJEY/OLSACg5DuHqkCQVALsRAOPIDGzzwH4oDNQ8nh+cwLUqDbROneDd0LwUDpLzkBME0DoNAKMHkEQ/0HFTAJJ8m/Q50Hi1AALzsrgAbWHoAMdCDzp/IKgG0Hi7AGT10m9cbYDtAJqbAEPF8lRYjZHUAD9UAMrd4iUI/ZcXAKGuAESP8eUTDlIyALjbALFJ4gXwvnbUAN9ZAOzCC8TB3pHnANIiAFxIALsipfkV4QHqADvzANGlANIZBqtf/7wB/8wj/8xF/8xn/8yJ/8yr/8zN/8zv/80B/90j/91F/91n/92J/92r/93Arf/d7//eDvNgEBACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27d+YVDnwLHx6V2w4gpywRX868aCB/0P0BCPaNQ/Pr2G/Kic7dXwpXp0xl/x9PfuWs7uj9eSPAprz79x/BpJ/vRMo1+PjzT1Qxv78/M7B0ot+ABBrEi38I+tOKNVkU6GB+PyQo4QzoiPfghdmlIeGGC9TRjQcYhjhcB45saKI/jjTzjIgs6vbMiTD6c8QPJLRo42zixBjjC9LccOOPrQWh45CMEBEGkEiW5kEEQzbpSDBIJCnlZxdsgUuTWG7yxpRccqYKEWscgKWOTJzyQZdoYobBFLAAMCaMKpQzRJq1QTDeLT8MssCbG54QDB90wnaLBtK4F0MmVrzAZ4IPuFNDoKvVAAYD/jDgAnxh6EHICYv6x4AJOkBqmg4mdKeGfiNQIkQGnfYHqqihsf9RKnoW5EEgCYs40+p8r8K62R2T9lfKg0/gE8mu6JnAi6+X2aHBAwiiMOeFimiQArLRMQDOE8xKNoQEFmxYgYg+VDEJttBlsEUo3TbWhThimthECy2K8oUS6J6AiQ/tIgbBLIjoeM6NPmTDDLogENFBv4TJ4kWTPTQAJAtrQIusE4cwDNgdxLx5SpKWwFIistssq7FeI3DC6ps52JmkD6Q8t+sDwNR4sl0iwNBqNFx28Mu5uzZRRXA3x9XJMch+keYZgyBLDhVFuzXCF5S2SgYNkNJgQtWdqjFt1Gh1E8KuJojCrKRc84nHLGCbdUslZPfBMNqtOsND22F1YAyTnQr/EerNNQTQagblUIB3V51s0Ko2WLetAxmtMoPF4Vl58IjFfPohC+UCaaLrogwEcyTnUxmSQ6eFxEM6Qcgc0akZYqz+FAc2pI2lCtlILPtAHUgy9qLA0Lt7UjQ4segLNowwvEEtWHMtn60YsnxRGECzJ5/LyDE9QomMA7o62wcVB9BvkqNI+ArRIAifgKDvExcT8LkKFwu7nxAEmejcpDb275TEEnxiACu+1r+EjEACmDtRArBRQJxAIWBvgoQBGuiQP3giRrSgYE0woA7b6cgRP6ifBhkCAXvswEQBGOFM5nDBNxHCVip8SBLcIaEoxCCGMDnECccUhXDgUCIlsAWC/7b0Q5Z0ABR8YsUKiiiRFuzBg9CZBxNXkghdsGwKU6RIL5iAnhx0IYsoUcTvsBQ8MFKEdtfzxwMaZ0aSAGJlTYoEFttYkV6czh/WoONIPCCPN21BeHqkiAck4AcMBBIkllAclmCAjENixHCO7IghQDAmYlwgkpicySnC1aQUSCKToHyJA4IxJnJEKZSoVIkPhDAmYFgnlbA0iSUe1qQd3COWuCTJNcaoI0HYIZfABAkc4tekYOgumMjUSBXSGCMlJCOZ0MwIJrDEjDhE85oUaQANm7SL0WHzmw7xAACHtIB3gPOcDVlBMZqUgG+g850JScQMmgQAa8LzngR5wpWGVP8HGeDzn/+IQxGKSTSAwpMH/NHRArJhUHziYBVDUoI7GwpPHMQrRkWQG0XfadEhHQGGGz3nDS4KoyAoL6TnZAExYwSGY6L0myrVER1eCs9ekFRCAqDpPTsqoQVwQacOvWl6LNAOoP6Tp/OxABqMClCkdmcCm2MqQPuQUO4c4HxSNShCrYqDrFJ0q/44QFe9+lUViJWsIeXBBNHK1ra69a1wjatc50rXutr1rnjNq173yte++vWvgA2sYAdL2MIa9rCITaxiF8vYxjr2sZCNrGQnS9nKWvaymM2sZjfL2c569rOgDa1oR0va0pr2tKhNrWpXy9rWuva1sI2tbGdL29r/2va2uM2tbnfL29769rfADa5wh0vc4hr3uMhNrnKXy9zmOve50I2udKdL3epa97rYza52t8vd7nr3u+ANr3jHS97ymve86E2vetfL3va6973wja9850vf+tr3vvjNr373y9/++ve/AA6wgAdM4AIbeLtASICCF8zgBjt4wbE4cGMK8CYCSJgxFB6ThS+smAxjacMcRoyHmwTiEBtmxEMqsYkJg2IdqXjFgmlxjF4MY8DIGEY0rrFfbnyiHOuYLzw2kY9/rJcgb2jIRMaLkSWE5CTbZckJarKT6QJlBEl5ynKpsn+ujGW4aLk/XO6yW748nzCniQQ2yyyZ02NmKXUA/wvl8MQCGrHZNaOnzT+ygz12kQDuVKLOFYZVCw4RDDel5wSvxKydu4PnC5HgHdvgpH9YoNlFc6fRD4oBFNODiUoHOlDe2JAgPK1hSNmAQ4C0rKWjg+kHUcNEJVDzp+nkAUVJ6BKyLjWkhCShAeT6w6LCx4YikOjKrho6rX6QGEwEtcse2x/JdlAXEugfOjt71oFqYYJMoGhs0+kRG0JEt3UNKTSYSDmq9naakmAi1aWb3JA6loRgcW14ByodG3JGvYENqwhJSAkuo+yzo/2gXpjIngJXd5ooAEcE6eHd/IYVJDZUBoiTmFnN2NAmLJ5iZn1iQ03guIuZhQUTJcLYCv9PUws2jR4ooNzekDJ0gn7w8ojDahcbOlXCYR6ocmzIEzW/OLPisSFHBL3jzGKDiUAa2YF3CwMN988cJev0bjFiQ5+cbNWZtYYN0VvrKadTGTZEjJ3bHFaZ2JATzC50ZiliQxYIOGS37qsrLB3sPIcUCjbU7KaHnU6uk1AGqf73NGlIQuLA+9lhZYQNcUPxbWdWKjY0BsgjvVvJ2BATLD/yduFgQwng/Iz7lQgTncnveQ9UB1jenVsQPvWBgmCCsDr3wqfJDxt6OOoXD6vDJ+gVr+e9qFixIVxHxRjO2IU5oPGKdkAhC1cQYRHpzqxpSmgLUgGHf/DgBF0s4ww4pL7/r0ixISBIhZUS+lgMxQ8rWmzI11HJxYaEEX7bo6kEmpdKITZE+xGyX1TXEG5SsUMJ0iDrZ39dYgcbkgJSYSLscoCwRyckYCLSxxQrYCKQpEL/BykOYCI39BR5sCEZ8EMbCCnPkyDa8xRIsCE7QIII2CVRsCF/ABUBKCGB4IIRSCcHIyE+8hQssCFegIPCJyrkgyCx9hRwkG9CGHndwmsJAgdQoQcb8mf1l4NpUgcbMnhOIQIbwm1VOISQMisJIgJQYQ8bQghLeHnton0SQnNP4W8JogFp2Hn9ogEbMgpQEQsbIodfyITMsgfiAhUVsCESMIejxzASEIhPMYgSUoh9/6iG3ZKIEjIui0iIhohjGiOJCUKJTsGICeKIEAiGgSIFFAcVpCghUnCJPaYxnoggoNgUmoggnKiBL8glregfr8gUsegfs+h/tTglt9gfubgUu9gfvahBJTiKG5KKTzF2qKiKQpaJitiJlviIdNguxTgfx6gUwTgfw0hByUgn2Zge25gU3Zge39hA4Zgm44ge5YgU54geewCNR6YxdighEfYUo7CH9Mhk9rghbugUcIgg4NCPUaYxhLAh9gAVXCghXhiKfugrYoggZPgU7ichdWCQVqYxcCMhuucUSSghQaCRW6Yxn/OEUIF/EjIJJAlmGkNLCUJpT3EDG8IMLVlmGv8jMwlyH0/xBxsSBTfJZhpDgAhySk6xHRLCgNZ4iP0Sdf3BdEwRAyZSULLRAQhwlViZlVq5lVzZlV75lWAZlmKJAFhohV1CASayRE/RASaSZrJxCAcQl3I5l3RZl3Z5l3iZl3q5l3x5AE7JlN0SCiYiFSeIIL9EGwqALoq5mIDJLFnAglIhewjCk7ORmIx5mZiJk/3ydhJSCFLBRRJyhJWZmaRZmgQnIsKwIbkgFQOQhbVhmaUZm4t5miFyChsiBFIBBBtCCq8pm76JLrSJIWewDLrgBHjgHwUZFVuwIZ2GmL/5nK0CClHTAVfAA1DQDq8ADeawC85gDFJxCRvCCr3/CZ3kOSYRAAj5AFevsCFpMJ7l+Z4K9QWn11ZSKCF+4J7wmZ8nUgf64FacmSDi5pz6OaAm4gQGiFa3sCEMUIGvAZsE+qD+AQOi6VUfYHICCqEYOh8Z8AlUKVV9JiFjJRsOmqEkGh0L8AUuxVQ7mCDPNJol+qLcIQSXlFVjsCGpcKEwCqNHcKBGxQ0bYgQ4mqMvCgOxw1Q5IiHt6aJCmqMR8FNGdZEJcgRBuqQlygCckKIhRQUbggJTSqUlKgQEFFIhuCFXoKRemqNe8CgvBQGShiD916BnSqUh4HIvZTwSkglmGqcwGgFVIHcN1TESUnEiqqdU+gB70KEABQsbsgZ5/0qoMLoEM9pQkrAhjDAbMmAAmJqpmrqpnNqpnvqpoBqqojqqn0oEfMOYXnApDTUFImhIWaQJPYCZKgB+BjWmEtIeYEQPisSYE5B1ADUyCeJuYEQCXXeZC/AIWIpO2oYg5UBHGFAG1IYtDJAGH3hParAhuxBIs3CqiwkJqgpPA+kfAHBIihCrlwkDPfhOUKCgqdZGLrCri5kCePpOpbchk3NIPuAKrLcoC2ADyRpNTbAhnxBJDVAGzKSYa+CW2LQJG9IMmdQPK7WYG5CC33RqEgIJoMQCMXiZiDB111SfCZIBGRhJcTBPl5kCbvBNcWAivRBKK2AFmNmvI4tMEIAvbf+ISg1ABwcrrSagltB0kgiSDrC0CJxymRtAD9GkqBISCbEEBbykmCHQd8FEdBuSBLGEBCbLmCiQsshkCSayVLEkAwWwr3ySAVIws7Ekmf7xCLnEAaWQmUBwUrk0kf4BdMBUBYWpmJNwmLjUCBvyAF8ETFBASZepBVKbSlq6IUUKTHeQtYs5AZSASxzArf6BD8kUA+PEmBmACa6aSq0pktBEAUZAtnwSt7AEnhLyAiCSTA5ABEXLmH7At6CkkhJCDddUAoTLmEVwr6DUAjs7HzaATUgAmoypBBUJSusjId7wTUlQo5f5AJfQuZFkfQnCANUaTaJLui7kTY70gwhiAdv/8A4KC00OAAivu5iCgG6OxAHnyx3TcQjtCk4lELCFy7uH1JHQkQC7YA+yi09sQLyLCQIn50iNsACeUA5YwKAAdQEMu5g+hUloZlQcYAS/uyjzKGZx4QCvQLmLIgTzicFw8QZVtSiMML4g7BY1cEd8AgJGecJy0QbOa56L68Jz4QFbUMF/SwQ0fBcQMAocbCIS4Kc7PBf7QJQmYgVoO8RzwQ8qvCFHcL1KbBcX0DQbEgLfGsV4gQCsgMPRkQIyicV7kQq2Nh8PoH5gzBdoQL/pYQNCfMZ40QdNHB1p8K9ufBdXgL/QsQH+VMd/8QFqUDUwcMV87Bek8AIo4LGD/Bdw/3C8idzIjvzIkBzJkjzJlFzJlnzJmJzJmrzJnNzJnvzJoBzKojzKpFzKpnzKqJzKqrzKrNzKrvzKsBzLsjzLtFzLtnzLuJzLurzLvNzLvvzLwBzMwjzMxFzMxnzMyJzMyrzMzNzMzvzM0BzN0jzN1FzN1nzN2JzN2rzN3NzN3vzN4BzO4jzO5FzO5nzO6JzO6rzO7NzO7vzO8BzP8jzP9FzP9nzP+JzP+lw0BnA3+ywRFqUC/vzPDsFTAk3QDeFUB43QCaEIQqUCGsXQBSELEctVEk0QaNCm6HFWF90OGp0eHI3QXMDFFk3QAgAjB7Ai+wyIMTIBX2zPDSAfOuLS+P88Ak6I0ulaz3kQeDES0vXcBwOlIz5Nz99gszGyCiFaz9lA0v2x0PU8Sk1SBAhHzzJQljqCC9xiz3EgczEyAwNcz9/woTpSDD5Lz+/A1P2xBKtLz2GAc03iDnTcznGwojrSnPWcDEYdIwtQBTBNSk0yAVBYz3aQvEMSApQ5z/dgxDDiBeorzxwADGNCBvxCz0gAk0MSDIj6zpKQtzBiAWYszxcAqE0CAtIDUEkMTcigP02yAY19TxjgBxKw1tDUAss5JvIg2/hkDdCRAy0LTVMgb02SAe3TUDSAOf1abLHUApA9JiHwpvjUBXHsD0zQ27F0A9EdI7rw1QY1D/PBAHv/EL+RtALE9yagoMD39AYIYgsTGknhsLFYsgMZs1Ex4N7+oQxW60h5kJBv4glzgFKCw4L20MZM1AE/AKxNwgDqIL0NBaUm4gkzaEYGMHFvggh0GlLYINYn8gASILc/NASsoL0IsgT3jVLasEiZIOD90wFcAFFvMgFO+lKAwCeCwEYUpAjksCiTMNUo1UGLMg7a7T5ysAz8Cg0K/lKG0AqLkgLlAN67MwI2MMZj4gQ0blTK3SkhIAnmTTkNkA0jjCUM8AjILVViYAadcgSNtDvxsH+LkgOl3VZhEAwgniDOoAmkIwu4tygP8Ai43VZYQNdvQgZ/AzY0UOKdsgECQlcU/1AOf9kkAaCmJ6MD6LcoEWAMWf5WPAC0b8IAYODo3dIHdPsmleB6ezULx9kpms7pkCIKn87c3fBXQ3CtrfIpU94lNAA5sf4FZe1XVHDjuzIItNolX4Asx3Dog+UAVaDGnTIJv1DpLBINrQIDjFxYJAAM0fomgUAKk40kEHDdMZIBnMDhiMUL24AtjgALrW0jtllJdwBZh2CnM7MGL90iDWCuOuIFURVZHUAEubsrzJAN2c4i56AjiDALKN5YPoAJ7dspSvAFZsMiLYDsCXIA4hC4mBUKW7DofDIJVfDvDxKP3WEBEhCmmfUE4BDnMJICGuDcAzIEe+cfD6AB/dtZvP+w6q0SCfiQ1QXytt0NButeWqRymc6wCCbsHnnw0f5gAriKWj+vuUJACeDuHrAeHb3CWqRi8jpyAoSgB9xLHi5AKacuWzUwDtWOLC9gBZkAxdghDRogyLHFB8GQ8OiyAIPwA6KOHQUPW0NQDl3OmAAAC1NQ5N78AacAwJh5AGtABKpAzm/QwLGJC1sQqeCMBMFg4JgZAXv+zWFABFeXmSOJzjcgDVCOLomnziTwAzyNLSrNzs/QDJTPJ0rA7OXsAd1QB2jNnvRsCujguE0SkPScBdaA5E1iMvgsCrBA5nCC0NcgBe6eIGBw0WxAAEU4H58t0aZwCq7A2dBBsRc9EBz+8A2Fxh03uP0JYQmnAAQ78HjivxAOkOvp3/7u//7wH//yP//0X//2f//4n//6v//8DxD/BA4kWNDgQYQJFS5k2NDhQ4gRJU6kWNHiRYwZNW7k2NHjR5AhRY4kWdLkSZQpVa5k2dLlS5gxZc6kWdPmTZw5de7k2dPnT6BBhQ4lWtToUaRJlS5l2tTpU6hRpU6lWtXqVaxZtW7l2tXrV7BhxY4lW9bsWbRp1a5l29btW7hx5c6lW9fuXbx59e7l29fvX8CBBQ8mXNjwYcSJFS9m3NjxY8iRJU+mXNnyZcyZNW/m3NnzZ9ChRY8mXdr0adSpVa9m3dr1a9ixZc+2GxAAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48ePIkytfzrz5WxqpnEuf7pEGLDP+/Fmizr17RB7qAmX/H3/Ou/nzBfM0mjG+vT9n6ONz90BrDAP37hkkks9/eS81SuAnoD9c9GcgcUOMcsSADGpz4IO+GQLOCwxWuMAFv10hDxUQeucDEexVKKI/mfxmTHbkLNJCh87dEUyAI45Ihm8Q4NKeI8HcwWJyJSwR44/+vDBCb2cMWIAYOw7HwSlOAOkkJb0RUuEMmXCQZG9DEACDk1zuwlsiGYwIgjgyXIkbH0ZMwOWaJ6yoGwFAogBLHmbOVoMGD6yp5wnP6AaBLVxa0AwSdbqmwy736enkCYTo4WZu3yjKABg1FJqaDiYo6mQGVrTz6G6ZasoAITpYShoqoWoaYzWLkABcInmq/5qdCaWa6hkbqcrKIC4VyDEcnLqOF0Actmr2hDSJBovfBBooUtyfyo73gAZ8FFtZKObEGm17fiziw3HIbNueBUa0YS1kPliTgrjjpVBLrcjFUcu67PqjBAEenLsYBp+oUK8/THzybXMrANJkvVFk4oC+hx0CQL0MuCKLdyyYkOy2R7zB8GC8VFLvAaXYEZ8qdMAo7hI6btxXDFsswK4t54Rh4AjniCeuBbAMqTJeDhCxA7uTdNNBhx344gW7IEgCwc51UUEOu9ucUec3A7CbSydMx3WBBuy6QoOtvQgh7gLArJA1WxBI8nO0DAABb7GYigsDPGenlcUx205aqcpxb/87yC11k8WBNWFGu8veWetAzLYRvINB4GBp8nC0ZKACuUA0bLMtOddcvlULwGyrC4eeD8SCJ9EuUEq+pVd1BnbKMoFG6wYlk0O0ORhCe1Q+1BJtD7MMvXtBDfSrLAM2WDn8UjfYrOsE+HSxPEIjYHKCsk58Pb1RHHBysaru0Ll9QnMAoewC0Dw+flCoMKJsLgasz9ANTwc7CbHy8wQBOhYECwM7+WuIA+yBh2BNoAoBzIkptBGsB3BCZwlkCAlq8T1FLSEJEaQJHJoQrGL0IYMQwQEkghUCKIDwJRQIRrCacIoTRsQBnziArhiACeG5ECVPmESwlIGhG0YkEbsIljP/quXDkujBZJqKBDWKSJFwREFXq7gHE0PSABXKagGcYN0UJTKCLQQLFAvb4kb4kAtdZU+MFlFEJHQVhCugESOGKKCqHpC8N1oEdLpChO7sSBE7rE1RTsAaHy8yhTXO8QeDnMgbKvijPXwgkRhpgRdlpYxHQvIhAliTGVhwSY0gAwSyWgc2OukQKzgJDGYjZUaSYEpVwWCPqkyIDAoRIyWIIJYcsQe9FGUBSeAyIbzY5YA8oYpfciQO9dMUJ8JoTILQokKgUF8zNcKBL8jKCjKb5kDoICAVaEybHRHGKlRFDiJqEwO6cM8A9gNOj1iijJoKgSC1GYoQjAeM7QRJFVU1/4FhtNMQGUiAFPMpknagQFMLaCE421FMgo6EDcxQlTUcStGQtEBKmgpGRTfqEQIwckQTwAJHR7qRQziCSwsYKElXepE4HOxHs2CpTC+ygk38SAAzzWlFOjDJCgFDp0ClCCBcNqBlMDOoSHXIME6KnyBQIKlQfcgfntgeckAwqlhVCB+YMJ5AsDOrYE3ICqqmAheE9awJoYAG4ofWtrr1rXCNq1znSte62vWueM2rXvfK17769a+ADaxgB0vYwhr2sIhNrGIXy9jGOvaxkI2sZCdL2cpa9rKYzaxmN8vZznr2s6ANrWhHS9rSmva0qE2talfL2ta69rWwja1sZ0vb2v/a9ra4za1ud8vb3vr2t8ANrnCHS9ziGve4yE2ucpfL3OY697nQja50p0vd6lr3utjNrna3y93ueve74A2veMdL3vKa97zoTa9618ve9rr3vfCNr3znS9/62ve++M2vfvfL3/76978ADrCAB0zgAhv4wAhOsIIXzOAGO/jBEI6whCdM4Qpb+MIYznBRgJCADnv4wyAOsYdjoeHCFEBXBCgxYU4sqxSrWDAsVpWLXwyYGGtqxjT2i40VheMc82XHeuqxj/UC5DUJech4KTKXjoxkuyjZSUxuMl2eDKQoS1kuVP6Rla8MlyzHaMtcdouXRwTmMLNlzCIqs5nVguYKqXn/zWhpM4PeDGezyHlAdK4zWe4soDzrWSx8xo+f/wyWQLtn0IT2iqHbg+hEc2XR42m0o7UC6exIetJYqbQ/Lo1pq2ia052myqdDvZZRkzotpj71WVKt6rKwutVjeTWswyJrvo7gDFd9Y633Gi4GMEMDVdCBDae4a72WY1m6sMEvRlnEYuc1y1FYQyN44EJn4xWUMWpEtVEcWD4AyYQntLZdFQAkV4Wb24C1xo9ycENx19UVPwJDu9H9V+eJiMTbbjFgfQAkJOVbxoClApAw+O8bA5YIP0KED909V2vGqA4Lp3dfNRejMkRc33+1Z4ygNG+M93UFQLJcxwHu114ASXoj/ze4X9nxI1s0W+J7lcKPZnRxkvd1GT+SwMs9DjlTaOIUNniHVUYYo0Xs3OYq83kmpEAIcgjzCFaRYYz8nXIeb8wSy3C6iCZQlSEASWQ1V7m+8gAkN04FBz/KwLDPzfNzUShGfZpKO35UCCYyPEkRjREtqFKPmdsd5tbyUYxwOpXQxWgef2+7tYzwI1ZQZXExEvrRxa6vc/xICFQh+oh8kXiknysaP5oBVeQ4Ik10nvLnMnmMVjGVD3z99FbfGDaAZEmoqOJHDGgA7IOsMgx8FD8pg4rqRxQCYgPeWoj40Q2kQu4YkcP4ircWPEcUDalUwe+7N/LO0FygqODjR+OAvv/nz8WNH11CKj0VESjEj/pzqeNHW5AKzmNUnuwveWej+JGXojKIH3He/lC2M93wI/ARFckkIt/AfrG3MUUSI4wgFVrwI9ozeQvIMKLwI1EgFcJUIWYFgFW2M7cXI1wHFQ0AJD1EgbynMjEAJLr3FEkAJEdVdSm4MRAAJObyFHbwIwewRXd3JUw1IsHXFH/wIz3Ag8dnLYASIyLnFAIXIwBghNFnLQsSI8v3FNTwI5AAheN3Ln7wIwn4FM03IkGghe13LkHwI+EAFSLwI2lAhhXIMGnwI7f0FJKgf244gxuDUSOCQE/xAz+iAXeofTvDNTGCSH34h4F4fzvTDD8SHU//kUkx8lMKiIcMIwE/UgFQUQE5l4gBuDOWGCOY+BTvFyOPwIkf6ImXCBWfOCKh6IFaxjTqFiM69xSrKCKtiIKCqDKaKIuqmIqTmIsbs4sjMotOUYsVcoth94b6IowiQoxNYYwMgowyCIwMw4wV4oxMAY0DIo0Fp4znYo0Mgo1LoY0Cwo1st4XWAo4DIo5KQY74MVG/qIi6uIlPoY4Cwo7nWIbW8gg/og6ZSI+u+GVM447uYY5IYY/4gY8g1INJYngjQnhOkQqIGI+dqDKEOCKG6BR+GCOASJGnaJE/kpFNcX0xQgim+Io7E0Qx4ktPsYYxUgAnKZA7E4cxModOEQ4//zKGHomSKnOGMaIAUPEGP+IHMUlmTKN5IrJET3EDPwJ1OymTKjM5I0I6TqEDP2IGRZlmTNMDP/IHUHEHP+IIWelmTCN1IwJ2TvGCP7I0tNEBCPCWcBmXcjmXdFmXdnmXeJmXeokAdXCEtuIAA0eCQBIDtXEIB3CYiJmYirmYjNmYjvmYkBmZknkAhYOOtnIBLBgVahIjDTUbYfgvoBmaH8kwLvAjKSAVXBkjolAbnymarvmah7YzNPAjWiAV7hMjUkMbrQmbvCmaoCYfkRIjGyAVzvAj3cCavZmcrvmb8eELPzIIUqGSIzIKyKmc1lkvzIkelhcjy4B+/Vid1xmeyv+yfioDCvAnFbE4ItwAnuLZnpoSAYCQDxszDj+CD1LBBT8Ck7rpnvyJUF9Qe9ZCBj/Ch1ABejGSC+zZnwoKJHWgD/pygBWShlHBlDGicPu5oBgKJE6QBeeicSPSC1IBljHCANIUG7uZoSgqIDBQAsXSAL/nHp35FK73I8wmGyeaojg6HhnwCTF4JTn4IwD6FH8kIiDqmTl6pAKyAF/QgnWiCT+CB1QRItR3oUhapeMhBCd4Jc4ZI1k4FWJDf1RqpVZ6BBxqJu/wI65AFebwI0YQpmJapTBAdTsyDz8iiVIBLCOyBG76pkgaAd23IwIaI/VAFc8UI06wp3x6pAzACUz/CiG0FCPtQBXP8CMvgKiJeqRCMAREU5kiggNU0QZAIj4meqmJ6gWIYyA/GiOaShWbySApQA7LsB02SqqJWkIPIgY6aBVTmB2vSghSkAmaYAq3caO0mqMRUAVsyR+LgIVW8Q42cAo3IKy9QazFiqMPsAc9ah4E2R7dyUfUWq04ugRZeh6BOiJSMEgyYADquq7s2q7u+q7wGq/yOq/0Wq/xSgQR8Jpe0IHokYQjAkCnpQmpKZoqkJvm0QVAUqSnRQ8b8JoTwJLegQpAkkqoRQJr8JoL8AiNOh2UkHCshQFloC2gyQBpQJjcUQY/sg2uNQv56pqQwK/S0ZeR+FqKMLCh/wkDVSgdyRcjRABbLtCwrpkCJeIcahkjVOlaPuAKL3o+NrCxyIGrPzIwsNUAZUBUorkG5qYcsfAjkVBb/dCqobkBvqIcYPAjJmBbLEBVookIU6ActxMj9mlbcSCloZkCboAcJAAkQHlbK9BKorkANvBUxQEFQGJOttUAdGC1I2sCFCscjfAjMMBbi3A9rrkB9EAcPNAIa6C2RtJbUOChoRkCRzsc2PALNqALYJsd5eBbSEC3oIkCd5scHaADVaABzHAf/uRbMlAASxssGSAFgrscK4BrwMUBpQCbQJBrs2Z9G/gvk4CWyzsVUIBtoqkFoxu9X+m6/zIBHIe9UhEDgv8nmhmACSXqvU5BAUbQu8GSvOYbFT1DuaLpB9Dbvk1RAtQbmkUgUvT7FEjAVa5pS/vrgmPwmg9wCeUbwEiBvuqrK4SQTQisFA4ACPAbmoIgqw+sFCXAQa6pBfp7wUnBBv4rmiDwVR58FBdgU6G5AH9awkjBAUaguOKyByzMFA7wCi0rLkIQpDOMFG/gL9vCCFm7w0tRA28bLCBAKELsFG0wwLoSAXKaxEzhAS0zRz0LxVABAaNww2siAclqxU+xD0MKJFYQvF4MFfxQxE1psmUsFRfQfz8SAjC7xlGBAKwAwwKSApwkx1aRCm83IA+gUHpsFWigwQJiA10cyFTRB2j/PB5p4LSIPBVX4DHtsQFl8shZ8QFqkCgwEMeWfBWk8AIo0LadzBVwYJOjfMqonMqqvMqs3Mqu/MqwHMuyPMu0XMu2fMu4nMu6vMu83Mu+/MvAHMzCPMzEXMzGfMzInMzKvMzM3MzO/MzQHM3SPM3UXM3WfM3YnM3avM3c3M3e/M3gHM7iPM7kXM7mfM7onM7qvM7s3M7u/M7wHM/yPM/0XM/2fM/4nM/6vM/83M/+/M8AHdACPdAEXdAGfdAIndAKvdAM3dAO/dAQHdESPdEUXdEWfdEY3RoGoAFk3M8u4C8D0Lj7nAjOwwSGm88jAKFR4JX6TAE+6R6OkLv37ADz/5ekgIDPDskgW7B28AyJI7IJIu3Os+AkToA/73wPdiwijnAI74wFqYt72SnNVqQohPAp6ZyeesIMbHBXqhCp4HQKSf0jKODVc3UPCZABsDRNw/DUThIMjhxWDmCe2RECodBOnQC6a5ILFoxWiVA17aELB/xLfAChXLIKwtBWPSwgdJBPYeC3ivIFyoNVGCDXA7J37eQAnCAr5GDUSaUKqFMhKcALBCUJ/aMpKWAPUCUCSMQghVDJ/7QlqmIFBJdTK1C2YuxQ2LAOsgICyJBTLAA7TgKR7fQByqArW2DVFfUBeyAp30RQPyCyehIJorxRnfBSerID8wtOhrCzqgIMyP+tTRwQsrKCB2mdT1fw0knkLPlEA9atKLlw0gQV18GyBcobSx4AC2Hd1m9NUPcwTrISBRL6S9RgSKqiBHowU3xQnLqyCyR8SRdQ3LoyCU+gUx2ACQtcIQfAo510CoSsKsHQ0TP1ucECCZ46SH1QDCsEB1GVBOGrKgxQC0E8RSPACdCtKNogrVhVBWy9JnhgD9l6QuwA27JiAehwyFEVBzoULOSQsy5kANMnK4ywhGeFAdCQ31wCBHNwQnngDsfDCZHtVuytLCeACfU9PV2ADzu+JoHA5HDFATZw4SKiAp+w36XTAbNgs7JSC1JLV4awyKqSA8mwPWgQwrpiBgZ7Vx7/UApWziWekMetQwXpFC3e3VfXQNiqsg0TGDioUK7BAgCm91cY8A5arCvE8DY7UwPS6bvW8OV/dQtuHC20cupgAOcjcgxlWljwIOTKEuvnogNAQOsisgNKk1grAAyLviZCoLCFQgPwJi4aMK6I1QlPriwD8IVXcgYUtznXq1gQcAr3qyxe4As8zR8d0A1dKC47QAQ/vlgjAAulvS2BcA5l7h1hcA7+mjpboMaUdQctHi1KQAcx6h12UApmuS2VINqa9Qa7mjcm4OjUIQtKWy8AwNSd5QCZwLnb4gSAENTI4QOfQOjbIueBrVkeQACrHS3uEoTGoQPz8i8pYA17Hlpt/2AE7y4uvW0cPrAI514vD2AOdY1afIAn4mILRv4biqABzcs20jDhrBUHAbAtUW0aclABNhKaJrDVsNU3svIADb4bJLAI1eCaJiDlsaUDhADs7XG2vdEC7WAFnPovvH5bNTDrimLtuNECekAIE/wvDLALpo5bSNAMNR8jRK8bz7D3/zItp9pbeQALB8WTd4/44jIBRgDfvyUD4vDtAsL1vJHqckMAq3pcHJAJ2tseJskbHcsuTnAKrJ5cYqBkh54bI9DHwbIELCpdLvKD/oALRX8bnK4pSpAj19UCi1A/xvAbmSArM0AEMX9dVCAPZtcbF3DsAvIC4FDe6cxATnIEo/8Q+u2cDT+iBGqg7O+cCC/KAGNAC1o0zwqOHzPQCKJqz9vZVepAbftsCdlhBrCQ6fwMEKlo/CNY0OBBhAkVLmTY0OFDiBElTqRY0eJFjBk1buTY0eNHkCFFjiRZ0uRJlClVrmTZ0uVLmDFlzqRZ0+ZNnDl17uTZ0+dPoEGFDiVa1OhRpEmVLmXa1OlTqFGlTqVa1epVrFm1buXa1etXsGHFjiVb1uxZtGnVrmXb1u1buHHlzqVb1+5dvHn17uXb1+9fwIEFDyZc2PBhxIkVL2bc2PFjyJElT6Zc2fJlzJk1b+bc2fNn0KFFjyZd2vRp1KlVr2bd2vVr2LFlz6Zd2/ZNbdy5de/m3dv3b+DBhQ8nXtz4ceTJlS9n3tz5c+jRpU+nXt36dezZtW/n3t37d/DhxY8nX978efTp1a9n3979e/jx5c+nX9/+ffwnAwIAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq168FXhpV4Tbs2XhlvBBDr4c9fNdvAg6uFwEZSM2a9k/dWIry5864dOqVKk0C59eS3nmvf/hRCp0ZkUFz/H5/8F/fz6IfakQSkCfn3yTGln0/f5oc3dArB359cSP3/AKqUBxFpTMDfgb2FEOCCDHrUhwB+IChhclc0aOGFEdEASisTdtjbGxiGKGJBNMBihoco+mPMiCxa+IcUkaQoIxAt1lgfNu8wIeOO/uRg44/bheHGNgzwaGQYQCYJnCIaiGfkk4YoKSVrSaCTw5NPmrHLNHNM6aVpsgRgAZYyrrKEOCVc8OWao8kwin5keugEK24gweadov3BjYFxSniEEckkgeegn0EAxwB9IhgJK7/EQOijnbXwAy6J7ufILouoAummm4WiTnWVksfII1NgwOmpmCHBzZihWvfANj/I/4HqrJbpAESRrSZ3AjGUkEDrr5NRQUauui6jRwvAJgvZDUEQ688LVrSDrLLUMsasswOcskK13CqGQx3EAmBMl92WaxgPJuSqBDdYmOsuYXMog2ulxYjQxbv4AjYEJy+EmkAwPOQrcF8c1ANqohvM4sHADOsVTYyJZpBOu/m6A0XDeeFQTKVNYGLKwLT0ZsITGNN1hQaVAmDPBwx/cGJvFtjgQ8lvQYCOI4k6AwcEGBtzHQzs0OzWJn1aQTHGbShBni59CL1WDRk8yQAYTQttDnwP0DGC02nZwOMDGpDsdBYP8IdIN1yf5QMiKYItNtfDIkgGuWmP5YuHDIzzNtdndP84wTkd1D1WNRMSUoPg/zgwA4reiII4WH2Uzd8mOjz+zykyPgANBZZ3ZcR+k4jReQsh8HhEJ51vJQMI5AXSTur/XPLkA+pwADtWmVx3QD22w45Pv08y4/jtVUGQS3ILzCMo8f/Ike6TGYjjAPNTXVPkAFVTLxALXmBZzN7aN2VNNOEX5AAXqzyJwinlt19VEs1guYuv7tcPFRbkZEmF/fw31cEPTtrRAgQwvf4ZECl8SMOTBvCxAzqwKNEoHY9AcLEHWjAoK+CGkRZQAZ5d8IM9OcPLdjSGIYDwhDrxQS2MVAQcoPCFNxEhj16QCRjacCYjcIeRWNGAG/rwJclwz47/jhGKHxpxJYkQAo8QYYAjOhEln4jAjk7wuidacSR/cAKPrHHFLoKkC2rg0TIW5sUybiQaOJORNxJhxjZi5Bb5k5EZ2ODGOlLkA2GU0QFEZ8c+QkQEJ5CRBUTgx0I2hBdwSpEADMnIhMhAiTICRgEbSUmBOAATOwJCDyvJyWQE0EPamBknK8mDQMhoEmoaJSWToAsZOSEPqqRkA1CWokKAL5Z+RMcCUlQEO+GSkcLgk4dUwItfMvIZKkjRAVxozEKqAgDKZGYz+ziEVqJomdP0owesEM1s9tEBtPQQNr1pR1CkKAEBI2cdR5EiFaRTnW2cxS49VIRbwvOK3WBVh4pg/4l7thEN+pxQIZbnTy+yQJgT2sDWCmpQhEpoAGRk6BUPiiJiTFKiT6Soh8aB0S7i4AAogkZHr6gJhyLIHiO1Iguk2KEFICOlTwSohyaAOpgeUQHznNAmbOrEkE2IDKLkqREBISFzBE6oTizHgWKB1Ct+AT4TSEZTr+iAAJAHBDSYahcb0CzrMMMOWvXiChihnG1sK6xe5ANv/KGBTaLVi384AAHe6sY20PWueM2rXvfK17769a+ADaxgB0vYwhr2sIhNrGIXy9jGOvaxkI2sZCdL2cpa9rKYzaxmN8vZznr2s6ANrWhHS9rSmva0qE2talfL2ta69rWwja1sZ0vb2v/a9ra4za1ud8vb3vr2t8ANrnCHS9ziGve4yE2ucpfL3OY697nQja50p0vd6lr3utjNrna3y93ueve74A2veMdL3vKa97zoTa9618ve9rr3vfCNr3znS9/62ve+VMGECeLBMvyu5mVKUEYJjko8ICTgwAhOsIIXjGCm5vUZ1wEBMI6WugIYaa55DcZ7AiGFdz7OwjzC8F0hEAX+HOEdYEUciHckYroaQkKE+PCF80oHCelBxiHO6wj3g4KI1m3FMmoxWkUhITBYDsgpEnJYrSEhYRx5xnc9AoJQ0F8VQ/mtt5BQADqHZBQpearsRFAVccziu1YCQS9YKJmDTNcwBBT/PmSo8JXDGg4JLULOOX6rBhFURC7PWaslPpA3YNdlD31ZqDyQEBfxXGa0hvlAvSD0n5u6BAThwYN+zrNWG5ACBCnjdoXu0KFtqgkJUQLUkxYqkxFUIUlreqrW5M8MiBfqCY06pR5483tKQetU23QKEvpGr1+N1AogyAL3QjWxhdpV/hSDebWW0K072oBAHkgK0PZ1SnshodkMu9FNJQWCFoCkb7N5qlY9kB+oF20ETRujRUAQJ9it7Y7mQULxoPeyYRoPCcEy2/tOqdcOVATttftA72boIBC0ZX2DW6ggPRApDF5viWYZQRRW9sNt+otxJxvgG4epFBDEiPAdnD8J//fnGBDkDpNXnKFsO9ArXB5wjA5BQhnX+Ll5CmwEldvhO7cpUQ8UiPKdfD8ph+ee+UMMo7/cn55AkEhpHvKRHmw/N6Z60FOaBAnRUetJFqoiEPQAU4Hdy0KdBYIA0L6jwyfp5IQFgpru9JozlJsHekTbnw5PHR2ohnWvOkatzZ8oBX7rHU2EhNh4+LDbFAsIioD73P4euGeTEghiwuT5Tk4BICgNm7e7P1d4oGCEXvAMjRt/Jr530d9TygcyT+tRX9D0Qfr0iJdoFySEDdw7PqV3GDeBz27oXyMoCvWjPHks38xoICgXyed8Nrnw+ei7Xp2yO1AtrE/7e17tQOrgfv/uGboGBP1A/L8fqTMQhDbfox2mZD1QBWc//oIGmj/Do3/6O2pS8mjK/cWXUg0gIfSjf+83Um0gIZjWeAfYUcF3II5gP8o3Hsz3SzqAILYggdLXTDdAchp4fd70BggyCR/YfepUZwcSBCVYf/ckAghSACu4fxJVBQgSY+jXgBj1AwiiATGIgxL1aPvBgzcYgCNlbAeyBz1IhB1lhPwhAUkoajDFhPvhhEMIhSlVCghyCU9oa+8CBxqgAWtgAmIoBEFQhkEACRuwAQ7mFBKAIBWwhdL2LlIIH1TIhm4Ih+4mhwhSh03RhgfyhlXIhe4yh+/Bh0zhh/wBiABoheZCiOT/YYhLgYj7oYgGqITd4ojjAYlKIYnwQYkMaIncgonXoYlJEQtpCAlmGARCIIYmsAZfCAd4iHDvkn38MW+KNYHXUYGPwonv4YmGhYvWoYuEwovk4YuFBYzKIYyDsgd3eIsbuCnhtB+jsFjImBzKiCfRCB/n54wgiCrLgCBVQI3PCCkKdCCExI0mSCvNth/hII7deCqTgCAggo4sCCzxxx834I7pOCu2gCCVQ48yWC1pxB93YEAdgAAImZAKuZAM2ZAO+ZAQGZESOZEIAC7vuCkQICF21T+HcAAe+ZEgGZIiOZIkWZImeZIomZIHEDUXCSkkICFuZT8K4Cw0WZO56C6q/4AgE3BAM2mTPkmT18gmRHYgyGdAPfmTSBkqQbkmUOCBRpmUUJkoS/kl7YAgzsCTUZmVWDKVXqKDB7IGWKmVYikjoOAu6oAg5hCWY7mWExIBgJAP5UJ6/KGFT8mWdjluX1Bl1FKO/MEFanmXgAkfdaAP3HI8B0I+dRmYikkeTpAF1bJW/DEFf7mYlJkcMOBtwNIBObUfBZmYlfmZ/pABn3BRqIINEvJx/HOUoPmZC/AFMXkqNIAgq+BAqrmanykEqYQqHXcgR0CbtvmbR+CYqCJuBxJnk/mblQkDfMQpGqZ9vomcthkBfskpfLkfi3Sc0EmZDMAJr4knfscfp4ad2f9JmUJgQo/CUvyRc/VTm+P5mV5wOIOieAjCeJ7ZnqAZAvPHJi92ICfwQOxpn5UZAVWwgF6SOweiec8JoLb5AHtAmlLyCAhiBf6poNC5BLk5JcSAILDwQDJgAB76oSAaoiI6oiRaoiZ6oiiaoiVKBOiZK17gAl8CTQcyC5elCZCZKypwBlOCAZLDH4qAWfSwATQ5AZIgJWwgIQRlWSRQfs6yAI/QnSyiB7K5WRhQBj3aKgyQBo7yI9CAIJ7QWbPQoq0CCTBqIxl6INzgWYpwo60CA/lYI6Z0IIDwWS4gpM6SAoA3ImEgIZL5WT7gCvPSKgtgA1DKIJCHIOb5WQ1QBpv/2SprUIAX8goIggik1Q/9hzCygiE6dCBjUFoscH+5ggh9aiH3uB/YVlpxsDh36gYW0gWN+h6yV1orgHfEMqicsyCHeiDZcVoNQAevmigMYAJnBSDEyR8HsFqLQHi5sgH0ECDpxh+DwFpQIEHEEgL78x/xdiA20FpIoKrEggKsSh/3hiD51loyUACBGioZIAW3ih79hiD/1locgIU0CQRqxh1yR3CyVQWd5iyTkGLcESEH0nCxBQWs4yxacK3aEQa/Oh6sJ1t34K25MgHh+RwlICGRRlsxUGnOkgGYYHbNMXL8WaiuRQFGkK6hYq/OsTEpiFsOQATK2ip+ALC20QW6/1aMulUCB0ssRaCerfENfLpbSPCd6nKOtUGv/GEBPoZbSbByzvIAlwCyriGx8KELvmWyKFsphPBzrHEFivZbDgAIMRsqgtBPrYF5CKIJwVUCQkQsWuCzpaEMCJICJJtbbEC0rQIC9IkaEIAHCLIExHUBRJMrCzCdqsFtCDKNxMUBRtCwT4KErLFqB+JhwuUAryCmWCIEepka3nB8yfUGyRQnjACpqREKEpKmyVUDV4IlIOBLrLEIEtKOytUGTssjEbCcrKF6+2EBXItcHrAFjnsgD0AErzECwMMfleBcEDAKmCshEkCgqlGViQtd+7ADKGIF7doaz8ofu/pc/LC6fv+ypa7xAZ8EH70pXRewcAgSAmX6GsLwtdOFAKwQvL2RAixgG2AgIfk3XalwvOPxAOxTGx5Qvu9hBtiFBm17HTYAvawhpQhCB9nVB+CrHGlQt6lBCBJieNh1BWemHBsgA8FhB8YAe/ARBQxMXXiEKzDQvsLBA1LQj+Rhet1FCi+AAqOqHVgADDubHM/wXXBgtOfRASWgDErjDwbsX6rxAfFgAvKBxE78xFAcxVI8xVRcxVZ8xVicxVq8xVzcxV78xWAcxmI8xmRcxmZ8xmicxmq8xmzcxm78xnAcx3I8x3Rcx3Z8x3icx3q8x3zcx378x4AcyII8yIRcyIZ8yIicyIr/vMiM3MiO/MiQHMmSPMmUXMmWfMmYnMmavMmc3Mme/MmgHMqiPMqkXMqmfMqonMqqvMqs3Mqu/MqwHMvUspGyXBQEcAB/UMtDMUu90QN8oMtAsQLboByMMKzArBN2gBzWEQQWfMwvQQM7rBwB4KDOHBPJcKm98QXVXBOxcCDlsM0x4QDfJ6fg7BI+oLsHQgvlzBKDOyELILvrjBKdgM3vYQFoEM8pgQz0Ox4ncL/4fBL2gCIT8KP/bBJdKk7SVNAjMQ4oYr8KTRIOcKZ+488PHRIegCgzRdEV/REjYKcTvdEhkQSJNCH2DNIgYQnZ2iEW0H4m3RFPkNLuTKMt3RE8/xC6HqK4M70RPHB1E1KWOb0RH5UiGkDNPz0RQX29S1vUFHHUHqILiarUFcHUHQIA/wfVUR1xw5SxVk0RvGDTfuNkW00RSADT7owOYU0RTzDSHdJWZy0ReaBFKaILSdrWDXEB8ZgigUC5dL0QI6ANMqIEUrXXDtEAQLAjmEDUgm0+wLAjQgDCic0QnicjhVBMj70QInCzOgnElX0QYoDVKKIGm7vZBMEGO+Yh5NC9ol0QidC5MuIIiJnaBeEB37gjaoCasC0QkpsiTpDLt00Q7TC2E/ICn9DbBGEAMScjQrC3tx0Kx8AjTRDYxN0ArGAk7nCvt50J/osiZqCjxP0POP9A1ihSC0F12xdQu3LE3b0NARWwz/zBDcYM2wZrJCHw2rdtChjNI2nwy73tAALA3jz2A8OX2lRQ2ilCDnCb2CSwC1jSDHMt2pJAwCiyClyA2MQTDYuGVk/AskbiBRpNPX2AKAxQU2jlAOLAkkZiAplKPEkwDzmVCyeMVKKgzEbyAvhwOwXj2b2Rp2/FAepwpTJCl53TDnEaYY59V51AwikSAtPyOGJw1+9hBHpFAdDg4xMSwIijA+2MNdmDV6LA2h0yAxTeMDUw2wjyG3vVAedAz+OB3lzzBOOQtfvhC301B+gMZ3XzBBpA5ZM63nrVDcf9Hg8gnEKD53o+IdvqVyP/QAeF3htpKTR9AAZw3iEZAJ9+1QexZh1KQMsN8wy0iiU7FVjsAAPXsSINAwH3sH594gjo8OJ5NQI2oE9mENru8gGSANd9ogGtRlhP8DzqLDCmgAkJTCbHkNCGBQUtly9YkA6YzSORQN9h7QGz4NF9kgC8Q9c8EAw8TSYvwAlPbdVdIAIaDqzKQDdbjQXcUMShYgJ6XdRzYAwy2ip1QOxFvQKncN+tEgRvCtUt0A5WkN2Vgu9W3QJ6sAzAnShkoLA/TQKUQAwF3ycMsAz/+NNyMArbsOh9YgHc4LotjQFT8Ail6iwJoA591tKqsAi7MJA1iQs/sOQbHQO/wAoQ85MD/7AzIJ0EyWAESO6TE8ANvP3QSOAGrGDrSVkIpFDk+HwBJSAOS2B7UWkBASALBT0H07ALBA6VOYAODb7O+ymWKKABBF3Re5qVDLANbtC7FT3BPskE79B7P13YPhkJUtDzRe0zNGkGsJBVYS2CudIKoID3be21leIHArDle02tRjIBaUAE8VrZkLQjhUAHbyDrj41JKNIEQCAJNNvbuzllZNAIncDqqX1x8JEAaZAK1xDg3V0Q6K4czNAMksAGoJ/6AkE4/tADxCAAb2D0st8QJTAMub77wB/8wj/8xF/8xn/8yJ/8yr/8zN/8zv/80B/90j/91F/91n/92J/92r/93A7f/d7//eAf/uI//locEAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnzyeH8CghIpYUbsSKMQPNurVmCnHeELEBRlerCP5y697dwrXv34kbZFFgbJyzKLuTK9+NDbjz53o9oBLxaEmrBcuza/fHC7r372yvlP94FwAA9u3otd8Az7691xglprnqkb5+egXu8+uHCqGPPQ0A2CdgfZnsZ+CBQzVARSNLJDDgg/WlguCEFNrUwTPiVDIBhBzWh0mFIIaoEhKfEONIhyjWN4+ILLbYURhwmGNGijTWB4aLOOYYkSo/aGNBjUCmV4eORBZZEA7qMBLkkukJYuSTLjogSzBFMGkleoVAqSWFUm4BwpVgbtfElmTqR0MwX4YZZgS46BLAF/hwoYcYWZRpp3d3QNOKmkvC4Ik0mEhSAi9D3GkoezEQkQufKTahSzP1wMGGB4dW2h4EJQDxAqMPNhFEMPZQEYOlpLpnSTlacGqfGbsQcEgepcb/2p4DhyzBgKpiLiHANxfI6it7bRCQKq7LMWEOPHf8qix4nYDzI7G6MbDBI/cUuuy13xkDbW7M0AEHCdiGC94FuHHaRDrsNCfuuuBpwKc35fTiALv0gqfDlS8UsAis9fYLXjVBHgBGNL35a/B38dB4gDKHUHDww991UCWEE4DRMMQYf9fIgA8s4UvBGYf8XAwn1LcBKVeIrLJ3aohJxx8rxwxdH9lVEo3DMufs3AC7gVDGEzoH7ZwwuRXTTQNCJ/1bB5zooPTTUEct9dRUV2311VhnrfXWXHft9ddghy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+332H2k/PfgQckQSQhTEK54T2vktsA0i0d+0w/JCQGu5Ji/JMqmydkiSuagqzTCnsudIELoqJe0DHrBYJD66x5VUd8AgsNuu0V/lJueGU7f7ntEYeQw4ATJ/G58Q+lwSMDxzB80C4rpfND89B6okOIxvU7PfBxHpIhLstof38U4Ke5gSPjMz6I7hBZ0g/7xqASSIinvGx+DNinCUv/vDsCSojtI29/torGhDpGBUgK0HSomxqFcjCCBtgvFojrkhexBMHUcAAeKcsCvC6ZuGigyA9A8mDpfPAtCUeABCVOniB10SAUqXGHo4oCLF8ZQhplLgh9siEPQhWEMHWpCH/96mLkGJI9DMCRi5iTwQjYoEXMg5FARRvjExX2iQ1OsYuREcJ4HFcIUWlycME44oBmMKoyEQwMZBZQLkKHRb28o4IMGEcA3+o0FchwQIeZlxzvmUUDA6OPf8MghyAmyb2JYo31Od0i+qRFCGShBIx2pyPQoAWaT1JsvuiggLSQik3pbBIe80QVQ5u0dHCIGH01ptzJwiBOsxFvLIMSOWNrNAWlg3zNsWTcPHANCIVAXL+V2gQA9yBsIHGbc7IAICElDmXPrxB/r8wNoyk0BtxpQBhRhzbjFApih6CbczAEhZ9RRnGvrAP4eJAF0uo0EhYBQONzZthqcaECrsAM92Xb/CE7WRxDn3OfZUMlOga6NEBA6hEHTFgZmPEgF4Vzo2ZCghAdtQqJoI9qDJIRRs/lvQC9ARUfLhoFfDogZHBgp2fjgwgHBUqVjO8SDGLAemIrtEQ8KhA9sGjYMrONBauBp2J6AAgElgBJCDRs77FMAMCY1bGBATwIY+dSwrWBG2WlqVck2heU44hRbNRsTdzMGPoTVbB9wQm6+ela0XeMBlTBrW9GGg7na9a54zate98rXvvr1r4ANrGAHS9jCGvawiE2sYhfL2MY69rGQjaxkJ0vZylr2spjNrGY3u7JOkKGmnH2YCXITBNCGtl41yCZpoXDaemlQOZ6QZGvD9YQH/2gntrO91hbSAwk45NZXSShZfSBhgN+WyhoDqpNxK+UBPAjIBMu1FBcGVNfoGgoCpKvPGKx7qHAMyLTcJdM2BOSJ8N6JBwMqnnnLxAoBtQIC6yUTCaapHS7El0zftA8eknlfI2FXQB/qL5TOIKAHdFDARUKofQKA4Cclwrb2wUKDjUQAAU1iwkWCgC0ERFUM40gMRuWvh1v02vq0c8Q4GoFw61MDFONIlPYZgItxNMH6uG/GLLqDUVOKYxGVQ0Bf6DGLspueTgg5RDQQ0BGOHCIjCIh+TOZSmtKzgDZwDQgJyLKWt8zlLms5FsOUhYDI0LUC1Gh5vNytfWhR5jPz0v8BU0bPBNyYNTPTCM2xFLN90uE1O6cIz6xUc30U2uY72xLO9jkAzrjmZxQBGpRUEJAyvtboDj06kzYQEKEL/WdbCq8+iqa0m1lZA0mDrdLKiyVB63OPU4/alMWwzwmkJ2pDmzIG/tSOK8KGaghd+pDtEJAbeP3qTLrDPguwYJ+L3UgIxHk7uhBbrx/06z52QkDvkDazDxnF+mDS1bbO5CDsE4WxTXtA1X7jB9a3nWaYe9t9BLF91EvscDdSCsi+XL07ncmf1scPZDu3gNIdxhHkOjtSCDi831gCAYlB4fYWpDrsEwFaazvifdSFfbZRNoHbh+BV5ADn0lOBji88jJr/EBALTI7xN64aPRYQMbj5fUhX2Ke8LKe5IENgH1CYzeP1AbkS56Dpn5+8itEQUBKM3vIwlsI+rTgb0NMjdCI6wz7PZLrO3wiBitbnFVI/uhLjIKDq5tzRh+yGfTKwaIhvHY2ZHi7apo6equNw3PVxd9ibXsUm2Me+e3+7FkMhIAkHHu19hAKyS3l4SwtyFPbJQdrovh27r7AZ9tnF5MXeQ0HYpxyb57sSvZ6eX4Re8E9MhIBaPHfOy/AG9rFAB06P+Dfawz5MUBvltWN5D3LCPtClvePtaAX7lEH3rl+hMdNTIOGn2o4jR8/5nO9rO6rePlamPrXtGOn6TGBtu89O/+8hSAv7MAL8yfdgheuTBvSLHoclCIYrIOF37RjB/agPYxeQUIJTWGMc29AKPwJl2oduyhQK+tZ67xdlvhF+yzF+DNgZDqgcEBiBmzGByVGBFpgZGLgbGriBl9GBuvGBIFgZIpgbJFiCk3GC/pCCKhgZLOiCL/gYMTiDwFGDNtiA6ZeDJriDPLiCPviDMBiEQkiDRFiEjYGDSCiBR7iEiqGETqgZUBiFmDGFVGgZVniFlJGFWigZXNiFkPGFYOgYYjiGjFGGZviETZiGf4GGbHgYbviGhRGHcjgYdFiHgXGHeNiGa7iHeKGHfsgXgBiIejGIhPiHfXiIc2GIilgXjP/YiIuYiJD4Fo84iXBRiZboFpiYiWyxiZyoFp74iWgRiqJoFqRYigfRAQiwiqzYiq74irAYi7I4i7RYi7aIAHUgiaiYEIdwAL74i8AYjMI4jMRYjMZ4jMiYjAeQAbq4iwehANsSjXwig874jNJ4jVdCjdVYENCIjd4IJNq4jQPRjd9YjsMnjhtBjua4jgOHjhyhjuwYj9vhc+6oEfAoj/iYHBEACPlQjxhxj/kYkP6wAF9gcf44EQApkAFZB/pwkBSRkAqZj06gXA4JERAZkfgIA7JVkQ5xkRgpjxnwCavEkQrhkR8ZjwQZUCRpECZ5kvEoBMpmMCQQUX7Tki7Jjkf/QJEGcw7+YAGtsA3jYA2nUAJIwHh1Y5M3uY4w8HAH42Ta0QSQ4ArBsJFvg5RJaY4RAHj+kktBd01XeZMMwAkqKS5KUh9sFjdW+ZXmKATWQi/0tRxU4JVqeZNewHrr0gYC8kloOZdJGQKstS6GYB8vMDdpyZflGAFVAF/hkgn2AQCEaZhJ+QB7MJLK4kr1YQWPCZlJuQQx6SujVR8vFTcyYACkWZqmeZqomZqquZqs2Zqu+ZqrSQTsFiZe4ALXwgT2IQlzpQn0wSkqcAbK0gGVtBzgtVX0sAGqMgG66SulZh96OVck0DicsgCPMJaG8gv2oQR5hQFlAGF8wgBpcEak//Jj/7RX6qMqkGCbpLIL9qF3eqUIvckoMFCcdvJp6TEKfeUCyMkpKdB8htIFB7ccf8lXPuAKqqUmC2AD1vkkWCAgNMlXDVAGAWola5CAWzJd9TEmgdUPb2klGyAHdoJ59TEIg8UCyMEpiJA4ZAIJ9mEDhBUHM6AqKTBsWkIBzGhjhbUCxTedNtB2RIIDAhIHhtUAdDChS8IAJrACT/IK2amYhrUIK8YnG0APRiIN9uEMigUFPMcpIRCXREJk21EKi4UEMcopKECjOJIEAhINjCUDBXCgYZIBUuCjISJT9jEHjcUBT6cqQPBALQIK9hECkFUFKaAqk6BPLOIJ9rFrkP8FBc8WJlrgpSDiAcOpHNkWWXdQpowyAUgFIiwgIJowWTGwBKqSAZjgOhRSAYLJY5JFAUYAp2HSpxQyXvURbZXlAEQQpWriB4hqIOtmH+qAWSXwqGBSBIa3H/JWH1RZWUiAm5yiBB3mHvhWHwvgp5iVBEDEKQ9wCajqHjtUH+vAWa4Kq2BCCGHgHiRgpLuRcJzlAICgq2EiCJbQHsngcK1VAvXHKFpwrN4houlRcbPFBs7KKCDwnNBxoulBorl1AZvAKAugldDxBwJiSLnFAUagrimyB+zxcuhhZMblAK8wm0AiBAYJHRpXHyDgpMb1BtbDJIxgoc9xARibG+4QXjX/YJ81AgJI0B5uICDtYF5tkK00EgFMyR42R63iyV0esAUzqx0PQATu8QHwmh3FcF8QMAoiax8SoLLfcQ/YJmD70FIPYgV06h3KsHoIxg84Wx9HkLTgQQEHEHkTdgF4Vx8hoJ7uYaf14aIThgCsgLEpsHL6cbb2IakTlgrRpxwPAFb6Abf2AQKU2WBokK/KYQNcyx56mx5bMGN9sLa5kQYL6h1HVB+ygGNXUAnJsQEyYCAt0KHJAbk99gFqkE0wgLf6UX72sblHRgovgAIqaiBkICCly2RwEK350QZNC7sreRekICD3t7x30T32QQPQaxfXBnXVaxdfICCgl71zwQEO/2If4OO9caF29pEL5DsXPGMfi5C+cdGc9XEC1uq+bTFW9QEO9PsWHhC+9VG0+bsWIiAggXC5/3sWk9COBbwW3VcfD2CwCXwWASAghPDAapEH3pkewEnBaIEJ7kXAGgwWzSUgYPbBZoGh3gezJPwV/2UfrJDCZVGvAnJDLhwWirpxMzwWsCcg83TDYSG06fFePAwWQCogEBvEXPGZ9bFfRuwVWTAg1rDEXmEALBq/SwfFXgEHU7wdumvFX/EGNbwcD0BFXPwVJfDFuyEPY0wWUBAEu8EAdpnGYnEDbOwPwQfHZXEDZOCxdrzHfNzHfvzHgBzIgjzIhFzIhnzIiJzIiv+8yIzcyI78yJAcyZI8yZRcyWpRXJacFHxQCQ9wDZl8FKdwT05Qsp/sE3zgw/5wYqX8E6G8HL+7yjphCudmBkoKyzkhAvybHTdiyzYhy/ZRS7w8E5SQy+iBAmIczC4xSwKyDt2KzC3hA/IzII/gzDBxA+S6HZtGzSyxpwKyA3KlzSvBAQ41IMfQzOCMEqhQqdmhP+e8EqkAIcLQzivRsAOiBDsrzygRCi0rIMxwrvh8EplrHxP8zydhv19L0CXRAJ43IAuQzQgdEnawCg/iCG/80CDhXV6EwhbNEQZtH9owexsNEg1wdQ9iDiEdEomwpQMywiftEYpwowLCAPjR0h7/QTkPMgGeTNMdYaUPEgK9qtMZ4QHeACEA0JlAXRHYoNICcgwyd9QU8QzqnB1pELlOPRFLBSFBVdUY8XsQcnxabREOQAwccqlfTRFdMNQQ0r5lTRGJMCwM7QtrTRF/QHoCkgFoENcTUQIwLSAWcNd4HREBzD4D+tcO0W3DI7iE7RDAwCETgNiJvRAOoGA37diPnRANULfDMwyVzRAtUGMD0tebvRAxoKmfTW+hfRCmEE8QsgDGe9oD8QQM9CCf4NoIAdsdQrG0TRBZsM8FldsFwQO8PSDpELqb3QeUOyBj4M++LRDA3SF+UMXL/Q/NzSG4IKTRLd3B3c3cdN08gLAP/2IBcH3dT4BVHCIO1/0PeeC5AgIOrOrbF+AFKJILD5rbI+DZD1IEIhXdHhC8HTIBbBrdDXBsKAILVH3aH9Uh2uC2tN28KBII+b3c3RDV2xEBs3DdhiC2HDIORpnbd1BDKHIE1u3eJvVCTR3aHzC6EFLh571+D8Jn5y0QyeC6ypEDyv3iOkDe6BEB3/biAnEF64seVcDjBoEBwYAeyyDkCCECU+sPrTC/SE4QorBhyfECn/PkCEECQpAc1WTlCjEN57EGXM4QUxACkbC6Yb4QVzBEZ77mbN7mbv7mcB7ncj7ndF7ndn7neJ7ner7nfN7nC6UDnADScN4A3RBr/hDPb//+BGUQZzLG5hQQDai7HGrO5X9AB8edHFmN5FdACvuJHieg4L7dAr6wBBecHo1w3RRwCGAg49lRBIJ+2qmuDHGbIvFw2i0QDWAw6zVSDZWdB4tQAIkLJL2z1g7QC+WA1mGiAWWNDeyQDpcOJhFg1BtNAnBAB+MMLcbQ0kNwD4+wAdfMKBYADnpM0C4AD+YwsNKoBQSQffh8Ad8gAEvw7NDCAEtwCAUezHlwCASwCzjujVpQDvOqzTFABfYQDEEg79f4AkBQAh5syR7ABnBQD82gCwj/jblABKAuyUPACyUgCZggDZ4AAxjZCtAwvo+cBWKgB1yAD18QALqAC1krkCDvEAzUS8kV/5EgsAWycO+OrNpXWQTBsPOrvNAuyQjqYHawnIsYaQHa8AOqQM1RJZBmYA5wUOPOPA/46AjE8An3LM8cbI4TUAni8Ayvjs/vjI0JsASNQAXEfc6MuS0AoAH20AcNj9CFySE94ArTUAIZ39JddSULAAAB8A4lUDtrzQtAsgCtsASPIAKoUOJrjQ0cEgXOMA7GoABZ0PZ43QIT3gq6AAY2QARvEAdlu9xMUAzEwA1SEAsiUAI80JZ+HvuyP/u0X/u2f/u4n/u6v/u83/u+//vAH/zCP/zEX/zGf/zIn/zKv/zM3/zO//xmExAAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2venBGDjDk1UN34pkCECCI/UhOowLqCuNSp7YlIBueGoT8NOOve3bhNnzO+YoHiZkIXkx4p/Clfzry58+fL5/CeTn1vGF73PtkIcMyWBejgw4v/by6juvnza31c81UBnCA84+PLj58bvf37W31gsUdHW5H5AAYYXgb4FWjgU3aEUw4xtgjo4IPPJXDghBQGFUo40JCxA4QcdrhcIBWGKOJMGOBAChBaeKiiioyM6OKLJnkgxiUDTLDijSrmAuOOPGbEgSyXePIAjkSqOEiPSCbZECqNDBJBkVCqaIKSVFYp0AogRKmlispY6WWSR2wpJoRbfGnmjpyMqWaAsJzp5ohirClnfBW8aSeFHNg454Mo4BHIEX4EkYYJ6WhgKDASJCpBMIYaSogrQeiygROz3GmpgWns+ZwFWuTiyhYVcNHOGaKoEoMDl6b65idzRlEMGFIs/1ICG0Ooauut/zyhJQwD1HLOIS5QgOuwxP7Tyop4aFMKOwasUOyzzxoBYQ7goFNCItBmm+0hAEbhyjRQlKftuNl28UJ4DGxghB6mkOsuudo4Z4EuUnwzwrv4kpvKcl5w8k0X+QZMbhwa+NKGwAgnrPDCDDfs8MMQRyzxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLMMcs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dVYZ6311lx37fXXYIct9thkl2322WinrfbabLft9ttwxy333HTXbffdeOet99589//t99+ABy744IQXbvjhiCeuOFt5QMLD4lnnUYg/KjwOedWhTK5c5ZdPfcEMzXHe+dOfPyf66EuPsA54PTyButIj5CJeEa6/brQHzsRXSB62E+3BIPMVckHvQTcAPIAb3Eu8z0A4WI0Hy/eMxncCFlBf9DpP76A02PN8iJ4BctL9ziw8KeAo42dPfYDRpJ8zGgsIaMEU7uPsS/wBJoBE/TfD42AkSeCfzQDhoGN8QIA1w4eDAoDAmgXDQdBoIM3k4aB2SFBmDaiDgCbQiQvGLAzeEFARQuFBmLUBFwLyhLBK6DIXqEBA3GDhy7BgPgBJQoYu04OAXoADHLZsGiI8mA//V6YBAQUBVUNMWQN0IaBLJFFlbWgQgBjwhiem7A/JARAeeGfFkwlDQM7AQBdPVg4BqWOMJoPAEgLEADGgsWQyOFa3hvfGkfEii/MpQB1J5gsBvWKPI9tCgCJQA0CGjAOTCBAkxGjIj6niAAE6YyM/poAALQALk/wYMALUihZksmMc8EKAgPHJjrHhBAGiXyk3Zo8ARcKTq9TYGkYZS40NIQQBUsSBMKCBQtbSJ98IkBNWiB8gvkAAjPzlTgQJoHIU6BY1PIIBlLmTLuQAQBZgA37ixZwFcAJ61MRJLxgAoGJAwD4igE4k3BjOm0ggQFVADwngA55miKudM/HANeez/4oAmoeZ4QmBMPBJE0OQcz7jMA8ODjqeXVyBoDJ5J4AMQR0I+AFAM4BoTLoQCAAdoQPTWUSA7qHRmJQgQOfgDQk2NJ9dlFQm4ADQAfzJmU3OxxHYeilMLtAEAMWQM1kY0nyIoFOZsGOKqODMJgCUi3MWNSZMnI8zNgOHKXbwqTHhgVDlo4fMYGCf8vkCVmcCCwBFgpiVYdV8QHDPsb4kDD0AUCouM4IXzscNbp1JOwCUABJYBhMAEoRT8xqT3M2nFJXJAyrn8wzCzgQVDB2PBVRBmWYACByOpQk3ACSPycRhq+NJARczG5MkQFI+DLAcZAIAIAGQliaNAJArIqODbv8B7LUy+YAU5UMDyAgBQJXC7Uxo4dPH0MCjSBSuTBI5HmboYbCMIQOAvqFcmrBAPIUQAUiNC6AgVLcmGnyOGRaRzMdIdz69/e5jnYOIH1wPMsedz2zVS5PmKQcP6DggZc4bHwbwgr40ucMDEkAAWFJGFADiHoBpEg5nXWYZ83lA7RZ8qzhEVjwaoPCwiigfCWv4VnxY33gy/GFbPSLCEy6xpXxw2vikQ8WqOgeAVAtjO3Vgt+OxQo0vtdf59GLHlvLEfLwLZDsZAEDDKLKdxjEfJij5TUk4l3yC+2QzEWA+MOBAlc3kgBTJhwBbNtM95vMCOobZSmuUT0LPbCVLXDj/PKJgs5WsMR9PyLlKHYjCfLpxZyohY63v7TOPICyfMgg6SUOQcnxSfGgYvWI+2mg0kkIon4FKeke8mI8KynvpEUlhPuLr9IsgYIb5/FfULlLEfCaB6heZYz7ZaPWIMMBSycbAZUBIgK53zete+3rXsejcSeUz35YVwENgvpwa5tM+lx27Q8leHK3l4wj9GhvZlxt2fNbsbGxDbtnyKQHMns2haCfOAbUWzw44vTJyQ8jciLvBfNQQM3c/CN6Hk2h8xD1ubysuEvJZd739jbhMy4feA4f24q4snyQnvNyLk118UKDlh79bcUN4M3SWMTN7OwjfhCOufODRcYIbjoLx/1mAX2XmcQGBXHAQoOd4iMxykxPuyPKpB81aHqCXB04cpt65zQe3DfkUoWY8B5DP/+YBRYvnpyVX+OHOMB8FIH3ogbOBfBbQVovfG3HhAAMuxSMImyV9PksPHBKysQy7OgcTZsf64bLwChOkWxZxlzrqIPCHH1ghBBUXut5ljZ6zf5nw9zF8fNKO+M0ofjyMb3xmHi+eyEv+MpQPj+UvX5nMg2fznJ+M56ED+tBHZvTPKb3pH4N656h+9Y1pfXNeD/vFyJ45tK99Ym6/nNzr/jC8V47vf1+Y4Ptj+MQfjPGRn/zALL/5mHk+9C0j/elTpvrWlwz2sw+Z7XPfMd7/Pv9jwi9+xZC//Ig5P/oNo/71E6b97hcM/OMPmPnT3y/2vz9f8q9/vfC//3jxfwBoFwI4gHRRgAYoFwiYgHCxgAzoFg74gGwRgRKoFhRYgWhxgRhoFhq4gWTRgR4oFiAYgmAxgiToFSZ4glyRgiqoFSzYgljxgjBoFTI4g1RRgzYoFTiYg1CxgzzoFD74g0wRhEKoFERYhEhxhEhoFEq4hETRhE4oFFAYhUAxhVToE1Z4hTyRhVqoE1zYhTjxhWBoE2I4hjRRhmYoE2iYhjCxhmzoEm74hiwRh3KoEnRYhyhxh3hoEnq4hyTRh34oEoAYiCAxiIToEYZ4iByRiIqoEYz/2IgY8YiQaBGSOIkUUYmm1wEIsImc2Ime+ImgGIqiOIqkWIqmiADhBXF7eAgH0Iqu+IqwGIuyOIu0WIu2eIu4eAAZIHdjWEma8otQwnwz6IvAWIwrIowwSIzGuIwXt4fKyIzQqHR++IzRWI2VN43WmI3jAQrYqI3e+BwRAAj5gIfU+I3fuABfYG1sWI7m+I11oA9yyI7t6I1OkAVvKI/zqI0wwG9miI/5mI0Z8AnJ1YX++I/WiI6BRoUFaZDWKARmdoULyZDVeAT2qIURKZHRCAPspJAYKZERwAUQ2ZESyQCckJA/eJEiGY1CUCtLiJIpCY1e4EtF6JIvyYwhAAVI/0iTNbmMEVAF0GWDOrmTxvgAezCQwyiUHbkEDwmDMmAATvmUUBmVUjmVVFmVVnmVWJmVVUkENbQlXuAClngUmhBXY6ICZxCWRkEPG6AmE3BDaEkUJDBLY7IAj2CSb8kTGFAGoBUlDJAGt3aXQjELXaklkACWgBkUikCWYgIDN3CYQeECazkmKZAJjgkUPuAKGkckC2ADdlmZNtEAZYA/YrIGK+eZPNEP4LMlGyAHptkTLKBnY4IIqtSaOhEHoCOZeEWbOrECVqAmm4lWulkTDUAHoqklDGACDhacN7EIiyUmG0APyokTUDB2YhICVBCdN4EEtykmKJCb2EkTMlAAmf+JIxkgBcD5nS/BAaWwJkCgPOgpE1WAR1syCXbwnjMBBVkyJlpwnfYZE3ewnVsyAZTQnzERA2kmJhmACexGoClBAUYwnjjSngzqEg5ABM25JX5QnzDCASFgBT/wBz+JWyWQn2JSBJj0Ite1HDtgAq9QkcKFBEygJkogAi8CWKazDNmwP6+VBGOgJg9wCQtqIIIwHiEABuFAWg4KoTdCCGEQIjJQnOFhA6/lAIBwoVoiCJZQIRd5liLaU/p5ogeyWfHxAuCEW2wQo2MCAjllIP8RH9vwXRewVFuyACB5IAYXH+KgXhxgBFCKI3tAIfUwH9OkXg7wCoO5IkKgjgUSBPL/gQchqlxv4HYrwgilaSAk0KfQ0VkUVgNg5SEgoKMT4j/yQQsf1gY96iERsJETQmjjwQAsqWEesAWYGmFEVSEcgALyoSMqBgGjcKjzIQGPih/DgHY7tg/pNh9WcJ4GAm7xcWo1xg+dGh9H8JcVMm3xEQlKdgHHEx8hYJghom3jIQFPhgCsMKvMkQIs4CLMOh6NWWWp4HTO8QCn4CIdcKzgsQNGWWRo4KXPYQPBaiBUd3Bs1gfRqhxp0JkGwmThJmdXUAnNsQFdVyEf4AgBF6RK9gFqcFAw4K0jEg3zdmik8AIoMJsu4grzwY99Bgc0CiMxIGLhIXATOhTZMB9lErND/0Fp8aFLNhsUdzoeZvCvO4sTaSIfUhC0QIEBkioezmq0PPFF8uENTPsT3BQffxS1PKEr8vECr2q1OVEG88FxXKsTDUCi44EMYasT3TAfUbBdZ3sTQiYf1tC2OIFgqJWlcmsTChsfS3C3NnEB8BoecMC3NcFw8aEF+Sq4LcEBMECsiCsTs0BmNNW4L4Gm2ya5MTGsgmq5MMGo8mFnmusSvQAgFvS5LdGb8mELbEu6KcEDAJJSqrsS0jAfB+ADr6sST7CX4fEItasSHBYfFoANu4sStzsfJBa8JtG7rRoHxmsSwysfYGsZK3Ck3Be78xFnldECBJAAD3AH2ccLSsocZP9QGR+ADjIHBNlnsug1GQ3wA4jgHEkFffElH+EbGRiwCKX2HHUwfZzLW5DRASKgOeCRrskXTPMxv40BAXrADPHBasTnAGGSvo4hpqNKfI87H0IAGaE7H7agqKHXBbApHzoQGegrH42gewIAIAwUGTzwvcsxU7CXB/IpHg+gvJKBcvIBdaEXU/PRDJShCi6LLu/Lec8AICcwWpKxnlIVehAwpPMBd5URAwkgupznBgCiAu5JGfsyHz3QpI0nA2Q7Hp+AGRQAcPPRJo03DwCSAxYLGToUYTSGap3AwssRuJphWPKhC4QHARInH5vAGZAFIOwga0QAIA/gopohwfHRBEv/2WiJQLHzQUq6YVqXhWq7ACA7UKmbIWMAgrKHNmYAsgjT0QEPLB+BcFuNBqDj4QdAexmGECDiKmmhUMn91UPVkbf9RVGXJgzUCR41Wx1JsAppXKaNJgOWBR54gMnTUQWujGpiQMbOsbLnAQHFMEU/JmoeUApQGmn3wQY/HB45YMqdZgCjHAG3UCBlBCC9LGoYIADnMg0GQgFOECDUJWs1oAFrTB2qBiAhsLXLGxI2NR9r0M8k0QLOLB/2INAjMQUBcgIyidAf8c/y4QWB59Ad0QIoBCCQTNEegQXmCh1Wp9EeoQ4BcgCUBdIcgQGQECCTMNEmjRE14Kvhkc4tjRGP/xYgvjDTGzF6KbC0OF0RF/DB8tEKEdvTEiEGcrwcS7DKRM0QIh0gzrTUFYEBdjwflgbVE5EHMicfKfAHVk0Rb3DUymELQtTVEXEJAqILCEvWB+EA+0u8ah0RbdCmAOLOb/0QOPC349FVde0QkiAgEQCme70Q6yofKsCxgY0QFPC2AIILY33YCBEKcj0f3sDFjo0QnZCa8lEHaX3YPRYgmlrZCAENDhIMoJ0QrCUg+FDaB/EBx+AggKDaBpEEBT0fJAfbBIEEUWxJN23bAzEF3SweC4AGvD0QHis/wj3c/zAKDnICAjzcQxsgE3AIyP0P1BsgFnDcvN0AB4pN2G3bHv9QDQ5ivsg9ApE5H4Ow2Yd9AQA8HoMgzMgtOfHhDO493U8Q2c+RC1c83QPxBIrpHOuQ3/o9EDyQtMoxA4sc4AKetAaO4Aox4MtRCCTE4A3+Qrsj4QzBA5BgxBa+4Rze4R7+4SAe4iI+4iRe4iZ+4iie4iq+4ize4i7+4jAe4zI+4zRe4zZ+4zie4zq+4zze4z7+40Ae5EI+5ERe5EZ+5Eie5Eq+5Eze5E7+5FAe5QrTBr6gATT84V3wDZwgSsoxVxw+At8gBbrww9qM4KYQDUawARD6AuAM2zIABdPgCkA9HtJd2olQAugADgU7H0YQ2CtgAOxQCtqQ1RzSClZNAS7/cAjnUAsDsLhRwmgCPQRsUAKLIAVgUAxzLiZhTLoOEAOqIApn0A5cUAFb4Aq5oAW/PSdp8J6z4AQboAtB4AqE0CgaEAyKIgHA0CjpYAJpEAR+cASBgAe4mo8TwNLBWQFIGSCqqpxlleyghp4A5ezjcQToqQzSLh8gkJzKaQLXDh4RMAiNEMTYua3d7g8P4AnQIAvGjp1MLO0TMACXIAZt3p+MkOxaAASkgAP3/J4dlZI7QAbQEA4RzrW5bZC2QAzlEA4aere7aI5FoA10YA9YQLuS2wDWiAeCAA4V4AvXQPGqKwO/aAG2cAwBYAOfcA+8QNnLOwdQkgI9wAS6YALcXgAKseAL1NAHjW3SDfAHhnADcJAMImAPsPEDq9EaBAAbRGAaCvANN4AKNTAHMrDvUj71VF/1Vn/1WJ/1Wr/1XN/1Xv/1YB/2Yj/2ZF/2Zn/2aJ/2ar/2bN/2bt/jAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2venJHCBVWobsiCI0zErB+oR1VYzXoUaiIiRAgbdgNVjTkyOnDezVtxB1M0Ds1qZMPdEkGFQETwx7y58+fQo0NXYmbDIELcQJFqxwKJjN7gw7f/JdEpXj1gawQhWiC9vfv38KW/sOVMmpRF39i0EM+//9VQu2xwQHwEFmjggf40Ucw4BPyiw37+RSihUWEgaOGFGEoHzIQcduhTCBmGKKKBBHho4ok1VTPiiixGpwCKMMbIkgYt1tgiGzLmqONI09joY4gPNLDjkERqJMyPSFoIQJFMNilRH0lGWaAJTlZpZUJdSKnle+pc6eWX//Sw5ZjQwQPmmU4OQOaazF2D5ptEqsHmmmHAaWeOjYjoSBFMbDBAEK6YoMGgGkhgqKF0EBqACVYEsc4MgeCBQota3GkpjEe6lwAjY6RDxzSLJGMID5as8BEGSdxBwze+ZIPPFq7k/2LLCwVucumtHkLpTwatVMJKI7RMcYcHOMnAxjeLSCGNM0Ww9xwduEYrIQUszKHbUQ3UcM85tWxTRBXShivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvz26++/AAcs8MAEF2zwwQgnrPDCDDfs8MMQRyzxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLMMcs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dVYZ6311lx37fXXYIct9thkl2322WinrfbabLft9ttwxy333HTXbffdeOet99589//t99+ABy744IQXbvjhiCeu+OKMN+7445BHLvnklFdu+eWYZ6755px37vncofDyucUNHJOCMKNTzEpz5aQesSTPmQCh6wv3YgF0R8hBu0oyENLJrUkUIV0Tsux+Eg+F+BMICZY6UIl7D7xiPEntpNDcEhDceUl8zQg5vUcdlAKdAHYOU+AxV3zPURtBRLfAGW9is4OBRfyuPkY4iCkdDOmD2YEuCArH/S5ij9u5RxsOABM0EGSNAVaEA80gEPm8dAYGHCgN2XOgRCyxjgItQBNXSgKIDAQAU2lQIoI4UBGYV6UCHCgFPDjhRFCxHAMto0pcQJCZZDiRWSBoFk2qwQn/DmQOHlaERgZCgQuKRAFyHMgPFDAiRT6wgQOt41o7ksKBEmAHKVbEBZMy0AR19AxnFSgZXrQILQ6UAfvJqAs5ONA80ngRbhyIGRzIETAOtIE80rEiXWDCgUohoykcaAJx+ONF+kCrAjHgGTBqQSQOtAhFYgQQB3KCH020hwO5wpIZEcKBbHAiQ1iwQIgYAigx0gYVGGgBbuoQBwBwoBKsMiNwONARMNChBRpojrfMCBILNA0OsSEDBirE7IJpER+YwUARuIWEIOCMV1KBmRoxpIEGIaFFjBKbG9mjgUTgnzYkwECaBKdGJGkgPLBQPO4wEAOuqc5sEpE/ijiQBOrJ/5FayBMH4enAEQwUiWXy8yI+EF6BJpHA3pDiQPA76EbucSAi9KYNjjCQPCTakV0YqAnv3IycCtSEJHCUI4kYUIGMsBtUnJJAbjhpR4hgoAfEcDMALNAAZNoRCKSwQNrYTDtqmgWedqQTL43PPTLDgUAYiBNG9Yg4CQQAXl4mFQaKgg+i2hEZgMBAn7hMDM5ZID1w1SOZaKcJKSO+AlXjrB6BQAcLVIbKqMKA8WEAKuDqkV4Y6AR5oIw8DMQNvn5ksAUqrGR4kNT3HKANhvWIKaxHoAfcQTLEMBA6IvuRCtgwMn4tkC02ydmNdCEKBoqlY9pXIFqU9iNpLRAZHnMDA/9N4rUfgYAXDESD1RqIBbj9yBsMNFvG1Fa2wQWJmgoEwsWwlkB7TW5fDRSExRyXQAGQLkhcYaBeKGYQBbKsdj/Chsa6p7iHoYGBNDBekIDBQDpAjBXC+4T2fiQOD5jSYXRFoC3YFyTDhA8DamAYaRTIAnz470eekF8CsZcwlmhwfPyr4I8E+D0WMAVhOlnZOVT4Iy4wb3tIKRgZhDE+4/iwewvkiLX+xRiOJLCKPcIDA8UiMA1ALYFuOOOPmKBAZsBiX9ZYoOj2uCPqLVA8APPT+FTiyCBREYGK8ZdnGCiiUO4IMgwE0L68l0BeyDJIGFEgcPQlERKGDyXE/BF2HNj/pHsRQIF64D02c4QCMCDmXjqg0PgYw86dBXJD8ZJLAp3gAoD2SBsaqVS9jKFAaki0hQtUh7w4QAMTIFAfJO0RHTjSEnpZwSdm8J6dctojxyhQA/nyDExLx6yn7giR46OFQe9F1Lt1DgjqHGuNUOCrBEJGYAygBspiotce0WJexwgYHxBhEqBGNkfkIGLn4EIACZZ2fzYhnQkoYwrallA8oOMJSWw13BJqAB6YE4JHyBjdHJKCK+5hVXjb+9745isQEsDvfvv73wDv943zHRkXhqhEBIeMwTOE8IQ7ZuEYarjDGQPxC0l84oqpuIUujnHEaBxBHO+4YT5+oJCLnDAk/yfRyTMuIpOvPDApL5DLX/6XmBNo5jTvi83jg/Oc72Xn8Om5z/MC9PcIfeh3Kbp7jo70uii9PUxv+lyeLp2oSz0uVI+O1a/+lqxDZ+tcb4vXnwP2sK9l7M4pu9nTgvbmqH3tZ2k7c94O97LI3R90r/tY7p53vYeF737HC+ADb5fBE54uhj+8XBKveLgwvvFueTzk2SL5yaul8pZHC+Yzb5bNc54snv+8WEIverCQvvReOT3quaL61Wul9a7HCuxjb5XZ054qtr+9VHKve6jwvvdO+T3wmSL84Sul+MZHCvKTb5TlM58ozn++UKIvfaBQv/o+uT72eaL97euk+97HCf/4w2+T8ZOfJuY/v0zSr36YsL/9Lnk//Fki//mrpP72Rwn+82+S/fOfJP73fyIRgAIIEgRYgB5xgAjIEQq4gBrRgA6IERAYgRYxgRRIERZ4gRKRgRoIERzYgQ7xgSDIECI4ggpRgiaIECiYggaxgixIEC74ggIRgzJIgy9ogyyIgymogybIgyPogyAIhB0ohBpIhBdohBSIhBGohA7IhAvohAgIhQUohQJIhf9nhfyHhfmnhfbHhfPnhfAHhvbVAQhQhmZ4hmiYhmq4hmzYhm74hnCIAHXQcs93CAdwh3iYh3q4h3zYh374h4AYiIJ4AMh0cM+nAHOSiDbSd4SHiIr/+IgjwoiB54iQWIkWd4iWmIkgh4ma2Ik8x4meGIrSAQqgKIqm2BwRAAj5kHyUeIquuABf8AHG14qu6Ip1oA/DR4u1eIpOUFS9p4u7aIowYEu6B4zBKIoZ8Am2tnrGeIyhCIu8hnrN6IyhKASI5nrTSI2eeAS+KI3a6IwwIAbM+I3OGAFc4I3keIwMwAnROHnZmI6eKASqxHnvCI+d6AXv5o72SI0hAAWZV4/7qIkRUAUZ1HgAGZCZ+AB7sIyTiJDauATXeHgyYAAUWZEWeZEYmZEauZEc2ZEe+ZEbSQQ1FCVesEQy2BKaoD9RogJYdpIqQQ9VJCUTIAkuyRIksAZa/7IAj9CONUkSGFAGafYjDJAGMdCTKjELI5kkkGCSRnkSiqCSSQIDN9CUKOECMRklKZAJVHkSPuAK1dYiC2ADPLmVHtEAZWBGSbIGIUWWIdEPmSYlG6A7bDkSLKBjUYII4DaXIhEHpCYlKRBTehkSKzBfUhKWURSYH9EAdICWQmkCLoaYHLEIQwSX9ACZHwEFIxQlIUBPlskRSNCXUYICgNmZGyEDBfCVLJIBUnCYpJkRHNBWUgIEI9CaG1EFlBUlk9BFtJkRUABsUaIFnLmbFnEHoJkkE7BmwnkRMbAEWpIBmFBvyTkRFGAEqMkishmdFeEARDCZUeIHuomdE1ECvv+ZJEWABeBJEUggSFKiBOR0nhKRBI8mJQ9wCdDpng0xndW5IoRQJ/b5EA4ACNyZJIIQbf3pECXQBFqiBeZZoA7BBuoZJSCQCAzqEBfAbUmyAOc4oQ7BAUbAmC2yBxoKEQ7wCknJIkIgiyEKEW/gSi3CCGuZog1RA3G0IiCABDA6EW0QnyESAeJ4oxPhAVvgoTVlUT5KERAwCiVqIBJQkEU6EfswPwhiBazZpBTBDzNaIEdQlFR6ERcAXgQSAky5pRaBAKwgpM+RAsAlphqRCowWHQ9wCmrKEWiAoNJhA0wapxjRB1fqHGkwlnhaEVfwPM6xAd/xpx3xAWpwSjAQpob/yhGk8AIokJeN+hFw0J6TeqmYykwYcA+uIAWZqhE18AgjhAd++qkM4QOS4AnQsWSmGhFToAxvCR220qoNwQcCgAvvwQByeXWWMAlEcG6BIQD5yRyeynWYwBwpoAYGEBhbRiAgMKVD1wDj6Q9e8AmPaWla0FpXpwfdpgGQxBfWcD5Xt1ztMQPWqheWMKzMEV9Ix1/vMQEawJBzMYcO1nQjFR9joBcURSAvAFk+dwEB+h5woBcO8EwEUgFDB2MEUgRCdhc9QiAwAK0i1wBQ+R7MhhdJgFfwwQ45RwnhJaF8AQ4Fwgg5l2vxAQZ+gQMGImwrdwYG8q19kWoE8lYrJ6jx/yEIgBENvHVyqGAgrvUXHWCw8UElIrcMBRIFpXoXsWAgNzVxNaCu/vBngbECGUUgKItx41AgKFCogWEDjsSo+DYHQekeIDoYpqCx7/FgCbcF4UWggnFh0FNfBMcHaOse0mAYT1sgaotvbFsgm2YYP1ZZiYRvDFYgVoAYnlYgV3tvcOsevYUYZOBIOGJvdzC27cFNiRFaBPJJ9hYABjKVivFc8eFd6NazBVJdi6EJBmJq4Ra5BQK6i+G6BPIG4cYC1OUYSQZmd3pqk/C5jyG78aGVyDZr8YG6jnENWdUFvcYBttBdkWG0BXKxiYYOBkIMkoFfBZICGsZpbaBSedW0kP9hRwWyUZwmvgRCvpKRBwH7HqQLaC51YKpQGWVgIOuwu1AmZQRCSJWxAutWIMLLZtxaIAmgpZXxCQYCAlwLZT5gl/GRCpiBAbRUIBsiZpxgIIFAWpWxrwTCAG7UY1lgue0Ba5mhDQYiCParYOQaH7rAGTwAwtJBpDPmBvJkZJphBAZyACD7YUlApwQSabtBAlBKILswY4hFII7gr7tBUwayVBXmsgZCCuDhAL1bIFoArO3FTljasJyBA1DrD7WgYBJwIIrAH+ZwIJKqXVTQxe7QHyTQvwRSUOPFAU5gIAmAxOLhZgYywdLltQZSSRHipQVyxq9FBWYqHc5wwr3hAkn/6h5mYMWc1QLJUyAZMLkS8rB6G1zzcCDQ0CEYMFAGMrClVQIHAgAYHCHXUMjRoQJ2DFdDgAjyZAgnwscFIgScxV0GUrYmIscHAgiG5U0EZVAd8gxdHAF/y1VxEKsEIsgmUsEGwgTKG1UccJUEoscwwgHMcCCKZVSZbCA58Mwy0gmFqK08lQwHsgAwmyNylkRgW092QFYFUqw70gFzVSAbgKIHRQF+cCDkILEyAkYHsrf1VMZ/lY9D4kMHAkT8BA8IkqFNAr0FEgE0zEw8cJsEUgBWQgJ9RiA4C04rEMEFEgJwViWagMrPsQ5ue0sQkAYHwgAtWSXpDB/NUMqrFK6a/wwmDkDC7mEB9lBP4YAguqDFVXIFeSYdPdBl6tQJGQ0fO4ANb3IGQhoEqwxOVyCz8TEMdvLSzVEKQA1ODRBB8LHJdgIBzIms7RBVr+DC/lAJ8gomJOBUhQC+PCULQfwcRRDSd9IJhJDAUSUHnuwcFtC+tAoRYRC4zUGTgU0R5dAcrHDYFiEMKXAMScvYC9EHoSDZln3ZmJ3Zmr3ZnN3Znv3ZoB3aoj3apF3apn3aqJ3aqr3arN3arv3asB3bsj3btF3btn3buJ3bur3bvN3bvv3bwB3cwj3cxF3cxn3cyJ3cyr3czN3czv3c0B3d0j3d1F3d1n3d2J3d2r3d3N3d3v/93eAd3uI93uRd3uZ93uid3h1SBUWwDbVwDvdQA5HNEx0wByzAzyNIB9CxAEVQH/eRH3o9Ex5wB1NAC43ACpXQCoVYzC9oofExH7ngCuaAD9ngC99AA3eQBPWpEStgCTxgCMmwCNNAB+kwBozgztKBOieZrSyCAngQCDOwDkFgBSYQAIRCB4diKISiASbgCkEwABvABEVQtRnSCCdZIQ4pHT78gsib5NHBuiyo0E4OHT1wkuow5dHhzSlI2FjeHAxugh7d5cyh4inYAGjtkFKbgmwg5s8B0CB4kPZIsylIAGzuHCHwglNV5/7AnynYAjrwCwQwDsfAwwh5ABuwC5WRbZQtcCzJsiyz8oqIIAhrAAz1EA+d8KKBKQNIwALtQAqgwA2EMAgbYAZKkCQRAAKFIAhL4A420AizcAg0YApbXaAdIANzUAOhMQylIQJEkBqs0Rqo8QOzIBtwIAu1oQoXgN/qvezM3uzO/uzQHu3SPu3UXu3Wfu3Ynu3avu3c3u3e/u3gHu7iPu7kXu7mThYBAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza95sskSFz6A/p/rxI5OIcCU0/XGR6APn17BjF5Tgr7bt27hxvwjB7NgSDaBi+aL2p43s48gZ087NvLlzfy9wVUsHKtuwGhySa9+ud/nz7+Bz9//QNU6cMB4UuKtfr9Z7+Pfway/AteQRpT8N2Ovfv7VC/P8A1pbBEdK8880F/CWoYFP+BehggGYA0YgsIyxo4YU/NfjghgECMM4pSGAo4ogyacjhiQDiQUw9z+RH4oswjmQiijT+N8EYjXTiQIw89njROzUG+eAqJmSTiI9IJrnQD0I26eANSkYppUBMOmnleyi4OOWWPVZ55ZfOWcHlmDx6CeaZt71C5pokaiLBm3C+qcGcJhQQhDfMBJIAmhy6wOafZI5ghw4sJFNFBfMAoQsAJ/DZnC2ARirpQDHw8oY9l8hTDAx81jLpp6AK5EEW96TSjC5NOJlMqKy2GgMVVXz/oYsjJy4gQ6u45joHGuKs0UOAnuQq7LBXoFEOGXi8V86wzDJ7RybNAPAcFs1Wy2wS4cCyAQO3HdCBteAyO0QyW0i7RrjoNptHHOm26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXbPPNOOes88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VhnrfXWXHft9ddghy322GSXbfbZaKet9tpst+120DwA8jbPPKjgTyNz51y3bT/k/23z3rdV4ffMgOMm+OAvP4GIc4cjvrIqRXzHjuMq51EIeAv4QvnJQxzxXuabkxxGLvGBHjrIFAwC4AIKnO6xA4QEOAELrnf8hey0176xALjrvrEbvfuecQkPAGjBIcJn/Aet/y2ARvIYmxJ585pDb3EYGwQoifUWO2BFgPVwb3EZAYIifsWZBKjG+RQrYgGAVuzIfsR8cPpfMR7MH/EHkwDITAz6ixg4AASDOQQQYqQA0ASuccCH3aB4pbtHAx2WiBAAaBQTbBgGnAGgLWSwYe55zyAw8MGFhQNAACBBCRVmh1X85wDsWiHCKLCO/zAAGTJMGB0ANI0cIgwZAFqGD/8Plgi7xYcJLRhiwSBQif8oIYZKHFgjACSMKBLsD++LDyysODAOMOI/xyAhFwMWQvA0gQ9jDJgYAPSGNALMB2b4TxncCLBa/GcdYqQjv6jhxCfosV8r+FV8KPHHfnHjP+koJL9Y8B8trECR+vLA5eDDgNxBEl+P+A8nLpkvVCwgPozIDift5YAawucBnRjlvT7xH2io0l6JYN57jpCeV9ILCPFBpS3pBQU57nJeGHBCfHLgml/GKxb/gZIxf4IB4cTGFEqIj6eW6RMoCBMGFXqNMuIDAhVScyeWWMZttsgZGvyHFt/UCQemMQHcZACKmfFEfLSRzpwMoxXNEcJmfBH/Hwv4qZ41UUUavkMNzYyiUe+RAkBp4gFrRAA8M5AfZvggj/BooQsLlQkybAGf7W3mGrr4zi8yKpMqxCcEYXhNMvDJHHqSNCYOIEd88AGbBpxjT7d5AA9eKhNNxAcFxoFNDOiQAdvMg6czCUB8jHCcO7jCHwlAEFJjMgeEhscCfjzOFNox1ZlIIT7S6CqzfAACStZArMMyKXxMgFZhdUCY8NFBW3OlgPjoc664kid8aIDXVvkUPsToa6vIEB+5ChZUqIgPWw8LKhPEhxeM/VQWuPWesEZ2UmA4pSouK6kaUDY8HuRspDL7nhNcQbSAykJ8XInaPzn2PTvAaGvXJIr4/2RjtmwaA3xaAQHckmkK8Wmdb8ek1/AMYLhjEkZ8+oDcLUFgkuFZX3OnxAX4nACA041SF1L1HnRkV0rQ2G1vv5skUxT1PWcgr5JIG57FqtdHzzhlHt6LpP69hwD09RE74BOJ8eYXRh5w4Xtk8V8eldE5iSwwjOIAnxfcSsEvCgJ8GgdhEdECPseoMIk+gNPw/FPDGAIGfC4BYhEl9j2BKLGIZPqeXqj4QueATzB8CIQE2PjGOM6xjm8ci3iF4pPhgYFES1iAE+E3XkKADxRyWGQOHRle7YCPdFfY5A09+V0tQAFsh5zBKj/oyu9iL3gITGUjz+sQ8Aktkc0srwbs4P89IOByA73sIDC/Sw3wUUSZnUyvN8DnEXu2Mr0ocID35CDQX67XNt/DhjXzmV5ogI8xHC1oen2gneHRBaUTXa/XYg67E6RzgOwMr/2+h6tdZjO9hgBk8Cjjg6IGEKnhFdLw4MG/B4z1f2b9LmPARxSpfnS9/gCfdwS70vYSJHgGcWxO2+uQ4XlB/uas6nr9IjwMgMSHA6jr+PD6XTH4bG4AMI9kgJrawraXKW1TBHeIYL4y7DZ8vv0uTPhjB4TgAjyZXO16zaETuFaivO/7YvUMPDz0LvhmDg6ehCs8Mwz/jsMffpmIP2fiFK+MxZ2D8YxPZuPN6bjHIwNy5oh85I//KXluTo7yxqgcNyxv+WJefpuYyzwxNLeNzW9+mJzXZuc8L4zP/QH0oA9m6EU3emCQrnTMML3plnk61Ckj9alLpupWhwzWs+6YrXOdMV7/umLCLnbEkL3shjk72gmj9rULpu1uBwzc4+6XudOdL3a/u17yrne88L3vdvk74Oki+MHLpfCGhwviE++WxTOeLY5/vFoiL3m0UL7yZrk85smi+c2LpfOeBwvoQ++V0ZOeK6Y/vVZSr3qssL71Vnk97Kki+9lLpfa2hwruc++U3fOeKb7/vVKCL3ykEL/4Rjk+8omi/OULpfnOBwr0o++T6VOfJ9a/vk6yr32ccL/7Nvk+//hpIv7xy6T85ocJ+tPvkvWznyXuf79K4i9/lNC//ia5P/5Jov/9i6T//gcSABiAHjGABMgRBniAGpGACogRDNiAFvGAEEgREjiBElGBHtcBCLCBHNiBHviBIBiCIjiCJFiCJogAddBv7HcIB9CCLviCMBiDMjiDNFiDNniDOHgA54Vs8ldXjvKDaJJ0sOeDQFiEViKErUeERriENYKEqqeETBiFPPh+UCiFVrhr+1eFV7iF4GE++KeFXBiGzBEBgJAP9QeGYpiGtrEAX1BM7IeGahiHdaAPVBiHdtgcTpAFb3iHfIgbMFAC6QeHfSiGGfAJchZ9gjiIYciGWnJ9if+oiGEoBFLliJBYiUegh5RYiZAIA2KQiZqoiBHABdT3iJ/IhQzACY0ofKRYilwoBEOwfKvIilvoBWdVfLEoi1cYAkumirioiRFQBQE3hL2oiQ+wB4d4erc4jFe4BJMIezJgANAYjdI4jdRYjdZ4jdiYjdq4jddIBA91Jl6wbRYoFJqgbF+iAuk1jkRBD9lzJhPgUeooFCSwBmiyAI+QivHYExhQBhD0JQyQBueWjz4xC98IJtomkEGhCOZ4JTCgTAjpEy7QjmCSApnwkD/hA64gblayADaAjxZ5Ew1QBq32JWvgTR+5E/2AaWCyAXJwkjzBAlGAJogwBS65E3EwA2j/kgJuUJM6sQLfcyYcWUs8aRMNQAcjaSUMYAKPNJQ3sQhW9SUbQA9MeRNQYEFnEgJUMJU2gQQ4eSYosJNaSRMyUAAa6SQZIAVCGZYwwQGlwCdAkE1qGRNVkAJoMgl2EJcyAQVldSZakJV4CRN30JVgMgGE9JcvEQNLgCYZgAl5ZJgrQQFGUJZO8paO2RIOQARPeSV+cJdCAwGdYEA/UwJ7CSZFQC0+EwdcsAtvxlo/gwRMgCZKIAI6kwci4A7TYxvrIDRJoFtn8gCX0JgwEwPJMA/S0hwMEJA9A5mS2SSEkFIwcweQsJy4MVJC4wCAkJlWIgiWADMe8ALvwQ1FUwLc/wUmWmCaLqM64dEDRsMGr3kmIHAkLgMk7/EHRnMBmwAmCyCKL1Nb7zFpRsMBRnCUQbIHMQMByZJpSOMAr1CQQSIEbvgyi4Y5r4g0b2BENcIIJgkzUfYek5M0NZADNQICITIzMSCgzeFeSNMGvMkhEdCJNVNr4DEBD3o0HrAFJnpKRHAzvvYez7M0EDAKDPofEhCMMcMG8PFqTbMPbwY/aVkz0PUdB9CkScMPIBofR4CcNJNJ7wGITnMB6BkeISCONqMIUgY1CMAKN3obKWBJOeMAo/kdO+CRSpMK3ukcD3AKPrMF8IE8UYMG45kbNkCkNyML8AEGU9MHVYobaSCnN//jAEsKHiiQRFJzBU10GxvwYD+DZ6dGNR+gBpQFA2LKM730HndFNaTwAihAk9VpP5hzWlUDB7JJNMEAH+dQmUTRC/BBDrZKFIEAH6iwq0JxCfABDMAaFC4AHwkwo8W6E8cAH+i0rD6hVuERBNDqEzJQp+Gxb9WKE+kAHxKwrTyxRu+xCtMGrjgBAZEAHx1qrjhBAPAxCeyaE3nQj+DxDPGKE54GHoZ6rzZxBvCRAabArzUBASwVHqwpsDKBDvDRBLKFsDERA9jpHPrpsDGhqeFRCIJKsSnRB/FRRRoLEwMAH8HysS8Ri6pKsixBsPAxBijrEtkQH8DWsivRBY8KHij/KrMoEV7wgYk4ixKhELHNsa89ixJ6+h4MUItDaxKqQK/fIbRJWxLSQEk8+7QjwQuKRbUmka/g8atYOxI6EB9k0LUkQQzxoQliKxLmJLJnKxJJBh/CtbYe8bXw4QTfArceobXfQWF2qxGeBR8g4AN72xHdCh8KJXPtcLKx8QRZFB4nAJojdwF74gp3cBxGEB8B0HLzYBsZQAdYihltoGXwYbYexwNMmwDnwKiVgQ/xQQ7HWGLa0BytsCqcEQasGh56+2LX9hy6wECbIQnwYQs49HBdoAXhIQ9olBkdIJjOEQHWUK4K91WlhUGZUQLfkQablXEusLjhUT2Z0ba50QrD/4Byr6u2mxEHO1gbEzANouRxFxYffMUZsHAby7CdKEcCbwoe7gAbI8ApTrCLLWdH8KEEAQsbvhALwOlxN/AfPRa4GfEBiRoeTnDADDwR5BMf/jvBFdEJTPsdQIDBF0EBngMfjgCfHkwROgsfn1DCGbzBz7EOravCCuFFpcO1MBwRnPAfgFbDEcEC0skcheC8OswQK0C88YG4QcwQgwsf4HnEDkEJ/9EDS8nEC/EE0RQfBSXFC4EB6/Ye04TFClHB8GEGgOvFCeFn/+GiZHwQfFCz4fGtaXwQGNCsoLS+b0wQ8dtP9FnHBaFc/xE+ekwQcVDF8FEJGevFLdCe8KECJP/8x/8gTv8RvIz8D9MAIHQQyQKBDD3MHOsgpW8cB4UWH6vAmYxMAsUZH+FgyRjwpd5qyf9QtPHhDBKcxqMAICGwyHoMB2naHA/gkH98DSoJH6RgyXNQu+8BDpYcA8wAIJOgrGnsAcVAQMf7x95jPHoWyRYbHxUZyWAcH3MUyfUQIPETyb4LIBvgnH/sC7ncHEUwwH+MBunMHI6Qx398CNr7Hg9wxX/MAr8MH2CZz/v8HgIQyfocIF8g0P8cHoTwwlIsDO+cG4OAul6MzvGRC+ZsyRIdHkcwoawsEBf9HIUAbxs9EKbmHEVwvSFNENKaG4iQVSddECltGyqwUy19EC//HdMznRCzXBs2fdMJMUU7zdMJAQgyDdREXdRGfdRIndRKvdRM3dRO/dRQHdVSPdVUXdVWfdVYndVavdVc3dVe/dVgHdZiPdZkXdZmfdZondZqvdZs3dZu/dZwHddyPdd0Xdd2fdd4ndd63S5xANJLTY85sAXJoNFG3QGfXBsMsAGwoABJUNRY8BwA0AyZMLkzXQ7vgQdkUA5oEAobXVzx0QMmIA734LhpLAMN/R2OoAtfUAVU0LkqnAxO0gS6oAapcA9ZAMQTDMBnAgPFIA+XYA9vwAuu/bQcxYQnAADOAATzUAFV8AssgAp2AJcoe6x8mACBwAzeEAQFYAJzogFx9BInogusr6CMuNE3xfqT5F0b5r2rDQC66e0P622rCfze6l2siZANJiBg5G1s0OoAndAIm3DQmlgB7NoAz1APxHCgn0jgAosEpzAOpTyIDE6xIyALjQAEcXSHE46yF/AN7yANR3C+V7jhPdsAf0AJj7AEuHDaV1IKcEsBPCAM4jAOurCQZ+LGE8wBNTAM2QAK6VANuICtQoLjQdwGf0ANvpAKoKABS1AMzBACQh4fRP7HH5AILvAHmlAC4SACmUAaqRAaocGlez3mZF7mZn7maJ7mar7mbN7mbv7mcB7ncj7ndF7ndn7neJ7ner7nfN7nfn7TAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4se/dZOqmSoSJBezZrzL3+w/SWABAYfpWsjWuvezfhc7N+/e2ySMItGGN7Ik/elA7x580LLxA0zpby69bcmnGt3jojYNGqqr4v/Hw8W0vbz2gFokFQDAvn38KfuQE9f+6oljWh0iM+/f9EW9QW4HQpkNHKNA/4lqCBObAjo4HY7LCOJHQtWaCFLbzyo4XaF7HEGBReGKOJHi2xoonYomDBLIiO26OJE6pwoo3beEMDGizjmeJA0M/bonBOYiKLjkC/q4uORzZkBCw1ENmmhFkhGCVwrl9Tg5JX8NcKNNrg8IOWX5NTDB5ZkvteBHCUAYsQmZnx55DbwdFHmnO/5QIMbnIwBgpsnOsLNM3QG+l4i3xgDBC58augEOoI2St4FbwhQAB6J1ieEo5i+d4cb3DBTqXbCZCrqexckY8QRn8IWAgajtkpqMqwg/8qnFK7WCp8qi+yihJRP2Orrew2IIQEAPmrz67Hw3fLDIAuc2A2y0L4XQyZpvPAgHiBGq+14I7RDyAkBcrLtuOS14MsSGaBnJbnsijfEItVoV0279I5niTiFACdCvfyKp4gGKcjmQb8EWxeGG68UrPDCDDfs8MMQRyzxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLMMcs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9FkGLO00Sg1w4084T1ctUijHwOZIHFZ3zRENiPzGzHFel12RLxE0t4vZbEMEQYzavdP23Ap5kN12C5xB994Ehf8yCX07zMH33ry0WR8kHwzeNjWOOKiM4mazY4GGn0DeNQEmZkCF5U47YI6MzXCudAOEyGiNe6IfPcIgJ6IQaupHX+DNiZHwAPvReThx4gBD3G70E5GcqEYDvhfNQw8mMhBL8carYOIECjBPNA7ObwhD09ILjcMBJgJAYfZBb29iMb2DD7T4G5owsPk/o68hNwiy7zMq3G+Iifw/81C9hqPg7/MTIdjQAtzgv57NoQgbskA0CsizNuRLQxM4BAN3NgIvbGgCLJigzjzgjAtmUIM468ASNnSAXoAwZxogIQ5OiDNMXHCFLLQZFzwYQ5vdo1kPwmANa9aJCWjIAsPYIc3/5gADDS3gHkKc2Qg8pSFaJFFmDhjDhir3xJgBY0MCqGLMZqihPWgRZrLw0oOAEL8vskwOTdBQEIhnRpa1YAYaIkdu2siy0j2oB3mgI8saoSFH/EGPKxMDDgX0gBIAUmWWoNSDFnHIlFFAEF1sZMqMoKEllFGSJNODhhjhA0yazAW7ctAOeuXJkrVAHg5aABRKibJZgKs+pGBlynigO/SAQ5Yqa0EKt+MFOeFSZSIIWHNWoYpfsowNjGhOEI3Jsi7sEja0YqbL4IECfwzgktJcWRw2waJsevOb4AynOMdJznKa85zoTKc618nOdrrznfCMpzznSc962vOe+MynPvfJ/89++vOfAA2oQAdK0IIa9KAITahCF8rQhjr0oRCNqEQnStGKWvSiGM2oRjfK0Y569KMgDalIR0rSkpr0pChNqUpXytK70EAOLXVRAygByS/EVERtwEcRYaOETt50QQZQxuSAk7Cf9qcB3fDEdpxg1PgkgQDIQ88NmkoeLlirPgGg6nhuICALJEGr4klmgBgFVutUQUAAKKt1WtC4ABlCrdX5goA0AFfl/EFAKSBbXXkDyQARcK+8cYOAggBY3nQhlPURXGF1owYBTWOxusECWiGrm1rWR0iUXY0xBPSIdAIhAaANrWhHS9rQLu9Y2GBAgLSAOnMWoEcEgNY2BPTWc/++dkaxRRY7BBQMdN5WRrk91giuSp8otJacvz1RcI9lx/rUtpzJNdFyf/WaAPXWtbCN1geqWZ8e2Da70eJRgLCHXPBCSxgCggZ2caut7QaIEesF7rbAIKBbQNe80IqHgGJZXvZqKwzERc8g7utfbQkhQBnwqTiju6HpIsseAnrdgvELrVAIKHTjZLCGHIysv3W3v/IdFz4EZLsJF1hbBthvhikMLQjsqT5jWPGJtaWMAE2AAyYO8bjgIaCphlPDD+IwstogoHLkWLnt2kCAdHFk6bbrEQGyQAt+zOJoZShAYqDyjLXVAjHSx8jgBLKDhAwtI9WHsGGucrQuEaATsNH/m2IWEJmRRQ0BmfCbcQ7QnI/V5QClIs1b3tY6ArQMQOuYXbAIUBQMjWR6JUNAY4KzmqOVCAH9As+Tjpbh6AMKTAd6W+kI0IAl/WltkSJAjjiuMfNcnz0jS7IB4lo2WU0fVx+rC4NEjx5Ifeh2WbA+0ZQmrdFj62M1I0B14HWj6/WKAIFA2U7mlyEEdIVZZzpaPhCQLKxd6m09kD4/4Hav23U3+qhB3MuuVzkC5Al0R5tf0QhQAtzdYII1KEChEPa1o4WBdNXHx6ved7SIVR9GMnPY5yk2ssrdHBVUQwPvEAZ1Di5waIGCp5NIh22usYIm15tgLtBEvn1b8cw6BuHb/1G4yRmDcu2ofOWKablzXg5zxMi8OTSvuWFuDpyc65wwPP+Nz38umKDHZuhEB4zRYYP0pPtl6f5outP5AnWpT10vVb96ZLKu9cdwveuN+TrYFyP2sSem7GY/DNrTXpi1s30wbn97YOIu97/Qve59uTve96L3veel736/C+ADX5fBE34uhj98XBKv+LcwvvFteTzk1yL5yael8pY/C+YzX5bNc34snv98WEIv+q+QvvRdOT3qt6L61Wel9a6/CuxjX5XZ034qtr99VHKv+6fwvvdN+T3wlyL84Sel+MY/CvKTX5TlM38ozn9+UKIv/Z9Qv/o9ub7cO4CA7nv/++APv//4x0/+8pv//OhHQB1KbvxDHOD98I+//OdP//rb//74z7/+D+DvcWN/IAqQKgI4gDj3fwgRgASYgAJodaiHgAr4gHzCgKXngBBYgUgigaJHgRa4gf5ngBrIgSD4IJ1mgAbxgSF4gvQRAYCQDyRIECaIgjCoHQvwBYnTgv/wgjGYg8BRB/pggziog0DoD06QBS34g0GogzBgSB54hEzYHBnwCdjEfEbYhDE4g2/2fFNIhTEoBBdQfVmohTB4BESIhWBYhv4AA1kmhWZYhhHABWq4hmDIAJxwhbr3hXCIgkJQPr1nh3d4gl6wLnXYh2YYAqtkPqGgCS5AHnwoiCEYAVX/oGqQswLXQAn4kA6TEEojKB6LyIgg+AB7EIVsYwrC8A4aUA370xwmoIicuIZL0IV7UyL1kVbjIQMGUIu2eIu4mIu6uIu82Iu++IvAyItEkDap4gWJSDdcVR8ZwCowowlR9SkqoDdzY2EBciMxQw9KlioTIAl0kwABskAyQwJrIIAL8Ah02DVKVR9gJjMYUAZeligMkAYxwDaNVR+pWDOzQIyfAgnH6DU/ECCFcDOK8IyVAgMAZzWyICB6RTMukI2fkgKZ4DVXQFs44wOuoFqfsgA2cI5K82L0UVQ30wBlkGuJsgbh8TTrVx8YljP94EOpsgEw9TRSECBewDMsEAUC/4gIU/A0mlQfC+BLOhMHcJQqKfBXShMHAoIFPbMCVkCONpAtSAMBbUUf/MUzDUAHJOkmDGACHZc0rFMf6QA0i/BKn7IB9JA0F1cfZhA0UBBAqRICm3M01VUf3fQzSDCUn4ICRkk0liAgySA0MlAAGFkpGSAFUDk0OFkfsDA0HFAKAwgEczQ0yxAg61A0VSBMnzIJ3yM0qRAgDzBlRAMFHlkpWhCXQdMLAkINRnMHeFkpE0AJQtMAZIkel3A0MTBCqZIBmMCMPxMES4Y0FGAEg1kpkAk061Yfn4k0DkAEs5kofrCZPCMGAvIGSlMCo5koRaCUPdMC/YcenaU0SMAEAv+oBPvSM2ZGHxvgNEkgRanyAJfAmzlznPXRBk4TnMOZKISwkDeTjPUBm50DCM3JJ4JgCTrDAS5JH49TNSWQRqmiBdqJM+xJHyAAiUnDBuKZKiBQlzZzauPVNRewCRnphjnDAwKCD17DAUaQlUjiRTtDkOcxCWXjAK+gj1EiBDWoM8eGb2bzBqfoI4xwkjrzaAFiD2xTAzmAJCCABD7jA915HpfCNm0QoTISAWnoM19JHy+gn13jAVugooREBEHDofURD3MDAaNAow8iARSqM7cgIGCwN/swHxpiBYf5M2JFHyhwo23DD0fqIEcwj0MDDRHGNxdwpfQRAv0oNCkWINL/MDgIwApe+hsp8EFF46IDoqd0kwoB1hwPcApIEwyWBjlowKDOYQNrCjTTFiCEYDl90KfAkQYcKTQQkJhYGpmDcwWVABwbIANLA6oBwg6c8wFqgJEwkKhIk6r1sQ2pQwovgAI76TQQACX1wQDYkDpwUJ5PA2UBIjc2mBaiICBM1a1pQXD18aDiWhbTICDndq5mMQcCogRAya5j4Zt+Ja9lIVgBIgj2ShZhgJn08Uf7KhbPRB82FbBhgaz04QigabBfQa70UQUMCxboICDwFbFekQRDVR/ParFcEQAB8gIiyrFbwZ/b0QME8FUi2xWW1Rye0A2xmrJX0WzAYQHKQF4w/+sVPoBYMIAP9HmzYiFXgkAJL+uzWyEHTEK0SJu0Sru0TNu0Tvu0UBu1Uju1VFu1Vnu1WJu1Wru1XNu1Xvu1YBu2Yju2ZFu2Znu2aJu2aru2bNu2bvu2cBu3cju3dFu3dnu3eJu3eru3fNu3fvu3rZIImyBrgJsSDjAA/oAC/lm4JzGTsaEB8cq4ITEMzcEI1ii5IKEKq+AcKYCtmMsRXfBr2qEBC/u5GQEO9OEEJWa6FyGm6HECs8C6FgEFkeoc8lC6susQTyCn72qsubsQPnCnArJrv+sQDoCbDmIExfsQe6AhglCny4sQsOggeECg0bsQJfCOPlml14sQfzCVAv/SCN2rEHlgqfSxquOLECNADhoyA7ibvgLRAPTqIE0Qk/BLEA4ABBryAJR6vwPRvBoSsv4rEAKwIcAwwATxCRsyBqCYvrSwIcxgq/57QxoCA4qFwMOQsQIyAZ2AwALBAgcqIEfkwf8AwhsiwP5LAyEsIPfjwe7jIHTlwb1QPw+yBPuBwCasIc6wPgOcww/iBRIMv4ewwgDZswMcDRosIEVwwf7rBrW7HSFASgM8CiaiAqvrvy5EQpjlvw4gNSqEwHZjIgcAQ/47BMUgxmR8v3bgsA4yxghsADulISqQxvCrAEQcIFaMwLFwnwLSA1ecvg1QjxsSCVIMv0OAuCbiBHn/5L88EDwm4g2ueL8KwF0bMghBfL0QYA0yQghDW7w5aiLm0MDXSwVNKmck/A8K/CAZAKyn/A81JiCOoJqt/A8fYB5qyQuzPBBzwLvbMQkjl8sCcQa1qz7AXBCbpR3qcKqzvAvNEQG+UMwIEQZMBBuIcLTQfBBxEErH8MvXfBDh4A/D080LYbPiXM7mfM7onM7qvM7s3M7u/M7wHM/yPM/0XM/2fM/4nM/6vM/83M/+bEyv4AZaes4e4I0poAGKsM4iMCXiYL3mHC/OUQ1VoIfQXAPokQFL4Avve8qc0GaE0A6X7L8UoEgC8gIFkAmAisDdcCILMAg/YF/+qw0+kgMS/yAGnfy5TyAlSrALi1BMy+u4boIL5pAMkfy5GOCWn3IERkDUmIteCsgM3OAGdwC4B2aBeFAAAvAGRX236LCyG4gLQGAM36ChdPsM3AC+IAgCY8AJbkADCha3XQAP8xuDZrAJRgAIJSAHN+y2fFAP7HuED4AL2sAN4uu2NXAJrdCEWiC3NAALm5aDTEa3oqAOXh2CjXq3bEAAs3OC6rC3iTALJkDJFWhwfEsBZ7AH36aA1Fm4diAJy8DLqXK5jOsA19AIZCDafLLRjNsBNNAIS7C5X7ID3VsDkqABbCwjkHC/JEAN00AMYXMi94jApjAM4rAMqV0fdADMYUADpyABm1Bgvr9xDuU8ApOID2AACd4YG5e2ziSACsmQCtD5z/I93/Rd3/Z93/id3/q93/zd3/793wAe4AI+4ARe4AZ+4Aie4Aq+4Aze4A7+4BAe4RsREAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu/dlYgKodPBNvLjTLP6SoygAKI7x59CF/khOPXkgc3BaRN/OvaaJ6uD9vf8gk21O9/PoUULYEb69P3L4/qSfT5/jH/f4/UWCRaO+//8QTZdffmbwB+CBCBJkxYAM+hOIOjwkKCF9DhzQ4IUzNJLHhBxu18mFIPrDwCa0eNDhib6lEuKKSqjRC4ow4pbGijT6c8QoQ8SoI2wdOFJjjS/I88yORKpGw49I+rPBKV0U6eRoIiyQJJIH7OHck1h2NgIaexwx5Y9CQJHlmJwl4kYA7H0Z4gzsNEDmm5g58AwmXqgJYgji5AjnnpVZwsUmGdjJ4Al78MHnoZPJQAkhJwianwXN3ILopJC1oAejjrrHABg6UOppY5ZaEWim4RHT6aeoJkbCItWQGp4Jp6b/KmthdlSAi6vVBVDDrLwSpogGKeAqoga9FhuYD4v4gasExjYLGCrcTOAoCno6ay1fMvwAgJ3lXOutX1CswUCSeKzw7bl8yUEHCj/Ggu67e60QixYrIvIBvPjm1UE73oC4SL4A51XCAAwWgkHACN+FxRL50ZLww3bpEMC44M0AAcRrxYAxQjV8Vx0cG6OFAQEpXBPyQTp47MnJZuEwQ3LeDMdyQZ2QMcXMYnnAiZTUpYLzz2YZkkN4KVgC9NFfeSABxeEtgfTTWtGwbX7RQG31VA1gwnN+IZh79ddM1QAJiOaAbTZSnzQaIhZntx1UEkLUyISbbtet0xkhICmO3XzX/4RBGVNG4ELfhL/ExzFqGlP44iodkmaSRdzD+OQldfCIml/4QPnmIYVC8JQ53Mz56B1pkneSDEhgIumsZ/TDA1NGYkjrtFvkgTxfmqNd7bxHZMkGUyLyRu/EP6QICFO6ckHxzC90igVJpiBJ89Qf5AAdU26ARPXcD+QDw0nSQUH33VvyMpKrhEN+952c/qMgdqzP/SHSIikB3fI3T8TWNCoRT/7Vw0SSmLA9ADKvAxpIEiHCYEDmeQB8NVqA4hpYvBUg7kcJ+AYFixeK89UIAFfaIO+eUAgkjUEGIuxdHIqAJGA4IIW844EKfrSAbMCQdzhIwI+UMLwb0g4HFqpRD//k48PW9SKINJoBNorYOhbUj0ZBGAETWUeFJ64oAPib4uaA+KM9XEyLnGMDEldEADCSrgHEoBEDuGBG1jUgACGyQDva2DoHgONCFkADHWnngGYwaAKy2CPv5pGfA8xOkLzbg3sOgANEEk8K4WGkI4t3iepIcpLFa0RyLonJ4qEjAY3sZPOqJcpSmvKUqEylKlfJyla68pWwjKUsZ0nLWtrylrjMpS53ycte+vKXwAymMIdJzGIa85jITKYyl8nMZjrzmdCMpjSnSc1qWvOa2MymNrfJzW5685vgDKc4x0nOcprznOhMpzrXyc52uvOd8IynPOdJz3ra8574zKc+98n/z376858ADahAB0rQghr0oAhNqEIXytCGOvShEI2oRCdK0Ypa9KIYzahGN8rRjnr0oyANqUhHStKSmvSkKE2pSlfK0pa69KUwjalMZ0rTmtr0pjjNKTaBkICe+vSnQA2qT92l08MU4EtlLKphjjqlpCqVMExNklOfKpioImmqVAWMVX+E1az6Zas16qpX+QJWGol1rHopKxnRqlWksvUvag3RWd9ql7iCaK50pYtdL4TXvMplrw3qq1/hAlgGCXawbinsgA67pyTAgx3KVGx+GJslB/SiHH4YFy4i61ZKOTYdTQiPpJApWfxQNkaWxSzTwvOJZJbWPadFkTlW0SAr/7i2s3ACwoUcITNjvrY9sT1RJkD0omP+NjzB7RA2QLQ34+IWTky40DZI+9w3GeFCEcjiMI8LnuR2CA4gooJzm3qoFfAvP80tJner490OKatBmxivVBF1uQYp4YXqre6bDgGiWG1Xv2QiwWrzw8b8khdR5LhQOnwLYDJ94UKRYPCBD+ULECXBwPNFlB1AhAwMX5VSiLjQJTzMVUp5jEFkIHFYKfWOC6lAxWallCxAZKj/TvhQYRgwfhRAzPVSp70oGlqDrNHjBr8JDBeyrY0zPKlYXMgWRb7xoWZ8Ia8F08fJAfKJYgCiGyz5w55iYYMKfGUjvwmCAwLGl0vsKUg2KP8Ia16xp+Dh4jjH2FOoAJHGyizlQ3lAx+4ZEp+ZTKlbNQiygwazp9CcH1AIE8v+0DKKSnEhQjzazG9axIXIcek+H4oFF1JCpwk9KUuAqA2JZrOnHAC9BvUHmJCWNIqmxiA9pFrOn4pbgxpx6zt/agsX2kKv14oqTTbIabDG9Jv0sOlhyzVVWLgQHpx911SZ+kIcSLanD9UAEI3Wl7GWlfsGxLZfhjtV/WrQL7RNakrpmkFEYLeiP5XABo3Y3Mp+kzqCLW9Vf2oUFwJCv3H9KVpId+C+/tQbLnQEhBMbVQa4UBQc/uxUqeJCE6B4tVNFAhBpV5fnRpUDLIzvbSNKCRf/+jYvQ44qejWIiL1k+aeYcSEvgzvfb3ovgzR4c5MfKggDWkACotDDmOOcTPfgggiSgYYb4OAPdkjECvBLbb4iNi8yv/pcsq71uHC962/5OtjbIvaxr6XsZk8L2tN+lrWzvSxuf/tY4i73sNC97l+5O967ove9b6Xvfs8K4AN/lcETviqGP/xUEq/4qDDegA5YQSLm8Acc3AANyRABF/QItMeT7w1RSMB5wwPnzh9dhN+4kB+O5vnu3eBCzGD96Td4nwZpQfY+L+ItQo37doMxCSCiumw6gIDiG//4yE++8pfP/OY7//nQR0AdZk/Bbl+IBLU5xAG2z/3ue//74A+///jHT/7ym/8Ao/I9GK2YH1XURgHCir/8Ny7IKFzIAO+fv/73j1xHeqlBRScb8Md/BKh/skY+23AhDkMbA1iADogrB9g9utUgo5B/D3iBmRKB3ANsDaIOFoiBIPgljoZIldQgxMKAIZiCSRIBgJAPgkQEFyIEH6iCNBgiC/AF90JHv3AhkzCDNfiDDVIH+kBH0dYgIeCDQJiE+OEEWdBGu3chH+caDaiEVOgeMFACZsQBIGI0szGFVfiF1ZEBnyB8RRRaDVJuAgiGaggeNxiFKZRgDWJrXbiGdEgdQrA8TMRo+MFrc1iHdXgETVhEHMggwtaHfkiHMCAGRWRsDCKDhv94iGsYAWSWQszWIACAgpBYhwzACW6YP0fSIBZAhlKYiYcoBKTUQG2whY9IimvoBbsiQijXICywiqyohiEgJhsEhwzyL2lYi34YAVXwRQZECBdSCrToi2D4AHsgiuQDCheCbLHhhci4hkuAh/nDDheyWbIhAwbQjd74jeAYjuI4juRYjuZ4juhIjkQQAfrnBYOTP89wIQywOlCjCT2gfypwBvnDZReCCl9DD8AzfxMwPfIzQw0CD2BDAmugfwvwCJ1IPEDXIFJgNn8DO/LHAGmwZ9wDDM/YNrPAjvMHCe9YPVxwIUXgNopwj/MHAzZHPa93IRppNi4QkPKXAplQPSv/ACKB5DY+4AqAlikLYAMPyTq2cCFE5TYNUAaj5yprgH3MsyANAgZ90w/shysbIAfMYw0XkgOEwwL2N3+IIDq9I42awkB9EwceFH8p4AbEwwc6WTgrAJXyF5TjwzsGySDvsDgNQAdLmSkMYAJW1jpkcCEmMDmLoDbytwH0UDslyCCIQDlQMG7CEgLi1TrIACLxMzlIkJbCggJsyTrAdyG+sDkyUAA/6SgZIAV1OTqRcCFfwDkcQGn6BwRSNDrp0GyjUwXBMn+TkJmbU5INwgBOyTlQgDzzpwWVSTk6wGGscweciSsTQAmb4wCxyCCP0DoxoIeukgGYcDCTswmqRzsU/2AEp+kotDk54nAhCxCYo+MARICY8ecHvkk4VAAiIFM7JWCc8lcEaNg3DQCSDGIEvYME0TV/SiACi5OADcIExJMEY6B/D3AJ3sk36XkhS9Q741megrJAfdMLIHKTxOMAgACfwiIIXFg3PRJwzVMCZih/WtCfbSOX+bEKZdM8bFCg8gcCiWA3n4AfDOAH5dALzNg7FwCe8bcAk9g2T1gdTZAO8HBh8sMBRtCXarIHhHMrPxqkQ9o9DvAKAOooQpCDfMMOT+pDb3CXdsIIw9l4XVEDQqYmIFBAbPoVbfCgXxIBijinYeEBW0ClDfIA8aanYgEBo/ClKyIBwiioYbEPj/8TIlawmooqFvzwpgwXk5EqFhcwCHcykpdKFgjACn6aHCkwi52KFqnwAvnxAKdQqmqBBi0aHjaQqKxqFn1AqdSRBkM5q2BxBZUAHhuAQrq6Fh+gBhQDA5warGpBCi+AAmKJrGwBBwjqrNI6rdRardZ6rdiardq6rdzard76reAaruI6ruRaruZ6ruiaruq6ruzaru76rvAar/I6r/Rar/Z6r/iar/q6r/zar/76rwAbsAI7sARbsAZ7sAibsAq7sAzbsA77sBAbsRI7sRRbsRZ7sRibsRq7sRzbsR77sSAbsiI7siRbsiZ7siibsiq7sizbsi77sjAbszI7szRbszb/e7M4m7Mfe4o6+w85hA49OxBc5A98qLNDmxxElrNHSx0TebNLWx1WWrOGMEbhMQ80KwtVGR7NsKUoiwatxiDgwLUl2w1f2yBY1LJcoKHtQQy5+rEE8CMHwAYpCwGKVCOcZLJv9CMTAKMkOwKaWiMTQKoniw3PeSEHUFwn+wcqSSN3W7JvUJ0rAkopmw2hih8qECEn6wAc+SNFEEIlKwN2WiOF8AQoGwe0lkShgLLfoEM/cgzsObLGULn4sQT0SLJhsAxJogG9RbIEmiSYgLLxALkrsgCBWrINIAFJMgGHcLJ2IAhJEgKdcLLhQFtIMgMnOrIUgD1JsgSaU7JIQJM//0IHYruxkrCbP2IBBEmyF+AKUwICimCybyCZNLIB1xuyLWAOXyIPtRuyhtCaSfIAP1CySqO2AxICmlCyU2CrNTIAqTuyPvBgX/IIuwuy9yBmSbIDy0uyxqAmx1BjJOsChkojZTChJVuhNRIC+piyDYCjISIEUKqyRQgiJ9BaLou/FwIJr+iyKyC/4bEAmNC2JRsNAwIArzaz2ikiqmOzc2C+1JEDh3SzKkIdC1AK+4tLU0AG0Xs0HZBuMxBKveQJyQErR3MNKUAAJLxL4FUdJpDDM8OzugQBz8kAAeBfM2tw+CEEfOuyGFBCAzIAWBizmnYh3tAOE5yyHxBiIaIFsf/wuibrZDWCAnSAlSi7AniAOiaAiyVbDnYCAKMArCE7BOwiKBOgBv4IssjrKn6wCN3LsRpAwD+SAhrwvhxbA3AUf7hQAfOJsSkzf9WwCGt6sTqQRvKXAVagB7ujy2DgyklyAoRgzBnrAs1QtsLCzJTgyRXLB3tAosKSAZvABfUrsUMgDjwsLF6ACc8wvgnbAOxQuPG3AwHgBjtKsVDwbgR4BHuABrUZsXGwB1S7fw8QrRLbBacAvvtXxBT7DPKAqvrHWxk7BKPwf/GXBh3bC2ogvI7iMx7rAbSwCcoMIlkMsnnQCOxst+iMsTygDoHwJUp2sjQAC2aAJAG8si3tvyFzAnMs+wf4oIsDsgOy2rJzkA1koNDuUZg12wVwsAUpHR4xjbN3AAgFEMr+EIg92wFUIADEELRYndVavdVc3dVe/dVgHdZiPdZkXdZmfdZondZqvdZs3dZu/dZwHddyPdd0Xdd2fdd4ndd6vdd83dd+/XYBAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu7fv38CDCx9OvLjx48iTK1/OvLnz59CjS59Ovbr169iza9/Ovbv37+A5I/8zdiW8eeVB/GVYJuu8++G3/MmX7wTQiPf4eZeZzz/FFjb5BVgbBiHwZ6A/YyADgYAMuibMgRACYM8HDVaI2hIQZqgCPkNY6GFofDCQ4YgTBGPJhyhuVsGILPrzwDg1pCgjZRCY0WKLDASgw4yd6WDFIuZ9c+OQ/piwI4+X6WCCfLh0EB4hRBJpJJKT1QAlfyKAd0UGUUYZQIxUNnYLGCIaWIiT3qHTZZcLaGBHmIm1AQyXGVLyHRzFrNmlBZzEACdhLVSAQotMLPgdD8EcoCeRCTRC4Z9+YcAFDETqYV4Xi3ix6JBFuGEopHmhAUCXhbqnCSEPbNriDFCAelcNdSz/Gg5+c9iQgKosmvCEq3LJQEeqi0ISYAs/BIJrhi+AEgavbXVARBPHwiFgB9F4cyyEIYjwKbNmUUHOtf74UeEZ2oBrYC5HcjtWEhqYK18JFtJQgLvyLbCHD+qGJckq9DIgwIdK0usPItHk2xUPedK7C5goBkzvJrcYjBUHmNBp7pRI6uAKvREYg6bEUikyqrsFpBsmDZXQC4nJIDPVAjD0FmMIs7JM4u4DmHDQMlNn2GguAAoY7Asu7jpBxc5IhVGLu4jY83G+DfyAh7kDIG3UDZGYO4EAXVi9ghQvHDtBxFYLxUEpZV6bDjZlDyTHkqr+0HZQfzBirh9YzF2QGEcs/1rNtnrnBAE6YV8Lg6eBF9QBFzt0OXbiOyVS7rUL0IEv5AbFsDSRcmOOExpTXysIKp4n9IymLf5dek0UGAFuAkQAvjpBHZyjBIlkzx7TEzZfK08bui+EzZUHZhN8TNHcfqwZZxzfUDgF8reN8y41EMy1DADTAvUNrdDMfCi8yb1KfAhyLQAzj+8QFFlzoX5KYkCL6wNl6Py+Qy18cv9JjSxwbA402J8Aa3KPa32hawNMoEykoaoewEuBEISJBzawqAD4KYIYdMkcGhclFNgpgyBsyRn8NyRv5C6EKEyJmm60Bwqk8IUqCQCL8HAIGNoQJV1A3YEGkIcb+tAkcuAgf/848bQfGhEkI5yPEn5xxCaO5B3yYcQdnEjFkCwDDNurohY70oAtevGLYAyjGMdIxjKa8YxoTKMa18jGNrrxjXCMoxznSMc62vGOeMyjHvfIxz768Y+ADKQgB0nIQhrykIhMpCIXychGOvKRkIykJCdJyUpa8pKYzKQmN8nJTnryk6AMpShHScpSmvKUqEylKlfJyla68pWwjKUsZ0nLWtrylrjMpS53ycte+vKXwAymMIdJzGIa85jITKYyl8nMZjrzmdCMpjSnSc1qWvOa2MymNrfJzW5685vgDKc4x0nOcprznOhMpzrXyc52uvOd8IynPOdJz3ra8574zKc+98n/z376858ADahAB0rQghr0oAhNqEIXytCGOvShEI2oRCdK0Ypa9KIYzahGN+pEICTgoyANqUhHCtJYcNQv8zoWAU7al5TiaqUs3YtLVQXTmOZlppuqqU3vgtNF6XSndempnn4K1LkIdU1ELWpcjtqlpCr1LUyNklOf2paoEmmqVF2LVYeE1aymZas36qpXzwLWFol1rGUpK4vOitaxqHVEbG1rWN6aobjK9St0hZBd79qVvB5or3zdil8NBNjAZmWw/CmsYa+C2PkodrFVaax8HgvZqUjWH5StbFQum1nNPoWznk3rtTobWqaAtrRiOS1qwaLa1Xqlta7lCmxjq5XZ/9IWK7a9rVVyq1uq8La3UvktcKEi3OE6pbjGNe1ok8vY5TI3ss59rmWjK93NUre6n70udpuC3O0SpbveFQp4wwuU8ZLXJ+Y9L0/SWyEfPAqT7HWPA1QxjFGYIwhR8IcvNBnf7pDgGSJQxxqOYAEI/SuT/d0OLIg0Dv5ql0GjIJIzHKxSFBVwSCGg8EtRxIYoZfGSCdbOB6LUBwQ/mEFaIFLQ4HtiAQ2ASIAwcYVR9L0h2UDGG0YRPogEBhzTNEWnkLCPc5qiEhDJFkP2aYo6PKQMyE6SIdbOCKJkChbPGEXKu5EBrJxjFDGDSN/g8o9TlLIhsUPMRE4RGIhUDzQrOf9FrrOxm4cqI3EQyR1zRqqMFkEkIeS5qTJKBpHWIRVTfPh9UdYOFYgUCalEQD0gAIAnhJCOL0AjFZlQAAt0UMTAJTo7NSDSKqJCgSitoHSfxk4eohSVJETJAahusYDCYGqoxGdIJ1hdqrETpTlA5Q9EAoGuZS2gWw0pC1DRBJFaMewro8hYQwrgU95ApA00u8so0mGLxACVBw0pCNcec4qqQSRpPUUERLJCuNOcovQMqR1QyYSU1v3mFG1sSFl6yg+IFAB601lGcLvRK6BCCiJpwN96lpE7OAeVFQ3p4LF29ofaNaQ2P8XhLEQ4oGUU5xtVoOFEkoDGpTojCRDp40//2c+QyjDyq5b85FAx+ZBQ7rldX0fmN7rxU3DeIp3XnNgB4jmLRL7zkLecqy8fEtGdIvQRLR1zNrdO0zP0dKZMHUJVT1zUqyMFoz/FBl7/ucQ9hPEWZV0pZR/60cM6I1AQieUXDzvUgZ6fqx+I5k1J+4iMsHazzmgPMH9KPQze97XOiOIeh8q+h4TniGN74kQiBVReMW/HixtFMhxS55yC7iG5ovBwnVHAW5QJqLSDSOC2PLtRZAUi5dspcCBSNUBf1xm5+0bCgIoYiOQF2ut1RhQc0hugQgMiBcL3f51RK4ikCahkgVHIJ+yMQECkP0BlDqxWfb1RdAIinZApK4jS/7Jo0wEEmP/86E+/+tfP/va7//3wjz8CYjX2CjkgSkmISpR6SJtDHOD/ABiAAjiABFiABniACJiACngAFnN5HhJ+ROJCUMEvQ8IwsqEAApOBGugupJUdHaADLKAAmZAK0PAF6SAEngAAIMAlESAVWTMkR0MbGLiBNFiDCccsLVBlUbEORJIMtTGDNhiEQvh7dyQERAIkMjiESriEHehFCzck4vCDSziFQdiEWwR2Q8J3SUiFXKiBoIBHgzckPbaFXViG5hIBgJAPdsQORFIJUmiGcEg5X/BeciQkQ8IMbxiHeqgqdaAPdGQARKIEebiHhLgmToBscmQKUXIfswGEhf/4iEQCAw8ERw7QgCwCII0IiZpIJBnwCbAGR7ZAJJMYG464iaYIIQvwBV30Rs5AJKdAhqcYiwciBBfwRms2JPgAi7K4i/JxBIjIRlh4I82gi7y4izDAbWwECERSNZlYjM7oDxHgPmtUiiOiBcT4jLHIAJywimjUB1FCh69Bjdgoi0LQIWhEa0SCiaQ4jtjoBRZYRtFzI/fQjOzojCHQKmfUikMyCvRYj8UYAVXwZF80DkQCC/3oj7z4AHvwiWMkABBiAUewBuogAs9AAteIkLK4BLU4Rr7gD1EQBOYwCsOgCgx5GzJgACiZkiq5kizZki75kjAZkzI5ky9JBI8WhF7/4AJj9AGXE0Ga0ANCqALNo149QQ/BZ4MTIAlE2RMksAZCuACPwI1LiRMYUAbAUoMMkAYXNJU5MQs3aYOQoJNcmROKAJRBCAM3MJY54QJHWYMpUHpqeRM+4AppQ4MLYANSGZcy0QBlQEI2uAYWqZc10Q8TIIQbIAeCWRMskF9BiAhTkJg0EQczIIQp4AaQORMr0HpBeJcSeJkv0QB04Jc0yAAmcGqeCROL0H1BuAH0cJowAQXxWIMhEIOu2RJIMJlBiAKWWZstIQMFUJcbmAFS0Jm8mRJnM4RAwIjFqRJVkAJCOAnis5wpAQXUF4RaQJvSeRJ3gJtI+UHZeRIxgCFB/5gBmIAB33kSrQOcG5ic52kSDkAEqmmDfhCd7TkSJVCdNlgEeVOfJIEETCCESvB6/BkSSTAGQvgAl2CeAxoS6SmEhDB+C/oRDgAI8VmDgnAiEQoSJSA/NqgF+5mhHsEG/xmEIJAIIPoRF7AJNrgA0niiHsEBRiCaArMHLhoSDvAKX0kvQgCONdoRb6ACAsMIgdmjIVEDOeAuIIAEREoSbWCg1xIByLikI+EBWyCja/IARCClJgEBo5CjayIBAqmlH7EPQtQlVkCcYkoS/HCkXXIEW5mmJnEBgxAlISCWcIoSCMAKVnogKcACd8oSqVA4GfIAr/inLIEGHHogNhCmhv9KEn3ApgaSBnnZqClxBWU2HxsgA5T6Eh+gBmUCA3a6qS5BCi+AAo8pqjEBBwKKqqzaqq76qrAaq7I6q7Raq7Z6q7iaq7q6q7zaq776q8AarMI6rMRarMZ6rMiarMq6rMzarM76rNAardI6rdRardZ6rdiardq6rdzard76reAaruI6ruRaruZ6ruiaruq6ruzaru76rvAar/I6r/Rar/Z6r/iar/q6r/zar/76rwAbsAI7sARbsAZ7sAibsAq7sAzbsA77sBAbsRI7sRRbsRZ7sRibsRq7sRzbsR77sQ07qdbaAmCwDNt6B3bjD42Qrb+QZQswlNTaAZxwIDuAmNP/mgcvBiFegEDQegihkyH99qwUAHg3gg7OegvWMiQvy6yUMChRsgO+hqwxkHlrsgEecKwlYJaLIg3F2gVfcC3zKKw0AKmbsgAri0afcGggxAFWeSxNEKVmxAX+EAn4CEKGMDK4Igh8kEZ24LT+oAGmCUEvo556EgwiO0bbYCAhMCsK1DPXogQFo0afkCG7wDb70wbyAC6TsCtqdAuFmSFKcA6dFjwQQATGdixGgKZmBAHk1iJe8Azcgwrmcy14gAZttHhDUgtvWjo+EJrgog0mykae2yU7wAWjOzcQ4AaUci0vgA6MOkasuyhHALd6gwV+YC6MYH1uhLuLYgI22zbY/5AO5sIApWA/bTS8uJIsgdsyXSAAn3stkZCWcJSztPsDh+sqHWAPiOAutQChb0QFTuAuuLBf+aIAeHstzFNHFHOV1zIJ7cErhpAw5qI9eKQDkEAvlSBtcKIDl8UfAKAIe9QBxuClx4IxPOIw5kKe5rtHt6Ci9GLCH1IDuyAwxcADghQN+/vCLMMgAkC4qrIKSklIPrAHe4orBaDBDGJk7qIB+XdIOpALGagNMCsg13st5ICdhwQBIhCb5uIN0XC84RF7uNIERADGhRQGoCCo7hIIP6C253HBi/IAdKCpkfQEo+cuCWADUese4ngjdfCOkQQF3EkvD0AIzXceEDCiRP8CALaLSclbBBvoBfbAs9+hB5HIBQqqSR/QCKcrMAcQDDb8HYncIihQAW6sSTHACQW2gcVgbt0BDyPyAMAAPKNkBxpQxNditN7RAYVwIAwABt83SjVAte6SAeXxHZ03H4QAyKaEwuBCCOHRAS8Iw6zkzLgSZuGxCGmww66kAwHgw0RiBs+7qzUwDgzcJXhXrJYQDO9LJAywt8o6BPgApESyBM76AfZwwCOSe88KAcjgpBkSApkMrWywBc55IHBHrSMACAHMH8E8rbKwDFySetp6BcaADCCb0Rq90Rzd0R790SAd0iI90iRd0iZ90iid0iq90izd0i790jAd0zI90zQdXdM2fdM4ndM6vdM83dM+/dNAHdRCPdREXdR/FBAAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48ePIkytfzry58+fQo0ufTr269evYs+duwS6c9u/Wqaj/UeJvEvjzz680AuCvfXs26OMjnwIkg/v7ZeTrD77iB7P7APrTgwP7FagbL2pMEOCC1Bjo4GwQHDLIghT6I82DGLbWQjbsVUjhBD5kKKJpoUixiocoujHiiqA9sUUEKMYYBIs0aqYDGA/EqKM/c9To42Q0kLHjkAT8aGRjQQ6pZA5HNnlYkkpG+YyTVAJ2jZBRRglAg1V2mRcShGSpJArNUOHlmXbxoUaOYuqoixstoCmnXDHAckKbMToCTBY06mBNnHPu1QApJ+Lp4Qb2hOFjJf4gMguBgd6lQCGGVvgAGFP+eMZ9M5wRKV2dDFAphauAgs2REGwQIBlxfPpWG+Mw/zBqgABw0YWTlFCYwSMhuppWB68cMCuAnsABAZUU2OJhCCL4epYmRwx7Hxk3eHmOjsd04qxYV4AjbXsMgKHDmSvssOMCwfS6bVd3vCBtuDXIWUaUUcSzrleXzHppvHJic2eWQshx71YftGIoAxo8EakGeJ6ATgcDZ/UNnibwGygPshrqBy8RY7VMlkHQ4GsBs2ZQDgUdV4UNeTtCwqWrKzghLSMipzzVtTFqQcu9HRChwrALYNKAzVF14IWHKIjzQccjSPHvqBtwTPRTz1DIgBpXTD0HGMO+UA+kUzPFTYAD/BH2QJocPaszCp+tVAx4uIeIL24T1EE2hVaKgop1I/+ViT8ZwKJu3wINwUrGlQYwAuFGwWIx4wT1onalkWQK+eVJdZBKCqM+MA3YmIdOFB+uzLpNIqKnTtQvIYwaAguqxw5UDOOMusA0sufe0xtmjLoECboHj5MP5oxqiwHCJ1/TGz1UasEpykcfUwzpjPrF0NJnz1I0TVQ6QBvah59SInVUqoUo4qdvUioWGHqCverHH5IoOeBpgSHy5/9RCwyLmYn+APRIN1g2JE4E8IAcucMMhiQE0CHwgRXpQu1ixIzFQfCCFzkFjCq0g1tg8IMW0YHBFpQB2IHwhBORgRAWRAQUulAiDpjXfb7wwhpGpB0K8scgIGbDHjbkD4HIAfD/fEjEhVygbUVMohKXyMQmOvGJUIyiFKdIxSpa8YpYzKIWt8jFLnrxi2AMoxjHSMYymvGMaEyjGtfIxja68Y1wjKMc50jHOtrxjnjMox73yMc++vGPgAykIAdJyEIa8pCITKQiF8nIRjrykZCMpCQnSclKWvKSmMykJjfJyU568pOgDKUoR0nKUprylKhMpSpXycpWuvKVsIylLGdJy1ra8pa4zKUud8nLXvryl8AMpjCHScxiGvOYyEymMpfJzGY685nQjKY0p0nNalrzmtjMpja3yc1uevOb4AynOMdJznKa85zoTKc618nOdrrznfCMpzznSc962vOe+MynPvfJ/89++rOLQEiAQAdK0IIadKCx+GdfSFapIil0Lww1lEMfmpeI4mmiFL2LRduE0YzWZaNi6qhH5wLSLIl0pHEpaZROitK3qFRJLG1pW15KJJnShaY7iqlN1YJTHel0p2jpaYx+ClSzCBVFRC0qWY7qoaQqVSxMrZBTnwqWqFJoqlT1ilUXhNWscmWrAeqqV7UCVgCJdaxYKet9zopWq6jVPWxtK1Xe2p64ylUqdPWHXe8Klbzula9O8Stglzqqvw52KYI9bFgSq9ivMLaxXXksZLci2clmpbKWvQpmM1uVzXJ2Kp79bFRCK9qnkLa0TTktahFb2NW6tbWunStsY4vX2f/Stq+2vW1gc4vFKdgDCyuInWqhOLb2aIEMsBDBNQDFuOE+sRpWwwUxMOGLP2AvbM51Yvd09Au3ZZeJQxiS1LDLWysq4lwoO9t3lyiJHbWibutVIid2ZAX4lreKJtjRI+zbUC5OLkX8lSgXUbCjann3vlNMwpD4EOCLbhEHO7LAsQ7cXy12Y0cA6Ft8iziNHQlBwwiW4hZ2RMMGc3SLVtgROkBc4Sx6Y0ftYLGAtQiDHeHPxCHVYgOGpAoZOziLdhhSeik8YyxiYUcqINyGfaiAlik5xFC0x47I8OQWX7HDOpJHlYt8RTrod8s/xmL1dNQIMJ84i5vY0SzMnGMX7wj/GWw2qRYDsaOa4VjOWcwbipAQ55VqEXEoQp2Pz3zFMAzpVoNu8xVNsaMHNBfKTqzBjnbwaCtXsRc7ikSluVzFG+xoA5sOsxWRsSNPhJrQVoTDjmbUZ5hmER47WsKpFW1FduzIBLPG8xV/sCMtt7qmR6KCCLLxg0ZU4BISkIAGNLAME5AhCMmACq91pIFc+/lI/YvRD6BijB1twdquxvaOtv2UCuxIAuAGtpHUsKOElvvc6c5pkySwowpAxdw6Qvev5X0keuvI3u/Od7x9Ou963xve+yZ4vw0e8BjpO9G6/pG/YwRwp+Db4QMfasH/fXCBJ1zjC+d4w1H08Dtf20gT/0dRxZsSix2pIeNI3TjFpb2jan885kcasY6MQXNqw7ypTco2isjtlGQEgQwmWMayk32JCjTiB1wQgZluDvQjyWPceVwyevKrI3ZkHdIYWsKO4PF1S9coCDuCQ9k5XSNPvHntovaRqnRk4Dtq/TyR2FEv4I5qH5lLR4+r493Bw6YYmQJzHUCA4hfP+MY7/vGQj7zkJ0/5yiOgfGZnUReGxFzGHeIAoA+96EdP+tKb/vSoT73qV38A+2R+RYnYEQNC1+Rv2f72tjdsdpCwo1XQHvfAD37caUSDHQXi98JPvvJx/iNS68gbyF++9Kev1yPNYkebiD71tx983WOnETtKh//2uU/+b4HiSI/YER3GX/72VyoCgMjHj66uI9xhrvbuz3+lFvCFpdUISzFiD+ynfwQYJXWgDzUydzGiAANYgA6oI07AJyzyMzpiOZCDfw+YgTsCAyWwIhQwJHbQgBo4ggGSAZ/gQAaiCkNyXRdIgi6IIvzHggZiCBsoOhj4gjgIIEJwARjSDjsCfSKYgy94BBJoIOhAXzYohEoIIDAgBg7yBd6WhEs4hf4QAVxgICtUf1JIhUvIAJwgg+fRITHSDVvIhUsoBEMgHxDQPjqCA2VohkroBYGnHXwwJEnwhnAohCEABejhaTqCAqlzg3kohBFQBROmHW6wI14QiIPIhQ//sAcoWB3ppyO4hoeNKIRLwIPZkWI6YkCiIwMGEIqiOIqkWIqmeIqomIqquIqsiIpEsEHJ5wUukB0jFCPQQ0ia0DzKpwKeYh0UsAA7ogiGRA8KKHwTIAnWwQtDkoaGRAJrsHwL8Ahg6By/sCNNkEgYUAaFF3wMkAYxMB0N8Ae+gAnEgAuAdh/VsEizAIvCBwmzeB0tcA0iAAtkoAXuwQ2MpAi6mHwwUHfasQJYYA9T0EguUIzBlwL/o1tC4QOucI64twA2MI0KqRMNUAbAqHxrMEQT+RP9kEPJtwECs5E/wQJRsHyIMJAi6RNxsEDKlwJ8k5I8sQKcmHwQOWQwmRMN/0AHFyl8DGACwXWTO7EITyN8G0APQLkTUNA6yhcCU3eUOIEELJl8e+OUOSEDBeCQt5cBUmCTVDkTHFAK0gcEFtSVNVEFnKN8kxCCZFkTUAACy6cFTbmWMqFAyzcBlCCXNBEDYqd8GYAJGICXMkEBRoCVtyeWgBkTDkAEQxl8fqCWh/kSJeCWylcEWPCYMIEETLB8StAslukSSTAGy/cAl/CXnckSgkmYtkcIilKaK+EAgLCYwCcIlsCaLFEC25V8WlCZtKkSbJCZygcCgrabKHEBaSZ8C3CFwqkSHGAEO3l7e5CcLOEAr8CO0iIE/gedK/EGFDgzGomdK1ED9TMsIP/AZ97pEm0AmqMSAU5Yni/hAVvQnFnyAC3EnjABAaNAnUoiAYdIny+xD38XJVbAlfzpEvwQnkNyBN84oDNxAROyIyHwjgo6EwjACvC5IClgQhFaE6ngLpZyixlqE2hwmwFiA/v5oTTRBwZ6H2kgkSYaE1fAKPexATLQojrxAWqQMTAAoTSaE6TwAiiAkju6E3DAmUFapEZ6pEiapEq6pEzapE76pFAapVI6pVRapVZ6pViapVq6pVzapV76pWAapmI6pmRapmZ6pmiapmq6pmzapm76pnAap3I6p3Rap3Z6p3iap3q6p3zap376p4AaqII6qIRaqIZ6qIiaqIq6qIz/2qiO+qiQGqmSOqmUWqmWeqmYmqmauqmc2qme+qmgGqqiOqqkWqqmeqqomqqquqqs2qqu+qqwGquyOqu0Wqu2equJ9ASa6KckkAOBYDZ92gENOgExxqdQiB+ROKdEsCBkMKN3ygKuFyCtMC51egv/uSAR4KFxOgL/ESPjgGhv6gBZqCMzcAdwOl9KogRk2KZ/IyYa0HlnaghsKCY5gD5pGg+wqSQW4G5oKgr2aCh1EJxm2gaiYihNEA1p2gDHaihgkKBnegrz2iY98AZpagDKUinmMDhkSgJ7aShmQLFoOg0VmiXj4LBlygJKaSgh0F1nmgjbMCuuwGBm6gDTsI1t/5ICqcBDZfoMeTcqXrB3qVMDsOBFIxAAs8IArMCMkOMDsGAfCdlFbkBgo7IK2aCzdeMLiOAeeGCyW/QEzjAsXqAJdfMHBXsf+PhFDlAPHDoqYNAjRHMFN0ohFthFvGCQeBIBUjCW9/IB4iC1FOIFVttFDYAJIysmKkAEgesqtPCvKHIOY0QDjCAtTvCTrkINkDAkSnAqYkQB5RCthlIAvkIDaBcly1BGvOAHlcIAPPApNcB1YvINZdQB6JCvNRcpT6ABqKkjrXCdYyQH46okJ6C5aFIDODIrl4BG8VCSSpIfwwsGuRslL2CuZ+QDwVC4AbIDlFslN/K8WQIOWZNGnf9wDDriuF1yAwAoLUcgtm0kAim7ILYgoD4CAXDgdrZ3AK+QuGrkA4/gufdxl03SBVwghu8yDuAzR3Fwvu2xASVKI9gACnomLQOgLXd0BlHpD73oI89QvLdXCAyoRw4wC1lbCT4SBvZgt8OyCqTAonXUAtZArSuSBcDgCMB3ArDAtVXaAm6gC8H3AGogs1hKBc3gt7hHCOSJpdQgwLhHBtfApVUTfGRgZ1yaotLyxGFKALZHxWI6B8NyKS48pqN7t1uARGWaiG2yClIQCmrqAx45JACQDfCKptKgJINwCAucptSgIxPADeMVrspLIcwACNkbpzIEIBkABEBap1kAIABW0Ajfm6cvpgRqEJd6Gg5wgquWfMmYnMmavMmc3Mme/MmgHMqiPMqkXMqmfMqonMqqvMqs3Mqu/MqwHMuyPMu0XMu2fMu4nMu6vMu83Mu+/MvAHMyHERAAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbv3wQ59fAsf7tQFF1cHHowgzrw50C5wWNnyR506MufYs9OU86rOi+rg/Un/0E6+PEpR0JiEX+9vg/n38Dc60LTHDPv7/i7E38/fIQRDX4CA34C/9GfggQPRAEsUAzbozxYIRgjfE/jg4uCFAEioIXYrSOLMhSBSl8eGJPYGARQBfBdiiCKU6OJtphBg4Yo0avDijbBBcIgVC9Dooz9a4CikakPUE8iPSPrzxJBMjnbNOBEkmeQiTVbJWQfR5CJlkgAEc42VYFo2QirTbUljE2BkwkeYbFKmjhJmrkgOJlg40Oadk3ETp4MvCLEINngGOlkcDOzJHgpAtLOcoIxKRoyh1aGgzCEfNGqpZFQYesIywlR66aeRFbPlAmP40gKoqEamQJJHoGNKqrBC/wYBADSuEowOseYKmT0hBkEJB7oG69gHAg6IRxkuCKusY+Lgt44IwC4r7WIxoBBeBBp8Oe22iwVTHQgVJMHtuIrN8cARs0RL7rqH/cHuu/DGK++89NZr77345qvvvvz26++/AAcs8MAEF2zwwQgnrPDCDDd8ERoOR3zUKP7sQoLEGAPVh4paKJLxxzpxcAR4C1RgJ8goz2QEe9pckfLLLn2DXwiywGwzSknAMGDJENzss0gFXEjGxT8XvRERIUaCitFMW1TDCStG4EbTVENEATk/AoNB1Vwr9EiSA4jb9dgDdbKlLUuTTfYrUSY5gTBqk90HM1u+E/fYHugppTsN3P/dNS3WJlnNEH5zHccMUrYSR+FVf9CMlKsYwnjVs7T94wlwT950J0ciucAnmjdNwhhSghI60w7YIKU8fZ9edDcTJLmEB64XLYp9SA6waO03hyJIkpPox/vNHgSQJDMjDn8zNEkGsqTyNlNiAZJFLA49zFTsgKQKPFwPMxJl+si99y+bgvWP45OP8gjabN+9+iA3IA2SAcCfMh0+DkK7/SiXs6L+/HsZKUBEjNYFMGWZ6NGACnhAm/1ievdhYANthgYIhkeCE6SgBamzDANm0GZviB11wHGyD/qMBbEjoQmNxoJalHCFMIyhDGdIwxra8IY4zKEOd8jDHvrwh0AMohD/h0jEIhrxiEhMohKXyMQmOvGJUIyiFKdIxSpa8YpYzKIWt8jFLnrxi2AMoxjHSMYymvGMaEyjGtfIxja68Y1wjKMc50jHOtrxjnjMox73yMc++vGPgAykIAdJyEIa8pCITKQiF8nIRjrykZCMpCQnSclKWvKSmMykJjfJyU568pOgDKUoR0nKUprylKhMpSpXycpWuvKVsIylLGdJy1ra8pa4zKUud8nLXvryl8AMpjCHScxiGhMjQEiAMpfJzGY6c5mxOCZhgrYlAkhzMNSUkjWvGZhsJmmb3PyLN5EEznD2ZZw/Kqc594JOH6lznXlpJ43eCc+7yHNF9KxnXe4Z/6J86nMu/ASRP/8Zl4BeaKAEfYtBHYTQhLZloQ1qqEPXAtEBSXSiaakofi6K0bNo9D4cJR8SCGCAnv3ro+wJqffeQZ0mBMANydsXStej0uu1LzyM4EQJPHWvmYanpsrjgOXWE4FNnIMX9vIpeIA6PDGAKAoGoJdSq8NU3qkDRAwgmrymSp2q1u53F/JDvbjqD6+ergUPAJHppGoms4buDCGCwljbCsNLgCgC+5sXWd2quQGAKAhJpasJKTDUAZUjsNVcIRZCJAbEanOFsQDRA04118SacBkgykVPBfvBIoDoEZu1bAZNEaJwhPaxH0xGiEJx2m+asAwgClJryWnCQf+AqH6zTacJEwCiVOBrrx+UQ4iw8FvONlAYIFpAF4or2gYy70KMyBdwMygEEMlDusY9YA9ARArsNjeAJAjRFLyL2gYqIkS7c6xrJ1gFEAVCX9NtIDBAVAD4Zpd/QVCrfb/LvyaACB77LW8AZRCitDFXwPyjQXLVlVt3ThAeIIqETO8LP2uAiAwT5i/8gAAiOmQYwfaDBIhAF+D1HpC3FzrDh03Mv/CCaA4rpu0BUQGiDLywwfNs4KouhAt+xZd/A7zQIHxMYfLh70LNILKGybcGEAlAySBWn5YuBOAY61a7IGIBlFkMPwik9ULWK7GM+ReKEFFWzFfmn9kupIR+/Rj/fisQRhXwYQ5XeCIQhfWHE9xc5AaO4A6aiMYr1BHNLY+5owXtM6LV8uZFP1TRjvYopCNdlkZTOqOTvrRYLK1ps3C602T5NKg3nelRd0XUpv4KqlN96lKzOiurfrVWYi1rrNC61la5Na6poutdS6XXvoYKsIPtlGETmynGPrZSkq1spDC72UZ5NrSJIu1pC6Xa1gYKtrPtk21zmyfe/rZOwi1unJC73DY5N7ppou51y6Td7oYJvOPtknnTmyX2vrdK8q1vlPC73yb59zE7gICCG/zgCE+4whfO8IY7/OEQR0AdXN3pQxzg4hjPuMY3zvGOe/zjIA+5yA+QAYpreseQ/0q5yiHF14mifOUwj7mDj/1ymdv85iBVds1xznOct9yhO++50GH+84QGfehIN9RaiX30pDtdShEARD6Y/vSqG2oBX+Apo2KhjldEQxN3SO/Bmm71sq+oDvqwlBOIGghPuMIc+KiCMFYgMLKb/e4OckIWGgWnC3Wi7ngP/I9gUAJBtWC1gBe84kOUgU/cGExxkKxJAWb3xVueOlj3IJhYAKIeDKzyl7+8EIQXJghfSLOJD73q73OEvYdJACBaw+dXT3v2wKCxYHrchTyc+tr73h8R4AKYbHuh7vb+97VnACc0j6MZOUgBs0e+9IVAuCE5oOQXMjDlpc99L9RgSHYIkf9Wt8996YdArjiC64USQDDQl1/xEajC5Ev0CRBBov3v5/4D9vB4CR3ZQUCAf/nHfUtAehtCBiBiDQQjAwbQgA74gBAYgRI4gRRYgRZ4gRhIgUSQZyvnBclCIpHwX1SkCdt1cyqgYhrCAQrkIDRQRfSwATg3AZKgITQGIjJgRSTQZDe3AI/AfPtheg7SBFiEAWXwZTLHAGkQAwgCCn+lRZWDc5Dwgf0BUcCwRYpQgjYHAzdgIJ3jIFXARS4AgzeXApnAHyMQIh7DRT7gCoVicwtgAz6YHVMgfl7UAGWwgjK3BuNHHkHmIJ4HRv0gQja3AXLwHvIAIkIgRizAIDeHCOP/VR6MACLQMEaHg3MpMDXa0QV4OCCZI0YrYAU494YUkB2LBSKFSEYNQAebuHIMYAJ05xypACLsd0aLADU3twH04BzGI2RpBAUhgHMhQAXNoQUgUgZqhASIc3MogInCUWYgkgxrJAMF0IYylwFSMIq+EQ4h8iprxAGlwHNAIHa58TUXUgRvVAUpgHOTYAe9MWUOsgxwBAXFYnNaIIy6gVYgUmhvdAfJaHMTQAm64VQgQlxxFANLgHMZgAlbcxsWdiERgI1xRAFGQI0yF463kV8XMgB15ABEYIs25wfsSBsewIHscQl3VALzKHNFQJCyAQUhgoJ2hATqcXNK0CKywYQX/zJZeZQEpHNzD3AJC/kafgAigrBHEkmRMUcIYfAaJICU+KEOfOQAgOCRMicIluAaBsCIDoJ7fFQC/nVzWsCSrMEL57AJJAl8DLZHbDCTNgcCiRAbH1ACnBCJ4aENgXQBm+CGwlcbeeAGAfCVdhNIHGAEq2goe6AbEGAABIAEg+QAbLNyQqB1APcTb6ACKccIeziZP1EDOWAoIMCYmkkUbdCTWxIBXBmaQ+EBW1CYIfIARICaRwEBo3CWDiIB8webRLEP2uMjVgCRuGkU/NCZK3IESvibSXEBxHchISCFxokUCMAKrAkeKaBlzckUqaAi9/EAp1CdToEGX8keNnCb3P+ZFH0gnOGRBnE4nkdxBZUQHhtwg+r5FB+gBm0IA8wZn05BCi+AAo+In1EBBzbpnwI6oARaoAZ6oAiaoAq6oAzaoA76oBAaoRI6oRRaoRZ6oRiaoRq6oRzaoR76oSAaoiI6oiRaoiZ6oiiaoiq6oizaoi76ojAaozI6ozRaozZ6oziaozq6ozzaoz76o0AapEI6pERapEZ6pEiapEq6pEzapE76pFAapVI6pVRapVZ6pViapVq6pVzapV76pWAapmI6pmRapmZaow5QC9QJpQ4ADv4wAWvapG1aHRPwDU7aAJgFHhYAMUvaAI+yHnuqpH6KHxZQIEc6qDtThkWKqA7/YnxC6gHJeSGHFaSQ6iO896O76CPSkJ42ygOW+SPaII456qlIQg7c2KOk+iNmAJqo+qk+sgP22KNx4Fk/YgEA6aNP0IU+Mok+mgd0Qz95taMXMAlJIgis1aMj4FdIYgai4KMecJBIMgHd4KMNcIhJYgP9d6M4iSRjkJk4+gnR6SCB8Hc9KgxUSSMRMAs+agirICXNIJk4GgetICUzEGY6OgTVICUoQAs92gDusCXcsFw8ylJSwgzBwaPCIIg/8gKv0KOoED5IQq47mgTK+iOg5aMYMF8+Qg6+2aNuQJvrcQLfJ6SoEIIg8ppESgII6CD1ZaQQUAHhCgNic6Sy8Iv3/2GnSnoFNxUeRiCnMAseR5CWSmoIxOgPL3CwT0oChOAPo0ClfHqmUBu1Uju1VFu1Vnu1WJu1Wtul7hKlHDALR/AAMOakSVAB8xgMTfokhYUCxXmkHCAC64Af4nCkLlAGeNAgIACvPcoBlICRFzKDQKoDwdCuKwIA4nmjpoAOI4Mk0JejLeALYxCuF1IMN/oBwrAM5yolsQqjH3AIyhA4kEIMMDoC7QAEoKtyDGCvKIoNiyAE2Clz3ICiDoAFmHA+POcIUEmifJAJfzl0tpAKosqh1xAMtIJ0uRANHVCii4B0ETAO2mKiTyB0gVAP1ZeiRStzC2AFh3C4JqoBMocLBKbwli8qAiv3AgEABdyronmQcs4gCa9Io8W7JbhQAc9zo1sgJVEACy24o7/wIyDwBYaQvjV6AStiBnugCdmqo7aLH0wADc1apBJwHy9QB69wikeKDOFhC6wABwKrpCOwAAfgClxwn0zaB8m7tSicwiq8wizcwi78wjAcwzI8wzRcwzZ8wzicwzq8wzzcwz78w0AcxEI8xERcxEZ8xEicxEq8xEycRwEBACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrVu2DxiwJm3rIWU27NmA+aATswuWvt+9htoMLl9tmWDkhKnwrV05quPPnZDuI+gTG1vLry7lB3879KocbFbSh/8BOfnm17ujTK6UAPkiE8vCXN1FPv75PXqTITIjP//oQ+wAGCNMK8WiASH8IXqeIgAw2SBIb6ATxQIIULneKgxhmeBEEWNiQQ4UgLseJhiSW2NAlIYSoonJLmOjiiwQBs+KM/kQC440mykLjigxwgOOPGDqQ3I4h9gHkkQyqQWSIcCDppH0lLMkfImRw4gYNPjyppXoNHCDlcgCAUQ81bWxppn3KSBnFLu9AMcKZcAIYzowLQAJMO5bEqWeAH4xH4QOeSFFCC3sWKmAACJIDy6CGNiqgHvCFMA4tZTpqaYAtnLAcA7kI0MmloDJoRW8nuMJOEqGmKqAw44Tjgaqwxv8q66y01mrrrbjmquuuvPbq66/ABivssMQWa+yxyCar7LLMNuvss9BGK+201FZr7bXYZqvtttx26+234IYr7rjklmvuueimq+667Lbr7rvwxivvvPTWa++9+Oar77789uvvvwAHLPDABBds8MEIJ6zwwgw37PDDEEcs8cQUV2zxxRhnfJoHP2hccAcF+DOOAx4LrIFvxHxQ8r+YLBfEmyvv+wp2k1wQc77xMEAeAHncbC8LFsBXCB8+z/uHl/EV8UTR8MqRYn9KM93uBR8mGAUPUqvbxTogqoB11ufio6LXYJvbAKIhRrF02eQ6MI+KUbNN7iVwEy33uKOoWEjPd4v/K8ICIQJgc9/h+gI4iJPATPi30QQNYhAqL/4tGo5XSAzJknuLxgshjpP5tyxwDmIpn2teOYXNlc4t5SAykIzq3EZzOIURUAH7toaD2MQdt2srQoiRVNr7tXmDuM6rw19LN4gBJI/tFiFW4Ly1DqBdYTTTV9sAGSBO8Gn207bgDYhRJAL+tKEEUuERdpw/LRKrJLgGoe5Pq8jp5Ulff7XRxIdCOPu7ljHKg4ssBBBb4MBOJUhwQGxxwBPLKQXmGnitK5ihNxEQAQW3pYMURAEHG+SWLEIRwhKa8IQoTKEKV8jCFrrwhTCMoQxnSMMa2vCGOMyhDnfIwx768IdADKIQ/4dIxCIa8YhITKISl8jEJjrxiVCMohSnSMUqWvGKWMyiFrfIxS568YtgDKMYx0jGMprxjGhMoxrXyMY2uvGNcIyjHOdIxzra8Y54zKMe98jHPvrxj4AMpCAHSchCGvKQiEykwSaoyNUsYxN6oEAjUzMEx+3ACKiYpGk+cR1IvCIGmhSNH8jzggBQAwKh7Awb+KMFa8wmlZmRQoK4AEvMXBBBX6slZaiQIG/o0jJfSNArfkkZDIAAQRkYXLKAkIBmOvOZ0IymM2NBuCghyBXMChmNCEA4JSFID9ncETfv1oEdIAgFkVOWNmc0TrnpCEHyaNY6V9ROtkEPQcAJ5zbv5v+AY/ZnBxiQpzjvZogEqcFZ81RRPcFmgwSVAKEDlRsAEHQASQp0n2y7Q4KU8ayEhmihUkNHgu7R0YiWTRcIOkE69clOtq1gQv3BZkkxCrZkJCgT0PIoiEBatGYgiAHCu2hLyxYFBB0jWjqtEE9v9ocECQCpJpVaKhL0vZkONWvc6w8IUJnTqBatAfvpjzuklVQKLXVlmkhQN8jqVZ+VI0HKtCo9wYbS/pBjWmVN0Fk99gH8lWdEbKVp0W6QoHxCVbA+EwAy6XfYqxatEkalVl4RtNeMYSCs/JGCZNu6smsk6BubRWzMsoGgBSiusXNlmjQQ5MvQOvZmvOkPHao12f7/VPZibUhQO2jLWY/JgAvjYIbO4DMH3orWZyMQwztMUNTlIMJateXPbW9mCmFIYRBK8McuoNtbtkGADbnEa3eJKZjoxme65O2LeeGD3vTuZb3laa978wJf8sh3vnepL3bui9+66Pc6/O3vXP67nAALOC4EVo6BD/yWBPtmwQxui4N7A+EIr2XC/qiwhdOCYQ1v+Cwd/rBfQixivpC4xHo5MYrxouIV26XFLqYLjGMslxnTGC42vrFbcqxjtvC4x2r5MZDRIuQhm6XIRiYLkpMsliUzGSxOfrJXoixlrlC5ylq5MpaxouUtW6XLXqYKmMMslTGTGSpmPrNT0qxmprC5/81KeTOckSLnORulznYmCp7zLJQ98xkofv6zTwItaJ4QutA6OTSicaLoRduk0Y6mCaQjLZNJUxomlr60SzKtaZZwutMq+TSoUSLqUZuk1KYmCapTLZJVsxokrn61R2Ita47QutYauTWuMaLrXVuk176mCLCDLZFhExsixj62Q5KtbIYwu9kKefYhO4CAalv72tjOtra3ze1ue/vb4EZAHcZL5kMc4NzoTre6183udrv73fCOt7wPkAFyh1kBX8q3vvXt4Rvje98AD7hCBf1vgRv84OwlOMIXzvAHK7zhEDd4v2lc8IhbPN+gePjFN76kCAAiH3yuOMdHvqIFfGGlbf8WOclXDqI66MPOKme5zBHkBAPCOeYzzzl8YPDQlOv858j8BCO9jHOgG903Jm/AmYt+9KYLIa5YZnrTj34Em29Z6lM3OgzEQPSse/06EaBl1L9Odt8wgBNKlzLWy/5zIfznyWtnu869UAO4y13uIYACk+N+95xHoApcBTLf+z7zB+xh6BQn/N2XAPUYy8AAkI+85CdP+cpb/vKYz7zmN395Irzn4F5wAbRrookeIFwFZxg9TeixAYRPQBKqnwkJ1oDwBTwi7bF/CQbKAFOBMyANoMw9TGbxeYNDQvTCf4kiTH9wGNwg+S9xQesPngKcQr8lPnDFcAW+ABvg/vopaUD/GWYn8DUwEPwr6QdmBb6BV6I/JSxorsERMYX3qyQOM0B4Ctxg/5SsYFQH130W1X8l0QB0QH4AxwAmsAIZwgNsEHhGtAiacnAbQA8Ysgv+oASDIAXCYApGBAVPY3AhYDsNciDLEQUm8A5icFo+hAT5d3AowH8CMgfxwQDMMA5cIAM/JAMFsH0BlwFSMID10Q4JElQ8xAGlsHBAwILpQQcIggtDVAUpgHCT0D71MT79IQ1EBAX+ZHBaQILpMQIIWB7ZUER38IIGNwGUoB7fQFVGFANLgHAZgAkB1R2y1B8TUIdFRAFG4IMBt4TdcQwIUglJ5ABEMIEG5wdW+BwtUG/9//FUSlQCXShwRYAF0DEMCfJ8S4QETIBwSqBBzsEJCGIBKIdESTAGCPcAl6CHtkEOCKILT8SHfghwhBAGwXEBCVIOUOQAgICIAicIeVIb3ZAgmiBFJdAECKcFlkgb7oAgE/B9T8QGnXhwIGA+qgEBkwgfZFBFF7AJBrcAYqcanZAgqWBFHGAEYygle1AbioUgf3BFDvAKxfclQlCKpyGI/REFWvQGQyIljHB+q9EGs0gezbBFNVA1RAICSGAbmZAgr7NFbYCKOxIBXGcbroAgD8CAXOQBW5COCfIARBAcH+CL8AGLXgQBozCPFSIBELga95Ag6BBG+2BOIGIFQkgbaf+CILwTRvyAkAhyBMFnGxSANPwBAGR0AYOQICGAfMFhTf1hA2WEAKzgkcqRAizgHN7UH4ZwRqkgOuTxABcyHBhAk/wBAognRmiAjORhAy1ZG5iIIFugRn3gk76RBtBoG/KQILKwRlcAWcqxATroHH2CIDvQAWz0AWowXDDAlMMBKQhyUG5ECi+AAvUHHReJID3nRnAAis9xAY5YlqxIgDkxMwjyBaLZE1jYH2B4mjjBAwliBqy5E1yQIJoVmzohB9agBfzBBrbJExBADQHglcvhB735EzHwCpBwHZ9QnEGBCkZAkxbwdswJFBSgB5uwDNNZFGeZndzZnd75neAZnuL/OZ7kWZ7meZ7omZ7quZ7s2Z7u+Z7wGZ/yOZ/0WZ/2eZ/4mZ/6uZ/82Z/++Z8AGqACOqAEWqAGeqAImqAKuqAM2qAO+qAQGqESOqEUWqEWeqEYmqEauqEc2qEe+qEgap+hsJccigNRkAI6sKEi8HlmcAUY6gBJqBye4CMVSgJ+uRzgUKFZEFvYYQwTGg5+Uh7gBKEV0B8WsCAN2gK0hyCrsJALagdHUCG2QEIKmgjy10uMhaCdsH4IQgZ3WaD9wzzbOaBFCiJxuaDWQyGXsKAewDUgMgoL2gaRECKciaB3oJYUsgC+sKBUoJL9sQDYo6C/MJDxYQFosKCkECKGuqAx/1ohL3CVCjoOIfICh5qgDkAMilqpCPoBQaCogYqgIzAJIaKnCnoBEwUiC1CnBpoHhaAicJqgfFAEKrKmCfoEshoi8zCmAPoEV0ohAfClAsoD/Vgh+oOgwmo8XbCgPGCCCJIDjXegtoogiOB+DBqt8XEA7wihfNCq5WEBkBqheXCq17EA8VChFyCq1zFMFjoCnaocmJChH4CpvaEBG+oAkloAujqhP4A8Idqv/vqvABuwAjuwBFuwBnuwCJuwCruwDNuwDvuwEBuxEjuxFFuxFnuxGJuxGruxHNuxHvuxIBuyIjuyJFuyJnuy4OkB4eAOwpChScAOrjCBVmChnSAAuf/ghyeQpQ3aBrQwDiGIHUO6oC1QArDgiv3RPAg6tFLgCb13TvbYn5bQDsAACVTZHwDknyMABe+wC706IxyVn21ADfUABuKabwcArOvZGm7ACWTArAaXme8JBxcHmfDZBxenAvlqnhxAqAdHovA5pxYHDPIZhxEXArQKn6LIcDlgA1jQlu15Cgf3AEGADrxpn4oQcIigAfGgkfg5BPk2AWRACrzwn3i6IhEQBBVwAzfZn9WgIiigDalLowTKDRRiC2DwCaJgmAl6DvGhAkJQDsNghAqKDNcRCbsgAGhgNxIqBz2wCRJwCliCstI7vdRbvdZ7vdibvdq7vdzbvd77veAdG77iO77kW77me77om77qu77s277u+77wG7+1EhAAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz588mOyS69s1NI07KChwDEAy069eZh3QSRorOmlyIFvjbzbs3MdjAgycmgYUdNCCQHPVezrz3AOHQo+uVcePTliAgmmvfvnuG9O/g2ar/+iVFSBHu6NFrCc++fVh3B9LLT6/Evf37WIHM38/dAf7/ADqFDn8EMjdEgAgmWBQLBTa42xMKRighTyM42GAnE2aoIU1OWEigGBuGKOJK4HjI3y8jpqiiSKOYuN8pK8YoY0ZYuDhfLDPmqCNEXehmI3rQ7CjkkAgd8aM/CTCzDRh0GGNPMizwQgKRVFLZTIEZFFIJN+LAw8IdXVQp5pgEcYEeA4EsUQoXUNjhH5lwximQAczZkoY6vvzhgZx89vkPBREw4s4oiqzg56GHNoDooow26uijkEYq6aSUVmrppZhmqummnHbq6aeghirqqKSWauqpqKaq6qqsturqq7DG/yrrrLTWauutuOaq66689urrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfghivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvz26++/AAcs8MAEF2zwwQgnrPDCDDfs8MMQRyzxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLoDpQSjQw88rBMv68YEjNucpQDW87xMGzrXwwsRwuSQw96x9RNFcMB0rDCkV82oETtau0WICeAFev2sh88XR9qgPA7JdCH2KT6sEuBAYSQ9qiJhFJgYN0AHeocexQoAR3h/9qiNYEitA3qN0UGAGGg3sqQIGRyJC4p+kUmMbjnXJwTIHvUM7pFefxt8ANmm96TQQEhhBK6JpSUmAQb6J+aSkFEuA6pg5oQ+ADWMx+aQxz82eLobpXKgrp/AUQvKX2FAjj8ZQqQ2AKdzA/aReMEJiL3dJHGocSBMqefaTtEJgBKt9HeiV/R0BdvqMtAEDgI+s/isoL/J1wevyNkrKfH1ng/+gS6XnBNLDnv0a1QQXc4V8BI6UA7QiQgAt8lDuYo8AISmoFZuDNAy1IKVnspoIcpNQjBhjCEprwhChMoQpXyMIWuvCFMIyhDGdIwxra8IY4zKEOd8jDHvrwh0AMohD/h0jEIqqrGy0w4opu4A88NCKJShTRJnjjRChGcUI0YA4eBAC8KyqIGNpJQAW66MX/8AA9YnRcGfHjvPSgQAoHWmN7+JCB/RhBju3hxH4eACE8gkcGKNiPO/wYnljshwE1IOR3OqCF/SxDkd+JBn+uAUnp5GI/g6hkdHDAnzdoEjoTnI8XPimcJNBvPoIjJXDesR8YUECVsHFABufDNVi+5hD7iUDSbOkaK+xHA7x0DTZ8JB/EBdMzFdiPJ475GQjMUj6UYKZnzrAfFbxSmpwBw35ggU3OyIB48oleNzVDhP0EYZybueR8uoHOzNxiPzu4Zjstgw87zhMzhdiPKO5p/5ksipKflgnGfkYBUMpAoGnyWcD9YAWEBDj0oRCNqEQfiqOIaWI/dZhVAVzkPYhtYT/RlNVGTdTRh83CE/JJgRVhNVIPlRRifDgHSrcDBlq11EIvlRg2PlENBjBHGDblqMYSwVOf+uMA6hOpUDlG1GqMo1Y3dVBONQYBqC61oImJaoOmitXBaDV2Xc3qVcNamK92j6yHMSt/uIpWv6h1P2xtK1/eOp+4ylUvdJWPXe+Kl7ymZ698tYtf0QPYwNJlsNwprGHlgtjtKHaxcGmsdh4LWbdItjmUrSxbLsuczGpWLZxdjmc/i5bQ9ma0pDWLaXmD2tSSZbW7aa1rxQJbf//IdrZgqe1tcesV3fK2Lr797VyCK9y4ELe4bzkuctui3OWupbnOTQt0o3uW6VK3LNa97liyq92wcLe7X/kueLsi3vFupbzmzQp603uV9bK3Ku5971TiK9+o0Le+T7kvfpui3/0upb/+TQqAA3yUARO4KAY+8FASrOCgMLjBP3kwhHsi4QnvpMIWzgmGM3yTDXO4Jh7+8ExCLOKYkLjELzkxilui4hWvpMUuTgmMY3ySGdO4JDa+8UhyrOOQ8LjHH/kxkDsi5CFvpMhGzgiSk3yRJTO5Ik5+8kSiLOWIULnKD7kylhui5S0vpMteTgiYw3yQMZO5IGY+80DSrOZ/sFn/zW8+c5zJPOcw19nLd95ynrG85yr3Wcp/fnKgmTzoJBfayIcecqKBvOgeN1rHj75xpGk86RhXWokdQICmN83pTnv606AOtahHTepSI6AOY8XvIQ7A6la7+tWwjrWsZ03rWtv61geoI0kJ3MAj+frXwI4tr4NN7GLjdNjGTrayCYvsZTv72bZtNrSnXezd4rbX1M42sEEhbW1720URAEQ+/Ivtb5vbQwv4wgf2W+5zu7tBddAHftv97nrvxwn9ky+97c1v9MCgBPrut8Dnk4FPtG68+x64wnuTbkWZN+ELj7g/hHCBh0v84sw5Qr67C3GMKxwGIOK4x0e+mwhwQeQk/x85Azjh8Oh2POUDF0IcnftymAvcC4mkuc1THgIo6HznJI9AFapa3JoDvd8P2MPBr310mC+h4r+VgQGmTvWqW/3qWM+61rfO9a57XetEAKexveCCNrNEEz1YtgrOYPaV0GMDy56AJNquEhKsYdkLeETL6V4SDJThAcpmQBrexveTzELsxYZE2QtvEkWkXdkwAB3jS+ICuCs7BZmYfEl84AqjGnsBNti75j/SgDIQ09hrmNLoRdKPCSx7A3JYvUhYgNBkI2IKsg9JHGaw7BS4IfcgWYEvlQ16eQJ/Iw2gw+mJzQATkPH4GlnECV5PD+h3BAohWHYIqGB9jiCB98pGwf/vu68RGRTA88XOgBSMT/6KcAB2ywbCCNqfkSqkYNmTsAP9MQKF7ChbC9y3fxZxB+CXbBMQUgJIETEAQMqWAZiAAQlIERRgBOhXbPIXgRPhAEQwfcrmB/qHgRJRAv6XbEWQOyAYEUhgNMqmBKl0gg+RBGOwbA9wCRDogg4xgRVIbIQQBjboEA4ACByYbIJgCT3oECXQBMumBSZYhAvBBiqYbCCQCEzIEBcwRZ93clPIEBxgBMvna3uQhT74Coj3I0KwbmDoEG+AQL7GCKp3hg5RAzlwJCCABG4YEW0Qg+AWcnUIER6wBV3IHw9ABHs4ERAwCmO4HxJAdIMoEfugNwX/YgXst4gQwQ9xiD6EJ4kUcQGDsB8hsHjuoYhGhACs8IfLkQIsgB/jUA2fIIVKlAqnpB0PsDz2wQFUwwCqyIpEhAZIqB02AIrtIQzMYYufgA1E1AeVuBxpIHrtoU3b4QnnwAdCdAWVsBwboEb30QKBlB6eMAtB9AFqYFQw4In3oTrzsQVDRAovgAK4ByCoNh+aQERw0IL4EQqkyBxR4IuYKBEtMh+tkY8W4QX7QQP+WBGosB+FMJAVYQT7gQ8IOREU4IjycQsNKRGSNB+5MJESYTvzIYgY+RBPkEvP15EK8Qj7UVMi2RAUgAf7wXYnyRDkKB9mgI8taRAzJR8VMJML/9EJ+7EAxIiTCaEB+2EFPpkQSXCI2nEIQ4kQizMfZrB0SfknMLAfxvCUBiEC+/ECu0SVAwGQ8zFIWjkQb8AfOPCVA7GJFkmWc8IfNIOWODMfWgBBVFkDObgdFUWWoSQfKGCNWvkEgDcfnICW/6CQBAeNaDkEUpCN6KEMgDkQMlABCYAePLCYBLECjqkdvyGZBbECAqCSyyGQmGkQLdAInOkPm/CZCRGaKil5pokQLcBOq/masBmbsjmbtFmbtnmbuJmburmbvNmbvvmbwBmcwjmcxBkiHTAN8FObWeAHuyELs3mcr2gGIYmZy8kcXmma0KkdCmCa1bkdKtAGkpmd6P+xBIvZnfJBCmgZCkEoHy9APmRJkvwBACv1lBxgJPzRDGiJCrq2H+2AlgRAIEogNF/ZAeq0H4wQJl95B/fHH4pJlqdQIPaAlgFAIC+wT1+5ArbQNpdIlVjQl/uhDU45lP9JIHzzlQ4QBAUCD2QZCtnHHxFASV95A/WoHUVwBWTJSgRyDElFlWlQIOlAljLQO/xRS1rZCUbJHa6plVZJIBawM18pAQUSNANqlvwRCVn5lDEQCASyC3vylX2woPIBDCGalPEwH42AmUu5HRZAC6ZZItpxAD5nmhxQDM0RBX8Am0mAC8vBBIQJm3nDG9Wgl7BpCPSzDDsqm9FQCjJZnIz/2qiO+qiQGqmSOqmUWqmWeqmYmqmauqmc2qme+qmgGqqiOqqkWqqmeqqomqqquqqs2qqu+qqwGquyOqu0Wqu2equ4mqu6uqu82qu++qvAGqzCOqzEWqzGeqzImqzKuqzM2qzO+qzQGq3CooyruQKKMAruwAgREIlo6QE64AvqkAbPxBtjOaB2AAVcUApLEAhz2RtY2JJdcAcsAA8EwA2VUAj7uR/4mY8kwAss8Av2YAx0AAbbwAyP+SOM4I/QgHcIKomGtGxLuIgPumwEhYm/4GxWg4li4GxOkI866WzzJ4kf6WynKIlD8GzogIkd8GxAkI/co2wHcJ2L2EjBVgRCdiAFv6AKA1mAJgICQbAFn3ADgjqQP1MgjgAJQAAN7IAFbdiSYLQdC4AIubAGdEAKCtAJM0eVwQAAx1AAysAJjZAJ33ANiQCX0nq2aJu2aru2bNu2bvu2cBu3cju3dFu3dnu3eJu3eru3fNu3fvu3gBu4gpsYAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2venHEEnyzXbqCJJ8LNjx/TKqhevVrAaR+cY8uuHEfBIgFfwGyaFCiBv9/AgwsfHpzE7OPIGe8hzry58xXJo0sf3Mi59ev+Pkzfzl2vCOzgiXf/H09eLrXw6IGXX88+La/06A+0n08fbBv44RPU388f6wP82IXQ34AEPhUFgNcFUuCCDBrlB4LWKdjghBTytASEzm1Q4YYc0lQLhs1p2OGIJKoEDYjMHVPiiiyKRASKxAXR4ow0ZiSMcxbgEQg5ngRhggnuaPCFBEQWWSQwGjRS45JMQsQDGe6UEYsIhzwTRxvaNanlllx26eWXYIYp5phklmnmmWimqeaabLbp5ptwxinnnHTWaeedeOap55589unnn4AGKuighBZq6KGIJqrooow26uijkEYq6aSUVmrppZhmqummnHbq6aeghirqqKSWauqpqKaq6qqsturqq7DG/yrrrLTWauutuOaq66689urrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfghivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvz26++/AAcs8MAEF2zwwQgnrPDCDDfs8MMQRyzxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLMMcs88w0x7YCGJnUHKchtviDgio6t9nBJQsAV4wDQav5hCDDEZA0muygQFwGfzxNpgwBZIiB1WFqosV11nDtJQaYFH3dA52IvWUM66B3BAVqazlGetDE3aQpTaD3ACp2M/95I3p+IN13jeOkR8rgNa7QA3opWII4jcOkJ8TjNGqQnh6UtziCGejBIIN0e/iS+UdnpAdMdCz8Nkgco3ekht59IIcBE8BZgIkHrWtEAgzo6YJcLMMFckjuGemRHjyzXaEEc8Q4TrxFF4YHwwiyWd7cBO808DxFlkgdHh2xGcDAdcywsP1EpOiNBGfFhAdOG+dD5AAk6BWwmfHhWcB6/A/1kh4UmeFAJNAjBf5FpBno8YLgLIMO9GihCwaESBJWgR5JXGYIvglPPCIYES50LgyW4QR6BsDBiMwvPHigQWXm8ILwLKBqJYQIFbBzAnVApzLKQI85YiiRrDWHAc3Iw2X/eDA+8BzgAjyMiB0iwJwl8CAzJkCPkpIYEVAMZxKy0AwO0BMIDlAxIiMAAXAiIbrNzC083fiiRKrgjx2QQnubuQF6JqFGiXSgHjfkTBDQI4Y61keO4dmEH+uzx/DwbZDtwQJ6loHI+ZAhPAyoQSPZgwr0jGOS7FlDeB7wBEyWJw5FxI4GPFkebmyyk6TsTiIsEJ5RprI7FYAkKl+5nQaIYAbYAQMty1OCSljnibssjw7A8Z/hECOY7eEDLJYXHCwgcz4rQMfi/OG7Z9LHljMYnjW3yc1uevOb4AynOMdJznKa85zoTKc618nOdrrznfCMpzznSc/tACEB+MynPvfJ/898xqKefykAiJwG0L4IFEMELeheDgqhhCo0LwxFkEMfepeIAmiiFK2LRfGD0YzOZaPw6ahH4wLS9Ih0pG8pKXpOitK2qDQ8LG3pWl4KnpjKNC00xY5Nb3qWnF5npzwti0+tA9SgjmWozimqUcOC1OYodalfaSpzngrVrkiVOFSt6lau2jStsoWrwsmqV7EC1uCIdaxWKStwzopWqqj1N2xtq1Te6o+4yhUqdLXrXZ2S170KdaB+JUtfAyuWwRIWLIY9rFcSq1iuMLaxWnksZMkK2Mk6trKWjSxmM0tZhHJWs579bGcbKtrRSrS0V5Esap+i2tU2pbWuXQpsY5uU2f/S9ii2vW1RcqvbofC2t0H5LXB/Itzh9qS4xt0JcpObk+Uy9ybOfW5NoivdmVC3ujG5LnZfot3ttqS73l0JeMObkvGS9yTmPW9J0qvekbC3vSF5L3w/It/5dqS+9t0IfvObkf3y9yL+/W9FAizgiRC4wBE5MIIfouAFN6TBDl4IhCOckAlT+CAWvnBBMqzhgXC4w//4cIdFrGESX9jEFEZxhFXsYBYv2MUIhnGBZSxgGv/XxvzFcX51bF8ez9fH8AVye4WsXiKf18jkRXJ4lexdJm/XydiFcnWlLF0qP9fKzMXyIDuAgC57+ctgDrOYx0zmMpv5zGhGQB02e9hDHOD/zXCOs5znTOc62/nOeM6zng+QATYTVgEwCrSgB43VyQKa0IhOdGgbe2hFO/rROjU0pCdN6a5CttGVzvSj9YpSTGv604QGhaRBTepBRwAQ+WB0qVcd6AV8IUt/ZrWsUVQHfRzW07POdXqckIVY6/rX8IFBCQKLa2Ab2zkZ+MQC21rsYzt7OK6GI7OfTW3rCAGJ0662tolzhF6jtdnbrjYM+jhWcIeb2hHgQrnPzW7gMIAT0l6qudv9bCEMoarzprezvSBJeetb3yEAoFHz/e9jR6AKEAgqwQtu7AfsYdmdZvi/l4DtlsrAABjPuMY3zvGOe/zjIA+5yEf+cSIwEdJe/3ABiEGiiWk+WgVnWPlH6LGBSU/AgjLvCAk0CekFPCLeOccIBspQTEczIA0xCDpHZnHyR0NC5UrXiCJc7mgY3CDqGnFBzSGdgpxhHSM+cEUoFb0AGwD96xJpQBnM9ug1GAftFunHBCa9ATnA3SIsOBCkETGFu1ckDrjkuhv8TpEVWGHSZYcb4SPSADqwXdEMMEEeF/+QRZyA7vSgfESgEIJJh4AKmocIEgL/aBQMPvQOkUEBxp7oDEhB8ahfCAdKQWkgUC/2DKlCCiY9CTvgniFQECOktQD63yvkDqR39AQoYXyFxCB6j84AJrbW/INQwAisT7Ttq38QBxDh8pD2g//vuW+QEgj/0UVwJvkLggTaQVoJIlh/QZJwxkc/4BLUl/8/rp99RBMChPr3Dw4ACOD3aILgPAFYAnkzfOoXgGzgfo8GAokQgAJxAZvwaAugbhQoEBxgBI83aHuwgQThAK/QdIImBLAmggLxBiowaIzwdipIEDWQA4EGAusTgwbRBvUHIRFAbjhoEB6wBR+YHg9ABD+YEBAwCiaYHhKQcEeYEPuwA/hhBbD3hAjBDzToNklnhQtxAYMQHiEAdVy4EAjACkM4HClgPmPoEKnQQs3xAKewhhCBBgtIHDbghHLoEH2QhcKRBmeXhwtxBb4UHBvwOYAYER+gBkUEA2J4iBH/QQovgAJ954gUAQfxR4mYmImauImc2Ime+ImgGIqiOIqkWIqmeIqomIqq2DqHMAMi8Iej6Ay/0QPoMHmjqEjBoQSwwAelSAzE8QDgoAOiyAPWUQnD9olggB2uCIuAeAv9xxwVwInWgx0WMIGa+ARFdx3cII2QtD+ZiI3hsQacWDjhIYyaWAPPSBxkwImEgB4NiImVFB4ysokXGB5Xp4ligB7zyBkrUA8dsE2TgB73qBkNcA5SWAXW1A3oMQac4QsD9BsgcHu7xAGBgB44oBmyEJDCIWrBVB3hYQKZwQPQJxwvMH6vdAEHAEnAVBl50Azp6A8BsEvmgB7KYBkroA4F/+gchvBKf3CGzPECc1AZNIAH4bEBENdIA4AenGAZYcA74aGBmBQP6JEA92YZkoAeq5AEmNQFXxMe6IAZDuAF6NEMmCQF6BEJVVgZUJAevdBIccBK4YE5mtFUkHCUVNQG4BAexcAZSJCN13E4jcQCzHAdDGAAsUEH6IECCDhIDfAOc9ccrsQZI+CU4LEEnmQJvkgcSnAFswEPl0NKh1CRwvFPx6ELnQODk+QBmACX/sAE+ScbfeCX1qEGrxQHX+gPaogcwJAeMfdKvhCC0SEDlIkdZmCLjog/rcSJQpAew7CJlrB74dEDxnmI6WNJm+gAD4IewrCJqCCbztEEprCJJ/+ykJtIAUeAHuuwhZnYCd4JbdPXidZwHVqgCZ+IAVvHHAFgiJ/4B302HCjADqRIAMMhCLMkig7QPr+xAJfwj6aoClJjCzuZipkABtO5ihZ6oRiaoRq6oRzaoR76oSAaoiI6oiRaoiZ6oiiaoiq6oizaoi76ojAaozI6ozRaozZ6oziaozq6ozzaoz76o0AapEI6pERapEZ6pEiapEq6pEzapE76pFAapVI6pVRapVZ6pViapVq6pVzapV76pWAapmI6pmRapmZ6pmiapmq6pmzapm76pnAap3I6p3Rap3Y6MB/QBnHwDIcgArFQBu5ABisZg42gAcBgJIj6BRrgDj+vEgSeQA6BgAesSRzb+YOFRGhG+IPHkGiXcIT3OWi14KmJZpk/KJqE5gdHaKqDFgVHOJyC9gBHmEGIBj84mJKJxgs/6GjUkKuKdokq6AGONkUquAKOBpwqGAMokgCBMAmbAAZfIACLoADeKII+cBoCwBrYOg2n4QYiEA9ocAPXkAV8IJF3Wq7meq7omq7quq7s2q7u+q7wGq/yOq/0Wq/2eq/4mq/6uq/82q/+yqIBAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza968UkSFz+d+/KgiQkEJTX9umQrDubXr1wpN+JtNu7btDDCcFEvjjlMjEdR4JIFNvHhkYraTK1/uL0MRPsajSy8chLl16x6ma9/Ot/r177VXcf8fT56ud/DgZ5Rfz37tefTXhbSfT1/se/jMzdXfzz/rffzKCdDfgARC9R+AtmVS4IIMHnUggrRR0+CEFPr0IIT+IFHhhhzWdCGErHUo4ogrfQigIySmqCJJ3mCoHDMrxijjRq9IYKMGOAKRRhDeMGNLAhaAV8eMRBYZUgt8oCLLL/a8E0wAzhQygT9qGGnllST5QAKWXHbp5ZdghinmmGSWaeaZaKap5ppstunmm3DGKeecdNZp55145qnnnnz26eefgAYq6KCEFmrooYgmquiijDbq6KOQRirppJRWaumlmGaq6aacdurpp6CGKuqopJZq6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLO97DzddtFxnInj4wwwvMs9ZB20REJEznKMkt8aWP6/ZxwvKmUFF0WlywARzCxDgANNmSvDdNqZQPaYiDICHBzJag9lCJPjt0UDYXQIDYC4doI3lFACi8ITbV/pgBoDs0H2lOQAG/6C3lYoAWIQMfxdJgRP4MTBF4UWWA6AEjBPJRpDw5ZBd5DFC4Ax+C9CAuYxVAGjD5zEmsQp+TnBA+orNcG7A6ir2AiAnsKfoACT4BRJz7SNyAWAJvI9oOn7gBD/iBePA18Rwxo9IgyDg5d08iRCwA4N1ukw/Egn2FOdDGZTb9kAf2oPUwSs7+COLcS4skRwd5X/0BjO0QQJBdN8AQBsMI8TPERJCSI4IpNOAVDjCH/Dwn0ZIQIcHKKcIH5hOG6ahQIycL33MMUYFKzS/7ziCeRsskB0CiB7IhbBAcgjfdywAnRMSCBb4qZILByQDDILnAbeY4YCCBh8w6LA/DWgFfP8YQL4f7ice+DGBEfmTC/zoYIn1OUMSoVgfE9WGATWg4nyegR8farE9BRiihr64Hh3gRwNkZE8A4PMAO6SxPGaETzDeWB7ZoCcFMaDjeFCBHwLocTxkgA8IIvhH7dAAP90rpHY2AR8A3E+R0hEDerwggrZBUjq4Yw4D0sCCS26nG8tJATDu4EnudMAWtinCO4hWSu78gDZ+8AUGWlmeFjRhF0ujJXtCpMte+vKXwAymMIdJzGIa85jITKYyl8nMZjrzma0EQgKmSc1qWvOa1IwFNAcTRhfNxo/bDEw3vQnOcP5lnC4qpzn7gk4MqXOde2knhN4Jz7zIE0H0rOdd7gn/oHzqsy787OM/4+nNbw5ULwGFjz8PGpeEomehDH2LQ8ED0Yi2ZaLfqahF14LR62h0o2npqHU+CtKziJQ5JC1pWU66nJSqdCwsVY5LXxqWmCZnpjT9ik1tg9OcdmWntempT7cCVNoIdahZKapBkcrRgvrjqEy1ilKfGlW1TBWqVZ3KVbOKlq1y1Sxe/SpZwipWsZC1rGA5K1q9ota1cqWtbtUKXOOKlbnSVapOxepdj2LXvWo1r359K2ADK9fBErauhj0sXguqV8UCpa+OZQpkI6uUyVIWKZa9rFEyq1micLazQvksaB+b2NFKtrSmrSxqU4vZ1bJ2s659rWdjK9vQ/9K2tqRlLG6TItrd2qS3vqUJcIMrk+ESFybGPa5LkqtcljC3uSp5LnRRIt3pmqS61iUJdrMrku1yFyTe/a5HwitejpC3vBo5L3oxot71WqS97qUIfOMrkfnSFyL2va9D8qtfhvC3vwr5L4ARIuABG6TABiYIghMskAUz2MEJhrCBJTxgCgPYwv3FsH41fF8O09fD8QWxe0W8XhKj18TlRbF4VfxdFnPXxdmFsXVlPF0aQ9fGzcWxcnWsxw4g4MdADrKQh0zkIhv5yEhOspIRsDPd3vUQB4iylKdM5Spb+cpYzrKWt8zlA2TgtllVgFPHTOYyK3SvYjazmtes5sZaNP/NbI6znOeJ5jnb+c4ZrTOe98znpdIVzn0OtJxBoWdBG3rNEQBEPv586EareQFfIORaAe3oShe0DvpwK6UtzWkIOSELk+60qF0EA+CVddOjTvV3MvCJqX0V1aqO9XIgfTauwlrWuLaNEC5g61z72jpHAHVVb/1rX8NADMMutrKTEwEuRJXYy8Y1AzhRa59CO9q4FsIQhnptbMvaC1nMabe9HesQQEHc5E53BKrwyJKOO92qfsAeXA3Sd8Nb1UvgNUhlYIB++/vfAA+4wAdO8IIb/OAIJzgRIoBnL7iAwR/RRA/wrIIzQNwj9NgAnicgiYt3hARrwPMCHlFtj2MEA2X/cKCdN5lHk2tkFgy/MyQe7vKMKGLid4bBDWqeERdo/M4pUBDPL+IDV3TNzguwQcmHLpEGlGEBeB4a0y3SjyndeQNymHpFWBAFPCNicVqfSBxmgOcUuCHsE1mBFURuAwqgPSINoAPUV26CFbw9Ios4AZ43QI+7QwQKIcBzCHLp94Yggex3RsHZC98QGRTg6HPOgBTczviFcKAUewZC/yq/kCqkAM+TcCPnFQIFEOBZC4Qf/UHugHg7T4ASqk9IDNx35wxgYpaxNwgFjAD5OWs+9wZxABH0fmc/iB74BCmB6e9cBCwgvyBIeNqdlTDA5w8kCWPA8wMugXvr7773ciYE/y+f7wBAEN/OgrCE9QdSgiac3vnr/wcbpG9nECQi/v+4ACPnvABn4/8fHGAEc8dme/B/A+EArxBzaiYEkmaA//AGKqBmjMBKDigQNZADZQYCY1SBBNEG2edUEYBsHGgQHrAFAwghD+AzI3gQEDAKCoggEtBuK2gQ+2BD+GEFlDeDCMEPGIgfR9ByOpgQFzAI8BECNBeECoEArHCCodRJSNgQqYA0zPEAp/CED4EG7rccNiCDVrgQfdCDtpEGS9eFC3EFlWAbG0A4ZAgRH6AGRwcDR7iGEEEKL4ACYCeHEgEH1YeHfNiHfviHgBiIgjiIhFiIhniIiJiIsjV+ikgFu//QBC2giBjgC35AGz+AiCTwDkVgG7ZgSYN4B8DwecrRDYPIAmkAfrYBCYDYASLgBeghgn0IAfqDHpsAiPaAH57jhx+wfOBBBoBIAPiBCn8YA6IIHkr0h8HgRH9oByoHHn7zhxqgjH6IBKjIHAUAiGCAH8/whzVQjcsRBIBoR+hhcX4YR+iRC+GIH7/wh33gjcrRCmO4htkIH6Pwh7fQjN+xA2rYh2qAH7Dwh3ygQtdhAVnnh1aDHkJwfHyYBAd0HczwBoJoDNaxA6/giYU0DW0wHR+wicnxAHRAgYUED/7gCKkQj64hAskhBBsISSNwPbMBAN8QHRCQSTYDka1EB8n/sQRx+Bqy4A8UaZGX1Af4SBsWUAY+UBz2AJKepAvWAQPswIV9yA7gIQi56IdJkIXg4Q76xofSgB+rAEJyWAIA4n942AWBgB+QQG9yyAkA0gt9aABMeB3N0IccgDjw8ZV9aAMAUgV9SANxaR3OAJVW6AFgCB4WEG54eJDwUQ59OAXuqBxOkINrKAMcCR+K0IdrhB/6wYdSiR9mcJR4+AQoACB3uIYd0ET4AQx92AB7gB+REIl+iAw18x0McJmAaArb8B0mFIgOQAB/ORtMoDqESAV3kxwvUESFCHLJUY+JuHC0MSSK+A+8QD94cH/R+Q9dwA33cJ3c2Z3e+Z3gGZ7i/zme5Fme5nme6Jme6rme7Nme7vme8Bmf8jmf9Fmf9nmf+Jmf+rmf/Nmf/vmfABqgAjqgBFqgBnqgCJqgCrqgDNqgDvqgEBqhEjqhFFqhFnqhGJqhGrqhHNqhHvqhIBqiIjqiJFqiJnqiKJqiKrqiLNqiLvqiMBqjMjqjNFqjNnqjOOo2JACa3NmPE1AIzhAAwfAO9vALsoAKfACbgdhkA5kAtsAM3hAEaQAEOKIBNiIBr4CE9ENmk4CEDTlm4KiDYWBmYTqDSECmQUgNaKqDmbCmMygAbrqCfFNmZbqCJERmdTqCrQemQXg6dKqDXaBmeVqBfNADX0ZmrvCEScAL1FMgAo3ACe6QBsXgBDBwqMYYiGFgCrfwB5pQAgogAlUgGufwGRWwhzl6qqiaqqq6qqzaqq76qrAaq7I6q7Raq7Z6q7iaq7q6q7zaq776q8AarFQREAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz2BHNABNurRphFv8IcpFaE+sZKhWnJ5N+3Iaf7hz526yLoA1SqLC1B5O/LAf3ciT+9NSic4pHF2KS5+OF5Hy68kZFCJ0j7r372sdLP/ATh75K/Do04sNVb49bkXq48vP2sl9ex/z8+uHisw++UL7BSggUvb4hx0QAyao4E8VGHjdNAtGKKFN5jio3DcTZqhhSwVYmFwoG4YoIkneeKhbCCOmqCJHIZiYGxkrxiijRBCo4CJu6syo444LfXCHLCJMw80ggYznXjw8JqmkQhg8Qc0rRgxSxHW3LGnllQj5cA07pWhjoxIQYCnmmAWFYgCZaKap5ppstunmm3DGKeecdNZp55145qnnnnz26eefgAYq6KCEFmrooYgmquiijDbq6KOQRirppJRWaumlmGaq6aacdurpp6CGKuqopJZq6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLDFCdrgxMaU+MOKPDRdH6oAQuS3jQceO0oFcLm2QvGgVykWChMqITvHAdQnIAnOhc9iInQUW3xyoBxu4B43PgErjHxgcEM1nKg7qMoTSebJgpH8PsAD1nYnAYCERV9uJgS4WGtG1nZxYSIYDY9MpjIXMjJD2nKoc4OAqVb4dJwaCOLjAG3bL/2mDhcb0HWcJFgYgOJyhgODgDNEd7iYLCRiohAuOw2kJ2PYlU3mcDggwc3kSbD7nM7iQVwwGos/pg9HKNZFH6nXS4khyh8BupxzH6LaH7Xd2cMl43lDAO56GMFL38Mgnr/zyzDfv/PPQRy/99NRXb/312Gev/fbcd+/99+CHL/745Jdv/vnop6/++uy37/778Mcv//z012///fjnr//+/Pfv//8ADKAAB/iSPnyAgNQpwSb8MQsEEqcB7JhBbmbgQNrI4B1RSA4UKlgaO9ABBdcpAAc/Y4AAfO46DLjDCDcjhmrYBxgr1Awp/KME4cTwMiNQgn+qcEPM7ME/FOyhZf9UwQD/wEeIlTGBf9KBxMpMwT8WuEATKcME/5xjipN5hX+YgEXJ+CAF/nlGFyPDCv+oYYyQ+QMNbYjGxuTNPuxoo2Mk4Z9tyLExX7QPA7BxR8ZowD/v6ONiDLFFQS4GAP4RhSETMw33REIdfHwYEBJAyUpa8pKYrGQs3jQH8oAgGL2YWIdu5A8CwGkAyTnAOEqAtouN8kamfNMpcvOCXfzigCp7pYti6aYRpGATbnCbz3RpIl66CT9QI6aHjLnIvSjTQsxsZl6e6aBoSvMu1DSQNa9Zl2z6Z5vcnIs37QPOcMZlnO4ppznfgs72qHOdbWlned4Jz7XIkzz0rGda7on/nXzq8yz8vI4//1mWgCpnoAQdi0GTg9CEhmWhyGmoQ78CUd1IdKJdqWhuLorRrWgUNxztaFY+WkqRxpOUJTWpPVEaUpVWhaQtdelUYCrTfbK0pmihKU7NotOdkqWnPhULUIMKlqES1StGPSpXkqpUrTC1qVh5KlStItWpUqWqVpUKVrMKla1y1Sle/SpTwipWpZC1rEg5K1qNota1EqWtbhUKXOMKlLnS1Sd2vStP8qpXnfC1rzj5K2BtItjB0qSwhpUJYhMLk8Uy1iWOfSxLIitZlVC2sii5LGZNotnNkqSznhUJaEMLktGS1iOmPS1HUqtajbC2tRh5LWwtItvZ/1KktraVCG5zC5Hd8tYhvv0tQ4IrXIUQt7gIOS5yDaLc5RKkuc4VCHSjO13nVne510Vudou7XeF297ff5W14czte25Z3tueFbXpbu17Vtve07yVtfEM7X8/Wd7P3xWx+K7tfyfb3sf9lbIATO2DDFniwBwZsgvu64PZ1AAEQjrCEJ0zhClv4whjOsIY3jIA63HSqhziAiEdM4hKb+MQoTrGKV8ziFh8gAx+GqgJQSuMa2/ibVp3xjXfM4x3HVJ867rGQh7zMHBP5yEh2p5GTzOQmg3TJTo4ykUEBZSlbeccRAEQ+ZHzlLu94AV/A5VGD7OUyo7QO+lAqmc3MZhM5If8LY26znF0EgxIQdc1zzrN7MvCJVuIUz3oONHbAPJo/C/rQ7hGCFGsKaEQ7OjdHgLNMG/3oR8NADJOutKaTEwEuuJTSm0Y0AzhR6I6COtSIFsLTTI3qVuPGCzVgtatbHYINTvTUsxZ0BKoQpoTiOteBfsAe/AxkYM96CYvWpwwMwOxmO/vZ0I62tKdN7Wpb+9rTJkIEkuwFykW3JJroQZJVcIZvl4QeQUPyBCRhbpKQYA1JXsAjSt3uj2CgDCccMgPSEIN6i2QW20YyJLzt748oQtxIhsENCg4SF6T7yCnIBMM/4gNXFPHIC7ABvSeekQaUYWpEXgMJON6RfkwgyRv/kAPJOcKCDCIZEVNY+UbiIEEkp6BnMsfICqwQbxsIL+cXaQAdQC5kBphANkC/yCJOgHJ6JP0iUGgRkkNAhadbBAk1PzIKcG51icigABcncgak8POuR4QDpWAyEIRp9ohUAYxInoQd2i4RKCgOyVqoOt0hcoesE3kClNg7RGKwhCRnABOoE3xDKGCEsBN57YpviAOIwHQk+2HukWdICe5+5CJgIfMMQUIVkawEEYB+IUkYQ5IfcInEn/4gjHf8kAnBxtcXxAGAqPyRBWEJ2yOkBE1IshY+73uDsGH0RwZBIopvkAsskMgL8DTzDcIBIxD9xrub/kEc8IqA71gIYta+/0HeoDMbM2Lk4k9IDXJgYxC8LP0KaYPqURoBTMN/IR7YwvUN9ACu3Z8hEDAK3mchEtBr/8cQ+7ADHmIFZXeADMEP7GcgR9BvDvgQFzAI/hECBFeBDoEArLB/yJECVsOBEpEKL0AeD3AKJEgRaBB812EDBpgsyPQsfRCByJEGG1csI+AGm5ACbOcsV1AJyLEBMoAsH/ALu3CCuKGC0fIBanBxMLCBwuIAJTAOcoMcA0AtpPACKBBzxNILwcB5yjEH1AIHpics2KAOkeAeELKCDiEK/gEAbvgQyNcehjCHDfEO/qEBeMgQ2CB72JECM9iHCLEN/sFuhJgQ7OAfgpCICf8RBjpkH3/giAihBv7BCpR4EL3gH4KYiQZRh+VxHp5IEOdQSKM4EBdgAf7hhaf4D+ngHybQigJBSHqkCrL4D35XHtnXiixjH0rwg54Iif5BCrcIDPZRDfbXincAiLrxAAFwJrcoXdeBAnSAedEoEFCQHFHwDkV4jQWRdTPADjnojf8wC/6wCXZGjgjxAX2gju74jvAYj/I4j/RYj/Z4j/iYj/q4j/zYj/74jwAZkAI5kARZkAZ5kAiZkAq5kAzZkA75kBAZkRI5kRRZkZlxC0xwh/RIASWyAJfQAfP4Q7nhCSoHj4eQHI5AC++YBy6YHNIAjLKIAcVAHrggRtcoAe3/8QACQGyjmAz+oQu9d4ouEIn2kQAjmIldkIvtAQIg4okBYCHpmInGYCEc44lvAILYIQiu54i3sAoOcgC2mIkjwAwWIgye6ABkYCGcMIpGYCG6sJWJSAQWAgPLl4lSozdHSYlDgDn+sUmnyAFg4B/SEI3Q4B4bMDLR6AaqiB0qQIbeKAuRoxwPwIreiARrmBw89I5tkAvIQQfy6AHLkBtCwJPv+DeMMIjy6AaOaZGs2Zqu+ZqwGZuyOZu0WZu2eZu4mZu6uZu82Zu++ZvAGZzCOZzEWZzGeZzImZzKuZzM2ZzO+ZzQGZ3SOZ3UWZ3WeZ3YmZ3auZ3c2Z3e+Z3gGZ7i+Dme5Fme5nme6Jme6rme7Nme7vme8Bmf8pktBtCU9AgBOqQC2lAK7HANqOmNt3AdRTAIRvAK1PAEcDmK8WAfCxAIg8AN0yACsnAH4deH6kBKKhCDc5iWN4IiiSh1LuINicgepCRChPgNKGUOidhIpFQBiQgEKGUPiVgIKIUMhOgDNNYJhKgINGafc6hFpLQApEmC97ALhcCM9oEISIkDp0AHlaAFBuIHtxgGokAJ1hAA69CSyZEG77gCqJAMsbAHhJALiMAAW3CPDQCT87mmbNqmbvqmcBqncjqndFqndnqneJqnerqnfNqnfvqngBqogjqohFqo0RMQACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXQW8o4AO7tm29hPz5U0EGGpokt4MLZ4tLt3HduKR9EuVguPPnXUccn25cCZlpijhA384dqibq4I1H/6gkjkaH7ujTD/0Rvn11Eurjy885zr17J/Pz64/pxX77YPsFKOBJFGTgX3j3DKjggh6JciB4D4zA4IQUVjTLg9Q5U+GGHDYEDIbT4dPhiCQS5AyIxxlS4oocQoACiropgQGLNE54B4y6WVHjjgq2EQsYOaAICI9EKjgCC42YAIN/bBTp5IJztPPFDAxQF8WTWDJIAjKP+LGAbuNkKaaWcAQzzJhopqnmmmy26eabcMYp55x01mnnnXjmqeeefPbp55+ABirooIQWauihiCaq6KKMNuroo5BGKumklFZq6aWYZqrpppx26umnoIYq6qiklmrqqaimquqqrLbq6quwxv8q66y01mrrrbjmquuuvPbq66/ABivssMQWa+yxyCar7LLMNuvss9BGK+201FZr7bXYZqvtttx26+234IYr7rjklmvuueimq+66fmrH7qo4IILDu6nicIA/B8xLb6n2GpfvvqPysMp0/wL8qQsqgFewwZtaUkR7E7DAsKahFGJfxBNfKsMMB2Kc8aQenPigxx8/6kAaKJJcMqMa4IiIuysrqg6OC8eM6CI4pqCvzYgO82XKEvOMqCgpwGiBLEInCg6MCySYNKINqIGiL08v+g6GRFTNaDQR+CeA1o1ikXB7wIDtqBxOhAdEc2Y3KsMA1G3TQNuPNuDOcYxISDekBOj/FgVte0fqSxM6BD5pC4YnrvjijDfu+OOQRy755JRXbvnlmGeu+eacd+7556CHLvropJdu+umop6766qy37vrrsMcu++y012777bjnrvvuvPfu++/ABy/88MQXb/zxyCev/PLMN+/889BHL/301Fdv/fXYZ6/99tx37/334Icv/vjkl2/++einr/767Lfv/vvwxy///PTXb//9+Oev//789+///wAMoACBAgFDbKEeigNCAhbIwAY68IEMjIWcdFAGM+imFYorAI6mQ4A3PYEAaZuOARKnwQ0ap4NrSsQoBNEeWJDQhCdMkwxmoY0quccML4ShP1A4JhNgiAaGKyEM/3koJlpgyAZB1OEO09SCEzwIg4ETogmJKKbcPIgXUVQiFbOkBwyJaG9S3OAWsdTEB20gizocI5ZcgSFsgFGLa4IH1t6YxjWRwEAHWgIdh8imTTwoAl2gWxhxpEYsfQJDTjPbIGFUyCfNAUPzECQc2cSxA+FCknVkEyYw5IK2LRJFjXwSFTD0Ck9Ock0OGJh9mgCEM5gyk2xaRngssA1jXAMCe5yimzIxnRmU4hseyOAp15QHf4RAGfBIhOM+CaJQYikOkmMmhpw5QLdI80HUrCZbrnmgbGpTLdz0jze/iZZw2mec5DSLOd2DznSSZZ3taac7xQLP8MhznmCpJ3juif9Pr+iTOvzsJ1f+yUGBwoWgxwmoQbOC0BgutC0N1Y1CH2qViC6Romux6EQxOhWNchScw/xoWTwq0rOQtKQjDSlKw3LSldJTpS71J0xjOtCZ0lQrLb1pV3Kq063wtKcMtSlQq/LToVZUqEaVSlGT2lGkMvUpS30qVKIqVadQtapMuSpWlaLVrSKlq141CljDSpSxklUoZj0rUNKqVp+wta08eStcdSLXueKkrna1CV7zSpO98lUmfv0rTAIrWJcQtrAsOSxiVaLYxaKksY41CWQjS5LJUlYklr0sSDKrWY9wtrMc+SxoNSLa0WKktKa1CGpTS5HVslYirn0tRGIrW4f/0La2DLktbhWi290ipLe+NQhwg0uQ4RJXIMY9bnKJu9zgNte3z91tdHE73dpWV7bXfW12Wbvd1HbXtN8dXwcQQN7ymve86E2vetfL3va6970IqINTP3qIA9j3vvjNr373y9/++ve/AA7wAfDIR6AqQIkITrCCpznUAy/4wRB+8EbJ6eAIW/jChGwwhjfMYXFquMMgDrFEPyziEmMYFCQ2sYofHAFA5KOnFV6xjBO8gC98QKcxnrGOdVgHfdw0xzsOMo6ckAWaAlnISMYQDEoQ0yMn+cn2ycAn2FZSJ0P5yuCp8dyqjOUuH0gIF+Cyl8fcniMU+aNWJvOYYSAGNKv5/83UiQAXOJpmOHeZAZzY8kLrbOcuC2EID+Vzn7HshRrsedCINiYUDCroREM5AlXAJT4b7egnP2APVE4npSv95CWE2Z0yMICoR03qUpv61KhOtapXzepWp5oIXeOwFzp5XJFoogcdVoErax0SemygwxOQBK9DQoI1dHgBj9DzsDmCgTI8gMMMSEMMlv2RWcR6w5CgNbU5oghccxgGN9h2R1zwaw6nIBPi5ogPXGFDDC/ABspOt0UaUIafbXgN8JF3RvoxgQ5vQA76zggLotBhREwh4BiJQyU3nAI3IPwiK7DCsW1AgYdXpAF0sPeFGWCCFVi8IotwIoc3QI+PUwQKIf/ocAioYPKJIGHhGEaBw1seERkUoN0XzoAUKk7zh3CgFCAGgt567pAqFI3Dk7AD0R8CBRB0WAssX3pD7gDzC0+AElJvSAyW0OEMYGJGWVcIBYyA8wsLPewKcQARRL5hPygd7QkpgdM5XAQswD0hSGBCh5UgglxB81ZJGEOHH3AJsMcqEfBQRsrzgKuxl93ChAiDqzzwjVJUHd24cgAg2I5hQVgiVRC4hjG2YYHwLGNXJWjC0+1eqjMAQfX2WUWmb8UGvXMYBMok1SswFHVdXcCP7p5zqVyAIUz0igNG0PiD94Cq4hxoBr5ywCuuvWAh3PhU88DQHH71hrEpmBH5PtX/PTD0CWDVIEgJBgESVNUF6rtnE8Fqg+CVGIE2r4rrB8pA+H3lgS0oH0UPkDWsQgQYAg/CAgGj4H4gIgGStirYgCGuQCz7sAM4YgU81yrl5h8ngDjDwg/ohyFHMG2vgg8YogfFcgGDgCEhoG2uwgsYQgjGggCs8H/UkQJBEyut8CAbeCyp8ALu8QCnQCs2gCFYdyxoAHvgYQMNGCs0gCEmkCx98IHHkQbxFisW5B4MoA2zIAPKcgWVMB0bwIW2AgvtIQijkHvM8gFqYEMwwIK0YgDU4QQE8ATTQgovgAIHlys56A9mUAaFYy1w0He6Ug9bYAhLeHeImIiKuIiM2IiO//iIkBiJkjiJlFiJlniJmJiJmriJnNiJnviJoBiKojiKpFiKpniKqJiKqriKrNiKrviKsBiLsjiLtFiLtniLuJiLuriLvNiLvviLwBiMwjiMxFiMxniMyJiMyriMzNiMzviM0BiN0jiN1FiN1niN2JiN2vguHDiLOtAEVCOLfEBwF/WKI8AIx+EOVYiKDbAN1DEAYqiKDgAE4eEEAKeKH9IeKsB6pygA/hEB0XCKBPgg71CKvoAiarCOm3gPNGgf4BCKslB6KJICogCKLNBvKLIAZ/KJOICRKLIIoNgvMKIOoMgBiIAjGiCKF4kiaTB7nriSD+IMwUSKMGkfMxCPNP/pkeFRCKGQijVJHUXweaooktOhAm6IikSpG6vAA69IlDXTiv3ylK4YLzsjizCzjViZlVq5lVzZlV75lWAZlmI5lmRZlmZ5lmiZlmq5lmzZlm75lnAZl3I5l3RZl3Z5l3iZl3q5l3zZl375l4AZmII5mIRZmIZ5mIiZmIq5mIwJKsMQDHCwf69YH/6wAH7wCMggmapIjsfBADPwBe2wfanIBv4BAybQCCwwdKIICCiSA2AQC20QihKHI3cAihjwIjCCAoe4iYawQRoCiiSII2UDisWwQbMAiiPwbDhSkZ84fjiSARfYicGwQV4QiiEEI2HyiSSAmzDyA6HYATQgDpVhoIDuoQmlyAGKMA1koAT+oZql6ACi8AnS4HzTcUmumARoAA1kMDYwOIt8oADh1pgCOqAEWqAGeqAImqAKuqAM2qAO+qAQGqESOqEUWqEWeqEYmqEauqEc2qEe+qEgWioBAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu7fv38CDv5wjvLjxoi0saOGmwMfx59BxHvJH3V8GbYDsRN/OnWWw6uD9Mf+6JKq7+fMgAYRfb4aOIQjo48uXaGe9fepRgl2bz7//QXv3BYiJfwT6t0uA9/FQ4ILxdZAAgus5weCE5mEB4XoCUKhhdOVcGF4cG4ZonCceVkeOiCgCR8ICJVLXSIow8hZPi9SpEuONuKlBYy449lgbHOngUeI5PhY5GwQ44AMJggzwYeSTs+WxCBkvrFcNlFjONkI7AaBQ3SdZhinbB8KAccAVYqYZGwZqtunmm3DGKeecdNZp55145qnnnnz26eefgAYq6KCEFmrooYgmquiijDbq6KOQRirppJRWaumlmGaq6aacdurpp6CGKuqopJZq6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsschShEqyvX6ywIvM5gpKde1Ea2sD44BngSLWzurBEuutUkO3sMpQzH22hEJuq4nMgKA3Layr6hyFXCiEA/KeekcRJbKSb6k8qECjMf+KKorANPrjS8Gf4nBAwtRZcAPDneoCMXXkmEIxpxfUm7A2I2zcaR4elwhGAyJ7SnKJdKQM6soQZujyyyWvxwARM4sKc3gLLJyzqE/wqy0aP5MadHUTyFJ0qUdPwMLSpj7BCBZQnwpf1VhnrfXWXHft9ddghy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744ow37vjjkEcu+eSUV2755ZhnrvnmnHfu+eeghy766KSXbvrpqKeu+uqst+7667DHLvvstNdu++2456777rz37vvvwAcv/PDEF2/88cgnr/zyzDfv/PPQRy/99NRXb/312Gev/fbcd+/99+CHL/745Jdv/vnop6/++uy37/55QCQg//z012///LG8r1cBF4dHgP554V//qvM/AN5FgAP0RwENWBcEDnCBDJyLA/sHwQjGZYIXq6AF34JBiGlwg23pYMI+CMK1iJBGJCxhWk7YohSq8CwsLJELX1iWGHpohjQciw0vhMMchmWHEOqhD/+/AkQECXGIXSligI6IxK0o8T5MbGJWnmifKErxKlRcjxWvWJUs+o+LZvEieLZ4IwdcoxHjcpsYCfgmJGTDBKtw0dvWSB0yaggbIlBGFNZDhjkmsI5YikEy5pEDBKUAZW2jowKhRA0GlIgKavzjIp9EAkd6CFpsU6QdC7SBEi0hkn/cJIEkUKIDXG1tmsQSHFrUh0RKUpT+GUKLquDKUGaJCSVyRy0TCEv/bKFEANjlA7NEiRYNIZOvzNITWjQMZNoySyAoUQWcycswEaNEBaDmMLM0jRKBQJsUDBMUIHSAQdhAD/hSWyqzRIL1lPOct4DbOrOUgx1sQgrRiCfd5on/pQvojZ9g/GEyA6rDgRJUoM88KFgAqlCuMLShWnkoRLEi0YlapaIWpQpGMyqVjXIUKh79qFNCKlKmkLSkSjkpSpGi0pUapaUuJQpMYyqUmdIUKDa9qU9yqlOe8LSnOvkpUHEi1KHapKhGpQlSkyqTpTIVJk59qkuiKlWWULWqKrkqVlGi1a2apKteJQlYwyqSsZIVJGY9q0fSqlaOsLWtGnkrXDEi17lapK52pQhe8yqRvfIVIn79q0MCK1iGELawCjksYhGi2MUapLGOJQhkIyuQyVLWspHFrGM1u1jOItazhQWtYEX7V9Ly1bR5Ra1dVTtX1sLVtW2FrVple1ba/5LVtsjrAAJ2y9ve+va3wA2ucIdL3OIaFwF1MGhDD3GA5jr3udCNrnSnS93qWve62D1ABpSrUAVI8rvgDW8LLepd8Zr3vObtJQPLi972ujeD5H2vfOfLw/jS9774BeRE2Zvf/roXFPb1r4DPGwFA5AOi/B2wgr+7gC98oKEJXrCEE1gHfXR3whiWpBOycNAIZ/jDLYJBCQjqYRCbGEIZ+EQ6r1jiE7vYPg1GpBRb/OIag0cI/pyxjXeMoCNwuIk05rGNYSAGIAv5yOuJABeQGGQkv5gBnJDxC5vs5BcL4Zg0pHKVXeyFNKpQy1s+cQigMOUwmzkCVTilBcFsZhM/YP8PK44gm9ts4iXkOIIyMICe98znPvv5z4AOtKAHTehCB5oIEaCvF1xA2ZJoogf0VcEZGk0SenRyvhOQBKVHQoI10HcBj5DypjuCgTI8YL4MSEMMRh2SWSR6vpBgNKs/oghIzxcGE5u1R1xwafmmIBO69ogPXGHJ9y7ABqIO9kUaUAYWzXcNJAjWnTfVjwnQdwNy2NUtoiGFTewgB59iwR7ni4gp1OoWerDBIB4Wnmh7Kg7umm8K3PAqB6R73RAi86dWYIVP24ACroqmh6YRqgbQwdnvZYAJVtAqIBJjVIs4wbXpwaoKeJNUUAgBfUMASVUNo0VPIBUS4i1fFNA7VbL/LBElSiWDAhTbvRmQAsBRpR4PbcFUHCjFfYEQslO5o0RMQFUVUkDfSWjHVFUwJqqgIHD5aqHjpOpDi+CQqjuQ/L0TWDmpIMDuC0lAVTEA13wzgAk2jUrsF9rAqihghJe7l+ejakSJGODuVDmACBKfrx+ODioqzJ0arSpB099bBKqBqgFED1AO5pGMVbsKCbicrxJEECoyrCcKyhABNmiVhDHQ9wGXMHun5O6PVZggG0jIFdvd3l5ChMFTNWjENeKcKwcAIu/yFYQllM2REjSBvlowPO8zwobIyxcEiRi+Ri6wCfkuYMnK1wgHjIDw8+4h+hxxwCtebV4hPBj7HHkD/8LCy4i6g38jNSgkeEGQ+vN7pA2el2QEiuz+j3hgC9WH2ANwVn+QQGAU3AcxEqBm/ecR+7ADF2MFM1eAIcEP6tciR+B4DCgSFzAILRICsjaBI4EArJB/9pECT6OBJpEKVRIgD3AKIogSaPB792EDBJiCI9EHDwgeaZBsMDgSV1AJ4bEBMnCDKvEBamBJMJCBPpgSpPACKGBuRcgScEB5S/iEUBiFUjiFVFiFVniFWJiFWriFXNiFXviFYBiGYjiGZFiGZniGaJiGariGbNiGbviGcBiHcjiHdFiHdniHeJiHeriHfNiHfviHgBiIgjiIhFiIhniIiJiIiriIjNiIjv/4iJAYiZI4iZRYiZZ4iZiYiZq4iZzYiZ74iaAYiqI4iqRYiqZ4iqiYiqq4iqzYiq74irBYWC9Yh1jACCGHhyxgbUVwi3UoC9ZGHbtYh2hgAeERjHLoCx7oD4WQB3FIBKxXHcv4hgJwIdHIhnRQItWIhg0ABjSSjWU4AtoAMYUwbWJoCuTQP7pghjdAjBBzADhwhr4AMSpQHmhoDDSiAgqihqxQIkVwB2zoAEJAjcTRhi3gDQgyA8n3hqFgC/dRDD0YhzUQR+GxBB5Ah4rAjtQxDjb4hu1QHQCGh42wAGCih8sSiyZ5kiiZkiq5kizZki75kjAZkzI5kzRZkzZ5kzj1mZM6uZM82ZM++ZNAGZRCOZREWZRGeZRIaT6ih4dXcABgIAzfZ4efUB0oEADt0HNzWA3r8QJksAjMCId88IzVAQn4gAOzaIbnUCJ4kA5Up4a5QCNqoIaqkDDxoIakVyILYH5meI4t4glqGAcJUw5qOI00Inxn6AQ0kgAdkIY8kDC7oIbqkDD2oIbXEAzj5iF8l4YQYAh0YAYQEkxwKAqXYHzhEQx0qAo/oA3bVR2HcIc+oADcUAQWEC96OJBJeZu4mZu6uZu82Zu++ZvAGZzCOZzEWZzGeZzImZzKuZzM2ZzO+ZzQGZ3SOZ3UWZ3WeZ3YmZ0rFRAAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48ePIkytfzry58+fQo0ufTr269eugwRGYg727939y/Pn/YxBERJjv6KWLE88+hbIb6eMzd8K+vj8A54bI30+8k/3/LwQgC38E+lbKfwhacEWBDOLmACII/hdAgxTWdkaE/8FX4YawjYNhfUxwKGJrHyjxIXufjKhianqcKF4KPqwoY2lpuOgPKzPmGNoQGdj4h45AdkaEjccEaaRmJQzCwInwHOkkZnxMA0CEeHDw5JWX9WKOI/bZgOWXlnWRiSDiMaAKmGhW9scXE6bp5ptwxinnnHTWaeedeOap55589unnn4AGKuighBZq6KGIJqrooow26uijkEYq6aSUVmrppZhmqummnHbq6aeghirqqKSWWhY2aJiqKkhTqHDCj6vG/5oRKQ+I14oMsuY6URfp2EeMrsA6ZIcXCBoT7LEIKYJHhAuwgOyzAp1iwYcgmAJtsA5IYGMxGFyb6whC2CjeHt7K6sIO4ooXTbmxTjGtuCjUwO6q7KTrDxMtzKuqOukmgIO+qgZg4xEuAKyqB7mcuEy+BqvaRiDMotOwrFkc8N8qUEycKzW1sgfAHRrrWgV7leAasq6w+PNFBycD6wAyLccs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dVYZ6311lx37fXXYIct9thkl2322WinrfbabLft9ttwxy333HTXbffdeOet99589//t99+ABy744IQXbvjhiCeu+OKMN+7445BHLvnklFdu+eWYZ6755px37vnnoIcu+uikl2766ainrvrqrLfu+uuwxy777LTXbvvtuOeu++689+7778AHL/zwxBdv/PHIJ6/88sw37/zz0Ecv/fTUV2/99dhnr/323Hfv/feLA5HA+OSXb/755McCvl0F2BshAevX1b77/8Ef/1zz01+f/ffHlb/+4uFf/97yPwAKcIBtKaD+DojAtSiQfgxsYFoe6L4ISvAsFLSXBS9Ylgyma4McHIsHxQXCEIZlhDYqoQm/gkIXqXCFXWnhiV4Iw63I8EM0rGFWboihHOrwKjx83w//OwjA/Q2RLEFEkA+POJUk1o+JYnGifZYIRahI0YhVZGER2UPFLDblilz0olfAGEAxxnCLZTSjDdHojy6qESlkbOMbtRJHN86xKHW8I1byqEer8LGPVPkjIKUiyEFakY12NKRPCqnILyKykVFhJCSVIslJwvGRlnQkGhOZyZtUMkccEEUm6DCAdWDtkyJqAzXQIQ1GdEw8C/DA1VDJIAh0owx1gMGJUDFLTK5oWTYSQS83OaMgiMtLVqMlg4IhLjIMc4ucxM4ixGWGZxYxmtehQroYRjVlFmgF6dJBMn25oh6Ia11V82aBtkHCcRJzRqwQlzLcCc0cnUNcuaDnNXOE/wYXneAI7tCnAXMUB/uowBPgKIcIDJGIrKmTQBjYQiyE8YcYfe2hnewJRjO6k41yNCce/agnySlSooS0pDQ5KUplotKVwqSlLnUJTGPKkpnSVCU2vSlKcqpTk/C0pyT5KVBFItShgqSoRvUIUpPKkaUyVSNOfSpGoipVi1C1qhS5KlYlotWtQqSrXnUIWMPKkLGSVSFmPStC0qpWg7C1rQR5K1wFIte51hWud21rXtW617P2lax/DWtgvTrYrRYWq4etamKlutinNpapj01qZI062aFWFqiX7WlmdbpZ3HUAAaANrWhHS9rSmva0qE2taleLgDqQlImHOIBsZ0vb2v/a9ra4za1ud8vb3h6gR+/MogLYSNziGveDYhzucZfL3OViE3zKba50p7vA5FL3uth1oXWzy93uplG43g0vdkGxXfGal7kRAEQ+wHve9h53AV/4QBWj6976srEO+oAife3LXwA6IQtM3G9/B2wvGJTgiAImsIJdlIFPOOCHCV6whJn1hQboMMITzrB9hHCBGmJYwyD2xxEAvMIPh1jDMBBDiU/M4v9EgAsmNHGLJ8wATli4ZT74gzBisYVuyUbGM56wEPSjr0QYQgTlAIcnVGCfOMwGyEGWsBfk5S13HOEELjrEk6PMZX+EIGPXSpiNzrHlLkc5AlWAALSUIS5zlNn/zEF+wB4ejCwCiGsbb4ZzkJfQ4WNFQ1w9mI0MDEDoQhv60IhOtKIXzehGO/rRiyZCBLLrhYIFSwfpWgGiNGFO7KrgDMFqQbqwkCh6bCC7E5BEsMwgrkUoigRryO4CHnFjWZFBXMFYFAbK8MrpMiANMciVDcQVhEbNYtLYhYSlVyUCceHBUYro9HVhoCFVoeJEMKhDGbqh5ka54NTYTUEmVuWBBdTnAUeQBjqo0QZK+cAVS7ruAmxQa1KtYwB0yIQorJSpBpTB3NhdAwnm+pF+TCC7G5ADwT3CgihkFxFTWHhH4jCD7KbADRLnyAqsIGsbUCDjGmkAHQBOXQaYQNMg/8/IIrCM3Q3QI+UZgUIIshsCKsAcI0ioOHZRgPGbW0QGBYg3dTMghY/7nCIcOFB2gTCCo1ekCinI7iTs4HSKQAEE2dWCzasukTvo/LoToATXJRKDJWQ3A5jw8dgdQgEjCJ26TF/7QxxABJZf1w9Ul7tDSoB17BaB1HpvCBKYkF0lCDPwDEnCGLL7gEuoHfEIafvbp0uI80A+IQ4AhN2pKwhLXF4hJWhC1gH/+YOwgfDYBUFDS3+QC2xC3jBmPUI4YASSM5dcssf8K5C9XCHIN/cKeQOTj8uIgQN/ITXIgXFBgITjN6QNi2djBFTs/IZ4YAu2p98DiFD9h0BgFLynn/8Eut19h+wDXfSzgtHL/xB+KN9eRwg2+yNygUGkKwTLnj9EEMCK7CMoBc6ifxSRCi/wIQ9wCgJoEWggehFiA+SXgBPRB+9nH2lQbxA4EVdQCfaxASZzgRbxAWoQbzCQfx5oEaTwAigQcSWoEXBweCv4gjAYgzI4gzRYgzZ4gziYgzq4gzzYgz74g0AYhEI4hERYhEZ4hEiYhEq4hEzYhE74hFAYhVI4hVRYhVZ4hViYhVq4hVzYhV74hWAYhmI4hmRYhmZ4hmiYhmq4hmzYhm74hnAYh3I4h3RYh3Z4h3iYh3q4h3zYh374h4AYiII4iIRYiIZ4iIiYiIq4iIzYiI7/+IiQGImSOImUWImWeImYmImaqITIQGdF2AFf4A+wYIQyoIHiUQVEeAdTwh4PQA1CCAWr8B8HQGI+iA7+Jx6B0G482ALLcCK5IEs66AJHYCNtgoM4kADpog452AKoJy4uaIM1gALpYgEqeIN/li47QII0uAfpIgRNh4MYUAw2IgGeiIOm0HcRYgGq1oMscIv+gAeKAITGgCBekHdASAz2kQ5dMIQy0Ari8QBkVoR/cAIqUI1FiAbYsIkKuZAM2ZAO+ZAQGZESOZEUWZEWeZEYmZEauZEc2ZGlEwBfACtFqArxJgiZsI9DOGz14Qjm0AtByAHA9B8AMA184IPwcCIMrDAIB7aDx2Aj3KeDf2AjGUBkORhPLpIGO+gDUecierCDn2AjSvB7OdiMHzIOO3gD4gJqOigwLoII5WiDV/AuJ1IKPCgLAVCAH9IJPjgE57CK/+EEQngDyrCU7CEORBgGIhAE8aZwRjgHBAAOHhmYgjmYhFmYhnmYiJmYirmYjNmYjvmYkBmZkjmZlFmZlnmZmJmZmrmZnNmZnvmZoBmaojmapFmapnmaqGmIAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48ePIkytfzry58+fQo0ufTr269evYs2vfzr279+/gw4v/H0++vPnz6NOrX8/+oqIgaCC0nx97lz9/ALh0oc9f9ZwF9923wyUX9GcgaY8EqOAJwNhx4IOddbGKghQ+YA+EGGJGBIUUMlBDhiBSxgyHCi4T4omQUUOigqig6CJjS6x4Hxkv1ojYHQzI6I8iNvZIWDA66uLjkICNgIKObxCpJF+j6AjJklDmBYCO8URpZV15gDIhhwDId+WXcrWQTSEUigDmmXJB8Ms695nRAJpwxiXLGJ/EaeedeOap55589unnn4AGKuighBZq6KGIJqooVRzQgcyikAalAxP+hFBgpJjmBEE9LwRISKag1mTKNhxSEuqpLyGDB4kJ8IHqqyhR/7CHjtrAaitJVeh4HyC39vqRA0HoekIcvha7USIg6LpOB8Y2e9EZOepYgbPUUoSJrg90Uu22D3Wgi65OfMDtuAvlsaqMDNxD7roIfSOjFjewK69BCXKYzgrz5jsQBsco6Igv+gYsEB873LeOKgInHA4DNmCQ8MPEPizxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLMMcs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dVYZ6311lx37fXXYIct9thkl2322WinrfbabLft9ttwxy333HTXbffdeOet99589//t99+ABy744IQXbvjhiCeu+OKMN+7445BHLvnklFdu+eWYZ6755px37vnnoIcu+uikl2766ainrvrqrLfu+uuwxy777LTXbvvtuOeu++689+7778AHL/zwxBdv/PHIJ6/88sw37/zz0EcvfUFAJGD99dhnr/31sUzfVgG6hu8PAd6zBb74OpJfvlrno7+i+uuj1b77HMIfv1nz06+g/feTlb/+9+Ff/8TyPwAKcIBgKaD+DohAryiQfgxsIFce6L4ISlArFESfBS+IlQyKb4MctIoHwwfCEFJlhLoqoQmlgsL0rdCBAKzfC7vSQhmpcIZOqeH7cLgVHZLohjxcig//ZRjEDsaQQkAsIlKGiEQlXoWJ+3OiCI8YRSmekIoBSqIVhwLFLG5xKl0M4BdZiEUxjhEqYRzfGdFYRjWuMYdt1OIbeZJGOc5RJ3W8I1PyqEel8LGPS4wjIJPyx0EWpZCG5KIgE3nIRTJSkWW04yNhgshJ+qSSlqSjIzN5yU1yUpOR/ORPMCnKm5CylDU5JSpnospVxqSVrnwJLGPZklnSciW2vGVKcqnLk/CylyX5JTBHIsxhhqSYxvwIMtUTBjZErGfLBI8D8vAMPdQDGFYgx5YC8LNobqcT8hhAIDKgo2J005PsKQH6bHHOUPKHDejLQDuxKEnujMB9V/CZN7eT/wL0tQia6GSPE9BXAn0GdD0DQJ+ZAOpO/gQAffUwaEPpAwz0wUKi9DTQNDiEAlwIYgnjsEEjZiEKjFKxntwxwCu6cQZUmIIDR9tnMjMi05lepKY2rQhOczqRnfI0Ij796UOCKtSGELWoCzkqUhOi1KUepKlOLQhUozqQqVL1H1alalajulWndnWpX0VqWIs6VqGW9adn5Wlac7pWm7Z1pm9NZlyNOddh1hWYd+1lXnW511v2lZZ/jWVgXTnYVRb2dB1AgGIXy9jGOvaxkI2sZCdL2coioA4HReAhDsDZznr2s6ANrWhHS9rSmva0ByDnRDmogDa69rWwreALWxvb2v/atrYoZR5tb8vb3sYwtwLjQB5QcYZuvMIAtdmtb5fLXBt6TBSzaIQNxrEEQeDiSBSaRnKby93uerFjsEAfMLbr3fIuFxQeqwf6uEkb5Zr3vbGNACDywTERoG8A5IWvfmG7gC+IS2PqFJ8T8rvfArexDvrQGCrQlwICG/jBR3RCFjJ2BfeNoL0QzjAVYVBQjKk2fGzAsIZHrL8MfMIBF7MFQUVM4haLr79vqlgxdJSBQAxAHtqajXtdzOMVCeFSE3uoP1ZBDisAox56eEYeUHybHff4yQo6woQnFgc2hCE4ToaylmEghvhlWctQjgAX1vdlMD+ZAZyIsfTKbOYnC2H/CNNjc5t77IUPRU/Oc+ZxCKBw5zz7+T4RqIKXmofnP7f4AXtgsm4NbeglAFl5MjCApCdN6Upb+tKYzrSmN83pTmeaCBForhdccFWLaKIHzVXBGUpdEXpsoLkTkASrKUKCNTR3AY9Q86wfgoEyPIC5DEhDDHYtkVmEmrmQIDWxIaIIVDMXBvFa9kNc8GrmpiAT0n6ID1wRLd8uwAa6znZCGlAGADF3DSQQd0P6MYHmbkAO6mYIC6LQXERMId4LicMMmpsCN+BbISuwwq1tQIF/I6QBdDC3bxlgAnwZ/CCLOIG76fHwg0AhBM0NARUqbhAk7Ju5KPA3xwkigwJ0u7cZ/5BCwUcuEA6UgrtAuDDLBVKFfjJ3Eg6a+T+gkCzmamHjOr/Dx5c7AVPpPAYxYm4GMOGwmVPACCfvbcx17gAiSJy5fsj5zEvQ8+UWAQs6/wcSKMVcJSx05kkYQ3MfcImms/zpUectIa48cwcA4urLFYQlwl6CJjRXC2DXORvIvlwQJCLsF9jEchcw5rD/gwNGULht9+D4gTjgFceurRD+W3mBvEEFtWVEujtPkBrkALYgQALpDdIGtbcxAl1evUE8sAXJA/ABRJA9QiAwiswDUAKD1r1B9lEwAFph5cJHCD9OT78jDDv5CrnAINwXAmVDXyEIYIXtSZQCFlzfIanolP+MHnCK7z8EDX5fkQ2Cb/6F9IH5FEpDuNu/kCtUgkIbkAH9I/IBNUQLBta3fxBBCi+AAvcmgBMBB2eHgAzYgA74gBAYgRI4gRRYgRZ4gRiYgRq4gRzYgR74gSAYgiI4giRYgiZ4giiYgiq4gizYgi74gjAYgzI4gzRYgzZ4gziYgzq4gzzYgz74g0AYhEI4hERYhEZ4hEiYhEq4hEzYhE74hFAYhVI4hVRYhVZ4hViYhVq4hVzYhV74hWAYhmI4hmRYhmZ4hmiYhmq4hmzYhm74hnAYh3I4h3RYh3Z4h3iYh3q4h3zYh374h4DIM8+0gRhgAwwQDhyoCmziDzvgKhn/6AuOoCDH4HYUuALpQCKPYIE3oAUy8g0UeA9xpyB4kAcT+AEDFSTMIoGd8Gs6ggkUWAG6wgCrJoEdsIgyYngTGAd4tyJBoGgQCAjhUwUUqA06sgfIF4F8kAAkggePYoGUwCHbYAoZSAgB8gL1wH4VeAEYxwQ60IHIQAcwFYjiOI7kWI7meI7oiB6fMAay0IENYAYG8wvYSIH2pSCFkA0tcIEQMCUcsgqgQIoUGA86AgAVCAk6MgoU+AY6ogQyJ4HfIiPBQIGaoCMMcAcUSAY6sgQUuGA6Qg0USI0ywgwUWAOhGCC5N4H2wIoksgr7QYF2AAy7GCCZeIEXcAnFdx8LWzAHGtgFXMCPu9CBEIAGQcAj6ViURnmUSJmUSrmUTNmUTvmUUBmVUjmVVFmVVnmVWJmVWrmVXNmVXvmVYBmWYjmWZFmWZnmWaJmWarmWbNmWbvmWcBmXclk0AQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48ePIkytfzry58+fQo0ufTr269evYs2vfzr279+/gw4v/H0++vPnz6NOrX8++vfv38OPLn0+/vv37+PPr38+/v//pN5BhwH8EOhaEP/6YoEOBDB52A4IIMpDOEw1WGNiBECL4gAQWdrjXgxlCCIuHJN6FYYgJDFHiinKBGKI/07Ao41vVvOgPIh7MqKNaJdjojyQ7BnmWJzYC0IGQSIrVo43CJOnkV0S+mMuTXjmgiZBLvjgFlVzxkMsCnQQpAAMvLsGlVhxYkwGCkzgQJA8mZMhAH2dipQgAIQKCJA5jIKhMnVdtYaMjeSR5QxBzAGrVFz4uo+ijT/lgho/DQGrpUmf4GEiOl3ZqVDM+guLpqEOt0IONGfBA6qo/DeOjM6zG/8qTPD4CKeutNsUQgo07JIHrrzOFY6MKVABrLExAhOiOisc2y9IFKiAYyRnOVsuSHgvAwqm13KJ0S7fghivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvz26++/AAcs8MAEF2zwwQgnrPDCDDfs8MMQRyzxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLMMcs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dVYZ6311lx37fXXYIct9thkl2322WinrfbabLft9ttwxy333HTXbffdeOet99589//t99+ABy744IQXbvjhiCeu+OKMN+7445BHLvnklFdu+eWYZ6755px37vnnoIcu+uikl2766ainrvrqrLfu+uuwxy777FcBkcDtuOeu++64x0K7WwX4KLyNBPzeVvDDJ49g8cavhbzywzPffFrPQ++j9NOfVb31L2KffVnbc5+h99+PFb74y5evPfrEq2/W+eiT7/5X8Isv//xd1c/9/fhvpb/1/OtfVv4HvQAK8CoEVJ4BD1iVBCZvgQycigOjF0GvTFB4EKwgVC54PQ1yhYPt86BWQNg9EY6QfSU0IVZIGKIMqlApLBzfCxGIwhbO0CoxhJALb2iUHKaPhxKsoQz/gSgVH/pjh0QUihGRmESgLLGJGxSiDqH4lCdSsSlWvOJSsqjFpHCxi0f5IhiLIsYxDqWMZgwKGtP4kzWysSdufONO4ijHnNCxjje5Ix5rosc9zqSPfowJIAP5kkESsiWGPORKEqnIlDCykSd5JCRLIslJjqSSlgwJJjP5kU1ysiOe/ORGQinKjJCylBc5JSorospVTqSVrowILGP5kFnSsiG2vOVCcqnLhPCylwf5JTALIsxhDqSYxvwHMo25zGE2E5jP7GU0dTnNW1bzOA1Iwi06IQsFsOMHFSiFBnahjW1x7JrECcEJoNeGj6FzOEqwHoU89k7hwMB6C6KnFH8Y/x9cWO8G7tznEeezAeuVIKD7ZGJ4dGE9OCBUigoFT5+gB4+HCjGi38lEKSoggB98QgS0gMMwbvCMPyBhDi2waA0xmkyJ1BOVLy1lTEU500/WlJM3zWROLbnTSfYUkj9tZFAVOdRDFpWQRw1kUpPUgjkg4Q/PuMEw4EALEXziBwIIZyaStFQkwcN6Y+CqQFmaLjhYTxdiTei/spS8DaQVov9yUfJw8daL/ksH1oNBXVf6rydYTwl7RSFZ0ZUE6J0gBIFl32DP9QFt7EIDG/0BOxQgi07c4gINwE0HEMDZznr2s6ANrWhHS9rSmva0CKjDWCt4iAO49rWwja1sZ0vb2v/a9ra4ze0B1qTWCCpAoMANrnD3V8HfDve4yD3uYlln3OQ697mCLS50p0tdBUq3utjNLj8P2Fzteve5ovLtd8fr3AgAIh8M7C551wvcBXzhA9xlr3yFWwd9CFC9880vCp2Qhf7hV78A5h4MDjq//wb4wMnLwCfcpD4DI/jBNnJvZsvnYAhbOENCuACFL8zh4R2hv9mrcIcvDAMxhHjEKH5RBLgwPRGnGMIM4MSEaefiF0NYCMyaXY1t/GAv1IDGPA6yP0IABR0LOcgRqAIEYrfjIx/4AXtgsOua7OQDL0HDrpOBAbbM5S57+ctgDrOYx0zmMptZzESIQHW94IKWYkT/E6eirgqo5WaL0KOg1J2ArepMERKsoboLeMSM+RwRDJThAdRlQBpiQGiKzELN1IVEmxstEUXEebowACilI+ICPE83BVvdNER84AoyTXcBNhi0qBfSgDIsoLprIMGqH9KPCVR3A3KYtUNYEIXqImJLumZIHGZQ3RS4IdgMWYEVAG0DCiBbIQ2gw6unywATrODZClnEOqm7AXpgOyFQ2BV1Q1Csbx8ECcSmLgqObW6DyKAApoZuBqTg7HYThAOlwC4QRmDvglQhBdWdhB36TRAogKC6Wig3wf9xh3RPdwKUWLhAYrCE6mYAExiQOAWMEG/o7lviDiDCtqfrh4FLvAQH/6duEbAg8X8ggQnVVYIIWp6EiU73AZfI+MI33vHnEiIMIAfEyKErCEu0vARNQDjLJc4GmFMXBIlo+QU2cWoWt/wfHDDCtJO7h6sPxAGvgPRxhQBfrw/kDdEaLiNkbXaC1CAHwgUBEtpukDbYXIoRMDHdDeKBLWwdhQ8gwt4RAoFRiJ19Eljy4BGyjx2g0Ar1XjxC+AF38R2B0ZJXyAUGwb0QTDrzCkEAK/7uoxSwAPQOScULhveAU6D+IWhIuo9soPjXN6QPlQ9RGlRt+4VcoRIh2oAMeh+RD6jB1DD4PPEhQooXoADYy5cIHGYe/epb//rYz772t8/97nv/++APv//4x0/+8pv//OhPv/rXz/72u//98I+//OdP//rb//74z7/+98///vv//wAYgAI4gARYgAZ4gAiYgAq4gAzYgA74gBAYgRI4gRRYgRZ4gRiYgRq4gRzYgR74gSAYgiI4giRYgiZ4giiYgiq4gizYgi74gjAYgzI4gzRYgzZ4gziYgzq4gzzYgz74g0AYhEI4hERYhEZ4hEiYhEq4hEzYhE74hFAYhdvxLebnAZywAHpQfmcQCQiiAlgGfkPgDiECBOFHBWkXIuEAfkngeC8SApjnfZLgI/IQfs5AKeDHA7wVIj1wbd8HCj7SDODnAYHgI3Tmfa5iI2bgA+C3DD7yBRzoMwdBoGlCkgeOYCNbwDHKgCBjgANIAgghAgCKwDF90HEmoCo74gCTgCAZYA0c0DEVFyIMIABB0gkLkAumyDFT4CMEtiOaIGUckws24gngJwy6+H0dgCcvIozfF4c2sovc5wGIYCPVAH7T4COSyH1DkAA2EgTgBwvWCH4SgGghwo3h9wTp0HHXCH46ECf+QI7lZwBkkI5SOI/0WI/2eI/4mI/6uI/82I/++I8AGZACOZAEWZAGeZAImZAKuZAM2ZAO+ZAQGZESOZEUWZEWeZEYmZEauZEc2ZEe+ZEgGZIiOZIkWZIm2RcBAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu7fv38CDCx9OvLjx48iTK1/OvLnz59CjS59Ovbr169iza9/Ovbv37+DDi/8fT768+fPo06tfz769+/fw48ufT7++/fv48+vfz7+///8ABijggAQWaOCBCCao4IIMYidGgw3xASFZ1xTjzzATJrSCCnXUkKFXV2jAgD/+MNPBhwY9QuIDe8iAolZMkCgjFy8OpIoFMvqDxwU1XqVHjjqu0OMuQILRI1YDAAlLjZoAmUIeR17FwwM5WvAEihB4A2QjUWJFB5C7oMgOkDlQ0OVVMoAApCYZthAFkN+cidUpQHoDwYTWAEmMnFhBsA6QIkDIxwk5RqAKn1jhAGQUXTQIDpCXIJpVM0DiwyANQNrigaRYtXFAjlE0sGAlQP7CaVajkMiAOUkwiE06Mmr/c2pWHTAywB8ZUuFNBh7OilWrWNLg67DEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXbPPNOOes88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VhnrfXWXHft9ddghy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744ow37vjjkEcu+eSUV2755ZhnrvnmnHfu+eeghy766KSXbnpSQCSg+uqst+766rGcDlcBQNZue+0EyP4W7bf3jrvubvHu+/D+5A48W8IT37vxx6uVvPK2M988Ws9DD6T005tVvfUyYp89WdtzX/z31IsfPflnhc+99+iDpb717Lfv1fvQxy8/V/Qrb//9WuVP/P78w4r/hgfAAFplgL4roAGpgsDlLfArDbydAh8YlQiej4L4M9/vMLgVC26Qg1nx4PVA2D8NjpCEAjRhjiaIQqWIcIUtvMoLuxfDA6qQhjVk4A1JxMIcFmWGPPThVP+AOD4hVnCHRTTiU4jYQyUChYlOXCISmxjFnkCxiky5IhZdOMUtLkWLXjwKGMP4wy6SUYxmPGMZd0hFNdJkjG58YhrjGBQ40tGKc7yjT+yoR53wsY84+SMgbSLIQb4xj4YMJCITSchFMvKQbHykHx0pyZgUspItuSQmV6LJTaakk548CShDWZJRknIkpjxlSFKpyo+wspUdeSUsNyLLWWaklra8CC5zWZFd8nIivvxlRIIpzIcQs5gNOSYyF6LMZSakmc48CDSjWZBpUnMg1rzmP7J5TW5S05vRBKczxblMciLTnMVEpzDV+Ut28tKduYTnsX4QiHoGAgAbyKc+/RD/hCBk40XyLE4JKkBQgsJCAghFKCs0oAE4QKUC0JMAQCmpHglArwIPjehEIykfiyoPo0+BqPIkiqKAEsejxAOpU0RKPJJ+yKTDQenwVNoUODCUFQlFKCwKStASbPSGbQRPNvq5Dn3qEwD2DMQPKAZTVTb1lE8lZVRDOVVPVnWTV8VkViu5VUl29ZFfZWRYEznWvnUAAWhNq1rXyta2uvWtcI2rXOeKgDpQlHyHOIBe98rXvvr1r4ANrGAHS9jCHiADd/2eApDI2MY6Fn4UXOxjJ0vZyQbVdJKtrGY3q8HLli6znA2taB34QNCO9rSn9SzpTIva1m4WFJF1rWw5GwFA/+RjgaydrW4Zu4AvfMCAud2tcG9YB30EMLjDTa75nJAF/iFXudCFHgx8Kr/nRve6vsvAJxzQPuti97u1662oyOdd8JpXRkLgkWLPy17iHaG52Stve80LgwdNT77zBW8EaNQ8/Ob3uwzgxHh159//flcIQwBegQ2MXS/06nQLZvB1QwAF2UVYwtGNQBXu9FkMe1hGLOLuaj9MYn8sQb2ik4EBVsziFrv4xTCOsYxnTOMa21jGRIjAaL3gAm1ORBM9GK0KzuBjidBjA6OdgCSKHBESrGG0C3jEgJnMEAyUgUqhZUAaYkDlh8xCx6KFRI+73BBFBFm0MLgBmRviAiSLNv8FmVgzQ3zgihGFdgE2mLKcDdKAMixgtGsgwZ4V0o8JjHYDchh0QljwJtEiYgqKRkgcZjDaFLgh0gdZgRWgbAMzYZogDaDDn7NsAiF9miCLIJRoN0CPUxMECiEYbQio4OqBIIHSokXBpWv9DxkUwM6czYAUPO1qDpTitEAYAa//UYUUjHYSdlg2FNQkWi3Qmtd3wHVoJ0CJZcdgCaPNACYwwGsKGAHYnE02rx1ABFWH1g/R5nUJqB3aImBh2UiIkWiVECheJ2EMo33AJchda3Oje7OECMO6AeFuzgrCEssuQRNGq4V785oN+g4tCBKx7Ats4s78XTYHjDDqyu5h2QT/ccArwDxZIfwW5QR5gwomywhBw7wgNciBY0GAhJsfpA0AR2IE7Otzg3hgCyXX4AOIUPSEQGAULDefBDjcdITsYwcatAKxq44Qfuice0fgMtcXcoFBWC8EYx77QhDAiqTfLgUsUPtDUvEC3z3gFHKHCBomfjsbUD3vDenD14GUBj0DniFXIFWONuCiw0fkA2qwMwzS7viIkOIFKIB05SkCh35v/vOgD73oR0/60pv+9KhPvepXz/rWu/71sI+97GdP+9rb/va4z73ud8/73vv+98APvvCHT/ziG//4yE++8pfP/OY7//nQj770p0/96lv/+tjPvva3z/3ue//74A+///jHT/7ym//86E+/+tfP/va7//3wj7/850//+tv//vjPv/73z//++///ABiAAjiABFiABniACJiACriADNiADviAEBiBEjiBFFiBFniBGJiBGriBHNiBHviBIBiCT0EDfzchwIIxNZAB3nBtEPIHA8AIJ4Ix2iAj6YANDJIE5mBno4AxvwAklbAgDdBoJHIAbWAxHmALQCIsC4IPQNIMFnMJQAIODdIFQkgiOEAxqhB1JyAhDSICQLIOJegwxAAk1jAhWQIkeBcx37AoLZAhTZIjINB4DkMBg0ci7IAiRJIjdAAxjVAnYcggT4AjIMYDDpMHzpYjbPIisAAkA+AwYJcAJj2yAngAJHrAMBcwiTJiAYfSI1wAJEzQMDKwB1j2CFHSAcygKhpwBQ9TA3WgAqZ2JMPgD8VwDRPDhV1CdCKYi7q4i7zYi774i8AYjMI4jMRYjMZ4jMiYjMq4jMzYjM74jNAYjdI4jdRYjdZ4jdiYjdq4jdzYjd74jeAYjuI4juRYjuZ4juiYjuq4juzYju74jvCoHwEBACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrX868ufPn0KNLn069uvXr2LNr3869u/fv4MOL/x9Pvrz58+jTq1/Pvr379/Djy59Pv779+/jz69/Pv7///wB+hUGABCr2RwHSFKhgYVIw4A8DPCwoIWC/+GOhCRNm2JcfFvpDg4Yg4iVLh5uEaGJdY3R4w4kswoVKh8e0KGNb0nQ4zIw4ovWEBRZCkuOPZRnRYTRAFgnWFShY6EQHQNphpFfldCjCjyuEsM0dT24VBh4W2tJAjvNYGME9WWoFyINgkIAjDQ76o0IMZWbVgAY65NiBFx36EueeU6XSIRl8BvqUJSlYiIIlgia6lBUdjqLoo0cp0KEgDkBqqVBhFGFhBrxc6ulPEnSozqek7iTKAhYCwEGprNrkwDoqtv8q60xZHGAhN7PmGlMoQISwgq7AvpREsMQWa+yxyCar7LLMNuvss9BGK+201FZr7bXYZqvtttx26+234IYr7rjklmvuueimq+667Lbr7rvwxivvvPTWa++9+Oar77789uvvvwAHLPDABBds8MEIJ6zwwgw37PDDEEcs8cQUV2zxxRhnrPHGHHfs8ccghyzyyCSXbPLJKKes8sost+zyyzDHLPPMNNds880456zzzjz37PPPQAct9NBEF2300UgnrfTSTDft9NNQRy311FRXbfXVWGet9dZcd+3112CHLfbYZJdt9tlop6322my37fbbcMct99x012333XjnrffefPf/7fffgAcu+OCEF2744YgnrvjijDfu+OOQRy755JRXbvnlmGfuNxAJdO7556CH7nksmrtVQIeop6666gSU3tbpq8cee+uurwW77Lh3SHvtad2eO+67836W77/PLnzvxece/PFkEZ986sszL5bzz+suvVnUV+9P9Nd/lX313Hff1ffPhy/+VuQnb/75WaVf/PrsX+X+7/DHX9X8ytvvvfar16+/VPgD3v/Gxz/WDZArAZSd/w7olAQaj4HtKyD0IBhBCVqPgvKz4AUxeD8NWmiBHESKA/sXwg56EIQlLMoIDZhCAHpwey104QljGJUVTpCGT7Eh6lCIw5/ocIM9XMoP/z8YxKYMEYZFFOILeZhEnRyRiU3EyROjmJQpUvEoVryiCpeoRaNksYtC+SIYgSLGMfqkjGbkCRrT6EQustGHbnxjT9YoR5vQsY40uSMeZaLHPcKkj350CSADyZJBElIlhjwkShKpSJMwspEkeSQkRSLJSYKkkpb0CCYzyZFNclIjnvwkRkIpSouQspQUOSUqJaLKVUKkla50CCxjyZBZ0lIhtrwlQnKpS4PwspcE+SUwBSLMYRYTmMfsZTJ1ucxbNrNVcdCABNQhgB9IghJwgAIV/qAKU6wAAjl6JqvekDw/hDOO4oJD8oJwzhmSSw8J4FHuhNBODULRWh9YwRXmEP+HP+DgBmeAQzxYUE8L3nOYDxGnKxW6Soai0qGlhKgoJfpJinLSopnEqCU1OkmOQtKjjQSpIkV6SJIS0qSBRGluWBAPOJzhBjj4QxzmcIUVfCBhKsWNEH5ngQTooWA5vU0QkgcHoKLzPRwq3huM6s74QGAFplDFH6gABThQQhI/EIA6JKCBODDVngil5FHD2smxiq8DCEirWtfK1ra69a1wjatc50pXBNTBrN07xAH2yte++vWvgA2sYAdL2MIa9gAZwOv1JPXCxjr2ser7H2MhS9nKQvaglpusZTfLWf5htnKa7axoR/tA+4WWtKgl7Wcpd9rUunazoJDsa2fb2Qj/ACIfpqWtbi27gC/clH2t3a1wNVgHfQB3uMh1rBOycL7gJve5z4NBCcTnXOhaN3cZ+ESlpFfd63p3db39EvO6+93yok4IFxivedf7uyMwV3jkZa95YSAG+Mr3vrGLABd4F1/8fpcBnBCv5vrr3+8KYQilI3CBveuFGgx4wRDuUAigkDkFR9i6EagCODN74Qs/YA/bZW2HO7yE9FJOBgZIsYpXzOIWu/jFMI6xjGdMYxgTIQKk9YILyCoRTfSAtCo4A48jQo8NkHYCkhgyREiwBtIu4BECVvJCMFCGB4yWAWmAk5QbMgscjxYSO94yQxTx49HCYEViXogLjDzaFGQi/80L8YEr2tTZBdggynAuSAPKgKrRrkFNeUZIPyZA2g3IIdAIYUEUSIuIKSD6IHGYAWlT4IZHG2QFjBqtnSlgaYI0gA597iwDTPCrTg9kEScoND1MPRAohIC0IaACqwWCBEmPFgWVnrUMCkBnzmZACpxmNQdKgVogjGDW/6hCoUY7CSfNGgogIK0WZD3rO9hatBOgBLJjsATSZgATA2I1BYzQa84ae9YOIEKqR+sHZ7O6BNEebRGwgGwkMIG0SpjSrJOQotE+4BLhNvW4y71ZQoQB3YBYt2gFgahZl6AJ0qb3rNlw79GCIBHIvsAmRLuA/SL7HxwwQqgru4ePD8QBr//wMmWF8FuTC+QNKqAsIwDt8oHUIAePBQESam6QNvTbgxGoL88N4oEtjJx/DyDC0BECgVGonH8S2PDSD7KPHRTQCsGeOkL4gfPqHUHLWk/IBQbxvBCEOewKQQArjr66FBAU7Q1JxQtw94BTwP0haIB47Gwg9bszpA9dT10a8Oz3hVyhEqnbgAwKH5EPqKFNMDg74yFCihegwNGTnwgc9J35znv+86APvehHT/rSm/70qE+96lfP+ta7/vWwj73sZ0/72tv+9rjPve53z/ve+/73wA++8IdP/OIb//jIT77yl8/85jv/+dCPvvSnT/3qW//62M++9rfP/e57//vgD7//+MdP/vKb//zoT7/618/+9rv//fCPv/znT//62//++M+//vfP//77//8AGIACOIAEWIAGeIAImIAKuIAM2IAO+IAQGIESOIEUWIEWeIEYmIEayDbD8npVAgSh4HrcYCEH8F6qdwMdsg4hhnocAAAWsgCiwHrq0CESwHq8kFj+UAQHp3oOIAgdogCsNwodYgWsZwlJ4g8p0HCqRwYdkgqs5wsd4gVMgiM6oAGE9y8xEHMP8iEzQgJg4CCAUDD34GXzkCMNYAsWggc7ODB3sA2+8iMi0CHlcDDuhiMd4ASGcgWtFw0dYgSuBwkWYgFP0HrD0CEJ0nrH0CGo0HooaCFjduB6G2chstB6NNAh5tR6JtAhv9B6POAgDCAFricNBfAHrxdwG3iKqJiKqriKrNiKrviKsBiLsjiLtFiLtniLuJiLuriLvNiLvviLwBiMwjiMxFiMxniMyJiMyriMzNiMzviM0BiN0jiN1FiN1niN2JiN2ng2AQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48ePIkytfzry58+fQo0ufTr269evYs2vfzr279+/gw4v/H0++vPnz6NOrX8++vfv38OPLn0+/vv37+DPfuJW/v2Zj/oDh34CWxcEAA/wRqGBkYPijwYIQOlYDAw+oEuGFijW4BYYcGjahBXx0KKJgDQYz4ol+TXhCKCi2qFeDpbgoo11Z+IPCEDPmKJcJ/kih449u6WDjCkAWqRaPAhippFk6bGHJklBGKeWUVFZp5ZVYZqklajVs6eVSvzDg45dkEnWBCv7EUuaaQQHhTzEOsCknT7/4M0GCc+Zp05n+AKLnnzW5uQ2ghMZUJwp2FKooS3yesuijKbk5BqSUllRnAqZUqilIfIqw6acduekKqKRmBIEEKlxR6qoXEcnqq7DG/yrrrLTWauutuOaq66689urrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfghivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvz26++/AAcs8MAEF2zwwQgnrPDCDDfs8MMQRyzxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLMMcs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dVYZ6311lx37fXXYIct9thkl2322WinrfbabLft9ttwxy333HTXbffdeOet994YAf+RwN+ABy744ICrybdaBfij+OKMN+744gQcjvjjlFceueRoJV755oxfjrlZmnPOueefkxW66JaXDjrqo6te1umsO06662DBHnvntI9l++2Kz557V7vz7vvvWwV/+/DEZ2V87Mgnf9XyrDfvfFXQoy799FNVL/r12Eelfevda/X95tyH79T4qZuPFfqUl6/+Uuw/7v77ScUvO/1W2d/4/PgbpT/u/cse7+QXQAEOcH8FlMr/IJdA7x0QgQ18ygJ7F0EJPhCAFWTKBP3Bvwz2ZIMd9OBOQChC+F2QgSWs3wkpmEKkkLCFR3khDIsiwxkOpYY2DAoOc/iTHfLwgyvk4A//heLDIeqkiEbECRKTaJMlMpEmTnyiTKIoRZhQsYouuSIWWaLFLaqki15ECRjDaJIxkpEkZjyjSNKoRpCwsY0eeSMcOSLHOWqkjnbECB7zaJE98pEifvyjRAIpSIgQspAOOSQiGaLIRSqkkY5ECCQjaZBJUpIglrykQDKpSU4WSgdsSAQHsORJQuVgcSfowQwGsAY1PMIYi4gGFHxQpFICShutaMICOMeDWgYxhLcKAzZ4YIhDUOITBICFGgiRBF+uEJiajIgtHTnNRVYTkdcsZDYFuc0/dpOP38xjOO04zjmWE47nbGM61bjOM7aTjO8MYzy9OM8t1hOL96xiPqW4/88n9pOJ/0xiQI040CEW9IcH5WFCc7hQGzZ0hg+FYUSF1gEEWPSiGM2oRjfK0Y569KMgDSkC6vDL6R3iAChNqUpXytKWuvSlMI2pTGd6gAyUND5JIIQaYEGAT1DiEIbgATbCUCUFBPGoSE0q8+TDA84toAmt0EaUjKrUqlq1qtD0jg+gEI1FGOMRaljDAGbQgxMsLgdTvapa13rBrKaHA4lggw7Syta62hV8yaPqXffKVyE6T699DexaQTE9wAr2sEqNACDykVfEOraqC/jCB4hn2Mda9oR10MfvKnvZzg7QCVnIHWc9S1rWwaAEtBttaVe7uQx8Ik6lUy1rZ+u4yP82ILa0zS3qhHCBz8lWt8A9Qmgl91vg6hYGYiCucZdLuQhw4XDFZS5tGcCJ2+otutKlrRBwlDfsZne2XugS3rz7XdaGAArjLa96FReBKkDAbuRdb2kfsAfYzi2+8i3tEno7NxkY4L8ADrCAB0zgAhv4wAhOsIINTIQI3NULLohmRTTRg7uq4AwSpgg9NnDXCUgiwxMhwRruuoBHWBfED8FAGR5gVwakIQYojsgsHGxXSEQ4xg9RRIXtCoMb4PghLuCwXVOQiR87xAeuYIBdF2CDExs5IQ0owy7tugYSPJkh/ZjAXTcghysvhAVRuCsipuBlhcRhBndNgRvKnJAVWIH/xDagAJsP0gA6TJmtDDCBq+ZckEWY1a4boAefDQKFENw1BFQYdEGQgGa7omDNih6IDAqg5LpmQApyjvQ/OFCKvQJhBJoWSBVScNdJJCrUUADBXbWQ6FDfodF1nQAlQv2PGCzhrhnABAZCTQEjVLqunw61A4jw57r64dSaLoGq7VoELNAaCUy4qxI8FeokjOGuD7jErjXd61+zlRBE1bQDAFFstgriSaEuQRNW7exQsyHadgVBImh9gU3UdQHPpfWmjXBnq+5B3wNxwCtoXFUhTBbgA3kDmpTKCCsjnCA1OCVSQYCEhxukDdcOYgSSa3GDeGAL/R7gA4jQcYRAYBQE/x+gBN5bcoTsYwcHtEKmW44Qfkg8dkeAMc0VcoFBxC4EN965QhDAipA/LgUsELpDUvGCzT3AUUp3CBrWTTkbsDzqDenDzRmXBidjnSFXqETjNiCDr0fkA2qoNAyCbnaIkOIFKCBz2ycCB2rP/e54z7ve9873vvv974APvOAHT/jCG/7wiE+84hfP+MY7/vGQj7zkJ0/5ylv+8pjPvOY3z/nOe/7zoA+96EdP+tKb/vSoT73qV8/61rv+9bCPvexnT/va2/72uM+97nfP+977/vfAD77wh0/84hv/+MhPvvKXz/zmO//50I++9KdP/epb//rYz772t8/97nv/++APv//4x0/+8pv//OhPv/rXz/72u//98I9/XvZ8+CuoYOWId4U/gIB4EfhDBfxVeKaQAP7wC4h3bfx3eKfwfwFIeHaAAgWIeNuwf4gHCAx4eLegZQZoeA5QDBR4eLFwgYcnBQywgYgnXvKXgiq4gndjCVswV4gnAP5gAom3AhAIgyM4g4k3BBA4XIfXaQKCeKFwAgyAgoYXDAGSeHxgAUWYeFuQhIinCg/QhIinAVCIgQcSB4nXIMaQeLfgYywYhmI4hmRYhmZ4hmiYhmq4hmzYhm74hnAYh3I4h3RYh3Z4h3iYh3q4h3zYh374h4AYiII4iIRYiIZ4iIiYiIq4iIzYiI4K+IiQGImSOBUBAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu7fv38CDCx9OvLjx48iTK1/OvLnz59CjS59Ovbr169iza9/Ovbv37+DDi/8fT768+fPo06tfz769+/fw48ufz1QAC/r4S/8ak79/aAgAoOLfgJ2dAgaBCGbWgBZyJOhgZbF88eCEkYWByAUUZtgYJpdo6GFiSfTQwockFvYFKSWmGJgckTSg4ot9SSMCjDTm1ccRNeZolxBY6OhjXBz8KOSQRBZp5JFIJqnkkkw26eSTUEYp5ZRUVmnllVhmqaVYlKiy5Zc4/dFDKGCWORMHjMBh5powSVALm3CyJEYOI8Zpp0kk2ILDnXySFIAAfQYKEiXFOCDooRtZUoSXiDZqEQQDsOPopBTVQwilmEL0By4xZOopQ5VA8emoCXlA6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXbPPNOOes88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VhnrfXWXHft9ddghy322GSXbfbZaKet9tpsWwlEAnDHLffcdMcdS9trFeDP3nz3/+3333wTgLdaegNuuOGCD45W4Yc3HrjiizsuuT+JQ14W45MjbrlZmGf+d+Wbi9W5532DHjpYo5O+t+mne5W66qy3ztXrpMcuu1a0e2777VjlnvnuvFvl++TAB0/V8JIXb7xUyDuu/PJQNd/489A7Jf3h1FfP1PWaa9+76oBn731S3Ic//lXlf36+8OCrv/7x7fst/vtEpS8//VPZXzr+zMe/P//R89/jAPgU/Q2QgE0x4OoQaD0BLpCB23Mg5SAYQQfOj4I6UeAEMUg+CV6QgzfR4AdBWBMRkvAoJjxhUVKowqGwsIVBeSEMfyLDGfakhjbcCQ5zmJMd8jCEHvyhT/98KESaELGIMjkiEmGixCW6pIlOZAkUo6iSKVIRJVa8okmyqEWScLGLIvkiGEEixjF6pIxm5Aga06iRNbIRI258o0XiKEeK0LGOErkjHiGixz06pI9+ZAgg+0QNedgAHSIogSgSgQElDZJPeYCDJIxBh3RU4ggwAAEzBhAAYExDFkN6JKUuUIMbRIMLbwhlEAN5ElGy0iCufCVBYilLgdCylreUZS5fuUtW9jKQv/RjMPc4TDwWs47HlGMy37hMNjYzjc80YzTHOE0wVrOL19RiNq+4TSp2M4rfdGI4lzhOJJaziOcUYjp/uE4etjOH77RhPGc4TxjWs4X3VGE+T7j/T5p1AAEADahAB0rQghr0oAhNqEIXioA6rJJ3hziARCdK0Ypa9KIYzahGN8rRjh4gAw+9nQIkSNKSmlR3xhvpSVfK0pWO8GwqbalMZ9q+l5otpjTNqU6xl9Kd+vSnBxQpUIeqU1DI5w1ciMYNaoChKOGUqFA9aQQAkQ/4yGIawAjAAJgBAhgcoRLpoIMxJAGHPCDpqVFNqwQX8IUP5AcDiRBFCUSADhvIgxpnVateTVoHfcgOrXsNLPickIXWAVawiM0cDEpwusMm9rGNy8AnDGU5x0L2sn9jq4sgZ1nMepZvQmjq4Dr72c8eobCjLa1qDwcDMaR2tbD1WwS4gDfS/8b2sgzgxGbVZtvbXlYIQ1hbb30LWS/UgLfETa4/QiAqtA1XuYmNQBUgAFPoJvcBe6As2Z5r3cQuQbRik4EBxkve8pr3vOhNr3rXy972ule9RIjATr3gglpaRBM92KkKzmDfitBjAzudgCT6SxESrGGnC3jEbgn8EAyU4QE6ZUAaOsXgiMxCvjqFRH0rDBFF5FenMLgBhyHiAgDrNAWZGPFDfOAKBuh0ATZYsIoT0oAyLGCnayDBjBvSjwnsdAMN2vFCWBCFnSJiCkJeSBxmsNMUuCHJClmBFRBsAwpAGSENoMONc8oAE6zgyghZxAl+TA8wHwQKIdhpCKhgZoMggf/JOkXBk9tMEBkUwMU5zYAUrExngXCgFD4Fwgj6PJAqpGCnk7ADoQUCBRDsVAtsXvQd4JzTCVBi0f+IwRJ2mgFMNJLQFDACnnMq6EU7gAhj1qkfFL3oEjhap0Xo0aKRwISdKmFGi07CGHb6gEt8us+hHjVNCREGUwMi1TkVhCUwXYImPFrWhGZDrXUKgkRg+gKbyOkCaIvpf3DACFtu6R66PRAHvALDKxWCW8k9kDeoYKWM0DG7CVKDHJgUBEiYt0HasGsJRsC1+jaIB7YQ7vY9gAgBRwgERoFu8EmAuglHyD520D4r8DniCOGHvUl3BApjPCEXGITnQrDhjysEAaz/KLjhUnAfkzckFS9o3ANO4fKHoMHZhrMBxGvekD5s3G9pkDHPF3KFSvhtAzIYekQ+oAY8w6DkSocIKV6AAiRHfSJwwPXVt871rnv962APu9jHTvaym/3saE+72tfO9ra7/e1wj7vc5073utv97njPu973zve++/3vgA+84AdP+MIb/vCIT7ziF8/4xjv+8ZCPvOQnT/nKW/7ymM+85jfP+c57/vOgD73oR0/60pv+9KhPvepXz/rWu/71sI+97GdP+9rb/va4z73ud8/73vv+98APvvCHT/ziG//4yE++8pfP/OY7//nQj770B2aqtkOhEm2PAS7+0HZC1KPt7BjA087TrooiLHvtDijGpdkugAC0HQe2kLfaW5ADgK+9FhJoOxwYEaS1h6IH3Md2qrB+01eABniACJiACriADGh3/cd2WCAEb3cEfeB2IiANbtcAkRBkbEcKEtJ2LdADSeB2l4AJbncBiFBsbfcFd9N2cqAFQod2YEBzbYcKADB+ajcGv+B2LAAoDfiDQBiEQjiERFiERniESJiESriETNiETviEUBiFUjiFVFiFVniFWJiFWriFXNiFXviFYBiGYjiGZFiGZniGaJiGariGbNiGblgmAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48ePIkytfzry58+fQo0ufTr269evYs2vfzr279+/gw4v/H0++vPnz6NOrX8++vXQPHNzLj90Azvz7roVBwM8/tQwo/QVo2i8CFiiaHaIYqKBnBC7oYGao2PHghJYlQ+GFksmyAoYcNgZBOB2GqNghDYhoYmEfvHHiioIJw+KLfl2QBIw01mjjjTjmqOOOPPbo449ABinkkEQWaeSRSCap5JJMNunkk1BGKeWUVFZZXSgYWKmlTA7As+WXL/3SAphkqoQKL2WmadIICqjp5kgivCnnRyVcMeedGslhCJ58WoRBN30GOpEeFAhqqEM43HHoogoNMQyjkB5kYaSUVmrppZhmqummnHbq6aeghirqqKSWauqpqKaq6qqsturqq7DG/yrrrLTWauutuOaq66689urrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfghivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvz26++/AAcs8MAEF2zwwQgnrPDCDDfs8MMQRyzxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLMMcs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dUtA5HA1lx37fXXXMeCNVsF+GP22WinrfbZBIy9Vtlrxx13226nBbfceLNdt9159//tD917m3W333MHftbghKsNuOFjIZ442oszHpbjj5sdueRfUV755Zh3pfnjnHe+1eeJhy56VqQTbvrpV6Xu9+qsV+V637DHPtXseddue1S446377k/1LvfvwDclfOHFo1752sQnr9TxzDuPFfSKS9/68tVbLzv2aTevfVHUd/89VeFDPv7t3Jt/Pu/p670+VOW7/75T8Vs+f/Dt23+/8fn/vT//+fPe/3ZSP/8N8Hn9E+ABcVJABS7QJg18IFIiKEGjULCCRLkgBoWiwQ0CpYMe9AkIQ8iTEZJQJyY8IQMTqMKfpLCFNXkhDGciwxnGpIY2fAkOc9iSHfJwJT78YUr/gijEkxCxiCU5IhJHosQlhqSJTvwIFKPYkSlScSNWvGJGsqjFi3CxixX5IhgnIsY5YaAEh3jDN75RAmQ8Qw7x+VEZDeWDOLCAGt84wxtksaM5jvEhfvxjQwIpyIUQspAJOSQiD6LIRRakkY4cCCQj+Y9JRtKSjsTkIjWJSE4W0pOCBOUfRTlGUoLRlF1EpRZVeUVWUtGVUYSlE2W5RFoi0ZZFxKUQdflDXvLQlzkEpg2FOUNiwtCYLUSmCpV5QmaS0JkhhKYHpblBamLQmhXEpgS1+bEOIOCb4AynOMdJznKa85zoTKc6EVAHFsbuEAeIpzznSc962vOe+MynPvfJ/88DZMCdrFNA/wZK0IKWznYCNahCF6pQB04toQyNqESx51CpQXSiGM3o8BCq0Y56VH6nu+hHRxpRUHCUpChlaAQAkY+ApvSlCl3AFz4QUpjatKB10IfoRHrTnmLPCVlojyzecIZvUIMFcfABknjq06YmDgYluA8H5PAMZJRgjW84RAmy9COmOvWrecvAJxzAOK+C9axrk2mJAmdWtLoVbUK4AFvfSle8HSGodWtrXd8KAzHkda+AVVsEuOA2vQYWrQzgxFqtZtjDolUIQ7haYx17Vi/UgLGUzaw/QgAgqk1Ws1+NQBX2Y1HQZvYBeyBr1D5r2q8uQa5Qk4EBZkvb2v/a9ra4za1ud8vb3vpWt0SIgEa94AJKWkQTPdCoCs5g3IrQYwManYAkmksREqxBowt4xGKp+xAMlOEBGWVAGmLAXYnMQrgZhURxywsRRSQ3ozC4AXsh4gLoZjQFmZjvQ3zgCgZkdAE22K5+E9KAMixAo2sgwYAb0o8JaHQDclgwQ1gQBY0iYgoSXkgcZqDRFLghwwpZgRWwa4NCgfggDaDDgTHKABNs6MQHWcQJHkwPGB8ECiHQaAioYGODIIHDGUXBh3tMEBkUwL8YzYAUTEzkf3CgFB0FwgiaPJAqpECjk5AQlf8BBRBoVAs83vIdgIzRCVBiy/+IwRI0mgFMcLX/yRQwApIxKuUtO4AIM86oH7RM5RJ4OaNFwAKakcAEjSohTltOwhg0+oBLvJnIcZ7zRAkRBjsDIs8YFYQl0FyCJnxZ0FtmQ6EzCoJEoPkCm8DoAgiLZicbYcUM3UOrB+KAV6BXoUKg6awH8gYVKJQRCt41QWqQg4KCAAnCNkgbFt2/CPg12QbxwBZgjb0HEAHaCIHAKG69PAmQFtsH2ccOsGcFJoP7IPwo9uOOQN5zK+QCg0hcCNbrboUggBXUjlsKWFBvh6TiBXh7wCn6/RA0eDpuNvg2wRnSB3WnLQ0CXvhCrlCJtG1ABhKPyAfUgGQY0DvjECHFC1CAYZBPBA6I/za5ylfO8pa7/OUwj7nMZ07zmtv85jjPuc53zvOe+/znQA+60IdO9KIb/ehIT7rSl870pjv96VCPutSnTvWqW/3qWM+61rfO9a57/etgD7vYx072spv97GhPu9rXzva2u/3tcI+73OdO97rb/e54z7ve9873vvv974APvOAHT/jCG/7wiE+84hfP+MY7/vGQj7zkJ0/5ylv+8pjPvOY3z/nOe/7zoHfapHY+jMju/A444DkF9NDzbjwa54ZQBc+vEFWep1znCpjyznmBCp63oEE7h4dqdY6BUIT++MhPvvKXz/zmO//50I++9N2TBNjy3EU9f4Oud96AQ/g8HArP+W0K+Njz0e/cDr3vOfB3Lgo+73z9OocCxnkOAezzHA4RvzkHPDD9/vv//wAYgAI4gARYgAZ4gAiYgAq4gAzYgA74gBAYgRI4gRRYgRZ4gRiYgRq4gRzYgR74gSAYgiI4giRYgiZ4giiYgiqYMgEBACH5BAUDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrX868ufPn0KNLn069uvXr2LNr3869u/fv4MOL/x9Pvrz58+jTq1/Pvr379/Djy59Pv779+/jz69/Pv7///wAGKOCABBZo4IEIJqjgggw26OCDEEYo4YQUVmjhhRhmqOGGHHbo4YcghijiiCSWaOKJKKao4oostujiizDGKOOMNNZo44045qjjjjz26OOPQAYp5JBEFmnkkUgmqeSSTDbp5JNQRinllFRWaeWVWGap5ZZcdunll2CGKeaYZJZp5plopqnmmmy26eabcMYp55x01mnnnXjmqeeefPbp55+ABirooIQWauihiCaq6KKMNuroo5BGKumklFZq6aWYZqrpppx26umnoIYq6qiklmrqqaimquqqrLbq6quwxv8q66y01mrrrbjmquuuvPbq66/ABivssMQWa+yxyCar7LLMNuvss9BGK+201FZr7bXYZqvtttx26+234IYr7rjklmvuueimq+667Lbr7rvwxivvvPTWa++9+Oar77789uvvvwAHLPDABBds8MEIJ6zwwgw37PDDDwKRwMQUV2zxxRTHArFZBfjj8ccghyzyxwRsXFbHI6eccskmj4WyyjCT3LLLMdfsD8szg/WyzSvnHNbOPIuMs89dAR00yEMTvZXRR3uctNJZMd3001BfJfXRVFdd1dVBZ631VFzz7PXXUYVt89hkP2V2zWin3dTaMbft9lJwwyz33EnVrfLdeB//pXfPfYPd9Mh8B07U34QbLhXiQite9uCNO6425CEXLvlPjFd+uVOZI73525R7/jndocs8ulKdm346Uqk7vXrepbv+ut+x3zw77bFbfntNrdu+++G16/67TL0LPzxMxR8vVPLKA8V88z49Dz1P0k+vU/XW44R99jZtzz1N3n9PfPDi5xR++S+dj35L6q+/UvvupwR//CfNT39J9t8/Uv76h8R//x/5HwA7IsABbqSABswIAhN4kQUysCIOfOBEIijBiFCwgg+5IAYbosENLqSDHkwICEN4kBGSsCAmPOFAUqjCf7BQhS88YQxJOMMQ1tCDN9xgDjG4wwr2UII/fGAQ/xk4xAQW0YBHHGASAbjE/jVRf0+8XxTpN8X4VdF9V1xfFtG3xfJ1UXxf/F4YuTfG7JXRemecXhqht8bmtVF5bzxeHIc3x9/VcXd3vF0eZ7fHaHUAAYAMpCAHSchCGvKQiEykIheJgDqQT2mHOIAkJ0nJSlrykpjMpCY3yclOHiADjySaAmpHylKasmtQG+UpV8nKVRqvYKpspSxnCblXEiyWtMylLveWyl368peq8xkugUlMWYKil8VMZisjAIh8iFKZ0FzlAr7wAWFG85qmrIM+cjZMbHoTck7Iwsy6+c1yBg0GJWgZOc3Jzphl4BMO2Ng620nPkU2zARCbZz33Cf8yIVzgYfrkp0CPIM6GBVSg/ISBGAyK0IamLAJcYNhBHVpPBnACnwmbKEXrKYQhZHSjIAWZF2qAMI2GtJ0hgMLBTHpSdkagChCAZUtb+oA9xHNgLJ0pO5fwT4HJwABADapQh0rUohr1qEhNqlKXelQiRGCXXnBBCyWiiR7sUgVnmGpE6LGBXU5AElqFCAnWsMsFPAKjYWUIBsrwAF0yIA0xSKtDZvFUXUJCqnJliCKsqksY3CCvDHFBV3WZgkwAdiE+cAUDdLkAG6D1sAZpQBkWsMs1kACyCenHBHa5ATlgFiEsiMIuETGFzx4kDjPYZQrcYFqDrMAKZbUBBVpLkAb/0IGyuWSACVZAW4Is4gScpUdvBwKFEOwyBFQYrkCQkFpdooC1ypVBARabywxIYbbD5UApfAmEESj3H1VIwS4nYYfvQgEEu9RCcpV7h+bmcgKU+G4MlrDLDGACA8qlgBGom8vuKtcBRACuLv1QXuWWAL26LAIWvosEJuxSCSL4bhLGsMsHXAK/w9Uvf2lJiDD8FxACzqUgLPHdEjQhvQtWLhscrEsQJOK7F9hELhcQ0e/+gwNGwG0r92DjgTjgFXVdpRCq2eOBvEEFq2TEZYtMkBrkwJQgQAKTDdIGCtcuAgudskE8sAUdQ+4BRNAyQiAwiiAPTgIxFTNC9rEDyFkB/7tqRgg/nny0I8Q1zgq5wCCCFgK84lkhCGCFl1OWAhb82SGpeAHMHnCKQz8EDSdOmQ3S7OiG9IHOIUvDYyvNkCtUImQbkAGnI/IBNVAXBn4eNURI8QIUlFbVE4FDhGFN61rb+ta4zrWud83rXvv618AOtrCHTexiG/vYyE62spfN7GY7+9nQjra0p03talv72tjOtra3ze1ue/vb4A63uMdN7nKb+9zoTre6183udrv73fCOt7znTe962/ve+M63vvfN7377+98AD7jAB07wghv84AhPuMIXzvCGO/zhEI+4xCdO8Ypb/OIYz7jGN87xjnv84yAPuchHTvKSm/zkKHdPucpXzvKWu/zlMI+5zGdO85rb/OY4z7nOd87znvv850APutCHTvSiG/3oSE+60pfO9KY7/elQj7rUp071qlv96ljPuta3zvWue/3rYA+72MdO9rKb/exoT7va1872trv97XCPu9znTve62/3ueM+73vfOd8gEBAAh+QQJAwD/ACwmACoAPAIQAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjRhSmi4TEixgzatzIsaPHjyBDihxJsqTJkyhTXpTiD53KlzBjypxJs6bNmzhz3syTwUwHnUCDCh1KtKjRo0g5pvOXLKnTp1CjSp1K1akBf9Wqat3KtavXr16d+UMFtqzZs2jTqt2YzN+4tXDjyp1L92mHQC/a1N3Lt6/fvx7P+RMAuLDhw4j3jlASokHix5AjS466xx+lyZgza978Ug4DP5xDix5N+qEJf89Kq17NWrMmf+lay55N26+9GLVz697Nu7fv38CDCx9OvLjx48iTK1/OvLnz59CjS59Ovbr169iza9/Ovbv37+DDi/8fT768+fPo06tfz769+/fw48ufT7++/fv48+vXjwzaz/0A6mcKHgvQEOCB9jkQhD/WIOjgfAL4M4ADD1boniILgJCIhRyqF0MR/rzR4YjnEeOPFCSmOB4g/hTzn4owcofKCzvwEeON2rWQgz+H4Ojjdcr4U8qPRE4ngj+COFbkks7ZcIAdTEbZ3BVSVmnllVhmqeWWXHbp5ZdghinmmGSWaeaZaKap5ppstunmm3DGKeecdNZp55145qnnnnz26eefgAYq6KCEFmrooYgmquiijDbq6KOQRirppJRWaumlmGaq6aacdurpp6CGKuqopJZq6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXbPPNOOes88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VhnrfXWXHft9ddghy322GSXbfbZaKet9tpst+3223DHLffcdNdt992YcYB3VIRM/+DEJmrgkwk1cXSx91DmtPKCP4w37s8O5KQxTyNQHp7TBToMswg0GmzCjBKNy2L5USMgQc0Io6eu+uqst+7667DHLvvstNdu++2456777rz37vvvwAcv/PDEF2/88cgnr/zyzDfv/PPQRy/99NRXb/312Gev/fbcd+/99+CHL/745JdvPnMjUIME6uDL0rgSzGyiATSLDKPDBdjb0cg8aZCzg+ONe0ErzLG9LsSBGpnAhxo24YQJEIJ8ejufBCdIwQpa8IIYzKAGN8jBDnrwgyAMoQhHSMISmvCEKEyhClfIwha68IUwjKEMZ0jDGtrwhjjMoQ53yMMe+vCHQAyiEP+HSMQiGvGISEyiEpfIxCY68YlQjKIUp0jFKlrxiljMoha3yMUuevGLYAyjGMdIxjKa8YxoTKMa18jGNrrxjXCMoxznSMc62vGOeMyjHvfIxz768Y+ADKQgB0nIQhrykIhMpCIXychGOvKRkIykJCdJyUpa8pKYzKQmN8nJTnryk6AMpShHScpSmvKUqEylKlfJyla68pWwjGVZqCQ+OxzgEeFrgCD8IYLwScAfygjfIfyRgxaAjw87eAFZvteBYvgDEOFjCTHC9wZ/FAE330sECBagCPA5YACDCZ81/BEECn2PBgvAgynC1wFoIEOW8IynPOdJz3ra8574zKc+98lRzwPFwB7jW4omxPcMf5hgfH5ggBzERwl/7EF8DQiBEtgHvgidQ3xteEEgXvS9cTBFfKjwhzPGVw1/GEB8bYkNO82QgTyIDx0nEh8JqiEM9AQEACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrX868ufPn0KNLn069uvXr2LNr3869u/fvqeXI/wBPXrkDNEsYoCvPnviVabb8yS/Uvv7vPxbk6/cny75/3RDksJ986fxn4G2ADOjPC0Mc6KBsPqCg4DkPVvjaFwoCYOGGqyGhoD+GcCjiadooqMyIKI52j4IRkJDii545EIiCgMBo42boKDjDjTxeRsIJCj7T45CTqTEgAxQSqaRjfeinAihyLCllY9U4QwsFU2a5mAdadunll2CGKeaYZJZp5plopqnmmmy26eabcMYp55x01mnnnXjmqeeefPbp55+ABirooIQWauihiCaq6KKMPqhKCY1GahIFkzBQAQSSZgqSEfqR4aKmoGakx4C2XBPqqRTdooSCL0CK6qsNcf+wwYeFrADrrQpx8yEKWeDqq0G0fOjPL78WK1AcEipYhrHFdsHIh5U4wOyvGnwYSAzT+irChyegkq2v1XxIybe+cmDkfsGQW6wbEcg3AAbqFqsDLj1cEa+xMvR677789uvvvwAHLPDABBds8MEIJ6zwwgw37PDDEEcs8cQUV2zxxRhnrPHGHHfs8ccghyzyyCSXbPLJKKes8sost+zyyzDHLPPMNNds880456zzzjz37PPPQAct9NBEF2300UgnrfTSTDft9NNQRy311FRXbfXVWGet9dZcd+3112CHLfbYZJdt9tlop6322my37fbbcMct99x012333XjnrffefPf/7fffgAcu+OCEF2744YgnrvjijDfu+OOQRy755JRXbvnlmGeu+eacd+7556CHLvropJdu+umop6766qy37vrrsMcu+6BAJGD77bjnrvvtscwuVwHCBv8hAb7HBbzwyMtHfPFvHZ+88Msz35bzzwsbvfRrUV+9gtdjn5b22+/XvfdngR++8uRnf/7w6atl/vnjtz/W++HHL39Y9G9v//1f5V/9/vzriv+eB8AAbmWAySugAbOCQOQpcIFXaSD0ICgWCQbvgRSkigWtl0GwbJB9HfTKB7kXQhGuj4Ql5MoIB4TBFDplheJz4QFPyEIZagWG+mmhDZWCQ/TtMII0jOEP/63SQ3/ocIhGKeIRkUgUJTJRg0HM4ROn4sQpRqWKVnwKFrPYlC1ycSle/GJSwijGo5CxjEU5IxqHosY1BqWNbvwJHOPYkznScSd2vGNO8qjHm/CxjzX5IyBnIshBxqSQhnwJIhPZkkUWiwCMcIUNTjEFU8zJkb+ShoJSsAEgQEMEWLgAmzDpq1w8bxXRUBMpcaWC6n1DlVH0ocDCsL07wDKWSzRWk57HgAbcMoq5LJYCqmeGNa3yVkNAhQJ+IIE1eKMJCgqCMWNpxIa1IAvfIIIUwGCMaeKSkXKkZjDBqZJjkpMk5jynSNKpTpCws50eeSc8OSLPeWqknvbECD7zaf+RffKTIv78p0QCKlCIELSgDjkoQhmi0IUqpKEORQhEI2qQiVKUIBa9qEAyqlGOXtSjFAVpREXqUJIu1KQIRWlBVSpQlv7TpfyEaT5lak+aztOm8MRpO3WqTp6e06fkBCo4hcpIoibSqIZE6iCVCkim9tGpeoTqHaVKR6oCrgMIyKpWt8rVrnr1q2ANq1jHSlYE1EGcJTzEAdbK1ra69a1wjatc50rXutr1ABlAawiHSc2++vWv/yshXwFL2MICdpyzG6xhF8vY9SFWdoptrGQny8G9UvaymJWiZTPLWcmCQrCdDe1iIwCIfHQwsqJNLTUX8IUPZBC1qo1tEOugDwr/wla2uD2fE/RlwNvm9rfPg4GrAuhb4Bo3eBn4hLT4V9zjOndArPXl/Zr73OrKRwiilB91rVvdI/CWfNvl7nNhIIb6GAMMUiDCN7LQgj2FV7zOjQAX2hMEBTXBG2uQwA8UgIoGyem98D0uAzghXfCYoXoK+G+AF/whIfjXOw1gQPX6oGAGW1g/XqjBd+6wvTBU+MIXDgEUvPON6qlgTgAGMXAjUAVMbScaq3heLlCsYhU/YA/L3c4FsCACaABhAylQkDRoXGMVLyG75DHFFE5hA1cw4rFakoEBpkzlKlv5yljOspa3zOUue1nLRGjXZL3gAo12RBM9oKwKzmBmjtBj/1aTnYAk2rwREqyBsgt4RIHpbBEMlOEBk2VAGrDFZ4zMQsyShUSZC30RRaR5sjC4AaMv4gI4SzYFmZi0RXzgCglLdgE22LOmIdKAMiyAsmv41Kgl0o8JUHYDUVq1RFgQBcoiYgqylkgcZkDZFLgh1xFZgRXwbAMsAdshDaDDqSXLABPY6tgOWQSQJrsBekDbIVAIAWVDQIVrNwQJvJ4sCn7t7YXIoACebmwGpGDsciOEA6W4LBBG4G6FVCHIk52EHeqdECiAgLJa6Da/D3KHcEt2AuMauEFisATKZgAT8FI4QShghHQ3dt4SJ4gDiDBtyfph3xkfSAn+PdkiYCHkA/9BAhMoqwQRoFwgSRgDZR9wiYiHnOIWZywhPIxyBwCi440VhCVe/o8SQHOyWjj5y9mw8smCIBFEv8AmPj1fov+DA0ZYtmH3YPWBOOAViAasEFzb9YG8oZWAZYSqyy6QGgjIryBAAtsN0gaZUzMC5Z27QTywBa2f8AFE0DtCIDCKsJ9PAi4W/EH2sYMTWqHdij8IP96+vSMQOvIJucAgtheCRWNeIQhghd+FlQIWfN4hqXiB8B5witM/BA1H/5ANEu96hvSB8vtJg6hrv5ArVGJAGxgP7yHyATV4GgaeHz5ESPECFOBa+ROBg8uhT/3qW//62M++9rfP/e57//vgD7//+MdP/vKb//zoT7/618/+9rv//fCPv/znT//62//++M+//vfP//77//8AGIACOIAEWIAGeIAImIAKuIAM2IAO+IAQGIESOIEUWIEWeIEYmIEauIEc2IEe+IEgGIIiOIIkWIImeIIomIIquIIs2IIu+IIwGIMyOIM0WIM2eIM4mIM6uIM82IM++INAGIRCOISokwXCR35X0AO4oAPkhwEDIB8RQG7hRwcDogYcAH6U8CHV8H2oAHT6MX3cFwMzoiAa4H0O8HsKwghd4H1lsCtx4H2/ICy04H1ZkCwDwg3etwKF8CEbcIXdVwKqNyBKcAvgdw3xsR96IH4kQAb6YQTk6AcBFcAAkwB54lcCqkCEmJiJmriJnNiJnviJoBiKojiKpFiKpniKqGg3XEJ+FEALzrCF4icHoIB2/kBh4HcOOacG4fcMCnICa9d9Bqcf6wF+CTIggZBj3UcChucP9xB+yqAg2hB+hvAhGgZ+AKAgXxB+56AgKOAD4DcEgbgfNQJ+6aAgOUB73CcLCmIBfxB+eygftjAN9hJ+6MAAS4AGyAh+MhBrqdiP/viPABmQAjmQBFmQBnmQCJmQCrmQDNmQDvmQEBmREjmRFFmRFnmRGJmRGrmRHNmRHvmRIBmSIjmSJFmSJllCAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48ePIkytfzry58+fQHWNgEb26dYtYvuDxx+O69+8Js6j/C+SvvD9r4NN/H/Jqg/n3TtTLfw6hBJAX7/P74zW/P3I+1mih34BS+GcgcXAMqGArBzYIXAdRKDigKA5WyJs1EupXoIUc3mYJAxm+Z0aHJNa2RIjv0VDiirAliGJ5sLAoI2sdIPKiPyPOqCNqmNzojyE7BkmaHCC+aIOQSIY2RogoyPMGBklG2ZkwCmZghR4eSKklZxiEkN8kXMSw5Zic9ehPE3T0Qeaam8lBRjwUsCnnnHTWaeedeOap55589unnn4AGKuighBZq6KGIJqrooow26uijkEYq6aSUVmrppZhmqummnHbq6aeghirqqKSWauqpqKaq6qqsturqq7DG/yorUJpIMuutFpni5TwN4OrrQw14Yt4ASfxqrEJb5GeLDsc2S5AbA07QjrPNXhOBhOhR6+sFtoQoTZzayuqANi/qMkS4sdrgYyF3oOvqLz6Wt4Mm7q6aBQrxlkdEvamuAEC+/mzI76kjCJGvNAOr6kAZPgbRa8KqdjMBioysADGropiRYRR8XNxqG7oo6MgfHrtKgTT6WUBNybBi+B47LMdKiwXlCRCzrIY00czNs1oCJc9ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dVYZ6311lx37fXXYIct9thkl2322WinrfbabLft9ttwxy333HTXbffdeOet99589//t99+ABy744IQXbvjhiCeu+OKMN+7445BHLvnklFdu+eWYZ6755px37vnnoIcu+uikl2766ainrvrqrLfu+uuwxy777LTXbvvtuOeu++689+7778AHL/zwxBdv/PHIJ6/88sw37/zz0Ecv/fTUV2/99dhnr/323Hfv/ffghy/++OSXb/756A8PRALst+/++/C3H0v6eBUAsH4E0H+X/fe/l7/+deFf/8rzPwDORYADLKAB44LA/ilwgW9p4P0eCMG2SBBgFKzgWi6YrwxqMC0cjJcHP3iWEPpohCQsiwlvhMIUjmWFL2qhC8MCQxTJcIZfqWGIbojDrugwQzzs4Vb/fiihIAoxK0RUkBGPeJUkDmiJTKyKE/EXRRUO0DxQrKJUppifLGoRKlz03xfFEkYsjpGGVyTgGcFSRjWu0Stt9IcX36iUOM6RjkixIx65osc9aqWPfsQKIANplUESkiqGPOQW0yhHRRaSkXd05E8SeTM0mGJSlGTZHMoTggKUQwEda1QmS+ai/KiADNAAZaJG6TEBoOiUrzAUKy+2hhuBQ5aQHForboQOXKYxksbygY9WVqhZJowKPmqDL68IzF9V4UYhOJQxB7aHG9VBmrkM2pJeBAps/lJoGnuRCLzJzKC1wEc4IGcCg4YKH41AnQ4MGi1uFAVETbNebhAQirZh/89sBu0DPAhHLGqxDX2+5wv9/GbSutAHYTRCDQMYJzwnKElE+rOiYLwoRp1yz40OpaMeDQpIQzpJjZI0KSM9KU9SqlKdsLSlOHkpTG0i05nSpKY2lQlOcwqTnfLUJT79KUuCKlSVELWoKDkqUk2i1KWSpKlOFQlUowqSqVLVI1a9KkeyqlWNcLWrGPkqWC0i1rFSpKxmlQha0wqRtbLVIW59K0PiKleF0LWuCLkrXg2i170SpK9+FQhgAztYvxZ2r4fFa2Lruli5Nvatj2VrZNM6WbNWdqyXBWtmu7pZrXb2qp+lamijOlqnlnZ4HUCAalfL2ta69rWwja1sZ0vb2v8ioA4m1eIhDsDb3vr2t8ANrnCHS9ziGve4B8hAbquoAEY697nQPSEdmxvd6lq3us3UH3Wvy93uUvSN2/WueMdbxOmS97zoNSN408ve8XZzve2N73UjAIh8rDG88s2vcxfwhQ+cEb/6DfAV66CPMQJYwAgGmBOy8MUDJ/jBN4JBCbToYAhbOEMZ+IQDoljhC3tYP/x9mBA7/OESm0cIFzgiiU1s4iMwuIcrZnGJYSAGGMv4xgqKABdwGGMce5gBnBDxB3vsYw8L4VwkJHKRL+yFGiR5yVA2TwigMOQoWzkCVYBAf0QwADU0Qhh96IKmlGxlCD9gDxuWzxf0o4Vt1CL/FuHggX8lReYyQ3gJKVbPIF6kBTdESgYGCLSgB03oQhv60IhOtKIXzWhEE+Fa4/WCC9QToRfRQm2a6AF5VXAG8IzAR6hYGz3cM94J2Mo7OPBRC9hGglqOdwGPEDJ0RHCjHLENA2V4wHgZkAYxVQcUNxoD3GYBafFCYtLRwe2L9hA3RWh6vDC4QXS89KIqyM0FpBZvCjLxnDb4iApz84EriuTdBdhA1sihho98QLcGlGEB5F0DCZiDjhvh4m79mNh4NyCH5YDjRmvAGwsqLV5ETEE5ryCDClBkM7zFYQbkTYGfl8MHBUBD4QOCg95WYAXymhtczal4OQpA7TnsrQF0/4C3eBlgAotVxxRo8NsiTkDeDdAjsCGBArXFGwJw4/wjSID4eFEw8Z93RAYFIHd3MyAFkBtdIxwoxXmB8M6nc6QKKSDvJOxgdY5AAQTk1YLPu56ROwhdvBOgBNk1EoMTjTcDmPjZ2i1CASMovbtUn/tFHEAEmo/XD1zXu0VKAPbxFgELgrcIEphAXiVINPETScI2xfuAS8gd8hCp+925S4gwYF4iDgCE38UrCEt8XiIlaELYEX96iLCB8eMFQSJaD5ELbEK8C9gx7SHCASOo/LrM3n1EHPCKYkdXCHMWfkTesPDoMmLeyp9IDXIAXRAgIfoVacPkrxiBGmO/Ih7Ywv/v7/eAfX3fIhAYhfHzJQEtn/8i+9jB/azg9PdXhB/Uj9cRfG1/jFxgz9CEbP2XEQjACuOnIClAHQPIEamAHxLyAKewgB6BBqqnIDbgfhLIEX2Qf/mRBuiWgRlxBZWQHxsgAyAIEh+gBkUCAwJ4gh9BCi+AAgfngiIBB49HgziYgzq4gzzYgz74g0AYhEI4hERYhEZ4hEiYhEq4hEzYhE74hFAYhVI4hVRYhVZ4hViYhVq4hVzYhV74hWAYhmI4hmRYhmZ4hmiYhmq4hmzYhm74hnAYh3I4h3RYh3Z4h3iYh3q4h3zYh374h4AYiII4iIRYiIZ4iIiYiIq4iIzYiI7/+IiQGImSOImUWImWeImYmImauImc2Ime+ImgGIpaiAGml4XN0ARAcoWu5A8WoHZVyA75kS1SSA00kx/fEoV/4AgKogvK5IR8QHADYgYUwoQrwAgoMgHdsIQNEAQ+UgZpdoTpkC9CUHVFKAUAAwAuR4READAo8GJFqAnyFy+/kIR3UAg+ciRKOAQhgyLa8IxJeDIhYgt51oQuMyARcA1R2A76lh9FB4U60C3vsQVVmAQDYB6e8IFP2ADz4A8hcElYKAn0IooSOZEUWZEWeZEYmZEauZEc2ZEe+ZEgGZIiOZIkWZImeZIomZLAQQHxQAb9VoV9QAcViAlTSAJcMAn5xBECl7eEHqAHVqBcAyIMTNgBbyAP+JIhwraE6vIiDPCSSWgIPkKTSxhOKIIIHbCEsOAjGqeENOAjS8CEVBkiDFCKSWiNNyKLSCgKPhIFV6mEu3QjW1mWfGYNoZSEvJAhLwAEJYCBS+gEA7IBr4BkT1iP/hAI6uCNUcgD/oAHX8B6VsgCO6mSkjmZlFmZlnmZmJmZmrmZnNmZnvmZoBmaojmapFmapnmaqJmaqrmarNmarvmasBmbsjmbtFmbtnmbuLklAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbv3wQ++gwt3CgGVsW0RSAxfzjzoBRHSVPib7k9Y8+vYa/IwVowB9e9fsov/H4/Sgaw9gb6rnw6AvPv3HDGUqAVivf3p2ODr3/8Qw7dxO9wnoD8i8GfggQQZMg8eAzYoD4IQwheKFGY0aKE/iESo4XiJLHDhhWxsKOJ1Y3xo4ScjpjgcJSY2aIKKMPbWAgotCniAAzHmmJsyNQqIg45A1nZGj/dNE+SRsTkQBZHfLSAIPEhG6VoZTGqhRjwxSKklazy0uIAzjWSx5ZitbWChI0CIMASZbLJ2joA7aHAIBW3WuVooHn4HgjklYGDnn6vVMR0KyvQJ6KGqxeNKNMAh6uijkEYq6aSUVmrppZhmqummnHbq6aeghirqqKSWauqpqKaq6qqsturqq7DG/yrrrLTWauutuOaq66689urrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfgfrZCuOQO5IEgATRa7rcBTHdMEut6W853uMQR77btrLfKFPdiS0ME9lnQTr/VWgLDgKMQLG0Y5Fj4iMLPOmDFh8o0ADGzj7RYhwcXJ3tKj86M0LGxN1hApDcXjEzsHkz6w0weKg9LQMu4PBGzsN28wGQRNt8MLBVN7HyHz8C60AqTKvBA9K9teIO00kv36sMmSK8ZNa8NpEMkOlf/WkqNVXQNbAUmhi02sKNcaPbZwM6S531rsw2sHibbF7fcwKJR93d34/+d994LQOl3sXr7s4Avgx/7hhKIJ36s1Y5HLvnklFdu+eWYZ6755px37vnnoIcu+uikl2766ainrvrqrLfu+uuwxy777LTXbvvtuOeu++689+7778AHL/zwxBdv/PHIJ6/88sw37/zz0Ecv/fTUV2/99dhnr/323Hfv/ffghy/++OSXb/756Kev/vrst+/++/DHL//89Ndv//3456///vz37///AAygAAdIwAIa8IAITKACF8jABjrwgRCMoAQnSMEKWvCCGMygBjfIwQ568IMgDKEIR0hC1wAhAShMoQpXyMIUxqKEfilAy6hDABj2RYYz9EcNbbgXHM5whzzMiw//WwbEIN5liEwqohHrgkQiKXGJc2lij54IxbhIsUZUrOJbrtiiLGqxLVw0kRe/uJYwfmiMZEyLGS+ExjSeZY0WaqMbywLHBslxjmOp44DuiMew6FFAfOzjV/54n0AqrBv4wEIHYkVI+xiSYFTzxwHWQIRbuKqR63nkvRowgfVEghXCkIGqMKkeTcbrBgNagCesoQg/lYqU3zHluuZ1oQNwjFSwpOHZdPEhSJgql9ORJblakIEPPeyVOdSh2MRgom/8MpnCDBfZLvSAFjwzh9EEVyU+pItTAVOZV+sAjS50CW9Cs2vXMFEJzInNrqXtQgvwATt/2LV2XciX8yRi19Jz/6FgoOqb2exWEkwUjX+eM2rIMJEpDNrOqFnjQ1FIFUCvRoYPrUGiB11agC70Dow2lGh8MJEYPErPpaHhQwwQGUNLSjQBfMgJo8yoz3bxITDE9KM+w8WHGnFTlt5sBOrsqT6J5oA/wMMGQijCgK4g1CSybQWK4MIWdHEA6oRgVRNNHB+G0QieNtWJggSjTMOKlqySVY1jPSsd06rWPLK1rX58K1wHKde5dsWsdhULXvMKlr3y1St+/StXAitYrRC2sFg5LGKtotjFUqWxjpUKZCMLlclS1imWvSxTMqtZpXC2s0j5LGiNItrREqW0phUKalMLlNWy1ieufS1PYitbnf/QtrY4uS1ubaLb3dKkt76VCXCDC5PhEtclxj0uS5KrXJUwt7koeS50TSLd6ZKkutYVCXazC5Ltctcj3v0uR8IrXo2Qt7wYOS96LaLe9VKkve6VCHzjC5H50tch9r0vQ/KrX4Xwt78I+S+ADSLgAROkwAYWCIITvGADN3jADwZwhPs7Yf1WmIEdQICGN8zhDnv4wyAOsYhHTOISI0BQOBXsIQ7A4ha7+MUwjrGMZ0zjGtv4xgcoZor/qoBk+vjHQBajY3sc5CIbucgBrSKRj8zkJoN1sUt2spSnDMghU/nKWNYllLPM5SmDwspdDvORIwCIfCA2ymJOs48X8AV18RX/zWqO8wzroA/BwlnOeO6RE8T05jz7uWUwWGde7/znQjcoA5/A0VwJbehG24fNFoMrox1N6e8IIWVtnXSlN30EPp9V05uuNAxG+ulQm/o+EeBCqU/N6u8wgBOR7iOoW+1oIUBujrOmdaO9UANZ6/rX/ggBFPCYa2AXOgJVgIAbi23sPz9gD4r+IrOb/eclYFqLMjCAtrfN7W57+9vgDre4x03ucoebCACbshdckGCTaKIHVFbBGdpdEnqYacoTkAS9SUKCNVB5AY+I9b4/goEyPGDKDEhDlgYeklmkW8qQYLeBujoMPvxOEfCeMgxuYKAQUOcAutgCFxQxrty54N5S/05BJvZzhQEVQQg2gMcfoi07H7jCO1JegA0EPp4SmEiltGtAGd7m5DUoxz2N+BAuctePTk55A3JwDxg+tAvdsWBJU0YEv8bjhA8JYHdxmAGVU+AG8YwA5xZCA+9WMLEp65xO12HmhyzOuwbQgehMZoAJSs6cd3xoB8BbxAmovAF6NMffFyJD8KDg8SmHgArMwbqFrCE8JIh9yigou3BMYaJhDE8GBUB7kzMgBbj3JhomgtfwOPA1KgMB6LsJxocCcbwqpIDKk7BDbyDxoQAgDwr1mbIWIK8bH+BdQAlD3h0uL+UJUEI3Pv/QNZQXgyVQOQOYcKVtLvEhFCxSeRQwgv/om/z62/DyQpVongOIMPgp+0H3tGnBwS9UgeeVIPhSLgIWaPMNkUIPCUxAZUpQILKRMReSAdYEPUlQIlP2AJegfa7BexfSTdITfuPHZIQQBq/hAVV1IeVAPQ4ACO0nZYJgCa+BAYpgDZ5wfN/BcdVTAkEjfPsXGzIgDKwQCesxAaZHPWwQgFMGAolQG7dABGvQgZuQPRcQSU22AKqGGx2ABfjQDdrDAUbAgj+2BwxXEg7wCg8XZELgZlkoEm8gHUHGCEcXhiVRAzkAZCCABGiIEm3AgDkUAaT2hifhAVtghR/yAERghyoBAaPQhTUiAcrmhyqxDxtVI1awg4aIEvz/sIYtcgQL14grcQGDYCIhIHGUyBIIwAp6SB0pwAKbCBOpoDMC8gCnMIoxgQYxaB82UIiq+BJ9AInqkQY8F4stcQXb9B0bIEq4KBMfoAY4BwOa+IsyQQovgAJbZ4w0AQcEyIzQGI3SOI3UWI3WeI3YmI3auI3c2I3e+I3gGI7iOI7kWI7meI7omI7quI7s2I7u+I7wGI/yOI/0WI/2eI/4mI/6uI/82I/++I8AGZACOZAEWZAGeZAImZAKuZAM2ZAO+ZAQGZESOZEUWZEWeZEYmZEauZEc2ZEe+ZEgGZIiOZIkWZImeZIomZIquZIs2ZIu+ZIw6T+3FpC+oARvMJC+/+AhFqB2AAkPb7OT/1gF6wGU/CiUAaMH+2iU97EAs5CPSokw9/iUDVJ/9CiVFlIK84gORJIOt6iOQ0CGPbIJ8vSOPACWNeINbQCPZckkrVCM7HgHSkUkTUB87vgEcdkjLyCF7/gEOuVU75gHzNAyWPiOF+A0PWIBLviOI+AMPZKK8ugBKGZM9dgAPHIhVkBz82iAA0IOGoiP73QfMGCC+tgOe/MdEUAD/TgFq7AeA+OPcdCX0/GBAJkExzAdvieQHxAAgnBLA8l3MfmbwBmcwjmcxFmcxnmcyJmcyrmczNmczvmc0Bmd0jmd1Fmd1nmd2Jmd2rmd3Nmd3hkuHxANrv4QDwCJAW+gDONUB/0oH+aAf9OxAKGQjxRwCBqQiOtxDvY4BCIABI5gIRswj1nQCM7wiesBNewYA/GgBlrAJGXAjvAgCARqIVGAmeY4DT82b+qIAz+mDOvoAB2YQyiQgOloAj/2fOr4CT82BuvIBj+2AEGojoiQTGYgBfGpjvLQMngwD4bgjiLQIzswDt8AgeyIDSYCAqxgKPMIAA0SCHsgCxQaj19gHwxQDMZgoPgoDN+hAtIgAte2jyQQAdtgDKgAi/8Iht95pmiapmq6pmzapm76pnAap3I6p3Rap3Z6p3iap3q6p3zap376p4AaqII6qIRaqIZ6qIiaqO4REAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq1YdStPq17AJQ4jjC1YlEP4YeIjNu7ddOe04DVDir7hxf9d8K1+O9oMmY8RwH59eXATz69i3jkAGqpgF6uCNc//KTr680xYlyvhZEL698Trm48sPCuHatAHf3esv3mO+//81DUEJGE3sZ+BxJACo4IIo9UHAMQwcKKFxijBo4YUbOXCDBIFM6KFxXGAo4ogSAfPhicV9QeKKLCZ0CIonDtDijDRSQByMEyZA444sgoGjh6bwKCSG0fw4YQlDJrlgCycYuV8ra/Si5JT/WeHkdBlA0gwXz4RB5Zf+iXBlIeBkcw0FYKb5HwkZoGhBMVIcMoSadCpYyYQRBCGOIhzU6aeCVey3gCfW3NDnn4gCmEiE4JnBijAyJCrpgsUct8AAjfAw6aYLnuMPCsvQkiCnpCo6zKGlpqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFE92xzwNVLxvHrb4Q8ZuGt+7wgzGHbNCyPV6oMt0M1yBsrwOEANeIXm8DK8G7QXyhM3tgqJfEUjwrO4oBqqgqdDm0iKh0UiTW0J+BzLdNLg4TPCh1FN3uweKWGe9rQQoRrGz19wSgGIRY5OtLRcoBlKz2trCw96HTlwAt7Z6QD3hBiPc/50tGnpLWAzIflsL+IlLYFD4tWJY/eE4i1/LguMewhK5tSwEfiApl1d7+Ie/dE7t53gaIvq00cw94Q5xnC6tGydGYrfr0P5wojNo0v6sACeCozu0dJzYyO/OQhCAh07cQryzDWwi4RgnL+9sGJMYGIwD0kN7RYftPVBF9tIisUN4q4gB/rSGvEAdAHecT20301USqfvU4mPcFx3Qb600DxCh/7UceMb/BkjAAhrwgAhMoAIXyMAGOvCBEIygBCdIwQpa8IIYzKAGN8jBDnrwgyAMoQhHSMISmvCEKEyhClfIwha68IUwjKEMZ0jDGtrwhjjMoQ53yMMe+vCHQAyiEP+HSMQiGvGISEyiEpfIxCY68YlQjKIUp0jFKlrxiljMoha3yMUuevGLYAyjGMdIxjKa8YxoTKMa18jGNrrxjXCMo7ZQJUfRZOEAtXBNHUMjBeNEwhrK2yNnIGAG6hyjCqMS5GUU0Z4XEAIOGVMkZbawHzwAwwCSjAwGVHCgDCQyWEBIgChHScpSmnKUsYBbCSREjGIVwEgEgJsaJBQNV8JSbRgYn4Ec8QFb/iiWZFvlgdxhrFf+Um3mkBCSfIkjYGYNAjA40A4Ux0wYOXNqhpCQGo5lzGaSDRbK5OYtvdYKaVKzmii6JtJqICFlIKub1vQaOiQUjneOc2oDONAEein/zmNOjQSq088akgXPdGatSAdiB0HviTScGYgBbVioP5sWhQN5QlkFPZE6bcYLCYkDowzl2TwPhAqQTlRodTgQCJaV0Q9tFGUNoJx+iGlSbyLtBhKiBUtD+rJySGh2ErWp0FZmoA0wq6UeeqnGPqC58Fhupyd9GU4PNIyj8jRkvDPQA1pg1aii7E4GumhXhfqyDqTgQFJoFlInpFSKiUJC31DrVSuWjQMtoG9jjSfPpHEgbzhrrRJq68S4tx8j/HWuFGNDJsxBjoBSpxuH9arNuqCJehCiB9SxQ2TJ6rU8JKMMA0gBIp4F2AMJdmodmANpEZtJv5TWQKdt7V5eu5/Y/8o2L7TVj21ve5fcume3vK2Lb9sD3ODOZbjhKa5x44Jc8Ch3uW9pLnWeC922SHc61K3uWq57nOxqNy3cNY53v3uW8BZnvOQti3n9gd70jmW97XVvWOArX7zQt752uS9+6aLf/cqlv/6FC4AD7JYBE5gtBj6wWhKsYLQwuMFmeTCEySLhCYulwhYGC4Yz7JUNc5grHv6wVkIsYqyQuMRWOTGKqaLiFUulxS6GCoxj7JQZ05gpNr6xUnKsY6TwuMdG+TGQiSLkIQulyEYGCpKT7JMlM5knTn6yTqIsZZxQuco2uTKWaaLlLcuky16GCZjD7JIxk5klZj6zStKsZpSwuf/NJnkznEki5zmLpM52Bgme8+yRPfOZI37+s0YCLWiMELrQFjk0oimi6EVLpNGOhgikI+2QSVOaIZa+tEIyrWmEcLrTBvk0GjuAgFKb+tSoTrWqV83qVrv61bBGQEol6+JDHODWuM61rnfN6177+tfADrawD9AmWq9YAVdKtrKX7dwhI5vZ0I62sVH8bGlb+9qwdTa2t83t6Wq72+DednzxW+1wmxvaoPj2udet7AgAIh89Lje75/2jBXyBnzSWN733jaI66OPG+ua3wCfkhCzke+AIPxEMlnnshDt8Qhn4BPao/fCKG8jekRRxwC3O8eMIAagc3njHR34Eg39Y5CP/7zgMzBfylLucOhEIUYZR/nKLM4ATGW8wzWtucSHMCcI753nFvVADoAv96P4IARR0jvSjR6AKEDhw0Jvu8AfsYeL+nTrVHb4EkNdXBgYIu9jHTvaym/3saE+72tfOdrQTIQLb9oILQA0TTWAW2yo4A91fQo8NbHsCkti7S0iwhm0v4BE5FzxKMFCGB2CbAWmIgeJZMgu4YxsSc5+8ShRx92vD4AaaV4kL/I7tFGQi9CnxgSsYZe0F2CDxqBdJA8rg2Giv4ZOxH0k/ZCrtDcgh9yZhQUWxjYgpAL8kcSBZ6d1wfJKswErYdn3umg+SBtCh9sxmgAmiR32QLKJJ2N4A/z0sNIf8qRAKIdh2CKjAIESkYABlSMbbTIgE5V8bBcwH0Byo0wNC1EMTXUBCMlAArCdtGSAF0ycf8NMeC0AO5pAJbBBCHFAK3AYEeCUfRnAggTBCVXBW2DYJmiUf1WMg0kBCUCAd16YF7GceI4B94JENJXQH9mdtE0AJ5vENEiIKJhQDS7BtGYAJ53QdfWQgKWB+JUQBRlCA0maB2eEJB1IJKeQARAB+1+YHIbgcLeB4BiIAK1QCKGhtRYAFzDEMEgJ6K4QETLBtSmAdygFOBmIB+KZCSTAG2/YAlxCEsEF6+6ELL4SEShhthOAlsXEBElIOMOQAgECF1iYIlhAbSv9zIGYIQyVQINimBWL4Gu6gT7DXQmyQhtgGAonwGl/oHvBBQxfgPK0nc6qBChKCDjbEAUbggk6yB7AhDhLCCzfkAK9gecsmBHGYGk5oIFGgQ2/AScrGCLiHGm3wh+GhATtUAzmQbCAQNLDBDrTEQ21Ah0YSASwHG4V3ccl4Qx6wBbKoVf4TGx/Ae+0hIz4EAaPAix8iAVEXG+HQikG0D7rkIVaQgK+hDBJSdEHED9E4IUcgebyRSwfSCkR0AYMgISGQebwhTAbyVEOEAKxQjsWRAiygHLN0IKZjRKmgPt1zCsqBkAYCA/NoRGhAieBhAykZkRJiDkrUBwM5HWmwiZj/GE5KdAVgZRwbMD++8QGOYE5M9AFqwCgwAJG+gVAGsk1ORAovgALGxxwycyAM10RwwIbLwSYHggd42H0zYQDAgAf7sQVgqRMNAAeEIJLgoUdnqRMkUAXHQB1m8JJvqRO3YA2RYBxpdZdAoQm1cAAm55dAQUeEeZiImZiKuZiM2ZiO+ZiQGZmSOZmUWZmWeZmYmZmauZmc2Zme+ZmgGZqiOZqkWZqmeZqomZqquZqs2Zqu+ZqwGZuyOZu0WZu2eZu4mZu6uZu82Zu++ZvAGZzCOZzEWZzGeZzImZzKuZzM2ZzO+ZzQGZ3S6UPPYJjBSQQPUILD2QFfYBz4IJwy0JPF/wFZv3kHAEAdL/CRvCkGqxAeO0CNulkFWhgegeAyuOkAwWAgkyCItbkC2mggm4CTrXkLTuAhAWCXr9kIJ0IHtQkOJ8KFs0kBznAiP0CbF7CXH5J/shkH+SghC1BLs2kI8HggFoAGtPkLJ1KitEkKKbqRs+mGHjIBLiqb43AiE9CNsIkBPfghKiqbHlApPGqisjkCejghFqAHs3kBBfohCwAPs5kHhOUhqgibT1AEBiWbTzB88TibPGCMH0KLstmlHzIBOECbYiohFnCVYeql+6FTt3mm+jEKuokEVuoe6babTxCl0+GMvZkHhQAexIB1vHkFM+gPukA4vrkCc1kcM//AfcDpAWTgD7Ywf8LZAPPQPtOZqZq6qZzaqZ76qaAaqqI6qqRaqqZ6qqiaqqq6qqzaqq76qrAaq7I6q7Raq7Z6q7iaq7q6q7zaq776q8AarMI6rMQKGRwwDKEonCRAC8uAAv5wDsDJA40wAAFVDLwpA8LACoUEHgyQrLXJATdgDZ6Akf7wPbLJAYogDkEwovoBha55AYcgBd6BIp6UmhRwDdkADn/qJFoZmmHwDFzQDORQbMpmBaHZC2tQTtd2Alz1mRKJbSDqmabQbWAQmgnAbUrAj5uZT9x2CKDZndwGDKDJNtcWCBJwA4LKmYwEbQxwDATQB6RJAsvWBGBACT9/Z5qdByMWMADTcA0IWpqzxqR+UAYl0LCtyQlGWgyggAwXCJtioh8wQAzGoAm/KJvXAB5KMACc0A6/t5seECEgUAmw4Atx8LO6qQmhUKxqu7Zs27Zu+7ZwG7dyO7d0W7d2e7d4m7d6u7d827d++7eAG7iCO7iEW7iGe7iIK5wBAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnzyY5PKGSbJE4YAEGWQLNuvXmNs9oEdhSgJwKf7hz58bhurfvxW002StF7MgE3ciT437zu7lzvm3OpGpWbJXy69hpPd/OvS2EGpQejf+Bgb28+Vfd06sHKyeajSBKzMuXX269/ftSOWCpRwzP/P/zGYHfgAQWNQIyoDgTAYAMzidNgRBGiJMHYkjhyQMNZjgfGRJ26KFL5Vig4YjzCfLhiSiWJAmJLJZXSIowxsiRHC3WmNwOMuaoI0Wt2OgjbhDsKOSQCm3xo48XEKnkkv8Ic6SNdzAp5Y4yLPAkgCFMIoQ7ZaAjwjctTCmmjIJcidwLzBQQTCp6YDFHA2PGOeQlRz6QAzFlsKNIHnL2KaUmLbZiAj7CsAGnn4hO2UAKDD6wQS1VPBNGopTKWYB8AIDzyjMfVOppn6MoZ4EnNoSTxKeo+plFbhYEUYEmnab/KqufBWAihgez5qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXbPPNOOes88489+zzz0CndwEbQRN8wQwq8FB0wEfjpkIWS/vbdG5FPBH1vlPrVvXV+GaNXBF8ck2v18kBkKTY8ZKtnDcjoP2u2tcNgKvb68KNXRqH0n2u3eXJ/6M3ulQcl6ENf58LhYgZAlK4uWggzuACySxebuMZRmCI5ORGY2WDqyCB+bjsaIjLEJ+LG2qGuuRdurflaKjM6uEGo+E0sIMrjYbx1O5tA5tkOMEfunc7wgYZBkJ68NsmYkuG23SA/LZI7JAhHc9vS8ULGYpQvba0VC7K9tnS2WAkMoCPLRgZpmH+tR94kqEx61vbhhYNLsBC/NV2ckKDMISCP7WUyFAlgvQ/acEiQ+8ooLQcUIkGPaAXCowWCSLRoECUL4LP6gT2GLQMDELLHhlygwef5Y4GKUEOI2xWF2bQIF04IIXMcgEKGpRAGC4LHg2ygA5suCxlNOhBPExWC/9y8J8MVAADQVQWKjZYniN0IonM+kF5FmADDkCxWb1TTg6wcEVnmUJ6yAHG3LrYrGjoxgyyIGO0wIGbZvhAjdFagSCGAcc62vGOeMyjHvfIxz768Y+ADKQgB0nIQhrykIhMpCIXychGOvKRkIykJCdJyUpa8pKYzKQmN8nJ1d2ik2N6hj9McA1QSokYuSHD5Uw5JDYkJwhnYOWOfKgcT6BBljHiA4awA4loEBCXHpKdfJggAucBM0IymOF/CHdMCNUDQAyIQzML1AH6/WcX0yyQHhhkgGwSKBcAGoQ3ByRKAMVynPdJB4A2gM77JMFx8tFeO9djDADBQHXz3I4Dlvf/HwHkUz1oAFAEzvZP7ggBQNwoaHfswAAAAU+h22ndf4oB0e1AwAwA0k5FnUMNAKmAAht1TgAABIqQNicGTDQPA1BoUt8AAkCbaOlv1gEgPci0N3cA0A5AetPWSHQ+1Otpa3r0nz4IlTW9ANAkjsqaLwBIcUz1jANA8J8FtMFbQEiAVrfK1a56daux8JksAMQhb12qRQTwmZH+44tvnZVFaeXZVP+DgjCZtUZx3dlY/wMOcL2VRHnV2TwAdAi/4pVnEIjCfw7A07uilWdJ/c/rDPvYnWGCsOH664gCizNGLLaxjoXrzmgkWXFpVkOctdnp5hMO0x5WZ9v4TwTsSlnR/+ZsBLuUzxLGddoMpZZmCgDQInj7WpyZA0CmIG5lcRaI//iBXL1t0G9lFgcA+VO5tr3ZS//DG+wCNmdr+E8TXujdzeasA1gQQDXgmZwAlCu6DJpuzVowjFKwMDnseG9xfdYGX2jAmv5IhH6XWzQXcGEP5oIvgOQb1cYo+D8MbvBiHjyfCEs4MRSWj4UvfJgMm2fDHC6Mh8sD4hAPZsTYKbGJA4Pi66h4xX9psXJeDOO+yDg5NK7xXm6MnBzrOC881o2Pf3yXIOdmyESui5Fxg+Qkz2XJ/miyk+MCZSlP+S1VvrJhsqxlwnC5y4L5MpgBI+Yx+6XMZuYLmtOslzWzGf8vbn6zXeIsZ7rQuc5yuTOe4aLnPbulz35mC6ADrZZBExothj60WRKtaLIwutFieTSkwSLpSXul0pbmCqYzrZVNcxornv60VUItaqqQutRSOTWqoaLqVTul1a5mCqxjrZRZ0xoptr61UXKta6LwutdC+TWwgSLsYfuk2MbmCbKTrZNlMxsnzn62TaItbZpQu9oyuTa2YaLtbbuk295mCbjDrZJxkxsl5j63SdKtbpKwu90ieTe8QSLveXuk3vbmCL7zrZF98xsj/v63RQIucIoQvOASOTjCIaLwhTuk4Q5nCMQjrpCJUxwhFr+4QTKucYJwvOMC+TjIRd5xkmvc5Ar/7QACVs7ylrv85TCPucxnTvOa2xwBddivsQ9xgJ77/OdAD7rQh070ohv96Eg/QAZ0PuzgmunpUDfvs50e9apbncTSpvrVt851Kx9a61wPe9S9Tmiwi/3sTyJ7oM2O9rbXqKRTd7vcfRQBQOSD2Wyfu94f94VYNX3vgCdRHfRh7LwH/vDlcQLUgG14xDs+OTAoAeMfT3n5ZOAT5KV14ytf+QV8AZ+o3jznKy8Egq5a9KOn/BEWf/rUu145MBCDq1H/esdHgAutr73uccMAToB+0rTfPeKFcDxOB1/4h/dCDT59fOQHPgRQML7zkR+BKvyy0c2fPuAfsIfMKzr72gf8/xJMT2gZGOD86E+/+tfP/va7//3wj7/83U+EBVndCy4AeU000YOrq+Cc+icT9EA8VjcBkhCAM0EC4WV1C/AIv4eAKoEBZZBbUMcAaRADEBgTs2B/VQcJ+ZeBL6EI/Wd1MHADIPgSLkCAVZcCmXCCLuEDrtBQVUdFD+iCJNEAZbA5VbcGJGCDLNEPglN1G8BSPpgSLKBYVocIU1CEKhEH97WCIsSEKLECVnB1VARaUjgSDUAHOliBJrACWXgSi7A/VrcB9BCGJgEFIXB1IUAFaFgSSPCEUYcCUfiGIiEDBSCDUZcBUoCFdtgRHFAKWwcEbfOHIVEFjGJ1k2AHhhgSUP9AVVanBW7YiB9xB3IIdRNACZT4ETGwBFeXAZiARJvIERRgBHoYdYQ4ihzhAERAhlXnB4yoihtRApBYdUXARbKoEUjABFenBPKUixiRBGNwdQ9wCaK4HnvABR/oSKV4ilBHCJOiHomQG1qgAb5wVYzkAIDgilEnCKuRHm6gHDNQCsNAW4hUAk1wdVqAi9wxUthhAdUgAFhgTIbEBrxodSAgYPqUjvOxBol0AVkEdQuAe9yBA0+lSBxgBF34JAjWHQIAINKkSA7wChx4JELgd9vhB/9hC470BrdxJIzQg91hCgBiDo9UA0TkIyDgOemxCACiAJDUBsNYIxEge+rhifP/8QCF+EgesAUL6UBEsB4tUJHlsQ2TBAGjQJQMIgHXxx3hACCjUEn7AEYNYgV+uB20NB+qYEn8kJIAcgQYuB4UcAD/wQiYdAGDgCXLqB6HACDqkEkIwAo/mRwpcD/3kZXyAUGalAoplRwPcAr4MZb/gQhNeUlowI/KYQOF2R1t+R9bAEp94JW6gTcDwkb/kUagdAUNpBsbcEH30QLKJB8g4H2c9AFqIIMwsJb24QsA8pi4RAovgAJLSCBkACCYiUtw8Iv40QZzqRyjCYwvsV3z8QXA+RKTACDPUJwt0QcA0grK2RJ0ACD18ZwqQQFUKR9RQp0psU3/sQ7aqRIBKR9Q//WdJiEHzogdLxCW5FkSoAAg7rWeJUEBHzkf1ACfJdE9/2EGi2mfHVEM0smfI/EH0BSLAAoS3AAgQlCgIXEBSokdt6SgH/GQG0maEJoRDUAe/0E7FdoRIgAgFnAqG8oRKigf6RCiHHEGDJKcJqoRafkfubCiGmEADGJTMIoRuwAgWkCPNUoRSHCe2FEPO3oRNgAgKOCZQToRHSAC92gewXCkGAEB0QAJ5fEAfOCkGoEG7qMck2WlGnEGQZAcRMOlHGEItYkbxCCmH3ENJuAPKoqmHvFJbhqncjqndFqndnqneJqnerqnfNqnfvqngBqogjqohFqohnqoiJqoirqoO/8xDIIAhovqA82AG32lqLKAUbkRDYjqAcBwI8lVqFggmboRU4PKATbQm7jxA4LaCUcgHy+ACn+KARWwdPORA+aop7fDIFu6pzrAXvIBD376Dg2CAqqJpw6gCw0yA13Qp3IQHwziDn4ajg1iD366DA3yAk/EpzLQXAwSCSK5p71AgfNRCRR6p8LaILDQpxCwmQyiiXwaChgKICeQrXvKAqh6HVqAjXtaTw3iCRiZp2mQIWDQpzJAQQ1yCX0qCg1qHhq1px16rZO4p9HZIDvAknraAbHVILagj3o6BNzKIBuwk3n6B0EIUzU4p/GgIUC0p9OgIU3Kp3j5n3vaAMiaIVH/uadDgAsakl97igTWUT80qqeGsLDlYQEPqqfJcK/XYbR8KpwMYgEAmKdD6jsRm6fykCEzQH532gABCyBZ66ceMAD/8bV/OgLeIB9kC6gXAADlkbaBmgdFcB1uK6hPELfIMbeDWre6gbeEmgUfybeFygMqALiGygZay6iIm7iKu7iM27iO+7iQG7mSO7mUW7mWe7mYm7mau7mc27me+7mgG7qiO7qkW7qme7qom7qqu7qs27qu+7qwG7uyO7u0W7u2e7u4m7u6u7u827u++7vAmygUggkFkKgfoAkVEASOw3qBmgThYAOe4Kv+cLN9+gHP8ArgwLbmUbx56gNYUAW1/0AO4moeKXCyQdoAbCAM+GACBksimsCleaAI7FAGxJAD48siCBuiDTAHWKAHqRAMBcAMfXklJgKfLfANIoAOZeAOQjAJa4h2C2Ck2plThycM8HkBiOea5AkBiOec8Hmde0eE31kIiHeA61kmgWcB00meZSp3D+AJ6nAr9pmrZxcBzgAKyCCy9mkEYYcHxFAPWHCV/PlTT6cEQWAD0SDCJvoKVwIDY/AIlFAD+2mi+Mkiq1AMzZAKZ6CvaPoGDTIBR0AMpWAPmsDFdGqQ16ECG1AAW0AAtPAMZqynljAIYGAE4rAIyUAFqmBFwdvHfvzHgBzIgjzIhFzIhnzIiJzIihq8yIzcyI78yJAcyZI8yZRcyZZ8yZicydASEAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza96MEcMFOX8MUYMjQgSgHwQqqOYkobUEfKorpPoxSwQVzrhzQw5zR1G0V5jMLRvAJMoEf8iTK1/OvLkJ3dCj+4XARxE8AWrqMDnQvLv378zHSf8fT/6tKRZcSllx8gK8+/fua5WfTx+sqRKkNKxzBL+//+8S1CfggFE5wAYlj1SCx38MNtgcNARGKGFRoXAyQAoOZqhhcgJM6OGHPMWw4Yga/gDiiSjSVAiJLP5XRYowxriSNC3W+J4IMuaoo0g/2Oijd8nsKOSQGT3z45HLoUHkkkxC9MEDSEZ5Q5NUVomQN1EiSYOVXHK5RZZH/tHlmE1mAuZyShQBACRBLGGCNBp84Ro0seHj2h4aaGCCCaGQ6eeQWdT4QA/rFFALNID4UsI1qsTgwJ+QRoqQAyg0iIIXxNBBijA0mPKopKCGutAA7lnAxBqYiGDIFaK26ipDNjD/xwAAQFSQTBwdvKrrrgn94k8G3tRSRS9d8GrssQaNgAMFyDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXbPPNOOes88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VhnrfXWXHft9ddghy322GSXbfbZaKet9tpst+3223B3fEkscQ/cgQbItVM3wB4I/5GcBVPuze8Fgix3ABKC6ytHDs1FkkTi96ICg3fHfAA5vWfw910Al8tLiwXvVdD5u7H4F83o7Erw3wSioJ7uB34wqEUbrqObBC4M6tJA7ee6sOB/X/B+LhYRMJiJ8ObqwWAEnSBfrjgMBkKC8+QqwyAZEFAvLgXFMCi69uFeYcZ/C8gCfrg6YOhfCKye/200DA7yqfvdlsEgAfR768AY5N+WP7ckiMR/zDC9/20LFcXzzzIMyC03MIgdDNyWGv6DAlVEMFsfmMF/PJGrC14rDpXyjzg8iC1f/CcDOiDhtZrxnyMwS4XUaoET/mMDGFbrDwmEzwK2ZMNpjeI/jHhhD/+jxT//QGiI0UrE7+DzAFQgMVoK+I83OvhEZ1nPP+io4rNWoAX/TMCC83FAGn6hRZic4T9joA8gkJMGS5TRJbX4j97IkwjN+QMFpKDiG1Hig/H1JwQrIA8QmOON1u0xJWf0DzDGA4XuLEACYTgkSibYnwWkEDoNmKF3zKAkSZZEBiHwzzGi04j37CIRniRJMv7jBt2YIoTucUQ2spfKkLjCPyAYQW6uCB8YBLKWIMGGEvzDCdzQ4D+0AKZIftifDNyBM7nwjzaUKZIOYKk/QtgMJfzzgmdSMyQ4YIB/SpCZD3SxP0f8Zkji2J8Z6JEyxvCPFoqlzpAMYQf+kcRlkmD/x/eQsZ4iWcT6WmAZI/hnEAAdiQM24B98VOYJoGMiDxI6Ek34BwW0mwyN+jMPipIkAP4xwmR04J9VxMCjI5nDCfoTBXpChgz+OQdKSSKF96CgHLqMjJH6g4vdzVQkPgDBdyxAh8dNJgj+icdPSVKF7jBgHHOojCz8k4ulkqQDAGCOCdhwGU/4RxNWJUkUkxMEHlpGDP4pQFhLcgx/eIMamkEqfBjQh7WSBAdK1cwN/JMOu1JpG/15wBP8yqRj9qcZhGWSFfpjAT4klkh98M8WHkskcDDWsZTdER+gBJ/JZnZHqmOiGz+bIxnA0j0aIK2O6tEfBiBOtTHCQBH6AwTY/8qoHf4xpG1TVDj4THO3KTIsfOAKXBTx0j1eKC6KkhDRGyn3RNCDTwh8+twJOeCc78FfdT10iP5E4ALb9VAa+pPa8ErIEuKEjxPNGyF89KcY7I0QBPz4Hl/El0DU6A8ehHhf+gwSPmXor4Bk0B74DFbA9CFCf36L4Pl4FT56aPB8XNCfHfBXwtGxRn/ogOHytKI/YuqwdITrHnKIeDx06I9MTwwdB4TyPQ9oH72AkIAa2/jGOM6xjelWtanCJ5v2KsCItEu1L8EnmUEectUcINT3nICgSd4QkaV2iyjABwz4ErKUr0YDWNgCPJ2MsoambDVRSCGrzDnAheel5TF3jf8H1tBgcpSRrzZniMxbiwMBJuGPQ9RZyWJTxZrZDGgWW8bODsKzoSOD6AYpetGPafT9IF0ZSf/n0ZRmjKX9g+lMK2bT/em0pxEDaviIetSGKXV2UQ0ZVbvn1KwejKvBA+tYB2bW36m1rf+Ca+/oetd96XV3fg3svQi7OcQudl6OzZxkK/suzF6Os59dl2grZ9rUnou1k4PtbMdl28jptrffAm5/iHvcbSn3udG9FnWzWzDufjdg4i1vv9C73ny5N771ou9946Xf/rYLwANOl4ETXC4GPzhcEq5wtzC84Wx5OMTVIvGJo6XiFjcLxjNOlo1zXCwe/zhYQi5yr5C85Fz/OTnKtaLylWOl5S63CsxjTpWZ01wqNr85VHKuc6fwvOdM+TnQlSL0oSOl6EY3CtKTTpSlM10oTn86UKIudZ9Qveo8uTrWdaL1reOk6163CdjDTpOxk10mZj87TNKudpewve0seTvcVSL3uaOk7nY3Cd7zTpK9810kfv87SAIveI8QvvAcOTziNaL4xWOk8Y63COQjT5HJU14ilr88RDKveYdwvvMM+TzoFSL60SOk9KY3COpTT5DVs14grn997Fk/+9TX3vS3H33uQb/7zvde87+/fPApP/zIF9/xx1988ovbAQQ4//nQj770p0/96lv/+tjPPgLqUGipH+IA4A+///jHT/7ym//86E+/+td/gAx0/+ljPZP852/urcef/vhH0rohfv/8+79G+9dw/fd/BLhlWDeABZiAk3aACtiADgIK9ueAEugfEQAI+VB1CDiBGsgcC/AFlgN/GxiC4FEH+gCCIniCzeEEWcB0GYiCIggD5GR0LeiCIZgBnzA/OjeDNLiBHUhdN6eDO7iBQgBeORiERogcR7CCP3iERwgDYrCETGiEEcAFNAeEUTiBDMAJPihyVniFEygEQ7ByXeiFEugFNYByY0iGDhgCUFByaaiGDRgBVUBLGfeGcKiAD7AHOMh/dxiFS0CEEycDBjCIhFiIhniIiJiIiriIjNiIjv+oiESQQ1HiBS7wejOhCT1wJipwBpYoE/TAUGAyAfrUiTBBAmtwJgvwCFtIiiqBAWXAWVHCAGlwUqzoErMgiUgCCZVYiy2hCJkIJjAQOLy4Ei4AilmSAsczjCvhA66QXlGyADawispIEg1QBgtwJmtQQNOIEv1wHGCyAXKwjSnBAlYGJogwBeKIEnEgZ8fYSuloEiuwWGACjYP2jh7RAHRwjVnCACbwS/Y4EouwUt9ID/9IElDwYlkSAv5TkCGBBOwYJSjgjgwJEjJQAM6IJBkgBfU4kRjBAaUgf0CQUxzpEVWgPlkyCXYwkh8BBU2WJVqwkCq5EXfwkEgyAZQQkx3/EQNLcCYZgAkYgJMbQQFGcJFIEpJAqREOQAQCmSV+kJJHmREl0JJRUgRY8JQZgQRMcCZKgCNWeRFJUERZ8gCX8JNdWRFCSZRHQgiRVJYU4QCAsJRRIgijxZYTUQJNcCZaUJV0ORFskJVgAgKotJcScQGbkCULQIWCOREcYAT6+CN7kJgV4QCvgIssIgQfCJkU8QYqYCOMoI2YSRE1wDgsAgKv9ZkW0QZgqSER8ISmiREesAWN2SAPQAStqREQMAqU2R8SQIe1iRH7gE8MYgUb2ZsTwQ+i2R9HQIsTQgFgZFsXMAh/tIvc5Q+TQABxYFsIwAqx2R0pwAInclwzYA0T/6VaqVBg3fEAp3AiFMAdzAEAUqBblIUGd9kdNsCbE4IG4GELsGBWidUHx6kcaSCNEQIG8BEFt0BZV1AJy7EBMoAiLQCX3wECe+hXH6AG6QUD0gkitNAfnvVZpPACKICOKeI38GE+qkUaMHIFsAgeITChxJkR57BhL/oR5NAf/DmjGfEH/dEKONoRKQYf1tCjQQmc75GhQmoRygMfnnCkGqEN/UGbTHoRT9AfL9CgUWoR9gMftXWlZrmZw8WlFWFC8GEG9gmmD9E98OFQZioRqNBac7mmD4E38JEGcBoRF5Cb3eFndfoQBNAfWuCie3oQDYCQ7jFCgdoQIsBYRnWoC//hBf1BZ4y6EPllo5G6EE4KH4JQqQohCv4xR5p6EP/1HkVAlp9aEEiAlt5RD6V6EHJqU565qv9gCSsKHgECqwRhZDCGWbb6D3zQXO4BDrs6ELj6HnUVrL3aH1YQrALRqu9xo6v6BLP6HdugrP+QDv4hjJgRDziwaH2Aqt0RBJpBDVgySobWa6xpGTQgV8ihACxmUf2xpJbBBibQnu/UYNHUHyY6GXMwDt76Ih0WD/4BrpPRBnTgq8wBAj6AYQ2AO/3xDJIxAuVwWt4hBRgWo/1BBpLRBeXoZFGFYDGwCv5xSZFhUP3BOQg2D/4hDZTRBhILHmDVXzwQrd5hAQc2Ge7/1R8bAKjPBZ39IVKV0QKE6h6LcF++0h+OsKiUIQn+sQNhaF5dgF3vYQyY0QE0CR7yYV7QIE+XaRkl4B8MsK3b5QLm+R43qRkkCh9TtF2XCh9VtRl34H79MQrVtaH+4ayXwQn+oQTYoFwrMDmPmhsjIJXu4QrKBQHZ0E/fgQKmoBsO5B9BolyJsAvv0QjR0VZ/ZKXKhQb0lYICmhk6sJ3goQbbFQYSALrI0YbSAQz/wYnbJQrXpBxbKh0rELTgYQYJu10dQAqw5AiBOR645R9XG16WMF7+AAj0kZrvwbrm9QtpoLO5oQreCB9a4I+2ig7/Aam7ak3/wa7Bigoy6x14/9C7tpq1/pFGwUoBjPAfchusNGC63hEBIbarseIfTgBltkoBR/AfiBWsOgC3/WFfwRpd/YEC15m9D9ZOW7uqqtCyoaus7MAgEmmry/AfEbBetkoCm/sekfCqpUoF7usdY+C8jNqn/xFgu+oAPGs6wXoFtAseKSCysCoLH9wdZiBjsFoBDFIMw3moEABT1xusJBAIDGKottoJePodEbarZkLBemmrX8AgeGCkn9oAusAguIC0pdoGUAsffpDAnyoK0Qsftbqr8NMfPKasOFwqSEat/wBS3+EIysvGH2C5zQEDFszGApEEAsQcORCOeGyq7JkcggCIf0wQN9BcQuABhf+MEL+rAfW6yAMRC5cAyZRcyZZ8yZicyZq8yZzcyZ78yaAcyqI8yqRcyqZ8yqicyqq8yqzcyq78yrAcy7I8y7Rcy7Z8y7icy7q8y7zcy778y8AczMI8zMRczMZ8zMiczMq8zMzczM78zNAczdI8zdRczdZ8zdiczdrcdhSAAyJJyV3QC1VQC97gfv+Exx0QB8lQAcsAAGhZQ7t6BYYgApiwBkxgsM0xAJHqAKZAA8JACnRADF7AwO6BAiJsmg4QA6pwDSXgC4AADbVQAILQA9/rIEo4kqGwJ3myB65RDrEBDa7xBRogDSawBEEACQBQBMNEf8k4kjoahR3KkSRmhN7TEJN7FYUP4MX/iJ9X6LAjuUpXaCIjmahXqLIj2VRXWAgq2SNeqJwMKQBRmAIDwAl9wpHk64J4UAmwQAlscNDiGFoa6AjroAGkUAKL25XsVIAv4ARWUApcwAJnLZjjQH8HwAR1oAYCAA+KwAdlCpnz2iIp0ANMMADLYA6Y8ArRoAh3sJZHSgUiMAs/kAp14hoSwAmxIQ4/AAilAQfUYAh/IAcXQKrbPNqkXdqmfdqondqqvdqs3dqu/dqwHduyPdu0Xdu2fdu4ndu6vdu83du+XRgBAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza96MkUISFzpuvAknosqPHwIqVOAkoXVrWKorEPjBRUQ3OFBosLG0AgLn38ATt7ijSM8PTOYI6WKG6IS/59CjS59OvXqCVuvqpNvz7tQwA6Y6BP8fT54tNk0iCNSq4wRF9ffw48t/v6CHJ0ISfsDh5aO8//9XYWEFEy/MZ+CBCCboTxOCKCOAHqh8AOCEFB4li4IYZqghdchU6OGHPvGx4YgkIigHiCimaJNzJbboYnQROKDijDS2NMOLOLboRY089ljSGjkGuSEQPhZpJEdSCKmkguUc6eSTE2Wy5JQGdgPllVgqpAmVXMKnQ5ZghvnPFV2WOV0XYqZ5pRJmtmmLmnA6CUmbZtYR550+BjCiI2YwMkkQaSyjgQbAtBZbbNC4No8GAZiwSTUbRIJHgSVKgOelNFoD3wNRCJKGOdAA0g01otghg28fURAKG1SgMUsjpaT/ow0TCRhYBaa4oijCcynM4Moe5/yCwxWo2tRFHFCIUIEGA5ixgHQ35CpthUlQEUpSGNxxCClbbNPGtOCGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXbPPNOOes88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VhnrfXWXHft9ddghy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744ow37vjjkEcu+eSUV2755ZhnrvnmnHfu+efrdtEL6BQHYAERpEd8DnS1NJC6SxhIK8uz0B1zxesr4dDKNbjyocJ0PeCAO0r2FGgLCZc2kEt1L4gwPEkcqBEdGcXCuUd8dIj3/Ed8rDOdAHcmM982Q2zfkSy/T8fAGXDewuZ8gfxhvkax0E4dDLeLScEGCE6gx/wWacEy5KMNGYUpGApKBQApcgcmGAh8YLqHggKwwInAwREHWoAispSHHSToCC2oYEQa0IoEaUEGV4LAABKUgCeIUCI6iECCKAilRijoHi+ciBsUxI4nocICCbJBDv8p0owEocCFRvIAMxKkC+0NMSIc4B+CPGFAHxkhQSBIxBMZ6B4ETaNIUFAQ+7ZIEVokKAPy45EPzJAgUJDRItz4IAV4pIEEeSJ2b6RIF5aIICHSaBgJOoAd8miRPlDKQAvgnYpW0IMEtYOQFxmFHFUURwRJA5IYqUOCoJGiCyHIFivA5EVCgQcEPUAUIPJAJBC0AE2IEiPiQ5A3nEghTgTxlRmRR4IUWCFUPABBjOAALjGygiL0b5ATcoD3DvSATgwzI2dIkJ0m9IoENemZGalFgqz0nzxg8EAbwCM2L7JGBCGiP/4BgimdOU5oJogO/gkjgtzYTo3UkZlfGg8G+Gj/IAAIs54ZWUEIEHQM8sQiQRsEqEbikSDnAccU7zMQNxTKESsgKATo5Iw7EAQC5FFUI3yI6HzK8BsDJIgWH+WIJA9kARdwphgIqkRKOdIBciCoAJvpBoIsEIeZcuQZCYJCZj6gBQRJwacdkd6BvFA9ytjwQFpAE1I3MgQPHigTlxlCrQ70i6l2JBsIikIIKyMBBA3Cqx3pwI0OBMHJqAKIiOQFWjsyBQQp4QKUkQaCzDFXjwzwQHuYDC8YcKAE4LWvHLHDIeVjgTlIxhUIOgdiPVIGBLkjMjRAUCRcN1mOrKCUBmJADSCzDQQ9srNfRRAYHnMDBPkBtR7pAAAQlE/G/wQBQdGCbUdiaSATNKa1BxKCbj+yTAPVNjG3PdBxh6sRT/Z2McA1EA2Z25FN0FYxY2BmT6nbERyoNjHXQJAGuPsRExxItIgBkoEegETyckQHCALHYWpAWAON170e2QUzLWEYZTCzvfjdCH0PFIzC5AGu87lvgDuiXwNNoHyDscF/F+wR+B4IH4PxwQEOJF8Ke8SiBsKDBwSTCgSxwcMeyeyBbgWYDrDxuSj2SCUO5ITAMPRANIixR+RpoGEAphoHGoCOP+KNA8nULxY2UIeG3JFoIIgHfrnnfJjB5Nji4kBb6MsFZGigWVTZI9U0EApGwBd0HAgGc/wyR1qw1fkAYv8vECihgTCs5o484kAA2As1WHqtOnPEEr80kFDzYl4DddjPHNGTgYiElwYw4kAGQHRHtmQgCyRBLzeQxmKpIwhJe8QLB0IHX2LwAwdWx6Ge3sgiDlSIvxhCGSyCzg5GnOqNdGHDjCVEKP+ygk+s1R+WqjVHEAgfJpzj0oR5RjNQsF1ha4QH1VGCGkaXGFo7eyMwjU4xMhGGa3toV/4AASyQ4O1ULkMY4iy3utfN7na7GzBASIC8503vett73rF4N2QKQCIC6Psx/B6Rv//dmIBvaOAEX4zBNYTwhCdm4RlquMMPA3EMSXziham4gi6O8cFoPEEc73hgPo6gkIv8LyT/P5DJT96XlBto5Szfi8vnA/OY52Xm8qm5ze+C8/jofOd16Tl8fg70uQj9PUQvelyOXp2kK/0tTKeO05/elqhPZ+pUX4vVpYP1rKdl69HputfPAnboiH3sZSn7c86O9rGo3R9sb3tY3h53uX+F7na3C97zTpe9810ufv87XAIveLcQvvBsOTzi1aL4xaOl8Y43C+QjT5bJU14slr88WDKvea9wvvNc+TzotSL60WOl9Ka3CupTT5XVs14qrn89VGIve6fQvvZMuT3ulaL73SOl9743CvCDT5ThE18oxj8+UJKvfJ8wv/k8eT70dSL96eOk+ta3CfazT5Ptc18m3v8+/0zCL36XkL/8LDk/+lWi/vWjpP3uNwn840+S+dNfJPa/P0jyr3+P8L//HPF/AKgRAjiAGFGABmgRCJiAFLGADCgRDviAEBGBEugQFFiBDHGBGKgQGriBCNGBHmgQIBiCBDGCJCgQJniCKUiCKxiCLeiBL7iBMYiBM1iBNSiBN/iAOciAO5iAPWiAPziAQQiAQ9h/Rah/R3h/SUh/Sxh/Teh+T7h+UYh+U1h+VSh+V0heHYAAXNiFXviFYBiGYjiGZFiGZniGCKBJAhd8h3AAbviGcBiHcjiHdFiHdniHeJiHB5AB/RZ8CkAngCgkdWd3fxiIhugigyh3hXiIjHhwfv/YiJAYcY8YiZSocpNYiZgIH/S0e4uYiZ4oHREACPnAiZ9YitKxAF8gIbXXiaZoinWgD6vYirL4HE6QBbLHirP4iTBQAq+Hi7noiRnwCVUEer74i5mIipxFjMaYi0JwWJ1XjMuYiUdgi88YjbkIA2JQjdY4ixHABZoHjduIiQzACcm4eOAYjpgoBBBmjuj4i14wWuzYjrkYAoNWeOcoj5UYAVXQVISIj7/4AHswjP3oj7+4BM5odzJgAAq5kAzZkA75kBAZkRI5kRRZkRFJBFw2JV7gUifIEprQSFSiAmPUkSpBD1I0JRMgCSS5EiSgXlOyAI9QjitZEhhQBoG2JAz/kAYxMJMpMQsZuSSQwJE8aRKKAJJTAgO5NZQl4QInuSQpgFVKWRI+4Ar1tSQLYAMyGZUf0QBlYD9LsgYepZUi0Q8TwCUbcCJiKRIsEAVcgghTkJYiEQe/5pRuAJchsQIg9pI2kGZ22RENQAdeKSQMYAK71pcdsQixtiQbQA+GuWMDRSUhQAWN2RFIMJdKggJ1OZkbIQMFUJVKkgFSwJeaeREcUApdAgRkNpoZUQUpwCWTgEyqeRFQAAJcogWSGZsXcQeWKSQTQAm4eRExsARckgGYkG6/GREUYASeqSSoeZwU4QBEkJhK4gew6ZwRUQK0SSVFgAXWORFIYGpTogSo/9adD5EE2UUlD3AJxkmeC5GcyykkhNBt7OkQDgAI0ikkgsBf8+kQJdAEtcmd+9kQbACeS5JFAdoQF2BdVumNB9oQHGAEgfkigdWg9PkKP+kiQqCKFOoQb5A+LsIIYbmhDlEDOeAiIEBuIhoRbXCeIxIB2ZiiEuEBWxChpoQ6MDoREDAKF4ogEsCPN/oQ+2BVCWIFovmjEsEPJYogR7CTRmoRFzAIBxICQtmkFYEArECj0pECLEClGpEKmyYdD3AKXLoRaOCf1WEDPjqmFNEHSSodaZCVamoRVzBj0bEBKBSnHPEBalBfMDCleLoRpPACKPCWf/oRcDCehZqoirqozP+FAcKwDNbGqBWBBLCQnYgqqQ8RBpmQbdBRDFkXqYbRC2ogUtEBZUoXByjQDM9QGElwDgRKHQWmdGX1HDPwCYXZFzJACAgGHwcgVTvnAUL6HCegDIbwF4VwIItQdOBGHUzwA0yqF2ZmIDsCdIIQHy8gDUl5F0mwq/HhSjZnUgbCCHAqF+okXTsHDgfiW3nBY/LxAPp5cqHArfBBDXsxWwbyCDGHDwfSCmk6F4BQWGPVcRQAA6HGFyPQRfPxCic3CwcSAQeZF1twILhASw7HT/KhYHsBbQcSDR2HDNflF3Q6H97QcStkINUAGIB0IPVIcCpmIPEQGE5gZBNXaPNhBhT/yxdVgCA5RnBsgCC8BBgeAFrzYQUJh64GcgAZBRj6qlz/9gQ3KR9+JBhDUJYGsgv/JmWMlQeFQWzzgV7u5rQHogyGAWgHYrXuhrXx4bWFYbTG1W5gayBrgBgDBmPrhrbxoUiHAQYIIjzqFgdPGx9joBhJNh+bsG6KZiDZehg0Ox+yUG6DKx9BwBiPGx/rUG5CgFuNsbjykQzXVlcHErmNMbnwAQA3i2h+gLmOobcHkg3C1g4IArqOMbfzgQe36mcNsEo4FhkbdSAk5WmrcyDEIBlzIK/v8QLVqWYX0GbywQByJRnXcyDLIGnmYEmUcQGkGh+Eqma8gKXUYQGqUBkC/4AgM1C6MQalBxJslNECbLm6avYLCJIA60gZUnIgOxC/MdYFRXUgjYAZEABqB6IGVZYkUKWhlsGu87GqOhYHxPse3JQZR0cO5OteITsfnroZLrDA1TEKMWZGCBJpnFFZB6IEfOBhJJCdBnJZv+EDj2kgREthlWQgSmAKwbGsLrtgipAg+TYex3BRtctcHGCvBsIM67kZOvC38YGx1AUKQeUfdJAgI8lcnWDE8MFo5eEDiIAgZpC0sIUBTSkfjqC1/6FTCFIL1FUOCaKwE6KGB/LEnRXFCLIOAlkedkC1BlIEPTxXHPBozIQKHlJiCCIPsCVhCMIJH9IBRYYgnDtZmv/AvdQRCaA6IaIgxe+BB302VytgCwnSuCgCDdKEWHo1xipCAUeQIBqMVq6LID1wxxVyDYw8HS/QB15lB7h2ID5GI4J8IMzgqymFAZ6QIEicIqKcIADsU0qMxVqsIn/AhwiCUikVTQnyoj0yDUZ0Bx+VCCZsIEZgJA7QywiyAf9UTx2gCwnCDI9cI0+AsAbSDAp1y5XGx07CDgqSmeMkQQmyv1ByuAYSAcv1Sk+gvPMxAP3KIzKQv/s6rnnUAqOMIDsAxleiCK0cHY4AB9iEzwaCQ2ASvvPBBNT8TH6MILEKJg6gDfKxDAE7THpAx/OxAUWKJVdAsNWxADncTn8QCDD/fAtwcgbv6Q8qoMkANQSltbl3gtHRsQ4j/FEd0MTwMaFxAgFkEB1q8M0pJQJf+hy5YNBgQgKY/AL2gFY4YJTQoQJFfSnX0Ap8i1ZXsMPQsQA8jSlDjFQNoE3P8bOYWhFEYAHTNdcW0Qu6jNd83dd+/deAHdiCPdiEXdiGfdiIndiKvdiM3diO/diQHdmSPdmUXdmWfdmYndmavdmc3dme/dmgHdqiPdqkXdqmfdqondqqvdqs3dqu/dqwHduyPdu0Xdu2fdu4ndu6vdu83du+/dvAHdzCPdzEXdzGfdzIndzKvdzM3dzO/dzQjTJtMAhbQAqHcAdtHRShQAXIdoLR//UcC2AGA6ABFSACUBAHez0TEHAFOPAL57AHrjADVHupG5iz83EATKAN6VAKjTALaEAFbBAKK60RECADdiAK1NANgAAN5pAG6xAFkvwc1kCSs0oiL4AHkbAB1bAJJhAAGjAPrgENh1IB+NAawDAoy5AGQTAJjGAG36Qhdx2CakyQ0AEJJInJNB4dStCRXZDj05E/ISi6NO6tISjGPg4dUBmCZnzk0HFUJFiuTO4PcUuC/hvlM0CCDrCjOX4CJCgHUR4dYY2BHvvlz7HWFfgBqKAHAqAMgmCm/vgCTGAFALqSPsALcPADErAMntADD82IKOAEdVALBCACmoANk9kBpn1gAMNwCu+wB+lQB+vQCv4cJCeACMygC4RgDpjwA3qgCHdQ0gcKAStgCWxAA1AAB90gAlzwAwQQG7DgGq+hGgJwGlUgAuHwBjegAy6QBAMe3b7+68Ae7MI+7MRe7MZ+7Mie7Mq+7Mze7M7+7NAe7dI+7dRe7dZ+7die7YEREAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza96MsUGbOzpuvAknosqPcxUq4JPAujVraxUI/PhhTwQcKFj+2LnQgbPv35H7MIkywZ/x48iTK1/OXIktSIOAfCFg714vORSAa9/ONw7z7+DDi//3F2LdmmD1fomSwb29+7VJxsufT9/fqkkBLsHr5OO9//9bOVDfgASKV4Q2dEiCQwsANuhgU6sUKOGEyzFQyC4VDHPFgxx2+FMhFIYoInI9ECNACTF4qOKKMeUy4oswAtCMJDVAwOKNOI4kBIw8wphAGqng0FuORBZZkTw9JgkjCmQ0YoADRkYpZUJ7KGkljDsAcYolU3YpJQFXhhnjK16WiSMRYqYpojhmtqmiHmrGKSEqbtb5IBRy5klfCHb2CaAoyDlixhF+BJHGMhpo0Fo5qTWqGmtfJLqMEANskEMPKOhJoAZ+duoeB6LIQYKNH2GQxB29fEMJOjYoUwc5MGj/qlw0ntZqa0IU3DIFJe+wUkkkD8S5AHu3FmvsQRioAkU2wWijhZW6HCvttAeFcY0IpWgDwotsUuvttwOFckYjQJgxIZ3gppvuBSVMU0ATe6or77xxuFELE+K5M+++816QjBFHMNcOvwT3m8wWuBy3QIoFNyyvKkSsQYbDFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXbPPNOOes88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VhnrfXWXHft9ddghy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744ow37vjjkEcuOYdsXDA52jjcN8LlZeNwgHG5bM552J4jN4AHo39denKDoJ761qsrl0YDr2fNQ4TfEUN77VXzoIJ40kDJu9RPhCAfOMIP7/QcRdA3j/JOJwFifV9Av/QIGxA4wRPWI+1BNdqz0P3RDRRAYArij2+0BgQegIP6RkPT/vvwE72I9lPUTzQaCww4Qfr6CxoOilMfCxwigEKbQ6zq8wA0IDBoPgjYgCjxQKA5gAwEAkQFgQYMAuFjgz/LBoGCAUKfTSFY9QlACXs2B3jVZwC7W2HOuuCFATFCdDLMGRAGVARs5FBn7xiQI/948cOciaF/9FlACYqIM2z8rj5cYOLNGuCJAdFBijczwoCWkDwsygxO9WFCf7w4s1sooT6ruAUZZ0aBSdRnAdRY48yCMaBUyFFm4RiQPO4YM2zgbj5ecB0fWwaBbdTnANwbpMvqMSA4KNJlqLBAfaTwyJZ5gBkv7GIlUaZF+oAgEZtcmSwG9IZQqswH5qIPJU3ZkxjYgAM3qkV9joEBVvJkGD3whw1YNIxDzsGWOvGBLI3zgE6oaAW5pI8vgJmTKdgiOUfIToe4UR9pMPMmHqADc6DRoSnUxxYruGZNaJCD7zxAFA/6QDnnswBNiHMmFAAFEr/jjSEBCBT12eU7Y6L/AwmKx44AQgUK5cMMWO7zJdnIwHwm8Ev/OMAP9CnmQWFyhvpMzD9cqA83JwqTYc6nG+9pw+fmswFpctQlqKQPDHC4HXBEFJ0npWh9rsgdFtSnDDGVCTXn84A+bAcDTqBPIQSZU5eswHjziZZ2zlEfABb1JfGoDzuAI1L6qOGpM0mDJ1mqmZ3KBwTEwipM+JCp+ehzM6JgAH1EINaZ/IA+FkikZopBnwG0dSYdIAd9TLCZaNAnAzW460x6UR8xZKYBCZsPKARLk2bQZwaanAxT51OELjB2Jkn443gycRkZ7IA+A7vsTDI6nx58wDKwoE81REsTB9RwPtOozBwkKR8G/6CLtTKx6XwOMATKsG8+rMBtTUxAH5pGpgbzFM8BkiBcmqjiBfOxAJciQwj6vKO5NcHnfDgFGUDNRwunxe5MRoAHnroAMhicDwXFS5NX0AcMj9EEfSBBKvbKpAGtmA8DiNiY9MpHFvatiV/nw1fG0IA+lQiwTdZBHx0wxr/joZ+CZ+LN+exiMQcm8IRtYsjaBjYxEA4PA9iw4XG+VzEsCIJ8lFFimyxBv0jA8IvB8wC5tlgmOqAPdxejAyCodTk7vvFM1jCfDPDBMTUYx0CJaWMh85M+nICMHLZAW3+kw8k2Ia58UECCyIRCAihgwIexPBPvyqdbkRkCSMlckxCDB/8E4WVzrTIsH3vI+VaDmA8T7myrN9Anjnz21GvHs4RAe8oX9LmDof3UgWfKp3qL7tNbtzzGSLspDI6YTzYsbScJzOcInK6THH48HkWE2k1aHs+VT22mCo/HAsxldZn8+U9Zl0mE8nGCrb3kg7KOBwu77pI55nPVYEvpD/NRAoOMHaUqyscNzI7SLOYThGgbKQwpqK0PrU2k347nutzOkSHmw4hwEwkA83GwuW9kjPk8YpBASIC8503vett73rHImCXmY4ZBmo9CBNDYAOZDAz7+e0IBz5gk5mPcNR5cQgnH2AqgO54o1JeMDy9QxDG2i/kY4o4ZJ9DGLwbG8ZBQjiH/H9DILdYFX4en3ygP0cotBob5wBTjMueYMOZTjpgDnGMfcDl4vOBzhHcsAPORg8NzzrF2zGcUS/85x0ZQ5fAMIupG71gd5GOBMOBc6hxDk3wc6cWU12fmFzPFfMzx9ax3zI3j0ULbIf6xcsyHv1I0O33QfjHCyocUZWd6xxzgQvEUIPBg71g6thzDIup9Pny/GC08jsXHyyfyFrvCfCpQecF7bAbyWW3ePd8xT39nAX54BDK4mkPLjwfzFkOGchiwAQnAIayId7vHwoBCL9i+y/4mfcdSkQzLbdL14oH9un2D/PAof/mbaT54ng/9zEj/O9Sv/mWuz5zsa78y3F+O//e/P5nwK2f85I+M+ZOD/vQ/Zv3Iab/7GwP/48h//oupv3Huj//E6N8f/Nd/h/F/ASiAhUGABsgZCJiAmrGADIgZDviAlhGBEkgZFFiBknGBGAgZGriBjtGBHsgYIBiCijGCJIgYJniChpGCKkgYLNiCgvGCMAgYMjiDflGDNsgXOJiDerGDPIgXPviDdhGEQkgXRFiEcnGESAgXSriEbtGETsgWUBiFajGFVIgWVniFZpGFWkgWXNiFYvGFYAgWYjiGXlGGZsgVaJiGWrGGbIgVbviGVhGHckgVdFiHUnGHeAgVeriHTtGHfsgUgBiISjGIhIgUhniIRpGIikgUjP/YiELxiJAIFJI4iT5RiZbIE5iYiTqxiZyIE574iTYRiqJIE6RYijJxiqgIE6q4ii7Riq7IErAYiyoxi7SIErZ4iyaRi7pIErzYiyLxi8AIEsI4jB5RjMbIEciYjBqxjMyIEc74jBYRje7XAQhwjdiYjdq4jdzYjd74jeAYjuKIAFuXeLd4CAeQjuq4juzYju74jvAYj/I4j/R4AApljrSoALKyjzBSgHioj/wYkPgYiwApkAapcsNYkAe5kK+XkAz5kMnnkBA5kcuxWMCokBSZkREACPnQixiZkRS5AF8QZwQJkiZ5HHWgD7f4kSc5kU6QBfnYki0JA0vkiiwpkxD/mQGfEFmZeJM4+ZAi2Xic6JM/+ZBCYHyfSJRFyZBHAJNJuZQyCQOGNZRQKZMREEU9WZUyyQCcIJSHqJRayZBC0FuQCJZhuZBeMGZfeZY4GQJQ0IhmyZYHGQFVcHF7GJdyaZAPsAc8+YZ4mZcGuQRIiYcyYACGeZiImZiKuZiM2ZiO+ZiQGZmNSQQRkCZecF7SmBSakExhogJnkJlJQQ/ZIyYTIAmgiRQkQGRisgCP4JWnCRQYUAZLpiQMkAYM85pEMQuVKSaQgJm4ORSKwJlXAgM38JtE4QKjGSYpwFnGKRQ+4AqkZiULYAOu2Zw60QBlkFxWsgbAZ50/0Q8EFCYb/6B03vkTLBAFaYII+VOePhEHoCcmKQBt7NkTK2AFaTKdJjWfOdEAdKCdScIAJhBO+rkTi3ACabIB9DCgOwEFSBUmIUAFCqoTSPCeYYIC8hmhNyEDBRCdSpIBUpCfGDoTHFAKagIErBeiMVEF2SYmk2AHKGoTULAtYqIFEPqiNHEHFHolE7BeNioTMTBjYZIBmFBLa+MvAEU2FGAEHKokJno2JAAHEvBaD+B1ZeMARGCgYuIHLho2MgClG7CkyIA2JSCjYVIEwMY1I4AMj+AH/okcEpA2SIAvYqIEbLU14DMeM6A2STAGafIAl0CkWFMB87EhaZOkS5okhEClVzNu8v9BC2vjAICApWEiCNNlNQ0gdN+xamtTAoV3JVpwplbTfE3Ql2XDBnIaJp90NaQwH73gNhewCWGyAFhpNbzAc2/DAUbQpiOyB1rzLOMxCXDjAK+wmzwiBCRpNcMmH6YQN2/wRC/CCN2JNXAwH0QgNzWwTiICAjG2NWFQdeBRB3PTBnwaIhEwlVyTZ692omzjAVugq/LxANXqNaMwH6ElNxAwCsQ6IBJgl1ojB/OhQnWzD581IFYAolwzaOGBAscaN/yArfJxBLf5NXYnH8JwNxeAruMRAr4JNmYmHvB1NwjACu56HOhTNqkkHihgWXiTChTHHA9wCmZDR/KhB3qDBp3/mhw2wK9gw6jjcWF60wcOexyzczYQgJ7j8QICmjdXUAnJsQG4VzbaJB+muTcfoAY/BgMbazZ0Jh521Tek8AIosJ5qc7LiUal7Awd1ujaPMB/G0KNKkWPyAQBuqxSMQHlzexRBJB9BdrdDgQ2HuhwpoKh8OxQqJh+zMLhF4Qbz4QmISxQtcEby8QeNOxRqsHaTKxRYMB8oUGmX6xNBJR+b1rk/kQqfJro/kQTeCh5ia7o7sXjyUWCsuxOKoF/kGbs6QWvh8aa2qxO4Nh6OILi7WxO9Nh8/ELw58QXzYQv2ZLw3qkzMexNAKh5E97w1QQ30UUrUSxOnKh5Xl70zYQ/0/1Fw3hsTH0Cm4nFRMNgNZBkZ4kAfN3eCNcAAKCABoRAZJICp3wG7J+i6/mABW1C7jcEJDaaCTzCbDzAOaqkYfHCP47EGKuhtycEAQKBuiwHB4kHBG1jA4bEE4psYSPC3y1FoIagM8hEETmUYNUdwHsgGIKwc6HsY8Tsf2+CBqTYeHYwYHTcfq8uAOEAfL4wYcCsf64CBTKvCjFHD4kErDzhK8/HDicELLZwcrVCd6QcBkEAf7uQYKSwfZJKAlODDkOECswkeeKCu3/cBviof79sYFhweFtl/eSsfhCAZlpC63/ECqtB/STBS47EACewYUfu6/ccKOkYZQ8DH43HC2v+HClGMHBbQUJMxDfThBaRqbncqH7BgGR8gnOIxq9rndPOxA08rGZlAH6sQa9XXBc0zH+eAGQ6Qo+LRDN+nXfKBC1QMGWJQH60KfTXAwONBs5qBxOFBDssbbgM3H8XAGU9gx99RvOsmAvTBAGuMGTZAHyhwZOEmA+YrHsXGGSOwzeGRBuZWubvVBsDBDvURD9ymW6y8HbqwJ0kbbB4wPbkGqL/RB2MMHtwQbWXQVO0RyPLxmcEmCvn8HeDgHiOwQPJhBpx7ahSQnONxAITaHt1QH7Wwa/JDH57cHm4WHgJ9ap1Q0MzhB5XsG3MQnuKRAaEbahyASTx1W/5BuuNxBBj/zGnVTB9v/B8d4A3hsQAfKmuaMLLKkQML+x4E/R05cMOhtgKOpsMdktHKQQdEdWrSUB/73CEUgLu2sMOnhmj00QPx/CAhfRy10NCnNgeIPB7DwCLV3ANrHWwYcAwWfSMcYAMRa2tSUB8MPb4u4Wf1AWB8zRKJAM7hYQSBzRIOcMzzwQxTfdgmkddwBdOObRLTWh/1MNkp8QRpLR7boLOYDRIegLDjsQrb9tklgST1EQ6mbRIyTR8nt9ojQQ1CrRyTYLCw3RG3oFnjoQRqdNsh4QPbO7O+HRIOEL3yYdjDDRIALR+ecMvJXRGkRR8qUNrPvRElMNvJsQDmWt0awQuZ/1Yf4MbdGoENq0wfQCDeGzECdVsfXqCy6H0RDaDY89EEkPzeFoF0DMTV9i0RMlsfK73fFIEPBAIMAG4RgEAgZFDSBZ4QXzwgR2DWC94QaCDS3wED9R3hDnEIzAweEyBhGO4QLIDS8rEADvThDzEFIi4fi2DiDxE79LFRLM4QLr5dMd4QLLCi9VEAzl3jIU4g1dDYNV4QT5Di47EBZhzkA4G89VEIqIzkCjEP9FEEF+7kCOEALpWxTUblCeEAVR0eKsADWv4QDUAM4LEKYB7mYq5Vy+E+aB4RHoCxx8Hmbe7m8i3ncx4RI+Ai/mDnd47nk7AKHt7nEXEBJCbohn7oiP+e6Iq+6Ize6I7+6JAe6ZI+6ZRe6ZZ+6Zie6Zq+6Zze6Z7+6aAe6qI+6qRe6qZ+6qie6qq+6qze6q7+6rAe67I+67Re67Z+67ie67q+68BBBmtABHls6TEwT7iwBcU36aCsHEdgBMfu6O4gHkxQC24QB4veoOPRBAUwDSUwmG2OChNiBkDQCGdQv2HeviMCAtpQCiJwDcD74e+sJFqgDcGQDVCgCvZs3zKA3SPyAJFQCazwDpQwBbdg27A9YAEJA+RQB8pgA+hACd/QC3eQBPe+ERBAAnKACgY1n208kSjQAzmwAQMgBIiiAV/AGvjgKKlRDq0hKWkQBH5wBLbw3cb/Mc3Wae2AOSBvOZ/efvMSAszsae48TyDxyp6vgG5Bj5ADagmnAAQDe/TiwasY6gAG0AhkgL9Obxx7ZKMdgAOpkAYJcPXIIQR8CwE1IAnNYPRHnwuXGwMlIADEwMlnWQixewXDUAGEUAiNDJKrwLwtgAOSQAfaUN44qeCm6wOdAA+XEAB/bpJNftgyIAq/UA/BsAbrYPP8SO3JTQFy0Av3YA8E8AVAMAiQYAuQq6NRwAQ+FeEdcAF28AdYAAVoaw+zQQAVYA2u4RonXwHn8ANVIALh8AY3oAN30AY7zuvGf/zIn/zKv/zM3/zO//zQH/3SP/3UX/3Wf/3Yn/3av/3cDd/93v/94B/+4t8wAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vevFKdBFgVQr/7cUpEuEM3dKga0oCz69ewEybwR7u27dv+IoRgFATIFmif4j2TwyG28eOQH+Beznz5DkZLtjTS8ywR8uvY/zbfzn15CnKEpGT/0nQhu/nzb7urX39bRRBgXG6QQE+/Plj2+PPTNkOsnAI79gUooFT6FahfE2SUM0wSAzboIFEGRlhgIOlw0YcDD2aooU0SdljgAWSIo0lrG5ZoIkoepljgBJW8Q0MHJ8YoI0cq1vghMVzIMeOOPEJk448FFmLEIV30aOSRAwGppH4RFLCIKUhGKeOSVOrnhwC8SKllhlV2mV8rUoiy5Zj2hQaNBGhyo4EJVgThCRM9KOHlnP7YAgsNZOapIQQryHHNG7SMggkrS3gTAgN0qtjKJUjo6WiMHeTxjB6NzLMEEy8kaiAk6OTx6KcyQmCJLIvAQgwuiGqqHgNj6FEcqLDG/+gBKvBIYUURqnKXwDwGxOqrjEOIkYo8TqSa621HnBPDr8yeOIIY76wRxbG2ReDOM81ma+Icvmwxg7G5blBFGNqWq6EMyDwCCbiJKvGHufBmSEI4RjCjaREwxqvvg3xIsssBXk6z78AZdqCIFIws+QKDBDf8oCqjbJOBjeM4bHGGMlBiRaYe9nrxxw6O0A4hJ0SYC8goP9gCLUJMnB8lKcfsYBJcFMMeCBTIrHODdlQQSHfW7Cz0gBCwIM8EzD3g6dBMB+iDJJPgBkTTVAvYiRpI06ZJ1VzbtwIgTHjR9dj2tUH22WinrfbabLft9ttwxy333HTXbffdeOet99589//t99+ABy744IQXbvjhiCeu+OKMN+7445BHLvnklFdu+eV4DcMG5pwH5QA0/jBSZOek65REJbXJU/rqNj2Dq22zsC47TIBYgNsJPMyue0ocaNCcEy3sLvxIieTCnerDJ98RDYioF7vy0F/kBsfd4R799RE5AEt+AJCL/fcKdeFKgWCAb75BiXgT4SLnt6/D6wYOAEH74A+DgoTz5Ew/9rMsEGEKMNsf9gQgIQDkToDRcwArJLQGHyAweh4wgYQq8MDojcAZEVICHCoIvQuQI0KtyAIHlZcHAESoEvMZ4fCeYIYImSNfKtwdD2BgoAXEIobDw8EODDSBDeJwdzgAWIH/oiCmH+ouiAZiAjaMeEQh6kcXKWQi65BYoDV4QIqyo6J+toAhLK5OFE7MjwC8yDoeqMBAryDj6p4AggItQARqLN0T4IcfCyQjjqQzRSFWVAI8dm4FM1gRC/zIOQ/o4kNTICTmOpCGD+FAkZgbhyMheblHTJKSlcvGih6JScqhwX/5mcAgOzm5TmStjm8g5eTmEAL9ZAANqpTcCuyVnwX4IpaR6wDq9FMFXEbOCAUaoy8ft4gCBWOYj7uBy/ATgC4ic3FyaIJ+xkCiZyouDAnLDzkcaM3FLUM/PVhaNxOXCv044l3jTNwUQMmeB/QxnYjDRhvzcwp4Io4CxssPJ+yJ/zhg6EcIzuTn4JKhHyesQKCFU0UY1bODWyCUcA2IGn4eIIaHEk4C+hmFRQcXDv2Ub6OBM8UO8XOE0YH0b9rIzwFccFLAnUM/92jp3/pAvfVgQqZ+40A22aMLGOJUb3TIDx7E+dO8TUE/qSyq3loQifw8Qql78yd+joEBqOZNDPlxhI6sejcftBA/cOTq3WqRnwCI9W43yE8RZHDWunHAhOxhwCjbOjdrOJWudGOD7djjhFfhFW4QsBl7FoCnv8atCvmxgWHj1oaFcqevi4WbJAdb2Mi2rRd3tWzbHAAJ/ETiipplGxfyQ43Qsi0Jq8APOEzLNhpogT1NYBhr1eYBa/+UrDvsmK3b5vDN7ehCt1l5wzGNcwMvJK0PwLUKEoRAm4oapwNVkOZt6JBcqpCADsqhDTnmdxwSBCO7/oDBCKoblQ68YqS2ye11srBLeJAXKm+gJW56ANrrhEMa73XKcrlDgPyS7brgbQ4KZOvfppUAvd2RQIGrZoeacucFfFgw1SzJHjVIuGkrkK56HuDQCw8NEPj5qId31oAcxFUHIxaaMPBjghQLbR34yZKLZUaNEM9YZ0GIaw1uHLNn2JjHKWvkehiwYyCDTAf40YCRUSbB9ViAqEtuGJLZ89QoX6zJ6lHCQa3sMBrgxxhcthgZ2BMCv4Z5X15mjyTO3LABsIf/EWwm2DDw49w46+sI7LGCnfcFj7iqYs/xasBX1bMHQMeLFOxxhPcMrS0fyGk92WC0uYK6nhlIuly3YNd2sHXpbAlZPRXrdLPOwJ4IRFHUvmICe36AamZ9gj1MaPWvRpAC9nBa1rBSA3tYgetYGYA9B/hAr2HV2fV0Y9igkgR7xoDsT4Wh1quCcrPH5A72vGPajmIBeyyN7TxB4Gfr2Vy3yVQO9lwitEBIgLrXze52u3vdN7yYHNjTitAWwEP9/Zib18PJyN67Q/m+WDHXUwrN/ltCAbdYDJbJnR4YHN8oWwJ7KmvYg0co4RajBHtAYVmLGwjjDmvBbbtTiI5DHGUB/2DPASt+cpDFgz3CZDnAUyby9YhtsR4vEMgtZgX2zAHnLQeZCNhDBKDPPGUkYPh2CmB0hMsspeo5gbD/mnP97Nxio13PMGTu9JjNgT1f4PrFdYZn9dhC7B/XWRnYcweqBx1lmmBPpPFa9fxc3WIdmI16Wkz3t6N8PQcIqFjrjp+7W8wN7On3WQnPHsM7jA/sEUffj64zuHYnCJPvus6k2p0I6G/xfkdZR9dDBboyfj2Od9gK2Mmda7f19OpJvcMEsR4ymD70KKNwdwL/etyD7B7sQUXvKa8zErAHEMPX/M7K3p10JH/sQ5vHeuoNeuLrTA/sKc/gfQ8yS7Bn69u3vv/OWqmeclRf+Tsbn3psH37068wY69nB+aE/NKyu5+dchX13ZG+xEWiaOT5kVfrHX1QjX9xBQfnHfSgDDuvBdwKogCATC+txdgkofjoDBezBVg9ogTJzAeyRSBvofjvTA5BWgSKoMwMIDCZIf0yDCeuxDSuYdlSjceoRAjGoc1WDChkYgiw4NF3AHljAgzJINeDWHc+jVAO4Hfz3MRKnHmUghDhYNZywHoQAhVbHNcqmHpBghXbHNbKwHo7AhYXHNXbAHkMAVUnYHEt4MQ6gdM2heDiVhsyxhhdjYupxS0gIgSkzZrfxAgBQCdwgDrRABdggeDIlh8tBhxYjDmSwBe//0A3VgXZROG47goi4oYiUWB+WeBuYmInosYm20YmeaB6gWBuiOIrYUYq0cYqoiByq6A+s2IrG8YqxKIuwQYu2WCK4mIsasou8+CC++IsNEozCKCDEWIz2cYzISB/KuIzn0YzOmB3QGI3XMY3UeBzWeI2xkY3a+Brc2I2c8Y3gqBniOI6YUY7maBnomI6UsY7sKBnu+I6QEY/y6Bj0WI+McY/4qBj6uI+I0Y/+aBgAGZCEMZAEKRgGeZCAkZAK6RcM2ZB88ZAQqRcSOZF4UZEWaRcYmZF0sZEcKRce+ZFwEZIi6RYkWZJscZIoqRYquZJo0ZIumRAdgAA0WZM2eZM4/5mTOrmTPNmTPvmTCFAHehiTI3EIB3CUSJmUSrmUTNmUTvmUUBmVUnkAbniFROkSCkAtWmkjtXiVFZGVWxmWHOiVJQGWYnmWVkmWKmGWaNmWsaeWK8GWbjmXcwiXa0mXeMkcHGeXKCGXeZmXEQAI+cCXJuGXf4mXC/AFU0eYImGYh4mXdaAPjNmYj1mZtOEEIjSZH+GYljmXMPBOmskRnNmZbpkBn2CIofmVpGmZiVlNqWkRo7mabikE2veaqimblnkEmYlHifAM3fAOWxAiGhKbuNmWMFBnMeQAfEAFtCAO3FAJAOBg/sB+D0KcxYmWEcAFP+QL65EDw3mdnckAnP/gmhWEA+uRAahpH9YJnmgpBGc4QkPAHgBSnexJml5QZBzkCOshCxmynvV5liEABSNUbN2xZvT5n50ZAVXAXQhECOuxTweKoJb5AHuQnuCzduqxBP0poau5BLVJP7OwHoGAMQZQoiZ6oiiaoiq6oizaoi76ojDKokQQAXPiBSy1P1jAHiaFOJpAgl6iAmewPzIQfIxDDxswJxNgoO1Dft0RQItDAmswJwvwCOSJPdtgU46DAWUQYEvCAGmwLObDedzBdI8zCzTqJZBwo9+jSerhcJCjCD7aJTBwA+BzVOvxoY3jAkfqJSmQCd8zpOshoJHjA67wfz+yADZQpcNjC+v/EW+R0wBlwHpUsganljzq1x2rRTn9cEpVsgFbpTwVsB7MYDksMC1eggggmDxwMGTjVTlxEEh86gbK83XrgZyTswI95yWI+nm7g2DbAWaX0wB0IKlKwgAmsGW7w4fd4Qqdswgj16n0IDzlVoOkAwVMWiUhUHq6M2frYQmkgwSw2iUoIKuz44HroQelIwMFYKg2kgFSwKul0wrrMQ+rwwGlQCdA0Kqrkw7rcQSyUwXQ1iWTMJ+lA2LrUamdAwXz1CVaoK2ko4PrEVOycwfhWiUT4KSc4wCOxRxVJjsx0IRdkgGYUFWdo6zccTK6QwFGwK42kq+d8w7rsQDIKjsOQATP/0olfkCwlkMF7BEOw1MCC1slRRCEl0MBZ9odKjg8SKBqXqIEYWU5OaYeAKA8STAGc/IAl0CylCMO7BFhyaOyLFsjhLBokmOe60GuyeMAgHCzSyII3jo5GrseZhU9JaBhVaIFRCs5WKYrPpU8bMC0XQIC1iE5bKoeW3M9F7AJXbIA2jk5d8AeT4g9HGAExFojhVY5jKoe/vo9DvAKR2sjQrCYk/MFPmc+b3BGNsIICBs5yMAejQs+NWCHKQICjXI5H8C2zKEN7dMGVushEWCrlTOAGbC6ELQFldtORdc5RMAeT2s+EDAKn5sfEsCgmEOr6qFn+7MPvroeVgCvmGNcUf8XPPvDD7Lbr2BaOgS0HvGAQBcwCGSmpqXDA+wxtwKEAKxwvLaRAnPFOnsUvhWUCtJpGw9QT7oDCuyBsQKEBnZ7GzZAvayTZhk6Qn1QvrWRBoq6OnHKHRlwvg90BbtUGxuggcJzr+vBPiP0AWqQKjAAv0DEHgOAQ6TwAiiQqskjr+uhsxwEB82bPJfAHuZnm4XBBuwRCA4MxIBRsdyxv0YMGDC7Hu6wxIORB2FbGylAtlDsF72rHkp6xX7RDeyxhVz8Fx+wsczhMWHcFwu0HhZ2xn3hY+uRAvrKxnoBuN3xCXLMFz8Aa3e8FyQQvdsRpHucF5OlHmkQyHnhxqvSYYb/bBdIvB3Utch2UbjdoQTcBMlzEQb6uR6kYMl1sQfsYQZay8lwoQpTXBvuJcpykauai8pyYX9ax8pxsVPd8cKw/BZZuB4UV8tqwQHXyh3UqctrAX8TB8xssQKPtnfEzBa6px4olsxpkQd7hczOnBa+wx7NPM1mUQOlTBuFjM1nAQb4cWvePBbazB6YN85lAc7sAcjoLBa8gB/r0M5ksbfdIQzyLBY6sM3+kAMXfM9Zoc7rgXz+/BW3wKXb0QQzO9BboWtUptBewQcBzBwvgMMOjRUYFX+gWdFZkQT3wx0PQAfEq9FVQQDcIQS164/S4LPY4QEZbBvMkFQB2Wf+UAm7/3kc7IAbO/AKfYuPI0BDtPEAwRDSmgEBH/TTIN2QlGYbTVAFO80Z9mfSENkHBk0bXkCnxkEHMN2Qh7Qdy4B/Ir0VN1091lBfX20VF7DA26EFuVzWUsGA7LEKBMbWUVFj+PG6ch0VHtBUX2yhd60Uy6wevdDXUkED+LscoSbYT8EBToAfB2A2iP0UNpAfvfTYTkHY+FEMRUzZR6HYdSRumr0Ufw00n80ULKDP/gAAZjbaRiEDdKQeVq3aSJFy+FELsJ0UQ4cfZlDJtU0UcpDJ7MGfu10UGHAM+ZG0wU0Uoc0dkSC+xy0Ub6AfNNzcP5EHeJAfjyzdQNEBW/1mqY3dPP/hgvjxAsjl3T8BfPlxDuT9E7dAxs2hu+ndE13AfPEHJe/NEwDds/XNE6OgHwqW3zohBlO9HZPQz/4NE7ewvdxxAH9W4DcxAoudH3fE4DbhAMxV3BJ+E1OYH7ngvRf+EqegHyCwRB0+EyUQ4M2xANE94i7xB77NHqmg4jKRBy2tHlMD4zAxAkWNH4xgxTauEg2QxbD1qT2+Eg4g2/iRAa895CsRDAViwkq+EumbH0bw5CyBWPpRCU1N5SPhC4XNHMyQ0FpOEmhQldwRAl4d5iXxBtHMHhPQCWh+EizAqTELS29eEjgg5yVY5yShRfjRsXoeEnzOHkr25yIR6OuRBln/TugZwQLs7VtkregcEecFMgNgDukZUQJ4rh6FQN+WzhHJsObsUQRP0OkdIQJdzhwgMOqkvhGvYCAqsHKrjhFRrlJFFOsX4QBbYCAHAIe2PhEeEKWX1OsVQQLbrVK8LuwQgQ10zNjHjuwOIQqmqh+77uwUAQeZzlDNTu0LEQunzhwhAOva3hAdYA4RYgaqHu4OQQIfrB8AIG3onhBZYMMFQg54+u4JAQfHrB/OEMf2nhChGiEm8Oj9bhA+AOwGwgp8PfA8YHnBNPALQQkBqx8LcIQObxAUIH0RggLgV/EGAQH7ZiBFcM0cbxADVyDeMLgjjxD3zR6usKMpbxBhwPDq/wELCf/yPIC7y/ECaPvyCxGi3YEIa83zCSEPJ4vyQs8QLfDgy6EB3X30CnHzuGEBAu30EOHztVEE4kz1D0H0tFEJca31DtEFCQMNNQ/2CMEGG2/2ar/2bN/2bv/2cB/3cj/3dF/3dn/3eJ/3er/3fC/3jt33XsAEgFDpdB93tDEBauDmeA8EuDEJksDvcJ8HAT4B8sACmb32dsUdgVABFG32FBC03FEMXPD1VE+DRy4EtMDcVJ9PBXIChNAOkD/yv+YhL2AFlCDCIz/IKZIB2zAKC+7wSRDRHsIIUqAIiS7s0+AlB7ALkuC11N4Brd0lzGAE4SDUiv4H+Z4oDAAJj/+ADLjf6WFQBXt6LAwwA1vgC2du6c/gDn6sKlGwBu8gBrFf5zFwDvKtlQzgBPKQCmIAEEP+DSRY0OBBhAkVLmTY0OFDiBElTqRY0eJFjBk1buTY0eNHkCFFjjxoYF4CfylVrmTZ0uVLmC6LWJECD5UHkjl17uTZ0+dPoEGFDiVaNCIHPWMYxGTa1OlLBriIwVokyxIEo1m1buXa1etXsGHD5kEH6elZtE9fMFkyr5GeZ3k6iKVb1+5dvHn17rWI5FKrtIEFx2QQwtsSVphG0XpzTc4KrHwlT6Zc2fJlzAdpwLI12PNnpkp6MPEUJI0JDdwkrIZWoUJm2LFlz6Zd+6H/KCmAQe/m7dT2b+DBhQ8Hy0uAn97Jlack3tz5c+jRM5paVCDCcuyDpW/n3t278y6HjBTKXt73d/Tp1a+XLIcLsQPm5bNkX9/+ffxFO9BoVGnCfPPyE3BAAgvkqAFNxCEjPgCTM/BBCCOU8CAH+uAinUAaBG1CDjv0ML8khimHjCY0TOtDFFNU0Ts7wimHGDNMZGpFGmu0cTgSbuACmCBUkHGlG4MUcsjYLtAkEykIISeFBol08kkoJUvkGT0a2WIJRnZQ7oEou/Tyy7o4kOOZeD6BZgsggmAkhBPQSgBMOOOUE6wGhlBFhxsOCUeEU354x7UKYJFAnTkLNfRQRBNVf3RRRht19FFII5V0UkortfRSTDPVdFNOO/X0U1BDFXVUUks19VRUU1V1VVZbdfVVWGOVdVZaa7X1Vlxz1XVXXnv19VdggxV2WGKLNfZYZJNVdllmm3X2WWijlXZaaqu19lpss9V2W2679fZbcMMVd1xyyzX3XHTTVXdddtutLCAAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz589dFehR5MID6NOoUxeE5K+1PxROyLASR0kRNtW4c1NG5Lq37wiMXMGqMuWK7uPICWfwzby5v1XO1JASkyS59et0Lzjfvh1RnTLtbmH/H0/eLBLu6Lkf0CblF5/y8ONjnZK+PvoeAUjhaCC/v3+l0dgnIHoRBFHBFKb9p+CCPH0y4IPoWaDLJZrwx+CFGL6ECYQcopdCAaNkkeGIJJLESocoolcEN3CEUeKLMF5kRYo0cvdCJT+oEuOOPC7kSY1AcjdDOaj0aKSRkQSp5HZm7GEIBEdGSeIES1bpXA+w0CDllgp2YE4afiDygJVkumaGDX9wqaZ/EFxBQzypBEPMDCeUqeQR9eSx5p4KmqJJJuqYAMCYdnbIwDYidMHnov81wMMv+JiQZKEPOlKLloxm6t8IhmQzDiMLUGofE+cMoemp/XWBBSkBmCEqei8o/0MFqrTKZ0o8nORC6KvMzUCED7UGW14LJUjhya68tqYEHeIJ6yx2LXxTygzJusZAAWc8q+11ocAjDx7V+sPELBRsa+5xDvRyCWvJIvLOCufGm5spVdSx3KtKPKKnvPyiNkI3QKDwqgUa1NDvwaB9IAwQdVLKABgGIywxZy3oscYLDoPRx8QcayaDPdWIaoIOHZd82RziFEIpEEiY7DJlioyTgp0PaPDeyzg/5sMpgthpgQTV5Sw0Y6JwMzOZKFjTwtBMJ+bDJ4yUicgsDjRttWFiWMEAmV5kezVfGHxd0C10KEHmEiKKbdcIe/gBpdoD+XCOq1UOAjddbsDQmiR3E/+EASXUBslAkX2/1ckxvYEwQuEEfTMAkLUw3tYQ5mzt2yOSE0QDGSke0EbmasGjgnMWuAD6QDiY0GEsp5/1RCXoEdP6QDqoPiAAFs4eFgbGNIweNboLVLuAhwQf1jOB18dIB8b/Q8M26dXRvFceSGC5gJ9M/w8U62z3QMTaZ2VIDhzuQEL44TjRHB3hZ8WB9SgG034HXIzuWhMytH8VDeqn+AAb+hsBKCLQGiLoryoNAEWoakSGA/5jDmDwAvMcGBUkeCNIkMACBf+RoA06pQpUqtEOiFA1D5qQKUmYUY0YYA5TnfCFSfmG3mokiE7A8IZGwcAjgOSIbLwNh0AECh//EFejNewriEjsySF2UKMiwCGJUNyJDldIB2BF8Yo2MQURUxSJG2DxizSZwgxTBIylgfGML0nFAlEUiSmg8Y0s6UIAavQFM8LxjiaZwwZoBIM34PGPJblBE2hkhQsA8pAhWcS9OjSBRSDykR3pADBo5I04QPKSGRlBHWgkgdxh8pMSmQMTUrSKcIDylBIxAAhSJAg7oPKVDoFDCDvUSVjaUiGvWCOElKCAW/ryIGVIkRMs+cti/qMB40jRGqxoTF96YJMdWgABmllMEvyoQ6vwIzV9mYfkQQgAptvmLZ+ACxRVIn/itCUbioCiLYQtnbBEhf0gtIDswROWODhAhw6g/817ojKfHepBmvyJShYcDUJMuBlBQcmCWT5oAOhc6Ccb2iEglEuin3yGQwdUih9iFJIA5ZAAPvpJHeiTQ/YkKSR5MM8BLQAeKr3kE9gJIQs8MaaPzEM5ITQBFuD0kUMYJU99+tNDeiAXHDrAM4p6yAZA80EHwAFTDwmOpEp1qn+0gVWx+scfcMgRV+UqHIWhS/v0VKx3pMFG62OBEqAVjnJoqX0WgIa3vnEFzKCnL+yKxg5sgkOz4CsatyBSwZ4xGxwChmHByAJk2QcIJVxsFFXBxAdtw5OSRWILjgChDSwus1FcBoS0kAjQRhEduxyoaZEohrKmZwHDWG0SsSHX+v+kVLY4bABSHyQ/3AYxGBAqQGR9C8NkQMgJzCTuC1VxUgEl4A7KvSEFJvEg2Eb3hhKA0DuuC0NkQCgA3H2hKcA1IC8oKrwm/OuADvAE9JowFRC6qXspmAWMDQgU8/UgBzgxIF1MML8blAVN0YOHIwJ4gzIAQ3r6eWAT+iIB27FBg2/IhyA0Zx2YnbAHIRAL+ypLRxrGYR+SJ4IQB3G//gCviZE4hYiu+MUwjrGMZ0zjGtv4xjjOsY53zOMe+/jHQA6ykIdM5CIb+chITrKSl8zkJjv5yVCOspSnTOUqW/nKWM6ylrfM5S57+ctgDrOYx0zmMpv5zJmSA5rNBQEF5CL/Bedbs7AaMIv++WMacq6VD9ARBd9EIcN5XlMopADh5pQ40Hy6BSsIuB0vIHpN11jG9bgDhUdziV31aaClpUSLAYVz00ZqwIDTIwFQR6kezj2vqXm0AoHZ5xSrNhIdBLSBWPfIDq7djgZtvSNXCAgcvN4RNQT0ghgEO0bks88rjg2jUQiIHMx+kQzWuh1RRLtE3BDQPK5NIlQ49wPcHhF17UOLcGeICwKqhLkxtAJGp4cBpV03g6pqH1LIm0GyEJAf7r0gCEyqPsTkt38EIKBy9BgICUi4whfO8IYrnHXyUoWACtHjAtRomvy6Zn0wpWOL0wjj8nKQfWDBY4+nCOTx/0qCY7eDi5Jf/GCcs4+1O/7yflFCQJfYsclRhPJ4tcB36HGCzmveL0IICIA53nmHeh6vm9uH6TRWOoegbq4ReBg9kKD5xyW2BAHdBsdShxDVzZUJARkQ7ETvFwly3ZwlJD3t/RqEfSLQwRqH/UFjN5dX7YMMtG9dYrcQkBH8fnKOAcA+Lb/x3QeUd3OVQkDNsjvc+8UCAXFB8ZPnFwYcYR9XYP7vExNtfQ4wXBkvXkCNN5ckBMTxGZ/+6R2Tg4CMYePX1yf15vo3etQtedBPrBZmBfSKbZ8e3G8rHgKaVdQz368hTJo7jeh94UuGafRo2vXM79fj6+OI0r+Y+Ogx/v+2hCGgjWHf9xNLgoCqsHz0T+zw9QH2+adfMjXYh+Lz57nLRCAgF8YY/NwhftvyBAISW6aXfQezSvVhcAfofhMDfgWQf0v3MgRXHyEggVP3Mt8gIAr1fQjYL9phH/LlgQ44MbrHHRXQgPRnMnNUHyaggvr3MqhVH4EAgxP4MiUgIPACYwC4HQJoLokgILtGgitoMuSVHo7Egx94MHJXH4OnhCU4MdlVH9vwf0vYL+xgHxcIhUVYMqKgg1wYgy/TAgLSC2F4gzijBfZxaMN3hXFnH9BwhhmYM1/wWHIodkKzd+mRdUQohi/zBvbhCHeId0JjB/3Xh2j4Mg6wSOhxDYj/OIc5s1PpEQ2PiIdC04TpUQ+VSIhCowH28YQm1oPO8YPxUgH2ITttGIUcw3/1UWup2IUmcwP2AQKbyHhDI3v2cVEhJorNQYrnwgECMgev6Ic4swr2sVSh6IYHk1f1IQzDmIg4ow32wX7JqIocIw32MVLVCIsmo1X1sW3bSIwvEwv2oWK7qIz9worpoQ3PCIk5cwj24WjhCI0vQwX2UQTtaIlCUwP2gQL5yIlCEwoC8l8TxovM4Yu/eIjnaI0cQ23NoWYLyY0m0wP2oVoFiY790gr2YQjz6I45s0f1wWANZpC+gZDn4gz2YUoRKY4vI431wYYXyZATYzvpEVgrSY8v/4ON9fEDHamPnWgfqdCTACk0s1YfKXiTHokzU5geR6lhJNkbJmkuS4ke1iCUtsg0U8kdpYaUPpkz3khqVol6TWOK9bGVTvEEN5CWarmWaymMJvSUrhGV20KWYPkUWbkdTblBcNkacqktc8CWgKmW7WWX9pGXFLSX/tCXxnSXziFhb4mR98SYzWGWegmZ8GQN9kGZh2mZ6USX6KGZDoSYillMnskd7POYMilR8FUfGnBCoilWeoge0uCanClOs2AfL4iaEqlS6oge7KibLIlT4WAfzkCbqblQgNiKxrmbJGUI9tEKyxmcMfUH9tED0YmTOIWL6TEB15mUPzUEAqKL8f/RAQhQnuZ5nuiZnuq5nuzZnu75nvCJAE8lnSrVAQISCv5xCAewn/zZn/75nwAaoAI6oARaoAZ6AIyInTjlaukBPvGhAOESoYUymsU0atyhfPIBoRK6oVVCob/kBfZRPP2hoRxaorUpTi6ZHjAJHyRqoi7qnT/VgukBcRn6ojbalUw1D/bhmDV6oz5aH/glVhWYHrM5oj96pNwRAYCQD1xVBfbxmz2KpFLqGwvwBeA2VeRXH8zgHy06pV7qD3WgD1P1DPaxClz6pWjaGk6QNj81BwLCAUaapmgKA271UxQgIBD5oHKaphnwCd6HUQqYHl4UpXvqpVUqfAQFkioap4X/iqZCYEgqRQyFyaiN+qVHwKYYZQT20ZqEWqleCgNiQFKoVh9206meOqURcHkYFSD1kXh6eqppygCcgKjUdA32kQF/eh1dCqteKgT+d0/gaR+u9Kq8mqZe4KDwxHkhaarFOqUhUGn+VH3cwZPE2qxoGgFV4FHbBAT28QXMaq1S+gB7kKu/BA32UaosCq6FugSQuk29yR1aIB8yYAD0Wq/2eq/4mq/6uq/82q/++q/7SgTuVihe8GnN1AsCYkcwpAkUKSoq4DXNtAICMnM4RA+KWigTwDfUxBv1wQ5IRAJr8CoL8Ai0ekrQU5ZJhAFlsHJWwgBpYGzFBFz1AaVINAsD/2snkGCwtrQI9oEHV6QIDUspMDCot4QFAhJvUOQCF2snKZAJviSx9gE8V+QDrvB8ZLIANlCyjxQI9oEOX9QAZcB2VbIGcfZKNIke5ohF/eCQVbIBeXpKpbkdkYBGLNBnooIIboRKcCAg7fpFceBNTOsGqJQHAvINd6VClIK14nlJIZCNcNQAdCC2SsIAJrCDmASBeLQIQGcnG0APn1QOs/hHUNC4ohICGPpIG2gfg3lHSAC4ZYICggtJwfqSgCQDBWC1VpIBUrC4f6Qy9cENh8QB2ycqQPBZVGUfAPBIVXBQhTIJwwpITmofQXNIUBCohaIFp3tHfSAgzvhId+C6ZP8yAZQASA6grOlRCpcUA10nKhmACe90RzG3h5hEAUaAu1ZSvHjUCPbBAL+KSA5ABJtbJn7wvGhkj/YRD6BUAtZrJ0UwhGfUAGzrG5EDSkggVJSiBCv6RbBTH3N7SkkwBq/yAJfwvl9kDHiKSvRrv1VCCC4CRjQgIBp7Sg4ACAFMJoJgCWDUAc2FHstgSyUwSKKiBQ4cRb7GfSR8SmxgwYUCAkgbRUQgIEQFSxegXnayAKqKRRJnH+h7SxxgBJJLI3uARpKIHsnrSw7wCjcbJEJwpWCkqfYRebf0BrVFI4xQtmDkXfZBrb9UA8kGJCDQMm/kAWnsHOj6S20AwjUSAaH/ekfr+1p27Exb8MXo8QBnd0dPbB9O20wQMAqDnJnaikbYICBut037UFkPYgW8+0bSuh0vYLzNxA99bB9HALOARAACMr7idAGYmB4hoLN4xAYCQgjwhACsIMkpEMWIZGfocQIKu02pcHXM8QCwdkmXcMv+hAZA3Bw28MmA9IX2cX3w1Aex7BppoLVwNMbc8QDTC09XsMGusQEudkmwgD0L9QFqYDkw4MuQ9ML24QkYRQovgAJ5i0q+Wx8gtlBwkMGfKyDaKHD9EQcCEgnc7NDj4QcCIgsU3R+k8GsZLR+JoMK/YbkdTR7unB5XPNLj0Wn2MQkoXR4fUGj1QTItPR46/2ofwDvT2OHN9TEB8YzTx0EOAjIKPn0dryAgOTDU1hED0MwdUovUx0Fv9eF5Tn0cRjtXBDzVqrG0ponVunEKAoICIs3Vp9EFMJ2JYo0bktkcRWDOZ20ZLjAg5dbWqBG/8ivXpwEF9cEAy+CIdn0aILodEcAKcNzXn/GurpEAUoCfhJ0aDWC3rhEF6JBci40a0+AaTjALbD3ZmUECKZALCjDRmn0abxvapF3apn3aqJ3aqr3arN3arv3asB3bsj3btF3btn3buJ3bur3bvN3bvv3bwB3cwj3cxF3cxn3cyJ3cyr3czN3czv3c0L0YMjDQ0Z0Xc8QJcFrdd6GOM2B+2v89F6pgNq7xArEA2t+NFg3QPcwRBB143mvxlcyRAHvl3muRnNwBBj1N32KRB0fIHUWA0fpNFh2gCwOC3QEuFqDwIC+AqQfOFXv7IEHZ4F7xBDtcH5sg4dTz1wKCB6aA4V0howLSdx6+Fe8AIaA54lUxDJLsG5OQyiguFXdQ1qN30C9eFT6gzPaRDDV+FQ7Ai72141UhswPiCZkN5EYhcgOiAl9n5FKh4tW1yEweFX8g3gPitVEeFYmghg/Sw1cOFSOg1elxBM3c5UrRACc7IDtA42SuFA7ArQ/yAMi85koxSRCSDXLeFEM6IFtw50xxmxCyCQTJ50bhCyvuG8wQ1oL/ThRoUOi9oQKjnehDUQIWwFOtB+lDQVHV1b2WThQ4YL4DosebLhQh9SA8GupBMeoDIn+mfuoVbh91UOSrHhPP0Or1kQt1F+s8gekPwgT9i+s6oesDggsG5us6AQeTDiFFsLrErhPwwOiNzgPL3iD7JNPRnhN5vl5hVe02AQHD+yATgIzabhMU4OZDFe43IQOPwyFnZe41wQdKPCDHzO418QdBC1XZLu8w8Qa0Pnr3ju8u8QnO3uiE4+8vgQGE1SFFgHQE7xIyUNIP0grKvvAr4QLwxyEzMOwSnxJvYIwd4gmPnPEoQQAB3xt1cOsgbxI+ELIoMg6wfvIZEQc4/iBl/+DyKqEAVE5Py0bzJ9EAab3TI6jzI2EHPYMiIGAAQG8S4cDxHcIEbnn0IsHzNFIHruz0HxEHF0RGgU71HbEIEZweGZCEWv8RF4C4HdIERBv2HfEGY9QhG9D0aL8RLVCHNBIAqvb2GjEFJ0hPEW73GtECdJ4iMEDdfH8ReF8jx9Dhg48RPkAHIG0fj3DEiT8RcGCh5SOikV8ReaDyNHIM7X35EAEB2eDpKPL4nk8RnTD0fGS4pS8RlNP49mEF67z6DfG/ppwiE0CNpmXy4YMFq9wh3gDIptUBXgAGbh8+dI0iCwAKLc9UlxwBoDD1zcMGLDsgTlDpoCUD2ewPKsAFWf8fPEIOIQwgAdmNW0XpG06gktNDArVv1BxJXDUw/f6wDtDaPEi+vxKg+6Y1n86xDdYPEP8EDiRY0OBBhAkVLmTY0OFDiBElTqRY0SLBDoz8beTY0eOMXhdFjiRZ0uRJlClVrmQJ8ZBHmB1N6GhZ0+ZNnDltUosJ84QxDDqFDiVa1OhRpAIbAOjZdGZSqFGlTjVIrOnGSk+obuXa1evXirGuXjWBA+xZtGkburDQUwU8tXHlzqWbss2BsWPJ0Kjb1y/SRzAZmBvy1/BhxHRr5WU84FtiyJFHjgDR8VgnyZk1b9aJigFj0DMoBeVc2vQ/SRthuDnd2vXrh4NAz/Zn5pz/D9i5/ULwQ2eEbuDBW7NZQnu2Ejq3hC8HS5r5c+iHz3gxDpqBFTHRtW/n3t27QQezEFUHzegT7u/p1a9nL7mFNRTkGafgJqr9ffz59W9NIqGt/LwEOQW9/Qo08EAES+JDgwcAzCuFcRRJcEIKK7SQICSAcJCxQsSZ40IQQxRRPR1M2JCxauyRYUQWW3Qxtz7A+OzEq15YQ48WXtRxRx4Pq0FGGsc6AQhhPujxSCST7KoGDf4LsikUgOjmNyWrtPJKnPJ4RIknx8qgjipMwXJMMsu8aIV3xutyLEgu6cUBM+OUc86CKJiFiTXzwkMeeEKh809AsTyjgBnzvGqGUr7J/zFQRht98RY6uDR0rAc8kaKERR3VdNMJfSBihkkZeyAXTuIRk1NUU8WPCmVeCBU0MwIgBYsuVLX11u2GOAfPV0FbgJFxsjGESlyLNfY1GmpxpFfjIjEBn194aOBYaquNrAsRtimU2dkeAMAEdTLR5FRryzVXrTzqAZVbAE+YgZhgUomHhisgOPdefKP6wwYz2A3yAUT8SMOcDvI1+OCcaIClB3+DnABhiCNmCQJD9rClYQcjkXhjjk9CpZx1MabNk45LNvkiVX6oxFWR87LiZJhjjigMOLgpouWmWJF5Z54ZymKUAlLAuSNMejb6aIMa0OQSXZzE+BOko5b6Hw9uqM4giAgajmZqrqNuAAdSAmC41ym6NltqPn6RQhu88kTibLinvqWdMupQ88QL4tab6yTEIEUNZ1YhL4O9Cz/7iimqgMUVRrIeCxHDI9cbG0UoEYcVMpyIjyNIJPc8cg9cUEQPBT43/XTUU1d9ddZbd/112GOXfXbaa7f9dtxz13133nv3/Xfggxd+eOKLN/545JNXfnnmm3f+eeijl3566qu3/nrss9d+e+679/578MMXf3zyyzf/fPTTV3999tt3/33445d/fvrrt/9+/CkMCAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr1z4hmNlkoxsSB7Bz67brwp9v3ymqPYpmZ7fx42mT/V7+GwSxelg4IJ9Ofas15th/v3AmpUSL6uDDO/91lb387weepFDzIL69+6CBzMv/HUEbOh3v8+un6WO+/+UgKKOHDPsVaOBJVPyn4HkDoMPGgRBGuBERC1b4Ww5l9AKBhBx26JA5FoboWxRbyIKbhyim+M8xIrboDwhbsLChijQaCAEKLuYYBR041Ojje6rkKKRvAAigyo9IUhfOkEz6U8wpPiQpZW4/MNAkkym4o8mUXLLWAhZccONNBlfm2IoxbXSppmof9AIIODmUKaIFAbCw5p2pJRGODcdYIGeFAIwyAp4/ssGeax/cUIEufv7pHwpfIEEoihAMM4Y/kuzmgRiYTGKlo/KNgcyMkxr4QRUA/DbDdEPooUEUoJr/58QpH5SqXxLl4IHdFOChIkAun8YKoABD2CqeHV+cUB4h7SXBDjHKCvvbCXTwYex0PEjzgHwPWOteC8LIc4C0vlmgQRzX6qaDCQpKsR8FhygzrrQMAIFfuqzRQEaFTdRaIAXhgBGtsCbci69pOOwbYiYRhiHCJsGCWvDBo63rIiQdJhILM9ICgS7Fnd0CRsQiGoIiDaw4EusDGngL8mWJcLPtkAGo6IEIxcRqgQRJvEzZCtAMPOQDedTIAzAqO6qEOIf63BgGgOgqJzQ/diHJDKD2kAmpTiN2T6p/PrCFlFOssYCjM5zR9WF9BOHoKo/M0aUlZSTgKDEurC3YBVuc/y1nJJ98d2cYo9jypwWPDKo3Xx28ssqfgvzSga0d6OHHnyC4sbheVJDz5yayUEyN23IeY/DmciXhzp8mdOJ0L2nIuQAwBKL+FgSSPH4lA2BksbjFZcLQje1t8ZDz7mDUQDzwV45xJPFncQANmVcmD/1AzDN5gjEYXD+WJmA3mcbp3v9DwzZlkuN6+V21AEyZAzzD/kFQCHLlA6BINz9WZ5hx5RHI2F9CklGIKwHAZAKcShhqcaUeuIFrCSxIA14htSExgBP6i2BTphCJJqVAAF3Q4EJWIIUINMkJBhChUjggAZK5SAOJUGFD5LCLJj0AGt2TIVH+wIgmeSKFOnTIDf88xyRvfCyIsanHC5gEA3ggESIOWMQOmDSBKjyRJ6YYBJMeUArFXfEhQ6iFC0WUhp590SZoqGCOnOG7M0oEB5NgUgig4EaZUMAITNrBLOpIEQf8QAkWVMfk+MgSVcRxSO64ACErgg12DekYLlukSfQASCFFgo6StAgceiCkVRQnkyRpQDCGtABYNA2UFFkBA10kDFSOhA+5GJITaODKjMiigyEyQi1DcgY1iuiGGdylRTxABwtNggLC9Egj/OaiWSZzI1OIz38O8LxnZqQFyxASAyTgL2tmxAernE8yvJkRORxBSFqwEzk5MgwYyEeX67SILKaYIzCsIJ4dSYIVygP/CWTicyKfmFmLlECLf35kERNgjhJuYdCIdGAeQspFNRvKESQQ0Td6oOhDVlAJIYEihxrtCAfe54+xhZQhcnBCjvDwhpOGJByDCKZLDUIDEORoADGcqU5TIoyEuggUJ9qpUElSJRet4h5DTepIbJAjL0xUqVDVSAOkkSNpnDKqWB1mHVy0gFFk9asXiUEsW7SD0IH1rBLJQw9bxIinovWtCnkCLlyUhjDA9a4LyUIRXASLoOL1rwQRhQpalIFMAfawA8HBvEJ0AEwi9rCKbZEZ2vhYwLIARyKCRCgqe1gW+DREm/AiZ+96g89aSB4NGO1fIyuiUqh2tYu1kDFei1ce/9gtRAs4BW3vyobBhsgC7dgtXFWx1xBNAA3CfaspCmhcdSYXrDHAGmMR+NyveoBFjO1Rdb+KgSWI6ADa3W5Wx/Hd8Io3quoo73mzSqHsrher92DmgiZwg/dG9RqmVdAEnGvfoVoiBL9Fbn+TOoJzWmgBvhiwUllbISsqWKk1wKWCCPDgqF5AFwqiQ4WxSgF5+AcMENxwUsUhn22kVsRZjUd+fTMD0aI4qgYA8HKKULQXg5UPF1XCH2yM1hbscwHf4PFbHcAJLgj5yEhOspKXzOQmO/nJUI6ylKdM5Spb+cpYzrKWt8zlLnv5y2AOs5jHTOYym/nMaE6zmtfM5ja7+f/NcI6znOdM5zrb+c54zrOe98znPvv5z4AOtKAHTehCG/rQiE60ohfN6EY7+tGQjrSkJ03pSlv60pjOtKY3zelOe/rToA61qEdN6lKb+tSoTrWqV83qVrv61bCOtaxnTeta2/rWuM61rnfN6177+tfADrawh03sYjekdsbOTR7QQY5VJds1I3DDNoLFg2erpgH3CIAJmaMOOAMhAeAOt7jHTe5wx4JiWJhHE8wTCTgXYEgUvpYcLiFh+dDSze8WUryNZY8FweLN+c7Rvm1FAur5xwwAhze+9qmge7M54C4auK3asaAy4Fvh6WqB0ORTiIvr+2CEWFC1H47xdOlhQQL/aDPEWyRxW2lcQZNQecnTRYwF1VjNKxdRy20lggUtguQfP1jBFbQEoAscZFr8zwm6ieach2jntvrBglqK85mnK0gZXrPTLQR1W63VPx2vetApBooFyUHsRwfZDXyO9oi/DANJ888u2s5yn9XwPwnwa5m3XqGu20oSC1rfmfm+IL+Xyg4LakSaCT9hpzHXP2RYvNUP9gUFpQCke588vpTT8KZrPl0XWFA9PD/2l21AQWkgfdp9JgEFJSDEYWb8fwxvK2EsiLJklr1/aF+q0CvIsJkv/ctU+h8NDP7z+GKFggBwfOGDjB0LIoGZdT8f3pfqDguixvSRjy9fmkcc23c+/8iob4Xwr95pAlBQD8zv9rW9YUFXCP75fTaEBQ1D/u1f21z/A/7ccx9fd+cfzOJ/4gcy07B8+Fd3evN+/8EAITRm1Ccf1mcribAg5gVmEWgeE2gr3lcemgOB/4cv2qAgnECA8+c0paAgkQeCBQgybqAgCMeCJ+gzNLAgdiVmGVgeG1gqK7AgoiCD+ac3nPQfw4ODIYgvSecf+ACECrg4lfcf4MCEOoc6UvcfgiCFT4c6w6AgTYCFXIc6vaEgLtZlOZgdO1gqDSBf8oEKRtiCL2M4/xEOVMEGz5AHsPdMZYgdZ1gqSTgfP0AVauAbGYALQTAO5TALUOACMoVKecgce/84KRqgIBJAFVslHyEgCECgCK7UiMvxiIRSAQoygFLBMf/xC5t4hPjSc/+RC1RRSf5xgYvEib/hiXgiCwqCCFPRAguyWYyIiumCff+xAIMEFcDoHw9wh3Uki75Bi3fSBQtiClKhCQoSBbWkjP7AjHdyW/4BRFBxclZYjb6YLqToH/cXFa+AeuDohi8zgv+hW1EBDQpiDuk4g12TDgoyDVIBIv9BNaeojiDDCQqyB1IRgH44j0G4OI2gIFEYFdWgIEXYi/5IMaegIHUgFV83H2rTj/ToNHCgIH4gFbDyH4IHStaIjWuCBQqCC1KxcebhVrEYjtdSAwqyClHBAdFnkE3/uDkVqCBR4Xv/sUslSTwfsCBjqBRY5x+OAJQweS1L9B+WABV/oH5KGZEU04HZ8SBPsXb/wQxTuZFOI02vCBUM6B8fiZNTSDyn9x/8xRQd+R9B0JUHuTgY9h9wABWq6B9FZ5ZZSDzs6B8Z9RQT+R8mAJc5uTmO5B8iABVV6B/Gp5dfSDwBoCBG9hSLOR+NqZFxqTeR+B9/+BQEoCDzQJhnaTuB+B/oABWg+B+T6Jh9Bz2t9x8VgJqSKJp7aTuv6R+x+RSp6R+riZmFuTi3OR+56RSwoCCXQJuPaTvw+B+gABXBKR/DCZFe6TO7OR+92RTPaR7RSZJLaSzVKR/XyRTZ/1ke25lJQUk832ke4bkU45kd5SlJ52k76Vke66kUZWCcyNmaxHMJCvJvujmbrFl4rqkg75kU85kd9fmSVHkw7YkdBYoUB4odCUpI8Yk6DcocD3oU6KAgapCfAko8EMV/iqkglymdmbk2m+kfnekUXKAgNROgjUc8KVqQT3GX8zGYMDp70HOY8+GOTuGN/qENHhqjtuNd/5GYT9GW/qELQ6qjxEM6/lGXT8ECCrIBTbp70HM5/0F1ToEDChIIV1p90DOO81FfT8EGCqICYSqB0DOE/rFjTzEHCvICa6qB0BN383F2TzECC8J0udEBCBCogjqohFqohnqoiJqoirqojP+KAJU4nS+zIIoEFQuSU7txCAeQqZq6qZzaqZ76qaAaqqI6qqR6AAZ3ok5DAguyiEtBT/6hPMahAOQyq7Sqh8RzlPNxAlKxf/6BBcchq7UarLNqkmrSCdMoFVoapb8qrMwqLMTaJWegIIwgFQrjHz6qG8DarNpaJs/KJd2gINUgFeCgIIoXq9t6rk3SrVNSmfIxd1GxByS4rOg6rz9FPMvpH/IYFcagIOkgr/T6rxUSAYCQD6ijj/7Bj1ARmEHqrwDbsP6xAF/gp04TO//xClKxhf/BBAzrsBxrHnWgD4tjP//xl1BxDa63sR2bsszhBLjnMyHpH1sSFaawIA+IrSr/e7PZAQMl0DUQIFDzcQdS0QFqaB5AuxvZirNI6w8Z8Al6hy+hsCCCExUvOx9mZbNJe7UQe2IU46X/oQRUMVaIaa5XO7ZCMKkH8wsKwpVTEXKwKbZje7VH0LLGoghAIAgy5rFUcaHLUaKwcbRvi7QwIAY+wwEuAAWzUA7jEAS4QD3cQBXsah6D4LZ/m7QRMJmLAwF58AxYKRVKOh+2ILmTi7QXpLW7hQoKsgCk+xp+G7pIKwTFIlx8qiB5Y7WsO7ZeAKu7tW7/UY65sbq1i7NzJFwiq6JG+7t/GwFVgIyANa7/8QXFa7xv+wB70LSIhQ8KErm0C71juwRmW1nf+h/r/6cbMmAA5Fu+5nu+6Ju+6ru+7Nu+7vu+60sE2yYtXjC7lSUKROlNmuCmwqICGflYYbAgDvdM9JCW0jIBwIdY/vMfH+hNJLAGs7oAj5C6eFWt8+Fa64QBZeCzoMIAaRADiAWQ/yGk+DQL8ysskGC/ePWC/4EHBqUI/BsrMGCmeMW1/2Gp8eQCBiwsKcAweNUFY5QdXIpPPuAKQVwmC2ADFAxW4TMf+NhQDVAGQ+soayB9cJVN/+GuFNUPK+YoG6CnaEVi/6GSIcUCUxsriMAraIWx/wHCIRUH0iUtKdDAX3UFU+dSK8Bw0pLE/vRVMWweKedSDUAHUywnDGAC9/RVev88HwWwU4vAkl5MD18lxv7hwjsFBXcrLCFABVlFDQtStDqFBHEsLChAx0mlqgrCDkMlAwVwxFeSAVLQx0nVxPLBCknFASk4q0BQlDM1o/LhBFBVBSkwq5PwSUMFeArSvUIFBTZFLlrAyUOVBQvSSlB1B6McKxNACUMFAdponVgVA0YqLRmACZjnUhTrH1bKYUbgyleyyztVD5KaVQ5ABJD8J35gzCdVgwoyTl9VAs0sLUXgqy6FAcPcvGeFBEwwq0qApCdlwRyHVklwKeTyAJdQzgaVkAqCz1l1R+zcJIRwgxRlrL83ZIBQz3IiCE9JUQ7Qze16VyWgu9KiBQLdUAT/KR+OYNFfxQYJTS4ggMP4tAgLQsNvdQGbsMeWa1BysCDNiVccYASFzCQCGVKPNx/T+lcO8AonfCVCILH/VEwK4pJo9Qa+dSWMYMUhNZbEe1g1ECdNAgKS4lIfYNLMgb2H1QYSLSQRILg6RX0ZYNaA5QF9kyMPQARCBdQKwtCHBQGjkNUVIgHKa1B5sCDEMFr74KoVYgWyrFOH5B8nELWPxQ9svSBH4MZDlX4KQrKVdQF9OB8hoMJCxQMLIoqchQCs8NS/kQJrOVRTLR+dTVup0JTl8QDXqlT3qSDBRVtoANPYYQOP7VL6/B/lt1t9ENrLkQZLnFQL7B99LVxX0FHL/7EByJZVxakg9pBcH6AGnwIDro1Vzy0fuHAJYCxcpPACKKDGaFVvzNEE8zDT2wUHiH1W6cUcERAA93Dd1hYasO0bDLANbsDLB04aM0AO6HBzD74a4V3hGJ7hGr7hHN7hHv7hIB7iIj7iJF7iJn7iKJ7iKr7iLN7iLv7iMB7jMj7jNF7jNn7jOJ7jOr7jPN7jPv7jQB7kQj7kRF7kRn7kSJ7kSr7kTN7kTv7kUB7lUj7lVF7lVn7lWJ7lWr7lXN7lXv7lYB7mYj7mZF7mZn7maJ7mar7mbN7mbv7mcB7ncj7ndF7ndn7neJ7nGcEFnEC9ej4U33A2VuDZfz4Uf+CK5P8QSYUOFHlQXL8RAty46D4xAtfsGxMQD5LuEw2APt+X6TsBAWDgH/KQ2Z4+E169pMpc6jDxmQsSCbir6i9RBe4F6y7hC7ZdHkfg4LROEmjQKBUSAim96yrhWcZ1DcK+EqWFW0h17CnBYBVC2MyOEs6+IN0W7Scx7QoyDtZ+7bG1IEuA09vuEdj+H8dwVeH+EYbQ7QoyA6R97iBB7CFSCNDo7iGBBl3sH0UA1vSeEe3g6xWiApu77x1xCrdeHgkwcgLfEfuqXgnfEbkcIkoAiw1vEQ3gYSKyXxO/ESNQ1Bef2xlPEaEACS2CAh7/8RKRBdltIeBl8hhxBuquICvP8hb/IQmn+u8/KPN9NN4iUgRyi/MOEQbnHCK48AQ+PxGqcJEWwggUXvQOMU8ukguvy/QPMQoF77HmLvUJ4QFU5SLSYOBYXxCq4AU5YgNf7xD3oDsiwgArWvYJ4QBl5yITQM1snxCJMAA5AgIDfMuDIIe7JdY54gTxrVRb4BvAwKqAhQFv7yKVkMhRBaT+QA5v/ViqALYtsgXDCFW34IqW/nOIRQuaHyIP8AlfRQEinx1WYEZ3tQKhniNlBVZ4ZB4wwLtoxQJaICRHEPhQxXnzUQtRAlYf0EJCsgyEDlWq8PLZEQj2HVU0QHxcVa6jv9kZdvUzJT0cHCJ48L9f9foWEglV/7tTyz8kuaDoWGV7LlILjH9SHgALVT8fweD1Q2UHaN8iPSClIQUF+C0iSoDaN4ZdQgIQJrD9I1jQ4EGECRUuZNjQ4UOIESVOpFjR4kWMGR1ecOfP40eQIUWCnKRK40mUKVWuZNnS5UuUHdQxGFnTppIfDmDu5NnT50+gKGftsFlUpBEKQZUuZdrU6VOEUEIYpepxEg6oWbVu5eoyi7OqVPGg6VrW7Fm0SpOkCWuUQa0haeXOpQt0RKkHbYsOMlXX71/AgatM0GtzxyKdgRUvZmwQHozCNV/Ug9DY8mXMPON4i1yT3I3MoUU/NeCp80hGf0avZt26IQZoeU+H3CXH9f9t3BgTaZgdkoEEDrmFD8dswElvkBGkrCDe3HkXASmQf4w0xfl17HQ5cKI53R+eVw2yjw8NwU0P7x5rhSHf3n1WQwDS+yuU7P19v8iOzDdzBv9/AHviABTZvBMEigATzOqZAebzBxj2FJRwQo06IcfBbWigcMOddGBrPgA04XBEEh/CwJgTHDRBhxJbvKgGMBzMAJrgXLTxRlXGcNCfFW/0cSEYu0uvGB5+NLLFbiBTkcUjfcwCDCG9W0WSypq0ckMZgFlgxzR6uZLETkzY0R93kvjyTAp1OGbMIKhBU0FZNhmTHCretFNCN0AYcxI9OrizvQ5+EWTMVV7x809E/xv/4RELxrRllBYSba6FTyIZc4EtLpB0U/xcIGZMfxIogw9OXZvjkVVADaKPUlt9j5oZQH2AENBczWyLAh0EAA5beyUPgkzQA3UGSbrwlTFoxsQDEAyOdRY7D8RRAlR/HAGmyGf9yiNX5E6Ahrlsw20uCQkapbYYETwQV64AvHuAm0TWlZc4PjTg1kFHWNFw3q4MQY4BMG7hd2Dh4gCC2o+YiSVegqGCZLYeG5b4Nh3ERNgfBjYRIcKJg8qkMzKw6njk1iq+2KMTwAgnKZJ5+qAJvcjYt2WaR9MBiCipPUCZQ1iumSUpwor4Z6JDi0MDc08+QB5hIi36JD7uBekBcLB9//pqzPgIJsWTUSaGHTOxtoiQmk74wg6x08ZsCAH07NojBnIRABW1I5pCJDzwCbtuvhn7QJLj3v4oCg30iKtvhWL1CIAqPkD8ccYgQEZHwT9iYBJMxFAX8n8k8WeMb6rkfPTAkPgChcpBskCXCm5wvG8P2CB9dsZGGEW+1FU/xoZw9qb9d+DLkiWApHP/KAdwAOnl9eCbd36pNoxpxfiRMvCGGy6wcPp57rt36QZ3pKN+JAZ+8P589FHy4ZRixhcpnPTjl98iVQTA3X2T5td//4dwoCMK6qFAdPwjYAENAoEpbMFtgjuGAR34QII4QBbzAGDXzAFBDDoQAjQoQw4uRuuEDIbQgWxAxwCkhpw6iVCFBZSBHpSxwOn4YIUzNKAO0KGNCPQmEDTkoQE9QA0peOKERXFFD41owBaUQArOeEFYrHFEKBqQA1ioBzFgKBL7RFGLBrRDNB5RDfF9xAVbJKMDHYCEbthgE2YYYBnd+EY4xlGOc6RjHe14RzzmUY975GMf/fhHQAZSkIMkZCENeUhEJlKRi2RkIx35SEhGUpKTpGQlLXlJTGZSk5vkZCc9+UlQhlKUoyRlKU15SlSmUpWrZGUrXflKWMZSlrOkZS1teUtc5lKXu+RlL335S2AGU5jDJGYxjXlMtQUEACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH04cby1KQ4orB4uNzWdU/vwtOCauz/LrVnVU8OavwOd30cP7/4tUSpMD7OiX0oDVSvwJD54HiJ+PR00JDOnzB6UhIcr88Pd0tsID//23g3346aegTTqUYUaB4tXSmQIQQojHPFQsqKFLcxjDRIXzIdIZNyBWaIs6NWyoIklhiBBEiQV2wlkRMIIoCBEkrKjjRpq4k0KNBVawWRZAlvjCMt9AsOOSEV1RDwBFQjjJZqlECaMtAmDD5JYJyUJIBlZWaIpmg4QJ4wJWIKMkl1uSQEoOZoIoSWZdWBBnjZHUEwObOvLCygR3gmhFZmgECmQEGojCp4IQwCGfoSCe8AFm80Ba5AAKrLmoci280p6lJR6CWTWgFhnJDy1sOlwo6iRQKoysZP/GyzvVLPBqiQlgcoWqvt1Rywu3VpjBIIBYwhkJlBCCQrAQRmDOLbzmpkMADDD73wlrUCKDaB8cosYO1s7HABg8REsbDUKE614Av6R6GgYlfKtueCYoaq5rNJAxrz8vrKGHu6zBq8yy85JBw72qYfGiugwEccoKtHmghxVgqmuFDgiX1om+6gJgjJa5XfDDBvOaYF3Gn7FhgrqO1PIMcH9IgEe4DICjCsqb8aFBtdYW40YXxFHQzcLMWmDErjhXRgInEVh7QDDOYfeEDU1Yi4I1ACftWAPnrGItJLMArR8HIqxjLSKznKc1Y9FEwmwGYBiiIw7y2BnsDCWsnVgnujD/2wQmYzKZCDQzByvEHXoTdsXOwQJQBXx8fiAJlLda8MgIif/VASmOBFtMOJpuCoECngQLQyaZ88XCh7cWkCHKinD86jEYp25XKOncOm7tWuuw8qsP0IG57XE5kM0BwGvggu01gMEzqIh0Q/xbOphd6gMaPDG9QM0/bykZdmyflgegEAgqA9JoL/5ANfwO6gSpdLA+WWJ8CuoaKc5fkA7plurNH/r7ig9q8SptXCOACLlB6UCVAWhQAIFaGQaNQOWNM0BQIeFwQqmOIKMLUsUHGiiVGSgROg8apANcUAGoHuBAE0JFDA+ylCMaMSkXLmQEUjgBqI7AOxsixQNGOF8t/9rgQ4fMAQgMfIfaikgUVGjQUgMAIBMfcgMvgMoZcphiUBzwjooZqgd60GJEHFAFcEEKBagTI0/y8ChDWQAUYVCjRIagBlARYltyvEk4zGioIOQvjxLpBTksZQYsAHImHKgUpEBAiUNWpAM/IFigHkCAJTpyJbcgGaSakaNLVoQPBbDUNhLhSZXoQQmQygELSomRaIRgkWJgZUko8AVIPUAKHJAlRmQQQkMtQAAl1OVG+CAISHFQmBo5QwwDRYbkIHMjJajaJCvQgGdqZICQMsPBrHkRY9gqUIzoIDeTucw4WWBO45RIC5bhSxvkMp0bWYE8IMWKasKzIU9ghKFsof+Je3okGtK8UzGQ5k+EyIKPcVLG8ArKEVPU4Ys4YKhBsmG+OB2gHRIFCSCAdacX+CKj/+iAOQx1jPCB9CM6oNydoCHRFWwiUAyAhvxOCpIWNMNQy4AcPOXAjECBwII0HUk3OnenSZAynTRQ4Z0GcNSgjuQWVrxTEU5mzXAA6k6YsKRTRfKBXloUqMh8xTfNtApRbRUlbtChOUWAzDIEagNZPGtK+lCIQAlAlg0YR6CkoVO5okQG/YtTLbSaRw8ENkwP+IFfW+IATARqF/YEpAwWaKYmrHKxLkmGJMM0iIWqMREzuBMjbobZl2TBbXHywwXkqIq6xskKPihtTIZAqjj/AQBiWrzDBM0EC8LKliUN8KqVJCBGHig1TBmwx29r0gjv1agZYjRA4cJ0ACgs1yZwuGqNgOBbFz7hlWHSQrmuaxMDHBdEQoisFo1rpQ0Ejrw2UYVKIVSNvhb3vCWqRGzhi5MhOKNCk/CsHEWBPBgFQL38tYkHdlEgJqz2kjgocIWIm+CdOIBE4sFFHliJgx9BSBwV9okUwhMF9bGSBdoNDwOIEOKfkMIfeBivLlEsHgtIr8U/gUdEn/kNu1kADTgOMkjQYIEJgFXISN7IIS6b5CY7+clQjrKUp0zlKlv5yljOspa3zOUue/nLYA6zmMdM5jKb+cxoTrOa18zmNrv5/81wjrOc50znOtv5znjOs573zOc++/nPgA60oAdN6EIb+tCITrSiF83oRjv60ZCOtKQnTelKW/rSmM60pjfN6U57+tOgDrWoR03qUpv61KhOtapXzepWu/rVsI61rGdN61rb+ta4zrWud83rXvv618AOtrCHTexiG/vYyE62spfN7GY7+9nQjra0p03talv72tjOtra3ze1ue/vb4A63uMdN7nKb+9zoTre6183udrv73fCOt7znTe+EACEB+M63vvfN73zHot6UCaWhCADwyQg8UAQveGQOfqeEK/wxDI+Twx/emIibaeIUX4zFw4TxjCdm41bquMcPA/IoiXzkhf8peZFOjvLBqBxILG95YF5eo5jL/C80h5HNb96XnJdo5zzfi89BBPSg52XoFSq60e+CdAgpfel1aXqBng71uUj9P1SvelyuPp+sa/0tXBeP17/elrCHZ+xkX4vZo4P2tKdl7f5ou7nyIAJSPBrucl9UHmjBDdeiYKaMxjvxrqCHLTxxPtsMPKTyvqILJMMIPQUROsASioIKXm+ahFEavuKBDBQBDFzoQzB1efm10QFIO/iKIuaTgCW8gwrvJP3iE5eMIv1xK+Bpli6k8A3cerL0WrtAkdDJFSvUiAEaKCXwtXb4EiW/K/itECiUP/vE1bFGzOiKKooE5N9XX29uABL/AwR8FT0UyZmXXH7S7lAk626lFEACACvVn7SAlmgaXPlvjeQx/+/rTXYlQgxb4QAeBiOf0H8Dlzr4ACRFsBVxUCQ75n0JmDnfUCQPhhW+ACQZ8EDUN4GJI3xAkjdZwQlA4g2yRH9JU04gYgxaoQ1AIiEIiHC2w2A1EgBaAQJAwgUn6H96Mw3xlxWhUCSJJ4EymDrIACQLYF9TQQ3ilzXpx4Nrgw1FckBX8WI1Ugiy54GZg1AgwlZXcVM1QghZWISpsw1AYgNYQVklIiQ7qIWJc3o14h1XQVQw8gtj2HDEswhAEghXkQhFEjUxiIe2YwhFooRQMQUamCCBKHHEswJF/0JVU2EPQMIEwoSCWgNeMBIPVkGCNbIGlQiFetNGJXJXVWF8NTJ9d8iIxMMKQDIOVqFPNZJGbUiGqWOFMOIMVtE0NSI3qXhx01MoNRICVWEKRdJUi+iLxMMGReKET0GINXICyGSJScMBRSJjUUELQMII0QiKeqMFQIIMVGEMQDIon+iGmSOKIJINVLEFQGIE22iOiTNPNYKGU3FYkveOtJg6lwAkNjgVRwAkYVSO+Zg5swAkxUAVXFghQ3iMHLc9TFgjtjAV1AgkGyaQgpiMQGIBU/EERaKIs3iRtuOIQEJQT4EFQCKM+AiStlOAJQKJTvELJfhM0qg18wUiIggVVf8AJEIgk9yoN7UFI14IFQtYI89nkao4PQEAJPUgFYoEI6holMg4PcBwhlKRlDWSCjwJj4kjDkBSlE9RCUDSSCl5lMSTkzWyeVEBCUAyDFk5kJkTD0ByDFLhjTXSC22pkqkjCz8YFahUI8szllFJPH0AJCAgFRZ4l2RpO5aQkVEhkjWCYAwZcuIzAkVSQ04xB4diTTOpNUVSeU/BC0ACA5rZk3rjKjUCLU9BA0DSCqOplYmjghUiRU6BiDWyAa3plpkTeTByA1ABB0CCi4gZmMTjB2sJFe0AJNpwm3iZOkRTInAAFSIAJCagnIlpO0sAJEHZFJIYhtQpnLbjPiWSnUz/8QNd2Z0NKT7gACSK9RS26HzmKZniI1wgsp5OUQFAQgfvaXLrA4YwgpVPYZ81QmGAeZ7bIwFAwob1CSQCCpUEOj0GWiMI2hQACiML2osNSjwPCiMRyhQTWiIV+pHVmToZuoZQ0aEg8qGRqZ/iM6IgsqFLYaITlp8rtz4sWiEuqhQwCiEo2oG4mTg1CiE3mhQ5WiA7SoTLmTk/GiQlqqAyCnM0eqBLGqBNWnNPCqFQUSXPNaU6tz5wqKFQQZ5EqaU/tz7yWSF29xRgCiPgIKZER6bqCZ3SyaZJtz6EACTK9RTRWSNLIKdOtz7g2YW9CSRBwKdTtz4uWCMY9RTDACR+/0CoWLc++gcjz/kUNwAk2RecF2o7mVciUwAVfwAkZuCoXbc+9lMiC7kUtwAkCSCqYrc+MAAkvAAVQQgkrHp266OLMDIHUOEBRUJ+r9EBCBCswjqsxFqsxnqsyJqsyrqszIoAD+Waa9MAReJ7TmE3MGIstHEIB7Ct3Nqt3vqt4Bqu4jqu5Fqu5noAXnSkegOCNSIVOFgjLgkbFLIv9Fqvo7o9LgAkSiAVNVkhslAb82qvArsvjMclvQAkWiAVxwAkmkgbATuwEMssBbsli1ojkCAVaQAkVQCwEduxwTKxTEIJQFIJUlGmH8axHpuylgKyS4KlBiYVNgAkwICyKluzcf/ylMQDCkAyD1JRD/xIszYbtEUSAYCQD9NjsgWCD1KRpzBSDUArtFBbIgvwBZaZOfZYIRsbFSWwl7PxsFH7tRVSB/pgO9xRI3YYFYNZIynwtGDbtvPhBFmQOphYIoYUFVcwrQ7rtnpbIDBwk1qDAUViYlBhrSUCiLHhtXu7txnwCd01d0USe1BhC0BCDXmbuJYbHVMLmfeimjWSelNRDEAyC5V7uZcrBBeYMeZXI0dAFVYJI5cwuqRruUcQtyiDDjpJFTG7f7Abu4kLA7GUMUFUI1tAFdkAJAOwu7y7txGggwhjijDCglNxhDWSsF2bvLHLAJyguXwCizBCC1TBA4//W73WG7tCgH6qolYwwotS0QJ/KL7jS7pecHt84odA8l5SMbcg0n2H+768GwLutyjOCCMRYBWRWiJnur/8G7sRUAWjtyOZkI1WoVc1EiuygbgJvLcPsAeNqyI6WyPkSBUCYLzue8GkuwSnuyRrACScYBVwGYyzIQMGEMMyPMM0XMM2fMM4nMM6vMM8jMNEgKvq4gV/ySSsAyN3ShVpWyPUyk2a0AP0qgJHtiIYkK4g0qlVwatAor7pRA+bGi4TQHwrooxAYoxTEQhAsggFRQIpvC8L8Ajamx8wWSOOgBU+h58FhQFlUFE0kwZ7oiJD+h+egBW5CyPbkFGzAMThAglD/7wgdZqlV8G0JeK5EqUITrwvMMCbGuJaMHLAVXENRQIyEuUCXWwtKSCL+dECzlUhlHsVHjBWJQKOIOUDrpDKwbIANvDGxMG5NeKZV9GvEIJ/J9UAZeDK4bIGnYQeXECYWtG6JbILTtUPKRYucJUeBFQjyZkV4lgjoepULOAf+4IIVnwdZQsjK5wVWwskJwxScRBa+5ICbnAdFEDFFfJRWcGuMPINZ7UCzqsutsyBxIEDRRIHW7FbJaK0Z9UAdEDMzMIAJrDEwPEJQJICGxwVxAAkZLBYi4C+6rIB9EAc8niLXOGDNdIEmAUF+GstIfA6weHLBVIKXAEFRYI4i4UE7P88LyjwzsAxBEUSkFoxArRcIDi9WDJQAD/9KhkgBf7MG8BYI6S1Fc0HImogWxwAf/QKBL56Gx0MIyrgFUj7H06wXFXAkuEyCSa1G4wDIx+8FZJwmL8FBe86L1qg0rqxAt+gDrqAyOLxDl5RA0WSDNd1BzWtLhMglr7BAVTwDktgmuGhCF+RkBBix8sVA9e5LxmACR7pGxDQB1wABkWQAYaIFRlbm/BFAUZQ1K9i1crBy11huyDCDEaQDOksWw5ABBodLn5Q1luly+LhBFugByRZYSXw1upSBHW7VR1AMIXADbRQkUmGBEWsLkognjRFCiLA3FCWBGNArw9wCZftdmn/QdqmXSqEEEfezRYOAAi1bS2CgK3lvRbRRK9aUNztnRZs8NzhAgJkPN9mcQEvxc/Mq99qwQFGoNClsgcA3hYO8Ap4bSlCULUHrhZvEH2GwgjH/OBsUQNwAioggAQWDhdtkN2QEgG/2+Fv4QFbQOBF8gAsRuJxAQGjsOAK2sAsvhb74NhondQzDhf8kOFFcgR9nONzcQFlcpKLDORygQCsgOLikQJMZuR1kQocBSEPcApOnhdoYH/zYQMyXuVw0Qc8Lh5pgMtcDhdXAJbisQF4NOZ58QFqwDMwUORqjhek8AIoEM5xvhdwIN13vud83ud+/ueAHuiCPuiEXuiGfuiI/57oir7ojN7ojv7okB7pkj7plF7pln7pmJ7pmr7pnN7pnv7poB7qoj7qpF7qpn7qqJ7qqr7qrN7qrv7qsB7rsj7rtF7rtn7ruJ7rur7rvN7rvv7rwB7swj7sxF7sxn7syJ7syr7szN7szv7s0B7t0j7t1F7t1n7t2J7t2r7t3N7t3v7t4B7u4j7u5F7u5n7u6J7u6r7ul8YCZsXuCQEFE/Bj8I4QRBYdFoDPz4QD8HBo3UC4E9DkrMQDM8PJgUYEqRzwuvQE3uwPUjBoXAkhKRCBl5QHuDAf3DDRdZak4XEAFA9IF2Df0bELn11nDcDMFXIA9gJIIzAJFeIM5ntnPv9g5jWiAtYoRh7wkxACAE1tZ6YwyiVi83LUAFdbICBgAHfGA3RpJSEguEXkAEgEJBMwqXMGBRJmJXiA9FrEn+K3lHJmD/IMJEKvRRzvfGJOZg4AC1Il01O0AixdI9UQ82jmA/tsJYXQ81N0AcQZJ5FAu2mmCtwbJjOg2mI0AkNuJijg12jGAlgeJZ6Q5nnUADQYJ1llZj+gx1YiBCWvRQ5QzXEiBJD/ZR6QnncyDmevRSF8J4UQq2AmB0BfJGWATCJAuFZyAuzwZYfgNXGyAK9gTWdw9WHSDA5uZY0VKBMQDuPUBwQdJuSAmleWCOhoJSpwqsiUCC5/J45wY1V2BsL/HSbMgNvj5AHsFCjNwIxN1gHQEN4lsgkOnU7QYCgA0ENNZgcLGyjmAHgM5QtRbiYvABCA/g0kWNDgQYQJFS5k2NDhQ4gRJU6kWNHiRYwZI7Y74M/jR5AhRfp7kE3jSZQpVa5k2dJlShw9Rs6cWcfUS5w5de7k2dNnwxHKaA4FuUPWT6RJlS5lmvFKMaJRm0RrWtXqVaxZEWqyFZUokydaxY4lW9ZhA1ZeicpbYdbtW7hx/3GwsUAtzWUt5O7l2/elJAt3Z5o549fwYcQnOx0RPHKBscSRJU82SMNM45G1fFDm3NlwgwoPMIdsUsLzadRvh5AZHZJwatixqy5uDVKQ/yXZuXUrhSDAbm2PGmTsJl4cJQcpooH7+0LB+HPoK8WAWO4vBNXo2bUfZJGjuhI928WPh5hoW3V/BfiQZ6+bRDP0G261p19/oAMCyoGj+NHB/n/JKKGuunk4APDA8bC4rDpyekHwwbiQOK+6HcKB8MLoZCAEPX/UGAJDEK8KQ4rAqhsgjxBTJC4TFNDboQoHVJSxJz1kqi6Dd2KcccfU5HCGQy9u4HFIlf4YgEMnRCFyyc4ceCcDDoGYg0kqJWqjFgY4NMKDKruMTAfG0DtBihG8NNOgDxpxhEMzxDjzTb8ogEa/5VTgwj84qYSAkgXR02CzPAOVizYkLRSUxzO84f/QnyKGOfRRuOSkczlPhIQUxGu0WdQfzS711CxUJtlUCB0+PbCGNTZtxU1TWxWrg3NS2NSEGlxl7wlpsuTwAVC4tPVXrOZgbVEGwKgVWOie0GDS5dYpFVloreoGkU2LPTZa2VxYdtMDstERW3CVGoEOZpcz4dlwO9MBDF0XTSeUdONVSodjNvWIDEXkjYyKAuz1hwkW9BUYqUxg8NcTBSAYWC4IwoHKXkdIwWBhinka4ZESNwVAkg8qJsuDKgDwl4FmrvD4ZJ3uEMJff/CAJhGUrTIFkyZY1qWTmHPGqYQZWLZAHhx0RsoQMKD0FxfshFZ6JQdmoZbldUQwcGmXupj/BRKW/VnlnAao9lqlFqxpkeUmbJjv65PYCKYjliPghAS040bpCiMy9jeIbpyTW6Iu3HiYZQY0WG9vwjNSBZx2/cVDgj8KZ+iZWtbM2h8T2HD8coz6MGFyjzb44QLMB8LGGJE5JwPn0FOvSAcrOPcnAyv08FXuFU4JInGWt8FCdd4tomFYzlFQpoSJqW5BjzVecN0fMmjo/XmLRNl8+R3UID7nFn4J4ITl/VnCeejDr4gHdruv/pCOF5aBkjW4X56BANAVf/6JbjEngu79QYEQSuBO1xJADMJoy3tBLe5APwRa5AqYSED+/LGAaryDF+BKS/4SoA54JVCDFWnBDyLh/0CPVANbh+heK16hlw2msCIQUMCR8jcPbH3AfVkbABwUpkIcRk8D+HMdGsDVOn9NgBUTzGERLxKDenwwaxboArgkYa8cnMN/RqSiRSCADCv8ZlODCJcpOJQBQhylimPMCDYE0JVFpSJdogIOAOphMjLGMSMQ+MYylFedLKSrAq1JgTs0IUdAokQGRBAEcIoQr05gJggiCEMgHZmSGqgDjY3hhryeFhUmGGNKj+SkSqgwDzwIRgHyqgVRzFAG+XVSlSjBQAnUsIOoPKAt8brHTKIgAfCtUpcsaaUaQjmTAejLAzP0RytgkctdJrMlDtBEKZQIkncIrF/eqEAqlXlNl6P0QRzH+A0qBMYGbGBTnD0ZAiVqMU50plOd62RnO935TnjGU57zpGc97XlPfOZTn/vkZz/9+U+ABlSgAyVoQQ16UIQmVKELZWhDHfpQiEZUohOlaEUtelGMZlSjG+VoRz36UZCGVKQjJWlJTXpSlKZUpStlaUtd+lKYxlSmM6VpTW16U5zmVKc75WlPffpToAZVqEMlalGNelSkJlWpS2VqTwMCACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevBV97AeU27Nl4Z1MQR6+HPHzPbwIOrhcDDnjsAvZP3XuBBuPPnXBs8ayQkgfLryXFA3879aQca0ypN/8BOPvmi7ujTD3XxidiB8vCTb1FPv77NLvfMRYrPP7kn+wAGqJIdP9TxQn8I9paCAwI26GBH11ziRYIUJofEgxhmCBEEhuxhRoUg9taOhiSWSBCHwMAQ4or+gGLiixgaUEoULNY4Bow42veEAMjV6CMIOQbJ3QiSFOPjkcklIuSStkEAhTQnICmlP8MwaSVreRCw35RHmrGLOLds5oEcV5aJEATfELMAlyzisYQAb1zwWSYMkAFHB2aaecE7uLAZIiOsiOACaYIkp4UAV+S5pCjjHOgnggx4IwEccprWB3YWSEODoi92EI2Rj/bHhBEKkLBaMPAJ4gsGnGI4Qiq2hP8aXxMBZMKHax5YF58WsazQaoDYwKKErOVtgAkVDNImQoJKlHLrr+mx4Y4FxF73Qh1EYCOcMxVaME4N0G5HgwnVKodCAHr48FwNKzLgyqbhAnfDGOX2hgI4cHzAnQQ+ktFLvK/dEES9JwQgjL7dcbADkkHcALBqApe7wBgiqKseJVwGAe/Do9GwTblHpBIKgAOzScY1HIOmgxXVJmBEJwLeIesuF6asmRzgMEBsELRw4KAkOof6gBra2lzZBXRQG+oOsISZoRzqgCDrCTb4ajRkHzTyXqieiOCziQ3oUY2seHzC6tWM+RLroy8oY8CSOmgQQagAhIN2YjR4EioIFST/UeYF4oQQ6iA83E1YIu6EesQsX+fZgBszPPoAMKYa7lcDjaDwaBDfAPxGyWzuQAQElu8FhRN+MrCLdimPGzSXfrBeel2mAOHnA/KAi3YNYDzAJgO1VD47XA4A4gibFpjzxOxPaOA7l3jAM/xbokyC/BbPTt/881Nq4/T0aHkAy5pTPqCBJeAX9EQ6ryMZgThnpz8WFH1OyQAYcch/UA27sOkFzPr7ygo0YDIdBDAhNAAdkh4AisYdECvD4M2UBMGCBy7kDeTgEgCwYEGrDJBLkYhGBxkCATfQSEoLsIEDR9gUMXxISglIBQVY2JAuCEBzUjoCAGmoFA8YoXzziAEP/x9iCmWUTwB4GqJRRNEjJG2DF0qMSC8KJaVjLC+KQXFAIzIgJS38AosSKaHUkISCTIDRJ3kYgJReIIUunHEiMgBG+2pECBm8MSdwWBiSKjGoO1KkE7mQkhmo4EeacOCHSIKBLwppEQhk43hHegABksXIltxiA1JihR0raZFE9A9Jg0gUJ1Xyi2EdCQCaGGVG0CBBH4WggqosSQMQ6aMHYGKFsaTICGqBpAWIg3S5BAk2Anmk/wVzI7LYUr+Ed0yNyEIFR8pABeLXTIy0ABhIisQfqpmRN5CvRkcwIDc5AoUX1mgCtBinRTiwjhoxQIXq7IgPCHgkCSQxnhGxBDRDFP8IQ+DzIwpowpEG0IZ/RmQK30yQPEZg0I8kog5dEmdDG3IOCh1gRBMFCSAcxaIU2C2jDAEDgo5hB5CG5A+o85ExTKqQLkwIPgyQAjVZ2pEW0LNG4JghTQ2iilWUBwRn2OlIfIFDFhWjoEIliDexUw0lJVUkcWCEjyKRv6cKhADXkcI9rQqSLiSuRk0gJFfX0JsE3IOrJjnF3FgUgWRw1QdOmMH30EoSUaytXaTgqiXcSNeTDEEbPpJAXwdbEgfAwkfSaABhFxuSdoyHRQVoDmMnyxFUFKFGumAoZTeLkVC0k0VeQCpnRzsRDwSgRoUgE2lXG5EK1KgIV2StbBmiB47/gqgIfZytbhGiCJ+uSAWF261wC4KEQLAIuMNNrkBC4Q0WJUB2yt1tC8jAogNAMbrCbYA8jhtc7O6WDtz1rnBduyJExFa8sv0Ei2CLXt36IqEUikQe2jvbcCgNRIyoFH1Xi4b7VigXYdgva9/wWBANQrECJi0LClwhE1AywZtd8IrUAGEFM5hCAqjwaFngXwqxQ8Oc7W+IMlACEG9WxCBSAipMTNlfwBdB/2HxZE8BIkGIVsaLRQeFdiFZHE+2DAiCBTB9TFlWxGcBVSDyaB1AiPIooXNKHu0HuHWdHmwzyqSNQUp7AwlTYJm1dhCcP5YQ4C+zFhUo+MKDzUzaObD5/81wjrOc50znOtv5znjOs573zOc++/nPgA60oAdN6EIb+tCITrSiF83oRjv60ZCOtKQnTelKW/rSmM60pjfN6U57+tOgDrWoR03qUpv61KhOtapXzepWu/rVsI61rGdN61rb+ta4zrWud83rXvv618AOtrCHTexiG/vYyE62spfN7GY7+9nQjra0p03talv72tjOtra3ze1ue/vb4A63uMdN7nKb+9zoTre6183udrv73UpeM7xrU4tqLGII864NBvSYgSXQogWqBEICBk7wghv84ASPRZ7fgJ0TgOEeOi1kAZBEgDwbsTyr4AYLhnzGiR+p4nemwNbiEwVOrLjjFP/H8zcoRGGUfxzPaqBQiV3uI5DX2QF67I8KZqpEj9f8ziyg0Hze6PMa2ZzOe6CQLO5YdBYdfc7GRdAO5N3zlNf5UglqOdGtTmesJugNfmz6ip4eZ2L2RwkRp7nR6zyEOcIHCBLnupzhQaF0hl3ucU5Hgh7ATLU7nc4QECiCBsBIsYeI7Gy+BoXqUXi8v3kaFOou0x3PZjUiyAyVNDyIEP9lD3QYPrXIPOW/XAIKCUP0L5czKBK0gE3GPfVx9kOCYtx42L95BC8uzyU4qfkKcT7KDE/Q0lH/8zhLIUERwOXWbc9mKvdnG6PsPYV+T+QPfL48FYj+6JVMBQpNQfvM/3L/PRJkgR7XvvhvJheCiqFK6SeI+j5WEYLK0P7t+3gOFJoN+NFv5nhQ6Mbnt3ZvZgMJ0gqx5H4IAn8yZnn9IQ0HaH8yBgGm1B8/8IDhp2QuQCHPYIH8h2V6sHcIs38CaGarhyBekEsI2B8KaGL0giAagIIQyGKIkCCvAIMX6GNDQCFiVX83iGNBlyAWw4MdqGQ/kCCBEEwpyB8rqGHmkCCugIQxCGIMyB+7Z4NDSGQ5xx96AIU9yGIXQCF9wIVXiGOGwHrKF4B/92VukCCFcExJGB9LCGHHhyBW4IZRaDkfwAvC8A4aUA2AYBWf1B+cYIddeDUYcAuHMArzoA3mlBzj/2AVL9Uf5yGGI1g6CpAD3AMf1WAVE8gfsGSFlWg595AgIVAVX5gg2cOBoWg4PEAh5gcVBkB+VEd8q3g3H0AhuiMVH4ggOdBMbwgfcQgwl4UgUCYVOoYgN0KIY4g2zscfREAVqIIgQ0eJaTg80pAg9DcVrpAgK6WMtXg3mJAg6UAVkJAglOCLd/gw9pAgmzgV8tcfqeSN1Tg7wdcfkTAVGEAhqkWNYwc+rYggFjAVeUAhZ0iL81g6JEAhfhMVOJAgO1BNv1gewQgwUYIgbCAVaJAgTACR6fgwrZAgQRUVkpAgySiP/Qg+oNIfdgcVxpAgDoiOhWg0TYYgChcVSYcgg/8Ik8uINl+QIFIgFdeIIO/AkTFpM/iQIKEXFdSFILNAlDt5NdnghFJBRf2hAE75jXezi/3hDFKRAwmiCFd5kKUDBQnCCFIheP2RBWF5ktMjCgkSBVKRe+ThVCZ5eOmjCgkyAVHRBRQCcDqJlWiTkAmSdkwRCgnCANwUkeQxkfECARSCb08hMwiSAInZkQ/TifHhZk+hA0ZYmUVpM2LWH2H4FDdQlp75lFdTCAnCQU9RegjiDacJmGiDSQgyfE4BBwkSBLEplqUzhfGhf06xLAiyBLvJltPzMQgSD1AhnP1hAsVpl+mjfv0hAlBBBAkSAM+5efKzDAmSZE9RhC6Ynb7/Jz83xR8V+J0J8oJrCZ3gU57xcZ5OIQAJYgTiOX3y0wwJUpNOQV79IVjrqZ3pwy8Ikn1PwZ/84Z9/yZuWI6D9QaD7mSAIWpcACj4Myh8O2hQGGh8Ryo/sOT0VGh8XyhQZCh8bCooKajgfCh8huhQjWh4lqoonejcpin1Q0aLk8aJCKJtXM6PksaJKYaPYgaMiGKNow6PY4aNJEQsJ0gz1+X7yg00IkmHoGZ7/OZ7p457wAZ9NAZ79oZ4JapzDg6XloaVMUQUJsgxNmoDyc1oI8oxPwZz84ZxVap/RmSDU+RT+hyDQN6dOmj5LYKdQgZuDl6YqKD8K9JtQIQsJsgGE/6qE8tNcCDJzToEFbNiocCg/UoUgDvMUWNcfpcinapo+UdcfEtUU+IcgSmCpwCg/utIfdwAVOZggHGeiYDo7blceI/MUFEAhfUcbHYAAwBqswjqsxFqsxnqsyJqsyrqsCABRn8kxLUAhfPUUFwYfqiAch3AA2rqt3Nqt3vqt4Bqu4jqu5FquB8BFz/owicB6UnFC/SEKwqEA9TKv9IodjBkuWZAgTSAVmdofUBCv9Rqw9Hqv0KIICdKLUdGM8bGFwSGvAvuwxEKwv+Kw/SEIUrGNCJINAAuxHOsnEtsqs5AgZCAVvIQg+LCxHZuylhkv7+CSUjGH/fEFKKuyNLsiLv8CPpyQIHsgFUqKIIQwszUbtMgHCPkwPUHZH90IFbSQIOzXsEL7tBSyAF8QgpbTgv0hCVJxBgUItFDbteVRB/owO0yQIGggFWyQICfAtV67tsrhBGppOVkYH9DlFEnAq07LtniLHTAgqVfDARQyX1JxfeQhebRBsXl7uP6QAZ8wi/EiBxTCc02hTPwBdsBhuIibt1KLYDajCQkCA1QxNghiD3d7uZcrBPrFMRiDIJBAFXqHIJgwuqSLuEfwthzTkgjyhFMBZAjykrZhubGbtzAgBimzBQkSDFRhnQjClZX7u7EbAVzAMVbLH+hAFSuHIEUAu8x7uAzACZoLLV6JIAz/KxXskiBU+xq+m715KwSQ+SsOILjY8TZT4QGRt7zoG7tekIucwgePWRWhyR9n1bv1+7sh8K+t8oNnZxWgGx8PkANWCcAB3LxVMKtXsggJcoJVMQ7YYQbaMA+jcAi3ALmucb4PjLcPsAeMGySlkCC7YBWAUA0a8A7CwAvl+xwiPMJ4uwSnayUsgyA/+U8yYABAHMRCPMREXMRGfMRInMRKvMRHTARrVS5ekFtWopoI4gaWpgmtVC0qEJJMwgFyiR3+ZGn0QJvlMgFYyySd2h85PGkkQFb1sgCP0L04opX88ZCZhgFlkImywgBpIERBcgkJQnibNgtPXC2QIMUvgrH9/2EOnaYIWUwsMLCpMDKq5ulpLkDG1ZICZvQiPkAhn8hpPuAKt+onKSTHGNJ9CbK+ndYAZfDFbLIGveogr5AgiDBq/VCtobIB+4ghYkoeJRlqLOCu1YII35chkcgfNztqcRA59ZICVvwgH6DH8BG+o7YCOywxNkCY9vEMFILIotYAdODK9mMCVhMgXMofSiDBo7YIFVkuG0APAnK0/CHIqQYF/UssIbCD9fGRCGIDrIYEzFwuKPDM9NEGFKKcrCYDBTDKbJIBUqDN2xEOFKKZrMYBKTyvQKBZ6KG7/eG5sFYFKTCvk1BS6JGScSprUDBG5aIF+vwcnpcgjCdrdxDQ1f8yAee4HVOgg7QWA39aLxmACSBMG0B6HRYww69GAUbA0GyS0c+BnFt5aw5ABO1cLX5A0sDBAYUcHz18ayWg0tVSBKxpG4r6dbqGBGNbL0pwp7UByAiyABqNa0kQvcTyAJcQ1KihNwjiB72G1ErNJYRQZq0hA+KcHMm8a8Uz1cQiCOjTGsIgc8BWAmhZLVoQ1qpRsv1RfsHGBmddLiBAl6nRiPFBz8B2AZsgMc+7Gv+IINNAbIc02DWys6wxfgmCMsTmAK+Q1VMiBEZtGr4JH02gzsD2BvvEJYwQy6ZBAtJcHuOIbDXwvVICAjXDGkubINKTbG0g12wlvK5hO5Ciysf/5gFb4Nrw8QBu2hoUgJnwQXvKBgGjgNsUIgHAfRr1WKjOtg9xmyBWANGpEXMJMprOxg/OnSBH4MeugXOdGW0XMAgUEgLevBpjjSCwHW0IwAqDnQKf7BrEmyAXDm2pYFvY8QCnYBsYMNx1fMLMhgaRfR02EN+p4ZoIonXV1gcBnhxpYMqtwd/EmG1XUAnXsQGuVxuowAnCXB4HoN/S9gFqEDQw0OC0AQEswA2+RR7K0G2k8AIoUMzbQQH3AAaI7Q+Uy21woNbo0QK0sATougN2nW+mMQSLUA1Jqea1YeJwPud0Xud2fud4nud6vud83ud+/ueAHuiCPuiEXuiGfuiI/57oir7ojN7ojv7okB7pkj7plF7pln7pmJ7pmr7pnN7pnv7poB7qoj7qpF7qpn7qqJ7qqr7qrN7qrv7qsB7rsj7rtF7rtn7ruJ7rur7rvN7rvv7rwB7swj7sxF7sxn7syJ7syr7szN7szv7s0B7t0j7t1F7t1r4UFH3tSOEAX4AC8KrtRxEGPR0CVg3uQmEK5ZgcTkDg5v4Tf/DI/uAMu93uN/EN6N0bhCDn9A4TVeDKrLDvOQEBh9Uf2QjwNOEBgdgf02vwMtEGVJkgIc7wMIHXFbIAXyTxLoEK984fFlC2GN8SJYCu3eLxH78S7LAiFrDhJW8S8hkiE6DyK08SOP9eIS8f8ynhANJJ8zBv8yDRAAru8l/O8yQRBmY38kJvEhfQr93yUUc/EnkguVG7SE0/Ek8wjCHyCVNP9TO4Ikia9RrBAyReIXTg9SEB9iwiDzZO9hjBCyMHImTgl2rPETjQqiDiDbka9xth9itiC9GN9xmh9yGyCmDp9xrhAlYPIi9AzYRvEVVfI12/+BAhB1S8IgHwipAvEW1wzCCyDnd/+RMxArrwWifn+aWlmMkxARhF+hLRAPIcIrCg76pvEEaKINrA7ibWBYv9VKTQ1/FhC99uYrcwA04QhEmVDO6NfBGvYfegK2uAVlSQ4iDiDtO6Xx0As73xsc10B1CPX1X/RV+JkMDJsQBBn1RtYNIhggJSj15n4NXKsQrXylUUAA5H0gxwr1wYIAVK7QXT/1S2CxD+BA4kWNCgkz//FC5k2NDhQ4gRJU6kWNHiRYwZNW7k2NHjR5Aa7RwzWBJMSJQpVa5k2dLlS5gKw6UoWbPkC0Axde7k2dPnT6AQ2x2wafBcUKRJlS5lClKHmaJRBdZJ1NTqVaxZtS4cIU9qwQVTto4lW9YsxTYDvhZtouDsW7hx5RoKtLagCkty9e7lGxNDMLs2NfjoW9jwYZUcbDAIXHAdB8SRJU9mSOlEY4NmoFDm3DmyjiOYwb7xXNq0WVG2RBcE1uL0a9hXMVTIsHqg/wpZsXXvDkpiie2BkXLzJl6cZScvwAXmwmbc+XOVxhYo91drBHTs2SNyUPeAupEG2sWPp3gjBPUeaMivN64JAHUlv9jPp39lEHV/u6rS599ZBiv8NrilPwLFc4AA75RzJBsICnSwL19gwM8IyB600DkqoKIul04u9JAsFyrBbwc4PjSRNxIIwY8BYGQ48cWkupDiBfwGyANGHF/LBAX8QHCjwRyDfOkXLfDLoBEHhFSSM1VIwk+QXpaU8iNetsHPHwBEmXJLxDoQIEHqlDGFSzInimEeMJULxoMy2+Srk9DwQ0GALtx0k4JUErjSDDHs9FMuxabDL4of/5wynkiu9P9HgxUMdfQtLN67khzSHsWRBUEU7WEYSzstiwNQ0lQuCBo89VAHMhRdtFFTW9UKOVV3qcHV/u4Ag7ErcdmMVl5lEycCRRlI54lex7NEA1GBWwAWNot1lqlbtFH1AQ2IfdY4PrawQNVJtLz2W6XgwWPaasGN7QlztlXUEUCSNPddoEioBdcrHwBjVng5q0GeZJUDYsx8A/YJBz9U9YcBE0oV2DAcdqH3Sid2XXhinSAgYgeD/QmiUorh+iaIjFFoJLyOS4aJBGD6VW4GN0g2OSsOZonTYHf2e/nmlni4L+MQxLkAZ6aSqACEjP3xRGGgk14pHEkNjkADHZT+yQBlaMz/2BZfpNZaJQw+GbfoavRweeuVOBDBk6L9OaCRD8h2O6QVbLisaBDUkePtkG6BBeOiLaDjZ7wD9wgbNVSmjgFJBNeIA1pATpsBcO5WfHKOkNgl7Tsor6gTI/RM2x8rotZ8dI2uSVXVIEiHKJRUZk57G6RVl90iGhzHj5LZFQpDhDEE/TyIG3IX/qIbbLdthwpJ/0CYAOb+XOPgh5feol5OX00C5eEAh8fnBRoj+unDr4gGVx62C1/FfdAjAO679ydh8eO/qIZx1F3LGcWxIaIOq923wB02yE+AF+FDKZSwFhG8zQFUwMQG3EcQJcCiOQOkoEVWEIsiFSUBzZIaHzIR/wC+PVAgtkjFdSp4QotgwBeZqkkwlEYCBRiBCSIsSDGi0QEU5hAjNJCG/QbCi5tdAA4SmIT5RPiCcXhLh0u8yBUEkEF/CKJkLhABKxhBw5Lg4h2AY2IXL9IBOJCBAZkQ2BDeIIAlfA2LYCHGN4DkRThiRA4c/NYtprELDa2xJJEgwI3i+EetDUOPNTmBNKDwRkAmEmimGGQNJWFCRUYyaUQbJAAEYC1JZhJoY1hjFEphAE2GMmmgECEMgGEIRIpSlSVrR/fMsAdUrlKWN0NC2rxwiWvMUpc3cwBNrvSCOvzADrsk5s3QppxImOMedSpmM022hdUcgBifcIEzrfmyRbUEZgKVMAYNcHhNcJYMB1JJgBAa8YyxhVOdE/OA7wgCAHfYgwepXGc9J8YMgfSAGOKghovs+c+XweENVwBoQQ16UIQmVKELZWhDHfpQiEZUohOlaEUtelGMZlSjG+VoRz36UZCGVKQjJWlJTXpSlKZUpStlaUtd+lKYxlSmM6VpTW16U5zmVKc75WlPffpToAZVqEMlalGNelSkJlWpS2VqU536VKhGVapTpWpVrXpVrGbVNAEBACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPJ5PwEAW6tOnSLbIc+gQKjDNbFvz583O6tu3ILVD5EqDMEwjZwIPLjnK7uHHBLXBkkjDGjPDn0DMcn06dbp5DAnbhgs69u78L1cOL/y+bBFm5AiG8q+9eY7z791cdoPokrdD6+95lwd/PXymHGwKMgQJ+BHrXTn8IJthTA4pUEEQEBUbo3SgKVmhhTDycs0QKEnbonRQXhigiSSv80kwRHqbonQYjtugiRnGcE0QGKtbYHRkv5qjjQhA8UwYANgbZHSQ7FlmkA7JskZ6QTEKHiJFQjujAGWqo0OSV0D0Q5ZYKGgLMb1iGCdwJrRTTApdouocEJoGI2WQRuihjjT1vsLFCmniGF8MrfrhZIyLbfDHKIXFQkOeh4jmAzDIv+CkhDJVIkAkNdyJqqXiWWNODowQWEkAjJVxx6ajidQBHHQxwqh4MrrwDBQmkxv8a3hUCaKEqdwyQ80U7c8jqa3U0pEPjrcE94IkUyIzw67LHNUCLIMQGN0MpyJzJ7LW3yfDOptGCIA8lbWArrm1zGDHgrQysI0AnEIzrrmm8gPPArScQM4uo7+b7GQ1L3HqAMgp0oe/AnU0RhKo7qIGMoQQ3nFkJnnCKAjiHNODwxZfdUIyjGRTQzgcYh0wZFgf76Q0gSYiscmQ6COGnCqXw0rAqf6xMmSpguMnAGPFY7DAhDMhjh82PJRFMbGGCgIkcIXcCnAV0gEd0Yh8Yo4SY1XTjc8hjCJcAOhxMbRgtzmF5ghp92HwDd5HoIbZgNECLZRTGSG1zxN0V08nbfSX/4k6YXsCztc33rMdAM+HyfVcDjZzbZCVQ8A3BEfg5QkoHitMFhRNXMhAAaYpTEuERmmQOVyJAXPmABneY3kArHYKDr+lpOfCJI01asEWvtBORYgKLtEu7WXGsk/sWfAz/jweI1FgMD8qThQ3uQT5QS/LRNxJkBtCEHX1Yr9jIQDpPfP8PBzsw6QQV5n8FgdweFiBz+//oQAaTDBhhLf1a8TKvhIIoHf8GwgLjCSkSUxigVqQQIVz8QoEG6UabhASM/UFwKh6A3X0SkIrBXVAgHGjEAYTUCix8kCpQWM8DvhCDEyIkCaxIlY0WoA4MuDAqyvDONuZ3Q4ToYABCggQb/3rolAs0ATpaeCARF6IHbtUoAlxYIlNEIBwLSEFgUlxIGGzwvxpZwW5ZNIo2gKONOITRIVkAoo2iELkzFuUWEQABLdwIETccsUYMuIQD6DiUYcCKjw+5wN9sVI08APKQUjnDBFWEhzcg8pFOacEeZJgiBpRjj5DMZFJ6wbkabQKMmgylUDjACUp6qAg4EKUqh2KIHNToBZlYpSx/0oIt2MgcHpylLm3yjSWl6Biz26UwaTIEV9RIC6gYpjJpUoUTqGgC0VimNGFSA3LUqBzTzCZLOGBLFaXDe9oMp0l+McIUFSNl4kznSFQxCRVFAgnqjCdIOMAKFe3AEPLMZ0dEMP+BFL1AifoM6EV4sZ0UkUKgCK0ICVyWIlgk9KERcQAmVDQOG0L0ogz5RT89tAQPYPSjCdFB2TpUDWWB9KQEacPGPLQOUKL0oxSQR4pmkIiX2lQAKSoE9mx60m5AqENFKB9PT2qI9HVIBdAbKkjjsMgIIVWpIL1CO4+aVKheNAyV8NBTrXrRBgRAq1XlakId8AWtmlGsEK3AKVWBVoj+wEOFMGRbE2qPBXSIES6dqzx9YVcJQcKkeg0oGpAWIU94NLCCJWyB6pBLxKZzsB1ShmMT26FHTFafkJUQhS4rz8xGyBec7eywCmSBNoY2nXyV0AHac9p0SqJDgUhca8M5ig7/5QJksw0nTiUUgNyKsxQdUodvwymNDolguNlsQNciFIFUIleaYZhqgaIQiudKMwn2idAxGGbdYT4BTAVSQ3eX+YyfFugT41WmHiT0AHymV5jTkFAUgvleWY5DQtvAZH1l2QA1FggT+9VlDApaIGQEeJa8cBx+VjG0A69SGBJah0UdLEprSKgMFF4lMSR0hgyL0gfMiFAI0OnhTLJBwffBUYk16QsJnWPFmiwrgZoQDhhnkgLwU08lTGFjTVrCqN15wYt7HEpkeIcRaSOyKOnAnWCAU8mapMAGhIMIR0J5lXHgkGyIkdcrZzIT/kjBIry8y3K0jsxoTrOa18zmNrv5/81wjrOc50znOtv5znjOs573zOc++/nPgA60oAdN6EIb+tCITrSiF83oRjv60ZCOtKQnTelKW/rSmM60pjfN6U57+tOgDnWnE+ECURMsGAwghHNNPS4SOG4Aw2C1uIzxnCMITta/akDzkHgOC+LaUqLzTgLUUd1fW6pP63lBLRps7DRhoUCmbTaXvoofckg7TaEY7XoocW007fY+RWhst3PUASeuxxjj3hKE8XOCFqYbSsu9Ty3eDSU5mFI9PKS3jiaKnwHou0gd8OV63PZvHaGBQCEQd8EvtAYCWWPhOUqCtr3DAEtA/EW1xc8SLv6iKeOnxhwfEQ8IBIMJh/xCZf8gkGVPHiIImFs9Q2T5hdaGH0HIPETdvE8Ub14hDABZPRZwtwKBkICiG/3oSE+60WNB4RIQyAQfLICNCEBhNRAoGVGfuoN9jp8DPHmAUq8R1Q/sdPy444RhV9HYA2x1/JQA7VoPsAOsdJ8mmFyBaU/R2uurCAKJF+5iPzBw3e7CvHto7+9tqnd2cHe8x72+I8dPM25o+A4hfrzaww8aKP/49zoDPyjALeDVvt8h9HU9hOhh5SV0eet2g0DH5Xzg6zvI9SxgCKrv/HjBq55iEHH1EWo9clFBIHTnfvbprQeBanZ80r83q/chzu91/1wOmFc9LJo+8rsrBgJFU/vOH+//JfDDANyDX+/v1QV+vCFF4BdI+Ln1gGK9g+Elup9A8J9t9/ETbdmH37rjdx8WcFjnd3jpVTLroQtZdH/4kX+n1QAbtR6XsIDU51s0QCD953/o113ngB8P4GsaaIDdRW3rQRsUuH3IhSL3IQFhxID34YCclQgEAlD2V4GzpQAEIlftZ4OtxW/rUQRn5ILrAYOXtQn4AQRByIOn9XPewXQtqIScJQcEIkAn+H++hYP3wQBhkIQomFsWdh9O4EZCqB5E6FhWgB/yIIZQeFkjpR6poIZd2ForQCD6wYVWOFtUQCBCV4UbOFyLgB9ACId32FrAgB8qZod96FuDgB82QEdj/+gdZRhYUYAfsYeIIuhbI0AgoGOJlodcOEAgIFiDcRhawbYeZsBHj9gdkThX+IAfY4CKa4hY6YAfwQCLo8hZ0qUegGCLgxhaTNgd38CLidhamYgfbOWIsahXf4AfC9B4O3iLkxUO+BEIgJSK3LGKaJVx6xEE1ZiMcwULkteN0OhYqXMfAiCOvXhZeLMesSSMlzhbL9cdGciH73haENBF6nFWyDiOgXUFoIiOwxhaOgB6h2SN0IGNXPUG+AEABemNaEVF9+FvAFmPoYUO+NFbE9mJuZVy9wEMDcmPeqUB+HGOGcl6vpUG+FEFH5mOjvV59xEPKxmQnBVi9yEGMUmRnP8FA/iRTCUZfL51fd7BO+6oka3VAARSKUNpkrM1BASCSAb5HAgJVVJ4HyjglA7JVcsYfVYJkm31DPiRA1vJkoHFAvixAWEpk5mzAlcwB7xwDTcwDF2GFHCAHwp4k0QpNhJwDBvQCkWQAPMHHHAAFdGAH9pwlji5MgioHgoAFRC5HlBnl0r5Nht2H5XYFOyAH4/Zk++nOCaAH+3oFG91H5IFmT7JN7WnHj8AFaG5HtmnmfinOCJ5H6n5FKuJfYZ5l1MTm+sxm07xDvixBbcZmWKTc+phfE6hVisYnKX5NhKAHxUAFci5HixImpvJN815H8/5FNGpHtPpmg2oONe5Htn/eZz40Z1JuZx46ZzQWZ7KWZ3MqZ7ayZ7U+ZrWCZ9OEV/3AZzz+Z18Q5ze8Q6qiR+teZ7uKTa6iZoBeh8Duo9iiTEH6h282RS16R1nt58vqDg5JJtQAWb3kZkESp9v05n3wQ6MiR/E0J4gKjYiuh6VyRRYuI0oyp9vM0b38X1OMZfQYQEJUAStsAHHYJ4MipYqo373EZhPcQHDcAPXwAtzcAVIGUpPKRxR+S4etx4ssGZRGhxT6i6udB/PgKVXqS+TeB/Ml2ZZChxbOi4o1h1Mo2ZnKhtpKi4EYn6P1AEIcKd4mqd6uqd82qd++qeAGqiCigB1EKbvMof4oXBndAgH/9CojvqokBqpkjqplFqplnqpmHoAE4ebNjMH+BEBmvSi0TKqbhKn10J89wEDoUqqrCompsos+7cezLCqrVqrTPKqyxIP+OEMtGqrvtqgDlMF+JEGvfqrxoqeRPNttplJonqszroeoMA3hXgf9QdJzfqs2AodEQAI+SA2JKge6FCs2TquwrEAXyB6K+Nf6tGih3St5Pqu/lAH+kA0QHIfVmat8JqvweEEWWAza8odZfpI7qqv4woDbycyLUAg9NWuBNuwGfAJ+uUwceCBwoOvDUuw5qqo45JC99EDoTSwFzuuQhCX48Kh6+EJHxuyF3sE/dowyuodSCiuKguvMGCTBP/TDPjhUDI7s+8KRQSTmBOSsjzbsAzACRrrK4rXHSDHrEMbskJAp+KCAaenHgErsE0bsl7AWuKiCgQCWBZ7tQ0bAvPoK9+AHzsgSiALtuMaAVVQscsCCPgxCWirtiH7AHsQsb4SDPiRDnNLtyG7BCSLKPGmHvggSjJgAIibuIq7uIzbuI77uJAbuZI7uY9LBEApJl5Qar/Sht7BbXamCfEYJirQYbKSsPixanVGD1XqJxMgCbIiCl2bZyTQcJyyAI9wtFHSmOohfXmGAWWAj2LCAGmwh4diA/gxCH02C5cbJpCguYhyPx3pZ4oQulgCAzdgKSq4HmPmZy6wum6SAp//mSYxQCDs82c+4Ar3FiYLYAO46yKycJSB1gBlMLVusgZ/xCWpgB+nOGj9EIF+sgFtuiXggB9WUGgsMKaOgggJtCWdtB4PV2hxMAOqkgJuECVhkL7csZiGtgJnWLs2wF06ogkEEsCF1gB0QL9hwgAm8KQvEgtmu2iL4EycsgH0sCPluB6bwGhQIHBuEgLl+yLZqx7Q0GhIIMESU8EukgcEosGMJgMFgMFXkgFSAMIX8gsEUlOOxgGDxylA4LUWEp7qEYiQVgVa5iiTwGwWgmzrgZGRBgW85yZa8MMK0gLA2x1DJml3YMSOMgGeqyAcex80UGkx0C+ckgGY4IzvEYDr/zEB7YtoFGAEUHwlXZwgRAqjl+YARCDDjuIHaPwe8ocfE5hpJfDGYlIEJrQff7weNptpSMAEqqIE7BoeHLkeA8hpSTC4bvIAl4DIx+ENdOlpjxzJTUIIWygeQyDMwRHKneYAgKDJfiIIFhceg4kfq+xpJXBHjqIFp0wdD9odEfB1ncYGrswpIIDF04HAOsZqF2CEfrIAOzcdWXkf9SBrHGAEKMwkexAetLaTuOYAr7C8NiIE6HocK7UeINBsb0B3TMII9zsdpmd20lYDXRokIABP4aG76tEN19YGuOwhEVDN1EEIzAi1xuYBW3DPBPIARDAeH/Cv0MGr4wYBowDQK//ottRxcPjRCPS2D794H1ZAxdSBs/gRVuPGDxONH0dAvNTBdfdBjf92AYuIHyHgvOJRdvdRCguHAKyA0sGRAlf6Hm13H4pwcanQKN3xAKcAHxiAzeqhAnj7b2jA1sJhAzYdHla9Hn/HcX1w1MCRBo1cG6epHgcbclcAfcCxATKwHxxQTuvBeDL3AWogQzBA1e6RDH7Hc/9ACi+AAgu8Hyu6HoN9c3AQy+IRA3/JHY6N2QnCBQSin6qNIDmmHtf72v3BBgTSA3VN2+PxCARSrbr9Hhigk0P92/shjWVJ3PtByPdxUMjtHpaAzMCRASTW3OHxhfexBtQ9Hg3Aw96xedn/HR7rJdWY893Voa7qAWDkTR28QCAMQMLpXRy1QCCv+N7HEQPOrB7CQN/Hsc8dO976bRsNEMTqQZL/bRuluB4ZUGwFXhvWdJELbhupvB7b/OClYQe1YNbqYYIUXhuhoA4JoB59vOG10QLnYCtO8tcijhkNAA+UIxzGmeLGMQz+hQINDePGgQNAU4s2Hh4uYM47/uNAHuRCPuREXuRGfuRInuRKvuRM3uRO/uRQHuVSPuVUXuVWfuVYnuVavuVc3uVe/uVgHuZiPuZkXuZmfuZonuZqvuZs/hV3gE1tzheLwCHhG+d1cQGTGWb6aOdz8Qa7dthAzedswQF6Cx10IOhw/9EHjOAdBobobHEOGI7a0ezoZ2EKhq0eghDolP4V4SDX6vEFm14WHfhZoU4W0EsgKBBzpQ4WScDd6sEMPrDqYXEGEnKisg4Ws+xwt/4VGGBABZLfu94VdrAKEYIC+RbsWWFkDaTUyG4VPkggA4DizZ4UDrANEjIO064VV4DO+DEN2Z4VhlDHA/ftWPEJEhIBX0ruVhHWBAICQqXuU0EBxyAhhTDd8A4VocDt9zEJxXzvUYEDNN0dYyDt/g4UGI0f0lDwUqEOHYLVCg8V30ogBP7wTPEBudAhm0XxTNEGSXsfrqvxTFEDjE0gCwBaIL8UUHDa6pEB3n3ySdFiEmIBLf/v8kehjaQ18zRfFLwd8zif80ORoREi8z5vFA1QqDw/9EXhAet480hPFCMACR1S8k0/FBew6BKyAPYw9UKRB9klIRGq9T2hCgJOIOMJ9j0RBwodIV/w1maPEzyQ9gUSAATf9irx9h5SCf1O9zlh9x0yCQur9zXB9xISCHsO+DYh+BFyT4afE08w9p+q0Yt/E3PQ9RIy8ZE/E3lg9R0iD5p++S1xAd5bIMUgW54fEyNQDSliBjpQ+jPhAR3cIRNAg6zvEg7Qzf/F9rOvEsabIkJQ47m/EqSgIrhw7L+vEr8Q6REyAaRd/CZRVCrCCuDM/CaBBJGgIpNwjNKfEklQ0B3/cgCyn/0lwQGzqCJbEP3gLxLlUCPkoLXnXxLR4L8ScgIq2f4mgQomniKuQNL0DxJXABDH/A0kWNDgwYEhvv1j2NDhQ4gRJU6kWNHiRYwZNW7k2NHjR5AhRY4kWdLkSZQpVa5k2bKBOYQxZW5p0dLmTZw5de7k2dPnT6BBhQ7N9ELm0YI5DA1l2tTpU6hRpU6lWtUmjiJItTLgxMHqV7BhxY4lW9bs0wubtGp10uvsW7hx5c6lW3eog3IM1h5lsKemXcCBBQ8mXNjsGzx7jwY6Y9jxY8iRJU/2mKea4qPuLlDm3NkiiWGeRY9+6uCSXswIm7gh3ZoyLRARbrmmXTsn/5QoqWMOyGLbt9042ghq+13c+MgLVnQjfGAjzHHoYbtIsWBQRHTs2StyibD8YA892sU3/aVF9ebx6bOzgeT94AAd6uXn5LXtqLL5+YtjULfAfUEGWElCPwJLiuGLB7SCokAGW8Oilf8KOqARrxq0EKMGUklgr1Y8uPDDyVoAJsKCAukGRBQf+gWX1KRI8UXDpoiERILWYQHGCzURZLkHeMHxR8BaMAI1GuuID8j5eCngP0EgQPJJuahwgsaBdqgQyuyeSIdI917B8kuzOIAmAxobATM6PmpJkEZHsDnzzbB4KCZCRDyE0zc+tqiOSn/WieNOQKmCYJENvSMiUNrm0P+TT38cecUBRCON6gpwlmulAUlFu0ODNfkEIpFMQ31KkyNSo0RUykQJgEsanVgQVViH6oAUR/Y6wslYHYOiEkYHQqERTHMVFqg2mmEVoXuGHawBeLzodSB3QFV2Wp86mVMmT6i16wJjcntWEBq0FbcnPWZE6IZx4+pDje6eNYOWdOPViQN0CiVoDHnLaqCby571RwljPsh34JsuoGNPfzohGCw5MAHBX38sCGbAhStmyQ55GFjG4qkaiGeMY/kEQxWOS17pD5JNboqXUlSAeCAhjlR5ZprpSuIVb14eKAgsavb557I+aKcAMnUuBl2gk1ZaKgoOkQYFnQfypISlq7b/OigKkFFjh6h3nuJqsMO+qQsFlDmg64GWCFdsttsm6YpMiDkBbX8eAMdHt/PWOyMIOhFgnZAhRsGIOfY2/HCI2qBEHpfpHqiHd2RAfPK9W0CmlBkcL0gQWoKl/HOwR0BGCk861TwDadYGfXWl52jnC3ICR1sLAa5g/faaSYDiHVdg0BwhBuqAowPci7f4ihIaCaCQ32XqwRpLjJc+3hVoyESCSnxvXqYXlkEG0unDz5WCOA4Z5YttENl+LT9eGUJ8+CNdgY037LFGGV2yWl+xQDBBIn4AwqkFxWjF3Pa3HBAAYykBZOCbTHfAvahADWcAXwMt+CX1QXAtIdiCLCp4/0EQQqk9GpQJAMrwDFyFUIVQIgMJDZKBIJzjTyukIZY04EJ/FKEZv1hBDX2IJSlAMAVLOAcPfnhELI1iexEIQgUU4TkkRhFI7XAcCsYggBtcSYpbBJIsotYKaXwCFR/kYhl/VINnhaAA5UAGxcz4xiddgEa42IUADpEHOOYRTEXDjBnGIIFM4OAveiTkl7wlExV4QhkC8AUqBllISIJpEgOxgC2cAQZQfOIQWXhkJD35JlFkwY2fJGUpTXlKVKZSlatkZStd+UpYxlKWs6RlLW15S1zmUpe75GUvfflLYAZTmMMkZjGNeUxkJlOZy2RmM535TGhGU5rTpGY1rXlNbCJmU5vb5GY3vflNcIZTnOMkZznNeU50plOd62RnO93ZmoAAACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3pyRQxI7f6iIgRNPxKkfP85VWF1hBefXsDVDCCXqDbtGjzSkOeYkRAR/wIMLHw58TuzjyBOvQKXgRylCuXo8IE69enXjybNrx7uCBjxrASbt/7BOvvz17ejTq12hiAiwQSHMy59PHLv6+/i1yhF2qYAW+gAGGJx9+RVo4FJ5KCDFJqsI6KCDBB4o4YQ8NdBLKssU8eCGD0ZI4YcgutRCCdAMcAKHKHYY4oosmsSBGFJ4Ml2KNELY4o04ZgQBKsZo81uNQNqY45BEMhQDLcqAEOSSKhbp5JN9GOPMAkxWKeSTWLLowA2lRGLll1dmKeaBGJSgRhNgpimgh2O2qV2ZyiSg5pzAHRBFDhsMsI0JJmjg5x4SBEqCm4RmB8EUrIxHZ41KODFAAMGIU0U8svwxh2uFZmpgH2VouKiDDwQySDMVsCNLHC1oqiqIF/ywwacABv9SRzCflKAKBqvmGmIHaJiQAazlabFEGfCgkqquyIb4BCZRAEsdA4wocw4LgyZrLYgdKDCGs8NpEUAqioRx7bggJoJPs9w+IEgpySRC7rsfYgHGr8BaoMslYnQB774SNkCLN8Ay4AcoYnjA78EGxjBND7BG0Uw01SIs8X1zBIPCogs4YwwvE3d8Xx/SzKgmCoTAE4PHKKPXSxp07qAGMhykLLN2v8yJxxZQ4Drzzsl9gMiXB2hQgs48F40cKUy+YMIvMRvtNHIt4AGkIERE/PTVsTWSIgw21ID118itIKeDDCwhDNFgp/1aBQKGAI0lascdWwwXzzdAPGjLrbdmUpj/NwErfewt+GtJnFhdD8acPPjim0lA3Qa0NMD45JolYoFwm0BB+eaabeEPA0CgwvnomFmiQRykp6766qy37vrrsMcu++y012777bjnXigEuvc+lxxMTOH78G1BUA1wpTRN/PJlIR0cMzowL31YcfwY3Aup8D799ll1IEh12pjC/fhVTUMeHsiQr/5Tf9BLHieSry//URS8Kt8kqsyv/1DQALhKOPsLYE9wIDL6cCJvAkxgTDjghAc5IxQKjGBMSsGhEChCghhcCQWOgKIH/CCDIDwJB0rBABQp4wMhTOFIpmAGFPkBGyqM4UdWAAYUwYAKMswhR0SgBA5ZQAQ6DCJG/1SxDhSVwQFCTOJEGgALFBFDX0qM4kO+IbUNecNdUsziQvhwDA5pIXBaDONBMEDBDR3gDGJMY0GS0cMHWQAeaozjP5DADA5NQ45qDMMyOBQM7eExjAQo4YMCEL8/avEQjtjQJo5lyCwioRUbyoUMGqnFGARhQzNoAyWz2ABWbKgQfNhkFmMhSAEV4QmilKICJvCgItwhlVE0gJIcpAIewFKJqsjBg2p5yyReoIu0tGUvg+iBAuxSmMPMYQfGccxkBrGJDgoBKp2ZQ2O0cprUjCEXHmSLPGRThrSgkoAAcIFvxvAXlxPQBkZgThWiIZ0BKobB2hnCErBSQAVAID0VyP+CewZoHPsMYT8dxImAgnCgAvqgQTH4TgEtQBgLZSg86TOBZ0RUgu0QJ4BUcIuLRtANDspBOT2awB846BjKI+n+BOAgcKg0gcFwkDFeGkAHBMBBAKSp/hpQCQGhAIw6ld8IABYgW2gyqPK7QiAE5IxCIpV8SGhQgIzwVPndYKLzAWJV1ecLAZ0gelslHwEEFAirhXV66RBQHZB41u15wA8CskZbuZcIdNGHAWKY6/Y64c/5hOAKep1eNASkDbYGdnmgEFAFDss8B/QUQAuQBWOXNwRbBCgKQ5gs8TphvfmYQLPEA2mAJAHa4ZkjQChwQWl7xwFyBEgQ+lzt7OJQN/r/XEK2uqNFgBaABdzmjhsBysE8fVu7D8wgQBIg7u1q0FnzMMAQyrVdNoI73OjKTgjItS7trqACADEAh9qVHRoCxAwKhFd2pwWQAM4buxZ4iT4vQB17XzeFAA1gvrADRoBmgV/XtQCS9FnFUfu7OkOUUj7uIHDrHAcg8Co4dS2wLH0gYdgHj24YAeKChVV30wAnYcOku8LY5lOL1/RCA4AFsVYkAaBlVBgznvCHEhphXhVj5Xjm8QILXtPV4LQCDja+ShYKSJwmVKEDr/mAp4RTiSwEuSp0qM4D6DBJ2JiPOg8Ahlmf3JQRwIA4dfBabC6QSOvsIBtI5vJTRCCcQqAh/zlGkM8RNKdmp3TREehwKmye4D7zLKPOTdFBMwaMnLTS5wuAFpwOAJSAkSZabtilDykerTdDAKgVeqb01y5Jn3hoOm71pU8uPh23GNMHuqQGWwkAVIBUp20Ad/2Dq792AwC5dNZY47R8HoBNXButFwDSgK+vxrL5WCCUwzZaHwC0hWQ7TRr0Obazi2YJIpOn2dPmWZSNjexsy4wEtTWPsL09s3fcVb7kRhkGGDYfIKRbZj2ejyjenbIizqcS9EYZDQCExnx3DNrzIYe/O3YFrJIHjgOXGEvnE4VMJ5xcDvjPfO748IPBgT4nyGzF+RVp+TRj4/yyxIHLA1aQv6sc9P+phsnhFXH6dGPl78LwfEDgcJjnao/zkYLNxxWDF8yHAXLY+bWmO59NCP1a9paPp4+OLCTQBw81Znqu+jef5EpdV0udj6yvvioq0McbXM9VTOcDiLCrygGzNE8GPuw6ICTg7XCPu9znDvdYbFUW9FkC7IyJIgJsFbjzacfeU+T3p6J9PiioLuv4zqHCIxXv85FG7Bi/IccH1XPzOcTkCf9UCPxMPquIuuso/yDL0xTY8/n45vv+1MRmXnakd5DpXwqA+RxA9KPnfFBdQB9lzC72Apo9SZ0nH4jCXvc63cZ8TsDIwbNepyvoM3msQDvgB0j4F00Gffj7e+S/FPDygWD/959P0yWXZx21sz6AsL/QLNBnsdX3PklHQZ9rpF/+HlX/cPDgx+OTn6QNEG7kIQ+2o3/zwX4BpQj0gXDx938exTbzkWIN2Hg0pWvlMQO3Y4DygYD0xAHNZR2lkIH4t1C1Nh/pU4AjaFBjJR8LwE4o6IARVQfz4Qe4o4HmwYHm5AACaB2PUIMpuE+oQB/D4IMwaFBE8HOY8oIUSFLyMB9ekDs2WB44+E2FMB/AAIU/2E4X4HJYWIT7JHPyEXREuIQXBYHmAQO6E4XkMYXUFIWf1YVkGFHxIR8UN4aV51GmQB/9Zoel51HIQB9bNoF3eFELZx6F0DtqaB1smEy70G6I/5iFVDgf7/CIXmhOLTBy1lEClBiHAYUD9CGBfCh7FyVa5gECvpOI1bGIvcQJ86ENpwiJ1EQGVfeKlfhNLSQfmUCLnEhPLUAfvbWJg2hQizYfSQiHwRhQesBww4OK1KGKsFSI5bENywiLyaQM82EO01iL1OQM8zFpuniM+/Rl8qF539iHBtWL8yFmwGiOAcUD9IF7oRh8C/WH8lEExMOMxOGMokR05nFf2biL5lQG80GA/wiO7VRD8nFbBcmO+8SN8kFaCymKBvVe5qGJESmPBmVw1eFkF3l9BpUE9FFl5SiR++SO8nECy4OPw6GPlHQG83GI90iNt6Rb8lEMKSmTsP8UC/NBCDepjcPUN/KBaDHpk71UC/OBDz0JkNnkCvORDUlpkN9UAq9gDcCQDnWwDq0wYsGhB0/JkCTVAUkQB8+ADPBgB11JkmbnJCopHCyZlgaylsHRlm6ZH3AJHHI5l/dRl/5wl3iZHnrJl325HX8ZmEMymISJI4Z5mC2SmIq5IozZmCDymJBJIZI5mRJSmZb5ljiZmdqBmZyJH575meoRmqKJHqRZmp25magJG6e5msjRmq4ZG7AZm68xm7S5GbZ5m5mRm7p5GbzZm5Xxm8A5GcI5nJFRnMb5GMiZnI2xnMy5GM75nIkRndJ5GNRZnYVxndhpEh2AAN75neAZnuL/OZ7kWZ7meZ7omZ4IIINEuZ0zcQgHEJ/yOZ/0WZ/2eZ/4mZ/6uZ/8eQDSh5buuRMKwC0EGiSAGaAmMaAFuqDtWTR2AA/I8AxxkARppj8KyqAYipF6k4zDkQCtsA51kA7AYA2vYJHTc6EZmqIbKDj8WB6uwD0oqqIymoqCgw8kBqMzmqPVAQqC8wU5h6M6GqTBEQGAkA96QwjzYXfbE6NCmqML8AUoFDfFMB+0AKRN2qR1oA9xU4XysYfSw6RXmqNOwJFgYzjmgUxfGqZhCgMmejUyQB9sd6JqGqYZ8AkvVjTuJx8WMD5gOqcz+qQ1JzOrJh+RwKd+qqZC4GhFw2Ly/+EMhnqoYXoEZMozlzAfYPCokHqlMJBXRdOE8lEGmJqpTRoBGsYzsCYfTmmlotqkDAA/O2N+5HGCS7qqcyoEGocyFEAfaJqmtKqmXqCOHVMD9NF8vNqrYRoCdNYxhzAfaBiqxjqqVdB/B0N85eGozvqsQvoAe3Cn8JJe5uF714qtQroEirovyicf6zU+MmAA7Nqu7vqu8Bqv8jqv9Fqv9nqv80oEH1glXqBaB2NX5cGVBKYJ7JYmKuCl5LIC9FFy/UUP9pMmEwCR74IFw2phJLAGc7IAjxCoq5IJ82EGIIYBZWBtTMIAaaA418Jg5kEGNjYL+8okkOCv1qIN81FQNv+mCAULJjBwA9eSduXhBk/mAg8LJimQi8hyBfSBA1zmA66AiUyyADbAsWMyqM5FrCrWAGWgUWCyBoHoJuYmHzBZZ/3QV1+yAWKoKUAwH7vwaCwAsF+CCMKjKVxqHumaaHFwXGqSAkBbKCRAH7KaaCtgBRlrA/CIJS45H+KjaQ1AB1prJQxgAsWYJVdmHiHgaotgpmCyAfTQJiYwH63malAwh2kSAg6GJeJoHvDnakiAt2mCAnv7JHIghL4mAwXgtEuSAVJQuDfSDfRRrqk2QnQCBC5IJPoFttNWBSkwJ5NglkTiBQOZbVDgs1+iBaXbIitgu8RBBN52B6wLJhNACTn/AobmITreFgNLMCcZgAmxNSGPgHjcOmwUYATYGyTC2yJwJR91QG8OQASY+yV+wLwgMgKNq4j+VgLSayVF8IsfQo/ywbP+hgRMMCdKoFUUUkbmEQEpRW9JsC1q8gCXsL7q0b3kEQQVF7/zCySEIC4HgrTzkboJ5wCA0L9WIghwYyDwQB8XBHIlgCZqogUKjB+eah4oILXvxgYRrCYggEX3AQFVZB6fu3IXsAlpsgClih/XQB+jsHMcYAQDDCR7YCBmeKZC5wCv8LIoIgRRmh9JVx72yHRv0F1Bwghdux2hQB/ccHU1oEs1AgJIcCCzQB/JwHVtwMEoEgGcaiCCKx8Z/xC5R+cBW9DF9PEA2nsgLSDD1SGNZgcBo2DG5iEB0oofwiBpc7kPihIgVqC76mGN8yGzackPekwfR4CyBkIBBzAfABCYFzAI9BECrGwgyzofPBqYCMAKkCwcKbBjFKIB9NELipkKPmcdD3AKH0IBUmUeiPDJeIkGPEwdNoDN+fHL8oFtjdkHrywcaUDE6QFw8iFZk3kFjxUcGyCSE+IBO1gdIPC+gfkBaiBIMNDLEtIOdiyapPACKBC3IHK+88HOnwkHFPwhSfCf9ozPCJoZgEAfwTDRyUFU8lG9GL0Zf0AfgdDRx6Gy5gENIg0bFNDE5tHHJ80Z8UAf6NfSnCHFTf8p05shByd8PbJs05YBlPLxZzyNGQ1wwNYxhEF9Gbw7H1og0UfdGDgmH+XQ1JYxjPLBADUs1ZPRDPQhBFhNGUNgydUBZF0tGZNrHks91pHRAG5LHnWL1o5xw8YGim7NGK4VeXP9GIc7HzRw147xzuYR03y9GKIAIL4Q2IyRtvPRAyBs2IARBzkdHJPI2ImhzIg3x5L9F3ygkdVBB5eNGJi3a1fd2YOR2fQheaJdGJ8tH0B12oFB2vORBqxNGJQ9H8wc24HxBCRbHSRs24EBDgDiwLztF3/w2MDhj8HtF4nYpsetF5ZGH56w3H6RCwBi0NCdFy9NH7td3XnRAAA2H6j/pt14Qa3mwdXgjRcXoJXmwbDlTRc+Sh/poB1t0AzqbZw4p8i9BhsNgA6JdAzYCQUcZB5UhRxoMLf+0NDM2QHZUMrU4Qi+qxk1wJ7CAQPDK50kAAy5XYecIQN0kNuc7Z5Z4NfAUQRprBkdUAXbjGWTip1w0N3+UNicwQLOax4qh6AU0Ag99Nyb4QD1/ZAYfQUaUNubYZT0kQByvd5ykQTVLB8BYOR3sU0AYtRMPhcOAAkAYgtWG+Vu4XUAYnVYLhfu4F3f3eVv0QYKbh6tcOVirhZ/DCBXmOZwcar0Qd1uvhZx8MzzEQloPudmAY3ygY16zhYUUEcA8mZ/vhZUQNzA/6ECRV7oZUHS8kHejI4WHlDOqBrpaWFgABIBwGrpZOHo5jEDI87pYjHpAXLHol4WWFDM1VGlp04WlQogKIBurQ4WGPA9AEIOGTzrXeEC9Uwefq7rYMGoAPK6wO4VnZvpnVDsXzEEa10etnCryr4VLKDq1FEJTB3tUhHGwIztXOEANBsg0cDtW3EFojsfE5Ds4p4VYoDowBEFSpzuVmENAuIHigfvUuEAEO7e9n4VJJB167fvVqEDYE0eLg7wU8FmAWIBwG3wURFnAbIKLM3wUNEADhkriy7xStEGEgYg3jDhGM8UfdDr5FEJ6PzxQhEODhIA127yQmFNAnLRLN8Uvv8tIG0d80jBAcAUIApl80lxASxOH8TO80bhAic+HwsgeEKPFFTAydVhAYSe9EZRMwLi9FB/FPQnIBOAzFVPFK4XIFm/9UUx2wDy9WAvFA5QbF6v3GXfEx5Q8QBC9WsPFCMwtNH2C3EPFBdQew7F6nffE3mw8RnW9z7xBLBKHzMl+DzxBOUOILCA+DzBA3AsIOOw2I7/EpD/IAVQ75U/E5d/Ug2++THR+QKSA/kD+jYh+gECAgZg+jZxB4Vv7grA+jVB+A/CAEoq+zLBBwQeIKxQ8rhPEm0gwgASBDv9+ywhA9L9IK0Q8cbfEi1A0w7iCOTY/C3RAB1GNgdK/RUBAWP/9yDLoMLavxJlLSDMwPzhjxLwoNnyoQSBfP4qcQa1vCGlQPnu3xG8IHEPcgzdVv8lARCJvPkjWNDgQYT+8Hz719DhQ4gRJU6kWNHiRYwZNW7k2NHjR5AhRY4kWdLkSZQpVa5k2dLlvy7EEs6cCavBS5w5de7k2dPnT6BBhQ4l6tJBGZpJDa5TVdTpU6hRpU6lWtXq1ZIiLChVqkQEVrBhxY4lW9bs2aBUYHBVCmYFWrhx5c6lW9duT2x+2CY1M+XuX8CBBQ8mHPaDsr00GZTiUNjxY8iRJU/O+CND4plHKFDm3NnzZ9BhFYXAjLBUaNSpVa9mjTKUs9IFnTRuXdv2/23cqzFwiv0AR27gwYUPDxxuFWZoxJUvZ968qqpJezdsdl7d+nXsLBvwVprhT3bw4cWPv4gMT9Jp5NWvZ3/dlLaZgjq0p1/f/m0IqV4cjBDn/n8AA+xMB2YMIkVABBNUEDAOSiGoGggWlHBCCsmaggk5KtRwQw6firBDEEMUcUQSSzTxRBRTVHFFFlt08UUYY5RxRhprtPFGHHPUcceS4tDAEh6DFHI1VIBgwJ8thlRyycmg2MQgCxJhckoq72qAlg0SkqBKLrssKwZjeqDphCS8NPNMqfpgZQKupEDzTTh9wiCeARJDIYY489RTJUugIa20CvYUdFCPMBBmiSNj8/8ngbcIdfTRiGqwYS1FDWoEUkwJJYEIQSpNCI8WMhX1TQ5+MWE/T2c6cFRWqcSgBA0OSFUpRD5o9dYgMYBii/NmZesXXIO1kQNk1NjB173S6EVYZmGMAR5CUECWrQfS+a5ZbFXkxRhnFpiWLRSCmSNbckskIZpmovh2ryimwbNceDn0AApQ/Eh0Xa68oeWmePuVsAsxLtFlK3zZygAMKvxVGMFEkilFkAcKTiwKfKRc+GL6wlAklQC0kLi0MRSYD2OSxSOBhXOUYeTej/dCBJMnSpbZuhZQgaeMJTxuObYMiEFj5JmDBg4DVUr4JJg6Atk51Q1+uEBoqFlrIQ5Z2Kn/oJlBAol46VmLKKOPqMOWbIU5/pAlnirECSaAAZxQgmt8d2Blig/FtvssEiTQew8N+jbBhG0G2CCHKGSFG+4DlCkBg7sbR2uOwyNPqgk1Fnf88rMgl3xzgiIp5QYHMBfdLM0553oBZ4wBe3TWyyrddIlBUIaWd1u3fazXYUc2Am2MQaXu24MPK3fdFX3AEynEoE145sUivni2ThgAmhJCbf563KHfqwggUumFX+zDd177mVbZRAoF8hB/fdfJJ0iLAi4RJkP2628f9hAGAYYIRRq1///7cW0HkwiANeBBA/8BUIGkw9cDepALQpTiBwpARQIXeMHHlSYCIXDCMdKgh4FHNIIdbxBFKICHQRTOZQUVYGEFzvGDH5xCBNGAgxio8Ac7JGF5KeRhD334QyAGUYhDJGIRjXhEJCZRiUtkYhOd+EQoRlGKU6RiFa14RSxmUYtb5GIXvfhFMIZRjGMkYxnNeEY0plGNa2RjG934RjjGUY5zpGMd7XhHPOZRj3vkYx/96MaAAAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza96c8cMFOX8UfYPjS4SbHz/eVVjNevW0H59EiIADhwUWHpZWcN7Ne7GDRDjunXr3aFyBXIVWLfDHvLnz59CjQ1fSg5muXeagvWoHJUnv7+Ddkv/o9KsesDW5oiyXzr69+/fP2YWfT98rCSyZyizzlgC+//8ARldCfQQW+FQbULwyTxAwBOjggw7+YeCEFAIFQRzt2DBGgxB26KF/bVQo4ogzyaHHIwMo8eGKLLb3AAQkxihjSR8oUg8xILSo447QITLjj0BmNAIyUhRjAY9IJumPH0E26SRDXXzziB/rKWnljks8qaWWEOBAwABHXikmj7VsaeaMScCTThNjtonkJWfGSeEfBHjCgJt48kiEnHyG1wELdNiS56A8CtPnoZtRMIwaOxDq6I69ICopZRh8o8wBjyZ5QA8A+BEEGSaYMI4GrEhg6qmmmqNBOiakEcQAGxT/AsIL7tkx6a2PcdJopg8ewMwY4JQyzSK/3MBGIj58RMEFqqByRjc/YMKKCcVwgOu1i2nAq3sP4FIJK434wsIdXWBrLp/UbNscA4EswckpssjRwbn0SupAjo7aYkI5vujgQb0AXxuMmxmQM84oU8gQ8MLm9nKlGQGcg8UHDFdMbyQ7PuAJKHCEYvHH9aqzYgTVXCJGuSCnTG8WEDIwCTQ3WKvyzPXOAGAPGugxBM08A9zIeww4U08WPRcN8BzspbAGOxcY7TTAxTy3gxrDyPz01edmw9zUJWCA9df0JqFG12CXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744ow37vjjkEcu+eSUV2755ZhnrvnmnHfu+eeghy766KSXbvrpqKeu+uqst+7667DHLvvstNdu++2456777rz37vvvwAcv/PDEg0TBLp0UrzxC6fgzwSHLRy8QNM0tsKf0xbsBHZzYCy9LmM8140D3v9eAqXRp/Ev+7lcE4t4AI6yfuwfrwLeBd/LX7sAa/xWSR/60g0WAzPAEAMaOCw+KAg8M6DoZ9OdBKlggA1mHCkRASAXXmCDr5uAECB0ABxpcXQyc4UEQhjB1HiBECU+YOgfMw4M6YGHqMHFBCcrQdOi4oAtueDp7VAlARVAFD/9N1w7wAch/QywdGk7woBk0LYmjY8EEHiSIFkAxilN00CYacEXRSfFBARhfF0H3RQcFY4yhK2OA6oFGMjLRQbRo4+fQYET/WIAFcvRcPH7onwTUII+do8SDAnEFQHKuClSkmCE1Vw8wLnJzAnRQOR6pOW05SA+UxJwDluCgCaAik5ejn4O0UEhQVu4ChXCQLrhoSsrdAg8O+kIrK4eFCDgoE7OkXDwcFIEM5lJy03BQIEjwS8kpw0FkgFExH0cBEgZIAMuEXBvMEKAFyCKaj9NBFv8TglJik3G7DJA2xPjNxYHCQeIoJ+McMIYAPeAZ6lwcCTAGIFzEL56JQ4UtAST/jTPF4hP4VEomHASPLYkiA/4QQogCepRmBEgJBXSSBzrIHBAMg6FG+YDNAOQJcgIJGNAxgtUwGpQ4oCBAxmgSFKRzhD6QdCgiCNALXPqjFWiBPS8YxUuFYsn/bICVMuope+rgsZ36pAvMCBA0ZjQM/6gAekbtiQ5o9Z8H0CBGK+gBgL6gzKjqJBUBcsJIKSRU+MjDqz3ZRIAwMaKVAkgLukHrThIBy/9kgKYT8gA9/3NNufLkFwHyw7wmxIkA7cGvPgFHgFIxIVHw0T3MGCticUICrf5nAkIkkAMmAaAMiGKyPvmGOAv0gwBNErQ+qUWAfFEfUzgCQEegAGp90oK9/8IHBvcMTwAAtICrztYnbv2PEeYTXP/A4rdAKat7FhDD7zSAov7JgfqQ25MYhABAuejqbhoJoClQFyjh/I8kehMKFf2nTN8FiisA1ASF7eaY/1EBMdP7E9cCiA67oUGAREDfoLwCQA9AAmc8AaBq9DcoHYAEgISwmXZ0lg0HDkov7vSfN2TmA9T8DygiLBTV/ocZg7XMz/5jhuly2CdDqKt/AGqZITzQP9E4sVBOASA8JKsydCiwjIUCAT8AyBqVkUMd28OAT+44KFQAEAqKKhl5AEgNRx7Kbv8jS8n0gcLwccRCowyUObwRPg+4hWTSACB0cHko1PsPECKj3/8EAv+oZ/5JC6IAoOY6phIAimOchTLQ/6ThMTcA0Aa0u2efdIAJAPItY4IAIGoUeij3ABAZGhPo/2jj0URxpn8UnRhG/+ezmBZKkv8zacVoAkABCDVRiJFoxZDhPwz4o6qFwgYsv6fUh9EBgMAwa6KAoc6ImTKYI9rroNTA1u5JtWFugez2aKDYvoa1mAvj4WFDeyg1eMB/uFEYUwyZPc++9lCUyx4L/G8wj/jPAogtbqA84bHsGa9gwnA++PC63UP5tXssoAGiDea//5EQvoXyh/YcoAymKAwEWvGfLA18KJyEThFScePCwAFAhnj4UEbdnBnAA86F8TR8dKFxouiCOdr/sLBidP2fb5R8KNQAQ/IYM47/OOHlHyPBPuGzCJxbjBT/aYKJfQ4wAPxHHURnmCzsmvCkB2wZ/wGH0wMWCoT6x4RTpxcB/jOJrAOM4f6ZhdfpdWr/OAJlY8cWuaVzxrRjqwUn9Q+E3X4tdvzHwHS/1gD+o+e8T0oV/3HE0P3ep637h9uEnxR03wPPxCOqD/8BgOMlJYX/pHTyh3IffBZw7sEBIQGgD73oR0/60McCkA7zTyUMV4AVEQCQA/MPLgvX+g+9Xo4QoDN8XuBewtXeQ7dv4zP+Q4zD/b5DwUejDf6DSda7Po9gfw8KrOh828uRB/+5d/WBL0cB/MdQxn9+/xs34J8ToJ324h+jHf5jgsQdH0LJv6LW/MNfxL3/QfGHIpnhk4H5ht/6Y8QB2+Qel+Z+6XdFb/Af2aA49+cg+TdEOeYffMCABwhFqQQfR7A4DRggD3hDT/Afj6CBFThE8wcf3kWBAHhFKpRlXoOC3HdFELAr77ELjLOBANKBLIQK/yF2IpiCSQRW/mEJNTiCNyQE/lEIjWOD/4GDIYQBcfcerJCERMhCw+cfzdeDL5hEOeQfT4SFyHdF6wUfM+A4SugfTKhBKuAfEkCGUxhCd/Af4cCGPnhD2uMf+DOEcyhDauAfkieHWchDRgcf4SaFeXhCI/Afp/A4ZQgfZ2hAxf/lHgLmh184RCP2Hk0AOYv4Ho0IQEDgHwWAiW04QbjgH6clifA3RBfwH2gAioWoQSXwH4nAin/IQppQAJbVHj0QOZnoHptoQBdwBvWQDk7wWMUni5OIRl1AA1VgDoLARNBkjKe4SA7ABk2niKGIeSOyi+3Ri9hoINrIHtzYjQTyjdIRjuJIH+QYHeZ4juGRjtCxjuz4He74HPAYj7wxj85Rj/bIGfjYHPq4j5rRj8zxjwCJGQLpDwRZkJZxkAmpkJTBkA5ZIRAZkRMykRRZIBZ5kfWRkRo5HxzZkeDxkSDZGyI5krtRkia5GSiZkpmxkix5GS75kpURkzI5GTRZk5H/cZM4+Rg6uZON0ZM+uRhAGZSJMZREeRhGeZSFkZRKORhM2ZSB8ZRQ+RdSOZV9UZVWuRdYmZV5sZVceRde+ZV1EZZiORdkWZZxcZZo+RZquZZt0ZZuuRZwGZdpMZd0eRZ2eZdlkZd6ORZ82Zdh8ZeA+RWCOZhdUZiGuRWImZhZsZiMeRWO+ZhVEZmSORWUWZlRcZmY+RSauZlN0ZmeuRSgGZpJMZqkeRSmeZpFkZqqORSs2ZpB8ZpW2QEIUJu2eZu4mZu6uZu82Zu++ZvAiQB1cI2w2RCHcADImZzKuZzM2ZzO+ZzQGZ3SOZ0HYHWzWJwSoQDqsp3RiJ0UoZ3cGZ5L/+idFQGe4nme20ie34me7FmO6jkR5tme8omQ75md83mfG1afEBGf94meEQAI+aCfDsGf/XmeC/AFiiSgCkGgBXqedaAPCrqgDXqfTuBvEWoQDDqh4gkDA3KhBZGhGhqeGfAJHnWhIBqi3HmgIKegJ4qi3CkEXRihLeqi23kEFsqiNNqfMCAGJpqj/RkBXCCjPtqfDMAJK+qdMzqk2ykEO1OfSaqk6uIFsqaeTwql2xICUPCeVWqlvBIBVUBorbmlXJopD7AHJaqaYjqmmbIEMaqaMmAAcBqncjqndFqndnqneJqnerqnd0oEO3clXrBDHpoVmnCLV6ICZzCoWUEP5P83JhMgb4pqFSTAP2OyAI9wpJH6FBhQBtomJgyQBjGQqVYxC39qJZAgqKI6FYpgqFYCAzeQqlThAo0qJikwe7AaFT7gCs2GJAtgA5iKK6bABmfKYQ1QBvCGJGvgf+fifScgCOZQBTRwfhHWDwNoJRsgB/XCas+xAE6QDvVwBndIXyyge2KCCCdoLqwaHT1QAJrQX3GwUbTqBuaSCP/RofS1AlbQJr0qW7iCBv/Rpt/VAHRwrDvCACYQV5NSDv6BCzK2CF92JRtAD7eyi2smY1BwXWMSAlQwKWwCH41wZEgAr1eCAvJ6KEjwH1l6ZDJQALvKIxkgBfwqJzTmH7m1Yxz/UApuAgQ1ayZrBx19eGZVkAJtMgm2EieB+B5QtmdQgC9iogUbayZJ8B8lu2d3ILJWMgGUYCbh8B93gGkxEHFikgGY0IJOIgFOpWoUYAQtyyM6+yRWyx6uMGsOQAQPayV+ULRAkor+YWa9VgJMeyVFgAVBogf/0Xi9hgSINiZKUH8zwgr+gQJk22tJ0E5j8gCXELkjcoHvwWDilrZruyOEEAYxYgn/wVjt5gCAULdKIghCOCKz8B9Ghm8l0LFNK7gisgv+sQNgem1skLhiAgKxSCEY8FrwQQgvdwFqdSULEKQVMgUKiHMcYAQEuyKHJSLp5h/spnEO8Aql2iJCkKAU/3IER+h0b5CGO8IIyjohfPAf+OV0NZADOgICkSgiJfgeKud0bUC5HxIBPEoi2uAfEyBZPucBWzC97/EA1zMiJGCd7vFnYwcBo9C9/yEBu2sgMeUfC+h2+yCDAGIFMTsiJvAfeJt2/AC/sBWqMdIFqisdG0B4FzAI3ISqJCIM//GMfocArGDA/pACeDQj+gYfNkR4qUBV0vEAiTgjcOcfrYCNaEC70GEDFUwhhOsfNtCNfWDCz5EGv0oh2gofhot5V4BnzrEBvScjMkDE7hEFUex3H6AGFAYDMiwjfQYfbceOpPACKHCuPyLG8BEp9ggHjPsjeaDDzBEIt5oWxvAfUv9wyGhxtO+BV4w8FlUIHzcXyWXBDeNpyWPhAcQLH5mlyWFBC/8xAKA8FtXwH/JRymDBBv8xfaoMFrEniK/8FV3Qye/RrrPcFa+rxLnsFZxlhr3MFThgV0wWzFihWP6xDMasFabAwO7RV8t8FSLDh9GMFR7gxO5BCtV8FYvwHxGQvtscFYvnHuPQGJ0ABo5Gl6L1H3aGGG/wv/5AcnR5cv4RBInRAPBgtU+7loYAIHBwGD4QC0UQHQ63lmD7Hq2wxnthCmVQb9EhcGVZcP/xCoSRBRrwbc+hfWL5w+9xAKIrGJKgbtlrle8GgoSRBxgdHYPIlT0LHRZQjYKByf7xAFP/StKdCh/oRRjMln1f2dLPwQDTVhjCBjQ13ZS3cNPvoWyGwXL+odFNydHv0c6F8Wr+wQBz15THRmqK0Wb+UYxNOdS3vBhU7R/7TJSiACD2vBhcDR/O0JTw7B+vyhhjDR/3cJTp8h9pzRhr/R5MEGI4CQGzCh9x3Rj7J3tBKcr/sXqPwdTwEQXUV5MNoHmbFhmd+B9LhZNb6B8ODBlH/R8nMAc12Qa27B4MAMmP8QWoVpN7+B9nNRmh8ITwUdYjiQqf+xwWgK2UYQ0A4gcKrZCnzL6W4QMqBh9HPJLRACAJ0KSV8Qk1ptwa6QEZ5h8fexkdkFTnNZLnRGLgWxkJCCB+/3yRbODM7tEOm2GE/wEJfu2Qv+0fnsAZSIDU70HRFHnB/8FpmRGBZgfTAEkC5usfysAbMoDN7hG3Dllt8KEExbwZIQ0g8aCQzgsgbNQbEJALAAIDKGyPHoDFlLzFl6EDhNwcK82OkYSy82EEAZKy7IgDH84cSg0eI8Ah/hEJj92NFCC+gaff3+ELAZLT3YgPAfIDBfLW/uFy3XhQADIJw/odqlCt7tED4Ox3HGDd/rEAoFYgQBh12LgHAcIJFNIBPgYgvzB5SwcgkTB49dEH4t0eeBC8fmdTJz4iNAQgm5B4TgYgIT4hHDDO72G6dAcBqP0fPYCwIkID8O0eLyDVaf93CP3tHhclI2lmc9KadqEwnO5x5yLSAIEty4k3Cmj8HHAFJH3Q6e8RyHnXBzYOHSj+I4msZHHgeNELHcDgJA5AYAAyA9udd8PAtE5g5jLyBLANH82AeW1ghJ61JXYXILbqeJ9wemYC1e8RAbEbzlCxAoJC5k8u7UthCCvOHGOQ5NieFOLgIGXw7VABAfr7Hw1O7k7RBhh7WYiu7kghC9vuD2awZfCuFN4XIM7wwfd+FBAw1/7d70tBApL9H9Mg8EpxDRLsHumO8Ecxx95suw5vFH9eY0E98UPRAPR8RACL8T9xBTcVIOvA6x7PE6jA5O+xBN5e8joxxQFi6SzPEwr/6yDHFfNBAdb+EeE27xMfIAgPUgU7//EF/x9ZG/Q9UQMvpm4Nb/Q6wQIpXW6ryPQ7gdgBcgI9LPU5wV0BMgFXj/U3EcsAwvVejxMOgPPwIfZjbxMNkLxb3/VpLxMt4POd5PZvDxMX8LZnD1V1LxN5oLkAYgFXuPcwoQoD7SALAKmC/xJ3sOhllvgxwQOM/x9s5fgvoQMODSDzsPKUTxI4cPn/QQgkv/mc7/n+4QwXLvop0fkQ4gSgjfoqcQ2R7x+IEO2ubxKQDyEJUMa1XxI8QK4Awry7jxJPEN3GFfwr0ff/sQaab/wgkQSZLh0jz/wsMQJ71x6EJP0t4QGFDR0H/1DU2J8SDuBQLg3N398SlwAdU1v+LkEEVXLZ6g8ThzBF6fD+M9EJu8Dv9J//+r///A8Q/wQOJFjQ4EGECRUuZNjQ4UOIESVOpFjR4kWMGTVu5NjR40eQIUWOJFnS5EmUKVWuZNnS5UuYMWXOpFnT5k2cOXXu5NnT50+gQYUOJVrU6FGkSZUuZdrU6VOoUaVOpVrV6lWsWbVu5drV61ewYcWOJVvW7Fm0adWuZdvW7Vu4ceXOpVvX7l28efXu5dvX71/AgQUPJlzY8GHEiRUvZtzY8WPIkSVPplzZ8mXMmTVv5tzZ82fQoUWPJl3a9GnUqVWvZt3a9WvYsWXPpl3b9v9t3Ll17+bd2/dv4MGFDyde3Phx5MmVL2fe3Plz6NGlT6de3fp17C8xlFCTJPt369vV7PDnLxt49M85DBtf3n2x9PGRX2C3JoV7/OXnyOcPPEs9ZxjIb0B/GunvQNyG0EODHgh00J8ZEJQQNg5ugGYSAR/UkIcJOzytCzEu0SUCDUt0Tx0PU/wsFDhA8eQBE2N0LxIVa7TsAyzOCcAMGXvMrxcbg2RMhilGGYecDHxUMr9ghHRSMA908KUcE2xZ8koCQXDgSS7t6kAOWU7hZIlAMsTyTAKp6XJNtbq4gwVaGmGlElxgRPPOEjVgc8+XOCjGBFYw+aGbM1BR5QIKPvL/IRE2bvhlkWlKAWcMZg7A81Ifd+CET05XsqPEF0AoZIMBgkjDhHQ0MEcCVltltRYNxjHBBDKC8AOAHhzBdFc0D1DmGww6FRalXng19lhMd1BjmESHddYkYZCVdloZbaGDhQ6e1dYkIqj19lt/GPCEgD+2NdekS8BVl9cm0oHHu3PjJamWdevF0oIBCMABAnn7JWkJewM2cQE/HvmmC38TJskPgRvGz4JipEBmBIUrJgkRhwMGgZh6FPnAYpBHgsDOjKlVYoBH9JAjZJZJaqNkZGEYw4Z24uC3ZZxH+gNmPGEIYp5XoGgjZ6JNKoFnHxPwZpkyMsGChKKjRokdpAdcriCKXNYApp5fOoFaarBVSgKKdl6BxpxddGGiByWoXWCVQnIpYJxH3pHkHhwS2TJsvnVawRIesGABDjhEEOGTH6apYHHGF3/nhx/cEMEXOIZR5A85Lvi4b8479/xz0EMXfXTSSzf9dNRTV3111lt3/XXYY5d9dtprt/123HPXfXfee/f9d+CDF3544os3/njkk1d+eeabd/556KOXfnrqq7f+euyz13577rv3HriAAAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza96MscMKS2wMsIBDScSpHz+MVVjNunWjH1xEwIOD5sYfVRc4cN7NWzGFOb2SZbMGDMymSVpS+FvOvLnz59ChW2gC4JgVbqDQsfv2J0nv7+DbXv+h0c4YqzpH8ERfz769+/UvIjkLAOsTshq6w+vfPzWJolmwWMFEBO8VaOCBCPoThTPyCPALLxTwJ+GEPiUhxigaHLNKghx26GF7C+CSBizsiJIfhSimeBIENVBiQx2IfCjjjDRC9wAj0tTzRhcq9ujjRXP8YsM2StRo5JFI+sPGj0w2yVASKiQp5ZQfpuCAk1hmSRAMVHbp5XvFaCkmliZ8aeaZzQEz5po/1oPmm1+6weacKSoC551T9kHnnhJ68ACegNb4AgZ8FqqfH4Em+uE6hjb6nRGKRprgFo5Wylk3gEaARyDkOFOHCbtooIE5EpRq6qncaBCACQUEIQgzRTj/cqY9ltaK2RNTguCFENyokwo7hzxzxwVXfjQCNjyIEQ0XAhQ3QCEEzniNrdRWBsKHETghxBfoxEMDHw3gREIWJWRijTzFxGhgBhFW6y5kxBj4AADEPJKJIaEk5QEbh5zDTTVNrLfBuwQ79g57kZhQTjJIEFpVDIacEkw1BzDXTMEYK3ZDcw+QU0sVVPgg1hz3EFBCxigb1oUT4IyChQcpxyzzzDTXbPPNOOes88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VhnrfXWXHft9ddghy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744ow37vjjkEcu+eSUV2755ZhnrvnmnHfu+eeghy766KSXbvrpqKeu+uqst+7667DHLvvstNdu++2456777rz37vvvwAcv/PDEF2/88cgnr/zyzDfv/PPQRy/99L038AH1fXsgBDHFYo93DJ4sZ473eOfBSHMCkF93HFo8J6f6ceMQ5XMPvPEzDpvEAH9LZygXXQo66JkluAQAOexPJXqwQHuKkIid+eAIzFEBDQ54klcw4D2TgBnOHEAG50wgHBQkSTkOtAYI4AwY0FkAIEIIEgiYI0GguFk22COB7rFwI/PgEDtqJos/sWcXGryhRv8csIYEvWCCMptDwNzjiQsIcSMecEaCEJGvlHlgAwZqxR2eqJEYOCFBxwgXygKAoCb0gosZmUMUEsQNlKEjQY7IAhozgooJJIgIGDvDAhC0gJPNMSNwuOCBLPAMgmFDPQjiwh838kYEFcGJ1cLAMRIUjEVyhBsJGoMNLSWBBC1hk5a0SAO2kaAKUCsZCTpCGELJERIUAkEMOEOtblGxA63iCazsSBZQgCA85KFSHMDigfqYS48II0HVACWd6JAgdBTzI9YoZaOGkSAwPPMjEEgDHw1RqFDMz0AbCOI1OeIDACDIDDLYEwQ2gaAEqGKcIOGBHQ9EiD018kAghCdIRJD/IFqxSRQZQBAs9CkSTB4oBbdYEweYgCBdOIygHwkmgo6hTCbBAkEg+CVEQ6KKWhrIGGIyhCALFMuNjiQeCLLAH7LUgkggqAwmJUktEDSDdjWJFQjyw0NjCpKVIcgGTnoDglCAS56O5A8vGCYSfeQDMyBIBEYtySsQdASbqgiFB5JGVE2yBAThw0dUGOl7zDCCrZbkCkssUAZ4oSIOfPFALDCrSVB5ID90IEXQQBAd5HoSeSDImRTqQ0ANBABx8lUkKyjCgU5gQAlBIBcHesBSD0sSKCBoCROSBIKgQVmUfAFByeDPBXZwoKp29iRNPVARVqkfDSj1tCgR6oEkoB8q/yCItrBFyTgiG8DvdACCBopEC3KLkhiE4ECeAM8PECRL4qLkFwiiRG8ukIADacC5KnHFgaLAWs7k0EB4GAJ2U2IJ/xVIHbvhxR4NNIvxquSe73nBOzcziAOFyb0pwQBwC+SKzYQjsnrCb0pse6DmXqYBuDhQKQS8EjUcyAsmvMxyDdQDkTE4JUPYkIHeV5kRILJAvrjwSgCh2utVJq8GSq6IVdKB8xnoHZVJxDwLhIMVr8SyBkqAeCczUwO5w8YsKZOB9ioZJPjwPSgwBZBXIodovccC84XMMg40jSWzRArWjYwOSmzllazgw+55ABIgI+QCZaLLLJlwgazpmC0biP8RFUXzSBBsIAbIsTEdNNAh5MySdhzIBI2hwYEGwOeWrONAvVVMngs02UKjZAoHssJirvFnR7eEnQZK9GHK/B5NWxolgjZQABJTA7G2ZxmfbkkB6hwHxCijzjVINUvcXKDrGkYOR3YPm2W9Ek635wGWMMwWDLSAWPN6JaU2EKUI0wYnuwccx24JGQt0Au8MZoQGMna0VULr95RjMB/4pnsAvW2WrLpAKjAxYOxxoBqXeyWhLpA/AfPW92zi3S0JAmEj7BdqGmgK+GaJLA6EDMBow0C5CHhLBGGgIPyFDQcKrcJXAl0DBZgvWH1PJOI8cZF0wKUFGh9fwlCkAv2g4yz/IXGBUrACvnDBQAfoLspR0oLqmpwvLn4PUGe+kjIQdi8bK9ADsMHzleRBgQUy8F2m/R4gFJ0lYDBQf/FyAaS/5wZPX4khiN3Au5DCQEzIOkvI8VG87Nc92RD7SthdoELcJd7uUYKF1Y6SLnjUPQCvS4/fMw+6r6STBZJHXbpQ8vfwwO8quYOBTtDyufCzQIxCvEoGYCA8zqUSBpq35E/y+PeoOC6JMPV6JjD3zZvEA7IqUELjkgoDjcP0Khl2gUwZF2G+RxGwT0knDJSDuEC8QL3PfUq8YCB3u0UdBhKH8FMyCgMZAS62MFBjxQaEBFj/+tjPvvavHwuihWK97mnF/1vg3p77ju3cHyJA0cbQnhMsQxjqZovPC2T5889I/UTrvHMsYAVaDDcuraBWO2Z/MoJ/Q9MCM+YPC1AJmUACdCEKBpIGZoN+HmKAQ5MO/sAA1ZAN1lYXWFYgejCB92c0VHAOfKAXAfgeJ/B/ZEOBHWKBvrMCS5BU7rEGZ+OCHAKDv+MDegAGqRcd0iWCBXg8FPAGrMAlzvECZSWE6ac8EEAFsJCC/iBpNziCzcMDAgAJQciEFbh834GDCaKDXpgZYIggYjiGl1GGB3KGaFgZamggbNiGk/GGBRKHchgZdPgedniHj5GH7rGHfNgYftgegBiIizGI7FGIhpgYiLgeiv+4iIfRiNHxiJBYGJIIHZRYiYNxic+RiZoYGJzoHJ74iX8Ris0xiqTYF6bIHKiYinuxisvRiq6YF7DoD7I4i3dRi7eIi3Whi7zIGL74i4oRjMKIGMRYjIZxjMhIGMq4jILRjM4IGNAYjX4xjdTIF9Z4jXqRjdqIF9zYjXbxjeBIF+I4jnJRjuYIF+iYjm6xjuzIFu74jmoRj/KIFvRYj2Zxj/hIFvq4j2LRj/4IFgAZkF4xkATJFQZ5kFqRkAqJFQzZkFbxkBBJFRI5kVJRkRYJFRiZkU6xkRzJFB75kUoRkiKJFCRZkkZxkihJFCq5kkLRki4JFDAZkz4xkzTJEzb/eZM6kZM6iRM82ZM28ZNASRNCOZQyUZRGCRNImZQusZRMaW5W+JRZ4ZRSmRJUWZUncZVYWRJauZUj0ZVeGRJgGZYfMZZk2RFmeZYbkZZqmRFs2ZYX8ZZwWRFyOZcTUZd2GRF4mZcPsZd82RB++ZcLEZiCmRCEWZgHcZiIWRCKuZgD0ZiO+Q+Q6ZiTuZiViZiXWZiZKZib+ZedyZefqXYdgACkWZqmeZqomZqquZqs2Zqu+ZoIUAdRCZSHcAC2eZu4mZu6uZu82Zu++ZvAGZwHMFhNaJQKICnIGYZJeZzJ2Zx6uJzOGZ2JCJ3SWZ2iSJ3WmZ276I/MmZ3WGUPG6Z3Z/xkBgJAPQ9md4imdC/AF8UeT6Jme0lkH+tCT7wmf0ekEd+ae9umdMOBHMVmf++mcGfAJHDeRABqgzbmeYoSSB4qgzSkEkFSSDeqgyXkE+fmRE0qhyAkDYiChGiqeEaBIGPqh4skAnLCgBkqi6SkEAwiRGaqiyOkF2taQLwqjkhICUJCiNgqiVcBvBFmjOxopD7AHBZqOQBqkkbIEEeqPMmAATvqkUBqlUjqlVFqlVnqlWJqlVUoEzkYlXuACkXkTmtADZqICShemMkEPttclEyAJaFoTJFBEX7IAj4Cib/oSGFAGuTYlDJAG+nOnMjELXTolkACmgBoTikCmXwIDWP93qDDhAmtKJSlwZo76Ej7gCqKXJAtgA3ZaqSnRAGUAfl2yBg7oqS3RDwlIJRswfaaqEiywRl+CCHnXqioRBzNgJinAYbSKEitgBWayqVa1qyXRAHQgqnxqAo0nrCexCCdgJhtAD8qKElBwXF8SAlQQrSeBBLf6JSigq9gqEjJQAJmKJBkgBcH6rRFVCmcCBEuIriJRBebVJZNgB+46ElBwLV+iBddaryFxB9vqJROwhfzqETHQVV+SAZiwUwO7ERRgBOOKJOy6sB7hAETQrF/iB/QqsR1RAvjqJUWABRrbEUjAUF+iBFAVshuRBOz3JQ9wCQqLshXRsA97JIQgczD/WxEOAAgW6yWCEGw3ixElkFZdogUg+7MXwQYk6yUg0HVGWxEXgGlUsgAi2rQWwQFGYKxHsgdUmxEO8AqDSiNC0J5bWxFvIG40wgilOrYZUQM5YCQgMGZquxFtsLIyEgEdGrcc4QFbgLWRVX94uxEQMApfWyAS4KMqQgmQIACH13H7QFoJYgXnmiK+uhytAAtUYLjbxg9tW1p/+iMjQIPNAQOs8AaRK2sXUF8FEgKGyiSUwB6OAAZ6UHq8hgCswLfOkQJx5SRy2h4vsATJemypALo2cgpY0gI72x7ilxd8cA77OjpoILTOYQOY2yN6YCBScBdJkA3VcEHpYDp9sLnO/5EGneoj2lQgokAXJJAJlSCqE8CCo3MFmNccG5BOWDIExIm8ctECtGAFVuccJ1s6H6AGggQDq+skRGAgMOUWHyAMy3C80DEGqUMKL4ACs4olxWAgjaYWUggiVXQ6cPC/WCIHBmILcAEpBTIK+CgOBoJeb4EDBuIF+Ai+7rEkcCHD7dEJ8mgnBTIwcVEByiaPu1UgqSAXt2AgjmBY3egDqboeDMC0cBE+BQLC4Mh271EJdHHABUJo6XhoUUwXK+DA7LFF48gDBqIEPEIXfkW45vhd71ELdgFpBXIAZ6yNPlB47pHBcfFK8gaOM1QgR4AXxmAg5ACOSesepIAXiWC70P/BTdcIx0+2pHWhXWumjUAganpxBgZiARrljNiwp+zRqHlhTgWSwM5oA2/GF2rmHgngvsIYBnfXHlObFysQr+2xQsuYyu2hBDaLFy9UIJFwV8XoACD3HmrSF31wIL+AjHRVIDTcF/pWIIKAjJBVINoAGMhwILIgjI78HsMAGBAgyu/hcL8Ite7hBIJBxe+Bx5rowpknGOFmIAXAi77GHul2bYg2izVwIN82GEkAxusxaq4IDgYSAW1QGLL3Hgwwo5VYA4r8HMtGGJbgyetBbp8YdULHqoPhWpn2iclWIMqAGHEws84Rz5o4ZSSl0ITBdOlcid02borR0u1xb5A4z+z/MS2KMbkFUsF3SH7tQQaMAdPsEXmBSHkY3Bg0vR7tEIiHcCA+3RhZINLNgQvjK3wOkHOd9hgWfXNymAmV9hhGBl6/u3wfoFgbDRkaXSDXi4bTcCCoFhmq0L+8i9GwZwq8JHRwGxnMZCAULXzucCBuPBlDYHMFkqPCx84FMgFOHBkH82bADHtQXCCcVRljfSC2bHq0cCB40K6U4Qa21KJ+5wOKqtWWAQHEZyBqYHrqaiBSnRmYfCDNS3d9INHrkU+ZIcl+/LJPN0kGMgicoQrC6x6ApXazEFlsxRkfuHI+m3VDAGbu0Xe7EQawyl9qd9bvkQCQrBnwgCDJ/HStbSAn//cdup26nYtyLXUgM9DYvPEHsh0dr8dzgGcgr90bqW0g9oNyNNDQz2Fr4REGZF0gZiC770YBZ+ceO3DdvbHMBfIFHYdiBuKmEmKwBkLY+HbfyDW93yEH/rweRRDWx+YB4PweGXBxEgJf7yF475bXBhLZFNIBiBJx5cYCCOIEJ0IhvHC/7oEHVxBtI+BUdRbfFIIPlxVt0oAgxdwjAo4gr8Br+jdWAI4iFG4gL7BSn/YEdU3fTmLKB+IEc8xnGNDiBsIKWEIB/1ogf11o8xdcrPwjfwDX7hEPhXYGUN0cDMDIWRLIB3IAUWZledCxBTJQYuIA4b3DM25jGKALCMIEg/+OJbdAy+7RRlZ2UQeSAefLJujcxUD2X3+1J4SAIBOwuCKmCoJdIDJNJzLA44TV5Nh1RQiiAh1MJ4aA38+RBhZOXFltIN1sKD6MINbAYCT+HkRmKA5QDQkiDPhVArDuHBuQ6HuSB8ztHihwobn1BBoGc6tXKXCOIIVAv7kVBgP+HhJXK7l+INsw1WblABBuILhlKw5Atwbi6KcVDGCE245yAf1tIMF9WC/XS0T3Ls/A5u3BAHBAWcbOR2daLVh8IBOACnyVBT9o7yhjUNs1B3LVC9DrHgCdMQ0Q6AXiBONtVHewwe0RTjETCupyIM6AxDF1AY/NHk0g8TJDA7/9Hmv/UKTw5AG78Gu5OzPswCHOXe7vDR1pZzOgkCDmMOsmBQh8W+Q1AwG7622nFQ6pSgY0XzAe4A0IneSwRQPfdASoPjOJUO/SEYLEJQfmBAPJrTM6wOjMkQIFf1oxsAnGxzNvINEqEPd/mxKc7Rxa0Gp33xIC0ByMsMl9zxK97AkdP/gq4QDEIAQoj/gp8QHk7viSP/mUX/mWf/mYn/mav/mc3/me//mgH/qiP/qkX/qmf/qon/qqv/qs3/qu//qwH/uyP/u0X/u2f/u4n/u6v/u83/u+//vAH/zCP/zEX/zGf/zIn/zKv/zM3/zO//zQH/3SP/3UX/3Wf/3Yn/2h7wFY/zAK4KDlW1kCBHAPLg8WPkAFVVAL5JBroCyVzcAcBzAAwXAKhnD4UIEBSJAM5WACwwwQ/gQO9Pfu30GECRUuZNjQ4UOIESVOpFjR4kWMGTVu5NjR40eQIUWOJFmS4gaCKZtU43buEBsPJmUuDKUo0yNiAB6k5EmQ2EygQYUOJVrU6FGkSZUudUghQ0+o/hAVk2ctU4ksJJg2bMCHRjx0X4Q4iRDV7EAQW9WuZdvW7Vu4ceUyvHbWrsATOQaAASaASDQxPLCNKOngwp1nh9ilUsdNiBcQdyWnfDLX8mXMmTVv5lzU3mTQPR0VYSYoyBITATRwk9Da9WtzGjTsMjHGGf+5QHjKhuYN1Vdn4MGFDydefO2W3smVL2cO1Yhx6NGlT6de/eC65tm1bz/rx/p38OHFjx+K4QV39Om1P4hJ3v17+PHl/+uj3v793orm7+ff379mN/ATcECz6vnvQAQTVHAoYAh08EF/TFhwQgortHCiYiDUED8YLvTwQxARdCCFDUtMT4UkQlRxRRbBY8NEGJdTYpsyfpmjRRxz1DG4Lt6oR5ojdopxyJ4QqcMGSmqAYEcmm3QSMw5EYQeWNHBZgEgNVzlGg1HESPFJMMMUMy4KePlFAGWciQLL7SJgwgpYZlHkyzHrtPPOtjioAZlPYAnAmUjOYxMqPI6ogxVj2qHc4Qo8G3X00beS+OMbdtABhRsrjgGgCQsETMGMSTbhy5pskullDgogVXVVVufi4AJV/rgBDTjgEYGLHxqpYFdeezXmhx9OEYESOFgwgA1LVnCgVWabdfZZaKOVdlpqq7X2Wmyz1XZbbrv19ltwwxV3XHLLNfdcdNNVd11223X3XXjjlXdeeuu1915889V3X3779fdfgAMWeGCCCzb4YIQTVnhhhht2+GGII5Z4YoortvhijDPWeGOOO/b4Y5BDFnlkkks2+WSUU1Z5ZZZbdvllmGOWeWaaa7b55m8DAgAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza96MEcMQVahuDIMDj92PVBVSVwAlobWEMqoF/HglQg8cFlj+zBnBubdvxjiicbG2ZZkuZlFS+FvOvLnz59Cjr8LlrRKYPcZOIcNhqcHv7+Dtjv+JTr68+fPPGSDKRUjCuV+ieIefT5+sPPT48+uH3kQQOGsiXNNCfQQWWBUo+yWoYIJmkCHBKc+EYeCEFBpFyoIYZogfAzkAMc0wplQo4og46aHhiSiaB4MV4pyxAokwxqjSDSnWaCN0ACizSBYy9uhjR3fcKOSQy+1ATCw0ePfjkkw6FAaRUA45wRjoiAJBk1hmOdAEUXYp5A7LVKGKlmT6mIOXaApZiATUcFDmmxXqkuacN6ZATBUewKknfQHQ6WeNKXyw56Df0fHnoRqaQOiivb1THgo9MCFIEEKYII8Ge7imjmoVSOGaERqkY8IgumyQAwwvIJqhG4y2mtkwaXD/ow4pvlAjihwxOADSB6HU8Mw3mTRSijSbHNGEqtEx0IarzDZL0Ad3yMIOAbVoE8gCiHri7LbcEtSAC8N8Qoc2PaRpTLfopivQCr24wckmKhDJg7r00mvKMNMAUUiKgdTrr79DfFOBEHhguMe/CP/7hAjcALAfFAlH/G8SwkiwAQPmHYCBxBz/e0E8rOASXQAdl4ywHaesoURztJjs8r8NsMAJMwuQ8PLN/16B88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VhnrfXWXHft9ddghy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744ow37vjjkEcu+eSUV2755ZhnrvnmnHfu+eeghy766KSXbvrpqKeu+uqst+564gu/TvkdRfhDieyR8xCvPwvAgbvjBuy+nAWy/L44Dgc8NwEOxiPOApfQJTBv84TjsDJ5MDxBveDIn2dGHtv/3T16AFwQPt/j4weJfOff/Ufy++mSZ/t13yG8fsTTT7cltSdoARr6m9sV9pWgCZwhgHIjwQwUpAQWIDBuHsiFgg7AvAe+rQNCmGAFLeg2DWiQg2+7xAdB2DYijJCEa1MAtvYzAUOgkG3XgB7+HPhCtfEhBAlaAABrmDYfeEFBvuBh2v8csAQFVUGIaQOGgqaBRLSZMEEHa6LZNGGBBAHhSlIkmyVAkKABKCmLYvOANxLkBfaBMWzSYFCIzii2WCRICbxgo9husML8LOAbcgxbKHC4n2zkEWwdqEaCgvFHsMEiQUvQVSG7poAEOcGMi8yaHOCXnwTcIZJcw4AE9bOAYWCSa2VI0Ds+ubUzJIhkpMzaFWCwH0Z0IZVZG49+lBAHWAaFAmT6QYJ+YUug8MILo8hSDSKwHwn08ieAIGYE2NAkDEBiP8XY2DF30oYMMgcSX/SROvbTBPBNUyfD4KJz1LEkLNQRPzv85k0+oEToLIAKPmqByPRDB3XipA9MKE8r5hf/IyPsBxK4tGdNRpEq8xgzRobAWH5QcEmBziQUddiQC0nkgTPphx0OnQk27neeHPCzQhLYDyEyShNCFHNENFAofhAxBJLOZAiI0A8DnlEhCjBjP3h06Uy+0UppGkgA+5mHTmsyj/2IY0IuIGZ+APDKoc6kCxbFTwRcYCBtyBQLTq1JQvUziAKJ4KRZrUlIL1qfIRQsPx4Na00qqh882Gw+atiPItRqk63mZwvzwYFK0QMMut7En/lhQCfAAwFB6McWA/JrTcKgBf3kAou+OcV+kKHYm6BhP6f4jQzEiZ9lVBYnJs0PHmTgG8Di5wCJ+OxNEkFJ9Bx0Mzx4gH6IoFqc/zwRPxloqGbIoB9PQLa2NIGAH/RTgM2UgJM6AC5OrrHX81AjMx1YYH6EqlycbEE/jOgAZiTR1rdW1yYkOCt+7HGZMLAyP4v4bk4kmx9ENJUy1tDPJH6r3uCOMT9HpUwbUKCfXtQ3J4rQjyNaOhlD5Uca/9UJEOg5mTlUET8nmEOCc2IHpaLHAnKQzDj0Q84J52Sb+dFAZNjQ3PKAwAcezol58/MAJEDGBPpJb4pzkg39gOExOtAPM7Q7Y5xggIDoYQAzGwPj/ISjxzr5hX4UxZgc5ycXSN7JOvST3MUUGT80jDJOWLDkxTgZP5vQ8k5kiZ8aKGYX+hmsmHNCAxsnBv8JJSYPk9eckyLiZwHaO4wH81NlOuPky+gRsWGw8WD0zNnPOLnyeSzAB8OUgsqI1skf9FOKwsSAv/g5dKRvomjzoOBFgwEqnzetEwPopxGE4QMsrmceYpB6J7zFTxSyGZgVoKNc5fHvqwFMVsM0QATSfc4Adr2TIOTnCIopQSWe8wZi6+S4+Wm2YnQADtn6YwPO3skP8SOExqhaCe3Itk4oEdhbOGYEPBb3TRrQP/RUWt3NcuNp3wtvRo2A1eeRcb1bxYlj79tVdohzdG7w71ZZ4cAFZxQ18vMC7yZ8Tw7DDyAeTihA5GcGFB+UD/BtHhpkfE9FxY8aPq4nUSxUQiT/f9Mk8iOClL/ptufRhsvL5AMZmocBa5x5lvaMHnToXEtUuPjPtRRx9Pxh6FgiQH4e8U0gJODpUI+61KcO9Vj0TA75McM3C3AiAvjMGfnx+DG5riGv98we+YHFNMmeIbPzTAYF9d7au/4zNONH7LZkO4bczjMT4UftvdT7gvi+sxacAD9aDzzdfxZa9BhA8WUHmt/RcwnItx1ohscPOSy/96A1/jwShqXgFUT4vufnFXlf/M98EHfzVCL1kQ8amc2TAUhGcvQJKj3PuJCfZIhe9T/DRn648fvYB+2Z6Ek8KXG/H93zDB/5MfPygf+zTuTnB6lkvn6cvzMIiNc83Z6+//GDlg78TMBNn9R+fri/s6/ip3jpp/7PEpGfysd//EHb9nmGff/LE+0RUoV+tyd/PwNt6EFwmKR++MF+hWdt51EB/dd5ReMJ+BEEETh4RiMF5/EAuQANF0h6RmOAzoECYyAALPBRA4h/QdMCDhgCQAAIoqBIsOd/RSMN3CACeaZOCogeDIh087GD59GDPggeQGgeQjiEv1GE5XGESNgbSkgeTNiEm/GE0RGFUpgZVAgdVniFl5GFz7GFXFgZXugcYBiGkzGGzVGGZhgZaMgcariGj9GGy/GGcNgYcugPdFiHi3GHeaiHicGHfvgdgBiIvjGIhMgZhniImpGIiogZjP/YiJbxiJBIGZI4iZJRiZYIGZiYiY6xiZzIGJ74iYoRiqKIGKRYioZxiqhIGKq4ioLRiq4IGLAYi34xi7TIF7Z4i3qRi7qIF7zYi3bxi8BIF8I4jHJRjMYIF8iYjG6xjMzIFs74jGoRjdKIFtRYjWZxjdhIFtq4jWLRjd4IFuAYjl4xjuTIFeZ4jlqRjuqIFezYjlbxjvBIFfI4j1JRj/YIFfiYj06xj/zIFP74j0oRkAKJFARZkEZxkAhJFAq5kELRkA4JFBAZkT4xkRTJExZ5kTqRkRqJExzZkTbxkSBJEyI5kjJRkiYJEyiZki6xkizJEi75kioRkzKJEjRZkyb/cZM4SRI6qYgdgABAGZRCOZREWZRGeZRImZRKuZQIEFEqWJOHcABSOZVUWZVWeZVYmZVauZVc2ZUHkAEEKJONhCxk+ZRiWZZoiYE7ORBjmZZuuYBryZZvOZdBGJcC0ZZ0mZdkaJf/gJd6+ZegwJd++Zd5GQGAkA9xOZiESZcL8AWCspOKuZh0WQf6AJmSeZlOwCM1GZmXOZcwUAKb2ZmXmQGfIIMmyZmi+ZaNSWsdiZqp+ZZCYD6n+ZqdeQSaCZKuSZtuCQNiMJK5qZtpGQFcgJvA2ZkMwAmsiZC/WZxpKQQEFpHLyZxo6QXS55DRKZ1lGQIQY53YKZoRUAX0xY/X/9mdZPkAe2Ca4kmeqbkEsvmPMmAA8Bmf8jmf9Fmf9nmf+Jmf+rmf90kEFhYlXkBVfOkUmoBrXaICBzSgTUEPG4AmEyAJCtoUJLAGaLIAj5CcEUoUGFAGDgglDJAGMZChSzEL/wklkCCgIooUimCgUQIDCJiiR+ECDeolKZAJMIoUPuAKAmcjC2ADGHqjPtEAZXBOULIGDgekQtEPNgclG5BhSEoULBAFaIIIU/CkRBEHwRYlKcAqVioUK3BwXtKjAdWlP9EAdECkQ8IAJgBqZPoTi3B4XrIB9NCmQAEFfNQlIQBPdOoTSJClUIICXLqnPCEDBbCjNZIBUjCmgpoTHP/waGgCBLbXOAvDDQhmOFWgHF4yCXbQOA4gCoAABHf6AIlVOFDAWVGiBXpqOB7AAgIwBpj2HKB5OHfgp0QyAbdDONCQCx0aHVKQODFgZ12SAZjgU4BjbOihLYlDAUZgqDUCqYJTAfghqorjAEQAp13iB5sKODSCH7GqOCVgqlBSBFj1NxxQouTBdIyDBPnkJUrQcn8zAPjhBY6TBLMHJQ9wCcSqNyKEH6nVOMrKrClCCCi3N7LAco/jAIBgrVEiCJbANxywpOSRDpFTAsfiJVowrnpjTeeBB+G5OGywrl0CAv2aN7qEH2oGORewCV2yAMO5N0iQH/gwORxgBGhaI1H/xDdmoD6U4wCvYK4oIgSPyTfckB/YUDlvwFEnwghHqjfJkB8tSzk1EFUnAgIu9jcjAJboMQaX0wb1uiAR0JuBs2zo8QIoZjkesAU1y2K0JTivkB96gDkQMAo+ix8S0LF8Mwf5MVKZsw87oCBWoKiBQw4QNqqXww9Six5HEKKFs6/o8baacwGDkB8hgKKEY2r4obeagwCskLbNkQJZZjg5ix4nQLiZkwqt9xwPkFmJc0j44bicgwYVCx02YLeC02b4sQuf0weHuxxp8KODE7rn8QKk5TlXILbMsQHDuzisix7k9TkfoAYKBQOUqzi2ix7OIDqk8AIoUKWPA7zn4aSg/wMH7vo4AAiXiyoVk4YfAHC+U0Gr5JGq7OsU6BBi8QsVpgCwyzEBZVu/TWG857G2/MsU7ocekxDATREGr3oeomDATBFX+EFdDJwU1XseSrC/EXwU7hsdE3fBSGFx6svBSEECp1sezwXCRpFG+GEFJmwU2xpk2brCQ3EE+cEJMEwUi5AfShCpNbwTXdBa5mF1OxwUjooeReC7qNgBOmwYt4C/y3GrwNgOSgALjcYYGnse8jqMM/oA4NBniPEG+tGtt+jFzlEJYGwYMlyBwAiv0DEDImDEfMEO+jFXt9gL5tED6MCmgtEAMYUfZKCLxIAeUTzFgmEM+vF4sQho5yEAhP8hAwlsHppWip32KIo7GHugH0e3iohsHu+WaoV2Ho/MiZFMHhZQtIbhwPjBxZyYyeXRDIjxBLtaHkuAiqGcLFV7GOUXdqJoffmBu4lRA0zsD1r7iSo7aooxy9HxuZDIZfnxyYWhyuSxDpy4SadMZPrBS5MYDl3WGCSWH4WQr4HYATdFzI0BBvrhR414w8sMGUjwytgzsIHoA+BaHkIWGTyHHh1GiCCGH+MgGXLQyeYRAS+sh5agsOZhAaEXGQaGH0BAiCiMH/U0GUPgCHHsh3S8UMtCGeKgH95Au0gIASuXH9ZgGV2wx/ihumuIzvgBA+48GWgnWkvbhOGlHxB6GR3/wAj6gVdmGHL4MQPpZhkLF1jXEIY6wLnQUcaRqB9+wNEzBwEUmB99vBl3gLX4AcBICHMbOD2bMVanNbI+yFr6YQS+IQPfdx6Y64PLoB8gkLycwV75kU5DhwyY9R0QIM3ooQUr7XItYAv6IQhKbRmd8Mv+ANZD104bskHfcV2BNVEzpwn7MXLzEdNohYIZx1ai9ZzhAcf68Vokp9X4Mb70EbmJnXJYANgyVyBJpR85QG8J1wVFhx5TNSEZrR8Q/HA6jR+KPCEYYNP6kVMJx1M6BrgE8gyAzVIJB1OchHcUwtnoUdb19nmuRVG7Wx4qQMr1htmRDSN2dR51EAr/dgeN/3xzik0iyg0dLxBM/0YBM5ofgh0jHtAK5cEEfZBwCY0fuEC6JEIFaQsMQbtvl8VJGNsj+cwcIOBJCZcHsYsf9+wjDYB8yyEEF11wGFAM/+TNMsIGyrTBDzfe/1ydTDIKXhBHFKdk+4F9WgLc+xYHHHcewRzEPKzb+QEDOsPiO9En+5GgMp4TjrIfgXnjOTEMRA0duUDhPB4Td5AA+3EA4DvkNDECTpAgCqDkNkFECQJ4UE4TwZAg1dDTVQ4TNbYfIcDdWy4T3/Djz7EALxrmL8ELKX4eQIzmL2EK3osflermLjEC+pcf3iDZdI4SDaDG+gEDDbvnLAEBC7YfFqAJgv/eEpWcIFSd6CgxDQrSV46uElWgIIk06SnhCwriBRaM6SSBBmT+HCEgyJ5OEizgz+gxAUFd6iVhCBB7Hgvw5KxOEukzW7NO6z6MH/Z36yFR6/TL672e6+ghBFoO7Bvh6/iRC3pu7BjBAmt+HjPw0sx+EWfw6udRCDE+7RuBBqhOxIGu7RohC91+HiqgW+CeER4gJ0d+yee+ESPA4OhBQe3uERfQ2uUh7/PuEXkQ59CB7/nuEU9wXtGhBIb97x3BA0YOHROAzAbfETgAsf7e8CAh7s2hAoYs8SIBByukAliN8SJBbkUwvR4fEjg48iZ/8iif8iq/8izf8i7/8jAf8zL/P/M0X/M2f/M4n/M6v/M83/M+//NAH/RCP/REX/RGf/RIn/RKv/RM3/RO//RQH/VSP/VUX/VWf/W0mO1ITwILwAycwAJuvPO00BxKsAanENBAT+PPgQusEA/tyfMYIOzNwQAbIAHC8OA4DwX7AQA3mIM0v+gKggdCUAHfYNkuHwgpUggeAiIszwNEogKbwAlu0At4LPGEjCY9MAh08AnD4AJhP+tN/ScLEAjaUAsEwA6ycAf7PettANho0gRHsAnSUAqNkAnf8Aw1kAirvxEOEANyIArU4AukoA7ckAYEDqNuQJsvAAM5sAG6MAgmkA4aYASuIQWcog6usQcaIA8m/yAEQSAITNAD390co3SjxqyeJ/LQKfoBmIr+QoJKKeoBVUAM7e/+KaILT8oB1CABQAYQ/gQOJFjQ4EGECRUuZNgwYY5/ESVOpFjR4kWMGTVu5NjR40eQIUWOJFnS5EmUKVWuZNnS5cuTqqos2+HQ5k2cOXVOgNnT50+gQYUOJVrU6FGkSSNCEIVuzASdUaVOdRhG6VWsWbVu5drV61ejGGjEIlaT6lm0Ou+AZdvW7Vu4ceXO7ZhlkTIAafXuPXiD7l/AgQUPJlxY44oz4qzA4Nv4rB7DkSVPplzZMkxTw6YBycHA8WeHpC6PJl3a9GnJYZ6dkkDGDGjYBUGhpl3b9v9t3ElbXBNhDZygJrEby8td3Phx5MlBjhD165wEQrkQeRauc4xy7Nm1b8/dwBIOZKeM7QFTyRuuVcJTRGGma9kWa1yi4eBe3/59/JdHzPmDZQocPUR45QcBKjAQFAkSlAAUAw1M5Qd24IFjmBtQUWUIDPLTcEMOO/TwQxBDFHFEEks08UQUU1RxRRZbdPFFGGOUcUYaa7TxRhxz1HFHHnv08UcggxRySCKLNPJIJJNUckkmm3TySSijlHJKKqu08koss9RySy679PJLMMMUc0wyyzTzTDTTVHNNNtt0800445RzTjrrtPNOPPPUc08++/TzT0ADFXRQQgs19FBEE1UQdFFGG3X0UUgjlXRSSqEMCAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza94ck82PUyLgvLkh6tYFDJxTq179UJK/17Bjp+jBSBeQeeWIxNN0iwPr38At/4hNvLjxJuQKmBPXjUaS4NCjFx5uvLp14ii8mLDhBgsJ6eDD1/+tcL28+dgqBrDKpmiF+PfwzZI/T7++LSuYfs2Jz78/Vhv1BSigCmRAg0Yi/iWooFISCOigg7ZIwwUqDixo4YU8ffHghg6iUEkFijSA4YgkvqQBhyg6OEEl4lAhYokwxhjSiSnWKCAKxHxyi4w89miRCTYG6SAu88DRgo9IJpkQkEI2GeALQhCBjZJUJrmJk1gKuEE5olTpJYxBZClmgK2UQcOXaC6IjgYmLBGEH0cUgcKYdBpnBifPpKnnhQ7EoIoo1PiSihTNFLBOCHViGQkmWezpKIwNWIKFHrF8IQQAFiSaoheNTPnopzBCwMcNkpSyRCQMaCogA5XQ4gGosMb/yEEf3UixRBGq0ncAK73E6muMMdxACjgA5FqeE6R89+uyJI7AAjrLIGKscREoQwWz2JJoRzdfbLDAtLHNEE225GI4AjKP+PHttK+U6665cEjAhKpK+PDuvRjykQkQq9A5D74AY+jAM5jMkGWjASd84RyAbJKpjQMoLLG5lJhwQorjTqyxhS3oscycDkaB2sYkL9hCO2lkEGAFJbdsYQyLVHNeBgi6bLOCcwgQyXVA3Ozzgje4k4JxN/xsdIJhSDJJbEcc7XSCnagxdBVPV92fD0SEYfXWXHft9ddghy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744ow37vjjkAvVgCSRV84TNrn4M4rlnNvEggqvZdBr56S/VM+6rxUxROmsp9TCLsaNAUHrtI9kh8HVCVD77h5N0cR1C4jB+/AYVaFyeSCYQvzyEWGwRX26dMD89AuNcGWAj1CvvUGWzOtgONuHfw2iD66iSvjUKzABiougzzwgqW54wD3uL48JijPsWD/vHdC4oTRd2B/vPLAEDi1gcwLcXQw8waFVQCGBu7sC7h7EDP1BsHV8KASHCjCCC9LuFrja0CMq5EHW8QB0D1oA1UrIOhwcYEOOKAELW/jCB2mhDzMsnQs3tIGa5ZBzO3zQIP86+EMg1tBBQHhRESsXRAfRgYRLjBwvjiggcUTRcifc0AqvCLknSMtBC/AFFyM3hxAKyAJwGCPkLqBBFT1QjY4bASQeNAEWwNFxHwiTgw5wrTsyzgFMEtABcODHxvkvQIMsJOPmI0hCKlJxbqCjIR6puBIcL0B1pGTidKAEB1ngEJpEHB+i4KAHoCGUh+vCHB0ED1QaDgKueNAPXGk4KTzoErQsnAgeZI5cEg4LDwsQEKDoy7+ZgnwB0oVvigk4CmROQE5QFjP/pgYHhcAO0wQcERyUgi5l029UCCZ9FoCMb/qtDaQU0DnM2TcHaMNBtWBn36zhoCAoUZ54e0P86pP/A2ni8258+F2AlFCDf+atA874nkHzRk8BlWOheLsB6uhDDIjeLQZmpI8T7GXRusUyQClgQ0frVgUH0WKkdHPB+gLUS5TKrQPPrM8klulSuAlAQKuQQ03jdo0HCEgYO4UbB5wgoJYG1W0AChAjPnBUt9FgouaJAA+a2rahCogIVG3b/QKUhqyyrRM+rY8KruBVtXXACwICX1nTVg8BaWCtaZPDSukTCI7C1WxkENAU7nq2bggIGHw1mwNwESAzHCmwZePDGupzBsSiDRk7K088HYs2D2BCnMSJgl0pezYkDKI6QOXs2mgBA+JUVLRsW8EX4ocCPqDWbddY2ixf6zYH/9CCmLTNrW53y9ve+va3wK3SyII7tg+kogeeIu7XICACM7xmssrt2jDQCpsHuCC6WzOAHokTAOw+7RbLuI4OvPuzK3whrNbpKnld1oJygMw8Z1pvyUoQIDLIt2UDCFB876uxZ9SXvySzQoCuAWCN8WKf5jFBgTUGhgAVdMEKqwGCywMOCEuswfR5wBMsnDAJ1+cLHE4Yhs9zgtWFGF81CJDuToyvQJpHBUxl8bsMEKD2yfhddagPAGZ343JNIUDf6LG71lEf+wqZXPEI0B2OnK0ORPY8IGYytj5RHxRsVsqxakG/6PMJLDMLFvVpmpd/ZQeoXmeSY/bVYukjjTT76v/H9HnBBdwcqyPUZ510BhUX6sOIPIPKB0Ojz379vCdW1Ae6hNYTKurjiAAmek+CqE8rH60ne9RnDJTWkw/mWp4F+DDTXnJHfWIBajRpoj7kKDWaWlEfhKmaSow0DzQoC4QE2PrWuM61rm9N6ondoj6toGwBakSAjR2jPt4M7LBTVGyN7Zk+UnDsslHU7IkN4ZLlCTZip82hak8sDcjeNrFJRon6RFvZ497YCF5An0KIm9klEzB9RMpXbm/I2xMrN32MgW54k2wEEaBPLvpN7Zat2TwMCEW9002yXdKHcne194PwbW0zV6cAC/d3yfJ7ngi8Cq4SdxDFJ5aK+gQZ5Az/J9mv6bOHiKecZN4zDwBcrvGS2ZI++1lryAU08ondoD72QHnNSYaBTp5nDUIvuM0+ah5HSK+sOw9QzydWUkHr/OUkk0N9GnH1oZesWOcxslejXp+pT8wI9EHB07NKdvqYXWLJqM+gm9r287xdYReYsHW4Pnasl2wD9BE7VetunrsrrEHnUQJug0r48hg+YXCoDy/67vWSkUDv1bHx4P1eMuqaxx2UV7rP5kGfmbOd8ySDR31MTHfUb8wF9QHl5ivfMjzQZ9azF73P5G0eIZye9iV7B31C8Hvd34wF9VFe64H/7/qccvnGv1kbzcMy6HfbaUCgaO6vf7RG0KcI27+3/9OgUB/3HLXx13m8xGJQHyxYX/xO0wJ9NL9T9FtH/RITAn3o8P6JPy2p5jEI/SdyT+Nw5gECA8hzT3MN9TFnjOd6JdMFmGccaFZ/EFgyhHUe7HB+Fxhgt8eBzNcypUAfPfOAIVgyz2YekACC0ecz5Jd4LMh9TmMH9UFWFniCJOMAmAUbGdAKlcAKxqAHh1VT9lcd+DcxRIUIxSAP1uAGUzAHi2eCLegz2EBTBCeDr0YiRWgcR5iF4bGFxdGFXigdYEgcYjiG0FGGsXGGaAgcaggbbNiGrPGGrxGHcqgadOgPdniHnJGHe8iHmuGHgKgggjiI/lGIhsgfiJiI8LGIjP8oHo74iOARiZIYHZRYicFxiZj4G5q4iavRiZ6YGqAYipsxiqSYGaZ4ipeRiqpYGazYipPxirAYGbI4i49Ri7bYGLiYi4uxi7yYGL74i4cRjMJYGMRYjINxjMgYGMq4jH/RjM7YF9AYjXsxjdSYF9Z4jXeRjdpYF9zYjXPxjeAYF+I4jm9RjubYFuiYjmuxjuyYFu74jmcRj/JYFvRYj2Nxj/hIEB2AAP74jwAZkAI5kARZkAZ5kAiZkAiQYzi4jx5xCAcQkRI5kRRZkRZ5kRiZkRq5kRx5ANgGfw6JEgoALiQpJn8YkhAxkiW5kkJykijpECrJkjI5hS/5ETE5kzj/qYA1WRI3mZM+WXg7yZM/OZTmAQpBSRI9SZRKCRsRAAj5cJQhkZRLuZQL8AUxBpUdIZVTuZR1oA9YmZVbGZax4QSu9pUYoZViSZQwIENmeZZp+ZYZ8AlR2JYPgZZvOZRVeU90mZJ3eZdC4IB7yZd9+ZZHUJaByRB2OZhDCQPCU0gckFwKkpiK+ZMRwAVR5ABzMAVuYA3yUAzS4gQXIpmT6ZMMwAl6uT8dYwy1UAmt8JGwYQFzCR+iOZo+KQSsJ0BXUB/YtCCzSZs56QUPlkBGZx5vFJm+2ZchUJz7s0rmYZm8eZx9GQFVwGP1k33nUQoW0pvQiZMPsAexyTzQQB9W/5Cd2zmYSwCY4cMO9IELFiIDBvCe8Bmf8jmf9Fmf9nmf+Jmf+mmfRBBwieIF14U+hkAfDOBof6MJPaApKtBY4XMB9UFggUMPgJcoEwBx2wMC9CECg0MCB0cnC/AIp0k8n3UeNkA4GFAG6DUmDJAGMaA9dBB4hjML/lknkBCgzLMI9KEFh6MICZooMFA0zIMFq3c4LjChdZICmcA8K1Afykk4PuAKE9gkC2ADIdo6GXUdfHc4DVAGFocla+BPtUMMJLg4/cBpY7IBOsU7N3Ue7rY4LJBOdYIIe7U7aFAfRKQ4cTBBdJICbrA7plAfdsQ4K8B7HmoDFFA7yFQe7+A4Df9AB13aJAxgAubHOvp3HuP5OItwMYmyAfTQOuF5HngQOVCQqGMSAn1EOshQHzbqOEigp2OCAn1KOkMgaZUjAwUQpUKSAVJwqJ0DdubxL5XDASOoKUBwp5UjaufhBZ1TBYFWJ5Owm5WDo+fBAGAKOVCAoYmiBacKObxQH2nUOXfgqmIyAZRQOQ4wnOUhAaUTAwWUKBmACcPlOHl1HhvAOhRgBLgqJMUKOd5HH+jJOQ5ABJpaJ34ArYxDA/WRDLRTAthaJ0Xgfo3TAe9VHkZQO0gQc3SiBBraOPMqc7uTBGOgKQ9wCfGKOP16HmlKO/ear0FCCFqjOAhLH1tEOw4ACAP/SyeCYAmK0wGOQB+uQDwlIFB1ogUQizgdeh1KULK0wwYYOyYg8GmFY2n0AaTDcwHXMyYL4JyIMwfmxjwcYASPWiMttzi+Wh5MMD0O8Aoz2iRCcJWJswf1YUHL8wYoJCSMUK2H8w31kQraUwM5ICQggASO4wFrex0Roz1tELI1EgGN6TiNtwC3yTwesAVhax4PgFWQ4xoZGj4QMAqFGyASQJ2OEwos+xpIhz77sAMPYgW8GjkxVR4RYKzaww9/GyBH0KKWYwz1Ua7ucwEjeh4hsKqRwwb1canugwCsULn+kAKB2jnTVx4vILvhkwrsZh0PcAqsc3Pnwbv7gwZCWxw2/yC6nCMK9aFeAtQHtUscaVCllcNqMxO57nMFlUAcGyADtaO9zXlBH6AG8QMDwls65Esfx1BCpPACKDCnu+O+5yG3CQQHG8s76lAf1XeYfkG89KFtFOwXzGkempDBfnEO9QF6HswXoaC8rzEBVzbCd6G45xF0KqwX+nYegvDCetEFPUsf40XDeFEL9cEKOowXMXseKZDCPxwXjFAfWlvEcwHC9CFmSjwXQ1C954HATxwX4FAfp1vFcTGg42SwWuwWdkYfsPDFcUFl9LEKQ0jGbOEDE1seXabGbqEh9BEJawfHanEHARIPdtwWHWse67DHbKG39UHFgGwWEFC25YFphf+cFtJKHwawyGjxAXWbYJCMFmtKH8FZyWMxBDdbHmCgyWYhx9OayaAMFk+Qop5cymRxxQRKyqrcFSlWH5/8ymHhYuXBAJNHy1/BgMWry2DRx+aRJ77cFUF8Hoc7zFwBzOXBlsisFcV8HShQDmnczFhBqMbxAF9gg9S8FTpwHcvAwNusFQFgHEHwyOH8FS6Qol4wDOcsFjzsD2YgAuLbzl2BDT2QClZIz2ChtPrcz/78zwAd0CFmW98p0FMxHJMAoQaNFXwAMgzwBZO60FQhprEBAycl0VMhDNUxCIKL0U/hA3BaHBaACR/n0UvxztcRCeVk0klxBljsWixdFC3gXPX/gQsFHdM5AQwC0g04PRRwVmQ9LRQ+EAiYlLJB7ROHdB71cNRAEQ4C4gV1zNQ6cQWTbLmdINU+AW4BgglY3RPbFCBOkM9dbRM88LnAM3djXRMfcMQBUqJpnRPmAE1i/dYyodEB8gAKTdc0IQdbVh8rptc0wQFLEyC5ENWADRNxjUn/e9guEcP1MbOM/RJs0Kw+G9ky4QNEFSBFgLuW/RIUXR8LQLWd3RLl4CDWMNov4dQC4gyGjdonUQPoeh5NANOurRIkkL4E+ga1vRINsF31cdq7rRIoXR/acNPB3RFMHCBR0AbHjRLIYMKxYQHb2twjIQqUTR+YS90kYQekeh5q/6DdJUECmU3YrQveIMEBumBNymfeIOEA1hkgFlC07P0RiS0gDzzfHnEJD3Ju+O0R1CEgrjDP/Y0RqucgkGCgA64RaIDK5xEFtJ3gGXEIO2geSpDDEJ4RLGCmM8PMF34RhqDh5xGrHX4RTbQyI44RJV4fb3XiFpHi9GECxs3iCGEIVFQfQeC2Mg4RGf4gkCC9Od4QUADi5lEI//rjDQEHE24eRZBzRv4QtADdxIEIG9bkD1F1DqICU0XlDiEO8pPLWr4QDvCiD5JIX74QDfDejVTm1fO7aa7mCZEIRtrmbn4QfSB/Y+5Ic24QJXDDe4TneU4QVQDlxIHlf14QDvAIHP9SBOCc5yOghoXw4IV+C8zAITOgzYX+D1DQ1w7iCZx96aMg6MSxBCVd6F0gDSiiAa3t5rcgrlt96QNxDzUeIAsACK4uEI1MRwpQ6wKhCpoeICGQ17Wu2gLCBDqr6wSB6AGyCT5e6x2Q3vSxBfxs7KbQsNaRAZBt7AUhBmHbBISM7QZxycUxA17s7QYBASwcG7swzeR+EEOQUQuw1OveEL1wPCDQvPHOEKPgD7kAmffOEJLAvv0e8AI/8ARf8AZ/8Aif8Aq/8Azf8A7/8BAf8RI/8RRf8XYcBkRAxAhfUimgBlfN8GH8GpMgCS978D9XHCngDqI98GheHJEgAEze74n/4JrGUQ2L0OnkHmvmkQFp0A7q7uoYENJVtgxCaOzRkCInYAKUsOxlznE1YgGbAAgxX+ZZkCUzgAnPEOMQTnpjsgpAMAuQzuI+ENtjwgQSAAdM39+vAC4L4AePgAxpD97RwOqqsgAb8AXdMO7sTQXKYNbGggjLgA4sEPe7TQKkMN4yCQDgQAo3gPPU3QusEOssWQRLAArd0Adz7doeQAuVULrTwgCRsASlIAk3wAcCbtnY0Aiet5QWAABC8AWxoAdYMAcAn9ZsgAlP9pYhsA4F0AxSkAq+QA2ioAoxkOpB/QycQNPQiQJFcAR+EARLYAIagA5MTQNloMDl+RpB0NWi/4APcQ6dm/DW2EAEQiDFtKlget0CcDAPGTiZ6M/Yt/AJxNDGYrnind0AVCAOlSDkQwkQGv4NJFjQ4EGECRUuZNjQ4UOIESVOpFjR4kWMGTVu5NjR40eQIUWGbKCoQiUU/lSuZNnS5UuYMWWq/DLS5k2cOXXu5NnT50+gQYV+dICKizRbM5UuZbpSwlCoUaVOpVrV6lWsWSkmQnOJjIqmYcXa0FrW7Fm0adWuZbtzzi9MVpKKpfuyQlu8efXu5dvX784VirKxGgC2rti7fxUvZtzY8eO0JLC4sWHCS8rDMX9A5tzZ82fQoTEmwdFNnLkC5Jpk9rdZ9GvYsWXPVszhlr+meETKzQOii1GPFDIl0SZe3Phx5FUxXLgl6sYbOCJO/WCT3Pp17Nm1b+fe3ft38OHFjydf3vx59OnVr2ff3v17+PHlz6df3/59/Pn17+ff3/9/AAMUcEACCzTwQAQTVHBBBht08EEII5RwQgortPBCDDPUcEMOO/TwQxBDFHFEEks08UQUU1RxRRZbdPFFGGOUcUYaa7TxRhxz1HFHHnv08UcggxRySCKLNPJIJJNUckkmm3TySSijlHJKKgUMCAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp03PvmELNuvXkav4SOKtFitoV17hzE8bjr7dvfyHqgGqHBILu48jpyvjN/LeSbaB+8UlOvfrZXs2zMw+xJhaNBtbDi//PKkK7eeYnBmAq0WK8+/dM1Z2fz9yCrks3OMDfz//nGvoAMhdBJanw0t+BCM7ERIAMMtdDM9HIkOCEFJbkgAUNZvjbA0GMckuFIIaYkSoalsgcE2XQIOKKLDaEjIkw/tZDMIYY1+KNN5IS446+hbDFDTbiKCSFrPBoZG89wCLKkEweOMCRUPoDgACqNGnleKw48UCUUA7gRhhXhkldA7z8UgEhrXC5YwrusCDmm9T5YMgnapCzpZoaFoJOEnD2iZwHWJACBi54NmhBALL4qehxVwhTiiB3FjpfDoD4sOiluHUhxiW6RCppdkp8gQSmpLbWQglleMPAp9pVgkyQpcb/SloSlCgDAqvNOXHKB7L2ShoEqAiwDq6/gSDAEL4mK1oikqRxArH+nGDEdMpW61kLv4CBArEWaBCHteBy9gEcyhyAKwMB6BDuuplxIAwhL+Bqgrrs1lvZCOyMseqn89rr72R5GAMAq8vU8O/BkD3DiiOSLqABtQhHrFgXmQgiqQUSICvxxoj98QXDeKJABcckG9bFIjOoiUh7JbdM2BRreLqjPS7XTBgfNiTAoxMd2OyzYGGMYkuMcPxsdGAd6DGshroc7XRgZwSR4TNPz5XHCFUr1EsaARKSNVwQfOKIEV8rpIMJ8z3gQtlt/WGxPwssyTZCZ5s3z9xqdfGIp4LA/4o3QXUzh8Jtf5vFQiTZVVE4QgZo81sFi5PlQy3mrcJn5AZB4QdwLGP+1TBmzOeO5wf98gvpXo2gQYCaoO56WCyEHiATGLxuu1YcSKBhPbf3XlUnTpSYgiW+F+8UBO9kAKMJxjeflCmD8IiM89QPhQZvPDZT/fY9cQCMkSrAw/34OakCiZHNxED++jUlY+6OTrTO/vwwNaD7jg/YoB/9/LPEx9sxOkIn+kdAlUxBBTvKAD4oUMAGmuQcC9gRE1DhwAqKpAsB2BEDOLE/C3qQI3bwwo5sMYUPmnAjisAejORhqRO60CKSwBCMlECLF9pwIg7Yw45yUaUb+tAhI6hDjP8YoI7a/fCICsGGCGGEhzMg8YkIQUUUYqSLPEDxigQZxrZgZIOeYRGLi4igiRKAhi9+ER8B/JAZoegAysEoAJ1b4xE/8B8TLSAWcoTiCGBjolU4MY9IvMD5TASAOwASiXlgBozGIKFD/vAJhDJRMBzgyB/yoAd25EIlLYlA4U1vkzfkQSc1hAgKgtKGOFBhho4AsVOeEAfv01A1sOZKF8LSRLvgVS1PyIMdmIgVlNylCUVpInwI84RPGGWGRnFMEz6hCCVawCya+UFTpElDFogGNT0Yg5RpaAKf3KYDu5CLEk3ATeJ0YAMc9010prOADliGOd35TgLqUEOOoGc9+Yf/jnnus4C08Oc/+wcFGRoqnAOdXw1iySALlDGh9GtDIDS0AD1AlH4fKKeGFnFR+mVQQ8bo6PwwUSIbiJR97SiR9k5KPlFMQENL8CJLt9cG2TVoHR6YKfca4Iw8XUCn3DNACjIEgicAdXy8iCSATtCLo5KPBGMIkEWdSj4HlIE+06Dq/KIxVO2MTqvzS2p2qgEesM4PqsyxRRvMyj+r+mYC9GIr/7jqj6nKtX+8+MFd98rXvvr1r4ANrGAHS9jCGvawiE2sYhfL2MY69rGQjaxkJ0vZylr2spjNrGY3y9nOevazoA2taEdL2tKa9rSoTa1qV8va1rr2tbCNrWxnS9va/9r2trjNrW53y9ve+va3wA2ucIdL3OIa97jITa5yl8vc5jr3udCNrnSnS93qWve62M2udrfL3e5697vgDa94xxuTCxCBvO+BQAmWgSF9ohc5cyiHFn7z1fcehwLR2MS+fjOBFtrXNTyQgCqbM83/ooYDp9DofJpm4NN8gKHzsUODT7MFBmV1wqWhAYOcgGHTLChAcuuwaOrBIFhUFggJSLGKV8ziFqsYj77Kw37nY4bKFoBHBFDWNhjU1MneeEc5TpYbGBQMyv44RkH21QieBaAo+M2xR4ZRkn1FCB77GMfV0kOJrwzkarVgi/RpBZeRbC0wMMiUkI2yiabsK2EwyP+YkVVzidjcqy4wmT6QkKycNUTnXu2CQdiIM5atRQkGnTfNg67WCJQHICEIusvgYid9IqBLKCe6WoBg0BsQDWlr2YFBdOA0mcN1hAAVQtRSXhcoGNTDxu45Q3321Q0YpDhLd9paGAAZfbxm61GH688A2kEwGfvqBsXaV6dg0DV6nep1fTpAjWD2mut1TfqQQdpzrpc5AoQCmSq22Aw6tq+SwSAVEfvS4BoCg6J97luTOkBWcDW6wWWEAOFB3u4GVzwYZMjFgjtA4vbVFRjEjnb7ml3BAxArDN7senEjQEdg+LTtNYsAMWAF/p43uGrAIGpkPN/ggoDOAHThxP4bQAH/T5YQAbSLjx+cXRUIUCBc3vB6DYNBJPi2xsE18ABBQecgDxcmAcRuxJ6cPilPFjECBASgv5xdaARQDpxe83qhIUAL6KBhjz6fpPvKFGc2+c7D1YQAic/oYweX1ABUBrEHPVzfA1AB3P50dlVB5nSver0UwSAwHZbr5/G6r0jAoLgWFvDmEbyvhk4fbf497eDaMcrR/vZwbRtA46B83dl1jgA5Q/N6r9c9AqQC0E/8YGxgEC0PD3lrUWDG5zH8YBGvHcX7amgAusfjKx8uydPnE7vfPLvGESCTbr311rJGgAIQ/NDXK9kA8kTzT38wagQoCtPPdsTiYHEjEpb22bF9/688wKBEHJ/34VoFiM8vfIQHaNOsRz+4ngSggse//ev6KH2KPnvkWysYAVIK7Od89WIMAZIOA0h9B5MJATIGCah9EXN1ALIOD8hnG2MIplaBsLYxWWBvGmhsG5MHWPeB4bYxXcAg/iVY4Ncc4ucrBjUfrRRYK8gcLdgrtwIgfXB/BEhtAWJu/Sd/4LIBAXIDOqiAB3MMAfJQP4h/67J29HE63+d/1oI2ACICRQiBEaN/86FJUQiE1rI62YECCQACgRAIG+ALV2iBG8MHfzAHc9AGK+B3EoeFImYZM/gbNViHhXGHvpGHejgYfNgbfviHgRGI/jCIhPgXhoiIidgXi//YiJTxiJAoGZI4iZBRiZboGJiYiYyxiRAVBivQBnNgB38Qg6jjidTkCxtQhiCQAGDGHBrQO6jYTFywfLIohZtUHgDCPLczi8f0CwESBLfohZskgfRxDMPIhK40awCyAcm4g7ukYQAiZr2Ii5XUBwECAs9ohNTEBwFiAdtIh9vkAwzSBeHRAQiQjuq4juzYju74jvAYj/I4j/SIACunjK4kRvRhRdZxCAfwjwAZkAI5kARZkAZ5kAiZkAp5AIyGj6c0YOaRBeGhANBSkRbJiF9UCAFiCBNpkR6JKxiJRUtDH0pIHRT5kSiJJyF5RVEFIJnQkSkZk1CyklCUDgESUtb/cZIyuZMOCUqlECBFlpM8OZQmAgr/1Ai2KJREuZQMEgGAkA/1xA4BMgAwyZRWOR8L8AWVtk1vECAcppRXGZbmUQf6kE6iECCrUJViuZbM4QQSuU2JwCA5VR06yZZ22RswUALbhAGwZx7fQpd3GZi9kQGfMGzCNEUA4nGAKZiBmZVlJUyeECCnAJaMeZdC8FPCpIXnYQ2UWZl2eQRvWUs2ECCZt5ieGZgwIAa79AkBsg2deZpsGQFceEqjByC28JqwuZYb9JiVpAMWx0AmmZuVKQQaU0kjwCBsYJrCGZheYDCbpEznoXvBuZyMGQI/V0k9BSDnoJzUeZcRUAVPZkbE/wcg5sCd3WmXD7AHhrlGBNCa5nmedrkEmClH0RAgPVAdMmAA+rmf/Nmf/vmfABqgAjqgBFqgAUoEEUAsXrA2cuSbAZJzzaMJjPcpKvBHZhQGDKII1EMPQogrEyAJcjRRAFJrzkMCdcQqC/AIvAlFXAcM24MBZSAzeMIAaaA+WHRVACKM3DMLCYorkMCgUAQPAdIE5KMIEyopMECEUIQKDLIa4+MCHcoqKfCST8QB+jgfJbk9PuAKfakmC2ADK3pDORAgcEY+DVAGVyopawChPwQEAUIM9NMPL4UrGyAHR4SUAHKf9MMCiMkqiFBCPgQFDEI48xMH3iSlbuBDhBcgw//QPytgBcTypcD5QiJKH5DTPw1AB2k6oyaAcS8EbPRRBw20CHf2KRtADy80DQGSAOHJPlAQAsQSAiNzQtYXIM5ZQEhwqJ+CAolqQivQpdlRYA0kAwUArFGSAVIwqRb0YfTBDRbEAT9JLECwehX0cADylRZUBV3FKpMgYRZUcQFCqBUEBTfIKlowqw7EcQESDyZ0B7oqKRNACRUEAb4EIGRjQjGwBMSSAZjgfQQEqQAScSdEAUZgrFEyrQ2UCgwynx/kAERQqpLiB97aP53AIMlgQyVQrp9SBFhAQA6ga/NRnjaEBMz6KUpghf1DBgFCjTaUBC3JKg9wCf66PngKIBP/+0IEa7BQQghyuD7XwCCT6UMOAAgQWyiCQDzs4wD1Sh8td0QlUHa4ogUdyz5VBiCOMLM2xAYlKykgYH7rc3dD+EQXsAkoOpvkQyIBYpRVagSbCiV7wD8aGbBX5ACv0KNcIgRbuT50wCA3i0RvAJ08wghsOj9dGSCA8EU1MKZHAgKj0j8fYLfzoQ1m1AYvGyMRoJoFJAQBkgHUCkUesAVtyyAPcGgFRAQMIq9mBAGjALkZIgGtyj7YwCBNu0b7sLQNYgXKWkCDRB8nYI5yxA+KyyBHYKMVFHUAIgyAdAHREyAhAKQVxKQBAgaHhACsELq/kQLu5UDVNh8oEEdylArx/2IeDxC0JgQLDGJXgIQGUJsdNvC6BYQdXbNJfRC8v5EGYWpBENCn83ECnZtHV1AJzLEBjfRCABggvVpJH6AG+wIDzutC8AsgrnlKpPACKACoPmRT88EA/AhKcICyP2S+AcI7nHgZZzk7I4wZCQcgPnjCk6GqAbIFLFwZzwYgB5C3MfwYugAguXAKWnfDjwGu2oEHEsADPlwZPjCnv8EAYxANuVvEkuEOv2EG+IC0TnwZLOAPFrAMJeC+VRwZRMCwXRzGYjzGZFzGZnzGaJzGarzGbNzGbvzGcBzHcjzHdFzHdnzHeJzHerzHfNzHfvzHgBzIgjzIhFzIhnzIiJzIiv+8yIzcyI78yJAcyZI8yZRcyZZ8yZicyZq8yZzcyZ78yaAcyqI8yqRcyqZ8yqicyqq8yqzcyq78yrBsOz9gILGsFFqWAo5Xy0ahA0hcBuupyz/RBrjnG2MwuMDcEw3AR8yBC7R8zD0BxdqBy87MEy58Hr48zTihZQBSzNhcE71QtObBzN0sE0+gsQCSAgYwzi9xAXHbIM5wv+psEh4wkgxiBmsVzyvRAZqbIRMQYvicEs1QIu3wzyvxCCWCCQStEgaoIcyX0CixCCXiCTbs0CGhB9ZrHoFwzxRNEmjwggFyALe60SKBDB4NIBZwnSItEiyAxA1SQymt0izNIOjw0ir/DbIM8rY0DRIrXSLL8Ms5nRE7rSGVAM8/bRFBnSG54LtFvRHIENMBMgPEu9QZEQ0lPY1OKtUZMQsXbR5FYFRYnRGjYCJF9dUZYbwZogJETNYW4QBFUiI7kNZqTRF0ZCIHgANxXRF7RNd2fdcTwQelViJ4sNd8HRGogAgmgtaDLRHIsK1nDdeJ7RBcsNXm0QOO/dgL4QAFXCK44NWWzRAyULkZwgwb3NkKcQcDYyKQAMakfRBnoH4mMkurvRCxINnmsQYTHdsC0QKamSG14NO4/Q+38NfF9NsIgQYjF00cRdwF0QGjCSMo0KjKTRB5kMMwEgVoFt3/cAYQ2SBeEGjY//0PGKAOOjsfddC/v60KCmYi6vnd/0ALShAjFgCi3+0D8rAjeKCh3z0Fw2wiXtC3v80BnDDe8xEASq3cqLC1FLWd2E0B+NCQh23Byt0Jwg0jgmCKsc0BNiCjGiIBRN3ZmpDCMHIAFxvdMRDQPAIJrUbc8AC4JQIMPYzbJm7fWUrcL7Ijg3DV302FJZIB78DFsW0JjL1hA8TeBUFirfviRI4BCG4eZpC9RC4QmhAgGmDeYGU6vQPNTA7dfNUCsOoHKI06SeDa2VELKbhXMecb2pDOrgO2zBEJTs5WV/CKvdEvpAMBAOQPD/AIBd5X82AedI45oiBGgvAHguUCGv4bf/++OEbgCJ/g42ZVtfSRBj1WOCMw2oD1DBkSBIr55ARB3RmyDnrgbewNBzFiC6PQs9HdASA+RjZg4bFtD1DyAGsA4bHdAobNJTOwCHtu2YYg51DiCF9A6Ks9BBIQvngiCJmw64PNBxpA2ybiCKxANaRdA/L0KQBgDJY+2IEjKUrMDlSu1tsuKS9ACMKA5OAeAAK+IwegDHBw218dBxpQ1WqCAmDwC96r1nxgBOCMJyeQBpKA42o9BAJgzqyyDgKACo6e0h9wCquOKyCgDJRwOWQNAcgAwB7JAN5QBuyh1kjwBe/9kQ9wH2Kg7DTtA4BAvx75AIJQCsIgrj8tCwEg7xX/iQtgQApYMJc5nQTo0M4y+QDkoAafYAhlvtEs4A5BvpOtsAsV8Au80OHjHAZuQH9W+QBOsHAirQoCcNpMSZU0LQqwcKQyafU5DQE3sAWwupOkgNUQYAjBAPYViVBYTQNlsOSskuJqfQujEASHziUW4NtkLQPR0AxuDyVMgNu8kAqVwLpGsgbKzQE3wCkynyHqwN5dUAKYMAD7HiAeTOQNQAOxsAZn3yCTzukDwQe/AArb8PHzMcCkbxAQgATtAAp1EPq/cW+t7xBXQA2kUAvOoDPVcPsUYQr9BvzEX/zGf/zIn/zKv/zM3/zO//zQH/3SP/3UX/3Wf/3Yn/3av/3cEd/93v/94B/+4j/+5F/+cBwQACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH04cLw5aMYorX76zmb8FuhrxYE69+sso/rJnD8TJEATr4MOH//yjvXx2EOZKYBDPvn3Fd+bj+9uhRowD9/jzJxwgvz+IeYboJ2B+KzzQ34H+BALNHQM2CF4yCEboTy5cJOfghcQ5J2GELwQAxXcYhtgbdhtuGIgAfIio4m3klejiAsS8AeKKNLoGn4s4+oMLOkPU6KNq/OWY4wsa/PHjkaMVKOSS/gwQzoxIRpkZHExWGckoLUip5WW8GOPMAlUKuQo0bWxpJmVDwEMICmHiGAErLpzpGg2ygPcBHO7s0GaJDIDBi5yp3bCNP0xAWR0GJaih554SmtAJoKSVEER54bhHwSHKKMFohGTQAOlnNxQT3zr6fdDOEgZu2p8QOnyqGQ2D9v93xoBtjAKJqv2Z0KqrlOlARoRBXPhHMKvgGl86T/AKmRzglNgLhhz4oo2x5VkAzBXKLjbEHha4mIaKt3CyKLUoWONDtoZ9MM0BQvax4gciCEJtdjAs0gG6grUTCJNg+GiANBnMe0QJ+PplgKhVLpCsj6ZAg8e8ZLBRcF6hKMNoLUh+IAkA1D5QyggT04VBKo5sakEeUUIgjCfUwuCGoSGvxQITxpaypSG/GpvLNTGzFQoYxj6gwS1n6mACA7gyAAzIPZsFARfsqmoBKwsDWgMYSKsaQjtNk/WHvFJvkaKyV2e96SZVd82VBzakyqjQc0xcwxq4nlDPvWprdUMOqvb/SXTPOhSA6yS75l2VD1/gusSfeStyjKoPqMOB4VOVYIaq67BA+UDh0LypE55u3lQLtaiKSzyiE9SBPTBs+gA0FKSelCKRbHpALLHLTpAP6pyw6RGP6j4UB5yYHeYC5iQh/EFzpLPpLssH1Yfnew4yXfQIGbJBmypgi31Po7zAaA96fK+QA1WMK6Qw5u8USh2MWiBFlu0rFMMWxpfoTv05DaMCo9uIA/8aQoPtucgMKxhgTTDwCEapQAQKdEgHRqGpDdUpgjKxw+P21AwLYbAheaBbhOjwwZiEo1htysEUShiRZITgQE7wAAtb0oEGtmkBsJDhDCEiAw3I5wEG2OFK/64QpDAdIXRCjIgY9lUefCQxJYZAxA1h98SJ+KB02fHDeqpYkh8ELEwAQCIXJXIGLUQACWMcCQfGsac96DCNE1nBrOAIElOso01F0Bwd90iTZ7wwTMsgAR8HGRMRdKtKKGAHIRfpEim0aR1pY6QkS+IBEVZJAg2YpCZLYgpvhGkH99ikKEXCAy2E6RhjG6UqOSKGqDFpD1tcpSwxAo9DLgkF5ZulLi0ijjAxowa7DKZEIBCMMK0hDMJMpkMaALQqCUCZ0FxIF8ZQJSWgIZrYPMgFclGlHAAzm+AUSBtmUKUgeDCc2MxDIaqkhkyiM5tPMOWSFoCOd4KTA0wU0gQqZf9PcKLBli5SgRj7iU0FgMlFOVAFQd/pi4NKqBgXWKg94bGhArxRouisQoTGEUuMvpMIB+KERyXaCPm8Y6QYLWl5qoBSjzryOZRo6UilYIFkyBSljLupTnfK05769KdADapQh0rUohr1qEhNqlKXytSmOvWpUI2qVKdK1apa9apYzapWt8rVrnr1q2ANq1jHStaymvWsaE2rWtfK1ra69a1wjatc50rXutr1rnjNq173yte++vWvgA2sYAdL2MIa9rCITaxiF8vYxjr2sZCNrGQnS9nKWvaymM2sZjfL2c569rOgDa1oR0va0pr2tKhNrWpXy9rWuva1sI2tbGdL29r/2va2uM2tbnfL29769rfADa5wh0vc4hr3uMhNrnKXy9zmOve50I2udKdL3epa97rYza52txtBICTgu+ANr3jHC95YcFcxgmsTAc6bmPSGab3sPYx7qwTf+BZmvkyqr30Hg98l6Xe/gemvkP4L4L8IOEcELnBfDoyjBCt4Lwx2kYMfnJcIl2jCFL6LhTeE4QzXZcMS6rCH5wLiCIl4xHEpMYJOjOK3qPhALG5xW17cnxjLeC00lo+Nb5yWHMdnxzw+i4/NA+Qgl2XI5SmykceCZO0oeclhaXJ2ngzlr0jZH1Q+0kXReuUsr2gEyHiEH1IwObV2WVlgFrND/REgM+/J/8sCSrMf1lwecaz1zGfiwpwlVIc7v1lONpSQEu6TVjybCRkuMlKh/3wmEuTvQERws3oB5YUSgUPS7wXUPEpUCEzTF1CUcNE5y2poM6nCRW9Y9KQB1boNPZPLjJZTGkpUAFVnGlC93FAPbP1pQFHDRd4za6nNRAIXDQPWqwYULkpk57MO20yEKBEQkH1rQE2jRACgdq8B9Q0+dcHZsZZTHlzEM2GHW05NKBEEzZ1sQA2iRDYAd7vlRIcSkUHe1QaUPUpkC3xvG1BYcNEH2J1vOa3ARe4i9bnl1GoJoU7h85ZTEU1M8H8DihUlGkfF88urc5RIFxv3L6+otKEQhHzAvP/igYu2DNZnn6kLLkIjWV1+pj9KiGAzX7icnFEiSUC84IBq1oag8XOLA0odJVJG0TnOK41uaABLFzmvhlGiSEQd5bziRYkscHUEK0sGos55xAEVgRLJXKw0P5MtSrTCsabdTCzbUC7RrnM5uaJEPxA70AFljhJJQSrnmIc1PtENanQCGywv4du3ZI0SNUMqlejPCYowiTGkwwhZ+ODitQTSDblCKpMoETI0X/czRaNEUI/KsjeEBdKPXU5nKNEMpKI+BH0zgpuXkgFKVASpuCgRrt+7nG5RIhRE5eAlGjgGcx+lIbioo0yZQ4kioPjSm6kDLlLeU7Re8uq/Xk4VlJD/Qp9yjRIFwvvCl9PlNqRop9ygRORAv9Ehtc4NPespVN+QIOTPdGUZUEI3ABXhUCLBEnzzBygIIyFwABUiUCLfYoD9xyux4nBQsQglAj0QKHXKYgLqBhU/UCIawH8ayCsBUCKf4IEgKIJYpyw+tCF59xQfuCEhmIEryCstKCEv6BQCUCLBoIJely0aIiGpABUVUCIS4IMNhi4SUCIVQIRGiIQSpoRM6IQbcoQ0+IPKsoQb0oRPUYRVCIUXJoVbSIUSYoXLZ31mooUSwoVO4YVlCIYcJoZrSIYRYoa4h4ZbooYRwoZN4YZ1CIchJod7CBWp4HiASHHZUm+uhoIyeIgr/4YuNxghOdgUMSghM3iG33cmkYggk8gUn1AiAeCIMAaJeMeAJWIColhj6LILJbIIUBEPJbINqahj6DJrG7JuTkFyDzWLP4Yuk7Ih/OR+JbIBvEhk6AI2EnJsT9ELnFaMSYYu5FAiAfgULSIhZuCMToYu+RQh5eYUp7YhSoCNU4YuNhchOdUUSeAieHOHmWgmZbchcfMUGOAiPUIbHYAA+JiP+riP/NiP/viPABmQAjmQCAA/7aglH+AiCQQVbLIhfzMbh3AAEjmRFFmRFnmRGJmRGrmRHNmRB/BF6WcmieAiUiFPEhJEtKEA87KSLHmAZ1IDJbIDUkFOG0INtaGSLf+ZkzqJiLwScBuCC1IxcQgSDTe5k0Z5lNmoLIi2IZMgFXe3IZGWkkg5lToJZxeSBUaQDmMwCUXgO/KhDVIRhBFiDUVJlWY5L1ZJIx6ADaJADd3wCdYwD+cgFS8lIeZQlmeZl5sCCkRViRHyeVKpl4LZJhEACPkgVHpQIrmAl4PZmEKyAF+gfD81BfzGmI55mS5SB/oAVEgwfZaJmaAZIU6QeT4VAy4iA4EZmqoZITCAcz0FUAhyjrCBk6tZm/2RAZ9AaDtVOxuijLJBm7YZnOUBme6kU0J5ICw1G8ApnMzpD0IQUToldBKiDqnZnM15BKQpU0i3IZemnNb5nf4AA2L/cFNOJyHOUJ3gKZwRwAUytZQSYnLemZ7WyQCcUJwYxQYu8m2/KZ/gKQT1iFEJWSLXExvLyZ/C6QW3J1E9UCILuJ8G+p0hAAUedZz9MZcO+qDWGQFVADPotIkHwgrxiaHW+QB7oJv2RACoF6Iiap1LAJ32BIsbAgOzIQMGUKM2eqM4mqM6uqM82qM++qNAyqNE8I456QVxYk99oJBJpAkLqpMqMEfoFKCs90T08H8tOQE+905rtyH2UEUkYEktuQCPYJ/YJAQlQkJVhAFl4DYsyQBpMGrQZAMlMghpNAtE2pKQcKTY1IAb0gRwpAhNmpMwMI3RVH4lgjJp5AJWypIp/5AJ2NQFj9Yf30BHPuAKkWosC2ADZBpMHLMh07BHDVAGdLaSayBIygQEJUIIg9QPE7CTGyAHypRrEgKUg8QCJJKTiNB2wZR/G2KqfBQHNJmTKeAGwnQFLmKThLQCVrCTmZo7uhSoEdJshNQAdDCq1MIAJrCQs1RiD8hIi+CVObkB9KBLOxijmgQF5ciSIUAFs/QGLjJ+koQEwdqSKECsq2SaJRJTmiQDBXCpuJIBUuCsolR/EjIPosQBpWCUQMA0oiSdEeIFqlQFKbCTk2AHo9R5EsIAvrpJUAACO6kF7LpJ1Sgho6dKdzCvLDkB+jpJDhB+EfIIshQDS7CTGYAJ0P9HSAaJIAvgB+wpSxRgBP6KKws7SbJqHjv7CMjAsLPkAEQAri3pBxbLSIYwnH6AtEqbTCXgsTpZBK23SByQAlWbtO+EBNTTkkqAi4OUeOGUBNSkkw9wCTdbZV7xs0GrKoSATHIrFg4ACE7LkoJgCXk7FiWQbjqpBV0buGDBBmXLkiAAfIgLFhewCTm5AD37uGDBAUZgrZuyB5Y7Fg7wCneqKkIgmZ0bFm/wP7jCCBtbumFRA3yzKSBwdqw7Fm3QtoQ5nrNrFh6wBZpbIg8QlbnrNKMQujgiARwavGKxD7VXIlYgsMhrFvzwui5yBHD6vGVxAe9WIiGgp9abFgjACr3/qx0poEfdyxapID4H8gCnUL5vgQaEKx82cLzsexZ9IL3lkQabOr9qcQWRVx4bgJr6CxcfoAZZAwPcG8BvQQovgAK6isBxAQdo68ASPMEUXMEWfMEYnMEavMEc3MEe/MEgHMIiPMIkXMImfMIonMIqvMIs3MIu/MIwHMMyPMM0XMM2fMM4nMM6vMM83MM+/MNAHMRCPMREXMRGfMRInMRKvMRM3MRO/MRQHMVSPMVUXMVWfMVYnMVavMVc3MVe/MVgHMZiPMZkXMZmfMZonMZqvMZs3MZu/MZwHMdyPMd0XMd2fMd4nMd6vMd83Md+/MeA7MGyCcjJID+BLBCUcFB//wfI5ZkdjfDHN2Iej8zHnHAglXvHGMBGCJKcduwBIAYPdnwBCRghC+ALdKwK9ishC6AAckwDqIsjFnBNbxwOrbokgVBmbIwO4YsgWhBJaNwAalAlhYCoaxwDv7gkM1AmbOy6VZILLqrGaOCyOTIG+rnG5cov+VvGYQCmQhIM8jvGNcAMYSKtaqwHDbkkFrCyaYwBexAmB4C7aswHG8QkWjCgaQwHy4sj3mAKa9wAergka6C2Y/wEdxQmi6zG7HDO6BzBZkwCy9AmIfAMa8wCRfBI/GxPZ6Cts+QB7dwm44DL6IQEEVAEULpKNNCpVZIBnRhOGOAH2lEL5zJKFAANu/8sIYjQZv2ED+YRCPA8STRwBHsyAMFmTwbAptqhAQC8SB4ACzUtIY+wjvbkAU5wICFgU4Q0Bam8JKsQjASliAiyBsScRjEgllVyDFG7ULJQIkowClD9RCLwMHvyCHGLTiuwfsM4UDMUBxMYJirgmxLlDkLCAFtQvQrUAjTFKHUQCiMlDFWyA0RgogqkB9BaJS8wCih1Ba/MJBuA0/zDA9m7J0yQcCPFioySDvFoPklgDk2dsZwA0h7VCUDNKCegDjG9PBQQC67UJpGgCDs100ZdJTBgD229OfGwehdDPzxFA1O9KUzA1YbDAgXNKGbgmj7FAerw22XN23nDCzOrKl//UNtBpQOhpyoFUDghcwtYoyo5QKhE1QHo0LdtsgYJmi12oAHYzSQPYAMCHVRPILl9AwbzDSl8sAWw2SaC0H5L1Q7p2iZ9EuBb8gSsUODuzAXfbFQjAAx1myPYat5Scgv2bSxgoNhTdQ3cZCxkwNlIkrC4wgTkS1UQ4AYNpyqeIAwVjiF5IOFL4gipMNdSNQKlcN9gJAmkWyNY1CbKIOJcxQY5Yyx4AA0XXSNPsNr9UQwoCVYlENvGkgHSUOUr0kxCEghcQ1YdsAgxjiuCIAJDfiFJmiMHMA1pLlY+YA0KjSs7wAkPiSG2uCEWsAf/mVZXAAw4zija4AuuLSDMyJ2w//pWT+A8LLkKwYDgAnLM/UEGHP5WRpOTkDAKyqwfsdcf24DXcqUDZtqSD7AE7fDm4RHd2lEM7I1XNLDkLKkEynAIzgseA6gdQUDdfNUJHKiT9KEe4gEBNDMIrf5XPJDevu4OcIDqxCELoB5YLsAKxLuSKEAI8NDnWHwF0IBCzFoMxiDaWNwCo8CbR9mgWgwB4UCh8/IAGr3Ff6AB6MuSqQfGQ4AOxk0tJzXGEPAGxCDliXbGfCAA29gmUaDGEAAFARDvVfJ4bBwDXFDiTGLVbnwH0DDwG8Luc2wI86C1T2fHDiAGiiIh+Y7JJWAOHB8fkH7HEGAInDDwBQ/IPNAIukwAJgx/yDFACzhwyDq/8zzf8z7/80Af9EI/9ERf9EZ/9Eif9Eq/9Ezf9E7/9FAf9VI/9VRf9VZ/9Vif9Vq/9Vzf9V7/9WAf9mL/WAEBACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrX868ufPn0KNLn14aAvXr2B2yKdOjRvbv4P9d/xkFyZ95aOHTR3dwaE0G8/BxqZ+//Am0KPDzm39Gv//wDnCMwYB+BALj34G9JSJAEQQ26A8IGCAooW00gPGegw5+05wcvUxYXAO0CILhiP6A09wW/uSiRwce/rZCI/iROCIKXSwnQwrwFVHPCi3qZkkpKMgoZDfLnUMgCrBg02NtPEjzgJBQFqAcBLg4aIE7WSwJGw2uQOmlPxlckNwhMppwjZar3aDNl2wSkdwYUJJBBZqm3RAEm3g6gxwSbAZxA52h2Yknmxm4ogByXwy6DQ2AckbDNoN+mQsXQyQ3QpCRksFoo5ZlYUKkUIIAi3fLjQIqfGuQyilkdigz4KkYMv+whDANNAdBK7Ca90AzfKzamAywWJCrgyBgMgd0wwwL3wmw8OjrYRScs4qyBA6gR63RkUEtfE0Agu2zgsUTybbwRaBGH9RBoEYE5JoHQDjgAqbDAO36U4QxYmaXhAAw1DsAuvHq1UYtr27rBSXfgteACDO0u8A8MQRsVwevHNBuJSUg+A295O6QDYsSx0UFOeQysAsqLeKwRsHKQtJhyG214Q65D7ijao81gLHAtgzUEjHMaUkyLbUWbGEHp09o8CS1eMwCtFk1VLPtAxo8AW7SSys7wB1Ph8WBNcIqS7XVEj8BDsuwRkBAhF1z1YsT2y6DRNc17LItI5u2fZUHEqD/fWodougtEA6QKruADRwITtUU4yrrjSyKE0TNBtTmYEjkT3lAB7VmUGId5gNBwE4PyjIgwQegK0UDAMoq0QjqqRfkgQCY5urEmbET1YA6O+fKQDNX5I5QKBqIXQHIwvuEhDfK6hJ48gnhkIuyfnAN/U5VTDAsIr5cz5AI/eaagiTe35SEFcM+wIkP5TM0ghG9w7oLCe3LJEuMsFaTZf0NoTJ9rkWYAv9a4oBLxA9UqzjFAB8CgUUkIFcLqIADFoiSPOhiWNJoAwUhcgUgDGsQidhgScgEK1tQQ4QSQYMWcgWCM6BwJI8AFQOA0YIXSsQHwPAdPj5nw45g4BiDAsDl/3o4Ecbligz0IyJH+LCDLzGAE4lT4kRaQAe/sSkQuJNiRkgopEgMUYsU0UQgYPWCTIAxIzGUkTlqeMaK+KAZufpCwtoYkR+OCAZvoCNG7gECWA1Ag3qUCDbw4CAr5CuQFklCAWClhech8iFvINAEqvBIjQCCXaCaQDwq+RAp5GcGN+OkRXhxBFgRQJQM6cAF/bEF2KESIx/gBqzSEcVXHiQPrdikLTfSDSWc6ge7RMgEg7mRW1BuUFYYJjGXCRIOyJJNkGAjM6f5ETdgUkg9MAU1t/kRVDSORCnQATfH2RES1IFEC0ADOde5EQeUYUTAZKc8M9IN7RHoC/PMJ0Z0YP8G/ZBBmfoMqESu4An4eIF9Ak2oRDiQDn+EoFcKjWhEppFFiVr0ohjNqEY3ytGOevSjIA2pSEdK0pKa9KQoTalKV8rSlrr0pTCNqUxnStOa2vSmOM2pTnfK05769KdADapQh0rUohr1qEhNqlKXytSmOvWpUI2qVKdK1apa9apYzapWt8rVrnr1q2ANq1jHStaymvWsaE2rWtfK1ra69a1wjatc50rXutr1rnjNq173yte++vWvgA2sYAdL2MIa9rCITaxiF8vYxjr2sZCNrGQnS9nKWvaymM2sZjfL2c569rOgDa1oR0va0pr2tKhNrWpXy9rWuva1sI2tbGdL29r/2va2uM2tbnfL29769rfADa5wh0vc4hr3uMhNrnKbAoQEOPe50I2udJ8bi+UGZpGmtC5gsHuqU2rXL9wFlXe/y5fwRmq85NWLeQeF3vTiZb14aq977QJfNsl3vnSp75fui1+56NdL/O0vXP4LpQAL2C0EFpKBD8yWBMtowQxWi4NJBOEIo2XCI6qwhc2CYQxpeMNk6bCDPgxisYi4QSQuMVhOTKAUq9grLNaPi1/MlRjnZ8Y01oqN4YPjHGNlx+bpsY+tAmR/CHnIVCnykZEsFSUz+cK5WvKTn+LkKZelylYeC5azHJYtc/krXv5yV8Is5q2QucxZOTOar6LmNVel/81ungqc4xyVOdOZylG+s47z3NJeHAuMdg4p6RIwADpkohO1RGGgP0qCBj2ACdKoRwlCscFFe1QRQgLBJpDXPkt3tApQCsQCPc3RHApJSgMk9UbvJKQyjJrPK20ClODx6uyuNAZeQlmqYZ3SXkBpAa6sn6ozKgIotYKCw8aoNaC0BGTzGqVggNIenG1rlU4CSp+gdndZajEhZazW21bpBbykCm2Ld6WdgFIGOC3sZ5tUAVDKQaXdXdIfQKkS867201pQgzcsYk5T4QSUmpHvcIOrDQZIxjnoYAJvyBo+j6DKMqBUgYKf21eUAMA1MQQGqohISG6w+HmfdQoo6WkqIf+AkhhEzt5nlQBKkZiKA6zYIBewPL7PygKULDCVK3gp2PxLtnpk4CVAQqUPUHKECIWunhNA6Q9SoQaUALB0etOJdUJyYVSKLaRqVF3fnHIGlLoXlXpAKQBfN/iqJi4kUkgFFlAy0M3tCy4UCUkdUlEGlKaR9ov76hJQqoVU0gAl8s19v+DiApSsIJVVyugXfR/5s6IBJV1IhREqj3zLnyUGKM1AKvgjUSc0j/NnXQNKWpCKPWVU7sMDGFy3gJISokIBLyXR3JL31bihxMOmtMFLvd812BvVANtDZQ5QOoCirU6n1ZPoz075A5R6sPzhNyr0IwKYUwwA8+qrfVVjFNL/6J9yAyhtwPt+9xXJhPSnpyADSrlAf+595QcoaegpwoBSEOS/+WexWkZwABVcJyOMR3p0By5CACUiABWzACWEwH+l9yyfIiQL+BT2JiQaAIEH+CwzIySvABUXKCMZaICIBy7FIyTx5BQhSCIj6HoFFi8nKCMp2BQrOCItiHv95ysxSCIzyBToEHgaWILPogZQcg5QUQFQIgFB+HrgIgEUd4RJuIQv2IRP+BRIKCRKSIJM+CxOKCQVZ4VRqIVTyIVV6BSxACVqIIUKFi+1ACXoAIJQcoPgln6rsoPwBIcYqIYPBoNQ0oNLUYMYIofC932cYocY4odKAYgO4g56SGF8/4iCUJEJUGICjZhh8UIIUKJATwEPUCIElehh8YI+FAgVcKB/nzhi8fJ/JCIMUBFJQuIHp4hi8fI/MoIMUFF+QkIOsdhi8XJMMtJ+TpFuQiJqYriG4PJNJGIAUMELUIIIuyhj8UI6QgJ1T4F8QjIBz3hj8dJtMgJ9TdFoUDJHQcd8WgIBRQcV5gglhyQbHYAA7viO8BiP8jiP9FiP9niP+JiPCHBO1kcn4CgkFBAVviQkt1Abh3AACJmQCrmQDNmQDvmQEBmREjmRB3AhhAgoqgAl2BgVKyQkFRUb8FYvIjmS88cpwigjUSAVDSMkK0cbIUmSMBmTlsh5UMIIjQcl0f9QGy8pkzzZk1IGHr9QeVIhijLCBTrZk0jJkz/5HZIAJWkgFW0oJJdwlElZlSO5lNkxDVCiDFKhDlCyBVRplWK5LaAALqYmI7AgFaQAJcsQlmP5lmkDCPngKwEAJfUgFb5gcm4Jl3w5KAvwBUCHJlIzilFxBlO3l32ZmF9SB/rAKVgnI98GFdInJCeAmIp5mTLiBPtDJ44AJdr3FL8HJTLgkphZml4CA5G5JB/gJcEjFWEjI5sJkqY5mzKSAZ8AUB7iAlDCALjpFMg4IqkJGztJm8SpH38pjgjSeUISAlQhdkKiibIxnMU5neYhBOsoIW4AJYJAFdFGIhEAAJRAmtT/OZ7wcQSxiSBXKCNtORVpZB5N4A0mQAfnkAwGYHTiSZ7kCQMtKSFwJCScQBVYsAhvUAPSxBvSiZ/FGQFGKSGV0IdKdKAISpxPhJzpkQNQcihEBKERSpxCUCn90QEWKXoPuqER6gWhFB4ZqY4jSqIIGgJQQB8vJyTKt6Isip8RUAXBlx2fACWTIEUaWqO0+QB70JvXsQdQ0nE0CqT4uQTXeR1LACXWIEUyYABUWqVWeqVYmqVauqVc2qVe+qVbSgQbN5JeYHPfgSuEOVWaII0wqQJadx0fcEAj8jJURQ++SJITYHjUgQpe8jNVRQJrIJML8AgUyhycKCRNkFUYUAZZ/zOSDJAGfgod7yQk+6dVszCmIgkJZgodEyZ3WqUIbEqSMACMzhF+MkJJXOUCdzqSKWBGztEBm9BHMqIIXuUDrkBz23I4hXocoVAC9SANTNCo8HF7XNUAZSCnIrkGxAodHNAJmUAHA/BA1BdW/eB8I7kBcgAelkCnYMUC2CeSiCBAeqYUcbCSMJkCITeuSbECREmShxOQ6noUDUAHyNouDGACzhKvRrEITheTG0AP+noUUJByMRkCABewRIEE5kqSKJCuCDsUMlAAuEotGSAF8PqwQcEBpcCTQDACGDsUVYAjMTkJR/OxQQEFsgqTWnCwJusTd7CwIzkB4dmyPxEDT/8akxmACWxDszxBAUYwsdTSsTzbEw5ABP0Kk35QskO7EyWQsiRZBFiwtDyBBEwgk0pQgVKbE0kAJzH5AJews1lrEz4LtMpCCGEQtjjhAIBwtCQpCJaAtjhRAg+nslELtzbBBlUbkyAQQnZbExewCTC5AAvatzXBAfAzktNGuDfhAK+AqcMiBIGpuDPxBipALoywrJJbEzVgocoCAnOTuTrRBlybNvsJujnhAVtQr17yAG5iujwBAaPguEmYo66LE/vQRHhiBRdbuzzBD5zrJUcQqbzLExcwCF4SAps6vD6BAKyguvmRAiygvEORCi8wIg8AndIbFGgwtwRiA7SbvT3/0Qe/mx9psKvguxNX0KD5sQGjeb5F8QFq8CowkLzuSxSk8AIoIK71exRwgLX7+78AHMACPMAEXMAGfMAInMAKvMAM3MAO/MAQHMESPMEUXMEWfMEYnMEavMEc3MEe/MEgHMIiPMIkXMImfMIonMIqvMIs3MIu/MIwHMMyPMM0XMM2fMM4nMM6vMM83MM+/MNAHMRCPMREXMRGfMRInMRKvMRM3MRO/MRQHMVSPMVUXMVWfMVYnMVavMVc3MVe/MVgHMZiPMZkXMZmfMZonMZqvMZs3MZu/MZwHMeldQ18V8R8kHK0NMQ+4AXw4Qmt+cMOoC35YQbi9MOJIklE0sOK/wgfZUCkNIwGzmsedYC5M6wDIksikaBrNWwKoeqdDivDLVAebMINiebCDtCuX7IBBblRjrxLiyx7iYxR8dAKebBNDAUr3BC5+vQBdqcL7LZMBAArR8ALEVUDCysF4xQP1somEQAICZU9BJJH3CQKHQkqBZAE+XQ+DoIHSsJNbcAxoAIC9yBPbxA+DnIMYDtNDXDIp9IMCLVNLWAOQhJx5JQJ1XsqgaAJ22QIvzkih7BO12CqkcIAdFCgtsQBnEC2+bEDEDVOJCDIpxIJ+vtKhvCYX4LO6wQB+KDQJAIM71xJLQAMHN0g9LxOZ+C0kaIF6lRJ1GALufLP7JQIxpsrQP/wx23UBtIwLLpQy/LkABUQyVCSAIvwvTZ0CkNzKgtwCa3MTVPAILmSC5pMRFngeKcSBZCTUCRgNxBkBB5rQz7ACcIaKVaAzRIlCZd8KjDgvxTkC4gwLJOUUXdQf8OSCzhAQZ1A1afiDZ+bUR1QAWEdKRpAae1zBc0w0iOyAOpgvgp1DXAzLCggAB5wPR/QCAOZKwCQNx71AX2jLD3ADkTdNhBACf2kLHQQ2SNlCOMLK+RwQqAjC6I8LBJ9UhxgA0D9JdtQ14IjCvw4LKZj2ihFA5hHLbtwogGDBGynLE7ArSmFAQQgu4PCAOBANgGDNURjDaW8UncAzulTNVejNNv/Ug3E3VKzQEjUMjacYgdbEKK5sgp6SlMxQDC5CgbhjSA14A5/fSruYJ821QuvXTprgNsTIgq7YNi5yLI51QHZgLvbMgD35x8loL7bcgCv8Ms6FQPzUNt4MgMioNjQ0QCUALO8XQv6/VN9oIrUAgMCQNbYcQHG4NTkMgCFbFThYNHUYi6frRx9sC71EgmQp1QNAAjcqyxkIB0NoAfavS2rcA67q1QrAAtsmyvDAB1zgAkoTTSw0L5QxQfNcN9s0go3LhwNIAxLQOBewgDKoLRTVQOBCiujwBw1AAtVvi0mcJ5VRQMQjSco0NXHMQRcQIsiuShe9SiDgk/HoQCuoN7t/+InYiUoX7LXxeGcI6noZYUFdz4iY5AcRDCS2kCqZnUNE+jPyXEBiJ4rroDZapUF7vCa+oELX+4bRQYfDyANPCBX2AALtQMfRqgc3eDYpfC2dbUC9eDiKYDlyNEFt44nUdAI+XpXHaAH0wOWzAEOkSIItMDhctUL2coc30AoYGDqL4wBcd4gWiAAfFvDZ+kgDDAGcEDhMvwMGBIF0CDdOlwl+ZEBa4AMS13D0AAfkDAKNu3DNdADZcAGRtzqcnzwCJ/wCr/wDN/wDv/wEB/xEj/xFF/xFn/xGJ/xGr/xHN/xHv/xIB/yIj/yJF/yJn/yKJ/yKr/yLN/yLv/yMB/zYAIREAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hzpx2BTI/u38Cxdvn2yM8Cf7iCK1++1IGBaUEs+JtOPQ/z69h9DqGVrgn179R9Z/8fTz5mHwK5GIBfP31L+ffwS3aYIiES+/vTj8Tfzz8jhhJq7IDfgNMN0d+BCDKEwRvKCEjgg3AkKOGEECiyBR4PZjgdLBN2yF8NoBSh4Yj++OHhieNdAIgfJLb4QAsoxgicA28QIl2LOJYg4462zWGNFjgGOd0lPBb5mgOHFKCekEJWY+STqSUhji1MVulPBBxAqaVooozzgpVCRhBEBTd0sOWZm3WgRzFg4riAIJfckCWadGLmwzlUtjmiFuYII0OdgF6WxyMH6JnhAgPUw0ugjFZ2hxo3GoofCsvAQ0KjmErWyTJLSsreDmp8Q0GmpD5GAxme3qfCFtRgUOqrjGH/gWqq4DmiTAmuwqorYjRsQut3Gbjyywe7FmuYDmn8St06r1xg7LOD3UGIsv7gUQoP0GYLWCK1PPArA2PEM6q25O61AiYn/IpHGaqU625eHWSjwq/F+DLuu/jSdYgTtL4wjij5BkyXDrSCIEASAic8FxCSMnPKnALHoHBcdkTQ5gDDTPwPMo6QYqbGbaljZRpYgExBIflpAjJbYYQQJANgYLtyI+Clc8XKarnhojs14PyPKUqsl8AiEPhsFgTeaPiABk8Y/Y88+HmyqNNjKfIgzEhQjQWBD6gDMdVfMYyfCX2AjXSGABgCNlgVs1fNM2v/IwmJX/gQd1cifzcDMnfL/zAvibZMcfdWLU+HyCxF302HkMDAODhWbkxQjuN3Z+GtkJGo/LhVEISy+T+DWMkAKPd+bjpUsui5ARunt/6UHj20GcEorte+VBg2ZNDmEgjb7rtRNQzQZghn/G48UW5gCGYZuR7vfE9DaNDmMXw8bz1PUNhn5Q4ZX+/9TV2UcpyVUjjw/fk00cCvldu0gf77MHFgw/hM9tAL/Pi3RAMAVlqQTf4ATIkHggEmNZQugAgMSQmiYCVPeC6BEARJDKZVJUTgIIIY9MgpUlClCPgigyDUSBw2YCVohPCEFqHA4qq0DA+g8IUSCccqquSHm8Hwhg2xgyCqFIie4fCHCWmAEf+qlAAWAPGIB+kGB4VkAVog8YkD4UEOqpQKKEJxBMSoUimsCEVrVAkMDeAiEhWAAiaRwYViBGIWtBekYowgjUAcgi6Y5AX3wRGHDZCekAphnTvisB5MikTT/HjDX1gsSEUYJCFfiAXl4UgFMlskCm+BsiBBUpIvvACLLBlJTIKwBbN6ZCc9icEGjENIlyRlCCUgJEQoUpUYFICQEglLEH5CSLhIRC0zSAv6jagAaNxlBLsRqQwtI4zCzCAaijkgd5gvmSB8wwQeNA9oopAF08SPFKz5QmzeRxzchKE3wfODcN5wmdRZwCnMiUM0eMsCH2QnDn1xAjTIM473zKc+98n/z376858ADahAB0rQghr0oAhNqEIXytCGOvShEI2oRCdK0Ypa9KIYzahGN8rRjnr0oyANqUhHStKSmvSkKE2pSlfK0pa69KUwjalMZ0rTmtr0pjjNqU53ytOe+vSnQA2qUIdK1KIa9ahITapSl8rUpjr1qVCNqlSnStWqWvWqWM2qVrfK1a569atgDatYx0rWspr1rGhNq1rXyta2uvWtcI2rXOdK17ra9a54zate98rXvvr1r4ANrGAHS9jCGvawiE2sYq0IhAQ49rGQjaxkHxuLxTKmAGAigGUXg1kraXazielslT4L2sOIlkmkLW1hTiuk1Kp2MKwNkmtfG5jY/+JotrT9i21bhNvc9mW3JOqtb/cC3BEJd7h5Ka6GjstOFtjNdcrNEHPDKYMFZGAQpLjD6aL7oOlyMxngKYQEoHBAsHGXQN61phruo4Q1ZOKB5s3sP0VEoEngg3VOO++A0pvMLIwInPmVbz/PMaJOUE2/+OGvMH2VIRUkzmgIvo+Ca9mAbD5IHvH1bD81MSJ4ZHi0/azAiHoXYA3zMwga8sbaIsyeCauSA4d80CNWLGB93mBEfPswavkp4kO9Ucet5WfoMmQiGps4nw4oY4bKEDcWr8fFniSYhnRkZBDrkwgaWgDlDlzje0ItQxu4m5PBA2VMtkJDXxBzl9nZhhE5sf/JazYnGkbULjgfWZ7l0BAMBjfm75R5kec1AZ/jHE4GZqgRg76zOa8wIigk2sryHMaILqVmRYdTlhlKzqN3fE9XaGgZj+szdf7sR1xoaBqhJjQ0PdApAlG50pA2ZydGnGpLW1MEGlLB5kQ9HVLD0QYa2sauVZ3MUBKIDsO2NTTNoKFFJDvW3OzCiEpWa2hb8w8jWsGzOW3OX2goCp/jtT98LcZpBDvcxN6lHh9UC3QrW5jV0FBltx1kdrosQ+Fwt7WT2YIRjdLO+xYmG0ZELHrLlp1v0FARTCducltxERpyBsPTDUtMaCgdE393LZWhoW3qm9vcFF6GiJDxgO+SjQT/yrHBb8tOZuKnbB+vNzdjMKI/xfzg4USChiKwXYqTMnUZikTPNa7KdmjIE0M3OSxJoSFXJB3k0ASFhtxTcqgnsxYawsfTZW5NCj7of1XnOjRRnKF43pzl4ZyBht6wdZxzk74PumDY3W5NCxPoFm1HuzUxMCKJzV3v0JTBiB68ct6Gcw4amkDrGh5OHmgIBIv3OSafoaFWRJ7onmSBhsKcd8NzEw4aclLngxtOYWgoCJdXOilxnSFipN7quzyFhgQ9euOG8wca0sDrxS5M3GdI97Vf7u1zv3u6JxPTDzJC8QGfzB4/SALL97w1afCD6lv/B/WogPa3/+qzSx+5fmE8//h1K/nxy0X8xirB9rdfj+tbnwYURX+xWJmhCsS//IEaYoYEcH/MN2rdBFJOEyV/uwKAAyKAEkWAumKA+IGAEaWAsGICGrJOA4h/gOJpGSIC/ad6mEJ2DyIMGwh7rxJvGRIhFeh/jEJCGWJEJ8iBjXJmGQI3LSiCpQICGjI1CWiBdWJ3AzIHIch7rwIBNWc7HYAARniESJiESriETNiETviEUBiFCFAHOogmNKchzdM6h3AAXNiFXviFYBiGYjiGZFiGZniGB6A7KAgot6AhJ+A7CkAtcjiH3fUsOKAhPQCHdLiHfDhqz5JwGaIfthOHfViIcuhwPOILGjIAemiIjv9IK4i4I9kwe434iJaoJ5EoI/igIdxQiZf4iUwCCs+yBRqiDp4IiqhIIhEACPlQLBj4IIBwiqk4iw+yAF9QcLDiCRoiHrVDiLT4ixlSB/qgKyg3IIIziMCYjA/iBFkAKzFGIFmDjMo4jfcBA93XKIKnIX7Xi9TYjeuRAZ/wTI3SBxpiAb/ji96YjraITIyCDBoidLKYjt0oBM7CKFiWIYwYj/JIjUfQjIEiBRqiDOe4jwTpDzAgBoGSDhqCCQNZkPsYAVwAKM7QbA3pkPLIAJzAjlsCdwTCdvpokdMoBAayJR8wIvgljSC5j17gQ1DieBqyZa6DjimZjiHgaFASDhr/EgLGI5Mz6Y0RUAWEtyOxEHo72ZMF+QB7II47gnW/V5RGWZBLUI87sg2nZjwyYABYmZVauZVc2ZVe+ZVgGZZiOZZfSQTPqCxe4AI8YmgP8gsgpQmxM4cqUDwxsgIjogMhRQ8qKIcTIAkxsjUa0gUiRQJrQIcL8AgaKSEQlyFmQFIYUAaXQy0MkAbbKCEr9CBkYFKzcJa/AglqOSFUmSE2cFKKEJdyCAM3MCF/8yAaeFIusJfUkgKZkCBJUGAp5QOu0Gq/sgA2kJjwUQIawgDBdFINUAa+pCxrQGn7YW6Z1lL9wIO/sgFywB/L0HQuxQJsSS2IcIzwYWr791JxoHZz/5gCbgAfJDAi3eNSK2AFhmkD5cUcUDAiNvRSDUAHx0krDGAC2jYeNJMh4DZTi5Auc7gB9DAeEpghBVBTUHBvchgCVJAdMKAh5WBTSCCecogC5ckcqjAi9mRTMqAkc5gBUvCeuEELI2JHNsUBpbCHQPBjwPEFGqJpOVUFSySHk2AHwQGbA4JhOwUFNjiHWvCgutEC93kfJMdTd2Ch1DIBlKAbwKkheNlTMbAEdJgBmJCFtFEGGoICSrlTFGAEuvkrLXobm/QggxBUDkAEAiqHfoCjtDECRcoe9idUJfCjclgE1CYb7qghqTlUSMAEdKgErRkbj7BzXxNUSTAGdPgAl/+ApayRNBmCekb1pWFKK4QQBq9Rmxoyp0blAICwptQiCJbgGvAwIpqDVCXgHUCap6rxZQ8yAb5ZVGwAqHMIArqkGhCwmgSyCU11AQymLAsQkasxaxpyDk7FAUYQp22yB60hDiPij03lAK/AmW0iBLioGmyAD5PwIAsXVW+gq23CCMrpGqGQCWsQNOyhBlNVA1OkJyAQjbNBAVAgAZVEHclAVW2gqGASAQiZG3dACoOQAQtgc1PlAVugrBnyAEcKHD7AglUFAaNArRoiAUFpfnuxDw7SIlZAohabF/zQriNyBJXZsX5xAUOWISHwmSQbGAjACgg7HSngsCsrGKnwJfj/8QAUOLOEgQaqyh42ULE6Cxh9ALLfkQaxGrSAcQWVAB4bQLBIWxgfoAZLAgMq+7SHQQovgALcabWIAQeDyrVgG7ZiO7ZkW7Zme7Zom7Zqu7Zs27Zu+7ZwG7dyO7d0W7d2e7d4m7d6u7d827d++7eAG7iCO7iEW7iGe7iIm7iKu7iM27iO+7iQG7mSO7mUW7mWe7mYm7mau7mc27me+7mgG7qiO7qkW7qme7qom7qqu7qs27qu+7qwG7uyO7u0W7u2e7u4m7u6u7u827u++7vAG7zCO7zEW7zGe7zIm7zBO5LK6xFocAJm17wa4QvS8QAdKr0YcQr0YwHXi70U4Xvf/zEBMuu9EOGs7CG+5BsRAIkf6Ju+DTEPr+qR7osQDuAO5di98zsQDVCdI2IB3ZC/BOEBLLYAbwbAieCdOPIJACwQT8CRJMJ/C/wEiCAk0LfAPACuIzIOR4u9FywkdQCT6dvBQeIHUjm/IowjhYB3AHzCLYIHrOq+DRwmbgnAT1CMJFIPC5wH9YojGrDBzdsGXsAkusC87jsCbII50Oq+HmBsLYICCgDADQAGVWINC7yiTEIMLuq+qVAlOfBv3ksLLjciKfC/+csCCVAlRuDDyVsDgVAlguCm7nsFZRokq5Bv8+sB/MskdMCxygsNVrIB8Jq+viCxGpICOZu+ODDBVf9CCCOLvaGgi1USBdeIvRSwXlYSDMPpvdkQxiQCAPDnvr1gmkLCm4cqvW0QmlXiBJ9Mvg6wvlWyABIgmOk7DBkbSDZJvnxwDG2iAUQsvY/ZJniQoeR7BgxaJQPAktibBFQKJhlgA5hKvhHbJj3Ai9jLBjrKJLKQvhQACpVKIme6OaEAtP+kCTY8Ig+QxGvTAuUwAcJMUC0ADEKCbHcDAbOgyCHwzAY1BXkyIirgtFSDDErqD6aIUD4AoyNiD3HzDCQIHhEAxwdlCPzzIN4gzhrTBwd6H0CwUBygDpF5Hy+8MkgABt38HYrAULwAyezBoz7zBBrQ0QMy0QwFAYtwxuD/oQSm4DM14A4u/SDtrFBXoJDfgWgrwwMiHST3/FCacATTUQh87C5YkCxVMtAO1QGk4AgqlzDDIHJW0tAR1cjvwgGnwAySktHJmwQCYKeSEqXF2yU26ylOcAjFSwG+cMSpogLZ8DHCqwpl4EiecgKYsJ/BSwHxMAYjbSUPUAu3Grw8UAp8nSqEoF3BewGvMMe0kgZq7bsf8AuuoIbKsgmr3Lv/oQyOMIdk8NG5iwHUsAUYTCtk8Nm6SwHfECB0yADLYGC8SwLwsAxKNocWoAaQrbu8UA8D8LKScgCP0Ee4KwPCYA5A0oe2cA7PZbsccAOXIAjEnSrFoAd4PbsdcAMV3RAEhEwt/gIwuAtjj2gL4kBiubvQe8gABXAIXZq7l8CHWmANowq8T0otFkAIbxDfvdsCO20ofgAIJTy8lN0mRQAKyGy8sGAoeLAFikDRwwt626MMb+CoyTsETAIquJK/Sk0ikSABU7Dd80uKV5MLBICDCywQejAgTZAOtNDLKy4QebAeFhAE02AA/j3jA3FmC+AHjzAMsszjC6EHyJDFRJ7kSr7kTN7kTv7kUB7lUj7lVF7lVn7lWJ7lWr7lXN7lXv7lYB7mYj7mZF7mZn7maJ7mar7mbN7mbv7muhIQACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTG03J4lLKipN1qGPLRhzqzDkNuRz5281byezfwPM6QOLr0SA8vJMr93chuPPna+XogaUrxfLrynFA38696wdD9YiB/8BOfrmv7ujTQw1TQsoxC+XjLyegvr79oR6gSPGzQL7/5RrcJ+CAN6FiTBAR/KfgcgMQ6OCDKsVAizvjLWihclpAqOGGHrFRTzX9XShicgxQwOGJKEIEARWPtDLii8shkeKMNBLkgCxbwADjjsoNU+OPHN64RYU8FrnbJ0AmSSANweho5JO7laLklOm5cAkuUGa52zJUdumcDIsUo2WRGTCxCybsGHKFl2zGBoEs0iQ4pogM5LBLBcLEgUGbfMaWCAFYzrlgBt5ww0UvXfSpKGoQnLHGA4L+B4A8n9Bg4qKYnhZGIZHGZ4EzZdyTRKakyjZIp8tFEEQFU3hQ6quyJf+Dqj8LrKOOGBzAqqtsHfQgaBTNREPCrsTOJkCWDBQzTR/FNjtbKBkUeYIJIjTn7LWyBQDjAcqE8wG24MqmiYjcHnJpuOiixoiCKYBhbrrwxsaFfAsI4UsL8eaLWhhKkOdFKqHoKzBqwCyXADCiDKzwaWwkFwQl3y4scWlBJCBBDRNnXJodrmrs8ccghyzyyCSXbPLJKKes8sost+zyyzDHLPPMNNds880456zzzjz37PPPQAct9NBEF2300UgnrfTSTDft9NNQRy311FSj9UEDVWc9kzTHmKL11y3N6w8MU4Bt9kkGwLfbA6mc7XZIJNiynDQdv203RhAIgZ03ltz/7XdFx5KngiJ/F/6QGCGSZ0EmhjeeUB5ExgeLA45XLhAGYipYQBiWOy7BhRvk0XnhsorYgw6j302CbiOi8EbqdivAuogLuAH723es+6IAt7vdgrYvskJ572Ybk/iFu2BNPNjDJPDiID4sD/YdALzoh7XSZy1DJS8yIXr2WXfwxYuFqAK+1q8cv2ARd5yfNRoTjKgCD+5XLQoi8tNf/9SWMCP/H/ubWgycMaIDaCeAUfPALkbUBP0h8GkO4Eb+Hhg1KUyQgk87x4hC8AQMPu0U6vtPEbDhQaf5IloXKoTXSsg0NKjNQjMYFguXRo34XcgTdZsh0lhgQwvVQXk63GEP/xcUAAgEMWk8FJEEjojEISqobUw8WhIvdJ4oGm0YL1SQBcpmxaIpIITyWYWMukg0X4goEm0gI9GqIKJcREyNQROHiAIAx6GVQkQVqKPQxiGiaOgRaBggw4VOkLA/+qwLfriQGdJoyJ4lgVMWqgYQG6kzFyDHQvOgZM+o8IIL2U6TO9PDhSLQCVDuzBgXCkQMTKkzcFxIBKzMGQUy559V3COWOmuD3OSzAfPhUmc6cOJymvHGX+asHeSJwCeNyTMLLqcVqGNmzxxQB+UQQwbS/BkJArGbBbwjm0ETRQTIBk6hDSMR5UynOtfJzna6853wjKc850nPetrznvjMpz73yf/PfvrznwANqEAHStCCGvSgCE2oQhfK0IY69KEQjahEJ0rRilr0ohjNqEY3ytGOevSjIA2pSEdK0pKa9KQoTalKV8rSlrr0pTCNqUxnStOa2vSmOM2pTnfK05769Kc6dAAAgaqhQ/gjFyIoJlHvYwLe7IATLljqfRIBKeVUQhgdkGp65IidKODje1p9DgQCRZ4HmOAMYXXOGRR0jLQCB3j+gYVbZ7OCTv6nfXONjSQUVI28yqYaCqKEX1FjBwWtIleDNU3g/BOMxJ4mBwqKpmNHQwMFMWKypYGFguqB2dFAwFf+YQBYTwaEBJj2tKhNrWpPG4s6GkJBm1hZAXhEHzj/BkNBsFTZbHdUWzJCIAr/OQG+dEtbOL72P3SUbXHVeNv/CINlu4VRb7uohf+gQKkni+6LphtFHSgIDC3T7oi4y8QKKOi50F1uFyFhXexmV71R5IOCkpte3pIxGwrqhsvEKyLyBnET/8nACvYL3yN2wa7yqcTL+Hsh/84QGQp6xYILHMTm+qdvBLavFSHrnw3AjMEWcnAJ5aCgS3yYwjMkgoIIN2ENM9EV/3FEVlss3Sg64AD/2UXMQLwgEWOwEwqyx45RXMJUKGgOQ3ZxENPwHyfIjMcK8vEDO4CC/xjhyUTGYGX/kwwsK3mGjVAQ9mi8XSYu4T9HmBmU/yNlBK7C/8pqzvIDkaCgLnu5xkF0g5jj/OUSsuI/zKDZmv3T5v0d4T/NELScA7gCBvxHEoruMwapoSCM8RnPM5zGfxJgxEuXWYcL9E8dajZo+RTafZH4Tx4jjekSkkBBPmL1p1kIBQWtSdbj1WE9/tMDm5U6PqcGHxj+kwZfL7p+TvhPOYwtaQRyoKryQQOzW43BPyhotHeetQfNWMub/bo8wZaeM+XToGlrG4PE+M8WvH3s85E1Plxgd7P31wUF3UDe1H5gH/Zs7lyXUBj/CQHOvk2ecBMvzP4pd7/7y0I1/EcNA2939gDrn0ZEfN71C4FzL57vAHYgDUyQU3kcSGqJny8RVP+ARwXGUQ3Q8sa9Se54ECmAhGFkY9X4PndnK0Nw7Bh854jp+XV+DnTDCH0+Rb/M0ZVD9KQPZunJabrTAwN13kh96n+p+m6ujvW+aN0fXO/6Xr4edrHnhexmhwza0+6YtbOdMW5/u2LiLvegm7zufKE73guj970//e5+x0vfAw+YwRPeL4Y/fN4Br/i5JL7xZ2c85OHy+MnbpfKWpwvmMy+XzXOe8pL/vFo8L/q2kL70azk96tOi+tWfpfWuLwvsYz+W2dM+LLa//Vdyr/uu8L73W/k98LMi/OFfpfjGrwrykz+V5TM/Ks5//lOiL/2mUL/6S7k+9pOi/e0fpfveLwr/+CffAQSY//zoT7/618/+9rv//fCPPwKqifHwH+IA+M+//vfP//77//8AGIACOIAHgEIyF34CoQCzsoAMaHUImBAK2IAS2CllR3sROIEYqCUVGHsXmIEeWCQb6Hod+IEk6G8PaBAjWIIqqCCgcIIHkYIrGIPlEQGAkA8uSBAwKIM6uBwL8AUw5305uINCyBt1oA83+A9BOIRD6ARZcINJqIRCCAMl4IJPCIU7mAGfMDzhV4VWqIM9OEnYx4VdqINCMGbVJ4ZjKINH0ITbh4ZpGIMwIAZt+IZ0uBsREG9nWId1yACcAIawUgHZMAxIcC5I44Z6uIJCMATE8gHK0QPV/zAOFQAPVIBOQ2OIh6iCXmBpsMID8hEBTJAGM+YzlniJJRgCUKArYihwQDOKpEiCEVAFnUYqCCcffbWKraiHD7AHWogpDucfEGeLt6iHS2CGfTIA/2FxQCMDBrCMzNiMzviM0BiN0jiN1FiN1iiNRCBykeIFUYUpGucf6BVPmuBykaICaKUoF6AgzDJP9LABszIBkNYnN6AgiUJPJLAGs7IAj+CHUyI28oEL94QBZQBtgsIAabBKbLIF/0EM+TQL2igokNCNXWKM/iEF+qQI5CgoMHBvXfJm/kEL++QC7ogqKcA4U5IHCjJU+uQDruBonbIANsCPKYIG/7EAiLVPDf9QBmCkJWsgQz9SDpICUP0gTGOyAXIAJEzmH+AFUCwAXKiCCFxEIxlJHq0VUHEwA7OSAsuEIlegIKcoUCtgBfloA4S4IcOgID4ZUA1ABzsJJQxgAgN2IublHwBpUItwArOyAfRwIvQnHzp2UFDwjZ0SAlSwIRDgPP4xDQmFBFiJKiiwlQRSAwpCDQolAwXgkpGSAVJQlvexV6EVlwnFAXc0K0AwAg7SDGjmUFVgHagyCXZAIP7jH6zwUFAQOYKiBYV5H+n4H5C5UHfQmJ0yAYJlH6XjH2P0UDFwZqiSAZiwJ+phBP+xChNFAUaAmZFSmupxaP6xBBTlAESAl6jiB6//2R27WXEWVQK2OSdFgAXdUZzyQQMXhQRMMCtKkFvQAZ3+gQKhWFFJMAaz8gCX4JzOkWz+UWwZRZ3WKSiEwDnBMQdPtFEOAAjg2SmCgGG/YQ8KUkocVQJNMCtawJ6/EWrycQC7qFFsMJ+oAgKUGBsdMDvx4QogdQEAFikLgIeyoQgKQgQhxQFG0JY8sgfAcQkKcpQh5QCv8JBGIgQ/SBojKR85UFJvoAJZwghpGRuWoCCNVVI1wGFFAgLHORuvoCDIcFJt4J88EgFyGBzc4x8vUI8m5QFb4KPy8QA6GhwrYIDxEVspBQGjgKQKIgGx+BvdoCDZwFL7sAMiYgWcmS0K/8IHLcUPXIpmCBkcH1Bl/gEJL3UBpxJwEhkcAKdqMIUArCCn/pACLLAdw/YfkvVSqYBg1/EAp7AdlfofGTJTaNCh2GEDgeqpWFpTfRCpvJEGMjkbcCUfhmBTV7CmvLEB2LQdLTCh8REFuypTH6AGLgkDnfocItCrOUUKL4ACUbkdM+ofx6pTcGCf25EHCUoePTCtRzgWu/YfcvWuaKE7/gGf9GoW3vUfT5qvZmFh8sE7/koWHOCR/kGkAysWlMBXCUsWFOcf8diwYHEHCvICoCmxXqFZyIWxYXEMCnKOHPsVZ2ACBHkduOCuIbsVeVABTnkd4pCyZNEBwqCsvPEAK/8Ks2PhApyAqLthAjhrNSKQC/5wCD+rFn9QokWbtEq7tEzbtE77tFAbtVI7tVRbtVZ7tVibtVq7tVzbtV77tWAbtmI7tmRbtmZ7tmibtmq7tmzbtm77tnAbt3I7t3Rbt3Z7t3ibt3q7t3zbt377t4AbuII7uIRbuIbLSokQa4d7ElMAAxFQSItLEu8QIoFQpZHbETKQbslRB0h7uRmhAy6yHBbpuRzhBn66G+1AuhnxAahZHhOwqqorEarQpOVhC4wUuxFxDwYrH8WwqLibENtqIeDwuw8RA9xkIYpJvA0hTheiB8rbEHpmIS+Qm8+rEPNwIU2QrdVbEA3wsApSCKP/sr0I0QZmcCF+MFziaxCiAK3/QQYCmr4EEQ0iMg7wexBzaSFSUr8FUawK8rL6OxAfILQXUgX/OxBtkGpUVMACgQS7W5MKoMD/MAVZ9B8WoLj/y20WMgGnqsBGdiEaDMGf48Eb/L8QwL//8cEF3AB9uSAo/L8e4AkiMgGUWcAkAJwLYgHSVsCmAEkWkgFV9L/YUAS0E6sF/ASCaSHnoMA8IKUiMrr/u8Qjwg2du708gKvIk0PwiwM4JiLOMKn1+wdMfCHMYKH1C8UiggiQW8ZhnME5rL93IMS0I2H/qwo8fCFfsJ/pmwcoKiKV0Kz1ewGJNCIAgFf16wObKiIJYMHp/9sAInohC2AM/+sAf/YiAYC+8LtYIsIIhAy/bkCq5OEID6y/b2CpIuIIlru9OjCVXKbAeUC7/7FEEBwGBFcM71vADqCx8gEC2AbBmTDBPJimEFwQirDGyyGwwWwQluAN2CEEKHvMHiANy2ELp3zMBJEK0GYBBkDNDNG4u2Gj2qwQplAM0vDNDtEAS0rO6JzO6rzO7NzO7vzO8BzP8jzP9FzP9nzP+JzP+rzP/NzPlOQB4wnPNSABCRAE7/wBlBAEycEG7CwKX4CYyQEM6RwKqWDDyqEEDHrMLeALQkCq3vy/FHAIYMCa/nFZIH0IyrDFFsKR4vsB4ZDSMEJfynsBIv9gAuw7IhkQML/bB9NQDOu6I8Z8uSQQDc3QslrSA3g8uBwgBuqwDp7MI3YmuB4wBRWAIBI4CICbBPdQBs7gywxYCBl9txRAA58gD9XzgQ+wBmfQzG3bBb3ABdzgDXjqgbhAADf7thgQB8JQAbuQAz+dgREgDbLA1mV7BYbADpiwC0ww1ytYDIvgx267DFaIC5egvW47mjsIA8GAr3X7CToIAlsgC1Mct2epgjAQ2qM9t3T2ga3wCFhA2HRLAX9No9VQDww9uNW1gCDgDrTgxYNLkYKiKsaACp6rAWOyAH4gBVCAxZFLAE9iAccgBSUQ1rGLwSMCAsRQD4Zwzp6LAxdlkgK6AAt6gLDwW57lgQeD8Ai+gASpLb79ohyOkAsacA5noNPkvA5OYAWlwAWysEL+/N8AHuACPuAEXuAGfuAInuAKvuAM3uAO/uAQHuESPuEUXuEWfuEYnuEavuEc3uEe/uFsERAAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vejNHDFReibqBJJmIW59OoUxdscedGux+YWLnSxSTEC3+4c+NGobq3b8h5DMETUIsMMyW6kytX/ru5c8BXWCyC5crJ7eXYs+vu8Ly7d7hJZP3/aFYsgfbz6HOv+M6+fVgILvRIqQMivf37Q9zr30+Vzy9Qgzhy34ADzsHfgQga1UAvqSwTBYEQEnhLghRWmJMHYlgTxAQRdkjgHxaGKCJLFNxgjS4WeKgigdeM6OKLILlAihAcrmjjgDfAqOOOF5Vz448DQsHjkEQ6hAWQSKIHR5FMNlmQA+YlKaVyvzhpZZOETKllbiJc6eWQp2z5YwJmHHFMEK4AQcWXbMLIh5joPRCFIMSYA80r7UAhihwjtOlnkU7AidsER1hBxzm/0BAKBH82+uUeUj4AgAlSZKLJFY5m2ug3N+JigjXxsNGApqRm6kEEEC7ghQavGBJGqbCW/1qJfWYEQAoWXcSqK6ypZPeAH6Ukk8iuxMbKS3IPHHPJGS0U66yuD3oBSwnNPmttrM+0ce223Hbr7bfghivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvz26++/AAcs8MAEF2zwwQgnrPDCDDfs8MMQRyzxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLMMcs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dVYZ6311lx37fXFHliBw9cpezCIPweMTXbJZueW9tojt63b23B/3MDZyq3CQ90dN/9ATHYq7M13xn6fF8ITg19cOHq25JE4xYunB8AFj0fsQDoEQtJn5Q5vEWEQFHDeMA4HRLiLA6IzTHqErKSueukQCuD6wizUSCA7sytcO4QZlJB7woekSKAjffyO8C8LQKjFsMYb7EaE3uTafME/ROgKo9MTfEmEUmRfMDcRUuL9wA7sAuELNIwvsAfOQIhIKOoHHAMAEOYSevz/2hEChM3gD/A1trvPIvz3LwUwgEAWUBsB+RULCBUhCQvslxogpA3URVBfDRgAhMpxwX3FABcEYgA1OqivLKCAQHhwHAnxFQ4IDcCCK7QXPjYYQ3ylgUALYEEN7SWDQhCoBzHYYb3/eJECAq1BiPWiBIQkgUR6sYJAKXBBE+XFAUgQKBfcmSK8VAG7+8hOi/DSA4Ee0AkwwuuJA2ICB8zorg8cgUA2YKO7eIGq+ywgfXJk1ysI5IQ15nFdBSCQOv64riuoYEAPQAUh1dXCAW0gi4s8lwYI1IhIossHZhjQBORgyXOdgUBj6OS5gDEgFdhBlOVqQSTso4YgorJcUEAPIwzxSnQ1IzsTMAYGaomuFTxIOUvgJC/TpYDkRCEew2TX3/yxgGD4IJnswoYSJtEiaLbrDzC0pja3yc1uevOb4AynOMdZmUvQAnvk/FYNDkiOb6TzW8vQzQB68c5t6WA5a6hBPZ8V/8jlPKAZ2NjnrmhwnhM8wpUCJVUQ0pMAY3ggoZkyxICkAVFHkWFACqwom3AwIBNo9E8muA8DivdRNv1hQGAoaZvAcJ8HSFGlXrrDAe2jAZh+CY3peQDibGqlJJzgPung6ZWsIVJ9CrVJHsDDfQhxVCdxYUA6aCqTINCK+6RBqkxqpH3WhFUi4S09uegqkdgwoCqJlUdfuA8usnlWF/nghPbJRlt3BIj7NEF6c30R/eyDibzCSBYtDahfXRSApQ7WRUO4TnqmcNgRkeI+R2jsiJggQMmG6Bn3OQBeLZugSdrHCJytUAvgmh4QhTZBSrSPH05LoTHch4msPVAikpeeFP88M7b8aaB9+odb/pDjPljo7X54cJ9CCHc/UrhPBY6rn6raZ6f+AkICpkvd6lr3utSNBdlEcZ9iBKyfKiIA2ZJrnyp810bi/Zpz0WMBEpx3RentGnftYwWBgddD8eUaedMjvveGV732ecHmAHbfDuVXa8ei78AKHKEDZ00c9+mvf/HrtXUEeMAERm/XTHGf+i5Yw1yrwn269GH4du2G6VkAQidsYK5xIIDaGUDBGAwhB1uNGvchxYxBrDUJ3Ae69uVx1vYqS4PRmEA2ppoc7vMIIwv5aiK2jw53bGKtmS89ShgVlf+bNQeswj4edXKVscaDmaLHHgc78oCSPDUSKMD/CMw4zynFzOWuJYIWGrCFcoyb5id77QmSAMMh/TEPhKn5Pmz2Gi9+8AxD+5m5pzm0fRINacxIOj2UrrRlLo2eTGuaMpw+j6c/LZlQa2fUpIaMqbOD6lQ7ZtXYabWrGQPr5ch61oqptXJujWvE6Do5vO61YX6tm2ALmzDEzo2xjy2YZONm2cwGjLP9Ae1o+2Xa1bY2X7Ct7clwu9uR+Ta4HyPucTem3OZeDLrTnZh1s/sw7n53YeIt78HQu96BuTe+/6Lvffel3/7eC8ADnpeBE/wuBj94XRKu8LkwvOFxeTjE3yLxibel4hZfC8YznpaNc/wsHv94WUIu8rGQvORh/zk5yr+i8pV3peUu3wrMY56VmdP8Kja/eVVyrvOp8LznUfk50J8i9KE3pehGXwrSk56UpTP9KE5/elGiLvWhUL3qQbk61n+i9a33pOte3wnYw56TsZP9JmY/e03SrvaZsL3tMXk73F8i97m3pO52Xwne856SvfP9JH7/e0kCL/iREL7wITk84j+i+MV3pPGO3wjkI5+RyVP+Ipa/fEUyr/mJcL7zEfk86B8i+tE3pPSV7gACVs/61rv+9bCPvexnT/va2x4BdXj02Q9xgN77/vfAD77wh0/84hv/+Mg/QAZ0T/ZiCur50Ac2350f/eoLKtsxp771tz8l7Ltc+9wP//+PvL9y8Iv//BTOu/nRz/4BgWL67Y8/hCIAiHzYff3yzz92FvCFD8wd//oXgMlRB/oAdwAogAjoD06QBW13gAkogDDgO2fngA8YgBnwCWxVdRRYgfrHf1q2dRvIgfonBJQDgiJ4grpxBAyIdSGIgvIHA2LAgi44gxHABRo4gzPIAJzwgUbXgjgof0KQH0nngz8Yf15gVENHhEXYfiEgJEm4hDgYAVWATjenhFDIfg+wBxlYflf4g0tQgjQnAwYwhmRYhmZ4hmiYhmq4hmzYhm6ohkRQR3DiBS9lej+hCT3wfCpwBnYIFPSwAc83AbDVhz1BAmvwfAvwCDxIiDmBAWX/8ACCwgBpsGKMmBOzIIdiAgl1WIk5oQh5KCgwkCOcqBMuAIiCkgKZMIo64QOuYGZbsgA2sIiqOBMNUAa0BSdr4F6zeBP9AGNasgHCtIs1wQK/BCeIwFjCWBNxMAPPlwJukIw1sQJWgIg2cD/QGBMNQAe3uCUMYALrcY0ysQg/JSgbQA/gKBNQsD+CEgJcdY4vgQTMKCgo8Izu+BIyUACuqCUZIAXWWI8rwQGlAH1AgGH+qBJVUESCMglzVpArAQX1ISha0I4MmRJ3EI9wMgESNpEoEQNL8HwZgAm7pJEoQQFGkI9aMpAiiRIOQATjCCd+sJApWRIl8JBwUgTBRSHP//ADvFBRSEBZgqIEJIYg84AbKgAGkgBk6ZQEriUoD3AJIckfPpQctqABtMA85ESSJjklhPAq+2EH58EMRqAAuhhODgAILSkmgmAJ+2EP9sEAgiNOJdAEz6cFN9keIZUeq7CF3sQGPgknIGCV3tEAyJEeu1BPF7AJcLIANtgeLHAf5lVPHGAE25gke6Afj3AfwfhODvAKmAgkQuB/7sEI9sFnCfUGgwYkjDCW7PEE90EHGlUDOQAkIIAE+/FY9uFOGtUGS7kiERCD+6FB6XECoKlRHrAFkzlGRMAfMXCc2OEKMAUBo9CZAyIBVNgeInAfpmFT+7ADEWIF/ege05geDP+AKTzFD7E5IEdAie0xAop1Hp7QVBfwVegRApuoH6mVHsYgVQjACsyZHCkwZQcSnumxglKVCu2pHA9wCgnCnvbRCmeFBnKJHTZQnfZ5H91zVn1wnsmRBrKoHwKKHqIwV1cwK7qxATJAISQgPOjhoHn1AWowUzBQn/wRZelxoX5FCi+AAshIIcVwHyF6WHAQlAnCmg0akz5RARZqpD0RlenxlkqKE0diH+TwpDsxQfahXVSKEz6AkOixAICZpTQhCfcRSmB6E34QYWVqEydlHyhQLWk6E0ZwHzX1pjPRBV2EHo1Gp+F4H0ygpzPxRvahY34KE1NwHy8ghIPqElliHwH/kKgvkQeQaB+y4KgugQn3AQCU2hJdEKHpAQiZyhLZcB8ocFufqpIgZB9fUKoq8QsDwgaqmhK5cB+D8KooQQUDEg60ehIolh6tQKG5+hH3dB+L+asjsajpgQcPRawisU73YQ3KOhKYYx8nAEHPChJPEKnp0TrVChKeJZ53sK0f4QLYih4pBa4ewVL3EVXmyhG8kJXYEWbruhF3aR8ZFa8XwVH3QQb2uhHSMCC0tK8Z4QHGECXnEQQAyxEx8AhnuRx4dLAbgQ3NMK66UQAO+xE1cIjKoa4V6xG9AJy4sQwbKxLf8FsMgIQh+xEQQAuXcLIs27Iu+7IwG7Oo5ACmJbMZ/9EJk6AEgmWzFeEDwUBbxMCzFREPxYgbCiC0ESEHHakcUfCNSLsQGGAMvpgbvPW0CWEIonkeTmi1BREDVooekeCmXPsPdnCa6ZGqYzsQu2kffJi2/yAHU5sdZkCqY9sIBDKnadsBpngfuOq2qCCx56EC5Jm26kAgFOu2HBAoA/IKbvsPNNCf2BEBO+m2NkAgRzCcXMsBfWkf2pq2nQC456EHjSsABHIAquC2HRCrAwIJfjS2LsClnNu4YkogGcm1GHsfKTC5YxsDn1hcJ5q2LAC52HFVbusjBIIPbusAHsu3bpsHSjUgKECgXEsN7poduKCeSGu8AzIAHcqzDqANEP+iBm6bBEUAIVg6tjigom15tGm7CBAyAdU0trdEICEAk09LAao7IACAvTwbCogAIc6QrFxLAwdKmHpps/c5INzgtvs1ICs7thDgChHyA2nbBd4QIfTItYmgBaliVlzbBwKCQIeQtiWwfAQyAQBqtewQISictqQLIXTDtbUQITH8tOVDw/UqtBSwUBCyBWk7AlaEUgdssxdAZOhBDN2LtHmgZ0ecxE/7BOqYHUjcuAXBA2abHFNMxVX8ZcoxCE7stqujG4MgwFpsEGHsD2NcxgqxOmmsxmtsBWTsxnI8x3Rcx3Z8x3icx3q8x3zcx378x4AcyII8yIRcyIZ8yIicyIr/vMiM3MiO/MiQHMmSPMmUXMmWfMmYnMmavMmc3Mme/MmgHMqiPMqkXMqmfMqonMp90QZ5esctUAKw4AX+EAV13AJncAnHILG6S8WJkAyl4Aegixup4LZdgAWkEACZlB6V8LRhYAivoAFeILyRG8cn2wBsEA/WYALrpSK4WbFXoAmZIAUm4ATBrCKVaa4QEAo08AvnQAdWcASwuyVO8Ko+IAeiAAXt8ArQYA7EIAhRUM7Pp5Z0SgVA4ApBcAxHYAYEi4AKSqfXOYNMRaesOoMJMMQxCQc/WJdlGks4yEFvegMuOAFkQAoySqXXwIEWoAuXcAPfmaZrGoATEATWIAbUpqynt5B/UbAMqdALX0ync4B+jjAIoPALfKCsQ7B9IFAHUqAHLuCruboCgpIAxdAMPyAL1GqvHZAkL+AErgALi8ACg7uxHqIEzEAGtSAA8GAIKhSzpJUcLxACTKALrsAKmPAD7XADdyC2TzsLIpAMaHADouACV1DTqlzYhn3YiJ3Yir3YjN3Yjv3YkB3Zkj3ZlF3Zln3ZmJ3Zmr3ZnN3Znv3ZoO2yAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vejLFBklt/bgxLJsLej0YVKqiTwLo16zKpjf0gIiIamhui7oT6wLm378QN7GBJtkicETCbvCCa4K+58+fQo0uf/kLN7+vY7ZK4pqcRMFfrQkz/H0++fPkt2dOrR3sDWgA/q8zLn0/fubr1+PN/rVC/v3/ysegn4IBWdfPfgQj6MwuBDDbYFCoJRlifMA5WaCFRYUiooXlTXOjhhzz1sOGI0vEC4okozrQNiSw6h02KMMaokjktttiFjDjmGNIoNZJogY5ABpkRMj2OCIOQSCYJ0RNFbsiMklBGeVAHGTQpYTFSZpklMxKeAEIh3gThigngaMCKBJykpqaaj0gwjwbKmGDCIH4AgEgKzaWh5Z5KumKeChssMY4N9bgxDA1PxIABSA7IkASfkAZpg3MP4LLJPI34MsUtHETq6accGcDFGaosCuqpqKaq6qqsturqq7DG/yrrrLTWauutuOaq66689urrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfghivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvz26++/AAcs8MAEF2zwwQgnrPDCDDfs8MMQRyzxxBRXbPHFGGes8cYcd+zxxyCHLPLIJJds8skop6zyyiy37PLLMMcs88w012zzzTjnrPPOPPfs889ABy300EQXbfTRSCet9NJMN+3001BHLfXUVFdt9dVYZ6311lx37fXXYIct9thkl2322WhPBEHa08agzShsQytKIP48oEjczVJygnMhJP+Cd7IYBBOdLh38bWwbA0z3iOHE4iDieHAwHuwsL5S3yhyS99oAK/MdY2rmuJpyTH1lgJ4r5/1RY/qtYQDQHwyPrl5rFnjWt4TsttLi3yu41/pFfxHU0PusDQjSHyQNDC8rH/HVJ4XysgrT3wI0QB/rFv3l4IGHUKxt/UgfHNGfBBeK4c8Adnw/Eht708eAIRW2EElzKHChvkj2ZL99gxJAt0369/uIn+pDPgY9gwHRQcEiAuiRC4CgPgvAAYE44ITxjIEPDOTIPfpzhM/lBxrlccQpMrgRDfSHAAJiQ5XMM4Y8kBAjPqAbfV5wB/1Ugz4JoMQLL3IDBNKnEvlhR3//nrdDi/SvPu1YTwzwUB8ndKqIFenC/OiDiBGohxv1eR8UL2K++gQjPVjozxe3eBE1QBAV2HEAOeoTiBaQ8SIriEJ9cuE931ShP2d4I0bg0J8R+kYGTKSPPPSYESDUBwY+8A0d6rOKNhASI6ZwRH1s0Bs2PKA+VXhkRnhEHws8gTObmGMdNVmRDmygPsTYzAbp8wAdkDIjvfDhfKCQmQ5UkD4FfCVGalEfRhTuMnekDwysqEuMkCCQ8/FjZVogHvosqJgZWUR9osCbyvCHPpMYJTQr4gAv1GcalbkCCuqDhW1qhAX1ScAQKDOP+kjDnBvZRX04MZknXHI+KXAhPDMi/4fKzccCmIuMMupTjn1uRB31UUZkaiBL84TAjQbNSBgeOB8GCO8xYMBkRDfyifqA4TE6qA8AfrnRzrTCfRdljAnqo4CSbkQPHm3MNerjDJdyZBLuM9FiBjgf+NlUI12cjwkWw4v6kOGnHBkDfVZxAcVklD7VQ6pGaCCfBFRgBYp5QkPLM1SpboQM5MFDI8LAGBPSx5Ve1YgopoOIWEB0MXywAH2AkFaOrPQ5PfhBNRtjBJTWdSMhbY4ZFpG8x8SgdvIhxF/tWgg3FBYy06gPWhebkSGQFDINQAR9jkrZCgmRPlTobIVmQJ8giNZBZ6iP6k7LILDOxxusZdAt6kOL2P8SiBP0KYIHbbueD+yAPgHirX4+Kx8UYFW4+VkHLpGbn5nOZwEAZK56zCofV0h3PSRgznxWe93s+II+OejuetgggSaYB27iXQ8FujGI8aTguOnFzxPU0czn1CK+A8JAOJYgyz/gl0HYqIAZBPFfB0HAFAVOsIIXzOAGO/jBEwNCAiZM4Qpb+MIUDi6EF1MACaFwwxz2MIhDHKEPjxgxHS7xiROT4gSZeMWFaTGCXgzjwcj4QDSucWBu/J8c6/gvPPaPj3/clyCfkMg2FjGSd6zkJQO5yU4uMpSjvBcj12fIVLaLlemD5SzTZcvz6bKX5QJm+Yh5zHAps3nOjGa3qLn/PGxuM1veTJ44y1ktdB6Pne+MljxPZ898NoufpQPoQJNl0NEptKHFgmjoKHrRYGn0cx4Naa9I2jmUrjRXLt2cTGtaK5z2h6c/jZVQj5rUVjE1qtui6lWvpdWuTgusY32WWdO6LLa+9Vhyreuw8LrXX/k1sLsi7GFvpdjGzgqyk32VZTO7Ks5+9lSiLe2oULvaT7k2tpui7W0vpdveTgq4w32UcZO7KOY+91DSre6gsLvdP3k3vHsi73nvpN72zgm+832TffO7Jv7+90wCLvCYELzgLzk4wlui8IWvpOEOTwnEI36SiVO8JBa/+EgyrvGQcLzjH/k4yDsi8pFvpOQm/88IylN+kZWzvCIuf/lEYi7ziNC85g+5Oc4bovOdL6TnPk8I0IN+kKETvSBGP/pAkq70fzBd6U8/etSJPvWgV93nV9951nG+9Zp3XeZff3nYWT72lJfd5GcfedpBvvaOt13jb7943Ck+94jX3eF3X3je/9oBBPj974APvOAHT/jCG/7wiE88Auow5WQf4gCQj7zkJ0/5ylv+8pjPvOY3f4AVuhjbCrCS6EevZ9CT/vSoPzWfQ4/61ltJ9Xdmvetn3yLYy1n2tM+9hmzfZtzr/vcHAoXpgU/8/0QAEPmQtu+Lz3zzLOALezX28ptP/fHUQR/Mnn71tw8dJ2Qh2drnvv/4/QGDEkh//OiPTgY+4QBghz/923/+Y2n9fvhvXwhNvXX97V/9I3yf/vwXgOQnBgAogPwXAfbjavtngM3HAJwwf5q2gAzYfEKwTqQmgRPIfF6QUpWGgRlYfCFASxH4gQIYAVWgTatHggL4AHvQfovmgSpYfEuQf4EmAwZwgziYgzq4gzzYgz74g0AYhELog0QQAaPnBS7QdCihCY9jJSqQR0poEvRwSqI3AZIQhSZBAmswegvwCBCIhR+BAWVwT03CAGkQA2BIErNghKIHCUmYhiKhCE3YJDBwA3AoEi5AhVaSAplwhyHhA66wVTWyADbwhX6YEQ1QBgswemtAAof/+BH9oF1WsgFy8IgewQJyJHqI0CGWyBFxQFqilwJu0IkcsQJWwIU2QAGkqBENQAeLaCUMYALwtYoXsQjtM4n0QIsZAQX11SQhEFq6eBFIAIpWggKjGIwWIQMFIIgtkgFSoIrISBEcUAqkBwTEFI0TUQWI1SSTEF3YGBFQQFFWogXA+I0RcQfE2CQToEPmGBExsASjlwGYsFvtuBAUYATM2CLWWI8P4QBEcItN4gfeyI8LUQLi2CRFUE4E2RBIwASjpwQisJANkQRKJXoPcAn0KJEFcY/5yCKEQFYamRAOAAgAWSSCYAkhqRAlYF6ipwUKmZIHwQYOKXog4DcweRAX/xBKTbIACXiTB8EBRvCKNbIHPqkQDvAKbMgiQhB9RXkQb6ACLMIIjtiUC1EDOTAiIIAEVNkQbVCRERIBBLiVDeEBWyCU//EARCCWDwEBo5CU/iEBKKiWCrEPv+UfVgCNcvkQ/HCV9XEEaJiXEXEB7TUfIfCGgBkRCMAKZjkdKcACh1kRqeBP0/EAyvSYE4EGLCkdNhCXlvkQfcCX0JEGhtiZEHEFlQAdGyADpIkRH6AGPgQDhrmaF0EKL4ACnCibGQEHEYmbvNmbvvmbwIkypsCZwdkQgmAGFfAixQkRf+AcDLAE4ZCRy2kQvAQdIaAOnzSdCLEC2wgdg9ANeKmdAv/BSeTRBBLABuIpEKBpHrWlndQwQxY4nTxlHu+knXawmORRjst5RPKxAeK5AuOUTOIZCzh0I9OJAUWwXNqpO/QRm8XpDZslnu9JH1A4nUFAHzMgnmFEH+wgnq4lH4gwmovRAfHJYIE1H+AUGQ3gBoXQVQ1GCPSRAn/pGA2wCGbgHJOlYAxFH0bwGB/wA3PoDy6qYIb0TxjEGC0QC5olHaKwYCcqHxrAGGHQCMgkHZyVYHclHwyQnYixAhWQAPIRVf9FVfTxUYlxAc0jH2OQYB8qHzqVGFkqH2EZX4ZQH9ZFVB0ZHZPwX85QH9fQGE81H3oQXx44pIqxo/PRCiIaWx3/4DpnhVH18QniFUzzYaaOgajyAQIgyVzM5FeQMVD0cR/SVQ4JJRlzIFfz8QKViFx50J3k8QBcChm4RR+7wFzSUB/zQBlDAKb04Zi8taHzgQJXUBmRRR9e4IKsBQE4RR8VYBkfkInzsUCxNQv18VCXcQr1gQdTKVojAAMadRkdwAj1cV+nxZ/y4QSXVRlQkEW9IFo6QIbycQ+bQQz1sQHp6lUQkAv1sQmc8QSoOh/o9VeUKh8PgJ6cMSn04QgIVldtkKbyQQe+0a31QVd1JQ/Zqpq+ga31ETlelVrf6hsQYDz0EQWz6FItIEPzQQ7I6huogJ/kYR1IJTjklB4ySx9z/1pShpCn0cEN6jECSzofkWCgG0VB2Tqj2WEgBORSUtAfHYofp+k+drhRlMCr8lEN+nEHkikfgZBIG5UHXkkeGWCw+UEA/RGlLnUKkkQe0JBf4lMf8upSfPC13fdEAoIDLjseIECDJbUIAfocDPAM/NMfd2pTdrAiz5FLBOIB6ykf9iBVXBCgkfBWDJKz9XECYku4iXOzDbIHHMSUJQUBImghitsf6DGdNHC340Eh07m0jHSkxdkAkNAfgrCoslkDbikfX6Cdr+Af7bmc8FgfKfB/xZkE3ipSmxqcE1ofrKCdZVAfx7Cwy4kBoyMfrEC7vDkHDisdL/BM6fkPqzQdPf8gQd07EI8wHQPgSOM7EB2gC9ERDNKZnolQXyfAjulrEIpwSYHQpPWLEKOgDUa7vwZBnAA8wARcwAZ8wAicwAq8wAzcwA78wBAcwRI8wRRcwRZ8wRicwRq8wRzcwR78wSAcwiI8wiRcwiZ8wiicwiq8wizcwi78wjAcwzI8wzRcwzZ8wzicwzq8wzzcwz78w0AcxEI8xERcxEZ8xEicxEq8xEzcxE78xFAcxVI8xVRcxVZ8xfiBAapwBlxgAPXLAbcwBb7QCPOwCbhAhpQUjUkgAyvLERgQA09AA8PgBvVgA+OwBBsAleUxuMGYBs2RAogAAH4wCHKiDBowDxLwCGvosiacIAGsoAHSYAKuEATeUAggUJL/8STRWAzjlwH3SopcMn6xSou9uH3IEI3/yn0BS4tdkH7mgIzYkH7bgIxFhX49gIxTAH/HS4rSk376S4vUmn7dEIwEmn7NqosIxX2r4AcBAA1RS4vYA3whsA6uAAyNoAfXsK3RqAZZ2yMTgAhesAlgYATisAjJgAV2YL3Y+AGhcAeicANoEA0iQAQ/MA2pUQau4RpSkBqN8AP2IALJMAw38Ae3kATqjMUIndAKvdAM3dAO/dAQHdESPdEUXdEWfdEYndEavdEc3dEe/dEgHdIivU8BAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza94c8tCPHwIqVAAlofQl0aKn/cgmghKcYYb6zCHRgbPt27dN+NvNu7fv374nhGC0LcA8a5/aKbr1Abfz54ndAZ9OvXrvHUfIqCFAC0si6ODD4//VYL28+eoRmBQoZU9TG/Hw46Olc76+/ekJjs2Sz78/Vwn3BSigP7H4Z+CBU1kz4ILnDYPggxAqVQGDFFY3R4QYZhjUORV26BsKGoYoYk4/eGiiP+uMqOKKMGVyoocasCjjjCeJ8GKHpNCo444eCXNjhSXwKOSQFcHxI4V8EKnkkgzJcuSCjjAp5ZQExaGBBkaUVgZqZZRWmjkagGGCEEH4AUAIE7zoCZVstkmRAzLIYcAblJyjDivE+BECA/Y14+afgF6EATY0JEOKEQUwccJ0OQbq6KMWhUKFG2W4AsAD/pwB6aacUoQBEl10KuqopJZq6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXbPPNOOes88489+zzz0AHLfTQRBdt9NFIJ6300kw37fTTUEct9dRUV2311VjfpckxeWS9LDYw+IMIDV4j+8E6vEVASdnGKvNbGQ6wLWyJwBXgg9y/aoLpdMw8/4E3r1eEYN0OsvydqwNBmPdANobfqo595jTQ+KzIBMjN5LHascN9jsSB+asYeHIfA8h8/iomARJguqss8GnfGqu3OkQU9zERRuyspnEfCp7jruonAerhu6pxLGofMMOn2oEf9wlCQfKo4nPfDhdCb+o1e9d3j/WmeuDEfV9wbyqA9s3AgfikYuH6eSewgf6oHHxvnz3vj/q4fSbUL2on2ZsHwgX64xQGNnAfNASQU+K4j58OCClVRMA+kbgbAx81BvswQBMTfJQe7kOHDKqEBOIZASIg2AIPnoQErMDDEMIDjPtAwYQmgQcIdlML8HRifea5HAxHgoRt9IYBOIDOMf/s04MV7DAkH7iEBX7jBwg4x0b2MeARP/KGVlBnEbjxwQjrk78pdiQRARjcCm1TBvugABte3IgDAOEI88zDNi5YYn0alUaMJGES9XlAFjizBPtsoDZ1zMgQ61OHzYjBgkEMZEZ0sAD7fCMzECAH5BS5kRbWhxmAtAwUz7MKAFIyIzKYYX0+cZkPFME+pPykRtxgHzxIkDIJrM8RMqlKjIiuPtaojA+UYJ8p1HIjNDDjFSqjiVycBwi/5Ig07GOEywhDftR5gR2SuRE+GM88FvCbZTpwCtpN5xHU5Mgl7CONzHzAGAn4TROMGE6NtMCb5mGADjQTA1hc0x+jaCdHXMT/Rc7wQQN8aoXk9KmRDjDBPvPkTBaskAyCciQc+HPojAZ5noRKVEWaiOhFV1QAhG5URTqwDyE+qiLdnIcBSCCpiEJanxipNESEqI8FkvTSDNUAh9bpYE0zBIb6nGCMO4VQFuxTgaBiiBj1AcH5jPqgYNZnP0x9UOLOc4SoPoga9qGGVRGEx/MUcqsG+oV9agBW/3QgEPVpZln7Q4r6OKKEa5XPLuuDxbjKh3zm8YJd5WOHRp7HEHuNzy7qk47AwocF9XkBUA0LHWbU5weMDQ8g6jODyIJnBCmojwEsCx1z1MccnH3OH9zqgdA6p6vl2UDvTGubKlgHBqX4A2uds4I0//3mBbtAAwZmCx239cYP2YgBb8Nzg90gogzuGy58jPCNuCn3uVUBQgKmS93qWve61C0QdB3TUQqpbruN6S6DvgvexYh3QeQtb2LOO6D0qvcw7BWQe99bmPimjr7rrdB88SsY+95nv/wFjH/tA+AA+2XA9SmwgfmC4PMoeMF6abB5HgxhvEi4PBSusF0ubJ0Ma5guHK6Ohz8slxBTZ8QkhouJp4PiFLtlxcBpsYvZAuPfyHjGaqmxb26MY7TouDc87rFZfsybIAuZLETejZGPLJYk+2PJTAaLk6EcZa9Mucp1uTKW56LlLcely15+C5jD3JYxk3ktZj5zWtKs5rOwuf/NZXkznMci5zmHpc52/gqe89yVPfN5K37+c1YCLeirELrQVTk0oqei6EVHpdGOfgqkI92USVN6KZa+dFIyremjcLrTRfk0qIci6lEHpdSm/gmqU92TVbN6J65+dU5iLeub0LrWNbk1rmei613HpNe+fgmwg92SYRN7JcY+dkqSreyTMLvZJXk2tEci7WmHpNrW/gi2s92RbXN7I97+dkbCLe6LkLvcFTk3uiei7nVHpN3ufgi8492QedN7Ifa+d0Lyre+D8LvfBfk3wAci8IH/o+ADRzjAFd5vhuvb4feGOL0lHm+Ku9vi68Y4ujVebo6L2+PfBjm3RZ5tklvb5NP/Rjm0Vd5slivb5ceGObFlHmya+9rmG+0AAnbO8577/OdAD7rQh070ohsdAXXQb6cPcYCmO/3pUI+61KdO9apb/epYP0AGlK5pBTzp62BPcKe9Hvaym33HYz+72s1O5SiTfe1wP1Lbmfz2uNvdRHM/ct3vzncGgSLtfQ/8giIAiHxceu+CT/x5FvCF5kQa8YqPvHXqoI/HS/7y53HCHhcNecx7vjcwCBKiO//50mfgE879M+lL/3nGD5TPq2f954XgyTzHXvaeP8Lm7Xx73GMeBmKwve+H35sIcIH3xE++PxjAidefuffKl7wQFhtm6Ec/8l4g6/Ovr/wQvJDM1ue+/+IjUAUnejn84k/8A/aQ+iqjP/2JX0LtoywDA9j//vjPv/73z//++///ABiA/UcEDxR2XuACBscSmtADZacCmpKAKkEPBBR2EyAJEPhBa1B2C/AIzneBJIEBZdA/R8IAaSBcHngSs1CAYAcJCHiCJqEIDBh2MHADLmgSLjCBYJcCmVCDJeEDroBTP7IANtCBPOgRDVAGfgV2awBCRSgS/WBbYLcBctCEIsEC8PR1iOBLVAgScTADZZcCbrCFILECVqCBNvA8YtgRDUAHSfgkDGAC7JSGHLEI9/QkG0APctgRUCA4YRcCVJCHHIEEXhh2KBCGgKgRMlAAQHgjGSAFaP94iBfBAaVgdkAwApCYEVWQWWE3CdN0iRcBBaIEdlrwh55oEXcwiGA3AWtTihURA30UdhmACbvFihNBAUawiDdSibQ4EQ5ABHV4JH7QibsYESUQil9XBFgwjBKBBAcVdkogAsoYEUlQQWH3AJcwi9HYELaIiy9CCLeTjQ2xRr/4I4JgCeDoECXQBGWnBcl4jgzBBs0IdiDwHe64EBewCWC3AMdXjwzBAUbQhi+yB/zoEA7wCip4IkLgeAPZEG+gAi/CCEy4kA5RAzlgIiCQUhIJEW1AjRQSAcGXkRHhAVsAkPfxAEQAkhMBAaNwkPchAeaHkhKxD5sTIFbwiDApEfz/UJH2cQQmeJMUcQGDUB8h0II+WREIwAok+RspwAJFmRGp8ALV8QCn0JQagQbqOB028JJUeRF9oJO+kQZEuJUVcQWV4BsbIANiyREfoAauAwNEmZYbQQovgAJaCJcdAQfQaJcw4wDfoFZ6mRFsUAZbRIN/2YrZwDy9oQyFKREYgAa7AJW/MQFxuJgL8QelEDbVUQWUuRBxgIPWMQmbqRAe0EbnIVuhiRCedR6gdZoHcQ31kQKWyJoGgYrlAQiyaRB0Yx7McJsFMQSQaR5MyZsDkQ71sQvCORCGUB8LIIzC6QX1IQHHKRCLUB9KEJvC2QKkaR50JJxGUB+BQEu3WQP2//EL0fkPSXceoBmdWFUfWhWdR1AfQVCes2AfZHOcHGCM1kEM5Tkh9bF7vDkE4zgdYFCe9HFS2iecfCBH5jFS0Uke9WFRvIkE3PgbXXScMfWg0clS51EA5WlS54FBx6mh5nEMHWof4cBZyWAF/pkZIloeTACedtUAVsQAGkBTmuGh5rGDjDUKvXECsNCTl6EDE+obUQBXe7UCV9kbCWAMCmkZy1Qfl2BYj0AdUSAJMBoZT6Cg5XECNrpWdvCb0wEAwnAZ3Vkf5WRXQHAeuQCik3EFKECfcTUF9qEEryQZClIfa1JWHfCe9SEOluEDeGAfhrhVwFMfRdCkk1Go5wECaP9pVUOwCvaRl9vkWPWBPFaVmudBDlpZGd9gHwsAoTuFA0PqGx+ZGed5HiRqVB3gmeWxBAolgtUxCUlgVG0lU2+ZGfNgHo4ACO33UtjwpvVRBrcxBDNJHQFAj0aFo+WBCHW6GdM5Ha3wBlaFBvchqbYBAYjZGxZwCYi6UysQg6gKHaLaG9uAkVbFDRbUCeBRC7sBAvBQVlBwH5YKHUOAB6wQkVbVApFgH4hgndCBr1tVoPUhPLypCaPaG2MgnD6wr/URAaognM1wH37Km9TqR9jImheAn9bxAOrKm8paHuognPZwH06wVLLJBgE6HQzQjrLJAbRpHtDJm19AsqV1m/f/UJLXwJtzUKzngQ+8SQGCcB9+cKWUaUk+tVqsuUH3kUqyGQfAWh9pwJthEI/nEQXUF5oZaEHBKZsEECCYwJvIcLC94QkXG5pxcADTw5ynia73UTq82QCYah4hG53ZAKvAEQS9ypuywLPAEQLDVJ4C8QSUChwPQJiAKxA+4F+QdbgE4QBl5BuKybgGQQkquA7dKrn/QAMjBANohLkHkQfHwKaeO7qkW7qme7qom7qqu7qs27qu+7qwG7uyO7u0W7u2e7u4m7u6u7u827u++7vAG7zCO7zEW7zGe7zIm7zKu7zM27zO+7zQG73SO73UW73We73Ym73au73c273e+73g/xu+4ju+5Fu+5nu+6Ju+6ru+7Nu+7vu+8Bu/8gu7XYAEZVu68foAAEAMZeAGVBAKpFurv3EC6mEEpJAMNIAN98uaEVsfDBACfkAMrKAO50AJb2AAciADeSuWt2QiwgEAfhAEQmACYKAB5uAlEgAKqEEaEmAEV4K0u5idiVc4ysgHlwcH0VgClzemyijAimettOigkaejw4g2kre4w/i0incOyjgHmFdUwzgMmJdLwxgLmBezuzgLx5BOkadT0dgGmiAJpZAoLLl2LjWQiYAFtEAAakAGR8C3T+IOTfkBt6AI7fAJ1jAPAbANjIAmHlKhhdkBJDAHfWAIwwAHlCAC2T7wA9OAGhVwCV6iwhUgAJ9xCPN7yZicyZq8yZzcyZ78yaAcyqI8yqRcyqZ8yqicyqq8yqzcyq78yrAcyxIZEAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz1zRVAlHYw4H0KhTqyZIzJ9r16tmpPnSqB0WU6tz65587LXv3/4mzFhjYxGLK7uTKx+cA7hz56uc1SJFLdTy69jponjOnTuMOmW6sf9xkL28ebIcuqtXj2KAjXh2zsuffzXP+vvrVVhphOU0/f8AItUJfgSu90IxoCAzQoAMNsjTGwVGuN4CnkhxhgcOZqjhS/BI6OF6Fhiy4YgklhTLhyg+94APJbboIkegpCijb868aOONFGkw444V4OjjjwstseOMVABp5JECCTJkikp0gOSTPqIzTh1ewLBkhMRAqSWQHWCDRTuNfJEGIxFc6dwrW6YJJTZTzCKFCQA8cGUNata5ZQO8xFMBIa2k2IOdgNbpAxXZ1OKNnARqEOiidn7QCyDgALAeLYxWCugF99hwjAXOIWfpp3ZyYEgFQZTpzwygphroB2Jcko2qsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/Pbr778AByzwwAQXbPDBCCes8MIMN+zwwxBHLPHEFFds8cUYZ6zxxhx37PHHIIcs8sgkl2zyySinrPLKLLfs8sswxyzzzDTXDOUQNvOLQwJV5JwvDge4lorP9vKggm+NED2v0cAlrfS7T4DwnNNPr5uHLd1RXfW5FzCzntZbjzuCH/iBHfa3HgRRoNlnb+vALhKy3Ta2X3h4gKdzayuOhxP0/5L3tuzwzcLf2paQgYQTDE44trw4IqEFwyyO7RVmSLhAMpJf68E6HmaSubUQwC3hOZ9bG6OEl5RerS8e1qI6tZ2cICEx5L0e7RVFSHgMhrZDS0FvEQKAc+/QqiEhDHMQD+0siOOg/LPXmFog5s83GwPWEdZTfbMOjCEhN9s3a42EAzQQ/rKyLBBhIBecr+wVIUSYQh/uJ+uANhJSX/+xFUhozf7I0oT6CrQECADQWDLQQoQiQYIDGisAETqBDhxYLBFISAQUJJYqlBAhc2SQWBAskBf888Fg+WAcBEJBHEpYLGE04T6UYmGxQiEE9YBPhseqwgSew4QP4BBZLlDSb/9e8IcfJqsD+ECU0Iy4LBxIyh+bYCKzujAPFSRCis0aHha3yMUuevGLYAyjGMdIxjKa8YxoTKMa18jGNrrxjXCMoxznSMc62vGOeMyjHvfIxz768Y+ADKQgB0nIQhrykIhMpCIXyUhmYaCRPnrDAFwHSRd1oB0bcE0E2lBJEn2gCrj4Teo6maEVGMNKwGlCF0jJoFCUgYPceRUr6XOLWnBKPbgw4CzPEwcGEOgeu5SPJwikjWCeJxkFYoMxywOBPuFnC8ssDxcIlAIZRBM7HsADgUhxTexggkAA6OZ18qDE9UxBnMshBIECgE7laIJAFkhCO5NDDgKhY567YR5+CoH/T910wXH4UUQ/c1M3/DRjoKv5A4GUsEqEpgZ494GHQ1NjQfwEYaKo6QIs75M8jH6mGQSSm0cvQwUCoWqknmkOfniA0s7sDT9ScB8QEkDTmtr0pjitaSxoxQdf3scW7ivAjAhQqwEQiAbnE6qMiEorexAIFkkdaq1IcLj7mCGqS7WVFY4aPqWmiKm00gOBYro9r6IIrLPqguzu04quStVW6sRPEatn1g+hdVZixY8AyvrWWrVgrevxA1+zeqvW4Ac3z6urh+46K0oQyB507WutZFDO7hQgsoS91TbwcwLeEU+xEmLsrEZBoG8kVrK1UgWB9nDazN6KCfgJp/JAGyHR/85KCgTqaO9oWyDbyuoGBFrEbFFbKwxstDutkMRwXXsrE3CnCQE4RXxa+9VdVeE3EdBGI0Shy8FWV1dy8AcDIGEDKPhwf7wlkG9ndY/2UTC9+FlvSxMD3/vId76Hqe967ovfwuhXPfzt72D+250ACzgwBOaOgQ/8lwQ/Z8EM7ouDnQPhCO9lwsCpsIXzguHfaHjDd+mwbz4M4rqI+DUkLvFcTuyaFKs4Liz2h4tf/JYYz5jGbbExjgmj4x0Lpsc+BgyQg+yXIROZL0Y+sl6SrGS8MLnJdnkylOki5SnLpcpWhguWs+yWLXOZLV7+slrCLGa0kLnMZjkzmsmi5jWLpf/NbgYLnOPslTnTmSt2vrNW8qxnrPC5z1b5M6CpIuhBS6XQhoYKohPtlEUzmimOfrRSIi1ppFC60ka5NKaJoulNC6XTngYKqEPtk1GTmiemPrVOUq1qnLC61TZ5NaxpIutZy6TWtoYJrnPtkl3zmiW+/rVKgi1slBC72CY5NrJJouxli6TZzgYJtKPtkWlTmyPWvrZGsq1tjHC72xb5NrgpIu5xS6Tc5oYIutPtkHWzmyHufrdC4i1vhNC73ga5N74Jou99C6Tf/gb4vgWOb4LX2+DX7AACFs7whjv84RCPuMQnTvGKWxwBdSDupg9xgI57/OMgD7nIR07ykpv85Cj/P0BVv3tqBZjp5TBf0o3F7PKY2/zmtW11zXHO855TWOc+D7rQZ/7lnQv96DYnOpeNjvSmXwkUQHe61JcUAUDko+VTz/qOFvCF83qa6VoPu4TqoI9Qg13saMePE7Lw9bS7PUIwKMGmz/72ujsnA5+o3aPpbve+v4br5tu73wfPHSG4N9F8J7zfj8B2xCv+8b+BgRgcD/nK+yMCXDB04i1fdwZwIvB63jzn6y4ELdJZ9KN/uxfodGfUp97tIYBC61/P+QhUobtodj3t0/6APei9zLrffdqXcHgxy8AAyE++8pfP/OY7//nQj770p/98Ikjv5l5wgb9pooke9FwFZ9j+/0zokUmeT0C54o8JCdbQ8wU8AvTpbwkGylBZmDMgDTGIP0xmcX2bQ0L7+ucSiuB9PAcDNxCALuEC5YdzKeA5CMgSPuAKPnVzC2AD8PeAJ9EAZTBAOLcGDYSBKtEPO8RzGyAHIKgSLBAFPYcI53SCKBEHM9BzKeAGLogSK7BVPFeBFFCDJtEAdMCBNscAJrACPGgSiwBYN7cB9FCEJQEF8cNzIVAkTDgSSBCDPIcCNDiFIiEDBTCBNpcBUrCDWggSHFAKPgcECzKGIFEFKdBzkzBdaugRUCA1PKcFUhiHHXEHVohzE0AJeOgRMSAkPJcBmPBIf7gRFGAEXmhzaHiIG//hAESAhDbnB3DoiBhRAnSIc0WABZaoEUgAWzynBBhEMJhSMEngPTz3AJdgiP3yAVBgA5DgSyZIMIm4iDFHCGGgLxAgCvWgDf3XMwXjAIAgiTEnCJZgL3ZwCgHwQs9hAghTAsyIc1rAifIiCc6kHkrAigXDBqCIcyBwRfGyCARygAhzAZuAcwuQefIyB2OlMBxgBEBoJqxFL0+0HkywMA7wCv03JELgdfKyBwTyBAzzBkdzJYzwgfQCIfgxCg1TAyq1IyCABPfiAcT4HNvgMG2AijISAZOHL//1ANbUMB6wBfEYIQ9ABPriVPjhhw4DAaOwjwQiAbhnL6ZAIFkCMfv/sAMeYgViqC9kcx8n0AIRww8PiR9HkH/8IgAEogcScwGDQCAhAID8olD4QQgTgwCsUJLAkQKK4y/XqB4n0FASkwov0B0PcAoBg1v4wZQUgwbRCBw2MJP8QgMEYgUW0wdF+RppcIH+Ujn3kQEIOTFXUAm/sQEhKTCw8FgX8wFq4FMwIJUCQ5f4MQAZQwovgAItWDDYsx4MwAcZAwejaDBqeR/i0IkwwQMEkgOmCRN7uB53uJor0QgEclCwyRLsiB8MVZssoTb4EZq6iRIdgh/H8JsqoVEEMlfEeRIghR9fkJwooQgE4ghi6ZwkUQgEMgvUaRLoQCDkkJ0lkQS3dB+a/+CdJBFC92GV5CkSU0AgD4AN6SkS9bgemPCeIUEKBIIHnkWfHCEDbYgf6qifHbEFBNIKcgmgF8EG02OgHYE/+OEJCsoR90AgDLBCD5oREBBK6mEBtXALFboR2dAdSlAG1tGhG9EFb/kaMGAMREiiHXEJv4ELVeCPLLoRbWAqG9AOTjKjIFELA/AGOjoS2vijQjqkRFqkRnqkSJqkSrqkTNqkTvqkUBqlUjqlVFqlVnqlWJqlWrqlXNqlXvqlYBqmYqpnpgemiaAC8zCdXnqO/gAAzvOlqeAbD4APObqlfVCWvyEIkHmlH9CNvzEBwIil3KAeQjCiVUoL99EEwlClcf+wHfgxDiwSpRxQTwXCTlFqDhGiBKoQpRVVIL7ZpDpQkd1hqU9KAhhKIFpwmE0KAYJIIAswnlBaDhLSI1AqDBKiDb/HpH3Qn1CJN016AYEQIQsgC1DaAEYVIf8DpYMaIWOQq0taDxJiC0jppMgUIRFwDVCKAyNYINj5pHOASgWiBlA6BPEpnD3JpB4AUQRSBL66pA5gWAVyAp0ApbXgId0ApS4qIVD3pOfgIbtQoEiaCR6yDvm5pMmglephBu2qpMMQntHJC0/KAttKIBkgd04qsR7CDk/aCxNLIKXppFcQNBLSnFAqmxGyC87KpCZrUQX7pCurHn6QhlT6ss/BDMX/N7PdYQt5oKU0+xogIJBb2rMqwFJd+rJ4QLRe2q/+cABvCqZVkABNG6ZlOqZUW7VWe7VYm7Vau7Vc27Ve+7VgG7ZiO7ZkW7Zme7Zom7Zqu7Zs27Zu+7ZwG7dyO7d0W7d2e7d4m7d6u7d827d++7eAG7iCO7iEW7iGe7iIm7iKu7jZkg2XIAYy2qVeoElBUAGGQEJaegXOYQHHYAPtlaWIqh4AAA6A0AuR66Q6wp7eUAvZQAWR2qQE+CGtQAgVEA+8wJdCWgNX8gAAYAJSMAtT4J4/+go4FwGMMBu1gQXYUKf6Ca9HBwNeUAfjcE/k2QHH5XSCkJ4lpXVLkJ79o3WKu0KezhB2+5qdPlB/TbdT3mkIDit1EkWeHnAGUuAJCNtzPqqfI4AMoFAMeBp08/qgHIAFjWAFBYlzOzujdhAPNjAAjvpymKujDsAG3VAGdQCuMoICSxoK1EAKteAMq/Ah/ASlV8ACi2ADazADovobw3mlpkAF3dAI81AAM/DBvnGTXsoBc0AD4VAFaMC4PvzDQBzEQjzERFzERnzESJzESrzETNzETvzEUBzFUjzFVFzFVnzFWJzFWvwtAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ue3TDMgUGgfvGhzbv3WkX+ggeHsSbWMwq+kyvvSkq48+ARikkp0WK59etQwT3fHvyBp+kesIv/Hz+UCffzwV8MMiYKAvn38Gt2WYC+fvAm6WgNic+/f0os9gUY3ALFiPOHfwgm2NErAjYYXCASaOKAghRWCJE7DmboDx4aDIOBhSCGSBAjGpa4gxolfCjiigjOV+KL/uxQyw3usWgjeTTAqKM/WoDCw41AWsfFjkRKEuSRvTVDpI4MmILkk7IB8cCSL44B5ZWwdYEFKem0QmWDtGApZmxXKADLMRZ8yZ0SXYzpZmwc3FBBEBGoGZwGb+YpW5zQrMMAlTfoKahsJPxSixY6BlLjoIzCxss71dCX4SWNViqbDLQsg0KDLljqKZyHqAFCfcd8ampsDkChxg7cLXLqq7Bh/1CCBgcI94IMsOb62gfxuGIBELoG+xoJcwhr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfghivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvz26++/AAcs8MAEF2zwwQgnrPDCDDfs8MMQRyxxnhNObHFDDuwRwMUcJxRGGsFV0PHIA/GxgXPRkNyxKIg8N0EnKlv8xqbbRZFIzBG7MeV5foSHc8MVBLjxzwo7wE2DIhN9cAO7ZJiy0gSPMIiGL0Mt8AV+vGiz1f/mAYCOsHDdryqF6PhFxWLn+0QRMC4ASNr78qACjEogA7e+csOICCp35/+b94vMFNv3vX+XqAsJg9/bydwv7sJB4vYWriE3aEMubw2Ml6iO5fWuDSMpnNNrCdslLjBL6PNeUXaJD/iCurwjzPCiBWi8Hq8Hxbw4ATW2w9sAGbqz0Du8YAQ//LucGH98u6Mov/y60cwuy/PsetCyhrRT3+4duGS4gALau5uEIA66Hr67HrgiYDbnw+uAEfYJ0L68qaAnwfzz/lLnc+7gTy8VTXBOHRrgP3pxLzjeCEMB6zU+XLRhgfbygOAgSMEKWvCCGMygBjfIwQ568IMgDKEIR0jCEprwhChMoQpXyMIWuvCFMIyhDGdIwxra8IY4zKEOd8jDHvrwh0AMohD/h0jEIhrxiEhMohKXyMQmOvGJUIyiFKdIxSpa8YpYzKIWt8jFLnrxi2AMoxjHSMYymvGMaEyjGtfIxja68Y1wjKMc50jHOtrxjnjMox73yMc++vGPgAykIAdJyEIa8pCITKQiF8nIRjrykZCMpCQnSclKNhEICcikJjfJyU5qMhaWPEwBlkQAY4miUygcJZFKmSsdSMFLwUihKnfESlPxwBpOcE4UFlXCWeqolpWKAwGYcR5DpJKUlVIFAWRXnz0cc5WNmpqAzPBMWjYqHQ66xgl9CSNg6kkYDrLGNpHJqA/QLEDkGCc0GxUAB01whNx8kTf1pAcHvcKE8SzRPPPk/4M0CWgT+CRno8bQoBe0iYT51NA+8zSkBtUOoQJlFDYcNI9eRpRRkGgQLiy6zkpdwkF3gGhHG0UFB7EPnhcdlANW0SATiNSanlpGgw5QuQ8mNEML1ZMbHIQDlI60UXlw0DR8ClNPfU1AlSDqL00FjAZNQEUgvKmDcqonBTiIBiKUaoOomicSSCpAjchqShvljQYVQKw/rZQEZlpTDmpVQFzNk1UbxIsQvjVAcX3TBRxkD7uOtVEkEhCeovpXRpmjQQDwa1orJQIHxYCwi23UHRxUAsgW1VQBFNBQbVpYRi2hQbuw7FJfJYAGFUG03YTVNxx0Bc5GtlF7bdAwXHtZU/+ZoUHGoO1oX9U0AQ2tg3e1T171NI0GMUO3qYUVMhq0gA94MLj1GW6eJtogmAG3s41iKXoewAQgCOCdGoQueqSbpyA8BxfEgIYveEFAxdbWVAIYAyfccI3qqPO9oQSMeM9D3vzWZb/c6a9/5wLg7Qh4wHEp8HMOjOC3KNg5DG5wWx4snAhLeC0UDo6FL5yWDPtjwxw+i4dBHOKyjLjEfDkxivWi4hXjpcUutguMY0yXGdNYLja+MVxyrGO38LjHbPkxkNUi5CGjpchGNguSk0yWJTNZLE5+MliiLGWvULnKXLkylrWi5S1jpctetgqYw0yVMZNZKmY+M1TSrGansLn/zUx5M5yVIuc5I6XOdjYKnvNMlD3zWSh+/jNQAi1onxC60Dw5NKJ1ouhF46TRjrYJpCNNk0lTWiaWvjRMMq1pl3C60yz5NKhVIupRo6TUpjYJqlNNklWzWiSufjVIYi1rj9C61hy5Na41outdY6TXjewAAoZN7GIb+9jITrayl83sZjsbAXXAbpgPcYBqW/va2M62trfN7W57+9vgPkAGpO3ludrp3Oi2E4lvbO50u/vd+hR0u+FN73rzV972zre+K4zvffub3uum8bz/TXA1gaLfBU/4lyIAiHzweeAKj/iLFvAF59oZ4hLPeIbqoI+La/zjMHJCFuaMcZCbHD0w/6hsm0t+8pY/JwOfaCuWWe7ymvuD4u0NM81tXnMhXIDMO+e5y48w8nIL/ejcgYEYjI70pgsnAlzYctCdbnIGcCLnTJ461U0uhP08WetbB7kXavD1sIc9BFDIutnDHoEq8FLHYF/7xx+wB5m7OO5y//gSft5jGRjg74APvOAHT/jCG/7wiE+84g1PhP3R2wuo9HVONNEDe6vgDJLXCT1OVu8JGCnzOCHBGuy9gEdgnWMtuIYbODEG+bkLA2XYGbwZkIbHSqwBvPAFNIjRPecEIV6zcDy8IRH5hc1BAEBgguy5swp5KaLy9YZBoBjWCQdhQ14u4Dy9U5AJhn3gq/axm/+8fOCKP9F7ATY4vcGIqVl6NaAM4H/3GhCXsHYKKLT16scE7L0BOSTMGA1CTfbCAlFgb4gwBQgzDA7Cd/USB8y0fW5wMFfgIN+ALytgBaRnA8hRMKQTIK53Lw1AB/GXbgxgAitQML0VIEuwL4twAvxHDwRTXALSBPwCBSFgbyFABQNTAiDFL0jwgPCGAhEYMDHgICLQLzJQAOYHbxkgBRv4L0cVIObgLxxQCvkGBCMAMBrQIIwAMFWQAvY2CXbwL/awgAADBaNSb1qgg/3CCw4CPgBzB0D4bhNACf3iALUiIPdDhJ9VbxmACVCVL8HlDQNDAUawhPCGhfvSCMxFfwH/4wBE4IL15gdjmC850iBwuINpSG9FgAX5ggH7JyDAYDBIYB71pgRHiC+VgFgHkwQEVW8PcAmBOC8yKCB5cDCGiIjvRggKVC844CBDaDAOAAiSSG+CYAn1gocNsgwKUwKZRW9a4In0YgINsgp2JzBsYIr0BgI3My+f4CBsmDAXsAnnF3UG5CCUsjAcYAQjqCbOZC+B0CCQ0DAO8ArCpyZCYHH1Mg/W5zBvkDlfwgiOWC9o4CDm2DA1kANqAgJIkC9d8AINYiUP0wavSCQRsHT6Qo4CYgE+ADEesAXt6CAPQAT8wiANogcRAwGjcI8ZIgFvdy9z4CC/BTH7wColYgVP/7gv5NAgKKCPEMMPCpkhR2B7/WINDiIMFnMB0iQgIVB8/HINDpIOF4MArBCSzpECwhMwtyUgg9AxqQCR23UKA7NW9TEDBKAKJIMGz7gdNvCS/WII58EMBBAHP9MHQfkcaaB+/gIBBSgcTmANPwI1V7CKzrEBuFIwweAPrSAFOgA3H6AG5gcDTikwLiAKkEMKL4ACCAh6XAEHqciZoBmaojmapFmapnmaqJmaqrmarNmarvmasBmbsjmbtFmbtnmbuJmburmbvNmbvvmbwBmcwjmcxFmcxnmcyJmcyrmczNmczvmc0Bmd0jmd1Fmd1nmd2Jmd2rmd3Nmd3vmd4Bme4v85nuRZnuZ5nuiZnuq5nuzZnu75nvAZn/I5n/RZn/Z5n/iZn/q5n10xBz6Tn22AC4KQBPkZBmXlD7gQUvbZANEmHE0QjvOJIc8RAb9An2TJHakgn6VVH0ZwjeaZDQLiCv+pnr7gIAO6ngpgldyRoOmJBv6UIYgwouMpCy/qNOfJAqGoIaNwozmaIZzAoy8CBkBaImSgl99JDT3qIMUgo+Hpoi8yA1lYnr6wfA5SCK1VnrOgouhRBMhYns3xIkXwBOapDjCiAmRHnkZTpoE5nhyQghqiAtpEniSgC2pannPAfiWiAmsqnqhwPXm6p+GJDEpQp+QJCFq6pbeApl+gI4X/gJbkCQs6AgC3WJ6J0Jca4gcMWJ6dkKQBMghRip7R4yC7YKTkGTQCQjnuaX/1kTTu6QFZcx4P0H3xWancgQJvQJ+b+hyIYJn1GarBsQG7cZ+mmga9iJ8BUHf76aH8uazM2qzO+qzQGq3SOq3UWq3Weq3Ymq3auq3c2q3e+q3gGq7iOq7kWq7meq7omq69OQcDiZ9AYAGuEA8+SZ8yAJb+cAAakCL1uQjccSJQoKznmTvoAQJqcAiP054uwJPLQAuHmZ4f5T3V8A51ZZ4QEI8wogW18Avt6p03QCUMsA7QcAMH251baCcREAQVILLa2QWD6m4WcAywoABXSp20oG+t0JAOpIAFB/WcFblvDwAszmkKuqhvzfCckpBwB9mcPAAKiOJvvSCdEHADtWCT9bYAOyudsrIq9NaF2IkBw6ABeOBu/bOdDqAJEmCxanJP3/kH4lAMhyog0hieQ0AL6bCWGmK1FCsKxjAI9mpc6+kBJSAFnkCl5wEO79kCgVsMLCkcoCOfFPAMsbAGMPAcioCffPALoDAIB1Cs6tq5nvu5oBu6oju6pFu6pnu6qJu6qru6rNu6rvu6sBu7sju7tFu7tnu7uJu7uru7vNu7vhu7AQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48ePIkytffjKPIgfMo0s32cgfCFYlMEzfzl2jJ3/g/R3/UJO9u/nzDRMxCM8ez5YpENDLn/9vEfv74LVIYUO//3Yy+AXozwajXODfgciN8IKAAlqwyyEdIChhcHowaKE/IWAix4Qc7pbOhRcyMIYw2nVoomwNHADiilEIEMqJMLZGzYo0+mMBGFTEqONp89Toox+0NLDjkKBF4eORPRgTA5FMZobDkVD6kwIdljRp5WTQRBnlA+D0ceWXjX1wiDs7aHnkAGCmyRgGZ3BTppkgvqHmnIthUIIyKsIZICR09rkYB/G4koGe7Onh56GKxUDEOoQWEh+ikCKWBScwmClJpJgihoEwY6znYxRCZiqqYXJgEkKN54yqqmEY6FENiE20/7DqrIX1UcsJDFZA666ExTCNkfehMASvxArWAC0bsFdKscwKdkYlNubR7LSAiTILtdhmq+223Hbr7bfghivuuOSWa+656Kar7rrspslBJ+3GCxUvR+xgirz4KkXKgv6Mke+/RIWyyX2fAGywTyWAgN8EcRzs8E0NPMLgOhE+bDFMdghyYTkXd8zSIauA+AAOHpdcUgdl1AiABya3/NEVr/r4hcs0a4QFIlHKWfPOE31igZZRLMnz0Axx4I6eYBCtNEKJaAxnD7IsLfVANOAMJxAkTD01PPxqiYIIWk+tjp7e3BL20h4QouceFJytdCJ+wLnDIW4rzYYZcApSZd1Ds/+Qp5Z7hMr3zpT87PUvgw9dD5wA8Jf4zhLAaYIPj9fcgDRwClD5zgKYqQQcm+/sgTNR4pJF6DyPMMOZQqO+cyiF1KiB4K7v/ITVFjLQSO1L8/B3gBMIw7vUVEwgoArPDD/1MIazl4PZyk9Ny32CGBi91q+ERwbL14eNjz/K0N791MmMb/756Kev/vrst+/++/DHL//89Ndv//3456///vz37///AAygAAdIwAIa8IAITKACF8jABjrwgRCMoAQnSMEKWvCCGMygBjfIwQ568IMgDKEIR0jCEprwhChMoQpXyMIWuvCFMIyhDGdIwxra8IY4zKEOd8jDHvrwh0AMohD/h0jEIhrxiEhMohKXyMQmOvGJUIyiFKdIxSpa8YpYzKIWt8jFLnrxi2AMoxjHSMYymvGMaEyjGtfIxja68Y1wjKMc50jHOtrxjnjMox73yMc++vGPgAykIAdJyEIa8pCITKQiF7lCICTgkZCMpCQnCclYMPIvBSAUAS7pl0zqaZOc5Isn4QTKUOpllGYqpSnxgkotqXKVdmlllF4JS7rIEkq0rKVcbnmkXOoSLrz0kS9/6ZZg1miYxGSLMWmEzGSqZZkraqYz0QJNEElzmmap5oWuiU2yaNNC3OymWL7JoHCKEyzkFJA5z+mVdAZonezkijvxA894amWe96mnPbGC/0/26HOfVulneP4JUKoIFDwELahUDuqPhCoUKgx16EOdEtGJlqWiFh0LRjMalo1y9Cse/WhXQkqnDnQiG9KAxQNJ+qU2wAEUAzAeeFqxUk2CqQOoIII8Yicg6zGQpToKQxBSsKJhOBCoOjrViqxxVJteyRU0EkJTP/klY9AoBFMl5ZegUKN7/dSpVhpBjdDQQKTqqBU00txXqfolINBoDWUFq5WqsyKarlWrXzoDjRggqwWaNUZXqBHJ/CpXKylsRae4ayrTpA0aSUCxrkxTKWhEBsjOMk1uoJEtLIvLNPWiRn1N4F9jtIIaoYKwbAUT7i5kKAWONkaDYCZq8QqmLf/QaByzXWyazkEjZ+Q2smm6B41U8NvLpokNoHVtYa1EAU+B6HSiXa6VikAjZCg3tWDSBY2ycV3agkkeNLJBd3WbpkvQKGnRxe6XTkEjXYwXuGkqAY0i8V7jpokHNLJAfTurJhnUqA3p9S6YcLUiHgSYvGnKAY3OcGD4pqkYNPJFg+2bJrWtyJIIfK2OeiSgHQCgGCZghc4OqOEYiSAA8ygHF/QghiyEokRxVa9It1LiGUNUuja+So1z3JQd83gpPv5xUoIs5KMQuchFOTKSh6LkJQelyU7+CZSj3JMpU3knVr5yTrKs5Ztwucs1+TKYZyLmMcekzGZ+CZrT3JI1s3n/JW5+c0riLOeT0LnOJbkznkei5z2HpM9+/gigA92RQRN6I4Y+dEYSreiLMLrRFXk0pCci6UlHpNKWfgimM92QTXN6IZ7mYwcQQOpSm/rUqE61qlfN6la7+tUIqAOOJ3qIA9j61rjOta53zete+/rXwA72AQYl44wqgFDITrayj5njYy/72dB+tkR/6exoW/vaFP5otbHN7W6X830YCEUWxKAHLpRjHgEAG2227e12t3vaU3sDK0xQDAC8KUDzqA273c3va4MifbGgESH03e+CYzsCgMjH+XxBo2IQ3OAQh/YCvvAB8+l1RTl4eMQ3ruw66GN8+F3RCTTO8ZLryQnQ/41eG2okg3Wb/OV6gkEJute8Cxl4NvuGuc5plIFPQEd5kaDRzHG+86IfaeLiQ512Eetyozs9qj51HRhodImmP/3qFjpCylFnAxrJw+pYDzt+YCCG2mWjvWAXu9rBEwEuuA4ZNCpC2teudgZwIul8y8Je2yabnNNd7EIYVuVaUCPHxcbvfw+7F2qwORXQ6B5ET7zkQwCFypFuRanqu+Q3H4EqPIpv46DRFiK/+cQ/YA8/rxsBaDQI0pc+8UuIetgqtCJEzEYGBsi97nfP+977/vfAD77wh0984BMhAt72ggvqhooareBcmuiBt1XA4LMRnka9QBc9ktXtCVzqbLagkf8b0kWCNXh7AY/A+9AAtKJlpQsDZXhAtxmQhtYtLXIr0ga7ZoH8bkNi+VLDXisCAu2iCNLXbTBwA1LzJDRyBe3iAtzHbSmQCUvTAs51IdXHLj7gChdobQtgA+rXMmi1IrsTLw1QBgvgbWuQNUNjfisCBPnSDzLFbRuwITzTOXX1LywALNyGCFPAM2hQIyPwL3GwOt2WAuNXM6ZQI5X3LytgBednA3znMkoFIsZgMA1ABynIbQxgAs/nMkJAI67gMItAYDRIDy5jDVf1MFBQhdgWAjliMsOwIikQBGHwMEhghNyGAknoMRfAIIUgD0SAChVjMTJQAB0YbRkgBVN4MSP/6A8TMACgAAdJQDMcMFneBgRD2DGwIA3Z0AmFyDNVQFTdNgl28GktAQWHxW1aEIeoqBJ3oIfYNgGU8IorEQNL4G0ZgAkwZosmQQFGkIjRpom+iBIOQARmiG1+cIrFeBIJ421FgAXNeBJIwATepgTqNo0kkQRj4G0PcAm9qI0gAYzCCG2EcIfiKBIOAAjJeG16k44jUQJN4G1aII3wGBJsYI3dBgKJcI8hcQEDg20L4Hb+GBIcYARbGG17UJAj4QCv0H/PJgQVx5Aj8QaOt2yMwIIUORI1oGDJBgJIsJEm0QbdSCgRUHYiaRIesAUJuSVEkJIoAQGjAJFQIgGfB5Mm/7EP9+YjVtCIOGkS/OCRNXIE9veTJ3EBsXVVAGiUKoEArNCSApICLMCULpEKXRMgD5BYVOkSaDCPAmIDN7mVK9EHQskeaRCCYnkSVwAt7LEBLZeWMPEBauApMLCUcAkT+4ICP3iXMwEH2ciXgBmYgjmYhFmYhnmYiJmYirmYjNmYjvmYkBmZkjmZlFmZlnmZmJmZmrmZnNmZnvmZoBmaojmapFmapnmaqJmaqrmarNmarvmasBmbsjmbtFmbtnmbuJmburmbvNmbvvmbwBmcwjmcxFmcxnmcyJmcyrmczNmczvmc0Bmd0jmd1Fmd1nmd2Jmd2rmd3Nmd3vmd4Bme4v85nuRZnuZ5nuiZnvJRPrHZAOCFD7DZBeznD6/gmhfgNOFBC6x5C2UJHhZgVKn5DBe5MK5YmsIwgwFyADdHmo1QjuyBCE8wmg2gATVSCC8CmjEwAEcyA5vYmVmAC1HiDNyzmXCgBGaiVpqJg1oiDWgJmT5gAnDyWJrJBgAAJ/Wwmb+AAmZiAbWYmQ2wB3ByAFOZmZaAn1FiBoZ3mYewk1DiB/2ImRQApHBCCCNqmbfgDXqiDpopAjpqJi8AD5lJAm4FJ4hAA5kpCwdoJoLwpJg5dXDiDhywmTHAg0diAQXTmW8QJYhgj575BUdSDQ4Imh5QozRSBqH4mTggfxeyCnT/U5rlcCGCwIyl2QGMIiDpl5pxgKDgAQJDp5qfcB+bcKGsWZIvQAqwaQo7cAS8IJudEKfq+aqwGquyOqu0WqvNOAuiIJt58DOVkIGtiYngsQFBwppD0KXsEQXTUJSlWQEMcgK14CWm2QJeaSHVoAfh+Jm8dVUaEpoNQKcrIiIk4pmSYCYwwAlbd5kQwFNwsg5EIHiWSXvIlgGuEA+uOpmQAG0HoAzlAZl5em07wA1ncK2IqaHdtgPucAgTmZh9AA6K2m3Q0JiWEAykiG2D1ZgxYAxpCm1RIJnHEjfQlm+USQVgUHOEQg2XGQoC4K1acgAt6pib0ilwgl6bWSpu6COtgNWZHXAIu0BsNPICHfqZFzAKEXghlVWabCAFWnAhi4CaEDAFW4AHAcIAbIqadqIGCcAenvCadsIKClOCsOkAiiAttjq2ZFu2Znu2aJu2aru2bNu2bvu2cBu3cju3dFu3dnu3eJu3eru3fNu3fvu3gBu4gju4hFu4hnu4iJu4cRQQACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrX868ufPn0KNLn069uvXr2LNr3869u/fv4MOL/x9Pvrz58+jTI8Wmvn3uMI4EdcPgvr7sT/7y93gnw75/1gDkJyAKe8zx34GllSDggv48kA4vCEb4mRUMVpjGMxJmiJkqDFToYRA3aCiiZKV4aKI/1ZQw4oqLtXDAiSd6EiKLNBJGBIw4BqFIjTz+xQyOQAqhQ49E4nUGkEgykM4TRTYpF4VIIpmBERc4aeVaHEap5QHGfHDll2XpcYKWZBbhC5hs8QIBixeIEwWZWnpCA5pnJaEGA27U2AAlXsAZ5Zx0itXBKC/6E0IYPZ6xiZ8wBhGoWIocwSAoRYqyTIeMLvgAhI961YY7Hr4gR5NxaPBApvnN06lXkiRw4hpWzv+xhQWM7hDDqlux4QyQLFzJx6xwfoJrVhRckgGSXnTwJR+mRnmEssNa9YwTZFaB5hPSYAqjGNFW1QId2kapwgp0/lEAjLB2O9UUkWQqwaOK5OJhBKOqC5UHe6DqTwZ3dBoNLgxiYi9UveSgb35CrNoAKa7600MLAzeFATQLHJwfA2zgesE8D9ASMVM1QGJxfs4MGW2/HytFxJgW99BNyjATdQGUBz/ACaIx5/yTLG9arEsWOgfNkwOXVHzwDrMIrXROH1QzsjxJLC31TdwcbAs1U2dd0wczZMoAHRBrLbZMcaDgZw6GjK22TLSQyYAEHqwtN0xVI1lI2nPn3RLXQJr/E7begKsURwonhjBM4IivJIKJVlSZ+OMoacDgCURAbvlJXTAi4Aw1XO55SWwQbo6Xn5cuUjfxmK766qy37vrrsMcu++y012777bjnrvvuvPfu++/ABy/88MQXb/zxyCev/PLMN+/889BHL/301Fdv/fXYZ6/99tx37/334Icv/vjkl2/++einr/767Lfv/vvwxy///PTXb//9+Oev//789+///wAMoAAHSMACGvCACEygAhfIwAY68IEQjKAEJ0jBClrwghjMoAY3yMEOevCDIAyhCEdIwhKa8IQoTKEKV8jCFrrwhTCMoQxnSMMa2vCGOMyhDnfIwx768IdADKIQ/4dIxCIa8YhITKISl8jEJjrxiVCMohSnSMUqWvGKWMyiFrfIxS568YtgDKMYx0jGMprxjGhMoxrXyMY2uvGNcAwUEBJAxzra8Y54rGMs4oiXcx2MAHy8ix/1BchA1mWQqCqkIeeCyEwpcpFxaSSjHgnJt0jST5SsZFsuCadManItnCSTJz+ZllBqaZSkPIspo4TKVJZllUhqpSvHAksgyXKWYakljm6Jy6/oEka87GVXfnmiYApzK8Q0kTGPmZVkemiZzLyKMysEzWhWZZoMqqY1p4LNBWlzm1HppoC+Cc6niDM/5CxnU87pj3SqcynsdOc7kxLPefrSYvK0p1Hqqf9PrvCzn1r5J0CxItCBWqWgBqUKQhMqlYUyFCoOfahTIipRplC0okq5KEaRotGN7hOfHg0nSENqzpGSdJ0mPSk8U6pSerK0pUfpKEx9ItOZ8qSmNtUJTnOKk53y1CY+/SlNgipUmRC1qDA5KlJdotSlsqSpTlUJVKOKkqlS1SRWvSpJsqpVkXCVOxS4hSzYIQA1bAIA6kDfV6mTiHAAAhbLEEQITAQEtb60PeyIkifs+scDQSFKPeArIQ8UhygtwAHnW+t0uqClKyT2ru1xRJRMVj7FTidASHrDY/t6oAFEKU/ms6x0wBClemx2sAcKRpRscNpEIkgcUdJAax2JoCr/RKkAs50kgn4RpWPkFpMIYkGUmPHbTiJIB1EKQXFFiSA7ROkFyz0lglagJdKRT7TS0ZLjrgvZyEbJQJXtrnp6BqQ/hFa86TEYkqhwXs4eaANRkkV7UdvZKMFhvq5F0DailLrwuvc/JoiSCPBLWwStIUpJ8y99/yM5JP2AwLpFUIOB9GAF5/dAE8YRKSAMXATRIUoV4LBxESQBEIuYuSQ28VNEEIQWB0EIJoixjGWciYFhNzolRlKIn1KBKL3LXjeGTiZmTGQhuDgIA+axj22M3t31GEk/VleQH/dkINGByf8VHilii+UFC+8HXAZyk3UHZiTJVsxZDt4popQuKY85/3eLQ5IJunzh4cUjStugc4GJB4coDUDPESaeLKK0AUB3mHhUiFIODD1i4v0hSlFgNIqJN4coOULS0i3eBbSEaVYa7wNaIhdtOoCAUpv61KhOtapXzepWu/rVsEZAHd6cuxdEyQ61OcQBds3rXvv618AOtrCHTexiG/sAx0pz8OaKJMrKRgEji7a0p73L4/0ISb2iDbSpze1uRzufrjtGlH5Rm217+9zonjTxdGktbaf73fAu5vEyDCNxlDve+M43uFtngygF4975Dni6KWW8ekQJDAAXuMK5HQFA5KN4bvBzwhdO8Wgv4AvWDd4bogSAiVf84wergz6Gh1wkXdrdIP9P+cGcALTgXUFLXUC5ymfOKBioCHgOMBqQ4iBzmvtcSxn4BGJ/14MoQaHnP086ji7egN95IkrsQLrSp24iIWx3d0AwUQgEsQxYACIciZA61ce+oCO0fHfqAMAm1CAAdsjiFhTYjbnJTvcFwYBbvZx73fceAS7kfe+AFxADONF0V+o98HUXwhAMj/jGe6FzpDx84+kegqN/UvKTJ3sEqrCmSmI+82N/wB6GvsjPg37sS7g6H2VggNa7/vWwj73sZ0/72tv+9rinPREiAG8vuKCrLtFE0d+tgjMAvyX0gO+7JyCJ47OEBAd+9wIeUXjnowQDZThVuhmQhltZPyWz4P3/uyHx+++jRBHDTzcMZmR+k7hA+elOQY3bbxIfuCJc3l6ADapPf5E0oAw6h25rQAL9VxL9MAHwtgH1UoAiwQLkhW6IMAUMOBJx0DXvlgKgNYEgsQI0g276F3ca+BENQAcB6G0MYAKiFoIesQgsk24bQA8q+BFQwGzpFgLsFYMdgQQWmG4okIE4qBEyUAD4120ZIAUg+IMZwQElAm9AMAJIuBFVQDjvNgm49oQZAQUgAG9acINWeBF3sIPoNgGU0IUYEQNLAG8ZgAn0QYYVQQFGMITd1oRsWBEOsDLw5gdVOIcTUQJZ+G5FgAV6SBFIwATwpgRJFogRkQRjAG8PcAlr/4iID+GGcMhthIAzkOgQDgAILYhugmAJlwgRJdAEWgiIn+gQbECI7wYCYVeKDXEBi+KBfseKDsEBRlCC07YHsggRDvAK4kdtQpBxudgQb6AC1MYIBBiMEVED6jUyIIAEyDgRbbCIFhMBePeMEuEBW2CLZPIAlWONFAEBo9CLfiIBneeNFLEPO8AoVnCE5kgR/LCMzuJ97WgRFzAIWhIC5TePF4EArKCNDJIC2aaPGZEKtnYiD3AKAskRaCCKJmID5ZiQGdEH8CggacB/EJkRV1AJDLIB/XGRHfEBd5IfMJCPHtkRpPACKCCBJQkScHCIK/mSMBmTMjmTNFmTNnmTOP+Zkzq5kzzZkz75k0AZlEI5lERZlEZ5lEiZlEq5lEzZlE75lFAZlVI5lVRZlVZ5lViZlVq5lVzZlV75lWAZlmI5lmRZlmZ5lmiZlmq5lmzZlm75lnAZl3I5l3RZl3Z5l3iZl3q5l3zZl375l4AZmII5mIRZmIZ5mIiZmIq5mIzZmI75mJAZmZI5mZRZmZZ5mZiZmZq5mZzZmZ75maAZmqI5mqRZmhwUDy/DlB9gDv6QAhmjlDWwg4wQc0hphwtyZkU5MybikkE5DDRYISngjEHZAqyJIzMAjDtpCIUQJdzgkx4gAZNoIh6TnBOJJCjAczj5LdFpnMgZk9RgCwfTnDT/mQTyMDLV0J0eOQvpeDALcAmk95JZoAsjEwXyFZNhwAnadzCNI5PdkH76QjnTgzLDogO7MjKQAHnRQwsPMA+qRydssJ1a0p6PCD0tMHwJQAoWiSZCYDE50AvVgwkMggvR0Cl3kGyZsgdxQz1yII4Ckgs7Eig55ieRoJLVE30mUgDmhSYrQIxuAzbXIwZAwgDSwCRgYlta4gQYcj0dIClI8gAawAdf0gF9AiQZcAnsWD34QSYWsAVQaiXChSPO8JrYEwPrCSdbCl5NYqMVkgDNtz3zoC9Oip1EIgcFySDu0Abcwwv5iSoMsAyiUCSgwCBH8KLcEwTTtgnGxyNhwGwH5jAK0MI9ONBtXkAJGaohbsAAahA14EMDT8dtUSAODSohEMAp4+MLRdBtJ6AHL/kBxlAo0sYAqhCTF2AEJmoxVkCTT5AOEBoliUqTOrCh+kJcOKkIhpop3ZiTN9CpZHIAf6OTJeA0WlIKQHkDxYojsCqUz5AGOHKrRMkL6bCnC3JzRTkHe2A2C9JxSSkD75B+wrKUGNANguAIlsiU7GGa9nqv+Jqv+rqv/Nqv/vqvABuwAjuwBFuwBnuwCJuwCruwDNuwDvuwEBuxEjuxFFuxFnuxGJuxGruxHNuxHvuxIBuyIjuyCRkQACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrX868ufPn0KNLn069uvXr2LNr3869u/fv4MOL/x9Pvrz58+jTq1/Pvr379/Djy59Pvz58HSY+2d/vmUYBf/6Y0QB/BF5GBRkAJihCgQxG1ksQCUbIDAQNVqiYDlZEqKE/wljoIWEugMHAhhr68eGJfmGjxgMkkngGijDe5QMmJ7TY4jYnDhjjXB0QAYKNQNLgYShRoEPBjnAh4wSQTLriYS0A4vILkmxloQ2TWPrDRoU1sJigLp1QedYKdHiZJZDyVJjhhu6EIqZYEGTy45lYPmAHg5rY6AgpHbzpFQ650ElnFQyuw+QRmvi5lQd4CIolA2DwwGA0Z4LjpqJY2eOojQ+AU0ODDeBCpyOAOICpVRAEummED2jwhIU/bP8qSB+nVoXKAqv6A6kLHq7QxKoPSPFBrVMZsWoaOpwISq4AFiILsVGNAIOgQfSCIh81MgugBitA+xQtZx7xTYzuaBuhFi962xSEQIYgSZ8xRhOIuRHW4oO6S9WQQYsTWNOCmB+8owS9AEYyBb5KLbuhMqZg2kYtuBKMDsJIdWFGhJBgAS0v29CbASoUI6UAgE0sQqG6evSgrTghJ0XMPCSEHIYN+256jKktH3VyzjUM4igKt+QsNFPdzJnlIkMnrVQMGmS5hNJQJyVLIUDicWnUWBP1gRRmathh1mATJcoRbIZt9lAUQGOmGSOc7XZQNCzJwMFv1+0TBzbYYPfefPf/7fffgAcu+OCEF2744YgnrvjijDfu+OOQRy755JRXbvnlmGeu+eacd+7556CHLvropJdu+umop6766qy37vrrsMcu++y012777bjnrvvuvPfu++/ABy/88MQXb/zxyCev/PLMN+/889BHL/301Fdv/fXYZ6/99tx37/334Icv/vjkl2/++einr/767Lfv/vvwxy///PTXb//9+Oev//789+///wAMoAAHSMACGvCACEygAhfIwAY68IEQjKAEJ0jBClrwghjMoAY3yMEOevCDIAyhCEdIwhKa8IQoTKEKV8jCFrrwhTCMoQxnSMMa2vCGOMyhDnfIwx768IdADKIQ/4dIxCIa8YhITKISl8jEJjqxM0BIgBSnSMUqWnGKsXhiXv5jLgJoES9c1JYXv2iXMDJrjGSkixlzhcY0ymWNq2qjG+ECx03JcY5uqaOj7ohHtuhRUHzso1r+SKdAChIthDyTIQ9plkRmaZGMJIsjsQTJSIplkkyqpCXBgkkgaXKTXumkjT4JSq6IskWkLKVWTkmiVKoSK6zckCtfaZVYamiWtKSKLSOEy1xKZZcJ6qUvoQJMAAlzmE4ppj+OiUymKJOZzVTKM6PJSXpBk5pHmSY2u6LNbW6lm97MCjjDeZVxkrMq5jznVNKpzqiws51PeSc8myLPeS6lnvZMCj7zmf9Na/Lzl/78JzEDKtBkErSgzjwoQqWp0IUiZZ8O/QlEI9qTiVJ0Jxa9aE4yqtGbcLSjNfkoSGci0pHGpKQmfQlKU9qSlbJ0JS59aUpiKtOT0LSmJbkpTkei052GpKc+/QhQg9qRoRJ1I0Y9akaSqtSLMLWpFXkqVCci1alGpKqB68YjGjELZNDgFvcSGlYBB6UNvaAH3qgDODhhjDB5a6x/I8SZsqEuuPrNZ1nyRV0bCjovnOkNe+2i6bRwJhwEVoymS8GZePVWvnqOAnQawmHPWDoS0GlnxLIr3+ZwJhTgS7N7Y8OZVPBZx3auE2cKRGkFS7obnIkcq0Us6Q5xJk//xJaypKNUlnA0WTaWTgRnMsFtfUs64GZJuL2NY+kAcSZlDFe59QnDClaAjTnMgRd/+IMibnCDOz0lVlnSwHPtOJ+mZekHUAEvlsSbXPLKx7xYQu9T6nGmWox3j/MBxplY9pQKnEkC9wXkfCRwpgpAxb9ZAnB78SsfAmfJwP39b4ALOeACH1jCCxZwgy0c4QRPWJEVfvCFPZxhCm9YxE+ZxpmA8eFHzqesWKpHes/E3sayNj7wZZJ8naJeJtUYWqBFTo6BtOOm2IG7isguD6yLjemGIWRBPo4yzgSI4kXZOCY404KId+XiZDlLWx5el4nTsSxFw8qmVY8nznQINN8Y/z7kONMN3Czb+MwrS24Vc5rTo4IzbYnLe0YPCs40BzrjFj4QoFPMKNYBBDj60ZCOtKQnTelKW/rSmM40AuoQaPMMgU5HotghDkDqUpv61KhOtapXzepWu/rVB6hZnd/jgjOloGUjI5iud81rT8oHB2fSAq57Texi7/qa2XnDmbwwbGM7+9kMho8vzjSIZkP72thupXyycSZCWDvb4MY2srHTCWNwAhx18EYPXkAi+4Ys1+GO97NBUSAf3KIXyJhFIx7RjW/L+9+8jgAg8kFNeAP84LpewBeG1UyDI/zh5qqDPhoO8YrTywlZQKbDLc5xQcGgBMPceMdHjqUMfAJnr/8UOclX3iKF60iVKme5zDUkhAukfOY4B9IRMl7KmOcc5zAQQ89/TvQNRYALoPR50WXOAE68/JBKX7rMhSBZRkZd6iz3wqegjvWu+yMEUOC617EegSpgNo1XHzvJH7AHlKNd7V5fgs3dKAMD2P3ueM+73vfO9777/e+AD3zfiRABbHuBsVYliSZUdm0VpCvxI6HHBrA9AUlAniQkWAO2F/CIp1/eIxgoQ9eMzYA0xODzIplF4a8NCcSj3iOKYDy0YTDn13/EBZO/dgoyYfuP+MAVI4L2Amzg+d5jpAFliBi017Bo42+kHxPA9gbk4HyOsCAK2EYE3aqfkTjMANspcAP/9zWygjUJ3wahHr9FGkAH5TubASbolvovsohsQXsD9Jj/RaAQAmyHgAr6ZxFI8H3XhgLiF4AUIQMFEHzPlgFSkH4ICBEcUArZBgRtE4ESUQWKdW2T4F0YCBFQYDTPpgUA+IEQcQcECG0TQAkmCBExsATYlgGYgAEt6BAUYAQM+GwWWIMN4QBEYH/P5gceyIMKUQIi6GxFoDFEuBBIwATYpgRhtoQIkQRjgG0PcAk0KIUIcYM56GyE8GRaeBAOAAhA6GyCYAlhiBAl8CvXpgVKmIYFwQZOeG0gkAhwaBAXsAnCh3R3aBAcYATu12t70IcI4QCvsHq9JgQMR4gH8QZ9/8ZrjNB8jHgQNZADuwYCSDCJC9EGVUgvESB0mrgQHrAFgegoD0AEodgQEDAKiLgpEnB2qZgQ+7ADq2IFEBiLC8EPligoR3B6uPgQF4BXWRICrveLDYEArFCKG5ICLGCME5EK7MYpp+CMFIEGbEgiNgCL1OgQfbCLGpIGxbeND3EFlaAhGyAD4mgRH6AGwQcDxZiOE0EKL4AC2wePFgEHUWiP+riP/NiP/viPABmQAjmQBFmQBnmQCJmQCrmQDNmQDvmQEBmREjmRFFmRFnmRGJmRGrmRHNmRHvmRIBmSIjmSJFmSJnmSKJmSKrmSLNmSLvmSMBmTMjmTNFmTNnmTOP+Zkzq5kzzZkz75k0AZlEI5lERZlEZ5lEiZlEq5lEzZlE75lFAZlVI5lVRZlVZ5lViZlVq5lVzZlV75lWAZlmI5lmRZlmZ5lmiZlmq5lmzZlm75lnAZl3I5l3QJFXnDARA5BSPiBELSkCNwMQDyANBwiwdZLhpyBKKgkMLQIsGyiAQZCo1iI85ikDC4Xr4YkItAJyDQbwB5C4MmKIOwdTmjjarjAMewKhlgA2CIMCQwD8QQO+KgLT2gB/jiAIvAhgrwOqgga8yyDbwALVgACRFiBl3gOuiQcLXQBphiClO2IfTmOlMQCbqmBO/gmDHSAtYQfSSSAaLJOj4AY/QSCGf/FiMdIAn9ByRBEDtnQFgE4w4x8g1kkyW0EDsrMGSrcgJ8gCIP4nEXCDtToy3P6SE6kAarYgSzszWjdyZNIH8VEiJdSCcLADKz0weCsClFViBPoAEJ6ii5QJqsM4aOQCe4EI71UQPgsKGrYg+2EwrgcCbjSSA8ICK8hgcecDuaEJ82sg4MUgXElguGhTsdQAoh2iKJUiB2gKKrAgKZ4KGzEwqGqSFWUCHyQDAPQAcM2judoAus0p0EIlrmog08Jzy/ICr+4G4V4grMwgTIcDwUgA5RcDUNQgNJWgXwgjwkSiBldiYngAlh5Y9ncCYPoAbYMJB+wCS7UpCLaSNWkCwGagkBzEAi1aKQxpUgZFCCCtkAgFkAfdmQn2ACjFqXoBqqojqqpFqqpnqqqJqqqrqqrNqqrvqqsBqrsjqrtFqrtnqruJqrurqrvNqrvvqrwBqswjqsxFqsxnqsyJqsyrqszNqszvqs0GqTAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c+vezbu379/AgwsfTry48ePIkytfzry58+fQo0ufTr269evYs2vfzr02hDdduov/h56IgC1/IsarTw7hkJUH/uIPWE9/OAl0geLrj3+rvn/eOqhxwn4ESvHfgd4lUw2BDPqDSAcIRuhaC9ng0uCFh0ioIWqhYLLDhSCuseGIoj2xhQUgpphBGyS2uFkW0sCX4oypuGhjZaGYMOOO8TFz44+RNWAGjzz2AuSRjb1C5I7cIOlkYh8gsmSKSoT35JWE/TAliE0YgOWXgX2gwpYEBtENBWCm+VcjZPqDByx3qCmnXy3gMeUk7HAw5559GcOjBdIYyeege62QQIpNXHIFoYzuVcGFAHDhQaOU5rXCAQQWAwcElXaKlxT61XGDp6TeNYQju3RS6qp2ycDqq7DG/yrrrLTWauutuOaq6668LoWMD70GS1UWL5gxhbDIOoXBBvqVomey0B716H7MqBrttUH9kQGDGbzDKbbg6kQBsxcOYkq46NoEzYx43JPuuzB1IuOMXzwL770nUXDEkhv0h++/I5WxpSPJAGywRzQs0KYRDRzs8EUcONFmfIJY8vDFEj0ysX5NyILxxw2JwsTG8S2ADsgoJ8RBKQyQ7A8QLaQsc0FTnEfyfDPn/I8P8my8gBg6B+2LI22SEvTRqniypTtHN40BJi3zuI69TQd9Bgg7hnBu1VWbokuKFjzD9dgdgHrhKWOn/Q8yqzAIjNpqP+HFfgNgALfaXYARny0X3P999zlK6OC33zEMbvjhiCeu+OKMN+7445BHLvnklFdu+eWYZ6755px37vnnoIcu+uikl2766ainrvrqrLfu+uuwxy777LTXbvvtuOeu++689+7778AHL/zwxBdv/PHIJ6/88sw37/zz0Ecv/fTUV2/99dhnr/323Hfv/ffghy/++OSXb/756Kev/vrst+/++/DHL//89Ndv//3456///vz37///AAygAAdIwAIa8IAITKACF8jABjrwgRCMoAQnSMEKWvCCGMygBjfIwQ568IMgDKEIR0jCEprwhChMoQpXyMIWuvCFMIyhDGdIwxra8IY4zKEOd8jDmQAhAUAMohD/h0jEIMaih3YpgMv8QQAk1kWJLmuiE+cCRZJJcYpxqeLGrojFt2hxYlzsYlu+2KYwinEtZCSTGc+YljRuaY1sPIsbpwTHOJZljkuqox3Hgkci6XGPYekjj/4IyK8IckeELGRXDjmjRCpyK4xMkSMfmZVIgmiSlLyKJS+EyUxWZZMN6qQnpwJKBolylFEpJYFOicqnqHI/rGxlU16pn1jKcim0jI8tb5mUXDKRl17x5S6BaRRhEpMrxjymVpKpTKwws5lWeSY0qSLNaUqlmtaECjaz6ZRtcpMp3vymUsIpTqSQs5zFXOIw0YmTc7JzKO58Z1DiKc+f0LOePbknPnei/8995qSf/rwJQANak4ESdCYG5doHlOAHd0xDAUiwG64SWrU+cMsJJsAEPK4RhllRtGnC4JEWwBCrjx5tGkTC2atMGjQNEEkNJVXn5JxBpJPBiqU6wxqPwhHTKErOA0tiQ0+tKLkaLAlNN5Vp5L5BpCjICqczIwKRivFUpUJOYDySRlV9GrkAEAkTWyVq5IpBJEmEdYuSsxCPqHFWMEruBUTKQlvLGLkhLIkEc1Vj5HhBpAh41KqOKwGRCvFXrj4OHkTSRWHF+rhYECkAi0Ur5My2oy9E1q2Q4waRKnBZukLOCkTiQmf1CrljECkao31j5DoRjkzEAhNbCMAmJhEIov/pB2h5Ve3mOpCEO/QiZrml40HTadjhCgWqxkUJcpNrkuUylyTOfa5IoitdkFC3uh65LnY5ot3taqS73sUIeMNrkfGSlyLmPa9E0qteiLC3vQ55L3wZIt/5KqS+9kUIfvNrkP3ylyD+/a9AAixgAv/XwPxFcH4VbF8Gz9fB8IVweyWsXgqf18LkxXB4NazBDiDgwyAOsYhHTOISm/jEKE6xihFQB8C28hAHiLGMZ0zjGtv4xjjOsY53zOMDbKu4rVTAEodM5CLn8Uct6MUdkgAhaAnZyFCOMpTXmR0x7McRgZjEJgKwBUzEIhPhsJatnizlMpvZszaKBpGOgSsyn/n/zXC+5I+4QCQrtDnOeM5zLX80LSbdWc+AfjMofvQFIhnoVm4OtKKNHAFA5MNGXuXRERG96EpDeQFf+ICLvsYjePzZ0qAech300aJCEKkEnw61qjfmBLmOKAJE4kWqV03rLcEA1RoiwZKGMOta+5pHGfiEAySUBSK9IFeJ/rWyU4TphiGIGkTCBbKXTW0eCaFvB5LEVKdd7W6D6Aiu9g8mHsttb5ubQDDAbX2kQaQylPvc8PZHBERbH7LyiAjvjve5GcAJZ6snCkT6Rr71fW4h8Ho8FFhSDQZOcHN7YeHiYcOSJtXrhps7BFAQTziIBAJdJdvi5o5AFb6lHXQQyRke/wd5wx+wh2FrRw1E0kDKVd7wJWAbOwMg0jR0JQMD+PznQA+60IdO9KIb/ehIT3rRiQBrOHvBBdkBgxZ4JAzeaaIHcVbBGbQThmvAAxMmcMKP99OH3tGDXG+egFnFgwEkKGAa7vCDEjTdOxKsIc4LeIS/BewRDJRhXmZmQBoKx3eQzKLpb4YE1Av/EUVgHc4wGBXjPeICtJ85BZmYvEd84IqonXkBNti75jHSgDIoDM5rwOvoN9KPCcR5A3JY/UZYAHA4I+JYss9IHGYQ5xS4IfcZWQFo4Qx6pAK/Ig2gw+nPzAATrOD4F1nEgOC8AXpA3yJQCEGcQ0CF61cECbyHM/8Kfu/9icigAJ43cwakYPzyP2RleAbCCNwvkSqkIM6TsAP9IwIFnb5ZC923fw9xB+GXdpQggA8RA0sQZxmACRKFgAtBAUaQfmYmfxDIEA5ABNP3Zn6gfxe4ECXgf2dWBFjwgQuBBCMDZ0qQHiaYEEkwBnH2AJfwgC1YEBJIgWVGCB1VgwbhAICwgWdWMTx4ECXQBHGmBSU4hAXBBin4ZiCQCEpYEBewCW+2APQWhQTBAUawfFG2B1h4EA7wCohnZEJAd19oEG8wJkbGCKp3hgdRAzlQZCCABG6oEG0Ag0sUAepWhwjhAVvAhWTyAPjGhwsBAaMwhlsiASRHiAqxDx//QiZW0H6MqBD8EIdTcgSEN4kNcQGDsCQhsHia6BAIwAqA2CApwAKhKBGpAFcg8gBok4oSgQZGeCE2sIiw+BB9YIkEkgaid4sPcQWVQCAb4Cq+SBEfoAZRAwOgWIwUQQovgAK4x4wWAQcsKI3WeI3YmI3auI3c2I3e+I3gGI7iOI7kWI7meI7omI7quI7s2I7u+I7wGI/yOI/0WI/2eI/4mI/6uI/82I/++I8AGZACOZAEWZAGeZAImZAKuZAM2ZAO+ZAQGZESOZEUWZEWeZEYmZEauZEc2ZEe+ZEgGZIiOZIkWZImeZIomZIquZIs2ZIu+ZIwGZMyOZM0WZM2eZM4/5mTOrmTPNmTPvmTQBmUQjmURNk7maiOOqAE57COF2AzYGAl5ogBOacfXvAE5wgMDLIKyFCOpwAiUtBk4PgMKAIiurA13mgK2jcjILB13cgB60AkDOCA3OgOW+IJqqCNo9AmjuAL2CgGpbgk8gAs0jiVG2ML0eiLLQAELsMAziKN6PCXU8IEoiCNsjCLG/MI1mgJgsBqVFOMDWAEbbIANKCNyWBbS+Ju23gLljcjRyCJ2MgBhbYjDyBm3XgPdpIi0CCOptCJF0IOrtmNEPAOY6cfGfAH5tgJzEAgnHWO8BcfG0CD5jgFZvAC4ZaOPrCVRZmd2rmd3LlCxKiOnbALjv9wcOd4Ay0WH4dGjhAAB/amHwfwfOLoAUQAABeynN94BZdgmQ2SAPDJjb0gDWM5I8awjRwgApMwJXgAXNZ4B7Bwm1vSCNJIAd0QBCSDB2YIiwagnxvzA8XYBUowZIhwoamoWUP2CsXYC0RmBr2oicm5RK4QCsWYCiTzANJQnbfYBsO5JBawBVZ5jXc3JTuACTCajYewJLiQDQqajR0gJTNSDclgi9pIWQxyAmogOOF4Cw0SCOjQhuJImA9gBYcApeEoAv5gCwQAhenYBW8gpt3Zpm76pnAap3I6p3Rap3Z6p3iap3q6p3zap376p4AaqII6qIRaqIZ6qIiaqIq6qIwT2qiO+qiQGqmSOqmUWqmWuo4BAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu7fv38CDCx9OvLjx48iTKy8K4dmjQnmWS59O0oGsLYj8aSdCvbt3jNa3gP/QTt6fkO/o0zekYWR8+fIvwqifT/9WhRzv82v/Rb9/dx+SHKPfgP7I49+BybEgzwQEEriDAwhGOBwEuDRo4Q0SZggcARY2WIqGIPKWxwIdDohLiCjmVkCJA2aR4ou0hcOiftPAaCNsGIQw43u53Ohja2XsWB4DofxoJGp3CKndCSa4cOSTpVUz4yrKCNMFlFiOBk+HByhzSANZhimaBwcMOEE6h1Ag5pqizfPeAnXA0wKbdIYmCnlMpFJknXyCFsQWBvQp6KCEFmrooYgmquiijDbq6KOQRirppJRWaumlmGaq6aacdurpp6CGKuqopJZq6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvssQV5gOyyE41yhBzMRtuQLCQ2wYK02B40RxPkPZBNtuD+48EG+ZnTQbjSSjPgJiOguyw6DTJjh7vGnkFigyA8Q++wcuxQ4gQK7AtsC17MuMAnAvu6jJI2JLyrMUpqBw6YDtuKjQURayeEshXXKoa/GR8TQ8e1PsFExv54QTHJsvpgRcZVsFyrA7AoaYzMt9rzwIwN43wrFGV2WIvPubKhhYUBQEg0rqaQQ2AdKy996wib6FcMx1Ln2gA473nRbta8SkBeIUmA7as4/hRhidm/soME23DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744ow37vjjkEcu+eSUV2755ZhnrvnmnHfu+eeghy766KSXbvrpqKeu+uqst+7667DHLvvstNdu++2456777rz37vvvwAcv/PDEF2/88cgnr/zyzDfv/PPQRy/99NRXb/312Gev/fbcd+/99+CHL/745Jdv/vnop6/++uy37/778Mcv//z012///fjnr//+/Pfv//8ADKAAB0jAAhrwgAhMoAIXyMAGOvCBEHQUEBJAwQpa8IIYrGAsIqiXFaFMOwTgYF48+MEQivAuJESZCU9YlxRmbIUsnIsLIwbDGMZlhkqqoQ3fgkMh6XCHbenhjv9+CMS1CHFGRCxiWo7IoiQq8SxMLJETn1iWKHZoilQcixUthMUshmWLDeqiF78CRgKJcYxdKeOAzojGrahRP2xsY1bemJ84yvEqdHyPHe9YlTyWZ498nIofyQPIQEZlkCA0JFkQ6Y9CKtIpjHTkI5kSyUl+8YOJtCQZMdlITW4Sk5LM1hM4IYwrjKqSZpMEeVrhDnuw4VOoBFsz9LODArxDER/QVCyzxgwLWcATsEDFpXa5NBnMyA3D5GQopVWCGb3NUsQk2jRYtApMRdNna2DReZIJSrP1gEUCsKYywXaFGb1BnN3M2jBmdAF0lhBs0yyRGTJ1TZkFgEW7oOc4swb/ABbVyJ0qzFoX7tWhYegznUvDwYyiA9AXZs0NLGqCLve5NE6waBsTRSjRyMAiCWT0nVKzBYtO8dGALq0FM8JCSR26tA7gQASYWAMTMDagFayUhnHrwC3QkIpm6IJb/ojCpuoJtxgYwqA3zaEnvULUpVKlqU6VClSjCpWpUhWSFL2qVayq1aVwtatJ+SpYjyLWsRalrGYdClrTGpS1svUnbn1rT+Iq153Qta45uSteb6LXvdakr36dCWADG5PBEvYlhj1sSxKr2JUwtrEpeSxkTyLZyZakspYdCWYzG5LNcvYjnv1sR0Ir2o2QtrQZOS1qL6La1Vakta6dCGxjG5HZ/9L2Iba9bUNyq9uF8La3CfktcA8i3OEWpLjGHQhyk/uP5SbXucaF7nClC1zq9ta6usXubbVLW+7G1ruuBe9qxYta8pbWvO7rAALWy972uve98I2vfOdL3/raFwF1yOokD3GA/vr3vwAOsIAHTOACG/jACD5ABvT7SAVw8sEQjjASl+pgCVv4whZeJgsrjOEOexinnuTwh0dMYjNSuMQoTjEhT6ziFo8YFCx2sYwvHAFA5EOTIp6xjh+8gC/kcpI53rGQP1gHfQB5yEjmpBNcpMggJ/nJM4JBCZoM5SorKQOfUNodnWzlLg+ox1FDI5e9TOb3CKGdchxzmdfsjyMwWf/MbI6zfmAghjaqWc5kjgAX4IznPmuHAZwIcxHv7GcvC2EIWSR0obvshRpQUdGLtnIIoPBESEe6yhGoAgQGfelFP2APWo6hpTtd5SWg2T/DMMTIYCUDA7j61bCOtaxnTeta2/rWuM51rYkQgRJ7wUn+iYJ2mqCLZqQCDbc4V+Y08U0Sq+AM/VkBgSzAhDVgQgQ4UPbk6EEuEk9AEvTBwozmVDkSZJPEC3iEoKlzChbZAnMYKMPORsyANKz6O2IrERk0N4tekxgSwPbOIFjEic0potkjhgGGvAPUDiFzcy7o9ohTkInu5GFGOOicD1zBAHTbYN3GWWeJFnClzjWgDAT//fAaSCCdeHYIAKHrB4NIvAFoKWcXLAqA6FggbBIjYgrKMYM/RxeHGZQ4BQ83zgVmhFTRreBlHldTcd4wI1OSrgF0SHmHGWACmxJHACzqAeoWcYISb4AexBECi9aQOijoiMQhoMJwVjH01CHB6CRGQdJ9g4QZTVl1MihAx0ecASlIvTcQZZEMWMeBUqAYCF/jDSpg4QmaEogZr6tCCko8iXn95gOKeEcBQPaeZsAOCu4ZsRbkPhw22MMdrSAPuGF3B7yPeAKUOM4VhMGJJ8guBksocQYwgQHmjoQCRhj8iCFvfJE4gAhlJ7EfPN98kJQg9R8ugkqrDxIknIzEShAB//dBkoQxlPgBlyj++DuCfOV/mBDyWT9HHACI6I9YEGuTP0dK0PAPa2H7+qcRbPB9IwYCiRCAG3EBVfNhC7BnCLgRHGAEWidhe/CAHeEAr+BvFiYEP2aBHPEGKmBhjMByHugRNYAfEAYCz1SCHtEG5sdJEVBnLAgSHrAFE7gjD8AdMxgSEDAKGqgkErBpOygS+0B6O2IFhzeEIcEPKDgjR3BvSigSFzBwLBICAReFI4EArHCD75EC14KFJ5EKL9AgD0BSYIgSaNB/72EDQniGJ9EHTVgeaQBybigSV1AJ77EBi1eHKvEBajB4MHCFfJgSpPACKAB0g9gScCB+idiIjv/4iJAYiZI4iZRYiZZ4iZiYiZq4iZzYiZ74iaAYiqI4iqRYiqZ4iqiYiqq4iqzYiq74irAYi7I4i7RYi7Z4i7iYi7q4i7zYi774i8AYjMI4jMRYjMZ4jMiYjMq4jMzYjM74jNAYjdI4jdRYjdZ4jdiYjdq4jdzYjd74jeAYjuI4juRYjuZ4juiYjuq4juzYju74jvAYj/I4j9qIBOyQi5ZQBP4gDreYBIVAHh5FiyNQMOUxMbLoAcWgH+wCiw2QXwNCDqbgig5wTw2iBa/EirVQIgdAaapoAzPyAPaQihAjJLAQaqJYBRljBT5Aig1AkBHDBL43ijHgCSizAzIoih7/oHYZYwHYwJJcEzE3Y4oeKSTLkIqfwIX64QXkhooKMHMWsgM2p4rPgH36sQDQ1op20EsEgg6wSDUDIg2y2AHmkB8bgDWxmA3z5g9NMAe2yALcsgCygItycASjoItmSY94mZd6uZd82Zd++ZeAGZiCOZiEWZiGeZiImZiKuZiM2ZiO+ZiQGZmOYwBbEAS2GAqpwAjkIQqy2ALwUAdaNw+vSAGHkA5O+R4HcJem2ACHoAxB0yDwgIpdIAzKQHcsUg2m6AImYH87cgelGArutyNlYIq5kDEhoH6j6HJKEg6lmAUoUwCmWCERswAMNYqOx1KjeAMogwttGIoOYIQsMgHyefCFpCgPO3IMkrCSp/gLJZIDFXALqxgGYzggIGAENPCKOlkeILAFsmCSrEgE5IEI/OmfrpgHhfAIz9CdkrmgDNqgDvqgEBqhEjqhFFqhFnqhGJqhGrqhHNqhHvqhIBqiIjqiJFqiJnqiKJqiKrqiLNqiLvqiMGocAQEAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2vezLmz58+gQ4seTbq06dOoU6tezbq169ewY8ueTbu27du4c6dtAeVSM93Ag1/lMOWSpwf+/C0YIby5c6W8UlU6kbx68hLPs2vvOeKXhijWwyf/x7S9vHmZP7ZlEM/eX7Xz8OOnHNC+fQQO8vPr/xirfnsq+wUooEV3+MfeOwMmqKBDABgYnhALRihhQY84aN0BDkyo4YKaWGjdHxuGKKADO3iY3CcipqifMib6E4CKMMIXT4uIxGjjdiNYYOIDptzoo3ObGGiBLpeI4cGPSAb3CnsMePNICUcmKSVwc1gHgzu0JDHllsKR40cF10DA5ZjB4UfmmWimqeaabLbp5ptwxinnnHTWaeedeOap55589unnn4AGKuighBZq6KGIJqrooow26uijkEYq6aSUVmrppZhmqummnHbq6aeghirqqKSWauqpqKaq6qqsturqq7DG/yrrrLTWauutuOaq66689urrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhm+xEPT2jb6hMwFJGFt6rmYUtyKoBIrqkXNFjdATisS+oIG4gHr7yheuBMewewgK+nDYzh3wT+/qupA4Q4OMEUBmeqgYf3NlzpHi1GLHGk5bSY3AF9XAypCzpq7I8K43rsKBrUiaxFCyY7ysIEGi8gQsuP9nKAiRYkQzOkONysMHY78+xzfQcoErSkPdenQidHT5q0eOI2TenT1RXSrdSUYgFzcozkgbWlLFA3yQVfX4qGNsyVrfbabLft9ttwxy333HTXbffdeOet99589//t99+ABy744IQXbvjhiCeu+OKMN+7445BHLvnklFdu+eWYZ6755px37vnnoIcu+uikl2766ainrvrqrLfu+uuwxy777LTXbvvtuOeu++689+7778AHL/zwxBdv/PHIJ6/88sw37/zz0Ecv/fTUV2/99dhnr/323Hfv/ffghy/++OSXb/756Kev/vrst+/++/DHL//8rwKRwP3456///vjHQj9eBRCZeAjwv7sEUIDWIWAB63JABCZHgQucSwMdCMEIxmWCCKygBd+CQQFqcINt6aDIPgjCtYhQYyQsYVpO2KIUqvAsLDSRC6f1DENkCFIx9NAMpRXAJigjHmljVA7/LbRDaH0gZcnJgDZ+oIpFDdFBRXzWN+rDhDLY8FBPNFAUnWUEB/kwHoXKon+22KxWeIgRYXRgdci4LDmYyAZpVKM/2KgsIpjoBnFUIx2TtQYPJQADeaRgthwwNAPtwlBirM8ej3UNE0kCkXKcY7YaYaI5QFKOizRWJTwEACxGMpPEasDWHPQFT2ISWzQwkc4uqUdsUdJCDIiBKVt5LSF4aAOISmR7QDmsb3BCEMjxjwRy+UlvdUEWFagECtgDB2KeUl4duMYoCAGD6pBtloKU2B0yoY5E6ZI9vHwhVr45QHGGsJjmNCE607nCdbIThu58Z1nIGZ5wyjMq9EzgPeH5/8x9kiWfa/TnPOMp0K8A9IEFHctBJZnQsCzUng1NykMjCpaJUtQrFr0oVzKqUa1wtKPjJChIq/LRkZJUpCaVSklTqlKUsvQpK30pTF0qU6bEtKY2pSlOJarTnR7lpj5FClCDapShEpUoRj2qUJKqVKAwtak+eSpUeSLVqeqkqlbFCVazapOtcpUmXv2qTMIqVpiQtawuOStaWaLWtaqkrW5FCVzjapK50pUkdr2rSPKqV5Dwta8e+StgOSLYwWqksIbFCGITa5HFMpYijn2sRCIrWYhQtrIOuSxmGaLZzSqks55FCGhDa5DRkpYgpj2tQFKrWtae1rWkhW1oZetZ2v9u1raYxW1ldStZ3j7Wt4wFbmKFa1jiVq8DCEiucpfL3OY697nQja50p0tdBNShp+88xAG2y93ueve74A2veMdL3vKa9wDr6WdEFRDJ9rr3vTLUKHvhS9/60heiBZyvfffLXw/Kt78ADjAU/yvgAhsYoRfV74EXzF9QEJjBEK5vBACRD4oqOMIYbu8CvvCB9Wb4w++tgz4aemEQm1iATiiZQEt84habCAZA8yeLXUxjA2XgEze854xrzGP2bLgB+9xxj4dsHSFc851CJrKSj6DidCZZyUSGgRiQDOUq24cL7HyylXvMAE4AWZxa3nKPhTAEMIv5zNbxQg1eGGY01zj/BFBQYZvdTOMIVEFMG5wznV38gD3keIF63rOLl3DkAsrAAIhOtKIXzehGO/rRkI60pCf9aCJEQMBecIFqP6KJHghYBWfYtEfoUa8AT+CRouYICfoY4AU84supzggGyhDM/jIgDbKMtUZmcekAQ0LTus6IIjwdYBjgMdgYcUGpAZyCTCAbIz5wBQNabQNYP3siDSjDAgS8BhJc2yL9GGV/NyCHb1eEBeAJMCIYZu6JxGEGAk6BG9o9kRVYQcALsAEF6B2RBtBh2wBmgAlWwO+ILAKJ46ZHwSEChRAIOAQAWrhDkADvAKNg3hJviAwKMG0AZ0AK+874QjhQigIDIYgi/09IFVIg4EnYQTjqyMQdPAcFEAhYCxHPzQWqAwNCjOIaHdDcHSoO4AlQQjdwYA8KKlEBWXThcjFYgoAzgAlA3kYCBnqAIDjxjcpRwAgdB/DJb7NsA0Gocg4gAsL564eX04YEYTdQIzBXApsHuAhYoE0yTESDzCGBCQJWwsxk8wUPTcDalkuCwAL8gEtY/TXuclAlOPf1uPOXEGF4TZU8NHfOOQAQa9+vICzhGkmY6BqfK0ETbp531uwCYn/mHBsAH2AQJGI1GEiAh9YgugsEqb8LwPJqbmAiIoyOA0YAuH330BobmKjco3PAK3pNXyF0mDVH8FArTvcGFdCXEd5uTf88lLF6AxkBdTXIwXtBgITYOMAQZaA9e4aRujYsXo4RmHJtVPEDbaQ3OSdwfajjAVugfAL0AMaXGyMwfqtXAKwDAaNAfSIjAXgGHO/3DK6zDyUiMlYQcim3Efygfi1yBLn2gRxxAYNgIiEAbCbYEQjACgbYHilQMC34EanwAv7xAKdQgyKBBuXHHjZQgTz4EX0gguGRBog3hB5xBZtkHRsgA0pIEh+gBh0HAywYhSNBCi+AAuyGhSUBB4PnhWI4hmRYhmZ4hmiYhmq4hmzYhm74hnAYh3I4h3RYh3Z4h3iYh3q4h3zYh374h4AYiII4iIRYiIZ4iIiYiIq4iIzYiI7/+IiQGImSOImUWImWeImYmImauImc2Ime+ImgGIqiOIqkWIqmeIqomIqquIqs2Iqu+IqwGIuyOIu0WIu2eIu4mIu6uIu8iIYjoA1oYIgXMAn+cAI0GIh5wAjVMQGtB4hPUAjhYTF9mAVFwB7SqIed4H38Ei97qAiFZI3ciIclIG5EE451mAwhYyEH0At2KAIxqDDHCIctoAUCdALBOIdZoI0aYwFXCId98I0WUg52SDUWwnx3SJD+oQF6OAXkyB6EEHt2+DL+MQZJeIcsAJDJ4QxR0ocI6Q8bgHIcWUgAUGh/+AfaaAteQ4jUCANXU4hPwAO9GJMyOZM0WZM2eZM4/5mTOrmTPNmTPvmTQBmUQjmURFmURnmUSJmUSrmUTNmUTvmUUBmVUjmVVFmVVnmVWJmVWrmVXNmVrWEmhHgNFeAH5CCISUAL7lBN1WFJfOgBJfAI3mB5yfEKedgFYnAJupCO7bEJeGgKteYgFgCSc4gILQJGdxgALaIMePgJLbIDEBmHf6AxmnCHhNQij4CHtmQinXSH76AxM2eHVKAx/mOHHCCBDjIAeFgNHpIB2/ADeIgJBhIFGvALgkmHJcAeJ1AJqcALfjgCAPcAnnAJUwCWf9gMlwAFLOOVyrmczNmczvmc0Bmd0jmd1Fmd1nmd2Jmd2rmd3Nmd3vmd4Bme4hA5nuRZnuZ5nuiZnur5LAEBACH5BAkDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrVn2Bw+rXsAvLEXYpTQ9/YmLr3n23zSFomw74G058FO/jyNfyCBCIuHPnGpJLny62xvPrwydR385d6yrsz084/+hOvjzUJeCf3zHPvv3RaemdJ3NPv75PFvGJ47PPv3/NLg/k548J/hVoYEuTCNjKgQw2SFIwAjLQgoMUVqhROwL6g4OFHHYYkSUZzuLhiCQmFIWAdJSo4ooB5GfLJSvGOOIozy3AiDKksECCjDx2iIM/UazRyBRh9Gikhw7kceSSTDbp5JNQRinllFRWaeWVWGap5ZZcdunll2CGKeaYZJZp5plopqnmmmy26eabcMYp55x01mnnnXjmqeeefPbp55+ABirooIQWauihiCaq6KKMNuroo5BGKumklFZq6aWYZqrpppx26umnoIYq6qiklmrqqaimquqqrLbq6quwxv8q66y01mrrrbjmquuuvPbq66/ABivssMQWa+yxyCar7LLMNuvss9BGK+201FZr7bXYZqvtttx26+234IYr7rjkUkAuoeJ44sG5gZYy3BIdsNunA+NAJ++eHhBznRT34jnCAOAB0m+dF3iTHgMKDCynJTnkN8E1Cr/JRhEZhmBJxGzigEeGwzEyAsZpQpECx8RtggHIZzZCMnGFmILymXusHEQML58JQYsZctNAzWg2MEh+C5zDs5ojQJKeEocMvWYiWmAXCA9Ks8mLI88V00bUbZawAHHymIt1m1UMZ8zXcEIjDNlop6322my37fbbcMct99x012333XjnrffefPf/7fffgAcu+OCEF2744YgnrvjijDfu+OOQRy755JRXbvnlmGeu+eacd+7556CHLvropJdu+umop6766qy37vrrsMcu++y012777bjnrvvuvPfu++/ABy/88MQXb/zxyCev/PLMN+/889BHL/301Fcf1QV9WE8ZOv6Qc04o2kO2AXEL1OFLF+EvhgR2KIwjCwTpH3ZJfEWAwkb8hLWSISQ/wAlEAgAMoAAHSMAAxuJZNCCZLuBUgJWBhwDPggXJiMBAB2IHgs4yA8cycIEKWvA5GGRWJ0gmhDg18IPOCeGypEAyWpgQhSl0VsMydIIJeRCG/lBhsnhAMkLI6YQ41CGy/7oxsgzp4Yc4HI4QkfUBNDRDBfF5gQ+QmMQlKssBhoCF/q5jhTkBEYZWbBYPxOEH54jAi0nMIbawkY1NTGBHVAzittaFxiri7y5fRGEY79iWPH5wj3xcix8tCMhApmWQDiykIc+CyJUpcpFlaSTJHgnJsUiSY5SsZFgumaFMavIrnBSQJz/ZlVDmZ5Sk3Iop44PKVGZllelppSuvAssHzlIttbzgLQ+ZRlnuciq5vI4vfxmVYIKQmGYxZgyRSRZlEmeYzGyKM5UYTUv2sppimaYasQkWbUKTm0jxJjhBec1xlrKc5lQlOtP5ynWyk5bufGdVxClPrNCznla5Jz6pov/PfUqln/6ECkAD6pSBEpQpBj2oUhKq0HDGs6ELfShEHWrHiUpTohYtCkMzKpSNchQoHv2oT0IqUp6QtKQ6OSlKcaLSldqkpS6lCUxjKpOZ0hQmNr2pS3KqU5bwtKcq+SlQUSLUoZqkqEYlCVKTKpKlMhUkTn2qR6IqVY5QtaoauSpWMaLVrVqkq16lCFjDKpGxkhUiZj2rQ9KqVoawta0KeStcESLXuRqkrnYlCF7zKpC98tWveQWsXQU7V8LC1bBtRaxaFXtWxpLVsWGFrFclu1XKYtWyVcWsVDX7VM4y1bNJBa1RRTtU0tquAwhIrWpXy9rWuva1sI2tbGdLWwT/1AGjxDzEAXbL29769rfADa5wh0vc4hr3ABnA7S8VkMbmOve5kzQnc6FL3epS95t3nK51t8vdP0q3u+ANryi/K97ympea49TuedfLXVCQl73wrW4EAJEPcKo3vvht7gK+8AFu3je/AMZhHfSBzf8G+MAWdEIWqmlgBDuYYzAoQTQb/OAKxycDnxgPMSls4Q5fZ787W66HR5whIXRwlxwmsYqPsOBbpljFJIZBbmb5YhiPOAJcoLGNd4wdBnAixJ+sMY89LIQhkFLIQ+6wF2oQ5CQ7mTghgIImkfzkCkegCvBbJJWr/OAH7EHDgdwylx+8hBPzUQYGSLOa18zmNrv5/81wjrOc50xnOBMhAuL1ggv42hFN3Ca8KjgDnzlCj/GFdwKSGPRGSLAG8S7gEUBWtEUwUIYAgZcBaaCZpDEyCzyHFxJ73vRFFPFn8MLgBqK+iAsMDd4UZCLVFvGBKxgQ3gXYINKwhkgDyrC18K4BjrmWSD8mIN4NyCHYE2HBicKLiCkgWyJxmIF4U+CGZ0dkBVZwtA28Zu2GNIAOve4uA0ywgm4/ZBEnKDY9zO0QKIRAvCGgArsbggRphxcF1Z73QmRQAFqDNwNS4La+D8IBd4kXCB8beEKqUETwTsIOCk8IFEAgXi3IO+IHuYO9wTsBSmD8IDFAT3gzgImTfZwgFP8wgr/Bi/CTE8QBREh3eP0AcZcPpAQUD28RsGDzgSCBCeJVwhl7/o8kjEG8D7iEyW2e8pV3lxBF6rkDACFz8AriYkQvQRMqznOiswHo4QVBIoj+jwtsArwLyDHZ/8EBI4S7untY+0Ac8ApPU1cI/ZX7QN4ARegyAth6F0gNZthcECAh8AZpw9HTGIEZw4aOnvPAFt5uwQdQMDYkmMAmsoENz0FgFHa3oASyDBsROMcP4oAa5/axgw9aQeCvyfZ1WgELQ4D5cvwgPMeOoOnY+OAF8VFBM9CQd8td4GccC0GodaMHjqWgG5hDACsoj50UsOA4hCCZ6jGXCuCn5wGnOE7/C6qenxxwDg1bB48NSK8bWpCMX5zrg+6JkwZcx0YIJOuE565QiedsQAbIcQHJlSFmADofoAb+BgPLxxtEQDKwIDqk8AIo4GzJoQskQwOjAwdDlxw/YDQKgngVwQagQDHpASMgWBEQIAvjgALYcXgneBFd4At1EG4b8IIbEQrnQA7+UA822BF9YGY9GIRCOIREWIRGeIRImIRKuIRM2IRO+IRQGIVSOIVUWIVWeIVYmIVauIVc2IVe+IVgGIZiOIZkWIZmeIZomIZquIZs2IZu+IZwGIdyOId0WId2eId4mId6uId82Id++IeAGIiCOIiEWIiGeIiImIiKyCnCAA1b/2gMw1EFWEgB8kA+ElaFbVAMz+EIvECFPNAc16EFYxeFh6AE6QEJCeeE50B9zzEI9neEDcANHBMA7HeEMRAEKxN3SWgKhWBBjZCEGHB2K5MCUpaEI8AIJIMHG7KElvBuAlIE99OE10Bs8ZEDWOeECuB0z+ENQOiEgAAeA5CKUchCz0EMkDeFGuAc43B7U9gBIlcKWugBniAOXAh7i3iP+JiP+riP/NiP/viPABmQAjmQBFmQBnmQCJmQCrmQDNmQDvmQEBmREjmRFFmRFnmRGJmRGrmRHNmRHvmRIBmSIjmSJFmSJnmSKJmSKrmSLNmSLvmSMBmTMjmTNFkUecCOUrkYBlPQCGtwIssIhSTAAqSgDIxAecbxhJdgC/kRAFAYM/kRBVA4CxlyjUz4IwLSDk/YAtqIHcEAhVsUH9rxhCYgIA+APk6IDxlyfU6YDBkyDU94BxmyBE/oAOQHHqsAhQkiIEzmhOkYH4EQANvHhDTyHAewCdBwCFcThWLgDz2QBpcgDMdmhRzQjTVZmZZ5mZiZmZq5mZzZmZ75maAZmqI5mqRZmqZ5mqiZmqq5mqzZmq75mrAZm+YUEAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix6NMkmvaKRTq74cAws7UGu8oPBHe8Xq27gZV6DNu7e/PrmDCx8Mz7dvNMOTK9fbyXjvV8ujS4/bwjlvTtOza09ry7q/XdvDi/8HS8a7t/Ho018t5X2H+vfwnZ7y7i9M/Pv4iRqinyW///87kUAfMgAWaOBMMHiXzYEMNqhSEN494uCEFIb0hXfLVKjhhhi9YpwFAAiBDocklviQJrgsUUoVU/ABgYkwxijjjDTWaOONOOao44489ujjj0AGKeSQRBZp5JFIJqnkkkw26eSTUEYp5ZRUVmnllVhmqeWWXHbp5ZdghinmmGSWaeaZaKap5ppstunmm3DGKeecdNZp55145qnnnnz26eefgAYq6KCEFmrooYgmquiijDbq6KOQRirppJRWaumlmGaq6aacdurpp6CGKuqopJZq6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuupi1YQe7V4qixREtwEtlNyfQlqG9UDoAim/G8OvkCksYtwA1Ai8ZBwDWNcFHwkgicwB9gjQAcZGNLEAfbcFcLKQH6WzcG2oe+2iJNyLzJsi7JffIgsYp02Fxyz6eI/IBydAcpDT0TaKKzkF6sIF1RlAAtJByrOKbEnocTSQavW1wi9NF/uvPFhxQXaQDafii9ddghy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744ow37vjjkEcu+eSUV2755ZhnrvnmnHfu+eeghy766KSXbrrod5w+WhhKAPCJfap7RgRvSgQTR+ycHWHcGIe8iLtlingXyTky/E4Zz/RNwAovxkM2xAsp+zMACc03Nkr0/jBRfWNMYP/J9os9gz0KPoCvGCUTp2yO+Yt9QMsgDGz8B/uN2VFOd875Qf9jEECRTgS+kcT+IiMDLviBNiko3wAlwwsJlGGBEIygBCcIKyAk4IIYzKAGN4jBWFDwLgXAnncI8EG7hFCEziFhCelyQhT6RoUrlEsLXcgbGMYQLjOkoT9seEO35JCGPOwhW/9+6MIgClEtREShEY+IliSKcIlMNIsTsQfFKJJlitGrohXFgsWUaXGLYOmiyL4IRq+IcWNkLCNXzkifNKpRK2wc4RvPEkfruHGOV6ljCvFYFj0a5458pIofXxjIsQyyN4AsZFQOWUNFhoWRtEmkI50CyR1O8iuVlOQll5LJTXalk57cCihDmZVRkjKPOkTkKUuZykauEpWttOQrrWLKWUqllraECi5zSclYypKXi/SlJoHpk10SUynGPCZSkqlMozCzmUR5JjSFIs1pAqWa1iymMLOJzG1yc5ne/KYzwynOaJKznNQ8Jzqvqc51ajOWw3SnS7ApT5rQs54yuSc+YaL/z33Os53+vEk/A7qSgRI0JQY96EkSqtCSMLShI3koREMi0Yl+pKIW7QhGM7qRjXI0Ix796EVCKtKKkLSkEzkpSiOi0pU+pKUubQhMY7qQmdI0ITa96UFyqtOC8LSnA/kpUP8hVKAWtadH1WlSb7pUmjY1pk91aVRXOlWUVrWkVxVpVj+6VY52NaNftWhYJzpWiJa1oWdVaFoPulaCtjWgb/VnXPc5V3zWtZ53lWde3bnXdfYVch1AgGAHS9jCGvawiE2sYhfL2MYioA4AxeMhDkDZylr2spjNrGY3y9nOevazB8hAZOeoAF+a9rSopeImS5va1rq2tfGMIWtfS9va/wJxtbbNrW7HiNvd+va3kewtcIdrW1AIl7jIbW0EAJGPSc42udA97QK+8AFHPje62I1lHfShyOtm97s0dEJ/Auld8JoXezAoAXnPy14XZuATDsBjedtLX+tMd2ZqnG999+sbIVzgjfrlr4D9cYTxgjHAA+YvDMRQRgQneL8R4MKBH0xh3zCAE/g9ooMrXF8hDCGKG+Ywfb1QAyaGWMTtDQEUNIziFkegCr6TbYtb/IA9xFfGM27xEv67QhkY4MdADrKQh0zkIhv5yEhOspKNTAQA6tYLLhhqRjTRg92q4AxSxgg9hqbbCQgwyxYhwRp2u4BHZBjMEcFAGR6gWwakIf8GaK7ILJycW0hEOc4TUUSVdQuDG+B5Ii7gcm5TkIk/S8QHrohfbhdggzMbeiENKAPMcrsG6j36If2YwG43IIdLP4QFUdgtIqbgaYfEYQa7TYEbSt2QFViBzDYwGqsV0gA6TLq2DDCBbWatkEXkS7cboAevFQKFEOw2BFQYdkKQgGrdomDVyj6IDAqgaNtmQAqyjjZBOMCe3QJhBNo2SBVSsNtJsCzcA4ECCHarhWSjeyB3aHZuJ0CJdw8kBgXTbQYwgQF7/4MCRqi2bb/tbwcQ4de59cO5312Cdeu2CFjw9z+Q0D3dKkEEEk/CGHb7gEv0294AF3htCQG7dzsAEAj/t60gLCHxEjSB3RH3NxsqnlsQJELiF9jEoiUs8X9wwAi3bu0eej4QB7yCzqkVQnWJPpA3qKC1jLA00wdSgxygFgRImLpB2rBxX0aAwVo3iAe2EHQUPoAIYUcIBEaBdBRKIMZpN8g+dkBDK2Q77gfhh9VFeAQ4410hFxgE9kJw578rBAGsKLtxUsACwzskFdDzzgNO4fiHoOHl1rEB3Cu/kD7s3TdpcDTnFXKFSvhmA8UbPUQ+oAZFw6DwqocIKV6AAlLHfiJwwPjtd8/73oOpDBJgnu8b4gNy+8MPXEj98BEiCd9EIB1Q2Pzy/3FA59iiHAsf/h82xoBB0GLpvjdH//QOUO/e+2A20XuG7z+BPe35nuYiG4XvSTCA6L3gw8PnBSs0TR9pTF8gMnAOkeAdivB/AwEBh9B1vXEEBmgQcRAMSsAbaNeABhEGnwAASlByFGgQqbOBHviBIBiCIjiCJFiCJniCKJiCKriCLNiCLviCMBiDMjiDNFiDNniDOJiDOriDPNiDPviDQBiEQjiERFiERniESJiESriETNiETmgWvpAGNwaCHLAFtGFcIHgLguYPyOGBehCBvbEKndaAAGcdG+ABBqgKk9B//5cM6UMf5zB8tRY9C9B4vGcHgoA93sByvBcN2JMOaOh7wSAyC9AI09cAeegdB0Ag/8cHmP9nHABwOw1IDWW3BLtGgcbgG6AwhRu4DLRxAt0ggi1wBFogCiRoB23whKq4iqzYiq74irAYi7I4i7RYi7Z4i7iYi7q4i7zYi774i8AYjMI4jMRYjMZ4jMiYjMq4jMzYjM74jNAYjdI4jdRYjdZ4jdiYjdq4jdzYjd74jeAYjuI4juRYjuZ4juiYjuq4juzYju74jvAYj/I4j/RYj/bohBDAB1NQBaWwBLigCRSIDkIAABZgHNDRgJ5oHV9AgY/gHUFAgdngHTBAgchAH1I3fVlAH+72f2FAH5TXgHRnHaVAgShjHWRAgbvgHbZAgZxAH/VigB7iHaZogFDjHfDQgH1GQB8V0IArwBso4AVrIAXsgAV+14DR0AtJcI9KuZRM2ZRO+ZRQGZVSOZVUWZVWeZVYmZVauZVc2ZVe+ZVgGZZiOZZkCUwBAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnzyY52OmVjEiFeUA4gF7NuvU/T/5iy/ZnyrXt25iXzZb9B7fv34/p7I4NBbjx44brDfenB7nz5319LecCvbp1ulOWC7jOvfvaO8uNeP8fT16sh+XpyqtfrzXB8E3s48uPymQ4pPn48yOtM7yI/v8A/qTBcCcEaOCBNkGznAcINuggS1Usx8eDFFY40iEgMLKJNLDUI8IIFoYo4ogklmjiiSimqOKKLLbo4oswxijjjDTWaOONOOao44489ujjj0AGKeSQRBZp5JFIJqnkkkw26eSTUEYp5ZRUVmnllVhmqeWWXHbp5ZdghinmmGSWaeaZaKap5ppstunmm3DGKeecdNZp55145qnnnnz26eefgAYq6KCEFmrooYgmquiijDbq6KOQRirppJRWaumlmGaq6aacdurpp6CGKuqopJZq6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvWf5wAo2+OJIQyv+DOBAvzRC8E4GshlDsIyJVLJbBtcs/CIyeCznBIMSq8iBcMvFFkzGKSJBTseyWTAHyCZKkgLJsR2hA8okygAEy/4sYAMFMJM4hyMst2JIziZSQvIWLQB9IhjD9VCC0SjKUMRs4MjAdIosMOAPHr9MveIjVlyh9YoDfy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIo5nEB4lXNw4IjfjQOHJ8IOxPAuUMMTlwHMuGAiyhbH7bEBMs98IWdojeGgEsPzBODap/9gEINPvDwDIvx76ZCLXPBrvumTmQTDG9DwB8Z70A8QDLwxzvmR0SKLHcEc6DtkIsWuwGT/WrddCNH7GZgQH3rSniyg/kp6/++uy37/778Mcv//z012///fjnr//+/Pfv//8XAUICBkjAAhrwgASMBQDpUoDe0YwAC5xLAx1IMghGMC4TpOByLHjBt2RQg7vhYAfb8kEQykaEI1xLCU3oDxSmMC0rNKELX3iWGIJwhjQsiw01iMMcjmWHFOyhD//DAkQHCnGIXyli746IxK4osXZMbOJWnvhAKZqFiiyLohWxgsUKbpEsXeyYFr9YlTBukIxiMeNwxohGqagxhG0Eyxtnw8Y4PmWOJ7SjV/AYmzrqkSl8bOEfuRJIPw4yKYU8pFYSqUgushCOjbwKIyNZxkfSkZJWmSQm3WjJPG5yKpr85B072UdRcpKUhjSlT0KpyqWwspWIJKUgYdmUV9LSKLa8JVFyqUuh8LKXQPklMFcpy1QOkybCPOZOkqnMnDCzmTd5JjRrIs1pzqSa1owJNrP5km1ysyXe/OZKwinOlJCznCc5JzpLos51jqSd7gwJPOP5kXnSsyP2vOdG8qn/z4zws58X+SdAKyLQgU6koAaNCEIT+pCFMrQhDn3oQiIq0YRQtKIHuShGC6LRjQ6kox79B0g9OtKNlhSjJ61oSiW60oe2lKEvTWhMDTrTgdYUoDftZ071udN79pSeP41nUN051HUWFZ1HLWdSxbnUbzaVm0/NZlStOdVpVhWaV21mVpW51WN2dZhfBWZYezlWXZY1bx1AgFrXyta2uvWtcI2rXOdK17oigD+o1OMhDsDXvvr1r4ANrGAHS9jCGvawB7BcJ40ZQQXI8rGQjWwQ9ehYyVr2spZl7AIri9nOepaFmgUgZz9L2tJ60Y6jNa1qVRva/6V2tbD1LCgoG9va/342AoDIRxxfa9vePnYBX2AcGnnr2+J2sg76GK5xlwtZJ2SBjMRlrnQpCIOlbTG6080uzTLwibA1EbvaDe9ygNsAKYJXvOidjRAu8N30urd2R3juEM/73vTCQAzzra9+OxYB6uSQvvsVLwM4Ud4XAjjA4hWC5lJ4YASH1wu/62CDHazdEBRHwhTOcGwiUAUIXHDCGp7uA/bgXdeGOMRLYC8AZWCAFrv4xTCOsYxnTOMa2/jGOKYxESJgWi+4IKQb0UQPTKuCMwBZI/TYgGknIIkjZ4QEazDtAh5RYCdXBANlWB5pGZCGGFj5IrPgcWkh8eMvV0QRQy4tDG5g5oq4QP/JpU1BJtpMER+4wmqktVmV6fyQBpRhAaZdAwn4LJF+lK60G5ADoSPCgiiYFhFTWDRE4jAD06bADZJ+yAqsIOWbZbohDaADoLdsghV8uiGLOIFpN0CPUzMECiEwbQio4OqFIKHSpUUBpmudEBkUAM+fzYAUcMbrg3CgFKoFAoiKfZAqrKy0k0gdsw0CBdqVVgu0nnZB7oBr0k6AEtouSAyWYNoMYGJ84RYIBYwA7M8qO90CcQARVF1aP0gb3iWwNmmLgAV4CwQJ9SmtEkTg738kYQymfcAl0J3udbfbs4QIg78dAAh6k1YQlih4CZpgWi30299sCDhpQZCIgl9gE3n/9m/BOWCEUWN2DwUniANeIWbLCkG4MR/IG1RgWUYMOucFqUEOIgsCJAD9IG1AuCwjgN+jH8QDW3A5Cx9ABKcnBAKjqLkJJeBhqydkHztgoRWI7fWE8GPoGjyCl8u+kAsMgoIhKDPbF4IAVki9YylgwdwfkooXtO4Ue4cIGjjeMRt0PfAO6QPad5OGPSO+IVdw2Gw2ILXHR+QDasAzDORu+YiQ4gUoiHTnKQIHgo/+9KhPvepXz/rWu/71sI+97GdP+9rb/vZM+4ErFIH7f2DADLHxQzc6YHt47EYLsTD17I+wHCVI4N6uH0brgNCL1w+gd8VIRolPXwMNml71OljG/8OXAwKcr74G49CyGGNvhy34fTgTWHDsQwELFOyGDrYfQjnc448MTOj2PtAIIDAOvScQH5AEBZiACriADNiADviAEBiBEjiBFFiBFniBGJiBGriBHNiBHviBIBiCIghM21d7V2AFj9B7v1AxDKB3tScD4DAbRVB5slcCaTYbYCB7LbAFJANur2cIAEMyjnAyrEcBNnB3wwEENJh6OsB8LJMCTcZ6c2ABNEMORud6RsAydKAar+cBTrAceIAMs3cNihUblVBytGcMspEB73B4s+cA19cKNNB72MAKkjOCeJiHeriHfNiHfviHgBiIgjiIhFiIhniIiJiIiriIjNiIjv/4iJAYiZI4iZRYiZZ4iZiYiZq4iZzYiZ74iaAYiqI4iqRYiqZ4iqiYiqq4iqzYiq74irAYi7I4i7RYi7Z4i7iYi7q4i7zYi774i8AYjMI4jMRYjMZ4jMiYjMq4jMzYjM74jNAYjdI4jX4yAiJQD7AgDZvACCBwCLTHB8tRBbR3HsMBDbVncbKhAbX3NLtRB7UHCcPBBLWHcruRALWXDgtCe1k4HHdAewKwHKIne1ywHL5Ae3qwHPVAe1CwHPg3e3+wHMtAe6awHJ5AexwABPNQAUSQDL1gB1xIjSAZkiI5kiRZkiZ5kiiZkiq5kizZki75kjAZkzI5kzRZkzZ5kzgFmZOlGBAAIfkECQMA/wAsAAAAAJACcgIACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27dw48qdS7eu3bt48+rdy7ev37+AAwseTLiw4cOIEytezLix48eQI0ueTLmy5cuYM2venJHDHF69xMAhwbm06dMTqflbvVoR6tewYw+kwXq1GNm4c2uuUdsfHN3Ag0c21bub8OPIEbfoLSK58+eAGdT+Ab269buraqO7zr2720C1K3j/H0++7Ibaj8qrX891QG067OPLn2qltob5+PMrlVc7gP7/AAYFTG0mBGjggTipU9s2CDbo4EujwNDKBgPY8OCFGGao4YYcdujhhyCGKOKIJJZo4okopqjiiiy26OKLMMYo44w01mjjjTjmqOOOPPbo449ABinkkEQWaeSRSCap5JJMNunkk1BGKeWUVFZp5ZVYZqnlllx26eWXYIYp5phklmnmmWimqeaabLbp5ptwxinnnHTWaeedeOap55589unnn4AGKuighBZq6KGIJqrooow26uijkEYq6aSUVmrppZhmqummnHbq6aeghirqqKSWauqpqKaq6qqsturqq7DG/yrrrLTWauutuOaq66689urrr8AGK+ywxBZr7LHIJqvsssw26+yz0EYr7bTUVmvttdhmq+223Hbr7bfghivuuOSWa+656Kar7rrstuvuu/DGK++89NZr77345qvvvvz26++/AAc8kynZCBxiJgn4I4vBHc4xBmuteMBwhhBwgUJv6U384C3V9LbaA6JojKADsUzgsT8MfDGCyAZmkcvJ/szQC8sBYkDACyef0AgGNAOIgR8wj6FKzwZK4TEItBB9IAc51NYMaUofeMNqTmgStYPBVEDB1Vx37fXXYIct9thkl2322Wg7msQHacenASJV8Nw2eTU8sFoh3UAwt3dg9P9GDjJ7X6eDdB7rYkjg0BEA82pL6IC4c1QEsTgD6TzxeHI3SA7zA1s0cDlymcNcyefO3VCMxzSQ/lwJnrBGjOrVse6P47BXh0rtuOeu++689+7778AHL/zwxBdv/PHIJ6/88sw37/zz0Ecv/fTUV2/99dhnr/323DMMRALghy/++OSHH0v3cxWw+Pq9EYC+XOqzL7/778MVv/zr01+/W/fjD7P++2NL//znMQAGUC0DJGBtDHhAtCRQgathYAPN8kAISnCCZKmgAi+IQbFokIAc7CBYPui/EIrQKyTEnwlPyJUUzo+FFITgyVYIw6y4kH00rOFVbpg/HY6Fh4vLoQ//qQLE/w0xLEWc4RFHKMMCLvErSXTiE7sSxfZNkYpNtOIVt1LFBW6Ri1n04hdtGEbWCHGMSumiGdGIFTVGkI07LOMb4VgVN/rjjHQsih3xmMeh7LGPU/kjIKMiyEE+pZCGbAoiE7mURTIyKY585FEiKUk9yvGOlWzkJfmYSZxQspNB+SQofyLKUfaklKbcCSpTmZNVsvImrnxlTWIpy5nQspYxuSUuX6LLXbakl75cCTCDmZJhEvMkxjxmSZKpzJEws5kheSY0PyLNaXakmtbcCDazmZFtcvMi3vxmRcIpzomQs5wROSc6H6LOdTakne5cCDzjmZB50vMg9rxnQfKp/8+B8LOf//hnPwWqT4Le06D0RGg8FepOhq7ToeiEaDklKk6KftOi3MRoNjVqTY5O06PQBGkzRapMkh7TpMREaTBV6kuW7tKluIRpLWUqS5q+0qasxGkqdWpKno7Sp6AEaieFmkmimq0DCEiqUpfK1KY69alQjapUp0pVBNRhk1M8xAG2ytWuevWrYA2rWMdK1rKa9QAZwOoTFXDJtrr1rSCcIlvhSte60pWT9ZurXffK1ybi9X167atgBxtEuRL2sIhd41oTy9jBgsKwjY2sXSMAiHwsMbCSzWxbF/AFtg0Rs5oNbRnroI/Piva0l3RCFnwIWtS6loAwKIEOW/va2v+yLwOfcAAMaWvb3p6Ms547IW99S9zaCOECwi2uctd3hNV2cLjLLS4MboNB6EaXuBHgQnWvy93eMIATwQ2gdbvrWyEM4YDjJW9vvVAD8ar3vf4IART2l1741jYCVdAb+upr39c+YA+67R5/+/vaJSCXezIwgIIXzOAGO/jBEI6whCdM4QpHmAgRIKwXXABQjWiiB4RVwRk6nBF6nGewE5AEiTFCgjUQdgGPCO+KJ4KBMthNsAxIQwxmbJFZZHiwkOAwjymiCBAPFgY3GDJFXHBiwaYgE0qeiA9cQbi+LsAGMo5yQxpQhgUQdg1Q0/JD+mGywW5ADmKGCAuiQFhETCH/zQ+JwwwImwI3wNkhK6jPYK+8tTsvpAF08DKOTbACPzNkEScg7AboYeiFQCEEhA0BFRqtECTMebAosDOlESKDAlSZrxmQQp83XRAOlOKwQFgZqQ1ShRQQdhJ2WLVBoAACwmph0rImyB0uLdgJUCLXBInBEgibAUzIDdgUMMKn+ZpqYAvEAURI9GD9EGtn/6MEtR5sEbBg7X8ggQmEVUJzrJ2Ehw32AZc4dq6Tvey9EiIM1nYAIKQtWEFYotslaIKtuW1tNoB7sCBIRLcvsAnBLkC73f4HB4wgaLvuIeEDccArfkxXIXgW4gJ5gwroyogwY1wgNWiaW0GAhI8bpA3m/5ZjBKhr8oJ4YAsNb+IDiNByhEBgFBSXoQT0W/OD7GMHTbTCqHt+EH6InIBH2DHRFXKBQRAwBEJeukIQwIqYwywFLJC6Q1KBs8U94BRafwga9A0zG/A87Azpw9Frk4Yso30hV6hEbzYgg7dH5ANqIBwMom53iJDiBSh4c98nAodxD/7wiE+84hfP+MY7/vGQj7zkJ0/5ylv+8pjPvOY3z/nOe/7zoA+96LV1u8zrwB+ekO3licGa1FeeNr0pRpIlL/eTBWH2jm/AFm5se9w3/gnpaDdrgoBrx+tg2IWFvCF0ATPaRR4Z5OgNGCoPgW4U4mPttTwGqoCI+2T+A0kYvf/4x0/+8pv//OhPv/prQoEKBAPzmnDCanwfeRI0ozY54MDkaZHt2kgh8qqQcr3hB+qmeBjQCPRWGy9AAAWYeL3Aa72RC87FeCPwBcI3AbEQYI0nCrxXG9VwC5L3CL2BAlxwdo/nAa3AGmMwB5YnC/6QAFCGedlgCutXgzZ4gziYgzq4gzzYgz74g0AYhEI4hERYhEZ4hEiYhEq4hEzYhE74hFAYhVI4hVRYhVZ4hViYhVq4hVzYhV74hWAYhmI4hmRYhmZ4hmiYhmq4hmzYhm74hnAYh3I4h3RYh3Z4h3iYh3q4h3zYh374h4AYiII4iIRYiIZ4iIiYiIq4iIzYiI6p+IiQGImSOImUWImWeImYmImauImgYgMDsAGtAAOjYHnbUBvqYHkmUBvAYHkBUBvyYHkaUBtWYHl0UBsDYHkiyBobYHkVUBuBYHnoUBurYHk/UBsMYHki0BstUHnd0Bs0SHlw0BvZN3li0BupQ3mK0BvUUHkkAAdi0Au8MAf6x4nkWI7meI7omI7quI7s2I7u+I7wGI/yOI/0WI/2eI/4mI/6uI/8WI4BAQAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza95MkkMFfBJKcB5NunTFFf5SVzDNurXrgqhVv55Nm7OP1P5W197NezJu3b2DC0/8e7jx44KLI1/OHC8K2c2jS3+bAPr069jLVs+dvbt3rzBSc//6Tr581UCpJZhfz54pen/q28ufLzRSevr48+vccF+///8wxSJBOaIBaOCBCCao4IIMNujggxBGKOGEFFZo4YUYZqjhhhx26OGHIIYo4ogklmjiiSimqOKKLLbo4oswxijjjDTWaOONOOao44489ujjj0AGKeSQRBZp5JFIJqnkkkw26eSTUEYp5ZRUVmnllVhmqeWWXHbp5ZdghinmmGSWaeaZaKap5ppstunmm3DGKeecdNZp55145qnnnnz26eefgAYq6KCEFmrooYgmquiijDbq6KOQRirppJRWaumlmGaq6aacdurpp6CGKuqopJZq6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvfjmq+++/PZbmwf++jdELcw0EDB9ECyyQ2qNHCwfDn7g5o8SVzhs3sAMSNwDLRaTB4EkC+P2ghRhlPZMxxx1kovE/ljxhGln+LMJDyhfRMIWGePmRIGlOTBDag/Mc0HNE12Dh8SOpGIwayWwnAApSxPtkAe2pMaABm3MZsg6LAOAhtQP/eJPLgbw1s17uM0MdkPDCEdBKtultoA5SaydXQx7WCDxAbFE/223dLcQInEEc/ydHRUr+yOF4d7F44kPjEcu+eSUV2755ZhnrvnmnHfu+eeghy766KSXbvrpqKeu+uqst+7667DHLvvstNdu++2456777rz37vvvwAcv/PAQApHA8cgnr/zyyMdC/FsFsCz99NIT8Lxb0VOvffXXt5X99uD7Y333a30fvvbjk5+W+edPn776Z7HfPsvvw1+W/PPjVr/9Y+Gfv/j8i9//3BdAs/gvf/sr4FcOOL8EKrArDGyfAx+4lQieb4IUzIoFw4fBDF5lg+DroAerAsLtiXCEUykh+lDoFRVS74QshIoLCRjDCg6QezXUygxxmEOs7JB+PdTgDf+BGMQPDlFiMCxiUn6IRCVahYn6cyIJjxhFKaaQiqlJohWJAsUsblEqXQTgF2WIRTGO0Slh1OIZf5LGNaKxjGp0I0/aKMel0LGOS4QjHpVyxz0apY9+5KIeA/nHQRJSkFiM4yFnAshFstGQjgRKIyM5R0hSsieTvGROMqnJm3CykzX5JCgZaclRerKUpgwlKlNJykSycpOrfCVMRClLltCyliq5JS5RostdmqSXviQJMIMpkmESEyTGPKZHkqlMjjCzmRp5JjQxIs1pWqSa1qQINrMpkW1yEyLe/KZDwilOhpCznAo5JzoRos51GqSd7iQIPOMpkHnS057xxKc79bn/Tn6i05/lBKg4BfpNgnLToNlEqDUVOk2GQtOhzYSoMiV6TIoS06LBxKgvNbpLjuLSo7UEqSxF+kqSstKkqUSpKVU6SpaC0qWdhKkmZWq5DiDgpjjNqU53ytOe+vSnQA2qUBFQh1gG8BAHSKpSl8rUpjr1qVCNqlSnStUDZMCo/FNAGbfK1a42kIVa9apYxypWRQ4vrGRNq1pvaFbhoXWtcI3rClH4Vrna1a5tDV5d78pXtYICrH0N7FojAIh8jHCvgk3sVhfwhQ94ELGKjSwV66CPDEJWspgdoBOyQMHLZvaz7YMBzwLoWdCadnsZ+IQDClja07pWeoz1m/pa+9ra/+JGCEOzH21ta9sjcBZ+u+VtbWEgBuAK97jbiwAXZovc5k6PAZyQrVudS12WCWEI1wtudU/rhRo8T7vbNW0IoEA88IYXtBGoAgSme97wPmAPqwWeedsL2iXk1ncyMIB+98vf/vr3vwAOsIAHTOACB5gIEZCrF1xAz4loogdyVcEZGiwRevAnrhOQBIUjQoI1yHUBj5DuhhOCgTI8IK4MSEMMRvyQWSQ4rpBgMIsboggIxxUGN5hxQ1xwYbimIBM6ZogPXJGztS7ABiIO8kAaUIYFyHUNJFCyQvoxAbluQA5STggLoiBXREwhywiJw8/imgI3gPkgK7DCh21AgTMXpP8BdHAyXBlgghW4uSCLOIGV6XFngkAhBHINARX6PBAkjBmuKDAzof8hgwIUWa0ZkEKbCc2BUtgVCCNY9D+qkAK5TsIOmoYCCOSqhUEv+g6HXusEKKHpGCxBrhnABAYWTQEjPFqtmF60A4ig57j6AdSLLsGo41oELGgaCUyQqxJEoOkkjEGuD7jErAld61unlRAlI7QDANFruArCEpouQRNIbexFsyHZcQVBIjR9gU3AdQHL1fQ/OGAEOZN1D/IeiANe8WKxCsGx+R7IG1QgVkZEOeAEqUEOugoCJCDcIG14dhkjUNyHG8QDW7D3DR9ABIsjBAKj6PcAJbBejyNkHyH/+58VJm1yhPBj4fk7wopbrpALDGJ+IZAxzRWCAFZonHopYMHOHZKKF2zvAacY+kPQMG7q2aDkSm9IH2DOsjQkOeoIuUIlWLYBGWA9Ih9QQ85goPOvQ4QUL0DBl80+ETgwm+1wj7vc5073utv97njPu973zve++/3vgA+84AdP+MIb/vCIT7ziF8/4xjv+8ZCPvOQnT/nKR8kHnoiH4KWQmlyYuu9zEDkhbtH3BsTiABKzwB5mvvckmEPjCUgFy3nTtsvxwN0SC0Q3eGOAlf0ic2gAAMvWYYjZtEEDObMFwDDXAFLELTWjJU0DUuEIieHhGpu7wDxO7I8ZxLc0JXCC/8QYsIWDc+72/phwaZ6gZonlohOiOxlpwiAFo+NmB5KA+t1pYWOr1QK7encFSiAxfoADftcIqbEDi6B/e9cAzPB/grd8ljeBFFiBFniBGJiBGriBHNiBHviBIBiCIjiCJFiCJniCKJiCKriCLNiCLviCMBiDMjiDNFiDNniDOJiDOriDPNiDPviDQBiEQjiERFiERniESJiESriETNiETviEUBiFUjiFVFiFVniFWJiFWriFXNiFXviFYBiGYjiGZFiGZniGaJiGariGbNiGbviGcBiHcjiHdFiHdniHeJiHeriHfNiHfviHgOiHJVAOEuA8gCcBqbEBgYeI/hAJi2WYGoHwiP4QiYDHCakBAoFXAamRAJm4iZ3oDyjwif4giqQIeJqYGpDzd6foD3amirjRin5XAhKADxXAAYF4i7iYi7q4i7zYi774i8AYjMI4jMRYjMZ4jMiYjMq4jMzYjM74jGAWEAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97cMk4FPZxDix59EY4/E6RTq159sNtp1rBjixbhD4js27gr09aQu7dvxrt/Cx8+ODjx48jznvInIbnz53F/MIdOvTpa6c2ta9/uVTo07uDDW/+VXkG8+fNNR/krj769+6EV/E17T7/+zvg/7OvfL7OEBE38BSjggAQWaOCBCCao4IIMNujggxBGKOGEFFZo4YUYZqjhhhx26OGHIIYo4ogklmjiiSimqOKKLLbo4oswxijjjDTWaOONOOao44489ujjj0AGKeSQRBZp5JFIJqnkkkw26eSTUEYp5ZRUVmnllVhmqeWWXHbp5ZdghinmmGSWaeaZaKap5ppstunmm3DGKeecdNZp55145qnnnnz26eefgAYq6KCEFmrooYgmquiijDbq6KOQRirppJRWaumlmGaq6aacdurpp6CGKuqopJZq6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqvuuuy26+678MYr77z01mvvvXeJAhq++kGQiz+bxMFvfR3EooQ/FkjhwcD0JQKOP/7YogDD9GlCDsRCqEKxex28coA/EZTzwcbtJdEMxK0MQ3J7vUwCMTFzrHweBIvs4M88Ml/kgAgjyxaDBEPkXNEZXvgjjtDgsbEExCHAg7R2SWzxgD8plNPC09V98I4j/izATSJYV9eNLRAvkUXY1FEhCMTeyII2dCQsA7EZlEDwNnQNtJJAPT3f/w0dKkH7LfjghBdu+OGIJ6744ow37vjjkEcu+eSUV2755ZhnrvnmnHfu+eeghy766KSXbvrpqKeu+uqst+7667DHLvtDQCRg++2456777bHM/lYBEAcv/PDEC0+A724BX/zyyx+PPFvKMy998M4/r1b000tfvfVoYZ9989xf//3024dflvfjD1+++WOhnz717J/l/vv+rB8/WPO/b//9XuWf/v7844r/xgfAAGplgN8roAGxgsDsKXCBVmkg+SCIP/oV74EUnIoEtZfB/lmQeBjsIFQ2yLwQitApJATfCQ/4QfWtkIUthN8LGRhDGc4wgjWEmAlviJQUXpCHOMzhDv+BWBQfgpCIVDGiC5EoFSUaj4lNzGH9oBgVJ9qQik2xog6x+BQtTpGLWZTiEMHIEy+OkYw6MSMal6LGNSaljW48ChzjWEQx0lGOdrxjHYWoxz3W8Ix9jMkcA/mTQRKyJ4Y85E4SqcicMLKRN3kkJGsiyUnOpJKWFGQeM+nITXIykp78JCVDKcpLkrKUmuQjKkepylWaspWuTOUfY/nKWdJSljEE5C07gsldkqSXvhQJMIMJkmES0yPGPCZHkqlMjTCzmRh5JjQtIs1pUqSa1pQINrMJkW1y0yHe/CZDwilOhZCznAg5JzoNos51EqSd7hQIPOM5T3fWc533RGc+y7n/T3H285v/5GZAszlQaxZ0mgeFZkKbuVBlNvSYDyVmRIM5UV9WdJcXvWVGabnRWHbUlR9dZUhROdJSllSUJ/1kShfXAQS49KUwjalMZ0rTmtr0pjjNKQLqcEr+HeIAQA2qUIdK1KIa9ahITapSl3qADPT0fgqQolSnStX/dTCqVc2qVrOqS9hhdatgDesHu/q6r4r1rGgt4VXTyta2XnGBZnWrXMEKirXO9a5bjQAg8kHBuOL1r1JcwBf6FkC/AvawMayDPuCK2MZK0QlnK6xjJxtDGJRAspTNLP0y8AkHQFWzoE2fYBsQP8OG9rTEE8IF2Gda1LoWYkeILPda+1rX/8JADOGjbW1RGwEuzHa3wB0eAzhBWuTpNrinFULgZndc5IbWCzXwXXOdC9oQQIG51M1uBKpgN69mN7sP2INny/rd7y5hta6TgQHWy972uve98I2vfOdL3/raV75EiEBaveCCeEJEEz1IqwrO4N+H0GMDaZ2AJArsEBKsIa0LeERxGawQDJRhamdlQBpiQGGGzEK/aIVEfzusEEUEGK0wuAGJFeICBKM1BZlYcUJ84AoGoHUBNpiwjAnSgDIsIK1rIMGOD9KPCaR1A3IYskFYEIW0ImIKSi5IHGaQ1hS4IcoEWYEVIGwDCmBZIA2gw48zbIIVfFkgizjBkelx5n9AIf8EaQ0BFdqMBCqjFQVXPrMMCmDjs2ZACl7+MgdKwVYgjKDNVUhBWidhhzZDAQRp1cKcz3wHO591ApRocwyWhtYMYAIDZ6aAEfp8VkOf2QFEUDNa/dDoM5cA0mgtAhbozIS0KkEEbU7CGNL6gEuA+suiJrVYCRGGUwNC1WcVhCXaXIImRHrWZ2ZDrdEKArCd+QKbOOsCfNvmf3DACGPe6h66PRAHvALEWRUCYcn9BhVklRFCJndBapADqoIACfI+SBt2LcUI4DbfB/HAFsL9wQcQAeAJgcAo0G1BCXQX4QjZh80saIVAQzwh/Kj3+47A4Ysv5AKDSF8IRuzxhSCAFQT/X14KWFDyh6TiBdJ7wClaDhE0OHt5Nng4zRvSB40PLw063nlDrlCJ4W1ABkKXyAfU0GcYkDzpESHFC1AAZahTBA64trrWt871rnv962APu9jHTvaym/3saE+72tfO9ra7/e1wj7vc5073utv97njPu973zve+m28IqGD7B+qRgFYEnewQoIQZILaMeJtdFt6AmCAmbfYscNoW3UB7IrjxY0e8Y91ib0E5FP2ALSQB7fCAsz+WwAa1i8MfXiAw44YggY7H5gMiGC/j5uGPHSxC52efAzEgNolesH0YrYBYM06v9g+UQ78HeEUH1q4KIUCMHABauwLI5g9wWDvtHpCC/wX8oYRYTF/tcch2LoCPdj2Iwu/wj7/850//+tv//vjPv/73z//++///ABiAAjiABFiABniACJiACriADNiADviAEBiBEjiBFFiBFniBGJiBGriBHNiBHviBIBiCIjiCJFiCJniCKJiCKriCLNiCLviCMBiDMjiDNFiDNniDOJiDOriDPNiDPviDQBiEQjiERFiERniESJiESriETNiETviEUBiFUjiFVFiFVniFWJiFWriFXNiFbaYJEnBZbEcebWcM69F28TEKaOgP+cF20MCGbScBcMh2ctiGayeHM8d2GuAPWbd2e9iHaveHbQcEfNh2JuAPmcd2hwgHbacHFSwgMF4YiZI4iZRYiZZ4iZiYiZq4iZzYiZ74iaAYiqI4iqRYiqZ4iqiYiggYEAAh+QQJAwD/ACwAAAAAkAJyAgAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza948s0E0zqBDi8a4ItDo06hTIwzlRLXr16LnbIBNu7blLNVs697d+M8g3sCDE1ZkQrjx43tvBEDOvLlcOBqcS5+eVoER6tizgxVRSrv371dPVf8AT7680x/GzKtfX7TeD/bw4/OsIEm+/fszabHAz7+///8ABijggAQWaOCBCCao4IIMNujggxBGKOGEFFZo4YUYZqjhhhx26OGHIIYo4ogklmjiiSimqOKKLLbo4oswxijjjDTWaOONOOao44489ujjj0AGKeSQRBZp5JFIJqnkkkw26eSTUEYp5ZRUVmnllVhmqeWWXHbp5ZdghinmmGSWaeaZaKap5ppstunmm3DGKeecdNZp55145qnnnnz26eefgAYq6KCEFmrooYgmquiijDbq6KOQRirppJRWaumlmGaq6aacdurpp6CGKuqopJZq6qmopqrqqqy26uqrsMb/KuustNZq66245qrrrrz26uuvwAYr7LDEFmvsscgmq+yyzDbr7LPQRivttNRWa+212Gar7bbcduvtt+CGK+645JZr7rnopqtushCsS+A4RvjgboAtcBKIAvMGiMo6JmCT738OvNLDKw78618eu6zzh8H+oYGLDR4wzF+9hZQgMX+oTALGBRffF3AeHYcs8sgkl2zyySinrPLKLIfbbsvaRZODHDBTR40329BQs3Q0bOPHGTs7V8MaTCQTdHN8aICLGx0cjdwQpWjxAwVOH9eCAFoI0ELVyPECyxBchy322GSXbfbZaKet9tpst+3223DHLffcdNdt991456333nz3/+3334AHLvjghBdu+OGIJ6744mICkcDjkEcu+eSQx8J4XAX4o/nmnHfu+eYEXA5X5p+XXnroortFuumsg5666q3H7g/qr6+1uuyn187W7bh7TrvuaPHeO+e/A2+W8MNrXrzxZCGf/PLMi+X88NBHD9b0vVdvvVfY46799lx1L/v34Gslfuzkl4/V+a2nr75V7LPu/vtUxW/6/PRLZX/u+XOf/Of4699T9gdAAXaFgL4zYPj+l0AFmo+BnQugA5WCwAhOMCsVJN4F1wdBDW4Qfh103QerkkERjnAqJVTeCesXQhWuUH8tnN0LYdhCCc4QKCmU4Q0HGEMb7rAnOfThD/93EsQhNqWIRlwKEpOYlCUy8ShOfGJRoijFoVCxikG5IhZ/osUtArGHXiRKF8OokzGSESdmPKNN0qhGmrCxjTJ5IxxhIsc5uqSOdmQJHvOokj3yESV+/KNJAilIkhCykCI5JCJBoshFeqSRjuQIJCOpkUlSEiOWvKRFMqlJinCykxL5JCghIspROqSUpmQIKlOpkFWyEiGufKVBYilLgtCylgK5JS51WUteytKXrwQmK4WZSmKa0pijRCYoldlJZmrSmZeEJiWlGUlqOtKai8QmIrVZSG4K0pt/BCcfxZlHctrRnHNEJxzV2UZ2qtGdZ4QnGeUZRnp60Z5bxCcW9Vn/RX62rAMICKhAB0rQghr0oAhNqEIXylAE1AGM/TvEASZK0Ypa9KIYzahGN8rRjnr0ABmAaP4UEMOSmvSk2RMgSVHK0payVIiMW6lLZ0pTBsJ0cTKtqU53ej+V8vSnQDUh/XIa1KLOFBQ+NapSXRoBQORjpEuNKksX8IUPDFWqWD1pHfTxPqJm9asMdEIW1OdVsJq1dzCwGPjKeta2ti4DnyiY9djq1rp+jqoNmKtd9yo7IXCMeXTlq2D9cYSxGi+wg+UrDMRw2MQ61nMR4ALwEPtYuzKAE3l9HWUra1chgC11m+VsXb1QA9CK9rT+CAEURBda1LY1AlV4meJa69qz/z5gD3JNHG1re9Yl/BVxMjCAcIdL3OIa97jITa5yl8vc5iaXCBHgqRdcgEuMaKIHPFUB0KprEXpsgKcTqA93K0KCNfB0AY/I7HglgoEyPGCnDEhDDNZLkVlEd6eQoC59JaII7O4UBjfYr0Rc8N2dpiATAo6ID1zBgJ0uwAbqTTBDGlCGBfB0DSSQ8EP6MQGeboBmGm4IC6LAU0RMIcQNicMMeJoCN6CYISuwwnltQLUXJ6QBdLCwThlgghXYWCGLOIGH6fHjhEAhBDwNARWKjBAkrHinKHAxkw0igwI0WKcZkEKNpzwQDpTip0AYAZcLUoUU8HQSdhgzQaAAAp5qYf/JahbIHZ6s0wlQIs4CicESeJoBTGAAzxQwwpV1GmY8O4AIQt6pH9KM5xK0eadFwAKe/4EEJvBUCSKYdBLGwNMHXOLPcQ70oGtKiDAYGhCJ1qkgLDHpEjTBzZLGMxssvVMQJGLSF9iEThcg2Un/gwNG0LFL9+DrgQTsviwVglWLPZA3qICljMgwswlSgxycFARImLZB2sDpGEaAsdo2iAe2IGwGPoAI4UYIBEaB7P9JQLbpNsg+dsBAK2w53gfhh7WHd4T54lshFxhE70Kg338rBAGsKHfpUrAfgzckFS9g3QNO4fCHoOHVpbMBvCu+kD7su3NpiDDHGXKFSnRuAzL/GHlEPqCGK8Og4CqHCClegIITx3wicMj0zXfO8577/OdAD7rQh070ohv96EhPutKXzvSmO/3pUI+61KdO9apb/epYz7rW+zcEWPBi6VfL2taQToEfaKEUnz16B9yACw3wQenJYMIaSpv0M/ghZ0rvmTeosXQ55OAzTd/41gdP+MIb/vCIT7ziD5UHgjX9AmDwAyqcXoJCcGLsS/eADXCBBqf/YR27ABnTA1YExzMdGyZYx+SbroBAXL7pPjDCOJ4u+MXb/va4z73ud8/73vv+98APvvCHT/ziG//4yE++8pfP/OY7//nQj770p0/96lv/+tjPvva3z/3ue//74A+/yPjHT/7ym//86E+/+tfP/va7//3wj7/850//+tv//vjPv/73z//++///ABiAAjiABFiABniACJiACriADNiADviAEBiBEjiBFFiBFniBGJiBGriBHNiBHqhJLEALTiceTvcD9eB0xvAeTVcBFNd0paBzTGcE+NJ0GgAHThcAAdZ0JqAITjcIC9N01WBYTLcBc+B0ThAKThcIPtZ00SByH/iEUBiFUjiFVFiFVniFWJiFWriFXNiFXviFYBiGYjiGZFiGZniGhhcQACH5BAUDAP8ALAAAAACQAnICAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3nxzBOfPoENnHCa6tOnTCc+gXs1atOrWsGNbJi27tu3GtG/r3j34Ne/fwPVCCU68+NxvxpMrV4t8ufPnYH1Dn0696vDq2LM7faO9u3ejzb+L/x+/Uzr58+hh0kjPvr379/Djy59Pv779+/jz69/Pv7///wAGKOCABBZo4IEIJqjgggw26OCDEEYo4YQUVmjhhRhmqOGGHHbo4YcghijiiCSWaOKJKKao4oostujiizDGKOOMNNZo44045qjjjjz26OOPQAYp5JBEFmnkkUgmqeSSTDbp5JNQRinllFRWaeWVWGap5ZZcdunll2CGKeaYZJZp5plopqnmmmy26eabcMYp55x01mnnnXjmqeeefPbp55+ABirooIQWauihiCaq6KKMNuroo5BGKumklFZq6aWYZqrpppx26umnoIYq6qiklmrqqaimquqqrLbq6quwxv8q66y01mrrrbjmquuuvPbq66/ABivssMQWa+yxyCar7LLMNuvss9BGK+201FZr7bXDQhEDtvcNcx239LVBCzbg1ncDGuXS54Mvd6Q7nwHCYOBufBzE88e88WWhhwf4vtcBd/0GLPDABBds8MEIJ6zwwgw37PDDEEcs8cQUV2xxsXcocnFxquhx78bA8aFHJyADF0o0OJT82xC/aKzybisoIMvLu7UARwkQ0LybDh3o7PPPQAct9NBEF2300UgnrfTSTDft9NNQRy311FRXbfXVWGet9dZcd+3112CHLfbYZHcHRAJop6322mynHUvZcBXgz9x012333XQTAPdbcuP/7bffeu/dVt9/F5634IMbrrg/gSOuFuGLA+74WpBHfnfjk59VueV1Y555WZtzPrfnn48Vuuiklx7W6ZynrvpXrFvu+utdxR757LRvZfviuOee1e6K9+77VcAbLvzwVRVf+PHIT6X838w3H9Xzkktfu+h4R2+9U9Rnvz1X3V/+ve7Yiz/+7+Xbrf35SYWvPvtYud85/MSnPz/9ydt/OP5Uyb8//1Lx3+gA6Dz9DZCA0zMg4xCYQAOuj4E/EeACIcg9BT6QgjyR4AUxqBMNcpApHvygUkIoQqSQsIRGOSEKiaLCFQqlhS4ECgxj6JMZ0jCDFrzhUGyow5zwsIc3+SEQ/2sixCHOpIhGjAkSk/iSJTKxJU584kqiKMWUULGKJ7kiFkuixS2OpIteDAkYw/iRMZKxI2Y840bSqMaMsLGNF3kjHCsixzlOpI52jAge8/iQPfKxIX7840ICKciEELKQBzkkIguiyEUOpJGO/AckHTnJRVYSkZcsZCYFuck/dpKPn8xjKO04yjmWEo6nbGMq1bjKM7aSjK8MYyy9OMst1hKLt6xiLqW4yyf2kom/TGIwjTjMIRYTiMfsYTJ1uMwbNpOGz4xhNF04zRVWM2IdQIA2t8nNbnrzm+AMpzjHSc5yIqAOOZTeIQ7Azna6853wjKc850nPetrzngfIQDqbp/8ABfrznwCVnfX6GdCCGrSgGyQbQQ/K0IaWL6FjW6hDJ0pR6A20ohjN6P+QJ1GNepShoLjoR0d60AgAIh/8JKlKC7qAL3yAoyuNKUDroI/hdVSmOC2fE7Lgu5vm9KeWg0EJcudToBrVcBn4hANeV9SjOhVvLW2A6pr61KrWTQgXKB1VrcrVI/A0c1vlqlVhIAawivWsfosAFyYXVrQ+lQGckKrg2urWpwphCHOtq17r5oUa7I2uez1qCL4V0cAaNgJVyFlhDRvYB+xhqWIDLGOPuoSshk0GBsisZjfL2c569rOgDa1oR0ta0BIhAhX1ggsieRFN9KCiKjAPayNCjw3/VHQCkphtRUiwhoou4BFy1W1EMFCGB1CUAWnYlnAlMgvUUhQSq11uRBTxWorC4AbSjYgLbEvRFGQiuxDxgSsYQNEF2CC44F1IA8qwgIqugQTpdUg/JlDRDcghvg1hQRQqiogp4JchcZhBRVPghv8uZAVW8K0NKGDghDSADu2dKANMsIIGJ2QRJ6gvPSyMECiEoKIhoAKHD4IEAVMUBQUecUFkUADyTjQDUmCwigfCgVJgFAiemfFAqpCCik7CDjoeCBRAUFEtiDjI/7iDiSc6AUog+R8xWEJFM4AJeQWZAkZw8URxjGQHECHDFPUDkJFcAiJTtAhYeDISmFBRJYjg/8lJGENFH3AJK+sYy1p2KCHC0GVAgHmigrDEk0vQhCKnGclsYDNFQZCIJ19gExNdwFqf/A8OGCHCB90DpQfigFc4t6BCeOmmB/IGFRSUEfAdNUFqkAOAggAJqjZIG+SswAiUNdYG8cAWMF2+BxAB1wiBwCg+jT0JKBbYB9nHDspnBRkjGyH8aDXnjqDcZyfkAoOwXAiia22FIIAVvPZbCljQbYek4gWFe8Apyv0QNBTabzY4NrsZ0gdp2y0N6J03Q65QCbttQAb6jsgH1OBiGHA74BAhxQtQ4F+ETwQOb3a4xCdO8Ypb/OIYz7jGN87xjnv84yAPuchHTvKSm/zkKP9PucpXzvKWu5yGHdDByCFQAji0QOSyUECFQ66IX+A15DiIRihE3gk98EHkf9CDKkauiHa9/OlQj7rUp071qlv96ljPuta3zvWuK+gNPSO5B/TwVZL/IR4cKDkGhGEAk9/BFz4wORqwW3Js0KINJodCbkYeA8J6/e+AD7zgB0/4whv+8IhPvOIXz/jGO/7xkI+85CdP+cpb/vKYz7zmN8/5znv+86APvehHT/rSm/70qE+96lfP+ta7/vWwj73sZ0/72tv+9rjPve53z/ve+/73wA++8IdP/OIb//jIT77yl8/85jv/+dCPvvSnT/3qW//62M++9rfP/e57//vgD79b+MdP/vIDaz0lly3IwzNygJHc7yFX/8fZL3L6hxz+IJe/x/cucv7H3+T613H+B3I5Zn4GeIAImIAKuIAM2IAO+IAQGIESOIEUWIEWeIEYmIEauIEc2IEeaG0BAQA7";

var Spinner = function Spinner() {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "spinner_wrappper"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: img$3,
    alt: "Loading..."
  })));
};

var css_248z$I = ".loader {\n  width: 75px;\n  height: 75px;\n  background: transparent;\n  border-radius: 50%;\n  background: #f8f8f8;\n  position: absolute;\n  display: inline-block;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto; }\n  .loader::before, .loader::after {\n    content: \"\";\n    display: block;\n    width: 75px;\n    height: 75px;\n    border-radius: 50%; }\n\n.loader-1::after {\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  border: 4px solid transparent;\n  border-top-color: #04d2c6;\n  border-bottom-color: #04d2c6;\n  animation: spin 2s linear infinite; }\n\n.icon-wrapper {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 42px;\n  color: #ccc; }\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg) scale(1); }\n  50% {\n    transform: rotate(180deg) scale(1.2); }\n  100% {\n    transform: rotate(360deg) scale(1); } }\n";
styleInject(css_248z$I);

var loader = function loader() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "loader loader-1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "icon-wrapper"
  }, /*#__PURE__*/React__default.createElement(HomeIcon, null)));
};

var API = {
  core: {
    baseAPIPath: "https://api-dev.peek.us/rest/v1/",
    imageBasePath: "https://piiq-uploads-dev.s3.amazonaws.com/",
    amenitiesImageBasePath: "https://piiq-dev-upload-amenities.s3.amazonaws.com/",
    agentLensBasePath: "https://lens-dev.peek.us/",
    baseAppPath: "https://agents-dev.peek.us",
    brandingImageBasePath: "https://piiq-dev-upload-branding.s3.amazonaws.com/",
    poolId: "us-east-1:3313ffcc-3d39-499a-aee3-031d52b5d5cb",
    imageBucket: "piiq-dev-upload-branding",
    profileImageBucket: "piiq-users-profile-dev",
    userProfileImageBasePath: " https://piiq-users-profile-dev.s3.amazonaws.com/",
    agentsSiteBasePath: "https://agent-lens-dev.peek.us/",
    nearbyMapId: "AIzaSyAk_3cEzBmmzkXYux7GKLXJ4_VuCsMqqv8",
    folioViewer: "https://folios-dev.peek.us/folio",
    floorPlanBaseImage: "https://piiq-upload-floorplans-dev.s3.amazonaws.com",
    requestPassword: "/users/request_password",
    orgAdminLogin: "/auth/login",
    validateRequestPasswordToken: "/users/validate_change_password_token",
    changePassword: "/users/update_user_details",
    resetPassword: "/users/change_password",
    validateUserId: "/users/validate_user_id"
  },
  relativeUrl: {
    GET_AMENITIES_WEB: "/amenities/get_amenities_web",
    UPDATE_CTA_LOG: "/analytics/update_cta_click_log",
    CAPTURE_2D_IMAGE: "/listings/generate_2d_images",
    SET_DEFAULT_IMAGE: "/listings/set_listing_first_room"
  },
  countryCodes: ["us", "can"],
  placeApiBasePath: "https://maps.googleapis.com/maps/api/geocode/json",
  hasAdminAccess: function hasAdminAccess() {
    if (localStorage.getItem("user") && localStorage.getItem("user").length && Object.keys(JSON.parse(localStorage.getItem("user"))).length) {
      return JSON.parse(localStorage.getItem("user")).permission_id === "5f351f8b20f4cb2d7ff24151";
    }

    return false;
  },
  convertNumberIntoValue: function convertNumberIntoValue(value) {
    if (value) {
      var number = Number(value).toLocaleString({
        style: "currency",
        currency: "USD"
      });
      return number;
    } else {
      return value;
    }
  },
  convertIntoCurrency: function convertIntoCurrency(value) {
    var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "USD";

    if (value) {
      var number = Number(value).toLocaleString({
        style: "currency",
        currency: currency
      });
      return "$" + number;
    } else {
      return value;
    }
  },
  convertVhToPx: function convertVhToPx(vhValue) {
    var _window = window,
        _document = document,
        _element = _document.documentElement,
        _body = _document.getElementsByTagName("body")[0],
        _height = _window.innerHeight || _element.clientHeight || _body.clientHeight;

    return _height * vhValue / 100;
  },
  checkPassword: function checkPassword(str) {
    var _regexp = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return _regexp.test(str);
  },
  checkEmail: function checkEmail(str) {
    var _regexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return _regexp.test(str);
  },
  checkPhone: function checkPhone(phone) {
    var _phoneRg = /^\d{3}-\d{3}-\d{4}$/;
    return _phoneRg.test(phone);
  },
  downloadFileFromUrl: function downloadFileFromUrl(url, nameOfFile) {
    var save = document.createElement("a");
    save.setAttribute("id", "download_link_for_custom_file");
    save.setAttribute("href", url);
    save.download = nameOfFile;
    document.body.appendChild(save);
    var elem = document.getElementById("download_link_for_custom_file");

    if (elem && document.createEvent) {
      var evt = document.createEvent("MouseEvents");
      evt.initEvent("click", true, false);
      elem.dispatchEvent(evt);
    }

    document.body.removeChild(save);
  },
  // converts number to string representation with K and M.
  // toFixed(d) returns a string that has exactly 'd' digits
  // after the decimal place, rounding if necessary.
  numFormatter: function numFormatter(num) {
    if (num > 999 && num < 1000000) {
      return (num / 1000).toFixed(1) + "k"; // convert to K for number from > 1000 < 1 million
    } else if (num > 1000000) {
      return (num / 1000000).toFixed(1) + "M"; // convert to M for number from > 1 million
    } else if (num <= 999) {
      return num; // if value < 1000, nothing to do
    }
  },
  timeConvertor: function timeConvertor(n) {
    return moment().startOf("day").seconds(n).minute() + " mins";
  },
  getCookie: function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }

      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  },
  getBrowserName: function getBrowserName() {
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf("OPR")) != -1) {
      return "Opera";
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      return "Chrome";
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return "Safari";
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return "Firefox";
    } else if (navigator.userAgent.indexOf("MSIE") != -1 || !!document.documentMode == true) //IF IE > 10
      {
        return "IE";
      } else {
      return "unknown";
    }
  },
  checkIfOptionChecked: function checkIfOptionChecked(key) {
    var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return array.indexOf(key) !== -1;
  },
  TEXT_CONSTANTS: {
    "AMENITIES_NOTIFICATION": "Check out the great amenities!",
    "FULL": "FULL",
    "STREET": "STREET",
    "NONE": "NONE",
    "STAGED_TOOLTIP": "See this room with furniture",
    "VOICE_OVER_ROOM_ICON": "Press enter to view rooms and amenities List.",
    "VOICE_OVER_LISTING_INFO": "Press enter to view current Listing Information",
    "VOICE_OVER_NEARBY": "Press enter to view what is near by for this listing",
    "VOICE_OVER_RENT": "Per month",
    "VOICE_OVER_FLOORPLAN": "Press enter to view floor plan",
    "VOICE_OVER_POWERED_BY": "Listing's Three sixty Degree view is Powered by Peek Technologies",
    "VOICE_OVER_EXPAND_ICON": "Press Enter to go to Full Screen mode, You can get back to Normal view by Pressing ESC Button"
  },
  stackedChartConfig: {
    STROKE_COLOR: "FFFFFF",
    FONT_SIZE: "12"
  },
  timeSeriesChartConfig: {
    XACCESSKEY: "xAxis",
    VALUE: "value",
    IS_DATE_AS_VALUE: false,
    STROKE_COLOR: "#18C015",
    FILL_COLOR: "#fff"
  },
  pieChartConfig: {
    DATAKEY: "value",
    PIE_FILL_COLOR: "lightgrey",
    SECTOR_FILL_COLOR: "#6DD230"
  },
  VALIDATION: {
    "EMAIL_VALIDATION": /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i,
    "PASSWORD_VALIDATION": /^(?=.*[A-Za-z].*)(?=.*[0-9].*)[A-Za-z0-9]{8,}$/i,
    "PHONE_VALIDATION": /^\d{3}-\d{3}-\d{4}$/i
  },
  VALIDATION_MESSAGE: {
    "REQUIRED_EMAIL_MESSAGE": "Please enter email",
    "VALID_EMAIL_MESSAGE": "Please enter valid email",
    "VALID_PASSWORD_MESSAGE": "Password must be at least 8 characters.  It must contain at least one uppercase, one lowercase, one digit and a special character.",
    "MATCH_PASSWORD_MESSAGE": "Password do not match"
  },
  MONTHLY_NAMES: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"],
  WEEK_DAYS: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  triggerOnKeyUp: function triggerOnKeyUp(event) {
    event.preventDefault();
    event.stopPropagation();

    if (event.keyCode === 13) {
      event.target.click();
    }
  }
};

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

// utils is a library of generic helper functions non-specific to axios

var toString$1 = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString$1.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString$1.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject$1(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject$1(val) {
  if (toString$1.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate$1(val) {
  return toString$1.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString$1.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString$1.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction$3(val) {
  return toString$1.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject$1(val) && isFunction$3(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject$1(result[key]) && isPlainObject$1(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject$1(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$1 = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject$1,
  isPlainObject: isPlainObject$1,
  isUndefined: isUndefined,
  isDate: isDate$1,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction$3,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$1.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$1.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$1.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$1.forEach(val, function parseValue(v) {
        if (utils$1.isDate(v)) {
          v = v.toISOString();
        } else if (utils$1.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils$1.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils$1.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

var cookies = (
  utils$1.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$1.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$1.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$1.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$1.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$1.trim(line.substr(0, i)).toLowerCase();
    val = utils$1.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var isURLSameOrigin = (
  utils$1.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$1.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils$1.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$1.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$1.isUndefined(headers) && utils$1.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$1.isFormData(data) ||
      utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$1.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$1.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils$1.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils$1.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData = function transformData(data, headers, fns) {
  var context = this || defaults_1;
  /*eslint no-param-reassign:0*/
  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$1.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$1.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults_1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge(target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$1.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$1.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils$1.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils$1.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$1.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils$1.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils$1.forEach(otherKeys, mergeDeepProperties);

  return config;
};

var name = "axios";
var version = "0.21.4";
var description = "Promise based HTTP client for the browser and node.js";
var main$1 = "index.js";
var scripts = {
	test: "grunt test",
	start: "node ./sandbox/server.js",
	build: "NODE_ENV=production grunt build",
	preversion: "npm test",
	version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
	postversion: "git push && git push --tags",
	examples: "node ./examples/server.js",
	coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
	fix: "eslint --fix lib/**/*.js"
};
var repository = {
	type: "git",
	url: "https://github.com/axios/axios.git"
};
var keywords = [
	"xhr",
	"http",
	"ajax",
	"promise",
	"node"
];
var author = "Matt Zabriskie";
var license = "MIT";
var bugs = {
	url: "https://github.com/axios/axios/issues"
};
var homepage = "https://axios-http.com";
var devDependencies = {
	coveralls: "^3.0.0",
	"es6-promise": "^4.2.4",
	grunt: "^1.3.0",
	"grunt-banner": "^0.6.0",
	"grunt-cli": "^1.2.0",
	"grunt-contrib-clean": "^1.1.0",
	"grunt-contrib-watch": "^1.0.0",
	"grunt-eslint": "^23.0.0",
	"grunt-karma": "^4.0.0",
	"grunt-mocha-test": "^0.13.3",
	"grunt-ts": "^6.0.0-beta.19",
	"grunt-webpack": "^4.0.2",
	"istanbul-instrumenter-loader": "^1.0.0",
	"jasmine-core": "^2.4.1",
	karma: "^6.3.2",
	"karma-chrome-launcher": "^3.1.0",
	"karma-firefox-launcher": "^2.1.0",
	"karma-jasmine": "^1.1.1",
	"karma-jasmine-ajax": "^0.1.13",
	"karma-safari-launcher": "^1.0.0",
	"karma-sauce-launcher": "^4.3.6",
	"karma-sinon": "^1.0.5",
	"karma-sourcemap-loader": "^0.3.8",
	"karma-webpack": "^4.0.2",
	"load-grunt-tasks": "^3.5.2",
	minimist: "^1.2.0",
	mocha: "^8.2.1",
	sinon: "^4.5.0",
	"terser-webpack-plugin": "^4.2.3",
	typescript: "^4.0.5",
	"url-search-params": "^0.10.0",
	webpack: "^4.44.2",
	"webpack-dev-server": "^3.11.0"
};
var browser$2 = {
	"./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
var jsdelivr = "dist/axios.min.js";
var unpkg = "dist/axios.min.js";
var typings = "./index.d.ts";
var dependencies = {
	"follow-redirects": "^1.14.0"
};
var bundlesize = [
	{
		path: "./dist/axios.min.js",
		threshold: "5kB"
	}
];
var _package = {
	name: name,
	version: version,
	description: description,
	main: main$1,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies,
	browser: browser$2,
	jsdelivr: jsdelivr,
	unpkg: unpkg,
	typings: typings,
	dependencies: dependencies,
	bundlesize: bundlesize
};

var _package$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	name: name,
	version: version,
	description: description,
	main: main$1,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies,
	browser: browser$2,
	jsdelivr: jsdelivr,
	unpkg: unpkg,
	typings: typings,
	dependencies: dependencies,
	bundlesize: bundlesize,
	'default': _package
});

var pkg = getCjsExportFromNamespace(_package$1);

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators$1
};

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios;

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios_1.prototype, context);

  // Copy context to instance
  utils$1.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults_1);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios_1;

// Factory for creating new instances
axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

var axios_1 = axios$1;

// Allow use of default import syntax in TypeScript
var default_1 = axios$1;
axios_1.default = default_1;

var axios = axios_1;

var HttpService = function () {
  function listenToIntercerports() {
    this.instance.defaults.headers.common["piiq-auth-token"] = getToken();
    this.instance.defaults.headers.common["Content-Type"] = "application/json";
  }

  function $getCall(relativeUrl, callBack, errorHandler, isDownload) {
    if (isDownload) {
      this.instance.defaults.headers.common["responseType"] = "blob";
    }

    return this.instance.get(relativeUrl).then(function (response) {
      if (callBack) callBack(response);else {
        return response;
      }
    })["catch"](function (error) {
      if (errorHandler) errorHandler(error);else {
        return error;
      }
    });
  }

  function $postCall(relativeUrl, options, callBack, errorHandler) {
    return this.instance.post(relativeUrl, options).then(function (response) {
      if (callBack) callBack(response);else {
        return response;
      }
    })["catch"](function (error) {
      if (errorHandler) errorHandler(error);else {
        return error;
      }
    });
  }

  function HttpService(baseUrl) {
    this.instance = axios.create({
      baseURL: baseUrl
    });
    this.listenToIntercerports = listenToIntercerports.bind(this);
    this.get = $getCall.bind(this);
    this.post = $postCall.bind(this);
    this.listenToIntercerports();
  }

  var getToken = function getToken() {
    try {
      return localStorage.getItem("token");
    } catch (exception) {
      window.console.info("Session Storage Issue", exception);
    }
  };

  return HttpService;
}();

var img$2 = "data:image/png;base64,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";

var css_248z$H = ".ErrorHandler {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100vh;\n  height: 100vh;\n  left: 20%;\n  position: relative; }\n\n.logo_position {\n  width: 29vh; }\n\n.logo_position img {\n  width: 100%; }\n\n.ErrorInformation {\n  margin-left: 20px;\n  font-family: \"Montserrat\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; }\n";
styleInject(css_248z$H);

function _createSuper$z(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$z(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$z() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ErrorHandler = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ErrorHandler, _React$Component);

  var _super = _createSuper$z(ErrorHandler);

  function ErrorHandler(props) {
    var _this;

    _classCallCheck$1(this, ErrorHandler);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass$1(ErrorHandler, [{
    key: "componentDidCatch",
    value: // eslint-disable-next-line no-unused-vars
    function componentDidCatch(error, errorInfo) {
      var errorMessage = _typeof$2(error) === "object" && (error.message && error.message || "Something went wrong.") || "Something went wrong.";
      this.setState({
        errorMessage: errorMessage
      }, function () {
        var _timeout = setTimeout(function () {
          clearInterval(_timeout);
          window.open("https://www.peek.us/", "_self");
        }, 5000);
      });
      window.console.error(errorInfo);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return /*#__PURE__*/React__default.createElement("div", {
          className: "ErrorHandler"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "logo_position"
        }, /*#__PURE__*/React__default.createElement("img", {
          src: img$2
        })), /*#__PURE__*/React__default.createElement("div", {
          className: "ErrorInformation"
        }, /*#__PURE__*/React__default.createElement("h1", null, this.state.errorMessage), /*#__PURE__*/React__default.createElement("h3", null, "Please contact your Agent.")));
      } else {
        return this.props.children;
      }
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: true
      };
    }
  }]);

  return ErrorHandler;
}(React__default.Component);

ErrorHandler.propTypes = {
  children: PropTypes.object
};

function _createSuper$y(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$y(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$y() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * nodename: String
 */

var Portal$2 = /*#__PURE__*/function (_Component) {
  _inherits$1(Portal, _Component);

  var _super = _createSuper$y(Portal);

  function Portal(props) {
    var _this;

    _classCallCheck$1(this, Portal);

    _this = _super.call(this, props);
    _this.renderChildren = _this.renderChildren.bind(_assertThisInitialized$3(_this));
    _this.portalNode = undefined;
    _this.getNode = _this.getNode.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(Portal, [{
    key: "getNode",
    value: function getNode() {
      var _this2 = this;

      if (!document.getElementById(this.props.nodename)) {
        this.portalNode = document.createElement("div");
        this.portalNode.id = this.props.nodename || "singlton";

        if (this.props.click) {
          this.portalNode.onclick = function () {
            _this2.props.click();
          };
        }

        document.body.appendChild(this.portalNode);
        return this.portalNode;
      } else {
        return document.getElementById(this.props.nodename);
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      return /*#__PURE__*/React__default.createElement("div", null, this.props.children);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/ReactDOM__default.createPortal(this.renderChildren(), this.getNode());
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      try {
        document.getElementById(this.portalNode.id) && document.body.removeChild(this.portalNode) || false;
      } catch (exception) {
        window.console.log(exception);
      }
    }
  }]);

  return Portal;
}(Component);

Portal$2.propTypes = {
  nodename: PropTypes.string,
  children: PropTypes.element,
  click: PropTypes.func
};

var css_248z$G = ".container-checkbox {\n  display: flex;\n  margin-bottom: 2px;\n  padding: 3px 0px;\n  cursor: pointer;\n  font-size: 14px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  line-height: 29px;\n  font-weight: 400;\n  position: relative;\n  max-width: 100%;\n  min-width: 100px;\n  align-items: center; }\n  .container-checkbox .required {\n    color: #EA6767;\n    margin-left: 5px; }\n  .container-checkbox span.label {\n    position: relative;\n    left: 25px;\n    display: block;\n    width: 100%;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    cursor: default;\n    outline: 0;\n    font-weight: 400; }\n\n.container-checkbox input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer; }\n\n.container-checkbox .checkmark {\n  position: absolute;\n  top: 6px;\n  box-sizing: border-box;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  border: solid 2px #979797;\n  background: transparent;\n  border-radius: 2px; }\n\n.container-checkbox:hover input ~ .checkmark {\n  background-color: #dfdfdf; }\n\n.container-checkbox input:checked ~ .checkmark {\n  background-color: #6DD230;\n  border: solid 2px #6DD230; }\n\n.container-checkbox .checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none; }\n\n.container-checkbox input:checked ~ .checkmark:after {\n  display: block; }\n\n.container-checkbox .checkmark:after {\n  left: 4px;\n  top: 1px;\n  width: 5px;\n  height: 9px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg); }\n";
styleInject(css_248z$G);

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
_core.version;

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f$2 = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f$2
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx(out, _global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min$1 = Math.min;
var _toLength = function (it) {
  return it > 0 ? min$1(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode: 'pure' ,
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var px$1 = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px$1).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var f$1 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$1
};

var f = {}.propertyIsEnumerable;

var _objectPie = {
	f: f
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// 19.1.2.1 Object.assign(target, source, ...)






var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = _toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;
  while (aLen > index) {
    var S = _iobject(arguments[index++]);
    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

var assign$2 = _core.Object.assign;

var assign$1 = assign$2;

var _extends_1$1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = assign$1 || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _extends$5 = unwrapExports(_extends_1$1);

function SvgAlertCircle(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React$2.createElement("path", {
    d: "M12 8v4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React$2.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgAlertCircle = /*#__PURE__*/React$2.memo(SvgAlertCircle);

function SvgBaths(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    d: "M16.5 10H2a1 1 0 00-1 1v4.5a3 3 0 003 3h10.5a3 3 0 003-3V11a1 1 0 00-1-1v0zm0 0V2a1 1 0 00-1-1H13a2 2 0 00-2 2v0M9.5 4.5l-1 3m2.5-3v3m1.5-3l1.5 3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBaths = /*#__PURE__*/React$2.memo(SvgBaths);

function SvgBeds(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    d: "M1 15v-2m20.5 2v-2M1 13V9.5a2 2 0 012-2h.5M1 13h20.5m0 0V9.5a2 2 0 00-2-2H19m-15.5 0V2a1 1 0 011-1H18a1 1 0 011 1v5.5m-15.5 0h2m13.5 0h-2m-11.5 0V6a1 1 0 011-1H9a1 1 0 011 1v1.5m-4.5 0H10m0 0h2.5m0 0V6a1 1 0 011-1H16a1 1 0 011 1v1.5m-4.5 0H17",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgBeds = /*#__PURE__*/React$2.memo(SvgBeds);

function SvgCheck(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    d: "M20 7L9 18l-5-5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgCheck = /*#__PURE__*/React$2.memo(SvgCheck);

function SvgChevronDown(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    d: "M6 9l6 6 6-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronDown = /*#__PURE__*/React$2.memo(SvgChevronDown);

function SvgChevronLeft(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    d: "M15 18l-6-6 6-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronLeft = /*#__PURE__*/React$2.memo(SvgChevronLeft);

function SvgChevronRight(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    d: "M9 18l6-6-6-6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronRight = /*#__PURE__*/React$2.memo(SvgChevronRight);

function SvgChevronUp(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    d: "M18 15l-6-6-6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgChevronUp = /*#__PURE__*/React$2.memo(SvgChevronUp);

function SvgDrive(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.383.025c-.425.039-.701.176-1.06.526-.39.381-.44.469-1.01 1.783l-.517 1.188-.798.007c-.559.005-.81.017-.836.04-.137.117-.205.483-.132.71a.936.936 0 00.383.435c.133.069.389.137.584.156l.181.017-.544 1.31.008 2.676c.007 2.613.008 2.679.062 2.808a.69.69 0 00.364.36c.083.03.353.037 1.272.037 1.323 0 1.348-.003 1.506-.208.16-.206.163-.234.163-1.087v-.781h8.062v.756c0 .5.01.794.032.866a.718.718 0 00.369.403c.117.047.23.051 1.309.051h1.18l.13-.068a.66.66 0 00.303-.343c.03-.072.04-.622.056-2.752l.02-2.662-.275-.669c-.15-.368-.274-.678-.274-.69 0-.011.048-.02.107-.02.17 0 .492-.08.647-.16.316-.163.477-.47.417-.799a.899.899 0 00-.098-.272l-.07-.107-1.612-.014-.506-1.17c-.56-1.294-.623-1.406-1.001-1.781-.378-.374-.645-.504-1.127-.548-.354-.032-6.94-.03-7.295.002zm7.39 1.2c.186.09.334.238.514.512.156.237.19.31.762 1.603l.4.906-2.698.007c-1.483.004-3.912.004-5.396 0l-2.699-.007.401-.906c.576-1.3.608-1.368.757-1.593.234-.357.42-.516.677-.578.058-.015 1.621-.024 3.617-.021l3.515.004.15.073zm-8.395 5.25c.194.09.398.294.491.493a1.058 1.058 0 01-.511 1.4c-.154.075-.206.086-.407.086-.203 0-.253-.01-.413-.088a1.097 1.097 0 01-.508-.51c-.06-.133-.07-.19-.07-.432 0-.247.009-.298.076-.446a.96.96 0 01.956-.59.874.874 0 01.386.086zm10.2-.003c.342.161.558.49.578.883.023.471-.186.82-.614 1.025-.13.061-.193.074-.386.074-.203 0-.252-.01-.413-.088-.86-.417-.78-1.64.128-1.95.18-.061.513-.034.706.056zm-3.097.92a.571.571 0 01.204.394c0 .13-.09.305-.204.393l-.102.08-2.293.008c-2.286.008-2.294.008-2.412-.051-.277-.138-.34-.523-.123-.76.148-.163.039-.157 2.532-.15l2.296.006.102.08z",
    fill: "currentColor"
  }));
}

var MemoSvgDrive = /*#__PURE__*/React$2.memo(SvgDrive);

function SvgEdit2(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    clipRule: "evenodd",
    d: "M16 3l5 5L8 21H3v-5L16 3z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgEdit2 = /*#__PURE__*/React$2.memo(SvgEdit2);

function SvgGoogle(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    fill: "url(#google_svg__pattern0)",
    d: "M0 0h17v17H0z"
  }), /*#__PURE__*/React$2.createElement("defs", null, /*#__PURE__*/React$2.createElement("pattern", {
    id: "google_svg__pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React$2.createElement("use", {
    xlinkHref: "#google_svg__image0",
    transform: "scale(.00098)"
  })), /*#__PURE__*/React$2.createElement("image", {
    id: "google_svg__image0",
    width: 1024,
    height: 1024,
    xlinkHref: "data:image/png;base64,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"
  })));
}

var MemoSvgGoogle = /*#__PURE__*/React$2.memo(SvgGoogle);

function SvgGym(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    d: "M4 8H2a1 1 0 00-1 1v2a1 1 0 001 1h2m0-4V4c0-.333.3-1 1.5-1S7 3.667 7 4M4 8v4m3-8V2c0-.333.3-1 1.5-1s1.5.667 1.5 1v6M7 4v11m3-7h10M10 8v4m10-4V2c0-.333.3-1 1.5-1s1.5.667 1.5 1v2m-3 4v1.5M23 4c.167-.333.7-1 1.5-1 .659 0 1.137.452 1.378.798a.757.757 0 01.122.438V8m-3-4v11.5M26 8h2a1 1 0 011 1v2a1 1 0 01-1 1h-2m0-4v4m0 0v3.264c0 .155-.033.31-.122.438-.24.346-.719.798-1.378.798-.8 0-1.333-.667-1.5-1m0 0V17c0 .333-.3 1-1.5 1s-1.5-.667-1.5-1v-5m0 0H10m10 0V9.5M10 12v4.764c0 .155-.033.31-.122.438-.24.346-.719.798-1.378.798-.659 0-1.137-.452-1.378-.798A.757.757 0 017 16.764V15m0 0c0 .5-.3 1.5-1.5 1.5S4 15.5 4 15v-3m8-2.5h1m7 0h-5.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
}

var MemoSvgGym = /*#__PURE__*/React$2.memo(SvgGym);

function SvgInfo(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React$2.createElement("path", {
    d: "M12 16v-4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React$2.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 1,
    fill: "currentColor"
  }));
}

var MemoSvgInfo = /*#__PURE__*/React$2.memo(SvgInfo);

function SvgMoreHorizontal(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    clipRule: "evenodd",
    d: "M12 14a2 2 0 100-4 2 2 0 000 4zM20 14a2 2 0 100-4 2 2 0 000 4zM4 14a2 2 0 100-4 2 2 0 000 4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgMoreHorizontal = /*#__PURE__*/React$2.memo(SvgMoreHorizontal);

function SvgPlusSquare(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React$2.createElement("path", {
    d: "M12 8v8M8 12h8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPlusSquare = /*#__PURE__*/React$2.memo(SvgPlusSquare);

function SvgPlus(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    d: "M12 5v14M5 12h14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgPlus = /*#__PURE__*/React$2.memo(SvgPlus);

function SvgShoppingCart(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    clipRule: "evenodd",
    d: "M8 23a2 2 0 100-4 2 2 0 000 4zM20 23a2 2 0 100-4 2 2 0 000 4z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React$2.createElement("path", {
    d: "M5.67 6H23l-1.68 8.39a2 2 0 01-2 1.61H8.75a2 2 0 01-2-1.74L5.23 2.74A2 2 0 003.25 1H1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgShoppingCart = /*#__PURE__*/React$2.memo(SvgShoppingCart);

function SvgStar(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    clipRule: "evenodd",
    d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgStar = /*#__PURE__*/React$2.memo(SvgStar);

function SvgSun(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    clipRule: "evenodd",
    d: "M12 17a5 5 0 100-10 5 5 0 000 10z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React$2.createElement("path", {
    d: "M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgSun = /*#__PURE__*/React$2.memo(SvgSun);

function SvgUser(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    d: "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React$2.createElement("path", {
    clipRule: "evenodd",
    d: "M12 11a4 4 0 100-8 4 4 0 000 8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgUser = /*#__PURE__*/React$2.memo(SvgUser);

function SvgWalk(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.008.036a1.503 1.503 0 00-1.04 1.001c-.07.222-.074.593-.009.806.128.426.424.767.815.943.212.096.387.13.643.129A1.458 1.458 0 005.855 1.46a1.3 1.3 0 00-.152-.652 1.492 1.492 0 00-.947-.772 1.952 1.952 0 00-.748 0zm-.75 3.267c-.246.083-.662.29-1.195.595-.592.338-.79.477-.969.682-.2.23-.257.324-.67 1.103-.434.82-.465.909-.396 1.145.11.375.491.574.854.444.237-.085.275-.135.702-.95.216-.413.424-.789.463-.836.08-.096.32-.265.33-.233.004.011-.1.487-.231 1.058-.197.858-.238 1.072-.238 1.236 0 .238.068.482.183.658.044.067.59.634 1.214 1.26l1.134 1.137.465 1.357c.256.747.49 1.403.522 1.458a.772.772 0 001.168.204c.195-.16.305-.47.248-.7-.057-.228-.967-2.835-1.04-2.977-.115-.227-.163-.282-.86-.981l-.658-.66.133-.417c.074-.228.262-.823.42-1.32.157-.498.293-.92.302-.937.011-.02.058.029.134.14.233.338.598.6.954.683.174.041 1.532.248 1.628.248a.69.69 0 00.583-.391.669.669 0 00-.32-.87c-.057-.03-1.411-.254-1.54-.255-.062 0-.189-.138-.371-.4-.679-.977-1.088-1.41-1.368-1.446a29.986 29.986 0 00-1.322-.086 1.02 1.02 0 00-.26.05zM1.62 11.122c-.64 1.703-.65 1.733-.65 1.914a.696.696 0 00.413.661.765.765 0 001.005-.303c.028-.056.282-.718.563-1.471l.512-1.37-.583-.581c-.32-.32-.589-.581-.597-.581-.007 0-.306.779-.663 1.73z",
    fill: "currentColor"
  }));
}

var MemoSvgWalk = /*#__PURE__*/React$2.memo(SvgWalk);

function SvgX(props) {
  return /*#__PURE__*/React$2.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React$2.createElement("path", {
    d: "M18 6L6 18M6 6l12 12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSvgX = /*#__PURE__*/React$2.memo(SvgX);

var CheckBox$1 = function CheckBox(props) {
  var onCheckBoxHit = function onCheckBoxHit(e) {
    if (e.keyCode === 13) {
      props.onChange();
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "container-checkbox parent-checkbox-div",
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      props.onChange();
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "container-checkbox"
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-label": "Hit Enter to checked/Unchecked the Checkbox",
    className: "label",
    tabIndex: 0,
    onKeyUp: function onKeyUp(e) {
      return onCheckBoxHit(e);
    }
  }, props.label, props.isRequired && /*#__PURE__*/React__default.createElement("span", {
    className: "required"
  }, "*")), /*#__PURE__*/React__default.createElement("input", {
    tabIndex: -1,
    type: "checkbox",
    onChange: function onChange(e) {
      e.stopPropagation();
      e.preventDefault();
      props.onChange();
    },
    checked: props.isChecked
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "checkmark"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      gap: 10,
      paddingLeft: 33
    }
  }, get(props, "isEditLabel", false) && /*#__PURE__*/React__default.createElement("span", {
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      props.onEditLableChange(true);
    }
  }, /*#__PURE__*/React__default.createElement(MemoSvgEdit2, null)), get(props, "isRemoveLable", false) && /*#__PURE__*/React__default.createElement("span", {
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      props.onChange();
    }
  }, /*#__PURE__*/React__default.createElement(MemoSvgX, null))));
};

CheckBox$1.defaultProps = {
  isChecked: false,
  isRequired: false,
  label: "Checkbox"
};
CheckBox$1.propTypes = {
  isChecked: PropTypes.bool,
  label: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  isEditLabel: PropTypes.bool,
  isRemoveLable: PropTypes.bool,
  onEditLableChange: PropTypes.func,
  onRemobeLableChange: PropTypes.func
};

var css_248z$F = ".textarea_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-family: \"Roboto-Regular\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 21px;\n  letter-spacing: 0em;\n  text-align: left; }\n  .textarea_header .title {\n    font-weight: 600;\n    text-transform: capitalize;\n    line-height: 28px;\n    letter-spacing: 0.04em;\n    text-align: left; }\n  .textarea_header .required {\n    color: #fbceb1; }\n\n.error_messasge {\n  margin-top: 0.5em;\n  background: #fbceb1;\n  font-size: 14px;\n  line-height: 21px;\n  padding: 2px 10px;\n  border-radius: 2px; }\n\n.peek_textarea {\n  width: 100%;\n  height: 100%;\n  resize: none;\n  border: 0;\n  box-sizing: border-box;\n  padding: 12px 24px 18px 15px;\n  font-family: \"Roboto-Regular\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 21px;\n  letter-spacing: 0em;\n  text-align: left;\n  box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1; }\n  .peek_textarea:focus {\n    outline: 0;\n    background: #F5F5FA !important;\n    border: 1px solid #1D1C38; }\n\ntextarea:disabled {\n  background: #dfdfdf;\n  cursor: not-allowed; }\n";
styleInject(css_248z$F);

var TextArea = function TextArea(props) {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.title && /*#__PURE__*/React__default.createElement("div", {
    className: "textarea_header"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "title"
  }, props.title), props.isRequired && /*#__PURE__*/React__default.createElement("span", {
    className: "required"
  }, "*")) || null, props.errorMessage && props.errorMessage.length && /*#__PURE__*/React__default.createElement("div", {
    className: "error_messasge"
  }, props.errorMessage) || null, /*#__PURE__*/React__default.createElement("textarea", {
    className: "peek_textarea",
    onChange: function onChange(e) {
      return props.onChange && props.onChange(e.target.value);
    },
    disabled: props.isDisabled,
    placeholder: props.placeholder || ""
  }, props.text));
};

TextArea.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isError: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string
};
TextArea.defaultProps = {
  rows: 4,
  columns: 10
};

var asyncToGenerator = createCommonjsModule(function (module) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _asyncToGenerator = unwrapExports(asyncToGenerator);

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _extends$4 = unwrapExports(_extends_1);

var arrayWithHoles = createCommonjsModule(function (module) {
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(arrayWithHoles);

var iterableToArrayLimit = createCommonjsModule(function (module) {
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(iterableToArrayLimit);

var arrayLikeToArray = createCommonjsModule(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(arrayLikeToArray);

var unsupportedIterableToArray = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(unsupportedIterableToArray);

var nonIterableRest = createCommonjsModule(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(nonIterableRest);

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _slicedToArray$1 = unwrapExports(slicedToArray);

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var regenerator = runtime_1;

var reactTable_production_min = createCommonjsModule(function (module, exports) {
!function(e,t){t(exports,React__default);}(commonjsGlobal,(function(e,t){function n(e,t,n,o,r,i,u){try{var l=e[i](u),s=l.value;}catch(e){return void n(e)}l.done?t(s):Promise.resolve(s).then(o,r);}function o(e){return function(){var t=this,o=arguments;return new Promise((function(r,i){var u=e.apply(t,o);function l(e){n(u,r,i,l,s,"next",e);}function s(e){n(u,r,i,l,s,"throw",e);}l(void 0);}))}}function r(){return (r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o]);}return e}).apply(this,arguments)}function i(e,t){if(null==e)return {};var n,o,r={},i=Object.keys(e);for(o=0;o<i.length;o++)n=i[o],t.indexOf(n)>=0||(r[n]=e[n]);return r}function u(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var o=n.call(e,t||"default");if("object"!=typeof o)return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return ("string"===t?String:Number)(e)}(e,"string");return "symbol"==typeof t?t:String(t)}t=t&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t;var l={init:"init"},s=function(e){var t=e.value;return void 0===t?"":t},a=function(){return t.createElement(t.Fragment,null," ")},c={Cell:s,width:150,minWidth:0,maxWidth:Number.MAX_SAFE_INTEGER};function d(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return t.reduce((function(e,t){var n=t.style,o=t.className;return e=r({},e,{},i(t,["style","className"])),n&&(e.style=e.style?r({},e.style||{},{},n||{}):n),o&&(e.className=e.className?e.className+" "+o:o),""===e.className&&delete e.className,e}),{})}var f=function(e,t){return void 0===t&&(t={}),function(n){return void 0===n&&(n={}),[].concat(e,[n]).reduce((function(e,o){return function e(t,n,o){return "function"==typeof n?e({},n(t,o)):Array.isArray(n)?d.apply(void 0,[t].concat(n)):d(t,n)}(e,o,r({},t,{userProps:n}))}),{})}},p=function(e,t,n,o){return void 0===n&&(n={}),e.reduce((function(e,t){return t(e,n)}),t)},g=function(e,t,n){return void 0===n&&(n={}),e.forEach((function(e){e(t,n);}))};function v(e,t,n,o){e.findIndex((function(e){return e.pluginName===n}));t.forEach((function(t){e.findIndex((function(e){return e.pluginName===t}));}));}function m(e,t){return "function"==typeof e?e(t):e}function h(e){var n=t.useRef();return n.current=e,t.useCallback((function(){return n.current}),[])}var y="undefined"!=typeof document?t.useLayoutEffect:t.useEffect;function w(e,n){var o=t.useRef(!1);y((function(){o.current&&e(),o.current=!0;}),n);}function R(e,t,n){return void 0===n&&(n={}),function(o,i){void 0===i&&(i={});var u="string"==typeof o?t[o]:o;if(void 0===u)throw console.info(t),new Error("Renderer Error ☝️");return b(u,r({},e,{column:t},n,{},i))}}function b(e,n){return function(e){return "function"==typeof e&&((t=Object.getPrototypeOf(e)).prototype&&t.prototype.isReactComponent);var t;}(o=e)||"function"==typeof o||function(e){return "object"==typeof e&&"symbol"==typeof e.$$typeof&&["react.memo","react.forward_ref"].includes(e.$$typeof.description)}(o)?t.createElement(e,n):e;var o;}function S(e,t,n){return void 0===n&&(n=0),e.map((function(e){return x(e=r({},e,{parent:t,depth:n})),e.columns&&(e.columns=S(e.columns,e,n+1)),e}))}function C(e){return G(e,"columns")}function x(e){var t=e.id,n=e.accessor,o=e.Header;if("string"==typeof n){t=t||n;var r=n.split(".");n=function(e){return function(e,t,n){if(!t)return e;var o,r="function"==typeof t?t:JSON.stringify(t),i=E.get(r)||function(){var e=function(e){return function e(t,n){void 0===n&&(n=[]);if(Array.isArray(t))for(var o=0;o<t.length;o+=1)e(t[o],n);else n.push(t);return n}(e).map((function(e){return String(e).replace(".","_")})).join(".").replace(W,".").replace(O,"").split(".")}(t);return E.set(r,e),e}();try{o=i.reduce((function(e,t){return e[t]}),e);}catch(e){}return void 0!==o?o:n}(e,r)};}if(!t&&"string"==typeof o&&o&&(t=o),!t&&e.columns)throw console.error(e),new Error('A column ID (or unique "Header" value) is required!');if(!t)throw console.error(e),new Error("A column ID (or string accessor) is required!");return Object.assign(e,{id:t,accessor:n}),e}function P(e,t){if(!t)throw new Error;return Object.assign(e,r({Header:a,Footer:a},c,{},t,{},e)),Object.assign(e,{originalWidth:e.width}),e}function B(e,t,n){void 0===n&&(n=function(){return {}});for(var o=[],i=e,u=0,l=function(){return u++},s=function(){var e={headers:[]},u=[],s=i.some((function(e){return e.parent}));i.forEach((function(o){var i,a=[].concat(u).reverse()[0];if(s){if(o.parent)i=r({},o.parent,{originalId:o.parent.id,id:o.parent.id+"_"+l(),headers:[o]},n(o));else i=P(r({originalId:o.id+"_placeholder",id:o.id+"_placeholder_"+l(),placeholderOf:o,headers:[o]},n(o)),t);a&&a.originalId===i.originalId?a.headers.push(o):u.push(i);}e.headers.push(o);})),o.push(e),i=u;};i.length;)s();return o.reverse()}var E=new Map;function I(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];for(var o=0;o<t.length;o+=1)if(void 0!==t[o])return t[o]}function F(e){if("function"==typeof e)return e}function G(e,t){var n=[];return function e(o){o.forEach((function(o){o[t]?e(o[t]):n.push(o);}));}(e),n}function A(e,t){var n=t.manualExpandedKey,o=t.expanded,r=t.expandSubRows,i=void 0===r||r,u=[];return e.forEach((function(e){return function e(t,r){void 0===r&&(r=!0),t.isExpanded=t.original&&t.original[n]||o[t.id],t.canExpand=t.subRows&&!!t.subRows.length,r&&u.push(t),t.subRows&&t.subRows.length&&t.isExpanded&&t.subRows.forEach((function(t){return e(t,i)}));}(e)})),u}function k(e,t,n){return F(e)||t[e]||n[e]||n.text}function H(e,t,n){return e?e(t,n):void 0===t}function T(){throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.")}var z=null;var W=/\[/g,O=/\]/g;var M=function(e){return r({role:"table"},e)},j=function(e){return r({role:"rowgroup"},e)},N=function(e,t){var n=t.column;return r({key:"header_"+n.id,colSpan:n.totalVisibleHeaderCount,role:"columnheader"},e)},L=function(e,t){var n=t.column;return r({key:"footer_"+n.id,colSpan:n.totalVisibleHeaderCount},e)},D=function(e,t){return r({key:"headerGroup_"+t.index,role:"row"},e)},V=function(e,t){return r({key:"footerGroup_"+t.index},e)},_=function(e,t){return r({key:"row_"+t.row.id,role:"row"},e)},X=function(e,t){var n=t.cell;return r({key:"cell_"+n.row.id+"_"+n.column.id,role:"cell"},e)};function q(){return {useOptions:[],stateReducers:[],useControlledState:[],columns:[],columnsDeps:[],allColumns:[],allColumnsDeps:[],accessValue:[],materializedColumns:[],materializedColumnsDeps:[],useInstanceAfterData:[],visibleColumns:[],visibleColumnsDeps:[],headerGroups:[],headerGroupsDeps:[],useInstanceBeforeDimensions:[],useInstance:[],prepareRow:[],getTableProps:[M],getTableBodyProps:[j],getHeaderGroupProps:[D],getFooterGroupProps:[V],getHeaderProps:[N],getFooterProps:[L],getRowProps:[_],getCellProps:[X],useFinalInstance:[]}}l.resetHiddenColumns="resetHiddenColumns",l.toggleHideColumn="toggleHideColumn",l.setHiddenColumns="setHiddenColumns",l.toggleHideAllColumns="toggleHideAllColumns";var K=function(e){e.getToggleHiddenProps=[U],e.getToggleHideAllColumnsProps=[$],e.stateReducers.push(J),e.useInstanceBeforeDimensions.push(Y),e.headerGroupsDeps.push((function(e,t){var n=t.instance;return [].concat(e,[n.state.hiddenColumns])})),e.useInstance.push(Q);};K.pluginName="useColumnVisibility";var U=function(e,t){var n=t.column;return [e,{onChange:function(e){n.toggleHidden(!e.target.checked);},style:{cursor:"pointer"},checked:n.isVisible,title:"Toggle Column Visible"}]},$=function(e,t){var n=t.instance;return [e,{onChange:function(e){n.toggleHideAllColumns(!e.target.checked);},style:{cursor:"pointer"},checked:!n.allColumnsHidden&&!n.state.hiddenColumns.length,title:"Toggle All Columns Hidden",indeterminate:!n.allColumnsHidden&&n.state.hiddenColumns.length}]};function J(e,t,n,o){if(t.type===l.init)return r({hiddenColumns:[]},e);if(t.type===l.resetHiddenColumns)return r({},e,{hiddenColumns:o.initialState.hiddenColumns||[]});if(t.type===l.toggleHideColumn){var i=(void 0!==t.value?t.value:!e.hiddenColumns.includes(t.columnId))?[].concat(e.hiddenColumns,[t.columnId]):e.hiddenColumns.filter((function(e){return e!==t.columnId}));return r({},e,{hiddenColumns:i})}return t.type===l.setHiddenColumns?r({},e,{hiddenColumns:m(t.value,e.hiddenColumns)}):t.type===l.toggleHideAllColumns?r({},e,{hiddenColumns:(void 0!==t.value?t.value:!e.hiddenColumns.length)?o.allColumns.map((function(e){return e.id})):[]}):void 0}function Y(e){var n=e.headers,o=e.state.hiddenColumns;t.useRef(!1).current;var r=0;n.forEach((function(e){return r+=function e(t,n){t.isVisible=n&&!o.includes(t.id);var r=0;return t.headers&&t.headers.length?t.headers.forEach((function(n){return r+=e(n,t.isVisible)})):r=t.isVisible?1:0,t.totalVisibleHeaderCount=r,r}(e,!0)}));}function Q(e){var n=e.columns,o=e.flatHeaders,r=e.dispatch,i=e.allColumns,u=e.getHooks,s=e.state.hiddenColumns,a=e.autoResetHiddenColumns,c=void 0===a||a,d=h(e),p=i.length===s.length,g=t.useCallback((function(e,t){return r({type:l.toggleHideColumn,columnId:e,value:t})}),[r]),v=t.useCallback((function(e){return r({type:l.setHiddenColumns,value:e})}),[r]),m=t.useCallback((function(e){return r({type:l.toggleHideAllColumns,value:e})}),[r]),y=f(u().getToggleHideAllColumnsProps,{instance:d()});o.forEach((function(e){e.toggleHidden=function(t){r({type:l.toggleHideColumn,columnId:e.id,value:t});},e.getToggleHiddenProps=f(u().getToggleHiddenProps,{instance:d(),column:e});}));var R=h(c);w((function(){R()&&r({type:l.resetHiddenColumns});}),[r,n]),Object.assign(e,{allColumnsHidden:p,toggleHideColumn:g,setHiddenColumns:v,toggleHideAllColumns:m,getToggleHideAllColumnsProps:y});}var Z={},ee={},te=function(e,t,n){return e},ne=function(e,t){return e.subRows||[]},oe=function(e,t,n){return ""+(n?[n.id,t].join("."):t)},re=function(e){return e};function ie(e){var t=e.initialState,n=void 0===t?Z:t,o=e.defaultColumn,u=void 0===o?ee:o,l=e.getSubRows,s=void 0===l?ne:l,a=e.getRowId,c=void 0===a?oe:a,d=e.stateReducer,f=void 0===d?te:d,p=e.useControlledState,g=void 0===p?re:p;return r({},i(e,["initialState","defaultColumn","getSubRows","getRowId","stateReducer","useControlledState"]),{initialState:n,defaultColumn:u,getSubRows:s,getRowId:c,stateReducer:f,useControlledState:g})}function ue(e,t){void 0===t&&(t=0);var n=0,o=0,r=0,i=0;return e.forEach((function(e){var u=e.headers;if(e.totalLeft=t,u&&u.length){var l=ue(u,t),s=l[0],a=l[1],c=l[2],d=l[3];e.totalMinWidth=s,e.totalWidth=a,e.totalMaxWidth=c,e.totalFlexWidth=d;}else e.totalMinWidth=e.minWidth,e.totalWidth=Math.min(Math.max(e.minWidth,e.width),e.maxWidth),e.totalMaxWidth=e.maxWidth,e.totalFlexWidth=e.canResize?e.totalWidth:0;e.isVisible&&(t+=e.totalWidth,n+=e.totalMinWidth,o+=e.totalWidth,r+=e.totalMaxWidth,i+=e.totalFlexWidth);})),[n,o,r,i]}function le(e){var t=e.data,n=e.rows,o=e.flatRows,r=e.rowsById,i=e.column,u=e.getRowId,l=e.getSubRows,s=e.accessValueHooks,a=e.getInstance;t.forEach((function(e,c){return function e(n,c,d,f,g){void 0===d&&(d=0);var v=n,m=u(n,c,f),h=r[m];if(h)h.subRows&&h.originalSubRows.forEach((function(t,n){return e(t,n,d+1,h)}));else if((h={id:m,original:v,index:c,depth:d,cells:[{}]}).cells.map=T,h.cells.filter=T,h.cells.forEach=T,h.cells[0].getCellProps=T,h.values={},g.push(h),o.push(h),r[m]=h,h.originalSubRows=l(n,c),h.originalSubRows){var y=[];h.originalSubRows.forEach((function(t,n){return e(t,n,d+1,h,y)})),h.subRows=y;}i.accessor&&(h.values[i.id]=i.accessor(n,c,h,g,t)),h.values[i.id]=p(s,h.values[i.id],{row:h,column:i,instance:a()});}(e,c,0,void 0,n)}));}l.resetExpanded="resetExpanded",l.toggleRowExpanded="toggleRowExpanded",l.toggleAllRowsExpanded="toggleAllRowsExpanded";var se=function(e){e.getToggleAllRowsExpandedProps=[ae],e.getToggleRowExpandedProps=[ce],e.stateReducers.push(de),e.useInstance.push(fe),e.prepareRow.push(pe);};se.pluginName="useExpanded";var ae=function(e,t){var n=t.instance;return [e,{onClick:function(e){n.toggleAllRowsExpanded();},style:{cursor:"pointer"},title:"Toggle All Rows Expanded"}]},ce=function(e,t){var n=t.row;return [e,{onClick:function(){n.toggleRowExpanded();},style:{cursor:"pointer"},title:"Toggle Row Expanded"}]};function de(e,t,n,o){if(t.type===l.init)return r({expanded:{}},e);if(t.type===l.resetExpanded)return r({},e,{expanded:o.initialState.expanded||{}});if(t.type===l.toggleAllRowsExpanded){var s=t.value,a=o.isAllRowsExpanded,c=o.rowsById;if(void 0!==s?s:!a){var d={};return Object.keys(c).forEach((function(e){d[e]=!0;})),r({},e,{expanded:d})}return r({},e,{expanded:{}})}if(t.type===l.toggleRowExpanded){var f,p=t.id,g=t.value,v=e.expanded[p],m=void 0!==g?g:!v;if(!v&&m)return r({},e,{expanded:r({},e.expanded,(f={},f[p]=!0,f))});if(v&&!m){var h=e.expanded;h[p];return r({},e,{expanded:i(h,[p].map(u))})}return e}}function fe(e){var n=e.data,o=e.rows,r=e.rowsById,i=e.manualExpandedKey,u=void 0===i?"expanded":i,s=e.paginateExpandedRows,a=void 0===s||s,c=e.expandSubRows,d=void 0===c||c,p=e.autoResetExpanded,g=void 0===p||p,m=e.getHooks,y=e.plugins,R=e.state.expanded,b=e.dispatch;v(y,["useSortBy","useGroupBy","usePivotColumns","useGlobalFilter"],"useExpanded");var S=h(g),C=Boolean(Object.keys(r).length&&Object.keys(R).length);C&&Object.keys(r).some((function(e){return !R[e]}))&&(C=!1),w((function(){S()&&b({type:l.resetExpanded});}),[b,n]);var x=t.useCallback((function(e,t){b({type:l.toggleRowExpanded,id:e,value:t});}),[b]),P=t.useCallback((function(e){return b({type:l.toggleAllRowsExpanded,value:e})}),[b]),B=t.useMemo((function(){return a?A(o,{manualExpandedKey:u,expanded:R,expandSubRows:d}):o}),[a,o,u,R,d]),E=t.useMemo((function(){return function(e){var t=0;return Object.keys(e).forEach((function(e){var n=e.split(".");t=Math.max(t,n.length);})),t}(R)}),[R]),I=h(e),F=f(m().getToggleAllRowsExpandedProps,{instance:I()});Object.assign(e,{preExpandedRows:o,expandedRows:B,rows:B,expandedDepth:E,isAllRowsExpanded:C,toggleRowExpanded:x,toggleAllRowsExpanded:P,getToggleAllRowsExpandedProps:F});}function pe(e,t){var n=t.instance.getHooks,o=t.instance;e.toggleRowExpanded=function(t){return o.toggleRowExpanded(e.id,t)},e.getToggleRowExpandedProps=f(n().getToggleRowExpandedProps,{instance:o,row:e});}var ge=function(e,t,n){return e=e.filter((function(e){return t.some((function(t){var o=e.values[t];return String(o).toLowerCase().includes(String(n).toLowerCase())}))}))};ge.autoRemove=function(e){return !e};var ve=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return void 0===o||String(o).toLowerCase()===String(n).toLowerCase()}))}))};ve.autoRemove=function(e){return !e};var me=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return void 0===o||String(o)===String(n)}))}))};me.autoRemove=function(e){return !e};var he=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t].includes(n)}))}))};he.autoRemove=function(e){return !e||!e.length};var ye=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return o&&o.length&&n.every((function(e){return o.includes(e)}))}))}))};ye.autoRemove=function(e){return !e||!e.length};var we=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return o&&o.length&&n.some((function(e){return o.includes(e)}))}))}))};we.autoRemove=function(e){return !e||!e.length};var Re=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return n.includes(o)}))}))};Re.autoRemove=function(e){return !e||!e.length};var be=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]===n}))}))};be.autoRemove=function(e){return void 0===e};var Se=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]==n}))}))};Se.autoRemove=function(e){return null==e};var Ce=function(e,t,n){var o=n||[],r=o[0],i=o[1];if((r="number"==typeof r?r:-1/0)>(i="number"==typeof i?i:1/0)){var u=r;r=i,i=u;}return e.filter((function(e){return t.some((function(t){var n=e.values[t];return n>=r&&n<=i}))}))};Ce.autoRemove=function(e){return !e||"number"!=typeof e[0]&&"number"!=typeof e[1]};var xe=Object.freeze({__proto__:null,text:ge,exactText:ve,exactTextCase:me,includes:he,includesAll:ye,includesSome:we,includesValue:Re,exact:be,equals:Se,between:Ce});l.resetFilters="resetFilters",l.setFilter="setFilter",l.setAllFilters="setAllFilters";var Pe=function(e){e.stateReducers.push(Be),e.useInstance.push(Ee);};function Be(e,t,n,o){if(t.type===l.init)return r({filters:[]},e);if(t.type===l.resetFilters)return r({},e,{filters:o.initialState.filters||[]});if(t.type===l.setFilter){var i=t.columnId,u=t.filterValue,s=o.allColumns,a=o.filterTypes,c=s.find((function(e){return e.id===i}));if(!c)throw new Error("React-Table: Could not find a column with id: "+i);var d=k(c.filter,a||{},xe),f=e.filters.find((function(e){return e.id===i})),p=m(u,f&&f.value);return H(d.autoRemove,p,c)?r({},e,{filters:e.filters.filter((function(e){return e.id!==i}))}):r({},e,f?{filters:e.filters.map((function(e){return e.id===i?{id:i,value:p}:e}))}:{filters:[].concat(e.filters,[{id:i,value:p}])})}if(t.type===l.setAllFilters){var g=t.filters,v=o.allColumns,h=o.filterTypes;return r({},e,{filters:m(g,e.filters).filter((function(e){var t=v.find((function(t){return t.id===e.id}));return !H(k(t.filter,h||{},xe).autoRemove,e.value,t)}))})}}function Ee(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.filterTypes,a=e.manualFilters,c=e.defaultCanFilter,d=void 0!==c&&c,f=e.disableFilters,p=e.state.filters,g=e.dispatch,v=e.autoResetFilters,m=void 0===v||v,y=t.useCallback((function(e,t){g({type:l.setFilter,columnId:e,filterValue:t});}),[g]),R=t.useCallback((function(e){g({type:l.setAllFilters,filters:e});}),[g]);u.forEach((function(e){var t=e.id,n=e.accessor,o=e.defaultCanFilter,r=e.disableFilters;e.canFilter=n?I(!0!==r&&void 0,!0!==f&&void 0,!0):I(o,d,!1),e.setFilter=function(t){return y(e.id,t)};var i=p.find((function(e){return e.id===t}));e.filterValue=i&&i.value;}));var b=t.useMemo((function(){if(a||!p.length)return [o,r,i];var e=[],t={};return [function n(o,r){void 0===r&&(r=0);var i=o;return (i=p.reduce((function(e,t){var n=t.id,o=t.value,i=u.find((function(e){return e.id===n}));if(!i)return e;0===r&&(i.preFilteredRows=e);var l=k(i.filter,s||{},xe);return l?(i.filteredRows=l(e,[n],o),i.filteredRows):(console.warn("Could not find a valid 'column.filter' for column with the ID: "+i.id+"."),e)}),o)).forEach((function(o){e.push(o),t[o.id]=o,o.subRows&&(o.subRows=o.subRows&&o.subRows.length>0?n(o.subRows,r+1):o.subRows);})),i}(o),e,t]}),[a,p,o,r,i,u,s]),S=b[0],C=b[1],x=b[2];t.useMemo((function(){u.filter((function(e){return !p.find((function(t){return t.id===e.id}))})).forEach((function(e){e.preFilteredRows=S,e.filteredRows=S;}));}),[S,p,u]);var P=h(m);w((function(){P()&&g({type:l.resetFilters});}),[g,a?null:n]),Object.assign(e,{preFilteredRows:o,preFilteredFlatRows:r,preFilteredRowsById:i,filteredRows:S,filteredFlatRows:C,filteredRowsById:x,rows:S,flatRows:C,rowsById:x,setFilter:y,setAllFilters:R});}Pe.pluginName="useFilters",l.resetGlobalFilter="resetGlobalFilter",l.setGlobalFilter="setGlobalFilter";var Ie=function(e){e.stateReducers.push(Fe),e.useInstance.push(Ge);};function Fe(e,t,n,o){if(t.type===l.resetGlobalFilter)return r({},e,{globalFilter:o.initialState.globalFilter||void 0});if(t.type===l.setGlobalFilter){var u=t.filterValue,s=o.userFilterTypes,a=k(o.globalFilter,s||{},xe),c=m(u,e.globalFilter);if(H(a.autoRemove,c)){e.globalFilter;return i(e,["globalFilter"])}return r({},e,{globalFilter:c})}}function Ge(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.filterTypes,a=e.globalFilter,c=e.manualGlobalFilter,d=e.state.globalFilter,f=e.dispatch,p=e.autoResetGlobalFilter,g=void 0===p||p,v=e.disableGlobalFilter,m=t.useCallback((function(e){f({type:l.setGlobalFilter,filterValue:e});}),[f]),y=t.useMemo((function(){if(c||void 0===d)return [o,r,i];var e=[],t={},n=k(a,s||{},xe);if(!n)return console.warn("Could not find a valid 'globalFilter' option."),o;u.forEach((function(e){var t=e.disableGlobalFilter;e.canFilter=I(!0!==t&&void 0,!0!==v&&void 0,!0);}));var l=u.filter((function(e){return !0===e.canFilter}));return [function o(r){return (r=n(r,l.map((function(e){return e.id})),d)).forEach((function(n){e.push(n),t[n.id]=n,n.subRows=n.subRows&&n.subRows.length?o(n.subRows):n.subRows;})),r}(o),e,t]}),[c,d,a,s,u,o,r,i,v]),R=y[0],b=y[1],S=y[2],C=h(g);w((function(){C()&&f({type:l.resetGlobalFilter});}),[f,c?null:n]),Object.assign(e,{preGlobalFilteredRows:o,preGlobalFilteredFlatRows:r,preGlobalFilteredRowsById:i,globalFilteredRows:R,globalFilteredFlatRows:b,globalFilteredRowsById:S,rows:R,flatRows:b,rowsById:S,setGlobalFilter:m,disableGlobalFilter:v});}function Ae(e,t){return t.reduce((function(e,t){return e+("number"==typeof t?t:0)}),0)}Ie.pluginName="useGlobalFilter";var ke=Object.freeze({__proto__:null,sum:Ae,min:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e));})),t},max:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.max(t,e));})),t},minMax:function(e){var t=e[0]||0,n=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e),n=Math.max(n,e));})),t+".."+n},average:function(e){return Ae(0,e)/e.length},median:function(e){if(!e.length)return null;var t=Math.floor(e.length/2),n=[].concat(e).sort((function(e,t){return e-t}));return e.length%2!=0?n[t]:(n[t-1]+n[t])/2},unique:function(e){return Array.from(new Set(e).values())},uniqueCount:function(e){return new Set(e).size},count:function(e){return e.length}}),He=[],Te={};l.resetGroupBy="resetGroupBy",l.setGroupBy="setGroupBy",l.toggleGroupBy="toggleGroupBy";var ze=function(e){e.getGroupByToggleProps=[We],e.stateReducers.push(Oe),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return [].concat(e,[n.state.groupBy])})),e.visibleColumns.push(Me),e.useInstance.push(Ne),e.prepareRow.push(Le);};ze.pluginName="useGroupBy";var We=function(e,t){var n=t.header;return [e,{onClick:n.canGroupBy?function(e){e.persist(),n.toggleGroupBy();}:void 0,style:{cursor:n.canGroupBy?"pointer":void 0},title:"Toggle GroupBy"}]};function Oe(e,t,n,o){if(t.type===l.init)return r({groupBy:[]},e);if(t.type===l.resetGroupBy)return r({},e,{groupBy:o.initialState.groupBy||[]});if(t.type===l.setGroupBy)return r({},e,{groupBy:t.value});if(t.type===l.toggleGroupBy){var i=t.columnId,u=t.value,s=void 0!==u?u:!e.groupBy.includes(i);return r({},e,s?{groupBy:[].concat(e.groupBy,[i])}:{groupBy:e.groupBy.filter((function(e){return e!==i}))})}}function Me(e,t){var n=t.instance.state.groupBy,o=n.map((function(t){return e.find((function(e){return e.id===t}))})).filter(Boolean),r=e.filter((function(e){return !n.includes(e.id)}));return (e=[].concat(o,r)).forEach((function(e){e.isGrouped=n.includes(e.id),e.groupedIndex=n.indexOf(e.id);})),e}var je={};function Ne(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.flatHeaders,a=e.groupByFn,c=void 0===a?De:a,d=e.manualGroupBy,p=e.aggregations,g=void 0===p?je:p,m=e.plugins,y=e.state.groupBy,R=e.dispatch,b=e.autoResetGroupBy,S=void 0===b||b,C=e.disableGroupBy,x=e.defaultCanGroupBy,P=e.getHooks;v(m,["useColumnOrder","useFilters"],"useGroupBy");var B=h(e);u.forEach((function(t){var n=t.accessor,o=t.defaultGroupBy,r=t.disableGroupBy;t.canGroupBy=n?I(t.canGroupBy,!0!==r&&void 0,!0!==C&&void 0,!0):I(t.canGroupBy,o,x,!1),t.canGroupBy&&(t.toggleGroupBy=function(){return e.toggleGroupBy(t.id)}),t.Aggregated=t.Aggregated||t.Cell;}));var E=t.useCallback((function(e,t){R({type:l.toggleGroupBy,columnId:e,value:t});}),[R]),F=t.useCallback((function(e){R({type:l.setGroupBy,value:e});}),[R]);s.forEach((function(e){e.getGroupByToggleProps=f(P().getGroupByToggleProps,{instance:B(),header:e});}));var A=t.useMemo((function(){if(d||!y.length)return [o,r,i,He,Te,r,i];var e=y.filter((function(e){return u.find((function(t){return t.id===e}))})),t=[],n={},l=[],s={},a=[],f={},p=function o(r,i,d){if(void 0===i&&(i=0),i===e.length)return r;var p=e[i],v=c(r,p);return Object.entries(v).map((function(r,c){var v=r[0],m=r[1],h=p+":"+v,y=o(m,i+1,h=d?d+">"+h:h),w=i?G(m,"leafRows"):m,R=function(t,n,o){var r={};return u.forEach((function(i){if(e.includes(i.id))r[i.id]=n[0]?n[0].values[i.id]:null;else {var u="function"==typeof i.aggregate?i.aggregate:g[i.aggregate]||ke[i.aggregate];if(u){var l=n.map((function(e){return e.values[i.id]})),s=t.map((function(e){var t=e.values[i.id];if(!o&&i.aggregateValue){var n="function"==typeof i.aggregateValue?i.aggregateValue:g[i.aggregateValue]||ke[i.aggregateValue];if(!n)throw console.info({column:i}),new Error("React Table: Invalid column.aggregateValue option for column listed above");t=n(t,e,i);}return t}));r[i.id]=u(s,l);}else {if(i.aggregate)throw console.info({column:i}),new Error("React Table: Invalid column.aggregate option for column listed above");r[i.id]=null;}}})),r}(w,m,i),b={id:h,isGrouped:!0,groupByID:p,groupByVal:v,values:R,subRows:y,leafRows:w,depth:i,index:c};return y.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(l.push(e),s[e.id]=e):(a.push(e),f[e.id]=e);})),b}))}(o);return p.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(l.push(e),s[e.id]=e):(a.push(e),f[e.id]=e);})),[p,t,n,l,s,a,f]}),[d,y,o,r,i,u,g,c]),k=A[0],H=A[1],T=A[2],z=A[3],W=A[4],O=A[5],M=A[6],j=h(S);w((function(){j()&&R({type:l.resetGroupBy});}),[R,d?null:n]),Object.assign(e,{preGroupedRows:o,preGroupedFlatRow:r,preGroupedRowsById:i,groupedRows:k,groupedFlatRows:H,groupedRowsById:T,onlyGroupedFlatRows:z,onlyGroupedRowsById:W,nonGroupedFlatRows:O,nonGroupedRowsById:M,rows:k,flatRows:H,rowsById:T,toggleGroupBy:E,setGroupBy:F});}function Le(e){e.allCells.forEach((function(t){var n;t.isGrouped=t.column.isGrouped&&t.column.id===e.groupByID,t.isPlaceholder=!t.isGrouped&&t.column.isGrouped,t.isAggregated=!t.isGrouped&&!t.isPlaceholder&&(null==(n=e.subRows)?void 0:n.length);}));}function De(e,t){return e.reduce((function(e,n,o){var r=""+n.values[t];return e[r]=Array.isArray(e[r])?e[r]:[],e[r].push(n),e}),{})}var Ve=/([0-9]+)/gm;function _e(e,t){return e===t?0:e>t?1:-1}function Xe(e,t,n){return [e.values[n],t.values[n]]}function qe(e){return "number"==typeof e?isNaN(e)||e===1/0||e===-1/0?"":String(e):"string"==typeof e?e:""}var Ke=Object.freeze({__proto__:null,alphanumeric:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];for(r=qe(r),i=qe(i),r=r.split(Ve).filter(Boolean),i=i.split(Ve).filter(Boolean);r.length&&i.length;){var u=r.shift(),l=i.shift(),s=parseInt(u,10),a=parseInt(l,10),c=[s,a].sort();if(isNaN(c[0])){if(u>l)return 1;if(l>u)return -1}else {if(isNaN(c[1]))return isNaN(s)?-1:1;if(s>a)return 1;if(a>s)return -1}}return r.length-i.length},datetime:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];return _e(r=r.getTime(),i=i.getTime())},basic:function(e,t,n){var o=Xe(e,t,n);return _e(o[0],o[1])},string:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];for(r=r.split("").filter(Boolean),i=i.split("").filter(Boolean);r.length&&i.length;){var u=r.shift(),l=i.shift(),s=u.toLowerCase(),a=l.toLowerCase();if(s>a)return 1;if(a>s)return -1;if(u>l)return 1;if(l>u)return -1}return r.length-i.length},number:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1],u=/[^0-9.]/gi;return _e(r=Number(String(r).replace(u,"")),i=Number(String(i).replace(u,"")))}});l.resetSortBy="resetSortBy",l.setSortBy="setSortBy",l.toggleSortBy="toggleSortBy",l.clearSortBy="clearSortBy",c.sortType="alphanumeric",c.sortDescFirst=!1;var Ue=function(e){e.getSortByToggleProps=[$e],e.stateReducers.push(Je),e.useInstance.push(Ye);};Ue.pluginName="useSortBy";var $e=function(e,t){var n=t.instance,o=t.column,r=n.isMultiSortEvent,i=void 0===r?function(e){return e.shiftKey}:r;return [e,{onClick:o.canSort?function(e){e.persist(),o.toggleSortBy(void 0,!n.disableMultiSort&&i(e));}:void 0,style:{cursor:o.canSort?"pointer":void 0},title:o.canSort?"Toggle SortBy":void 0}]};function Je(e,t,n,o){if(t.type===l.init)return r({sortBy:[]},e);if(t.type===l.resetSortBy)return r({},e,{sortBy:o.initialState.sortBy||[]});if(t.type===l.clearSortBy)return r({},e,{sortBy:e.sortBy.filter((function(e){return e.id!==t.columnId}))});if(t.type===l.setSortBy)return r({},e,{sortBy:t.sortBy});if(t.type===l.toggleSortBy){var i,u=t.columnId,s=t.desc,a=t.multi,c=o.allColumns,d=o.disableMultiSort,f=o.disableSortRemove,p=o.disableMultiRemove,g=o.maxMultiSortColCount,v=void 0===g?Number.MAX_SAFE_INTEGER:g,m=e.sortBy,h=c.find((function(e){return e.id===u})).sortDescFirst,y=m.find((function(e){return e.id===u})),w=m.findIndex((function(e){return e.id===u})),R=null!=s,b=[];return "toggle"!==(i=!d&&a?y?"toggle":"add":w!==m.length-1||1!==m.length?"replace":y?"toggle":"replace")||f||R||a&&p||!(y&&y.desc&&!h||!y.desc&&h)||(i="remove"),"replace"===i?b=[{id:u,desc:R?s:h}]:"add"===i?(b=[].concat(m,[{id:u,desc:R?s:h}])).splice(0,b.length-v):"toggle"===i?b=m.map((function(e){return e.id===u?r({},e,{desc:R?s:!y.desc}):e})):"remove"===i&&(b=m.filter((function(e){return e.id!==u}))),r({},e,{sortBy:b})}}function Ye(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.allColumns,u=e.orderByFn,s=void 0===u?Qe:u,a=e.sortTypes,c=e.manualSortBy,d=e.defaultCanSort,p=e.disableSortBy,g=e.flatHeaders,m=e.state.sortBy,y=e.dispatch,R=e.plugins,b=e.getHooks,S=e.autoResetSortBy,C=void 0===S||S;v(R,["useFilters","useGlobalFilter","useGroupBy","usePivotColumns"],"useSortBy");var x=t.useCallback((function(e){y({type:l.setSortBy,sortBy:e});}),[y]),P=t.useCallback((function(e,t,n){y({type:l.toggleSortBy,columnId:e,desc:t,multi:n});}),[y]),B=h(e);g.forEach((function(e){var t=e.accessor,n=e.canSort,o=e.disableSortBy,r=e.id,i=t?I(!0!==o&&void 0,!0!==p&&void 0,!0):I(d,n,!1);e.canSort=i,e.canSort&&(e.toggleSortBy=function(t,n){return P(e.id,t,n)},e.clearSortBy=function(){y({type:l.clearSortBy,columnId:e.id});}),e.getSortByToggleProps=f(b().getSortByToggleProps,{instance:B(),column:e});var u=m.find((function(e){return e.id===r}));e.isSorted=!!u,e.sortedIndex=m.findIndex((function(e){return e.id===r})),e.isSortedDesc=e.isSorted?u.desc:void 0;}));var E=t.useMemo((function(){if(c||!m.length)return [o,r];var e=[],t=m.filter((function(e){return i.find((function(t){return t.id===e.id}))}));return [function n(o){var r=s(o,t.map((function(e){var t=i.find((function(t){return t.id===e.id}));if(!t)throw new Error("React-Table: Could not find a column with id: "+e.id+" while sorting");var n=t.sortType,o=F(n)||(a||{})[n]||Ke[n];if(!o)throw new Error("React-Table: Could not find a valid sortType of '"+n+"' for column '"+e.id+"'.");return function(t,n){return o(t,n,e.id,e.desc)}})),t.map((function(e){var t=i.find((function(t){return t.id===e.id}));return t&&t.sortInverted?e.desc:!e.desc})));return r.forEach((function(t){e.push(t),t.subRows&&0!==t.subRows.length&&(t.subRows=n(t.subRows));})),r}(o),e]}),[c,m,o,r,i,s,a]),G=E[0],A=E[1],k=h(C);w((function(){k()&&y({type:l.resetSortBy});}),[c?null:n]),Object.assign(e,{preSortedRows:o,preSortedFlatRows:r,sortedRows:G,sortedFlatRows:A,rows:G,flatRows:A,setSortBy:x,toggleSortBy:P});}function Qe(e,t,n){return [].concat(e).sort((function(e,o){for(var r=0;r<t.length;r+=1){var i=t[r],u=!1===n[r]||"desc"===n[r],l=i(e,o);if(0!==l)return u?-l:l}return n[0]?e.index-o.index:o.index-e.index}))}l.resetPage="resetPage",l.gotoPage="gotoPage",l.setPageSize="setPageSize";var Ze=function(e){e.stateReducers.push(et),e.useInstance.push(tt);};function et(e,t,n,o){if(t.type===l.init)return r({pageSize:10,pageIndex:0},e);if(t.type===l.resetPage)return r({},e,{pageIndex:o.initialState.pageIndex||0});if(t.type===l.gotoPage){var i=o.pageCount,u=o.page,s=m(t.pageIndex,e.pageIndex),a=!1;return s>e.pageIndex?a=-1===i?u.length>=e.pageSize:s<i:s<e.pageIndex&&(a=s>-1),a?r({},e,{pageIndex:s}):e}if(t.type===l.setPageSize){var c=t.pageSize,d=e.pageSize*e.pageIndex;return r({},e,{pageIndex:Math.floor(d/c),pageSize:c})}}function tt(e){var n=e.rows,o=e.autoResetPage,r=void 0===o||o,i=e.manualExpandedKey,u=void 0===i?"expanded":i,s=e.plugins,a=e.pageCount,c=e.paginateExpandedRows,d=void 0===c||c,f=e.expandSubRows,p=void 0===f||f,g=e.state,m=g.pageSize,y=g.pageIndex,R=g.expanded,b=g.globalFilter,S=g.filters,C=g.groupBy,x=g.sortBy,P=e.dispatch,B=e.data,E=e.manualPagination;v(s,["useGlobalFilter","useFilters","useGroupBy","useSortBy","useExpanded"],"usePagination");var I=h(r);w((function(){I()&&P({type:l.resetPage});}),[P,E?null:B,b,S,C,x]);var F=E?a:Math.ceil(n.length/m),G=t.useMemo((function(){return F>0?[].concat(new Array(F)).fill(null).map((function(e,t){return t})):[]}),[F]),k=t.useMemo((function(){var e;if(E)e=n;else {var t=m*y,o=t+m;e=n.slice(t,o);}return d?e:A(e,{manualExpandedKey:u,expanded:R,expandSubRows:p})}),[p,R,u,E,y,m,d,n]),H=y>0,T=-1===F?k.length>=m:y<F-1,z=t.useCallback((function(e){P({type:l.gotoPage,pageIndex:e});}),[P]),W=t.useCallback((function(){return z((function(e){return e-1}))}),[z]),O=t.useCallback((function(){return z((function(e){return e+1}))}),[z]),M=t.useCallback((function(e){P({type:l.setPageSize,pageSize:e});}),[P]);Object.assign(e,{pageOptions:G,pageCount:F,page:k,canPreviousPage:H,canNextPage:T,gotoPage:z,previousPage:W,nextPage:O,setPageSize:M});}Ze.pluginName="usePagination",l.resetPivot="resetPivot",l.togglePivot="togglePivot";var nt=function(e){e.getPivotToggleProps=[rt],e.stateReducers.push(it),e.useInstanceAfterData.push(ut),e.allColumns.push(lt),e.accessValue.push(st),e.materializedColumns.push(at),e.materializedColumnsDeps.push(ct),e.visibleColumns.push(dt),e.visibleColumnsDeps.push(ft),e.useInstance.push(pt),e.prepareRow.push(gt);};nt.pluginName="usePivotColumns";var ot=[],rt=function(e,t){var n=t.header;return [e,{onClick:n.canPivot?function(e){e.persist(),n.togglePivot();}:void 0,style:{cursor:n.canPivot?"pointer":void 0},title:"Toggle Pivot"}]};function it(e,t,n,o){if(t.type===l.init)return r({pivotColumns:ot},e);if(t.type===l.resetPivot)return r({},e,{pivotColumns:o.initialState.pivotColumns||ot});if(t.type===l.togglePivot){var i=t.columnId,u=t.value,s=void 0!==u?u:!e.pivotColumns.includes(i);return r({},e,s?{pivotColumns:[].concat(e.pivotColumns,[i])}:{pivotColumns:e.pivotColumns.filter((function(e){return e!==i}))})}}function ut(e){e.allColumns.forEach((function(t){t.isPivotSource=e.state.pivotColumns.includes(t.id);}));}function lt(e,t){var n=t.instance;return e.forEach((function(e){e.isPivotSource=n.state.pivotColumns.includes(e.id),e.uniqueValues=new Set;})),e}function st(e,t){var n=t.column;return n.uniqueValues&&void 0!==e&&n.uniqueValues.add(e),e}function at(e,t){var n=t.instance,o=n.allColumns,i=n.state;if(!i.pivotColumns.length||!i.groupBy||!i.groupBy.length)return e;var u=i.pivotColumns.map((function(e){return o.find((function(t){return t.id===e}))})).filter(Boolean),l=o.filter((function(e){return !e.isPivotSource&&!i.groupBy.includes(e.id)&&!i.pivotColumns.includes(e.id)})),s=C(function e(t,n,o){void 0===t&&(t=0),void 0===o&&(o=[]);var i=u[t];return i?Array.from(i.uniqueValues).sort().map((function(u){var l=r({},i,{Header:i.PivotHeader||"string"==typeof i.header?i.Header+": "+u:u,isPivotGroup:!0,parent:n,depth:t,id:n?n.id+"."+i.id+"."+u:i.id+"."+u,pivotValue:u});return l.columns=e(t+1,l,[].concat(o,[function(e){return e.values[i.id]===u}])),l})):l.map((function(e){return r({},e,{canPivot:!1,isPivoted:!0,parent:n,depth:t,id:""+(n?n.id+"."+e.id:e.id),accessor:function(t,n,r){if(o.every((function(e){return e(r)})))return r.values[e.id]}})}))}());return [].concat(e,s)}function ct(e,t){var n=t.instance.state,o=n.pivotColumns,r=n.groupBy;return [].concat(e,[o,r])}function dt(e,t){var n=t.instance.state;return e=e.filter((function(e){return !e.isPivotSource})),n.pivotColumns.length&&n.groupBy&&n.groupBy.length&&(e=e.filter((function(e){return e.isGrouped||e.isPivoted}))),e}function ft(e,t){var n=t.instance;return [].concat(e,[n.state.pivotColumns,n.state.groupBy])}function pt(e){var t=e.columns,n=e.allColumns,o=e.flatHeaders,r=e.getHooks,i=e.plugins,u=e.dispatch,s=e.autoResetPivot,a=void 0===s||s,c=e.manaulPivot,d=e.disablePivot,p=e.defaultCanPivot;v(i,["useGroupBy"],"usePivotColumns");var g=h(e);n.forEach((function(t){var n=t.accessor,o=t.defaultPivot,r=t.disablePivot;t.canPivot=n?I(t.canPivot,!0!==r&&void 0,!0!==d&&void 0,!0):I(t.canPivot,o,p,!1),t.canPivot&&(t.togglePivot=function(){return e.togglePivot(t.id)}),t.Aggregated=t.Aggregated||t.Cell;}));o.forEach((function(e){e.getPivotToggleProps=f(r().getPivotToggleProps,{instance:g(),header:e});}));var m=h(a);w((function(){m()&&u({type:l.resetPivot});}),[u,c?null:t]),Object.assign(e,{togglePivot:function(e,t){u({type:l.togglePivot,columnId:e,value:t});}});}function gt(e){e.allCells.forEach((function(e){e.isPivoted=e.column.isPivoted;}));}l.resetSelectedRows="resetSelectedRows",l.toggleAllRowsSelected="toggleAllRowsSelected",l.toggleRowSelected="toggleRowSelected",l.toggleAllPageRowsSelected="toggleAllPageRowsSelected";var vt=function(e){e.getToggleRowSelectedProps=[mt],e.getToggleAllRowsSelectedProps=[ht],e.getToggleAllPageRowsSelectedProps=[yt],e.stateReducers.push(wt),e.useInstance.push(Rt),e.prepareRow.push(bt);};vt.pluginName="useRowSelect";var mt=function(e,t){var n=t.instance,o=t.row,r=n.manualRowSelectedKey,i=void 0===r?"isSelected":r;return [e,{onChange:function(e){o.toggleRowSelected(e.target.checked);},style:{cursor:"pointer"},checked:!(!o.original||!o.original[i])||o.isSelected,title:"Toggle Row Selected",indeterminate:o.isSomeSelected}]},ht=function(e,t){var n=t.instance;return [e,{onChange:function(e){n.toggleAllRowsSelected(e.target.checked);},style:{cursor:"pointer"},checked:n.isAllRowsSelected,title:"Toggle All Rows Selected",indeterminate:Boolean(!n.isAllRowsSelected&&Object.keys(n.state.selectedRowIds).length)}]},yt=function(e,t){var n=t.instance;return [e,{onChange:function(e){n.toggleAllPageRowsSelected(e.target.checked);},style:{cursor:"pointer"},checked:n.isAllPageRowsSelected,title:"Toggle All Current Page Rows Selected",indeterminate:Boolean(!n.isAllPageRowsSelected&&n.page.some((function(e){var t=e.id;return n.state.selectedRowIds[t]})))}]};function wt(e,t,n,o){if(t.type===l.init)return r({selectedRowIds:{}},e);if(t.type===l.resetSelectedRows)return r({},e,{selectedRowIds:o.initialState.selectedRowIds||{}});if(t.type===l.toggleAllRowsSelected){var i=t.value,u=o.isAllRowsSelected,s=o.rowsById,a=o.nonGroupedRowsById,c=void 0===a?s:a,d=void 0!==i?i:!u,f=Object.assign({},e.selectedRowIds);return d?Object.keys(c).forEach((function(e){f[e]=!0;})):Object.keys(c).forEach((function(e){delete f[e];})),r({},e,{selectedRowIds:f})}if(t.type===l.toggleRowSelected){var p=t.id,g=t.value,v=o.rowsById,m=o.selectSubRows,h=void 0===m||m,y=o.getSubRows,w=e.selectedRowIds[p],R=void 0!==g?g:!w;if(w===R)return e;var b=r({},e.selectedRowIds);return function e(t){var n=v[t];if(n.isGrouped||(R?b[t]=!0:delete b[t]),h&&y(n))return y(n).forEach((function(t){return e(t.id)}))}(p),r({},e,{selectedRowIds:b})}if(t.type===l.toggleAllPageRowsSelected){var S=t.value,C=o.page,x=o.rowsById,P=o.selectSubRows,B=void 0===P||P,E=o.isAllPageRowsSelected,I=o.getSubRows,F=void 0!==S?S:!E,G=r({},e.selectedRowIds);return C.forEach((function(e){return function e(t){var n=x[t];if(n.isGrouped||(F?G[t]=!0:delete G[t]),B&&I(n))return I(n).forEach((function(t){return e(t.id)}))}(e.id)})),r({},e,{selectedRowIds:G})}return e}function Rt(e){var n=e.data,o=e.rows,r=e.getHooks,i=e.plugins,u=e.rowsById,s=e.nonGroupedRowsById,a=void 0===s?u:s,c=e.autoResetSelectedRows,d=void 0===c||c,p=e.state.selectedRowIds,g=e.selectSubRows,m=void 0===g||g,y=e.dispatch,R=e.page,b=e.getSubRows;v(i,["useFilters","useGroupBy","useSortBy","useExpanded","usePagination"],"useRowSelect");var S=t.useMemo((function(){var e=[];return o.forEach((function(t){var n=m?function e(t,n,o){if(n[t.id])return !0;var r=o(t);if(r&&r.length){var i=!0,u=!1;return r.forEach((function(t){u&&!i||(e(t,n,o)?u=!0:i=!1);})),!!i||!!u&&null}return !1}(t,p,b):!!p[t.id];t.isSelected=!!n,t.isSomeSelected=null===n,n&&e.push(t);})),e}),[o,m,p,b]),C=Boolean(Object.keys(a).length&&Object.keys(p).length),x=C;C&&Object.keys(a).some((function(e){return !p[e]}))&&(C=!1),C||R&&R.length&&R.some((function(e){var t=e.id;return !p[t]}))&&(x=!1);var P=h(d);w((function(){P()&&y({type:l.resetSelectedRows});}),[y,n]);var B=t.useCallback((function(e){return y({type:l.toggleAllRowsSelected,value:e})}),[y]),E=t.useCallback((function(e){return y({type:l.toggleAllPageRowsSelected,value:e})}),[y]),I=t.useCallback((function(e,t){return y({type:l.toggleRowSelected,id:e,value:t})}),[y]),F=h(e),G=f(r().getToggleAllRowsSelectedProps,{instance:F()}),A=f(r().getToggleAllPageRowsSelectedProps,{instance:F()});Object.assign(e,{selectedFlatRows:S,isAllRowsSelected:C,isAllPageRowsSelected:x,toggleRowSelected:I,toggleAllRowsSelected:B,getToggleAllRowsSelectedProps:G,getToggleAllPageRowsSelectedProps:A,toggleAllPageRowsSelected:E});}function bt(e,t){var n=t.instance;e.toggleRowSelected=function(t){return n.toggleRowSelected(e.id,t)},e.getToggleRowSelectedProps=f(n.getHooks().getToggleRowSelectedProps,{instance:n,row:e});}var St=function(e){return {}},Ct=function(e){return {}};l.setRowState="setRowState",l.setCellState="setCellState",l.resetRowState="resetRowState";var xt=function(e){e.stateReducers.push(Pt),e.useInstance.push(Bt),e.prepareRow.push(Et);};function Pt(e,t,n,o){var i=o.initialRowStateAccessor,u=void 0===i?St:i,s=o.initialCellStateAccessor,a=void 0===s?Ct:s,c=o.rowsById;if(t.type===l.init)return r({rowState:{}},e);if(t.type===l.resetRowState)return r({},e,{rowState:o.initialState.rowState||{}});if(t.type===l.setRowState){var d,f=t.rowId,p=t.value,g=void 0!==e.rowState[f]?e.rowState[f]:u(c[f]);return r({},e,{rowState:r({},e.rowState,(d={},d[f]=m(p,g),d))})}if(t.type===l.setCellState){var v,h,y,w,R,b=t.rowId,S=t.columnId,C=t.value,x=void 0!==e.rowState[b]?e.rowState[b]:u(c[b]),P=void 0!==(null==x?void 0:null==(v=x.cellState)?void 0:v[S])?x.cellState[S]:a(null==(h=c[b])?void 0:null==(y=h.cells)?void 0:y.find((function(e){return e.column.id===S})));return r({},e,{rowState:r({},e.rowState,(R={},R[b]=r({},x,{cellState:r({},x.cellState||{},(w={},w[S]=m(C,P),w))}),R))})}}function Bt(e){var n=e.autoResetRowState,o=void 0===n||n,r=e.data,i=e.dispatch,u=t.useCallback((function(e,t){return i({type:l.setRowState,rowId:e,value:t})}),[i]),s=t.useCallback((function(e,t,n){return i({type:l.setCellState,rowId:e,columnId:t,value:n})}),[i]),a=h(o);w((function(){a()&&i({type:l.resetRowState});}),[r]),Object.assign(e,{setRowState:u,setCellState:s});}function Et(e,t){var n=t.instance,o=n.initialRowStateAccessor,r=void 0===o?St:o,i=n.initialCellStateAccessor,u=void 0===i?Ct:i,l=n.state.rowState;e&&(e.state=void 0!==l[e.id]?l[e.id]:r(e),e.setState=function(t){return n.setRowState(e.id,t)},e.cells.forEach((function(t){e.state.cellState||(e.state.cellState={}),t.state=void 0!==e.state.cellState[t.column.id]?e.state.cellState[t.column.id]:u(t),t.setState=function(o){return n.setCellState(e.id,t.column.id,o)};})));}xt.pluginName="useRowState",l.resetColumnOrder="resetColumnOrder",l.setColumnOrder="setColumnOrder";var It=function(e){e.stateReducers.push(Ft),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return [].concat(e,[n.state.columnOrder])})),e.visibleColumns.push(Gt),e.useInstance.push(At);};function Ft(e,t,n,o){return t.type===l.init?r({columnOrder:[]},e):t.type===l.resetColumnOrder?r({},e,{columnOrder:o.initialState.columnOrder||[]}):t.type===l.setColumnOrder?r({},e,{columnOrder:m(t.columnOrder,e.columnOrder)}):void 0}function Gt(e,t){var n=t.instance.state.columnOrder;if(!n||!n.length)return e;for(var o=[].concat(n),r=[].concat(e),i=[],u=function(){var e=o.shift(),t=r.findIndex((function(t){return t.id===e}));t>-1&&i.push(r.splice(t,1)[0]);};r.length&&o.length;)u();return [].concat(i,r)}function At(e){var n=e.dispatch;e.setColumnOrder=t.useCallback((function(e){return n({type:l.setColumnOrder,columnOrder:e})}),[n]);}It.pluginName="useColumnOrder",c.canResize=!0,l.columnStartResizing="columnStartResizing",l.columnResizing="columnResizing",l.columnDoneResizing="columnDoneResizing",l.resetResize="resetResize";var kt=function(e){e.getResizerProps=[Ht],e.getHeaderProps.push({style:{position:"relative"}}),e.stateReducers.push(Tt),e.useInstance.push(Wt),e.useInstanceBeforeDimensions.push(zt);},Ht=function(e,t){var n=t.instance,o=t.header,r=n.dispatch,i=function(e,t){var n=!1;if("touchstart"===e.type){if(e.touches&&e.touches.length>1)return;n=!0;}var o=function(e){var t=[];return function e(n){n.columns&&n.columns.length&&n.columns.map(e);t.push(n);}(e),t}(t).map((function(e){return [e.id,e.totalWidth]})),i=n?Math.round(e.touches[0].clientX):e.clientX,u=function(e){r({type:l.columnResizing,clientX:e});},s=function(){return r({type:l.columnDoneResizing})},a={mouse:{moveEvent:"mousemove",moveHandler:function(e){return u(e.clientX)},upEvent:"mouseup",upHandler:function(e){document.removeEventListener("mousemove",a.mouse.moveHandler),document.removeEventListener("mouseup",a.mouse.upHandler),s();}},touch:{moveEvent:"touchmove",moveHandler:function(e){return e.cancelable&&(e.preventDefault(),e.stopPropagation()),u(e.touches[0].clientX),!1},upEvent:"touchend",upHandler:function(e){document.removeEventListener(a.touch.moveEvent,a.touch.moveHandler),document.removeEventListener(a.touch.upEvent,a.touch.moveHandler),s();}}},c=n?a.touch:a.mouse,d=!!function(){if("boolean"==typeof z)return z;var e=!1;try{var t={get passive(){return e=!0,!1}};window.addEventListener("test",null,t),window.removeEventListener("test",null,t);}catch(t){e=!1;}return z=e}()&&{passive:!1};document.addEventListener(c.moveEvent,c.moveHandler,d),document.addEventListener(c.upEvent,c.upHandler,d),r({type:l.columnStartResizing,columnId:t.id,columnWidth:t.totalWidth,headerIdWidths:o,clientX:i});};return [e,{onMouseDown:function(e){return e.persist()||i(e,o)},onTouchStart:function(e){return e.persist()||i(e,o)},style:{cursor:"col-resize"},draggable:!1,role:"separator"}]};function Tt(e,t){if(t.type===l.init)return r({columnResizing:{columnWidths:{}}},e);if(t.type===l.resetResize)return r({},e,{columnResizing:{columnWidths:{}}});if(t.type===l.columnStartResizing){var n=t.clientX,o=t.columnId,i=t.columnWidth,u=t.headerIdWidths;return r({},e,{columnResizing:r({},e.columnResizing,{startX:n,headerIdWidths:u,columnWidth:i,isResizingColumn:o})})}if(t.type===l.columnResizing){var s=t.clientX,a=e.columnResizing,c=a.startX,d=a.columnWidth,f=a.headerIdWidths,p=(s-c)/d,g={};return (void 0===f?[]:f).forEach((function(e){var t=e[0],n=e[1];g[t]=Math.max(n+n*p,0);})),r({},e,{columnResizing:r({},e.columnResizing,{columnWidths:r({},e.columnResizing.columnWidths,{},g)})})}return t.type===l.columnDoneResizing?r({},e,{columnResizing:r({},e.columnResizing,{startX:null,isResizingColumn:null})}):void 0}kt.pluginName="useResizeColumns";var zt=function(e){var t=e.flatHeaders,n=e.disableResizing,o=e.getHooks,r=e.state.columnResizing,i=h(e);t.forEach((function(e){var t=I(!0!==e.disableResizing&&void 0,!0!==n&&void 0,!0);e.canResize=t,e.width=r.columnWidths[e.id]||e.originalWidth||e.width,e.isResizing=r.isResizingColumn===e.id,t&&(e.getResizerProps=f(o().getResizerProps,{instance:i(),header:e}));}));};function Wt(e){var n=e.plugins,o=e.dispatch,r=e.autoResetResize,i=void 0===r||r,u=e.columns;v(n,["useAbsoluteLayout"],"useResizeColumns");var s=h(i);w((function(){s()&&o({type:l.resetResize});}),[u]);var a=t.useCallback((function(){return o({type:l.resetResize})}),[o]);Object.assign(e,{resetResizing:a});}var Ot={position:"absolute",top:0},Mt=function(e){e.getTableBodyProps.push(jt),e.getRowProps.push(jt),e.getHeaderGroupProps.push(jt),e.getFooterGroupProps.push(jt),e.getHeaderProps.push((function(e,t){var n=t.column;return [e,{style:r({},Ot,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return [e,{style:r({},Ot,{left:n.column.totalLeft+"px",width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return [e,{style:r({},Ot,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]}));};Mt.pluginName="useAbsoluteLayout";var jt=function(e,t){return [e,{style:{position:"relative",width:t.instance.totalColumnsWidth+"px"}}]},Nt={display:"inline-block",boxSizing:"border-box"},Lt=function(e,t){return [e,{style:{display:"flex",width:t.instance.totalColumnsWidth+"px"}}]},Dt=function(e){e.getRowProps.push(Lt),e.getHeaderGroupProps.push(Lt),e.getFooterGroupProps.push(Lt),e.getHeaderProps.push((function(e,t){var n=t.column;return [e,{style:r({},Nt,{width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return [e,{style:r({},Nt,{width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return [e,{style:r({},Nt,{width:n.totalWidth+"px"})}]}));};function Vt(e){e.getTableProps.push(_t),e.getRowProps.push(Xt),e.getHeaderGroupProps.push(Xt),e.getFooterGroupProps.push(Xt),e.getHeaderProps.push(qt),e.getCellProps.push(Kt),e.getFooterProps.push(Ut);}Dt.pluginName="useBlockLayout",Vt.pluginName="useFlexLayout";var _t=function(e,t){return [e,{style:{minWidth:t.instance.totalColumnsMinWidth+"px"}}]},Xt=function(e,t){return [e,{style:{display:"flex",flex:"1 0 auto",minWidth:t.instance.totalColumnsMinWidth+"px"}}]},qt=function(e,t){var n=t.column;return [e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]},Kt=function(e,t){var n=t.cell;return [e,{style:{boxSizing:"border-box",flex:n.column.totalFlexWidth+" 0 auto",minWidth:n.column.totalMinWidth+"px",width:n.column.totalWidth+"px"}}]},Ut=function(e,t){var n=t.column;return [e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]};function $t(e){e.stateReducers.push(Qt),e.getTableProps.push(Jt),e.getHeaderProps.push(Yt);}$t.pluginName="useGridLayout";var Jt=function(e,t){return [e,{style:{display:"grid",gridTemplateColumns:t.instance.state.gridLayout.columnWidths.map((function(e){return e})).join(" ")}}]},Yt=function(e,t){return [e,{id:"header-cell-"+t.column.id,style:{position:"sticky"}}]};function Qt(e,t,n,o){if("init"===t.type)return r({gridLayout:{columnWidths:o.columns.map((function(){return "auto"}))}},e);if("columnStartResizing"===t.type){var i=t.columnId,u=o.visibleColumns.findIndex((function(e){return e.id===i})),l=function(e){var t,n=null==(t=document.getElementById("header-cell-"+e))?void 0:t.offsetWidth;if(void 0!==n)return n}(i);return void 0!==l?r({},e,{gridLayout:r({},e.gridLayout,{columnId:i,columnIndex:u,startingWidth:l})}):e}if("columnResizing"===t.type){var s=e.gridLayout,a=s.columnIndex,c=s.startingWidth,d=s.columnWidths,f=c-(e.columnResizing.startX-t.clientX),p=[].concat(d);return p[a]=f+"px",r({},e,{gridLayout:r({},e.gridLayout,{columnWidths:p})})}}e._UNSTABLE_usePivotColumns=nt,e.actions=l,e.defaultColumn=c,e.defaultGroupByFn=De,e.defaultOrderByFn=Qe,e.defaultRenderer=s,e.emptyRenderer=a,e.ensurePluginOrder=v,e.flexRender=b,e.functionalUpdate=m,e.loopHooks=g,e.makePropGetter=f,e.makeRenderer=R,e.reduceHooks=p,e.safeUseLayoutEffect=y,e.useAbsoluteLayout=Mt,e.useAsyncDebounce=function(e,n){void 0===n&&(n=0);var r=t.useRef({}),i=h(e),u=h(n);return t.useCallback(function(){var e=o(regeneratorRuntime.mark((function e(){var t,n,l,s=arguments;return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:for(t=s.length,n=new Array(t),l=0;l<t;l++)n[l]=s[l];return r.current.promise||(r.current.promise=new Promise((function(e,t){r.current.resolve=e,r.current.reject=t;}))),r.current.timeout&&clearTimeout(r.current.timeout),r.current.timeout=setTimeout(o(regeneratorRuntime.mark((function e(){return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return delete r.current.timeout,e.prev=1,e.t0=r.current,e.next=5,i().apply(void 0,n);case 5:e.t1=e.sent,e.t0.resolve.call(e.t0,e.t1),e.next=12;break;case 9:e.prev=9,e.t2=e.catch(1),r.current.reject(e.t2);case 12:return e.prev=12,delete r.current.promise,e.finish(12);case 15:case"end":return e.stop()}}),e,null,[[1,9,12,15]])}))),u()),e.abrupt("return",r.current.promise);case 5:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}(),[i,u])},e.useBlockLayout=Dt,e.useColumnOrder=It,e.useExpanded=se,e.useFilters=Pe,e.useFlexLayout=Vt,e.useGetLatest=h,e.useGlobalFilter=Ie,e.useGridLayout=$t,e.useGroupBy=ze,e.useMountedLayoutEffect=w,e.usePagination=Ze,e.useResizeColumns=kt,e.useRowSelect=vt,e.useRowState=xt,e.useSortBy=Ue,e.useTable=function(e){for(var n=arguments.length,o=new Array(n>1?n-1:0),i=1;i<n;i++)o[i-1]=arguments[i];e=ie(e),o=[K].concat(o);var u=t.useRef({}),s=h(u.current);Object.assign(s(),r({},e,{plugins:o,hooks:q()})),o.filter(Boolean).forEach((function(e){e(s().hooks);}));var a=h(s().hooks);s().getHooks=a,delete s().hooks,Object.assign(s(),p(a().useOptions,ie(e)));var c=s(),d=c.data,v=c.columns,m=c.initialState,y=c.defaultColumn,w=c.getSubRows,b=c.getRowId,E=c.stateReducer,I=c.useControlledState,F=h(E),G=t.useCallback((function(e,t){if(!t.type)throw console.info({action:t}),new Error("Unknown Action 👆");return [].concat(a().stateReducers,Array.isArray(F())?F():[F()]).reduce((function(n,o){return o(n,t,e,s())||n}),e)}),[a,F,s]),A=t.useReducer(G,void 0,(function(){return G(m,{type:l.init})})),k=A[0],H=A[1],T=p([].concat(a().useControlledState,[I]),k,{instance:s()});Object.assign(s(),{state:T,dispatch:H});var z=t.useMemo((function(){return S(p(a().columns,v,{instance:s()}))}),[a,s,v].concat(p(a().columnsDeps,[],{instance:s()})));s().columns=z;var W=t.useMemo((function(){return p(a().allColumns,C(z),{instance:s()}).map(x)}),[z,a,s].concat(p(a().allColumnsDeps,[],{instance:s()})));s().allColumns=W;var O=t.useMemo((function(){for(var e=[],t=[],n={},o=[].concat(W);o.length;){var r=o.shift();le({data:d,rows:e,flatRows:t,rowsById:n,column:r,getRowId:b,getSubRows:w,accessValueHooks:a().accessValue,getInstance:s});}return [e,t,n]}),[W,d,b,w,a,s]),M=O[0],j=O[1],N=O[2];Object.assign(s(),{rows:M,initialRows:[].concat(M),flatRows:j,rowsById:N}),g(a().useInstanceAfterData,s());var L=t.useMemo((function(){return p(a().visibleColumns,W,{instance:s()}).map((function(e){return P(e,y)}))}),[a,W,s,y].concat(p(a().visibleColumnsDeps,[],{instance:s()})));W=t.useMemo((function(){var e=[].concat(L);return W.forEach((function(t){e.find((function(e){return e.id===t.id}))||e.push(t);})),e}),[W,L]),s().allColumns=W;var D=t.useMemo((function(){return p(a().headerGroups,B(L,y),s())}),[a,L,y,s].concat(p(a().headerGroupsDeps,[],{instance:s()})));s().headerGroups=D;var V=t.useMemo((function(){return D.length?D[0].headers:[]}),[D]);s().headers=V,s().flatHeaders=D.reduce((function(e,t){return [].concat(e,t.headers)}),[]),g(a().useInstanceBeforeDimensions,s());var _=L.filter((function(e){return e.isVisible})).map((function(e){return e.id})).sort().join("_");L=t.useMemo((function(){return L.filter((function(e){return e.isVisible}))}),[L,_]),s().visibleColumns=L;var X=ue(V),U=X[0],$=X[1],J=X[2];return s().totalColumnsMinWidth=U,s().totalColumnsWidth=$,s().totalColumnsMaxWidth=J,g(a().useInstance,s()),[].concat(s().flatHeaders,s().allColumns).forEach((function(e){e.render=R(s(),e),e.getHeaderProps=f(a().getHeaderProps,{instance:s(),column:e}),e.getFooterProps=f(a().getFooterProps,{instance:s(),column:e});})),s().headerGroups=t.useMemo((function(){return D.filter((function(e,t){return e.headers=e.headers.filter((function(e){return e.headers?function e(t){return t.filter((function(t){return t.headers?e(t.headers):t.isVisible})).length}(e.headers):e.isVisible})),!!e.headers.length&&(e.getHeaderGroupProps=f(a().getHeaderGroupProps,{instance:s(),headerGroup:e,index:t}),e.getFooterGroupProps=f(a().getFooterGroupProps,{instance:s(),headerGroup:e,index:t}),!0)}))}),[D,s,a]),s().footerGroups=[].concat(s().headerGroups).reverse(),s().prepareRow=t.useCallback((function(e){e.getRowProps=f(a().getRowProps,{instance:s(),row:e}),e.allCells=W.map((function(t){var n=e.values[t.id],o={column:t,row:e,value:n};return o.getCellProps=f(a().getCellProps,{instance:s(),cell:o}),o.render=R(s(),t,{row:e,cell:o,value:n}),o})),e.cells=L.map((function(t){return e.allCells.find((function(e){return e.column.id===t.id}))})),g(a().prepareRow,e,{instance:s()});}),[a,s,W,L]),s().getTableProps=f(a().getTableProps,{instance:s()}),s().getTableBodyProps=f(a().getTableBodyProps,{instance:s()}),g(a().useFinalInstance,s()),s()},Object.defineProperty(e,"__esModule",{value:!0});}));

});

unwrapExports(reactTable_production_min);

var reactTable_development = createCommonjsModule(function (module, exports) {
(function (global, factory) {
  factory(exports, React__default) ;
}(commonjsGlobal, (function (exports, React) {
  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];

    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }

    return (hint === "string" ? String : Number)(input);
  }

  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");

    return typeof key === "symbol" ? key : String(key);
  }

  var renderErr = 'Renderer Error ☝️';
  var actions = {
    init: 'init'
  };
  var defaultRenderer = function defaultRenderer(_ref) {
    var _ref$value = _ref.value,
        value = _ref$value === void 0 ? '' : _ref$value;
    return value;
  };
  var emptyRenderer = function emptyRenderer() {
    return React.createElement(React.Fragment, null, "\xA0");
  };
  var defaultColumn = {
    Cell: defaultRenderer,
    width: 150,
    minWidth: 0,
    maxWidth: Number.MAX_SAFE_INTEGER
  };

  function mergeProps() {
    for (var _len = arguments.length, propList = new Array(_len), _key = 0; _key < _len; _key++) {
      propList[_key] = arguments[_key];
    }

    return propList.reduce(function (props, next) {
      var style = next.style,
          className = next.className,
          rest = _objectWithoutPropertiesLoose(next, ["style", "className"]);

      props = _extends({}, props, {}, rest);

      if (style) {
        props.style = props.style ? _extends({}, props.style || {}, {}, style || {}) : style;
      }

      if (className) {
        props.className = props.className ? props.className + ' ' + className : className;
      }

      if (props.className === '') {
        delete props.className;
      }

      return props;
    }, {});
  }

  function handlePropGetter(prevProps, userProps, meta) {
    // Handle a lambda, pass it the previous props
    if (typeof userProps === 'function') {
      return handlePropGetter({}, userProps(prevProps, meta));
    } // Handle an array, merge each item as separate props


    if (Array.isArray(userProps)) {
      return mergeProps.apply(void 0, [prevProps].concat(userProps));
    } // Handle an object by default, merge the two objects


    return mergeProps(prevProps, userProps);
  }

  var makePropGetter = function makePropGetter(hooks, meta) {
    if (meta === void 0) {
      meta = {};
    }

    return function (userProps) {
      if (userProps === void 0) {
        userProps = {};
      }

      return [].concat(hooks, [userProps]).reduce(function (prev, next) {
        return handlePropGetter(prev, next, _extends({}, meta, {
          userProps: userProps
        }));
      }, {});
    };
  };
  var reduceHooks = function reduceHooks(hooks, initial, meta, allowUndefined) {
    if (meta === void 0) {
      meta = {};
    }

    return hooks.reduce(function (prev, next) {
      var nextValue = next(prev, meta);

      {
        if (!allowUndefined && typeof nextValue === 'undefined') {
          console.info(next);
          throw new Error('React Table: A reducer hook ☝️ just returned undefined! This is not allowed.');
        }
      }

      return nextValue;
    }, initial);
  };
  var loopHooks = function loopHooks(hooks, context, meta) {
    if (meta === void 0) {
      meta = {};
    }

    return hooks.forEach(function (hook) {
      var nextValue = hook(context, meta);

      {
        if (typeof nextValue !== 'undefined') {
          console.info(hook, nextValue);
          throw new Error('React Table: A loop-type hook ☝️ just returned a value! This is not allowed.');
        }
      }
    });
  };
  function ensurePluginOrder(plugins, befores, pluginName, afters) {
    if ( afters) {
      throw new Error("Defining plugins in the \"after\" section of ensurePluginOrder is no longer supported (see plugin " + pluginName + ")");
    }

    var pluginIndex = plugins.findIndex(function (plugin) {
      return plugin.pluginName === pluginName;
    });

    if (pluginIndex === -1) {
      {
        throw new Error("The plugin \"" + pluginName + "\" was not found in the plugin list!\nThis usually means you need to need to name your plugin hook by setting the 'pluginName' property of the hook function, eg:\n\n  " + pluginName + ".pluginName = '" + pluginName + "'\n");
      }
    }

    befores.forEach(function (before) {
      var beforeIndex = plugins.findIndex(function (plugin) {
        return plugin.pluginName === before;
      });

      if (beforeIndex > -1 && beforeIndex > pluginIndex) {
        {
          throw new Error("React Table: The " + pluginName + " plugin hook must be placed after the " + before + " plugin hook!");
        }
      }
    });
  }
  function functionalUpdate(updater, old) {
    return typeof updater === 'function' ? updater(old) : updater;
  }
  function useGetLatest(obj) {
    var ref = React.useRef();
    ref.current = obj;
    return React.useCallback(function () {
      return ref.current;
    }, []);
  } // SSR has issues with useLayoutEffect still, so use useEffect during SSR

  var safeUseLayoutEffect = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;
  function useMountedLayoutEffect(fn, deps) {
    var mountedRef = React.useRef(false);
    safeUseLayoutEffect(function () {
      if (mountedRef.current) {
        fn();
      }

      mountedRef.current = true; // eslint-disable-next-line
    }, deps);
  }
  function useAsyncDebounce(defaultFn, defaultWait) {
    if (defaultWait === void 0) {
      defaultWait = 0;
    }

    var debounceRef = React.useRef({});
    var getDefaultFn = useGetLatest(defaultFn);
    var getDefaultWait = useGetLatest(defaultWait);
    return React.useCallback(
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _len2,
            args,
            _key2,
            _args2 = arguments;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = _args2[_key2];
                }

                if (!debounceRef.current.promise) {
                  debounceRef.current.promise = new Promise(function (resolve, reject) {
                    debounceRef.current.resolve = resolve;
                    debounceRef.current.reject = reject;
                  });
                }

                if (debounceRef.current.timeout) {
                  clearTimeout(debounceRef.current.timeout);
                }

                debounceRef.current.timeout = setTimeout(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          delete debounceRef.current.timeout;
                          _context.prev = 1;
                          _context.t0 = debounceRef.current;
                          _context.next = 5;
                          return getDefaultFn().apply(void 0, args);

                        case 5:
                          _context.t1 = _context.sent;

                          _context.t0.resolve.call(_context.t0, _context.t1);

                          _context.next = 12;
                          break;

                        case 9:
                          _context.prev = 9;
                          _context.t2 = _context["catch"](1);
                          debounceRef.current.reject(_context.t2);

                        case 12:
                          _context.prev = 12;
                          delete debounceRef.current.promise;
                          return _context.finish(12);

                        case 15:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[1, 9, 12, 15]]);
                })), getDefaultWait());
                return _context2.abrupt("return", debounceRef.current.promise);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }(), [getDefaultFn, getDefaultWait]);
  }
  function makeRenderer(instance, column, meta) {
    if (meta === void 0) {
      meta = {};
    }

    return function (type, userProps) {
      if (userProps === void 0) {
        userProps = {};
      }

      var Comp = typeof type === 'string' ? column[type] : type;

      if (typeof Comp === 'undefined') {
        console.info(column);
        throw new Error(renderErr);
      }

      return flexRender(Comp, _extends({}, instance, {
        column: column
      }, meta, {}, userProps));
    };
  }
  function flexRender(Comp, props) {
    return isReactComponent(Comp) ? React.createElement(Comp, props) : Comp;
  }

  function isReactComponent(component) {
    return isClassComponent(component) || typeof component === 'function' || isExoticComponent(component);
  }

  function isClassComponent(component) {
    return typeof component === 'function' && function () {
      var proto = Object.getPrototypeOf(component);
      return proto.prototype && proto.prototype.isReactComponent;
    }();
  }

  function isExoticComponent(component) {
    return typeof component === 'object' && typeof component.$$typeof === 'symbol' && ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description);
  }

  function linkColumnStructure(columns, parent, depth) {
    if (depth === void 0) {
      depth = 0;
    }

    return columns.map(function (column) {
      column = _extends({}, column, {
        parent: parent,
        depth: depth
      });
      assignColumnAccessor(column);

      if (column.columns) {
        column.columns = linkColumnStructure(column.columns, column, depth + 1);
      }

      return column;
    });
  }
  function flattenColumns(columns) {
    return flattenBy(columns, 'columns');
  }
  function assignColumnAccessor(column) {
    // First check for string accessor
    var id = column.id,
        accessor = column.accessor,
        Header = column.Header;

    if (typeof accessor === 'string') {
      id = id || accessor;
      var accessorPath = accessor.split('.');

      accessor = function accessor(row) {
        return getBy(row, accessorPath);
      };
    }

    if (!id && typeof Header === 'string' && Header) {
      id = Header;
    }

    if (!id && column.columns) {
      console.error(column);
      throw new Error('A column ID (or unique "Header" value) is required!');
    }

    if (!id) {
      console.error(column);
      throw new Error('A column ID (or string accessor) is required!');
    }

    Object.assign(column, {
      id: id,
      accessor: accessor
    });
    return column;
  }
  function decorateColumn(column, userDefaultColumn) {
    if (!userDefaultColumn) {
      throw new Error();
    }

    Object.assign(column, _extends({
      // Make sure there is a fallback header, just in case
      Header: emptyRenderer,
      Footer: emptyRenderer
    }, defaultColumn, {}, userDefaultColumn, {}, column));
    Object.assign(column, {
      originalWidth: column.width
    });
    return column;
  } // Build the header groups from the bottom up

  function makeHeaderGroups(allColumns, defaultColumn, additionalHeaderProperties) {
    if (additionalHeaderProperties === void 0) {
      additionalHeaderProperties = function additionalHeaderProperties() {
        return {};
      };
    }

    var headerGroups = [];
    var scanColumns = allColumns;
    var uid = 0;

    var getUID = function getUID() {
      return uid++;
    };

    var _loop = function _loop() {
      // The header group we are creating
      var headerGroup = {
        headers: []
      }; // The parent columns we're going to scan next

      var parentColumns = [];
      var hasParents = scanColumns.some(function (d) {
        return d.parent;
      }); // Scan each column for parents

      scanColumns.forEach(function (column) {
        // What is the latest (last) parent column?
        var latestParentColumn = [].concat(parentColumns).reverse()[0];
        var newParent;

        if (hasParents) {
          // If the column has a parent, add it if necessary
          if (column.parent) {
            newParent = _extends({}, column.parent, {
              originalId: column.parent.id,
              id: column.parent.id + "_" + getUID(),
              headers: [column]
            }, additionalHeaderProperties(column));
          } else {
            // If other columns have parents, we'll need to add a place holder if necessary
            var originalId = column.id + "_placeholder";
            newParent = decorateColumn(_extends({
              originalId: originalId,
              id: column.id + "_placeholder_" + getUID(),
              placeholderOf: column,
              headers: [column]
            }, additionalHeaderProperties(column)), defaultColumn);
          } // If the resulting parent columns are the same, just add
          // the column and increment the header span


          if (latestParentColumn && latestParentColumn.originalId === newParent.originalId) {
            latestParentColumn.headers.push(column);
          } else {
            parentColumns.push(newParent);
          }
        }

        headerGroup.headers.push(column);
      });
      headerGroups.push(headerGroup); // Start scanning the parent columns

      scanColumns = parentColumns;
    };

    while (scanColumns.length) {
      _loop();
    }

    return headerGroups.reverse();
  }
  var pathObjCache = new Map();
  function getBy(obj, path, def) {
    if (!path) {
      return obj;
    }

    var cacheKey = typeof path === 'function' ? path : JSON.stringify(path);

    var pathObj = pathObjCache.get(cacheKey) || function () {
      var pathObj = makePathArray(path);
      pathObjCache.set(cacheKey, pathObj);
      return pathObj;
    }();

    var val;

    try {
      val = pathObj.reduce(function (cursor, pathPart) {
        return cursor[pathPart];
      }, obj);
    } catch (e) {// continue regardless of error
    }

    return typeof val !== 'undefined' ? val : def;
  }
  function getFirstDefined() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    for (var i = 0; i < args.length; i += 1) {
      if (typeof args[i] !== 'undefined') {
        return args[i];
      }
    }
  }
  function isFunction(a) {
    if (typeof a === 'function') {
      return a;
    }
  }
  function flattenBy(arr, key) {
    var flat = [];

    var recurse = function recurse(arr) {
      arr.forEach(function (d) {
        if (!d[key]) {
          flat.push(d);
        } else {
          recurse(d[key]);
        }
      });
    };

    recurse(arr);
    return flat;
  }
  function expandRows(rows, _ref) {
    var manualExpandedKey = _ref.manualExpandedKey,
        expanded = _ref.expanded,
        _ref$expandSubRows = _ref.expandSubRows,
        expandSubRows = _ref$expandSubRows === void 0 ? true : _ref$expandSubRows;
    var expandedRows = [];

    var handleRow = function handleRow(row, addToExpandedRows) {
      if (addToExpandedRows === void 0) {
        addToExpandedRows = true;
      }

      row.isExpanded = row.original && row.original[manualExpandedKey] || expanded[row.id];
      row.canExpand = row.subRows && !!row.subRows.length;

      if (addToExpandedRows) {
        expandedRows.push(row);
      }

      if (row.subRows && row.subRows.length && row.isExpanded) {
        row.subRows.forEach(function (row) {
          return handleRow(row, expandSubRows);
        });
      }
    };

    rows.forEach(function (row) {
      return handleRow(row);
    });
    return expandedRows;
  }
  function getFilterMethod(filter, userFilterTypes, filterTypes) {
    return isFunction(filter) || userFilterTypes[filter] || filterTypes[filter] || filterTypes.text;
  }
  function shouldAutoRemoveFilter(autoRemove, value, column) {
    return autoRemove ? autoRemove(value, column) : typeof value === 'undefined';
  }
  function unpreparedAccessWarning() {
    throw new Error('React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.');
  }
  var passiveSupported = null;
  function passiveEventSupported() {
    // memoize support to avoid adding multiple test events
    if (typeof passiveSupported === 'boolean') return passiveSupported;
    var supported = false;

    try {
      var options = {
        get passive() {
          supported = true;
          return false;
        }

      };
      window.addEventListener('test', null, options);
      window.removeEventListener('test', null, options);
    } catch (err) {
      supported = false;
    }

    passiveSupported = supported;
    return passiveSupported;
  } //

  var reOpenBracket = /\[/g;
  var reCloseBracket = /\]/g;

  function makePathArray(obj) {
    return flattenDeep(obj) // remove all periods in parts
    .map(function (d) {
      return String(d).replace('.', '_');
    }) // join parts using period
    .join('.') // replace brackets with periods
    .replace(reOpenBracket, '.').replace(reCloseBracket, '') // split it back out on periods
    .split('.');
  }

  function flattenDeep(arr, newArr) {
    if (newArr === void 0) {
      newArr = [];
    }

    if (!Array.isArray(arr)) {
      newArr.push(arr);
    } else {
      for (var i = 0; i < arr.length; i += 1) {
        flattenDeep(arr[i], newArr);
      }
    }

    return newArr;
  }

  var defaultGetTableProps = function defaultGetTableProps(props) {
    return _extends({
      role: 'table'
    }, props);
  };

  var defaultGetTableBodyProps = function defaultGetTableBodyProps(props) {
    return _extends({
      role: 'rowgroup'
    }, props);
  };

  var defaultGetHeaderProps = function defaultGetHeaderProps(props, _ref) {
    var column = _ref.column;
    return _extends({
      key: "header_" + column.id,
      colSpan: column.totalVisibleHeaderCount,
      role: 'columnheader'
    }, props);
  };

  var defaultGetFooterProps = function defaultGetFooterProps(props, _ref2) {
    var column = _ref2.column;
    return _extends({
      key: "footer_" + column.id,
      colSpan: column.totalVisibleHeaderCount
    }, props);
  };

  var defaultGetHeaderGroupProps = function defaultGetHeaderGroupProps(props, _ref3) {
    var index = _ref3.index;
    return _extends({
      key: "headerGroup_" + index,
      role: 'row'
    }, props);
  };

  var defaultGetFooterGroupProps = function defaultGetFooterGroupProps(props, _ref4) {
    var index = _ref4.index;
    return _extends({
      key: "footerGroup_" + index
    }, props);
  };

  var defaultGetRowProps = function defaultGetRowProps(props, _ref5) {
    var row = _ref5.row;
    return _extends({
      key: "row_" + row.id,
      role: 'row'
    }, props);
  };

  var defaultGetCellProps = function defaultGetCellProps(props, _ref6) {
    var cell = _ref6.cell;
    return _extends({
      key: "cell_" + cell.row.id + "_" + cell.column.id,
      role: 'cell'
    }, props);
  };

  function makeDefaultPluginHooks() {
    return {
      useOptions: [],
      stateReducers: [],
      useControlledState: [],
      columns: [],
      columnsDeps: [],
      allColumns: [],
      allColumnsDeps: [],
      accessValue: [],
      materializedColumns: [],
      materializedColumnsDeps: [],
      useInstanceAfterData: [],
      visibleColumns: [],
      visibleColumnsDeps: [],
      headerGroups: [],
      headerGroupsDeps: [],
      useInstanceBeforeDimensions: [],
      useInstance: [],
      prepareRow: [],
      getTableProps: [defaultGetTableProps],
      getTableBodyProps: [defaultGetTableBodyProps],
      getHeaderGroupProps: [defaultGetHeaderGroupProps],
      getFooterGroupProps: [defaultGetFooterGroupProps],
      getHeaderProps: [defaultGetHeaderProps],
      getFooterProps: [defaultGetFooterProps],
      getRowProps: [defaultGetRowProps],
      getCellProps: [defaultGetCellProps],
      useFinalInstance: []
    };
  }

  actions.resetHiddenColumns = 'resetHiddenColumns';
  actions.toggleHideColumn = 'toggleHideColumn';
  actions.setHiddenColumns = 'setHiddenColumns';
  actions.toggleHideAllColumns = 'toggleHideAllColumns';
  var useColumnVisibility = function useColumnVisibility(hooks) {
    hooks.getToggleHiddenProps = [defaultGetToggleHiddenProps];
    hooks.getToggleHideAllColumnsProps = [defaultGetToggleHideAllColumnsProps];
    hooks.stateReducers.push(reducer);
    hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions);
    hooks.headerGroupsDeps.push(function (deps, _ref) {
      var instance = _ref.instance;
      return [].concat(deps, [instance.state.hiddenColumns]);
    });
    hooks.useInstance.push(useInstance);
  };
  useColumnVisibility.pluginName = 'useColumnVisibility';

  var defaultGetToggleHiddenProps = function defaultGetToggleHiddenProps(props, _ref2) {
    var column = _ref2.column;
    return [props, {
      onChange: function onChange(e) {
        column.toggleHidden(!e.target.checked);
      },
      style: {
        cursor: 'pointer'
      },
      checked: column.isVisible,
      title: 'Toggle Column Visible'
    }];
  };

  var defaultGetToggleHideAllColumnsProps = function defaultGetToggleHideAllColumnsProps(props, _ref3) {
    var instance = _ref3.instance;
    return [props, {
      onChange: function onChange(e) {
        instance.toggleHideAllColumns(!e.target.checked);
      },
      style: {
        cursor: 'pointer'
      },
      checked: !instance.allColumnsHidden && !instance.state.hiddenColumns.length,
      title: 'Toggle All Columns Hidden',
      indeterminate: !instance.allColumnsHidden && instance.state.hiddenColumns.length
    }];
  };

  function reducer(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        hiddenColumns: []
      }, state);
    }

    if (action.type === actions.resetHiddenColumns) {
      return _extends({}, state, {
        hiddenColumns: instance.initialState.hiddenColumns || []
      });
    }

    if (action.type === actions.toggleHideColumn) {
      var should = typeof action.value !== 'undefined' ? action.value : !state.hiddenColumns.includes(action.columnId);
      var hiddenColumns = should ? [].concat(state.hiddenColumns, [action.columnId]) : state.hiddenColumns.filter(function (d) {
        return d !== action.columnId;
      });
      return _extends({}, state, {
        hiddenColumns: hiddenColumns
      });
    }

    if (action.type === actions.setHiddenColumns) {
      return _extends({}, state, {
        hiddenColumns: functionalUpdate(action.value, state.hiddenColumns)
      });
    }

    if (action.type === actions.toggleHideAllColumns) {
      var shouldAll = typeof action.value !== 'undefined' ? action.value : !state.hiddenColumns.length;
      return _extends({}, state, {
        hiddenColumns: shouldAll ? instance.allColumns.map(function (d) {
          return d.id;
        }) : []
      });
    }
  }

  function useInstanceBeforeDimensions(instance) {
    var headers = instance.headers,
        hiddenColumns = instance.state.hiddenColumns;
    var isMountedRef = React.useRef(false);

    if (!isMountedRef.current) ;

    var handleColumn = function handleColumn(column, parentVisible) {
      column.isVisible = parentVisible && !hiddenColumns.includes(column.id);
      var totalVisibleHeaderCount = 0;

      if (column.headers && column.headers.length) {
        column.headers.forEach(function (subColumn) {
          return totalVisibleHeaderCount += handleColumn(subColumn, column.isVisible);
        });
      } else {
        totalVisibleHeaderCount = column.isVisible ? 1 : 0;
      }

      column.totalVisibleHeaderCount = totalVisibleHeaderCount;
      return totalVisibleHeaderCount;
    };

    var totalVisibleHeaderCount = 0;
    headers.forEach(function (subHeader) {
      return totalVisibleHeaderCount += handleColumn(subHeader, true);
    });
  }

  function useInstance(instance) {
    var columns = instance.columns,
        flatHeaders = instance.flatHeaders,
        dispatch = instance.dispatch,
        allColumns = instance.allColumns,
        getHooks = instance.getHooks,
        hiddenColumns = instance.state.hiddenColumns,
        _instance$autoResetHi = instance.autoResetHiddenColumns,
        autoResetHiddenColumns = _instance$autoResetHi === void 0 ? true : _instance$autoResetHi;
    var getInstance = useGetLatest(instance);
    var allColumnsHidden = allColumns.length === hiddenColumns.length;
    var toggleHideColumn = React.useCallback(function (columnId, value) {
      return dispatch({
        type: actions.toggleHideColumn,
        columnId: columnId,
        value: value
      });
    }, [dispatch]);
    var setHiddenColumns = React.useCallback(function (value) {
      return dispatch({
        type: actions.setHiddenColumns,
        value: value
      });
    }, [dispatch]);
    var toggleHideAllColumns = React.useCallback(function (value) {
      return dispatch({
        type: actions.toggleHideAllColumns,
        value: value
      });
    }, [dispatch]);
    var getToggleHideAllColumnsProps = makePropGetter(getHooks().getToggleHideAllColumnsProps, {
      instance: getInstance()
    });
    flatHeaders.forEach(function (column) {
      column.toggleHidden = function (value) {
        dispatch({
          type: actions.toggleHideColumn,
          columnId: column.id,
          value: value
        });
      };

      column.getToggleHiddenProps = makePropGetter(getHooks().getToggleHiddenProps, {
        instance: getInstance(),
        column: column
      });
    });
    var getAutoResetHiddenColumns = useGetLatest(autoResetHiddenColumns);
    useMountedLayoutEffect(function () {
      if (getAutoResetHiddenColumns()) {
        dispatch({
          type: actions.resetHiddenColumns
        });
      }
    }, [dispatch, columns]);
    Object.assign(instance, {
      allColumnsHidden: allColumnsHidden,
      toggleHideColumn: toggleHideColumn,
      setHiddenColumns: setHiddenColumns,
      toggleHideAllColumns: toggleHideAllColumns,
      getToggleHideAllColumnsProps: getToggleHideAllColumnsProps
    });
  }

  var defaultInitialState = {};
  var defaultColumnInstance = {};

  var defaultReducer = function defaultReducer(state, action, prevState) {
    return state;
  };

  var defaultGetSubRows = function defaultGetSubRows(row, index) {
    return row.subRows || [];
  };

  var defaultGetRowId = function defaultGetRowId(row, index, parent) {
    return "" + (parent ? [parent.id, index].join('.') : index);
  };

  var defaultUseControlledState = function defaultUseControlledState(d) {
    return d;
  };

  function applyDefaults(props) {
    var _props$initialState = props.initialState,
        initialState = _props$initialState === void 0 ? defaultInitialState : _props$initialState,
        _props$defaultColumn = props.defaultColumn,
        defaultColumn = _props$defaultColumn === void 0 ? defaultColumnInstance : _props$defaultColumn,
        _props$getSubRows = props.getSubRows,
        getSubRows = _props$getSubRows === void 0 ? defaultGetSubRows : _props$getSubRows,
        _props$getRowId = props.getRowId,
        getRowId = _props$getRowId === void 0 ? defaultGetRowId : _props$getRowId,
        _props$stateReducer = props.stateReducer,
        stateReducer = _props$stateReducer === void 0 ? defaultReducer : _props$stateReducer,
        _props$useControlledS = props.useControlledState,
        useControlledState = _props$useControlledS === void 0 ? defaultUseControlledState : _props$useControlledS,
        rest = _objectWithoutPropertiesLoose(props, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]);

    return _extends({}, rest, {
      initialState: initialState,
      defaultColumn: defaultColumn,
      getSubRows: getSubRows,
      getRowId: getRowId,
      stateReducer: stateReducer,
      useControlledState: useControlledState
    });
  }

  var useTable = function useTable(props) {
    for (var _len = arguments.length, plugins = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      plugins[_key - 1] = arguments[_key];
    }

    // Apply default props
    props = applyDefaults(props); // Add core plugins

    plugins = [useColumnVisibility].concat(plugins); // Create the table instance

    var instanceRef = React.useRef({}); // Create a getter for the instance (helps avoid a lot of potential memory leaks)

    var getInstance = useGetLatest(instanceRef.current); // Assign the props, plugins and hooks to the instance

    Object.assign(getInstance(), _extends({}, props, {
      plugins: plugins,
      hooks: makeDefaultPluginHooks()
    })); // Allow plugins to register hooks as early as possible

    plugins.filter(Boolean).forEach(function (plugin) {
      plugin(getInstance().hooks);
    }); // Consume all hooks and make a getter for them

    var getHooks = useGetLatest(getInstance().hooks);
    getInstance().getHooks = getHooks;
    delete getInstance().hooks; // Allow useOptions hooks to modify the options coming into the table

    Object.assign(getInstance(), reduceHooks(getHooks().useOptions, applyDefaults(props)));

    var _getInstance = getInstance(),
        data = _getInstance.data,
        userColumns = _getInstance.columns,
        initialState = _getInstance.initialState,
        defaultColumn = _getInstance.defaultColumn,
        getSubRows = _getInstance.getSubRows,
        getRowId = _getInstance.getRowId,
        stateReducer = _getInstance.stateReducer,
        useControlledState = _getInstance.useControlledState; // Setup user reducer ref


    var getStateReducer = useGetLatest(stateReducer); // Build the reducer

    var reducer = React.useCallback(function (state, action) {
      // Detect invalid actions
      if (!action.type) {
        console.info({
          action: action
        });
        throw new Error('Unknown Action 👆');
      } // Reduce the state from all plugin reducers


      return [].concat(getHooks().stateReducers, Array.isArray(getStateReducer()) ? getStateReducer() : [getStateReducer()]).reduce(function (s, handler) {
        return handler(s, action, state, getInstance()) || s;
      }, state);
    }, [getHooks, getStateReducer, getInstance]); // Start the reducer

    var _React$useReducer = React.useReducer(reducer, undefined, function () {
      return reducer(initialState, {
        type: actions.init
      });
    }),
        reducerState = _React$useReducer[0],
        dispatch = _React$useReducer[1]; // Allow the user to control the final state with hooks


    var state = reduceHooks([].concat(getHooks().useControlledState, [useControlledState]), reducerState, {
      instance: getInstance()
    });
    Object.assign(getInstance(), {
      state: state,
      dispatch: dispatch
    }); // Decorate All the columns

    var columns = React.useMemo(function () {
      return linkColumnStructure(reduceHooks(getHooks().columns, userColumns, {
        instance: getInstance()
      }));
    }, [getHooks, getInstance, userColumns].concat(reduceHooks(getHooks().columnsDeps, [], {
      instance: getInstance()
    })));
    getInstance().columns = columns; // Get the flat list of all columns and allow hooks to decorate
    // those columns (and trigger this memoization via deps)

    var allColumns = React.useMemo(function () {
      return reduceHooks(getHooks().allColumns, flattenColumns(columns), {
        instance: getInstance()
      }).map(assignColumnAccessor);
    }, [columns, getHooks, getInstance].concat(reduceHooks(getHooks().allColumnsDeps, [], {
      instance: getInstance()
    })));
    getInstance().allColumns = allColumns; // Access the row model using initial columns

    var _React$useMemo = React.useMemo(function () {
      var rows = [];
      var flatRows = [];
      var rowsById = {};
      var allColumnsQueue = [].concat(allColumns);

      while (allColumnsQueue.length) {
        var column = allColumnsQueue.shift();
        accessRowsForColumn({
          data: data,
          rows: rows,
          flatRows: flatRows,
          rowsById: rowsById,
          column: column,
          getRowId: getRowId,
          getSubRows: getSubRows,
          accessValueHooks: getHooks().accessValue,
          getInstance: getInstance
        });
      }

      return [rows, flatRows, rowsById];
    }, [allColumns, data, getRowId, getSubRows, getHooks, getInstance]),
        rows = _React$useMemo[0],
        flatRows = _React$useMemo[1],
        rowsById = _React$useMemo[2];

    Object.assign(getInstance(), {
      rows: rows,
      initialRows: [].concat(rows),
      flatRows: flatRows,
      rowsById: rowsById // materializedColumns,

    });
    loopHooks(getHooks().useInstanceAfterData, getInstance()); // Get the flat list of all columns AFTER the rows
    // have been access, and allow hooks to decorate
    // those columns (and trigger this memoization via deps)

    var visibleColumns = React.useMemo(function () {
      return reduceHooks(getHooks().visibleColumns, allColumns, {
        instance: getInstance()
      }).map(function (d) {
        return decorateColumn(d, defaultColumn);
      });
    }, [getHooks, allColumns, getInstance, defaultColumn].concat(reduceHooks(getHooks().visibleColumnsDeps, [], {
      instance: getInstance()
    }))); // Combine new visible columns with all columns

    allColumns = React.useMemo(function () {
      var columns = [].concat(visibleColumns);
      allColumns.forEach(function (column) {
        if (!columns.find(function (d) {
          return d.id === column.id;
        })) {
          columns.push(column);
        }
      });
      return columns;
    }, [allColumns, visibleColumns]);
    getInstance().allColumns = allColumns;

    {
      var duplicateColumns = allColumns.filter(function (column, i) {
        return allColumns.findIndex(function (d) {
          return d.id === column.id;
        }) !== i;
      });

      if (duplicateColumns.length) {
        console.info(allColumns);
        throw new Error("Duplicate columns were found with ids: \"" + duplicateColumns.map(function (d) {
          return d.id;
        }).join(', ') + "\" in the columns array above");
      }
    } // Make the headerGroups


    var headerGroups = React.useMemo(function () {
      return reduceHooks(getHooks().headerGroups, makeHeaderGroups(visibleColumns, defaultColumn), getInstance());
    }, [getHooks, visibleColumns, defaultColumn, getInstance].concat(reduceHooks(getHooks().headerGroupsDeps, [], {
      instance: getInstance()
    })));
    getInstance().headerGroups = headerGroups; // Get the first level of headers

    var headers = React.useMemo(function () {
      return headerGroups.length ? headerGroups[0].headers : [];
    }, [headerGroups]);
    getInstance().headers = headers; // Provide a flat header list for utilities

    getInstance().flatHeaders = headerGroups.reduce(function (all, headerGroup) {
      return [].concat(all, headerGroup.headers);
    }, []);
    loopHooks(getHooks().useInstanceBeforeDimensions, getInstance()); // Filter columns down to visible ones

    var visibleColumnsDep = visibleColumns.filter(function (d) {
      return d.isVisible;
    }).map(function (d) {
      return d.id;
    }).sort().join('_');
    visibleColumns = React.useMemo(function () {
      return visibleColumns.filter(function (d) {
        return d.isVisible;
      });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [visibleColumns, visibleColumnsDep]);
    getInstance().visibleColumns = visibleColumns; // Header Visibility is needed by this point

    var _calculateHeaderWidth = calculateHeaderWidths(headers),
        totalColumnsMinWidth = _calculateHeaderWidth[0],
        totalColumnsWidth = _calculateHeaderWidth[1],
        totalColumnsMaxWidth = _calculateHeaderWidth[2];

    getInstance().totalColumnsMinWidth = totalColumnsMinWidth;
    getInstance().totalColumnsWidth = totalColumnsWidth;
    getInstance().totalColumnsMaxWidth = totalColumnsMaxWidth;
    loopHooks(getHooks().useInstance, getInstance()) // Each materialized header needs to be assigned a render function and other
    // prop getter properties here.
    ;
    [].concat(getInstance().flatHeaders, getInstance().allColumns).forEach(function (column) {
      // Give columns/headers rendering power
      column.render = makeRenderer(getInstance(), column); // Give columns/headers a default getHeaderProps

      column.getHeaderProps = makePropGetter(getHooks().getHeaderProps, {
        instance: getInstance(),
        column: column
      }); // Give columns/headers a default getFooterProps

      column.getFooterProps = makePropGetter(getHooks().getFooterProps, {
        instance: getInstance(),
        column: column
      });
    });
    getInstance().headerGroups = React.useMemo(function () {
      return headerGroups.filter(function (headerGroup, i) {
        // Filter out any headers and headerGroups that don't have visible columns
        headerGroup.headers = headerGroup.headers.filter(function (column) {
          var recurse = function recurse(headers) {
            return headers.filter(function (column) {
              if (column.headers) {
                return recurse(column.headers);
              }

              return column.isVisible;
            }).length;
          };

          if (column.headers) {
            return recurse(column.headers);
          }

          return column.isVisible;
        }); // Give headerGroups getRowProps

        if (headerGroup.headers.length) {
          headerGroup.getHeaderGroupProps = makePropGetter(getHooks().getHeaderGroupProps, {
            instance: getInstance(),
            headerGroup: headerGroup,
            index: i
          });
          headerGroup.getFooterGroupProps = makePropGetter(getHooks().getFooterGroupProps, {
            instance: getInstance(),
            headerGroup: headerGroup,
            index: i
          });
          return true;
        }

        return false;
      });
    }, [headerGroups, getInstance, getHooks]);
    getInstance().footerGroups = [].concat(getInstance().headerGroups).reverse(); // The prepareRow function is absolutely necessary and MUST be called on
    // any rows the user wishes to be displayed.

    getInstance().prepareRow = React.useCallback(function (row) {
      row.getRowProps = makePropGetter(getHooks().getRowProps, {
        instance: getInstance(),
        row: row
      }); // Build the visible cells for each row

      row.allCells = allColumns.map(function (column) {
        var value = row.values[column.id];
        var cell = {
          column: column,
          row: row,
          value: value
        }; // Give each cell a getCellProps base

        cell.getCellProps = makePropGetter(getHooks().getCellProps, {
          instance: getInstance(),
          cell: cell
        }); // Give each cell a renderer function (supports multiple renderers)

        cell.render = makeRenderer(getInstance(), column, {
          row: row,
          cell: cell,
          value: value
        });
        return cell;
      });
      row.cells = visibleColumns.map(function (column) {
        return row.allCells.find(function (cell) {
          return cell.column.id === column.id;
        });
      }); // need to apply any row specific hooks (useExpanded requires this)

      loopHooks(getHooks().prepareRow, row, {
        instance: getInstance()
      });
    }, [getHooks, getInstance, allColumns, visibleColumns]);
    getInstance().getTableProps = makePropGetter(getHooks().getTableProps, {
      instance: getInstance()
    });
    getInstance().getTableBodyProps = makePropGetter(getHooks().getTableBodyProps, {
      instance: getInstance()
    });
    loopHooks(getHooks().useFinalInstance, getInstance());
    return getInstance();
  };

  function calculateHeaderWidths(headers, left) {
    if (left === void 0) {
      left = 0;
    }

    var sumTotalMinWidth = 0;
    var sumTotalWidth = 0;
    var sumTotalMaxWidth = 0;
    var sumTotalFlexWidth = 0;
    headers.forEach(function (header) {
      var subHeaders = header.headers;
      header.totalLeft = left;

      if (subHeaders && subHeaders.length) {
        var _calculateHeaderWidth2 = calculateHeaderWidths(subHeaders, left),
            totalMinWidth = _calculateHeaderWidth2[0],
            totalWidth = _calculateHeaderWidth2[1],
            totalMaxWidth = _calculateHeaderWidth2[2],
            totalFlexWidth = _calculateHeaderWidth2[3];

        header.totalMinWidth = totalMinWidth;
        header.totalWidth = totalWidth;
        header.totalMaxWidth = totalMaxWidth;
        header.totalFlexWidth = totalFlexWidth;
      } else {
        header.totalMinWidth = header.minWidth;
        header.totalWidth = Math.min(Math.max(header.minWidth, header.width), header.maxWidth);
        header.totalMaxWidth = header.maxWidth;
        header.totalFlexWidth = header.canResize ? header.totalWidth : 0;
      }

      if (header.isVisible) {
        left += header.totalWidth;
        sumTotalMinWidth += header.totalMinWidth;
        sumTotalWidth += header.totalWidth;
        sumTotalMaxWidth += header.totalMaxWidth;
        sumTotalFlexWidth += header.totalFlexWidth;
      }
    });
    return [sumTotalMinWidth, sumTotalWidth, sumTotalMaxWidth, sumTotalFlexWidth];
  }

  function accessRowsForColumn(_ref) {
    var data = _ref.data,
        rows = _ref.rows,
        flatRows = _ref.flatRows,
        rowsById = _ref.rowsById,
        column = _ref.column,
        getRowId = _ref.getRowId,
        getSubRows = _ref.getSubRows,
        accessValueHooks = _ref.accessValueHooks,
        getInstance = _ref.getInstance;

    // Access the row's data column-by-column
    // We do it this way so we can incrementally add materialized
    // columns after the first pass and avoid excessive looping
    var accessRow = function accessRow(originalRow, rowIndex, depth, parent, parentRows) {
      if (depth === void 0) {
        depth = 0;
      }

      // Keep the original reference around
      var original = originalRow;
      var id = getRowId(originalRow, rowIndex, parent);
      var row = rowsById[id]; // If the row hasn't been created, let's make it

      if (!row) {
        row = {
          id: id,
          original: original,
          index: rowIndex,
          depth: depth,
          cells: [{}] // This is a dummy cell

        }; // Override common array functions (and the dummy cell's getCellProps function)
        // to show an error if it is accessed without calling prepareRow

        row.cells.map = unpreparedAccessWarning;
        row.cells.filter = unpreparedAccessWarning;
        row.cells.forEach = unpreparedAccessWarning;
        row.cells[0].getCellProps = unpreparedAccessWarning; // Create the cells and values

        row.values = {}; // Push this row into the parentRows array

        parentRows.push(row); // Keep track of every row in a flat array

        flatRows.push(row); // Also keep track of every row by its ID

        rowsById[id] = row; // Get the original subrows

        row.originalSubRows = getSubRows(originalRow, rowIndex); // Then recursively access them

        if (row.originalSubRows) {
          var subRows = [];
          row.originalSubRows.forEach(function (d, i) {
            return accessRow(d, i, depth + 1, row, subRows);
          }); // Keep the new subRows array on the row

          row.subRows = subRows;
        }
      } else if (row.subRows) {
        // If the row exists, then it's already been accessed
        // Keep recursing, but don't worry about passing the
        // accumlator array (those rows already exist)
        row.originalSubRows.forEach(function (d, i) {
          return accessRow(d, i, depth + 1, row);
        });
      } // If the column has an accessor, use it to get a value


      if (column.accessor) {
        row.values[column.id] = column.accessor(originalRow, rowIndex, row, parentRows, data);
      } // Allow plugins to manipulate the column value


      row.values[column.id] = reduceHooks(accessValueHooks, row.values[column.id], {
        row: row,
        column: column,
        instance: getInstance()
      }, true);
    };

    data.forEach(function (originalRow, rowIndex) {
      return accessRow(originalRow, rowIndex, 0, undefined, rows);
    });
  }

  actions.resetExpanded = 'resetExpanded';
  actions.toggleRowExpanded = 'toggleRowExpanded';
  actions.toggleAllRowsExpanded = 'toggleAllRowsExpanded';
  var useExpanded = function useExpanded(hooks) {
    hooks.getToggleAllRowsExpandedProps = [defaultGetToggleAllRowsExpandedProps];
    hooks.getToggleRowExpandedProps = [defaultGetToggleRowExpandedProps];
    hooks.stateReducers.push(reducer$1);
    hooks.useInstance.push(useInstance$1);
    hooks.prepareRow.push(prepareRow);
  };
  useExpanded.pluginName = 'useExpanded';

  var defaultGetToggleAllRowsExpandedProps = function defaultGetToggleAllRowsExpandedProps(props, _ref) {
    var instance = _ref.instance;
    return [props, {
      onClick: function onClick(e) {
        instance.toggleAllRowsExpanded();
      },
      style: {
        cursor: 'pointer'
      },
      title: 'Toggle All Rows Expanded'
    }];
  };

  var defaultGetToggleRowExpandedProps = function defaultGetToggleRowExpandedProps(props, _ref2) {
    var row = _ref2.row;
    return [props, {
      onClick: function onClick() {
        row.toggleRowExpanded();
      },
      style: {
        cursor: 'pointer'
      },
      title: 'Toggle Row Expanded'
    }];
  }; // Reducer


  function reducer$1(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        expanded: {}
      }, state);
    }

    if (action.type === actions.resetExpanded) {
      return _extends({}, state, {
        expanded: instance.initialState.expanded || {}
      });
    }

    if (action.type === actions.toggleAllRowsExpanded) {
      var value = action.value;
      var isAllRowsExpanded = instance.isAllRowsExpanded,
          rowsById = instance.rowsById;
      var expandAll = typeof value !== 'undefined' ? value : !isAllRowsExpanded;

      if (expandAll) {
        var expanded = {};
        Object.keys(rowsById).forEach(function (rowId) {
          expanded[rowId] = true;
        });
        return _extends({}, state, {
          expanded: expanded
        });
      }

      return _extends({}, state, {
        expanded: {}
      });
    }

    if (action.type === actions.toggleRowExpanded) {
      var id = action.id,
          setExpanded = action.value;
      var exists = state.expanded[id];
      var shouldExist = typeof setExpanded !== 'undefined' ? setExpanded : !exists;

      if (!exists && shouldExist) {
        var _extends2;

        return _extends({}, state, {
          expanded: _extends({}, state.expanded, (_extends2 = {}, _extends2[id] = true, _extends2))
        });
      } else if (exists && !shouldExist) {
        var _state$expanded = state.expanded;
            _state$expanded[id];
            var rest = _objectWithoutPropertiesLoose(_state$expanded, [id].map(_toPropertyKey));

        return _extends({}, state, {
          expanded: rest
        });
      } else {
        return state;
      }
    }
  }

  function useInstance$1(instance) {
    var data = instance.data,
        rows = instance.rows,
        rowsById = instance.rowsById,
        _instance$manualExpan = instance.manualExpandedKey,
        manualExpandedKey = _instance$manualExpan === void 0 ? 'expanded' : _instance$manualExpan,
        _instance$paginateExp = instance.paginateExpandedRows,
        paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp,
        _instance$expandSubRo = instance.expandSubRows,
        expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo,
        _instance$autoResetEx = instance.autoResetExpanded,
        autoResetExpanded = _instance$autoResetEx === void 0 ? true : _instance$autoResetEx,
        getHooks = instance.getHooks,
        plugins = instance.plugins,
        expanded = instance.state.expanded,
        dispatch = instance.dispatch;
    ensurePluginOrder(plugins, ['useSortBy', 'useGroupBy', 'usePivotColumns', 'useGlobalFilter'], 'useExpanded');
    var getAutoResetExpanded = useGetLatest(autoResetExpanded);
    var isAllRowsExpanded = Boolean(Object.keys(rowsById).length && Object.keys(expanded).length);

    if (isAllRowsExpanded) {
      if (Object.keys(rowsById).some(function (id) {
        return !expanded[id];
      })) {
        isAllRowsExpanded = false;
      }
    } // Bypass any effects from firing when this changes


    useMountedLayoutEffect(function () {
      if (getAutoResetExpanded()) {
        dispatch({
          type: actions.resetExpanded
        });
      }
    }, [dispatch, data]);
    var toggleRowExpanded = React.useCallback(function (id, value) {
      dispatch({
        type: actions.toggleRowExpanded,
        id: id,
        value: value
      });
    }, [dispatch]);
    var toggleAllRowsExpanded = React.useCallback(function (value) {
      return dispatch({
        type: actions.toggleAllRowsExpanded,
        value: value
      });
    }, [dispatch]);
    var expandedRows = React.useMemo(function () {
      if (paginateExpandedRows) {
        return expandRows(rows, {
          manualExpandedKey: manualExpandedKey,
          expanded: expanded,
          expandSubRows: expandSubRows
        });
      }

      return rows;
    }, [paginateExpandedRows, rows, manualExpandedKey, expanded, expandSubRows]);
    var expandedDepth = React.useMemo(function () {
      return findExpandedDepth(expanded);
    }, [expanded]);
    var getInstance = useGetLatest(instance);
    var getToggleAllRowsExpandedProps = makePropGetter(getHooks().getToggleAllRowsExpandedProps, {
      instance: getInstance()
    });
    Object.assign(instance, {
      preExpandedRows: rows,
      expandedRows: expandedRows,
      rows: expandedRows,
      expandedDepth: expandedDepth,
      isAllRowsExpanded: isAllRowsExpanded,
      toggleRowExpanded: toggleRowExpanded,
      toggleAllRowsExpanded: toggleAllRowsExpanded,
      getToggleAllRowsExpandedProps: getToggleAllRowsExpandedProps
    });
  }

  function prepareRow(row, _ref3) {
    var getHooks = _ref3.instance.getHooks,
        instance = _ref3.instance;

    row.toggleRowExpanded = function (set) {
      return instance.toggleRowExpanded(row.id, set);
    };

    row.getToggleRowExpandedProps = makePropGetter(getHooks().getToggleRowExpandedProps, {
      instance: instance,
      row: row
    });
  }

  function findExpandedDepth(expanded) {
    var maxDepth = 0;
    Object.keys(expanded).forEach(function (id) {
      var splitId = id.split('.');
      maxDepth = Math.max(maxDepth, splitId.length);
    });
    return maxDepth;
  }

  var text = function text(rows, ids, filterValue) {
    rows = rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return String(rowValue).toLowerCase().includes(String(filterValue).toLowerCase());
      });
    });
    return rows;
  };

  text.autoRemove = function (val) {
    return !val;
  };

  var exactText = function exactText(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue !== undefined ? String(rowValue).toLowerCase() === String(filterValue).toLowerCase() : true;
      });
    });
  };

  exactText.autoRemove = function (val) {
    return !val;
  };

  var exactTextCase = function exactTextCase(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue !== undefined ? String(rowValue) === String(filterValue) : true;
      });
    });
  };

  exactTextCase.autoRemove = function (val) {
    return !val;
  };

  var includes = function includes(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue.includes(filterValue);
      });
    });
  };

  includes.autoRemove = function (val) {
    return !val || !val.length;
  };

  var includesAll = function includesAll(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue && rowValue.length && filterValue.every(function (val) {
          return rowValue.includes(val);
        });
      });
    });
  };

  includesAll.autoRemove = function (val) {
    return !val || !val.length;
  };

  var includesSome = function includesSome(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue && rowValue.length && filterValue.some(function (val) {
          return rowValue.includes(val);
        });
      });
    });
  };

  includesSome.autoRemove = function (val) {
    return !val || !val.length;
  };

  var includesValue = function includesValue(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return filterValue.includes(rowValue);
      });
    });
  };

  includesValue.autoRemove = function (val) {
    return !val || !val.length;
  };

  var exact = function exact(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue === filterValue;
      });
    });
  };

  exact.autoRemove = function (val) {
    return typeof val === 'undefined';
  };

  var equals = function equals(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id]; // eslint-disable-next-line eqeqeq

        return rowValue == filterValue;
      });
    });
  };

  equals.autoRemove = function (val) {
    return val == null;
  };

  var between = function between(rows, ids, filterValue) {
    var _ref = filterValue || [],
        min = _ref[0],
        max = _ref[1];

    min = typeof min === 'number' ? min : -Infinity;
    max = typeof max === 'number' ? max : Infinity;

    if (min > max) {
      var temp = min;
      min = max;
      max = temp;
    }

    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue >= min && rowValue <= max;
      });
    });
  };

  between.autoRemove = function (val) {
    return !val || typeof val[0] !== 'number' && typeof val[1] !== 'number';
  };

  var filterTypes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    text: text,
    exactText: exactText,
    exactTextCase: exactTextCase,
    includes: includes,
    includesAll: includesAll,
    includesSome: includesSome,
    includesValue: includesValue,
    exact: exact,
    equals: equals,
    between: between
  });

  actions.resetFilters = 'resetFilters';
  actions.setFilter = 'setFilter';
  actions.setAllFilters = 'setAllFilters';
  var useFilters = function useFilters(hooks) {
    hooks.stateReducers.push(reducer$2);
    hooks.useInstance.push(useInstance$2);
  };
  useFilters.pluginName = 'useFilters';

  function reducer$2(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        filters: []
      }, state);
    }

    if (action.type === actions.resetFilters) {
      return _extends({}, state, {
        filters: instance.initialState.filters || []
      });
    }

    if (action.type === actions.setFilter) {
      var columnId = action.columnId,
          filterValue = action.filterValue;
      var allColumns = instance.allColumns,
          userFilterTypes = instance.filterTypes;
      var column = allColumns.find(function (d) {
        return d.id === columnId;
      });

      if (!column) {
        throw new Error("React-Table: Could not find a column with id: " + columnId);
      }

      var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);
      var previousfilter = state.filters.find(function (d) {
        return d.id === columnId;
      });
      var newFilter = functionalUpdate(filterValue, previousfilter && previousfilter.value); //

      if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter, column)) {
        return _extends({}, state, {
          filters: state.filters.filter(function (d) {
            return d.id !== columnId;
          })
        });
      }

      if (previousfilter) {
        return _extends({}, state, {
          filters: state.filters.map(function (d) {
            if (d.id === columnId) {
              return {
                id: columnId,
                value: newFilter
              };
            }

            return d;
          })
        });
      }

      return _extends({}, state, {
        filters: [].concat(state.filters, [{
          id: columnId,
          value: newFilter
        }])
      });
    }

    if (action.type === actions.setAllFilters) {
      var filters = action.filters;
      var _allColumns = instance.allColumns,
          _userFilterTypes = instance.filterTypes;
      return _extends({}, state, {
        // Filter out undefined values
        filters: functionalUpdate(filters, state.filters).filter(function (filter) {
          var column = _allColumns.find(function (d) {
            return d.id === filter.id;
          });

          var filterMethod = getFilterMethod(column.filter, _userFilterTypes || {}, filterTypes);

          if (shouldAutoRemoveFilter(filterMethod.autoRemove, filter.value, column)) {
            return false;
          }

          return true;
        })
      });
    }
  }

  function useInstance$2(instance) {
    var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        rowsById = instance.rowsById,
        allColumns = instance.allColumns,
        userFilterTypes = instance.filterTypes,
        manualFilters = instance.manualFilters,
        _instance$defaultCanF = instance.defaultCanFilter,
        defaultCanFilter = _instance$defaultCanF === void 0 ? false : _instance$defaultCanF,
        disableFilters = instance.disableFilters,
        filters = instance.state.filters,
        dispatch = instance.dispatch,
        _instance$autoResetFi = instance.autoResetFilters,
        autoResetFilters = _instance$autoResetFi === void 0 ? true : _instance$autoResetFi;
    var setFilter = React.useCallback(function (columnId, filterValue) {
      dispatch({
        type: actions.setFilter,
        columnId: columnId,
        filterValue: filterValue
      });
    }, [dispatch]);
    var setAllFilters = React.useCallback(function (filters) {
      dispatch({
        type: actions.setAllFilters,
        filters: filters
      });
    }, [dispatch]);
    allColumns.forEach(function (column) {
      var id = column.id,
          accessor = column.accessor,
          columnDefaultCanFilter = column.defaultCanFilter,
          columnDisableFilters = column.disableFilters; // Determine if a column is filterable

      column.canFilter = accessor ? getFirstDefined(columnDisableFilters === true ? false : undefined, disableFilters === true ? false : undefined, true) : getFirstDefined(columnDefaultCanFilter, defaultCanFilter, false); // Provide the column a way of updating the filter value

      column.setFilter = function (val) {
        return setFilter(column.id, val);
      }; // Provide the current filter value to the column for
      // convenience


      var found = filters.find(function (d) {
        return d.id === id;
      });
      column.filterValue = found && found.value;
    });

    var _React$useMemo = React.useMemo(function () {
      if (manualFilters || !filters.length) {
        return [rows, flatRows, rowsById];
      }

      var filteredFlatRows = [];
      var filteredRowsById = {}; // Filters top level and nested rows

      var filterRows = function filterRows(rows, depth) {
        if (depth === void 0) {
          depth = 0;
        }

        var filteredRows = rows;
        filteredRows = filters.reduce(function (filteredSoFar, _ref) {
          var columnId = _ref.id,
              filterValue = _ref.value;
          // Find the filters column
          var column = allColumns.find(function (d) {
            return d.id === columnId;
          });

          if (!column) {
            return filteredSoFar;
          }

          if (depth === 0) {
            column.preFilteredRows = filteredSoFar;
          }

          var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);

          if (!filterMethod) {
            console.warn("Could not find a valid 'column.filter' for column with the ID: " + column.id + ".");
            return filteredSoFar;
          } // Pass the rows, id, filterValue and column to the filterMethod
          // to get the filtered rows back


          column.filteredRows = filterMethod(filteredSoFar, [columnId], filterValue);
          return column.filteredRows;
        }, rows); // Apply the filter to any subRows
        // We technically could do this recursively in the above loop,
        // but that would severely hinder the API for the user, since they
        // would be required to do that recursion in some scenarios

        filteredRows.forEach(function (row) {
          filteredFlatRows.push(row);
          filteredRowsById[row.id] = row;

          if (!row.subRows) {
            return;
          }

          row.subRows = row.subRows && row.subRows.length > 0 ? filterRows(row.subRows, depth + 1) : row.subRows;
        });
        return filteredRows;
      };

      return [filterRows(rows), filteredFlatRows, filteredRowsById];
    }, [manualFilters, filters, rows, flatRows, rowsById, allColumns, userFilterTypes]),
        filteredRows = _React$useMemo[0],
        filteredFlatRows = _React$useMemo[1],
        filteredRowsById = _React$useMemo[2];

    React.useMemo(function () {
      // Now that each filtered column has it's partially filtered rows,
      // lets assign the final filtered rows to all of the other columns
      var nonFilteredColumns = allColumns.filter(function (column) {
        return !filters.find(function (d) {
          return d.id === column.id;
        });
      }); // This essentially enables faceted filter options to be built easily
      // using every column's preFilteredRows value

      nonFilteredColumns.forEach(function (column) {
        column.preFilteredRows = filteredRows;
        column.filteredRows = filteredRows;
      });
    }, [filteredRows, filters, allColumns]);
    var getAutoResetFilters = useGetLatest(autoResetFilters);
    useMountedLayoutEffect(function () {
      if (getAutoResetFilters()) {
        dispatch({
          type: actions.resetFilters
        });
      }
    }, [dispatch, manualFilters ? null : data]);
    Object.assign(instance, {
      preFilteredRows: rows,
      preFilteredFlatRows: flatRows,
      preFilteredRowsById: rowsById,
      filteredRows: filteredRows,
      filteredFlatRows: filteredFlatRows,
      filteredRowsById: filteredRowsById,
      rows: filteredRows,
      flatRows: filteredFlatRows,
      rowsById: filteredRowsById,
      setFilter: setFilter,
      setAllFilters: setAllFilters
    });
  }

  actions.resetGlobalFilter = 'resetGlobalFilter';
  actions.setGlobalFilter = 'setGlobalFilter';
  var useGlobalFilter = function useGlobalFilter(hooks) {
    hooks.stateReducers.push(reducer$3);
    hooks.useInstance.push(useInstance$3);
  };
  useGlobalFilter.pluginName = 'useGlobalFilter';

  function reducer$3(state, action, previousState, instance) {
    if (action.type === actions.resetGlobalFilter) {
      return _extends({}, state, {
        globalFilter: instance.initialState.globalFilter || undefined
      });
    }

    if (action.type === actions.setGlobalFilter) {
      var filterValue = action.filterValue;
      var userFilterTypes = instance.userFilterTypes;
      var filterMethod = getFilterMethod(instance.globalFilter, userFilterTypes || {}, filterTypes);
      var newFilter = functionalUpdate(filterValue, state.globalFilter); //

      if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter)) {
        state.globalFilter;
            var stateWithoutGlobalFilter = _objectWithoutPropertiesLoose(state, ["globalFilter"]);

        return stateWithoutGlobalFilter;
      }

      return _extends({}, state, {
        globalFilter: newFilter
      });
    }
  }

  function useInstance$3(instance) {
    var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        rowsById = instance.rowsById,
        allColumns = instance.allColumns,
        userFilterTypes = instance.filterTypes,
        globalFilter = instance.globalFilter,
        manualGlobalFilter = instance.manualGlobalFilter,
        globalFilterValue = instance.state.globalFilter,
        dispatch = instance.dispatch,
        _instance$autoResetGl = instance.autoResetGlobalFilter,
        autoResetGlobalFilter = _instance$autoResetGl === void 0 ? true : _instance$autoResetGl,
        disableGlobalFilter = instance.disableGlobalFilter;
    var setGlobalFilter = React.useCallback(function (filterValue) {
      dispatch({
        type: actions.setGlobalFilter,
        filterValue: filterValue
      });
    }, [dispatch]); // TODO: Create a filter cache for incremental high speed multi-filtering
    // This gets pretty complicated pretty fast, since you have to maintain a
    // cache for each row group (top-level rows, and each row's recursive subrows)
    // This would make multi-filtering a lot faster though. Too far?

    var _React$useMemo = React.useMemo(function () {
      if (manualGlobalFilter || typeof globalFilterValue === 'undefined') {
        return [rows, flatRows, rowsById];
      }

      var filteredFlatRows = [];
      var filteredRowsById = {};
      var filterMethod = getFilterMethod(globalFilter, userFilterTypes || {}, filterTypes);

      if (!filterMethod) {
        console.warn("Could not find a valid 'globalFilter' option.");
        return rows;
      }

      allColumns.forEach(function (column) {
        var columnDisableGlobalFilter = column.disableGlobalFilter;
        column.canFilter = getFirstDefined(columnDisableGlobalFilter === true ? false : undefined, disableGlobalFilter === true ? false : undefined, true);
      });
      var filterableColumns = allColumns.filter(function (c) {
        return c.canFilter === true;
      }); // Filters top level and nested rows

      var filterRows = function filterRows(filteredRows) {
        filteredRows = filterMethod(filteredRows, filterableColumns.map(function (d) {
          return d.id;
        }), globalFilterValue);
        filteredRows.forEach(function (row) {
          filteredFlatRows.push(row);
          filteredRowsById[row.id] = row;
          row.subRows = row.subRows && row.subRows.length ? filterRows(row.subRows) : row.subRows;
        });
        return filteredRows;
      };

      return [filterRows(rows), filteredFlatRows, filteredRowsById];
    }, [manualGlobalFilter, globalFilterValue, globalFilter, userFilterTypes, allColumns, rows, flatRows, rowsById, disableGlobalFilter]),
        globalFilteredRows = _React$useMemo[0],
        globalFilteredFlatRows = _React$useMemo[1],
        globalFilteredRowsById = _React$useMemo[2];

    var getAutoResetGlobalFilter = useGetLatest(autoResetGlobalFilter);
    useMountedLayoutEffect(function () {
      if (getAutoResetGlobalFilter()) {
        dispatch({
          type: actions.resetGlobalFilter
        });
      }
    }, [dispatch, manualGlobalFilter ? null : data]);
    Object.assign(instance, {
      preGlobalFilteredRows: rows,
      preGlobalFilteredFlatRows: flatRows,
      preGlobalFilteredRowsById: rowsById,
      globalFilteredRows: globalFilteredRows,
      globalFilteredFlatRows: globalFilteredFlatRows,
      globalFilteredRowsById: globalFilteredRowsById,
      rows: globalFilteredRows,
      flatRows: globalFilteredFlatRows,
      rowsById: globalFilteredRowsById,
      setGlobalFilter: setGlobalFilter,
      disableGlobalFilter: disableGlobalFilter
    });
  }

  function sum(values, aggregatedValues) {
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return aggregatedValues.reduce(function (sum, next) {
      return sum + (typeof next === 'number' ? next : 0);
    }, 0);
  }
  function min(values) {
    var min = values[0] || 0;
    values.forEach(function (value) {
      if (typeof value === 'number') {
        min = Math.min(min, value);
      }
    });
    return min;
  }
  function max(values) {
    var max = values[0] || 0;
    values.forEach(function (value) {
      if (typeof value === 'number') {
        max = Math.max(max, value);
      }
    });
    return max;
  }
  function minMax(values) {
    var min = values[0] || 0;
    var max = values[0] || 0;
    values.forEach(function (value) {
      if (typeof value === 'number') {
        min = Math.min(min, value);
        max = Math.max(max, value);
      }
    });
    return min + ".." + max;
  }
  function average(values) {
    return sum(null, values) / values.length;
  }
  function median(values) {
    if (!values.length) {
      return null;
    }

    var mid = Math.floor(values.length / 2);
    var nums = [].concat(values).sort(function (a, b) {
      return a - b;
    });
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
  }
  function unique(values) {
    return Array.from(new Set(values).values());
  }
  function uniqueCount(values) {
    return new Set(values).size;
  }
  function count(values) {
    return values.length;
  }

  var aggregations = /*#__PURE__*/Object.freeze({
    __proto__: null,
    sum: sum,
    min: min,
    max: max,
    minMax: minMax,
    average: average,
    median: median,
    unique: unique,
    uniqueCount: uniqueCount,
    count: count
  });

  var emptyArray = [];
  var emptyObject = {}; // Actions

  actions.resetGroupBy = 'resetGroupBy';
  actions.setGroupBy = 'setGroupBy';
  actions.toggleGroupBy = 'toggleGroupBy';
  var useGroupBy = function useGroupBy(hooks) {
    hooks.getGroupByToggleProps = [defaultGetGroupByToggleProps];
    hooks.stateReducers.push(reducer$4);
    hooks.visibleColumnsDeps.push(function (deps, _ref) {
      var instance = _ref.instance;
      return [].concat(deps, [instance.state.groupBy]);
    });
    hooks.visibleColumns.push(visibleColumns);
    hooks.useInstance.push(useInstance$4);
    hooks.prepareRow.push(prepareRow$1);
  };
  useGroupBy.pluginName = 'useGroupBy';

  var defaultGetGroupByToggleProps = function defaultGetGroupByToggleProps(props, _ref2) {
    var header = _ref2.header;
    return [props, {
      onClick: header.canGroupBy ? function (e) {
        e.persist();
        header.toggleGroupBy();
      } : undefined,
      style: {
        cursor: header.canGroupBy ? 'pointer' : undefined
      },
      title: 'Toggle GroupBy'
    }];
  }; // Reducer


  function reducer$4(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        groupBy: []
      }, state);
    }

    if (action.type === actions.resetGroupBy) {
      return _extends({}, state, {
        groupBy: instance.initialState.groupBy || []
      });
    }

    if (action.type === actions.setGroupBy) {
      var value = action.value;
      return _extends({}, state, {
        groupBy: value
      });
    }

    if (action.type === actions.toggleGroupBy) {
      var columnId = action.columnId,
          setGroupBy = action.value;
      var resolvedGroupBy = typeof setGroupBy !== 'undefined' ? setGroupBy : !state.groupBy.includes(columnId);

      if (resolvedGroupBy) {
        return _extends({}, state, {
          groupBy: [].concat(state.groupBy, [columnId])
        });
      }

      return _extends({}, state, {
        groupBy: state.groupBy.filter(function (d) {
          return d !== columnId;
        })
      });
    }
  }

  function visibleColumns(columns, _ref3) {
    var groupBy = _ref3.instance.state.groupBy;
    // Sort grouped columns to the start of the column list
    // before the headers are built
    var groupByColumns = groupBy.map(function (g) {
      return columns.find(function (col) {
        return col.id === g;
      });
    }).filter(Boolean);
    var nonGroupByColumns = columns.filter(function (col) {
      return !groupBy.includes(col.id);
    });
    columns = [].concat(groupByColumns, nonGroupByColumns);
    columns.forEach(function (column) {
      column.isGrouped = groupBy.includes(column.id);
      column.groupedIndex = groupBy.indexOf(column.id);
    });
    return columns;
  }

  var defaultUserAggregations = {};

  function useInstance$4(instance) {
    var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        rowsById = instance.rowsById,
        allColumns = instance.allColumns,
        flatHeaders = instance.flatHeaders,
        _instance$groupByFn = instance.groupByFn,
        groupByFn = _instance$groupByFn === void 0 ? defaultGroupByFn : _instance$groupByFn,
        manualGroupBy = instance.manualGroupBy,
        _instance$aggregation = instance.aggregations,
        userAggregations = _instance$aggregation === void 0 ? defaultUserAggregations : _instance$aggregation,
        plugins = instance.plugins,
        groupBy = instance.state.groupBy,
        dispatch = instance.dispatch,
        _instance$autoResetGr = instance.autoResetGroupBy,
        autoResetGroupBy = _instance$autoResetGr === void 0 ? true : _instance$autoResetGr,
        disableGroupBy = instance.disableGroupBy,
        defaultCanGroupBy = instance.defaultCanGroupBy,
        getHooks = instance.getHooks;
    ensurePluginOrder(plugins, ['useColumnOrder', 'useFilters'], 'useGroupBy');
    var getInstance = useGetLatest(instance);
    allColumns.forEach(function (column) {
      var accessor = column.accessor,
          defaultColumnGroupBy = column.defaultGroupBy,
          columnDisableGroupBy = column.disableGroupBy;
      column.canGroupBy = accessor ? getFirstDefined(column.canGroupBy, columnDisableGroupBy === true ? false : undefined, disableGroupBy === true ? false : undefined, true) : getFirstDefined(column.canGroupBy, defaultColumnGroupBy, defaultCanGroupBy, false);

      if (column.canGroupBy) {
        column.toggleGroupBy = function () {
          return instance.toggleGroupBy(column.id);
        };
      }

      column.Aggregated = column.Aggregated || column.Cell;
    });
    var toggleGroupBy = React.useCallback(function (columnId, value) {
      dispatch({
        type: actions.toggleGroupBy,
        columnId: columnId,
        value: value
      });
    }, [dispatch]);
    var setGroupBy = React.useCallback(function (value) {
      dispatch({
        type: actions.setGroupBy,
        value: value
      });
    }, [dispatch]);
    flatHeaders.forEach(function (header) {
      header.getGroupByToggleProps = makePropGetter(getHooks().getGroupByToggleProps, {
        instance: getInstance(),
        header: header
      });
    });

    var _React$useMemo = React.useMemo(function () {
      if (manualGroupBy || !groupBy.length) {
        return [rows, flatRows, rowsById, emptyArray, emptyObject, flatRows, rowsById];
      } // Ensure that the list of filtered columns exist


      var existingGroupBy = groupBy.filter(function (g) {
        return allColumns.find(function (col) {
          return col.id === g;
        });
      }); // Find the columns that can or are aggregating
      // Uses each column to aggregate rows into a single value

      var aggregateRowsToValues = function aggregateRowsToValues(leafRows, groupedRows, depth) {
        var values = {};
        allColumns.forEach(function (column) {
          // Don't aggregate columns that are in the groupBy
          if (existingGroupBy.includes(column.id)) {
            values[column.id] = groupedRows[0] ? groupedRows[0].values[column.id] : null;
            return;
          } // Aggregate the values


          var aggregateFn = typeof column.aggregate === 'function' ? column.aggregate : userAggregations[column.aggregate] || aggregations[column.aggregate];

          if (aggregateFn) {
            // Get the columnValues to aggregate
            var groupedValues = groupedRows.map(function (row) {
              return row.values[column.id];
            }); // Get the columnValues to aggregate

            var leafValues = leafRows.map(function (row) {
              var columnValue = row.values[column.id];

              if (!depth && column.aggregateValue) {
                var aggregateValueFn = typeof column.aggregateValue === 'function' ? column.aggregateValue : userAggregations[column.aggregateValue] || aggregations[column.aggregateValue];

                if (!aggregateValueFn) {
                  console.info({
                    column: column
                  });
                  throw new Error("React Table: Invalid column.aggregateValue option for column listed above");
                }

                columnValue = aggregateValueFn(columnValue, row, column);
              }

              return columnValue;
            });
            values[column.id] = aggregateFn(leafValues, groupedValues);
          } else if (column.aggregate) {
            console.info({
              column: column
            });
            throw new Error("React Table: Invalid column.aggregate option for column listed above");
          } else {
            values[column.id] = null;
          }
        });
        return values;
      };

      var groupedFlatRows = [];
      var groupedRowsById = {};
      var onlyGroupedFlatRows = [];
      var onlyGroupedRowsById = {};
      var nonGroupedFlatRows = [];
      var nonGroupedRowsById = {}; // Recursively group the data

      var groupUpRecursively = function groupUpRecursively(rows, depth, parentId) {
        if (depth === void 0) {
          depth = 0;
        }

        // This is the last level, just return the rows
        if (depth === existingGroupBy.length) {
          return rows;
        }

        var columnId = existingGroupBy[depth]; // Group the rows together for this level

        var rowGroupsMap = groupByFn(rows, columnId); // Peform aggregations for each group

        var aggregatedGroupedRows = Object.entries(rowGroupsMap).map(function (_ref4, index) {
          var groupByVal = _ref4[0],
              groupedRows = _ref4[1];
          var id = columnId + ":" + groupByVal;
          id = parentId ? parentId + ">" + id : id; // First, Recurse to group sub rows before aggregation

          var subRows = groupUpRecursively(groupedRows, depth + 1, id); // Flatten the leaf rows of the rows in this group

          var leafRows = depth ? flattenBy(groupedRows, 'leafRows') : groupedRows;
          var values = aggregateRowsToValues(leafRows, groupedRows, depth);
          var row = {
            id: id,
            isGrouped: true,
            groupByID: columnId,
            groupByVal: groupByVal,
            values: values,
            subRows: subRows,
            leafRows: leafRows,
            depth: depth,
            index: index
          };
          subRows.forEach(function (subRow) {
            groupedFlatRows.push(subRow);
            groupedRowsById[subRow.id] = subRow;

            if (subRow.isGrouped) {
              onlyGroupedFlatRows.push(subRow);
              onlyGroupedRowsById[subRow.id] = subRow;
            } else {
              nonGroupedFlatRows.push(subRow);
              nonGroupedRowsById[subRow.id] = subRow;
            }
          });
          return row;
        });
        return aggregatedGroupedRows;
      };

      var groupedRows = groupUpRecursively(rows);
      groupedRows.forEach(function (subRow) {
        groupedFlatRows.push(subRow);
        groupedRowsById[subRow.id] = subRow;

        if (subRow.isGrouped) {
          onlyGroupedFlatRows.push(subRow);
          onlyGroupedRowsById[subRow.id] = subRow;
        } else {
          nonGroupedFlatRows.push(subRow);
          nonGroupedRowsById[subRow.id] = subRow;
        }
      }); // Assign the new data

      return [groupedRows, groupedFlatRows, groupedRowsById, onlyGroupedFlatRows, onlyGroupedRowsById, nonGroupedFlatRows, nonGroupedRowsById];
    }, [manualGroupBy, groupBy, rows, flatRows, rowsById, allColumns, userAggregations, groupByFn]),
        groupedRows = _React$useMemo[0],
        groupedFlatRows = _React$useMemo[1],
        groupedRowsById = _React$useMemo[2],
        onlyGroupedFlatRows = _React$useMemo[3],
        onlyGroupedRowsById = _React$useMemo[4],
        nonGroupedFlatRows = _React$useMemo[5],
        nonGroupedRowsById = _React$useMemo[6];

    var getAutoResetGroupBy = useGetLatest(autoResetGroupBy);
    useMountedLayoutEffect(function () {
      if (getAutoResetGroupBy()) {
        dispatch({
          type: actions.resetGroupBy
        });
      }
    }, [dispatch, manualGroupBy ? null : data]);
    Object.assign(instance, {
      preGroupedRows: rows,
      preGroupedFlatRow: flatRows,
      preGroupedRowsById: rowsById,
      groupedRows: groupedRows,
      groupedFlatRows: groupedFlatRows,
      groupedRowsById: groupedRowsById,
      onlyGroupedFlatRows: onlyGroupedFlatRows,
      onlyGroupedRowsById: onlyGroupedRowsById,
      nonGroupedFlatRows: nonGroupedFlatRows,
      nonGroupedRowsById: nonGroupedRowsById,
      rows: groupedRows,
      flatRows: groupedFlatRows,
      rowsById: groupedRowsById,
      toggleGroupBy: toggleGroupBy,
      setGroupBy: setGroupBy
    });
  }

  function prepareRow$1(row) {
    row.allCells.forEach(function (cell) {
      var _row$subRows;

      // Grouped cells are in the groupBy and the pivot cell for the row
      cell.isGrouped = cell.column.isGrouped && cell.column.id === row.groupByID; // Placeholder cells are any columns in the groupBy that are not grouped

      cell.isPlaceholder = !cell.isGrouped && cell.column.isGrouped; // Aggregated cells are not grouped, not repeated, but still have subRows

      cell.isAggregated = !cell.isGrouped && !cell.isPlaceholder && ((_row$subRows = row.subRows) == null ? void 0 : _row$subRows.length);
    });
  }

  function defaultGroupByFn(rows, columnId) {
    return rows.reduce(function (prev, row, i) {
      // TODO: Might want to implement a key serializer here so
      // irregular column values can still be grouped if needed?
      var resKey = "" + row.values[columnId];
      prev[resKey] = Array.isArray(prev[resKey]) ? prev[resKey] : [];
      prev[resKey].push(row);
      return prev;
    }, {});
  }

  var reSplitAlphaNumeric = /([0-9]+)/gm; // Mixed sorting is slow, but very inclusive of many edge cases.
  // It handles numbers, mixed alphanumeric combinations, and even
  // null, undefined, and Infinity

  var alphanumeric = function alphanumeric(rowA, rowB, columnId) {
    var _getRowValuesByColumn = getRowValuesByColumnID(rowA, rowB, columnId),
        a = _getRowValuesByColumn[0],
        b = _getRowValuesByColumn[1]; // Force to strings (or "" for unsupported types)


    a = toString(a);
    b = toString(b); // Split on number groups, but keep the delimiter
    // Then remove falsey split values

    a = a.split(reSplitAlphaNumeric).filter(Boolean);
    b = b.split(reSplitAlphaNumeric).filter(Boolean); // While

    while (a.length && b.length) {
      var aa = a.shift();
      var bb = b.shift();
      var an = parseInt(aa, 10);
      var bn = parseInt(bb, 10);
      var combo = [an, bn].sort(); // Both are string

      if (isNaN(combo[0])) {
        if (aa > bb) {
          return 1;
        }

        if (bb > aa) {
          return -1;
        }

        continue;
      } // One is a string, one is a number


      if (isNaN(combo[1])) {
        return isNaN(an) ? -1 : 1;
      } // Both are numbers


      if (an > bn) {
        return 1;
      }

      if (bn > an) {
        return -1;
      }
    }

    return a.length - b.length;
  };
  function datetime(rowA, rowB, columnId) {
    var _getRowValuesByColumn2 = getRowValuesByColumnID(rowA, rowB, columnId),
        a = _getRowValuesByColumn2[0],
        b = _getRowValuesByColumn2[1];

    a = a.getTime();
    b = b.getTime();
    return compareBasic(a, b);
  }
  function basic(rowA, rowB, columnId) {
    var _getRowValuesByColumn3 = getRowValuesByColumnID(rowA, rowB, columnId),
        a = _getRowValuesByColumn3[0],
        b = _getRowValuesByColumn3[1];

    return compareBasic(a, b);
  }
  function string(rowA, rowB, columnId) {
    var _getRowValuesByColumn4 = getRowValuesByColumnID(rowA, rowB, columnId),
        a = _getRowValuesByColumn4[0],
        b = _getRowValuesByColumn4[1];

    a = a.split('').filter(Boolean);
    b = b.split('').filter(Boolean);

    while (a.length && b.length) {
      var aa = a.shift();
      var bb = b.shift();
      var alower = aa.toLowerCase();
      var blower = bb.toLowerCase(); // Case insensitive comparison until characters match

      if (alower > blower) {
        return 1;
      }

      if (blower > alower) {
        return -1;
      } // If lowercase characters are identical


      if (aa > bb) {
        return 1;
      }

      if (bb > aa) {
        return -1;
      }

      continue;
    }

    return a.length - b.length;
  }
  function number(rowA, rowB, columnId) {
    var _getRowValuesByColumn5 = getRowValuesByColumnID(rowA, rowB, columnId),
        a = _getRowValuesByColumn5[0],
        b = _getRowValuesByColumn5[1];

    var replaceNonNumeric = /[^0-9.]/gi;
    a = Number(String(a).replace(replaceNonNumeric, ''));
    b = Number(String(b).replace(replaceNonNumeric, ''));
    return compareBasic(a, b);
  } // Utils

  function compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
  }

  function getRowValuesByColumnID(row1, row2, columnId) {
    return [row1.values[columnId], row2.values[columnId]];
  }

  function toString(a) {
    if (typeof a === 'number') {
      if (isNaN(a) || a === Infinity || a === -Infinity) {
        return '';
      }

      return String(a);
    }

    if (typeof a === 'string') {
      return a;
    }

    return '';
  }

  var sortTypes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    alphanumeric: alphanumeric,
    datetime: datetime,
    basic: basic,
    string: string,
    number: number
  });

  actions.resetSortBy = 'resetSortBy';
  actions.setSortBy = 'setSortBy';
  actions.toggleSortBy = 'toggleSortBy';
  actions.clearSortBy = 'clearSortBy';
  defaultColumn.sortType = 'alphanumeric';
  defaultColumn.sortDescFirst = false;
  var useSortBy = function useSortBy(hooks) {
    hooks.getSortByToggleProps = [defaultGetSortByToggleProps];
    hooks.stateReducers.push(reducer$5);
    hooks.useInstance.push(useInstance$5);
  };
  useSortBy.pluginName = 'useSortBy';

  var defaultGetSortByToggleProps = function defaultGetSortByToggleProps(props, _ref) {
    var instance = _ref.instance,
        column = _ref.column;
    var _instance$isMultiSort = instance.isMultiSortEvent,
        isMultiSortEvent = _instance$isMultiSort === void 0 ? function (e) {
      return e.shiftKey;
    } : _instance$isMultiSort;
    return [props, {
      onClick: column.canSort ? function (e) {
        e.persist();
        column.toggleSortBy(undefined, !instance.disableMultiSort && isMultiSortEvent(e));
      } : undefined,
      style: {
        cursor: column.canSort ? 'pointer' : undefined
      },
      title: column.canSort ? 'Toggle SortBy' : undefined
    }];
  }; // Reducer


  function reducer$5(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        sortBy: []
      }, state);
    }

    if (action.type === actions.resetSortBy) {
      return _extends({}, state, {
        sortBy: instance.initialState.sortBy || []
      });
    }

    if (action.type === actions.clearSortBy) {
      var sortBy = state.sortBy;
      var newSortBy = sortBy.filter(function (d) {
        return d.id !== action.columnId;
      });
      return _extends({}, state, {
        sortBy: newSortBy
      });
    }

    if (action.type === actions.setSortBy) {
      var _sortBy = action.sortBy;
      return _extends({}, state, {
        sortBy: _sortBy
      });
    }

    if (action.type === actions.toggleSortBy) {
      var columnId = action.columnId,
          desc = action.desc,
          multi = action.multi;
      var allColumns = instance.allColumns,
          disableMultiSort = instance.disableMultiSort,
          disableSortRemove = instance.disableSortRemove,
          disableMultiRemove = instance.disableMultiRemove,
          _instance$maxMultiSor = instance.maxMultiSortColCount,
          maxMultiSortColCount = _instance$maxMultiSor === void 0 ? Number.MAX_SAFE_INTEGER : _instance$maxMultiSor;
      var _sortBy2 = state.sortBy; // Find the column for this columnId

      var column = allColumns.find(function (d) {
        return d.id === columnId;
      });
      var sortDescFirst = column.sortDescFirst; // Find any existing sortBy for this column

      var existingSortBy = _sortBy2.find(function (d) {
        return d.id === columnId;
      });

      var existingIndex = _sortBy2.findIndex(function (d) {
        return d.id === columnId;
      });

      var hasDescDefined = typeof desc !== 'undefined' && desc !== null;
      var _newSortBy = []; // What should we do with this sort action?

      var sortAction;

      if (!disableMultiSort && multi) {
        if (existingSortBy) {
          sortAction = 'toggle';
        } else {
          sortAction = 'add';
        }
      } else {
        // Normal mode
        if (existingIndex !== _sortBy2.length - 1 || _sortBy2.length !== 1) {
          sortAction = 'replace';
        } else if (existingSortBy) {
          sortAction = 'toggle';
        } else {
          sortAction = 'replace';
        }
      } // Handle toggle states that will remove the sortBy


      if (sortAction === 'toggle' && // Must be toggling
      !disableSortRemove && // If disableSortRemove, disable in general
      !hasDescDefined && ( // Must not be setting desc
      multi ? !disableMultiRemove : true) && ( // If multi, don't allow if disableMultiRemove
      existingSortBy && // Finally, detect if it should indeed be removed
      existingSortBy.desc && !sortDescFirst || !existingSortBy.desc && sortDescFirst)) {
        sortAction = 'remove';
      }

      if (sortAction === 'replace') {
        _newSortBy = [{
          id: columnId,
          desc: hasDescDefined ? desc : sortDescFirst
        }];
      } else if (sortAction === 'add') {
        _newSortBy = [].concat(_sortBy2, [{
          id: columnId,
          desc: hasDescDefined ? desc : sortDescFirst
        }]); // Take latest n columns

        _newSortBy.splice(0, _newSortBy.length - maxMultiSortColCount);
      } else if (sortAction === 'toggle') {
        // This flips (or sets) the
        _newSortBy = _sortBy2.map(function (d) {
          if (d.id === columnId) {
            return _extends({}, d, {
              desc: hasDescDefined ? desc : !existingSortBy.desc
            });
          }

          return d;
        });
      } else if (sortAction === 'remove') {
        _newSortBy = _sortBy2.filter(function (d) {
          return d.id !== columnId;
        });
      }

      return _extends({}, state, {
        sortBy: _newSortBy
      });
    }
  }

  function useInstance$5(instance) {
    var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        allColumns = instance.allColumns,
        _instance$orderByFn = instance.orderByFn,
        orderByFn = _instance$orderByFn === void 0 ? defaultOrderByFn : _instance$orderByFn,
        userSortTypes = instance.sortTypes,
        manualSortBy = instance.manualSortBy,
        defaultCanSort = instance.defaultCanSort,
        disableSortBy = instance.disableSortBy,
        flatHeaders = instance.flatHeaders,
        sortBy = instance.state.sortBy,
        dispatch = instance.dispatch,
        plugins = instance.plugins,
        getHooks = instance.getHooks,
        _instance$autoResetSo = instance.autoResetSortBy,
        autoResetSortBy = _instance$autoResetSo === void 0 ? true : _instance$autoResetSo;
    ensurePluginOrder(plugins, ['useFilters', 'useGlobalFilter', 'useGroupBy', 'usePivotColumns'], 'useSortBy');
    var setSortBy = React.useCallback(function (sortBy) {
      dispatch({
        type: actions.setSortBy,
        sortBy: sortBy
      });
    }, [dispatch]); // Updates sorting based on a columnId, desc flag and multi flag

    var toggleSortBy = React.useCallback(function (columnId, desc, multi) {
      dispatch({
        type: actions.toggleSortBy,
        columnId: columnId,
        desc: desc,
        multi: multi
      });
    }, [dispatch]); // use reference to avoid memory leak in #1608

    var getInstance = useGetLatest(instance); // Add the getSortByToggleProps method to columns and headers

    flatHeaders.forEach(function (column) {
      var accessor = column.accessor,
          defaultColumnCanSort = column.canSort,
          columnDisableSortBy = column.disableSortBy,
          id = column.id;
      var canSort = accessor ? getFirstDefined(columnDisableSortBy === true ? false : undefined, disableSortBy === true ? false : undefined, true) : getFirstDefined(defaultCanSort, defaultColumnCanSort, false);
      column.canSort = canSort;

      if (column.canSort) {
        column.toggleSortBy = function (desc, multi) {
          return toggleSortBy(column.id, desc, multi);
        };

        column.clearSortBy = function () {
          dispatch({
            type: actions.clearSortBy,
            columnId: column.id
          });
        };
      }

      column.getSortByToggleProps = makePropGetter(getHooks().getSortByToggleProps, {
        instance: getInstance(),
        column: column
      });
      var columnSort = sortBy.find(function (d) {
        return d.id === id;
      });
      column.isSorted = !!columnSort;
      column.sortedIndex = sortBy.findIndex(function (d) {
        return d.id === id;
      });
      column.isSortedDesc = column.isSorted ? columnSort.desc : undefined;
    });

    var _React$useMemo = React.useMemo(function () {
      if (manualSortBy || !sortBy.length) {
        return [rows, flatRows];
      }

      var sortedFlatRows = []; // Filter out sortBys that correspond to non existing columns

      var availableSortBy = sortBy.filter(function (sort) {
        return allColumns.find(function (col) {
          return col.id === sort.id;
        });
      });

      var sortData = function sortData(rows) {
        // Use the orderByFn to compose multiple sortBy's together.
        // This will also perform a stable sorting using the row index
        // if needed.
        var sortedData = orderByFn(rows, availableSortBy.map(function (sort) {
          // Support custom sorting methods for each column
          var column = allColumns.find(function (d) {
            return d.id === sort.id;
          });

          if (!column) {
            throw new Error("React-Table: Could not find a column with id: " + sort.id + " while sorting");
          }

          var sortType = column.sortType; // Look up sortBy functions in this order:
          // column function
          // column string lookup on user sortType
          // column string lookup on built-in sortType
          // default function
          // default string lookup on user sortType
          // default string lookup on built-in sortType

          var sortMethod = isFunction(sortType) || (userSortTypes || {})[sortType] || sortTypes[sortType];

          if (!sortMethod) {
            throw new Error("React-Table: Could not find a valid sortType of '" + sortType + "' for column '" + sort.id + "'.");
          } // Return the correct sortFn.
          // This function should always return in ascending order


          return function (a, b) {
            return sortMethod(a, b, sort.id, sort.desc);
          };
        }), // Map the directions
        availableSortBy.map(function (sort) {
          // Detect and use the sortInverted option
          var column = allColumns.find(function (d) {
            return d.id === sort.id;
          });

          if (column && column.sortInverted) {
            return sort.desc;
          }

          return !sort.desc;
        })); // If there are sub-rows, sort them

        sortedData.forEach(function (row) {
          sortedFlatRows.push(row);

          if (!row.subRows || row.subRows.length === 0) {
            return;
          }

          row.subRows = sortData(row.subRows);
        });
        return sortedData;
      };

      return [sortData(rows), sortedFlatRows];
    }, [manualSortBy, sortBy, rows, flatRows, allColumns, orderByFn, userSortTypes]),
        sortedRows = _React$useMemo[0],
        sortedFlatRows = _React$useMemo[1];

    var getAutoResetSortBy = useGetLatest(autoResetSortBy);
    useMountedLayoutEffect(function () {
      if (getAutoResetSortBy()) {
        dispatch({
          type: actions.resetSortBy
        });
      }
    }, [manualSortBy ? null : data]);
    Object.assign(instance, {
      preSortedRows: rows,
      preSortedFlatRows: flatRows,
      sortedRows: sortedRows,
      sortedFlatRows: sortedFlatRows,
      rows: sortedRows,
      flatRows: sortedFlatRows,
      setSortBy: setSortBy,
      toggleSortBy: toggleSortBy
    });
  }

  function defaultOrderByFn(arr, funcs, dirs) {
    return [].concat(arr).sort(function (rowA, rowB) {
      for (var i = 0; i < funcs.length; i += 1) {
        var sortFn = funcs[i];
        var desc = dirs[i] === false || dirs[i] === 'desc';
        var sortInt = sortFn(rowA, rowB);

        if (sortInt !== 0) {
          return desc ? -sortInt : sortInt;
        }
      }

      return dirs[0] ? rowA.index - rowB.index : rowB.index - rowA.index;
    });
  }

  var pluginName = 'usePagination'; // Actions

  actions.resetPage = 'resetPage';
  actions.gotoPage = 'gotoPage';
  actions.setPageSize = 'setPageSize';
  var usePagination = function usePagination(hooks) {
    hooks.stateReducers.push(reducer$6);
    hooks.useInstance.push(useInstance$6);
  };
  usePagination.pluginName = pluginName;

  function reducer$6(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        pageSize: 10,
        pageIndex: 0
      }, state);
    }

    if (action.type === actions.resetPage) {
      return _extends({}, state, {
        pageIndex: instance.initialState.pageIndex || 0
      });
    }

    if (action.type === actions.gotoPage) {
      var pageCount = instance.pageCount,
          page = instance.page;
      var newPageIndex = functionalUpdate(action.pageIndex, state.pageIndex);
      var canNavigate = false;

      if (newPageIndex > state.pageIndex) {
        // next page
        canNavigate = pageCount === -1 ? page.length >= state.pageSize : newPageIndex < pageCount;
      } else if (newPageIndex < state.pageIndex) {
        // prev page
        canNavigate = newPageIndex > -1;
      }

      if (!canNavigate) {
        return state;
      }

      return _extends({}, state, {
        pageIndex: newPageIndex
      });
    }

    if (action.type === actions.setPageSize) {
      var pageSize = action.pageSize;
      var topRowIndex = state.pageSize * state.pageIndex;
      var pageIndex = Math.floor(topRowIndex / pageSize);
      return _extends({}, state, {
        pageIndex: pageIndex,
        pageSize: pageSize
      });
    }
  }

  function useInstance$6(instance) {
    var rows = instance.rows,
        _instance$autoResetPa = instance.autoResetPage,
        autoResetPage = _instance$autoResetPa === void 0 ? true : _instance$autoResetPa,
        _instance$manualExpan = instance.manualExpandedKey,
        manualExpandedKey = _instance$manualExpan === void 0 ? 'expanded' : _instance$manualExpan,
        plugins = instance.plugins,
        userPageCount = instance.pageCount,
        _instance$paginateExp = instance.paginateExpandedRows,
        paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp,
        _instance$expandSubRo = instance.expandSubRows,
        expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo,
        _instance$state = instance.state,
        pageSize = _instance$state.pageSize,
        pageIndex = _instance$state.pageIndex,
        expanded = _instance$state.expanded,
        globalFilter = _instance$state.globalFilter,
        filters = _instance$state.filters,
        groupBy = _instance$state.groupBy,
        sortBy = _instance$state.sortBy,
        dispatch = instance.dispatch,
        data = instance.data,
        manualPagination = instance.manualPagination;
    ensurePluginOrder(plugins, ['useGlobalFilter', 'useFilters', 'useGroupBy', 'useSortBy', 'useExpanded'], 'usePagination');
    var getAutoResetPage = useGetLatest(autoResetPage);
    useMountedLayoutEffect(function () {
      if (getAutoResetPage()) {
        dispatch({
          type: actions.resetPage
        });
      }
    }, [dispatch, manualPagination ? null : data, globalFilter, filters, groupBy, sortBy]);
    var pageCount = manualPagination ? userPageCount : Math.ceil(rows.length / pageSize);
    var pageOptions = React.useMemo(function () {
      return pageCount > 0 ? [].concat(new Array(pageCount)).fill(null).map(function (d, i) {
        return i;
      }) : [];
    }, [pageCount]);
    var page = React.useMemo(function () {
      var page;

      if (manualPagination) {
        page = rows;
      } else {
        var pageStart = pageSize * pageIndex;
        var pageEnd = pageStart + pageSize;
        page = rows.slice(pageStart, pageEnd);
      }

      if (paginateExpandedRows) {
        return page;
      }

      return expandRows(page, {
        manualExpandedKey: manualExpandedKey,
        expanded: expanded,
        expandSubRows: expandSubRows
      });
    }, [expandSubRows, expanded, manualExpandedKey, manualPagination, pageIndex, pageSize, paginateExpandedRows, rows]);
    var canPreviousPage = pageIndex > 0;
    var canNextPage = pageCount === -1 ? page.length >= pageSize : pageIndex < pageCount - 1;
    var gotoPage = React.useCallback(function (pageIndex) {
      dispatch({
        type: actions.gotoPage,
        pageIndex: pageIndex
      });
    }, [dispatch]);
    var previousPage = React.useCallback(function () {
      return gotoPage(function (old) {
        return old - 1;
      });
    }, [gotoPage]);
    var nextPage = React.useCallback(function () {
      return gotoPage(function (old) {
        return old + 1;
      });
    }, [gotoPage]);
    var setPageSize = React.useCallback(function (pageSize) {
      dispatch({
        type: actions.setPageSize,
        pageSize: pageSize
      });
    }, [dispatch]);
    Object.assign(instance, {
      pageOptions: pageOptions,
      pageCount: pageCount,
      page: page,
      canPreviousPage: canPreviousPage,
      canNextPage: canNextPage,
      gotoPage: gotoPage,
      previousPage: previousPage,
      nextPage: nextPage,
      setPageSize: setPageSize
    });
  }

  actions.resetPivot = 'resetPivot';
  actions.togglePivot = 'togglePivot';
  var _UNSTABLE_usePivotColumns = function _UNSTABLE_usePivotColumns(hooks) {
    hooks.getPivotToggleProps = [defaultGetPivotToggleProps];
    hooks.stateReducers.push(reducer$7);
    hooks.useInstanceAfterData.push(useInstanceAfterData);
    hooks.allColumns.push(allColumns);
    hooks.accessValue.push(accessValue);
    hooks.materializedColumns.push(materializedColumns);
    hooks.materializedColumnsDeps.push(materializedColumnsDeps);
    hooks.visibleColumns.push(visibleColumns$1);
    hooks.visibleColumnsDeps.push(visibleColumnsDeps);
    hooks.useInstance.push(useInstance$7);
    hooks.prepareRow.push(prepareRow$2);
  };
  _UNSTABLE_usePivotColumns.pluginName = 'usePivotColumns';
  var defaultPivotColumns = [];

  var defaultGetPivotToggleProps = function defaultGetPivotToggleProps(props, _ref) {
    var header = _ref.header;
    return [props, {
      onClick: header.canPivot ? function (e) {
        e.persist();
        header.togglePivot();
      } : undefined,
      style: {
        cursor: header.canPivot ? 'pointer' : undefined
      },
      title: 'Toggle Pivot'
    }];
  }; // Reducer


  function reducer$7(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        pivotColumns: defaultPivotColumns
      }, state);
    }

    if (action.type === actions.resetPivot) {
      return _extends({}, state, {
        pivotColumns: instance.initialState.pivotColumns || defaultPivotColumns
      });
    }

    if (action.type === actions.togglePivot) {
      var columnId = action.columnId,
          setPivot = action.value;
      var resolvedPivot = typeof setPivot !== 'undefined' ? setPivot : !state.pivotColumns.includes(columnId);

      if (resolvedPivot) {
        return _extends({}, state, {
          pivotColumns: [].concat(state.pivotColumns, [columnId])
        });
      }

      return _extends({}, state, {
        pivotColumns: state.pivotColumns.filter(function (d) {
          return d !== columnId;
        })
      });
    }
  }

  function useInstanceAfterData(instance) {
    instance.allColumns.forEach(function (column) {
      column.isPivotSource = instance.state.pivotColumns.includes(column.id);
    });
  }

  function allColumns(columns, _ref2) {
    var instance = _ref2.instance;
    columns.forEach(function (column) {
      column.isPivotSource = instance.state.pivotColumns.includes(column.id);
      column.uniqueValues = new Set();
    });
    return columns;
  }

  function accessValue(value, _ref3) {
    var column = _ref3.column;

    if (column.uniqueValues && typeof value !== 'undefined') {
      column.uniqueValues.add(value);
    }

    return value;
  }

  function materializedColumns(materialized, _ref4) {
    var instance = _ref4.instance;
    var allColumns = instance.allColumns,
        state = instance.state;

    if (!state.pivotColumns.length || !state.groupBy || !state.groupBy.length) {
      return materialized;
    }

    var pivotColumns = state.pivotColumns.map(function (id) {
      return allColumns.find(function (d) {
        return d.id === id;
      });
    }).filter(Boolean);
    var sourceColumns = allColumns.filter(function (d) {
      return !d.isPivotSource && !state.groupBy.includes(d.id) && !state.pivotColumns.includes(d.id);
    });

    var buildPivotColumns = function buildPivotColumns(depth, parent, pivotFilters) {
      if (depth === void 0) {
        depth = 0;
      }

      if (pivotFilters === void 0) {
        pivotFilters = [];
      }

      var pivotColumn = pivotColumns[depth];

      if (!pivotColumn) {
        return sourceColumns.map(function (sourceColumn) {
          // TODO: We could offer support here for renesting pivoted
          // columns inside copies of their header groups. For now,
          // that seems like it would be (1) overkill on nesting, considering
          // you already get nesting for every pivot level and (2)
          // really hard. :)
          return _extends({}, sourceColumn, {
            canPivot: false,
            isPivoted: true,
            parent: parent,
            depth: depth,
            id: "" + (parent ? parent.id + "." + sourceColumn.id : sourceColumn.id),
            accessor: function accessor(originalRow, i, row) {
              if (pivotFilters.every(function (filter) {
                return filter(row);
              })) {
                return row.values[sourceColumn.id];
              }
            }
          });
        });
      }

      var uniqueValues = Array.from(pivotColumn.uniqueValues).sort();
      return uniqueValues.map(function (uniqueValue) {
        var columnGroup = _extends({}, pivotColumn, {
          Header: pivotColumn.PivotHeader || typeof pivotColumn.header === 'string' ? pivotColumn.Header + ": " + uniqueValue : uniqueValue,
          isPivotGroup: true,
          parent: parent,
          depth: depth,
          id: parent ? parent.id + "." + pivotColumn.id + "." + uniqueValue : pivotColumn.id + "." + uniqueValue,
          pivotValue: uniqueValue
        });

        columnGroup.columns = buildPivotColumns(depth + 1, columnGroup, [].concat(pivotFilters, [function (row) {
          return row.values[pivotColumn.id] === uniqueValue;
        }]));
        return columnGroup;
      });
    };

    var newMaterialized = flattenColumns(buildPivotColumns());
    return [].concat(materialized, newMaterialized);
  }

  function materializedColumnsDeps(deps, _ref5) {
    var _ref5$instance$state = _ref5.instance.state,
        pivotColumns = _ref5$instance$state.pivotColumns,
        groupBy = _ref5$instance$state.groupBy;
    return [].concat(deps, [pivotColumns, groupBy]);
  }

  function visibleColumns$1(visibleColumns, _ref6) {
    var state = _ref6.instance.state;
    visibleColumns = visibleColumns.filter(function (d) {
      return !d.isPivotSource;
    });

    if (state.pivotColumns.length && state.groupBy && state.groupBy.length) {
      visibleColumns = visibleColumns.filter(function (column) {
        return column.isGrouped || column.isPivoted;
      });
    }

    return visibleColumns;
  }

  function visibleColumnsDeps(deps, _ref7) {
    var instance = _ref7.instance;
    return [].concat(deps, [instance.state.pivotColumns, instance.state.groupBy]);
  }

  function useInstance$7(instance) {
    var columns = instance.columns,
        allColumns = instance.allColumns,
        flatHeaders = instance.flatHeaders,
        getHooks = instance.getHooks,
        plugins = instance.plugins,
        dispatch = instance.dispatch,
        _instance$autoResetPi = instance.autoResetPivot,
        autoResetPivot = _instance$autoResetPi === void 0 ? true : _instance$autoResetPi,
        manaulPivot = instance.manaulPivot,
        disablePivot = instance.disablePivot,
        defaultCanPivot = instance.defaultCanPivot;
    ensurePluginOrder(plugins, ['useGroupBy'], 'usePivotColumns');
    var getInstance = useGetLatest(instance);
    allColumns.forEach(function (column) {
      var accessor = column.accessor,
          defaultColumnPivot = column.defaultPivot,
          columnDisablePivot = column.disablePivot;
      column.canPivot = accessor ? getFirstDefined(column.canPivot, columnDisablePivot === true ? false : undefined, disablePivot === true ? false : undefined, true) : getFirstDefined(column.canPivot, defaultColumnPivot, defaultCanPivot, false);

      if (column.canPivot) {
        column.togglePivot = function () {
          return instance.togglePivot(column.id);
        };
      }

      column.Aggregated = column.Aggregated || column.Cell;
    });

    var togglePivot = function togglePivot(columnId, value) {
      dispatch({
        type: actions.togglePivot,
        columnId: columnId,
        value: value
      });
    };

    flatHeaders.forEach(function (header) {
      header.getPivotToggleProps = makePropGetter(getHooks().getPivotToggleProps, {
        instance: getInstance(),
        header: header
      });
    });
    var getAutoResetPivot = useGetLatest(autoResetPivot);
    useMountedLayoutEffect(function () {
      if (getAutoResetPivot()) {
        dispatch({
          type: actions.resetPivot
        });
      }
    }, [dispatch, manaulPivot ? null : columns]);
    Object.assign(instance, {
      togglePivot: togglePivot
    });
  }

  function prepareRow$2(row) {
    row.allCells.forEach(function (cell) {
      // Grouped cells are in the pivotColumns and the pivot cell for the row
      cell.isPivoted = cell.column.isPivoted;
    });
  }

  var pluginName$1 = 'useRowSelect'; // Actions

  actions.resetSelectedRows = 'resetSelectedRows';
  actions.toggleAllRowsSelected = 'toggleAllRowsSelected';
  actions.toggleRowSelected = 'toggleRowSelected';
  actions.toggleAllPageRowsSelected = 'toggleAllPageRowsSelected';
  var useRowSelect = function useRowSelect(hooks) {
    hooks.getToggleRowSelectedProps = [defaultGetToggleRowSelectedProps];
    hooks.getToggleAllRowsSelectedProps = [defaultGetToggleAllRowsSelectedProps];
    hooks.getToggleAllPageRowsSelectedProps = [defaultGetToggleAllPageRowsSelectedProps];
    hooks.stateReducers.push(reducer$8);
    hooks.useInstance.push(useInstance$8);
    hooks.prepareRow.push(prepareRow$3);
  };
  useRowSelect.pluginName = pluginName$1;

  var defaultGetToggleRowSelectedProps = function defaultGetToggleRowSelectedProps(props, _ref) {
    var instance = _ref.instance,
        row = _ref.row;
    var _instance$manualRowSe = instance.manualRowSelectedKey,
        manualRowSelectedKey = _instance$manualRowSe === void 0 ? 'isSelected' : _instance$manualRowSe;
    var checked = false;

    if (row.original && row.original[manualRowSelectedKey]) {
      checked = true;
    } else {
      checked = row.isSelected;
    }

    return [props, {
      onChange: function onChange(e) {
        row.toggleRowSelected(e.target.checked);
      },
      style: {
        cursor: 'pointer'
      },
      checked: checked,
      title: 'Toggle Row Selected',
      indeterminate: row.isSomeSelected
    }];
  };

  var defaultGetToggleAllRowsSelectedProps = function defaultGetToggleAllRowsSelectedProps(props, _ref2) {
    var instance = _ref2.instance;
    return [props, {
      onChange: function onChange(e) {
        instance.toggleAllRowsSelected(e.target.checked);
      },
      style: {
        cursor: 'pointer'
      },
      checked: instance.isAllRowsSelected,
      title: 'Toggle All Rows Selected',
      indeterminate: Boolean(!instance.isAllRowsSelected && Object.keys(instance.state.selectedRowIds).length)
    }];
  };

  var defaultGetToggleAllPageRowsSelectedProps = function defaultGetToggleAllPageRowsSelectedProps(props, _ref3) {
    var instance = _ref3.instance;
    return [props, {
      onChange: function onChange(e) {
        instance.toggleAllPageRowsSelected(e.target.checked);
      },
      style: {
        cursor: 'pointer'
      },
      checked: instance.isAllPageRowsSelected,
      title: 'Toggle All Current Page Rows Selected',
      indeterminate: Boolean(!instance.isAllPageRowsSelected && instance.page.some(function (_ref4) {
        var id = _ref4.id;
        return instance.state.selectedRowIds[id];
      }))
    }];
  }; // eslint-disable-next-line max-params


  function reducer$8(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        selectedRowIds: {}
      }, state);
    }

    if (action.type === actions.resetSelectedRows) {
      return _extends({}, state, {
        selectedRowIds: instance.initialState.selectedRowIds || {}
      });
    }

    if (action.type === actions.toggleAllRowsSelected) {
      var setSelected = action.value;
      var isAllRowsSelected = instance.isAllRowsSelected,
          rowsById = instance.rowsById,
          _instance$nonGroupedR = instance.nonGroupedRowsById,
          nonGroupedRowsById = _instance$nonGroupedR === void 0 ? rowsById : _instance$nonGroupedR;
      var selectAll = typeof setSelected !== 'undefined' ? setSelected : !isAllRowsSelected; // Only remove/add the rows that are visible on the screen
      //  Leave all the other rows that are selected alone.

      var selectedRowIds = Object.assign({}, state.selectedRowIds);

      if (selectAll) {
        Object.keys(nonGroupedRowsById).forEach(function (rowId) {
          selectedRowIds[rowId] = true;
        });
      } else {
        Object.keys(nonGroupedRowsById).forEach(function (rowId) {
          delete selectedRowIds[rowId];
        });
      }

      return _extends({}, state, {
        selectedRowIds: selectedRowIds
      });
    }

    if (action.type === actions.toggleRowSelected) {
      var id = action.id,
          _setSelected = action.value;
      var _rowsById = instance.rowsById,
          _instance$selectSubRo = instance.selectSubRows,
          selectSubRows = _instance$selectSubRo === void 0 ? true : _instance$selectSubRo,
          getSubRows = instance.getSubRows;
      var isSelected = state.selectedRowIds[id];
      var shouldExist = typeof _setSelected !== 'undefined' ? _setSelected : !isSelected;

      if (isSelected === shouldExist) {
        return state;
      }

      var newSelectedRowIds = _extends({}, state.selectedRowIds);

      var handleRowById = function handleRowById(id) {
        var row = _rowsById[id];

        if (!row.isGrouped) {
          if (shouldExist) {
            newSelectedRowIds[id] = true;
          } else {
            delete newSelectedRowIds[id];
          }
        }

        if (selectSubRows && getSubRows(row)) {
          return getSubRows(row).forEach(function (row) {
            return handleRowById(row.id);
          });
        }
      };

      handleRowById(id);
      return _extends({}, state, {
        selectedRowIds: newSelectedRowIds
      });
    }

    if (action.type === actions.toggleAllPageRowsSelected) {
      var _setSelected2 = action.value;

      var page = instance.page,
          _rowsById2 = instance.rowsById,
          _instance$selectSubRo2 = instance.selectSubRows,
          _selectSubRows = _instance$selectSubRo2 === void 0 ? true : _instance$selectSubRo2,
          isAllPageRowsSelected = instance.isAllPageRowsSelected,
          _getSubRows = instance.getSubRows;

      var _selectAll = typeof _setSelected2 !== 'undefined' ? _setSelected2 : !isAllPageRowsSelected;

      var _newSelectedRowIds = _extends({}, state.selectedRowIds);

      var _handleRowById = function _handleRowById(id) {
        var row = _rowsById2[id];

        if (!row.isGrouped) {
          if (_selectAll) {
            _newSelectedRowIds[id] = true;
          } else {
            delete _newSelectedRowIds[id];
          }
        }

        if (_selectSubRows && _getSubRows(row)) {
          return _getSubRows(row).forEach(function (row) {
            return _handleRowById(row.id);
          });
        }
      };

      page.forEach(function (row) {
        return _handleRowById(row.id);
      });
      return _extends({}, state, {
        selectedRowIds: _newSelectedRowIds
      });
    }

    return state;
  }

  function useInstance$8(instance) {
    var data = instance.data,
        rows = instance.rows,
        getHooks = instance.getHooks,
        plugins = instance.plugins,
        rowsById = instance.rowsById,
        _instance$nonGroupedR2 = instance.nonGroupedRowsById,
        nonGroupedRowsById = _instance$nonGroupedR2 === void 0 ? rowsById : _instance$nonGroupedR2,
        _instance$autoResetSe = instance.autoResetSelectedRows,
        autoResetSelectedRows = _instance$autoResetSe === void 0 ? true : _instance$autoResetSe,
        selectedRowIds = instance.state.selectedRowIds,
        _instance$selectSubRo3 = instance.selectSubRows,
        selectSubRows = _instance$selectSubRo3 === void 0 ? true : _instance$selectSubRo3,
        dispatch = instance.dispatch,
        page = instance.page,
        getSubRows = instance.getSubRows;
    ensurePluginOrder(plugins, ['useFilters', 'useGroupBy', 'useSortBy', 'useExpanded', 'usePagination'], 'useRowSelect');
    var selectedFlatRows = React.useMemo(function () {
      var selectedFlatRows = [];
      rows.forEach(function (row) {
        var isSelected = selectSubRows ? getRowIsSelected(row, selectedRowIds, getSubRows) : !!selectedRowIds[row.id];
        row.isSelected = !!isSelected;
        row.isSomeSelected = isSelected === null;

        if (isSelected) {
          selectedFlatRows.push(row);
        }
      });
      return selectedFlatRows;
    }, [rows, selectSubRows, selectedRowIds, getSubRows]);
    var isAllRowsSelected = Boolean(Object.keys(nonGroupedRowsById).length && Object.keys(selectedRowIds).length);
    var isAllPageRowsSelected = isAllRowsSelected;

    if (isAllRowsSelected) {
      if (Object.keys(nonGroupedRowsById).some(function (id) {
        return !selectedRowIds[id];
      })) {
        isAllRowsSelected = false;
      }
    }

    if (!isAllRowsSelected) {
      if (page && page.length && page.some(function (_ref5) {
        var id = _ref5.id;
        return !selectedRowIds[id];
      })) {
        isAllPageRowsSelected = false;
      }
    }

    var getAutoResetSelectedRows = useGetLatest(autoResetSelectedRows);
    useMountedLayoutEffect(function () {
      if (getAutoResetSelectedRows()) {
        dispatch({
          type: actions.resetSelectedRows
        });
      }
    }, [dispatch, data]);
    var toggleAllRowsSelected = React.useCallback(function (value) {
      return dispatch({
        type: actions.toggleAllRowsSelected,
        value: value
      });
    }, [dispatch]);
    var toggleAllPageRowsSelected = React.useCallback(function (value) {
      return dispatch({
        type: actions.toggleAllPageRowsSelected,
        value: value
      });
    }, [dispatch]);
    var toggleRowSelected = React.useCallback(function (id, value) {
      return dispatch({
        type: actions.toggleRowSelected,
        id: id,
        value: value
      });
    }, [dispatch]);
    var getInstance = useGetLatest(instance);
    var getToggleAllRowsSelectedProps = makePropGetter(getHooks().getToggleAllRowsSelectedProps, {
      instance: getInstance()
    });
    var getToggleAllPageRowsSelectedProps = makePropGetter(getHooks().getToggleAllPageRowsSelectedProps, {
      instance: getInstance()
    });
    Object.assign(instance, {
      selectedFlatRows: selectedFlatRows,
      isAllRowsSelected: isAllRowsSelected,
      isAllPageRowsSelected: isAllPageRowsSelected,
      toggleRowSelected: toggleRowSelected,
      toggleAllRowsSelected: toggleAllRowsSelected,
      getToggleAllRowsSelectedProps: getToggleAllRowsSelectedProps,
      getToggleAllPageRowsSelectedProps: getToggleAllPageRowsSelectedProps,
      toggleAllPageRowsSelected: toggleAllPageRowsSelected
    });
  }

  function prepareRow$3(row, _ref6) {
    var instance = _ref6.instance;

    row.toggleRowSelected = function (set) {
      return instance.toggleRowSelected(row.id, set);
    };

    row.getToggleRowSelectedProps = makePropGetter(instance.getHooks().getToggleRowSelectedProps, {
      instance: instance,
      row: row
    });
  }

  function getRowIsSelected(row, selectedRowIds, getSubRows) {
    if (selectedRowIds[row.id]) {
      return true;
    }

    var subRows = getSubRows(row);

    if (subRows && subRows.length) {
      var allChildrenSelected = true;
      var someSelected = false;
      subRows.forEach(function (subRow) {
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) {
          return;
        }

        if (getRowIsSelected(subRow, selectedRowIds, getSubRows)) {
          someSelected = true;
        } else {
          allChildrenSelected = false;
        }
      });
      return allChildrenSelected ? true : someSelected ? null : false;
    }

    return false;
  }

  var defaultInitialRowStateAccessor = function defaultInitialRowStateAccessor(row) {
    return {};
  };

  var defaultInitialCellStateAccessor = function defaultInitialCellStateAccessor(cell) {
    return {};
  }; // Actions


  actions.setRowState = 'setRowState';
  actions.setCellState = 'setCellState';
  actions.resetRowState = 'resetRowState';
  var useRowState = function useRowState(hooks) {
    hooks.stateReducers.push(reducer$9);
    hooks.useInstance.push(useInstance$9);
    hooks.prepareRow.push(prepareRow$4);
  };
  useRowState.pluginName = 'useRowState';

  function reducer$9(state, action, previousState, instance) {
    var _instance$initialRowS = instance.initialRowStateAccessor,
        initialRowStateAccessor = _instance$initialRowS === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS,
        _instance$initialCell = instance.initialCellStateAccessor,
        initialCellStateAccessor = _instance$initialCell === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell,
        rowsById = instance.rowsById;

    if (action.type === actions.init) {
      return _extends({
        rowState: {}
      }, state);
    }

    if (action.type === actions.resetRowState) {
      return _extends({}, state, {
        rowState: instance.initialState.rowState || {}
      });
    }

    if (action.type === actions.setRowState) {
      var _extends2;

      var rowId = action.rowId,
          value = action.value;
      var oldRowState = typeof state.rowState[rowId] !== 'undefined' ? state.rowState[rowId] : initialRowStateAccessor(rowsById[rowId]);
      return _extends({}, state, {
        rowState: _extends({}, state.rowState, (_extends2 = {}, _extends2[rowId] = functionalUpdate(value, oldRowState), _extends2))
      });
    }

    if (action.type === actions.setCellState) {
      var _oldRowState$cellStat, _rowsById$_rowId, _rowsById$_rowId$cell, _extends3, _extends4;

      var _rowId = action.rowId,
          columnId = action.columnId,
          _value = action.value;

      var _oldRowState = typeof state.rowState[_rowId] !== 'undefined' ? state.rowState[_rowId] : initialRowStateAccessor(rowsById[_rowId]);

      var oldCellState = typeof (_oldRowState == null ? void 0 : (_oldRowState$cellStat = _oldRowState.cellState) == null ? void 0 : _oldRowState$cellStat[columnId]) !== 'undefined' ? _oldRowState.cellState[columnId] : initialCellStateAccessor((_rowsById$_rowId = rowsById[_rowId]) == null ? void 0 : (_rowsById$_rowId$cell = _rowsById$_rowId.cells) == null ? void 0 : _rowsById$_rowId$cell.find(function (cell) {
        return cell.column.id === columnId;
      }));
      return _extends({}, state, {
        rowState: _extends({}, state.rowState, (_extends4 = {}, _extends4[_rowId] = _extends({}, _oldRowState, {
          cellState: _extends({}, _oldRowState.cellState || {}, (_extends3 = {}, _extends3[columnId] = functionalUpdate(_value, oldCellState), _extends3))
        }), _extends4))
      });
    }
  }

  function useInstance$9(instance) {
    var _instance$autoResetRo = instance.autoResetRowState,
        autoResetRowState = _instance$autoResetRo === void 0 ? true : _instance$autoResetRo,
        data = instance.data,
        dispatch = instance.dispatch;
    var setRowState = React.useCallback(function (rowId, value) {
      return dispatch({
        type: actions.setRowState,
        rowId: rowId,
        value: value
      });
    }, [dispatch]);
    var setCellState = React.useCallback(function (rowId, columnId, value) {
      return dispatch({
        type: actions.setCellState,
        rowId: rowId,
        columnId: columnId,
        value: value
      });
    }, [dispatch]);
    var getAutoResetRowState = useGetLatest(autoResetRowState);
    useMountedLayoutEffect(function () {
      if (getAutoResetRowState()) {
        dispatch({
          type: actions.resetRowState
        });
      }
    }, [data]);
    Object.assign(instance, {
      setRowState: setRowState,
      setCellState: setCellState
    });
  }

  function prepareRow$4(row, _ref) {
    var instance = _ref.instance;
    var _instance$initialRowS2 = instance.initialRowStateAccessor,
        initialRowStateAccessor = _instance$initialRowS2 === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS2,
        _instance$initialCell2 = instance.initialCellStateAccessor,
        initialCellStateAccessor = _instance$initialCell2 === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell2,
        rowState = instance.state.rowState;

    if (row) {
      row.state = typeof rowState[row.id] !== 'undefined' ? rowState[row.id] : initialRowStateAccessor(row);

      row.setState = function (updater) {
        return instance.setRowState(row.id, updater);
      };

      row.cells.forEach(function (cell) {
        if (!row.state.cellState) {
          row.state.cellState = {};
        }

        cell.state = typeof row.state.cellState[cell.column.id] !== 'undefined' ? row.state.cellState[cell.column.id] : initialCellStateAccessor(cell);

        cell.setState = function (updater) {
          return instance.setCellState(row.id, cell.column.id, updater);
        };
      });
    }
  }

  actions.resetColumnOrder = 'resetColumnOrder';
  actions.setColumnOrder = 'setColumnOrder';
  var useColumnOrder = function useColumnOrder(hooks) {
    hooks.stateReducers.push(reducer$a);
    hooks.visibleColumnsDeps.push(function (deps, _ref) {
      var instance = _ref.instance;
      return [].concat(deps, [instance.state.columnOrder]);
    });
    hooks.visibleColumns.push(visibleColumns$2);
    hooks.useInstance.push(useInstance$a);
  };
  useColumnOrder.pluginName = 'useColumnOrder';

  function reducer$a(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        columnOrder: []
      }, state);
    }

    if (action.type === actions.resetColumnOrder) {
      return _extends({}, state, {
        columnOrder: instance.initialState.columnOrder || []
      });
    }

    if (action.type === actions.setColumnOrder) {
      return _extends({}, state, {
        columnOrder: functionalUpdate(action.columnOrder, state.columnOrder)
      });
    }
  }

  function visibleColumns$2(columns, _ref2) {
    var columnOrder = _ref2.instance.state.columnOrder;

    // If there is no order, return the normal columns
    if (!columnOrder || !columnOrder.length) {
      return columns;
    }

    var columnOrderCopy = [].concat(columnOrder); // If there is an order, make a copy of the columns

    var columnsCopy = [].concat(columns); // And make a new ordered array of the columns

    var columnsInOrder = []; // Loop over the columns and place them in order into the new array

    var _loop = function _loop() {
      var targetColumnId = columnOrderCopy.shift();
      var foundIndex = columnsCopy.findIndex(function (d) {
        return d.id === targetColumnId;
      });

      if (foundIndex > -1) {
        columnsInOrder.push(columnsCopy.splice(foundIndex, 1)[0]);
      }
    };

    while (columnsCopy.length && columnOrderCopy.length) {
      _loop();
    } // If there are any columns left, add them to the end


    return [].concat(columnsInOrder, columnsCopy);
  }

  function useInstance$a(instance) {
    var dispatch = instance.dispatch;
    instance.setColumnOrder = React.useCallback(function (columnOrder) {
      return dispatch({
        type: actions.setColumnOrder,
        columnOrder: columnOrder
      });
    }, [dispatch]);
  }

  defaultColumn.canResize = true; // Actions

  actions.columnStartResizing = 'columnStartResizing';
  actions.columnResizing = 'columnResizing';
  actions.columnDoneResizing = 'columnDoneResizing';
  actions.resetResize = 'resetResize';
  var useResizeColumns = function useResizeColumns(hooks) {
    hooks.getResizerProps = [defaultGetResizerProps];
    hooks.getHeaderProps.push({
      style: {
        position: 'relative'
      }
    });
    hooks.stateReducers.push(reducer$b);
    hooks.useInstance.push(useInstance$b);
    hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions$1);
  };

  var defaultGetResizerProps = function defaultGetResizerProps(props, _ref) {
    var instance = _ref.instance,
        header = _ref.header;
    var dispatch = instance.dispatch;

    var onResizeStart = function onResizeStart(e, header) {
      var isTouchEvent = false;

      if (e.type === 'touchstart') {
        // lets not respond to multiple touches (e.g. 2 or 3 fingers)
        if (e.touches && e.touches.length > 1) {
          return;
        }

        isTouchEvent = true;
      }

      var headersToResize = getLeafHeaders(header);
      var headerIdWidths = headersToResize.map(function (d) {
        return [d.id, d.totalWidth];
      });
      var clientX = isTouchEvent ? Math.round(e.touches[0].clientX) : e.clientX;

      var dispatchMove = function dispatchMove(clientXPos) {
        dispatch({
          type: actions.columnResizing,
          clientX: clientXPos
        });
      };

      var dispatchEnd = function dispatchEnd() {
        return dispatch({
          type: actions.columnDoneResizing
        });
      };

      var handlersAndEvents = {
        mouse: {
          moveEvent: 'mousemove',
          moveHandler: function moveHandler(e) {
            return dispatchMove(e.clientX);
          },
          upEvent: 'mouseup',
          upHandler: function upHandler(e) {
            document.removeEventListener('mousemove', handlersAndEvents.mouse.moveHandler);
            document.removeEventListener('mouseup', handlersAndEvents.mouse.upHandler);
            dispatchEnd();
          }
        },
        touch: {
          moveEvent: 'touchmove',
          moveHandler: function moveHandler(e) {
            if (e.cancelable) {
              e.preventDefault();
              e.stopPropagation();
            }

            dispatchMove(e.touches[0].clientX);
            return false;
          },
          upEvent: 'touchend',
          upHandler: function upHandler(e) {
            document.removeEventListener(handlersAndEvents.touch.moveEvent, handlersAndEvents.touch.moveHandler);
            document.removeEventListener(handlersAndEvents.touch.upEvent, handlersAndEvents.touch.moveHandler);
            dispatchEnd();
          }
        }
      };
      var events = isTouchEvent ? handlersAndEvents.touch : handlersAndEvents.mouse;
      var passiveIfSupported = passiveEventSupported() ? {
        passive: false
      } : false;
      document.addEventListener(events.moveEvent, events.moveHandler, passiveIfSupported);
      document.addEventListener(events.upEvent, events.upHandler, passiveIfSupported);
      dispatch({
        type: actions.columnStartResizing,
        columnId: header.id,
        columnWidth: header.totalWidth,
        headerIdWidths: headerIdWidths,
        clientX: clientX
      });
    };

    return [props, {
      onMouseDown: function onMouseDown(e) {
        return e.persist() || onResizeStart(e, header);
      },
      onTouchStart: function onTouchStart(e) {
        return e.persist() || onResizeStart(e, header);
      },
      style: {
        cursor: 'col-resize'
      },
      draggable: false,
      role: 'separator'
    }];
  };

  useResizeColumns.pluginName = 'useResizeColumns';

  function reducer$b(state, action) {
    if (action.type === actions.init) {
      return _extends({
        columnResizing: {
          columnWidths: {}
        }
      }, state);
    }

    if (action.type === actions.resetResize) {
      return _extends({}, state, {
        columnResizing: {
          columnWidths: {}
        }
      });
    }

    if (action.type === actions.columnStartResizing) {
      var clientX = action.clientX,
          columnId = action.columnId,
          columnWidth = action.columnWidth,
          headerIdWidths = action.headerIdWidths;
      return _extends({}, state, {
        columnResizing: _extends({}, state.columnResizing, {
          startX: clientX,
          headerIdWidths: headerIdWidths,
          columnWidth: columnWidth,
          isResizingColumn: columnId
        })
      });
    }

    if (action.type === actions.columnResizing) {
      var _clientX = action.clientX;

      var _state$columnResizing = state.columnResizing,
          startX = _state$columnResizing.startX,
          _columnWidth = _state$columnResizing.columnWidth,
          _state$columnResizing2 = _state$columnResizing.headerIdWidths,
          _headerIdWidths = _state$columnResizing2 === void 0 ? [] : _state$columnResizing2;

      var deltaX = _clientX - startX;
      var percentageDeltaX = deltaX / _columnWidth;
      var newColumnWidths = {};

      _headerIdWidths.forEach(function (_ref2) {
        var headerId = _ref2[0],
            headerWidth = _ref2[1];
        newColumnWidths[headerId] = Math.max(headerWidth + headerWidth * percentageDeltaX, 0);
      });

      return _extends({}, state, {
        columnResizing: _extends({}, state.columnResizing, {
          columnWidths: _extends({}, state.columnResizing.columnWidths, {}, newColumnWidths)
        })
      });
    }

    if (action.type === actions.columnDoneResizing) {
      return _extends({}, state, {
        columnResizing: _extends({}, state.columnResizing, {
          startX: null,
          isResizingColumn: null
        })
      });
    }
  }

  var useInstanceBeforeDimensions$1 = function useInstanceBeforeDimensions(instance) {
    var flatHeaders = instance.flatHeaders,
        disableResizing = instance.disableResizing,
        getHooks = instance.getHooks,
        columnResizing = instance.state.columnResizing;
    var getInstance = useGetLatest(instance);
    flatHeaders.forEach(function (header) {
      var canResize = getFirstDefined(header.disableResizing === true ? false : undefined, disableResizing === true ? false : undefined, true);
      header.canResize = canResize;
      header.width = columnResizing.columnWidths[header.id] || header.originalWidth || header.width;
      header.isResizing = columnResizing.isResizingColumn === header.id;

      if (canResize) {
        header.getResizerProps = makePropGetter(getHooks().getResizerProps, {
          instance: getInstance(),
          header: header
        });
      }
    });
  };

  function useInstance$b(instance) {
    var plugins = instance.plugins,
        dispatch = instance.dispatch,
        _instance$autoResetRe = instance.autoResetResize,
        autoResetResize = _instance$autoResetRe === void 0 ? true : _instance$autoResetRe,
        columns = instance.columns;
    ensurePluginOrder(plugins, ['useAbsoluteLayout'], 'useResizeColumns');
    var getAutoResetResize = useGetLatest(autoResetResize);
    useMountedLayoutEffect(function () {
      if (getAutoResetResize()) {
        dispatch({
          type: actions.resetResize
        });
      }
    }, [columns]);
    var resetResizing = React.useCallback(function () {
      return dispatch({
        type: actions.resetResize
      });
    }, [dispatch]);
    Object.assign(instance, {
      resetResizing: resetResizing
    });
  }

  function getLeafHeaders(header) {
    var leafHeaders = [];

    var recurseHeader = function recurseHeader(header) {
      if (header.columns && header.columns.length) {
        header.columns.map(recurseHeader);
      }

      leafHeaders.push(header);
    };

    recurseHeader(header);
    return leafHeaders;
  }

  var cellStyles = {
    position: 'absolute',
    top: 0
  };
  var useAbsoluteLayout = function useAbsoluteLayout(hooks) {
    hooks.getTableBodyProps.push(getRowStyles);
    hooks.getRowProps.push(getRowStyles);
    hooks.getHeaderGroupProps.push(getRowStyles);
    hooks.getFooterGroupProps.push(getRowStyles);
    hooks.getHeaderProps.push(function (props, _ref) {
      var column = _ref.column;
      return [props, {
        style: _extends({}, cellStyles, {
          left: column.totalLeft + "px",
          width: column.totalWidth + "px"
        })
      }];
    });
    hooks.getCellProps.push(function (props, _ref2) {
      var cell = _ref2.cell;
      return [props, {
        style: _extends({}, cellStyles, {
          left: cell.column.totalLeft + "px",
          width: cell.column.totalWidth + "px"
        })
      }];
    });
    hooks.getFooterProps.push(function (props, _ref3) {
      var column = _ref3.column;
      return [props, {
        style: _extends({}, cellStyles, {
          left: column.totalLeft + "px",
          width: column.totalWidth + "px"
        })
      }];
    });
  };
  useAbsoluteLayout.pluginName = 'useAbsoluteLayout';

  var getRowStyles = function getRowStyles(props, _ref4) {
    var instance = _ref4.instance;
    return [props, {
      style: {
        position: 'relative',
        width: instance.totalColumnsWidth + "px"
      }
    }];
  };

  var cellStyles$1 = {
    display: 'inline-block',
    boxSizing: 'border-box'
  };

  var getRowStyles$1 = function getRowStyles(props, _ref) {
    var instance = _ref.instance;
    return [props, {
      style: {
        display: 'flex',
        width: instance.totalColumnsWidth + "px"
      }
    }];
  };

  var useBlockLayout = function useBlockLayout(hooks) {
    hooks.getRowProps.push(getRowStyles$1);
    hooks.getHeaderGroupProps.push(getRowStyles$1);
    hooks.getFooterGroupProps.push(getRowStyles$1);
    hooks.getHeaderProps.push(function (props, _ref2) {
      var column = _ref2.column;
      return [props, {
        style: _extends({}, cellStyles$1, {
          width: column.totalWidth + "px"
        })
      }];
    });
    hooks.getCellProps.push(function (props, _ref3) {
      var cell = _ref3.cell;
      return [props, {
        style: _extends({}, cellStyles$1, {
          width: cell.column.totalWidth + "px"
        })
      }];
    });
    hooks.getFooterProps.push(function (props, _ref4) {
      var column = _ref4.column;
      return [props, {
        style: _extends({}, cellStyles$1, {
          width: column.totalWidth + "px"
        })
      }];
    });
  };
  useBlockLayout.pluginName = 'useBlockLayout';

  function useFlexLayout(hooks) {
    hooks.getTableProps.push(getTableProps);
    hooks.getRowProps.push(getRowStyles$2);
    hooks.getHeaderGroupProps.push(getRowStyles$2);
    hooks.getFooterGroupProps.push(getRowStyles$2);
    hooks.getHeaderProps.push(getHeaderProps);
    hooks.getCellProps.push(getCellProps);
    hooks.getFooterProps.push(getFooterProps);
  }
  useFlexLayout.pluginName = 'useFlexLayout';

  var getTableProps = function getTableProps(props, _ref) {
    var instance = _ref.instance;
    return [props, {
      style: {
        minWidth: instance.totalColumnsMinWidth + "px"
      }
    }];
  };

  var getRowStyles$2 = function getRowStyles(props, _ref2) {
    var instance = _ref2.instance;
    return [props, {
      style: {
        display: 'flex',
        flex: '1 0 auto',
        minWidth: instance.totalColumnsMinWidth + "px"
      }
    }];
  };

  var getHeaderProps = function getHeaderProps(props, _ref3) {
    var column = _ref3.column;
    return [props, {
      style: {
        boxSizing: 'border-box',
        flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : undefined,
        minWidth: column.totalMinWidth + "px",
        width: column.totalWidth + "px"
      }
    }];
  };

  var getCellProps = function getCellProps(props, _ref4) {
    var cell = _ref4.cell;
    return [props, {
      style: {
        boxSizing: 'border-box',
        flex: cell.column.totalFlexWidth + " 0 auto",
        minWidth: cell.column.totalMinWidth + "px",
        width: cell.column.totalWidth + "px"
      }
    }];
  };

  var getFooterProps = function getFooterProps(props, _ref5) {
    var column = _ref5.column;
    return [props, {
      style: {
        boxSizing: 'border-box',
        flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : undefined,
        minWidth: column.totalMinWidth + "px",
        width: column.totalWidth + "px"
      }
    }];
  };

  function useGridLayout(hooks) {
    hooks.stateReducers.push(reducer$c);
    hooks.getTableProps.push(getTableProps$1);
    hooks.getHeaderProps.push(getHeaderProps$1);
  }
  useGridLayout.pluginName = 'useGridLayout';

  var getTableProps$1 = function getTableProps(props, _ref) {
    var instance = _ref.instance;
    return [props, {
      style: {
        display: "grid",
        gridTemplateColumns: instance.state.gridLayout.columnWidths.map(function (w) {
          return w;
        }).join(" ")
      }
    }];
  };

  var getHeaderProps$1 = function getHeaderProps(props, _ref2) {
    var column = _ref2.column;
    return [props, {
      id: "header-cell-" + column.id,
      style: {
        position: "sticky" //enables a scroll wrapper to be placed around the table and have sticky headers

      }
    }];
  };

  function reducer$c(state, action, previousState, instance) {
    if (action.type === "init") {
      return _extends({
        gridLayout: {
          columnWidths: instance.columns.map(function () {
            return "auto";
          })
        }
      }, state);
    }

    if (action.type === "columnStartResizing") {
      var columnId = action.columnId;
      var columnIndex = instance.visibleColumns.findIndex(function (col) {
        return col.id === columnId;
      });
      var elWidth = getElementWidth(columnId);

      if (elWidth !== undefined) {
        return _extends({}, state, {
          gridLayout: _extends({}, state.gridLayout, {
            columnId: columnId,
            columnIndex: columnIndex,
            startingWidth: elWidth
          })
        });
      } else {
        return state;
      }
    }

    if (action.type === "columnResizing") {
      var _state$gridLayout = state.gridLayout,
          _columnIndex = _state$gridLayout.columnIndex,
          startingWidth = _state$gridLayout.startingWidth,
          columnWidths = _state$gridLayout.columnWidths;
      var change = state.columnResizing.startX - action.clientX;
      var newWidth = startingWidth - change;
      var columnWidthsCopy = [].concat(columnWidths);
      columnWidthsCopy[_columnIndex] = newWidth + "px";
      return _extends({}, state, {
        gridLayout: _extends({}, state.gridLayout, {
          columnWidths: columnWidthsCopy
        })
      });
    }
  }

  function getElementWidth(columnId) {
    var _document$getElementB;

    var width = (_document$getElementB = document.getElementById("header-cell-" + columnId)) == null ? void 0 : _document$getElementB.offsetWidth;

    if (width !== undefined) {
      return width;
    }
  }

  exports._UNSTABLE_usePivotColumns = _UNSTABLE_usePivotColumns;
  exports.actions = actions;
  exports.defaultColumn = defaultColumn;
  exports.defaultGroupByFn = defaultGroupByFn;
  exports.defaultOrderByFn = defaultOrderByFn;
  exports.defaultRenderer = defaultRenderer;
  exports.emptyRenderer = emptyRenderer;
  exports.ensurePluginOrder = ensurePluginOrder;
  exports.flexRender = flexRender;
  exports.functionalUpdate = functionalUpdate;
  exports.loopHooks = loopHooks;
  exports.makePropGetter = makePropGetter;
  exports.makeRenderer = makeRenderer;
  exports.reduceHooks = reduceHooks;
  exports.safeUseLayoutEffect = safeUseLayoutEffect;
  exports.useAbsoluteLayout = useAbsoluteLayout;
  exports.useAsyncDebounce = useAsyncDebounce;
  exports.useBlockLayout = useBlockLayout;
  exports.useColumnOrder = useColumnOrder;
  exports.useExpanded = useExpanded;
  exports.useFilters = useFilters;
  exports.useFlexLayout = useFlexLayout;
  exports.useGetLatest = useGetLatest;
  exports.useGlobalFilter = useGlobalFilter;
  exports.useGridLayout = useGridLayout;
  exports.useGroupBy = useGroupBy;
  exports.useMountedLayoutEffect = useMountedLayoutEffect;
  exports.usePagination = usePagination;
  exports.useResizeColumns = useResizeColumns;
  exports.useRowSelect = useRowSelect;
  exports.useRowState = useRowState;
  exports.useSortBy = useSortBy;
  exports.useTable = useTable;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

});

unwrapExports(reactTable_development);

var reactTable = createCommonjsModule(function (module) {
if (process.env.NODE_ENV === 'production') {
  module.exports = reactTable_production_min;
} else {
  module.exports = reactTable_development;
}
});
var reactTable_1 = reactTable.useTable;
var reactTable_2 = reactTable.useSortBy;
var reactTable_3 = reactTable.useFlexLayout;
var reactTable_4 = reactTable.useResizeColumns;

function upTo(el, tagName) {
  tagName = tagName.toLowerCase();

  while (el && el.parentNode) {
    el = el.parentNode;

    if (el.tagName && el.tagName.toLowerCase() == tagName) {
      return el;
    }
  }

  return null;
}
function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    window.console.error("Async: Could not copy text: as Navigator clipboard is Not available");
  }

  navigator.clipboard.writeText(text).then(function () {
    window.postMessage({
      msg: "Link Copied to Clipboard",
      type: "notification"
    });
    window.console.error("Async: Copying to clipboard was successful!");
  }, function (err) {
    window.console.error("Async: Could not copy text: ", err);
  });
}

var css_248z$E = ".peek_table {\n  display: block;\n  font-family: \"Roboto-Regular\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; }\n  .peek_table thead {\n    overflow: hidden;\n    display: block;\n    width: 100%;\n    height: 45px; }\n    .peek_table thead tr {\n      padding: 10px 0 10px 0;\n      border-bottom: solid 0.5px #f0f0f0;\n      height: 45px;\n      box-sizing: border-box; }\n      .peek_table thead tr th {\n        text-align: left;\n        font-size: 13px;\n        line-height: 12.89px;\n        letter-spacing: 0.04em;\n        font-weight: 500;\n        color: #515151;\n        text-transform: capitalize;\n        display: flex;\n        align-items: center; }\n        .peek_table thead tr th .table-hover-text-header {\n          padding: 0 7px; }\n          .peek_table thead tr th .table-hover-text-header .amenity_icon {\n            display: flex;\n            align-items: center;\n            gap: 21px; }\n        .peek_table thead tr th ._head_diff {\n          margin-left: 10px;\n          padding-bottom: 3px; }\n  .peek_table tbody {\n    height: calc(100% - 130px);\n    display: block;\n    overflow-y: auto; }\n    .peek_table tbody tr {\n      border-bottom: solid 1px #f0f0f0;\n      font-weight: 400;\n      font-style: normal;\n      padding: 14px 0;\n      letter-spacing: 0.02em;\n      font-size: 16px;\n      line-height: 21px;\n      color: #333; }\n      .peek_table tbody tr:hover {\n        background: #fbfbfb; }\n      .peek_table tbody tr td {\n        text-overflow: ellipsis;\n        overflow: hidden;\n        display: flex;\n        align-items: center; }\n        .peek_table tbody tr td .columnWrapper {\n          width: 100%; }\n        .peek_table tbody tr td .clickable {\n          cursor: pointer;\n          height: 100%; }\n    .peek_table tbody .grid_loader {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center; }\n      .peek_table tbody .grid_loader .spinner_wrappper {\n        margin: 15px;\n        width: 50px;\n        height: 50px; }\n        .peek_table tbody .grid_loader .spinner_wrappper img {\n          width: 100%;\n          height: 100%; }\n\n.grid_option_menu {\n  font-size: 14px;\n  line-height: 32px;\n  cursor: pointer;\n  padding: 0 10px; }\n  .grid_option_menu:hover {\n    background-color: rgba(29, 28, 56, 0.05); }\n\n.grid_option_menu_disabled {\n  color: #dfdfdf;\n  cursor: not-allowed;\n  font-size: 14px;\n  line-height: 32px;\n  padding: 0 10px; }\n\n.warning_no_data {\n  text-transform: capitalize;\n  padding: 8px 10px;\n  background: #E5E5E5;\n  border-radius: 3px;\n  font-size: 11px;\n  line-height: 29px;\n  margin: 10px 0;\n  display: inline-flex;\n  position: relative;\n  left: 50%;\n  transform: translate(-50%); }\n\n#grid_option .grid_option_div {\n  position: \"fixed\";\n  border: \"solid 0.2px #dfdfdf\";\n  border-radius: \"3px\";\n  box-shadow: \"1px 1px 7px rgba($color: #000000, $alpha: 0.14)\";\n  display: \"flex\";\n  flex-direction: \"column\";\n  background-color: \"#fff\";\n  z-index: 1305; }\n";
styleInject(css_248z$E);

var css_248z$D = "div._datatitle_Wrapper ._tooltip {\n  position: relative; }\n\ndiv._datatitle_Wrapper ._tooltip .tooltiptext {\n  background: linear-gradient(0deg, rgba(129, 129, 165, 0.2), rgba(129, 129, 165, 0.2)), #FFFFFF;\n  border-radius: 6px;\n  color: #1D1C38;\n  font-size: 12px;\n  padding: 10px;\n  line-height: 12px;\n  font-weight: 500;\n  position: fixed;\n  width: max-content;\n  min-width: 100px;\n  max-width: 34em;\n  text-transform: none;\n  white-space: pre-wrap;\n  z-index: 999; }\n\ndiv._datatitle_Wrapper .custom_tooltip {\n  text-align: left !important;\n  z-index: 200;\n  padding: 15px 22px !important;\n  max-width: 19em !important; }\n\ndiv._datatitle_Wrapper .display_block {\n  display: block; }\n\ndiv._datatitle_Wrapper .tour_title {\n  font-weight: 600; }\n";
styleInject(css_248z$D);

var DataTitle = function DataTitle(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      showTooltip = _useState2[0],
      setShowTooltip = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray$1(_useState3, 2),
      x = _useState4[0],
      setX = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray$1(_useState5, 2),
      y = _useState6[0],
      setY = _useState6[1];

  var positionHoverText = function positionHoverText(event) {
    var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setShowTooltip(show);
    var x = event.clientX;
    var y = event.clientY;

    switch (true) {
      case get(props, "showMultipleLineHoverText", false):
        setX(x - 114);
        setY(y - 108);
        break;

      default:
        if (show) {
          var bound = event.currentTarget.getBoundingClientRect();
          var _x = bound.x,
              top = bound.top,
              bottom = bound.bottom;
          setX(_x);

          if (top - 40 < 0) {
            setY(bottom + 40);
          } else {
            setY(top - 40 - event.currentTarget.clientHeight);
          }
        } else {
          setY(0);
          setX(0);
        }

    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "_datatitle_Wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "_tooltip",
    onMouseEnter: function onMouseEnter(event) {
      return positionHoverText(event, true);
    },
    onMouseLeave: function onMouseLeave(event) {
      return positionHoverText(event);
    },
    onBlur: function onBlur(event) {
      return positionHoverText(event);
    }
  }, props.children[0], showTooltip && !get(props, "showMultipleLineHoverText", false) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      left: x,
      top: y
    },
    className: "tooltiptext " + (get(props, "showMultipleLineHoverText", false) ? "custom_tooltip" : "")
  }, props.children[1]) || null, showTooltip && get(props, "showMultipleLineHoverText", false) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      left: x,
      top: y
    },
    className: "tooltiptext " + (get(props, "showMultipleLineHoverText", false) ? "custom_tooltip" : "")
  }, Object.keys(get(props, "multipleLineHoverText", [])).map(function (key, index) {
    return /*#__PURE__*/React__default.createElement("span", {
      key: index
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "display_block"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "tour_title"
    }, key, ":"), " " + props.multipleLineHoverText[key]));
  })) || null));
};

DataTitle.propTypes = {
  children: PropTypes.array.isRequired,
  hoverText: PropTypes.string,
  multipleLineHoverText: PropTypes.array,
  showMultipleLineHoverText: PropTypes.bool
};
var DataTitle$1 = /*#__PURE__*/React__default.memo(DataTitle);

var css_248z$C = ".card {\n  width: inherit;\n  height: inherit;\n  background: #efedf0;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 99; }\n\n.animatedLine {\n  width: 100px;\n  top: -500px;\n  bottom: -500px;\n  background: rgba(255, 255, 255, 0.4);\n  transform: rotateZ(-25deg);\n  position: absolute;\n  animation: 1s shine linear infinite; }\n\n@keyframes shine {\n  from {\n    right: 100%; }\n  to {\n    right: -100%; } }\n";
styleInject(css_248z$C);

var SkeletonLoader = function SkeletonLoader() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "animatedLine"
  }));
};

var previousScrollCount = 0;
var List$2 = /*#__PURE__*/forwardRef(function (props, ref) {
  var columns = props.columns,
      data = props.data,
      onSort = props.onSort,
      onScrollHit = props.onScrollHit,
      onActionButtonClicked = props.onActionButtonClicked,
      onRowClick = props.onRowClick,
      closeOptions = props.closeOptions,
      showLoader = props.showLoader;

  var _useTable = reactTable_1({
    columns: columns,
    data: data,
    manualSortBy: true
  }, reactTable_2, reactTable_3, reactTable_4),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      rows = _useTable.rows,
      prepareRow = _useTable.prepareRow,
      sortBy = _useTable.state.sortBy;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  useEffect(function () {
    onSort(sortBy);

    if (!isLoaded) {
      setIsLoaded(true);
      var body = document.getElementsByTagName("body");

      if (body.length) {
        body[0].addEventListener("click", function (e) {
          closeOptions();
          e.preventDefault();
          e.stopPropagation();
        });
        window.addEventListener("scroll", function (e) {
          closeOptions();
          e.preventDefault();
          e.stopPropagation();
        });
      }

      return function () {
        if (body.length) {
          window.removeEventListener("scroll", function (e) {
            e.preventDefault();
            e.stopPropagation();
            closeOptions();
          });
        }
      };
    }
  }, [onSort, sortBy]);

  var _onRowClick = function _onRowClick(e, row) {
    onRowClick(row.original);
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  var _actionButtonClicked = function _actionButtonClicked(e, cell) {
    cell.column.isActionButton && onActionButtonClicked && onActionButtonClicked(e, cell.row.original);
    e.preventDefault();
    e.stopPropagation();
  };

  var onCellClicked = function onCellClicked(e, _cell, row) {
    _onRowClick(e, row);

    e.preventDefault();
    e.stopPropagation();
  };

  var onClickOption = function onClickOption(e, cell) {
    _actionButtonClicked(e, cell);

    e.preventDefault();
    e.stopPropagation();
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("table", _extends$4({}, getTableProps(), {
    border: 0,
    width: "100%",
    height: "100%",
    cellPadding: 0,
    cellSpacing: 0,
    className: "peek_table"
  }), /*#__PURE__*/React__default.createElement("thead", null, headerGroups.map(function (headerGroup, key) {
    return /*#__PURE__*/React__default.createElement("tr", _extends$4({
      key: key
    }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column, key) {
      return /*#__PURE__*/React__default.createElement("th", _extends$4({
        className: "react_table_header",
        key: key
      }, column.getHeaderProps(column.getSortByToggleProps({
        title: undefined
      }))), (column.hoverText || column.showMultipleLineHoverText) && /*#__PURE__*/React__default.createElement("span", {
        className: "table-hover-text-header"
      }, /*#__PURE__*/React__default.createElement(DataTitle$1, {
        showMultipleLineHoverText: get(column, "showMultipleLineHoverText", false),
        multipleLineHoverText: get(column, "multipleLineHoverText", {})
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "amenity_icon"
      }, /*#__PURE__*/React__default.createElement("span", null, column.render("Header")), /*#__PURE__*/React__default.createElement("span", {
        style: {
          fontSize: "18px"
        }
      }, /*#__PURE__*/React__default.createElement(MemoSvgInfo, null))), /*#__PURE__*/React__default.createElement("div", null, column.hoverText))) || column.render("Header"), /*#__PURE__*/React__default.createElement("span", {
        className: !column.hideSort && "_head_diff" || ""
      }, !column.hideSort && (column.isSorted && (column.isSortedDesc && /*#__PURE__*/React__default.createElement(Icon, {
        name: "downArrow",
        color: "#04D2C6",
        width: 9,
        height: 5
      }) || /*#__PURE__*/React__default.createElement(Icon, {
        name: "upArrow",
        color: "#04D2C6",
        width: 10,
        height: 5
      })) || /*#__PURE__*/React__default.createElement(Icon, {
        name: "downArrow",
        color: "#1D1C38 ",
        width: 9,
        height: 5
      })) || ""));
    }));
  })), /*#__PURE__*/React__default.createElement("tbody", _extends$4({
    ref: ref,
    onScroll: onScrollHit
  }, getTableBodyProps()), showLoader && rows.length === 0 && /*#__PURE__*/React__default.createElement(SkeletonLoader, null) || null, rows.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React__default.createElement("tr", _extends$4({
      key: i
    }, row.getRowProps()), row.cells.map(function (cell, key) {
      return /*#__PURE__*/React__default.createElement("td", _extends$4({
        className: ["column", cell.column.className && cell.column.className || ""].join(" "),
        key: key
      }, cell.getCellProps()), /*#__PURE__*/React__default.createElement("span", {
        className: !cell.column.isActionButton ? "columnWrapper" : "action_btn_wrapper",
        onClick: function onClick(e) {
          return cell.column.isActionButton ? onClickOption(e, cell) : onCellClicked(e, cell, row);
        }
      }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, cell.render("Cell")), /*#__PURE__*/React__default.createElement("span", {
        className: cell.column.isActionButton && "clickable" || "pointer"
      }, cell.column.isActionButton && /*#__PURE__*/React__default.createElement(MemoSvgMoreHorizontal, null) || null)));
    }));
  }), data.length === 0 && showLoader && /*#__PURE__*/React__default.createElement("div", {
    className: "grid_loader"
  }, /*#__PURE__*/React__default.createElement(Spinner, null)))));
});
List$2.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  onSort: PropTypes.func,
  onScrollHit: PropTypes.func,
  onActionButtonClicked: PropTypes.func,
  onRowClick: PropTypes.func,
  closeOptions: PropTypes.func,
  showLoader: PropTypes.bool
};

var Grid = function Grid(props) {
  var OPTION_ROW_HEIGHT = 32;
  var OPTION_ROW_WIDTH = 200;
  var ref = /*#__PURE__*/createRef();
  var pageSize = props.pageSize,
      actionItems = props.actionItems,
      actionMenuCallback = props.actionMenuCallback,
      onRowSelect = props.onRowSelect,
      conditionalActionItems = props.conditionalActionItems,
      showErrorMessage = props.showErrorMessage;

  var _useState3 = useState(0),
      _useState4 = _slicedToArray$1(_useState3, 2),
      currentPageIndex = _useState4[0],
      setCurrentPageIndex = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray$1(_useState5, 2),
      data = _useState6[0],
      setData = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray$1(_useState7, 2),
      totalCount = _useState8[0],
      setTotalCount = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray$1(_useState9, 2),
      showOptions = _useState10[0],
      setShowOptions = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray$1(_useState11, 2),
      xp = _useState12[0],
      setXp = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray$1(_useState13, 2),
      yp = _useState14[0],
      setYp = _useState14[1];

  var _useState15 = useState(get(props, "initialSort", "")),
      _useState16 = _slicedToArray$1(_useState15, 2),
      sortString = _useState16[0],
      setSortString = _useState16[1];

  var _useState17 = useState(get(props, "initialSortOrder", 1)),
      _useState18 = _slicedToArray$1(_useState17, 2),
      sortOrder = _useState18[0],
      setSortOrder = _useState18[1];

  var _useState19 = useState(true),
      _useState20 = _slicedToArray$1(_useState19, 2),
      showLoader = _useState20[0],
      setShowLoader = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray$1(_useState21, 2),
      needRefresh = _useState22[0],
      setNeedRefresh = _useState22[1];

  var _useState23 = useState(0),
      _useState24 = _slicedToArray$1(_useState23, 2),
      updateList = _useState24[0],
      setUpdateList = _useState24[1];

  var _useState25 = useState({}),
      _useState26 = _slicedToArray$1(_useState25, 2),
      selectedValueForListItem = _useState26[0],
      setSelectedValueForListItem = _useState26[1];

  var previousSortByValue = [];
  var disbledColumn = useMemo(function () {
    return props.getColumnConfig().filter(function (column) {
      return column.hideSort;
    }).map(function (column) {
      return column.accessor;
    });
  }, []);

  function getData(_x) {
    return _getData.apply(this, arguments);
  }

  function _getData() {
    _getData = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(_payload) {
      var isSortRequest,
          payload,
          response,
          _data,
          _args = arguments;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isSortRequest = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              setShowLoader(true);

              if (isSortRequest) {
                setCurrentPageIndex(function (value) {
                  return value > 0 ? 0 : value;
                });
                setTotalCount(0);
              }

              payload = {
                filter: {
                  start_index: currentPageIndex * pageSize,
                  limit: currentPageIndex === 0 && pageSize * 2 || pageSize
                },
                sort_by: sortString,
                sort_order: sortOrder
              };
              payload.filter.limit = payload.filter.start_index === 0 && payload.filter.limit - 1 || payload.filter.limit;
              Object.assign(payload, _payload);

              if (!payload.sort_by.trim().length) {
                delete payload.sort_by;
                delete payload.sort_order;
              }

              _context.next = 9;
              return props.getData(payload);

            case 9:
              response = _context.sent;
              _data = props.objectName ? response && response.data && response.data.data && response.data.data["".concat(props.objectName)] || [] : response && response.data && response.data.data;
              setShowLoader(false);

              if (totalCount) {
                setData(data.concat(_data));
              } else {
                setData(_data);
              }

              if (totalCount === 0) setTotalCount(response && response.data && response.data.data && response.data.data.total_count || 0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _getData.apply(this, arguments);
  }

  useEffect(function () {
    if (data.length < totalCount || totalCount === 0) {
      getData();
    }
  }, [currentPageIndex, needRefresh]);

  var resetGrid = function resetGrid() {
    var isSortRequest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setCurrentPageIndex(function (value) {
      return value > 0 ? 0 : value;
    });
    setSortString("");
    setSortOrder(1);
    getData({
      sort_by: "",
      sort_order: 1
    }, isSortRequest);
  };

  if (props.updateList > 0 && updateList !== props.updateList) {
    previousScrollCount = 0;
    setUpdateList(props.updateList);
    setShowLoader(true);
    setTotalCount(0);
    setTimeout(function () {
      setCurrentPageIndex(function (currentValue) {
        return parseInt(currentValue > 0 && "0" || currentValue);
      });
      setNeedRefresh(function (value) {
        return !value;
      });
    }, 1000);
  }

  var columns = React__default.useMemo(function () {
    return props.getColumnConfig();
  }, []);
  var handleSort = useCallback(function (sortBy) {
    if (Array.isArray(sortBy) && sortBy.length && disbledColumn.indexOf(sortBy[0].id) === -1) {
      if (Array.isArray(sortBy) && sortBy.length) {
        previousSortByValue = sortBy;
        setSortString(sortBy[0].id);
        setSortOrder(sortBy[0].desc && -1 || 1);
        getData({
          sort_by: sortBy[0].id,
          sort_order: sortBy[0].desc && -1 || 1
        }, true);
      } else {
        if (previousSortByValue.length) {
          previousSortByValue = [];
          resetGrid(true);
        }
      }
    }
  }, []);

  var onScrollHit = function onScrollHit() {
    setShowOptions(false);
    var scrollTop = ref.current && ref.current.scrollTop && ref.current.scrollTop;
    var shouldMakeAPICall = scrollTop > previousScrollCount;

    if (scrollTop > previousScrollCount) {
      previousScrollCount = scrollTop;
    }

    var scrollHeight = ref.current && ref.current.scrollTop && ref.current.scrollHeight;

    if (ref.current.clientHeight + Math.ceil(scrollTop) >= scrollHeight && data.length < totalCount && shouldMakeAPICall) {
      setCurrentPageIndex(function (value) {
        return currentPageIndex === 0 && value + 2 || value + 1;
      });
    }
  };

  var onRowClick = function onRowClick(row) {
    setShowOptions(false);
    onRowSelect && onRowSelect(row) || false;
  };

  function optionSelectAsyncAction(_x2, _x3) {
    return _optionSelectAsyncAction.apply(this, arguments);
  }

  function _optionSelectAsyncAction() {
    _optionSelectAsyncAction = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(value, rowValue) {
      var response;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return actionMenuCallback(value, rowValue);

            case 2:
              response = _context2.sent;

              if (get(response, "data.success", false)) {
                setTotalCount(0);
                setShowLoader(true);
                setTimeout(function () {
                  setCurrentPageIndex(function (currentValue) {
                    return currentValue > 0 && 0 || currentValue;
                  });
                  setNeedRefresh(function (status) {
                    return !status;
                  });
                }, 1000);
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _optionSelectAsyncAction.apply(this, arguments);
  }

  var optionSelected = function optionSelected(item) {
    if (_typeof$2(item) === "object" && item.liveUpdateRequired) optionSelectAsyncAction(item.value, selectedValueForListItem);else if (item.liveUpdateRequired) optionSelectAsyncAction(item, selectedValueForListItem);else if (_typeof$2(item) === "object" && !item.liveUpdateRequired) {
      actionMenuCallback(item.value, selectedValueForListItem);
    } else {
      actionMenuCallback(item, selectedValueForListItem);
    }
  };

  var getActionMenu = function getActionMenu() {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, actionItems.map(function (item, key) {
      return /*#__PURE__*/React__default.createElement("span", {
        onClick: function onClick() {
          return optionSelected(item);
        },
        className: "grid_option_menu",
        key: key
      }, item);
    }), conditionalActionItems(selectedValueForListItem).map(function (item, key) {
      return /*#__PURE__*/React__default.createElement("span", {
        onClick: function onClick() {
          return !item.disabled && optionSelected(item);
        },
        className: item.disabled && "grid_option_menu_disabled" || "grid_option_menu",
        key: key
      }, _typeof$2(item) === "object" && item.value || item);
    }));
  };

  var renderOptions = function renderOptions() {
    return showOptions && /*#__PURE__*/React__default.createElement(Portal$2, {
      nodename: "grid_option"
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        left: (xp > 0 && xp || 0) + "px",
        top: (yp > 0 && yp || 0) + "px",
        width: OPTION_ROW_WIDTH + "px",
        height: (actionItems.length + conditionalActionItems(selectedValueForListItem).length) * OPTION_ROW_HEIGHT + "px",
        position: "fixed",
        border: "solid 0.2px #dfdfdf",
        borderRadius: "3px",
        boxShadow: "1px 1px 7px rgba($color: #000000, $alpha: 0.14)",
        display: "flex",
        flexDirection: "column",
        padding: "8px 0",
        backgroundColor: "#fff",
        zIndex: 1305
      }
    }, getActionMenu()));
  };

  var onActionButtonClicked = function onActionButtonClicked(e, cell) {
    if (e && e.target) {
      var clientX = e.clientX,
          clientY = e.clientY;
      var immediateParent = upTo(e.target, "span");
      var element = upTo(e.target, "tbody");

      if (element) {
        var _element$getBoundingC = element.getBoundingClientRect(),
            x = _element$getBoundingC.x,
            y = _element$getBoundingC.y,
            width = _element$getBoundingC.width,
            height = _element$getBoundingC.height; // calculate position of rectangle in tbody


        var x1 = x;
        var x2 = x1 + width;
        var y1 = y;
        var y2 = y1;
        var y3 = y1 + height;
        var y4 = y3;

        if (clientX < x2 - OPTION_ROW_WIDTH && clientX >= x1 && clientY >= y2 && clientY < y3 - (actionItems.length + conditionalActionItems(selectedValueForListItem).length) * OPTION_ROW_HEIGHT) {
          setXp(clientX + 10);
          setYp(clientY);
          setShowOptions(true);
        } else if (clientX > x1 + OPTION_ROW_WIDTH && clientX + OPTION_ROW_WIDTH > x2 && clientY >= y2 && clientY <= y3 - (actionItems.length + conditionalActionItems(selectedValueForListItem).length) * OPTION_ROW_HEIGHT) {
          if (immediateParent) {
            var _immediateParent$getB = immediateParent.getBoundingClientRect(),
                _width = _immediateParent$getB.width;

            setXp(clientX - OPTION_ROW_WIDTH - _width + 10);
          } else {
            setXp(clientX - OPTION_ROW_WIDTH + 10);
          }

          setYp(clientY);
          setShowOptions(true);
        } else if (clientX + OPTION_ROW_WIDTH <= x2 && clientX >= x1 && clientY >= y1 && clientY + (actionItems.length + conditionalActionItems(selectedValueForListItem).length) * OPTION_ROW_HEIGHT >= y4) {
          setXp(clientX);
          setYp(clientY - (actionItems.length + conditionalActionItems(selectedValueForListItem).length) * OPTION_ROW_HEIGHT);
          setShowOptions(true);
        } else if (clientX + OPTION_ROW_WIDTH > x2 && clientX >= x1 && clientY >= y1 && clientY + (actionItems.length + conditionalActionItems(selectedValueForListItem).length) * OPTION_ROW_HEIGHT >= y4) {
          if (immediateParent) {
            var _immediateParent$getB2 = immediateParent.getBoundingClientRect(),
                _width2 = _immediateParent$getB2.width;

            setXp(clientX - OPTION_ROW_WIDTH - _width2);
          } else {
            setXp(clientX - OPTION_ROW_WIDTH);
          }

          setYp(clientY - (actionItems.length + conditionalActionItems(selectedValueForListItem).length) * OPTION_ROW_HEIGHT);
          setShowOptions(true);
        }
      }

      setSelectedValueForListItem(cell);
    }
  };

  var closeOptions = function closeOptions() {
    return setShowOptions(false);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(List$2, {
    ref: ref,
    columns: columns,
    data: data,
    onSort: handleSort,
    onScrollHit: data.length < totalCount && onScrollHit,
    onActionButtonClicked: onActionButtonClicked,
    onRowClick: onRowClick,
    closeOptions: closeOptions,
    showLoader: showLoader
  }), renderOptions(), data.length === 0 && showErrorMessage && !showLoader && /*#__PURE__*/React__default.createElement("span", {
    className: "warning_no_data"
  }, "no data found"));
};

Grid.defaultProps = {
  showErrorMessage: true,
  conditionalActionItems: function conditionalActionItems() {
    return [];
  }
};
Grid.propTypes = {
  getColumnConfig: PropTypes.func.isRequired,
  getData: PropTypes.func.isRequired,
  pageSize: PropTypes.number,
  actionItems: PropTypes.array,
  conditionalActionItems: PropTypes.func,
  actionMenuCallback: PropTypes.func,
  onRowSelect: PropTypes.func,
  objectName: PropTypes.string,
  updateList: PropTypes.number,
  showErrorMessage: PropTypes.bool
};

var css_248z$B = ".pie-chart-div {\n  transform: scale(0.5); }\n\n.percentage {\n  font-weight: normal;\n  font-size: 27px;\n  line-height: 32px;\n  color: #333333;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  align-items: center;\n  transform: translate(5px, 10px); }\n\n.recharts-cartesian-axis-tick {\n  font-size: 10px;\n  line-height: 12px;\n  font-weight: bold;\n  color: #000000;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  align-items: center; }\n\n.stroke-width-2 {\n  stroke-width: 2; }\n\n.recharts-cartesian-axis-tick-line {\n  display: none; }\n\n.timeseries-div {\n  width: 100%;\n  height: 175px; }\n\n.pie-div {\n  width: 100%;\n  height: 175px; }\n\n.display-block {\n  display: block; }\n\n.display-none {\n  display: none; }\n\n@media only screen and (max-width: 1367px) {\n  .custom-chart-container {\n    width: 100% !important; } }\n\n@media only screen and (min-width: 1025px) {\n  .custom-chart-container {\n    width: 110% !important; } }\n\n@media only screen and (max-width: 1024px) {\n  .custom-chart-container {\n    width: 105% !important; } }\n\n.custom-chart-container svg {\n  position: absolute;\n  left: -30px; }\n\n.custom-tooltip {\n  background-color: white;\n  height: auto;\n  width: 75px;\n  border-radius: 5px;\n  box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 10px;\n  line-height: 12px;\n  color: #1d1c38;\n  padding: 10px 15px; }\n  .custom-tooltip .hover-bar-span {\n    font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    font-style: normal;\n    font-weight: 300;\n    font-size: 20px;\n    line-height: 13px; }\n\n.stacked-custom-tooltip {\n  background-color: white;\n  height: auto;\n  width: auto;\n  border-radius: 5px;\n  box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 28px;\n  line-height: 28px;\n  color: #1d1c38;\n  padding: 10px 15px; }\n  .stacked-custom-tooltip .hover-bar-span {\n    font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    font-style: normal;\n    font-weight: 300;\n    font-size: 20px;\n    line-height: 13px; }\n\n.hover-row-div {\n  display: flex;\n  align-items: center;\n  margin-left: 3px; }\n  .hover-row-div .sensex-div {\n    margin-left: 10px;\n    margin-bottom: 3px; }\n    .hover-row-div .sensex-div .sensex_wrapper_component > .current-value {\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n      font-style: normal;\n      font-weight: 300;\n      font-size: 11px;\n      line-height: 13px; }\n    .hover-row-div .sensex-div .decrease-percentage,\n    .hover-row-div .sensex-div .increase-percentage {\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n      font-style: normal;\n      font-weight: 500;\n      font-size: 10px;\n      line-height: 12px;\n      top: -5px; }\n\n.stacked-hover-row-div {\n  display: flex;\n  align-items: center;\n  margin-left: 0 !important;\n  padding-top: 5px; }\n  .stacked-hover-row-div .svg-div, .stacked-hover-row-div .views-text-div {\n    font-size: 12px;\n    line-height: 12px; }\n  .stacked-hover-row-div .views-text-div {\n    padding: 0 4px 3px 6px; }\n  .stacked-hover-row-div .sensex-div {\n    width: 100%; }\n    .stacked-hover-row-div .sensex-div .sensex_wrapper_component {\n      padding: 0 !important; }\n    .stacked-hover-row-div .sensex-div .sensex_wrapper_component > .current-value {\n      display: none !important;\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n      font-style: normal;\n      font-weight: 300;\n      font-size: 12px;\n      line-height: 10px; }\n    .stacked-hover-row-div .sensex-div .decrease-percentage,\n    .stacked-hover-row-div .sensex-div .increase-percentage {\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n      font-style: normal;\n      font-weight: 500;\n      font-size: 15px;\n      line-height: 0;\n      margin-left: auto;\n      margin-right: 0;\n      top: 0; }\n\n.recharts-legend-item-text {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 14px; }\n\n.peek-bar-chart > .recharts-responsive-container > .recharts-wrapper {\n  left: -45px; }\n\n.recharts-default-legend {\n  position: relative;\n  left: 34px; }\n  .recharts-default-legend li > .recharts-surface {\n    display: none !important; }\n\n.timeseries_tooltip {\n  background-color: white;\n  height: auto;\n  width: auto;\n  min-width: 75px;\n  border-radius: 5px;\n  box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 10px;\n  line-height: 12px;\n  color: #1d1c38;\n  padding: 13px; }\n  .timeseries_tooltip .sensex_wrapper_component {\n    padding: 0 !important; }\n    .timeseries_tooltip .sensex_wrapper_component .current-value {\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n      font-style: normal;\n      font-weight: 300;\n      font-size: 20px;\n      line-height: 13px; }\n    .timeseries_tooltip .sensex_wrapper_component .decrease-percentage,\n    .timeseries_tooltip .sensex_wrapper_component .increase-percentage {\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n      font-style: normal;\n      font-weight: 500;\n      font-size: 10px;\n      line-height: 12px;\n      top: -5px; }\n\n.peek_bar_chart_legentName {\n  margin-right: 35px;\n  display: flex;\n  align-items: center; }\n";
styleInject(css_248z$B);

var css_248z$A = ".increase-percentage {\n  font-style: normal;\n  display: flex;\n  align-items: center;\n  text-transform: capitalize;\n  color: #6DD230;\n  margin-left: 5px;\n  font-size: 16px;\n  line-height: 19px;\n  font-weight: 500;\n  position: relative;\n  top: 7px; }\n\n.decrease-percentage {\n  font-style: normal;\n  display: flex;\n  align-items: center;\n  text-transform: capitalize;\n  margin-left: 5px;\n  font-size: 16px;\n  color: #ea6767;\n  line-height: 19px;\n  font-weight: 500;\n  position: relative;\n  top: 7px; }\n\n.current-value {\n  font-style: normal;\n  display: flex;\n  align-items: center;\n  text-transform: capitalize;\n  font-weight: 300;\n  font-size: 39px;\n  line-height: 45.7px;\n  letter-spacing: -0.02em;\n  color: #383838; }\n\n.sensex_wrapper_component {\n  display: flex;\n  align-items: flex-start; }\n  .sensex_wrapper_component .label {\n    margin-right: 18px;\n    margin-left: 2px; }\n";
styleInject(css_248z$A);

function _createSuper$x(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$x(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$x() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Sensex = /*#__PURE__*/function (_React$Component) {
  _inherits$1(Sensex, _React$Component);

  var _super = _createSuper$x(Sensex);

  function Sensex(props) {
    var _this;

    _classCallCheck$1(this, Sensex);

    _this = _super.call(this, props);
    _this.getCurrentSensexValue = _this.getCurrentSensexValue.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(Sensex, [{
    key: "getPercentage",
    value: function getPercentage() {
      var currentValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var lastValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (currentValue === lastValue) {
        return {
          per: 0,
          perClassname: "increase-percentage",
          perSign: ""
        };
      } else if (lastValue === 0 && currentValue > 0 || lastValue > 0 && currentValue === 0) {
        return {
          per: "",
          perClassname: "",
          perSign: ""
        };
      } else if (lastValue > 0 && currentValue !== lastValue) {
        var difference = lastValue - currentValue;

        if (get(this.props, "type", "") === "time") {
          if (difference > 0) {
            return {
              per: this.getCurrentSensexValue(Math.abs(difference)),
              perClassname: "decrease-percentage",
              perSign: "-"
            };
          } else if (difference < 0) {
            return {
              per: this.getCurrentSensexValue(Math.abs(difference)),
              perClassname: "increase-percentage",
              perSign: "+"
            };
          } else {
            return {
              per: 0,
              perClassname: "increase-percentage",
              perSign: "+"
            };
          }
        } else {
          var percentageDiff = (difference / lastValue * 100).toFixed(0);

          if (parseInt(percentageDiff) > 0) {
            return {
              per: percentageDiff,
              perClassname: "decrease-percentage",
              perSign: "-"
            };
          } else if (parseInt(percentageDiff) < 0) {
            return {
              per: Math.abs(percentageDiff),
              perClassname: "increase-percentage",
              perSign: "+"
            };
          } else {
            return {
              per: 0,
              perClassname: "increase-percentage",
              perSign: "+"
            };
          }
        }
      }
    }
  }, {
    key: "getCurrentSensexValue",
    value: function getCurrentSensexValue(num) {
      if (Number.isNaN(num)) {
        num = 0;
      }

      switch (this.props.type) {
        case "time":
          {
            if (!num) {
              return 0;
            }

            var h = Math.floor(num / 3600);
            var m = Math.floor(num % 3600 / 60);
            var s = Math.floor(num % 3600 % 60);
            var hDisplay = h > 0 ? h + (h === 1 ? "h " : "h ") : "";
            var mDisplay = m > 0 ? m + (m === 1 ? "m " : "m ") : "";
            var sDisplay = s > 0 ? s + (s === 1 ? "s" : "s") : "";
            return hDisplay + mDisplay + sDisplay;
          }

        default:
          return API.numFormatter(num);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var data = this.props.data;
      return data && data.map(function (val, index) {
        var currentValue = val.currentValue,
            lastValue = val.lastValue;

        if (Number.isNaN(currentValue)) {
          currentValue = 0;
        } else if (Number.isNaN(lastValue)) {
          lastValue = 0;
        }

        var _this2$getPercentage = _this2.getPercentage(currentValue && currentValue || 0, lastValue && lastValue || 0),
            per = _this2$getPercentage.per,
            perClassname = _this2$getPercentage.perClassname,
            perSign = _this2$getPercentage.perSign;

        return (currentValue || lastValue) && /*#__PURE__*/React__default.createElement("div", {
          key: index,
          className: "sensex_wrapper_component"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "current-value"
        }, _this2.getCurrentSensexValue(currentValue)), get(_this2.props, "type", "") !== "time" && perSign && _this2.getCurrentSensexValue(currentValue) && /*#__PURE__*/React__default.createElement("div", {
          className: perClassname
        }, "".concat(perSign).concat(per, "%")), get(_this2.props, "type", "") === "time" && perSign && _this2.getCurrentSensexValue(currentValue) && /*#__PURE__*/React__default.createElement("div", {
          className: perClassname
        }, "".concat(perSign).concat(per))) || /*#__PURE__*/React__default.createElement("div", {
          key: index,
          className: "sensex_wrapper_component"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "current-value"
        }, "0"));
      });
    }
  }]);

  return Sensex;
}(React__default.Component);
Sensex.propTypes = {
  data: PropTypes.array,
  type: PropTypes.string
};

function _createSuper$w(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$w(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$w() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TimeSeries = /*#__PURE__*/function (_PureComponent) {
  _inherits$1(TimeSeries, _PureComponent);

  var _super = _createSuper$w(TimeSeries);

  function TimeSeries(props) {
    var _this;

    _classCallCheck$1(this, TimeSeries);

    _this = _super.call(this, props);
    _this.setDayAndMonth = _this.setDayAndMonth.bind(_assertThisInitialized$3(_this));
    _this.renderTooltip = _this.renderTooltip.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(TimeSeries, [{
    key: "renderTooltip",
    value: function renderTooltip(payload) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, this.props.showSensexOnHover && payload.payload !== undefined && payload.payload !== null && payload.payload.length !== 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "timeseries_tooltip"
      }, this.props.chartConfig.IS_DATE_AS_VALUE && /*#__PURE__*/React__default.createElement("span", null, " ", payload.payload[0].payload.formatted_date, " "), " ", " " + payload.payload[0].payload.label, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Sensex, {
        data: [{
          lastValue: payload && Array.isArray(payload.payload) && payload.payload[0].payload[this.props.chartConfig.PREV_VALUE] || 0,
          currentValue: payload && Array.isArray(payload.payload) && payload.payload[0].payload[this.props.chartConfig.VALUE] || 0
        }],
        type: get(this.props, "type", "")
      })), !this.props.showSensexOnHover && payload.payload !== undefined && payload.payload.length !== 0 && /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "none"
        }
      }, payload.label, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, "Count: ", " " + payload.payload[0].payload[this.props.chartConfig.VALUE], " ")));
    }
  }, {
    key: "setDayAndMonth",
    value: function setDayAndMonth() {
      var _this2 = this;

      if (this.props.data && this.props.dates && this.props.dates.length > 0 && this.props.data.length > 0 && this.props.chartConfig.IS_DATE_AS_VALUE) {
        this.props.data.map(function (key, index) {
          var isValidaDate = API.WEEK_DAYS.some(function (day) {
            return _this2.props.dates[index] && _this2.props.dates[index].toString().includes(day.toUpperCase()) || false;
          });

          var _isValidaDate = API.MONTHLY_NAMES.some(function (day) {
            return _this2.props.dates[index] && _this2.props.dates[index].toString().includes(day.toUpperCase()) || false;
          });

          if (!isValidaDate && !_isValidaDate) {
            if (_this2.props.dates.length > index) {
              var date = new Date(_this2.props.dates[index]);
              var month = date.toLocaleDateString("default", {
                month: "short"
              });
              var day = date.toLocaleDateString("default", {
                weekday: "short"
              });
              var formattedDate = day + ", " + month;
              key.formatted_date = formattedDate;
              var dt = date.getDate();

              if (dt < 10) {
                dt = "0" + dt;
              }

              key.label = dt;
              key[_this2.props.chartConfig.VALUE] = parseInt(key[_this2.props.chartConfig.VALUE]);
              key[_this2.props.chartConfig.PREV_VALUE] = parseInt(key[_this2.props.chartConfig.PREV_VALUE]);
              var startDate = new Date();
              startDate.setDate(startDate.getDate() - (_this2.props.dateRange + 1));
              var lastDate = new Date();
              lastDate.setDate(lastDate.getDate() - 1);
              var month1 = startDate.toLocaleString("default", {
                month: "short"
              });
              var month2 = lastDate.toLocaleString("default", {
                month: "short"
              });

              if (month1 !== month2) {
                key[_this2.props.chartConfig.XACCESSKEY] = month + " " + dt;
              } else {
                key[_this2.props.chartConfig.XACCESSKEY] = day + " " + dt;
              }

              key[_this2.props.chartConfig.XACCESSKEY] = key[_this2.props.chartConfig.XACCESSKEY].toUpperCase();
              return key;
            }
          }
        }) || false;
      } else if (this.props.data && this.props.dates === undefined && this.props.data.length > 0 && this.props.chartConfig.IS_DATE_AS_VALUE) {
        this.props.data.map(function (key) {
          var date = new Date(key[_this2.props.chartConfig.XACCESSKEY]);
          var dt = date.getDate();

          if (dt < 10) {
            dt = "0" + dt;
          }

          key[_this2.props.chartConfig.XACCESSKEY] = dt;
          return key;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          chartConfig = _this$props.chartConfig;
      this.setDayAndMonth();
      return /*#__PURE__*/React__default.createElement("div", {
        className: "custom-chart-container"
      }, get(this.props, "loader", false) && get(this.props, "data", []).length === 0 && /*#__PURE__*/React__default.createElement(SkeletonLoader, null), get(this.props, "data", []).length !== 0 && /*#__PURE__*/React__default.createElement(ResponsiveContainer, {
        width: "100%",
        height: "100%"
      }, /*#__PURE__*/React__default.createElement(AreaChart, {
        data: data,
        margin: {
          top: 5,
          right: 20,
          bottom: 5,
          left: 0
        }
      }, /*#__PURE__*/React__default.createElement(CartesianGrid, {
        vertical: false
      }), /*#__PURE__*/React__default.createElement(XAxis, {
        tick: {
          dy: 5
        },
        dataKey: chartConfig.XACCESSKEY || API.timeSeriesChartConfig.XACCESSKEY
      }), /*#__PURE__*/React__default.createElement(YAxis, {
        tick: {
          dx: -3
        },
        axisLine: false
      }), /*#__PURE__*/React__default.createElement(Tooltip$2, {
        content: this.renderTooltip
      }), /*#__PURE__*/React__default.createElement(Area, {
        dataKey: chartConfig.VALUE || API.timeSeriesChartConfig.VALUE,
        stroke: chartConfig.STROKE_COLOR || API.timeSeriesChartConfig.STROKE_COLOR,
        fill: chartConfig.FILL_COLOR || API.timeSeriesChartConfig.FILL_COLOR,
        className: "stroke-width-2"
      }))) || null);
    }
  }]);

  return TimeSeries;
}(PureComponent);

TimeSeries.defaultProps = {
  data: [],
  loader: true
};
TimeSeries.propTypes = {
  data: PropTypes.array,
  chartConfig: PropTypes.object,
  dates: PropTypes.array,
  showSensexOnHover: PropTypes.bool,
  dateRange: PropTypes.number,
  type: PropTypes.string,
  loader: PropTypes.bool
};
var TimeSeries$1 = /*#__PURE__*/React__default.memo(TimeSeries);

function _createSuper$v(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$v(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$v() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var renderActiveShape = function renderActiveShape(props) {
  var cx = props.cx,
      cy = props.cy,
      innerRadius = props.innerRadius,
      outerRadius = props.outerRadius,
      startAngle = props.startAngle,
      endAngle = props.endAngle,
      percent = props.percent;
  return /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("text", {
    className: "percentage",
    x: cx,
    y: cy,
    textAnchor: "middle"
  }, (100 - percent * 100).toFixed(0), "%"), /*#__PURE__*/React__default.createElement(Sector, {
    cx: cx,
    cy: cy,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    startAngle: startAngle,
    endAngle: endAngle,
    fill: API.pieChartConfig.SECTOR_FILL_COLOR
  }));
};

var PeekPieChart = /*#__PURE__*/function (_PureComponent) {
  _inherits$1(PeekPieChart, _PureComponent);

  var _super = _createSuper$v(PeekPieChart);

  function PeekPieChart(props) {
    var _this;

    _classCallCheck$1(this, PeekPieChart);

    _this = _super.call(this, props);
    _this.state = {
      activeIndex: 0
    };
    return _this;
  }

  _createClass$1(PeekPieChart, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          chartConfig = _this$props.chartConfig;
      return /*#__PURE__*/React__default.createElement(PieChart, {
        width: this.props.width,
        height: this.props.height,
        className: "pie-chart-div"
      }, /*#__PURE__*/React__default.createElement(Pie, {
        activeIndex: this.state.activeIndex,
        activeShape: renderActiveShape,
        data: data,
        innerRadius: 70,
        outerRadius: 80,
        fill: (chartConfig === null || chartConfig === void 0 ? void 0 : chartConfig.PIE_FILL_COLOR) || API.pieChartConfig.PIE_FILL_COLOR,
        dataKey: (chartConfig === null || chartConfig === void 0 ? void 0 : chartConfig.DATAKEY) || API.pieChartConfig.DATAKEY,
        startAngle: 90,
        endAngle: -270
      }));
    }
  }]);

  return PeekPieChart;
}(PureComponent);
PeekPieChart.propTypes = {
  data: PropTypes.array,
  chartConfig: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number
};

function _createSuper$u(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$u(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$u() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var StackedBarChart = /*#__PURE__*/function (_React$Component) {
  _inherits$1(StackedBarChart, _React$Component);

  var _super = _createSuper$u(StackedBarChart);

  function StackedBarChart(props) {
    var _this;

    _classCallCheck$1(this, StackedBarChart);

    _this = _super.call(this, props);
    _this.setRadiusForBar = _this.setRadiusForBar.bind(_assertThisInitialized$3(_this));
    _this.renderBarChartTooltip = _this.renderBarChartTooltip.bind(_assertThisInitialized$3(_this));
    _this.radiusObj = {};
    _this.state = {
      tooltip: ""
    };
    return _this;
  }

  _createClass$1(StackedBarChart, [{
    key: "setRadiusForBar",
    value: function setRadiusForBar(inputData, chartConfig) {
      var _this2 = this;

      inputData.map(function (key) {
        if (key[chartConfig.FIRST_DATAKEY] > 0 && key[chartConfig.SECOND_DATAKEY] === 0 && key[chartConfig.THIRD_DATAKEY] > 0) {
          _this2.radiusObj = {
            radius1: [10, 0, 0, 10],
            radius2: [],
            radius3: [0, 10, 10, 0]
          };
        } else if (key[chartConfig.FIRST_DATAKEY] === 0 && key[chartConfig.SECOND_DATAKEY] === 0 && key[chartConfig.THIRD_DATAKEY] > 0) {
          _this2.radiusObj = {
            radius1: [],
            radius2: [],
            radius3: [10, 10, 10, 10]
          };
        } else if (key[chartConfig.FIRST_DATAKEY] === 0 && key[chartConfig.SECOND_DATAKEY] > 0 && key[chartConfig.THIRD_DATAKEY] > 0) {
          _this2.radiusObj = {
            radius1: [],
            radius2: [10, 0, 0, 10],
            radius3: [0, 10, 10, 0]
          };
        } else if (key[chartConfig.FIRST_DATAKEY] === 0 && key[chartConfig.SECOND_DATAKEY] > 0 && key[chartConfig.THIRD_DATAKEY] === 0) {
          _this2.radiusObj = {
            radius1: [],
            radius2: [10, 10, 10, 10],
            radius3: []
          };
        } else if (key[chartConfig.FIRST_DATAKEY] > 0 && key[chartConfig.SECOND_DATAKEY] === 0 && key[chartConfig.THIRD_DATAKEY] === 0) {
          _this2.radiusObj = {
            radius1: [10, 10, 10, 10],
            radius2: [],
            radius3: []
          };
        } else if (key[chartConfig.FIRST_DATAKEY] > 0 && key[chartConfig.SECOND_DATAKEY] > 0 && key[chartConfig.THIRD_DATAKEY] === 0) {
          _this2.radiusObj = {
            radius1: [10, 0, 0, 10],
            radius2: [0, 10, 10, 0],
            radius3: [0, 10, 10, 0]
          };
        } else if (key[chartConfig.FIRST_DATAKEY] > 0 && key[chartConfig.SECOND_DATAKEY] > 0 && key[chartConfig.THIRD_DATAKEY] > 0) {
          _this2.radiusObj = {
            radius1: [10, 0, 0, 10],
            radius2: [0, 0, 0, 0],
            radius3: [0, 10, 10, 0]
          };
        }
      });
    }
  }, {
    key: "renderBarChartTooltip",
    value: function renderBarChartTooltip(payload) {
      if (!payload || !this.state.tooltip) {
        return null;
      } else {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "stacked-custom-tooltip"
        }, payload.payload !== undefined && payload.payload !== null && payload.payload.length !== 0 && /*#__PURE__*/React__default.createElement("span", {
          className: "hover-span"
        }, this.state.tooltip === this.props.chartConfig.FIRST_DATAKEY && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, new Intl.NumberFormat('en').format(this.props.data[0][this.props.chartConfig.FIRST_DATAKEY])), /*#__PURE__*/React__default.createElement("div", {
          className: "stacked-hover-row-div"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "svg-div"
        }, /*#__PURE__*/React__default.createElement("svg", {
          width: "10",
          height: "10",
          style: {
            borderRadius: 3
          }
        }, /*#__PURE__*/React__default.createElement("rect", {
          width: "10",
          height: "10",
          style: {
            fill: payload.payload[0].color
          }
        }))), /*#__PURE__*/React__default.createElement("div", {
          className: "views-text-div"
        }, "Views"), /*#__PURE__*/React__default.createElement("div", {
          className: "sensex-div"
        }, /*#__PURE__*/React__default.createElement(Sensex, {
          data: [{
            lastValue: payload.payload[0].payload[this.props.chartConfig.FIRST_PREV_DATAKEY],
            currentValue: payload.payload[0].payload[this.props.chartConfig.FIRST_DATAKEY]
          }]
        })))), this.state.tooltip === this.props.chartConfig.SECOND_DATAKEY && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, new Intl.NumberFormat('en').format(this.props.data[0][this.props.chartConfig.SECOND_DATAKEY])), /*#__PURE__*/React__default.createElement("div", {
          className: "stacked-hover-row-div"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "svg-div"
        }, /*#__PURE__*/React__default.createElement("svg", {
          width: "10",
          height: "10",
          style: {
            borderRadius: 3
          }
        }, /*#__PURE__*/React__default.createElement("rect", {
          width: "10",
          height: "10",
          style: {
            fill: payload.payload[1].color
          }
        }))), /*#__PURE__*/React__default.createElement("div", {
          className: "views-text-div"
        }, "Views"), /*#__PURE__*/React__default.createElement("div", {
          className: "sensex-div"
        }, /*#__PURE__*/React__default.createElement(Sensex, {
          data: [{
            lastValue: payload.payload[0].payload[this.props.chartConfig.SECOND_PREV_DATAKEY],
            currentValue: payload.payload[0].payload[this.props.chartConfig.SECOND_DATAKEY]
          }]
        })))), this.state.tooltip === this.props.chartConfig.THIRD_DATAKEY && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, new Intl.NumberFormat('en').format(this.props.data[0][this.props.chartConfig.THIRD_DATAKEY])), /*#__PURE__*/React__default.createElement("div", {
          className: "stacked-hover-row-div"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "svg-div"
        }, /*#__PURE__*/React__default.createElement("svg", {
          width: "10",
          height: "10",
          style: {
            borderRadius: 3
          }
        }, /*#__PURE__*/React__default.createElement("rect", {
          width: "10",
          height: "10",
          style: {
            fill: payload.payload[2].color
          }
        }))), /*#__PURE__*/React__default.createElement("div", {
          className: "views-text-div"
        }, "Views"), /*#__PURE__*/React__default.createElement("div", {
          className: "sensex-div"
        }, /*#__PURE__*/React__default.createElement(Sensex, {
          data: [{
            lastValue: payload.payload[0].payload[this.props.chartConfig.THIRD_PREV_DATAKEY],
            currentValue: payload.payload[0].payload[this.props.chartConfig.THIRD_DATAKEY]
          }]
        }))))));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          data = _this$props.data,
          chartConfig = _this$props.chartConfig;
      this.setRadiusForBar(data, chartConfig);
      var isDataAvailable = false;
      Object.values(data[0]).map(function (val) {
        if (val !== 0) {
          isDataAvailable = true;
        }
      });
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "100%",
          height: 50
        },
        className: isDataAvailable ? "display-block" : "display-none"
      }, /*#__PURE__*/React__default.createElement(ResponsiveContainer, {
        height: 50,
        width: "100%"
      }, /*#__PURE__*/React__default.createElement(BarChart, {
        height: 50,
        width: "100%",
        layout: "vertical",
        data: data,
        margin: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        }
      }, /*#__PURE__*/React__default.createElement(XAxis, {
        hide: true,
        type: "number"
      }), /*#__PURE__*/React__default.createElement(YAxis, {
        axisLine: false,
        type: "category",
        dataKey: "name",
        stroke: chartConfig.STROKE_COLOR || API.stackedChartConfig.STROKE_COLOR,
        fontSize: chartConfig.FONT_SIZE || API.stackedChartConfig.FONT_SIZE
      }), /*#__PURE__*/React__default.createElement(Tooltip$2, {
        content: this.renderBarChartTooltip,
        cursor: {
          fill: "none"
        }
      }), /*#__PURE__*/React__default.createElement(Bar, {
        onMouseOver: function onMouseOver() {
          return _this3.setState({
            tooltip: chartConfig.FIRST_DATAKEY
          });
        },
        dataKey: chartConfig.FIRST_DATAKEY,
        fill: chartConfig.FIRST_DATAKEY_FILL_COLOR,
        stackId: "stackedBar",
        radius: this.radiusObj.radius1
      }), /*#__PURE__*/React__default.createElement(Bar, {
        onMouseOver: function onMouseOver() {
          return _this3.setState({
            tooltip: chartConfig.SECOND_DATAKEY
          });
        },
        dataKey: chartConfig.SECOND_DATAKEY,
        fill: chartConfig.SECOND_DATAKEY_FILL_COLOR,
        stackId: "stackedBar",
        radius: this.radiusObj.radius2
      }), /*#__PURE__*/React__default.createElement(Bar, {
        dataKey: "",
        fill: "",
        stackId: "stackedBar"
      }), /*#__PURE__*/React__default.createElement(Bar, {
        onMouseOver: function onMouseOver() {
          return _this3.setState({
            tooltip: chartConfig.THIRD_DATAKEY
          });
        },
        dataKey: chartConfig.THIRD_DATAKEY,
        fill: chartConfig.THIRD_DATAKEY_FILL_COLOR,
        stackId: "stackedBar",
        radius: this.radiusObj.radius3
      }))));
    }
  }]);

  return StackedBarChart;
}(React__default.Component);
StackedBarChart.propTypes = {
  data: PropTypes.array.isRequired,
  chartConfig: PropTypes.object,
  totalDays: PropTypes.number
};

var css_248z$z = ".notification-info {\n  position: fixed;\n  justify-content: space-between;\n  display: flex;\n  align-items: baseline;\n  background: linear-gradient(0deg, rgba(4, 210, 198, 0.1), rgba(4, 210, 198, 0.1)), #FFFFFF;\n  width: 300px;\n  word-break: break-word;\n  height: auto;\n  border-radius: 6px;\n  margin: 5px;\n  top: 0;\n  right: 68px;\n  z-index: 20000;\n  padding: 10px; }\n\n.message {\n  left: 74.58%;\n  right: 7.29%;\n  top: 6.44%;\n  bottom: 92.78%;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 15px;\n  display: flex;\n  align-items: flex-end;\n  text-align: left;\n  padding-left: 10px;\n  padding-right: 5px;\n  color: #333;\n  word-wrap: break-word; }\n\n.btn-dismiss {\n  position: inherit;\n  left: 89.82%;\n  border: none;\n  top: 25%;\n  background: linear-gradient(0deg, rgba(4, 210, 198, 0.1), rgba(4, 210, 198, 0.1)), #FFFFFF;\n  cursor: pointer; }\n  .btn-dismiss:focus {\n    outline: none; }\n\n.vl {\n  margin-right: 5px; }\n  .vl::after {\n    content: \"\";\n    background-color: #ffffff;\n    position: absolute;\n    height: 100%;\n    top: 0px;\n    left: 86%;\n    display: block; }\n\n.close-btn {\n  color: #fff;\n  font-weight: 300; }\n  .close-btn:focus {\n    outline: none; }\n\n.default-category {\n  background: linear-gradient(0deg, rgba(4, 210, 198, 0.1), rgba(4, 210, 198, 0.1)), #FFFFFF; }\n\n.primary-category {\n  background: linear-gradient(0deg, rgba(129, 129, 165, 0.1), rgba(129, 129, 165, 0.1)), #FFFFFF; }\n\n.secondary-category {\n  background: linear-gradient(0deg, rgba(118, 232, 169, 0.1), rgba(118, 232, 169, 0.1)), #FFFFFF; }\n";
styleInject(css_248z$z);

function _createSuper$t(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$t(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$t() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NotificationView = /*#__PURE__*/function (_React$Component) {
  _inherits$1(NotificationView, _React$Component);

  var _super = _createSuper$t(NotificationView);

  function NotificationView(props) {
    var _this;

    _classCallCheck$1(this, NotificationView);

    _this = _super.call(this, props);
    _this.state = {
      visible: _this.props.visible
    };
    _this._isMounted = false;
    return _this;
  }

  _createClass$1(NotificationView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;
      var timeout = setTimeout(function () {
        clearTimeout(timeout);
        _this2._isMounted && _this2.remove(_this2.props.id);
      }, this.props.duration);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "remove",
    value: function remove(id) {
      var _this3 = this;

      this.setState({
        visible: false
      }, function () {
        _this3.props.removeNotification(id);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          id = _this$props.id,
          msg = _this$props.msg,
          category = _this$props.category;
      return this.state.visible && /*#__PURE__*/React__default.createElement("div", {
        key: id
      }, /*#__PURE__*/React__default.createElement("div", {
        role: "alert",
        className: "notification-info " + category
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "message-div"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "message"
      }, msg)), /*#__PURE__*/React__default.createElement("div", {
        className: "vl"
      }, /*#__PURE__*/React__default.createElement("button", {
        onClick: function onClick() {
          return _this4.remove(id);
        },
        className: "btn-dismiss " + category,
        "aria-label": "dismiss-notification"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "close",
        color: "#333"
      })))));
    }
  }]);

  return NotificationView;
}(React__default.Component);
NotificationView.propTypes = {
  id: PropTypes.string,
  msg: PropTypes.string,
  duration: PropTypes.number,
  color: PropTypes.string,
  removeNotification: PropTypes.func,
  visible: PropTypes.bool,
  category: PropTypes.string
};

function _createSuper$s(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$s(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$s() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NotificationBar = /*#__PURE__*/function (_React$Component) {
  _inherits$1(NotificationBar, _React$Component);

  var _super = _createSuper$s(NotificationBar);

  function NotificationBar(props) {
    var _this;

    _classCallCheck$1(this, NotificationBar);

    _this = _super.call(this, props);
    _this.removeNotification = _this.removeNotification.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(NotificationBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "removeNotification",
    value: function removeNotification(notification_id) {
      this.props.onNotificationClick(notification_id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var notifications = this.props.notifications;
      var portalId = Date.now().toString();
      if (!notifications) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
      return /*#__PURE__*/React__default.createElement(Portal$2, {
        nodename: portalId
      }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, notifications.map(function (msgObj) {
        var notId = msgObj.notId;
        var msg = msgObj.msg;
        var category = msgObj.category;
        return /*#__PURE__*/React__default.createElement(NotificationView, {
          key: notId,
          id: notId,
          msg: msg,
          removeNotification: _this2.removeNotification,
          duration: 5000,
          visible: true,
          category: category
        });
      }))) || null;
    }
  }]);

  return NotificationBar;
}(React__default.Component);

NotificationBar.propTypes = {
  color: PropTypes.string,
  notifications: PropTypes.array,
  onNotificationClick: PropTypes.func,
  duration: PropTypes.number
};

function _createSuper$r(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$r(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$r() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NotificationWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits$1(NotificationWrapper, _React$Component);

  var _super = _createSuper$r(NotificationWrapper);

  function NotificationWrapper(props) {
    var _this;

    _classCallCheck$1(this, NotificationWrapper);

    _this = _super.call(this, props);
    _this.state = {
      msgs: []
    };
    _this.handleNotificationClick = _this.handleNotificationClick.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(NotificationWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener("message", function (event) {
        if (event.data.type === "notification") {
          var msgs = _this2.state.msgs;
          var id = Date.now().toString();
          var notificationObj = {
            notId: id,
            msg: event.data.msg,
            category: event.data.category
          };
          msgs.push(notificationObj);

          _this2.setState({
            msgs: msgs
          });
        }
      });
    }
  }, {
    key: "handleNotificationClick",
    value: function handleNotificationClick(notification_id) {
      if (notification_id) {
        this.setState({
          msgs: this.state.msgs.filter(function (key) {
            if (key.notId === notification_id) {
              key.isVisible = false;
            }

            return key.notId !== notification_id;
          })
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.msgs.length === 0 ? null : /*#__PURE__*/React__default.createElement(NotificationBar, {
        notifications: this.state.msgs,
        onNotificationClick: this.handleNotificationClick
      });
    }
  }]);

  return NotificationWrapper;
}(React__default.Component);

var arrayWithoutHoles = createCommonjsModule(function (module) {
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(arrayWithoutHoles);

var iterableToArray = createCommonjsModule(function (module) {
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(iterableToArray);

var nonIterableSpread = createCommonjsModule(function (module) {
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(nonIterableSpread);

var toConsumableArray = createCommonjsModule(function (module) {
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _toConsumableArray$1 = unwrapExports(toConsumableArray);

var css_248z$y = ".list_header {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 22.27px;\n  padding: 30px 27px 0 27px;\n  font-family: roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; }\n  .list_header .button_title_wrapper_datalist {\n    display: flex;\n    align-items: center;\n    justify-content: space-between; }\n    .list_header .button_title_wrapper_datalist .caption_container {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 3em; }\n      .list_header .button_title_wrapper_datalist .caption_container .toggle_vitual_tour {\n        display: flex;\n        align-items: center; }\n        .list_header .button_title_wrapper_datalist .caption_container .toggle_vitual_tour .toggle_listings .container .toggle_wrapper {\n          height: 18px;\n          width: 34px; }\n          .list_header .button_title_wrapper_datalist .caption_container .toggle_vitual_tour .toggle_listings .container .toggle_wrapper span.off {\n            background-color: #fff;\n            border: solid 1px #04D2C6; }\n          .list_header .button_title_wrapper_datalist .caption_container .toggle_vitual_tour .toggle_listings .container .toggle_wrapper span.on {\n            background-color: #fff;\n            border: solid 1px #e2e2e2; }\n        .list_header .button_title_wrapper_datalist .caption_container .toggle_vitual_tour .on_clr .container .toggle_wrapper {\n          background-color: #e2e2e2; }\n        .list_header .button_title_wrapper_datalist .caption_container .toggle_vitual_tour .off_clr .container .toggle_wrapper {\n          background-color: #04D2C6; }\n        .list_header .button_title_wrapper_datalist .caption_container .toggle_vitual_tour .hide_virtual_tour {\n          font-family: Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 29px;\n          color: #383838;\n          margin: 0 10px; }\n  .list_header hr {\n    border-top: solid 1px #c4c4c4;\n    margin: 0; }\n  .list_header .button {\n    background-color: #1d1c38;\n    color: white;\n    min-width: 0;\n    padding: 0 20px;\n    z-index: 1; }\n    .list_header .button span {\n      font-weight: 500;\n      font-size: 13px;\n      line-height: 15.23px; }\n\nspan._filter_capsul_ui {\n  font-size: 13px;\n  line-height: 15.23px;\n  font-weight: 700;\n  min-width: 124px;\n  border: solid 0.1px #ebeff1;\n  padding: 12px 13px;\n  background: #FFFFFF;\n  /* box-glow-1 */\n  box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1;\n  border-radius: 35px;\n  display: flex;\n  justify-content: space-between;\n  box-sizing: border-box;\n  cursor: pointer;\n  max-width: 200px;\n  align-items: center;\n  height: 38px; }\n  span._filter_capsul_ui .label {\n    font-size: 13px !important; }\n\n.filters_list {\n  display: flex;\n  gap: 15px;\n  padding: 30px 0 45px 27px; }\n\nspan.selection_filter_ui {\n  font-weight: 500;\n  max-width: 130px;\n  min-width: 50px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  align-items: center;\n  gap: 5px;\n  margin-left: 5px; }\n\n.datalist_Wrapper_component_filter {\n  padding: 0 27px;\n  height: calc(100% - 114px);\n  overflow: hidden; }\n";
styleInject(css_248z$y);

var css_248z$x = "ul.radio_selector_component {\n  list-style-type: none;\n  display: flex;\n  justify-content: flex-start;\n  margin: 0;\n  padding: 0;\n  font-size: 11px;\n  align-items: baseline;\n  line-height: 12.89px;\n  font-weight: 500; }\n  ul.radio_selector_component > li {\n    min-width: 26px;\n    display: inline-block;\n    font-weight: 600;\n    box-sizing: border-box;\n    text-align: center;\n    cursor: pointer; }\n  ul.radio_selector_component .isNotSelectedRadioList {\n    padding: 5px 7px;\n    margin: 0 3.5px;\n    border-radius: 25px;\n    border: solid 0.05px rgba(4, 210, 198, 0.5); }\n  ul.radio_selector_component .isSelectedRadioList {\n    background: linear-gradient(0deg, rgba(4, 210, 198, 0.5), rgba(4, 210, 198, 0.5)), linear-gradient(0deg, #FFFFFF, #FFFFFF);\n    padding: 5px 10px; }\n\n.left_corner_round {\n  border-top-left-radius: 25px;\n  border-bottom-left-radius: 25px; }\n\n.right_corner_round {\n  border-top-right-radius: 25px;\n  border-bottom-right-radius: 25px; }\n";
styleInject(css_248z$x);

var RadioSelector = function RadioSelector(props) {
  var _useState = useState(props.selector),
      _useState2 = _slicedToArray$1(_useState, 2),
      _array = _useState2[0],
      setArray = _useState2[1];

  var setSelection = function setSelection(index) {
    var _newArray = _toConsumableArray$1(_array);

    var hasMultipleSelected = _newArray.filter(function (arrayElement) {
      return arrayElement.isSelected;
    }).length;

    if (hasMultipleSelected) {
      // now we have at least one value selected
      var firstSelectedIndex = _newArray.findIndex(function (arrayElement) {
        return arrayElement.isSelected;
      });

      if (index === firstSelectedIndex) {
        _newArray.forEach(function (arrayElement, key) {
          if (hasMultipleSelected > 1) {
            return arrayElement.isSelected = key === firstSelectedIndex && true || false;
          } else if (hasMultipleSelected === 1) {
            return arrayElement.isSelected = key === firstSelectedIndex && !arrayElement.isSelected || false;
          }
        });
      } else if (index > firstSelectedIndex) {
        _newArray.forEach(function (arrayElement, currrentIndex) {
          if (currrentIndex <= index && currrentIndex >= firstSelectedIndex) return arrayElement.isSelected = true;else return arrayElement.isSelected = false;
        });
      } else if (index < firstSelectedIndex) {
        _newArray.forEach(function (arrayElement, currrentIndex) {
          return arrayElement.isSelected = currrentIndex === index;
        });
      }
    } else {
      _newArray[index].isSelected = true;
    }

    setArray(_newArray);
    props.getSelection && props.getSelection(_newArray) || false;
  };

  var firstInstanceOfSelector = _array.findIndex(function (arrayElement) {
    return arrayElement.isSelected;
  });

  var lastIndexOfSelector = _array.length - 1 - _array.slice().reverse().findIndex(function (o) {
    return o.isSelected;
  });

  return /*#__PURE__*/React__default.createElement("ul", {
    className: "radio_selector_component"
  }, _array.map(function (arrayElement, index) {
    var classListArray = [];

    if (arrayElement.isSelected) {
      classListArray.push("isSelectedRadioList");
    } else {
      classListArray.push("isNotSelectedRadioList");
    }

    if (index === firstInstanceOfSelector) {
      classListArray.push("left_corner_round");
    }

    if (index === lastIndexOfSelector) {
      classListArray.push("right_corner_round");
    }

    return /*#__PURE__*/React__default.createElement("li", {
      key: index,
      onClick: function onClick(event) {
        event.stopPropagation();
        event.preventDefault();
        setSelection(index);
      },
      className: classListArray.join(" ")
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "radio_selector_value"
    }, arrayElement.name));
  }));
};

RadioSelector.propTypes = {
  getSelection: PropTypes.func.isRequired,
  selector: PropTypes.array.isRequired
};

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$1(obj);
}

function isPlainObject(item) {
  return item && _typeof$1(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends$3({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

function isClassComponent$1(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent$1(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
var elementAcceptingRef$1 = elementAcceptingRef;

function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementTypeAcceptingRef$1 = chainPropTypes(propTypes_14, elementTypeAcceptingRef);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }

  return _extends$3({}, propTypes, _defineProperty({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://material-ui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (_typeof$1(Component) === 'object') {
    switch (Component.$$typeof) {
      case ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
  }

  return null;
}

var refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
var refType$1 = refType;

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp$1(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : formatMuiErrorMessage(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
var warnedOnce$1 = false;
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 *
 * @deprecated
 * Use `import { alpha } from '@material-ui/core/styles'` instead.
 */

function fade(color, value) {
  if (process.env.NODE_ENV !== 'production') {
    if (!warnedOnce$1) {
      warnedOnce$1 = true;
      console.error(['Material-UI: The `fade` color utility was renamed to `alpha` to better describe its functionality.', '', "You should use `import { alpha } from '@material-ui/core/styles'`"].join('\n'));
    }
  }

  return alpha(color, value);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha value is overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0-1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp$1(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp$1(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp$1(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = _objectWithoutProperties(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  var warnedOnce = false;

  function width(key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!warnedOnce) {
        warnedOnce = true;
        console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", 'Use the `theme.breakpoints.values` instead.'].join('\n'));
      }
    }

    return values[key];
  }

  return _extends$3({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return _extends$3({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.warn(['Material-UI: theme.mixins.gutters() is deprecated.', 'You can use the source of the mixin directly:', "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join('\n'));
      return _extends$3({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, _defineProperty({}, breakpoints.up('sm'), _extends$3({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

var common = {
  black: '#000',
  white: '#fff'
};
var common$1 = common;

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var grey$1 = grey;

var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var indigo$1 = indigo;

var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var pink$1 = pink;

var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var red$1 = red;

var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var orange$1 = orange;

var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var blue$1 = blue;

var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var green$1 = green;

var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    default: grey$1[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common$1.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey$1[800],
    default: '#303030'
  },
  action: {
    active: common$1.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo$1[300],
    main: indigo$1[500],
    dark: indigo$1[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink$1.A200,
    main: pink$1.A400,
    dark: pink$1.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red$1[300],
    main: red$1[500],
    dark: red$1[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange$1[300],
    main: orange$1[500],
    dark: orange$1[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue$1[300],
    main: blue$1[500],
    dark: blue$1[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green$1[300],
    main: green$1[500],
    dark: green$1[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = _objectWithoutProperties(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (process.env.NODE_ENV !== 'production') {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends$3({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : formatMuiErrorMessage(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });") : formatMuiErrorMessage(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (process.env.NODE_ENV !== 'production') {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = deepmerge(_extends$3({
    // A collection of common colors.
    common: common$1,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

function round$1(value) {
  return Math.round(value * 1e5) / 1e5;
}

var warnedOnce = false;

function roundWithDeprecationWarning(value) {
  if (process.env.NODE_ENV !== 'production') {
    if (!warnedOnce) {
      console.warn(['Material-UI: The `theme.typography.round` helper is deprecated.', 'Head to https://material-ui.com/r/migration-v4/#theme for a migration path.'].join('\n'));
      warnedOnce = true;
    }
  }

  return round$1(value);
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends$3({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round$1(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends$3({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: roundWithDeprecationWarning,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$1 = shadows;

var shape = {
  borderRadius: 4
};
var shape$1 = shape;

var responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
var responsivePropType$1 = responsivePropType;

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest();
}

var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

process.env.NODE_ENV !== 'production' ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = createUnarySpacing({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = _objectWithoutProperties(options, ["duration", "easing", "delay"]);

    if (process.env.NODE_ENV !== 'production') {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;

function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = _objectWithoutProperties(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: shadows$1,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape$1,
    transitions: transitions,
    zIndex: zIndex$1
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);

  if (process.env.NODE_ENV !== 'production') {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (process.env.NODE_ENV !== 'production') {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (process.env.NODE_ENV === 'production') {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

function createStyles$1(styles) {
  return styles;
}

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var isProduction = process.env.NODE_ENV === 'production';
function warning$2(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser$1 = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
    process.env.NODE_ENV !== "production" ? warning$2(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
      process.env.NODE_ENV !== "production" ? warning$2(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose$2(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized$2(_assertThisInitialized$2(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$3({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  _createClass(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends$3({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
      process.env.NODE_ENV !== "production" ? warning$2(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(_extends$3({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends$3({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp$1 = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp$1, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

      process.env.NODE_ENV !== "production" ? warning$2(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose$2(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$3({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins$1 = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = _extends$3({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = _extends$3({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends$3({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
          process.env.NODE_ENV !== "production" ? warning$2(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = _objectWithoutPropertiesLoose$2(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  _createClass(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      process.env.NODE_ENV !== "production" ? warning$2(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning$2(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


    process.env.NODE_ENV !== "production" ? warning$2(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else process.env.NODE_ENV !== "production" ? warning$2(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning$2(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.9.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser$1 ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins$1.length; i++) {
      this.plugins.use(plugins$1[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = _extends$3({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, _extends$3({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = _extends$3({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
createJss();

var now$1 = Date.now();
var fnValuesNs = "fnValues" + now$1;
var fnRuleNs = "fnStyle" + ++now$1;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (process.env.NODE_ENV === 'development') {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning$2(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var functions = functionPlugin;

var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends$3({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends$3({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp$1 = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp$1);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends$3({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends$3({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

      process.env.NODE_ENV !== "production" ? warning$2(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return _extends$3({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = _extends$3({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], _extends$3({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], _extends$3({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$2 = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache$2.hasOwnProperty(name)) {
    return cache$2[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache$2[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser$1 = '';
var isTouch = isBrowser$1 && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (isBrowser$1) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser$1 = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser$1,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (isBrowser$1) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (isBrowser$1) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}

/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

function jssPreset() {
  return {
    plugins: [functions(), jssGlobal(), jssNested(), camelCase(), defaultUnit(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = _extends$3({}, baseClasses);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
var multiKeyStore$1 = multiKeyStore;

var ThemeContext = React__default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}

var ThemeContext$1 = ThemeContext;

function useTheme$1() {
  var theme = React__default.useContext(ThemeContext$1);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__default.useDebugValue(theme);
  }

  return theme;
}

var jss = createJss(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React__default.createContext(defaultOptions);

if (process.env.NODE_ENV !== 'production') {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = _objectWithoutProperties(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = React__default.useContext(StylesContext);

  var context = _extends$3({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = createJss({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/React__default.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (process.env.NODE_ENV !== 'production') {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
var noopTheme$1 = noopTheme;

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (process.env.NODE_ENV !== 'production') {
    if (_typeof$1(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          if (themingEnabled === true && theme === noopTheme$1) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = _extends$3({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (process.env.NODE_ENV !== 'production') {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore$1.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = _extends$3({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore$1.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends$3({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        multiKeyStore$1.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends$3({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update$1(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    multiKeyStore$1.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = React__default.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = React__default.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  React__default.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles$1(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? noopTheme$1 : _options$defaultTheme,
      stylesOptions2 = _objectWithoutProperties(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme$1() || defaultTheme;

    var stylesOptions = _extends$3({}, React__default.useContext(StylesContext), stylesOptions2);

    var instance = React__default.useRef();
    var shouldUpdate = React__default.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React__default.useEffect(function () {
      if (shouldUpdate.current) {
        update$1(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__default.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (process.env.NODE_ENV !== 'production') {
      if (!mergedTheme) {
        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return _extends$3({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = useTheme$1();

  if (process.env.NODE_ENV !== 'production') {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  var theme = React__default.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[nested] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/React__default.createElement(ThemeContext$1.Provider, {
    value: theme
  }, children);
}

process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = exactProp(ThemeProvider.propTypes) : void 0;
}

// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles$1 = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = _objectWithoutProperties(options, ["defaultTheme", "withTheme", "name"]);

    if (process.env.NODE_ENV !== 'production') {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = makeStyles$1(stylesOrCreator, _extends$3({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/React__default.forwardRef(function WithStyles(props, ref) {
      props.classes;
          var innerRef = props.innerRef,
          other = _objectWithoutProperties(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(_extends$3({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = useTheme$1() || defaultTheme;

        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/React__default.createElement(Component, _extends$3({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
    process.env.NODE_ENV !== "production" ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (process.env.NODE_ENV !== 'production') {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    hoistNonReactStatics_cjs(WithStyles, Component);

    if (process.env.NODE_ENV !== 'production') {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

var withStylesWithoutDefault = withStyles$1;

// To remove in v5

function createStyles(styles) {
  // warning(
  //   warnOnce,
  //   [
  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
  //     'Please use @material-ui/styles/createStyles',
  //   ].join('\n'),
  // );
  // warnOnce = true;
  return createStyles$1(styles);
}

var defaultTheme = createTheme();
var defaultTheme$1 = defaultTheme;

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return makeStyles$1(stylesOrCreator, _extends$3({
    defaultTheme: defaultTheme$1
  }, options));
}

function useTheme() {
  var theme = useTheme$1() || defaultTheme$1;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__default.useDebugValue(theme);
  }

  return theme;
}

function withStyles(stylesOrCreator, options) {
  return withStylesWithoutDefault(stylesOrCreator, _extends$3({
    defaultTheme: defaultTheme$1
  }, options));
}

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = React$2.useCallback(function (instance) {
    var node = ReactDOM.findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$2.useDebugValue(isFocusVisible);
  }

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

var useEnhancedEffect$6 = typeof window !== 'undefined' ? React$2.useLayoutEffect : React$2.useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = React$2.useRef(fn);
  useEnhancedEffect$6(function () {
    ref.current = fn;
  });
  return React$2.useCallback(function () {
    return (ref.current).apply(void 0, arguments);
  }, []);
}

// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return React$2.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : formatMuiErrorMessage(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = React$2.useRef(controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = React$2.useState(defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (process.env.NODE_ENV !== 'production') {
    React$2.useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [controlled]);

    var _React$useRef2 = React$2.useRef(defaultProp),
        defaultValue = _React$useRef2.current;

    React$2.useEffect(function () {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }

  var setValueIfUncontrolled = React$2.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

var styles$E = function styles(theme) {
  return {
    thumb: {
      '&$open': {
        '& $offset': {
          transform: 'scale(1) translateY(-10px)'
        }
      }
    },
    open: {},
    offset: _extends$3({
      zIndex: 1
    }, theme.typography.body2, {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.2,
      transition: theme.transitions.create(['transform'], {
        duration: theme.transitions.duration.shortest
      }),
      top: -34,
      transformOrigin: 'bottom center',
      transform: 'scale(0)',
      position: 'absolute'
    }),
    circle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: 'currentColor',
      transform: 'rotate(-45deg)'
    },
    label: {
      color: theme.palette.primary.contrastText,
      transform: 'rotate(45deg)'
    }
  };
};
/**
 * @ignore - internal component.
 */


function ValueLabel(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      open = props.open,
      value = props.value,
      valueLabelDisplay = props.valueLabelDisplay;

  if (valueLabelDisplay === 'off') {
    return children;
  }

  return /*#__PURE__*/React$2.cloneElement(children, {
    className: clsx(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
  }, /*#__PURE__*/React$2.createElement("span", {
    className: clsx(classes.offset, className)
  }, /*#__PURE__*/React$2.createElement("span", {
    className: classes.circle
  }, /*#__PURE__*/React$2.createElement("span", {
    className: classes.label
  }, value))));
}

var ValueLabel$1 = withStyles(styles$E, {
  name: 'PrivateValueLabel'
})(ValueLabel);

function asc(a, b) {
  return a - b;
}

function clamp(value, min, max) {
  return Math.min(Math.max(min, value), max);
}

function findClosest(values, currentValue) {
  var _values$reduce = values.reduce(function (acc, value, index) {
    var distance = Math.abs(currentValue - value);

    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance: distance,
        index: index
      };
    }

    return acc;
  }, null),
      closestIndex = _values$reduce.index;

  return closestIndex;
}

function trackFinger(event, touchId) {
  if (touchId.current !== undefined && event.changedTouches) {
    for (var i = 0; i < event.changedTouches.length; i += 1) {
      var touch = event.changedTouches[i];

      if (touch.identifier === touchId.current) {
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
    }

    return false;
  }

  return {
    x: event.clientX,
    y: event.clientY
  };
}

function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}

function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}

function getDecimalPrecision(num) {
  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
  if (Math.abs(num) < 1) {
    var parts = num.toExponential().split('e-');
    var matissaDecimalPart = parts[0].split('.')[1];
    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }

  var decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

function roundValueToStep(value, step, min) {
  var nearest = Math.round((value - min) / step) * step + min;
  return Number(nearest.toFixed(getDecimalPrecision(step)));
}

function setValueIndex(_ref) {
  var values = _ref.values,
      source = _ref.source,
      newValue = _ref.newValue,
      index = _ref.index;

  // Performance shortcut
  if (values[index] === newValue) {
    return source;
  }

  var output = values.slice();
  output[index] = newValue;
  return output;
}

function focusThumb(_ref2) {
  var sliderRef = _ref2.sliderRef,
      activeIndex = _ref2.activeIndex,
      setActive = _ref2.setActive;

  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) {
    sliderRef.current.querySelector("[role=\"slider\"][data-index=\"".concat(activeIndex, "\"]")).focus();
  }

  if (setActive) {
    setActive(activeIndex);
  }
}

var axisProps = {
  horizontal: {
    offset: function offset(percent) {
      return {
        left: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  'horizontal-reverse': {
    offset: function offset(percent) {
      return {
        right: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  vertical: {
    offset: function offset(percent) {
      return {
        bottom: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        height: "".concat(percent, "%")
      };
    }
  }
};

var Identity = function Identity(x) {
  return x;
};

var styles$D = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 2,
      width: '100%',
      boxSizing: 'content-box',
      padding: '13px 0',
      display: 'inline-block',
      position: 'relative',
      cursor: 'pointer',
      touchAction: 'none',
      color: theme.palette.primary.main,
      WebkitTapHighlightColor: 'transparent',
      '&$disabled': {
        pointerEvents: 'none',
        cursor: 'default',
        color: theme.palette.grey[400]
      },
      '&$vertical': {
        width: 2,
        height: '100%',
        padding: '0 13px'
      },
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      '@media (pointer: coarse)': {
        // Reach 42px touch target, about ~8mm on screen.
        padding: '20px 0',
        '&$vertical': {
          padding: '0 20px'
        }
      },
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {// TODO v5: move the style here
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `marks` is provided with at least one label. */
    marked: {
      marginBottom: 20,
      '&$vertical': {
        marginBottom: 'auto',
        marginRight: 20
      }
    },

    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
    vertical: {},

    /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the rail element. */
    rail: {
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor',
      opacity: 0.38,
      '$vertical &': {
        height: '100%',
        width: 2
      }
    },

    /* Styles applied to the track element. */
    track: {
      display: 'block',
      position: 'absolute',
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor',
      '$vertical &': {
        width: 2
      }
    },

    /* Styles applied to the track element if `track={false}`. */
    trackFalse: {
      '& $track': {
        display: 'none'
      }
    },

    /* Styles applied to the track element if `track="inverted"`. */
    trackInverted: {
      '& $track': {
        backgroundColor: // Same logic as the LinearProgress track color
        theme.palette.type === 'light' ? lighten(theme.palette.primary.main, 0.62) : darken(theme.palette.primary.main, 0.5)
      },
      '& $rail': {
        opacity: 1
      }
    },

    /* Styles applied to the thumb element. */
    thumb: {
      position: 'absolute',
      width: 12,
      height: 12,
      marginLeft: -6,
      marginTop: -5,
      boxSizing: 'border-box',
      borderRadius: '50%',
      outline: 0,
      backgroundColor: 'currentColor',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: theme.transitions.create(['box-shadow'], {
        duration: theme.transitions.duration.shortest
      }),
      '&::after': {
        position: 'absolute',
        content: '""',
        borderRadius: '50%',
        // reach 42px hit target (2 * 15 + thumb diameter)
        left: -15,
        top: -15,
        right: -15,
        bottom: -15
      },
      '&$focusVisible,&:hover': {
        boxShadow: "0px 0px 0px 8px ".concat(alpha(theme.palette.primary.main, 0.16)),
        '@media (hover: none)': {
          boxShadow: 'none'
        }
      },
      '&$active': {
        boxShadow: "0px 0px 0px 14px ".concat(alpha(theme.palette.primary.main, 0.16))
      },
      '&$disabled': {
        width: 8,
        height: 8,
        marginLeft: -4,
        marginTop: -3,
        '&:hover': {
          boxShadow: 'none'
        }
      },
      '$vertical &': {
        marginLeft: -5,
        marginBottom: -6
      },
      '$vertical &$disabled': {
        marginLeft: -3,
        marginBottom: -4
      }
    },

    /* Styles applied to the thumb element if `color="primary"`. */
    thumbColorPrimary: {// TODO v5: move the style here
    },

    /* Styles applied to the thumb element if `color="secondary"`. */
    thumbColorSecondary: {
      '&$focusVisible,&:hover': {
        boxShadow: "0px 0px 0px 8px ".concat(alpha(theme.palette.secondary.main, 0.16))
      },
      '&$active': {
        boxShadow: "0px 0px 0px 14px ".concat(alpha(theme.palette.secondary.main, 0.16))
      }
    },

    /* Pseudo-class applied to the thumb element if it's active. */
    active: {},

    /* Pseudo-class applied to the thumb element if keyboard focused. */
    focusVisible: {},

    /* Styles applied to the thumb label element. */
    valueLabel: {
      // IE 11 centering bug, to remove from the customization demos once no longer supported
      left: 'calc(-50% - 4px)'
    },

    /* Styles applied to the mark element. */
    mark: {
      position: 'absolute',
      width: 2,
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the mark element if active (depending on the value). */
    markActive: {
      backgroundColor: theme.palette.background.paper,
      opacity: 0.8
    },

    /* Styles applied to the mark label element. */
    markLabel: _extends$3({}, theme.typography.body2, {
      color: theme.palette.text.secondary,
      position: 'absolute',
      top: 26,
      transform: 'translateX(-50%)',
      whiteSpace: 'nowrap',
      '$vertical &': {
        top: 'auto',
        left: 26,
        transform: 'translateY(50%)'
      },
      '@media (pointer: coarse)': {
        top: 40,
        '$vertical &': {
          left: 31
        }
      }
    }),

    /* Styles applied to the mark label element if active (depending on the value). */
    markLabelActive: {
      color: theme.palette.text.primary
    }
  };
};
var Slider$1 = /*#__PURE__*/React$2.forwardRef(function Slider(props, ref) {
  var ariaLabel = props['aria-label'],
      ariaLabelledby = props['aria-labelledby'],
      ariaValuetext = props['aria-valuetext'],
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'span' : _props$component,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      getAriaLabel = props.getAriaLabel,
      getAriaValueText = props.getAriaValueText,
      _props$marks = props.marks,
      marksProp = _props$marks === void 0 ? false : _props$marks,
      _props$max = props.max,
      max = _props$max === void 0 ? 100 : _props$max,
      _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      name = props.name,
      onChange = props.onChange,
      onChangeCommitted = props.onChangeCommitted,
      onMouseDown = props.onMouseDown,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$scale = props.scale,
      scale = _props$scale === void 0 ? Identity : _props$scale,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      _props$ThumbComponent = props.ThumbComponent,
      ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent,
      _props$track = props.track,
      track = _props$track === void 0 ? 'normal' : _props$track,
      valueProp = props.value,
      _props$ValueLabelComp = props.ValueLabelComponent,
      ValueLabelComponent = _props$ValueLabelComp === void 0 ? ValueLabel$1 : _props$ValueLabelComp,
      _props$valueLabelDisp = props.valueLabelDisplay,
      valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp,
      _props$valueLabelForm = props.valueLabelFormat,
      valueLabelFormat = _props$valueLabelForm === void 0 ? Identity : _props$valueLabelForm,
      other = _objectWithoutProperties(props, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "scale", "step", "ThumbComponent", "track", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]);

  var theme = useTheme();
  var touchId = React$2.useRef(); // We can't use the :active browser pseudo-classes.
  // - The active state isn't triggered when clicking on the rail.
  // - The active state isn't transfered when inversing a range slider.

  var _React$useState = React$2.useState(-1),
      active = _React$useState[0],
      setActive = _React$useState[1];

  var _React$useState2 = React$2.useState(-1),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _useControlled = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'Slider'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      valueDerived = _useControlled2[0],
      setValueState = _useControlled2[1];

  var range = Array.isArray(valueDerived);
  var values = range ? valueDerived.slice().sort(asc) : [valueDerived];
  values = values.map(function (value) {
    return clamp(value, min, max);
  });
  var marks = marksProp === true && step !== null ? _toConsumableArray(Array(Math.floor((max - min) / step) + 1)).map(function (_, index) {
    return {
      value: min + step * index
    };
  }) : marksProp || [];

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState3 = React$2.useState(-1),
      focusVisible = _React$useState3[0],
      setFocusVisible = _React$useState3[1];

  var sliderRef = React$2.useRef();
  var handleFocusRef = useForkRef(focusVisibleRef, sliderRef);
  var handleRef = useForkRef(ref, handleFocusRef);
  var handleFocus = useEventCallback(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));

    if (isFocusVisible(event)) {
      setFocusVisible(index);
    }

    setOpen(index);
  });
  var handleBlur = useEventCallback(function () {
    if (focusVisible !== -1) {
      setFocusVisible(-1);
      onBlurVisible();
    }

    setOpen(-1);
  });
  var handleMouseOver = useEventCallback(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));
    setOpen(index);
  });
  var handleMouseLeave = useEventCallback(function () {
    setOpen(-1);
  });
  var isRtl = theme.direction === 'rtl';
  var handleKeyDown = useEventCallback(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));
    var value = values[index];
    var tenPercents = (max - min) / 10;
    var marksValues = marks.map(function (mark) {
      return mark.value;
    });
    var marksIndex = marksValues.indexOf(value);
    var newValue;
    var increaseKey = isRtl ? 'ArrowLeft' : 'ArrowRight';
    var decreaseKey = isRtl ? 'ArrowRight' : 'ArrowLeft';

    switch (event.key) {
      case 'Home':
        newValue = min;
        break;

      case 'End':
        newValue = max;
        break;

      case 'PageUp':
        if (step) {
          newValue = value + tenPercents;
        }

        break;

      case 'PageDown':
        if (step) {
          newValue = value - tenPercents;
        }

        break;

      case increaseKey:
      case 'ArrowUp':
        if (step) {
          newValue = value + step;
        } else {
          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
        }

        break;

      case decreaseKey:
      case 'ArrowDown':
        if (step) {
          newValue = value - step;
        } else {
          newValue = marksValues[marksIndex - 1] || marksValues[0];
        }

        break;

      default:
        return;
    } // Prevent scroll of the page


    event.preventDefault();

    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    }

    newValue = clamp(newValue, min, max);

    if (range) {
      var previousValue = newValue;
      newValue = setValueIndex({
        values: values,
        source: valueDerived,
        newValue: newValue,
        index: index
      }).sort(asc);
      focusThumb({
        sliderRef: sliderRef,
        activeIndex: newValue.indexOf(previousValue)
      });
    }

    setValueState(newValue);
    setFocusVisible(index);

    if (onChange) {
      onChange(event, newValue);
    }

    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }
  });
  var previousIndex = React$2.useRef();
  var axis = orientation;

  if (isRtl && orientation !== "vertical") {
    axis += '-reverse';
  }

  var getFingerNewValue = function getFingerNewValue(_ref3) {
    var finger = _ref3.finger,
        _ref3$move = _ref3.move,
        move = _ref3$move === void 0 ? false : _ref3$move,
        values2 = _ref3.values,
        source = _ref3.source;
    var slider = sliderRef.current;

    var _slider$getBoundingCl = slider.getBoundingClientRect(),
        width = _slider$getBoundingCl.width,
        height = _slider$getBoundingCl.height,
        bottom = _slider$getBoundingCl.bottom,
        left = _slider$getBoundingCl.left;

    var percent;

    if (axis.indexOf('vertical') === 0) {
      percent = (bottom - finger.y) / height;
    } else {
      percent = (finger.x - left) / width;
    }

    if (axis.indexOf('-reverse') !== -1) {
      percent = 1 - percent;
    }

    var newValue;
    newValue = percentToValue(percent, min, max);

    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    } else {
      var marksValues = marks.map(function (mark) {
        return mark.value;
      });
      var closestIndex = findClosest(marksValues, newValue);
      newValue = marksValues[closestIndex];
    }

    newValue = clamp(newValue, min, max);
    var activeIndex = 0;

    if (range) {
      if (!move) {
        activeIndex = findClosest(values2, newValue);
      } else {
        activeIndex = previousIndex.current;
      }

      var previousValue = newValue;
      newValue = setValueIndex({
        values: values2,
        source: source,
        newValue: newValue,
        index: activeIndex
      }).sort(asc);
      activeIndex = newValue.indexOf(previousValue);
      previousIndex.current = activeIndex;
    }

    return {
      newValue: newValue,
      activeIndex: activeIndex
    };
  };

  var handleTouchMove = useEventCallback(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue = getFingerNewValue({
      finger: finger,
      move: true,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue.newValue,
        activeIndex = _getFingerNewValue.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }
  });
  var handleTouchEnd = useEventCallback(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue2 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue2.newValue;

    setActive(-1);

    if (event.type === 'touchend') {
      setOpen(-1);
    }

    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }

    touchId.current = undefined;
    var doc = ownerDocument(sliderRef.current);
    doc.removeEventListener('mousemove', handleTouchMove);
    doc.removeEventListener('mouseup', handleTouchEnd);
    doc.removeEventListener('touchmove', handleTouchMove);
    doc.removeEventListener('touchend', handleTouchEnd);
  });
  var handleTouchStart = useEventCallback(function (event) {
    // Workaround as Safari has partial support for touchAction: 'none'.
    event.preventDefault();
    var touch = event.changedTouches[0];

    if (touch != null) {
      // A number that uniquely identifies the current finger in the touch session.
      touchId.current = touch.identifier;
    }

    var finger = trackFinger(event, touchId);

    var _getFingerNewValue3 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue3.newValue,
        activeIndex = _getFingerNewValue3.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }

    var doc = ownerDocument(sliderRef.current);
    doc.addEventListener('touchmove', handleTouchMove);
    doc.addEventListener('touchend', handleTouchEnd);
  });
  React$2.useEffect(function () {
    var slider = sliderRef.current;
    slider.addEventListener('touchstart', handleTouchStart);
    var doc = ownerDocument(slider);
    return function () {
      slider.removeEventListener('touchstart', handleTouchStart);
      doc.removeEventListener('mousemove', handleTouchMove);
      doc.removeEventListener('mouseup', handleTouchEnd);
      doc.removeEventListener('touchmove', handleTouchMove);
      doc.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchEnd, handleTouchMove, handleTouchStart]);
  var handleMouseDown = useEventCallback(function (event) {
    if (onMouseDown) {
      onMouseDown(event);
    }

    event.preventDefault();
    var finger = trackFinger(event, touchId);

    var _getFingerNewValue4 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue4.newValue,
        activeIndex = _getFingerNewValue4.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }

    var doc = ownerDocument(sliderRef.current);
    doc.addEventListener('mousemove', handleTouchMove);
    doc.addEventListener('mouseup', handleTouchEnd);
  });
  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;

  var trackStyle = _extends$3({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap));

  return /*#__PURE__*/React$2.createElement(Component, _extends$3({
    ref: handleRef,
    className: clsx(classes.root, classes["color".concat(capitalize(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function (mark) {
      return mark.label;
    }) && classes.marked, track === false && classes.trackFalse, orientation === 'vertical' && classes.vertical, track === 'inverted' && classes.trackInverted),
    onMouseDown: handleMouseDown
  }, other), /*#__PURE__*/React$2.createElement("span", {
    className: classes.rail
  }), /*#__PURE__*/React$2.createElement("span", {
    className: classes.track,
    style: trackStyle
  }), /*#__PURE__*/React$2.createElement("input", {
    value: values.join(','),
    name: name,
    type: "hidden"
  }), marks.map(function (mark, index) {
    var percent = valueToPercent(mark.value, min, max);
    var style = axisProps[axis].offset(percent);
    var markActive;

    if (track === false) {
      markActive = values.indexOf(mark.value) !== -1;
    } else {
      markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
    }

    return /*#__PURE__*/React$2.createElement(React$2.Fragment, {
      key: mark.value
    }, /*#__PURE__*/React$2.createElement("span", {
      style: style,
      "data-index": index,
      className: clsx(classes.mark, markActive && classes.markActive)
    }), mark.label != null ? /*#__PURE__*/React$2.createElement("span", {
      "aria-hidden": true,
      "data-index": index,
      style: style,
      className: clsx(classes.markLabel, markActive && classes.markLabelActive)
    }, mark.label) : null);
  }), values.map(function (value, index) {
    var percent = valueToPercent(value, min, max);
    var style = axisProps[axis].offset(percent);
    return /*#__PURE__*/React$2.createElement(ValueLabelComponent, {
      key: index,
      valueLabelFormat: valueLabelFormat,
      valueLabelDisplay: valueLabelDisplay,
      className: classes.valueLabel,
      value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
      index: index,
      open: open === index || active === index || valueLabelDisplay === 'on',
      disabled: disabled
    }, /*#__PURE__*/React$2.createElement(ThumbComponent, {
      className: clsx(classes.thumb, classes["thumbColor".concat(capitalize(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
      tabIndex: disabled ? null : 0,
      role: "slider",
      style: style,
      "data-index": index,
      "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
      "aria-labelledby": ariaLabelledby,
      "aria-orientation": orientation,
      "aria-valuemax": scale(max),
      "aria-valuemin": scale(min),
      "aria-valuenow": scale(value),
      "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
      onKeyDown: handleKeyDown,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onMouseOver: handleMouseOver,
      onMouseLeave: handleMouseLeave
    }));
  }));
});
process.env.NODE_ENV !== "production" ? Slider$1.propTypes = {
  /**
   * The label of the slider.
   */
  'aria-label': chainPropTypes(PropTypes.string, function (props) {
    var range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-label'] != null) {
      return new Error('Material-UI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
    }

    return null;
  }),

  /**
   * The id of the element containing a label for the slider.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  'aria-valuetext': chainPropTypes(PropTypes.string, function (props) {
    var range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-valuetext'] != null) {
      return new Error('Material-UI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

  /**
   * If `true`, the slider will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   *
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: PropTypes.func,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   *
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: PropTypes.func,

  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks will be spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   */
  marks: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),

  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   */
  max: PropTypes.number,

  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   */
  min: PropTypes.number,

  /**
   * Name attribute of the hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number | number[]} value The new value.
   */
  onChange: PropTypes.func,

  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {object} event The event source of the callback.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * The slider orientation.
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * A transformation function, to change the scale of the slider.
   */
  scale: PropTypes.func,

  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   */
  step: PropTypes.number,

  /**
   * The component used to display the value label.
   */
  ThumbComponent: PropTypes.elementType,

  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   */
  track: PropTypes.oneOf(['normal', false, 'inverted']),

  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

  /**
   * The value label component.
   */
  ValueLabelComponent: PropTypes.elementType,

  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   */
  valueLabelDisplay: PropTypes.oneOf(['on', 'auto', 'off']),

  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   */
  valueLabelFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
} : void 0;
var Slider$2 = withStyles(styles$D, {
  name: 'MuiSlider'
})(Slider$1);

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$2(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
        _this$props.classNames;
        var props = _objectWithoutPropertiesLoose$2(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default.createElement(Transition$1, _extends$3({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$3({}, Transition$1.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var CSSTransition$1 = CSSTransition;

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps$1 = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized$2(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$3({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$2(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps$1;
var TransitionGroup$1 = TransitionGroup;

var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles$C = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = /*#__PURE__*/React$2.forwardRef(function Grow(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Transition$1 : _props$TransitionComp,
      other = _objectWithoutProperties(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var timer = React$2.useRef();
  var autoTimeout = React$2.useRef();
  var theme = useTheme();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = React$2.useRef(null);
  var foreignRef = useForkRef(children.ref, ref);
  var handleRef = useForkRef(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = _slicedToArray(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    reflow(node); // So the animation always start from the start.

    var _getTransitionProps = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        delay = _getTransitionProps.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var _getTransitionProps2 = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        delay = _getTransitionProps2.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };

  React$2.useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/React$2.createElement(TransitionComponent, _extends$3({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/React$2.cloneElement(children, _extends$3({
      style: _extends$3({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles$C[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
process.env.NODE_ENV !== "production" ? Grow.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Grow.muiSupportAuto = true;
var Grow$1 = Grow;

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce$2 = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction$2(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent$1(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent$1(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends$2({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent$1(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent$1(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$2({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex$1(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex$1(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction$2(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent$1(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent$1(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends$2({}, attributes, data.attributes);
  data.styles = _extends$2({}, styles, data.styles);
  data.arrowStyles = _extends$2({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends$2({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$2({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends$2({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper$2 = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce$2(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends$2({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends$2({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$2({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$2({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction$2(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper$2.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper$2.placements = placements;
Popper$2.Defaults = Defaults;

var PopperJs = Popper$2;

function deprecatedPropType(validator, reason) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}

function getContainer$1(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return ReactDOM.findDOMNode(container);
}

var useEnhancedEffect$5 = typeof window !== 'undefined' ? React$2.useLayoutEffect : React$2.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal = /*#__PURE__*/React$2.forwardRef(function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = React$2.useState(null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = useForkRef( /*#__PURE__*/React$2.isValidElement(children) ? children.ref : null, ref);
  useEnhancedEffect$5(function () {
    if (!disablePortal) {
      setMountNode(getContainer$1(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect$5(function () {
    if (mountNode && !disablePortal) {
      setRef(ref, mountNode);
      return function () {
        setRef(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect$5(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/React$2.isValidElement(children)) {
      return /*#__PURE__*/React$2.cloneElement(children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/ReactDOM.createPortal(children, mountNode) : mountNode;
});
process.env.NODE_ENV !== "production" ? Portal.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React$2.Component), PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be removed in v5, the ref can be used instead.
   * @deprecated Use the ref instead.
   */
  onRendered: deprecatedPropType(PropTypes.func, 'Use the ref instead.')
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  Portal['propTypes' + ''] = exactProp(Portal.propTypes);
}

var Portal$1 = Portal;

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (typeof func !== 'function') {
        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
      }
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

function flipPlacement(placement, theme) {
  var direction = theme && theme.direction || 'ltr';

  if (direction === 'ltr') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl$1(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var useEnhancedEffect$4 = typeof window !== 'undefined' ? React$2.useLayoutEffect : React$2.useEffect;
var defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */

var Popper = /*#__PURE__*/React$2.forwardRef(function Popper(props, ref) {
  var anchorEl = props.anchorEl,
      children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      modifiers = props.modifiers,
      open = props.open,
      _props$placement = props.placement,
      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$popperOptions = props.popperOptions,
      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
      popperRefProp = props.popperRef,
      style = props.style,
      _props$transition = props.transition,
      transition = _props$transition === void 0 ? false : _props$transition,
      other = _objectWithoutProperties(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);

  var tooltipRef = React$2.useRef(null);
  var ownRef = useForkRef(tooltipRef, ref);
  var popperRef = React$2.useRef(null);
  var handlePopperRef = useForkRef(popperRef, popperRefProp);
  var handlePopperRefRef = React$2.useRef(handlePopperRef);
  useEnhancedEffect$4(function () {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  React$2.useImperativeHandle(popperRefProp, function () {
    return popperRef.current;
  }, []);

  var _React$useState = React$2.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var theme = useTheme$1();
  var rtlPlacement = flipPlacement(initialPlacement, theme);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */

  var _React$useState2 = React$2.useState(rtlPlacement),
      placement = _React$useState2[0],
      setPlacement = _React$useState2[1];

  React$2.useEffect(function () {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });
  var handleOpen = React$2.useCallback(function () {
    if (!tooltipRef.current || !anchorEl || !open) {
      return;
    }

    if (popperRef.current) {
      popperRef.current.destroy();
      handlePopperRefRef.current(null);
    }

    var handlePopperUpdate = function handlePopperUpdate(data) {
      setPlacement(data.placement);
    };

    var resolvedAnchorEl = getAnchorEl$1(anchorEl);

    if (process.env.NODE_ENV !== 'production') {
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }
    }

    var popper = new PopperJs(getAnchorEl$1(anchorEl), tooltipRef.current, _extends$3({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: _extends$3({}, disablePortal ? {} : {
        // It's using scrollParent by default, we can use the viewport when using a portal.
        preventOverflow: {
          boundariesElement: 'window'
        }
      }, modifiers, popperOptions.modifiers),
      // We could have been using a custom modifier like react-popper is doing.
      // But it seems this is the best public API for this use case.
      onCreate: createChainedFunction(handlePopperUpdate, popperOptions.onCreate),
      onUpdate: createChainedFunction(handlePopperUpdate, popperOptions.onUpdate)
    }));
    handlePopperRefRef.current(popper);
  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
  var handleRef = React$2.useCallback(function (node) {
    setRef(ownRef, node);
    handleOpen();
  }, [ownRef, handleOpen]);

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleClose = function handleClose() {
    if (!popperRef.current) {
      return;
    }

    popperRef.current.destroy();
    handlePopperRefRef.current(null);
  };

  var handleExited = function handleExited() {
    setExited(true);
    handleClose();
  };

  React$2.useEffect(function () {
    return function () {
      handleClose();
    };
  }, []);
  React$2.useEffect(function () {
    if (!open && !transition) {
      // Otherwise handleExited will call this.
      handleClose();
    }
  }, [open, transition]);

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  var childProps = {
    placement: placement
  };

  if (transition) {
    childProps.TransitionProps = {
      in: open,
      onEnter: handleEnter,
      onExited: handleExited
    };
  }

  return /*#__PURE__*/React$2.createElement(Portal$1, {
    disablePortal: disablePortal,
    container: container
  }, /*#__PURE__*/React$2.createElement("div", _extends$3({
    ref: handleRef,
    role: "tooltip"
  }, other, {
    style: _extends$3({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: 'fixed',
      // Fix Popper.js display issue
      top: 0,
      left: 0,
      display: !open && keepMounted && !transition ? 'none' : null
    }, style)
  }), typeof children === 'function' ? children(childProps) : children));
});
process.env.NODE_ENV !== "production" ? Popper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), function (props) {
    if (props.open) {
      var resolvedAnchorEl = getAnchorEl$1(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
      }
    }

    return null;
  }),

  /**
   * Popper render function or node.
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes.node, PropTypes.func]).isRequired,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React$2.Component), PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: PropTypes.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
   */
  modifiers: PropTypes.object,

  /**
   * If `true`, the popper is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
   */
  popperOptions: PropTypes.object,

  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType$1,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: PropTypes.bool
} : void 0;
var Popper$1 = Popper;

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = React$2.useState(idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  React$2.useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function arrowGenerator() {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '0 100%'
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '100% 0'
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '100% 100%'
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '0 0'
      }
    }
  };
}

var styles$B = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      pointerEvents: 'none' // disable jss-rtl plugin

    },

    /* Styles applied to the Popper component if `interactive={true}`. */
    popperInteractive: {
      pointerEvents: 'auto'
    },

    /* Styles applied to the Popper component if `arrow={true}`. */
    popperArrow: arrowGenerator(),

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: alpha(theme.palette.grey[700], 0.9),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(round(14 / 10), "em"),
      maxWidth: 300,
      wordWrap: 'break-word',
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
    tooltipArrow: {
      position: 'relative',
      margin: '0'
    },

    /* Styles applied to the arrow element. */
    arrow: {
      overflow: 'hidden',
      position: 'absolute',
      width: '1em',
      height: '0.71em'
      /* = width / sqrt(2) = (length of the hypotenuse) */
      ,
      boxSizing: 'border-box',
      color: alpha(theme.palette.grey[700], 0.9),
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundColor: 'currentColor',
        transform: 'rotate(45deg)'
      }
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(round(16 / 14), "em"),
      fontWeight: theme.typography.fontWeightRegular
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: _defineProperty({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: _defineProperty({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: _defineProperty({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: _defineProperty({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};
var hystersisOpen = false;
var hystersisTimer = null;
var Tooltip = /*#__PURE__*/React$2.forwardRef(function Tooltip(props, ref) {
  var _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? false : _props$arrow,
      children = props.children,
      classes = props.classes,
      _props$disableFocusLi = props.disableFocusListener,
      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
      _props$disableHoverLi = props.disableHoverListener,
      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
      _props$disableTouchLi = props.disableTouchListener,
      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
      _props$enterDelay = props.enterDelay,
      enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay,
      _props$enterNextDelay = props.enterNextDelay,
      enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay,
      _props$enterTouchDela = props.enterTouchDelay,
      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
      idProp = props.id,
      _props$interactive = props.interactive,
      interactive = _props$interactive === void 0 ? false : _props$interactive,
      _props$leaveDelay = props.leaveDelay,
      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
      _props$leaveTouchDela = props.leaveTouchDelay,
      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
      onClose = props.onClose,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$PopperComponen = props.PopperComponent,
      PopperComponent = _props$PopperComponen === void 0 ? Popper$1 : _props$PopperComponen,
      PopperProps = props.PopperProps,
      title = props.title,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Grow$1 : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = _objectWithoutProperties(props, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);

  var theme = useTheme();

  var _React$useState = React$2.useState(),
      childNode = _React$useState[0],
      setChildNode = _React$useState[1];

  var _React$useState2 = React$2.useState(null),
      arrowRef = _React$useState2[0],
      setArrowRef = _React$useState2[1];

  var ignoreNonTouchEvents = React$2.useRef(false);
  var closeTimer = React$2.useRef();
  var enterTimer = React$2.useRef();
  var leaveTimer = React$2.useRef();
  var touchTimer = React$2.useRef();

  var _useControlled = useControlled({
    controlled: openProp,
    default: false,
    name: 'Tooltip',
    state: 'open'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      openState = _useControlled2[0],
      setOpenState = _useControlled2[1];

  var open = openState;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _React$useRef = React$2.useRef(openProp !== undefined),
        isControlled = _React$useRef.current; // eslint-disable-next-line react-hooks/rules-of-hooks


    React$2.useEffect(function () {
      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
        console.error(['Material-UI: You are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
      }
    }, [title, childNode, isControlled]);
  }

  var id = useId(idProp);
  React$2.useEffect(function () {
    return function () {
      clearTimeout(closeTimer.current);
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      clearTimeout(touchTimer.current);
    };
  }, []);

  var handleOpen = function handleOpen(event) {
    clearTimeout(hystersisTimer);
    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleEnter = function handleEnter() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) {
        childrenProps.onMouseOver(event);
      }

      if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      if (childNode) {
        childNode.removeAttribute('title');
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);

      if (enterDelay || hystersisOpen && enterNextDelay) {
        event.persist();
        enterTimer.current = setTimeout(function () {
          handleOpen(event);
        }, hystersisOpen ? enterNextDelay : enterDelay);
      } else {
        handleOpen(event);
      }
    };
  };

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState3 = React$2.useState(false),
      childIsFocusVisible = _React$useState3[0],
      setChildIsFocusVisible = _React$useState3[1];

  var handleBlur = function handleBlur() {
    if (childIsFocusVisible) {
      setChildIsFocusVisible(false);
      onBlurVisible();
    }
  };

  var handleFocus = function handleFocus() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      // Workaround for https://github.com/facebook/react/issues/7769
      // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.
      if (!childNode) {
        setChildNode(event.currentTarget);
      }

      if (isFocusVisible(event)) {
        setChildIsFocusVisible(true);
        handleEnter()(event);
      }

      var childrenProps = children.props;

      if (childrenProps.onFocus && forward) {
        childrenProps.onFocus(event);
      }
    };
  };

  var handleClose = function handleClose(event) {
    clearTimeout(hystersisTimer);
    hystersisTimer = setTimeout(function () {
      hystersisOpen = false;
    }, 800 + leaveDelay);
    setOpenState(false);

    if (onClose) {
      onClose(event);
    }

    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(function () {
      ignoreNonTouchEvents.current = false;
    }, theme.transitions.duration.shortest);
  };

  var handleLeave = function handleLeave() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'blur') {
        if (childrenProps.onBlur && forward) {
          childrenProps.onBlur(event);
        }

        handleBlur();
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      event.persist();
      leaveTimer.current = setTimeout(function () {
        handleClose(event);
      }, leaveDelay);
    };
  };

  var detectTouchStart = function detectTouchStart(event) {
    ignoreNonTouchEvents.current = true;
    var childrenProps = children.props;

    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
  };

  var handleTouchStart = function handleTouchStart(event) {
    detectTouchStart(event);
    clearTimeout(leaveTimer.current);
    clearTimeout(closeTimer.current);
    clearTimeout(touchTimer.current);
    event.persist();
    touchTimer.current = setTimeout(function () {
      handleEnter()(event);
    }, enterTouchDelay);
  };

  var handleTouchEnd = function handleTouchEnd(event) {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }

    clearTimeout(touchTimer.current);
    clearTimeout(leaveTimer.current);
    event.persist();
    leaveTimer.current = setTimeout(function () {
      handleClose(event);
    }, leaveTouchDelay);
  };

  var handleUseRef = useForkRef(setChildNode, ref);
  var handleFocusRef = useForkRef(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = React$2.useCallback(function (instance) {
    // #StrictMode ready
    setRef(handleFocusRef, ReactDOM.findDOMNode(instance));
  }, [handleFocusRef]);
  var handleRef = useForkRef(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.

  if (title === '') {
    open = false;
  } // For accessibility and SEO concerns, we render the title to the DOM node when
  // the tooltip is hidden. However, we have made a tradeoff when
  // `disableHoverListener` is set. This title logic is disabled.
  // It's allowing us to keep the implementation size minimal.
  // We are open to change the tradeoff.


  var shouldShowNativeTitle = !open && !disableHoverListener;

  var childrenProps = _extends$3({
    'aria-describedby': open ? id : null,
    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
  }, other, children.props, {
    className: clsx(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  });

  var interactiveWrapperListeners = {};

  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }

  if (!disableHoverListener) {
    childrenProps.onMouseOver = handleEnter();
    childrenProps.onMouseLeave = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onMouseOver = handleEnter(false);
      interactiveWrapperListeners.onMouseLeave = handleLeave(false);
    }
  }

  if (!disableFocusListener) {
    childrenProps.onFocus = handleFocus();
    childrenProps.onBlur = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onFocus = handleFocus(false);
      interactiveWrapperListeners.onBlur = handleLeave(false);
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (children.props.title) {
      console.error(['Material-UI: You have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
    }
  }

  var mergedPopperProps = React$2.useMemo(function () {
    return deepmerge({
      popperOptions: {
        modifiers: {
          arrow: {
            enabled: Boolean(arrowRef),
            element: arrowRef
          }
        }
      }
    }, PopperProps);
  }, [arrowRef, PopperProps]);
  return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.cloneElement(children, childrenProps), /*#__PURE__*/React$2.createElement(PopperComponent, _extends$3({
    className: clsx(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
    placement: placement,
    anchorEl: childNode,
    open: childNode ? open : false,
    id: childrenProps['aria-describedby'],
    transition: true
  }, interactiveWrapperListeners, mergedPopperProps), function (_ref) {
    var placementInner = _ref.placement,
        TransitionPropsInner = _ref.TransitionProps;
    return /*#__PURE__*/React$2.createElement(TransitionComponent, _extends$3({
      timeout: theme.transitions.duration.shorter
    }, TransitionPropsInner, TransitionProps), /*#__PURE__*/React$2.createElement("div", {
      className: clsx(classes.tooltip, classes["tooltipPlacement".concat(capitalize(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
    }, title, arrow ? /*#__PURE__*/React$2.createElement("span", {
      className: classes.arrow,
      ref: setArrowRef
    }) : null));
  }));
});
process.env.NODE_ENV !== "production" ? Tooltip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, adds an arrow to the tooltip.
   */
  arrow: PropTypes.bool,

  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef$1.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: PropTypes.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: PropTypes.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: PropTypes.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: PropTypes.number,

  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   */
  enterNextDelay: PropTypes.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: PropTypes.number,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * Makes a tooltip interactive, i.e. will not close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   */
  interactive: PropTypes.bool,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: PropTypes.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: PropTypes.bool,

  /**
   * Tooltip placement.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * The component used for the popper.
   */
  PopperComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Popper`](/api/popper/) element.
   */
  PopperProps: PropTypes.object,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: PropTypes
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
var Tooltip$1 = withStyles(styles$B, {
  name: 'MuiTooltip',
  flip: false
})(Tooltip);

var useStyles$9 = makeStyles(function () {
  return {
    root: {
      width: "100%!important"
    }
  };
});
var sliderValue = [];
var NumberTooltip = withStyles({
  tooltip: {
    color: "black",
    backgroundColor: "rgba(3, 210, 198, 20%)",
    fontSize: "12px",
    lineHeight: "14px",
    fontWeight: 500,
    borderRadius: "25px",
    padding: "6px 11px"
  }
})(Tooltip$1);

function LabelWrapperComponent(props) {
  var children = props.children,
      value = props.value;
  return /*#__PURE__*/React__default.createElement(NumberTooltip, {
    open: true,
    placement: "bottom",
    title: "$ ".concat(value)
  }, children);
}

LabelWrapperComponent.propTypes = {
  children: PropTypes.any.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired
};
var CustomValueSlider = withStyles({
  root: {
    color: "#04d2c6",
    height: 3,
    padding: "13px 0",
    width: "100%!important"
  },
  thumb: {
    height: "17px!important",
    width: "17px!important",
    backgroundColor: "#04d2c6",
    border: "1px solid currentColor",
    marginTop: 0,
    marginLeft: -8,
    borderRadius: "50%!important",
    boxShadow: "#ebebeb 0 2px 2px",
    "&:focus, &:hover, &$active": {
      boxShadow: "#ccc 0 2px 3px 1px"
    },
    "& .bar": {
      height: 9,
      width: 1,
      backgroundColor: "currentColor",
      marginLeft: 1,
      marginRight: 1
    }
  },
  active: {},
  track: {
    height: 3,
    opacity: "1!important"
  },
  rail: {
    color: "rgba(129, 129, 165, 30%)!important",
    height: 3,
    opacity: "1!important"
  }
})(Slider$2); // function ThumbComponent(props) {
//   return (
//     <span {...props}>
//     </span>
//   );
// }

var CustomizedSlider = function CustomizedSlider(props) {
  var classes = useStyles$9();

  var handleChange = function handleChange(event, value) {
    sliderValue = value;
    event.stopPropagation();
    event.preventDefault();
  };

  var updateSliderValue = function updateSliderValue(e) {
    e.stopPropagation();
    e.preventDefault();
    props.onChange && props.onChange(e, sliderValue);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement(CustomValueSlider, {
    min: 0,
    max: 10000,
    onChange: handleChange,
    onChangeCommitted: function onChangeCommitted(event) {
      return updateSliderValue(event);
    },
    valueLabelDisplay: "on",
    ValueLabelComponent: LabelWrapperComponent,
    step: 250,
    defaultValue: [props.minimumValue, props.maximumValue]
  }));
};

CustomizedSlider.propTypes = {
  minimumValue: PropTypes.number.isRequired,
  maximumValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

var css_248z$w = "span.radio_button_filter_not_selected {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 11px;\n  line-height: 13px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  text-transform: capitalize;\n  color: #1D1C38;\n  border: solid 0.1px #DADADA;\n  border-radius: 25px;\n  padding: 8px 14px;\n  cursor: pointer;\n  box-sizing: border-box; }\n\nspan.radio_button_filter_selected {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 11px;\n  line-height: 13px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  text-transform: capitalize;\n  color: #1D1C38;\n  border-radius: 25px;\n  padding: 8px 14px;\n  cursor: pointer;\n  background: #cdf6f4;\n  border: solid 0.1px #cdf6f4;\n  box-sizing: border-box; }\n";
styleInject(css_248z$w);

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$q(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$q(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$q() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * [{"name": A, isSelected: true}]
 */

var RadioButtonList = /*#__PURE__*/function (_Component) {
  _inherits$1(RadioButtonList, _Component);

  var _super = _createSuper$q(RadioButtonList);

  function RadioButtonList(props) {
    var _this;

    _classCallCheck$1(this, RadioButtonList);

    _this = _super.call(this, props);
    _this.getSelection = _this.getSelection.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(RadioButtonList, [{
    key: "getSelection",
    value: function getSelection(event, index) {
      event.stopPropagation();
      event.preventDefault();
      var currentState = this.props.buttonList.map(function (element, _index) {
        return _objectSpread$g(_objectSpread$g({}, element), {}, {
          isSelected: index === _index ? !element.isSelected : element.isSelected
        });
      });
      this.props.getSelection && this.props.getSelection(currentState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, this.props.buttonList.map(function (button, index) {
        return /*#__PURE__*/React__default.createElement("span", {
          onClick: function onClick(event) {
            return _this2.getSelection(event, index);
          },
          className: button.isSelected && "radio_button_filter_selected" || "radio_button_filter_not_selected",
          key: index
        }, button.name);
      }));
    }
  }]);

  return RadioButtonList;
}(Component);

RadioButtonList.propTypes = {
  buttonList: PropTypes.array.isRequired,
  getSelection: PropTypes.func.isRequired
};

var css_248z$v = ".filter_grid_wrapper {\n  width: 513px;\n  position: fixed;\n  box-sizing: border-box;\n  padding: 19px 20px;\n  background: #fff;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n  border-radius: 5px;\n  border: solid 0.1px #ebeff1;\n  margin-top: 10px; }\n  .filter_grid_wrapper span.label {\n    font-size: 12px !important;\n    font-weight: 500 !important; }\n  .filter_grid_wrapper .filter_grid_title {\n    font-size: 12px;\n    line-height: 14px;\n    font-weight: 600;\n    margin-bottom: 23px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between; }\n  .filter_grid_wrapper .pointer {\n    cursor: pointer; }\n  .filter_grid_wrapper .filter_grid_radio_selector {\n    display: flex;\n    justify-content: space-between; }\n    .filter_grid_wrapper .filter_grid_radio_selector span.label {\n      width: 56px; }\n  .filter_grid_wrapper .filter_grid_radio_selector_group {\n    display: flex;\n    align-items: baseline; }\n  .filter_grid_wrapper .filter_grid_rent_slider_plugin {\n    margin-top: 30px;\n    display: flex;\n    align-items: center; }\n    .filter_grid_wrapper .filter_grid_rent_slider_plugin span.label {\n      width: 70px;\n      display: inline-block; }\n    .filter_grid_wrapper .filter_grid_rent_slider_plugin span.customized_slider_container {\n      width: 330px;\n      display: inline-block; }\n  .filter_grid_wrapper .filter_grid_amenities_plugin {\n    margin-top: 45px;\n    display: flex;\n    align-items: flex-start; }\n  .filter_grid_wrapper span.customized_amenities_filter_list_wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 9px;\n    margin-left: 28px; }\n  .filter_grid_wrapper .filter_grid_listing_type_plugin {\n    display: flex;\n    align-items: baseline;\n    margin-top: 30px; }\n  .filter_grid_wrapper span.customized_listing_type_filter_list_wrapper {\n    display: flex;\n    margin-left: 18px; }\n";
styleInject(css_248z$v);

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$p(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$p(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$p() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ListingsFilterPlugin = /*#__PURE__*/function (_Component) {
  _inherits$1(ListingsFilterPlugin, _Component);

  var _super = _createSuper$p(ListingsFilterPlugin);

  function ListingsFilterPlugin(props) {
    var _this;

    _classCallCheck$1(this, ListingsFilterPlugin);

    _this = _super.call(this, props);
    _this.filterPluginDOM = /*#__PURE__*/React__default.createRef();
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(ListingsFilterPlugin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener("click", this.handleClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener("click", this.handleClick);
    }
  }, {
    key: "handleClick",
    value: function handleClick(click) {
      !this.filterPluginDOM.contains(click.target) && this.props.closePopup();
      return;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(element) {
          return _this2.filterPluginDOM = element;
        },
        className: "filter_grid_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "filter_grid_title"
      }, /*#__PURE__*/React__default.createElement("span", null, "ALL FILTERS"), /*#__PURE__*/React__default.createElement("span", {
        className: "pointer",
        onClick: function onClick() {
          return _this2.props.closePopup();
        }
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "close",
        width: 15,
        height: 8,
        color: "#000"
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "filter_grid_radio_selector"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "filter_grid_radio_selector_group"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Beds"), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(RadioSelector, {
        selector: this.props.bedRoomFilter,
        getSelection: function getSelection(value) {
          return _this2.props.getAllFilter(_objectSpread$f(_objectSpread$f({}, _this2.props), {}, {
            bedRoomFilter: value
          }));
        }
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "filter_grid_radio_selector_group"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Baths"), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(RadioSelector, {
        selector: this.props.bathRoomFilter,
        getSelection: function getSelection(value) {
          return _this2.props.getAllFilter(_objectSpread$f(_objectSpread$f({}, _this2.props), {}, {
            bathRoomFilter: value
          }));
        }
      })))), /*#__PURE__*/React__default.createElement("div", {
        className: "filter_grid_rent_slider_plugin"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Price"), /*#__PURE__*/React__default.createElement("span", {
        className: "customized_slider_container"
      }, /*#__PURE__*/React__default.createElement(CustomizedSlider, {
        minimumValue: this.props.minRent,
        maximumValue: this.props.maxRent,
        onChange: function onChange(e, value) {
          _this2.props.getAllFilter(_objectSpread$f(_objectSpread$f({}, _this2.props), {}, {
            minRent: value[0],
            maxRent: value[1]
          }));
        }
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "filter_grid_amenities_plugin"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Amenities"), /*#__PURE__*/React__default.createElement("span", {
        className: "customized_amenities_filter_list_wrapper"
      }, /*#__PURE__*/React__default.createElement(RadioButtonList, {
        buttonList: this.props.amenities,
        getSelection: function getSelection(value) {
          return _this2.props.getAllFilter(_objectSpread$f(_objectSpread$f({}, _this2.props), {}, {
            amenities: value
          }));
        }
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "filter_grid_listing_type_plugin"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Listing type"), /*#__PURE__*/React__default.createElement("span", {
        className: "customized_listing_type_filter_list_wrapper"
      }, /*#__PURE__*/React__default.createElement(CheckBox$1, {
        label: "Rental",
        isChecked: this.props.isRentalListingsSelected,
        onChange: function onChange() {
          return _this2.props.getAllFilter(_objectSpread$f(_objectSpread$f({}, _this2.props), {}, {
            isRentalListingsSelected: !_this2.props.isRentalListingsSelected
          }));
        }
      }), /*#__PURE__*/React__default.createElement(CheckBox$1, {
        label: "Sale",
        isChecked: this.props.isSalesListings,
        onChange: function onChange() {
          return _this2.props.getAllFilter(_objectSpread$f(_objectSpread$f({}, _this2.props), {}, {
            isSalesListings: !_this2.props.isSalesListings
          }));
        }
      }))));
    }
  }]);

  return ListingsFilterPlugin;
}(Component);

ListingsFilterPlugin.propTypes = {
  getAllFilter: PropTypes.func.isRequired,
  minRent: PropTypes.number,
  maxRent: PropTypes.number,
  bedRoomFilter: PropTypes.array,
  bathRoomFilter: PropTypes.array,
  amenities: PropTypes.array,
  isSalesListings: PropTypes.bool,
  isRentalListingsSelected: PropTypes.bool,
  closePopup: PropTypes.func
};

var css_248z$u = ".textfield {\n  box-sizing: border-box;\n  outline: 0;\n  border: 0;\n  line-height: 29px;\n  border-radius: 4px;\n  width: 60%;\n  text-overflow: ellipsis;\n  display: block;\n  width: 100%;\n  background: #fff;\n  min-height: 36px; }\n  .textfield:-webkit-autofill, .textfield:-webkit-autofill:hover, .textfield:-webkit-autofill:focus, .textfield:-webkit-autofill:active {\n    -webkit-transition: background-color 5000s ease-in-out 0s;\n    transition: background-color 5000s ease-in-out 0s; }\n  .textfield:disabled {\n    background: #dfdfdf;\n    cursor: not-allowed; }\n\n.errorWrapper {\n  color: #EA6767;\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  line-height: 19px;\n  padding-top: 10px; }\n\n.textfield_wrapper {\n  display: inline-flex;\n  flex-direction: column;\n  width: 100%; }\n  .textfield_wrapper .controller_wrapper {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 0 10px;\n    border-radius: 4px;\n    background: #FFFFFF;\n    box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n    border-radius: 5px; }\n    .textfield_wrapper .controller_wrapper .inputUnit {\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n      font-style: normal;\n      font-weight: bold;\n      font-size: 12px;\n      line-height: 21px;\n      color: #979797; }\n  .textfield_wrapper .disabled_clr {\n    background-color: #dfdfdf !important; }\n  .textfield_wrapper .active_clr {\n    background-color: #fff; }\n  .textfield_wrapper .errorMsg_clr, .textfield_wrapper .errorMsg_clr:focus-within {\n    background: linear-gradient(0deg, rgba(234, 103, 103, 0.1), rgba(234, 103, 103, 0.1)), #FFFFFF !important;\n    border: 1px solid #EA6767; }\n    .textfield_wrapper .errorMsg_clr input, .textfield_wrapper .errorMsg_clr:focus-within input {\n      background: linear-gradient(0deg, rgba(234, 103, 103, 0.1), rgba(234, 103, 103, 0.1)), #FFFFFF !important; }\n  .textfield_wrapper .controller_wrapper:focus-within {\n    background: #F5F5FA;\n    border: 1px solid #1D1C38; }\n    .textfield_wrapper .controller_wrapper:focus-within input {\n      background: #F5F5FA; }\n\n.required_astrick {\n  color: #EA6767;\n  display: flex;\n  justify-content: flex-end; }\n\n.label_error_wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; }\n  .label_error_wrapper .label {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px;\n    letter-spacing: -0.01em;\n    text-align: left;\n    display: flex; }\n\n.texxtfieldWrapper {\n  display: flex;\n  background: #fff;\n  border-radius: 5px;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  padding-right: 10px; }\n  .texxtfieldWrapper .symbol {\n    font-weight: 700;\n    margin: 0 8px; }\n\n.search_field_wrapper {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  padding: 0 10px;\n  border-radius: 30px;\n  justify-content: flex-start;\n  box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n  border: solid 0.1px #ebeff1; }\n  .search_field_wrapper .search_icon_search_field {\n    position: relative;\n    top: 2px; }\n  .search_field_wrapper .textfield_wrapper .controller_wrapper, .search_field_wrapper .controller_wrapper:focus-within {\n    box-shadow: none;\n    border: none;\n    background-color: #FFFFFF !important; }\n    .search_field_wrapper .textfield_wrapper .controller_wrapper input:focus, .search_field_wrapper .controller_wrapper:focus-within input:focus {\n      background-color: #FFFFFF !important; }\n\n.clearButton {\n  cursor: pointer; }\n\n::placeholder {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 21px;\n  color: #C4C4C4;\n  opacity: 1;\n  /* Firefox */ }\n\n:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #979797;\n  font-weight: normal; }\n\n::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #979797;\n  font-weight: normal; }\n";
styleInject(css_248z$u);

function _interopDefault$1(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React$1=_interopDefault$1(React__default);function _defaults2$1(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r);}return e}function _extends$1(){return (_extends$1=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);}return e}).apply(this,arguments)}function _inheritsLoose$1(e,t){e.prototype=Object.create(t.prototype),_defaults2$1(e.prototype.constructor=e,t);}function _objectWithoutPropertiesLoose$1(e,t){if(null==e)return {};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized$1(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant$2=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation";}throw l.framesToPop=1,l}},invariant_1=invariant$2;function setInputSelection$1(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else {var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select();}}function getInputSelection$1(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else {var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length));}return {start:t,end:n,length:n-t}}var defaultFormatChars$1={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar$1="_";function parseMask$1(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar$1),null==n&&(n=defaultFormatChars$1),!e||"string"!=typeof e)return {maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1);}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter$1(e,t){return -1!==e.permanents.indexOf(t)}function isAllowedCharacter$1(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return !1;if(isPermanentCharacter$1(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty$2(n,e){return e.split("").every(function(e,t){return isPermanentCharacter$1(n,t)||!isAllowedCharacter$1(n,t,e)})}function getFilledLength$1(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter$1(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter$1(e,r)&&isAllowedCharacter$1(e,r,o)){i=r+1;break}}return i}function isFilled$2(e,t){return getFilledLength$1(e,t)===e.mask.length}function formatValue$1(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString$1(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter$1(e,t.length);)t+=a[t.length];return t}if(t)return insertString$1(e,formatValue$1(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter$1(e,r)?t+=a[r]:t+=n;return t}function clearRange$1(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter$1(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter$1(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue$1(n,e)}function insertString$1(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled$2(r,o);return !u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter$1(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter$1(r,n)&&t===u)return !0;if(++s>=l.length)return !1}var t,n,a,i;return !isAllowedCharacter$1(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue$1(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength$1(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter$1(a,t=i)&&n!==r[t];)if(++i>=r.length)return !1;var t,n;return (isAllowedCharacter$1(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition$1(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter$1(e,n))return n;return null}function getRightEditablePosition$1(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter$1(e,a))return a;return null}function getStringValue$1(e){return e||0===e?e+"":""}function processChange$1(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength$1(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition$1(e,n.start):getLeftEditablePosition$1(e,n.start);l=clearRange$1(e,l,f,h);}return l=insertString$1(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition$1(e,f)),u||(u=null),{value:l=formatValue$1(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser$1(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction$1(e){return "function"==typeof e}function getRequestAnimationFrame$1(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame$1(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer$1(e){return (!!getCancelAnimationFrame$1()?getRequestAnimationFrame$1():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer$1(e){(getCancelAnimationFrame$1()||clearTimeout)(e);}var InputElement$1=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer$1(f.saveSelectionLoop);},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop();},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer$1(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null);},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=ReactDOM__default.findDOMNode(_assertThisInitialized$1(_assertThisInitialized$1(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e);},f.setCursorToEnd=function(){var e=getFilledLength$1(f.maskOptions,f.value),t=getRightEditablePosition$1(f.maskOptions,e);null!==t&&f.setCursorPosition(t);},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection$1(a,e,t),null!==f.selectionDeferId&&cancelDefer$1(f.selectionDeferId),f.selectionDeferId=defer$1(function(){f.selectionDeferId=null,setInputSelection$1(a,e,t);}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)});},f.getSelection=function(){return getInputSelection$1(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e);},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return {mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return !0}catch(r){}return !f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized$1(_assertThisInitialized$1(f)).beforePasteState,n=_assertThisInitialized$1(_assertThisInitialized$1(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue$1(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange$1(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction$1(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection;}f.setInputValue(c),isFunction$1(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end);},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength$1(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else {var r=formatValue$1(f.maskOptions,i),o=formatValue$1(f.maskOptions,r),s=getFilledLength$1(f.maskOptions,o),l=getRightEditablePosition$1(f.maskOptions,s),u={start:l,end:l};if(isFunction$1(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection;}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction$1(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end);}f.runSaveSelectionLoop();}isFunction$1(f.props.onFocus)&&f.props.onFocus(e);},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty$2(f.maskOptions,f.value)){var a="";if(isFunction$1(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction$1(f.props.onChange)&&f.props.onChange(e);}isFunction$1(f.props.onBlur)&&f.props.onBlur(e);},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd();}};document.addEventListener("mouseup",r);}isFunction$1(f.props.onMouseDown)&&f.props.onMouseDown(e);},f.onPaste=function(e){isFunction$1(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""));},f.handleRef=function(e){null==f.props.children&&isFunction$1(f.props.inputRef)&&f.props.inputRef(e);};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask$1(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue$1(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue$1(f.maskOptions,l),isFunction$1(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue$1(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value;}return f.value=l,f}_inheritsLoose$1(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser$1(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value));},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue$1(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask$1(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue$1(this.maskOptions,c)),f){var p=getFilledLength$1(this.maskOptions,c);(null===h||p<h)&&(h=isFilled$2(this.maskOptions,c)?p:getRightEditablePosition$1(this.maskOptions,p));}!this.maskOptions.mask||!isEmpty$2(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction$1(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection;}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end);}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate());},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer$1(this.selectionDeferId),this.stopSaveSelectionLoop();},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose$1(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction$1(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends$1({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1);}else t=React$1.createElement("input",_extends$1({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React$1.cloneElement(t,o)},e}(React$1.Component);var reactInputMask_production_min=InputElement$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant$1 = function(condition, format, a, b, c, d, e, f) {
  if (process.env.NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var browser = invariant$1;

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning$1 = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning$1 = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning$1;

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(React__default);

var invariant = _interopDefault(browser);
var warning = _interopDefault(warning_1);

function _defaults2(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _defaults2(subClass, superClass);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function setInputSelection(input, start, end) {
  if ('selectionStart' in input && 'selectionEnd' in input) {
    input.selectionStart = start;
    input.selectionEnd = end;
  } else {
    var range = input.createTextRange();
    range.collapse(true);
    range.moveStart('character', start);
    range.moveEnd('character', end - start);
    range.select();
  }
}
function getInputSelection(input) {
  var start = 0;
  var end = 0;

  if ('selectionStart' in input && 'selectionEnd' in input) {
    start = input.selectionStart;
    end = input.selectionEnd;
  } else {
    var range = document.selection.createRange();

    if (range.parentElement() === input) {
      start = -range.moveStart('character', -input.value.length);
      end = -range.moveEnd('character', -input.value.length);
    }
  }

  return {
    start: start,
    end: end,
    length: end - start
  };
}

var defaultFormatChars = {
  '9': '[0-9]',
  'a': '[A-Za-z]',
  '*': '[A-Za-z0-9]'
};
var defaultMaskChar = '_';

function parseMask (mask, maskChar, formatChars) {
  var parsedMaskString = '';
  var prefix = '';
  var lastEditablePosition = null;
  var permanents = [];

  if (maskChar === undefined) {
    maskChar = defaultMaskChar;
  }

  if (formatChars == null) {
    formatChars = defaultFormatChars;
  }

  if (!mask || typeof mask !== 'string') {
    return {
      maskChar: maskChar,
      formatChars: formatChars,
      mask: null,
      prefix: null,
      lastEditablePosition: null,
      permanents: []
    };
  }

  var isPermanent = false;
  mask.split('').forEach(function (character) {
    if (!isPermanent && character === '\\') {
      isPermanent = true;
    } else {
      if (isPermanent || !formatChars[character]) {
        permanents.push(parsedMaskString.length);

        if (parsedMaskString.length === permanents.length - 1) {
          prefix += character;
        }
      } else {
        lastEditablePosition = parsedMaskString.length + 1;
      }

      parsedMaskString += character;
      isPermanent = false;
    }
  });
  return {
    maskChar: maskChar,
    formatChars: formatChars,
    prefix: prefix,
    mask: parsedMaskString,
    lastEditablePosition: lastEditablePosition,
    permanents: permanents
  };
}

/* eslint no-use-before-define: ["error", { functions: false }] */
function isPermanentCharacter(maskOptions, pos) {
  return maskOptions.permanents.indexOf(pos) !== -1;
}
function isAllowedCharacter(maskOptions, pos, character) {
  var mask = maskOptions.mask,
      formatChars = maskOptions.formatChars;

  if (!character) {
    return false;
  }

  if (isPermanentCharacter(maskOptions, pos)) {
    return mask[pos] === character;
  }

  var ruleChar = mask[pos];
  var charRule = formatChars[ruleChar];
  return new RegExp(charRule).test(character);
}
function isEmpty$1(maskOptions, value) {
  return value.split('').every(function (character, i) {
    return isPermanentCharacter(maskOptions, i) || !isAllowedCharacter(maskOptions, i, character);
  });
}
function getFilledLength(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    while (value.length > prefix.length && isPermanentCharacter(maskOptions, value.length - 1)) {
      value = value.slice(0, value.length - 1);
    }

    return value.length;
  }

  var filledLength = prefix.length;

  for (var i = value.length; i >= prefix.length; i--) {
    var character = value[i];
    var isEnteredCharacter = !isPermanentCharacter(maskOptions, i) && isAllowedCharacter(maskOptions, i, character);

    if (isEnteredCharacter) {
      filledLength = i + 1;
      break;
    }
  }

  return filledLength;
}
function isFilled$1(maskOptions, value) {
  return getFilledLength(maskOptions, value) === maskOptions.mask.length;
}
function formatValue(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    value = insertString(maskOptions, '', value, 0);

    if (value.length < prefix.length) {
      value = prefix;
    }

    while (value.length < mask.length && isPermanentCharacter(maskOptions, value.length)) {
      value += mask[value.length];
    }

    return value;
  }

  if (value) {
    var emptyValue = formatValue(maskOptions, '');
    return insertString(maskOptions, emptyValue, value, 0);
  }

  for (var i = 0; i < mask.length; i++) {
    if (isPermanentCharacter(maskOptions, i)) {
      value += mask[i];
    } else {
      value += maskChar;
    }
  }

  return value;
}
function clearRange(maskOptions, value, start, len) {
  var end = start + len;
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;
  var arrayValue = value.split('');

  if (!maskChar) {
    // remove any permanent chars after clear range, they will be added back by formatValue
    for (var i = end; i < arrayValue.length; i++) {
      if (isPermanentCharacter(maskOptions, i)) {
        arrayValue[i] = '';
      }
    }

    start = Math.max(prefix.length, start);
    arrayValue.splice(start, end - start);
    value = arrayValue.join('');
    return formatValue(maskOptions, value);
  }

  return arrayValue.map(function (character, i) {
    if (i < start || i >= end) {
      return character;
    }

    if (isPermanentCharacter(maskOptions, i)) {
      return mask[i];
    }

    return maskChar;
  }).join('');
}
function insertString(maskOptions, value, insertStr, insertPosition) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;
  var arrayInsertStr = insertStr.split('');
  var isInputFilled = isFilled$1(maskOptions, value);

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentCharacter(maskOptions, pos) || character === mask[pos];
  };

  var isUsableCharacter = function isUsableCharacter(character, pos) {
    return !maskChar || !isPermanentCharacter(maskOptions, pos) || character !== maskChar;
  };

  if (!maskChar && insertPosition > value.length) {
    value += mask.slice(value.length, insertPosition);
  }

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPosition, insertCharacter)) {
      if (insertPosition >= value.length) {
        value += mask[insertPosition];
      }

      if (!isUsableCharacter(insertCharacter, insertPosition)) {
        return true;
      }

      insertPosition++; // stop iteration if maximum value length reached

      if (insertPosition >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedCharacter(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

    if (!isAllowed) {
      return true;
    }

    if (insertPosition < value.length) {
      if (maskChar || isInputFilled || insertPosition < prefix.length) {
        value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition + 1);
      } else {
        value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition);
        value = formatValue(maskOptions, value);
      }
    } else if (!maskChar) {
      value += insertCharacter;
    }

    insertPosition++; // stop iteration if maximum value length reached

    return insertPosition < mask.length;
  });
  return value;
}
function getInsertStringLength(maskOptions, value, insertStr, insertPosition) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar;
  var arrayInsertStr = insertStr.split('');
  var initialInsertPosition = insertPosition;

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentCharacter(maskOptions, pos) || character === mask[pos];
  };

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPosition, insertCharacter)) {
      insertPosition++; // stop iteration if maximum value length reached

      if (insertPosition >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedCharacter(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

    if (isAllowed) {
      insertPosition++;
    } // stop iteration if maximum value length reached


    return insertPosition < mask.length;
  });
  return insertPosition - initialInsertPosition;
}
function getLeftEditablePosition(maskOptions, pos) {
  for (var i = pos; i >= 0; --i) {
    if (!isPermanentCharacter(maskOptions, i)) {
      return i;
    }
  }

  return null;
}
function getRightEditablePosition(maskOptions, pos) {
  var mask = maskOptions.mask;

  for (var i = pos; i < mask.length; ++i) {
    if (!isPermanentCharacter(maskOptions, i)) {
      return i;
    }
  }

  return null;
}
function getStringValue(value) {
  return !value && value !== 0 ? '' : value + '';
}

function processChange(maskOptions, value, selection, previousValue, previousSelection) {
  var mask = maskOptions.mask,
      prefix = maskOptions.prefix,
      lastEditablePosition = maskOptions.lastEditablePosition;
  var newValue = value;
  var enteredString = '';
  var formattedEnteredStringLength = 0;
  var removedLength = 0;
  var cursorPosition = Math.min(previousSelection.start, selection.start);

  if (selection.end > previousSelection.start) {
    enteredString = newValue.slice(previousSelection.start, selection.end);
    formattedEnteredStringLength = getInsertStringLength(maskOptions, previousValue, enteredString, cursorPosition);

    if (!formattedEnteredStringLength) {
      removedLength = 0;
    } else {
      removedLength = previousSelection.length;
    }
  } else if (newValue.length < previousValue.length) {
    removedLength = previousValue.length - newValue.length;
  }

  newValue = previousValue;

  if (removedLength) {
    if (removedLength === 1 && !previousSelection.length) {
      var deleteFromRight = previousSelection.start === selection.start;
      cursorPosition = deleteFromRight ? getRightEditablePosition(maskOptions, selection.start) : getLeftEditablePosition(maskOptions, selection.start);
    }

    newValue = clearRange(maskOptions, newValue, cursorPosition, removedLength);
  }

  newValue = insertString(maskOptions, newValue, enteredString, cursorPosition);
  cursorPosition = cursorPosition + formattedEnteredStringLength;

  if (cursorPosition >= mask.length) {
    cursorPosition = mask.length;
  } else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
    cursorPosition = prefix.length;
  } else if (cursorPosition >= prefix.length && cursorPosition < lastEditablePosition && formattedEnteredStringLength) {
    cursorPosition = getRightEditablePosition(maskOptions, cursorPosition);
  }

  newValue = formatValue(maskOptions, newValue);

  if (!enteredString) {
    enteredString = null;
  }

  return {
    value: newValue,
    enteredString: enteredString,
    selection: {
      start: cursorPosition,
      end: cursorPosition
    }
  };
}

function isWindowsPhoneBrowser() {
  var windows = new RegExp('windows', 'i');
  var phone = new RegExp('phone', 'i');
  var ua = navigator.userAgent;
  return windows.test(ua) && phone.test(ua);
}

function isFunction(value) {
  return typeof value === 'function';
}

function getRequestAnimationFrame() {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
}

function getCancelAnimationFrame() {
  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
}

function defer(fn) {
  var hasCancelAnimationFrame = !!getCancelAnimationFrame();
  var deferFn;

  if (hasCancelAnimationFrame) {
    deferFn = getRequestAnimationFrame();
  } else {
    deferFn = function deferFn() {
      return setTimeout(fn, 1000 / 60);
    };
  }

  return deferFn(fn);
}
function cancelDefer(deferId) {
  var cancelFn = getCancelAnimationFrame() || clearTimeout;
  cancelFn(deferId);
}

var InputElement =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(InputElement, _React$Component);

  function InputElement(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.focused = false;
    _this.mounted = false;
    _this.previousSelection = null;
    _this.selectionDeferId = null;
    _this.saveSelectionLoopDeferId = null;

    _this.saveSelectionLoop = function () {
      _this.previousSelection = _this.getSelection();
      _this.saveSelectionLoopDeferId = defer(_this.saveSelectionLoop);
    };

    _this.runSaveSelectionLoop = function () {
      if (_this.saveSelectionLoopDeferId === null) {
        _this.saveSelectionLoop();
      }
    };

    _this.stopSaveSelectionLoop = function () {
      if (_this.saveSelectionLoopDeferId !== null) {
        cancelDefer(_this.saveSelectionLoopDeferId);
        _this.saveSelectionLoopDeferId = null;
        _this.previousSelection = null;
      }
    };

    _this.getInputDOMNode = function () {
      if (!_this.mounted) {
        return null;
      }

      var input = ReactDOM__default.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
      var isDOMNode = typeof window !== 'undefined' && input instanceof window.Element; // workaround for react-test-renderer
      // https://github.com/sanniassin/react-input-mask/issues/147

      if (input && !isDOMNode) {
        return null;
      }

      if (input.nodeName !== 'INPUT') {
        input = input.querySelector('input');
      }

      if (!input) {
        throw new Error('react-input-mask: inputComponent doesn\'t contain input node');
      }

      return input;
    };

    _this.getInputValue = function () {
      var input = _this.getInputDOMNode();

      if (!input) {
        return null;
      }

      return input.value;
    };

    _this.setInputValue = function (value) {
      var input = _this.getInputDOMNode();

      if (!input) {
        return;
      }

      _this.value = value;
      input.value = value;
    };

    _this.setCursorToEnd = function () {
      var filledLength = getFilledLength(_this.maskOptions, _this.value);
      var pos = getRightEditablePosition(_this.maskOptions, filledLength);

      if (pos !== null) {
        _this.setCursorPosition(pos);
      }
    };

    _this.setSelection = function (start, end, options) {
      if (options === void 0) {
        options = {};
      }

      var input = _this.getInputDOMNode();

      var isFocused = _this.isFocused(); // don't change selection on unfocused input
      // because Safari sets focus on selection change (#154)


      if (!input || !isFocused) {
        return;
      }

      var _options = options,
          deferred = _options.deferred;

      if (!deferred) {
        setInputSelection(input, start, end);
      }

      if (_this.selectionDeferId !== null) {
        cancelDefer(_this.selectionDeferId);
      } // deferred selection update is required for pre-Lollipop Android browser,
      // but for consistent behavior we do it for all browsers


      _this.selectionDeferId = defer(function () {
        _this.selectionDeferId = null;
        setInputSelection(input, start, end);
      });
      _this.previousSelection = {
        start: start,
        end: end,
        length: Math.abs(end - start)
      };
    };

    _this.getSelection = function () {
      var input = _this.getInputDOMNode();

      return getInputSelection(input);
    };

    _this.getCursorPosition = function () {
      return _this.getSelection().start;
    };

    _this.setCursorPosition = function (pos) {
      _this.setSelection(pos, pos);
    };

    _this.isFocused = function () {
      return _this.focused;
    };

    _this.getBeforeMaskedValueChangeConfig = function () {
      var _this$maskOptions = _this.maskOptions,
          mask = _this$maskOptions.mask,
          maskChar = _this$maskOptions.maskChar,
          permanents = _this$maskOptions.permanents,
          formatChars = _this$maskOptions.formatChars;
      var alwaysShowMask = _this.props.alwaysShowMask;
      return {
        mask: mask,
        maskChar: maskChar,
        permanents: permanents,
        alwaysShowMask: !!alwaysShowMask,
        formatChars: formatChars
      };
    };

    _this.isInputAutofilled = function (value, selection, previousValue, previousSelection) {
      var input = _this.getInputDOMNode(); // only check for positive match because it will be false negative
      // in case of autofill simulation in tests
      //
      // input.matches throws an exception if selector isn't supported


      try {
        if (input.matches(':-webkit-autofill')) {
          return true;
        }
      } catch (e) {} // if input isn't focused then change event must have been triggered
      // either by autofill or event simulation in tests


      if (!_this.focused) {
        return true;
      } // if cursor has moved to the end while previousSelection forbids it
      // then it must be autofill


      return previousSelection.end < previousValue.length && selection.end === value.length;
    };

    _this.onChange = function (event) {
      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          beforePasteState = _assertThisInitialize.beforePasteState;

      var _assertThisInitialize2 = _assertThisInitialized(_assertThisInitialized(_this)),
          previousSelection = _assertThisInitialize2.previousSelection;

      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;

      var value = _this.getInputValue();

      var previousValue = _this.value;

      var selection = _this.getSelection(); // autofill replaces entire value, ignore old one
      // https://github.com/sanniassin/react-input-mask/issues/113


      if (_this.isInputAutofilled(value, selection, previousValue, previousSelection)) {
        previousValue = formatValue(_this.maskOptions, '');
        previousSelection = {
          start: 0,
          end: 0,
          length: 0
        };
      } // set value and selection as if we haven't
      // cleared input in onPaste handler


      if (beforePasteState) {
        previousSelection = beforePasteState.selection;
        previousValue = beforePasteState.value;
        selection = {
          start: previousSelection.start + value.length,
          end: previousSelection.start + value.length,
          length: 0
        };
        value = previousValue.slice(0, previousSelection.start) + value + previousValue.slice(previousSelection.end);
        _this.beforePasteState = null;
      }

      var changedState = processChange(_this.maskOptions, value, selection, previousValue, previousSelection);
      var enteredString = changedState.enteredString;
      var newSelection = changedState.selection;
      var newValue = changedState.value;

      if (isFunction(beforeMaskedValueChange)) {
        var modifiedValue = beforeMaskedValueChange({
          value: newValue,
          selection: newSelection
        }, {
          value: previousValue,
          selection: previousSelection
        }, enteredString, _this.getBeforeMaskedValueChangeConfig());
        newValue = modifiedValue.value;
        newSelection = modifiedValue.selection;
      }

      _this.setInputValue(newValue);

      if (isFunction(_this.props.onChange)) {
        _this.props.onChange(event);
      }

      if (_this.isWindowsPhoneBrowser) {
        _this.setSelection(newSelection.start, newSelection.end, {
          deferred: true
        });
      } else {
        _this.setSelection(newSelection.start, newSelection.end);
      }
    };

    _this.onFocus = function (event) {
      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
      var _this$maskOptions2 = _this.maskOptions,
          mask = _this$maskOptions2.mask,
          prefix = _this$maskOptions2.prefix;
      _this.focused = true; // if autoFocus is set, onFocus triggers before componentDidMount

      _this.mounted = true;

      if (mask) {
        if (!_this.value) {
          var emptyValue = formatValue(_this.maskOptions, prefix);
          var newValue = formatValue(_this.maskOptions, emptyValue);
          var filledLength = getFilledLength(_this.maskOptions, newValue);
          var cursorPosition = getRightEditablePosition(_this.maskOptions, filledLength);
          var newSelection = {
            start: cursorPosition,
            end: cursorPosition
          };

          if (isFunction(beforeMaskedValueChange)) {
            var modifiedValue = beforeMaskedValueChange({
              value: newValue,
              selection: newSelection
            }, {
              value: _this.value,
              selection: null
            }, null, _this.getBeforeMaskedValueChangeConfig());
            newValue = modifiedValue.value;
            newSelection = modifiedValue.selection;
          }

          var isInputValueChanged = newValue !== _this.getInputValue();

          if (isInputValueChanged) {
            _this.setInputValue(newValue);
          }

          if (isInputValueChanged && isFunction(_this.props.onChange)) {
            _this.props.onChange(event);
          }

          _this.setSelection(newSelection.start, newSelection.end);
        } else if (getFilledLength(_this.maskOptions, _this.value) < _this.maskOptions.mask.length) {
          _this.setCursorToEnd();
        }

        _this.runSaveSelectionLoop();
      }

      if (isFunction(_this.props.onFocus)) {
        _this.props.onFocus(event);
      }
    };

    _this.onBlur = function (event) {
      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
      var mask = _this.maskOptions.mask;

      _this.stopSaveSelectionLoop();

      _this.focused = false;

      if (mask && !_this.props.alwaysShowMask && isEmpty$1(_this.maskOptions, _this.value)) {
        var newValue = '';

        if (isFunction(beforeMaskedValueChange)) {
          var modifiedValue = beforeMaskedValueChange({
            value: newValue,
            selection: null
          }, {
            value: _this.value,
            selection: _this.previousSelection
          }, null, _this.getBeforeMaskedValueChangeConfig());
          newValue = modifiedValue.value;
        }

        var isInputValueChanged = newValue !== _this.getInputValue();

        if (isInputValueChanged) {
          _this.setInputValue(newValue);
        }

        if (isInputValueChanged && isFunction(_this.props.onChange)) {
          _this.props.onChange(event);
        }
      }

      if (isFunction(_this.props.onBlur)) {
        _this.props.onBlur(event);
      }
    };

    _this.onMouseDown = function (event) {
      // tiny unintentional mouse movements can break cursor
      // position on focus, so we have to restore it in that case
      //
      // https://github.com/sanniassin/react-input-mask/issues/108
      if (!_this.focused && document.addEventListener) {
        _this.mouseDownX = event.clientX;
        _this.mouseDownY = event.clientY;
        _this.mouseDownTime = new Date().getTime();

        var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
          document.removeEventListener('mouseup', mouseUpHandler);

          if (!_this.focused) {
            return;
          }

          var deltaX = Math.abs(mouseUpEvent.clientX - _this.mouseDownX);
          var deltaY = Math.abs(mouseUpEvent.clientY - _this.mouseDownY);
          var axisDelta = Math.max(deltaX, deltaY);

          var timeDelta = new Date().getTime() - _this.mouseDownTime;

          if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
            _this.setCursorToEnd();
          }
        };

        document.addEventListener('mouseup', mouseUpHandler);
      }

      if (isFunction(_this.props.onMouseDown)) {
        _this.props.onMouseDown(event);
      }
    };

    _this.onPaste = function (event) {
      if (isFunction(_this.props.onPaste)) {
        _this.props.onPaste(event);
      } // event.clipboardData might not work in Android browser
      // cleaning input to get raw text inside onChange handler


      if (!event.defaultPrevented) {
        _this.beforePasteState = {
          value: _this.getInputValue(),
          selection: _this.getSelection()
        };

        _this.setInputValue('');
      }
    };

    _this.handleRef = function (ref) {
      if (_this.props.children == null && isFunction(_this.props.inputRef)) {
        _this.props.inputRef(ref);
      }
    };

    var _mask = props.mask,
        _maskChar = props.maskChar,
        _formatChars = props.formatChars,
        _alwaysShowMask = props.alwaysShowMask,
        _beforeMaskedValueChange = props.beforeMaskedValueChange;
    var defaultValue = props.defaultValue,
        _value = props.value;
    _this.maskOptions = parseMask(_mask, _maskChar, _formatChars);

    if (defaultValue == null) {
      defaultValue = '';
    }

    if (_value == null) {
      _value = defaultValue;
    }

    var _newValue = getStringValue(_value);

    if (_this.maskOptions.mask && (_alwaysShowMask || _newValue)) {
      _newValue = formatValue(_this.maskOptions, _newValue);

      if (isFunction(_beforeMaskedValueChange)) {
        var oldValue = props.value;

        if (props.value == null) {
          oldValue = defaultValue;
        }

        oldValue = getStringValue(oldValue);

        var modifiedValue = _beforeMaskedValueChange({
          value: _newValue,
          selection: null
        }, {
          value: oldValue,
          selection: null
        }, null, _this.getBeforeMaskedValueChangeConfig());

        _newValue = modifiedValue.value;
      }
    }

    _this.value = _newValue;
    return _this;
  }

  var _proto = InputElement.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true; // workaround for react-test-renderer
    // https://github.com/sanniassin/react-input-mask/issues/147

    if (!this.getInputDOMNode()) {
      return;
    }

    this.isWindowsPhoneBrowser = isWindowsPhoneBrowser();

    if (this.maskOptions.mask && this.getInputValue() !== this.value) {
      this.setInputValue(this.value);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var previousSelection = this.previousSelection;
    var _this$props = this.props,
        beforeMaskedValueChange = _this$props.beforeMaskedValueChange,
        alwaysShowMask = _this$props.alwaysShowMask,
        mask = _this$props.mask,
        maskChar = _this$props.maskChar,
        formatChars = _this$props.formatChars;
    var previousMaskOptions = this.maskOptions;
    var showEmpty = alwaysShowMask || this.isFocused();
    var hasValue = this.props.value != null;
    var newValue = hasValue ? getStringValue(this.props.value) : this.value;
    var cursorPosition = previousSelection ? previousSelection.start : null;
    this.maskOptions = parseMask(mask, maskChar, formatChars);

    if (!this.maskOptions.mask) {
      if (previousMaskOptions.mask) {
        this.stopSaveSelectionLoop(); // render depends on this.maskOptions and this.value,
        // call forceUpdate to keep it in sync

        this.forceUpdate();
      }

      return;
    } else if (!previousMaskOptions.mask && this.isFocused()) {
      this.runSaveSelectionLoop();
    }

    var isMaskChanged = this.maskOptions.mask && this.maskOptions.mask !== previousMaskOptions.mask;

    if (!previousMaskOptions.mask && !hasValue) {
      newValue = this.getInputValue();
    }

    if (isMaskChanged || this.maskOptions.mask && (newValue || showEmpty)) {
      newValue = formatValue(this.maskOptions, newValue);
    }

    if (isMaskChanged) {
      var filledLength = getFilledLength(this.maskOptions, newValue);

      if (cursorPosition === null || filledLength < cursorPosition) {
        if (isFilled$1(this.maskOptions, newValue)) {
          cursorPosition = filledLength;
        } else {
          cursorPosition = getRightEditablePosition(this.maskOptions, filledLength);
        }
      }
    }

    if (this.maskOptions.mask && isEmpty$1(this.maskOptions, newValue) && !showEmpty && (!hasValue || !this.props.value)) {
      newValue = '';
    }

    var newSelection = {
      start: cursorPosition,
      end: cursorPosition
    };

    if (isFunction(beforeMaskedValueChange)) {
      var modifiedValue = beforeMaskedValueChange({
        value: newValue,
        selection: newSelection
      }, {
        value: this.value,
        selection: this.previousSelection
      }, null, this.getBeforeMaskedValueChangeConfig());
      newValue = modifiedValue.value;
      newSelection = modifiedValue.selection;
    }

    this.value = newValue;
    var isValueChanged = this.getInputValue() !== this.value; // render depends on this.maskOptions and this.value,
    // call forceUpdate to keep it in sync

    if (isValueChanged) {
      this.setInputValue(this.value);
      this.forceUpdate();
    } else if (isMaskChanged) {
      this.forceUpdate();
    }

    var isSelectionChanged = false;

    if (newSelection.start != null && newSelection.end != null) {
      isSelectionChanged = !previousSelection || previousSelection.start !== newSelection.start || previousSelection.end !== newSelection.end;
    }

    if (isSelectionChanged || isValueChanged) {
      this.setSelection(newSelection.start, newSelection.end);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;

    if (this.selectionDeferId !== null) {
      cancelDefer(this.selectionDeferId);
    }

    this.stopSaveSelectionLoop();
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        mask = _this$props2.mask;
        _this$props2.alwaysShowMask;
        var maskChar = _this$props2.maskChar,
        formatChars = _this$props2.formatChars,
        inputRef = _this$props2.inputRef;
        _this$props2.beforeMaskedValueChange;
        var children = _this$props2.children,
        restProps = _objectWithoutPropertiesLoose(_this$props2, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);

    var inputElement;
    process.env.NODE_ENV !== "production" ? warning( // parse mask to test against actual mask prop as this.maskOptions
    // will be updated later in componentDidUpdate
    !restProps.maxLength || !parseMask(mask, maskChar, formatChars).mask, 'react-input-mask: maxLength property shouldn\'t be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.') : void 0;

    if (children) {
      !isFunction(children) ? process.env.NODE_ENV !== "production" ? invariant(false, 'react-input-mask: children must be a function') : invariant(false) : void 0;
      var controlledProps = ['onChange', 'onPaste', 'onMouseDown', 'onFocus', 'onBlur', 'value', 'disabled', 'readOnly'];

      var childrenProps = _extends({}, restProps);

      controlledProps.forEach(function (propId) {
        return delete childrenProps[propId];
      });
      inputElement = children(childrenProps);
      var conflictProps = controlledProps.filter(function (propId) {
        return inputElement.props[propId] != null && inputElement.props[propId] !== restProps[propId];
      });
      !!conflictProps.length ? process.env.NODE_ENV !== "production" ? invariant(false, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + conflictProps.join(', ')) : invariant(false) : void 0;
      process.env.NODE_ENV !== "production" ? warning(!inputRef, 'react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead') : void 0;
    } else {
      inputElement = React.createElement("input", _extends({
        ref: this.handleRef
      }, restProps));
    }

    var changedProps = {
      onFocus: this.onFocus,
      onBlur: this.onBlur
    };

    if (this.maskOptions.mask) {
      if (!restProps.disabled && !restProps.readOnly) {
        changedProps.onChange = this.onChange;
        changedProps.onPaste = this.onPaste;
        changedProps.onMouseDown = this.onMouseDown;
      }

      if (restProps.value != null) {
        changedProps.value = this.value;
      }
    }

    inputElement = React.cloneElement(inputElement, changedProps);
    return inputElement;
  };

  return InputElement;
}(React.Component);

var reactInputMask_development = InputElement;

var reactInputMask = createCommonjsModule(function (module) {
if (process.env.NODE_ENV === 'production') {
  module.exports = reactInputMask_production_min;
} else {
  module.exports = reactInputMask_development;
}
});

function _createSuper$o(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$o(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$o() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TextField$2 = /*#__PURE__*/function (_Component) {
  _inherits$1(TextField, _Component);

  var _super = _createSuper$o(TextField);

  function TextField(props) {
    var _this;

    _classCallCheck$1(this, TextField);

    _this = _super.call(this, props);
    _this.state = {
      dirty: false,
      text: _this.props.value || ""
    };
    _this.valueUpdated = _this.valueUpdated.bind(_assertThisInitialized$3(_this));
    _this.inputBlurred = _this.inputBlurred.bind(_assertThisInitialized$3(_this));
    _this.onTouchEvent = _this.onTouchEvent.bind(_assertThisInitialized$3(_this));
    _this.iconClick = _this.iconClick.bind(_assertThisInitialized$3(_this));
    _this._handleKeyDown = _this._handleKeyDown.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(TextField, [{
    key: "valueUpdated",
    value: function valueUpdated(e) {
      this.setState({
        text: e.currentTarget.value
      });
      this.props.change(e.currentTarget.value);
    }
  }, {
    key: "_handleKeyDown",
    value: function _handleKeyDown(e) {
      if (e.key === "Enter") {
        this.props.onKeyDown(true);
      }
    }
  }, {
    key: "iconClick",
    value: function iconClick() {
      this.props.onIconClick(true);
    }
  }, {
    key: "onTouchEvent",
    value: function onTouchEvent() {
      this.setState({
        dirty: true
      });
    }
  }, {
    key: "inputBlurred",
    value: function inputBlurred(e) {
      this.props.blur && this.props.blur(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          value = _this$props.value,
          disabled = _this$props.disabled,
          id = _this$props.id,
          name = _this$props.name,
          errorMessage = _this$props.errorMessage,
          isRequired = _this$props.isRequired,
          hasError = _this$props.hasError,
          placeholder = _this$props.placeholder,
          maxLength = _this$props.maxLength,
          errorMessageColor = _this$props.errorMessageColor,
          mask = _this$props.mask,
          inputUnit = _this$props.inputUnit,
          isCheckmark = _this$props.isCheckmark,
          isSelectionBox = _this$props.isSelectionBox;

      return /*#__PURE__*/React__default.createElement("div", {
        className: "textfield_wrapper"
      }, this.props.label.length > 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "label_error_wrapper"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, this.props.label, this.props.isRequired && /*#__PURE__*/React__default.createElement("div", {
        className: "required_astrick"
      }, "*"))), /*#__PURE__*/React__default.createElement("span", {
        className: "controller_wrapper ".concat(disabled ? "disabled_clr" : "active_clr", " ").concat(hasError || this.state.dirty && isRequired && this.state.text.length <= 0 ? "errorMsg_clr" : "active_clr")
      }, isSelectionBox && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("input", {
        className: "edit_checkbox",
        tabIndex: -1,
        type: "checkbox"
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "checkmark"
      })), mask ? /*#__PURE__*/React__default.createElement(reactInputMask, {
        type: this.props.type,
        className: "textfield",
        placeholder: placeholder,
        tabIndex: 0,
        onChange: function onChange(e) {
          return _this2.valueUpdated(e);
        },
        onKeyDown: this._handleKeyDown,
        value: value,
        disabled: disabled,
        id: id,
        name: name,
        autoComplete: this.props.autocomplete,
        onBlur: function onBlur(e) {
          _this2.onTouchEvent();

          _this2.inputBlurred(e);
        },
        mask: mask
      }) : /*#__PURE__*/React__default.createElement("input", {
        type: this.props.type,
        min: this.props.min,
        max: this.props.max,
        className: "textfield",
        placeholder: placeholder,
        tabIndex: 0,
        onChange: function onChange(e) {
          return _this2.valueUpdated(e);
        },
        onKeyDown: this._handleKeyDown,
        value: value,
        disabled: disabled,
        id: id,
        maxLength: maxLength,
        name: name,
        autoComplete: this.props.autocomplete,
        onBlur: function onBlur(e) {
          _this2.onTouchEvent();

          _this2.inputBlurred(e);
        }
      }), (this.state.dirty && isRequired && this.state.text.length <= 0 || hasError) && /*#__PURE__*/React__default.createElement(Icon, {
        name: "info",
        color: errorMessageColor || "red",
        width: 20,
        height: 20
      }), inputUnit && /*#__PURE__*/React__default.createElement("span", {
        className: "inputUnit"
      }, inputUnit), isCheckmark && /*#__PURE__*/React__default.createElement("span", {
        style: {
          cursor: "pointer"
        },
        onClick: function onClick(e) {
          return _this2.iconClick(e);
        }
      }, /*#__PURE__*/React__default.createElement(MemoSvgCheck, null))), /*#__PURE__*/React__default.createElement("span", null, (this.state.dirty && isRequired && this.state.text.length <= 0 || hasError) && /*#__PURE__*/React__default.createElement("div", {
        className: "errorWrapper",
        color: errorMessageColor
      }, /*#__PURE__*/React__default.createElement("span", null, errorMessage)) || null));
    }
  }]);

  return TextField;
}(Component);

TextField$2.defaultProps = {
  errorMessage: "Required",
  isRequired: false,
  label: "",
  hasError: false,
  placeholder: "",
  type: "text",
  autocomplete: "new-password",
  maxLength: 99999,
  errorMessageColor: "#EA6767"
};
TextField$2.propTypes = {
  type: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  change: PropTypes.func,
  onIconClick: PropTypes.func,
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  maxLength: PropTypes.number,
  isRequired: PropTypes.bool,
  errorMessage: PropTypes.string,
  blur: PropTypes.func,
  hasError: PropTypes.bool,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
  errorMessageColor: PropTypes.string,
  color: PropTypes.string,
  mask: PropTypes.string,
  inputUnit: PropTypes.string,
  isCheckmark: PropTypes.bool,
  isSelectionBox: PropTypes.bool,
  onKeyDown: PropTypes.func
};
var TextField$3 = /*#__PURE__*/React__default.memo(TextField$2);

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PassiveSearchField = function PassiveSearchField(props) {
  var remainProps = _objectSpread$e({}, props);

  delete remainProps.symbol;
  delete remainProps.change;
  delete remainProps.value;

  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      userQuery = _useState2[0],
      setUserQuery = _useState2[1];

  var delayedQuery = useRef(_.debounce(function (q) {
    return sendQuery(q);
  }, 500)).current;

  var sendQuery = function sendQuery(query) {
    props.change(query);
  };

  var onChange = function onChange(e) {
    setUserQuery(e);
    delayedQuery(e);
  };

  var clearText = function clearText() {
    setUserQuery("");
    props.change("");
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "search_field_wrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "search_icon_search_field"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "search_icon",
    width: 17,
    height: 17,
    color: "#979797"
  })), /*#__PURE__*/React__default.createElement(TextField$3, _extends$4({
    value: userQuery,
    change: onChange
  }, remainProps)), userQuery && /*#__PURE__*/React__default.createElement("span", {
    className: "clearButton",
    onClick: clearText
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "close",
    width: 10,
    height: 10,
    color: "#979797"
  })));
};

PassiveSearchField.propTypes = {
  symbol: PropTypes.string,
  change: PropTypes.func.isRequired
};
var PassiveSearchField$1 = /*#__PURE__*/React__default.memo(PassiveSearchField);

var css_248z$t = ".toggle_wrapper {\n  display: flex;\n  border: transparent;\n  border-radius: 31px;\n  position: relative;\n  background: #fff;\n  box-sizing: border-box;\n  height: 32px;\n  font-size: 14px;\n  cursor: pointer;\n  line-height: 29px;\n  width: 158px; }\n  .toggle_wrapper span {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n    text-transform: capitalize;\n    flex-direction: row;\n    width: 85px; }\n\nspan.on {\n  border: solid 1px #04D2C6;\n  border-radius: 31px;\n  width: 85px;\n  background: #04D2C6;\n  color: white;\n  float: left;\n  font-weight: 700; }\n\nspan.off {\n  border: solid 1px #333333;\n  border-radius: 31px;\n  width: 85px;\n  background: #333333;\n  color: white;\n  float: right;\n  font-weight: 700; }\n";
styleInject(css_248z$t);

var Toggle = function Toggle(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "toggle_wrapper",
    onClick: function onClick() {
      return props.onChange();
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: props.on && "on" || ""
  }, props.onText), /*#__PURE__*/React__default.createElement("span", {
    className: props.off && "off" || ""
  }, props.offText));
};

Toggle.defaultProps = {
  on: false,
  off: false,
  onText: "on",
  offText: "off"
};
Toggle.propTypes = {
  on: PropTypes.bool,
  off: PropTypes.bool,
  onText: PropTypes.string,
  offText: PropTypes.string,
  onChange: PropTypes.func
};
var Toggle$1 = /*#__PURE__*/React__default.memo(Toggle);

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$n(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$n(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var _bedroomFilter = [{
  name: "Studio",
  label: "Studio",
  value: 0,
  isSelected: false
}, {
  name: "1",
  label: "1 BR",
  value: 1,
  isSelected: false
}, {
  name: "2",
  label: "2 BR",
  value: 2,
  isSelected: false
}, {
  name: "3",
  label: "3 BR",
  value: 3,
  isSelected: false
}, {
  name: "4+",
  label: "4+ BR",
  value: 4,
  isSelected: false
}];
var _bathroomFilter = [{
  name: "1",
  label: "1 BA",
  value: 1,
  isSelected: false
}, {
  name: "2",
  label: "2 BA",
  value: 2,
  isSelected: false
}, {
  name: "3",
  label: "3 BA",
  value: 3,
  isSelected: false
}, {
  name: "4+",
  label: "4+ BA",
  value: 4,
  isSelected: false
}];
var _amenitySelectionList = [{
  name: "Dishwasher",
  isSelected: false
}, {
  name: "Laundry in unit",
  isSelected: false
}, {
  name: "Outdoor space",
  isSelected: false
}, {
  name: "Furnished",
  isSelected: false
}, {
  name: "Doorman",
  isSelected: false
}, {
  name: "Elevator",
  isSelected: false
}, {
  name: "Gym",
  isSelected: false
}, {
  name: "Laundry in building",
  isSelected: false
}, {
  name: "Pets allowed",
  isSelected: false
}];

var DataList = /*#__PURE__*/function (_Component) {
  _inherits$1(DataList, _Component);

  var _super = _createSuper$n(DataList);

  function DataList(props) {
    var _this;

    _classCallCheck$1(this, DataList);

    _this = _super.call(this, props);
    _this.state = {
      filterState: {},
      inlineUpdate: 0,
      oldParentUpdateStateValue: undefined,
      bedRoomFilter: _bedroomFilter,
      bathRoomFilter: _bathroomFilter,
      amenitiesFilter: _amenitySelectionList,
      minRent: 0,
      maxRent: 10000,
      isSalesListings: false,
      isRentalListingsSelected: false,
      filterPositionX: 0,
      filterPositionY: 0,
      isCompleteListings: false
    };
    _this.getDataWithFilter = _this.getDataWithFilter.bind(_assertThisInitialized$3(_this));
    _this.getAllFilter = _this.getAllFilter.bind(_assertThisInitialized$3(_this));
    _this.getLayoutFilter = _this.getLayoutFilter.bind(_assertThisInitialized$3(_this));
    _this.renderBannerRentFilter = _this.renderBannerRentFilter.bind(_assertThisInitialized$3(_this));
    _this.clearRentFilter = _this.clearRentFilter.bind(_assertThisInitialized$3(_this));
    _this.clearLayoutFilter = _this.clearLayoutFilter.bind(_assertThisInitialized$3(_this));
    _this.renderAmenitiesFilter = _this.renderAmenitiesFilter.bind(_assertThisInitialized$3(_this));
    _this.clearAmenityFilter = _this.clearAmenityFilter.bind(_assertThisInitialized$3(_this));
    _this.toggleFilterPosition = _this.toggleFilterPosition.bind(_assertThisInitialized$3(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(DataList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("scroll", this.handleScroll);
      this.setState({
        filterState: {},
        inlineUpdate: 0,
        oldParentUpdateStateValue: undefined,
        bedRoomFilter: _bedroomFilter.map(function (element) {
          return _objectSpread$d(_objectSpread$d({}, element), {}, {
            isSelected: false
          });
        }),
        bathRoomFilter: _bathroomFilter.map(function (element) {
          return _objectSpread$d(_objectSpread$d({}, element), {}, {
            isSelected: false
          });
        }),
        amenitiesFilter: _amenitySelectionList.map(function (element) {
          return _objectSpread$d(_objectSpread$d({}, element), {}, {
            isSelected: false
          });
        }),
        minRent: 0,
        maxRent: 10000,
        isSalesListings: true,
        isRentalListingsSelected: true,
        filterPositionX: 0,
        filterPositionY: 0
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      var body = document.getElementsByTagName("body");
      body[0].removeEventListener("click", function (e) {
        _this2.setState({
          showListingsFilter: false
        });

        e.preventDefault();
        e.stopPropagation();
      });
      document.removeEventListener("scroll", this.handleScroll);
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      this.setState({
        showListingsFilter: false
      });
    }
  }, {
    key: "getDataWithFilter",
    value: function getDataWithFilter(options) {
      options.is_complete_listing = this.state.isCompleteListings;
      return this.props.getData(options, this.state.filterState);
    }
  }, {
    key: "clearRentFilter",
    value: function clearRentFilter() {
      var filterObject = _objectSpread$d({}, this.state.filterState);

      delete filterObject.budget;
      this.setState({
        minRent: 0,
        maxRent: 10000,
        inlineUpdate: this.state.inlineUpdate + 1,
        filterState: filterObject,
        showListingsFilter: false
      });
    }
  }, {
    key: "renderBannerRentFilter",
    value: function renderBannerRentFilter() {
      var _this3 = this;

      return (this.state.minRent > 0 || this.state.maxRent < 10000) && /*#__PURE__*/React__default.createElement(Tooltip$1, {
        enterDelay: 500,
        leaveDelay: 200,
        title: "$".concat(this.state.minRent, " -  $").concat(this.state.maxRent),
        placement: "top-start"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "_filter_capsul_ui"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Price:"), /*#__PURE__*/React__default.createElement("span", {
        className: "selection_filter_ui"
      }, "".concat(API.numFormatter(this.state.minRent), " - ").concat(API.numFormatter(this.state.maxRent))), /*#__PURE__*/React__default.createElement("span", {
        onClick: function onClick() {
          return _this3.clearRentFilter();
        }
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "close",
        width: 15,
        height: 8,
        color: "#000"
      })))) || null;
    }
  }, {
    key: "renderAmenitiesFilter",
    value: function renderAmenitiesFilter() {
      var _this4 = this;

      var amenities = this.state.amenitiesFilter.filter(function (e) {
        return e.isSelected;
      }).map(function (e) {
        return e.name;
      });
      return amenities.length && /*#__PURE__*/React__default.createElement(Tooltip$1, {
        enterDelay: 500,
        leaveDelay: 200,
        title: amenities.join(","),
        placement: "top-start"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "_filter_capsul_ui"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Amenities:"), /*#__PURE__*/React__default.createElement("span", {
        className: "selection_filter_ui"
      }, amenities.join(",")), /*#__PURE__*/React__default.createElement("span", {
        onClick: function onClick() {
          return _this4.clearAmenityFilter();
        }
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "close",
        width: 15,
        height: 8,
        color: "#000"
      })))) || null;
    }
  }, {
    key: "clearAmenityFilter",
    value: function clearAmenityFilter() {
      var filterState = _objectSpread$d({}, this.state.filterState);

      delete filterState.amenities;

      var filterAmenities = _toConsumableArray$1(this.state.amenitiesFilter).map(function (amenity) {
        return _objectSpread$d(_objectSpread$d({}, amenity), {}, {
          isSelected: false
        });
      });

      this.setState({
        amenitiesFilter: filterAmenities,
        filterState: filterState,
        inlineUpdate: this.state.inlineUpdate + 1,
        showListingsFilter: false
      });
    }
  }, {
    key: "getAllFilter",
    value: function getAllFilter(filterState) {
      var filterObject = {};
      var bedRoomUnitMin = filterState.bedRoomFilter.findIndex(function (arrayElement) {
        return arrayElement.isSelected;
      });
      var bedRoomUnitMax = filterState.bedRoomFilter.length - 1 - filterState.bedRoomFilter.slice().reverse().findIndex(function (o) {
        return o.isSelected;
      });
      filterObject.bedroom_unit = {
        min: bedRoomUnitMin !== -1 ? bedRoomUnitMin : 0,
        max: bedRoomUnitMax !== -1 ? bedRoomUnitMax === 4 ? 9 : bedRoomUnitMax : 9
      };

      if (bedRoomUnitMin === -1) {
        delete filterObject.bedroom_unit;
      }

      var bathRoomUnitMin = filterState.bathRoomFilter.findIndex(function (arrayElement) {
        return arrayElement.isSelected;
      });
      var bathRoomUnitMax = filterState.bathRoomFilter.length - 1 - filterState.bathRoomFilter.slice().reverse().findIndex(function (o) {
        return o.isSelected;
      });
      filterObject.bathroom_unit = {
        min: bathRoomUnitMin !== -1 && bathRoomUnitMin + 1 || 0,
        max: bathRoomUnitMax !== -1 && (bathRoomUnitMax + 1 === 4 ? 9 : bedRoomUnitMax) || 9
      };

      if (bathRoomUnitMin === -1) {
        delete filterObject.bathroom_unit;
      }

      filterObject.budget = {
        min: filterState.minRent || 0,
        max: filterState.maxRent || 5000
      };

      if (filterState.minRent === 0 && filterState.maxRent === 5000) {
        delete filterState.budget;
      }

      filterObject.amenities = filterState.amenities.filter(function (e) {
        return e.isSelected;
      }).map(function (e) {
        return e.name.split(" ").map(function (str) {
          return str.charAt(0).toUpperCase() + str.slice(1);
        }).join(" ");
      });

      if (filterState.isRentalListingsSelected) {
        filterObject.is_sales_listing = false;
      }

      if (filterState.isSalesListings) {
        filterObject.is_sales_listing = true;
      }

      if (filterState.isSalesListings === filterState.isRentalListingsSelected) {
        delete filterObject.is_sales_listing;
      }

      var newInlineUpdate = this.state.inlineUpdate + 1;
      this.setState(_objectSpread$d({
        filterState: filterObject,
        inlineUpdate: newInlineUpdate,
        amenitiesFilter: filterState.amenities,
        isRentalListingsSelected: filterState.isRentalListingsSelected,
        isSalesListings: filterState.isSalesListings
      }, filterState));
    }
  }, {
    key: "clearLayoutFilter",
    value: function clearLayoutFilter() {
      var _filterState = _objectSpread$d({}, this.state.filterState);

      delete _filterState.bedroom_unit;
      delete _filterState.bathroom_unit;
      this.setState({
        bedRoomFilter: _bedroomFilter.map(function (element) {
          return _objectSpread$d(_objectSpread$d({}, element), {}, {
            isSelected: false
          });
        }),
        bathRoomFilter: _bathroomFilter.map(function (element) {
          return _objectSpread$d(_objectSpread$d({}, element), {}, {
            isSelected: false
          });
        }),
        inlineUpdate: this.state.inlineUpdate + 1,
        filterState: _filterState,
        showListingsFilter: false
      });
    }
  }, {
    key: "getLayoutFilter",
    value: function getLayoutFilter() {
      var _this5 = this;

      var bedRoomSelected = this.state.bedRoomFilter.filter(function (e) {
        return e.isSelected;
      }).map(function (element) {
        return element.label;
      });
      var bathRoomSelected = this.state.bathRoomFilter.filter(function (e) {
        return e.isSelected;
      }).map(function (element) {
        return element.label;
      });
      var totalSelection = [].concat(_toConsumableArray$1(bedRoomSelected), _toConsumableArray$1(bathRoomSelected));
      return totalSelection.length && /*#__PURE__*/React__default.createElement(Tooltip$1, {
        enterDelay: 500,
        leaveDelay: 200,
        title: totalSelection.join(","),
        placement: "top-start"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "_filter_capsul_ui"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Layout:"), /*#__PURE__*/React__default.createElement("span", {
        className: "selection_filter_ui"
      }, totalSelection.map(function (selection, index) {
        return /*#__PURE__*/React__default.createElement("span", {
          key: index
        }, selection, index < totalSelection.length - 1 && ", ");
      })), /*#__PURE__*/React__default.createElement("span", {
        onClick: function onClick() {
          return _this5.clearLayoutFilter();
        }
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "close",
        width: 15,
        height: 8,
        color: "#000"
      })))) || null;
    }
  }, {
    key: "toggleFilterPosition",
    value: function toggleFilterPosition(event) {
      event.stopPropagation();
      event.preventDefault();
      var isAtBottom = event.currentTarget.getBoundingClientRect().y + 500 > window.screen.height;
      var yPoistion = event.currentTarget.getBoundingClientRect().y + 40;

      if (isAtBottom) {
        yPoistion = event.currentTarget.getBoundingClientRect().y - 400;
      }

      this.setState({
        showListingsFilter: !this.state.showListingsFilter,
        filterPositionX: event.currentTarget.getBoundingClientRect().x,
        filterPositionY: yPoistion
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var remainingProps = _objectSpread$d({}, this.props);

      delete remainingProps.getData;
      delete remainingProps.updateList;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, this.props.showListHeader && /*#__PURE__*/React__default.createElement("div", {
        className: "list_header"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "button_title_wrapper_datalist"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "caption_container"
      }, /*#__PURE__*/React__default.createElement("span", null, this.props.caption), this.props.ListingsFilterForShowFullListing && /*#__PURE__*/React__default.createElement("div", {
        className: "toggle_vitual_tour"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "hide_virtual_tour"
      }, "Hide listings without virtual tours"), /*#__PURE__*/React__default.createElement("div", {
        className: "toggle_listings " + (!this.state.isCompleteListings ? "on_clr" : "off_clr")
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "container"
      }, /*#__PURE__*/React__default.createElement(Toggle$1, {
        onText: "",
        offText: "",
        on: !this.state.isCompleteListings,
        off: this.state.isCompleteListings,
        onChange: function onChange() {
          return _this6.setState({
            isCompleteListings: !_this6.state.isCompleteListings,
            inlineUpdate: _this6.state.inlineUpdate + 1
          });
        }
      }))))), /*#__PURE__*/React__default.createElement(Button$2, {
        color: "#1D1C38",
        textColor: "#fff",
        label: this.props.buttonLabel,
        onClick: function onClick() {
          return _this6.props.onActionButtonClick();
        }
      }))), this.props.showListingsFilter && /*#__PURE__*/React__default.createElement("div", {
        className: "filters_list"
      }, /*#__PURE__*/React__default.createElement(PassiveSearchField$1, {
        change: function change(value) {
          return _this6.setState({
            filterState: _objectSpread$d(_objectSpread$d({}, _this6.state.filterState), {}, {
              search_key: value
            }),
            inlineUpdate: _this6.state.inlineUpdate + 1
          });
        },
        value: this.state.filterState.search_key,
        placeholder: "Search"
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "_filter_capsul_ui",
        onClick: function onClick(e) {
          return _this6.toggleFilterPosition(e);
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "Filter"), this.state.showListingsFilter && /*#__PURE__*/React__default.createElement(Icon, {
        name: "upArrow",
        color: "#000",
        width: 12,
        height: 8
      }) || /*#__PURE__*/React__default.createElement(Icon, {
        name: "downArrow",
        color: "#000",
        width: 12,
        height: 8
      })), this.getLayoutFilter(), this.renderBannerRentFilter(), this.renderAmenitiesFilter()) || null, this.props.showListingsFilter && this.state.showListingsFilter && /*#__PURE__*/React__default.createElement("div", {
        style: {
          top: this.state.filterPositionY,
          left: this.state.filterPositionX,
          position: "fixed",
          zIndex: 1
        }
      }, /*#__PURE__*/React__default.createElement(ListingsFilterPlugin, {
        getAllFilter: this.getAllFilter,
        bedRoomFilter: this.state.bedRoomFilter,
        bathRoomFilter: this.state.bathRoomFilter,
        minRent: this.state.minRent,
        maxRent: this.state.maxRent,
        amenities: this.state.amenitiesFilter,
        isSalesListings: this.state.isSalesListings,
        isRentalListingsSelected: this.state.isRentalListingsSelected,
        closePopup: function closePopup() {
          return _this6.setState({
            showListingsFilter: false
          });
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "datalist_Wrapper_component_filter",
        style: {
          marginTop: this.props.showListHeader && "30px" || 0
        }
      }, /*#__PURE__*/React__default.createElement(Grid, _extends$4({
        updateList: this.state.inlineUpdate + this.state.oldParentUpdateStateValue,
        getData: this.getDataWithFilter
      }, remainingProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.oldParentUpdateStateValue === undefined || prevState.oldParentUpdateStateValue !== nextProps.updateList) {
        return {
          oldParentUpdateStateValue: nextProps.updateList || 0
        };
      }

      return null;
    }
  }]);

  return DataList;
}(Component);

DataList.defaultProps = {
  showListHeader: true,
  showListingsFilter: false,
  buttonLabel: "See all",
  ListingsFilterForShowFullListing: false
};
DataList.propTypes = {
  caption: PropTypes.string,
  getData: PropTypes.func.isRequired,
  showListHeader: PropTypes.bool,
  updateList: PropTypes.number,
  onActionButtonClick: PropTypes.func,
  showListingsFilter: PropTypes.bool,
  buttonLabel: PropTypes.string,
  ListingsFilterForShowFullListing: PropTypes.bool
};
var DataList$1 = /*#__PURE__*/React__default.memo(DataList);

var css_248z$s = ".dropDownIcon {\n  padding: 2px 10px;\n  pointer-events: none; }\n  .dropDownIcon span {\n    position: relative;\n    top: 3px; }\n  .dropDownIcon:focus {\n    box-shadow: 0px 0px 11px #fff !important;\n    border: solid 2px #02d4c6 !important;\n    outline: 0;\n    border-radius: 6px !important;\n    -webkit-transition: border .10s ease-in-out;\n    transition: border .10s ease-in-out;\n    padding: 2px 10px;\n    line-height: 19px; }\n\n.pointer_all {\n  pointer-events: all; }\n\n.fade-appear {\n  opacity: 0.2;\n  z-index: -1; }\n\n.fade-appear .fade-appear-active {\n  opacity: 1;\n  transition: opacity 4000 ease-out; }\n";
styleInject(css_248z$s);

var uaParser_min = createCommonjsModule(function (module, exports) {
/* UAParser.js v0.7.31
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined$1){var LIBVERSION="0.7.31",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=255;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i]);}else {mergedRegexes[i]=regexes[i];}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i];}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined$1},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY).replace(/\s\s*$/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match);}else {this[q[0]]=q[1];}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined$1;}else {this[q[0]]=match?match.replace(q[1],q[2]):undefined$1;}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined$1;}}else {this[q]=match?match:undefined$1;}}}}i+=2;}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined$1:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined$1:i}}return str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,/(ba?idubrowser)[\/ ]?([\w\.]+)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/\bqbcore\/([\w\.]+)/i],[VERSION,[NAME,"WeChat(Win) Desktop"]],[/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/yabrowser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360 "+BROWSER]],[/(oculus|samsung|sailfish)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 "+BROWSER],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(metasr)[\/ ]?([\w\.]+)/i,/(lbbrowser)/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(chromium|instagram)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/\((ip(?:hone|od)[\w ]*);/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+)(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[12]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( 2)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows) nt 6\.2; (arm)/i,/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,/(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,strMapper,windowsVersionMap]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+ ([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined$1;}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _ua=ua||(typeof window!==UNDEF_TYPE&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var _rgxmap=extensions?extend(regexes,extensions):regexes;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined$1;_browser[VERSION]=undefined$1;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser.major=majorize(_browser.version);return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined$1;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined$1;_device[MODEL]=undefined$1;_device[TYPE]=undefined$1;rgxMapper.call(_device,_ua,_rgxmap.device);return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined$1;_engine[VERSION]=undefined$1;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined$1;_os[VERSION]=undefined$1;rgxMapper.call(_os,_ua,_rgxmap.os);return _os};this.getResult=function(){return {ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);{if(module.exports){exports=module.exports=UAParser;}exports.UAParser=UAParser;}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop];}};}})(typeof window==="object"?window:commonjsGlobal);
});
uaParser_min.UAParser;

var main = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }


var React__default$1 = _interopDefault(React__default);



var UA = new uaParser_min();
var browser = UA.getBrowser();
UA.getCPU();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();

var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: 'IE',
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};
var checkType = function checkType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    default:
      return initialData;
  }
};
var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

var type = checkType(device.type);

function deviceDetect() {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return broPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return stvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearPayload(isWearable, engine, os, ua);
  }
}

var isMobileType = function isMobileType() {
  return device.type === DeviceTypes.Mobile;
};

var isTabletType = function isTabletType() {
  return device.type === DeviceTypes.Tablet;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (device.type) {
    case DeviceTypes.Mobile:
    case DeviceTypes.Tablet:
      return true;

    default:
      return false;
  }
};

var isEdgeChromiumType = function isEdgeChromiumType() {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};

var isSmartTVType = function isSmartTVType() {
  return device.type === DeviceTypes.SmartTv;
};

var isBrowserType = function isBrowserType() {
  return device.type === DeviceTypes.Browser;
};

var isWearableType = function isWearableType() {
  return device.type === DeviceTypes.Wearable;
};

var isConsoleType = function isConsoleType() {
  return device.type === DeviceTypes.Console;
};

var isAndroidType = function isAndroidType() {
  return os.name === OsTypes.Android;
};

var isWindowsType = function isWindowsType() {
  return os.name === OsTypes.Windows;
};

var isMacOsType = function isMacOsType() {
  return os.name === OsTypes.MAC_OS;
};

var isWinPhoneType = function isWinPhoneType() {
  return os.name === OsTypes.WindowsPhone;
};

var isIOSType = function isIOSType() {
  return os.name === OsTypes.IOS;
};

var isChromeType = function isChromeType() {
  return browser.name === BrowserTypes.Chrome;
};

var isFirefoxType = function isFirefoxType() {
  return browser.name === BrowserTypes.Firefox;
};

var isChromiumType = function isChromiumType() {
  return browser.name === BrowserTypes.Chromium;
};

var isEdgeType = function isEdgeType() {
  return browser.name === BrowserTypes.Edge;
};

var isYandexType = function isYandexType() {
  return browser.name === BrowserTypes.Yandex;
};

var isSafariType = function isSafariType() {
  return browser.name === BrowserTypes.Safari || browser.name === BrowserTypes.MobileSafari;
};

var isMobileSafariType = function isMobileSafariType() {
  return browser.name === BrowserTypes.MobileSafari;
};

var isOperaType = function isOperaType() {
  return browser.name === BrowserTypes.Opera;
};

var isIEType = function isIEType() {
  return browser.name === BrowserTypes.InternetExplorer || browser.name === BrowserTypes.Ie;
};

var isMIUIType = function isMIUIType() {
  return browser.name === BrowserTypes.MIUI;
};

var isSamsungBrowserType = function isSamsungBrowserType() {
  return browser.name === BrowserTypes.SamsungBrowser;
};

var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};

var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};

var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};

var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};

var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return setDefaults(browser.version);
};

var getBrowserVersion = function getBrowserVersion() {
  return setDefaults(browser.major);
};

var getOsVersion = function getOsVersion() {
  return setDefaults(os.version);
};

var getOsName = function getOsName() {
  return setDefaults(os.name);
};

var getBrowserName = function getBrowserName() {
  return setDefaults(browser.name);
};

var getMobileVendor = function getMobileVendor() {
  return setDefaults(device.vendor);
};

var getMobileModel = function getMobileModel() {
  return setDefaults(device.model);
};

var getEngineName = function getEngineName() {
  return setDefaults(engine.name);
};

var getEngineVersion = function getEngineVersion() {
  return setDefaults(engine.version);
};

var getUseragent = function getUseragent() {
  return setDefaults(ua);
};

var getDeviceType = function getDeviceType() {
  return setDefaults(device.type, 'browser');
};

var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType() || getIPad13();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType() || getIPad13();
var isMobileOnly = isMobileType();
var isTablet = isTabletType() || getIPad13();
var isBrowser = isBrowserType();
var isDesktop = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType() || getIPad13();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType() || isEdgeChromiumType();
var isYandex = isYandexType();
var deviceType = getDeviceType();
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType();
var isLegacyEdge = isEdgeType() && !isEdgeChromiumType();
var isWindows = isWindowsType();
var isMacOs = isMacOsType();
var isMIUI = isMIUIType();
var isSamsungBrowser = isSamsungBrowserType();

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isAndroid ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isBrowser ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIE ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIOS ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobile ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isTablet ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWinPhone ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isSmartTV ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isConsole ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWearable ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default$1.createElement(React__default.Fragment, null, children) : React__default$1.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};

function withOrientationChange(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default$1.createElement(WrappedComponent, _extends({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);

      return _class;
    }(React__default$1.Component)
  );
}

exports.AndroidView = AndroidView;
exports.BrowserTypes = BrowserTypes;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.OsTypes = OsTypes;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isDesktop = isDesktop;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMIUI = isMIUI;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSamsungBrowser = isSamsungBrowser;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.withOrientationChange = withOrientationChange;
});

unwrapExports(main);
main.AndroidView;
main.BrowserTypes;
main.BrowserView;
main.ConsoleView;
main.CustomView;
main.IEView;
main.IOSView;
main.MobileOnlyView;
main.MobileView;
main.OsTypes;
main.SmartTVView;
main.TabletView;
main.WearableView;
main.WinPhoneView;
main.browserName;
main.browserVersion;
main.deviceDetect;
main.deviceType;
main.engineName;
main.engineVersion;
main.fullBrowserVersion;
main.getUA;
main.isAndroid;
main.isBrowser;
main.isChrome;
main.isChromium;
main.isConsole;
main.isDesktop;
main.isEdge;
main.isEdgeChromium;
main.isElectron;
main.isFirefox;
main.isIE;
main.isIOS;
main.isIOS13;
main.isIPad13;
main.isIPhone13;
main.isIPod13;
main.isLegacyEdge;
main.isMIUI;
main.isMacOs;
var main_42 = main.isMobile;
main.isMobileOnly;
main.isMobileSafari;
main.isOpera;
main.isSafari;
main.isSamsungBrowser;
main.isSmartTV;
main.isTablet;
main.isWearable;
main.isWinPhone;
main.isWindows;
main.isYandex;
main.mobileModel;
main.mobileVendor;
main.osName;
main.osVersion;
main.withOrientationChange;

function navigate(element) {
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "next";
  var parent = element && element.parentNode;
  var children = parent && parent.children && Array.from(parent.children);
  var currentIndex = children.indexOf(element);

  if (currentIndex !== -1) {
    if (direction === "next") {
      // check if there is any next available element
      if (currentIndex < children.length - 1) {
        var newFocusable = children[parseInt(currentIndex + 1)];
        newFocusable && newFocusable.focus();
      }
    } else if (direction === "back") {
      if (currentIndex > 0) {
        var _newFocusable = children[parseInt(currentIndex - 1)];
        _newFocusable && _newFocusable.focus();
      }
    }
  }
}

function _createSuper$m(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Accordion = /*#__PURE__*/function (_Component) {
  _inherits$1(Accordion, _Component);

  var _super = _createSuper$m(Accordion);

  function Accordion(props) {
    var _this;

    _classCallCheck$1(this, Accordion);

    _this = _super.call(this, props);
    _this.childrenRef = /*#__PURE__*/createRef();
    _this.state = {
      showChildren: props.showExpandedView
    };
    _this.switchView = _this.switchView.bind(_assertThisInitialized$3(_this));
    _this.switchOnEnterKey = _this.switchOnEnterKey.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(Accordion, [{
    key: "switchView",
    value: function switchView(e) {
      this.props.CallBackOnExpandClick && this.props.CallBackOnExpandClick(e);

      if (!this.props.CallBackOnExpandClick) {
        this.setState({
          showChildren: !this.state.showChildren
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.children) this.childrenRef && this.childrenRef.current && this.childrenRef.current.focus();
    }
  }, {
    key: "switchOnEnterKey",
    value: function switchOnEnterKey(e) {
      e.keyCode === 40 && navigate(e.currentTarget, "next");
      e.keyCode === 38 && navigate(e.currentTarget, "back");
      if (e.keyCode === 13 || e.keyCode === 39 || e.keyCode === 37 && this.state.showChildren) this.switchView(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: this.props.headerClassName,
        onClick: function onClick(e) {
          return _this2.props.CallBackOnExpandClick(e);
        }
      }, this.props.showExpander === "left" && /*#__PURE__*/React__default.createElement("span", {
        "aria-label": "Expand or Collapse",
        className: "dropDownIcon",
        "aria-hidden": true,
        tabIndex: 0,
        onKeyUp: function onKeyUp(e) {
          return _this2.switchOnEnterKey(e);
        }
      }, /*#__PURE__*/React__default.createElement("i", {
        onClick: function onClick(e, index) {
          return _this2.switchView(index);
        },
        className: "mouse_clicker",
        tabIndex: -1
      }, this.state.showChildren && /*#__PURE__*/React__default.createElement(Icon, {
        name: "downArrow",
        color: !this.props.isCustomIconColor && (main_42 && "#383838" || "#fff") || this.props.customIconColor
      }) || /*#__PURE__*/React__default.createElement(Icon, {
        name: "rightArrow",
        color: !this.props.isCustomIconColor && (main_42 && "#383838" || "#fff") || this.props.customIconColor
      }))), this.props.children[0], this.props.showExpander === "right" && /*#__PURE__*/React__default.createElement("span", {
        "aria-label": "Expand or Collapse",
        tabIndex: 0,
        className: "dropDownIcon",
        "aria-hidden": true,
        onKeyUp: function onKeyUp(e) {
          return _this2.switchOnEnterKey(e);
        }
      }, /*#__PURE__*/React__default.createElement("i", {
        onClick: function onClick(e, index) {
          return _this2.switchView(index);
        },
        className: "mouse_clicker",
        tabIndex: -1
      }, this.state.showChildren && /*#__PURE__*/React__default.createElement(Icon, {
        name: "downArrow",
        color: !this.props.isCustomIconColor && (main_42 && "#383838" || "#fff") || this.props.customIconColor
      }) || /*#__PURE__*/React__default.createElement(Icon, {
        name: "rightArrow",
        color: !this.props.isCustomIconColor && (main_42 && "#383838" || "#fff") || this.props.customIconColor
      }))), this.props.hasGear && /*#__PURE__*/React__default.createElement("span", {
        "aria-label": "actionable click",
        tabIndex: 0,
        className: "dropDownIcon pointer_all",
        "aria-hidden": true,
        onClick: function onClick(e) {
          return _this2.props.settingsView(e);
        }
      }, /*#__PURE__*/React__default.createElement("i", {
        className: "mouse_clicker",
        tabIndex: -1
      }, /*#__PURE__*/React__default.createElement(Icon, {
        color: !this.props.isCustomIconColor && (main_42 && "#383838" || "#fff") || this.props.customIconColor,
        name: "gear"
      }))) || null, this.props.hasSpread && /*#__PURE__*/React__default.createElement("span", {
        "aria-label": "actionable click",
        tabIndex: 0,
        className: "dropDownIcon pointer_all",
        "aria-hidden": true,
        onClick: function onClick(e) {
          return _this2.props.settingsView(e);
        }
      }, /*#__PURE__*/React__default.createElement("i", {
        className: "mouse_clicker",
        tabIndex: -1
      }, /*#__PURE__*/React__default.createElement(Icon, {
        color: !this.props.isCustomIconColor && (main_42 && "#383838" || "#fff") || this.props.customIconColor,
        name: "spread"
      }))) || null), this.state.showChildren && /*#__PURE__*/React__default.createElement("div", {
        style: {
          outline: 0
        },
        className: "accordion_children",
        tabIndex: -1,
        ref: this.childrenRef
      }, /*#__PURE__*/React__default.createElement(CSSTransition$1, {
        "in": true,
        appear: true,
        timeout: 300,
        classNames: "fade"
      }, this.props.children[1])));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (typeof props.CallBackOnExpandClick === "function" && props.showExpandedView !== state.showChildren) return {
        showChildren: props.showExpandedView
      };else return null;
    }
  }]);

  return Accordion;
}(Component);

Accordion.defaultProps = {
  showExpander: "right",
  showExpandedView: false,
  hasGear: false
};
Accordion.propTypes = {
  children: PropTypes.array,
  showExpander: PropTypes.oneOf(["left", "right"]),
  headerClassName: PropTypes.string,
  showExpandedView: PropTypes.bool,
  hasGear: PropTypes.bool,
  CallBackOnExpandClick: PropTypes.func,
  isCustomIconColor: PropTypes.bool,
  customIconColor: PropTypes.string,
  settingsView: PropTypes.func,
  onClickAccordion: PropTypes.func,
  hasSpread: PropTypes.bool
};

var ActionMenu = function ActionMenu(_ref) {
  var options = _ref.options,
      clickEvent = _ref.clickEvent,
      toggle = _ref.toggle;
  var OPTION_ROW_HEIGHT = 32;
  var OPTION_ROW_WIDTH = 200;

  var _useState = useState(null),
      _useState2 = _slicedToArray$1(_useState, 2),
      xp = _useState2[0],
      setXp = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      yp = _useState4[0],
      setYp = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$1(_useState5, 2),
      isMenuVisible = _useState6[0],
      setIsMenuVisible = _useState6[1];

  useEffect(function () {
    if (clickEvent && clickEvent.target) {
      var clientX = clickEvent.clientX,
          clientY = clickEvent.clientY;
      var immediateParent = upTo(clickEvent.target, "span");
      var element = upTo(clickEvent.target, "div");

      if (element) {
        var _element$getBoundingC = element.getBoundingClientRect(),
            x = _element$getBoundingC.x,
            y = _element$getBoundingC.y,
            width = _element$getBoundingC.width,
            height = _element$getBoundingC.height; // calculate position of rectangle in tbody


        var x1 = x;
        var x2 = x1 + width; // const x3 = x2;
        // const x4 = x1;

        var y1 = y;
        var y2 = y1;
        var y3 = y1 + height;
        var y4 = y3;

        if (clientX < x2 - OPTION_ROW_WIDTH && clientX >= x1 && clientY >= y2 && clientY < y3 - options.length * OPTION_ROW_HEIGHT) {
          setXp(clientX + 10);
          setYp(clientY); // setShowOptions(true);
        } else if (clientX > x1 + OPTION_ROW_WIDTH && clientX + OPTION_ROW_WIDTH > x2 && clientY >= y2 && clientY <= y3 - options.length * OPTION_ROW_HEIGHT) {
          if (immediateParent) {
            var _immediateParent$getB = immediateParent.getBoundingClientRect(),
                _width = _immediateParent$getB.width;

            setXp(clientX - OPTION_ROW_WIDTH - _width + 10);
          } else {
            setXp(clientX - OPTION_ROW_WIDTH + 10);
          }

          setYp(clientY); // setShowOptions(true);
        } else if (clientX + OPTION_ROW_WIDTH <= x2 && clientX >= x1 && clientY >= y1 && clientY + options.length * OPTION_ROW_HEIGHT >= y4) {
          setXp(clientX);
          setYp(clientY - options.length * OPTION_ROW_HEIGHT); // setShowOptions(true);
        } else if (clientX + OPTION_ROW_WIDTH > x2 && clientX >= x1 && clientY >= y1 && clientY + options.length * OPTION_ROW_HEIGHT >= y4) {
          if (immediateParent) {
            var _immediateParent$getB2 = immediateParent.getBoundingClientRect(),
                _width2 = _immediateParent$getB2.width;

            setXp(clientX - OPTION_ROW_WIDTH - _width2);
          } else {
            setXp(clientX - OPTION_ROW_WIDTH);
          }

          setYp(clientY - options.length * OPTION_ROW_HEIGHT); // setShowOptions(true);
        }
      }

      var body = document.getElementsByTagName("body");

      if (body.length) {
        body[0].addEventListener("click", toggle);
        window.addEventListener("scroll", toggle);
      }

      setIsMenuVisible(true);
    }

    return function cleanListeners() {
      var body = document.getElementsByTagName("body");

      if (body.length) {
        body[0].removeEventListener("click", toggle);
        window.removeEventListener("scroll", toggle);
      }
    };
  }, []);
  return isMenuVisible && /*#__PURE__*/React__default.createElement(Portal$2, {
    nodename: "grid_option"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      left: (xp > 0 && xp || 0) + "px",
      top: (yp > 0 && yp || 0) + "px",
      width: OPTION_ROW_WIDTH + "px",
      height: options.length * OPTION_ROW_HEIGHT + "px",
      position: "fixed",
      border: "solid 0.2px #dfdfdf",
      borderRadius: "3px",
      boxShadow: "1px 1px 7px rgba($color: #000000, $alpha: 0.14)",
      display: "flex",
      flexDirection: "column",
      padding: "8px 10px",
      backgroundColor: "#fff",
      zIndex: 1305
    }
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, options.map(function (option, key) {
    return /*#__PURE__*/React__default.createElement("span", {
      onClick: function onClick() {
        option.onClick();
      },
      className: "grid_option_menu",
      key: key
    }, option.label);
  }))));
};

ActionMenu.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func
  })),
  clickEvent: PropTypes.object,
  toggle: PropTypes.func
};

var css_248z$r = ".input-field {\n  padding-bottom: 10px;\n  font-family: \"Roboto-Regular\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; }\n  .input-field .title {\n    font-size: 13px;\n    font-weight: 500;\n    display: flex;\n    padding-bottom: 8px; }\n  .input-field .text-field {\n    padding: 12px 7px;\n    width: 100%;\n    background-color: #F2F2F2;\n    box-shadow: none;\n    border-radius: 6px;\n    border: none;\n    outline: none; }\n  .input-field .error-message {\n    color: #FF0000;\n    font-size: 10px;\n    font-weight: 500; }\n    .input-field .error-message p {\n      margin-bottom: 0; }\n\n.required_astrick {\n  color: #EA6767;\n  display: flex;\n  justify-content: flex-end; }\n";
styleInject(css_248z$r);

function _createSuper$l(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$l(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$l() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Input$2 = /*#__PURE__*/function (_React$Component) {
  _inherits$1(Input, _React$Component);

  var _super = _createSuper$l(Input);

  function Input(props) {
    var _this;

    _classCallCheck$1(this, Input);

    _this = _super.call(this, props);
    _this.setTextInputRef = /*#__PURE__*/React__default.createRef();
    _this.state = {
      error: {
        isError: false,
        message: ""
      },
      isRequired: false,
      dirty: false
    };
    _this.inputBlurred = _this.inputBlurred.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(Input, [{
    key: "handleChanges",
    value: function handleChanges(value) {
      var _this2 = this;

      var message = value.target.value && value.target.value.length === "" && API.VALIDATION_MESSAGE.REQUIRED_EMAIL_MESSAGE || API.VALIDATION_MESSAGE.VALID_EMAIL_MESSAGE;
      var emailValidation = API.checkEmail(value.target.value);
      var passwordValidation = API.checkPassword(value.target.value);
      var newPassword = API.VALIDATION_MESSAGE.VALID_PASSWORD_MESSAGE;

      switch (this.props.name) {
        case "email":
          if (emailValidation) {
            this.setState({
              error: {
                isError: false
              }
            }, function () {
              _this2.props.status(value.target.value, "email");
            });
          } else {
            this.setState({
              error: {
                isError: true,
                message: message
              }
            }, function () {
              _this2.props.status(value.target.value, "email");
            });
          }

          break;
        // case "password":
        //   this.props.status(value.target.value, "password");
        //   this.setState({
        //     error: {
        //       isError: value.target.value.length >= 8
        //     }
        //   });
        //   break;

        case "newPassword":
          if (passwordValidation) {
            this.setState({
              error: {
                isError: false
              }
            }, function () {
              return _this2.props.status(value.target.value, "newPassword");
            });
          } else {
            this.setState({
              error: {
                isError: true,
                message: newPassword
              }
            });
          }

          break;

        default:
          this.props.status(value.target.value, "confirmPassword");
      }
    }
  }, {
    key: "inputBlurred",
    value: function inputBlurred(e) {
      this.props.blur && this.props.blur(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          textColor = _this$props.textColor,
          value = _this$props.value,
          name = _this$props.name,
          disabled = _this$props.disabled,
          type = _this$props.type;
      var style = {};
      if (textColor) style.color = textColor;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "input-field"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "title",
        style: style
      }, label, this.props.requiresAsterisk && /*#__PURE__*/React__default.createElement("div", {
        className: "required_astrick"
      }, "*")), /*#__PURE__*/React__default.createElement("input", {
        id: id,
        type: type,
        className: "text-field",
        value: value,
        autoComplete: "new-password",
        onChange: this.handleChanges.bind(this),
        name: name,
        disabled: disabled,
        ref: function ref(el) {
          return _this3.setTextInputRef = el;
        },
        onBlur: function onBlur(e) {
          _this3.inputBlurred(e);
        }
      }), this.state.error.isError && /*#__PURE__*/React__default.createElement("div", {
        className: "error-message"
      }, /*#__PURE__*/React__default.createElement("p", null, this.state.error.message)) || null);
    }
  }]);

  return Input;
}(React__default.Component);

Input$2.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.oneOf(["text", "number", "password", "email"]),
  value: PropTypes.any,
  onChange: PropTypes.func,
  textColor: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  status: PropTypes.func,
  blur: PropTypes.func,
  isRequired: PropTypes.bool,
  requiresAsterisk: PropTypes.bool
};
Input$2.defaultProps = {
  type: "standard"
};

var AuthService = /*#__PURE__*/function () {
  function AuthService(baseUrl) {
    _classCallCheck$1(this, AuthService);

    this._request = new HttpService(baseUrl);
  }

  _createClass$1(AuthService, [{
    key: "auth0Login",
    value: function auth0Login(relativeUrl, payload, callBack, errorHandler) {
      return this._request.post(relativeUrl, payload).then(function (response) {
        if (callBack) callBack(response);else {
          return response;
        }
      })["catch"](function (error) {
        if (errorHandler) errorHandler(error);else {
          return error;
        }
      });
    }
  }]);

  return AuthService;
}();

var css_248z$q = ".logo-wrapper {\n  background-color: #1D1C38;\n  padding: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.login-wrapper {\n  margin: 30px 40px 10px; }\n  .login-wrapper .email-block Input::after {\n    content: \"*\";\n    color: #FF0000; }\n  .login-wrapper .input-field {\n    width: 96%; }\n  .login-wrapper .invalid-msg {\n    font-size: 10px;\n    display: flex;\n    font-weight: 500;\n    text-align: center;\n    justify-content: center;\n    color: #FF0000;\n    font-family: \"Roboto-Italic\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    font-style: italic; }\n\n.login-button .disabled {\n  background: #04D2C6;\n  color: #fff;\n  letter-spacing: 0.02em; }\n\n.success-msg {\n  display: flex;\n  justify-content: center;\n  padding: 10px 0px;\n  font-size: 14px;\n  color: #04D2C6; }\n\n.forgot-password {\n  display: flex;\n  justify-content: center;\n  padding: 12px 20px 0px;\n  cursor: pointer;\n  font-weight: 500;\n  font-family: \"Roboto-Italic\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-size: 14px;\n  color: #797979; }\n\n.login-button {\n  margin: 10px 40px;\n  font-size: 20px;\n  line-height: 23.44px;\n  font-weight: 500;\n  min-width: 145px; }\n\n.sso_button_wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1em; }\n  .sso_button_wrapper button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 1px;\n    height: 34px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    color: white;\n    cursor: pointer; }\n  .sso_button_wrapper .icon, .sso_button_wrapper .icon_button_wrapper, .sso_button_wrapper .ms_login_button_icon {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 6px;\n    font-size: 20px;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px; }\n  .sso_button_wrapper .icon_button_wrapper {\n    background: #fff; }\n  .sso_button_wrapper .ms_login_button {\n    background: #2F2F2F !important; }\n  .sso_button_wrapper .ms_login_button_icon {\n    background: transparent; }\n  .sso_button_wrapper .text_wrapper {\n    font-size: 11px;\n    padding: 0 12px; }\n  .sso_button_wrapper .google_button {\n    border: #4285F4;\n    background: #4285F4; }\n\n.peek_login_wrapper {\n  padding-bottom: 20px; }\n";
styleInject(css_248z$q);

var LoginService = /*#__PURE__*/function () {
  function LoginService(param) {
    _classCallCheck$1(this, LoginService);

    this._request = new HttpService(param.baseAPIPath);
  }

  _createClass$1(LoginService, [{
    key: "requestPassword",
    value: function () {
      var _requestPassword = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(payload) {
        var response;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._request.post(API.core.requestPassword, payload);

              case 2:
                response = _context.sent;
                return _context.abrupt("return", response);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function requestPassword(_x) {
        return _requestPassword.apply(this, arguments);
      }

      return requestPassword;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(payload) {
        var response;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._request.post(API.core.orgAdminLogin, payload);

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", response);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function login(_x2) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "validateRequestPasswordToken",
    value: function () {
      var _validateRequestPasswordToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(payload) {
        var response;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._request.post(API.core.validateRequestPasswordToken, payload);

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", response);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function validateRequestPasswordToken(_x3) {
        return _validateRequestPasswordToken.apply(this, arguments);
      }

      return validateRequestPasswordToken;
    }()
  }, {
    key: "changePassword",
    value: function () {
      var _changePassword = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(payload) {
        var response;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._request.post(API.core.changePassword, payload);

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", response);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function changePassword(_x4) {
        return _changePassword.apply(this, arguments);
      }

      return changePassword;
    }()
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(payload) {
        var response;
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._request.post(API.core.resetPassword, payload);

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", response);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function resetPassword(_x5) {
        return _resetPassword.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: "checkUsertokenValidaitity",
    value: function () {
      var _checkUsertokenValidaitity = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(payload) {
        var res;
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._request.post(API.core.validateUserId, payload);

              case 2:
                res = _context6.sent;
                return _context6.abrupt("return", res);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function checkUsertokenValidaitity(_x6) {
        return _checkUsertokenValidaitity.apply(this, arguments);
      }

      return checkUsertokenValidaitity;
    }()
  }]);

  return LoginService;
}();

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$k(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$k(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Login = /*#__PURE__*/function (_Component) {
  _inherits$1(Login, _Component);

  var _super = _createSuper$k(Login);

  function Login(props) {
    var _this2;

    _classCallCheck$1(this, Login);

    _this2 = _super.call(this, props);
    _this2.state = {
      email: "",
      password: ""
    };
    _this2.AuthService = new AuthService(props.baseAPIPath);
    _this2.LoginService = new LoginService(props);
    _this2.fetchInputStatus = _this2.fetchInputStatus.bind(_assertThisInitialized$3(_this2));
    _this2.loginAgent = _this2.loginAgent.bind(_assertThisInitialized$3(_this2));
    _this2.forgotPassword = _this2.forgotPassword.bind(_assertThisInitialized$3(_this2));
    _this2.userCreds = {
      email: "",
      password: ""
    };
    _this2.state = {
      showForgotPassword: false,
      showLoginButton: false,
      resetPassword: false,
      resetPasswordSuccess: false,
      showResetButton: false
    };
    _this2.handleLoginOnEnter = _this2.handleLoginOnEnter.bind(_assertThisInitialized$3(_this2));
    _this2.validEmailTest = _this2.validEmailTest.bind(_assertThisInitialized$3(_this2));
    _this2.validatePassword = _this2.validatePassword.bind(_assertThisInitialized$3(_this2));
    _this2.eventAdderOnLoad = _this2.eventAdderOnLoad.bind(_assertThisInitialized$3(_this2));
    _this2.onSsoLogin = _this2.onSsoLogin.bind(_assertThisInitialized$3(_this2));
    _this2.enterKey = /*#__PURE__*/React__default.createRef();
    _this2.emailRef = /*#__PURE__*/React__default.createRef();
    _this2.passRef = /*#__PURE__*/React__default.createRef();
    return _this2;
  }

  _createClass$1(Login, [{
    key: "onSsoLogin",
    value: function onSsoLogin(event, type) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({
        loader: true
      });

      switch (type) {
        case "g":
          window.location.href = process.env.baseAPIPath.concat("auth/login/google");
          break;

        case "m":
          window.location.href = process.env.baseAPIPath.concat("auth/login/microsoft");
          break;
      }
    }
  }, {
    key: "eventAdderOnLoad",
    value: function eventAdderOnLoad(e) {
      if (this.emailRef && this.emailRef.setTextInputRef.value) {
        this.fetchInputStatus(this.emailRef.setTextInputRef.value, "email");
      }

      if (this.passRef && this.passRef.setTextInputRef.value) {
        this.fetchInputStatus(this.passRef.setTextInputRef.value, "password");
      }

      if (e.keyCode === 13) {
        localStorage.clear();

        if (this.state.validEmail && this.state.showLoginButton) {
          this.loginAgent();
        } else {
          window.console.log("Login Button Failed");
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      localStorage.setItem("user", "");
      localStorage.setItem("piiq-auth-token", "");
      localStorage.setItem("token", "");
      localStorage.setItem("persist:root", "");
      sessionStorage.setItem("is_viewed_highlight", false);
      localStorage.clear();
      this.setState({
        showForgotPassword: false,
        showLoginButton: this.emailRef.setTextInputRef.value.lenght && this.passRef.setTextInputRef.value.length,
        resetPassword: false,
        resetPasswordSuccess: false,
        showResetButton: false,
        validPassword: true,
        validEmail: true
      });
      document.addEventListener("keyup", this.eventAdderOnLoad, false);

      if (this.emailRef) {
        try {
          this.emailRef.setTextInputRef.focus();
        } catch (e) {
          window.console.log(e);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {

      document.removeEventListener("keyup", this.eventAdderOnLoad, false);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(prevProps, prevState) {
      return JSON.stringify(prevState) !== JSON.stringify(this.state);
    }
  }, {
    key: "forgotPassword",
    value: function forgotPassword() {
      var _this3 = this;

      var userDetails = {
        email: this.emailRef.setTextInputRef.value
      };

      if (this.emailRef.setTextInputRef.value && this.emailRef.setTextInputRef.value.length) {
        this.setState({
          loader: true
        });
        this.LoginService.requestPassword(userDetails).then(function (response) {
          if (!response.data.success) {
            _this3.setState({
              loader: false
            });

            if (response.data.error_id === 10001) {
              window.postMessage({
                type: "notification",
                msg: response.data.message
              });
            }

            if (response.data.error_id === 10027) {
              window.postMessage({
                type: "notification",
                msg: "You are an admin user. Please sign in with your Peek google account"
              });
            }

            return;
          }

          if (response.data.success) {
            _this3.setState({
              resetPasswordSuccess: true,
              loader: false
            });

            window.location.href = "/";
          }
        }, function (err) {
          window.console.error(err);
        });
      } else {
        window.postMessage({
          type: "notification",
          msg: "Please enter valid email"
        });
      }
    }
  }, {
    key: "loginAgent",
    value: function loginAgent() {
      var _this4 = this;

      localStorage.setItem("token", "");
      localStorage.setItem("piiq-auth-token", "");
      localStorage.setItem("user", "");

      if (this.emailRef && this.passRef) {
        var user = {
          email: this.emailRef.setTextInputRef.value,
          password: this.passRef.setTextInputRef.value
        };
        this.setState({
          loader: true
        });
        this.LoginService.login(user).then(function (response) {
          if (!response.data.success) {
            _this4.setState({
              showForgotPassword: true,
              loader: false
            });

            return false;
          } else {
            localStorage.setItem("token", response.data.data.access_token);
            localStorage.setItem("piiq-auth-token", response.data.data.access_token);
            localStorage.setItem("user", JSON.stringify(response.data.data.user_details));

            if (response.data.data.user_details.reset_pass) {
              _this4.props.resetPasswordCallBack(response.data.data.user_details.user_id);
            } else {
              _this4.props.callBackRedirect();
            }
          }

          _this4.setState({
            loader: false
          });
        }, function (err) {
          window.console.error(err);
        });
      }
    }
  }, {
    key: "fetchInputStatus",
    value: function fetchInputStatus(status, key) {
      var _objectSpread2;

      this.setState(_objectSpread$c(_objectSpread$c({}, this.state), {}, (_objectSpread2 = {}, _defineProperty$1(_objectSpread2, "".concat(key), status), _defineProperty$1(_objectSpread2, "showLoginButton", this.emailRef && this.emailRef.setTextInputRef.value && this.emailRef.setTextInputRef.value.length > 0 && this.passRef && this.passRef.setTextInputRef.value && this.passRef.setTextInputRef.value.length > 0 && true || false), _defineProperty$1(_objectSpread2, "showResetButton", this.emailRef && this.emailRef.setTextInputRef.value > 0 && true || false), _objectSpread2)));
      key === "email" && this.validEmailTest(status) || false;
    }
  }, {
    key: "handleLoginOnEnter",
    value: function handleLoginOnEnter(e) {
      if (e.keyCode == 13 && e.shiftKey == false) {
        e.preventDefault();
        this.loginAgent();
      }
    }
  }, {
    key: "validEmailTest",
    value: function validEmailTest(e) {
      if (API.checkEmail(e)) {
        this.setState({
          validEmail: true
        });
      } else {
        this.setState({
          validEmail: false
        });
      }
    }
  }, {
    key: "validatePassword",
    value: function validatePassword(e) {
      if (API.checkPassword(e)) {
        this.setState({
          validPassword: true
        });
      } else {
        this.setState({
          validPassword: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var resetPassword = this.state.resetPassword;
      return /*#__PURE__*/React__default.createElement("div", null, " ", /*#__PURE__*/React__default.createElement("form", null, !this.state.loader && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " ", /*#__PURE__*/React__default.createElement("div", {
        className: "login peek_login_wrapper"
      }, /*#__PURE__*/React__default.createElement("section", {
        className: "logo-wrapper"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "logo-name"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "brand",
        fillOpacity: "1",
        width: 90,
        height: 32
      })), /*#__PURE__*/React__default.createElement(Icon, {
        name: "peeklogo"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "login-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "email-block"
      }, /*#__PURE__*/React__default.createElement(Input$2, {
        ref: function ref(e) {
          return _this5.emailRef = e;
        },
        className: "input-field",
        textColor: "#979797",
        label: "Email",
        type: "email",
        name: "email",
        status: this.fetchInputStatus,
        isRequired: true,
        requiresAsterisk: false
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "password-block",
        style: {
          display: resetPassword ? "none" : "block"
        }
      }, /*#__PURE__*/React__default.createElement(Input$2, {
        ref: function ref(e) {
          return _this5.passRef = e;
        },
        textColor: "#979797",
        label: "Password",
        name: "password",
        type: "password",
        status: this.fetchInputStatus,
        className: "input-field",
        isRequired: true,
        requiresAsterisk: false
      })), this.state.showForgotPassword && !this.state.resetPassword && /*#__PURE__*/React__default.createElement("div", {
        className: "invalid-msg"
      }, "Invalid email or password. Please check and try again.")), /*#__PURE__*/React__default.createElement("div", {
        className: "login-button"
      }, !resetPassword && /*#__PURE__*/React__default.createElement(Button$2, {
        type: this.state.validEmail && this.state.showLoginButton && "login_footer" || "disabled-button",
        color: this.props.primaryColor,
        ref: function ref(e) {
          return _this5.enterKey = e;
        },
        label: "Sign in",
        disabled: !this.state.showLoginButton,
        onClick: function onClick() {
          return _this5.loginAgent();
        },
        tabIndex: 0
      }), resetPassword && /*#__PURE__*/React__default.createElement(Button$2, {
        type: this.state.validEmail && this.state.showResetButton && "login_footer" || "",
        color: this.props.primaryColor,
        label: "Reset password",
        onClick: function onClick() {
          return _this5.forgotPassword();
        }
      }), this.state.resetPasswordSuccess && /*#__PURE__*/React__default.createElement("div", {
        className: "success-msg"
      }, "Password reset link sent!"), this.state.showForgotPassword && !this.state.resetPassword && /*#__PURE__*/React__default.createElement("div", {
        className: "forgot-password",
        onClick: function onClick() {
          return _this5.setState({
            resetPassword: !resetPassword
          });
        }
      }, "Forgot Password")), /*#__PURE__*/React__default.createElement("div", {
        className: "sso_button_wrapper"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "google_button",
        type: "button",
        onClick: function onClick(e) {
          return _this5.onSsoLogin(e, "g");
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "icon_button_wrapper"
      }, /*#__PURE__*/React__default.createElement(MemoSvgGoogle, null)), /*#__PURE__*/React__default.createElement("span", {
        className: "text_wrapper"
      }, "Sign in with Google")), /*#__PURE__*/React__default.createElement("button", {
        className: "google_button ms_login_button",
        type: "button",
        onClick: function onClick(e) {
          return _this5.onSsoLogin(e, "m");
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "icon_button_wrapper ms_login_button_icon"
      }, /*#__PURE__*/React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "21",
        viewBox: "0 0 21 21"
      }, /*#__PURE__*/React__default.createElement("title", null, "MS-SymbolLockup"), /*#__PURE__*/React__default.createElement("rect", {
        x: "1",
        y: "1",
        width: "9",
        height: "9",
        fill: "#f25022"
      }), /*#__PURE__*/React__default.createElement("rect", {
        x: "1",
        y: "11",
        width: "9",
        height: "9",
        fill: "#00a4ef"
      }), /*#__PURE__*/React__default.createElement("rect", {
        x: "11",
        y: "1",
        width: "9",
        height: "9",
        fill: "#7fba00"
      }), /*#__PURE__*/React__default.createElement("rect", {
        x: "11",
        y: "11",
        width: "9",
        height: "9",
        fill: "#ffb900"
      }))), /*#__PURE__*/React__default.createElement("span", {
        className: "text_wrapper"
      }, "Sign in with Microsoft"))))) || /*#__PURE__*/React__default.createElement("div", {
        className: "_spinner_loader_generic"
      }, /*#__PURE__*/React__default.createElement(Spinner, null))));
    }
  }]);

  return Login;
}(Component);

Login.propTypes = {
  baseAPIPath: PropTypes.string,
  primaryColor: PropTypes.string,
  textColor: PropTypes.string,
  label: PropTypes.string,
  status: PropTypes.func,
  fillOpacity: PropTypes.string,
  callBackRedirect: PropTypes.func,
  resetPasswordCallBack: PropTypes.func
};

var css_248z$p = ".logo-wrapper {\n  background-color: #1D1C38;\n  padding: 25px;\n  display: flex;\n  justify-content: center; }\n  .logo-wrapper .logo-name {\n    padding: 0px 10px; }\n\n.password-wrapper {\n  margin: 30px 40px 0px; }\n  .password-wrapper .input-field {\n    width: 96%; }\n\n.sign-button {\n  margin: 10px 40px 32px; }\n\n.reset_password_match_error {\n  text-align: center;\n  width: 100%;\n  display: block;\n  font-style: italic; }\n";
styleInject(css_248z$p);

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ResetPassword$1 = /*#__PURE__*/function (_Component) {
  _inherits$1(ResetPassword, _Component);

  var _super = _createSuper$j(ResetPassword);

  function ResetPassword(props) {
    var _this;

    _classCallCheck$1(this, ResetPassword);

    _this = _super.call(this, props);
    _this.LoginService = new LoginService(props);
    _this.validatePasswordToken = _this.validatePasswordToken.bind(_assertThisInitialized$3(_this));
    _this.fetchInputStatus = _this.fetchInputStatus.bind(_assertThisInitialized$3(_this));
    _this.setNewPassword = _this.setNewPassword.bind(_assertThisInitialized$3(_this));
    _this.state = {
      setValidNewPassword: false
    };
    return _this;
  }

  _createClass$1(ResetPassword, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validatePasswordToken();
      this.setState({
        passwordMatch: true
      });
    }
  }, {
    key: "validatePasswordToken",
    value: function validatePasswordToken() {
      var queryParams = {};
      var newUrl = new URLSearchParams(window.location.search);

      var _iterator = _createForOfIteratorHelper$1(newUrl),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var param = _step.value;
          queryParams[param[0]] = param[1];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      queryParams.token = queryParams.token || false;
      var password_token = {
        token: queryParams.token
      };
      var loginService = new LoginService({
        // eslint-disable-next-line no-undef
        baseAPIPath: process.env.baseAPIPath
      });
      loginService.validateRequestPasswordToken(password_token).then(function (response) {
        if (!response.data.success) {
          window.postMessage({
            type: "notification",
            msg: "Reset password link expired."
          });
          window.location.href = "/";
        }
      });
    }
  }, {
    key: "fetchInputStatus",
    value: function fetchInputStatus(status, key) {
      var _objectSpread2,
          _this2 = this;

      this.setState(_objectSpread$b(_objectSpread$b({}, this.state), {}, (_objectSpread2 = {}, _defineProperty$1(_objectSpread2, "".concat(key), status), _defineProperty$1(_objectSpread2, "showSignInButton", this.state.newPassword && this.state.newPassword.length > 0 && this.state.newPassword && this.state.newPassword.length > 0), _objectSpread2)), function () {
        _this2.setState({
          passwordMatch: _this2.state.newPassword === _this2.state.confirmPassword
        });
      });
      this.validPassword(status, key);
    }
  }, {
    key: "validPassword",
    value: function validPassword(value, passwordKey) {
      var isValid = API.checkPassword(value);

      switch (passwordKey) {
        case "newPassword":
          {
            if (isValid) {
              this.setState({
                setValidNewPassword: true
              });
            } else {
              this.setState({
                setValidNewPassword: false
              });
            }
          }
          break;
      }
    }
  }, {
    key: "setNewPassword",
    value: function setNewPassword() {
      var _this3 = this;

      var queryParams = {}; // eslint-disable-next-line no-undef

      var loginService = new LoginService({
        // eslint-disable-next-line no-undef
        baseAPIPath: process.env.baseAPIPath
      });
      var newUrl = new URLSearchParams(window.location.search);

      var _iterator2 = _createForOfIteratorHelper$1(newUrl),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var param = _step2.value;
          queryParams[param[0]] = param[1];
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      queryParams.token = queryParams.token || false;
      var payload = {
        token: queryParams.token,
        password: this.state.newPassword
      };
      loginService.resetPassword(payload).then(function (response) {
        if (!response.data.success) {
          return;
        } else {
          localStorage.setItem("token", response.data.data.access_token);
          localStorage.setItem("user", JSON.stringify(response.data.data.user_details));

          _this3.props.callBackRedirectToListing();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("section", {
        className: "logo-wrapper"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "logo-name"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "brand",
        fillOpacity: "1",
        width: "125px",
        height: "32px"
      })), /*#__PURE__*/React__default.createElement(Icon, {
        name: "peeklogo"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "password-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "new-password"
      }, /*#__PURE__*/React__default.createElement(Input$2, {
        textColor: "#979797",
        label: "Password",
        type: "password",
        name: "newPassword",
        status: this.fetchInputStatus,
        required: true
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "confirm-password"
      }, /*#__PURE__*/React__default.createElement(Input$2, {
        textColor: "#979797",
        label: "Confirm Password",
        type: "password",
        name: "confirmPassword",
        status: this.fetchInputStatus,
        required: true
      }))), !this.state.passwordMatch && /*#__PURE__*/React__default.createElement("span", {
        className: "input-field"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "error-message reset_password_match_error"
      }, "Password and confirm password should match")) || null, /*#__PURE__*/React__default.createElement("div", {
        className: "sign-button"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        disabled: !(this.state.showSignInButton && this.state.setValidNewPassword && this.state.passwordMatch),
        type: this.state.showSignInButton && this.state.setValidNewPassword && this.state.passwordMatch && "login_footer" || "disabled-button",
        color: this.props.primaryColor,
        label: "Reset password",
        onClick: function onClick() {
          return _this4.setNewPassword();
        }
      }))));
    }
  }]);

  return ResetPassword;
}(Component);

ResetPassword$1.propTypes = {
  primaryColor: PropTypes.string,
  textColor: PropTypes.string,
  label: PropTypes.string,
  status: PropTypes.func,
  fillOpacity: PropTypes.string,
  callBackRedirectToListing: PropTypes.func
};

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SymboledTextField = function SymboledTextField(props) {
  var remainProps = _objectSpread$a({}, props);

  delete remainProps.symbol;
  delete remainProps.hasError;
  delete remainProps.errorMessage;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "texxtfieldWrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "symbol"
  }, props.symbol), /*#__PURE__*/React__default.createElement(TextField$3, remainProps), props.hasError && /*#__PURE__*/React__default.createElement(Icon, {
    name: "info",
    color: "red",
    width: 20,
    height: 20
  })), /*#__PURE__*/React__default.createElement("span", null, props.hasError && /*#__PURE__*/React__default.createElement("div", {
    className: "errorWrapper"
  }, /*#__PURE__*/React__default.createElement("span", null, props.errorMessage)) || null));
};

SymboledTextField.propTypes = {
  symbol: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string
};
var SymboledTextField$1 = /*#__PURE__*/React__default.memo(SymboledTextField);

var css_248z$o = ".label {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: -0.01em;\n  color: #545454; }\n\n.uploader-div {\n  background: #ffffff;\n  border: 1px dashed #979797;\n  box-sizing: border-box;\n  border-radius: 4px;\n  width: 100%;\n  height: 100%;\n  display: flex; }\n\n.file-div {\n  box-sizing: border-box;\n  border-radius: 3px;\n  width: 60%;\n  height: 175px;\n  position: relative;\n  margin: 20px 0; }\n\n.upload-input {\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  z-index: 2; }\n\n.upload-input + label * {\n  pointer-events: none; }\n\n.input-label {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: -0.01em;\n  color: #545454;\n  text-align: center; }\n\n.upload-label {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: -0.01em;\n  color: #545454;\n  display: block;\n  margin-bottom: 5px; }\n\n.upload-btn {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 15px;\n  background: none;\n  align-items: center;\n  text-decoration-line: underline;\n  color: #333333;\n  border: none;\n  padding: 0;\n  cursor: pointer; }\n\n.upload-btn:focus, .upload-btn:active {\n  outline: none; }\n\n.image-action-btns {\n  display: flex;\n  justify-content: space-between; }\n";
styleInject(css_248z$o);

function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FileUploader = /*#__PURE__*/function (_React$Component) {
  _inherits$1(FileUploader, _React$Component);

  var _super = _createSuper$i(FileUploader);

  function FileUploader(props) {
    var _this;

    _classCallCheck$1(this, FileUploader);

    _this = _super.call(this, props);
    _this.dropRef = /*#__PURE__*/React__default.createRef();
    _this.btnRef = /*#__PURE__*/React__default.createRef();
    _this.validateFile = _this.validateFile.bind(_assertThisInitialized$3(_this));
    _this.handleDrop = _this.handleDrop.bind(_assertThisInitialized$3(_this));
    _this.removeFile = _this.removeFile.bind(_assertThisInitialized$3(_this));
    _this.onFileChange = _this.onFileChange.bind(_assertThisInitialized$3(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized$3(_this));
    _this.uploadToS3 = _this.uploadToS3.bind(_assertThisInitialized$3(_this));
    _this.onImgLoad = _this.onImgLoad.bind(_assertThisInitialized$3(_this));
    _this.state = {
      file: null,
      isFileUploaded: false,
      isImageFile: false,
      dimensions: {}
    };
    return _this;
  }

  _createClass$1(FileUploader, [{
    key: "onImgLoad",
    value: function onImgLoad(_ref) {
      var img = _ref.target;
      this.setState({
        dimensions: {
          height: img.offsetHeight,
          width: img.offsetWidth
        }
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      if (document.createEvent) {
        var evt = document.createEvent("MouseEvents");
        evt.initEvent("click", true, false);
        this.btnRef.current.dispatchEvent(evt);
      }
    }
  }, {
    key: "removeFile",
    value: function removeFile() {
      var configObj = {
        key: this.props.path,
        bucket: this.props.bucketName,
        region: this.props.region,
        IdentityPoolId: this.props.identityPoolId
      };
      this.props.deleteFromS3(configObj);
      this.setState({
        file: null,
        isFileUploaded: false,
        isImageFile: false
      });
      this.btnRef.current.val = "";
      this.btnRef.current.value = "";
      this.props.change("");
    }
  }, {
    key: "validateFile",
    value: function validateFile(file) {
      var _this$props = this.props,
          maxFileSize = _this$props.maxFileSize,
          allowedExtensions = _this$props.allowedExtensions;
      var isValidType = allowedExtensions === null || allowedExtensions === void 0 ? void 0 : allowedExtensions.filter(function (ele) {
        return file && file.name.includes(ele);
      });

      if (file && file.size < maxFileSize && isValidType.length === 1) {
        this.setState({
          isFileUploaded: true
        });
        return true;
      } else {
        this.setState({
          isFileUploaded: false
        });
        return false;
      }
    }
  }, {
    key: "onFileChange",
    value: function onFileChange(e) {
      var errorMessage = this.props.errorMessage;
      e.stopPropagation();
      e.preventDefault();
      var file = e.target.files[0];
      var isValidFile = this.validateFile(file);

      if (isValidFile) {
        this.checkTypeOfFile(file);
        this.uploadToS3(file);
        this.props.change(!this.props.hasExplicitFileName && file.name || this.props.explicitFileName);
      } else {
        e.target.value = null;
        alert(errorMessage);
      }
    }
  }, {
    key: "uploadToS3",
    value: function uploadToS3(file) {
      var configObj = {
        file: file,
        fileType: file.type,
        fileName: !this.props.hasExplicitFileName && file.name || this.props.explicitFileName,
        bucket: this.props.bucketName,
        region: this.props.region,
        IdentityPoolId: this.props.identityPoolId,
        awsUrl: this.props.bucketUrl,
        listingId: this.props.listingId
      };
      this.props.uploadToS3(configObj);
    }
  }, {
    key: "handleDrag",
    value: function handleDrag(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, {
    key: "handleDragIn",
    value: function handleDragIn(e) {
      e.preventDefault();
      e.stopPropagation();
      this.dragCounter++;
    }
  }, {
    key: "handleDragOut",
    value: function handleDragOut(e) {
      e.preventDefault();
      e.stopPropagation();
      this.dragCounter--;
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(e) {
      var errorMessage = this.props.errorMessage;
      e.preventDefault();
      e.stopPropagation();

      if (e.dataTransfer.files[0]) {
        var file = e.dataTransfer.files[0];
        var isValidFile = this.validateFile(file);

        if (isValidFile) {
          this.checkTypeOfFile(file);
          this.uploadToS3(file);
          this.props.change(file.name);
        } else {
          e.target.value = null;
          alert(errorMessage);
        }

        e.dataTransfer.clearData();
        this.dragCounter = 0;
      }
    }
  }, {
    key: "checkTypeOfFile",
    value: function checkTypeOfFile(file) {
      if (file.type.includes("image")) {
        this.setState({
          isImageFile: true
        });
        this.setState({
          file: URL.createObjectURL(file)
        });
      } else {
        this.setState({
          isImageFile: false
        });
        this.setState({
          file: file.name
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var div = this.dropRef.current;
      this.props.path ? this.setState({
        file: this.props.bucketUrl + this.props.path,
        isImageFile: true
      }) : "";
      div.addEventListener("dragenter", this.handleDragIn);
      div.addEventListener("dragleave", this.handleDragOut);
      div.addEventListener("dragover", this.handleDrag);
      div.addEventListener("drop", this.handleDrop);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var div = this.dropRef.current;
      div.removeEventListener("dragenter", this.handleDragIn);
      div.removeEventListener("dragleave", this.handleDragOut);
      div.removeEventListener("dragover", this.handleDrag);
      div.removeEventListener("drop", this.handleDrop);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var label = this.props.label;
      var idForInput = "file" + Math.random().toString();
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
        className: "upload-label"
      }, " ", label, " "), /*#__PURE__*/React__default.createElement("div", {
        id: "upload-div",
        className: this.state.file ? "file-div" : "uploader-div",
        ref: this.dropRef
      }, /*#__PURE__*/React__default.createElement("input", {
        id: idForInput,
        className: "upload-input",
        type: "file",
        name: "file",
        onChange: function onChange(e) {
          return _this2.onFileChange(e);
        },
        ref: this.btnRef
      }), /*#__PURE__*/React__default.createElement("label", {
        className: "input-label",
        htmlFor: idForInput,
        onClick: function onClick() {
          return _this2.handleClick(idForInput);
        }
      }, !this.state.isFileUploaded && !this.state.file && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Icon, {
        name: "folder"
      }), /*#__PURE__*/React__default.createElement("br", null), "Drag and drop", /*#__PURE__*/React__default.createElement("br", null), " or", " ", /*#__PURE__*/React__default.createElement("span", {
        style: {
          color: "#04D2C6"
        }
      }, "upload from your computer")), get(this.props, "isReminderLogo", false) && /*#__PURE__*/React__default.createElement("span", {
        style: {
          color: "#EA6767",
          display: "flex",
          gap: "10px"
        }
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "info",
        color: "#EA6767",
        width: 20,
        height: 20
      }), "Do not upload white unbordered logos!")), this.state.isImageFile ? /*#__PURE__*/React__default.createElement("img", {
        style: {
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "cover",
          borderRadius: 3
        },
        src: this.state.file,
        onLoad: this.onImgLoad
      }) : /*#__PURE__*/React__default.createElement("span", null, this.state.file))), /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginTop: 5,
          width: this.state.isImageFile ? this.state.dimensions.width : "100%"
        },
        className: "image-action-btns"
      }, this.props.fileUploadBtnLabel && /*#__PURE__*/React__default.createElement("button", {
        className: "upload-btn",
        type: "button",
        style: {
          marginRight: 15
        },
        onClick: function onClick() {
          return _this2.handleClick(idForInput);
        }
      }, this.props.fileUploadBtnLabel), this.props.fileRemoveBtnLabel && this.state.isImageFile && /*#__PURE__*/React__default.createElement("button", {
        className: "upload-btn",
        type: "button",
        onClick: function onClick() {
          return _this2.removeFile();
        }
      }, this.props.fileRemoveBtnLabel)));
    }
  }]);

  return FileUploader;
}(React__default.Component);

FileUploader.propTypes = {
  maxFileSize: PropTypes.number,
  allowedExtensions: PropTypes.array,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  path: PropTypes.string,
  fileUploadBtnLabel: PropTypes.string,
  fileRemoveBtnLabel: PropTypes.string,
  change: PropTypes.func,
  bucketName: PropTypes.string,
  region: PropTypes.string,
  listingId: PropTypes.string,
  uploadToS3: PropTypes.func,
  deleteFromS3: PropTypes.func,
  bucketUrl: PropTypes.string,
  identityPoolId: PropTypes.string,
  explicitFileName: PropTypes.string,
  hasExplicitFileName: PropTypes.bool,
  isReminderLogo: PropTypes.bool
};

var css_248z$n = ".profile-wrapper {\n  background: #dedede;\n  border-radius: 50%;\n  color: #aeaeae;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .profile-wrapper.is-disabled {\n    opacity: 0.5; }\n\n.profile_card {\n  width: 350px;\n  background: #fff;\n  border-radius: 5px;\n  padding: 25px 23px; }\n  .profile_card .name_dp {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-direction: row;\n    padding-bottom: 27px;\n    border-bottom: solid 0.5px #C4C4C4; }\n    .profile_card .name_dp .dp_image {\n      width: 100px;\n      height: 100px;\n      background-size: cover !important;\n      border-radius: 50%; }\n    .profile_card .name_dp .name_image {\n      display: flex;\n      flex-direction: column;\n      flex: 1;\n      margin-left: 1rem; }\n  .profile_card .user_subsciption {\n    display: flex;\n    flex-direction: column;\n    margin-top: 17px; }\n  .profile_card span.name {\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 23px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #1D1C38; }\n  .profile_card span.subtext {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 19px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #333; }\n  .profile_card .organization_info {\n    margin-bottom: 27px; }\n\ndiv#showEditInfo {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1500;\n  transform: translateZ(0);\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\ndiv#edit_user_profile_window div.change_password_window {\n  z-index: 1501;\n  width: 500px;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  padding: 23px 22px;\n  background: #f2f2f2;\n  border-radius: 5px;\n  transform: translate(-50%, -50%);\n  z-index: 1501; }\n  div#edit_user_profile_window div.change_password_window .inline-form-control {\n    display: flex;\n    margin-bottom: 8px;\n    align-items: center;\n    justify-content: flex-start; }\n    div#edit_user_profile_window div.change_password_window .inline-form-control .inline-form-label {\n      flex-basis: 35%;\n      font-size: 13px; }\n      div#edit_user_profile_window div.change_password_window .inline-form-control .inline-form-label .label {\n        font-weight: 700;\n        font-size: 14px; }\n    div#edit_user_profile_window div.change_password_window .inline-form-control .inline-form-ctrl {\n      flex: 1;\n      margin-left: 20px; }\n\ndiv#edit_user_profile_window div.edit_profile_dialog_title {\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0em;\n  text-align: left;\n  padding-bottom: 12px;\n  border-bottom: solid 0.5px #c4c4c5;\n  margin-bottom: 1.5rem; }\n\ndiv#edit_user_profile_window div.edit_profile_image {\n  width: 450px;\n  background: #fff;\n  min-height: 300px;\n  max-height: 700px;\n  justify-content: center;\n  padding: 23px 30px;\n  border-radius: 5px;\n  z-index: 1501;\n  background: #f2f2f2;\n  box-sizing: border-box;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n\ndiv#edit_user_profile_window .form_control_flex_wrapper {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  box-sizing: border-box;\n  margin-bottom: 1rem; }\n  div#edit_user_profile_window .form_control_flex_wrapper .form_control_label {\n    display: flex;\n    gap: 3px;\n    flex-basis: 27%; }\n  div#edit_user_profile_window .form_control_flex_wrapper .form_control_input {\n    flex: 1;\n    position: relative; }\n    div#edit_user_profile_window .form_control_flex_wrapper .form_control_input .auto_complete_wrapper {\n      position: absolute; }\n\ndiv#edit_user_profile_window .form_button_section {\n  display: flex;\n  justify-content: center;\n  padding-top: 1rem;\n  border-top: solid 0.5px #c5c5c5; }\n  div#edit_user_profile_window .form_button_section .default {\n    min-width: 113px; }\n  div#edit_user_profile_window .form_button_section .standard {\n    min-width: 125px; }\n  div#edit_user_profile_window .form_button_section .button {\n    height: 34px;\n    margin: 0 9px;\n    z-index: 1; }\n    div#edit_user_profile_window .form_button_section .button span {\n      font-size: 14px;\n      line-height: 16.41px; }\n\n.profile_pic_wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 2rem; }\n\n.profile_pic_container {\n  display: flex;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background-size: cover !important; }\n\ndiv#hide_file_uploader {\n  position: fixed;\n  top: -80000000px;\n  left: -500000px;\n  opacity: 0; }\n\n.red {\n  color: #EA6767; }\n\n._spinner_loader_generic {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 50px;\n  height: 50px; }\n  ._spinner_loader_generic img {\n    width: 100%;\n    height: 100%; }\n\n.mandatory_info {\n  font-size: 13px; }\n\n.MuiAutocomplete-popper {\n  z-index: 1600; }\n";
styleInject(css_248z$n);

function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Profile = /*#__PURE__*/function (_Component) {
  _inherits$1(Profile, _Component);

  var _super = _createSuper$h(Profile);

  function Profile() {
    _classCallCheck$1(this, Profile);

    return _super.apply(this, arguments);
  }

  _createClass$1(Profile, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: ["profile-wrapper", this.props.isDisabled ? "is-disabled" : ""].join(" "),
        style: {
          width: this.props.width,
          height: this.props.height
        }
      }, this.props.image && /*#__PURE__*/React__default.createElement("img", {
        src: this.props.image
      }), !this.props.image && /*#__PURE__*/React__default.createElement(PersonIcon, {
        fontSize: "large"
      }));
    }
  }]);

  return Profile;
}(Component);

Profile.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  isDisabled: PropTypes.bool,
  image: PropTypes.string
};

var toArray = createCommonjsModule(function (module) {
function _toArray(arr) {
  return arrayWithHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableRest();
}

module.exports = _toArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _toArray = unwrapExports(toArray);

var css_248z$m = "*, *::before, *::after {\n  box-sizing: inherit; }\n\n.select_wrapper {\n  position: relative;\n  display: inline-block;\n  color: #1D1C38;\n  box-sizing: border-box;\n  width: 100%; }\n  .select_wrapper:focus {\n    outline: 0; }\n  .select_wrapper .label {\n    display: block;\n    margin-bottom: 6px;\n    font-weight: 600; }\n  .select_wrapper .selection {\n    position: relative;\n    padding: 5px;\n    background: #fff;\n    height: 36px;\n    border-radius: 4px;\n    border: 1px solid #E1E1E1;\n    display: flex;\n    align-items: center; }\n  .select_wrapper .value {\n    position: relative;\n    padding: 5px 10px;\n    background: rgba(4, 210, 198, 0.2);\n    align-items: baseline;\n    border-radius: 50px;\n    font-size: 13px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 150px; }\n  .select_wrapper .multiple {\n    padding-right: 30px;\n    margin-right: 5px;\n    border-radius: 100px; }\n  .select_wrapper .delete {\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: block;\n    padding: 8px;\n    font-size: 12px;\n    cursor: pointer; }\n  .select_wrapper .placeholder {\n    padding: 5px 10px; }\n  .select_wrapper .arrow {\n    position: absolute;\n    font-size: 19px;\n    right: 1em;\n    top: 0.3em; }\n  .select_wrapper .option_wrapper {\n    background-color: #fff;\n    position: absolute;\n    top: 116%;\n    width: 100%;\n    z-index: 2; }\n  .select_wrapper .options {\n    left: 0;\n    right: 0;\n    border-width: 0 1px;\n    box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    padding: 15px 20px;\n    z-index: 1;\n    max-height: 300px;\n    overflow-y: auto; }\n  .select_wrapper .option {\n    padding: 10px 15px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    color: black;\n    width: 100%;\n    line-height: 15px;\n    gap: 10px; }\n    .select_wrapper .option.selected {\n      margin: -1px -1px 0; }\n  .select_wrapper .checkbox {\n    content: ''; }\n    .select_wrapper .checkbox .void_box {\n      width: 15px; }\n";
styleInject(css_248z$m);

function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Select$2 = /*#__PURE__*/function (_Component) {
  _inherits$1(Select, _Component);

  var _super = _createSuper$g(Select);

  function Select(props) {
    var _this;

    _classCallCheck$1(this, Select);

    _this = _super.call(this, props);
    _this.state = {
      values: props.selected.length && props.selected || [],
      focusedValue: -1,
      isFocused: false,
      isOpen: false,
      typed: ""
    };
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized$3(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized$3(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized$3(_this));
    _this.onClick = _this.onClick.bind(_assertThisInitialized$3(_this));
    _this.onDeleteOption = _this.onDeleteOption.bind(_assertThisInitialized$3(_this));
    _this.onHoverOption = _this.onHoverOption.bind(_assertThisInitialized$3(_this));
    _this.onClickOption = _this.onClickOption.bind(_assertThisInitialized$3(_this));
    _this.renderOption = _this.renderOption.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(Select, [{
    key: "onFocus",
    value: function onFocus() {
      this.setState({
        isFocused: true
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      var _this$props = this.props,
          options = _this$props.options,
          multiple = _this$props.multiple;
      this.setState(function (prevState) {
        var values = prevState.values;

        if (multiple) {
          return {
            focusedValue: -1,
            isFocused: false,
            isOpen: false
          };
        } else {
          var value = values[0];
          var focusedValue = -1;

          if (value) {
            focusedValue = options.findIndex(function (option) {
              return option.value === value;
            });
          }

          return {
            focusedValue: focusedValue,
            isFocused: false,
            isOpen: false
          };
        }
      });
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var _this$props2 = this.props,
          options = _this$props2.options,
          multiple = _this$props2.multiple;
      var isOpen = this.state.isOpen;

      switch (e.key) {
        case "Escape":
        case "Tab":
          if (isOpen) {
            e.preventDefault();
            this.setState({
              isOpen: false
            });
          }

          break;

        case "Enter":
          this.setState(function (prevState) {
            return {
              isOpen: !prevState.isOpen
            };
          });
          break;

        case "ArrowDown":
          e.preventDefault();
          this.setState(function (prevState) {
            var focusedValue = prevState.focusedValue;

            if (focusedValue < options.length - 1) {
              focusedValue++;

              if (multiple) {
                return {
                  focusedValue: focusedValue
                };
              } else {
                return {
                  values: [options[focusedValue].value],
                  focusedValue: focusedValue
                };
              }
            }
          });
          break;

        case "ArrowUp":
          e.preventDefault();
          this.setState(function (prevState) {
            var focusedValue = prevState.focusedValue;

            if (focusedValue > 0) {
              focusedValue--;

              if (multiple) {
                return {
                  focusedValue: focusedValue
                };
              } else {
                return {
                  values: [options[focusedValue].value],
                  focusedValue: focusedValue
                };
              }
            }
          });
          break;
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    }
  }, {
    key: "onDeleteOption",
    value: function onDeleteOption(e) {
      var _this2 = this;

      var typeObject = this.props.typeObject;
      var value = e.currentTarget.dataset.value;
      this.setState(function (prevState) {
        var _prevState$values = _toArray(prevState.values),
            values = _prevState$values.slice(0);

        var index = values.indexOf(value);
        values.splice(index, 1);
        return {
          values: values
        };
      }, function () {
        // filter the list based on selection
        if (typeObject) {
          var returnList = _this2.props.options.filter(function (option) {
            return _this2.state.values.indexOf(option.value) !== -1;
          });

          _this2.props.onSelect(returnList);
        } else {
          _this2.props.onSelect(_this2.state.values);
        }
      });
    }
  }, {
    key: "onHoverOption",
    value: function onHoverOption(e) {
      var options = this.props.options;
      var value = e.currentTarget.dataset.value;
      var index = options.findIndex(function (option) {
        return option.value === value;
      });
      this.setState({
        focusedValue: index
      });
    }
  }, {
    key: "onClickOption",
    value: function onClickOption(e) {
      var _this3 = this;

      var _this$props3 = this.props,
          multiple = _this$props3.multiple,
          typeObject = _this$props3.typeObject;
      var value = e.currentTarget.dataset.value;
      this.setState(function (prevState) {
        if (!multiple) {
          return {
            values: [value],
            isOpen: false
          };
        }

        var _prevState$values2 = _toArray(prevState.values),
            values = _prevState$values2.slice(0);

        var index = values.indexOf(value);

        if (index === -1) {
          values.push(value);
        } else {
          values.splice(index, 1);
        }

        return {
          values: values
        };
      }, function () {
        if (typeObject) {
          var returnList = _this3.props.options.filter(function (option) {
            return _this3.state.values.indexOf(option.value) !== -1;
          });

          _this3.props.onSelect(returnList);
        } else {
          _this3.props.onSelect(_this3.state.values);
        }
      });
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation(e) {
      e.stopPropagation();
    }
  }, {
    key: "renderValues",
    value: function renderValues() {
      var _this4 = this;

      var _this$props4 = this.props,
          placeholder = _this$props4.placeholder,
          multiple = _this$props4.multiple,
          isNew = _this$props4.isNew;
      var values = this.state.values;

      if (values.length === 0 || isNew) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "placeholder"
        }, placeholder);
      }

      if (multiple) {
        return values.map(function (value) {
          return /*#__PURE__*/React__default.createElement("span", {
            key: value,
            title: value,
            onClick: _this4.stopPropagation,
            className: "multiple value"
          }, value, /*#__PURE__*/React__default.createElement("span", {
            "data-value": value,
            onClick: _this4.onDeleteOption,
            className: "delete"
          }, /*#__PURE__*/React__default.createElement(MemoSvgX, null)));
        });
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "value",
        title: values[0]
      }, values[0]);
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var options = this.props.options;
      var isOpen = this.state.isOpen;

      if (!isOpen) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "option_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "options"
      }, options.map(this.renderOption)));
    }
  }, {
    key: "renderOption",
    value: function renderOption(option, index) {
      var multiple = this.props.multiple;
      var _this$state = this.state,
          values = _this$state.values,
          focusedValue = _this$state.focusedValue;
      var value = option.value;
      var selected = values.includes(value);
      var className = "option";
      if (selected) className += " selected";
      if (index === focusedValue) className += " focused";
      return /*#__PURE__*/React__default.createElement("div", {
        key: value,
        "data-value": value,
        className: className,
        onMouseOver: this.onHoverOption,
        onClick: this.onClickOption
      }, multiple ? /*#__PURE__*/React__default.createElement("span", {
        className: "checkbox"
      }, selected ? /*#__PURE__*/React__default.createElement(MemoSvgCheck, null) : /*#__PURE__*/React__default.createElement("div", {
        className: "void_box"
      })) : null, value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          label = _this$props5.label,
          isRequired = _this$props5.isRequired;
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "select_wrapper",
        tabIndex: "0",
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown
      }, /*#__PURE__*/React__default.createElement("label", {
        className: "label"
      }, label, isRequired && /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*") || null), /*#__PURE__*/React__default.createElement("div", {
        className: "selection",
        onClick: this.onClick
      }, this.renderValues(), /*#__PURE__*/React__default.createElement("span", {
        className: "arrow"
      }, isOpen ? /*#__PURE__*/React__default.createElement(MemoSvgChevronUp, null) : /*#__PURE__*/React__default.createElement(MemoSvgChevronDown, null))), this.renderOptions());
    }
  }]);

  return Select;
}(Component);

Select$2.defaultProps = {
  isRequired: false,
  isNew: false
};
Select$2.propTypes = {
  options: PropTypes.array,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  onSelect: PropTypes.func,
  typeObject: PropTypes.any,
  selected: PropTypes.array,
  isRequired: PropTypes.bool,
  isNew: PropTypes.bool
};
var MultipleSelect = /*#__PURE__*/React__default.memo(Select$2);

var css_248z$l = "ul.options__list__wrapper {\n  position: absolute;\n  z-index: 1501;\n  padding: 1em;\n  background: #fff;\n  width: 100%;\n  max-height: 208px;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  top: 47px;\n  box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n  border-radius: 4px; }\n  ul.options__list__wrapper li {\n    font-size: 12px;\n    line-height: 15.81px;\n    cursor: pointer;\n    width: 100%;\n    display: block;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n    ul.options__list__wrapper li.info_text_types_text {\n      font-size: 11px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 13px;\n      letter-spacing: 0.05em;\n      text-align: left;\n      color: #979797; }\n    ul.options__list__wrapper li:first-child {\n      display: flex;\n      justify-content: space-between;\n      align-items: center; }\n      ul.options__list__wrapper li:first-child span.new_entry_label_button {\n        font-size: 28px; }\n      ul.options__list__wrapper li:first-child span.new_entry_label {\n        flex-basis: 85%; }\n\n.textfield__wrapper__autocomplete {\n  position: relative; }\n  .textfield__wrapper__autocomplete .expand_button {\n    position: absolute;\n    display: flex;\n    top: 50%;\n    right: 20px;\n    font-size: 19px;\n    transform: translateY(-50%); }\n";
styleInject(css_248z$l);

var Autocomplete = function Autocomplete(props) {
  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      typedText = _useState2[0],
      setTypedText = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray$1(_useState3, 2),
      newEntry = _useState4[0],
      setNewEntry = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$1(_useState5, 2),
      openOptions = _useState6[0],
      setOpenOptions = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray$1(_useState7, 2),
      filteredOptions = _useState8[0],
      setFilteredOptions = _useState8[1];

  var firstUpdate = useRef(true);
  useEffect(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      setFilteredOptions(props.options);
      return;
    }

    if (typedText.length || newEntry.length) {
      var filterdValue = typedText.length && props.options.filter(function (option) {
        return option.label.toLowerCase().indexOf(typedText.toLowerCase()) !== -1;
      }) || newEntry.length && props.options.filter(function (option) {
        return option.label.toLowerCase().indexOf(newEntry.toLowerCase()) !== -1;
      }) || props.options;
      setFilteredOptions(filterdValue);
    } else {
      setFilteredOptions(props.options);
    }
  }, [typedText, newEntry]);
  useEffect(function () {
    setTypedText(props.selectedValue);
  }, []);

  var onClickCreate = function onClickCreate() {
    // check if organization already exists
    if (!props.options.some(function (option) {
      return option.label.toLowerCase() === newEntry.toLowerCase();
    })) {
      props.onClickCreate && props.onClickCreate(newEntry);
      setTypedText(newEntry);
      setOpenOptions(false);
    }
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.showInlineCreate && /*#__PURE__*/React__default.createElement("div", {
    className: "textfield__wrapper__autocomplete"
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    value: typedText,
    change: function change(text) {
      setTypedText(text);
      setOpenOptions(true);
    },
    placeholder: props.primarySearchPlaceholder
  })) || null, openOptions && /*#__PURE__*/React__default.createElement("ul", {
    className: "options__list__wrapper"
  }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("span", {
    className: "new_entry_label"
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    value: newEntry,
    change: function change(text) {
      return setNewEntry(text);
    },
    placeholder: props.secondarySearchPlaceholder
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "new_entry_label_button",
    onClick: function onClick() {
      return onClickCreate();
    }
  }, /*#__PURE__*/React__default.createElement(MemoSvgPlusSquare, null))), typedText.length && /*#__PURE__*/React__default.createElement("li", {
    className: "info_text_types_text"
  }, "Results matching: \"".concat(typedText, "\"")) || null, (typedText.length || newEntry.length) && filteredOptions.map(function (option, key) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: key,
      onClick: function onClick() {
        setTypedText(option.label);
        props.onSelect(option);
        setOpenOptions(false);
      }
    }, option.label);
  }) || props.options.map(function (option, key) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: key,
      onClick: function onClick() {
        setTypedText(option.label);
        props.onSelect(option);
        setOpenOptions(false);
      }
    }, option.label);
  })) || null);
};

Autocomplete.defaulProps = {
  showInlineCreate: false
};
Autocomplete.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  showInlineCreate: PropTypes.bool,
  onClickCreate: PropTypes.func,
  selectedValue: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  primarySearchPlaceholder: PropTypes.text,
  secondarySearchPlaceholder: PropTypes.text
};

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditProfileCard = /*#__PURE__*/function (_Component) {
  _inherits$1(EditProfileCard, _Component);

  var _super = _createSuper$f(EditProfileCard);

  function EditProfileCard(props) {
    var _this2;

    _classCallCheck$1(this, EditProfileCard);

    _this2 = _super.call(this, props);
    _this2.userId = props.userId;
    _this2.state = {
      name: "",
      organization: "",
      organizationId: "",
      plan: "",
      phone: "",
      email: "",
      leadEmail: "",
      validEmail: true,
      validLeadEmail: true,
      planId: 8,
      isActive: false,
      organizations: []
    };
    _this2.emailPattern = new RegExp(API.VALIDATION.EMAIL_VALIDATION);
    _this2.validLeadEmailTest = _this2.validLeadEmailTest.bind(_assertThisInitialized$3(_this2));
    _this2.validEmailTest = _this2.validEmailTest.bind(_assertThisInitialized$3(_this2));
    _this2.uploadImageToS3 = _this2.uploadImageToS3.bind(_assertThisInitialized$3(_this2));
    _this2.onSubmit = _this2.onSubmit.bind(_assertThisInitialized$3(_this2));
    _this2.onCreate = _this2.onCreate.bind(_assertThisInitialized$3(_this2));
    _this2.openFileSelector = _this2.openFileSelector.bind(_assertThisInitialized$3(_this2));
    _this2.validateForm = _this2.validateForm.bind(_assertThisInitialized$3(_this2));
    _this2.setActiveStatus = _this2.setActiveStatus.bind(_assertThisInitialized$3(_this2));
    _this2.setUserType = _this2.setUserType.bind(_assertThisInitialized$3(_this2));
    _this2.hideForSuperAdmin = _this2.hideForSuperAdmin.bind(_assertThisInitialized$3(_this2));
    _this2.getRoleId = _this2.getRoleId.bind(_assertThisInitialized$3(_this2));
    _this2.getRoleIdBasedOnValue = _this2.getRoleIdBasedOnValue.bind(_assertThisInitialized$3(_this2));
    _this2.getRoleValueBasedOnId = _this2.getRoleValueBasedOnId.bind(_assertThisInitialized$3(_this2));
    _this2.getPlanSelectionBasedOnRole = _this2.getPlanSelectionBasedOnRole.bind(_assertThisInitialized$3(_this2));
    _this2.getPlanIdBasedOnRoleId = _this2.getPlanIdBasedOnRoleId.bind(_assertThisInitialized$3(_this2));
    _this2.getPlanValueBasedOnId - _this2.getPlanValueBasedOnId.bind(_assertThisInitialized$3(_this2));
    _this2.getPlanIdUsingValue = _this2.getPlanIdUsingValue.bind(_assertThisInitialized$3(_this2));
    _this2.onClickCreateOrganization = _this2.onClickCreateOrganization.bind(_assertThisInitialized$3(_this2));
    _this2.getOrganizationsList = _this2.getOrganizationsList.bind(_assertThisInitialized$3(_this2));
    _this2.onSelectOrganization = _this2.onSelectOrganization.bind(_assertThisInitialized$3(_this2));
    _this2.getUserTypesBasedOnRoleId = _this2.getUserTypesBasedOnRoleId.bind(_assertThisInitialized$3(_this2));
    return _this2;
  }

  _createClass$1(EditProfileCard, [{
    key: "onSelectOrganization",
    value: function onSelectOrganization(selectedBuildingObject) {
      var _this3 = this;

      this.setState({
        organization: selectedBuildingObject.label,
        organizationId: selectedBuildingObject._id
      }, function () {
        return window.console.log(_this3.state);
      });
    }
  }, {
    key: "getOrganizationsList",
    value: function getOrganizationsList(name_of_organization) {
      var _this4 = this;

      // eslint-disable-next-line no-undef
      var request = new HttpService(process.env.baseAPIPath);
      var payload = {
        "filter": ""
      };
      request.post("users/get_organisation_list", payload, function (response) {
        if (get(response, "data.success", false)) {
          var organizations = get(response, "data.data.organisation_list", []);

          _this4.setState({
            organizations: organizations
          }, function () {
            if (name_of_organization) {
              // filter the name of organization
              var selectedOrganization = _this4.state.organizations.filter(function (org) {
                return org.label === name_of_organization;
              });

              if (selectedOrganization.length) {
                _this4.onSelectOrganization(selectedOrganization[0]);
              }
            }
          });
        }
      });
    }
  }, {
    key: "onClickCreateOrganization",
    value: function onClickCreateOrganization(name_of_organization) {
      var _this5 = this;

      // eslint-disable-next-line no-undef
      var request = new HttpService(process.env.baseAPIPath);
      var payload = {
        "organisation": {
          "name": name_of_organization
        }
      };
      request.post("users/add_organisation", payload, function (response) {
        if (get(response, "data.success", false)) {
          window.postMessage({
            type: "notification",
            msg: "Organization created successfully"
          });

          _this5.getOrganizationsList(name_of_organization);
        } else {
          window.postMessage({
            type: "notification",
            msg: "Error while creating an organization"
          });
        }
      }, function (_error) {
        return window.postMessage({
          type: "notification",
          msg: "Error while creating an organization"
        });
      });
    }
  }, {
    key: "getUserTypesBasedOnRoleId",
    value: function getUserTypesBasedOnRoleId(roleId) {
      switch (roleId) {
        case 1:
          return "5ced1a18ff3085e86a0f2093";

        case 3:
          return "5ced1a18ff3085e86a0f2095";

        case 5:
          return "5f351eba20f4cb2d7ff24150";

        case 2:
          return "5ced1a18ff3085e86a0f2094";
      }
    }
  }, {
    key: "getRoleId",
    value: function getRoleId(planId) {
      switch (planId) {
        case 0:
          return 1;

        case 7:
          return 3;

        case 8:
          return 5;

        case 2:
        case 3:
        case 5:
        case 6:
          return 2;

        default:
          return null;
      }
    }
  }, {
    key: "getPlanIdBasedOnRoleId",
    value: function getPlanIdBasedOnRoleId(roleId) {
      switch (roleId) {
        case 1:
          return 0;

        case 3:
          return 7;

        case 5:
          return 8;

        case 2:
          return 2;
      }
    }
  }, {
    key: "getRoleIdBasedOnValue",
    value: function getRoleIdBasedOnValue(value) {
      switch (value) {
        case "Admin":
          return 1;

        case "Scanner":
          return 3;

        case "Organization admin":
          return 5;

        case "Agent":
          return 2;
      }
    }
  }, {
    key: "getRoleValueBasedOnId",
    value: function getRoleValueBasedOnId(id) {
      switch (id) {
        case 1:
          return ["Admin"];

        case 3:
          return ["Scanner"];

        case 5:
          return ["Organization admin"];

        case 2:
          return ["Agent"];

        default:
          return [];
      }
    }
  }, {
    key: "getPlanValueBasedOnId",
    value: function getPlanValueBasedOnId(id) {
      switch (id) {
        case 2:
          return ["Agent pro"];

        case 3:
          return ["Agent essentials"];

        case 5:
          return ["Management essentials"];

        case 6:
          return ["Management pro"];
      }
    }
  }, {
    key: "getPlanIdUsingValue",
    value: function getPlanIdUsingValue(value) {
      switch (value) {
        case "Agent pro":
          return 2;

        case "Agent essentials":
          return 3;

        case "Management essentials":
          return 5;

        case "Management pro":
          return 6;
      }
    }
  }, {
    key: "getPlanSelectionBasedOnRole",
    value: function getPlanSelectionBasedOnRole() {
      var roleId = this.state.roleId;

      switch (roleId) {
        case 2:
          return [{
            value: "Agent pro"
          }, {
            value: "Management pro"
          }];
      }
    }
  }, {
    key: "onRoleSelected",
    value: function onRoleSelected(value) {
      var roleId = this.getRoleIdBasedOnValue(value[0]);
      this.setState({
        roleId: roleId,
        planId: this.getPlanIdBasedOnRoleId(roleId)
      });
    }
  }, {
    key: "onPlanSelected",
    value: function onPlanSelected(value) {
      var planId = this.getPlanIdUsingValue(value[0]);
      this.setState({
        planId: planId,
        roleId: 2
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this6 = this;

      if (!this.props.isNewUser) {
        this.setState({
          loader: true
        }); // eslint-disable-next-line no-undef

        var request = new HttpService(process.env.baseAPIPath);
        var param = {
          user_id: this.userId
        };

        if (this.userId === JSON.parse(localStorage.getItem("user")).user_id) {
          request.get("users/get_profile_details", function (response) {
            if (response.data.success) {
              var _userObject = response.data.data.user_details;

              _this6.setState({
                name: _userObject.name,
                organization: _userObject.organisation,
                organizationId: _userObject.org_id,
                plan: _userObject.plan.plan_name,
                phone: _userObject.phone || "",
                email: _userObject.email,
                leadEmail: _userObject.leads_email || "",
                planId: _userObject.plan.plan_id,
                isActive: _userObject.is_active || false,
                loader: false
              });
            } else {
              _this6.setState({
                loader: false
              });

              window.postMessage({
                type: "notification",
                msg: "Error While Fetching User Details"
              });
            } // eslint-disable-next-line no-unused-vars

          }, function (_error) {
            window.postMessage({
              type: "notification",
              msg: "Error While Fetching User Details"
            });

            _this6.setState({
              loader: false
            });
          });
        } else {
          request.post("users/user_account_detail", param, function (response) {
            if (response.data.success) {
              var _userObject = response.data.data.user_detail;

              _this6.setState({
                name: _userObject.name,
                organization: _userObject.organisation,
                organizationId: _userObject.org_id,
                plan: _userObject.permission_id.plan_name,
                phone: _userObject.phone,
                email: _userObject.email,
                leadEmail: _userObject.leads_email,
                planId: _userObject.permission_id.plan_id,
                roleId: _userObject.permission_id.role_id,
                isActive: _userObject.is_active,
                loader: false
              });
            } else {
              _this6.setState({
                loader: false
              });

              window.postMessage({
                type: "notification",
                msg: "Error While Fetching User Details"
              });
            } // eslint-disable-next-line no-unused-vars

          }, function (_error) {
            window.postMessage({
              type: "notification",
              msg: "Error While Fetching User Details"
            });

            _this6.setState({
              loader: false
            });
          });
        }
      }

      if (!this.hideForSuperAdmin()) {
        // eslint-disable-next-line no-undef
        this.getOrganizationsList();
      }
    }
  }, {
    key: "validEmailTest",
    value: function validEmailTest(e) {
      if (API.checkEmail(e.currentTarget.value)) {
        this.setState({
          validEmail: true,
          emailDirty: true
        });
      } else {
        this.setState({
          validEmail: false,
          emailDirty: true
        });
      }
    }
  }, {
    key: "validLeadEmailTest",
    value: function validLeadEmailTest(e) {
      if (API.checkEmail(e.currentTarget.value)) {
        this.setState({
          validLeadEmail: true,
          leadEmailDirty: true
        });
      } else {
        this.setState({
          validLeadEmail: false,
          leadEmailDirty: true
        });
      }
    }
  }, {
    key: "hideForSuperAdmin",
    value: function hideForSuperAdmin() {
      var userDetails = JSON.parse(localStorage.getItem("user"));
      var permission_id = userDetails.permission_id;
      return permission_id !== "5e46727aef985be3147e7431";
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      var _this7 = this;

      if (this.validateForm()) {
        var payload = {
          "name": this.state.name,
          "phone": this.state.phone,
          "email": this.state.email,
          "leads_email": this.state.leadEmail,
          "user_id": this.userId
        };

        if (this.props.isFromUserTab) {
          Object.assign(payload, {
            "plan_id": this.state.planId,
            "is_active": this.state.isActive
          });
        } // handle the onSubmit for super Admin


        if (!this.hideForSuperAdmin()) {
          delete payload.is_active; // organization_id and user_type

          payload.plan_id = this.state.planId, payload.org_id = this.state.organizationId, payload.user_types = this.getUserTypesBasedOnRoleId(this.state.roleId);
        }

        var _this = this; // eslint-disable-next-line no-undef


        var request = new HttpService(process.env.baseAPIPath);
        request.post("users/update_user_profile", payload, function (response) {
          if (response.data.success) {
            var updateUserDetails = _objectSpread$9(_objectSpread$9({}, JSON.parse(localStorage.getItem("user"))), {}, {
              name: _this7.state.name,
              phone: _this7.state.phone,
              email: _this7.state.email
            });

            window.postMessage({
              type: "notification",
              msg: "".concat(_this.props.isFromUserTab && "Account " || "Profile ", "updated successfully.")
            });
            !_this.props.isFromUserTab && localStorage.setItem("user", JSON.stringify(updateUserDetails)) || false;
          } else {
            window.postMessage({
              type: "notification",
              msg: "Error while updating profile."
            });
          }

          _this7.props.onProfileUpdate();
        }, function (err) {
          return window.console.log(err);
        });
      }
    }
  }, {
    key: "onCreate",
    value: function onCreate() {
      var _this8 = this;

      if (this.validateForm()) {
        // eslint-disable-next-line no-undef
        var request = new HttpService(process.env.baseAPIPath);

        if (!this.hideForSuperAdmin() && this.state.organizationId.length === 0) {
          window.postMessage({
            type: "notification",
            msg: "Please select organization"
          });
          return;
        }

        var payload = {
          "name": this.state.name,
          "phone": this.state.phone,
          "email": this.state.email,
          "leads_email": this.state.leadEmail,
          "plan_id": this.state.planId.toString()
        };

        if (this.hideForSuperAdmin()) {
          payload.org_id = JSON.parse(localStorage.getItem("user")).org_id, payload.user_types = this.state.planId === 6 && "5ced1a18ff3085e86a0f2094" || "5f351eba20f4cb2d7ff24150";
        }

        if (!this.hideForSuperAdmin()) {
          // organization_id and user_type
          payload.org_id = this.state.organizationId, payload.user_types = this.getUserTypesBasedOnRoleId(this.state.roleId);
        }

        request.post("users/create_user", payload, function (response) {
          window.console.info(response);
          window.postMessage({
            type: "notification",
            msg: response && response.data && response.data.message || "Unknown message"
          });
          _this8.props.onProfileUpdate && _this8.props.onProfileUpdate();
        }, function (_error) {
          window.console.error(_error);
          window.postMessage({
            type: "notification",
            msg: "Error while updating profile."
          });
        });
      }
    }
  }, {
    key: "uploadImageToS3",
    value: function uploadImageToS3(dataObj) {
      var _this9 = this;

      this.setState({
        loader: true
      });
      this.props.uploadToS3(dataObj, function (err, data) {
        if (data) {
          _this9.setState({
            loader: false
          });

          window.postMessage({
            type: "notification",
            msg: "Image uploaded Successfully, It will be available once you reload the screen."
          });
        } else if (err) {
          _this9.setState({
            loader: false
          });

          window.postMessage({
            type: "notification",
            msg: "Image uploadation failed"
          });
        }
      });
    }
  }, {
    key: "openFileSelector",
    value: function openFileSelector() {
      var div = document.querySelector("#upload-div input");
      div.dispatchEvent(new MouseEvent("click"));
    }
  }, {
    key: "setActiveStatus",
    value: function setActiveStatus() {
      this.setState({
        isActive: !this.state.isActive
      });
    }
  }, {
    key: "setUserType",
    value: function setUserType() {
      this.setState({
        planId: this.state.planId === 8 && 6 || 8
      });
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      return this.state.name.length >= 5 && this.state.phone.length === 12 && API.checkPhone(this.state.phone) && this.state.email.length > 0 && this.state.validEmail && this.state.leadEmail.length > 0 && this.state.validLeadEmail;
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;

      var _this$props = this.props,
          isFromUserTab = _this$props.isFromUserTab,
          isNewUser = _this$props.isNewUser,
          hideStatus = _this$props.hideStatus;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "edit_profile_image"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "edit_profile_dialog_title"
      }, /*#__PURE__*/React__default.createElement("span", null, !isNewUser && (!isFromUserTab && "Edit profile" || "Edit account") || "Create new account")), !this.state.loader && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isNewUser && !isFromUserTab && /*#__PURE__*/React__default.createElement("div", {
        className: "profile_pic_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          backgroundImage: "url(".concat(this.props.ProfilePicUrl, ")")
        },
        onClick: function onClick() {
          return _this10.openFileSelector();
        },
        className: "profile_pic_container"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "edit_photo"
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Name"), /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(TextField$3, {
        value: this.state.name,
        hasError: this.state.namedirty && this.state.name.length < 5,
        errorMessage: "Name of user should contain at least 5 characters ",
        blur: function blur() {
          return _this10.setState({
            namedirty: true
          });
        },
        change: function change(e) {
          return _this10.setState({
            name: e
          });
        },
        isRequired: true
      }))), !isNewUser && !isFromUserTab && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Organization")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(TextField$3, {
        value: this.state.organization,
        disabled: true,
        isRequired: true
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Plan")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(TextField$3, {
        value: this.state.plan,
        disabled: true,
        isRequired: true
      })))), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Phone"), /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(TextField$3, {
        maxLength: 12,
        hasError: API.checkPhone(this.state.phone) === false && this.state.phoneDirty,
        mask: "999-999-9999",
        errorMessage: "Please enter mobile number in 999-999-9999 format",
        placeholder: "999-999-9999",
        blur: function blur() {
          return _this10.setState({
            phoneDirty: true
          });
        },
        value: this.state.phone,
        change: function change(e) {
          return _this10.setState({
            phone: e
          });
        },
        isRequired: true
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Email"), /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(TextField$3, {
        value: this.state.email,
        errorMessage: !this.state.validEmail && "Please enter valid email" || "field  is required",
        hasError: !this.state.validEmail && this.state.emailDirty,
        blur: function blur(e) {
          return _this10.validEmailTest(e);
        },
        change: function change(e) {
          return _this10.setState({
            email: e
          });
        },
        isRequired: true
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Leads Email"), /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(TextField$3, {
        value: this.state.leadEmail,
        errorMessage: !this.state.validLeadEmail && "Please enter valid email" || "field  is required",
        hasError: !this.state.validLeadEmail && this.state.leadEmailDirty,
        blur: function blur(e) {
          return _this10.validLeadEmailTest(e);
        },
        change: function change(e) {
          return _this10.setState({
            leadEmail: e
          });
        },
        isRequired: true
      }))), !isNewUser && !isFromUserTab && API.hasAdminAccess() && !hideStatus && /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Status"), /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(Toggle$1, {
        onText: "On",
        offText: "Off",
        onChange: function onChange() {
          return _this10.setActiveStatus();
        },
        on: this.state.isActive,
        off: !this.state.isActive
      }))), this.hideForSuperAdmin() && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (isFromUserTab || isNewUser) && (this.state.planId === 8 || this.state.planId === 6) && /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Type"), /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(Toggle$1, {
        onText: "Admin",
        offText: "User",
        onChange: function onChange() {
          return _this10.setUserType();
        },
        on: this.state.planId === 8,
        off: this.state.planId === 6
      })))) || null, !this.hideForSuperAdmin() && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Role"), /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(MultipleSelect, {
        placeholder: "Select Role",
        onSelect: function onSelect(values) {
          return _this10.onRoleSelected(values);
        },
        selected: this.getRoleValueBasedOnId(this.state.roleId),
        options: [{
          value: "Agent"
        }, {
          value: "Scanner"
        }, {
          value: "Organization admin"
        }]
      }))), this.state.roleId === 2 && /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Plan"), /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(MultipleSelect, {
        placeholder: "Select plan",
        onSelect: function onSelect(values) {
          return _this10.onPlanSelected(values);
        },
        selected: this.getPlanValueBasedOnId(this.state.planId),
        options: this.getPlanSelectionBasedOnRole()
      }))) || null, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Organization"), /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input auto_complete_wrapper"
      }, /*#__PURE__*/React__default.createElement(Autocomplete, {
        options: this.state.organizations.map(function (option) {
          return _objectSpread$9(_objectSpread$9({}, option), {}, {
            label: option.name
          });
        }),
        selectedValue: this.state.organization,
        showInlineCreate: true,
        onClickCreate: function onClickCreate(value) {
          return _this10.onClickCreateOrganization(value);
        },
        onSelect: function onSelect(value) {
          return _this10.onSelectOrganization(value);
        },
        primarySearchPlaceholder: "Search organizations",
        secondarySearchPlaceholder: "Create new organization"
      })))) || null, /*#__PURE__*/React__default.createElement("div", {
        className: "form_button_section"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        type: "default",
        label: "Cancel",
        onClick: function onClick() {
          _this10.props.onCancelClick();
        }
      }), !isNewUser && /*#__PURE__*/React__default.createElement(Button$2, {
        type: this.validateForm() && "standard" || "default",
        label: "Save changes",
        onClick: function onClick() {
          return _this10.onSubmit();
        }
      }) || /*#__PURE__*/React__default.createElement(Button$2, {
        type: this.validateForm() && "standard" || "default",
        label: "Create",
        onClick: function onClick() {
          return _this10.onCreate();
        }
      }))) || /*#__PURE__*/React__default.createElement("div", {
        className: "_spinner_loader_generic"
      }, /*#__PURE__*/React__default.createElement(Spinner, null)), /*#__PURE__*/React__default.createElement("div", {
        id: "hide_file_uploader"
      }, /*#__PURE__*/React__default.createElement(FileUploader, {
        maxFileSize: 3000000,
        listingId: this.props.userId // eslint-disable-next-line no-undef
        ,
        bucketName: process.env.profilePicBucketName,
        region: "us-east-1",
        identityPoolId: "us-east-1:3313ffcc-3d39-499a-aee3-031d52b5d5cb" // eslint-disable-next-line no-undef
        ,
        bucketUrl: "https://".concat(process.env.profilePicBucketName, ".s3.amazonaws.com/") // eslint-disable-next-line no-undef
        ,
        path: "".concat(this.userId, "/ProfilePicture.jpg"),
        allowedExtensions: [".jpeg", ".jpg", ".png"],
        errorMessage: "Please upload an image in JPG or PNG format less than 3MB",
        change: function change(e) {
          return window.console.log(e, "window close");
        },
        hasExplicitFileName: true,
        explicitFileName: "ProfilePicture.jpg",
        uploadToS3: function uploadToS3(data) {
          return _this10.uploadImageToS3(data);
        }
      })));
    }
  }]);

  return EditProfileCard;
}(Component);

EditProfileCard.defaultProps = {
  isFromUserTab: false,
  hideStatus: false
};
EditProfileCard.propTypes = {
  userId: PropTypes.string,
  onProfileUpdate: PropTypes.func,
  onCancelClick: PropTypes.func,
  ProfilePicUrl: PropTypes.string,
  uploadToS3: PropTypes.func,
  isFromUserTab: PropTypes.bool,
  isNewUser: PropTypes.bool,
  hideStatus: PropTypes.bool
};

var ResetPassword = function ResetPassword(props) {
  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      newPassword = _useState2[0],
      setNewPassword = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray$1(_useState3, 2),
      newPasswordConfirm = _useState4[0],
      setNewPasswordConfirm = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$1(_useState5, 2),
      validNewPassword = _useState6[0],
      setValidNewPassword = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray$1(_useState7, 2),
      hasPasswordDiff = _useState8[0],
      setHasPaswordDiff = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray$1(_useState9, 2),
      dirtyPassword = _useState10[0],
      setDirtyPassword = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray$1(_useState11, 2),
      dirtyConfirmPassword = _useState12[0],
      setDirtyConfirmPassword = _useState12[1];

  var validateEmail = function validateEmail(passwordKey, value) {
    var isValid = API.checkPassword(value);

    switch (passwordKey) {
      case "newPassword":
        {
          if (isValid) {
            setValidNewPassword(true);
          } else {
            setValidNewPassword(false);
          }
        }
        break;
    }
  };

  var comparePassword = function comparePassword(e) {
    setHasPaswordDiff(newPassword === e);
    setNewPasswordConfirm(e);
  };

  var submit = function submit() {
    // eslint-disable-next-line no-undef
    var request = new HttpService(process.env.baseAPIPath);
    var payload = {
      user_id: JSON.parse(localStorage.getItem("user")).user_id,
      password: newPasswordConfirm
    };
    request.post("users/set_new_password", payload, function (response) {
      if (response.data.success) {
        window.postMessage({
          type: "notification",
          msg: "Password is updated"
        });
        props.onCancelClick();
      } else {
        window.postMessage({
          type: "notification",
          msg: "Error while Updating password"
        });
        props.onCancelClick();
      }
    }, function () {
      window.postMessage({
        type: "notification",
        msg: "Error while Updating password"
      });
      props.onCancelClick();
    });
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "change_password_window"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "edit_profile_dialog_title"
  }, "Change password"), /*#__PURE__*/React__default.createElement("div", {
    className: "inline-form-control"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "inline-form-label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "label"
  }, "New password")), /*#__PURE__*/React__default.createElement("span", {
    className: "inline-form-ctrl"
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    type: "password",
    placeholder: "New Password",
    value: newPassword,
    errorMessage: "Password must be at least 8 characters.  It must contain at least one uppercase, one lowercase, one digit and a special character. ",
    hasError: !validNewPassword && dirtyPassword,
    blur: function blur(e) {
      setDirtyPassword(true);
      validateEmail("newPassword", e.currentTarget.value);
    },
    change: function change(e) {
      return setNewPassword(e);
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "inline-form-control"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "inline-form-label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "label"
  }, "Confirm new password"), /*#__PURE__*/React__default.createElement("span", {
    className: "red"
  }, "*")), /*#__PURE__*/React__default.createElement("span", {
    className: "inline-form-ctrl"
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    type: "password",
    placeholder: "Confirm New Password",
    value: newPasswordConfirm,
    errorMessage: !hasPasswordDiff && "New Password and Confirm new Password should match." || "",
    hasError: !hasPasswordDiff && dirtyConfirmPassword,
    change: function change(e) {
      return comparePassword(e);
    },
    blur: function blur() {
      return setDirtyConfirmPassword(true);
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "form_button_section"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "default",
    label: "Cancel",
    onClick: function onClick() {
      props.onCancelClick(false);
    }
  }), hasPasswordDiff && validNewPassword && newPassword.length === newPasswordConfirm.length && /*#__PURE__*/React__default.createElement(Button$2, {
    label: "Save Changes",
    onClick: function onClick() {
      return submit();
    }
  }), (!hasPasswordDiff || !validNewPassword || newPassword.length !== newPasswordConfirm.length) && /*#__PURE__*/React__default.createElement(Button$2, {
    type: "disabled",
    label: "Submit"
  })));
};

ResetPassword.propTypes = {
  userId: PropTypes.string,
  onCancelClick: PropTypes.func
};

var ProfileCard = function ProfileCard(props) {
  var getProfilePicUrl = function getProfilePicUrl(agent_id) {
    // eslint-disable-next-line no-undef
    return encodeURI("".concat(process.env.userProfileImageBasePath).concat(agent_id, "/ProfilePicture.jpg"));
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      showEditInfo = _useState2[0],
      setShowEditInfo = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      changePassword = _useState4[0],
      setChangePassword = _useState4[1];

  var onProfileUpdate = function onProfileUpdate() {
    props.onUpdate && props.onUpdate();
    setShowEditInfo(false);
    props.onClickEdit && props.onClickEdit();
  };

  var logout = function logout() {
    // eslint-disable-next-line no-undef
    var request = new HttpService(process.env.baseAPIPath);
    request.get("users/logout", function () {
      localStorage.setItem("user", "");
      localStorage.setItem("piiq-auth-token", "");
      localStorage.setItem("token", "");
      localStorage.setItem("persist:root", "");
      sessionStorage.setItem("is_viewed_highlight", false);
      localStorage.clear();
      window.location.href = "/";
    }, function (error) {
      return window.console.error(error);
    });
  };

  var onCancelClick = function onCancelClick() {
    setShowEditInfo(false);
    props.onCancelClick && props.onCancelClick();
  };

  var userDetails = JSON.parse(localStorage.getItem("user")); // eslint-disable-next-line no-unused-vars

  var name = userDetails.name,
      email = userDetails.email;
      userDetails.org_id;
      var organisation = userDetails.organisation,
      permission_id = userDetails.permission_id;
      userDetails.plan_id;
      userDetails.region;
      var user_id = userDetails.user_id,
      user_type = userDetails.user_type;
      userDetails.user_type_id;

  var hideForSuperAdmin = function hideForSuperAdmin() {
    return permission_id !== "5e46727aef985be3147e7431";
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "profile_card"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "name_dp"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dp_image",
    style: {
      background: "url(".concat(getProfilePicUrl(user_id), ")")
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "name_image"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "name"
  }, name), /*#__PURE__*/React__default.createElement("span", {
    className: "subtext"
  }, email))), /*#__PURE__*/React__default.createElement("div", {
    className: "user_subsciption"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "name"
  }, "Plan"), /*#__PURE__*/React__default.createElement("span", {
    className: "subtext"
  }, user_type)), /*#__PURE__*/React__default.createElement("div", {
    className: "user_subsciption organization_info"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "name"
  }, "Organization"), /*#__PURE__*/React__default.createElement("span", {
    className: "subtext"
  }, organisation)), hideForSuperAdmin() && /*#__PURE__*/React__default.createElement("div", {
    className: "button_control"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "admin_control",
    label: "Edit profile",
    onClick: function onClick() {
      return setShowEditInfo(true);
    }
  })) || null, hideForSuperAdmin() && /*#__PURE__*/React__default.createElement("div", {
    className: "button_control"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "admin_control",
    label: "Change password",
    onClick: function onClick() {
      return setChangePassword(true);
    }
  })) || null, /*#__PURE__*/React__default.createElement("div", {
    className: "button_control"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "logout",
    label: "Log out",
    onClick: function onClick() {
      return logout();
    }
  }))), showEditInfo && /*#__PURE__*/React__default.createElement(Portal$2, {
    nodename: "showEditInfo",
    click: onCancelClick
  }), showEditInfo && /*#__PURE__*/React__default.createElement(Portal$2, {
    nodename: "edit_user_profile_window"
  }, /*#__PURE__*/React__default.createElement(EditProfileCard, {
    hideStatus: true,
    uploadToS3: props.uploadToS3,
    onCancelClick: onCancelClick,
    onProfileUpdate: onProfileUpdate,
    userId: user_id,
    ProfilePicUrl: getProfilePicUrl(user_id)
  })), changePassword && /*#__PURE__*/React__default.createElement(Portal$2, {
    nodename: "showEditInfo",
    click: function click() {
      return setChangePassword(false);
    }
  }), changePassword && /*#__PURE__*/React__default.createElement(Portal$2, {
    nodename: "edit_user_profile_window"
  }, /*#__PURE__*/React__default.createElement(ResetPassword, {
    onCancelClick: setChangePassword
  })));
};

ProfileCard.propTypes = {
  onUpdate: PropTypes.func,
  onClickEdit: PropTypes.func,
  uploadToS3: PropTypes.func,
  onCancelClick: PropTypes.func
};

var css_248z$k = ".profile-container {\n  display: flex;\n  cursor: pointer; }\n  .profile-container .profile-wrapper {\n    background: #1d1c38;\n    border-radius: 50%;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n    .profile-container .profile-wrapper img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      border-radius: 50%; }\n    .profile-container .profile-wrapper.is-disabled {\n      opacity: 0.5; }\n  .profile-container .user-name {\n    font-family: Roboto-Regular;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 18px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.02em;\n    padding: 0 18px;\n    padding-top: 3px; }\n";
styleInject(css_248z$k);

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NamedProfile = /*#__PURE__*/function (_Component) {
  _inherits$1(NamedProfile, _Component);

  var _super = _createSuper$e(NamedProfile);

  function NamedProfile(props) {
    var _this;

    _classCallCheck$1(this, NamedProfile);

    _this = _super.call(this, props);
    _this.state = {
      isError: false
    };
    _this.onError = _this.onError.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(NamedProfile, [{
    key: "onError",
    value: function onError(ev) {
      ev.target.remove();
      this.setState({
        isError: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React__default.createElement("div", {
        className: "profile-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: ["profile-wrapper", this.props.isDisabled ? "is-disabled" : ""].join(" "),
        style: {
          width: this.props.width,
          height: this.props.height
        }
      }, this.props.image && /*#__PURE__*/React__default.createElement("img", {
        src: this.props.image,
        onError: function onError(_ev) {
          return _this2.onError(_ev);
        }
      }), !this.props.image || this.state.isError && /*#__PURE__*/React__default.createElement(MemoSvgUser, null)));
    }
  }]);

  return NamedProfile;
}(Component);

NamedProfile.defaultProps = {
  color: "#000"
};
NamedProfile.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
  image: PropTypes.string,
  color: PropTypes.string
};

var css_248z$j = ".colorPicketPallet {\n  display: block;\n  position: absolute;\n  width: 250px;\n  box-sizing: border-box;\n  background: #f2f2f2;\n  border-radius: 5px;\n  margin: 0;\n  padding: 30px 33px; }\n\n.color_section {\n  width: 36px;\n  height: 36px;\n  background: red;\n  border-radius: 50%;\n  display: inline-block;\n  margin: 5px;\n  cursor: pointer;\n  position: relative; }\n  .color_section span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n\n.colorPickerPen {\n  display: flex;\n  align-items: center; }\n";
styleInject(css_248z$j);

var listOfColors = ["#fff", "#73D288", "#53CDE8", "#5362E8", "#979797", "#FFC700", "#FF7A00", "#E85353", "#231F20", "#FF00E5", "#9C44E0"];

var ColorPicker = function ColorPicker(props) {
  if (props.selectedColor) {
    if (listOfColors.indexOf(props.selectedColor) === -1) {
      listOfColors.push(props.selectedColor);
    }
  }

  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      color = _useState2[0],
      setColor = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      showColor = _useState4[0],
      setShowColor = _useState4[1];

  var inputTextColor = function inputTextColor(value) {
    if (listOfColors.indexOf(value) === -1 && value.length === 7) {
      listOfColors.push(value);
      props.onColorSelect(value);
    }

    setColor(value);
  };

  useEffect(function () {
    setColor(props.selectedColor);
  }, []);

  function selectedColorAction(_color) {
    setColor(_color);
    setShowColor(false);
    props.onColorSelect(_color);
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "colorPickerPen",
    onClick: function onClick() {
      setShowColor(!showColor);
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "pen"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "color_section",
    style: {
      backgroundColor: color
    }
  })), showColor && /*#__PURE__*/React__default.createElement("div", {
    className: "colorPicketPallet"
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, listOfColors.map(function (_color, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      onClick: function onClick() {
        selectedColorAction(_color);
      },
      style: {
        backgroundColor: _color
      },
      className: "color_section"
    }, color === _color && /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Icon, {
      name: "checkmark",
      color: (_color === "#fff" || _color === "#ffffff") && "#383838" || "#ffffff"
    })));
  })), /*#__PURE__*/React__default.createElement(TextField$3, {
    maxlength: "6",
    value: color,
    change: inputTextColor
  })));
};

ColorPicker.propTypes = {
  selectedColor: PropTypes.string,
  onColorSelect: PropTypes.func.isRequired
};
var ColorPicker$1 = /*#__PURE__*/React__default.memo(ColorPicker);

var css_248z$i = "div.tabs-nav.nav.navbar-nav.navbar-left {\n  display: flex;\n  box-sizing: border-box;\n  border-bottom: solid 0.2px #c4c4c4; }\n\ndiv.tab {\n  padding-bottom: 15px;\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: #c7c7c7;\n  padding: 10px;\n  cursor: pointer;\n  text-transform: capitalize;\n  display: flex;\n  justify-content: space-between;\n  align-items: self-start;\n  min-width: 80px; }\n\ndiv.tab.active {\n  border-bottom: solid 0.5px;\n  color: #1D1C38; }\n";
styleInject(css_248z$i);

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TabsContainer = /*#__PURE__*/function (_React$Component) {
  _inherits$1(TabsContainer, _React$Component);

  var _super = _createSuper$d(TabsContainer);

  function TabsContainer(props, context) {
    var _this;

    _classCallCheck$1(this, TabsContainer);

    _this = _super.call(this, props, context);
    _this.state = {
      activeTabIndex: 0
    };
    _this.handleTabClick = _this.handleTabClick.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(TabsContainer, [{
    key: "handleTabClick",
    value: function handleTabClick(tabIndex) {
      this.setState({
        activeTabIndex: tabIndex === this.state.activeTabIndex ? this.props.defaultActiveTabIndex : tabIndex
      });
    } // Encapsulate <Tabs/> component API as props for <Tab/> children

  }, {
    key: "renderChildrenWithTabsApiAsProps",
    value: function renderChildrenWithTabsApiAsProps() {
      var _this2 = this;

      return React__default.Children.map(this.props.children, function (child, index) {
        return /*#__PURE__*/React__default.cloneElement(child, {
          onClick: _this2.handleTabClick,
          tabIndex: index,
          isActive: index === _this2.state.activeTabIndex
        });
      });
    } // Render current active tab content

  }, {
    key: "renderActiveTabContent",
    value: function renderActiveTabContent() {
      var children = this.props.children;
      var activeTabIndex = this.state.activeTabIndex;

      if (children[activeTabIndex]) {
        return children[activeTabIndex].props.children;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "tabs"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "tabs-nav nav navbar-nav navbar-left"
      }, this.renderChildrenWithTabsApiAsProps()), /*#__PURE__*/React__default.createElement("div", {
        className: "tabs-active-content"
      }, this.renderActiveTabContent()));
    }
  }]);

  return TabsContainer;
}(React__default.Component);

TabsContainer.propTypes = {
  defaultActiveTabIndex: PropTypes.number,
  children: PropTypes.any
};
TabsContainer.defaultProps = {
  defaultActiveTabIndex: null
};
var Tabs = /*#__PURE__*/React__default.memo(TabsContainer);

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Tab = /*#__PURE__*/function (_React$Component) {
  _inherits$1(Tab, _React$Component);

  var _super = _createSuper$c(Tab);

  function Tab(props, context) {
    var _this;

    _classCallCheck$1(this, Tab);

    _this = _super.call(this, props, context);
    _this.handleTabClick = _this.handleTabClick.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(Tab, [{
    key: "handleTabClick",
    value: function handleTabClick() {
      this.props.onClick(this.props.tabIndex);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return _this2.handleTabClick();
        },
        className: "tab ".concat(this.props.isActive ? "active" : "")
      }, this.props.tabTitle, this.props.iconName && /*#__PURE__*/React__default.createElement(Icon, {
        name: this.props.iconName,
        color: this.props.iconColor || "#000",
        width: 20,
        height: 20
      }));
    }
  }]);

  return Tab;
}(React__default.Component);

Tab.propTypes = {
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
  isActive: PropTypes.bool,
  tabTitle: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  iconColor: PropTypes.string
};
var Tab$1 = /*#__PURE__*/React__default.memo(Tab);

var css_248z$h = ".dropdown {\n  position: relative;\n  margin: 0 auto;\n  width: 100%;\n  border-radius: 35px;\n  background: #ffff;\n  box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1; }\n\n.dropdown__text {\n  padding: 10px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  height: 15px;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 17px;\n  display: flex;\n  align-items: center;\n  color: #383838; }\n\n.dropdown__text:after {\n  content: \"\";\n  border-style: solid;\n  border-color: attr(dataarrowcolor);\n  border-width: 0 1px 1px 0;\n  margin: 0 8px;\n  padding: 3px;\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg); }\n\n.dropdown.active .dropdown__text:after {\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg); }\n\n.dropdown__items {\n  position: absolute;\n  visibility: hidden;\n  opacity: 0;\n  overflow: auto;\n  max-height: 0px;\n  transition: max-height 0.6s ease; }\n\n.dropdown.active .dropdown__items {\n  visibility: visible;\n  height: auto;\n  max-height: 100px;\n  opacity: 1;\n  width: 100%;\n  border-radius: 5px;\n  margin-top: 5px;\n  z-index: 10000;\n  box-shadow: 5px 5px 5px #c4c4c4;\n  overflow: auto;\n  transition: max-height 0.5s, opacity 0.5s, visibility 0.5s ease; }\n\n.dropdown__item {\n  cursor: pointer;\n  padding: 10px 20px;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-size: 13px;\n  line-height: 15px;\n  letter-spacing: 0.02em;\n  background-color: white;\n  color: #383838; }\n\n.dropdown__item:hover {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 14px;\n  letter-spacing: 0.02em;\n  background: linear-gradient(0deg, rgba(4, 210, 198, 0.1), rgba(4, 210, 198, 0.1)), #FFFFFF;\n  color: #383838; }\n\n.selected_text {\n  width: 120px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap; }\n";
styleInject(css_248z$h);

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Dropdown = /*#__PURE__*/function (_Component) {
  _inherits$1(Dropdown, _Component);

  var _super = _createSuper$b(Dropdown);

  function Dropdown(props) {
    var _this;

    _classCallCheck$1(this, Dropdown);

    _this = _super.call(this, props);
    _this.state = {
      isOpen: false,
      haveText: ""
    };
    _this.setDropdownModalRef = _this.setDropdownModalRef.bind(_assertThisInitialized$3(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized$3(_this));
    _this.handleText = _this.handleText.bind(_assertThisInitialized$3(_this));
    _this.itemList = _this.itemList.bind(_assertThisInitialized$3(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mousedown", this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
  }, {
    key: "setDropdownModalRef",
    value: function setDropdownModalRef(node) {
      this.modalRef = node;
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.modalRef && !this.modalRef.contains(event.target)) {
        this.setState({
          isOpen: false
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "handleText",
    value: function handleText(ev) {
      var buildingId = ev.currentTarget.getAttribute("data-building-id");

      if (buildingId) {
        this.props.change(buildingId);
      } else {
        this.props.change(ev.currentTarget.textContent);
      }

      this.setState({
        haveText: ev.currentTarget.textContent
      });
    }
  }, {
    key: "itemList",
    value: function itemList() {
      var _this2 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (this.props.isArrayOfObject) {
        var prop = Array.from(props);
        var list = prop.map(function (item) {
          return /*#__PURE__*/React__default.createElement("div", {
            onClick: _this2.handleText,
            className: "dropdown__item",
            "data-building-id": item._id,
            key: item[_this2.props.returnKey].toString()
          }, item[_this2.props.altName] ? item[_this2.props.altName] : item[_this2.props.keyName]);
        });
        return /*#__PURE__*/React__default.createElement("div", {
          className: "dropdown__items"
        }, " ", list, " ");
      } else {
        var _prop = Array.from(props);

        var _list = _prop.map(function (item) {
          return /*#__PURE__*/React__default.createElement("div", {
            onClick: _this2.handleText,
            className: "dropdown__item",
            key: item.toString()
          }, item);
        });

        return /*#__PURE__*/React__default.createElement("div", {
          className: "dropdown__items"
        }, " ", _list, " ");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          haveText = _this$state.haveText;
      return /*#__PURE__*/React__default.createElement("div", {
        ref: this.setDropdownModalRef,
        className: isOpen ? "dropdown active" : "dropdown",
        onClick: this.handleClick
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown__text",
        dataarrowcolor: this.props.arrowColor
      }, /*#__PURE__*/React__default.createElement("span", {
        className: get(this.props, "truncateSelectedText", false) ? "selected_text" : ""
      }, !haveText || this.props.value === "" ? this.props.value ? this.props.value : this.props.placeholder : this.props.value ? this.props.value : haveText)), this.itemList(this.props.dropdownList));
    }
  }]);

  return Dropdown;
}(Component);

Dropdown.defaultProps = {
  placeholder: "",
  dropdownList: [],
  arrowColor: "#ccc"
};
Dropdown.propTypes = {
  placeholder: PropTypes.string,
  dropdownList: PropTypes.array,
  change: PropTypes.func,
  isArrayOfObject: PropTypes.bool,
  keyName: PropTypes.string,
  altName: PropTypes.string,
  returnKey: PropTypes.string,
  value: PropTypes.string,
  arrowColor: PropTypes.string,
  truncateSelectedText: PropTypes.bool
};
var Dropdown$1 = /*#__PURE__*/React__default.memo(Dropdown);

var css_248z$g = "* {\n  margin: 0;\n  padding: 0;\n  list-style-type: none; }\n\n* {\n  scrollbar-width: none;\n  /* Firefox */\n  -ms-overflow-style: none;\n  /* IE 10+ */ }\n  * ::-webkit-scrollbar-track {\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    background-color: transparent; }\n  * ::-webkit-scrollbar {\n    width: 3px !important;\n    background-color: transparent; }\n  * ::-webkit-scrollbar-thumb {\n    background-color: transparent; }\n\n.on-scrollbar {\n  scrollbar-width: thin;\n  -ms-overflow-style: none; }\n  .on-scrollbar::-webkit-scrollbar {\n    width: 3px !important;\n    height: 3px !important;\n    background-color: #fff; }\n  .on-scrollbar::-webkit-scrollbar-thumb {\n    background-color: #dadada !important; }\n\n.listings_details .page_header {\n  color: #1d1c38;\n  padding: 0px 22px 18px 30px;\n  font-size: 18px;\n  line-height: 34px;\n  font-weight: normal !important;\n  margin: 0 22px 18px 0;\n  display: flex;\n  gap: 1rem;\n  align-items: center; }\n  .listings_details .page_header .label_input_field {\n    position: relative;\n    display: flex;\n    align-items: center;\n    flex-direction: row; }\n    .listings_details .page_header .label_input_field .label_field {\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n      font-style: normal;\n      font-weight: bold;\n      font-size: 22px;\n      line-height: 26px;\n      color: #1d1c38;\n      border: 1px solid #1d1c38;\n      background: #fafafa;\n      padding: 0 20px 2px 10px;\n      border-radius: 7px;\n      display: flex;\n      align-items: center;\n      flex-direction: row; }\n      .listings_details .page_header .label_input_field .label_field.not_editable {\n        border: 1px solid transparent;\n        pointer-events: none; }\n    .listings_details .page_header .label_input_field .button__icon {\n      position: absolute;\n      right: 2px;\n      top: 6px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      flex-direction: row; }\n  .listings_details .page_header span._listing_details_title {\n    font-weight: 700; }\n\n.listing_details_wrapper {\n  display: flex;\n  gap: 24px;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 0 30px; }\n  .listing_details_wrapper .edit-listing_modal_container form .listing-modal-area {\n    transform: none;\n    width: 100%;\n    max-height: none;\n    left: auto;\n    top: auto;\n    margin-top: 6px; }\n  @media only screen and (max-width: 1280px) {\n    .listing_details_wrapper {\n      flex-direction: column; } }\n\n.notification_wrapper {\n  display: flex;\n  padding: 10px;\n  border-radius: 5px;\n  background: rgba(129, 129, 165, 0.1);\n  margin-bottom: 5px; }\n\n.notificationTitle {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  color: #383838;\n  margin-bottom: 5px; }\n\n.notificationBody {\n  font-size: 12px;\n  line-height: 14px;\n  color: #383838; }\n\n.notification_details {\n  width: 90%; }\n\n.notification_status {\n  width: 10%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end; }\n\n.notificationTime {\n  font-size: 9px;\n  color: #383838; }\n\n.readStatus {\n  width: 7px;\n  height: 7px;\n  background-color: #04d2c6;\n  border-radius: 25px;\n  margin-top: 5px; }\n\n.notifications_container {\n  padding: 15px 28px 15px 28px;\n  height: 390px;\n  overflow-y: scroll;\n  margin-right: 4px;\n  margin-top: 6px; }\n\n.activityFeed_container {\n  width: 35%; }\n  @media only screen and (max-width: 1280px) {\n    .activityFeed_container {\n      width: 100%; } }\n\n.viewer_editlistings_container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 17px; }\n\n.activity_feed_wrapper {\n  background: #fff;\n  border-radius: 6px;\n  min-width: 250px;\n  box-sizing: border-box; }\n\n.totalImpression_wrapper {\n  margin-top: 1rem; }\n  .totalImpression_wrapper .time-series-div {\n    margin-top: 17px;\n    background-color: white;\n    max-height: 380px;\n    box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n    border-radius: 4px;\n    padding: 23px 30px;\n    box-sizing: border-box; }\n\n.virtual_tour_wrapper {\n  box-sizing: border-box;\n  border-radius: 6px;\n  text-transform: capitalize;\n  min-width: 250px;\n  min-height: 444px; }\n\n.viewer_filters {\n  display: flex;\n  justify-content: flex-end;\n  flex: 1; }\n  @media screen and (max-width: 569px) {\n    .viewer_filters {\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      padding-left: 10px; } }\n  .viewer_filters .action_item_button_icon {\n    display: flex;\n    padding: 12px 18px;\n    border-radius: 64px;\n    cursor: pointer;\n    justify-content: center;\n    align-items: center;\n    background: #fff;\n    margin-left: 15px;\n    box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1; }\n    @media screen and (max-width: 1000px) {\n      .viewer_filters .action_item_button_icon {\n        padding: 8px 12px;\n        margin-left: 10px; } }\n    @media screen and (max-width: 569px) {\n      .viewer_filters .action_item_button_icon {\n        margin-top: 10px; } }\n    .viewer_filters .action_item_button_icon span {\n      display: flex;\n      align-items: center; }\n      .viewer_filters .action_item_button_icon span.icon_text {\n        margin-left: 10px;\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: bold;\n        font-size: 14px;\n        line-height: 16px;\n        display: flex;\n        align-items: center;\n        text-align: center;\n        color: #04d2c6; }\n        @media screen and (max-width: 1210px) {\n          .viewer_filters .action_item_button_icon span.icon_text {\n            display: none; } }\n\n.editListings_wrapper {\n  background: #ffffff;\n  box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n  border-radius: 5px;\n  height: 710px;\n  width: 92%;\n  padding: 22px 30px;\n  margin-top: 73px; }\n\n#viewer_container_listings_details {\n  height: 444px; }\n\n#viewer_container_listings_details_fullscreen {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1600; }\n\n@media only screen and (max-width: 767px) {\n  .tour_like {\n    font-size: 1.3em;\n    padding: 16px 28px; } }\n\n.listing-modal-area {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 95vw;\n  transform: translate(-50%, -50%);\n  max-height: 90vh;\n  overflow: auto;\n  background-color: #ffffff;\n  padding: 3em;\n  box-sizing: border-box;\n  border-radius: 4px; }\n  .listing-modal-area .header-div {\n    display: flex;\n    align-items: center;\n    justify-content: space-between; }\n    .listing-modal-area .header-div .container-checkbox .container-checkbox .label {\n      line-height: 21px; }\n  .listing-modal-area .edit-listing-form {\n    display: flex;\n    gap: 12px;\n    box-sizing: border-box;\n    border-bottom: none;\n    padding-bottom: 26px;\n    padding-top: 18px; }\n  .listing-modal-area .edit-text-info-div {\n    padding: 0; }\n  .listing-modal-area .rename-room-div {\n    display: flex;\n    justify-content: space-between;\n    gap: 5px 12px;\n    flex-wrap: wrap;\n    height: auto;\n    padding-right: 0;\n    max-width: 475px; }\n    .listing-modal-area .rename-room-div .room-name-span {\n      flex-basis: 48%;\n      flex-grow: 1; }\n  .listing-modal-area .prospect_form .prospect_form__title {\n    font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 28px;\n    letter-spacing: -0.01em;\n    text-transform: capitalize;\n    color: #545454; }\n  .listing-modal-area .prospect_form .prospect_form__checks {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    max-width: 290px; }\n    .listing-modal-area .prospect_form .prospect_form__checks .container-checkbox {\n      cursor: pointer; }\n    .listing-modal-area .prospect_form .prospect_form__checks .is-disabled {\n      pointer-events: none; }\n      .listing-modal-area .prospect_form .prospect_form__checks .is-disabled .label {\n        color: rgba(56, 56, 56, 0.5); }\n\n@media only screen and (max-width: 990px) {\n  .listing-modal-area .edit-listing-form {\n    flex-wrap: wrap; }\n  .file-div,\n  .uploader-div {\n    width: 100% !important; } }\n\n.listing-modal-area .texxtfieldWrapper,\n.listing-modal-area .controller_wrapper,\n.listing-modal-area .listing-span,\n.listing-modal-area .peek_textarea {\n  background: #FFFFFF;\n  box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1;\n  border-radius: 5px; }\n\n.listing-modal-area .listing-span:focus-within, .listing-modal-area .texxtfieldWrapper:focus-within {\n  background: #F5F5FA !important;\n  border: 1px solid #1D1C38; }\n  .listing-modal-area .listing-span:focus-within input.listing-input, .listing-modal-area .texxtfieldWrapper:focus-within input.listing-input {\n    border: none;\n    background: #F5F5FA !important; }\n\n.listing-modal-area .amenities-div {\n  justify-content: space-between; }\n\n.listing-modal-area .textfield_wrapper {\n  margin: 1px; }\n\n.listing-modal-area .edit-modal-btn {\n  display: flex;\n  justify-content: center;\n  gap: 6px; }\n\n.listing-modal-area .dollar-span .controller_wrapper {\n  border: none; }\n\n@media only screen and (max-width: 810px) {\n  .listings_details .page_header {\n    padding: 0 10px; }\n  .time-series-div-view-source {\n    margin-bottom: 1rem !important; }\n  .listing_details_wrapper {\n    padding: 0 5px;\n    margin: 0;\n    flex-direction: column; }\n    .listing_details_wrapper .activityFeed_container {\n      flex: 1;\n      width: 100%; } }\n\n.listing_collpased_entry {\n  display: flex;\n  justify-content: flex-start;\n  padding: 11px 12px;\n  background: #fff;\n  border-radius: 6px;\n  min-width: 750px;\n  align-items: center;\n  box-sizing: border-box;\n  border-bottom: solid 3px #1d1c38;\n  box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1;\n  height: 48px; }\n\n.listing_collpased_entry_dark {\n  display: flex;\n  justify-content: flex-start;\n  padding: 11px 12px;\n  background: #fff;\n  border-radius: 6px 6px 0 0;\n  min-width: 750px;\n  align-items: center;\n  box-sizing: border-box;\n  color: #fff;\n  background-color: #1d1c38;\n  height: 48px; }\n\n.filter-div {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 12px; }\n  .filter-div .listing-info-div {\n    display: flex; }\n    .filter-div .listing-info-div .listing-info-block {\n      width: 168px;\n      padding: 10px 25px;\n      display: flex;\n      height: 44px;\n      margin-right: 10px;\n      align-items: center;\n      justify-content: space-between;\n      background: white;\n      border-radius: 4px;\n      box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1; }\n      .filter-div .listing-info-div .listing-info-block .info-title {\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 16px;\n        color: #000000; }\n      .filter-div .listing-info-div .listing-info-block .info-subtitle {\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 11px;\n        line-height: 13px;\n        color: #333333; }\n      .filter-div .listing-info-div .listing-info-block .info-data {\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 33px;\n        line-height: 39px;\n        letter-spacing: -0.02em;\n        text-transform: capitalize;\n        color: #383838; }\n  .filter-div .date-range-div {\n    display: flex;\n    filter: drop-shadow(0px 2px 5px #EBEFF1) drop-shadow(0px 0px 20px #EBEFF1); }\n    .filter-div .date-range-div div .active-date-btn,\n    .filter-div .date-range-div div .active-date-btn:focus {\n      width: 40px;\n      height: 34px;\n      margin-right: 2px;\n      border-radius: 1px; }\n      .filter-div .date-range-div div .active-date-btn span,\n      .filter-div .date-range-div div .active-date-btn:focus span {\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: bold;\n        font-size: 11px;\n        line-height: 13px;\n        display: flex;\n        align-items: center;\n        text-align: center;\n        color: white; }\n    .filter-div .date-range-div div .date-btn {\n      width: 40px;\n      background-color: white;\n      height: 34px;\n      border-radius: 1px;\n      margin-right: 2px; }\n      .filter-div .date-range-div div .date-btn span {\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: bold;\n        font-size: 11px;\n        line-height: 13px;\n        display: flex;\n        align-items: center;\n        text-align: center;\n        color: #1d1c38; }\n    .filter-div .date-range-div .csv-btn {\n      width: 90px;\n      margin-left: 10px;\n      border-radius: 5px;\n      max-height: 34px; }\n      .filter-div .date-range-div .csv-btn span {\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 16px;\n        display: flex;\n        align-items: flex-end;\n        text-align: center;\n        color: #ffffff; }\n\n.edit-text-info-div .file-div .input-label {\n  justify-content: flex-start !important; }\n\n.csv-loader {\n  background: rgba(0, 0, 0, 0.7);\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .csv-loader .text-message {\n    margin-top: 160px;\n    font-size: 11px;\n    color: white; }\n\n.building_spinner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 50px;\n  height: 50px; }\n  .building_spinner img {\n    width: 100%;\n    height: 100%; }\n\n.image-uploader {\n  display: flex;\n  justify-content: space-between;\n  gap: 25px;\n  margin-bottom: 20px;\n  max-width: 500px; }\n  .image-uploader .floorplan-div {\n    width: 100%;\n    max-width: 230px; }\n    .image-uploader .floorplan-div .file-div {\n      margin: auto; }\n      .image-uploader .floorplan-div .file-div .input-label {\n        justify-content: flex-start; }\n        .image-uploader .floorplan-div .file-div .input-label img {\n          border: 1px solid #1D1C38;\n          height: 175px; }\n  .image-uploader .cover-photo-div {\n    width: 100%;\n    max-width: 230px; }\n    .image-uploader .cover-photo-div .file-div {\n      margin: auto; }\n      .image-uploader .cover-photo-div .file-div .input-label {\n        justify-content: flex-start; }\n        .image-uploader .cover-photo-div .file-div .input-label img {\n          border: 1px solid #1D1C38;\n          height: 175px; }\n\n@media only screen and (max-width: 767px) {\n  .image-uploader {\n    flex-direction: column; } }\n\n#addtofolio {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1500;\n  width: 500px;\n  padding: 27px 35px;\n  background: #F2F2F2;\n  border-radius: 5px;\n  min-width: 350px;\n  overflow: auto;\n  min-height: 256px; }\n  #addtofolio .title {\n    font-family: 'Roboto-Regular';\n    font-style: normal;\n    font-weight: bold;\n    font-size: 19px;\n    line-height: 22px;\n    display: flex;\n    align-items: center;\n    color: #1D1C38;\n    padding-bottom: 6px;\n    border-bottom: 0.5px solid #C4C4C4; }\n  #addtofolio ._title {\n    line-height: normal;\n    margin-right: 20px;\n    text-transform: none; }\n  #addtofolio .description {\n    display: flex;\n    width: 100%;\n    margin-top: 15px;\n    margin-bottom: -15px; }\n    #addtofolio .description span {\n      font-style: normal;\n      font-weight: normal;\n      font-size: 12px;\n      line-height: 23px;\n      color: #1D1C38; }\n  #addtofolio .dropdown {\n    border-radius: 4px; }\n  #addtofolio .addtofolio_section {\n    display: flex;\n    margin: 34px 0;\n    align-items: center; }\n    #addtofolio .addtofolio_section span._title {\n      width: 25%; }\n    #addtofolio .addtofolio_section span.container {\n      display: block;\n      width: 100%; }\n  #addtofolio .addtofolio_bottom {\n    display: flex;\n    padding-top: 19px;\n    margin-top: 30px;\n    justify-content: center;\n    border-top: solid 0.5PX #C4C4C4; }\n    #addtofolio .addtofolio_bottom .button {\n      max-width: 138px;\n      height: 34px;\n      margin: 0 10px; }\n      #addtofolio .addtofolio_bottom .button span {\n        font-weight: 500; }\n\n#email_listing {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(51, 51, 51, 0.82);\n  z-index: 9999;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif; }\n  #email_listing .email_container {\n    background: #f2f2f2;\n    border-radius: 5px;\n    width: 100%;\n    min-height: 400px;\n    min-width: 370px;\n    max-width: 500px;\n    position: relative;\n    padding: 18px 32px; }\n    @media screen and (max-width: 500px) {\n      #email_listing .email_container {\n        min-width: 320px; } }\n    #email_listing .email_container .email_title {\n      margin: 18px 0px;\n      padding-bottom: 10px;\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n      font-style: normal;\n      font-weight: bold;\n      font-size: 19px;\n      line-height: 22px;\n      border-bottom: 0.5px solid #c4c4c4;\n      color: #1D1C38; }\n    #email_listing .email_container .form_control_flex_wrapper {\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      box-sizing: border-box;\n      margin: 16px 0px;\n      line-height: 14px; }\n      #email_listing .email_container .form_control_flex_wrapper .form_control_label {\n        flex-basis: 27%;\n        font-size: 14px;\n        padding-right: 22px; }\n      #email_listing .email_container .form_control_flex_wrapper .form_control_input {\n        width: 100%; }\n      #email_listing .email_container .form_control_flex_wrapper .form_control_input > .textfield_wrapper > .controller_wrapper {\n        flex: 1; }\n        #email_listing .email_container .form_control_flex_wrapper .form_control_input > .textfield_wrapper > .controller_wrapper .textfield {\n          font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-style: normal;\n          font-weight: normal;\n          line-height: 21px;\n          border-radius: 4px;\n          height: 36px;\n          font-size: 16px; }\n    #email_listing .email_container .custom_message {\n      display: flex; }\n      #email_listing .email_container .custom_message .peek_textarea {\n        height: 70px;\n        font-size: 16px;\n        font-weight: 400; }\n      #email_listing .email_container .custom_message .cust_message {\n        font-weight: bold;\n        font-size: 14px;\n        line-height: 14px;\n        color: #545454;\n        width: 28%;\n        padding: 4px 22px 0px 0px; }\n    #email_listing .email_container .required_field {\n      font-size: 13px;\n      line-height: 15px;\n      display: flex;\n      align-items: center;\n      margin: 10px 110px; }\n    #email_listing .email_container .email_copy {\n      display: flex;\n      margin: 12px 20px 12px 110px; }\n      #email_listing .email_container .email_copy .container-checkbox > .container-checkbox > .label {\n        font-weight: 400;\n        font-size: 11px; }\n  #email_listing .email__action_btns {\n    display: flex;\n    padding-top: 24px;\n    justify-content: center;\n    border-top: solid 0.5px #c4c4c4; }\n    #email_listing .email__action_btns .standard, #email_listing .email__action_btns .disabled {\n      height: 42px;\n      font-size: 15px;\n      font-weight: 500;\n      line-height: 18px;\n      margin-right: 15px;\n      min-width: 130px;\n      border-radius: 5px; }\n    #email_listing .email__action_btns .disabled:focus {\n      border: none !important; }\n\n.edit-modal-cover {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1500;\n  transform: translateZ(0);\n  background-color: rgba(0, 0, 0, 0.8); }\n\n.modal-area {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 75%;\n  transform: translate(-50%, -50%);\n  max-height: 85vh;\n  padding: 32px 42px;\n  background-color: #f2f2f2;\n  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.1);\n  overflow: auto;\n  border-radius: 5px; }\n\n@media only screen and (max-width: 990px) {\n  .modal-area {\n    padding: 25px 30px;\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%); }\n    .modal-area .edit-listing-form {\n      flex-direction: column; }\n      .modal-area .edit-listing-form .edit-text-info-div {\n        padding-right: 0; }\n  .rename-room-div {\n    padding-right: 0 !important; }\n  .file-div,\n  .uploader-div {\n    width: 100% !important; } }\n\n.listing-header {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 19px;\n  line-height: 22px;\n  margin-top: 0;\n  display: flex;\n  align-items: center;\n  color: #1d1c38;\n  margin-bottom: 5px; }\n\n.input-box > .textfield_wrapper > .controller_wrapper .textfield {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 21px;\n  display: flex;\n  align-items: center;\n  color: #222222;\n  border-radius: 4px;\n  height: 36px; }\n\n._title {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 28px;\n  letter-spacing: -0.01em;\n  text-transform: capitalize;\n  color: #545454;\n  display: flex; }\n\n.input-box {\n  display: block;\n  margin-bottom: 10px; }\n  .input-box .textfield_wrapper {\n    display: flex; }\n\n.margin-b-30 {\n  margin-bottom: 30px; }\n\n.peek_textarea {\n  height: 187px;\n  border-radius: 4px; }\n\n.uploader-div {\n  width: 90%;\n  height: 172px; }\n\n.cancel-btn > .button {\n  background: #ffffff;\n  border: 1px solid #d9d9d9;\n  box-sizing: border-box;\n  border-radius: 5px;\n  color: #333333; }\n\n.cancel-btn > .standard {\n  height: 42px;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 18px; }\n\n.save-btn .standard, .save-btn .disabled {\n  height: 42px;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 18px;\n  margin-right: 10px; }\n\n.save-btn .disabled:focus {\n  border: none !important; }\n\n.listing-input {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 21px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  text-transform: capitalize;\n  color: #222222;\n  border-radius: 4px;\n  height: 36px;\n  border: none;\n  outline: none;\n  padding: 0 10px; }\n\n.listing-span {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  background: #fff;\n  border-radius: 5px; }\n\n.rename-room-div {\n  padding-right: 10px; }\n  .rename-room-div .room-name-span {\n    display: block; }\n    .rename-room-div .room-name-span .textfield_wrapper {\n      display: flex; }\n      .rename-room-div .room-name-span .textfield_wrapper .controller_wrapper > .textfield {\n        font-size: 13px; }\n\n.label_error_wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; }\n\n.edit-text-info-div {\n  flex: 50%;\n  padding-right: 75px; }\n  .edit-text-info-div .uploader-div .upload-input {\n    height: auto;\n    width: auto; }\n\n.edit-text-info-div .custom_amenities {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin-top: 5px; }\n  .edit-text-info-div .custom_amenities .custom_amenity {\n    flex-basis: 49%;\n    box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n    border-radius: 4px;\n    padding: 2px 20px; }\n    .edit-text-info-div .custom_amenities .custom_amenity .parent-checkbox-div {\n      justify-content: space-between; }\n      .edit-text-info-div .custom_amenities .custom_amenity .parent-checkbox-div .container-checkbox span.label {\n        left: 35px; }\n    .edit-text-info-div .custom_amenities .custom_amenity .textfield_wrapper .controller_wrapper {\n      box-shadow: none;\n      padding: 0;\n      border: none;\n      background-color: white; }\n      .edit-text-info-div .custom_amenities .custom_amenity .textfield_wrapper .controller_wrapper .textfield {\n        background-color: white; }\n        .edit-text-info-div .custom_amenities .custom_amenity .textfield_wrapper .controller_wrapper .textfield:focus-within {\n          background-color: white; }\n  .edit-text-info-div .custom_amenities .custom_checkbox {\n    box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n    border-radius: 4px;\n    padding: 2px 20px;\n    flex-basis: 49%; }\n    .edit-text-info-div .custom_amenities .custom_checkbox .parent-checkbox-div .container-checkbox .label {\n      left: 35px; }\n  .edit-text-info-div .custom_amenities .textfield_wrapper {\n    flex-basis: 49%; }\n    .edit-text-info-div .custom_amenities .textfield_wrapper .controller_wrapper {\n      padding-left: 19px;\n      padding-right: 20px; }\n      .edit-text-info-div .custom_amenities .textfield_wrapper .controller_wrapper .edit_checkbox {\n        position: absolute;\n        opacity: 0; }\n      .edit-text-info-div .custom_amenities .textfield_wrapper .controller_wrapper .checkmark {\n        border: none;\n        width: 16px;\n        height: 16px;\n        position: absolute;\n        background: rgba(29, 28, 56, 0.1);\n        border-radius: 2px; }\n      .edit-text-info-div .custom_amenities .textfield_wrapper .controller_wrapper .textfield {\n        padding-left: 35px;\n        height: 38px; }\n\n.amenities-div {\n  display: flex;\n  margin-top: 5px;\n  justify-content: flex-start;\n  flex-wrap: wrap; }\n  .amenities-div .container-checkbox {\n    min-width: 33%; }\n  .amenities-div .parent-checkbox-div {\n    box-sizing: border-box;\n    box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1;\n    border-radius: 4px;\n    padding: 5px 20px;\n    width: 49%; }\n    .amenities-div .parent-checkbox-div .container-checkbox span.label {\n      left: 35px; }\n  .amenities-div .container-checkbox input:checked ~ .checkmark {\n    background: #1D1C38;\n    border: none; }\n  .amenities-div .container-checkbox .checkmark:after {\n    border: solid #1D1C38; }\n  .amenities-div .container-checkbox .checkmark {\n    background: rgba(29, 28, 56, 0.1);\n    border: none; }\n\n.dollar-span > .texxtfieldWrapper > .textfield_wrapper > .controller_wrapper {\n  padding: 0;\n  box-shadow: none; }\n  .dollar-span > .texxtfieldWrapper > .textfield_wrapper > .controller_wrapper .textfield {\n    height: 36px; }\n\n.listing_collpased_entry_dark .building_accordian_collapsed .building_address span.listing_analytics_header {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 27px; }\n\n.listing_collpased_entry .building_accordian_collapsed .building_address span.listing_analytics_header {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 27px;\n  color: #1D1C38; }\n\n.custom_amenities .container-checkbox input:checked ~ .checkmark {\n  background: #1D1C38;\n  border: none; }\n\n.custom_amenities .container-checkbox .checkmark:after {\n  border: solid #1D1C38; }\n\n.custom_amenities .container-checkbox .checkmark {\n  background: rgba(29, 28, 56, 0.1);\n  border: none; }\n";
styleInject(css_248z$g);

var css_248z$f = ".notification_wrapper {\n  padding: 20px 15px;\n  display: flex;\n  border-radius: 5px;\n  background: rgba(129, 129, 165, 0.1);\n  margin-bottom: 9px; }\n\n.notificationTitle {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 16px;\n  color: #383838;\n  margin-bottom: 5px; }\n\n.notificationBody {\n  font-size: 12px;\n  line-height: 14px;\n  color: #383838; }\n\n.notification_details {\n  width: 90%; }\n\n.notification_status {\n  width: 10%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end; }\n\n.notificationTime {\n  font-size: 9px;\n  color: #383838; }\n\n.readStatus {\n  width: 7px;\n  height: 7px;\n  background-color: #04d2c6;\n  border-radius: 25px;\n  margin-top: 5px; }\n\n.notifications_container {\n  padding: 15px 28px 15px 28px;\n  max-height: 430px;\n  overflow-y: scroll;\n  margin-right: 4px; }\n\n.activity_feed_collpased_entry_dark {\n  display: flex;\n  justify-content: flex-start;\n  padding: 11px 12px;\n  background: #fff;\n  border-radius: 6px 6px 0 0;\n  align-items: center;\n  box-sizing: border-box;\n  color: #fff;\n  background-color: #1d1c38;\n  height: 48px; }\n  .activity_feed_collpased_entry_dark .activity_feed_accordian_collapsed {\n    cursor: pointer;\n    width: 100%;\n    display: flex; }\n    .activity_feed_collpased_entry_dark .activity_feed_accordian_collapsed .activity_info {\n      display: flex;\n      margin-left: 22px;\n      width: 100%;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n      .activity_feed_collpased_entry_dark .activity_feed_accordian_collapsed .activity_info span.activity_feed {\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 27px;\n        color: #ffffff; }\n";
styleInject(css_248z$f);

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ActivityFeed = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ActivityFeed, _React$Component);

  var _super = _createSuper$a(ActivityFeed);

  function ActivityFeed(props) {
    var _this;

    _classCallCheck$1(this, ActivityFeed);

    _this = _super.call(this, props);
    _this.state = {
      notification: [],
      initialIndex: 0,
      limit: 20,
      todaysDate: new Date()
    };
    return _this;
  }

  _createClass$1(ActivityFeed, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getActivityFeed(this.props.listingsId);
    }
  }, {
    key: "renderActivityFeed",
    value: function renderActivityFeed(notification, idx) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "notification_wrapper",
        key: idx
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "notification_details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "notificationTitle"
      }, " ", notification.title), /*#__PURE__*/React__default.createElement("div", {
        className: "notificationBody"
      }, " ", notification.body)), /*#__PURE__*/React__default.createElement("div", {
        className: "notification_status"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "notificationTime"
      }, " ", this.convertTimeFormat(notification.sent_on)), /*#__PURE__*/React__default.createElement("div", {
        className: "readStatus"
      }, " ", notification.is_read)));
    }
  }, {
    key: "convertTimeFormat",
    value: function convertTimeFormat(time) {
      var serverDate = new Date(time);

      if (serverDate.getMonth() === this.state.todaysDate.getMonth() && serverDate.getDate() === this.state.todaysDate.getDate()) {
        var hours = serverDate.getHours();
        var minutes = serverDate.getMinutes();
        var ampm = hours >= 12 ? " PM" : " AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'

        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes + ampm;
        return strTime;
      } else {
        var notificationDate = serverDate.getMonth() + "/" + serverDate.getDate();
        return notificationDate;
      }
    }
  }, {
    key: "getActivityFeed",
    value: function getActivityFeed(listingId) {
      var _this2 = this;

      var request = new HttpService(process.env.baseAPIPath);
      var url = "notification/get_listings_notifications?start_index=".concat(this.state.initialIndex, "&limit=").concat(this.state.limit, "&listing_id=").concat(listingId);
      request.get(url, function (response) {
        if (response.data.success) {
          _this2.setState({
            notification: [].concat(_toConsumableArray$1(_this2.state.notification), _toConsumableArray$1(response.data.data.notifications))
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Accordion, {
        isCustomIconColor: true,
        customIconColor: "#fff" ,
        hasGear: false,
        showExpander: "left",
        headerClassName: "activity_feed_collpased_entry_dark",
        CallBackOnExpandClick: function CallBackOnExpandClick() {
          return true;
        },
        showExpandedView: true
      }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "activity_feed_accordian_collapsed"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "activity_info"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "activity_feed"
      }, "Activity feed")))), /*#__PURE__*/React__default.createElement("div", {
        className: "notifications_container"
      }, this.state.notification.map(function (notification, idx) {
        return _this3.renderActivityFeed(notification, idx);
      }))));
    }
  }]);

  return ActivityFeed;
}(React__default.Component);

ActivityFeed.propTypes = {
  listingsId: PropTypes.string
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce$1;

var helpers = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = function compose() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    fns.forEach(function (fn) {
      return fn && fn.apply(undefined, args);
    });
  };
};

exports.pick = function pick(obj) {
  for (var _len3 = arguments.length, props = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    props[_key3 - 1] = arguments[_key3];
  }

  return props.reduce(function (newObj, prop) {
    if (obj && obj.hasOwnProperty(prop)) {
      newObj[prop] = obj[prop];
    }
    return newObj;
  }, {});
};
});

unwrapExports(helpers);
helpers.compose;
helpers.pick;

var _propTypes = propTypes;

var PlacesAutocomplete_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(_propTypes);



var _lodash2 = _interopRequireDefault(lodash_debounce);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (c) 2016-present, Ken Hibino.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Licensed under the MIT License (MIT).
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * See https://kenny-hibino.github.io/react-places-autocomplete
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

// transform snake_case to camelCase
var formattedSuggestion = function formattedSuggestion(structured_formatting) {
  return {
    mainText: structured_formatting.main_text,
    secondaryText: structured_formatting.secondary_text
  };
};

var PlacesAutocomplete = function (_React$Component) {
  _inherits(PlacesAutocomplete, _React$Component);

  function PlacesAutocomplete(props) {
    _classCallCheck(this, PlacesAutocomplete);

    var _this = _possibleConstructorReturn(this, (PlacesAutocomplete.__proto__ || Object.getPrototypeOf(PlacesAutocomplete)).call(this, props));

    _this.init = function () {
      if (!window.google) {
        throw new Error('[react-places-autocomplete]: Google Maps JavaScript API library must be loaded. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library');
      }

      if (!window.google.maps.places) {
        throw new Error('[react-places-autocomplete]: Google Maps Places library must be loaded. Please add `libraries=places` to the src URL. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library');
      }

      _this.autocompleteService = new window.google.maps.places.AutocompleteService();
      _this.autocompleteOK = window.google.maps.places.PlacesServiceStatus.OK;
      _this.setState(function (state) {
        if (state.ready) {
          return null;
        } else {
          return { ready: true };
        }
      });
    };

    _this.autocompleteCallback = function (predictions, status) {
      _this.setState({ loading: false });
      if (status !== _this.autocompleteOK) {
        _this.props.onError(status, _this.clearSuggestions);
        return;
      }
      var highlightFirstSuggestion = _this.props.highlightFirstSuggestion;

      _this.setState({
        suggestions: predictions.map(function (p, idx) {
          return {
            id: p.id,
            description: p.description,
            placeId: p.place_id,
            active: highlightFirstSuggestion && idx === 0 ? true : false,
            index: idx,
            formattedSuggestion: formattedSuggestion(p.structured_formatting),
            matchedSubstrings: p.matched_substrings,
            terms: p.terms,
            types: p.types
          };
        })
      });
    };

    _this.fetchPredictions = function () {
      var value = _this.props.value;

      if (value.length) {
        _this.setState({ loading: true });
        _this.autocompleteService.getPlacePredictions(_extends({}, _this.props.searchOptions, {
          input: value
        }), _this.autocompleteCallback);
      }
    };

    _this.clearSuggestions = function () {
      _this.setState({ suggestions: [] });
    };

    _this.clearActive = function () {
      _this.setState({
        suggestions: _this.state.suggestions.map(function (suggestion) {
          return _extends({}, suggestion, {
            active: false
          });
        })
      });
    };

    _this.handleSelect = function (address, placeId, suggestion) {
      _this.clearSuggestions();
      if (_this.props.onSelect) {
        _this.props.onSelect(address, placeId, suggestion);
      } else {
        _this.props.onChange(address);
      }
    };

    _this.getActiveSuggestion = function () {
      return _this.state.suggestions.find(function (suggestion) {
        return suggestion.active;
      });
    };

    _this.selectActiveAtIndex = function (index) {
      var activeName = _this.state.suggestions.find(function (suggestion) {
        return suggestion.index === index;
      }).description;
      _this.setActiveAtIndex(index);
      _this.props.onChange(activeName);
    };

    _this.selectUserInputValue = function () {
      _this.clearActive();
      _this.props.onChange(_this.state.userInputValue);
    };

    _this.handleEnterKey = function () {
      var activeSuggestion = _this.getActiveSuggestion();
      if (activeSuggestion === undefined) {
        _this.handleSelect(_this.props.value, null, null);
      } else {
        _this.handleSelect(activeSuggestion.description, activeSuggestion.placeId, activeSuggestion);
      }
    };

    _this.handleDownKey = function () {
      if (_this.state.suggestions.length === 0) {
        return;
      }

      var activeSuggestion = _this.getActiveSuggestion();
      if (activeSuggestion === undefined) {
        _this.selectActiveAtIndex(0);
      } else if (activeSuggestion.index === _this.state.suggestions.length - 1) {
        _this.selectUserInputValue();
      } else {
        _this.selectActiveAtIndex(activeSuggestion.index + 1);
      }
    };

    _this.handleUpKey = function () {
      if (_this.state.suggestions.length === 0) {
        return;
      }

      var activeSuggestion = _this.getActiveSuggestion();
      if (activeSuggestion === undefined) {
        _this.selectActiveAtIndex(_this.state.suggestions.length - 1);
      } else if (activeSuggestion.index === 0) {
        _this.selectUserInputValue();
      } else {
        _this.selectActiveAtIndex(activeSuggestion.index - 1);
      }
    };

    _this.handleInputKeyDown = function (event) {
      /* eslint-disable indent */
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          _this.handleEnterKey();
          break;
        case 'ArrowDown':
          event.preventDefault(); // prevent the cursor from moving
          _this.handleDownKey();
          break;
        case 'ArrowUp':
          event.preventDefault(); // prevent the cursor from moving
          _this.handleUpKey();
          break;
        case 'Escape':
          _this.clearSuggestions();
          break;
      }
      /* eslint-enable indent */
    };

    _this.setActiveAtIndex = function (index) {
      _this.setState({
        suggestions: _this.state.suggestions.map(function (suggestion, idx) {
          if (idx === index) {
            return _extends({}, suggestion, { active: true });
          } else {
            return _extends({}, suggestion, { active: false });
          }
        })
      });
    };

    _this.handleInputChange = function (event) {
      var value = event.target.value;

      _this.props.onChange(value);
      _this.setState({ userInputValue: value });
      if (!value) {
        _this.clearSuggestions();
        return;
      }
      if (_this.props.shouldFetchSuggestions) {
        _this.debouncedFetchPredictions();
      }
    };

    _this.handleInputOnBlur = function () {
      if (!_this.mousedownOnSuggestion) {
        _this.clearSuggestions();
      }
    };

    _this.getActiveSuggestionId = function () {
      var activeSuggestion = _this.getActiveSuggestion();
      return activeSuggestion ? 'PlacesAutocomplete__suggestion-' + activeSuggestion.placeId : undefined;
    };

    _this.getIsExpanded = function () {
      return _this.state.suggestions.length > 0;
    };

    _this.getInputProps = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.hasOwnProperty('value')) {
        throw new Error('[react-places-autocomplete]: getInputProps does not accept `value`. Use `value` prop instead');
      }

      if (options.hasOwnProperty('onChange')) {
        throw new Error('[react-places-autocomplete]: getInputProps does not accept `onChange`. Use `onChange` prop instead');
      }

      var defaultInputProps = {
        type: 'text',
        autoComplete: 'off',
        role: 'combobox',
        'aria-autocomplete': 'list',
        'aria-expanded': _this.getIsExpanded(),
        'aria-activedescendant': _this.getActiveSuggestionId(),
        disabled: !_this.state.ready
      };

      return _extends({}, defaultInputProps, options, {
        onKeyDown: (0, helpers.compose)(_this.handleInputKeyDown, options.onKeyDown),
        onBlur: (0, helpers.compose)(_this.handleInputOnBlur, options.onBlur),
        value: _this.props.value,
        onChange: function onChange(event) {
          _this.handleInputChange(event);
        }
      });
    };

    _this.getSuggestionItemProps = function (suggestion) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var handleSuggestionMouseEnter = _this.handleSuggestionMouseEnter.bind(_this, suggestion.index);
      var handleSuggestionClick = _this.handleSuggestionClick.bind(_this, suggestion);

      return _extends({}, options, {
        key: suggestion.id,
        id: _this.getActiveSuggestionId(),
        role: 'option',
        onMouseEnter: (0, helpers.compose)(handleSuggestionMouseEnter, options.onMouseEnter),
        onMouseLeave: (0, helpers.compose)(_this.handleSuggestionMouseLeave, options.onMouseLeave),
        onMouseDown: (0, helpers.compose)(_this.handleSuggestionMouseDown, options.onMouseDown),
        onMouseUp: (0, helpers.compose)(_this.handleSuggestionMouseUp, options.onMouseUp),
        onTouchStart: (0, helpers.compose)(_this.handleSuggestionTouchStart, options.onTouchStart),
        onTouchEnd: (0, helpers.compose)(_this.handleSuggestionMouseUp, options.onTouchEnd),
        onClick: (0, helpers.compose)(handleSuggestionClick, options.onClick)
      });
    };

    _this.handleSuggestionMouseEnter = function (index) {
      _this.setActiveAtIndex(index);
    };

    _this.handleSuggestionMouseLeave = function () {
      _this.mousedownOnSuggestion = false;
      _this.clearActive();
    };

    _this.handleSuggestionMouseDown = function (event) {
      event.preventDefault();
      _this.mousedownOnSuggestion = true;
    };

    _this.handleSuggestionTouchStart = function () {
      _this.mousedownOnSuggestion = true;
    };

    _this.handleSuggestionMouseUp = function () {
      _this.mousedownOnSuggestion = false;
    };

    _this.handleSuggestionClick = function (suggestion, event) {
      if (event && event.preventDefault) {
        event.preventDefault();
      }
      var description = suggestion.description,
          placeId = suggestion.placeId;

      _this.handleSelect(description, placeId, suggestion);
      setTimeout(function () {
        _this.mousedownOnSuggestion = false;
      });
    };

    _this.state = {
      loading: false,
      suggestions: [],
      userInputValue: props.value,
      ready: !props.googleCallbackName
    };

    _this.debouncedFetchPredictions = (0, _lodash2.default)(_this.fetchPredictions, props.debounce);
    return _this;
  }

  _createClass(PlacesAutocomplete, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var googleCallbackName = this.props.googleCallbackName;

      if (googleCallbackName) {
        var isPlacesLoaded = window.google && window.google.maps && window.google.maps.places;
        if (!isPlacesLoaded) {
          window[googleCallbackName] = this.init;
        } else {
          this.init();
        }
      } else {
        this.init();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var googleCallbackName = this.props.googleCallbackName;

      if (googleCallbackName && window[googleCallbackName]) {
        delete window[googleCallbackName];
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        getInputProps: this.getInputProps,
        getSuggestionItemProps: this.getSuggestionItemProps,
        loading: this.state.loading,
        suggestions: this.state.suggestions
      });
    }
  }]);

  return PlacesAutocomplete;
}(_react2.default.Component);

PlacesAutocomplete.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.func.isRequired,
  onError: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  searchOptions: _propTypes2.default.shape({
    bounds: _propTypes2.default.object,
    componentRestrictions: _propTypes2.default.object,
    location: _propTypes2.default.object,
    offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    types: _propTypes2.default.array
  }),
  debounce: _propTypes2.default.number,
  highlightFirstSuggestion: _propTypes2.default.bool,
  shouldFetchSuggestions: _propTypes2.default.bool,
  googleCallbackName: _propTypes2.default.string
};

PlacesAutocomplete.defaultProps = {
  /* eslint-disable no-unused-vars, no-console */
  onError: function onError(status, _clearSuggestions) {
    return console.error('[react-places-autocomplete]: error happened when fetching data from Google Maps API.\nPlease check the docs here (https://developers.google.com/maps/documentation/javascript/places#place_details_responses)\nStatus: ', status);
  },
  /* eslint-enable no-unused-vars, no-console */
  searchOptions: {},
  debounce: 200,
  highlightFirstSuggestion: false,
  shouldFetchSuggestions: true
};

exports.default = PlacesAutocomplete;
});

unwrapExports(PlacesAutocomplete_1);

var utils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.geocodeByAddress = function geocodeByAddress(address) {
  var geocoder = new window.google.maps.Geocoder();
  var OK = window.google.maps.GeocoderStatus.OK;

  return new Promise(function (resolve, reject) {
    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== OK) {
        reject(status);
      }
      resolve(results);
    });
  });
};

exports.getLatLng = function getLatLng(result) {
  return new Promise(function (resolve, reject) {
    try {
      var latLng = {
        lat: result.geometry.location.lat(),
        lng: result.geometry.location.lng()
      };
      resolve(latLng);
    } catch (e) {
      reject(e);
    }
  });
};

exports.geocodeByPlaceId = function geocodeByPlaceId(placeId) {
  var geocoder = new window.google.maps.Geocoder();
  var OK = window.google.maps.GeocoderStatus.OK;

  return new Promise(function (resolve, reject) {
    geocoder.geocode({ placeId: placeId }, function (results, status) {
      if (status !== OK) {
        reject(status);
      }
      resolve(results);
    });
  });
};
});

unwrapExports(utils);
utils.geocodeByAddress;
utils.getLatLng;
utils.geocodeByPlaceId;

var dist = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLatLng = exports.geocodeByPlaceId = exports.geocodeByAddress = undefined;



var _PlacesAutocomplete2 = _interopRequireDefault(PlacesAutocomplete_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.geocodeByAddress = utils.geocodeByAddress;
exports.geocodeByPlaceId = utils.geocodeByPlaceId;
exports.getLatLng = utils.getLatLng;
exports.default = _PlacesAutocomplete2.default;
});

var PlacesAutocomplete = unwrapExports(dist);
var dist_1 = dist.getLatLng;
dist.geocodeByPlaceId;
var dist_3 = dist.geocodeByAddress;

var CheckBox = function CheckBox(props) {
  var onCheckBoxHit = function onCheckBoxHit(e) {
    if (e.keyCode === 13) {
      props.onChange();
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "container-checkbox parent-checkbox-div",
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      props.onChange();
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "container-checkbox"
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-label": "Hit Enter to checked/Unchecked the Checkbox",
    className: "label",
    tabIndex: 0,
    onKeyUp: function onKeyUp(e) {
      return onCheckBoxHit(e);
    }
  }, props.label, props.isRequired && /*#__PURE__*/React__default.createElement("span", {
    className: "required"
  }, "*")), /*#__PURE__*/React__default.createElement("input", {
    tabIndex: -1,
    type: "checkbox",
    onChange: function onChange(e) {
      e.stopPropagation();
      e.preventDefault();
      props.onChange();
    },
    checked: props.isChecked
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "checkmark"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      gap: 10,
      paddingLeft: 33
    }
  }, get(props, "isEditLabel", false) && /*#__PURE__*/React__default.createElement("span", {
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      props.onEditLableChange(true);
    }
  }, /*#__PURE__*/React__default.createElement(MemoSvgEdit2, null)), get(props, "isRemoveLable", false) && /*#__PURE__*/React__default.createElement("span", {
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      props.onChange();
    }
  }, /*#__PURE__*/React__default.createElement(MemoSvgX, null))));
};

CheckBox.defaultProps = {
  isChecked: false,
  isRequired: false,
  label: "Checkbox"
};
CheckBox.propTypes = {
  isChecked: PropTypes.bool,
  label: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  isEditLabel: PropTypes.bool,
  isRemoveLable: PropTypes.bool,
  onEditLableChange: PropTypes.func,
  onRemobeLableChange: PropTypes.func
};

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditListing = /*#__PURE__*/function (_Component) {
  _inherits$1(EditListing, _Component);

  var _super = _createSuper$9(EditListing);

  function EditListing(props) {
    var _this;

    _classCallCheck$1(this, EditListing);

    _this = _super.call(this, props);
    _this.state = {};
    _this.setModalRef = _this.setModalRef.bind(_assertThisInitialized$3(_this));
    _this.unitAmenityRef = /*#__PURE__*/React__default.createRef();
    _this.buildingAmenityRef = /*#__PURE__*/React__default.createRef();
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized$3(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized$3(_this));
    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized$3(_this));
    _this.saveChanges = _this.saveChanges.bind(_assertThisInitialized$3(_this));
    _this.isBtnEnabled = _this.isBtnEnabled.bind(_assertThisInitialized$3(_this));
    _this.isUnitAvailable = _this.isUnitAvailable.bind(_assertThisInitialized$3(_this));
    _this.uploadImageToS3 = _this.uploadImageToS3.bind(_assertThisInitialized$3(_this));
    _this.deleteImageFromS3 = _this.deleteImageFromS3.bind(_assertThisInitialized$3(_this));
    _this.uploadFloorplanImageToS3 = _this.uploadFloorplanImageToS3.bind(_assertThisInitialized$3(_this));
    _this.deleteFloorplanImageFromS3 = _this.deleteFloorplanImageFromS3.bind(_assertThisInitialized$3(_this));
    _this.cancelListing = _this.cancelListing.bind(_assertThisInitialized$3(_this));
    _this._setRequireLogin = _this._setRequireLogin.bind(_assertThisInitialized$3(_this));
    _this._setRequireLoginAllowBypass = _this._setRequireLoginAllowBypass.bind(_assertThisInitialized$3(_this));
    _this._setModelUnit = _this._setModelUnit.bind(_assertThisInitialized$3(_this));
    _this.getPostalSuggestions = _this.getPostalSuggestions.bind(_assertThisInitialized$3(_this));
    _this.getValidAddr = _this.getValidAddr.bind(_assertThisInitialized$3(_this));
    _this._setCustomAmenities = _this._setCustomAmenities.bind(_assertThisInitialized$3(_this));
    _this._setCustomAmenityName = _this._setCustomAmenityName.bind(_assertThisInitialized$3(_this));
    _this.createAmenity = _this.createAmenity.bind(_assertThisInitialized$3(_this));
    _this._updateCustomAmenity = _this._updateCustomAmenity.bind(_assertThisInitialized$3(_this));
    _this._editCustomAmenity = _this._editCustomAmenity.bind(_assertThisInitialized$3(_this));
    _this._setCustomBuildingAmenities = _this._setCustomBuildingAmenities.bind(_assertThisInitialized$3(_this));
    _this._setCustomBuildingAmenityName = _this._setCustomBuildingAmenityName.bind(_assertThisInitialized$3(_this));
    _this.createBuildingAmenity = _this.createBuildingAmenity.bind(_assertThisInitialized$3(_this));
    _this._updateCustomBuildingAmenity = _this._updateCustomBuilding.bind(_assertThisInitialized$3(_this));
    _this._editCustomBuildingAmenity = _this._editCustomBuildingAmenity.bind(_assertThisInitialized$3(_this));
    _this.saveCustomAmenityOnEnter = _this.saveCustomAmenityOnEnter.bind(_assertThisInitialized$3(_this));
    _this.saveCustomBuildingAmenityOnEnter = _this.saveCustomBuildingAmenityOnEnter.bind(_assertThisInitialized$3(_this));
    _this.handleClickOutsideAmenity = _this.handleClickOutsideAmenity.bind(_assertThisInitialized$3(_this));
    _this.handleClickOutsideBuildingAmenity = _this.handleClickOutsideBuildingAmenity.bind(_assertThisInitialized$3(_this));
    _this._setToPreviousStateAmenity = _this._setToPreviousStateAmenity.bind(_assertThisInitialized$3(_this));
    _this._setToPreviousStateBuildingAmenity = _this._setToPreviousStateBuildingAmenity.bind(_assertThisInitialized$3(_this));
    _this.uploadedImageKey = "";
    _this.isImageUploaded = false;
    _this.geographicLocation = {};
    _this.geoPlaceId = {};
    _this.isValidAddress = true;
    _this.modalWidth = 153;
    _this.isCustomAmenity = false;
    _this.customamenity = [];
    _this.createdAmenity = "";
    _this.isCheckmark = false;
    _this.tempCustomAmenityLabel = "";
    _this.customAmenityIndex = null;
    _this.isCustomBuildingAmenity = false;
    _this.customBuildingAmenity = [];
    _this.createdBuildingAmenity = "";
    _this.isCustomBuildingAmenityCheckmark = false;
    _this.tempCustomBuildingAmenityLabel = "";
    _this.customBuildingAmenityIndex = null;
    return _this;
  }

  _createClass$1(EditListing, [{
    key: "setModalRef",
    value: function setModalRef(node) {
      this.modalRef = node;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.modalWidth = this.modalRef.offsetWidth / 5;
      document.addEventListener("mousedown", this.handleClickOutside);
      document.addEventListener("mousedown", this.handleClickOutsideAmenity);
      document.addEventListener("mousedown", this.handleClickOutsideBuildingAmenity);
      this.setState({
        require_contact: get(this.props, "selectedData.require_contact", false),
        allow_bypass: get(this.props, "selectedData.allow_bypass", false)
      });

      if (get(this.state, "custom_amenities", []).length > 0) {
        this.state.custom_amenities.forEach(function (amenity) {
          _this2.customamenity.push(amenity);

          return _this2.customamenity;
        });
      }

      if (get(this.state, "custom_building_amenities", []).length > 0) {
        this.state.custom_building_amenities.forEach(function (amenity) {
          _this2.customBuildingAmenity.push(amenity);

          return _this2.customBuildingAmenity;
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
      document.removeEventListener("mousedown", this.handleClickOutsideAmenity);
      document.removeEventListener("mousedown", this.handleClickOutsideBuildingAmenity);
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (!get(this.props, "hideCancelBtn", false) && this.modalRef && !this.modalRef.contains(event.target)) {
        this.props.openEditListing();

        if (this.isImageUploaded) {
          this.props.onChange(false, this.state);
        }
      }
    }
  }, {
    key: "handleClickOutsideAmenity",
    value: function handleClickOutsideAmenity(event) {
      if (this.unitAmenityRef && this.unitAmenityRef.current && !this.unitAmenityRef.current.contains(event.target)) {
        this._setToPreviousStateAmenity();
      }
    }
  }, {
    key: "handleClickOutsideBuildingAmenity",
    value: function handleClickOutsideBuildingAmenity(event) {
      if (this.buildingAmenityRef && this.buildingAmenityRef.current && !this.buildingAmenityRef.current.contains(event.target)) {
        this._setToPreviousStateBuildingAmenity();
      }
    }
  }, {
    key: "cancelListing",
    value: function cancelListing() {
      this.props.onChange(false, this.state);
      this.props.openEditListing();
    }
  }, {
    key: "_setUploadFloorPlanPhoto",
    value: function _setUploadFloorPlanPhoto(value, listing_id) {
      var _this3 = this;

      var payload = {};

      if ([undefined, null, ""].includes(value)) {
        payload = {
          listing_id: listing_id,
          floorplan: ""
        };
      } else payload = {
        listing_id: listing_id,
        floorplan: value
      };

      var httpService = new HttpService(process.env.baseAPIPath);
      httpService.post("listings/update_floorplan", payload, function (response) {
        if (response.data.success) {
          var floorplan = "";
          floorplan = value;

          _this3.setState({
            floorplan: floorplan
          });

          _this3.props.onChange(true, _this3.state);
        }
      });
    }
  }, {
    key: "_setCoverPhoto",
    value: function _setCoverPhoto(value, listing_id) {
      var _this4 = this;

      var payload = {};

      if ([undefined, null, ""].includes(value)) {
        payload = {
          listing_id: listing_id,
          thumbnails: []
        };
      } else payload = {
        listing_id: listing_id,
        thumbnails: [value]
      };

      var httpService = new HttpService(process.env.baseAPIPath);
      httpService.post("listings/update_thumbnails", payload, function (response) {
        if (response.data.success) {
          var thumbnails = [];
          thumbnails[0] = value;

          _this4.setState({
            thumbnails: [thumbnails[0]]
          });

          _this4.props.onChange(true, _this4.state);
        }
      });
    }
  }, {
    key: "uploadFloorplanImageToS3",
    value: function uploadFloorplanImageToS3(dataObj) {
      var _this5 = this;

      this.uploadedImageKey = "";
      this.props.uploadToS3(dataObj, function (err, data) {
        if (data) {
          _this5.isImageUploaded = true;

          _this5._setUploadFloorPlanPhoto(data.key, _this5.state._id);

          _this5.uploadedImageKey = data.key;
          window.postMessage({
            type: "notification",
            msg: "Floorplan uploaded Successfully"
          });
        } else if (err) {
          window.postMessage({
            type: "notification",
            msg: "Floorplan uploadation failed"
          });
        }
      });
    }
  }, {
    key: "deleteFloorplanImageFromS3",
    value: function deleteFloorplanImageFromS3(dataObj) {
      var _this6 = this;

      this.props.deleteFromS3(dataObj, function () {
        _this6.isImageUploaded = true;

        _this6._setUploadFloorPlanPhoto(null, _this6.state._id);

        _this6.uploadedImageKey = "";
        window.postMessage({
          type: "notification",
          msg: "Floorplan deleted successfully"
        });
      });
    }
  }, {
    key: "uploadImageToS3",
    value: function uploadImageToS3(dataObj) {
      var _this7 = this;

      this.uploadedImageKey = "";
      this.props.uploadToS3(dataObj, function (err, data) {
        if (data) {
          _this7.isImageUploaded = true;

          _this7._setCoverPhoto(data.key, _this7.state._id);

          _this7.uploadedImageKey = data.key;
          window.postMessage({
            type: "notification",
            msg: "Image uploaded Successfully"
          });
        } else if (err) {
          window.postMessage({
            type: "notification",
            msg: "Image uploadation failed"
          });
        }
      });
    }
  }, {
    key: "deleteImageFromS3",
    value: function deleteImageFromS3(dataObj) {
      var _this8 = this;

      this.props.deleteFromS3(dataObj, function () {
        _this8.isImageUploaded = true;

        _this8._setCoverPhoto(null, _this8.state._id);

        _this8.uploadedImageKey = "";
        window.postMessage({
          type: "notification",
          msg: "Image deleted successfully"
        });
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(address) {
      this._setListingAddress(address);
    }
  }, {
    key: "getValidAddr",
    value: function getValidAddr(addressComponents) {
      var isValidStreet = false;
      var isValidAdministrative_area = false;
      var isValidLocality = false;
      var isValidCity = false;
      addressComponents.map(function (addr) {
        if (addr.types.includes("street_number")) {
          isValidStreet = true;
        }

        if (addr.types.includes("administrative_area_level_1")) {
          isValidAdministrative_area = true;
        }

        if (addr.types.includes("neighborhood")) {
          isValidLocality = true;
        } else if (addr.types.includes("locality")) {
          isValidLocality = true;
        }

        if (addr.types.includes("administrative_area_level_3")) {
          isValidCity = true;
        } else if (addr.types.includes("locality")) {
          isValidCity = true;
        } else if (addr.types.includes("sublocality_level_1")) {
          isValidCity = true;
        }
      });

      if (isValidStreet && isValidLocality && isValidAdministrative_area && isValidCity) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(address) {
      var _this9 = this;

      this.isValidAddress = true;
      var googleApiKey = process.env.googleApiKey;
      fetch("".concat(API.placeApiBasePath, "?address=").concat(address, "&key=").concat(googleApiKey)).then(function (response) {
        return response.json();
      }).then(function (location) {
        _this9._setListingAddress(address);

        _this9.geoPlaceId = location.results[0].place_id;
        _this9.geographicLocation = location.results[0].geometry.location;

        var _ref = location.results[0].address_components.find(function (c) {
          return c.types.includes("postal_code");
        }) || {},
            _ref$long_name = _ref.long_name,
            postalCode = _ref$long_name === void 0 ? "" : _ref$long_name;

        var isValidAdd = _this9.getValidAddr(get(location.results[0], "address_components", []));

        if (postalCode === "" || location.results[0].types[0] === "route" || !isValidAdd || !location.results[0].place_id) {
          _this9.isValidAddress = false;

          _this9.forceUpdate();
        }
      });
    }
  }, {
    key: "isUnitAvailable",
    value: function isUnitAvailable() {
      if (!this.state.unit) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "isBtnEnabled",
    value: function isBtnEnabled(selectedData) {
      var _this10 = this;

      var isDisable = false;
      get(selectedData, "images", []).map(function (room) {
        if (!get(room, "name", "") || !get(_this10.state, "building.address", "") || !get(selectedData, "unit", "") || selectedData.bathroom_unit === "" || get(selectedData, "bathroom_unit", "") > 9 || get(selectedData, "bathroom_unit", "") < 0 || selectedData.bedroom_unit === "" || get(selectedData, "bedroom_unit", "") > 9 || get(selectedData, "bedroom_unit", "") < 0 || selectedData.rent === "" || get(selectedData, "rent", "") > 99999 || get(selectedData, "rent", "") < 0 || selectedData.gross_rent === "" || get(selectedData, "gross_rent", "") > 99999 || get(selectedData, "gross_rent", "") < 0 || selectedData.price === "" || selectedData.price < 0 || selectedData.unit_size === "" || get(selectedData, "unit_size", "") > 30000 || get(selectedData, "unit_size", "") < 0 || !_this10.isValidAddress) {
          isDisable = true;
        }

        return isDisable;
      });
      return isDisable;
    }
  }, {
    key: "saveChanges",
    value: function saveChanges(options) {
      var _this11 = this;

      var payloadForEditListing = {};

      if (this.geographicLocation.lat && this.geographicLocation.lat && this.geoPlaceId) {
        payloadForEditListing = {
          listing_id: options._id,
          address: options.building.address,
          latitude: this.geographicLocation.lat.toString(),
          longitude: this.geographicLocation.lng.toString(),
          place_id: this.geoPlaceId.toString(),
          unit: options.unit,
          bedroom_unit: parseInt(options.bedroom_unit),
          bathroom_unit: parseInt(options.bathroom_unit),
          rent: parseInt(options.rent),
          price: parseInt(options.price),
          amenities: options.amenities,
          building_amenities: options.building_amenities,
          tax: parseInt(options.tax),
          maintenance: parseInt(options.maintenance),
          gross_rent: parseInt(options.gross_rent),
          description: options.description,
          layout_type: options.layout_type,
          unit_size: parseFloat(options.unit_size),
          require_contact: options.require_contact,
          allow_bypass: options.allow_bypass,
          custom_amenities: options.custom_amenities,
          custom_building_amenities: options.custom_building_amenities,
          is_model_unit: options.is_model_unit
        };
      } else {
        payloadForEditListing = {
          listing_id: options._id,
          unit: options.unit,
          bedroom_unit: parseInt(options.bedroom_unit),
          bathroom_unit: parseInt(options.bathroom_unit),
          rent: parseInt(options.rent),
          price: parseInt(options.price),
          amenities: options.amenities,
          building_amenities: options.building_amenities,
          tax: parseInt(options.tax),
          maintenance: parseInt(options.maintenance),
          gross_rent: parseInt(options.gross_rent),
          description: options.description,
          layout_type: options.layout_type,
          unit_size: parseFloat(options.unit_size),
          require_contact: options.require_contact,
          allow_bypass: options.allow_bypass,
          custom_amenities: options.custom_amenities,
          custom_building_amenities: options.custom_building_amenities,
          is_model_unit: options.is_model_unit
        };
      }

      var images = options.images.map(function (img) {
        var room = {
          image_id: img._id,
          name: img.name
        };
        return room;
      });
      var payloadForRenameRoom = {
        listing_id: options._id,
        images: images
      };
      var httpService = new HttpService(process.env.baseAPIPath);
      var isImageNameUpdated = false;
      var isListingEdited = false;
      httpService.post("listings/update_listing_image_name", payloadForRenameRoom, function (response) {
        isImageNameUpdated = response.data.success;
        httpService.post("listings/edit_listing", payloadForEditListing, function (response) {
          isListingEdited = response.data.success;

          if (isImageNameUpdated && isListingEdited) {
            _this11.props.onChange(true, _this11.state);

            if (!get(_this11.props, "hideCancelBtn", false)) {
              _this11.props.openEditListing();
            }

            window.postMessage({
              type: "notification",
              msg: "Listing edited successfully."
            });
          } else {
            if (!get(_this11.props, "hideCancelBtn", false)) {
              _this11.props.openEditListing();
            }

            window.postMessage({
              type: "notification",
              msg: "Error while editing listing."
            });
          }
        });
      });
    }
  }, {
    key: "_setUnitNumber",
    value: function _setUnitNumber(e) {
      this.setState({
        unit: e
      });
    }
  }, {
    key: "_setLayout",
    value: function _setLayout(e) {
      this.setState({
        layout_type: e
      });
    }
  }, {
    key: "_setUnitSize",
    value: function _setUnitSize(e) {
      if (this.state.unit_size > 0 && e === "") {
        this.setState({
          unit_size: 0
        });
      } else {
        this.setState({
          unit_size: e
        });
      }
    }
  }, {
    key: "_setListingAddress",
    value: function _setListingAddress(addr) {
      var building = _objectSpread$8({}, this.state.building);

      var addrArr = addr.split(",");
      building.address = addrArr[0];
      this.setState({
        building: building
      });
    }
  }, {
    key: "_setBathrooms",
    value: function _setBathrooms(e) {
      this.setState({
        bathroom_unit: e
      });
    }
  }, {
    key: "_setBedrooms",
    value: function _setBedrooms(e) {
      this.setState({
        bedroom_unit: e
      });
    }
  }, {
    key: "_setTax",
    value: function _setTax(e) {
      this.setState({
        tax: e
      });
    }
  }, {
    key: "_setRent",
    value: function _setRent(e) {
      if (this.state.rent > 0 && e === "") {
        this.setState({
          rent: 0
        });
      } else {
        this.setState({
          rent: e
        });
      }
    }
  }, {
    key: "_setGrossRent",
    value: function _setGrossRent(e) {
      if (this.state.gross_rent > 0 && e === "") {
        this.setState({
          gross_rent: 0
        });
      } else {
        this.setState({
          gross_rent: e
        });
      }
    }
  }, {
    key: "_setPrice",
    value: function _setPrice(e) {
      if (this.state.price > 0 && e === "") {
        this.setState({
          price: 0
        });
      } else {
        this.setState({
          price: e
        });
      }
    }
  }, {
    key: "_setMaintenace",
    value: function _setMaintenace(e) {
      this.setState({
        maintenance: e
      });
    }
  }, {
    key: "_setDescription",
    value: function _setDescription(e) {
      this.setState({
        description: e
      });
    }
  }, {
    key: "_setRenameRooms",
    value: function _setRenameRooms(e, id, images) {
      var updateImage = images.map(function (img) {
        return img._id === id ? _objectSpread$8(_objectSpread$8({}, img), {}, {
          name: e
        }) : img;
      });
      this.setState({
        images: updateImage
      });
    }
  }, {
    key: "_setRequireLogin",
    value: function _setRequireLogin() {
      this.setState(function (prevState) {
        return {
          require_contact: !prevState.require_contact,
          allow_bypass: false
        };
      });
    }
  }, {
    key: "_setModelUnit",
    value: function _setModelUnit() {
      this.setState(function (prevState) {
        return {
          is_model_unit: !prevState.is_model_unit
        };
      });
    }
  }, {
    key: "_setRequireLoginAllowBypass",
    value: function _setRequireLoginAllowBypass() {
      this.setState(function (prevState) {
        return {
          allow_bypass: !prevState.allow_bypass
        };
      });
    }
  }, {
    key: "_setAmenities",
    value: function _setAmenities(amenities, value) {
      if (amenities.indexOf(value) !== -1) {
        var amenity = amenities.filter(function (item) {
          return item !== value;
        });
        this.setState({
          amenities: amenity
        });
      } else {
        amenities.push(value);
        this.setState({
          amenities: amenities
        });
      }
    }
  }, {
    key: "_setBuildingAmenities",
    value: function _setBuildingAmenities(amenities, value) {
      if (amenities.indexOf(value) !== -1) {
        var amenity = amenities.filter(function (item) {
          return item !== value;
        });
        this.setState({
          building_amenities: amenity
        });
      } else {
        amenities.push(value);
        this.setState({
          building_amenities: amenities
        });
      }
    }
  }, {
    key: "_setCustomAmenities",
    value: function _setCustomAmenities(val) {
      if (val) {
        this.customAmenityIndex = null;
        this.isCustomAmenity = val;
        this.isCheckmark = false;
        this.forceUpdate();
      }
    }
  }, {
    key: "createAmenity",
    value: function createAmenity(val, index) {
      var _this12 = this;

      if (val && index > -1) {
        if (this.createdAmenity === "") {
          this.customamenity.splice(index, 1);
        } else {
          this.customamenity[index] = this.createdAmenity;
        }
      } else if (val && index === -1) {
        if (this.createdAmenity !== "") {
          this.isCheckmark = true;

          if (this.state.custom_amenities.length !== this.customamenity.length) {
            this.state.custom_amenities.map(function (custom) {
              _this12.customamenity.push(custom);

              return _this12.customamenity;
            });
          }

          this.customamenity.push(this.createdAmenity);
        } else {
          this.isCheckmark = false;
        }
      }

      this.setState({
        custom_amenities: this.customamenity
      });
      this.isCustomAmenity = false;
      this.createdAmenity = "";
      this.customAmenityIndex = null;
    }
  }, {
    key: "_setCustomAmenityName",
    value: function _setCustomAmenityName(e, val) {
      if (this.state.custom_amenities) {
        var amenity = this.state.custom_amenities.filter(function (item) {
          return item !== e;
        });

        if (amenity.length !== this.state.custom_amenities.length || e.indexOf(" ") === 0 || e === "") {
          this.isCheckmark = false;
        } else {
          this.isCheckmark = true;
        }

        this.createdAmenity = e;

        if (val === "edit") {
          this.tempCustomAmenityLabel = e;
        }

        this.forceUpdate();
      }
    }
  }, {
    key: "_updateCustomAmenity",
    value: function _updateCustomAmenity(index) {
      this.customamenity.splice(index, 1);
      this.setState({
        custom_amenities: this.customamenity
      });
    }
  }, {
    key: "_editCustomAmenity",
    value: function _editCustomAmenity(val, index) {
      var _this13 = this;

      if (val) {
        this.customAmenityIndex = index;
        this.tempCustomAmenityLabel = this.state.custom_amenities[index];
        this.createdAmenity = this.state.custom_amenities[index];
        this.isCheckmark = true;

        if (this.state.custom_amenities && this.state.custom_amenities.length > 0 && this.customamenity.length === 0) {
          this.state.custom_amenities.map(function (custom) {
            _this13.customamenity.push(custom);

            return _this13.customamenity;
          });
          this.setState({
            custom_amenities: this.customamenity
          });
        } else {
          this.setState({
            custom_amenities: this.customamenity
          });
        }
      }
    }
  }, {
    key: "saveCustomAmenityOnEnter",
    value: function saveCustomAmenityOnEnter(val, index) {
      var _this14 = this;

      if (val) {
        if (this.state.custom_amenities) {
          var amenity = this.state.custom_amenities.filter(function (item) {
            return item !== _this14.createdAmenity;
          });

          if (amenity.length !== this.state.custom_amenities.length || this.createdAmenity.indexOf(" ") === 0 || this.createdAmenity === "") {
            this.isCheckmark = false;
          } else {
            this.createAmenity(this.createdAmenity, index);
          }
        }
      }
    }
  }, {
    key: "_setToPreviousStateAmenity",
    value: function _setToPreviousStateAmenity() {
      this.customAmenityIndex = null;
      this.isCustomAmenity = false;
      this.forceUpdate();
    }
  }, {
    key: "_setToPreviousStateBuildingAmenity",
    value: function _setToPreviousStateBuildingAmenity() {
      this.customBuildingAmenityIndex = null;
      this.isCustomBuildingAmenity = false;
      this.forceUpdate();
    }
  }, {
    key: "saveCustomBuildingAmenityOnEnter",
    value: function saveCustomBuildingAmenityOnEnter(val, index) {
      var _this15 = this;

      if (val) {
        if (this.state.custom_building_amenities) {
          var amenity = this.state.custom_building_amenities.filter(function (item) {
            return item !== _this15.createdBuildingAmenity;
          });

          if (amenity.length !== this.state.custom_building_amenities.length || this.createdBuildingAmenity.indexOf(" ") === 0 || this.createdBuildingAmenity === "") {
            this.isCustomBuildingAmenityCheckmark = false;
          } else {
            this.createBuildingAmenity(this.createdBuildingAmenity, index);
          }
        }
      }
    }
  }, {
    key: "_setCustomBuildingAmenities",
    value: function _setCustomBuildingAmenities(val) {
      if (val) {
        this.customBuildingAmenityIndex = null;
        this.isCustomBuildingAmenity = val;
        this.isCustomBuildingAmenityCheckmark = false;
        this.forceUpdate();
      }
    }
  }, {
    key: "createBuildingAmenity",
    value: function createBuildingAmenity(val, index) {
      var _this16 = this;

      if (val && index > -1) {
        if (this.createdBuildingAmenity === "") {
          this.customBuildingAmenity.splice(index, 1);
        } else {
          this.customBuildingAmenity[index] = this.createdBuildingAmenity;
        }
      } else if (val && index === -1) {
        if (this.createdBuildingAmenity !== "") {
          this.isCustomBuildingAmenityCheckmark = true;

          if (this.state.custom_building_amenities && this.state.custom_building_amenities.length !== this.customBuildingAmenity.length) {
            this.state.custom_building_amenities.map(function (custom) {
              _this16.customBuildingAmenity.push(custom);

              return _this16.customBuildingAmenity;
            });
          }

          this.customBuildingAmenity.push(this.createdBuildingAmenity);
        } else {
          this.isCustomBuildingAmenityCheckmark = false;
        }
      }

      this.setState({
        custom_building_amenities: this.customBuildingAmenity
      });
      this.isCustomBuildingAmenity = false;
      this.createdBuildingAmenity = "";
      this.customBuildingAmenityIndex = null;
    }
  }, {
    key: "_setCustomBuildingAmenityName",
    value: function _setCustomBuildingAmenityName(e, val) {
      var amenity = [];

      if (this.state.custom_building_amenities) {
        amenity = this.state.custom_building_amenities.filter(function (item) {
          return item !== e;
        });

        if (amenity.length !== this.state.custom_building_amenities.length || e.indexOf(" ") === 0 || e === "") {
          this.isCustomBuildingAmenityCheckmark = false;
        } else {
          this.isCustomBuildingAmenityCheckmark = true;
        }
      } else {
        if (e.indexOf(" ") === 0 || e === "") {
          this.isCustomBuildingAmenityCheckmark = false;
        } else {
          this.isCustomBuildingAmenityCheckmark = true;
        }
      }

      this.createdBuildingAmenity = e;

      if (val === "edit") {
        this.tempCustomBuildingAmenityLabel = e;
      }

      this.forceUpdate();
    }
  }, {
    key: "_updateCustomBuilding",
    value: function _updateCustomBuilding(index) {
      this.customBuildingAmenity.splice(index, 1);
      this.setState({
        custom_building_amenities: this.customBuildingAmenity
      });
    }
  }, {
    key: "_editCustomBuildingAmenity",
    value: function _editCustomBuildingAmenity(val, index) {
      var _this17 = this;

      if (val) {
        this.customBuildingAmenityIndex = index;
        this.tempCustomBuildingAmenityLabel = this.state.custom_building_amenities[index];
        this.creacreatedBuildingAmenitytedAmenity = this.state.custom_building_amenities[index];
        this.isCustomBuildingAmenityCheckmark = true;

        if (this.state.custom_building_amenities && this.state.custom_building_amenities.length > 0 && this.customBuildingAmenity.length === 0) {
          this.state.custom_building_amenities.map(function (custom) {
            _this17.customBuildingAmenity.push(custom);

            return _this17.customBuildingAmenity;
          });
          this.setState({
            custom_building_amenities: this.customBuildingAmenity
          });
        } else {
          this.setState({
            custom_building_amenities: this.customBuildingAmenity
          });
        }
      }
    }
  }, {
    key: "getPostalSuggestions",
    value: function getPostalSuggestions(suggestions) {
      var suggestionsList = [];

      if (suggestions.length > 0) {
        suggestions.map(function (suggestion) {
          if (!suggestion.types.includes("route") || get(suggestion, "place_id", "")) {
            suggestionsList.push(suggestion);
          }
        });
        return suggestionsList;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this18 = this;

      if (Object.keys(this.state).length !== 0) {
        return /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement("div", {
          ref: this.setModalRef,
          className: "listing-modal-area"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "header-div"
        }, /*#__PURE__*/React__default.createElement("h1", {
          className: "listing-header"
        }, "Listing settings"), /*#__PURE__*/React__default.createElement(CheckBox, {
          label: "Model unit",
          isChecked: this.state.is_model_unit,
          onChange: function onChange() {
            _this18._setModelUnit();
          }
        })), /*#__PURE__*/React__default.createElement("div", {
          className: "edit-listing-form"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "edit-text-info-div"
        }, /*#__PURE__*/React__default.createElement("div", {
          style: {
            display: "flex",
            justifyContent: "space-between"
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          style: {
            flex: "65%",
            paddingRight: 10
          }
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
          className: "input-box " + (!this.state.unit ? "margin-b-30" : "")
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "label_error_wrapper"
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "_title"
        }, "Listing Address")), /*#__PURE__*/React__default.createElement(PlacesAutocomplete, {
          value: this.state.building.address,
          onChange: this.handleChange,
          onSelect: this.handleSelect,
          searchOptions: {
            componentRestrictions: {
              country: API.countryCodes
            }
          }
        }, function (_ref2) {
          var getInputProps = _ref2.getInputProps,
              suggestions = _ref2.suggestions,
              getSuggestionItemProps = _ref2.getSuggestionItemProps,
              loading = _ref2.loading;
          return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
            className: "listing-span"
          }, /*#__PURE__*/React__default.createElement("input", _extends$4({}, getInputProps({
            placeholder: "Listing address ...",
            className: "location-search-input"
          }), {
            className: "listing-input"
          }))), /*#__PURE__*/React__default.createElement("div", {
            className: "autocomplete-dropdown-container"
          }, loading && /*#__PURE__*/React__default.createElement("div", null, "Loading..."), _this18.getPostalSuggestions(suggestions) && _this18.getPostalSuggestions(suggestions).map(function (suggestion, index) {
            var className = suggestion.active ? "suggestion-item--active" : "suggestion-item";
            var style = suggestion.active ? {
              backgroundColor: "#fafafa",
              cursor: "pointer"
            } : {
              backgroundColor: "#ffffff",
              cursor: "pointer"
            };
            return /*#__PURE__*/React__default.createElement("div", _extends$4({}, getSuggestionItemProps(suggestion, {
              className: className,
              style: style
            }), {
              key: index
            }), /*#__PURE__*/React__default.createElement("span", {
              className: "listing-input"
            }, suggestion.description));
          })));
        }), /*#__PURE__*/React__default.createElement("span", null, (!get(this.state, "building.address", "") || !this.isValidAddress) && /*#__PURE__*/React__default.createElement("div", {
          className: "errorWrapper"
        }, /*#__PURE__*/React__default.createElement("span", null, "Please enter valid listing address")) || null))), /*#__PURE__*/React__default.createElement("div", {
          style: {
            display: "flex",
            justifyContent: "space-between"
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          style: {
            flex: "50%",
            paddingRight: 10
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "input-box"
        }, /*#__PURE__*/React__default.createElement(TextField$3, {
          type: "number",
          name: "bedrooms",
          label: "Bedrooms",
          placeholder: "Enter bedrooms",
          value: this.state.bedroom_unit,
          change: function change(e) {
            return _this18._setBedrooms(e);
          },
          isRequired: false,
          hasError: this.state.bedroom_unit > 9 || this.state.bedroom_unit < 0,
          errorMessage: "Please enter bedroom count in between 0 to 9"
        }))), /*#__PURE__*/React__default.createElement("div", {
          style: {
            flex: "50%"
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "input-box"
        }, /*#__PURE__*/React__default.createElement(TextField$3, {
          type: "number",
          name: "bathrooms",
          label: "Bathrooms",
          placeholder: "Enter bathrooms",
          value: this.state.bathroom_unit,
          change: function change(e) {
            return _this18._setBathrooms(e);
          },
          isRequired: false,
          hasError: this.state.bathroom_unit > 9 || this.state.bathroom_unit < 0,
          errorMessage: "Please enter bathroom count in between 0 to 9"
        })))), !this.state.is_sales_listing && /*#__PURE__*/React__default.createElement("div", {
          style: {
            display: "flex",
            justifyContent: "space-between"
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          style: {
            flex: "50%",
            paddingRight: 10
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "_title"
        }, "Rent"), /*#__PURE__*/React__default.createElement("span", {
          className: "input-box dollar-span"
        }, /*#__PURE__*/React__default.createElement(SymboledTextField$1, {
          symbol: "$",
          type: "number",
          name: "rent",
          id: "rent",
          placeholder: "Enter rent",
          min: 0,
          max: 99999,
          value: this.state.rent,
          change: function change(e) {
            return _this18._setRent(e);
          },
          hasError: get(this.state, "rent", "") > 99999 || get(this.state, "rent", "") < 0 || this.state.rent === "" || get(this.state, "rent", "").toString().indexOf(".") !== -1,
          errorMessage: "Please enter rent as a non-decimal value and in between 0 and 99999"
        }))), /*#__PURE__*/React__default.createElement("div", {
          style: {
            flex: "50%"
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "_title"
        }, "Gross Rent"), /*#__PURE__*/React__default.createElement("span", {
          className: "input-box dollar-span"
        }, /*#__PURE__*/React__default.createElement(SymboledTextField$1, {
          symbol: "$",
          type: "number",
          name: "gross_rent",
          id: "gross_rent",
          placeholder: "Enter gross rent",
          min: 0,
          max: 99999,
          value: this.state.gross_rent,
          change: function change(e) {
            return _this18._setGrossRent(e);
          },
          hasError: get(this.state, "gross_rent", "") > 99999 || get(this.state, "gross_rent", "") < 0 || this.state.gross_rent === "" || get(this.state, "gross_rent", "").toString().indexOf(".") !== -1,
          errorMessage: "Please enter gross rent as a non-decimal value and in between 0 and 99999"
        })))), this.state.is_sales_listing && /*#__PURE__*/React__default.createElement("div", {
          style: {
            display: "flex",
            justifyContent: "space-between"
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          style: {
            flex: "50%",
            paddingRight: 10
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "_title"
        }, "Price"), /*#__PURE__*/React__default.createElement("span", {
          className: "input-box dollar-span"
        }, /*#__PURE__*/React__default.createElement(SymboledTextField$1, {
          symbol: "$",
          type: "number",
          name: "price",
          id: "price",
          placeholder: "Enter price",
          min: 0,
          errorMessage: "Please enter price as a non-decimal value and should be greater than 0",
          hasError: get(this.state, "price", "") > 99999 || get(this.state, "price", "") < 0 || this.state.price === "" || get(this.state, "price", "").toString().indexOf(".") !== -1,
          value: this.state.price,
          change: function change(e) {
            return _this18._setPrice(e);
          }
        }))), /*#__PURE__*/React__default.createElement("div", {
          style: {
            flex: "50%"
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "_title"
        }, "Taxes"), /*#__PURE__*/React__default.createElement("span", {
          className: "input-box"
        }, /*#__PURE__*/React__default.createElement(TextField$3, {
          type: "number",
          name: "tax",
          id: "tax",
          placeholder: "Enter tax",
          value: this.state.tax,
          change: function change(e) {
            return _this18._setTax(e);
          }
        }))))), /*#__PURE__*/React__default.createElement("div", {
          style: {
            flex: "35%"
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          style: {
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column"
          }
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
          className: "input-box"
        }, /*#__PURE__*/React__default.createElement(TextField$3, {
          type: "text",
          name: "unitNumber",
          label: "Unit Number",
          placeholder: "Enter unit",
          value: this.state.unit,
          change: function change(e) {
            return _this18._setUnitNumber(e);
          },
          isRequired: false,
          hasError: this.isUnitAvailable(),
          errorMessage: "Please enter a unit number"
        }))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
          className: "input-box"
        }, /*#__PURE__*/React__default.createElement(TextField$3, {
          type: "text",
          name: "layout",
          label: "Layout type",
          placeholder: "Enter layout",
          value: this.state.layout_type,
          change: function change(e) {
            return _this18._setLayout(e);
          },
          isRequired: false
        }))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
          className: "input-box"
        }, /*#__PURE__*/React__default.createElement(TextField$3, {
          type: "text",
          name: "unitSize",
          label: "Unit size",
          placeholder: "Enter size",
          value: this.state.unit_size,
          change: function change(e) {
            return _this18._setUnitSize(e);
          },
          isRequired: false,
          hasError: get(this.state, "unit_size", "") > 30000 || get(this.state, "unit_size", "") < 0 || this.state.unit_size === "",
          errorMessage: "Please enter a unit size between 0 to 30000",
          inputUnit: "sqft"
        })))))), /*#__PURE__*/React__default.createElement("div", {
          style: {
            marginTop: 26
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "image-uploader"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "floorplan-div"
        }, /*#__PURE__*/React__default.createElement(FileUploader, {
          listingId: this.state._id,
          maxFileSize: 3000000,
          bucketName: process.env.floorPlanBucket,
          region: "us-east-1",
          identityPoolId: process.env.poolId,
          bucketUrl: process.env.floorPlanBaseImage,
          allowedExtensions: [".png", ".jpeg", ".jpg"],
          label: "Floorplan",
          path: this.state.floorplan,
          errorMessage: "Please upload an image in JPG or PNG format less than 3MB",
          fileUploadBtnLabel: "Replace",
          fileRemoveBtnLabel: "Delete",
          change: function change() {
            return _this18._setUploadFloorPlanPhoto(_this18.uploadedImageKey, _this18.state._id);
          },
          uploadToS3: function uploadToS3(data) {
            return _this18.uploadFloorplanImageToS3(data);
          },
          deleteFromS3: function deleteFromS3(data) {
            return _this18.deleteFloorplanImageFromS3(data);
          }
        })), /*#__PURE__*/React__default.createElement("div", {
          className: "cover-photo-div"
        }, /*#__PURE__*/React__default.createElement(FileUploader, {
          listingId: this.state._id,
          maxFileSize: 3000000,
          bucketName: process.env.coverImageBucket,
          region: "us-east-1",
          identityPoolId: process.env.poolId,
          bucketUrl: process.env.imageBasePath,
          path: this.state.thumbnails[0],
          allowedExtensions: [".png", ".jpeg", ".jpg"],
          label: "Cover photo",
          errorMessage: "Please upload an image in JPG or PNG format less than 3MB",
          fileUploadBtnLabel: "Replace",
          fileRemoveBtnLabel: "Delete",
          change: function change() {
            return _this18._setCoverPhoto(_this18.uploadedImageKey, _this18.state._id);
          },
          uploadToS3: function uploadToS3(data) {
            return _this18.uploadImageToS3(data);
          },
          deleteFromS3: function deleteFromS3(data) {
            return _this18.deleteImageFromS3(data);
          }
        })))), /*#__PURE__*/React__default.createElement("div", {
          style: {
            marginTop: 26
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "_title"
        }, "Unit amenities"), /*#__PURE__*/React__default.createElement("div", {
          className: "amenities-div"
        }, /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: API.checkIfOptionChecked("Dishwasher", this.state.amenities),
          label: "Dishwasher",
          onChange: function onChange() {
            return _this18._setAmenities(_this18.state.amenities, "Dishwasher");
          }
        }), /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: API.checkIfOptionChecked("Outdoor Space", this.state.amenities),
          label: "Outdoor Space",
          onChange: function onChange() {
            return _this18._setAmenities(_this18.state.amenities, "Outdoor Space");
          }
        })), /*#__PURE__*/React__default.createElement("div", {
          className: "amenities-div"
        }, /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: API.checkIfOptionChecked("Laundry In Unit", this.state.amenities),
          label: "Laundry In Unit",
          onChange: function onChange() {
            return _this18._setAmenities(_this18.state.amenities, "Laundry In Unit");
          }
        }), /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: API.checkIfOptionChecked("Furnished", this.state.amenities),
          label: "Furnished",
          onChange: function onChange() {
            return _this18._setAmenities(_this18.state.amenities, "Furnished");
          }
        }))), /*#__PURE__*/React__default.createElement("div", {
          ref: this.unitAmenityRef,
          className: "custom_amenities"
        }, get(this.state, "custom_amenities", []) && get(this.state, "custom_amenities", []).map(function (custom, index) {
          return /*#__PURE__*/React__default.createElement("div", {
            key: index,
            className: "custom_amenity"
          }, _this18.customAmenityIndex !== index && /*#__PURE__*/React__default.createElement(CheckBox, {
            isChecked: API.checkIfOptionChecked(_this18.state.custom_amenities[index], _this18.state.custom_amenities),
            label: custom,
            onChange: function onChange() {
              return _this18._updateCustomAmenity(index);
            },
            isEditLabel: true,
            onEditLableChange: function onEditLableChange(val) {
              return _this18._editCustomAmenity(val, index);
            },
            isRemoveLable: true,
            onRemobeLableChange: function onRemobeLableChange() {
              return _this18._updateCustomAmenity(index);
            }
          }), _this18.customAmenityIndex === index && /*#__PURE__*/React__default.createElement(TextField$3, {
            type: "text",
            name: "customAmenity",
            placeholder: "Enter custom unit amenity",
            isCheckmark: _this18.isCheckmark,
            isSelectionBox: true,
            isRequired: false,
            value: _this18.tempCustomAmenityLabel,
            onKeyDown: function onKeyDown(val) {
              return _this18.saveCustomAmenityOnEnter(val, index);
            },
            onIconClick: function onIconClick(e) {
              return _this18.createAmenity(e, index);
            },
            change: function change(e) {
              return _this18._setCustomAmenityName(e, "edit");
            }
          }));
        }), !this.isCustomAmenity && /*#__PURE__*/React__default.createElement("div", {
          className: "custom_checkbox"
        }, /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: false,
          label: "Custom..",
          onChange: function onChange() {
            return _this18._setCustomAmenities(true);
          }
        })), this.isCustomAmenity && /*#__PURE__*/React__default.createElement(TextField$3, {
          type: "text",
          name: "customAmenity",
          placeholder: "Enter custom unit amenity",
          isCheckmark: this.isCheckmark,
          isSelectionBox: true,
          isRequired: false,
          onKeyDown: function onKeyDown(val) {
            return _this18.saveCustomAmenityOnEnter(val, -1);
          },
          onIconClick: function onIconClick(e) {
            return _this18.createAmenity(e, -1);
          },
          change: function change(e) {
            return _this18._setCustomAmenityName(e, "");
          }
        }))), /*#__PURE__*/React__default.createElement("div", {
          className: "edit-text-info-div"
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(TextArea, {
          text: this.state.description,
          title: "Description",
          onChange: function onChange(e) {
            return _this18._setDescription(e);
          }
        })), /*#__PURE__*/React__default.createElement("div", {
          style: {
            marginTop: 26
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "_title"
        }, "Building amenities"), /*#__PURE__*/React__default.createElement("div", {
          className: "amenities-div"
        }, /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: API.checkIfOptionChecked("Doorman", this.state.building_amenities),
          label: "Doorman",
          onChange: function onChange() {
            return _this18._setBuildingAmenities(_this18.state.building_amenities, "Doorman");
          }
        }), /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: API.checkIfOptionChecked("Laundry In Building", this.state.building_amenities),
          label: "Laundry In Building",
          onChange: function onChange() {
            return _this18._setBuildingAmenities(_this18.state.building_amenities, "Laundry In Building");
          }
        })), /*#__PURE__*/React__default.createElement("div", {
          className: "amenities-div"
        }, /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: API.checkIfOptionChecked("Elevator", this.state.building_amenities),
          label: "Elevator",
          onChange: function onChange() {
            return _this18._setBuildingAmenities(_this18.state.building_amenities, "Elevator");
          }
        }), /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: API.checkIfOptionChecked("Pets Allowed", this.state.building_amenities),
          label: "Pets Allowed",
          onChange: function onChange() {
            return _this18._setBuildingAmenities(_this18.state.building_amenities, "Pets Allowed");
          }
        })), /*#__PURE__*/React__default.createElement("div", {
          className: "amenities-div"
        }, /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: API.checkIfOptionChecked("Gym", this.state.building_amenities),
          label: "Gym",
          onChange: function onChange() {
            return _this18._setBuildingAmenities(_this18.state.building_amenities, "Gym");
          }
        }), /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: API.checkIfOptionChecked("Swimming Pool", this.state.building_amenities),
          label: "Swimming Pool",
          onChange: function onChange() {
            return _this18._setBuildingAmenities(_this18.state.building_amenities, "Swimming Pool");
          }
        }))), /*#__PURE__*/React__default.createElement("div", {
          ref: this.buildingAmenityRef,
          className: "custom_amenities"
        }, get(this.state, "custom_building_amenities", []) && get(this.state, "custom_building_amenities", []).map(function (custom, index) {
          return /*#__PURE__*/React__default.createElement("div", {
            key: index,
            className: "custom_amenity"
          }, _this18.customBuildingAmenityIndex !== index && /*#__PURE__*/React__default.createElement(CheckBox, {
            isChecked: API.checkIfOptionChecked(_this18.state.custom_building_amenities[index], _this18.state.custom_building_amenities),
            label: custom,
            onChange: function onChange() {
              return _this18._updateCustomBuilding(index);
            },
            isEditLabel: true,
            onEditLableChange: function onEditLableChange(val) {
              return _this18._editCustomBuildingAmenity(val, index);
            },
            isRemoveLable: true,
            onRemobeLableChange: function onRemobeLableChange() {
              return _this18._updateCustomBuilding(index);
            }
          }), _this18.customBuildingAmenityIndex === index && /*#__PURE__*/React__default.createElement(TextField$3, {
            type: "text",
            name: "customBuildingAmenity",
            placeholder: "Enter custom building amenity",
            isCheckmark: _this18.isCustomBuildingAmenityCheckmark,
            isSelectionBox: true,
            isRequired: false,
            value: _this18.tempCustomBuildingAmenityLabel,
            onKeyDown: function onKeyDown(val) {
              return _this18.saveCustomBuildingAmenityOnEnter(val, index);
            },
            onIconClick: function onIconClick(e) {
              return _this18.createBuildingAmenity(e, index);
            },
            change: function change(e) {
              return _this18._setCustomBuildingAmenityName(e, "edit");
            }
          }));
        }), !this.isCustomBuildingAmenity && /*#__PURE__*/React__default.createElement("div", {
          className: "custom_checkbox"
        }, /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: false,
          label: "Custom..",
          onChange: function onChange() {
            return _this18._setCustomBuildingAmenities(true);
          }
        })), this.isCustomBuildingAmenity && /*#__PURE__*/React__default.createElement(TextField$3, {
          type: "text",
          name: "customBuildingAmenity",
          placeholder: "Enter custom building amenity",
          isCheckmark: this.isCustomBuildingAmenityCheckmark,
          isSelectionBox: true,
          isRequired: false,
          onIconClick: function onIconClick(e) {
            return _this18.createBuildingAmenity(e, -1);
          },
          onKeyDown: function onKeyDown(val) {
            return _this18.saveCustomBuildingAmenityOnEnter(val, -1);
          },
          change: function change(e) {
            return _this18._setCustomBuildingAmenityName(e, "");
          }
        })), /*#__PURE__*/React__default.createElement("div", {
          style: {
            marginTop: 26
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "prospect_form"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "prospect_form__title"
        }, "Contact form"), /*#__PURE__*/React__default.createElement("div", {
          className: "prospect_form__checks"
        }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: this.state.require_contact,
          label: "Request prospect emails",
          onChange: function onChange() {
            _this18._setRequireLogin();
          }
        })), /*#__PURE__*/React__default.createElement("span", {
          className: !this.state.require_contact && "is-disabled"
        }, /*#__PURE__*/React__default.createElement(CheckBox, {
          isChecked: this.state.require_contact && this.state.allow_bypass,
          label: "Allow bypass",
          onChange: function onChange() {
            _this18._setRequireLoginAllowBypass();
          }
        }))))))), /*#__PURE__*/React__default.createElement("div", {
          className: "edit-modal-btn"
        }, !get(this.props, "hideCancelBtn", false) && /*#__PURE__*/React__default.createElement("div", {
          className: "cancel-btn",
          style: {
            width: this.modalWidth
          }
        }, /*#__PURE__*/React__default.createElement(Button$2, {
          onClick: function onClick() {
            return _this18.cancelListing();
          },
          label: "Cancel"
        })), /*#__PURE__*/React__default.createElement("div", {
          className: "save-btn",
          style: {
            width: this.modalWidth
          }
        }, /*#__PURE__*/React__default.createElement(Button$2, {
          onClick: function onClick() {
            return _this18.saveChanges(_this18.state);
          },
          label: "Save changes",
          type: "standard savechanges-btn",
          disabled: this.isBtnEnabled(this.state)
        })))));
      } else {
        return null;
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (Object.keys(state).length === 0) {
        return _objectSpread$8({}, props.selectedData);
      }

      return null;
    }
  }]);

  return EditListing;
}(Component);

EditListing.propTypes = {
  selectedData: PropTypes.object,
  uploadToS3: PropTypes.func,
  deleteFromS3: PropTypes.func,
  openEditListing: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  hideCancelBtn: PropTypes.bool
};

var css_248z$e = ".analytics-container {\n  display: flex;\n  margin: 12px 0; }\n  .analytics-container .room-engagement-div {\n    border-radius: 4px;\n    width: 35%;\n    height: auto;\n    background-color: white;\n    box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1; }\n    .analytics-container .room-engagement-div .recharts-responsive-container {\n      height: 268px !important; }\n      .analytics-container .room-engagement-div .recharts-responsive-container .recharts-wrapper .recharts-surface {\n        position: absolute;\n        left: -20px; }\n        .analytics-container .room-engagement-div .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-xAxis .recharts-cartesian-axis-ticks .recharts-cartesian-axis-tick:first-child, .analytics-container .room-engagement-div .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-xAxis .recharts-cartesian-axis-ticks .recharts-cartesian-axis-tick:last-child {\n          transform: translate(0); }\n      .analytics-container .room-engagement-div .recharts-responsive-container .recharts-wrapper .recharts-legend-wrapper {\n        display: none; }\n  .analytics-container .total-impression-div {\n    width: 64%;\n    margin-left: 15px;\n    background: white;\n    border-radius: 4px;\n    box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1; }\n    .analytics-container .total-impression-div .dropdown {\n      width: 35%;\n      padding-top: 25px;\n      margin: 8px 10px 0 0;\n      box-shadow: none;\n      margin-top: 0; }\n      .analytics-container .total-impression-div .dropdown .dropdown__text {\n        padding: 5px 0;\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: bold;\n        font-size: 18px;\n        line-height: 22px;\n        display: flex;\n        align-items: center;\n        color: #1d1c38;\n        margin-left: 25px;\n        padding-bottom: 15px;\n        margin-right: 60px; }\n      .analytics-container .total-impression-div .dropdown .dropdown__text:after {\n        border-width: 0 2px 2px 0; }\n      .analytics-container .total-impression-div .dropdown .dropdown__items {\n        margin-top: 0;\n        width: 88%;\n        margin-left: 25px; }\n        .analytics-container .total-impression-div .dropdown .dropdown__items .dropdown__item {\n          font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-style: normal;\n          font-weight: normal;\n          font-size: 13px;\n          line-height: 15px;\n          display: flex;\n          align-items: center;\n          color: #333333;\n          padding: 10px 15px; }\n    .analytics-container .total-impression-div .time-series-div {\n      box-shadow: none; }\n      .analytics-container .total-impression-div .time-series-div .custom-chart-container {\n        height: 260px;\n        width: 100% !important; }\n        .analytics-container .total-impression-div .time-series-div .custom-chart-container .recharts-responsive-container > .recharts-wrapper {\n          left: -15px; }\n          .analytics-container .total-impression-div .time-series-div .custom-chart-container .recharts-responsive-container > .recharts-wrapper .recharts-surface {\n            left: 0; }\n  .analytics-container .margin-r-100 .dropdown .dropdown__text {\n    margin-right: 105px; }\n\n.source-div {\n  padding-bottom: 17px;\n  background-color: white;\n  height: 405px;\n  display: flex;\n  border-radius: 4px;\n  box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1; }\n  .source-div .traffic-source-div {\n    width: 45%; }\n    .source-div .traffic-source-div .peek-bar-chart {\n      height: 75% !important;\n      width: 102% !important; }\n      .source-div .traffic-source-div .peek-bar-chart .recharts-responsive-container .recharts-wrapper {\n        left: -25px !important; }\n    .source-div .traffic-source-div .no-data {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 200px;\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 14px;\n      color: #333333; }\n  .source-div .referral-source-div {\n    width: 55%; }\n\n.header-name {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n  color: #1d1c38;\n  margin-left: 25px;\n  padding-bottom: 15px;\n  margin-right: 50px;\n  padding-top: 25px;\n  margin-top: 0; }\n\n.last-days {\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 14px;\n  display: flex;\n  align-items: center;\n  color: #333333;\n  margin-left: 25px;\n  margin-bottom: 20px; }\n\n.impression-days {\n  margin-right: 35px; }\n\n@media only screen and (max-width: 767px) {\n  .filter-div {\n    flex-direction: column;\n    align-items: flex-start; }\n    .filter-div .date-range-div {\n      margin-left: 22px;\n      margin-top: 12px; }\n  .analytics-container {\n    flex-direction: column; }\n    .analytics-container .room-engagement-div {\n      width: 100%; }\n    .analytics-container .total-impression-div {\n      width: 100%;\n      margin-left: 0;\n      margin-top: 15px; }\n      .analytics-container .total-impression-div .time-series-div {\n        padding-right: 0; }\n  .source-div {\n    flex-direction: column;\n    height: auto; }\n    .source-div .traffic-source-div {\n      width: 100%;\n      height: 100%; }\n    .source-div .referral-source-div {\n      width: 100%;\n      background-color: white;\n      margin-top: 55px;\n      margin-bottom: 15px; } }\n";
styleInject(css_248z$e);

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CustomizedAxisTick = function CustomizedAxisTick(props) {
  var x = props.x,
      y = props.y,
      payload = props.payload;
  return /*#__PURE__*/React__default.createElement(Text, {
    x: x,
    y: y,
    width: props.width / props.visibleTicksCount,
    textAnchor: "middle",
    verticalAnchor: "start"
  }, payload.value);
};

CustomizedAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  visibleTicksCount: PropTypes.number,
  payload: PropTypes.object
};

var PeekBarChart = /*#__PURE__*/function (_Component) {
  _inherits$1(PeekBarChart, _Component);

  var _super = _createSuper$8(PeekBarChart);

  function PeekBarChart(props) {
    var _this;

    _classCallCheck$1(this, PeekBarChart);

    _this = _super.call(this, props);
    _this.state = {
      dates: []
    };
    _this.renderTooltip = _this.renderTooltip.bind(_assertThisInitialized$3(_this));
    _this.renderLegendText = _this.renderLegendText.bind(_assertThisInitialized$3(_this));
    _this.convertToPayloadForStaticXAxis = _this.convertToPayloadForStaticXAxis.bind(_assertThisInitialized$3(_this));
    _this.validateDate = _this.validateDate.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(PeekBarChart, [{
    key: "renderLegendText",
    value: function renderLegendText(value) {
      if (value === this.props.chartConfig.FIRST_DATAKEY) {
        return /*#__PURE__*/React__default.createElement("span", {
          className: "peek_bar_chart_legentName"
        }, /*#__PURE__*/React__default.createElement("span", {
          style: {
            width: "16px",
            height: "16px",
            borderRadius: "5px",
            marginRight: "7px",
            content: "",
            backgroundColor: this.props.chartConfig.FIRST_DATAKEY_FILL_COLOR
          }
        }), /*#__PURE__*/React__default.createElement("span", null, this.props.chartConfig.FIRST_LEGEND_NAME));
      } else if (value === this.props.chartConfig.SECOND_DATAKEY) {
        return /*#__PURE__*/React__default.createElement("span", {
          className: "peek_bar_chart_legentName"
        }, /*#__PURE__*/React__default.createElement("span", {
          style: {
            width: "16px",
            height: "16px",
            content: "",
            borderRadius: "5px",
            marginRight: "7px",
            backgroundColor: this.props.chartConfig.SECOND_DATAKEY_FILL_COLOR
          }
        }), /*#__PURE__*/React__default.createElement("span", null, this.props.chartConfig.SECOND_LEGEND_NAME));
      } else if (value === this.props.chartConfig.THIRD_DATAKEY) {
        return /*#__PURE__*/React__default.createElement("span", {
          className: "peek_bar_chart_legentName"
        }, /*#__PURE__*/React__default.createElement("span", {
          style: {
            width: "16px",
            height: "16px",
            content: "",
            borderRadius: "5px",
            marginRight: "7px",
            backgroundColor: this.props.chartConfig.THIRD_DATAKEY_FILL_COLOR
          }
        }), /*#__PURE__*/React__default.createElement("span", null, this.props.chartConfig.THIRD_LEGEND_NAME));
      } else if (value === this.props.chartConfig.FOURTH_DATAKEY) {
        return /*#__PURE__*/React__default.createElement("span", {
          className: "peek_bar_chart_legentName"
        }, /*#__PURE__*/React__default.createElement("span", {
          style: {
            width: "16px",
            height: "16px",
            content: "",
            borderRadius: "5px",
            marginRight: "7px",
            backgroundColor: this.props.chartConfig.FOURTH_DATAKEY_FILL_COLOR
          }
        }), /*#__PURE__*/React__default.createElement("span", null, this.props.chartConfig.FOURTH_LEGEND_NAME));
      }
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip(payload) {
      try {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, payload.payload !== undefined && payload.payload.length > 0 && /*#__PURE__*/React__default.createElement("div", {
          className: "custom-tooltip"
        }, " ", this.props.chartConfig.IS_DATE_AS_VALUE && /*#__PURE__*/React__default.createElement("span", null, " ", payload.payload[0].payload.formatted_date, " "), " ", " " + get(payload, "payload[0].payload.label", ""), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
          className: "hover-span"
        }, this.props.chartConfig.FIRST_DATAKEY && /*#__PURE__*/React__default.createElement("div", {
          className: "hover-row-div"
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("svg", {
          width: "10",
          height: "10",
          style: {
            borderRadius: 2
          }
        }, /*#__PURE__*/React__default.createElement("rect", {
          width: "10",
          height: "10",
          style: {
            fill: payload.payload[0].color
          }
        }))), /*#__PURE__*/React__default.createElement("div", {
          className: "sensex-div"
        }, /*#__PURE__*/React__default.createElement(Sensex, {
          data: [{
            lastValue: payload.payload[0].payload[this.props.chartConfig.FIRST_PREV_DATAKEY],
            currentValue: payload.payload[0].payload[this.props.chartConfig.FIRST_DATAKEY]
          }]
        }))) || null), /*#__PURE__*/React__default.createElement("span", {
          className: "hover-span"
        }, this.props.chartConfig.SECOND_DATAKEY && /*#__PURE__*/React__default.createElement("div", {
          className: "hover-row-div"
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("svg", {
          width: "10",
          height: "10",
          style: {
            borderRadius: 2
          }
        }, /*#__PURE__*/React__default.createElement("rect", {
          width: "10",
          height: "10",
          style: {
            fill: payload.payload[1].color
          }
        }))), /*#__PURE__*/React__default.createElement("div", {
          className: "sensex-div"
        }, /*#__PURE__*/React__default.createElement(Sensex, {
          data: [{
            lastValue: payload.payload[0].payload[this.props.chartConfig.SECOND_PREV_DATAKEY],
            currentValue: payload.payload[0].payload[this.props.chartConfig.SECOND_DATAKEY]
          }]
        }))) || null), /*#__PURE__*/React__default.createElement("span", {
          className: "hover-span"
        }, this.props.chartConfig.THIRD_DATAKEY && /*#__PURE__*/React__default.createElement("div", {
          className: "hover-row-div"
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("svg", {
          width: "10",
          height: "10",
          style: {
            borderRadius: 2
          }
        }, /*#__PURE__*/React__default.createElement("rect", {
          width: "10",
          height: "10",
          style: {
            fill: payload.payload[2].color
          }
        }))), /*#__PURE__*/React__default.createElement("div", {
          className: "sensex-div"
        }, /*#__PURE__*/React__default.createElement(Sensex, {
          data: [{
            lastValue: payload.payload[0].payload[this.props.chartConfig.THIRD_PREV_DATAKEY],
            currentValue: payload.payload[0].payload[this.props.chartConfig.THIRD_DATAKEY]
          }]
        }))) || null), /*#__PURE__*/React__default.createElement("span", {
          className: "hover-span"
        }, this.props.chartConfig.FOURTH_DATAKEY && /*#__PURE__*/React__default.createElement("div", {
          className: "hover-row-div"
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("svg", {
          width: "10",
          height: "10",
          style: {
            borderRadius: 2
          }
        }, /*#__PURE__*/React__default.createElement("rect", {
          width: "10",
          height: "10",
          style: {
            fill: payload.payload[3].color
          }
        }))), /*#__PURE__*/React__default.createElement("div", {
          className: "sensex-div"
        }, /*#__PURE__*/React__default.createElement(Sensex, {
          data: [{
            lastValue: payload.payload[0].payload[this.props.chartConfig.FOURTH_PREV_DATAKEY],
            currentValue: payload.payload[0].payload[this.props.chartConfig.FOURTH_DATAKEY]
          }]
        }))) || null)) || null);
      } catch (_unused) {
        return null;
      }
    }
  }, {
    key: "validateDate",
    value: function validateDate(index) {
      var _this2 = this;

      var isValidaDate = API.WEEK_DAYS.some(function (day) {
        return (_this2.props.dates[index] || get(_this2.props, "data[".concat(index, "].date"), "") || get(_this2.props, "data[".concat(index, "]._id"), "")) && (_this2.props.dates[index].toString().includes(day.toUpperCase()) || get(_this2.props, "data[".concat(index, "].date"), "").toString().includes(day.toUpperCase()) || get(_this2.props, "data[".concat(index, "]._id"), "").toString().includes(day.toUpperCase())) || false;
      });

      var _isValidaDate = API.MONTHLY_NAMES.some(function (day) {
        return (_this2.props.dates[index] || get(_this2.props, "data[".concat(index, "].date"), "") || get(_this2.props, "data[".concat(index, "]._id"), "")) && (_this2.props.dates[index].toString().includes(day.toUpperCase()) || get(_this2.props, "data[".concat(index, "].date"), "").toString().includes(day.toUpperCase()) || get(_this2.props, "data[".concat(index, "]._id"), "").toString().includes(day.toUpperCase())) || false;
      });

      return !isValidaDate && !_isValidaDate;
    }
  }, {
    key: "convertToPayloadForStaticXAxis",
    value: function convertToPayloadForStaticXAxis() {
      var _this3 = this;

      return this.props.data && this.props.data.map(function (key, index) {
        if (_this3.props.chartConfig.IS_DATE_AS_VALUE) {
          var isDateValidated = _this3.validateDate(index);

          if (isDateValidated) {
            var date = new Date(_this3.props.dates[index]);
            var formattedDate = API.WEEK_DAYS[date.getDay(date)] + ", " + API.MONTHLY_NAMES[date.getMonth(date)];
            key.formatted_date = formattedDate;

            if (_this3.props.chartConfig.IS_DATE_AS_VALUE) {
              var _date = new Date(key[_this3.props.chartConfig.XACCESSKEY]);

              var dt = _date.getDate();

              if (!Number.isNaN(dt)) {
                if (dt < 10) {
                  dt = "0" + dt;
                }

                key.label = dt;

                if (_this3.props.data.length > 30) {
                  key[_this3.props.chartConfig.XACCESSKEY] = API.MONTHLY_NAMES[_date.getMonth(_date)] + " " + dt;
                } else {
                  key[_this3.props.chartConfig.XACCESSKEY] = API.WEEK_DAYS[_date.getDay(_date)] + " " + dt;
                }

                key[_this3.props.chartConfig.XACCESSKEY] = key[_this3.props.chartConfig.XACCESSKEY].toUpperCase();
              }
            }
          }
        } else if (_this3.props.customizedLabel) {
          key.label = key[_this3.props.chartConfig.XACCESSKEY];
        } else {
          key.label = _this3.props.fixedToolTipLabel;
        }

        return key;
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(newProps, state) {
      if (get(newProps, "chartConfig.IS_DATE_AS_VALUE", false)) {
        return newProps.dates.length === state.dates.length && false || true;
      } else {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: ["peek-bar-chart", "peek-bar-chart-ex"].join(" "),
        style: {
          width: "100%",
          height: "100%"
        }
      }, /*#__PURE__*/React__default.createElement(ResponsiveContainer, {
        height: "100%",
        width: "100%"
      }, /*#__PURE__*/React__default.createElement(BarChart, {
        data: get(this.props, "chartConfig.IS_DATE_AS_VALUE", false) && this.state.payload || this.convertToPayloadForStaticXAxis(),
        margin: {
          top: 20,
          right: 30,
          left: 20,
          bottom: 5
        }
      }, /*#__PURE__*/React__default.createElement(CartesianGrid, {
        vertical: false
      }), /*#__PURE__*/React__default.createElement(XAxis, {
        dataKey: this.props.chartConfig.XACCESSKEY,
        interval: this.props.interval,
        tick: /*#__PURE__*/React__default.createElement(CustomizedAxisTick, null)
      }), /*#__PURE__*/React__default.createElement(YAxis, {
        axisLine: false
      }), this.props.showTooltip && /*#__PURE__*/React__default.createElement(Tooltip$2, {
        position: {
          y: -80
        },
        content: this.renderTooltip
      }) || null, !this.props.hideLegeds && /*#__PURE__*/React__default.createElement(Legend, {
        formatter: this.renderLegendText,
        layout: "horizontal",
        verticalAlign: "top",
        align: "left",
        wrapperStyle: {
          top: 0
        }
      }) || null, this.props.chartConfig.FIRST_DATAKEY && /*#__PURE__*/React__default.createElement(Bar, {
        dataKey: this.props.chartConfig.FIRST_DATAKEY,
        stackId: "a",
        fill: this.props.chartConfig.FIRST_DATAKEY_FILL_COLOR
      }), this.props.chartConfig.SECOND_DATAKEY && /*#__PURE__*/React__default.createElement(Bar, {
        dataKey: this.props.chartConfig.SECOND_DATAKEY,
        stackId: "a",
        fill: this.props.chartConfig.SECOND_DATAKEY_FILL_COLOR
      }), this.props.chartConfig.THIRD_DATAKEY && /*#__PURE__*/React__default.createElement(Bar, {
        dataKey: this.props.chartConfig.THIRD_DATAKEY,
        stackId: "a",
        fill: this.props.chartConfig.THIRD_DATAKEY_FILL_COLOR
      }), this.props.chartConfig.FOURTH_DATAKEY && /*#__PURE__*/React__default.createElement(Bar, {
        dataKey: this.props.chartConfig.FOURTH_DATAKEY,
        stackId: "a",
        fill: this.props.chartConfig.FOURTH_DATAKEY_FILL_COLOR
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(newProps, state) {
      var isNewData = false;

      if (get(newProps, "data", []) && get(state, "payload", []).length !== 0) {
        for (var i = 0; i < newProps.data.length; i++) {
          if (newProps.data[i] !== state.payload[i]) {
            isNewData = true;
          } else {
            isNewData = false;
          }
        }
      }

      if (get(newProps, "chartConfig.IS_DATE_AS_VALUE", false) && newProps.dates.length !== state.dates.length && isNewData) {
        return {
          dates: newProps.dates,
          payload: newProps.data && newProps.data.map(function (key, index) {
            if (newProps.chartConfig.IS_DATE_AS_VALUE) {
              var isValidaDate = API.WEEK_DAYS.some(function (day) {
                return newProps.dates[index] && newProps.dates[index].toString().includes(day.toUpperCase()) || false;
              });

              var _isValidaDate = API.MONTHLY_NAMES.some(function (day) {
                return newProps.dates[index] && newProps.dates[index].toString().includes(day.toUpperCase()) || false;
              });

              if (!isValidaDate && !_isValidaDate) {
                var date = new Date(newProps.dates[index]);
                var formattedDate = API.WEEK_DAYS[date.getDay(date)] + ", " + API.MONTHLY_NAMES[date.getMonth(date)];
                key.formatted_date = formattedDate;

                if (newProps.chartConfig.IS_DATE_AS_VALUE) {
                  var _date2 = new Date(key[newProps.chartConfig.XACCESSKEY]);

                  var dt = _date2.getDate();

                  if (!Number.isNaN(dt)) {
                    if (dt < 10) {
                      dt = "0" + dt;
                    }

                    key.label = dt;

                    if (newProps.data.length > 30) {
                      key[newProps.chartConfig.XACCESSKEY] = API.MONTHLY_NAMES[_date2.getMonth(_date2)] + " " + dt;
                    } else {
                      key[newProps.chartConfig.XACCESSKEY] = API.WEEK_DAYS[_date2.getDay(_date2)] + " " + dt;
                    }

                    key[newProps.chartConfig.XACCESSKEY] = key[newProps.chartConfig.XACCESSKEY].toUpperCase();
                  }
                }
              }
            } else if (newProps.customizedLabel) {
              key.label = key[newProps.chartConfig.XACCESSKEY];
            } else {
              key.label = newProps.fixedToolTipLabel;
            }

            return key;
          })
        };
      } else {
        return null;
      }
    }
  }]);

  return PeekBarChart;
}(Component);

PeekBarChart.defaultProps = {
  hideLegeds: false,
  showTooltip: true,
  interval: "preserveStartEnd"
};
PeekBarChart.propTypes = {
  data: PropTypes.array,
  chartConfig: PropTypes.object,
  dates: PropTypes.array,
  hideLegeds: PropTypes.bool,
  fixedToolTipLabel: PropTypes.string,
  customizedLabel: PropTypes.bool,
  showTooltip: PropTypes.bool,
  interval: PropTypes.string
};
var PeekBarChart$1 = /*#__PURE__*/React__default.memo(PeekBarChart);

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var barColors = ["#6DD230", "#FFBA3F"];

var SimpleBarChart = /*#__PURE__*/function (_PureComponent) {
  _inherits$1(SimpleBarChart, _PureComponent);

  var _super = _createSuper$7(SimpleBarChart);

  function SimpleBarChart(props) {
    var _this;

    _classCallCheck$1(this, SimpleBarChart);

    _this = _super.call(this, props);
    _this.customTooltip = _this.customTooltip.bind(_assertThisInitialized$3(_this));
    _this.CustomizedAxisTick = _this.CustomizedAxisTick.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(SimpleBarChart, [{
    key: "CustomizedAxisTick",
    value: function CustomizedAxisTick(props) {
      var x = props.x,
          y = props.y,
          payload = props.payload;
      var payloadArr = get(payload, "value", "").toString().split(" ");
      var val = payloadArr[0];

      if (this.props.data.length > 5) {
        val = val.substring(0, 3).concat("...");
      } else if (val && val.length > 4 || payloadArr.length > 1) {
        val = val.substring(0, 5).concat("...");
      }

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
        transform: "translate(".concat(x, ",").concat(y, ")")
      }, /*#__PURE__*/React__default.createElement("text", {
        dy: 6
      }, val, /*#__PURE__*/React__default.createElement("title", null, payload.value))));
    }
  }, {
    key: "customTooltip",
    value: function customTooltip(payload) {
      if (!payload) {
        return null;
      } else {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, get(payload, "payload", false) && payload.payload.length !== 0 && /*#__PURE__*/React__default.createElement("div", {
          className: "custom-tooltip"
        }, " ", payload.payload[0].payload[this.props.xaxisKey], " ", /*#__PURE__*/React__default.createElement("br", null), " ", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
          className: "hover-bar-span"
        }, parseFloat(payload.payload[0].payload[this.props.yaxisKey]).toFixed(2))));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(ResponsiveContainer, {
        width: "100%",
        height: "100%"
      }, /*#__PURE__*/React__default.createElement(BarChart, {
        width: 500,
        height: 300,
        data: this.props.data,
        margin: {
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }
      }, /*#__PURE__*/React__default.createElement(CartesianGrid, {
        vertical: false
      }), /*#__PURE__*/React__default.createElement(XAxis, {
        interval: 0,
        tick: this.CustomizedAxisTick,
        dataKey: this.props.xaxisKey
      }), /*#__PURE__*/React__default.createElement(YAxis, {
        axisLine: false
      }), /*#__PURE__*/React__default.createElement(Tooltip$2, {
        content: this.customTooltip,
        cursor: {
          fill: "none"
        }
      }), /*#__PURE__*/React__default.createElement(Legend, null), /*#__PURE__*/React__default.createElement(Bar, {
        dataKey: this.props.yaxisKey,
        fill: "#6DD230",
        radius: [4, 4, 0, 0]
      }), get(this.props, "data", false) && this.props.data.map(function (entry, index) {
        return /*#__PURE__*/React__default.createElement(Cell, {
          key: "cell-".concat(index),
          fill: barColors[index % 20]
        });
      })));
    }
  }]);

  return SimpleBarChart;
}(PureComponent);
SimpleBarChart.propTypes = {
  data: PropTypes.array,
  xaxisKey: PropTypes.string,
  yaxisKey: PropTypes.string
};

var css_248z$d = ".time-series-div-view-source {\n  background-color: white;\n  border-radius: 4px;\n  padding: 0 30px;\n  box-sizing: border-box;\n  margin-bottom: 149px; }\n  .time-series-div-view-source .last-days-span {\n    margin-bottom: 15px;\n    margin-left: 35px;\n    font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 12px;\n    line-height: 14px;\n    display: flex;\n    align-items: center;\n    color: #333333; }\n  .time-series-div-view-source .donut_chart_main_wrapper .chart_lable_wrapper {\n    display: flex; }\n    .time-series-div-view-source .donut_chart_main_wrapper .chart_lable_wrapper .color-block {\n      border-radius: 5px;\n      margin-right: 7px;\n      height: 16px;\n      width: 16px; }\n    .time-series-div-view-source .donut_chart_main_wrapper .chart_lable_wrapper .donut_chart_lable {\n      margin-right: 25px;\n      font-size: 14px;\n      line-height: 16px;\n      display: flex;\n      align-items: center;\n      color: #1d1c38; }\n  .time-series-div-view-source .donut_chart_main_wrapper .chart_wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start; }\n    .time-series-div-view-source .donut_chart_main_wrapper .chart_wrapper .donut_details {\n      box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n      border-radius: 5px;\n      margin: 0px 25px;\n      padding: 10px 15px; }\n      .time-series-div-view-source .donut_chart_main_wrapper .chart_wrapper .donut_details .date_range {\n        font-size: 10px;\n        line-height: 12px;\n        display: flex;\n        align-items: center;\n        color: #1d1c38;\n        margin-bottom: 7px;\n        font-weight: 600; }\n      .time-series-div-view-source .donut_chart_main_wrapper .chart_wrapper .donut_details .donut_chart_lable {\n        font-size: 11px;\n        line-height: 13px;\n        display: flex;\n        align-items: center;\n        color: #333333; }\n        .time-series-div-view-source .donut_chart_main_wrapper .chart_wrapper .donut_details .donut_chart_lable .color-block {\n          border-radius: 2px;\n          margin-right: 7px;\n          height: 10px;\n          width: 10px; }\n  .time-series-div-view-source .sensex_wrapper_component {\n    padding: 5px 35px; }\n    .time-series-div-view-source .sensex_wrapper_component .increase-percentage {\n      color: #6dd230; }\n  .time-series-div-view-source .custom-chart-container {\n    width: 100% !important; }\n    .time-series-div-view-source .custom-chart-container svg {\n      left: 0; }\n  .time-series-div-view-source .no-data {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 200px;\n    font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 14px;\n    color: #333333; }\n\n.time-series-div-view-source .decrease-percentage {\n  font-size: 10px !important;\n  line-height: 5px !important; }\n\n.time-series-div-view-source .current-value {\n  font-size: 11px !important;\n  line-height: 27.7px !important; }\n\n.time-series-div-view-source .sensex_wrapper_component .increase-percentage {\n  font-size: 10px !important;\n  line-height: 5px !important; }\n\n.time-series-div-view-source .sensex_wrapper_component {\n  padding: unset !important; }\n\n.chart_wrapper .recharts-wrapper {\n  margin-top: 30px; }\n";
styleInject(css_248z$d);

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ListingViews = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ListingViews, _React$Component);

  var _super = _createSuper$6(ListingViews);

  function ListingViews(props) {
    var _this;

    _classCallCheck$1(this, ListingViews);

    _this = _super.call(this, props);
    _this.state = {
      totalImpression: {},
      referralSource: {},
      colors: ["#FFBA3F", "#FFCA6B", "#FFE3B2", "#FFF1D8"],
      data: [],
      loader: true
    };
    _this.getTopThreeFields = _this.getTopThreeFields.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(ListingViews, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getReferralSource(this.props.dateRange, this.props.buildingId, this.props.listingsId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.dateRange !== this.props.dateRange || prevProps.buildingId !== this.props.buildingId || prevProps.listingsId !== this.props.listingsId) {
        this.getReferralSource(this.props.dateRange, this.props.buildingId, this.props.listingsId);
      }
    }
  }, {
    key: "getTopThreeFields",
    value: function getTopThreeFields(referral_source) {
      if (Object.entries(referral_source).length > 1) {
        return Object.entries(referral_source).sort(function (a, b) {
          return parseInt(b[1]) - parseInt(a[1]);
        });
      } else {
        return Object.entries(referral_source);
      }
    }
  }, {
    key: "getReferralSource",
    value: function getReferralSource(period, buildingId, unit) {
      var _this2 = this;

      var url = "analytics/get_referral_source_analytics?period=".concat(period);

      if (unit) {
        url += "&listing_id=".concat(unit);
      }

      if (buildingId) {
        url += "&building_id=".concat(buildingId);
      }

      var httpService = new HttpService(process.env.baseAPIPath);
      httpService.get(url, function (response) {
        var referral_sources = response.data.data.referral_sources;

        var referralSource = _this2.getTopThreeFields(referral_sources);

        var dataArr = [];

        if (referralSource.length > 0) {
          for (var i = 0; i < 3 && i < referralSource.length; i++) {
            var val = referralSource[i];
            dataArr.push({
              name: val[0],
              value: val[1]
            });
          }

          var Other = 0;

          for (var _i = 3; _i < referralSource.length; _i++) {
            var _val = referralSource[_i];
            Other = Other + _val[1];
          }

          if (Other) dataArr.push({
            name: "Other",
            value: Other
          });

          _this2.setState({
            totalImpression: referral_sources,
            data: dataArr,
            loader: false
          });
        } else {
          _this2.setState({
            totalImpression: {},
            referralSource: {},
            colors: ["#FFBA3F", "#FFCA6B", "#FFE3B2", "#FFF1D8"],
            data: [],
            loader: false
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, this.state.totalImpression && /*#__PURE__*/React__default.createElement("div", {
        className: "time-series-div-view-source"
      }, get(this.state, "loader", false) && /*#__PURE__*/React__default.createElement(SkeletonLoader, null), this.state.data && this.state.data.length > 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "donut_chart_main_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "chart_lable_wrapper"
      }, this.state.data.map(function (entry, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "donut_chart_lable",
          key: index
        }, " ", /*#__PURE__*/React__default.createElement("div", {
          style: {
            backgroundColor: _this3.state.colors[index % _this3.state.colors.length]
          },
          className: "color-block"
        }), /*#__PURE__*/React__default.createElement("div", null, entry.name));
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "chart_wrapper"
      }, /*#__PURE__*/React__default.createElement(PieChart, {
        width: 240,
        height: 240
      }, /*#__PURE__*/React__default.createElement(Pie, {
        data: this.state.data,
        cx: 100,
        cy: 100,
        innerRadius: 70,
        outerRadius: 100,
        fill: "#8884d8",
        paddingAngle: 0
      }, this.state.data.map(function (entry, index) {
        return /*#__PURE__*/React__default.createElement(Cell, {
          fill: _this3.state.colors[index % _this3.state.colors.length],
          key: index
        });
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "donut_details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "date_range"
      }, "Last ", this.props.dateRange, " days"), this.state.data.map(function (entry, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "donut_chart_lable",
          key: index
        }, /*#__PURE__*/React__default.createElement("div", {
          style: {
            backgroundColor: _this3.state.colors[index % _this3.state.colors.length]
          },
          className: "color-block"
        }), /*#__PURE__*/React__default.createElement("div", null, entry.value));
      })))), this.state.data && this.state.data.length === 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "no-data"
      }, "No data available")));
    }
  }]);

  return ListingViews;
}(React__default.Component);

ListingViews.propTypes = {
  listingsId: PropTypes.string,
  dateRange: PropTypes.number,
  buildingId: PropTypes.string
};
var ListingViews$1 = /*#__PURE__*/React__default.memo(ListingViews);

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ListingAnalytics = /*#__PURE__*/function (_Component) {
  _inherits$1(ListingAnalytics, _Component);

  var _super = _createSuper$5(ListingAnalytics);

  function ListingAnalytics(props) {
    var _this;

    _classCallCheck$1(this, ListingAnalytics);

    _this = _super.call(this, props);
    _this.state = {
      totalImpressionsDropdown: ["Total impressions", "Session time"],
      impression: "Total impressions",
      totalImpressionData: [],
      sessionTimeData: [],
      trafficSourceData: [],
      roomEngagementData: []
    };
    _this.setImpression = _this.setImpression.bind(_assertThisInitialized$3(_this));
    _this.getTotalImpressions = _this.getTotalImpressions.bind(_assertThisInitialized$3(_this));
    _this.getSessionTime = _this.getSessionTime.bind(_assertThisInitialized$3(_this));
    _this.getRoomEngagement = _this.getRoomEngagement.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(ListingAnalytics, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getTotalImpressions(this.props.dateRange, this.props.listingId);
      this.getTrafficSource(this.props.dateRange, this.props.listingId);
      this.getRoomEngagement(this.props.dateRange, this.props.listingId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.dateRange !== this.props.dateRange) {
        if (this.state.impression === "Total impressions") {
          this.getTotalImpressions(this.props.dateRange, this.props.listingId);
        } else if (this.state.impression === "Session time") {
          this.getSessionTime(this.props.dateRange, this.props.listingId);
        }

        this.getTrafficSource(this.props.dateRange, this.props.listingId);
        this.getRoomEngagement(this.props.dateRange, this.props.listingId);
      }
    }
  }, {
    key: "getTotalImpressions",
    value: function getTotalImpressions(period) {
      var _this2 = this;

      var listingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var url = "orglistings/get_day_wise_listings_views?period=".concat(period);

      if (listingId) {
        url += "&listing_id=".concat(listingId);
      } // eslint-disable-next-line no-undef


      var httpService = new HttpService(process.env.baseAPIPath);
      httpService.get(url, function (response) {
        if (response.data.success) {
          _this2.setState({
            totalImpressionData: response.data.data.day_wise_views
          });
        } else {
          window.postMessage({
            type: "notification",
            msg: "Error in fetching impression data"
          });
        }
      });
    }
  }, {
    key: "getRoomEngagement",
    value: function getRoomEngagement(period, listingId) {
      var _this3 = this;

      var url = "analytics/get_room_engagement_analytics?period=".concat(period);

      if (listingId) {
        url += "&listing_id=".concat(listingId);
      } // eslint-disable-next-line no-undef


      var httpService = new HttpService(process.env.baseAPIPath);
      httpService.get(url, function (response) {
        if (response.data.success) {
          _this3.setState({
            roomEngagementData: response.data.data.rooms
          });
        } else {
          window.postMessage({
            type: "notification",
            msg: "Error in fetching impression data"
          });
        }
      });
    }
  }, {
    key: "getSessionTime",
    value: function getSessionTime(period) {
      var _this4 = this;

      var listingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var url = "orglistings/get_day_wise_tour_views?period=".concat(period);

      if (listingId) {
        url += "&listing_id=".concat(listingId);
      } // eslint-disable-next-line no-undef


      var httpService = new HttpService(process.env.baseAPIPath);
      httpService.get(url, function (response) {
        if (response.data.success) {
          _this4.setState({
            sessionTimeData: response.data.data.day_wise_tour_duration_time
          });
        } else {
          window.postMessage({
            type: "notification",
            msg: "Error in saving rename rooms details"
          });
        }
      });
    }
  }, {
    key: "getTrafficSource",
    value: function getTrafficSource(period) {
      var _this5 = this;

      var listingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var isSourceCategory = true;
      var url = "orglistings/get_day_wise_analytics_by_origin?period=".concat(period, "&source_category=").concat(isSourceCategory);

      if (listingId) {
        url += "&listing_id=".concat(listingId);
      } // eslint-disable-next-line no-undef


      var httpService = new HttpService(process.env.baseAPIPath);
      httpService.get(url, function (response) {
        if (response.data.success) {
          _this5.setState({
            trafficSourceData: response.data.data.origin_details
          });
        } else {
          window.postMessage({
            type: "notification",
            msg: "Error in saving rename rooms details"
          });
        }
      });
    }
  }, {
    key: "setImpression",
    value: function setImpression(option) {
      if (option === "Total impressions") {
        this.getTotalImpressions(this.props.dateRange, this.props.listingId);
      } else if (option === "Session time") {
        this.getSessionTime(this.props.dateRange, this.props.listingId);
      }

      this.setState({
        impression: option
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var chartConfig = {
        XACCESSKEY: "_id",
        VALUE: "count",
        PREV_VALUE: "prev_count",
        IS_DATE_AS_VALUE: true,
        STROKE_COLOR: "#18C015",
        FILL_COLOR: "#fff"
      };
      var chartConfigForSession = {
        XACCESSKEY: "_id",
        VALUE: "duration_time",
        PREV_VALUE: "prev_duration_time",
        IS_DATE_AS_VALUE: true,
        STROKE_COLOR: "#FFBA3F",
        FILL_COLOR: "#fff"
      };
      var datesArrForListingViews = [];

      if (this.state.totalImpressionData !== undefined && this.state.totalImpressionData.length > 0) {
        // eslint-disable-next-line array-callback-return
        this.state.totalImpressionData.map(function (item) {
          datesArrForListingViews.push(item._id);
        });
      }

      var datesArrForSessionData = [];

      if (this.state.sessionTimeData !== undefined && this.state.sessionTimeData.length > 0) {
        for (var i = 0; i < this.state.sessionTimeData.length; i++) {
          datesArrForSessionData.push(this.state.sessionTimeData[i]._id);
        }
      }

      var datesForTrafficSorce = [];

      if (this.state.trafficSourceData !== undefined && this.state.trafficSourceData.length > 0) {
        // eslint-disable-next-line array-callback-return
        this.state.trafficSourceData.map(function (item) {
          datesForTrafficSorce.push(item.date);
        });
      }

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "analytics-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "room-engagement-div"
      }, /*#__PURE__*/React__default.createElement("h1", {
        className: "header-name"
      }, "Room engagement (avg. minutes)"), /*#__PURE__*/React__default.createElement("span", {
        className: "last-days"
      }, " Last ", this.props.dateRange, " days "), this.state.roomEngagementData.length > 0 && /*#__PURE__*/React__default.createElement(SimpleBarChart, {
        data: this.state.roomEngagementData,
        xaxisKey: "name",
        yaxisKey: "count"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "total-impression-div " + (this.state.impression === "Session time" ? "margin-r-100" : "")
      }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
        dropdownList: this.state.totalImpressionsDropdown,
        isArrayOfObject: false,
        keyName: "impression",
        placeholder: this.state.impression,
        change: function change(option) {
          _this6.setImpression(option);
        }
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "last-days impression-days"
      }, " Last ", this.props.dateRange, " days "), this.state.impression === "Total impressions" && /*#__PURE__*/React__default.createElement("div", {
        className: "time-series-div"
      }, /*#__PURE__*/React__default.createElement(TimeSeries$1, {
        chartConfig: chartConfig,
        showSensexOnHover: true,
        dateRange: this.props.dateRange,
        dates: datesArrForListingViews,
        data: this.state.totalImpressionData
      })), this.state.impression === "Session time" && /*#__PURE__*/React__default.createElement("div", {
        className: "time-series-div"
      }, /*#__PURE__*/React__default.createElement(TimeSeries$1, {
        chartConfig: chartConfigForSession,
        showSensexOnHover: true,
        dateRange: this.props.dateRange,
        dates: datesArrForSessionData,
        data: this.state.sessionTimeData
      })))), /*#__PURE__*/React__default.createElement("div", {
        className: "source-div"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "traffic-source-div"
      }, /*#__PURE__*/React__default.createElement("h1", {
        className: "header-name"
      }, "Traffic source"), /*#__PURE__*/React__default.createElement("span", {
        className: "last-days"
      }, " Last ", this.props.dateRange, " days "), this.state.trafficSourceData !== undefined && this.state.trafficSourceData.length > 0 && /*#__PURE__*/React__default.createElement(PeekBarChart$1, {
        dates: datesForTrafficSorce,
        data: this.state.trafficSourceData,
        chartConfig: {
          FIRST_DATAKEY: "link_count",
          FIRST_PREV_DATAKEY: "link_prevCount",
          FIRST_LEGEND_NAME: "Link",
          SECOND_DATAKEY: "referral_count",
          SECOND_PREV_DATAKEY: "referral_prevCount",
          SECOND_LEGEND_NAME: "Referral",
          THIRD_DATAKEY: "other_count",
          THIRD_PREV_DATAKEY: "other_prevCount",
          THIRD_LEGEND_NAME: "Other",
          IS_DATE_AS_VALUE: true,
          XACCESSKEY: "date",
          FIRST_DATAKEY_FILL_COLOR: "#6DD230",
          SECOND_DATAKEY_FILL_COLOR: "#FFBA3F",
          THIRD_DATAKEY_FILL_COLOR: "#7B61FF"
        }
      }) || /*#__PURE__*/React__default.createElement("div", {
        className: "no-data"
      }, "No aata available")), /*#__PURE__*/React__default.createElement("div", {
        className: "referral-source-div"
      }, /*#__PURE__*/React__default.createElement("h1", {
        className: "header-name",
        style: {
          marginRight: 35
        }
      }, /*#__PURE__*/React__default.createElement("svg", {
        width: "16",
        height: "16",
        style: {
          borderRadius: 5,
          marginRight: 15
        }
      }, /*#__PURE__*/React__default.createElement("rect", {
        width: "16",
        height: "16",
        style: {
          fill: "#FFBA3F"
        }
      })), " Referral source"), /*#__PURE__*/React__default.createElement("span", {
        className: "last-days"
      }, " Last ", this.props.dateRange, " days "), /*#__PURE__*/React__default.createElement(ListingViews$1, {
        listingsId: this.props.listingId,
        dateRange: this.props.dateRange
      }))));
    }
  }]);

  return ListingAnalytics;
}(Component);

ListingAnalytics.propTypes = {
  dateRange: PropTypes.number,
  listingId: PropTypes.string,
  buildingId: PropTypes.string
};

var css_248z$c = ".prospect_suggestions {\n  display: flex;\n  width: 100%; }\n  .prospect_suggestions div.container {\n    display: block;\n    width: 100%;\n    max-width: 295px;\n    position: relative; }\n    .prospect_suggestions div.container .prospect_list {\n      background-color: white;\n      display: block;\n      width: 100%;\n      position: absolute;\n      z-index: 2000;\n      margin-top: 5px; }\n      .prospect_suggestions div.container .prospect_list .prospects {\n        margin-bottom: 5px;\n        max-height: 150px;\n        overflow-y: auto;\n        z-index: 20;\n        background-color: #ffffff;\n        box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1; }\n        .prospect_suggestions div.container .prospect_list .prospects li.prospect_email {\n          font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-style: normal;\n          font-weight: normal;\n          font-size: 13px;\n          line-height: 15px;\n          display: block;\n          color: #333333;\n          padding: 10px 20px;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          white-space: nowrap; }\n          .prospect_suggestions div.container .prospect_list .prospects li.prospect_email span.prospect_name {\n            font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n            font-style: normal;\n            font-weight: bold;\n            font-size: 13px;\n            line-height: 15px;\n            color: #333333;\n            padding-right: 5px; }\n        .prospect_suggestions div.container .prospect_list .prospects li.prospect_email:hover {\n          background: rgba(4, 210, 198, 0.2);\n          cursor: pointer; }\n        .prospect_suggestions div.container .prospect_list .prospects .create_prospect {\n          font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 13px;\n          line-height: 15px;\n          color: #333333;\n          display: flex;\n          gap: 10px;\n          align-items: center;\n          cursor: pointer;\n          margin: 10px 0;\n          padding: 0 20px; }\n        .prospect_suggestions div.container .prospect_list .prospects .recent_prospects {\n          font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 11px;\n          line-height: 13px;\n          color: #979797;\n          margin-bottom: 2px;\n          padding: 0 20px; }\n    .prospect_suggestions div.container .top-160 {\n      top: -160px; }\n      .prospect_suggestions div.container .top-160 .prospects {\n        min-height: 150px; }\n    .prospect_suggestions div.container .prospect_wrapper {\n      display: flex;\n      background-color: #ffffff;\n      align-items: center;\n      height: 38px;\n      border-radius: 4px; }\n      .prospect_suggestions div.container .prospect_wrapper .tooltip_span {\n        display: flex;\n        flex: 1;\n        align-items: center;\n        justify-content: flex-end; }\n        .prospect_suggestions div.container .prospect_wrapper .tooltip_span svg {\n          background-color: #f5f5f5;\n          border-radius: 50%;\n          border: none;\n          margin-right: 10px;\n          cursor: pointer; }\n        .prospect_suggestions div.container .prospect_wrapper .tooltip_span .info_tooltip {\n          visibility: hidden;\n          position: absolute; }\n      .prospect_suggestions div.container .prospect_wrapper .tooltip_span:hover .info_tooltip {\n        visibility: visible;\n        height: auto;\n        padding: 12px;\n        background: linear-gradient(0deg, rgba(129, 129, 165, 0.2), rgba(129, 129, 165, 0.2)), #ffffff;\n        border-radius: 6px;\n        width: 230px;\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 13px;\n        display: flex;\n        align-items: center;\n        color: #1d1c38;\n        margin-top: 5px;\n        z-index: 2000;\n        margin-bottom: 115px; }\n      .prospect_suggestions div.container .prospect_wrapper .email {\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 15px;\n        line-height: 29px;\n        color: #383838;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n        padding-right: 5px; }\n      .prospect_suggestions div.container .prospect_wrapper .selected_prospect {\n        font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-style: normal;\n        font-weight: bold;\n        font-size: 15px;\n        line-height: 29px;\n        color: #383838;\n        padding-left: 10px;\n        padding-right: 5px;\n        white-space: nowrap; }\n      .prospect_suggestions div.container .prospect_wrapper .textfield_wrapper .controller_wrapper {\n        box-shadow: none; }\n        .prospect_suggestions div.container .prospect_wrapper .textfield_wrapper .controller_wrapper .textfield {\n          font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 29px;\n          color: #383838; }\n      .prospect_suggestions div.container .prospect_wrapper:focus-within {\n        background: #F5F5FA !important;\n        border: 1px solid #1D1C38; }\n        .prospect_suggestions div.container .prospect_wrapper:focus-within .textfield_wrapper .controller_wrapper:focus-within {\n          border: none; }\n\n._title {\n  flex-basis: 35%; }\n\n#prospect_listing {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(51, 51, 51, 0.82);\n  z-index: 9999;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif; }\n  #prospect_listing .prospect_container {\n    background: #f2f2f2;\n    border-radius: 5px;\n    width: 100%;\n    min-height: 400px;\n    min-width: 370px;\n    max-width: 500px;\n    position: relative;\n    padding: 18px 32px; }\n    @media screen and (max-width: 500px) {\n      #prospect_listing .prospect_container {\n        min-width: 320px; } }\n    #prospect_listing .prospect_container .prospect_title {\n      margin: 18px 0px;\n      padding-bottom: 10px;\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n      font-style: normal;\n      font-weight: bold;\n      font-size: 19px;\n      line-height: 22px;\n      border-bottom: 0.5px solid #c4c4c4;\n      color: #1d1c38; }\n    #prospect_listing .prospect_container .prospect_wrapper .form_control_flex_wrapper {\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      box-sizing: border-box;\n      margin: 16px 0px;\n      line-height: 14px; }\n      #prospect_listing .prospect_container .prospect_wrapper .form_control_flex_wrapper .form_control_label {\n        flex-basis: 27%;\n        font-size: 14px;\n        padding-right: 22px; }\n      #prospect_listing .prospect_container .prospect_wrapper .form_control_flex_wrapper .form_control_input {\n        width: 100%; }\n      #prospect_listing .prospect_container .prospect_wrapper .form_control_flex_wrapper .form_control_input > .textfield_wrapper > .controller_wrapper {\n        flex: 1; }\n        #prospect_listing .prospect_container .prospect_wrapper .form_control_flex_wrapper .form_control_input > .textfield_wrapper > .controller_wrapper .textfield {\n          font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-style: normal;\n          font-weight: normal;\n          line-height: 21px;\n          border-radius: 4px;\n          min-height: 36px;\n          font-size: 16px; }\n    #prospect_listing .prospect_container .required_field {\n      font-size: 13px;\n      line-height: 15px;\n      display: flex;\n      align-items: center;\n      margin: 10px 110px; }\n  #prospect_listing .prospect__action_btns {\n    display: flex;\n    padding-top: 24px;\n    justify-content: center;\n    border-top: solid 0.5px #c4c4c4; }\n    #prospect_listing .prospect__action_btns .standard,\n    #prospect_listing .prospect__action_btns .disabled {\n      height: 42px;\n      font-size: 15px;\n      font-weight: 500;\n      line-height: 18px;\n      margin-right: 15px;\n      min-width: 130px;\n      border-radius: 5px; }\n    #prospect_listing .prospect__action_btns .disabled:focus {\n      border: none !important; }\n\n.modal-cover {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1500;\n  transform: translateZ(0);\n  background-color: rgba(0, 0, 0, 0.8); }\n\n.modal-area {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 75%;\n  transform: translate(-50%, -50%);\n  max-height: 85vh;\n  padding: 32px 42px;\n  background-color: #f2f2f2;\n  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.1);\n  overflow: auto;\n  border-radius: 5px; }\n";
styleInject(css_248z$c);

var CreateNewProspect = function CreateNewProspect(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray$1(_useState, 2),
      validEmail = _useState2[0],
      setValidEmail = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray$1(_useState3, 2),
      email = _useState4[0],
      setEmail = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray$1(_useState5, 2),
      firstName = _useState6[0],
      setFirstName = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray$1(_useState7, 2),
      lastName = _useState8[0],
      setLastName = _useState8[1];

  var _useState9 = useState(""),
      _useState10 = _slicedToArray$1(_useState9, 2),
      phone = _useState10[0],
      setPhone = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray$1(_useState11, 2),
      phoneDirty = _useState12[0],
      setPhoneDirty = _useState12[1];

  useEffect(function () {
    var container = document.getElementsByClassName("modal_overflow"); //props.toggleParent();

    if (container.length) {
      var modal = container[0];
      modal.addEventListener("click", function () {
        props.toggleCreateProspect();
      });
    }

    return function () {
      if (container.length) {
        var _modal = container[0];

        _modal.removeEventListener("click", function () {
          props.toggleCreateProspect();
        });
      }
    };
  }, []);

  var handleClickOutside = function handleClickOutside(event) {
    var attr = event.target.getAttribute("id");

    if (attr === "prospect_listing") {
      closeModal();
    }
  };

  var closeModal = function closeModal() {
    document.removeEventListener("mousedown", handleClickOutside);
    props.toggleCreateProspect();
  };

  var createNewPorsp = function createNewPorsp() {
    // eslint-disable-next-line no-undef
    var httpService = new HttpService(process.env.baseAPIPath);
    var payload = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: phone
    };
    httpService.post("prospects/create_prospect", payload, function (response) {
      if (response.data.success) {
        window.postMessage({
          type: "notification",
          msg: "New prospect is created."
        });
        closeModal();
      }
    });
  };

  var validEmailTest = function validEmailTest(e) {
    if (e) {
      if (API.checkEmail(e.target.value)) {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    }
  };

  var isBtnEnabled = function isBtnEnabled() {
    var isDisable = false;

    if (firstName === "" || lastName === "" || email === "" || validEmail === false || phone === "" || !API.checkPhone(phone)) {
      isDisable = true;
    }

    return isDisable;
  };

  return /*#__PURE__*/React__default.createElement(Portal$2, {
    nodename: "prospect_listing"
  }, /*#__PURE__*/React__default.createElement("section", {
    className: "prospect_container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "prospect_title"
  }, /*#__PURE__*/React__default.createElement("span", null, "Create new prospect")), /*#__PURE__*/React__default.createElement("div", {
    className: "prospect_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_flex_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "label"
  }, "Email address"), /*#__PURE__*/React__default.createElement("span", {
    className: "red"
  }, "*")), /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_input"
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    value: email,
    errorMessage: !validEmail && "You must include a valid email address" || "Email  is required",
    hasError: !validEmail,
    blur: function blur(e) {
      return validEmailTest(e);
    },
    isRequired: true,
    change: function change(e) {
      return setEmail(e);
    },
    placeholder: "example@mail.com"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_flex_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "label"
  }, "First name"), /*#__PURE__*/React__default.createElement("span", {
    className: "red"
  }, "*")), /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_input"
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    value: firstName,
    placeholder: "Johnny",
    isRequired: true,
    change: function change(e) {
      return setFirstName(e);
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_flex_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "label"
  }, "Last name"), /*#__PURE__*/React__default.createElement("span", {
    className: "red"
  }, "*")), /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_input"
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    value: lastName,
    placeholder: "Appleseed",
    isRequired: true,
    change: function change(e) {
      return setLastName(e);
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_flex_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "label"
  }, "Phone number"), /*#__PURE__*/React__default.createElement("span", {
    className: "red"
  }, "*")), /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_input"
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    value: phone,
    placeholder: "123-456-6969",
    isRequired: true,
    change: function change(e) {
      return setPhone(e);
    },
    hasError: API.checkPhone(phone) === false && phoneDirty,
    blur: function blur() {
      return setPhoneDirty(true);
    },
    errorMessage: "Please enter mobile number in 999-999-9999 format"
  })))), /*#__PURE__*/React__default.createElement("section", {
    className: "prospect__action_btns"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "standard",
    onClick: function onClick() {
      closeModal();
    },
    label: "Cancel",
    color: "#fff",
    textColor: "#333"
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "standard",
    onClick: function onClick() {
      createNewPorsp();
    },
    label: "Create",
    disabled: isBtnEnabled()
  }))));
};

CreateNewProspect.propTypes = {
  toggleCreateProspect: PropTypes.func.isRequired,
  toggleParent: PropTypes.func
};

var SearchbarSuggestion = function SearchbarSuggestion(props) {
  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      prospectName = _useState2[0],
      setProspectName = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray$1(_useState3, 2),
      prospectEmail = _useState4[0],
      setProspectEmail = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray$1(_useState5, 2),
      label = _useState6[0],
      setLabel = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray$1(_useState7, 2),
      prospectsList = _useState8[0],
      setProspectsList = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray$1(_useState9, 2),
      isProspectList = _useState10[0],
      setIsProspectList = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray$1(_useState11, 2),
      showCreateProspect = _useState12[0],
      setShowCreateProspect = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray$1(_useState13, 2),
      isProspectSelected = _useState14[0],
      setIsProspectSelected = _useState14[1];

  var node = useRef();
  useEffect(function () {
    document.addEventListener("mousedown", handleClick);
    return function () {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  var handleClick = function handleClick(e) {
    if (!node.current.contains(e.target)) {
      setIsProspectList(false);
    }
  };

  var _getProspectList = function _getProspectList(payload) {
    var httpService = new HttpService(process.env.baseAPIPath);
    httpService.post("prospects/get_prospect_list", payload, function (response) {
      if (response.data.success) {
        setIsProspectList(true);
        setProspectsList(response.data.data);
      }
    });
  };

  var createProspect = function createProspect(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    setShowCreateProspect(!showCreateProspect);
    props.toggleParent(true);
  };

  var getProspectsList = function getProspectsList(val) {
    setLabel(val);

    if (val === "" && !props.showTooltip) {
      props.getFirstName("");
      props.getLastName("");
      getRecentProspects();
    }

    setProspectName(val);
    var payload = {
      search_email: val,
      start_index: 0,
      limit: 10
    };

    _getProspectList(payload);
  };

  var getRecentProspects = function getRecentProspects() {
    setProspectEmail("");
    setProspectName("");
    props.change("");
    setLabel("");

    if (!props.showTooltip) {
      props.getFirstName("");
      props.getLastName("");
    }

    var payload = {
      start_index: 0,
      limit: 4
    };

    _getProspectList(payload);
  };

  var selectProspect = function selectProspect(event, prospect) {
    event.preventDefault();
    event.stopPropagation();
    setProspectName(prospect.name);
    setProspectEmail(prospect.email);
    props.change(prospect.email);

    if (!props.showTooltip) {
      prospect.first_name ? props.getFirstName(prospect.first_name) : props.getFirstName("");
      prospect.last_name ? props.getLastName(prospect.last_name) : props.getLastName("");
    }

    setIsProspectList(false);
    setIsProspectSelected(true);
  };

  var hoverOnProspect = function hoverOnProspect(prospect) {
    setIsProspectSelected(true);
    setProspectName(prospect.name);
    setProspectEmail(prospect.email);
  };

  var hoverOffProspect = function hoverOffProspect() {
    setIsProspectSelected(false);
    setProspectName("");
    setProspectEmail("");
  };

  var showProspectInput = function showProspectInput() {
    setIsProspectSelected(false);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "prospect_suggestions"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "form_control_label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "label"
  }, props.emailTitle), /*#__PURE__*/React__default.createElement("span", {
    className: "red"
  }, "*")), /*#__PURE__*/React__default.createElement("div", {
    ref: node,
    onClick: function onClick() {
      return getRecentProspects();
    },
    className: "container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "prospect_wrapper"
  }, !isProspectSelected && /*#__PURE__*/React__default.createElement(TextField$3, {
    type: "text",
    name: "label",
    value: prospectName,
    change: function change(val) {
      return getProspectsList(val);
    },
    placeholder: "example@mail.com",
    autocomplete: "off"
  }), isProspectSelected && /*#__PURE__*/React__default.createElement("span", {
    className: "selected_prospect",
    onClick: function onClick() {
      return showProspectInput();
    }
  }, prospectName), /*#__PURE__*/React__default.createElement("span", {
    className: "email",
    onClick: function onClick() {
      return showProspectInput();
    }
  }, prospectEmail), props.showTooltip && /*#__PURE__*/React__default.createElement("span", {
    className: "tooltip_span"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "info_tooltip"
  }, "Tracked link data is reported in Prospect Intelligence. Prospects are identified by email address"), /*#__PURE__*/React__default.createElement(MemoSvgInfo, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "prospect_list " + (get(props, "topProspectList", false) ? "top-160" : "")
  }, get(prospectsList, "prospect_list", []).length > 0 && isProspectList && /*#__PURE__*/React__default.createElement("ul", {
    className: "prospects"
  }, /*#__PURE__*/React__default.createElement("li", {
    className: "create_prospect",
    onClick: function onClick(event) {
      return createProspect(event);
    }
  }, /*#__PURE__*/React__default.createElement(MemoSvgPlus, null), "Create a new prospect"), !label && /*#__PURE__*/React__default.createElement("li", {
    className: "recent_prospects"
  }, "RECENT PROSPECTS"), label && /*#__PURE__*/React__default.createElement("li", {
    className: "recent_prospects"
  }, "Results matching: \"".concat(label, "\"")), get(prospectsList, "prospect_list", []).map(function (prospect, index) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: index,
      className: "prospect_email",
      onClick: function onClick(event) {
        return selectProspect(event, prospect);
      },
      onMouseOut: function onMouseOut() {
        return hoverOffProspect();
      },
      onMouseOver: function onMouseOver() {
        return hoverOnProspect(prospect);
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "prospect_name"
    }, prospect.name), prospect.email);
  })) || null, get(prospectsList, "prospect_list", []).length === 0 && label && /*#__PURE__*/React__default.createElement("ul", {
    className: "prospects"
  }, /*#__PURE__*/React__default.createElement("li", {
    className: "create_prospect",
    onClick: function onClick(event) {
      return createProspect(event);
    }
  }, /*#__PURE__*/React__default.createElement(MemoSvgPlus, null), "Create a new prospect"), /*#__PURE__*/React__default.createElement("li", {
    className: "recent_prospects"
  }, "No results matching \"".concat(label, "\""))) || null)), showCreateProspect && /*#__PURE__*/React__default.createElement(CreateNewProspect, {
    toggleCreateProspect: createProspect
  }));
};

SearchbarSuggestion.propTypes = {
  change: PropTypes.func,
  toggleParent: PropTypes.func,
  emailTitle: PropTypes.string,
  showTooltip: PropTypes.bool,
  getFirstName: PropTypes.func,
  getLastName: PropTypes.func,
  topProspectList: PropTypes.bool
};
var SearchbarSuggestion$1 = /*#__PURE__*/React__default.memo(SearchbarSuggestion);

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EmailListing = /*#__PURE__*/function (_Component) {
  _inherits$1(EmailListing, _Component);

  var _super = _createSuper$4(EmailListing);

  function EmailListing(props) {
    var _this;

    _classCallCheck$1(this, EmailListing);

    _this = _super.call(this, props);
    _this.sendEmailListing = _this.sendEmailListing.bind(_assertThisInitialized$3(_this));
    _this.toggleEmail = _this.toggleEmail.bind(_assertThisInitialized$3(_this));
    _this.isBtnEnabled = _this.isBtnEnabled.bind(_assertThisInitialized$3(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized$3(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized$3(_this));
    _this.state = {
      validEmail: true,
      setEmail: "",
      setFirstName: "",
      setLastName: "",
      customMessage: "",
      emailCopy: false
    };
    return _this;
  }

  _createClass$1(EmailListing, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mousedown", this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
  }, {
    key: "_setFirstName",
    value: function _setFirstName(e) {
      this.setState({
        setFirstName: e
      });
    }
  }, {
    key: "_setLastName",
    value: function _setLastName(e) {
      this.setState({
        setLastName: e
      });
    }
  }, {
    key: "_setEmail",
    value: function _setEmail(e) {
      this.setState({
        setEmail: e
      });
    }
  }, {
    key: "_setCustomMessage",
    value: function _setCustomMessage(e) {
      this.setState({
        customMessage: e
      });
    }
  }, {
    key: "_sendEmailCopy",
    value: function _sendEmailCopy(emailCopy) {
      this.setState({
        emailCopy: emailCopy
      });
    }
  }, {
    key: "_sendEmail",
    value: function _sendEmail(id, firstName, lastName, emailAddress, customMessage, sendCopy) {
      // eslint-disable-next-line no-undef
      var httpService = new HttpService(process.env.baseAPIPath);
      var payload = {
        listing_id: id,
        first_name: firstName,
        last_name: lastName,
        client_email: emailAddress,
        custom_message: customMessage,
        email_me: sendCopy
      };
      httpService.post("/listings/send_listing_by_email", payload, function (response) {
        if (!response.data.success) {
          window.postMessage({
            type: "notification",
            msg: response.data.message
          });
        }

        if (response.data.success) {
          window.postMessage({
            type: "notification",
            msg: "Your email was sent."
          });
        } else {
          window.postMessage({
            type: "notification",
            msg: "Error while sending email."
          });
        }
      });
    }
  }, {
    key: "sendEmailListing",
    value: function sendEmailListing() {
      this._sendEmail(this.props.data._id, this.state.setFirstName, this.state.setLastName, this.state.setEmail, this.state.customMessage, this.state.emailCopy);

      this.closeModal();
      window.postMessage({
        type: "notification",
        msg: "Your email was sent."
      });
    }
  }, {
    key: "isBtnEnabled",
    value: function isBtnEnabled() {
      var isDisable = false;

      if (this.state.setFirstName === "" || this.state.setLastName === "" || this.state.setEmail === "" || this.state.validEmail === false) {
        isDisable = true;
      }

      return isDisable;
    }
  }, {
    key: "toggleEmail",
    value: function toggleEmail() {
      this._sendEmailCopy(!this.state.emailCopy);
    }
  }, {
    key: "validEmailTest",
    value: function validEmailTest(e) {
      if (e) {
        if (API.checkEmail(e.target.value)) {
          this.setState({
            validEmail: true
          });
        } else {
          this.setState({
            validEmail: false
          });
        }
      }
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      var attr = event.target.getAttribute("id");

      if (attr === "email_listing") {
        this.closeModal();
      }
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      document.removeEventListener("mousedown", this.handleClickOutside);
      this.props.toggleEmail();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React__default.createElement(Portal$2, {
        nodename: "email_listing"
      }, /*#__PURE__*/React__default.createElement("section", {
        className: "email_container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "email_title"
      }, /*#__PURE__*/React__default.createElement("span", null, "Email this listing")), /*#__PURE__*/React__default.createElement("div", {
        className: "email_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement(SearchbarSuggestion$1, {
        emailTitle: "Email",
        getFirstName: function getFirstName(e) {
          return _this2._setFirstName(e);
        },
        getLastName: function getLastName(e) {
          return _this2._setLastName(e);
        },
        change: function change(e) {
          return _this2._setEmail(e);
        },
        showTooltip: false
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "First name"), /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(TextField$3, {
        value: this.state.setFirstName,
        errorMessage: "Please enter first name",
        isRequired: true,
        change: function change(e) {
          return _this2._setFirstName(e);
        },
        placeholder: "John"
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_flex_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "label"
      }, "Last name"), /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*")), /*#__PURE__*/React__default.createElement("div", {
        className: "form_control_input"
      }, /*#__PURE__*/React__default.createElement(TextField$3, {
        value: this.state.setLastName,
        errorMessage: "Please enter last name",
        isRequired: true,
        change: function change(e) {
          return _this2._setLastName(e);
        },
        placeholder: "Appleseed"
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "custom_message"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "cust_message"
      }, "Custom message"), /*#__PURE__*/React__default.createElement(TextArea, {
        onChange: function onChange(e) {
          return _this2._setCustomMessage(e);
        },
        placeholder: "Write here..."
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "required_field"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, "*"), /*#__PURE__*/React__default.createElement("span", null, "Required field")), /*#__PURE__*/React__default.createElement("div", {
        className: "email_copy"
      }, /*#__PURE__*/React__default.createElement(CheckBox$1, {
        label: "Send me a copy of this message",
        onChange: this.toggleEmail,
        isChecked: this.state.emailCopy
      }))), /*#__PURE__*/React__default.createElement("section", {
        className: "email__action_btns"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        type: "standard",
        onClick: function onClick() {
          _this2.closeModal();
        },
        label: "Cancel",
        color: "#fff",
        textColor: "#333"
      }), /*#__PURE__*/React__default.createElement(Button$2, {
        type: "standard",
        onClick: function onClick() {
          _this2.sendEmailListing();
        },
        label: "Send",
        disabled: this.isBtnEnabled()
      }))));
    }
  }]);

  return EmailListing;
}(Component);

EmailListing.propTypes = {
  data: PropTypes.object.isRequired,
  toggleEmail: PropTypes.func.isRequired
};

var ShareListing = function ShareListing(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      tracking = _useState2[0],
      setTracking = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray$1(_useState3, 2),
      address = _useState4[0],
      setAddress = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray$1(_useState5, 2),
      email = _useState6[0],
      setEmail = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray$1(_useState7, 2),
      isWarningAccepted = _useState8[0],
      setIsWarningAccepted = _useState8[1];

  useEffect(function () {
    var container = document.getElementsByClassName("modal_overflow");

    if (container.length) {
      var modal = container[0];
      modal.addEventListener("click", function () {
        props.openShareListing();
      });
    }

    return function () {
      if (container.length) {
        var _modal = container[0];

        _modal.removeEventListener("click", function () {
          props.openShareListing();
        });
      }
    };
  }, []);

  var showWarningModal = function showWarningModal() {
    if (tracking) {
      setIsWarningAccepted(true);
    } else {
      copyToClipboard();
    }
  };

  var copyToClipboard = function copyToClipboard() {
    var isPreview = false;

    _getUrl(props.data._id, tracking, email, address, isPreview);

    props.openShareListing();
    var timeout = setTimeout(function () {
      clearTimeout(timeout);
      window.postMessage({
        type: "notification",
        msg: "Copied to Clipboard"
      });
    }, 2000);
  };

  var previewShareLink = function previewShareLink(tracking) {
    var isPreview = true;

    _getUrl(props.data._id, tracking, email, address, isPreview);

    props.openShareListing();
    var timeout = setTimeout(function () {
      clearTimeout(timeout);
      window.postMessage({
        type: "notification",
        msg: "Copied to Clipboard"
      });
    }, 2000);
  };

  var _getUrl = function _getUrl(id, isTracked, client_email, address, isPreview) {
    var httpService = new HttpService(process.env.baseAPIPath);
    var baseUrl = process.env.listingsAppUrl + "viewer";
    var payload = {
      listing_id: id,
      is_embedded: false,
      origin: "link",
      is_tracked: isTracked,
      client_email: client_email
    };

    if (!isTracked) {
      delete payload.client_email;
    }

    httpService.post("listings/get_listing_link", payload, function (response) {
      if (response.data.success) {
        if (response.data.error_id === 402) {
          window.postMessage({
            type: "notification",
            msg: "Operation Failed"
          });
        }

        var data = baseUrl.concat("?token=".concat(response.data.data.token));

        if (response.data.data.prospect_id) {
          data = data + "&pid=" + response.data.data.prospect_id;
        }

        if (address) {
          data = data + "&display=f";
        } else {
          data = data + "&display=n";
        }

        _copyToClipboard(data, isPreview);
      } else {
        window.postMessage({
          type: "notification",
          msg: "Error while Generating Sharable Link"
        });
      }
    });
  };

  var _copyToClipboard = function _copyToClipboard(text, isPreview) {
    if (isPreview) {
      window.open(text);
    } else {
      var dummy = document.createElement("textarea"); // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'

      document.body.appendChild(dummy); // Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard

      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    }
  };

  return Object.keys(get(props, "data", {})).length && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "modal_overflow"
  }), isWarningAccepted && tracking && /*#__PURE__*/React__default.createElement(Portal$2, {
    nodename: "warningAlert"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "warning_div"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "warning_icon"
  }, /*#__PURE__*/React__default.createElement(MemoSvgAlertCircle, null), /*#__PURE__*/React__default.createElement("h1", {
    className: "warning_header"
  }, "Warning")), /*#__PURE__*/React__default.createElement("span", {
    className: "warning_info"
  }, "Do not open this link on your own device! Opening the link on your device will mix your browsing data into Prospect Intelligence."), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "share_link",
    label: "Copy Link",
    color: "rgb(4, 210, 198)",
    textColor: "rgb(255, 255, 255)",
    onClick: function onClick() {
      return copyToClipboard() || null;
    }
  }))), /*#__PURE__*/React__default.createElement(Portal$2, {
    nodename: "sharelink"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React__default.createElement("span", null, "Share link")), /*#__PURE__*/React__default.createElement("div", {
    className: "sharelink_section"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "_title"
  }, "Address"), /*#__PURE__*/React__default.createElement("span", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement(Toggle$1, {
    onText: "show",
    offText: "hide",
    onChange: function onChange() {
      return setAddress(!address);
    },
    on: address,
    off: !address
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "sharelink_section"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "_title"
  }, "Tracking"), /*#__PURE__*/React__default.createElement("span", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement(Toggle$1, {
    onChange: function onChange() {
      return setTracking(!tracking);
    },
    on: tracking,
    off: !tracking
  }))), tracking && /*#__PURE__*/React__default.createElement("div", {
    className: "sharelink_section"
  }, /*#__PURE__*/React__default.createElement(SearchbarSuggestion$1, {
    emailTitle: "Prospect Email",
    showTooltip: true,
    change: setEmail,
    topProspectList: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "sharelink_bottom"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "share_link",
    label: "Cancel",
    color: "#fff",
    textColor: "#333",
    onClick: function onClick() {
      return props.openShareListing();
    }
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "share_link",
    label: "Preview",
    color: "#fff",
    textColor: "#04d2c6",
    onClick: function onClick() {
      return previewShareLink(false);
    }
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "share_link",
    label: "Copy Link",
    color: !(tracking && email.length || !tracking) && "#dfdfdf" || "#04D2C6",
    textColor: !(tracking && email.length || !tracking) && "#000" || "#fff",
    onClick: function onClick() {
      return (tracking && email.length || !tracking) && showWarningModal() || null;
    }
  }))))) || null;
};

ShareListing.defaultProps = {
  url: "https://listings-dev.peek.us/viewer?token=xxxxxxxxxxxxxxxxxxxxxxxxxxxxx&display=f"
};
ShareListing.propTypes = {
  data: PropTypes.object.isRequired,
  openShareListing: PropTypes.func.isRequired
};
var ShareListing$1 = /*#__PURE__*/React__default.memo(ShareListing);

var EmbedListing = function EmbedListing(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      showRoomsMenu = _useState2[0],
      setShowRoomsMenu = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      showListingDetails = _useState4[0],
      setShowListingDetails = _useState4[1];

  var _useState5 = useState("900 px"),
      _useState6 = _slicedToArray$1(_useState5, 2),
      width = _useState6[0],
      setWidth = _useState6[1];

  var _useState7 = useState("600 px"),
      _useState8 = _slicedToArray$1(_useState7, 2),
      height = _useState8[0],
      setHeight = _useState8[1];

  var _useState9 = useState("Medium"),
      _useState10 = _slicedToArray$1(_useState9, 2),
      viewerSize = _useState10[0],
      setViewerSize = _useState10[1];

  var _useState11 = useState(""),
      _useState12 = _slicedToArray$1(_useState11, 2),
      url = _useState12[0],
      setUrl = _useState12[1];

  useEffect(function () {
    var container = document.getElementsByClassName("modal_overflow");

    if (container.length) {
      var modal = container[0];
      modal.addEventListener("click", function () {
        props.openEmbedListing();
      });
    }

    return function () {
      if (container.length) {
        var _modal = container[0];

        _modal.removeEventListener("click", function () {
          props.openEmbedListing();
        });
      }
    };
  }, []);

  var generateEmbedLink = function generateEmbedLink() {
    _getEmbedCode(props.data._id, width, height, showListingDetails, showRoomsMenu);
  };

  var _getEmbedCode = function _getEmbedCode(id, width, height, showListingDetails, showRoomsMenu) {
    var httpService = new HttpService(process.env.baseAPIPath);
    var baseUrl = process.env.listingsAppUrl + "viewer";
    var payload = {
      listing_id: id,
      is_embedded: true,
      is_tracked: false
    };
    httpService.post("listings/get_listing_link", payload, function (response) {
      if (!response.data.success) {
        window.postMessage({
          type: "notification",
          msg: response.data.message
        });
      }

      if (response.data.success) {
        var data = baseUrl.concat("?token=".concat(response.data.data.token)).concat("&showListingDetails=".concat(showListingDetails)).concat("&showRoomsMenu=".concat(showRoomsMenu));
        var embeddedLink = "<iframe width=\"".concat(width, "\" height=\"").concat(height, "\" src=\"").concat(data, "\" frameborder=\"0\" allowfullscreen></iframe>");
        setUrl(embeddedLink);

        _copyToClipboard(embeddedLink);
      } else {
        window.postMessage({
          type: "notification",
          msg: "Error while Generating Embed Link"
        });
      }
    });
  };

  var _copyToClipboard = function _copyToClipboard(text) {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  };

  var _setWidth = function _setWidth(e) {
    setWidth(e);
  };

  var _setHeight = function _setHeight(e) {
    setHeight(e);
  };

  var toggleButton = function toggleButton(value, flag) {
    setViewerSize(value, flag);

    switch (value) {
      case "Small":
        setWidth("450 px");
        setHeight("300 px");
        flag = true;
        break;

      case "Medium":
        setWidth("900 px");
        setHeight("600 px");
        flag = true;
        break;

      case "Large":
        setWidth("1200 px");
        setHeight("800 px");
        flag = true;
        break;

      case "Custom":
        setWidth("0 px");
        setHeight("0 px");
        flag = false;
    }
  }; // setViewerSize = (value, readOnly = false) => {
  //   switch (value) {
  //   case "Small":
  //     setWidth("450 px");
  //     setHeight("300 px");
  //     readOnly = true;
  //     break;
  //   case "Medium":
  //     setWidth("900 px");
  //     setHeight("600 px");
  //     readOnly = true;
  //     break;
  //   case "Large":
  //     setWidth("1200 px");
  //     setHeight("800 px");
  //     readOnly = true;
  //     break;
  //   case "Custom":
  //     setWidth("0 px");
  //     setHeight("0 px");
  //     readOnly = false;
  //   }
  // };


  var setDefaultWidth = function setDefaultWidth(defaultWidth, param) {
    if (defaultWidth.indexOf(" px") === -1) {
      defaultWidth = defaultWidth + " px";

      if (param === "width") {
        setWidth(defaultWidth);
      } else if (param === "height") {
        setHeight(defaultWidth);
      }
    }

    width = Number(defaultWidth.substr(0, defaultWidth.length - 2));
    height = Number(defaultWidth.substr(0, defaultWidth.length - 2));

    if (width < 300 || height < 300) {
      setWidth("300 px");
      setHeight("300 px");
    }
  };

  var copyToClipboard = function copyToClipboard() {
    _getEmbedCode(props.data._id, width, height, showListingDetails, showRoomsMenu);

    var timeOut = setTimeout(function () {
      clearTimeout(timeOut);
      props.openEmbedListing();
      window.postMessage({
        type: "notification",
        msg: "Copied to Clipboard"
      });
    }, 2000);
  };

  return Object.keys(props.data).length && /*#__PURE__*/React__default.createElement("div", {
    className: "modal_overflow"
  }, /*#__PURE__*/React__default.createElement(Portal$2, {
    nodename: "embedlisting"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React__default.createElement("span", null, "Embed listing")), /*#__PURE__*/React__default.createElement("div", {
    className: "embed_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "fixed_size"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "capsule",
    label: "Small",
    textColor: "".concat(viewerSize === "Small" ? "#fff" : "#333"),
    value: "Small",
    color: "".concat(viewerSize === "Small" ? "#04D2C6" : "#fff"),
    onClick: function onClick() {
      return toggleButton("Small", true);
    }
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "capsule",
    label: "Medium",
    textColor: "".concat(viewerSize === "Medium" ? "#fff" : "#333"),
    color: "".concat(viewerSize === "Medium" ? "#04D2C6" : "#fff"),
    value: "Medium",
    onClick: function onClick() {
      return toggleButton("Medium", true);
    }
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "capsule",
    label: "Large",
    textColor: "".concat(viewerSize === "Large" ? "#fff" : "#333"),
    color: "".concat(viewerSize === "Large" ? "#04D2C6" : "#fff"),
    value: "Large",
    onClick: function onClick() {
      return toggleButton("Large", true);
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "custom_size"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "capsule",
    label: "Custom",
    textColor: "".concat(viewerSize === "Custom" ? "#fff" : "#333"),
    color: "".concat(viewerSize === "Custom" ? "#04D2C6" : "#fff"),
    value: "Custom",
    onClick: function onClick() {
      return toggleButton("Custom", false);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "group"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "_title"
  }, "W"), /*#__PURE__*/React__default.createElement(TextField$3, {
    type: "text",
    name: "width",
    id: "width",
    value: width,
    change: _setWidth,
    disabled: viewerSize !== "Custom",
    blur: function blur() {
      return setDefaultWidth(width, "width");
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "group"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "_title"
  }, "H"), /*#__PURE__*/React__default.createElement(TextField$3, {
    type: "text",
    name: "height",
    id: "height",
    value: height,
    change: _setHeight,
    disabled: viewerSize !== "Custom",
    blur: function blur() {
      return setDefaultWidth(height, "height");
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "embed_section"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "_title"
  }, "Listing details"), /*#__PURE__*/React__default.createElement("span", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement(Toggle$1, {
    onText: "show",
    offText: "hide",
    onChange: function onChange() {
      return setShowListingDetails(!showListingDetails);
    },
    on: showListingDetails,
    off: !showListingDetails
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "embed_section"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "_title"
  }, "Rooms menu"), /*#__PURE__*/React__default.createElement("span", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement(Toggle$1, {
    onText: "show",
    offText: "hide",
    onChange: function onChange() {
      return setShowRoomsMenu(!showRoomsMenu);
    },
    on: showRoomsMenu,
    off: !showRoomsMenu
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "embed_bottom"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "medium",
    label: "Cancel",
    color: "#fff",
    textColor: "#333",
    onClick: function onClick() {
      return props.openEmbedListing();
    }
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "medium",
    label: "Copy embed code",
    color: "#04D2C6",
    textColor: "#fff",
    disabled: height === "0px" || width === "0px",
    onClick: function onClick() {
      generateEmbedLink();
      copyToClipboard();
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "copy-url"
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    type: "text",
    name: "URL",
    label: "URL",
    id: "copyTextLink",
    value: url
  })))));
};

EmbedListing.propTypes = {
  data: PropTypes.object.isRequired,
  openEmbedListing: PropTypes.func.isRequired
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AddToFolio = function AddToFolio(_ref) {
  var openFolio = _ref.openFolio,
      success = _ref.success,
      data = _ref.data,
      loading = _ref.loading;

  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      folioName = _useState2[0],
      setFolioName = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray$1(_useState3, 2),
      folioId = _useState4[0],
      setFolioId = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray$1(_useState5, 2),
      foliosList = _useState6[0],
      setFolioList = _useState6[1];

  var chageFolioName = useCallback(function (folioName) {
    if (folioId) {
      setFolioId("");
    }

    setFolioName(folioName);
  }, [folioId, setFolioId, setFolioName]);
  var changeFolioId = useCallback(function (folioId) {
    if (folioName) {
      setFolioName("");
    }

    setFolioId(folioId);
  }, [folioName, folioId, setFolioId]);
  useEffect(function () {
    _getFoliosList();
  }, []);

  var _getFoliosList = function _getFoliosList(options) {
    var currentIndex = 0;
    var limit = 15;
    var predefinedFilter = {
      search: "",
      filter: {
        start_index: currentIndex,
        limit: limit
      }
    };

    var data = _objectSpread$7(_objectSpread$7({}, predefinedFilter), options);

    var request = new HttpService(process.env.baseAPIPath);
    request.post("/folio/get_folio_list", _objectSpread$7({}, data), function (response) {
      if (response.data.error_id === 402) {
        window.postMessage({
          type: "notification",
          msg: "Error While Fetching the data, please try again"
        });
      }

      if (response.data.success) {
        var _data = response.data.data.folio_list;
        setFolioList(_data);
      } else {
        window.postMessage({
          type: "notification",
          msg: "Error While Fetching the data, please try again"
        });
      }
    }, function (error) {
      window.console.error(error);
    });
  };

  useEffect(function () {
    if (success) openFolio({});
  }, [success]);
  var isSubmitButtonEnabled = useMemo(function () {
    return !!folioName.length || !!folioId;
  }, [folioName, folioId]);
  var isCreate = useMemo(function () {
    if (folioName.length && !folioId) {
      return true;
    } else if (!folioName.length && folioId) {
      return false;
    }
  }, [folioName, folioId]);
  var foliosListDropDown = useMemo(function () {
    return foliosList;
  }, [foliosList]);
  var createFolio = useCallback(function () {
    _createFolio({
      name: folioName,
      listings: [data._id]
    });
  });
  var addToFolio = useCallback(function () {
    return _addToFolio({
      folio_id: folioId,
      listings: [data._id]
    });
  }, [folioId, _addToFolio]);

  var _addToFolio = function _addToFolio(options) {
    var data = _objectSpread$7({}, options);

    var request = new HttpService(process.env.baseAPIPath);
    request.post("/folio/update_folio", _objectSpread$7({}, data), function (response) {
      if (response.data.error_id === 402) {
        window.postMessage({
          type: "notification",
          msg: "Error While Fetching the data, please try again"
        });
      }

      if (response.data.success) {
        window.postMessage({
          type: "notification",
          msg: "Successfully added listing to folio"
        });
        openFolio();
      } else {
        window.postMessage({
          type: "notification",
          msg: "Error While Fetching the data, please try again"
        });
      }
    }, function (error) {
      window.console.error(error);
    });
  };

  var _createFolio = function _createFolio(options) {
    var data = _objectSpread$7({}, options);

    var request = new HttpService(process.env.baseAPIPath);
    request.post("/folio/create_folio", _objectSpread$7({}, data), function (response) {
      if (response.data.error_id === 402) {
        window.postMessage({
          type: "notification",
          msg: "Error While Fetching the data, please try again"
        });
      }

      if (response.data.success) {
        window.postMessage({
          type: "notification",
          msg: "Successfully created a new folio."
        });
        openFolio();
      } else {
        window.postMessage({
          type: "notification",
          msg: "Error While Fetching the data, please try again"
        });
      }
    }, function (error) {
      window.console.error(error);
    });
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "modal_overflow"
  }), /*#__PURE__*/React__default.createElement(Portal$2, {
    nodename: "addtofolio"
  }, loading ? /*#__PURE__*/React__default.createElement("div", {
    className: "_spinner_loader_generic"
  }, /*#__PURE__*/React__default.createElement(Spinner, null)) : /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React__default.createElement("span", null, "Add to folio")), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, /*#__PURE__*/React__default.createElement("span", null, data.building_address)), /*#__PURE__*/React__default.createElement("div", {
    className: "addtofolio_section"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "_title"
  }, "Create a new folio"), /*#__PURE__*/React__default.createElement("span", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    type: "text",
    name: "label",
    value: folioName,
    change: chageFolioName,
    placeholder: "Park Slope duplexes"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "addtofolio_section"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "_title"
  }, "Select a folio"), /*#__PURE__*/React__default.createElement("span", {
    className: "container dropdown"
  }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
    dropdownList: foliosListDropDown,
    placeholder: "Select a folio",
    isArrayOfObject: true,
    keyName: "name",
    altName: "alt_name",
    returnKey: "_id",
    change: changeFolioId,
    value: folioId ? null : ""
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "addtofolio_bottom"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    label: "Cancel",
    color: "#fff",
    textColor: "#333",
    onClick: function onClick() {
      return openFolio({});
    }
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    label: isCreate ? "Create" : "Add",
    type: "standard savechanges-btn",
    disabled: !isSubmitButtonEnabled,
    onClick: function onClick() {
      isCreate ? createFolio() : addToFolio();
    }
  })))));
};

AddToFolio.propTypes = {
  openFolio: PropTypes.func.isRequired,
  success: PropTypes.bool,
  loading: PropTypes.bool,
  data: PropTypes.object
};

var ListingActionButtons = [{
  func: "openShareListing",
  iconName: "share",
  iconColor: "#04D2C6",
  text: "Share",
  iconWidth: null,
  iconHeight: null,
  tooltip: "Share Listing",
  alternateTooltip: "",
  keyIdentifier: "",
  disabledIcon: "share"
}, {
  func: "openEmbedListing",
  iconName: "embed",
  iconColor: "#04D2C6",
  text: "Embed",
  iconWidth: null,
  iconHeight: null,
  tooltip: "Embed Listing",
  alternateTooltip: "",
  keyIdentifier: "",
  disabledIcon: "embed"
}, {
  func: "openEmailListing",
  iconName: "emailV2",
  iconColor: "#04D2C6",
  text: null,
  iconWidth: 20,
  iconHeight: 16,
  tooltip: "Email Listing",
  alternateTooltip: "Email Listing",
  keyIdentifier: "",
  disabledIcon: "email"
}, {
  func: "addToFolio",
  iconName: "folio",
  iconColor: "#04D2C6",
  text: null,
  iconWidth: 20,
  iconHeight: 26,
  tooltip: "Add to folio",
  alternateTooltip: "Add to folio",
  keyIdentifier: "",
  disabledIcon: "folio"
}, {
  func: "makeListingPublic",
  iconName: "eye",
  iconColor: "#04D2C6",
  text: null,
  iconWidth: null,
  iconHeight: null,
  tooltip: "Set Privacy",
  alternateTooltip: "Set Privacy",
  keyIdentifier: "is_public",
  disabledIcon: "disabled_eye"
}, {
  func: "requestThreeSixtyVideo",
  iconName: "video_cam",
  iconColor: "#04D2C6",
  text: null,
  iconWidth: null,
  iconHeight: null,
  tooltip: "Request 360° video",
  alternateTooltip: "Request 360° video",
  keyIdentifier: "",
  disabledIcon: "video_cam"
}, {
  func: "archiveListing",
  iconName: "dump",
  iconColor: "#EA6767",
  text: null,
  iconWidth: null,
  iconHeight: null,
  tooltip: "Unarchive Listing",
  alternateTooltip: "Archive Listing",
  keyIdentifier: "is_archived",
  disabledIcon: "dump"
}];
var AmenityActionButtons = [{
  func: "openShareListing",
  iconName: "share",
  iconColor: "#04D2C6",
  text: "Share",
  iconWidth: null,
  iconHeight: null,
  tooltip: "Share Amenity",
  alternateTooltip: "",
  keyIdentifier: "",
  disabledIcon: "share"
}];

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CustomTooltip = withStyles({
  tooltip: {
    color: "#1D1C38",
    backgroundColor: "#8181A533",
    padding: "12px",
    fontSize: "12px",
    fontWeight: "500"
  }
})(Tooltip$1);

var ListingsDetails = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ListingsDetails, _React$Component);

  var _super = _createSuper$3(ListingsDetails);

  function ListingsDetails(props) {
    var _this;

    _classCallCheck$1(this, ListingsDetails);

    _this = _super.call(this, props);
    _this.state = {
      notification: [],
      initialIndex: 0,
      limit: 20,
      todaysDate: new Date(),
      isFullScreen: false,
      listingsDetails: {},
      dataReceived: false,
      showViewer: false,
      showEditListing: false,
      showEmailListing: false,
      showShareListing: false,
      showEmbedListing: false,
      showAddToFolio: false,
      isExpanded: false,
      isEditListAccordionExpanded: false,
      selectedDaySpan: 7,
      dateSelectorArray: [7, 14, 30, 90],
      listingInfo: {},
      currentVisitor: {},
      isImageNameEditable: false
    };
    _this.archiveListing = _this.archiveListing.bind(_assertThisInitialized$3(_this));
    _this.requestThreeSixtyVideo = _this.requestThreeSixtyVideo.bind(_assertThisInitialized$3(_this));
    _this.makeListingPublic = _this.makeListingPublic.bind(_assertThisInitialized$3(_this));
    _this.openEditListing = _this.openEditListing.bind(_assertThisInitialized$3(_this));
    _this.openShareListing = _this.openShareListing.bind(_assertThisInitialized$3(_this));
    _this.openEmbedListing = _this.openEmbedListing.bind(_assertThisInitialized$3(_this));
    _this.openEmailListing = _this.openEmailListing.bind(_assertThisInitialized$3(_this));
    _this.addToFolio = _this.addToFolio.bind(_assertThisInitialized$3(_this));
    _this.toggleListingAnalytics = _this.toggleListingAnalytics.bind(_assertThisInitialized$3(_this));
    _this.toggleEditListing = _this.toggleEditListing.bind(_assertThisInitialized$3(_this));
    _this.setDateRange = _this.setDateRange.bind(_assertThisInitialized$3(_this));
    _this.updateListingData = _this.updateListingData.bind(_assertThisInitialized$3(_this));
    _this.getListingInfo = _this.getListingInfo.bind(_assertThisInitialized$3(_this));
    _this.getCurrentVisitor = _this.getCurrentVisitor.bind(_assertThisInitialized$3(_this));
    _this.initiateDownloadCSV = _this.initiateDownloadCSV.bind(_assertThisInitialized$3(_this));
    _this.downloadCSV = _this.downloadCSV.bind(_assertThisInitialized$3(_this));
    _this.getHistoryState = _this.getHistoryState.bind(_assertThisInitialized$3(_this));
    _this.setIsImageNameEditable = _this.setIsImageNameEditable.bind(_assertThisInitialized$3(_this));
    _this.updateAmentiyLabel = _this.updateAmentiyLabel.bind(_assertThisInitialized$3(_this));
    _this.clickSave = _this.clickSave.bind(_assertThisInitialized$3(_this));
    _this.openShareLink = _this.openShareLink.bind(_assertThisInitialized$3(_this));
    _this.getAmenityToken = _this.getAmenityToken.bind(_assertThisInitialized$3(_this));
    _this.copyToClipboard = _this.copyToClipboard.bind(_assertThisInitialized$3(_this));
    _this.enableLabelRef = /*#__PURE__*/createRef();
    _this.wrapperContent = /*#__PURE__*/createRef();

    if (_this.getHistoryState().is_amenity) {
      _this.actionButtonConfig = AmenityActionButtons;
    } else {
      _this.actionButtonConfig = ListingActionButtons;
    }

    return _this;
  }

  _createClass$1(ListingsDetails, [{
    key: "getHistoryState",
    value: function getHistoryState() {
      var histroyState = this.props.history.location.state;
      return histroyState || {};
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var iframe = document.getElementsByClassName("page_header")[0].focus();

      if (iframe && iframe[0]) {
        iframe.focus();
      }

      if (!this.getHistoryState().is_amenity) {
        this.getListingInfo();
        this.getCurrentVisitor();
      }

      this.getViewerData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.isFullScreen) {
        document.getElementById("viewer_container_listings_details") && document.getElementById("webviewer_wrapper").remove();
      } else if (!this.state.isFullScreen) {
        document.getElementById("viewer_container_listings_details_fullscreen") && document.getElementById("webviewer_wrapper_fullscreen").remove();
      }
    }
  }, {
    key: "toggleListingAnalytics",
    value: function toggleListingAnalytics() {
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    }
  }, {
    key: "toggleEditListing",
    value: function toggleEditListing() {
      this.setState({
        isEditListAccordionExpanded: !this.state.isEditListAccordionExpanded
      });
    }
  }, {
    key: "updateListingData",
    value: function updateListingData(isUpdated, updatedList) {
      if (isUpdated) {
        this.setState({
          listingsDetails: updatedList
        });
      }
    }
  }, {
    key: "archiveListing",
    value: function archiveListing() {
      var _this2 = this;

      var newValue = !this.state.listingsDetails.is_archived;
      var request = new HttpService(process.env.baseAPIPath);
      request.post("listings/archive_unarchive_listing", {
        is_archived: newValue,
        listing_id: this.state.listingsDetails._id
      }, function (response) {
        if (response.data.success) {
          var newState = _objectSpread$6({}, _this2.state);

          _this2.setState(_objectSpread$6(_objectSpread$6({}, newState), {}, {
            listingsDetails: _objectSpread$6(_objectSpread$6({}, _this2.state.listingsDetails), {}, {
              is_archived: newValue
            })
          }));

          window.postMessage({
            type: "notification",
            msg: "Listings updated"
          });
        }
      });
    }
  }, {
    key: "requestThreeSixtyVideo",
    value: function requestThreeSixtyVideo() {
      var options = {
        listing_id: this.state.listingsDetails._id
      };
      var request = new HttpService(process.env.baseAPIPath);
      request.post("listings/generate_360_video", options, function (response) {
        if (response.data.success) {
          window.postMessage({
            type: "notification",
            msg: "Request submitted"
          });
        }
      });
    }
  }, {
    key: "openEditListing",
    value: function openEditListing() {
      this.setState({
        showEditListing: !this.state.showEditListing
      });
    }
  }, {
    key: "openShareListing",
    value: function openShareListing() {
      if (this.getHistoryState().is_amenity) {
        this.openShareLink();
      } else {
        this.setState({
          showShareListing: !this.state.showShareListing
        });
      }
    }
  }, {
    key: "openEmbedListing",
    value: function openEmbedListing() {
      this.setState({
        showEmbedListing: !this.state.showEmbedListing
      });
    }
  }, {
    key: "openEmailListing",
    value: function openEmailListing() {
      this.setState({
        showEmailListing: !this.state.showEmailListing
      });
    }
  }, {
    key: "addToFolio",
    value: function addToFolio() {
      this.setState({
        showAddToFolio: !this.state.showAddToFolio
      });
    }
  }, {
    key: "setDateRange",
    value: function setDateRange(date) {
      var _this3 = this;

      this.setState({
        selectedDaySpan: date
      }, function () {
        return _this3.getListingInfo();
      });
    }
  }, {
    key: "getListingInfo",
    value: function getListingInfo() {
      var _this4 = this;

      var url = "analytics/get_listing_analytics?period=".concat(this.state.selectedDaySpan, "&listing_id=").concat(this.props.listingsId); // eslint-disable-next-line no-undef

      var httpService = new HttpService(process.env.baseAPIPath);
      httpService.get(url, function (response) {
        if (response.data.success) {
          _this4.setState({
            listingInfo: response.data.data
          });
        } else {
          window.postMessage({
            type: "notification",
            msg: "Error in fetching listing info data"
          });
        }
      });
    }
  }, {
    key: "getCurrentVisitor",
    value: function getCurrentVisitor() {
      var _this5 = this;

      var api = "".concat(this.props.currentVisitorUrl).concat(this.props.region, ".amazonaws.com/default/").concat(this.props.userHandler, "?listing_id=").concat(this.props.listingsId);
      axios.get(api, {
        headers: {
          "X-Api-Key": this.props.xApiKey
        }
      }).then(function (response) {
        _this5.setState({
          currentVisitor: response.data.data
        });
      })["catch"](function (error) {
        window.console.log(error);
      });
    }
  }, {
    key: "initiateDownloadCSV",
    value: function initiateDownloadCSV() {
      var _this6 = this;

      var url = "analytics/generate_download_csv_request?period=".concat(this.state.selectedDaySpan, "&listing_id=").concat(this.props.listingsId); // eslint-disable-next-line no-undef

      var httpService = new HttpService(process.env.baseAPIPath);
      var token = "";
      httpService.get(url, function (response) {
        if (response.data.success) {
          var res = response.data.data;

          if (res.error) {
            token = "";
            window.postMessage({
              type: "notification",
              msg: "Error in downloading csv"
            });
          } else if (!res.is_genrating_csv && res.csv_url) {
            window.open(res.csv_url);
            token = "";
          } else {
            token = res.token;
            var timer = setInterval(function () {
              _this6.downloadCSV(token, function (value) {
                if (value) {
                  clearInterval(timer);
                }
              });
            }, 5000);
          }
        } else {
          window.postMessage({
            type: "notification",
            msg: "Error in generating csv"
          });
        }
      });
    }
  }, {
    key: "downloadCSV",
    value: function downloadCSV(token, callback) {
      var url = "analytics/get_download_csv_status?token=".concat(token); // eslint-disable-next-line no-undef

      var httpService = new HttpService(process.env.baseAPIPath);
      httpService.get(url, function (response) {
        if (response.data.error_id === 402) {
          localStorage.setItem("user", {});
          window.location.href = "/";
        }

        var res = response.data.data;

        if (res.error) {
          callback(true);
          window.postMessage({
            type: "notification",
            msg: "Error while downloading CSV"
          });
        } else if (!res.is_genrating_csv && res.csv_url) {
          callback(res.csv_url);
          var element = document.createElement("a");
          element.setAttribute("href", "data:text/plain;charset=utf-8, " + encodeURIComponent(res.csv_url));
          element.setAttribute("download", "".concat(Date.now(), ".csv"));
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        } else {
          callback(res.csv_url);
        }
      });
    }
  }, {
    key: "makeListingPublic",
    value: function makeListingPublic() {
      var _this7 = this;

      var newValue = !this.state.listingsDetails.is_public;
      var request = new HttpService(process.env.baseAPIPath);
      request.post("listings/make_listing_private", {
        is_public: newValue,
        listing_id: this.props.listingsId
      }, function (response) {
        if (response.data.success) {
          var newState = _objectSpread$6({}, _this7.state);

          _this7.setState(_objectSpread$6(_objectSpread$6({}, newState), {}, {
            listingsDetails: _objectSpread$6(_objectSpread$6({}, _this7.state.listingsDetails), {}, {
              is_public: newValue
            })
          }));

          window.postMessage({
            type: "notification",
            msg: "Listings updated"
          });
        }
      });
    }
  }, {
    key: "getViewerData",
    value: function getViewerData() {
      var _this8 = this;

      var path = this.props.listingsId ? process.env.baseAPIPath : process.env.baseV2APIPath;
      var request = new HttpService(path);

      if (this.props.listingsId) {
        request.get("listings/get_full_listing_details?listing_id=".concat(this.props.listingsId), function (response) {
          if (response.data.success) {
            _this8.setState({
              listingsDetails: response.data.data,
              dataReceived: true
            });
          }
        });
      } else if (this.getHistoryState().amenityId) {
        request.get("amenities/".concat(this.getHistoryState().amenityId), function (response) {
          if (response.data.status === "SUCCESS") {
            _this8.setState({
              listingsDetails: _objectSpread$6(_objectSpread$6({}, response.data.data.result), {
                isAmenity: true
              }),
              dataReceived: true
            });
          }
        });
      }

      window.addEventListener("message", function (message) {
        message.data === "back_button_clicked" && _this8.onClickOutSide() || window.console.info("Back Button not clicked");
        message.data === "fullscreen_button_clicked" && _this8.fullScreenSwitched() || window.console.log("Full Screen Button was not clicked");
        message.data === "reload" && window.location.reload() || window.console.log("reload skipped");
        message.data && message.data.type === "changeImageName" && _this8.renameTourImageName(message.data);
      }, false);
    }
  }, {
    key: "renameTourImageName",
    value: function renameTourImageName(data) {
      var endpoint = data.isAmenity ? "amenities/update_amenity_image_name" : "listings/update_listing_image_name";
      var request = new HttpService(process.env.baseAPIPath);
      request.post(endpoint, data.payload, function (response) {
        if (response.data.success) {
          window.postMessage({
            type: "imageNameUpdated",
            msg: "Request submitted"
          });
          window.location.reload();
        }
      });
    }
  }, {
    key: "showWebViewer",
    value: function showWebViewer() {
      var _this9 = this;

      var url = "";

      if (this.props.listingsId) {
        url = process.env.listingsAppUrl + "viewer?isAdmin=true&inModalBackButtonOff=true&isModal=true&showListingDetails=false&isFromAdminTab=true&listing_id=" + this.props.listingsId;
      } else {
        url = process.env.listingsAppUrl + "viewer?isAdmin=true&inModalBackButtonOff=true&isModal=true&showListingDetails=false&isFromAdminTab=true&isAmenity=true&amenity_id=" + this.getHistoryState().amenityId;
      }

      if (this.state.isFullScreen) {
        return /*#__PURE__*/React__default.createElement("div", {
          id: "viewer_container_listings_details_fullscreen"
        }, /*#__PURE__*/React__default.createElement("iframe", {
          frameBorder: "0",
          width: "100%",
          height: "100%",
          id: "inline_webviewer",
          onLoad: function onLoad() {
            return _this9.onIframeLoaded();
          },
          src: url
        }));
      }

      return /*#__PURE__*/React__default.createElement("div", {
        id: "viewer_container_listings_details"
      }, /*#__PURE__*/React__default.createElement("iframe", {
        frameBorder: "0",
        width: "100%",
        height: "100%",
        id: "inline_webviewer",
        onLoad: function onLoad() {
          return _this9.onIframeLoaded();
        },
        src: url
      }));
    }
  }, {
    key: "onClickOutSide",
    value: function onClickOutSide() {
      var onClose = this.props.onClose;
      onClose && onClose();
      this.state.isFullScreen && this.fullScreenSwitched();
    }
  }, {
    key: "fullScreenSwitched",
    value: function fullScreenSwitched() {
      if (this.state.isFullScreen) {
        this.setState({
          isFullScreen: false
        });

        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      } else {
        this.setState({
          isFullScreen: true
        }, function () {
          try {
            if (document.fullScreenElement && document.fullScreenElement !== null || !document.mozFullScreen && !document.webkitIsFullScreen) {
              if (document.documentElement.requestFullScreen) {
                document.documentElement.requestFullScreen();
              } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
              } else if (document.documentElement.webkitRequestFullScreen) {
                document.documentElement.webkitRequestFullScreen();
              }
            }
          } catch (exception) {
            window.console.log(exception);
          }
        });
      }
    }
  }, {
    key: "onIframeLoaded",
    value: function onIframeLoaded() {
      var _this10 = this;

      if (this.state.isFullScreen) {
        var waitingForData = setInterval(function () {
          if (_this10.state.dataReceived) {
            clearInterval(waitingForData);
            var iframeFullScreenToPost = document.querySelectorAll("#viewer_container_listings_details_fullscreen iframe");

            if (iframeFullScreenToPost.length) {
              Object.keys(_this10.state.listingsDetails).length && iframeFullScreenToPost[0].contentWindow.postMessage({
                type: "dataForIframe",
                data: _this10.state.listingsDetails,
                accessToken: window.localStorage.getItem("token")
              }, "*");
            }
          }
        }, 1000);
      } else {
        var _waitingForData = setInterval(function () {
          if (_this10.state.dataReceived) {
            clearInterval(_waitingForData);
            var iframeFullScreenToPost = document.querySelectorAll("#viewer_container_listings_details iframe");

            if (iframeFullScreenToPost.length) {
              Object.keys(_this10.state.listingsDetails).length && iframeFullScreenToPost[0].contentWindow.postMessage({
                type: "dataForIframe",
                data: _this10.state.listingsDetails,
                accessToken: window.localStorage.getItem("token")
              }, "*");
            }
          }
        }, 1000);
      }
    }
  }, {
    key: "setIsImageNameEditable",
    value: function setIsImageNameEditable() {
      var _this11 = this;

      this.setState({
        isImageNameEditable: !this.state.isImageNameEditable
      }, function () {
        if (_this11.state.isImageNameEditable) {
          _this11.enableLabelRef.current.focus();

          _this11.wrapperContent.current && _this11.wrapperContent.current.addEventListener("click", _this11.clickSave, false);
          return;
        }
      });
    }
  }, {
    key: "openShareLink",
    value: function openShareLink() {
      window.dataLayer.push({
        event: "gtm.click",
        eventProps: {
          category: "listings-grid-option",
          action: "Sharelink",
          label: location.pathname
        }
      });
      this.getAmenityToken(this.getHistoryState().amenityId);
    }
  }, {
    key: "getAmenityToken",
    value: function getAmenityToken(amenityId) {
      var _this12 = this;

      var httpService = new HttpService(process.env.baseAPIPath);
      var baseUrl = process.env.listingsAppUrl + "viewer";
      var amenity = {
        amenity_id: amenityId
      };
      httpService.post("amenities/get_amenity_token", amenity, function (response) {
        if (!response.data.success) {
          window.postMessage({
            type: "notification",
            msg: response.data.message
          });
        }

        if (response.data.success) {
          var data = baseUrl.concat("?token=".concat(response.data.data.token).concat("&is_amenity=true"));

          _this12.copyToClipboard(data);

          window.postMessage({
            type: "notification",
            msg: "Copied to Clipboard"
          });
        } else {
          window.postMessage({
            type: "notification",
            msg: "Error while Generating Sharable Link"
          });
        }
      });
    }
  }, {
    key: "copyToClipboard",
    value: function copyToClipboard(text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    }
  }, {
    key: "updateAmentiyLabel",
    value: function updateAmentiyLabel(newName) {
      var _this13 = this;

      var request = new HttpService(process.env.baseAPIPath);
      request.post("amenities/update_amenity_data", {
        "amenity_id": this.getHistoryState().amenityId,
        "label": newName
      }, function (response) {
        if (response.data.success) {
          _this13.setState({
            listingsDetails: _objectSpread$6(_objectSpread$6({}, _this13.state.listingsDetails), {
              label: newName
            })
          });

          window.postMessage({
            type: "notification",
            msg: "Amenity updated"
          });
        } else {
          window.postMessage({
            type: "notification",
            msg: "Something went wrong"
          });
          _this13.enableLabelRef.current.value = get(_this13.state.listingsDetails, "label", "");
        }
      });
    }
  }, {
    key: "clickSave",
    value: function clickSave(_ref) {
      var target = _ref.target;

      if (target.classList && target.classList.contains("label_field")) {
        return;
      }

      this.wrapperContent.current && this.wrapperContent.current.removeEventListener("click", this.clickSave, false);
      var classExist = target.classList.contains("save_image_name") || target.closest(".save_image_name");

      if (classExist) {
        var name = this.enableLabelRef.current.value;

        try {
          this.updateAmentiyLabel(name);
        } catch (exception) {
          window.console.info(exception);
        }

        this.setIsImageNameEditable();
      } else {
        this.enableLabelRef.current.value = get(this.state.listingsDetails, "label", "");
        this.setIsImageNameEditable();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this14 = this;

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "listings_details",
        ref: this.wrapperContent
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "page_header"
      }, (get(this.state.listingsDetails, "label", "") || get(this.state.listingsDetails, "unit", "")) && /*#__PURE__*/React__default.createElement("div", {
        className: "label_input_field"
      }, /*#__PURE__*/React__default.createElement("input", {
        type: "text",
        className: ["label_field", !this.state.isImageNameEditable && "not_editable" || ""].join(" "),
        style: {
          width: "".concat((get(this.state.listingsDetails, "label", "") || get(this.state.listingsDetails, "unit", "")).length + 2, "ch")
        },
        defaultValue: get(this.state.listingsDetails, "label", "") || get(this.state.listingsDetails, "unit", "Hello"),
        ref: this.enableLabelRef
      }), this.getHistoryState().is_amenity && /*#__PURE__*/React__default.createElement("span", {
        className: "button__icon",
        onClick: function onClick() {
          return _this14.setIsImageNameEditable();
        }
      }, this.state.isImageNameEditable && /*#__PURE__*/React__default.createElement(MemoSvgCheck, {
        className: "save_image_name"
      }) || /*#__PURE__*/React__default.createElement(MemoSvgEdit2, null))) || null, /*#__PURE__*/React__default.createElement("div", {
        className: "viewer_filters"
      }, this.actionButtonConfig.map(function (config, key) {
        return /*#__PURE__*/React__default.createElement("span", {
          className: "action_item_button_icon",
          onClick: function onClick() {
            return _this14[config.func]();
          },
          key: key
        }, /*#__PURE__*/React__default.createElement(CustomTooltip, {
          title: _this14.state.listingsDetails[config.keyIdentifier] || !config.keyIdentifier ? config.tooltip : config.alternateTooltip,
          placement: "top"
        }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Icon, {
          name: _this14.state.listingsDetails[config.keyIdentifier] || !config.keyIdentifier ? config.iconName : config.disabledIcon,
          color: config.iconColor,
          width: config.iconWidth,
          height: config.iconHeight
        }), config.text && /*#__PURE__*/React__default.createElement("span", {
          className: "icon_text"
        }, config.text))));
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "listing_details_wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "viewer_editlistings_container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "virtual_tour_wrapper"
      }, (this.props.listingsId || this.getHistoryState().amenityId) && this.showWebViewer()), this.state.showEmailListing && /*#__PURE__*/React__default.createElement(EmailListing, {
        data: this.state.listingsDetails,
        toggleEmail: this.openEmailListing
      }), this.state.showShareListing && /*#__PURE__*/React__default.createElement(ShareListing$1, {
        data: this.state.listingsDetails,
        openShareListing: this.openShareListing
      }), this.state.showEmbedListing && /*#__PURE__*/React__default.createElement(EmbedListing, {
        data: this.state.listingsDetails,
        openEmbedListing: this.openEmbedListing
      }), this.state.showAddToFolio && /*#__PURE__*/React__default.createElement(AddToFolio, {
        data: this.state.listingsDetails,
        openFolio: this.addToFolio
      })), !this.getHistoryState().is_amenity && /*#__PURE__*/React__default.createElement("div", {
        className: "activityFeed_container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "activity_feed_wrapper"
      }, /*#__PURE__*/React__default.createElement(ActivityFeed, {
        listingsId: this.props.listingsId
      }))) || null, !this.getHistoryState().is_amenity && /*#__PURE__*/React__default.createElement("div", {
        className: "listing_analytics_container",
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React__default.createElement(Accordion, {
        isCustomIconColor: true,
        customIconColor: this.state.isExpanded && "#fff" || "#383838",
        hasGear: false,
        showExpander: "left",
        headerClassName: this.state.isExpanded && "listing_collpased_entry_dark" || "listing_collpased_entry",
        CallBackOnExpandClick: function CallBackOnExpandClick() {
          _this14.toggleListingAnalytics();
        },
        showExpandedView: this.state.isExpanded
      }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "building_accordian_collapsed",
        onClick: function onClick() {
          _this14.toggleListingAnalytics();
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "building_address"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "listing_analytics_header"
      }, "Listing analytics")))), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, this.state.isExpanded && /*#__PURE__*/React__default.createElement("div", {
        className: "listing-analytics=parent-div"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "filter-div"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "listing-info-div"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "listing-info-block"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "info-title"
      }, "Inquiries ", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
        className: "info-subtitle"
      }, " Last ", this.state.selectedDaySpan, " days")), /*#__PURE__*/React__default.createElement("span", {
        className: "info-data"
      }, this.state.listingInfo.inquiry)), /*#__PURE__*/React__default.createElement("div", {
        className: "listing-info-block"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "info-title"
      }, "Applications ", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
        className: "info-subtitle"
      }, " Last ", this.state.selectedDaySpan, " days")), /*#__PURE__*/React__default.createElement("span", {
        className: "info-data"
      }, this.state.listingInfo.application)), /*#__PURE__*/React__default.createElement("div", {
        className: "listing-info-block"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "info-title"
      }, "Current ", /*#__PURE__*/React__default.createElement("br", null), "visitors"), /*#__PURE__*/React__default.createElement("span", {
        className: "info-data"
      }, this.state.currentVisitor.count))), /*#__PURE__*/React__default.createElement("div", {
        className: "date-range-div"
      }, this.state.dateSelectorArray.map(function (date, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: index,
          className: "".concat(index === 0 ? "first-child" : "", " ").concat(index === 3 ? "last-child" : "")
        }, _this14.state.selectedDaySpan === date && /*#__PURE__*/React__default.createElement(Button$2, {
          label: date + "d",
          type: "active-date-btn"
        }), _this14.state.selectedDaySpan !== date && /*#__PURE__*/React__default.createElement(Button$2, {
          label: date + "d",
          type: "date-btn",
          onClick: function onClick() {
            return _this14.setDateRange(date);
          }
        }));
      }), /*#__PURE__*/React__default.createElement(Button$2, {
        isIcon: true,
        iconName: "csvdownload",
        label: ".CSV",
        type: "csv-btn",
        onClick: function onClick() {
          return _this14.initiateDownloadCSV();
        }
      }))), /*#__PURE__*/React__default.createElement(ListingAnalytics, {
        dateRange: this.state.selectedDaySpan,
        buildingId: this.state.listingsDetails.building._id,
        listingId: this.state.listingsDetails._id
      }))))) || null, !this.getHistoryState().is_amenity && /*#__PURE__*/React__default.createElement("div", {
        className: "edit-listing_modal_container",
        style: {
          width: "100%",
          position: "relative"
        }
      }, /*#__PURE__*/React__default.createElement(Accordion, {
        isCustomIconColor: true,
        customIconColor: this.state.isEditListAccordionExpanded && "#fff" || "#383838",
        hasGear: false,
        showExpander: "left",
        headerClassName: this.state.isEditListAccordionExpanded && "listing_collpased_entry_dark" || "listing_collpased_entry",
        CallBackOnExpandClick: function CallBackOnExpandClick() {
          _this14.toggleEditListing();
        },
        showExpandedView: this.state.isEditListAccordionExpanded
      }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "building_accordian_collapsed",
        onClick: function onClick() {
          _this14.toggleEditListing();
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "building_address"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "listing_analytics_header"
      }, "Listing settings")))), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, this.state.isEditListAccordionExpanded && Object.keys(this.state.listingsDetails).length > 0 && /*#__PURE__*/React__default.createElement(EditListing, {
        selectedData: this.state.listingsDetails,
        uploadToS3: this.props.uploadTos3,
        deleteFromS3: this.props.deleteFroms3,
        onChange: function onChange(isUpdated, changesState) {
          return _this14.updateListingData(isUpdated, changesState);
        },
        hideCancelBtn: true
      })))) || null)));
    }
  }]);

  return ListingsDetails;
}(React__default.Component);

ListingsDetails.propTypes = {
  listingsId: PropTypes.string,
  listingName: PropTypes.string,
  onClick: PropTypes.func,
  onBackClick: PropTypes.func,
  onClose: PropTypes.func,
  uploadTos3: PropTypes.func.isRequired,
  deleteFroms3: PropTypes.func.isRequired,
  region: PropTypes.string,
  userHandler: PropTypes.string,
  xApiKey: PropTypes.string,
  currentVisitorUrl: PropTypes.string,
  history: PropTypes.any
};

var css_248z$b = ".logo-wrapper {\n  background-color: #1D1C38;\n  padding: 25px;\n  display: flex;\n  justify-content: center; }\n  .logo-wrapper .logo-name {\n    padding: 0px 10px; }\n\n.password-wrapper {\n  margin: 30px 40px 0px; }\n  .password-wrapper .input-field {\n    width: 96%; }\n\n.sign-button {\n  margin: 10px 40px 32px; }\n\n.reset_password_match_error {\n  text-align: center;\n  width: 100%;\n  display: block;\n  font-style: italic; }\n\n.onboard_form_wrapper {\n  width: 420px;\n  height: 353px;\n  background: #fff;\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: #d8d8d8;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n";
styleInject(css_248z$b);

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WelcomeOnBoard = /*#__PURE__*/function (_Component) {
  _inherits$1(WelcomeOnBoard, _Component);

  var _super = _createSuper$2(WelcomeOnBoard);

  function WelcomeOnBoard(props) {
    var _this;

    _classCallCheck$1(this, WelcomeOnBoard);

    _this = _super.call(this, props);
    _this.LoginService = new LoginService(props);
    _this.validatePasswordToken = _this.validatePasswordToken.bind(_assertThisInitialized$3(_this));
    _this.fetchInputStatus = _this.fetchInputStatus.bind(_assertThisInitialized$3(_this));
    _this.setNewPassword = _this.setNewPassword.bind(_assertThisInitialized$3(_this));
    _this.state = {
      setValidNewPassword: false
    };
    return _this;
  }

  _createClass$1(WelcomeOnBoard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validatePasswordToken();
      this.setState({
        passwordMatch: true
      });
    }
  }, {
    key: "validatePasswordToken",
    value: function validatePasswordToken() {
      var queryParams = {};
      var newUrl = new URLSearchParams(window.location.search);

      var _iterator = _createForOfIteratorHelper(newUrl),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var param = _step.value;
          queryParams[param[0]] = param[1];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      queryParams.token = queryParams.token || false;
      var password_token = {
        user_id: queryParams.token
      };
      var loginService = new LoginService({
        // eslint-disable-next-line no-undef
        baseAPIPath: process.env.baseAPIPath
      });
      loginService.checkUsertokenValidaitity(password_token).then(function (response) {
        if (!response.data.success) {
          window.postMessage({
            type: "notification",
            msg: "User is already on boarded."
          });

          var _setTimeout = setTimeout(function () {
            clearTimeout(_setTimeout);
            window.location.href = "/";
          }, 5000);
        }
      });
    }
  }, {
    key: "fetchInputStatus",
    value: function fetchInputStatus(status, key) {
      var _objectSpread2,
          _this2 = this;

      this.setState(_objectSpread$5(_objectSpread$5({}, this.state), {}, (_objectSpread2 = {}, _defineProperty$1(_objectSpread2, "".concat(key), status), _defineProperty$1(_objectSpread2, "showSignInButton", this.state.newPassword && this.state.newPassword.length > 0 && this.state.newPassword && this.state.newPassword.length > 0), _objectSpread2)), function () {
        _this2.setState({
          passwordMatch: _this2.state.newPassword === _this2.state.confirmPassword
        });
      });
      this.validPassword(status, key);
    }
  }, {
    key: "validPassword",
    value: function validPassword(value, passwordKey) {
      var isValid = API.checkPassword(value);

      switch (passwordKey) {
        case "newPassword":
          {
            if (isValid) {
              this.setState({
                setValidNewPassword: true
              });
            } else {
              this.setState({
                setValidNewPassword: false
              });
            }
          }
          break;
      }
    }
  }, {
    key: "setNewPassword",
    value: function setNewPassword() {
      var _this3 = this;

      var queryParams = {};
      var newUrl = new URLSearchParams(window.location.search);

      var _iterator2 = _createForOfIteratorHelper(newUrl),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var param = _step2.value;
          queryParams[param[0]] = param[1];
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      queryParams.token = queryParams.token || false;
      var payload = {
        user_id: queryParams.token,
        password: this.state.newPassword
      };
      var loginService = new LoginService({
        // eslint-disable-next-line no-undef
        baseAPIPath: process.env.baseAPIPath
      });
      loginService.changePassword(payload).then(function (response) {
        if (!response.data.success) {
          return;
        } else {
          localStorage.setItem("token", response.data.data.access_token);
          window.postMessage({
            type: "notification",
            msg: "Password has been updated, please login with new password"
          });
          localStorage.setItem("user", JSON.stringify(response.data.data.user_details));
          _this3.props.callBackRedirectToListing && _this3.props.callBackRedirectToListing();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement("div", {
        className: "onboard_form_wrapper"
      }, /*#__PURE__*/React__default.createElement("section", {
        className: "logo-wrapper"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "logo-name"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "brand",
        fillOpacity: "1",
        width: "125px",
        height: "32px"
      })), /*#__PURE__*/React__default.createElement(Icon, {
        name: "peeklogo"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "password-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "new-password"
      }, /*#__PURE__*/React__default.createElement(Input$2, {
        textColor: "#979797",
        label: "Password",
        type: "password",
        name: "newPassword",
        status: this.fetchInputStatus,
        required: true
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "confirm-password"
      }, /*#__PURE__*/React__default.createElement(Input$2, {
        textColor: "#979797",
        label: "Confirm Password",
        type: "password",
        name: "confirmPassword",
        status: this.fetchInputStatus,
        required: true
      }))), !this.state.passwordMatch && /*#__PURE__*/React__default.createElement("span", {
        className: "input-field"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "error-message reset_password_match_error"
      }, "Password and confirm password should match")) || null, /*#__PURE__*/React__default.createElement("div", {
        className: "sign-button"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        disabled: !(this.state.showSignInButton && this.state.setValidNewPassword && this.state.passwordMatch),
        type: this.state.showSignInButton && this.state.setValidNewPassword && this.state.passwordMatch && "login_footer" || "disabled-button",
        color: this.props.primaryColor,
        label: "Reset password",
        onClick: function onClick() {
          return _this4.setNewPassword();
        }
      }))));
    }
  }]);

  return WelcomeOnBoard;
}(Component);

WelcomeOnBoard.propTypes = {
  primaryColor: PropTypes.string,
  textColor: PropTypes.string,
  label: PropTypes.string,
  status: PropTypes.func,
  fillOpacity: PropTypes.string,
  callBackRedirectToListing: PropTypes.func
};

function createPromotion(_x) {
  return _createPromotion.apply(this, arguments);
}

function _createPromotion() {
  _createPromotion = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(payload) {
    var isUpdate,
        request,
        response,
        _args = arguments;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isUpdate = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            request = new HttpService$1(process.env.baseAPIPath); // eslint-disable-next-line no-mixed-operators

            _context.next = 4;
            return request.post(!isUpdate && "promotion/create_promotion" || "promotion/update_promotion", payload);

          case 4:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createPromotion.apply(this, arguments);
}

function getPromotionBuildingList() {
  return _getPromotionBuildingList.apply(this, arguments);
}

function _getPromotionBuildingList() {
  _getPromotionBuildingList = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var request, response;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            request = new HttpService$1(process.env.baseAPIPath);
            _context2.next = 3;
            return request.get("promotion/get_promotion_buildings");

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getPromotionBuildingList.apply(this, arguments);
}

function getBuildingLayouts(_x2) {
  return _getBuildingLayouts.apply(this, arguments);
}

function _getBuildingLayouts() {
  _getBuildingLayouts = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(buildingId) {
    var request, response;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            request = new HttpService$1(process.env.baseAPIPath);
            _context3.next = 3;
            return request.get("promotion/get_promotion_layouts?building_id=".concat(buildingId));

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getBuildingLayouts.apply(this, arguments);
}

function getBuildingUnits(_x3) {
  return _getBuildingUnits.apply(this, arguments);
}

function _getBuildingUnits() {
  _getBuildingUnits = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(buildingId) {
    var request, response;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            request = new HttpService$1(process.env.baseAPIPath);
            _context4.next = 3;
            return request.get("promotion/get_promotion_units?building_id=".concat(buildingId));

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getBuildingUnits.apply(this, arguments);
}

function getPromotionDetails(_x4) {
  return _getPromotionDetails.apply(this, arguments);
}

function _getPromotionDetails() {
  _getPromotionDetails = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(id) {
    var request, response;
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            request = new HttpService$1(process.env.baseAPIPath);
            _context5.next = 3;
            return request.get("promotion/get_promotion_details?promotion_id=".concat(id));

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getPromotionDetails.apply(this, arguments);
}

var css_248z$a = ".promote_bg {\n  width: 100vw;\n  height: 100vh;\n  background: rgba(51, 51, 51, 0.82);\n  mix-blend-mode: multiply;\n  z-index: 1500;\n  position: fixed;\n  top: 0;\n  left: 0; }\n\n.Mui-disabled {\n  color: \"#dfdfdf\" !important;\n  background-color: \"#dfdfdf\" !important;\n  cursor: not-allowed !important; }\n\n.promote_edit_wrapper {\n  width: 70%;\n  height: 70%;\n  overflow-y: auto;\n  box-sizing: border-box;\n  background: #F2F2F2;\n  border-radius: 5px;\n  z-index: 1501;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 32.89px 41.21px; }\n  .promote_edit_wrapper .expiry_warning {\n    font-size: 10px;\n    line-height: 1em; }\n  .promote_edit_wrapper .campaign_selector_wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 15px; }\n  .promote_edit_wrapper .form_submit_control {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 18px;\n    display: flex;\n    align-items: flex-end;\n    text-align: center;\n    color: #333333;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 1em;\n    gap: 1em;\n    padding-top: 1em;\n    border-top: 0.5px solid #C4C4C4; }\n    .promote_edit_wrapper .form_submit_control div {\n      padding: 12px 30px;\n      cursor: pointer; }\n    .promote_edit_wrapper .form_submit_control .save_button {\n      background: #04D2C6;\n      border-radius: 5px;\n      color: #FFFFFF; }\n    .promote_edit_wrapper .form_submit_control .disabled {\n      pointer-events: none;\n      color: #333333; }\n    .promote_edit_wrapper .form_submit_control .cancel_button {\n      background: #FFFFFF;\n      border: 1px solid #D9D9D9;\n      box-sizing: border-box;\n      border-radius: 5px;\n      border: 1px solid #D9D9D9; }\n  .promote_edit_wrapper .dialog_title {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 19px;\n    line-height: 22px;\n    align-items: center;\n    color: #1D1C38;\n    padding-bottom: 8px;\n    border-bottom: 0.5px solid #C4C4C4; }\n  .promote_edit_wrapper .form_controller {\n    display: flex;\n    gap: 20px;\n    width: 100%;\n    padding: 1em 0; }\n    .promote_edit_wrapper .form_controller .left_side,\n    .promote_edit_wrapper .form_controller .right_side {\n      width: 50%;\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 15px;\n      justify-content: flex-start; }\n      .promote_edit_wrapper .form_controller .left_side .building_selector_wrapper,\n      .promote_edit_wrapper .form_controller .right_side .building_selector_wrapper {\n        width: 100%; }\n        .promote_edit_wrapper .form_controller .left_side .building_selector_wrapper .dropdown,\n        .promote_edit_wrapper .form_controller .right_side .building_selector_wrapper .dropdown {\n          padding: 0.5em;\n          border-radius: 5px; }\n          .promote_edit_wrapper .form_controller .left_side .building_selector_wrapper .dropdown .dropdown__items,\n          .promote_edit_wrapper .form_controller .right_side .building_selector_wrapper .dropdown .dropdown__items {\n            left: 0;\n            top: 40px;\n            max-height: 40vh; }\n      .promote_edit_wrapper .form_controller .left_side .select_expiration_date,\n      .promote_edit_wrapper .form_controller .right_side .select_expiration_date {\n        display: flex;\n        gap: 0 20px;\n        flex-wrap: wrap; }\n        .promote_edit_wrapper .form_controller .left_side .select_expiration_date .container-checkbox .label,\n        .promote_edit_wrapper .form_controller .right_side .select_expiration_date .container-checkbox .label {\n          top: -3px; }\n  .promote_edit_wrapper .label, .promote_edit_wrapper .unit_selector_title, .promote_edit_wrapper .title {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 28px;\n    letter-spacing: -0.01em;\n    color: #545454;\n    font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    font-weight: 500; }\n  .promote_edit_wrapper .unit_selector_wrapper {\n    display: flex;\n    gap: 10px;\n    justify-content: space-between;\n    align-items: center;\n    text-align: center; }\n    .promote_edit_wrapper .unit_selector_wrapper .selected {\n      border: solid 1px #000; }\n    .promote_edit_wrapper .unit_selector_wrapper div {\n      background: #FFFFFF;\n      box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n      border-radius: 4px;\n      width: 149px;\n      cursor: pointer;\n      font-size: 16px;\n      line-height: 29px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      padding: 1.5px 1em; }\n\n.promotion_preview {\n  height: 360px;\n  position: relative; }\n  .promotion_preview img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 5px; }\n  .promotion_preview .promotional_label_text {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 28px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: #1D1C38;\n    background: linear-gradient(0deg, rgba(4, 210, 198, 0.1), rgba(4, 210, 198, 0.1)), #FFFFFF;\n    border-radius: 6px;\n    position: absolute;\n    bottom: 2em;\n    left: 2em;\n    padding: 0 21px; }\n\n@media screen and (max-width: 750px) {\n  .form_controller {\n    flex-direction: column; }\n  .right_side,\n  .left_side {\n    width: 100% !important; } }\n";
styleInject(css_248z$a);

var img$1 = "data:image/png;base64,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";

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PromoteDialog = function PromoteDialog(props) {
  var isInitialMount = useRef(true);

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      associatedBuildingInfoDownloaded = _useState2[0],
      setAssociatedBuildingInfoDownloaded = _useState2[1];

  var _useState3 = useState("all"),
      _useState4 = _slicedToArray$1(_useState3, 2),
      unitCategory = _useState4[0],
      selectUnitCategory = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray$1(_useState5, 2),
      buildingList = _useState6[0],
      setBuildingList = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray$1(_useState7, 2),
      selectedBuilding = _useState8[0],
      setSelectedBuilding = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray$1(_useState9, 2),
      layoutList = _useState10[0],
      setLayoutList = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray$1(_useState11, 2),
      unitList = _useState12[0],
      setUnitList = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray$1(_useState13, 2),
      selectedUnit = _useState14[0],
      setSelectedUnit = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray$1(_useState15, 2),
      selectedLayout = _useState16[0],
      setSelectedLayout = _useState16[1];

  var _useState17 = useState(""),
      _useState18 = _slicedToArray$1(_useState17, 2),
      promotionName = _useState18[0],
      setPromotionName = _useState18[1];

  var _useState19 = useState(""),
      _useState20 = _slicedToArray$1(_useState19, 2),
      campaigName = _useState20[0],
      setCampaignName = _useState20[1];

  var _useState21 = useState(""),
      _useState22 = _slicedToArray$1(_useState21, 2),
      description = _useState22[0],
      setDescription = _useState22[1];

  var _useState23 = useState(""),
      _useState24 = _slicedToArray$1(_useState23, 2),
      details = _useState24[0],
      setDetails = _useState24[1];

  var _useState25 = useState(new Date()),
      _useState26 = _slicedToArray$1(_useState25, 2),
      expirationDate = _useState26[0],
      setExpirationDate = _useState26[1];

  var _useState27 = useState(false),
      _useState28 = _slicedToArray$1(_useState27, 2),
      doesNotExpireCheckbox = _useState28[0],
      setDoesNotExpireCheckbox = _useState28[1];

  var _useState29 = useState(true),
      _useState30 = _slicedToArray$1(_useState29, 2),
      expirationDateValid = _useState30[0],
      SetExpirationDateValid = _useState30[1];

  var _useState31 = useState(true),
      _useState32 = _slicedToArray$1(_useState31, 2),
      showLoader = _useState32[0],
      setShowLoader = _useState32[1];

  var _useState33 = useState(!props.isEditWindow),
      _useState34 = _slicedToArray$1(_useState33, 2),
      renderDropdown = _useState34[0],
      setRerenderDropdown = _useState34[1];

  var validExpirationDate = function validExpirationDate() {
    var isReturn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var currentDate = new Date();

    var _expiry = expirationDate && expirationDate || new Date();

    var momentConvertionCurrentDate = moment(currentDate).format("l");
    var momentConversionExpiryDate = moment(_expiry).format("l");
    var isValidExpiration = !doesNotExpireCheckbox ? momentConvertionCurrentDate === momentConversionExpiryDate ? true : moment(momentConvertionCurrentDate).isBefore(momentConversionExpiryDate) : true;

    if (isReturn) {
      SetExpirationDateValid(isValidExpiration);
    } else {
      return isValidExpiration;
    }
  };

  var validatePromoteForm = function validatePromoteForm() {
    if (get(selectedBuilding, "_id", "").length && campaigName.length && promotionName.length && validExpirationDate(false)) {
      if (unitCategory === "unit") {
        if (selectedUnit.length) {
          return true;
        } else {
          return false;
        }
      } else if (unitCategory === "all") {
        return true;
      } else if (unitCategory === "layout") {
        if (selectedLayout.length) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  };

  var setDateForExpiry = function setDateForExpiry(date) {
    setExpirationDate(date);
  };

  var getUnitList = function getUnitList() {
    var selectedBuildingObject = buildingList.filter(function (buildingObject) {
      return buildingObject.building === selectedBuilding;
    });
    var selectedUnits = get(selectedBuildingObject[0], "units", []);
    setUnitList(selectedUnits.map(function (unitObject) {
      return {
        value: unitObject.unit
      };
    }));
  };

  var saveCampaign = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var isEditWindow, id, _selectedUnit, payload, response;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isEditWindow = props.isEditWindow, id = props.id;
              _selectedUnit = [];

              if (selectedUnit.length && _typeof$2(selectedUnit[0]) === "object") {
                _selectedUnit = selectedUnit.map(function (unit) {
                  return unit._id;
                });
              } else {
                _selectedUnit = selectedUnit;
              }

              payload = {
                campaign_name: campaigName,
                building_id: selectedBuilding._id,
                promotion_headline: promotionName,
                details: details,
                terms_and_conditions: description,
                expired_on: doesNotExpireCheckbox ? "" : moment(expirationDate).format("YYYY-MM-DD"),
                promotion_units: {
                  all_units: unitCategory === "all",
                  selected_layouts: unitCategory === "layout" && selectedLayout.map(function (layout) {
                    return {
                      bedroom: layout.bedroom,
                      bathroom: layout.bathroom
                    };
                  }) || [],
                  selected_units: unitCategory === "unit" && _selectedUnit || []
                }
              };

              if (isEditWindow) {
                payload.promotion_id = id;
              }

              _context.next = 7;
              return createPromotion(payload, isEditWindow);

            case 7:
              response = _context.sent;

              if (response) {
                if (response.data.success) {
                  window.postMessage({
                    type: "notification",
                    msg: !isEditWindow && "Promotion created successfully" || "Promotion updated successfully"
                  });
                  props.onSuccess();
                } else {
                  window.postMessage({
                    type: "notification",
                    msg: "Error occurred while ".concat(!isEditWindow && "create" || "update the", " promotion")
                  });
                }

                window.dataLayer && window.dataLayer.push({
                  event: "gtm.click",
                  eventProps: {
                    category: "Promotions_Actions",
                    action: "Created",
                    label: "Agent Dashboard",
                    value: 1
                  }
                });
                props.cancelClick();
              } else {
                window.postMessage({
                  type: "notification",
                  msg: "Error occurred while creating the promotion"
                });
                window.dataLayer && window.dataLayer.push({
                  event: "gtm.click",
                  eventProps: {
                    category: "Promotions_Actions",
                    action: "Create Promotion Failed",
                    label: "Agent Dashboard",
                    value: 1
                  }
                });
                props.cancelClick();
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function saveCampaign() {
      return _ref.apply(this, arguments);
    };
  }();

  var getPromotionInformation = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      var response, _response$data$data, campaign_name, building_id, promotion_headline, _details, terms_and_conditions, expired_on, promotion_units, expiry, selectedBuildingObject, all_units, selected_layouts, selected_units;

      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getPromotionDetails(props.id);

            case 2:
              response = _context2.sent;

              if (response.data.success) {
                _response$data$data = response.data.data, campaign_name = _response$data$data.campaign_name, building_id = _response$data$data.building_id, promotion_headline = _response$data$data.promotion_headline, _details = _response$data$data.details, terms_and_conditions = _response$data$data.terms_and_conditions, expired_on = _response$data$data.expired_on, promotion_units = _response$data$data.promotion_units;
                setPromotionName(promotion_headline);
                setCampaignName(campaign_name);
                setDetails(_details);
                setDescription(terms_and_conditions);

                if (expired_on) {
                  expiry = moment(expired_on.substr(0, 10));
                  setExpirationDate(expiry);
                } else setDoesNotExpireCheckbox(true); // filter the selected building


                selectedBuildingObject = buildingList.filter(function (building) {
                  return building._id === building_id;
                });
                setSelectedBuilding(selectedBuildingObject[0]); // set Selected Unit, Layout and category

                all_units = promotion_units.all_units, selected_layouts = promotion_units.selected_layouts, selected_units = promotion_units.selected_units;

                if (all_units === "true") {
                  selectUnitCategory("all");
                  setSelectedLayout([]);
                  setSelectedUnit([]);
                } else if (all_units !== "true" && selected_layouts.length) {
                  selectUnitCategory("layout");
                  setSelectedUnit([]);
                  setSelectedLayout(selected_layouts);
                } else if (all_units !== "true" && selected_units.length) {
                  selectUnitCategory("unit");
                  setSelectedUnit(selected_units);
                  setSelectedLayout([]);
                }
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getPromotionInformation() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getBuildingsList = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var response, _buildingList;

      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getPromotionBuildingList();

            case 2:
              response = _context3.sent;

              if (response.data.success) {
                _buildingList = get(response, "data.data.buildings", []).map(function (building) {
                  return {
                    _id: building._id,
                    value: building.address
                  };
                });
                setBuildingList(_buildingList);
                !props.isEditWindow && setShowLoader(false);
              }

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function getBuildingsList() {
      return _ref3.apply(this, arguments);
    };
  }();

  var convertLayoutsIntoPreselectedValues = function convertLayoutsIntoPreselectedValues() {
    return selectedLayout.map(function (layout) {
      return "".concat(layout.bedroom, " Bed/").concat(layout.bathroom, " Bath");
    });
  };

  var getBuildingLayoutsList = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      var response, unitResponse, _unitList;

      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getBuildingLayouts(selectedBuilding._id);

            case 2:
              response = _context4.sent;

              if (response.data.success) {
                setLayoutList(get(response, "data.data.layouts", []).map(function (layout) {
                  return _objectSpread$4(_objectSpread$4({}, layout), {}, {
                    value: "".concat(layout.bedroom_unit, " Bed/").concat(layout.bathroom_unit, " Bath")
                  });
                }));
              }

              _context4.next = 6;
              return getBuildingUnits(selectedBuilding._id);

            case 6:
              unitResponse = _context4.sent;

              if (unitResponse.data.success) {
                _unitList = get(unitResponse, "data.data.units", []).map(function (unit) {
                  return {
                    _id: unit._id,
                    value: unit.unit
                  };
                });
                setUnitList(_unitList);
              }

              setAssociatedBuildingInfoDownloaded(true);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function getBuildingLayoutsList() {
      return _ref4.apply(this, arguments);
    };
  }();

  var getPreselctedUnit = function getPreselctedUnit() {
    var preselectedUnit = unitList.filter(function (unit) {
      return selectedUnit.indexOf(unit._id) !== -1;
    }).map(function (unit) {
      return unit.value;
    });
    return preselectedUnit;
  }; // eslint-disable-next-line no-unused-vars

  var onLayoutSelect = function onLayoutSelect(values) {
    var selectedUnit = values.map(function (value) {
      return {
        bedroom: value.bedroom_unit,
        bathroom: value.bathroom_unit
      };
    });
    setSelectedLayout(selectedUnit);
  };

  useEffect(function () {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      getBuildingsList();
    }

    return function cleanup() {
      setAssociatedBuildingInfoDownloaded(false);
      selectUnitCategory("all");
      setBuildingList([]);
      setSelectedBuilding({});
      setLayoutList([]);
      setUnitList([]);
      setSelectedUnit([]);
      setSelectedLayout([]);
      setPromotionName("");
      setCampaignName("");
      setDescription("");
      setDetails("");
      setExpirationDate(new Date());
      setDoesNotExpireCheckbox(false);
      SetExpirationDateValid(true);
      setShowLoader(true);
    };
  }, []);
  useEffect(function () {
    associatedBuildingInfoDownloaded && setShowLoader(false);
  }, [associatedBuildingInfoDownloaded]);
  useEffect(function () {
    buildingList.length && props.isEditWindow && getPromotionInformation();
  }, [buildingList]);
  useEffect(function () {
    if (Object.keys(selectedBuilding).length && selectedBuilding._id) {
      setAssociatedBuildingInfoDownloaded(false);
      getBuildingLayoutsList();
      setSelectedUnit([]);
    }
  }, [selectedBuilding]);
  useEffect(function () {
    !isInitialMount && validExpirationDate();
  }, [expirationDate, doesNotExpireCheckbox]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "promote_edit_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dialog_title"
  }, props.isEditWindow ? "Edit Campaign" : "Create a campaign"), !showLoader && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "form_controller"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "left_side"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "building_selector_wrapper"
  }, /*#__PURE__*/React__default.createElement(Dropdown$1, {
    dropdownList: buildingList,
    placeholder: "Select building",
    isArrayOfObject: true,
    keyName: "value",
    altName: "value",
    returnKey: "_id",
    value: Object.keys(selectedBuilding).length && buildingList.filter(function (building) {
      return building._id === selectedBuilding._id;
    })[0].value || "",
    change: function change(buildingId) {
      var filtredBuilding = buildingList.filter(function (building) {
        return building._id === buildingId;
      });
      setSelectedBuilding(filtredBuilding[0]);
      getUnitList();
      setRerenderDropdown(true);
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "campaign_selector_wrapper"
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    type: "text",
    name: "compaign_name",
    label: "Campaign name",
    value: campaigName,
    disabled: get(selectedBuilding, "_id", "").length === 0,
    change: function change(e) {
      return setCampaignName(e);
    },
    isRequired: true,
    hasError: false,
    errorMessage: "Please enter campaign name"
  }), /*#__PURE__*/React__default.createElement(TextField$3, {
    type: "text",
    name: "promotion_headline",
    label: "Promotion Headline",
    value: promotionName,
    disabled: get(selectedBuilding, "_id", "").length === 0,
    change: function change(e) {
      return setPromotionName(e);
    },
    isRequired: true,
    hasError: false,
    errorMessage: "Please enter a promotion headline"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "unit_selector_title"
  }, "Units", /*#__PURE__*/React__default.createElement("span", {
    className: "red"
  }, "*")), /*#__PURE__*/React__default.createElement("div", {
    className: "unit_selector_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: unitCategory === "all" ? "selected" : "",
    onClick: function onClick() {
      return selectUnitCategory("all");
    }
  }, "All units"), /*#__PURE__*/React__default.createElement("div", {
    className: unitCategory === "layout" ? "selected" : "",
    onClick: function onClick() {
      return selectUnitCategory("layout");
    }
  }, "Select layouts"), /*#__PURE__*/React__default.createElement("div", {
    className: unitCategory === "unit" ? "selected" : "",
    onClick: function onClick() {
      return selectUnitCategory("unit");
    }
  }, "Select units")), unitCategory !== "all" && /*#__PURE__*/React__default.createElement("div", {
    className: "dropdown_selector"
  }, unitCategory === "unit" && /*#__PURE__*/React__default.createElement(MultipleSelect, {
    placeholder: "Select unit",
    options: unitList,
    typeObject: true,
    selected: getPreselctedUnit(),
    isNew: renderDropdown,
    onSelect: function onSelect(values) {
      setSelectedUnit(values);
      setRerenderDropdown(false);
    },
    multiple: true
  }) || null, unitCategory === "layout" && /*#__PURE__*/React__default.createElement(MultipleSelect, {
    placeholder: "Select layout",
    onSelect: function onSelect(values) {
      onLayoutSelect(values);
    },
    typeObject: true,
    selected: convertLayoutsIntoPreselectedValues(),
    options: layoutList,
    multiple: true
  }) || null), /*#__PURE__*/React__default.createElement("div", {
    className: "date_wrapper_form"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "title"
  }, "Expiration Date", /*#__PURE__*/React__default.createElement("span", {
    className: "red"
  }, "*")), /*#__PURE__*/React__default.createElement("div", {
    className: "select_expiration_date"
  }, /*#__PURE__*/React__default.createElement(Datepicker, {
    change: setDateForExpiry,
    disabled: doesNotExpireCheckbox,
    value: expirationDate,
    placeholder: "Select date"
  }), /*#__PURE__*/React__default.createElement(CheckBox$1, {
    onChange: function onChange() {
      setDoesNotExpireCheckbox(!doesNotExpireCheckbox);
    },
    isChecked: doesNotExpireCheckbox,
    label: "Does not expire"
  })), !expirationDateValid && /*#__PURE__*/React__default.createElement("span", {
    className: "red expiry_warning"
  }, "Expiration date should be future data.")), /*#__PURE__*/React__default.createElement("div", {
    className: "terms_condition"
  }, /*#__PURE__*/React__default.createElement(TextArea, {
    text: description,
    isDisabled: get(selectedBuilding, "_id", "").length === 0,
    title: "Terms & conditions",
    placeholder: "Visit peek.us for full terms & conditions",
    onChange: function onChange(e) {
      return setDescription(e);
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "right_side"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "terms_condition"
  }, /*#__PURE__*/React__default.createElement(TextArea, {
    text: details,
    isDisabled: get(selectedBuilding, "_id", "").length === 0,
    title: "Details",
    placeholder: "Optional",
    onChange: function onChange(e) {
      return setDetails(e);
    }
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "unit_selector_title"
  }, "Preview"), /*#__PURE__*/React__default.createElement("div", {
    className: "promotion_preview"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "promotional_label_text"
  }, promotionName, ". Learn more."), /*#__PURE__*/React__default.createElement("img", {
    src: img$1,
    alt: "preview image"
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "form_submit_control"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cancel_button",
    onClick: function onClick() {
      return props.cancelClick();
    }
  }, "Cancel"), /*#__PURE__*/React__default.createElement("div", {
    className: "save_button ".concat(!validatePromoteForm() ? "cancel_button disabled" : "right_button"),
    onClick: function onClick() {
      return saveCampaign();
    }
  }, props.isEditWindow ? "Save changes" : "Create"))) || /*#__PURE__*/React__default.createElement("div", {
    className: "_spinner_loader_generic"
  }, /*#__PURE__*/React__default.createElement(Spinner, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "promote_bg",
    onClick: function onClick() {
      return props.cancelClick();
    }
  }));
};

PromoteDialog.defaultProps = {
  isEditWindow: false
};
PromoteDialog.propTypes = {
  cancelClick: PropTypes.func,
  onSuccess: PropTypes.func,
  isEditWindow: PropTypes.bool,
  id: PropTypes.string
};

var css_248z$9 = ".promotion_delete_rollup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: #333;\n  width: 100%;\n  height: 100%;\n  opacity: 0.85;\n  z-index: 1; }\n\n.delete_promotion_dialog {\n  position: fixed;\n  width: 452px;\n  top: 50%;\n  left: 50%;\n  background: #F2F2F2;\n  box-shadow: 1px 1px 7px rgba(0, 0, 0, 0.14);\n  border-radius: 5px;\n  transform: translate(-50%, -50%);\n  padding: 27px 36px 17px;\n  z-index: 2; }\n  .delete_promotion_dialog .delete_promotion_dialog_title {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 19px;\n    line-height: 22px;\n    display: flex;\n    align-items: center;\n    color: #1D1C38;\n    padding-bottom: 10px;\n    border-bottom: 0.5px solid #C4C4C4; }\n  .delete_promotion_dialog .delete_promotion_text {\n    margin-top: 6px;\n    padding-top: 10px;\n    margin-bottom: 36px;\n    font-style: normal;\n    font-weight: 500;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    color: #1D1C38;\n    line-height: 23px; }\n    .delete_promotion_dialog .delete_promotion_text .delete_promotion_text_heading {\n      font-size: 17px; }\n    .delete_promotion_dialog .delete_promotion_text .delete_promotion_text_subtext {\n      font-size: 12px; }\n  .delete_promotion_dialog .delete_promotion_form_control {\n    padding-top: 13px;\n    display: flex;\n    justify-content: center;\n    gap: 13px;\n    border-top: 0.5px solid #C4C4C4; }\n    .delete_promotion_dialog .delete_promotion_form_control div {\n      width: 110px;\n      background: #fff;\n      padding: 9px 0;\n      border-radius: 4px;\n      text-align: center;\n      cursor: pointer;\n      border: 1px solid #D9D9D9; }\n    .delete_promotion_dialog .delete_promotion_form_control .delete_button {\n      background: #EA6767;\n      color: #fff; }\n";
styleInject(css_248z$9);

var DeletePromotionDialog = function DeletePromotionDialog(props) {
  var id = props.id,
      closeDeletePromotion = props.closeDeletePromotion,
      deletePromotion = props.deletePromotion;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "promotion_delete_rollup",
    onClick: function onClick() {
      return closeDeletePromotion();
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "delete_promotion_dialog"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "delete_promotion_dialog_title"
  }, "Delete promotion"), /*#__PURE__*/React__default.createElement("div", {
    className: "delete_promotion_text"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "delete_promotion_text_heading"
  }, "Are you sure you want to delete this promotion?"), /*#__PURE__*/React__default.createElement("div", {
    className: "delete_promotion_text_subtext"
  }, "This offer will be permanently deleted.")), /*#__PURE__*/React__default.createElement("div", {
    className: "delete_promotion_form_control"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cancel_button",
    onClick: function onClick() {
      return closeDeletePromotion();
    }
  }, "Cancel"), /*#__PURE__*/React__default.createElement("div", {
    className: "delete_button",
    onClick: function onClick() {
      return deletePromotion(id);
    }
  }, "Delete"))));
};

DeletePromotionDialog.propTypes = {
  id: PropTypes.string,
  closeDeletePromotion: PropTypes.func,
  deletePromotion: PropTypes.func
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 * 
 * @example
 * // Are 4 September and 4 October in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 * 
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
 *
 *   // v2.0.0 onward
 *
 *   eachDayOfInterval(
 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
 *   )
 *   ```
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */

function eachDayOfInterval(dirtyInterval, options) {
  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = options && 'step' in options ? Number(options.step) : 1;
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return dates;
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */

function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

var formatDistance$1 = formatDistance;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

var formatRelative$1 = formatRelative;

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$2 = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters$3.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters$3.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var formatters$1 = formatters;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp$1).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours$1(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  requiredArgs(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
var parsers$1 = parsers;

var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    var firstCharacter = token[0];
    var parser = parsers$1[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */

function isPast(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getTime() < Date.now();
}

/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */

function startOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}

/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour (and same day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 * 
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */

function isSameHour(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

var DateFnsUtils = /** @class */ (function () {
    function DateFnsUtils(_a) {
        var locale = (_a === void 0 ? {} : _a).locale;
        this.yearFormat = "yyyy";
        this.yearMonthFormat = "MMMM yyyy";
        this.dateTime12hFormat = "MMMM do hh:mm aaaa";
        this.dateTime24hFormat = "MMMM do HH:mm";
        this.time12hFormat = "hh:mm a";
        this.time24hFormat = "HH:mm";
        this.dateFormat = "MMMM do";
        this.locale = locale;
    }
    // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
    // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
    DateFnsUtils.prototype.addDays = function (value, count) {
        return addDays(value, count);
    };
    DateFnsUtils.prototype.isValid = function (value) {
        return isValid(this.date(value));
    };
    DateFnsUtils.prototype.getDiff = function (value, comparing) {
        return differenceInMilliseconds(value, this.date(comparing));
    };
    DateFnsUtils.prototype.isAfter = function (value, comparing) {
        return isAfter(value, comparing);
    };
    DateFnsUtils.prototype.isBefore = function (value, comparing) {
        return isBefore(value, comparing);
    };
    DateFnsUtils.prototype.startOfDay = function (value) {
        return startOfDay(value);
    };
    DateFnsUtils.prototype.endOfDay = function (value) {
        return endOfDay(value);
    };
    DateFnsUtils.prototype.getHours = function (value) {
        return getHours$1(value);
    };
    DateFnsUtils.prototype.setHours = function (value, count) {
        return setHours(value, count);
    };
    DateFnsUtils.prototype.setMinutes = function (value, count) {
        return setMinutes(value, count);
    };
    DateFnsUtils.prototype.getSeconds = function (value) {
        return getSeconds(value);
    };
    DateFnsUtils.prototype.setSeconds = function (value, count) {
        return setSeconds(value, count);
    };
    DateFnsUtils.prototype.isSameDay = function (value, comparing) {
        return isSameDay(value, comparing);
    };
    DateFnsUtils.prototype.isSameMonth = function (value, comparing) {
        return isSameMonth(value, comparing);
    };
    DateFnsUtils.prototype.isSameYear = function (value, comparing) {
        return isSameYear(value, comparing);
    };
    DateFnsUtils.prototype.isSameHour = function (value, comparing) {
        return isSameHour(value, comparing);
    };
    DateFnsUtils.prototype.startOfMonth = function (value) {
        return startOfMonth(value);
    };
    DateFnsUtils.prototype.endOfMonth = function (value) {
        return endOfMonth(value);
    };
    DateFnsUtils.prototype.getYear = function (value) {
        return getYear(value);
    };
    DateFnsUtils.prototype.setYear = function (value, count) {
        return setYear(value, count);
    };
    DateFnsUtils.prototype.date = function (value) {
        if (typeof value === "undefined") {
            return new Date();
        }
        if (value === null) {
            return null;
        }
        return new Date(value);
    };
    DateFnsUtils.prototype.parse = function (value, formatString) {
        if (value === "") {
            return null;
        }
        return parse(value, formatString, new Date(), { locale: this.locale });
    };
    DateFnsUtils.prototype.format = function (date, formatString) {
        return format(date, formatString, { locale: this.locale });
    };
    DateFnsUtils.prototype.isEqual = function (date, comparing) {
        if (date === null && comparing === null) {
            return true;
        }
        return isEqual(date, comparing);
    };
    DateFnsUtils.prototype.isNull = function (date) {
        return date === null;
    };
    DateFnsUtils.prototype.isAfterDay = function (date, value) {
        return isAfter(date, endOfDay(value));
    };
    DateFnsUtils.prototype.isBeforeDay = function (date, value) {
        return isBefore(date, startOfDay(value));
    };
    DateFnsUtils.prototype.isBeforeYear = function (date, value) {
        return isBefore(date, startOfYear(value));
    };
    DateFnsUtils.prototype.isAfterYear = function (date, value) {
        return isAfter(date, endOfYear(value));
    };
    DateFnsUtils.prototype.formatNumber = function (numberToFormat) {
        return numberToFormat;
    };
    DateFnsUtils.prototype.getMinutes = function (date) {
        return date.getMinutes();
    };
    DateFnsUtils.prototype.getMonth = function (date) {
        return date.getMonth();
    };
    DateFnsUtils.prototype.setMonth = function (date, count) {
        return setMonth(date, count);
    };
    DateFnsUtils.prototype.getMeridiemText = function (ampm) {
        return ampm === "am" ? "AM" : "PM";
    };
    DateFnsUtils.prototype.getNextMonth = function (date) {
        return addMonths(date, 1);
    };
    DateFnsUtils.prototype.getPreviousMonth = function (date) {
        return addMonths(date, -1);
    };
    DateFnsUtils.prototype.getMonthArray = function (date) {
        var firstMonth = startOfYear(date);
        var monthArray = [firstMonth];
        while (monthArray.length < 12) {
            var prevMonth = monthArray[monthArray.length - 1];
            monthArray.push(this.getNextMonth(prevMonth));
        }
        return monthArray;
    };
    DateFnsUtils.prototype.mergeDateAndTime = function (date, time) {
        return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
    };
    DateFnsUtils.prototype.getWeekdays = function () {
        var _this = this;
        var now = new Date();
        return eachDayOfInterval({
            start: startOfWeek(now, { locale: this.locale }),
            end: endOfWeek(now, { locale: this.locale })
        }).map(function (day) { return _this.format(day, "EEEEEE"); });
    };
    DateFnsUtils.prototype.getWeekArray = function (date) {
        var start = startOfWeek(startOfMonth(date), { locale: this.locale });
        var end = endOfWeek(endOfMonth(date), { locale: this.locale });
        var count = 0;
        var current = start;
        var nestedWeeks = [];
        while (isBefore(current, end)) {
            var weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = addDays(current, 1);
            count += 1;
        }
        return nestedWeeks;
    };
    DateFnsUtils.prototype.getYearRange = function (start, end) {
        var startDate = startOfYear(start);
        var endDate = endOfYear(end);
        var years = [];
        var current = startDate;
        while (isBefore(current, endDate)) {
            years.push(current);
            current = addYears(current, 1);
        }
        return years;
    };
    // displaying methpds
    DateFnsUtils.prototype.getCalendarHeaderText = function (date) {
        return this.format(date, this.yearMonthFormat);
    };
    DateFnsUtils.prototype.getYearText = function (date) {
        return this.format(date, "yyyy");
    };
    DateFnsUtils.prototype.getDatePickerHeaderText = function (date) {
        return this.format(date, "EEE, MMM d");
    };
    DateFnsUtils.prototype.getDateTimePickerHeaderText = function (date) {
        return this.format(date, "MMM d");
    };
    DateFnsUtils.prototype.getMonthText = function (date) {
        return this.format(date, "MMMM");
    };
    DateFnsUtils.prototype.getDayText = function (date) {
        return this.format(date, "d");
    };
    DateFnsUtils.prototype.getHourText = function (date, ampm) {
        return this.format(date, ampm ? "hh" : "HH");
    };
    DateFnsUtils.prototype.getMinuteText = function (date) {
        return this.format(date, "mm");
    };
    DateFnsUtils.prototype.getSecondText = function (date) {
        return this.format(date, "ss");
    };
    return DateFnsUtils;
}());

var MuiPickersContext = createContext(null);
var MuiPickersUtilsProvider = function MuiPickersUtilsProvider(_ref) {
  var Utils = _ref.utils,
      children = _ref.children,
      locale = _ref.locale,
      libInstance = _ref.libInstance;
  var utils = useMemo(function () {
    return new Utils({
      locale: locale,
      instance: libInstance
    });
  }, [Utils, libInstance, locale]);
  return createElement(MuiPickersContext.Provider, {
    value: utils,
    children: children
  });
};
process.env.NODE_ENV !== "production" ? MuiPickersUtilsProvider.propTypes = {
  utils: propTypes_1.isRequired,
  locale: propTypes_2([propTypes_3, propTypes_4]),
  children: propTypes_2([propTypes_5.isRequired, propTypes_6(propTypes_5.isRequired)]).isRequired
} : void 0;

var checkUtils = function checkUtils(utils) {
  if (!utils) {
    // tslint:disable-next-line
    throw new Error('Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.');
  }
};
function useUtils() {
  var utils = useContext(MuiPickersContext);
  checkUtils(utils);
  return utils;
}

var styles$A = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = /*#__PURE__*/React$2.forwardRef(function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = _objectWithoutProperties(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return /*#__PURE__*/React$2.createElement(Component, _extends$3({
    className: clsx(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(capitalize(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(capitalize(align))], display !== 'initial' && classes["display".concat(capitalize(display))]),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Typography.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: PropTypes.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),

  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: PropTypes.object
} : void 0;
var Typography$1 = withStyles(styles$A, {
  name: 'MuiTypography'
})(Typography);

var useEnhancedEffect$3 = typeof window === 'undefined' ? React$2.useEffect : React$2.useLayoutEffect;
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = React$2.useState(false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = clsx(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = useEventCallback(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect$3(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return /*#__PURE__*/React$2.createElement("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /*#__PURE__*/React$2.createElement("span", {
    className: childClassName
  }));
}

process.env.NODE_ENV !== "production" ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,

  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,

  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;

var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles$z = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = /*#__PURE__*/React$2.forwardRef(function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties(props, ["center", "classes", "className"]);

  var _React$useState = React$2.useState([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = React$2.useRef(0);
  var rippleCallback = React$2.useRef(null);
  React$2.useEffect(function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = React$2.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = React$2.useRef(null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = React$2.useRef(null);
  var container = React$2.useRef(null);
  React$2.useEffect(function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = React$2.useCallback(function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(_toConsumableArray(oldRipples), [/*#__PURE__*/React$2.createElement(Ripple, {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = React$2.useCallback(function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = React$2.useCallback(function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = React$2.useCallback(function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  React$2.useImperativeHandle(ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/React$2.createElement("span", _extends$3({
    className: clsx(classes.root, className),
    ref: container
  }, other), /*#__PURE__*/React$2.createElement(TransitionGroup$1, {
    component: null,
    exit: true
  }, ripples));
});
process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
var TouchRipple$1 = withStyles(styles$z, {
  flip: false,
  name: 'MuiTouchRipple'
})( /*#__PURE__*/React$2.memo(TouchRipple));

var styles$y = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = /*#__PURE__*/React$2.forwardRef(function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = _objectWithoutProperties(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = React$2.useRef(null);

  function getButtonNode() {
    // #StrictMode ready
    return ReactDOM.findDOMNode(buttonRef.current);
  }

  var rippleRef = React$2.useRef(null);

  var _React$useState = React$2.useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  React$2.useImperativeHandle(action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  React$2.useEffect(function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return useEventCallback(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = useEventCallback(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = React$2.useRef(false);
  var handleKeyDown = useEventCallback(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = useEventCallback(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = useForkRef(buttonRefProp, ref);
  var handleOwnRef = useForkRef(focusVisibleRef, buttonRef);
  var handleRef = useForkRef(handleUserRef, handleOwnRef);

  var _React$useState2 = React$2.useState(false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  React$2.useEffect(function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$2.useEffect(function () {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }

  return /*#__PURE__*/React$2.createElement(ComponentProp, _extends$3({
    className: clsx(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  /*#__PURE__*/

  /* TouchRipple is only needed client-side, x2 boost on the server. */
  React$2.createElement(TouchRipple$1, _extends$3({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
process.env.NODE_ENV !== "production" ? ButtonBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType$1,

  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: deprecatedPropType(refType$1, 'Use `ref` instead.'),

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: PropTypes.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   */
  focusRipple: PropTypes.bool,

  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * @ignore
   */
  href: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,

  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,

  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,

  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,

  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string])
} : void 0;
var ButtonBase$1 = withStyles(styles$y, {
  name: 'MuiButtonBase'
})(ButtonBase);

var styles$x = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends$3({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: alpha(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '6px 8px'
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabledBackground)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(alpha(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(alpha(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&$focusVisible': {
        boxShadow: 'none'
      },
      '&:active': {
        boxShadow: 'none'
      },
      '&$disabled': {
        boxShadow: 'none'
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4,
      '&$iconSizeSmall': {
        marginLeft: -2
      }
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8,
      '&$iconSizeSmall': {
        marginRight: -2
      }
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 20
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  };
};
var Button = /*#__PURE__*/React$2.forwardRef(function Button(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && /*#__PURE__*/React$2.createElement("span", {
    className: clsx(classes.startIcon, classes["iconSize".concat(capitalize(size))])
  }, startIconProp);
  var endIcon = endIconProp && /*#__PURE__*/React$2.createElement("span", {
    className: clsx(classes.endIcon, classes["iconSize".concat(capitalize(size))])
  }, endIconProp);
  return /*#__PURE__*/React$2.createElement(ButtonBase$1, _extends$3({
    className: clsx(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat(capitalize(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat(capitalize(size))], classes["size".concat(capitalize(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), /*#__PURE__*/React$2.createElement("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
process.env.NODE_ENV !== "production" ? Button.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the button.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, no elevation is used.
   */
  disableElevation: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,

  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string]),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['contained', 'outlined', 'text'])
} : void 0;
var Button$1 = withStyles(styles$x, {
  name: 'MuiButton'
})(Button);

var styles$w = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: _defineProperty({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};
var Toolbar = /*#__PURE__*/React$2.forwardRef(function Toolbar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "component", "disableGutters", "variant"]);

  return /*#__PURE__*/React$2.createElement(Component, _extends$3({
    className: clsx(classes.root, classes[variant], className, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Toolbar.propTypes = {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['regular', 'dense'])
} : void 0;
var Toolbar$1 = withStyles(styles$w, {
  name: 'MuiToolbar'
})(Toolbar);

var styles$v = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var DialogActions = /*#__PURE__*/React$2.forwardRef(function DialogActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties(props, ["disableSpacing", "classes", "className"]);

  return /*#__PURE__*/React$2.createElement("div", _extends$3({
    className: clsx(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
var DialogActions$1 = withStyles(styles$v, {
  name: 'MuiDialogActions'
})(DialogActions);

var styles$u = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      overflowY: 'auto',
      padding: '8px 24px',
      '&:first-child': {
        // dialog without title
        paddingTop: 20
      }
    },

    /* Styles applied to the root element if `dividers={true}`. */
    dividers: {
      padding: '16px 24px',
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }
  };
};
var DialogContent = /*#__PURE__*/React$2.forwardRef(function DialogContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$dividers = props.dividers,
      dividers = _props$dividers === void 0 ? false : _props$dividers,
      other = _objectWithoutProperties(props, ["classes", "className", "dividers"]);

  return /*#__PURE__*/React$2.createElement("div", _extends$3({
    className: clsx(classes.root, className, dividers && classes.dividers),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Display the top and bottom dividers.
   */
  dividers: PropTypes.bool
} : void 0;
var DialogContent$1 = withStyles(styles$u, {
  name: 'MuiDialogContent'
})(DialogContent);

// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function getScrollbarSize() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
}

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}

function isOverflowing(container) {
  var doc = ownerDocument(container);

  if (doc.body === container) {
    return ownerWindow(doc).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(node) {
  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}

function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : undefined;
  var blacklist = [mountNode, currentNode].concat(_toConsumableArray(nodesToExclude));
  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, function (node) {
    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}

function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var restorePaddings = [];
  var container = containerInfo.container;
  var fixedNodes;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      var scrollbarSize = getScrollbarSize();
      restoreStyle.push({
        value: container.style.paddingRight,
        key: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

      fixedNodes = ownerDocument(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedNodes, function (node) {
        restorePaddings.push(node.style.paddingRight);
        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
      });
    } // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


    var parent = container.parentElement;
    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    restoreStyle.push({
      value: scrollContainer.style.overflow,
      key: 'overflow',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  var restore = function restore() {
    if (fixedNodes) {
      [].forEach.call(fixedNodes, function (node, i) {
        if (restorePaddings[i]) {
          node.style.paddingRight = restorePaddings[i];
        } else {
          node.style.removeProperty('padding-right');
        }
      });
    }

    restoreStyle.forEach(function (_ref) {
      var value = _ref.value,
          el = _ref.el,
          key = _ref.key;

      if (value) {
        el.style.setProperty(key, value);
      } else {
        el.style.removeProperty(key);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (node) {
    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    _classCallCheck(this, ModalManager);

    // this.modals[modalIndex] = modal
    this.modals = []; // this.containers[containerIndex] = {
    //   modals: [],
    //   container,
    //   restore: null,
    // }

    this.containers = [];
  }

  _createClass(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex !== -1) {
        return modalIndex;
      }

      modalIndex = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }

      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });

      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }

      this.containers.push({
        modals: [modal],
        container: container,
        restore: null,
        hiddenSiblingNodes: hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];

      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex === -1) {
        return modalIndex;
      }

      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

      if (containerInfo.modals.length === 0) {
        // The modal might be closed before it had the chance to be mounted in the DOM.
        if (containerInfo.restore) {
          containerInfo.restore();
        }

        if (modal.modalRef) {
          // In case the modal wasn't in the DOM yet.
          ariaHidden(modal.modalRef, true);
        }

        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
        this.containers.splice(containerIndex, 1);
      } else {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }

      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);

  return ModalManager;
}();

/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */
/**
 * Utility component that locks focus inside the component.
 */

function Unstable_TrapFocus(props) {
  var children = props.children,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      getDoc = props.getDoc,
      isEnabled = props.isEnabled,
      open = props.open;
  var ignoreNextEnforceFocus = React$2.useRef();
  var sentinelStart = React$2.useRef(null);
  var sentinelEnd = React$2.useRef(null);
  var nodeToRestore = React$2.useRef();
  var rootRef = React$2.useRef(null); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = React$2.useCallback(function (instance) {
    // #StrictMode ready
    rootRef.current = ReactDOM.findDOMNode(instance);
  }, []);
  var handleRef = useForkRef(children.ref, handleOwnRef);
  var prevOpenRef = React$2.useRef();
  React$2.useEffect(function () {
    prevOpenRef.current = open;
  }, [open]);

  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
    // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
  }

  React$2.useEffect(function () {
    if (!open) {
      return;
    }

    var doc = ownerDocument(rootRef.current); // We might render an empty child.

    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(['Material-UI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
        }

        rootRef.current.setAttribute('tabIndex', -1);
      }

      rootRef.current.focus();
    }

    var contain = function contain() {
      var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
        rootRef.current.focus();
      }
    };

    var loopFocus = function loopFocus(event) {
      // 9 = Tab
      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
        return;
      } // Make sure the next tab starts from the right place.


      if (doc.activeElement === rootRef.current) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;

        if (event.shiftKey) {
          sentinelEnd.current.focus();
        } else {
          sentinelStart.current.focus();
        }
      }
    };

    doc.addEventListener('focus', contain, true);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    var interval = setInterval(function () {
      contain();
    }, 50);
    return function () {
      clearInterval(interval);
      doc.removeEventListener('focus', contain, true);
      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()

      if (!disableRestoreFocus) {
        // In IE 11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE 11 have a focus method.
        // Once IE 11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
  return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement("div", {
    tabIndex: 0,
    ref: sentinelStart,
    "data-test": "sentinelStart"
  }), /*#__PURE__*/React$2.cloneElement(children, {
    ref: handleRef
  }), /*#__PURE__*/React$2.createElement("div", {
    tabIndex: 0,
    ref: sentinelEnd,
    "data-test": "sentinelEnd"
  }));
}

process.env.NODE_ENV !== "production" ? Unstable_TrapFocus.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.node,

  /**
   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, the trap focus will not restore focus to previously focused element once
   * trap focus is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Return the document to consider.
   * We use it to implement the restore focus between different browser documents.
   */
  getDoc: PropTypes.func.isRequired,

  /**
   * Do we still want to enforce the focus?
   * This prop helps nesting TrapFocus elements.
   */
  isEnabled: PropTypes.func.isRequired,

  /**
   * If `true`, focus will be locked.
   */
  open: PropTypes.bool.isRequired
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  Unstable_TrapFocus['propTypes' + ''] = exactProp(Unstable_TrapFocus.propTypes);
}

var styles$t = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
/**
 * @ignore - internal component.
 */

var SimpleBackdrop = /*#__PURE__*/React$2.forwardRef(function SimpleBackdrop(props, ref) {
  var _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      other = _objectWithoutProperties(props, ["invisible", "open"]);

  return open ? /*#__PURE__*/React$2.createElement("div", _extends$3({
    "aria-hidden": true,
    ref: ref
  }, other, {
    style: _extends$3({}, styles$t.root, invisible ? styles$t.invisible : {}, other.style)
  })) : null;
});
process.env.NODE_ENV !== "production" ? SimpleBackdrop.propTypes = {
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
var SimpleBackdrop$1 = SimpleBackdrop;

function getContainer(container) {
  container = typeof container === 'function' ? container() : container;
  return ReactDOM.findDOMNode(container);
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


var defaultManager = new ModalManager();
var styles$s = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

var Modal = /*#__PURE__*/React$2.forwardRef(function Modal(inProps, ref) {
  var theme = useTheme$1();
  var props = getThemeProps({
    name: 'MuiModal',
    props: _extends$3({}, inProps),
    theme: theme
  });

  var _props$BackdropCompon = props.BackdropComponent,
      BackdropComponent = _props$BackdropCompon === void 0 ? SimpleBackdrop$1 : _props$BackdropCompon,
      BackdropProps = props.BackdropProps,
      children = props.children,
      _props$closeAfterTran = props.closeAfterTransition,
      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
      container = props.container,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      _props$disableScrollL = props.disableScrollLock,
      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
      _props$hideBackdrop = props.hideBackdrop,
      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      _props$manager = props.manager,
      manager = _props$manager === void 0 ? defaultManager : _props$manager,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onRendered = props.onRendered,
      open = props.open,
      other = _objectWithoutProperties(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);

  var _React$useState = React$2.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var modal = React$2.useRef({});
  var mountNodeRef = React$2.useRef(null);
  var modalRef = React$2.useRef(null);
  var handleRef = useForkRef(modalRef, ref);
  var hasTransition = getHasTransition(props);

  var getDoc = function getDoc() {
    return ownerDocument(mountNodeRef.current);
  };

  var getModal = function getModal() {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  var handleMounted = function handleMounted() {
    manager.mount(getModal(), {
      disableScrollLock: disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  var handleOpen = useEventCallback(function () {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = React$2.useCallback(function () {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = useEventCallback(function (node) {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (onRendered) {
      onRendered();
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      ariaHidden(modalRef.current, true);
    }
  });
  var handleClose = React$2.useCallback(function () {
    manager.remove(getModal());
  }, [manager]);
  React$2.useEffect(function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  React$2.useEffect(function () {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleExited = function handleExited() {
    setExited(true);

    if (closeAfterTransition) {
      handleClose();
    }
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (onEscapeKeyDown) {
      onEscapeKeyDown(event);
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  var inlineStyle = styles$s(theme || {
    zIndex: zIndex$1
  });
  var childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = children.props.tabIndex || '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = createChainedFunction(handleEnter, children.props.onEnter);
    childProps.onExited = createChainedFunction(handleExited, children.props.onExited);
  }

  return /*#__PURE__*/React$2.createElement(Portal$1, {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal
  }, /*#__PURE__*/React$2.createElement("div", _extends$3({
    ref: handleRef,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, other, {
    style: _extends$3({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
  }), hideBackdrop ? null : /*#__PURE__*/React$2.createElement(BackdropComponent, _extends$3({
    open: open,
    onClick: handleBackdropClick
  }, BackdropProps)), /*#__PURE__*/React$2.createElement(Unstable_TrapFocus, {
    disableEnforceFocus: disableEnforceFocus,
    disableAutoFocus: disableAutoFocus,
    disableRestoreFocus: disableRestoreFocus,
    getDoc: getDoc,
    isEnabled: isTopModal,
    open: open
  }, /*#__PURE__*/React$2.cloneElement(children, childProps))));
});
process.env.NODE_ENV !== "production" ? Modal.propTypes = {
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   */
  BackdropComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: PropTypes.object,

  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,

  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */
  closeAfterTransition: PropTypes.bool,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React$2.Component), PropTypes.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, clicking the backdrop will not fire `onClose`.
   */
  disableBackdropClick: deprecatedPropType(PropTypes.bool, 'Use the onClose prop with the `reason` argument to filter the `backdropClick` events.'),

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, hitting escape will not fire `onClose`.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Disable the scroll lock behavior.
   */
  disableScrollLock: PropTypes.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: PropTypes.bool,

  /**
   * @ignore
   */
  manager: PropTypes.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: deprecatedPropType(PropTypes.func, 'Use the onClose prop with the `reason` argument to handle the `backdropClick` events.'),

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: deprecatedPropType(PropTypes.func, 'Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.'),

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` prop took effect.
   *
   * This prop will be removed in v5, the ref can be used instead.
   */
  onRendered: deprecatedPropType(PropTypes.func, 'Use the ref instead.'),

  /**
   * If `true`, the modal is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
var Modal$1 = Modal;

var styles$r = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout = {
  enter: duration.enteringScreen,
  exit: duration.leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade = /*#__PURE__*/React$2.forwardRef(function Fade(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Transition$1 : _props$TransitionComp,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = _objectWithoutProperties(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);

  var theme = useTheme();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = React$2.useRef(null);
  var foreignRef = useForkRef(children.ref, ref);
  var handleRef = useForkRef(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = _slicedToArray(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    reflow(node); // So the animation always start from the start.

    var transitionProps = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/React$2.createElement(TransitionComponent, _extends$3({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/React$2.cloneElement(children, _extends$3({
      style: _extends$3({
        opacity: 0,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles$r[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
process.env.NODE_ENV !== "production" ? Fade.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
var Fade$1 = Fade;

var styles$q = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
var Backdrop = /*#__PURE__*/React$2.forwardRef(function Backdrop(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Fade$1 : _props$TransitionComp,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);

  return /*#__PURE__*/React$2.createElement(TransitionComponent, _extends$3({
    in: open,
    timeout: transitionDuration
  }, other), /*#__PURE__*/React$2.createElement("div", {
    className: clsx(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref: ref
  }, children));
});
process.env.NODE_ENV !== "production" ? Backdrop.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
var Backdrop$1 = withStyles(styles$q, {
  name: 'MuiBackdrop'
})(Backdrop);

var styles$p = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return _extends$3({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = /*#__PURE__*/React$2.forwardRef(function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/React$2.createElement(Component, _extends$3({
    className: clsx(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Paper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: chainPropTypes(PropTypes.number, function (props) {
    var classes = props.classes,
        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning

    if (classes === undefined) {
      return null;
    }

    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
    }

    return null;
  }),

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['elevation', 'outlined'])
} : void 0;
var Paper$1 = withStyles(styles$p, {
  name: 'MuiPaper'
})(Paper);

var styles$o = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
      }
    },

    /* Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the container element if `scroll="body"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden',
      textAlign: 'center',
      '&:after': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0'
      }
    },

    /* Styles applied to the container element. */
    container: {
      height: '100%',
      '@media print': {
        height: 'auto'
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      margin: 32,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE 11 issue, to remove at some point.
      '@media print': {
        overflowY: 'visible',
        boxShadow: 'none'
      }
    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'left' // 'initial' doesn't work on IE 11

    },

    /* Styles applied to the `Paper` component if `maxWidth=false`. */
    paperWidthFalse: {
      maxWidth: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
      '&$paperScrollBody': _defineProperty({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': _defineProperty({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': _defineProperty({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': _defineProperty({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      '&$paperScrollBody': _defineProperty({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0,
        maxWidth: '100%'
      }
    }
  };
};
var defaultTransitionDuration = {
  enter: duration.enteringScreen,
  exit: duration.leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

var Dialog = /*#__PURE__*/React$2.forwardRef(function Dialog(props, ref) {
  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? Paper$1 : _props$PaperComponent,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$scroll = props.scroll,
      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Fade$1 : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      ariaDescribedby = props['aria-describedby'],
      ariaLabelledby = props['aria-labelledby'],
      other = _objectWithoutProperties(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);

  var mouseDownTarget = React$2.useRef();

  var handleMouseDown = function handleMouseDown(event) {
    mouseDownTarget.current = event.target;
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    // Ignore the events not coming from the "backdrop"
    // We don't want to close the dialog when clicking the dialog content.
    if (event.target !== event.currentTarget) {
      return;
    } // Make sure the event starts and ends on the same DOM element.


    if (event.target !== mouseDownTarget.current) {
      return;
    }

    mouseDownTarget.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  return /*#__PURE__*/React$2.createElement(Modal$1, _extends$3({
    className: clsx(classes.root, className),
    BackdropComponent: Backdrop$1,
    BackdropProps: _extends$3({
      transitionDuration: transitionDuration
    }, BackdropProps),
    closeAfterTransition: true
  }, disableBackdropClick ? {
    disableBackdropClick: disableBackdropClick
  } : {}, {
    disableEscapeKeyDown: disableEscapeKeyDown,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref
  }, other), /*#__PURE__*/React$2.createElement(TransitionComponent, _extends$3({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    role: "none presentation"
  }, TransitionProps), /*#__PURE__*/React$2.createElement("div", {
    className: clsx(classes.container, classes["scroll".concat(capitalize(scroll))]),
    onMouseUp: handleBackdropClick,
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/React$2.createElement(PaperComponent, _extends$3({
    elevation: 24,
    role: "dialog",
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby
  }, PaperProps, {
    className: clsx(classes.paper, classes["paperScroll".concat(capitalize(scroll))], classes["paperWidth".concat(capitalize(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
  }), children))));
});
process.env.NODE_ENV !== "production" ? Dialog.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  'aria-describedby': PropTypes.string,

  /**
   * The id(s) of the element(s) that label the dialog.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   * @deprecated Use the onClose prop with the `reason` argument to filter the `backdropClick` events.
   */
  disableBackdropClick: deprecatedPropType(PropTypes.bool, 'Use the onClose prop with the `reason` argument to filter the `backdropClick` events.'),

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: PropTypes.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   */
  fullWidth: PropTypes.bool,

  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),

  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the onClose prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: deprecatedPropType(PropTypes.func, 'Use the onClose prop with the `reason` argument to handle the `backdropClick` events.'),

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the dialog enters.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the dialog has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the dialog is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   * @deprecated Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.
   */
  onEscapeKeyDown: deprecatedPropType(PropTypes.func, 'Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.'),

  /**
   * Callback fired before the dialog exits.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the dialog has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the dialog is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * If `true`, the Dialog is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The component used to render the body of the dialog.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes.object,

  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: PropTypes.oneOf(['body', 'paper']),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
var Dialog$1 = withStyles(styles$o, {
  name: 'MuiDialog'
})(Dialog);

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentElement;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles$n = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Popover = /*#__PURE__*/React$2.forwardRef(function Popover(props, ref) {
  var action = props.action,
      anchorEl = props.anchorEl,
      _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$anchorOrigin,
      anchorPosition = props.anchorPosition,
      _props$anchorReferenc = props.anchorReference,
      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
      children = props.children,
      classes = props.classes,
      className = props.className,
      containerProp = props.container,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
      getContentAnchorEl = props.getContentAnchorEl,
      _props$marginThreshol = props.marginThreshold,
      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$transformOrigi = props.transformOrigin,
      transformOrigin = _props$transformOrigi === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$transformOrigi,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Grow$1 : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps,
      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
      other = _objectWithoutProperties(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var paperRef = React$2.useRef(); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  var getAnchorOffset = React$2.useCallback(function (contentAnchorOffset) {
    if (anchorReference === 'anchorPosition') {
      if (process.env.NODE_ENV !== 'production') {
        if (!anchorPosition) {
          console.error('Material-UI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }

      return anchorPosition;
    }

    var resolvedAnchorEl = getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : ownerDocument(paperRef.current).body;
    var anchorRect = anchorElement.getBoundingClientRect();

    if (process.env.NODE_ENV !== 'production') {
      var box = anchorElement.getBoundingClientRect();

      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }

    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided

  var getContentAnchorOffset = React$2.useCallback(function (element) {
    var contentAnchorOffset = 0;

    if (getContentAnchorEl && anchorReference === 'anchorEl') {
      var contentAnchorEl = getContentAnchorEl(element);

      if (contentAnchorEl && element.contains(contentAnchorEl)) {
        var scrollTop = getScrollParent(element, contentAnchorEl);
        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
      } // != the default value


      if (process.env.NODE_ENV !== 'production') {
        if (anchorOrigin.vertical !== 'top') {
          console.error(['Material-UI: You can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
        }
      }
    }

    return contentAnchorOffset;
  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
  // and taking the content anchor offset into account if in use

  var getTransformOrigin = React$2.useCallback(function (elemRect) {
    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = React$2.useCallback(function (element) {
    // Check if the parent has requested anchoring on an inner content node
    var contentAnchorOffset = getContentAnchorOffset(element);
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of of the anchoring element


    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning

    var top = anchorOffset.top - elemTransformOrigin.vertical;
    var left = anchorOffset.left - elemTransformOrigin.horizontal;
    var bottom = top + elemRect.height;
    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    var containerWindow = ownerWindow(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

    var heightThreshold = containerWindow.innerHeight - marginThreshold;
    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      var diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      var _diff = bottom - heightThreshold;

      top -= _diff;
      elemTransformOrigin.vertical += _diff;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['Material-UI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    } // Check if the horizontal axis needs shifting


    if (left < marginThreshold) {
      var _diff2 = left - marginThreshold;

      left -= _diff2;
      elemTransformOrigin.horizontal += _diff2;
    } else if (right > widthThreshold) {
      var _diff3 = right - widthThreshold;

      left -= _diff3;
      elemTransformOrigin.horizontal += _diff3;
    }

    return {
      top: "".concat(Math.round(top), "px"),
      left: "".concat(Math.round(left), "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
  var setPositioningStyles = React$2.useCallback(function () {
    var element = paperRef.current;

    if (!element) {
      return;
    }

    var positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  var handleEntering = function handleEntering(element, isAppearing) {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles();
  };

  var handlePaperRef = React$2.useCallback(function (instance) {
    // #StrictMode ready
    paperRef.current = ReactDOM.findDOMNode(instance);
  }, []);
  React$2.useEffect(function () {
    if (open) {
      setPositioningStyles();
    }
  });
  React$2.useImperativeHandle(action, function () {
    return open ? {
      updatePosition: function updatePosition() {
        setPositioningStyles();
      }
    } : null;
  }, [open, setPositioningStyles]);
  React$2.useEffect(function () {
    if (!open) {
      return undefined;
    }

    var handleResize = debounce(function () {
      setPositioningStyles();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [open, setPositioningStyles]);
  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  var container = containerProp || (anchorEl ? ownerDocument(getAnchorEl(anchorEl)).body : undefined);
  return /*#__PURE__*/React$2.createElement(Modal$1, _extends$3({
    container: container,
    open: open,
    ref: ref,
    BackdropProps: {
      invisible: true
    },
    className: clsx(classes.root, className)
  }, other), /*#__PURE__*/React$2.createElement(TransitionComponent, _extends$3({
    appear: true,
    in: open,
    onEnter: onEnter,
    onEntered: onEntered,
    onExit: onExit,
    onExited: onExited,
    onExiting: onExiting,
    timeout: transitionDuration
  }, TransitionProps, {
    onEntering: createChainedFunction(handleEntering, TransitionProps.onEntering)
  }), /*#__PURE__*/React$2.createElement(Paper$1, _extends$3({
    elevation: elevation,
    ref: handlePaperRef
  }, PaperProps, {
    className: clsx(classes.paper, PaperProps.className)
  }), children)));
});
process.env.NODE_ENV !== "production" ? Popover.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType$1,

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), function (props) {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
      }
    }

    return null;
  }),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),

  /**
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React$2.Component), PropTypes.func]),

  /**
   * The elevation of the popover.
   */
  elevation: PropTypes.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` prop.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: PropTypes.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired before the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * If `true`, the popover is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes
  /* @typescript-to-proptypes-ignore */
  .shape({
    component: elementTypeAcceptingRef$1
  }),

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
var Popover$1 = withStyles(styles$n, {
  name: 'MuiPopover'
})(Popover);

/** Use it instead of .includes method for IE support */
function arrayIncludes(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(function (item) {
      return array.indexOf(item) !== -1;
    });
  }

  return array.indexOf(itemOrItems) !== -1;
}

var DIALOG_WIDTH = 310;
var DIALOG_WIDTH_WIDER = 325;
var VIEW_HEIGHT = 305;

var useStyles$8 = makeStyles(function (theme) {
  return {
    staticWrapperRoot: {
      overflow: 'hidden',
      minWidth: DIALOG_WIDTH,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.paper
    }
  };
}, {
  name: 'MuiPickersStaticWrapper'
});
var StaticWrapper = function StaticWrapper(_ref) {
  var children = _ref.children;
  var classes = useStyles$8();
  return createElement("div", {
    className: classes.staticWrapperRoot,
    children: children
  });
};

var ModalDialog = function ModalDialog(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      onAccept = _ref.onAccept,
      onDismiss = _ref.onDismiss,
      onClear = _ref.onClear,
      onSetToday = _ref.onSetToday,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      clearable = _ref.clearable,
      showTodayButton = _ref.showTodayButton;
      _ref.showTabs;
      var wider = _ref.wider,
      other = _objectWithoutProperties(_ref, ["children", "classes", "onAccept", "onDismiss", "onClear", "onSetToday", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "clearable", "showTodayButton", "showTabs", "wider"]);

  return createElement(Dialog$1, _extends$3({
    role: "dialog",
    onClose: onDismiss,
    classes: {
      paper: clsx(classes.dialogRoot, wider && classes.dialogRootWider)
    }
  }, other), createElement(DialogContent$1, {
    children: children,
    className: classes.dialog
  }), createElement(DialogActions$1, {
    classes: {
      root: clsx((clearable || showTodayButton) && classes.withAdditionalAction)
    }
  }, clearable && createElement(Button$1, {
    color: "primary",
    onClick: onClear
  }, clearLabel), showTodayButton && createElement(Button$1, {
    color: "primary",
    onClick: onSetToday
  }, todayLabel), cancelLabel && createElement(Button$1, {
    color: "primary",
    onClick: onDismiss
  }, cancelLabel), okLabel && createElement(Button$1, {
    color: "primary",
    onClick: onAccept
  }, okLabel)));
};
ModalDialog.displayName = 'ModalDialog';
var styles$m = createStyles({
  dialogRoot: {
    minWidth: DIALOG_WIDTH
  },
  dialogRootWider: {
    minWidth: DIALOG_WIDTH_WIDER
  },
  dialog: {
    '&:first-child': {
      padding: 0
    }
  },
  withAdditionalAction: {
    // set justifyContent to default value to fix IE11 layout bug
    // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
    justifyContent: 'flex-start',
    '& > *:first-child': {
      marginRight: 'auto'
    }
  }
});
var ModalDialog$1 = withStyles(styles$m, {
  name: 'MuiPickersModal'
})(ModalDialog);

var useIsomorphicEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
function runKeyHandler(e, keyHandlers) {
  var handler = keyHandlers[e.key];

  if (handler) {
    handler(); // if event was handled prevent other side effects (e.g. page scroll)

    e.preventDefault();
  }
}
function useKeyDown(active, keyHandlers) {
  var keyHandlersRef = useRef(keyHandlers);
  keyHandlersRef.current = keyHandlers;
  useIsomorphicEffect(function () {
    if (active) {
      var handleKeyDown = function handleKeyDown(event) {
        runKeyHandler(event, keyHandlersRef.current);
      };

      window.addEventListener('keydown', handleKeyDown);
      return function () {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [active]);
}

var ModalWrapper = function ModalWrapper(_ref) {
  var open = _ref.open,
      children = _ref.children,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      showTodayButton = _ref.showTodayButton,
      clearable = _ref.clearable,
      DialogProps = _ref.DialogProps,
      showTabs = _ref.showTabs,
      wider = _ref.wider,
      InputComponent = _ref.InputComponent,
      DateInputProps = _ref.DateInputProps,
      onClear = _ref.onClear,
      onAccept = _ref.onAccept,
      onDismiss = _ref.onDismiss,
      onSetToday = _ref.onSetToday,
      other = _objectWithoutProperties(_ref, ["open", "children", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "showTodayButton", "clearable", "DialogProps", "showTabs", "wider", "InputComponent", "DateInputProps", "onClear", "onAccept", "onDismiss", "onSetToday"]);

  useKeyDown(open, {
    Enter: onAccept
  });
  return createElement(Fragment, null, createElement(InputComponent, _extends$3({}, other, DateInputProps)), createElement(ModalDialog$1, _extends$3({
    wider: wider,
    showTabs: showTabs,
    open: open,
    onClear: onClear,
    onAccept: onAccept,
    onDismiss: onDismiss,
    onSetToday: onSetToday,
    clearLabel: clearLabel,
    todayLabel: todayLabel,
    okLabel: okLabel,
    cancelLabel: cancelLabel,
    clearable: clearable,
    showTodayButton: showTodayButton,
    children: children
  }, DialogProps)));
};
process.env.NODE_ENV !== "production" ? ModalWrapper.propTypes = {
  okLabel: propTypes_7,
  cancelLabel: propTypes_7,
  clearLabel: propTypes_7,
  clearable: propTypes_8,
  todayLabel: propTypes_7,
  showTodayButton: propTypes_8,
  DialogProps: propTypes_3
} : void 0;
ModalWrapper.defaultProps = {
  okLabel: 'OK',
  cancelLabel: 'Cancel',
  clearLabel: 'Clear',
  todayLabel: 'Today',
  clearable: false,
  showTodayButton: false
};

var InlineWrapper = function InlineWrapper(_ref) {
  var open = _ref.open;
      _ref.wider;
      var children = _ref.children,
      PopoverProps = _ref.PopoverProps;
      _ref.onClear;
      var onDismiss = _ref.onDismiss;
      _ref.onSetToday;
      var onAccept = _ref.onAccept;
      _ref.showTabs;
      var DateInputProps = _ref.DateInputProps,
      InputComponent = _ref.InputComponent,
      other = _objectWithoutProperties(_ref, ["open", "wider", "children", "PopoverProps", "onClear", "onDismiss", "onSetToday", "onAccept", "showTabs", "DateInputProps", "InputComponent"]);

  var ref = useRef();
  useKeyDown(open, {
    Enter: onAccept
  });
  return createElement(Fragment, null, createElement(InputComponent, _extends$3({}, other, DateInputProps, {
    inputRef: ref
  })), createElement(Popover$1, _extends$3({
    open: open,
    onClose: onDismiss,
    anchorEl: ref.current,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    children: children
  }, PopoverProps)));
};
process.env.NODE_ENV !== "production" ? InlineWrapper.propTypes = {
  onOpen: propTypes_1,
  onClose: propTypes_1,
  PopoverProps: propTypes_3
} : void 0;

function getWrapperFromVariant(variant) {
  switch (variant) {
    case 'inline':
      return InlineWrapper;

    case 'static':
      return StaticWrapper;

    default:
      return ModalWrapper;
  }
}
var VariantContext = createContext(null);
var Wrapper = function Wrapper(_ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["variant"]);

  var Component = getWrapperFromVariant(variant);
  return createElement(VariantContext.Provider, {
    value: variant || 'dialog'
  }, createElement(Component, props));
};

function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}

/**
 * @ignore - internal component.
 */

var FormControlContext = React$2.createContext();

if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}

function useFormControl$1() {
  return React$2.useContext(FormControlContext);
}
var FormControlContext$1 = FormControlContext;

function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

var useEnhancedEffect$2 = typeof window !== 'undefined' ? React$2.useLayoutEffect : React$2.useEffect;
var styles$l = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
var TextareaAutosize = /*#__PURE__*/React$2.forwardRef(function TextareaAutosize(props, ref) {
  var onChange = props.onChange,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMinProp = props.rowsMin,
      maxRowsProp = props.maxRows,
      _props$minRows = props.minRows,
      minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows,
      style = props.style,
      value = props.value,
      other = _objectWithoutProperties(props, ["onChange", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "style", "value"]);

  var maxRows = maxRowsProp || rowsMax;
  var minRows = rows || rowsMinProp || minRowsProp;

  var _React$useRef = React$2.useRef(value != null),
      isControlled = _React$useRef.current;

  var inputRef = React$2.useRef(null);
  var handleRef = useForkRef(ref, inputRef);
  var shadowRef = React$2.useRef(null);
  var renders = React$2.useRef(0);

  var _React$useState = React$2.useState({}),
      state = _React$useState[0],
      setState = _React$useState[1];

  var syncHeight = React$2.useCallback(function () {
    var input = inputRef.current;
    var computedStyle = window.getComputedStyle(input);
    var inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    var boxSizing = computedStyle['box-sizing'];
    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content

    var outerHeight = innerHeight;

    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }

    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(function (prevState) {
      // Need a large enough difference to update the height.
      // This prevents infinite rendering loop.
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow: overflow,
          outerHeightStyle: outerHeightStyle
        };
      }

      if (process.env.NODE_ENV !== 'production') {
        if (renders.current === 20) {
          console.error(['Material-UI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
        }
      }

      return prevState;
    });
  }, [maxRows, minRows, props.placeholder]);
  React$2.useEffect(function () {
    var handleResize = debounce(function () {
      renders.current = 0;
      syncHeight();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [syncHeight]);
  useEnhancedEffect$2(function () {
    syncHeight();
  });
  React$2.useEffect(function () {
    renders.current = 0;
  }, [value]);

  var handleChange = function handleChange(event) {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement("textarea", _extends$3({
    value: value,
    onChange: handleChange,
    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
    ,
    rows: minRows,
    style: _extends$3({
      height: state.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: state.overflow ? 'hidden' : null
    }, style)
  }, other)), /*#__PURE__*/React$2.createElement("textarea", {
    "aria-hidden": true,
    className: props.className,
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    style: _extends$3({}, styles$l.shadow, style)
  }));
});
process.env.NODE_ENV !== "production" ? TextareaAutosize.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  placeholder: PropTypes.string,

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rows: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Use `minRows` instead.'),

  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Use `maxRows` instead.'),

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rowsMin: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Use `minRows` instead.'),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
} : void 0;
var TextareaAutosize$1 = TextareaAutosize;

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.

function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.

function isAdornedStart(obj) {
  return obj.startAdornment;
}

var styles$k = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: '0 !important'
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    '@global': {
      '@keyframes mui-auto-fill': {},
      '@keyframes mui-auto-fill-cancel': {}
    },

    /* Styles applied to the root element. */
    root: _extends$3({}, theme.typography.body1, {
      color: theme.palette.text.primary,
      lineHeight: '1.1876em',
      // Reset (19px), match the native input line-height
      boxSizing: 'border-box',
      // Prevent padding issue with fullWidth.
      position: 'relative',
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default'
      }
    }),

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      '&$marginDense': {
        paddingTop: 4 - 1
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      letterSpacing: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      height: '1.1876em',
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      animationName: 'mui-auto-fill-cancel',
      animationDuration: '10ms',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      },
      '&:-webkit-autofill': {
        animationDuration: '5000s',
        animationName: 'mui-auto-fill'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      height: 'auto',
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {},

    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
    inputHiddenLabel: {}
  };
};
var useEnhancedEffect$1 = typeof window === 'undefined' ? React$2.useEffect : React$2.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */

var InputBase = /*#__PURE__*/React$2.forwardRef(function InputBase(props, ref) {
  var ariaDescribedby = props['aria-describedby'],
      autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      classes = props.classes,
      className = props.className;
      props.color;
      var defaultValue = props.defaultValue,
      disabled = props.disabled,
      endAdornment = props.endAdornment;
      props.error;
      var _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      id = props.id,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$inputProps = props.inputProps,
      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
      inputRefProp = props.inputRef;
      props.margin;
      var _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      renderSuffix = props.renderSuffix,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMin = props.rowsMin,
      maxRows = props.maxRows,
      minRows = props.minRows,
      startAdornment = props.startAdornment,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      valueProp = props.value,
      other = _objectWithoutProperties(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "startAdornment", "type", "value"]);

  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;

  var _React$useRef = React$2.useRef(value != null),
      isControlled = _React$useRef.current;

  var inputRef = React$2.useRef();
  var handleInputRefWarning = React$2.useCallback(function (instance) {
    if (process.env.NODE_ENV !== 'production') {
      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
        console.error(['Material-UI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  var handleInputPropsRefProp = useForkRef(inputPropsProp.ref, handleInputRefWarning);
  var handleInputRefProp = useForkRef(inputRefProp, handleInputPropsRefProp);
  var handleInputRef = useForkRef(inputRef, handleInputRefProp);

  var _React$useState = React$2.useState(false),
      focused = _React$useState[0],
      setFocused = _React$useState[1];

  var muiFormControl = useFormControl$1();

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$2.useEffect(function () {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }

      return undefined;
    }, [muiFormControl]);
  }

  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.

  React$2.useEffect(function () {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);

      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  var onFilled = muiFormControl && muiFormControl.onFilled;
  var onEmpty = muiFormControl && muiFormControl.onEmpty;
  var checkDirty = React$2.useCallback(function (obj) {
    if (isFilled(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect$1(function () {
    if (isControlled) {
      checkDirty({
        value: value
      });
    }
  }, [value, checkDirty, isControlled]);

  var handleFocus = function handleFocus(event) {
    // Fix a bug with IE 11 where the focus/blur events are triggered
    // while the input is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }

    if (onFocus) {
      onFocus(event);
    }

    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      var element = event.target || inputRef.current;

      if (element == null) {
        throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://material-ui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage(1));
      }

      checkDirty({
        value: element.value
      });
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (inputPropsProp.onChange) {
      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
    } // Perform in the willUpdate


    if (onChange) {
      onChange.apply(void 0, [event].concat(args));
    }
  }; // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).


  React$2.useEffect(function () {
    checkDirty(inputRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleClick = function handleClick(event) {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }

    if (onClick) {
      onClick(event);
    }
  };

  var InputComponent = inputComponent;

  var inputProps = _extends$3({}, inputPropsProp, {
    ref: handleInputRef
  });

  if (typeof InputComponent !== 'string') {
    inputProps = _extends$3({
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      type: type
    }, inputProps, {
      ref: null
    });
  } else if (multiline) {
    if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) {
      InputComponent = 'textarea';
    } else {
      inputProps = _extends$3({
        minRows: rows || minRows,
        rowsMax: rowsMax,
        maxRows: maxRows
      }, inputProps);
      InputComponent = TextareaAutosize$1;
    }
  } else {
    inputProps = _extends$3({
      type: type
    }, inputProps);
  }

  var handleAutoFill = function handleAutoFill(event) {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };

  React$2.useEffect(function () {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  return /*#__PURE__*/React$2.createElement("div", _extends$3({
    className: clsx(classes.root, classes["color".concat(capitalize(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
    onClick: handleClick,
    ref: ref
  }, other), startAdornment, /*#__PURE__*/React$2.createElement(FormControlContext$1.Provider, {
    value: null
  }, /*#__PURE__*/React$2.createElement(InputComponent, _extends$3({
    "aria-invalid": fcs.error,
    "aria-describedby": ariaDescribedby,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: fcs.disabled,
    id: id,
    onAnimationStart: handleAutoFill,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    required: fcs.required,
    rows: rows,
    value: value,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }, inputProps, {
    className: clsx(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }))), endAdornment, renderSuffix ? renderSuffix(_extends$3({}, fcs, {
    startAdornment: startAdornment
  })) : null);
});
process.env.NODE_ENV !== "production" ? InputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  'aria-describedby': PropTypes.string,

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the input is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rowsMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
var InputBase$1 = withStyles(styles$k, {
  name: 'MuiInputBase'
})(InputBase);

var styles$j = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},

    /* Styles applied to the `input` element. */
    input: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};
var Input = /*#__PURE__*/React$2.forwardRef(function Input(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = _objectWithoutProperties(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/React$2.createElement(InputBase$1, _extends$3({
    classes: _extends$3({}, classes, {
      root: clsx(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
process.env.NODE_ENV !== "production" ? Input.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
Input.muiName = 'Input';
var Input$1 = withStyles(styles$j, {
  name: 'MuiInput'
})(Input);

var styles$i = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      },
      '&$focused': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
      },
      '&$disabled': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
      }
    },

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:before': {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '27px 12px 10px',
      '&$marginDense': {
        paddingTop: 23,
        paddingBottom: 6
      }
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '27px 12px 10px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },

    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      '&$inputMarginDense': {
        paddingTop: 10,
        paddingBottom: 11
      }
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var FilledInput = /*#__PURE__*/React$2.forwardRef(function FilledInput(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = _objectWithoutProperties(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/React$2.createElement(InputBase$1, _extends$3({
    classes: _extends$3({}, classes, {
      root: clsx(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
process.env.NODE_ENV !== "production" ? FilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
FilledInput.muiName = 'Input';
var FilledInput$1 = withStyles(styles$i, {
  name: 'MuiFilledInput'
})(FilledInput);

var styles$h = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: '0 8px',
      pointerEvents: 'none',
      borderRadius: 'inherit',
      borderStyle: 'solid',
      borderWidth: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the legend element when `labelWidth` is provided. */
    legend: {
      textAlign: 'left',
      padding: 0,
      lineHeight: '11px',
      // sync with `height` in `legend` styles
      transition: theme.transitions.create('width', {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the legend element. */
    legendLabelled: {
      display: 'block',
      width: 'auto',
      textAlign: 'left',
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: '0.75em',
      visibility: 'hidden',
      maxWidth: 0.01,
      transition: theme.transitions.create('max-width', {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      '& > span': {
        paddingLeft: 5,
        paddingRight: 5,
        display: 'inline-block'
      }
    },

    /* Styles applied to the legend element is notched. */
    legendNotched: {
      maxWidth: 1000,
      transition: theme.transitions.create('max-width', {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  };
};
/**
 * @ignore - internal component.
 */

var NotchedOutline = /*#__PURE__*/React$2.forwardRef(function NotchedOutline(props, ref) {
  props.children;
      var classes = props.classes,
      className = props.className,
      label = props.label,
      labelWidthProp = props.labelWidth,
      notched = props.notched,
      style = props.style,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);

  var theme = useTheme();
  var align = theme.direction === 'rtl' ? 'right' : 'left';

  if (label !== undefined) {
    return /*#__PURE__*/React$2.createElement("fieldset", _extends$3({
      "aria-hidden": true,
      className: clsx(classes.root, className),
      ref: ref,
      style: style
    }, other), /*#__PURE__*/React$2.createElement("legend", {
      className: clsx(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/React$2.createElement("span", null, label) : /*#__PURE__*/React$2.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: '&#8203;'
      }
    })));
  }

  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
  return /*#__PURE__*/React$2.createElement("fieldset", _extends$3({
    "aria-hidden": true,
    style: _extends$3(_defineProperty({}, "padding".concat(capitalize(align)), 8), style),
    className: clsx(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/React$2.createElement("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, /*#__PURE__*/React$2.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  })));
});
process.env.NODE_ENV !== "production" ? NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The label.
   */
  label: PropTypes.node,

  /**
   * The width of the label.
   */
  labelWidth: PropTypes.number.isRequired,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
var NotchedOutline$1 = withStyles(styles$h, {
  name: 'PrivateNotchedOutline'
})(NotchedOutline);

var styles$g = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        '&:hover $notchedOutline': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '18.5px 14px',
      '&$marginDense': {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },

    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor: borderColor
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '18.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var OutlinedInput = /*#__PURE__*/React$2.forwardRef(function OutlinedInput(props, ref) {
  var classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      label = props.label,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      notched = props.notched,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = _objectWithoutProperties(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);

  return /*#__PURE__*/React$2.createElement(InputBase$1, _extends$3({
    renderSuffix: function renderSuffix(state) {
      return /*#__PURE__*/React$2.createElement(NotchedOutline$1, {
        className: classes.notchedOutline,
        label: label,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: _extends$3({}, classes, {
      root: clsx(classes.root, classes.underline),
      notchedOutline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
process.env.NODE_ENV !== "production" ? OutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * The label of the input. It is only used for layout. The actual labelling
   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
   */
  label: PropTypes.node,

  /**
   * The width of the label. Is ignored if `label` is provided. Prefer `label`
   * if the input label appears with a strike through.
   */
  labelWidth: PropTypes.number,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
OutlinedInput.muiName = 'Input';
var OutlinedInput$1 = withStyles(styles$g, {
  name: 'MuiOutlinedInput'
})(OutlinedInput);

function useFormControl() {
  return React$2.useContext(FormControlContext$1);
}

var styles$f = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends$3({
      color: theme.palette.text.secondary
    }, theme.typography.body1, {
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused': {
        color: theme.palette.secondary.main
      }
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Styles applied to the asterisk element. */
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};
var FormLabel = /*#__PURE__*/React$2.forwardRef(function FormLabel(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className;
      props.color;
      var _props$component = props.component,
      Component = _props$component === void 0 ? 'label' : _props$component;
      props.disabled;
      props.error;
      props.filled;
      props.focused;
      props.required;
      var other = _objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);

  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  return /*#__PURE__*/React$2.createElement(Component, _extends$3({
    className: clsx(classes.root, classes["color".concat(capitalize(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
    ref: ref
  }, other), children, fcs.required && /*#__PURE__*/React$2.createElement("span", {
    "aria-hidden": true,
    className: clsx(classes.asterisk, fcs.error && classes.error)
  }, "\u2009", '*'));
});
process.env.NODE_ENV !== "production" ? FormLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool
} : void 0;
var FormLabel$1 = withStyles(styles$f, {
  name: 'MuiFormLabel'
})(FormLabel);

var styles$e = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      transformOrigin: 'top left'
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Pseudo-class applied to the asterisk element. */
    asterisk: {},

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(12px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(12px, 17px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(12px, 10px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(12px, 7px) scale(0.75)'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(14px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(14px, 12px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(14px, -6px) scale(0.75)'
      }
    }
  };
};
var InputLabel = /*#__PURE__*/React$2.forwardRef(function InputLabel(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableAnimati = props.disableAnimation,
      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati;
      props.margin;
      var shrinkProp = props.shrink;
      props.variant;
      var other = _objectWithoutProperties(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);

  var muiFormControl = useFormControl();
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['margin', 'variant']
  });
  return /*#__PURE__*/React$2.createElement(FormLabel$1, _extends$3({
    "data-shrink": shrink,
    className: clsx(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
      'filled': classes.filled,
      'outlined': classes.outlined
    }[fcs.variant]),
    classes: {
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required,
      asterisk: classes.asterisk
    },
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? InputLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The contents of the `InputLabel`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: PropTypes.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var InputLabel$1 = withStyles(styles$e, {
  name: 'MuiInputLabel'
})(InputLabel);

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/React$2.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

var styles$d = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.

  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */

var FormControl = /*#__PURE__*/React$2.forwardRef(function FormControl(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      visuallyFocused = props.focused,
      _props$hiddenLabel = props.hiddenLabel,
      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? 'none' : _props$margin,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      size = props.size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);

  var _React$useState = React$2.useState(function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialAdornedStart = false;

    if (children) {
      React$2.Children.forEach(children, function (child) {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }

        var input = isMuiElement(child, ['Select']) ? child.props.input : child;

        if (input && isAdornedStart(input.props)) {
          initialAdornedStart = true;
        }
      });
    }

    return initialAdornedStart;
  }),
      adornedStart = _React$useState[0],
      setAdornedStart = _React$useState[1];

  var _React$useState2 = React$2.useState(function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialFilled = false;

    if (children) {
      React$2.Children.forEach(children, function (child) {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }

        if (isFilled(child.props, true)) {
          initialFilled = true;
        }
      });
    }

    return initialFilled;
  }),
      filled = _React$useState2[0],
      setFilled = _React$useState2[1];

  var _React$useState3 = React$2.useState(false),
      _focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;

  if (disabled && focused) {
    setFocused(false);
  }

  var registerEffect;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var registeredInput = React$2.useRef(false);

    registerEffect = function registerEffect() {
      if (registeredInput.current) {
        console.error(['Material-UI: There are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
      }

      registeredInput.current = true;
      return function () {
        registeredInput.current = false;
      };
    };
  }

  var onFilled = React$2.useCallback(function () {
    setFilled(true);
  }, []);
  var onEmpty = React$2.useCallback(function () {
    setFilled(false);
  }, []);
  var childContext = {
    adornedStart: adornedStart,
    setAdornedStart: setAdornedStart,
    color: color,
    disabled: disabled,
    error: error,
    filled: filled,
    focused: focused,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    margin: (size === 'small' ? 'dense' : undefined) || margin,
    onBlur: function onBlur() {
      setFocused(false);
    },
    onEmpty: onEmpty,
    onFilled: onFilled,
    onFocus: function onFocus() {
      setFocused(true);
    },
    registerEffect: registerEffect,
    required: required,
    variant: variant
  };
  return /*#__PURE__*/React$2.createElement(FormControlContext$1.Provider, {
    value: childContext
  }, /*#__PURE__*/React$2.createElement(Component, _extends$3({
    className: clsx(classes.root, className, margin !== 'none' && classes["margin".concat(capitalize(margin))], fullWidth && classes.fullWidth),
    ref: ref
  }, other), children));
});
process.env.NODE_ENV !== "production" ? FormControl.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The contents of the form control.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the component will be displayed in focused state.
   */
  focused: PropTypes.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * If `true`, the label will be hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   */
  hiddenLabel: PropTypes.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,

  /**
   * The size of the text field.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var FormControl$1 = withStyles(styles$d, {
  name: 'MuiFormControl'
})(FormControl);

var styles$c = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends$3({
      color: theme.palette.text.secondary
    }, theme.typography.caption, {
      textAlign: 'left',
      marginTop: 3,
      margin: 0,
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      marginLeft: 14,
      marginRight: 14
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {}
  };
};
var FormHelperText = /*#__PURE__*/React$2.forwardRef(function FormHelperText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'p' : _props$component;
      props.disabled;
      props.error;
      props.filled;
      props.focused;
      props.margin;
      props.required;
      props.variant;
      var other = _objectWithoutProperties(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);

  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  return /*#__PURE__*/React$2.createElement(Component, _extends$3({
    className: clsx(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), children === ' ' ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  React$2.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : children);
});
process.env.NODE_ENV !== "production" ? FormHelperText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var FormHelperText$1 = withStyles(styles$c, {
  name: 'MuiFormHelperText'
})(FormHelperText);

/**
 * @ignore - internal component.
 */

var ListContext = React$2.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ListContext.displayName = 'ListContext';
}

var ListContext$1 = ListContext;

var styles$b = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List = /*#__PURE__*/React$2.forwardRef(function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = React$2.useMemo(function () {
    return {
      dense: dense
    };
  }, [dense]);
  return /*#__PURE__*/React$2.createElement(ListContext$1.Provider, {
    value: context
  }, /*#__PURE__*/React$2.createElement(Component, _extends$3({
    className: clsx(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
process.env.NODE_ENV !== "production" ? List.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: PropTypes.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node
} : void 0;
var List$1 = withStyles(styles$b, {
  name: 'MuiList'
})(List);

function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  var text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  var wrappedOnce = false;
  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return;
    }
  }
}

var useEnhancedEffect = typeof window === 'undefined' ? React$2.useEffect : React$2.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */

var MenuList = /*#__PURE__*/React$2.forwardRef(function MenuList(props, ref) {
  var actions = props.actions,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$autoFocusItem = props.autoFocusItem,
      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
      children = props.children,
      className = props.className,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      onKeyDown = props.onKeyDown,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = _objectWithoutProperties(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);

  var listRef = React$2.useRef(null);
  var textCriteriaRef = React$2.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect(function () {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  React$2.useImperativeHandle(actions, function () {
    return {
      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
        // Let's ignore that piece of logic if users are already overriding the width
        // of the menu.
        var noExplicitWidth = !listRef.current.style.width;

        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
          var scrollbarSize = "".concat(getScrollbarSize(), "px");
          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
        }

        return listRef.current;
      }
    };
  }, []);

  var handleKeyDown = function handleKeyDown(event) {
    var list = listRef.current;
    var key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */

    var currentFocus = ownerDocument(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      var criteria = textCriteriaRef.current;
      var lowerKey = key.toLowerCase();
      var currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleOwnRef = React$2.useCallback(function (instance) {
    // #StrictMode ready
    listRef.current = ReactDOM.findDOMNode(instance);
  }, []);
  var handleRef = useForkRef(handleOwnRef, ref);
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */

  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  React$2.Children.forEach(children, function (child, index) {
    if (! /*#__PURE__*/React$2.isValidElement(child)) {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = React$2.Children.map(children, function (child, index) {
    if (index === activeItemIndex) {
      var newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      return /*#__PURE__*/React$2.cloneElement(child, newChildProps);
    }

    return child;
  });
  return /*#__PURE__*/React$2.createElement(List$1, _extends$3({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other), items);
});
process.env.NODE_ENV !== "production" ? MenuList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   */
  autoFocusItem: PropTypes.bool,

  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: PropTypes.bool,

  /**
   * If `true`, the menu items will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
var MenuList$1 = MenuList;

var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles$a = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  },

  /* Styles applied to the `List` component via `MenuList`. */
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Menu = /*#__PURE__*/React$2.forwardRef(function Menu(props, ref) {
  var _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      _props$disableAutoFoc = props.disableAutoFocusItem,
      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$MenuListProps = props.MenuListProps,
      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
      onClose = props.onClose,
      onEnteringProp = props.onEntering,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      PopoverClasses = props.PopoverClasses,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps;
  _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;

  var onEntering = _props$TransitionProp.onEntering,
      TransitionProps = _objectWithoutProperties(_props$TransitionProp, ["onEntering"]),
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = _objectWithoutProperties(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"]);

  var theme = useTheme();
  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  var menuListActionsRef = React$2.useRef(null);
  var contentAnchorRef = React$2.useRef(null);

  var getContentAnchorEl = function getContentAnchorEl() {
    return contentAnchorRef.current;
  };

  var handleEntering = function handleEntering(element, isAppearing) {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEnteringProp) {
      onEnteringProp(element, isAppearing);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */


  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  React$2.Children.map(children, function (child, index) {
    if (! /*#__PURE__*/React$2.isValidElement(child)) {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant !== "menu" && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = React$2.Children.map(children, function (child, index) {
    if (index === activeItemIndex) {
      return /*#__PURE__*/React$2.cloneElement(child, {
        ref: function ref(instance) {
          // #StrictMode ready
          contentAnchorRef.current = ReactDOM.findDOMNode(instance);
          setRef(child.ref, instance);
        }
      });
    }

    return child;
  });
  return /*#__PURE__*/React$2.createElement(Popover$1, _extends$3({
    getContentAnchorEl: getContentAnchorEl,
    classes: PopoverClasses,
    onClose: onClose,
    TransitionProps: _extends$3({
      onEntering: handleEntering
    }, TransitionProps),
    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: _extends$3({}, PaperProps, {
      classes: _extends$3({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    open: open,
    ref: ref,
    transitionDuration: transitionDuration
  }, other), /*#__PURE__*/React$2.createElement(MenuList$1, _extends$3({
    onKeyDown: handleListKeyDown,
    actions: menuListActionsRef,
    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
    autoFocusItem: autoFocusItem,
    variant: variant
  }, MenuListProps, {
    className: clsx(classes.list, MenuListProps.className)
  }), items));
});
process.env.NODE_ENV !== "production" ? Menu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.func]),

  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   */
  autoFocus: PropTypes.bool,

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   */
  disableAutoFocusItem: PropTypes.bool,

  /**
   * Props applied to the [`MenuList`](/api/menu-list/) element.
   */
  MenuListProps: PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the Menu enters.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired before the Menu exits.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * If `true`, the menu is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: PropTypes.object,

  /**
   * `classes` prop applied to the [`Popover`](/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition) component.
   */
  TransitionProps: PropTypes.object,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
var Menu$1 = withStyles(styles$a, {
  name: 'MuiMenu'
})(Menu);

function areEqualValues(a, b) {
  if (_typeof$1(b) === 'object' && b !== null) {
    return a === b;
  }

  return String(a) === String(b);
}

function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */


var SelectInput = /*#__PURE__*/React$2.forwardRef(function SelectInput(props, ref) {
  var ariaLabel = props['aria-label'],
      autoFocus = props.autoFocus,
      autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      inputRefProp = props.inputRef,
      labelId = props.labelId,
      _props$MenuProps = props.MenuProps,
      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
      multiple = props.multiple,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClose = props.onClose,
      onFocus = props.onFocus,
      onOpen = props.onOpen,
      openProp = props.open,
      readOnly = props.readOnly,
      renderValue = props.renderValue,
      _props$SelectDisplayP = props.SelectDisplayProps,
      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
      tabIndexProp = props.tabIndex;
      props.type;
      var valueProp = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);

  var _useControlled = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var inputRef = React$2.useRef(null);

  var _React$useState = React$2.useState(null),
      displayNode = _React$useState[0],
      setDisplayNode = _React$useState[1];

  var _React$useRef = React$2.useRef(openProp != null),
      isOpenControlled = _React$useRef.current;

  var _React$useState2 = React$2.useState(),
      menuMinWidthState = _React$useState2[0],
      setMenuMinWidthState = _React$useState2[1];

  var _React$useState3 = React$2.useState(false),
      openState = _React$useState3[0],
      setOpenState = _React$useState3[1];

  var handleRef = useForkRef(ref, inputRefProp);
  React$2.useImperativeHandle(handleRef, function () {
    return {
      focus: function focus() {
        displayNode.focus();
      },
      node: inputRef.current,
      value: value
    };
  }, [displayNode, value]);
  React$2.useEffect(function () {
    if (autoFocus && displayNode) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);
  React$2.useEffect(function () {
    if (displayNode) {
      var label = ownerDocument(displayNode).getElementById(labelId);

      if (label) {
        var handler = function handler() {
          if (getSelection().isCollapsed) {
            displayNode.focus();
          }
        };

        label.addEventListener('click', handler);
        return function () {
          label.removeEventListener('click', handler);
        };
      }
    }

    return undefined;
  }, [labelId, displayNode]);

  var update = function update(open, event) {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    } // Hijack the default focus behavior.


    event.preventDefault();
    displayNode.focus();
    update(true, event);
  };

  var handleClose = function handleClose(event) {
    update(false, event);
  };

  var childrenArray = React$2.Children.toArray(children); // Support autofill.

  var handleChange = function handleChange(event) {
    var index = childrenArray.map(function (child) {
      return child.props.value;
    }).indexOf(event.target.value);

    if (index === -1) {
      return;
    }

    var child = childrenArray[index];
    setValue(child.props.value);

    if (onChange) {
      onChange(event, child);
    }
  };

  var handleItemClick = function handleItemClick(child) {
    return function (event) {
      if (!multiple) {
        update(false, event);
      }

      var newValue;

      if (multiple) {
        newValue = Array.isArray(value) ? value.slice() : [];
        var itemIndex = value.indexOf(child.props.value);

        if (itemIndex === -1) {
          newValue.push(child.props.value);
        } else {
          newValue.splice(itemIndex, 1);
        }
      } else {
        newValue = child.props.value;
      }

      if (child.props.onClick) {
        child.props.onClick(event);
      }

      if (value === newValue) {
        return;
      }

      setValue(newValue);

      if (onChange) {
        event.persist(); // Preact support, target is read only property on a native event.

        Object.defineProperty(event, 'target', {
          writable: true,
          value: {
            value: newValue,
            name: name
          }
        });
        onChange(event, child);
      }
    };
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (!readOnly) {
      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      'Enter'];

      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };

  var open = displayNode !== null && (isOpenControlled ? openProp : openState);

  var handleBlur = function handleBlur(event) {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      event.persist(); // Preact support, target is read only property on a native event.

      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value: value,
          name: name
        }
      });
      onBlur(event);
    }
  };

  delete other['aria-invalid'];
  var display;
  var displaySingle;
  var displayMultiple = [];
  var computeDisplay = false;
  var foundMatch = false; // No need to display any value if the field is empty.

  if (isFilled({
    value: value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }

  var items = childrenArray.map(function (child) {
    if (! /*#__PURE__*/React$2.isValidElement(child)) {
      return null;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (isFragment(child)) {
        console.error(["Material-UI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var selected;

    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`." : formatMuiErrorMessage(2));
      }

      selected = value.some(function (v) {
        return areEqualValues(v, child.props.value);
      });

      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);

      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }

    if (selected) {
      foundMatch = true;
    }

    return /*#__PURE__*/React$2.cloneElement(child, {
      'aria-selected': selected ? 'true' : undefined,
      onClick: handleItemClick(child),
      onKeyUp: function onKeyUp(event) {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }

        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected: selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.

    });
  });

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$2.useEffect(function () {
      if (!foundMatch && !multiple && value !== '') {
        var values = childrenArray.map(function (child) {
          return child.props.value;
        });
        console.warn(["Material-UI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
          return x != null;
        }).map(function (x) {
          return "`".concat(x, "`");
        }).join(', ') || '""', ".")].join('\n'));
      }
    }, [foundMatch, childrenArray, multiple, name, value]);
  }

  if (computeDisplay) {
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  } // Avoid performing a layout computation in the render method.


  var menuMinWidth = menuMinWidthState;

  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }

  var tabIndex;

  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }

  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
  return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement("div", _extends$3({
    className: clsx(classes.root, // TODO v5: merge root and select
    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
    ref: setDisplayNode,
    tabIndex: tabIndex,
    role: "button",
    "aria-disabled": disabled ? 'true' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
    onKeyDown: handleKeyDown,
    onMouseDown: disabled || readOnly ? null : handleMouseDown,
    onBlur: handleBlur,
    onFocus: onFocus
  }, SelectDisplayProps, {
    // The id is required for proper a11y
    id: buttonId
  }), isEmpty(display) ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  React$2.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : display), /*#__PURE__*/React$2.createElement("input", _extends$3({
    value: Array.isArray(value) ? value.join(',') : value,
    name: name,
    ref: inputRef,
    "aria-hidden": true,
    onChange: handleChange,
    tabIndex: -1,
    className: classes.nativeInput,
    autoFocus: autoFocus
  }, other)), /*#__PURE__*/React$2.createElement(IconComponent, {
    className: clsx(classes.icon, classes["icon".concat(capitalize(variant))], open && classes.iconOpen, disabled && classes.disabled)
  }), /*#__PURE__*/React$2.createElement(Menu$1, _extends$3({
    id: "menu-".concat(name || ''),
    anchorEl: displayNode,
    open: open,
    onClose: handleClose
  }, MenuProps, {
    MenuListProps: _extends$3({
      'aria-labelledby': labelId,
      role: 'listbox',
      disableListWrap: true
    }, MenuProps.MenuListProps),
    PaperProps: _extends$3({}, MenuProps.PaperProps, {
      style: _extends$3({
        minWidth: menuMinWidth
      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
    })
  }), items));
});
process.env.NODE_ENV !== "production" ? SelectInput.propTypes = {
  /**
   * @ignore
   */
  'aria-label': PropTypes.string,

  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,

  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType$1,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   */
  open: PropTypes.bool,

  /**
   * @ignore
   */
  readOnly: PropTypes.bool,

  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  type: PropTypes.any,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
var SelectInput$1 = SelectInput;

var styles$9 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/React$2.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/React$2.createElement(Component, _extends$3({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat(capitalize(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/React$2.createElement("title", null, titleAccess) : null);
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: PropTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: chainPropTypes(PropTypes.oneOf(['default', 'inherit', 'large', 'medium', 'small']), function (props) {
    var fontSize = props.fontSize;

    if (fontSize === 'default') {
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    }

    return null;
  }),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: PropTypes.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = withStyles(styles$9, {
  name: 'MuiSvgIcon'
})(SvgIcon);

/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/React__default.createElement(SvgIcon$1, _extends$3({
      ref: ref
    }, props), path);
  };

  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/React__default.memo( /*#__PURE__*/React__default.forwardRef(Component));
}

/**
 * @ignore - internal component.
 */

var ArrowDropDownIcon = createSvgIcon( /*#__PURE__*/React$2.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

/**
 * @ignore - internal component.
 */

var NativeSelectInput = /*#__PURE__*/React$2.forwardRef(function NativeSelectInput(props, ref) {
  var classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);

  return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement("select", _extends$3({
    className: clsx(classes.root, // TODO v5: merge root and select
    classes.select, classes[variant], className, disabled && classes.disabled),
    disabled: disabled,
    ref: inputRef || ref
  }, other)), props.multiple ? null : /*#__PURE__*/React$2.createElement(IconComponent, {
    className: clsx(classes.icon, classes["icon".concat(capitalize(variant))], disabled && classes.disabled)
  }));
});
process.env.NODE_ENV !== "production" ? NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,

  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType$1,

  /**
   * @ignore
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
var NativeSelectInput$1 = NativeSelectInput;

var styles$8 = function styles(theme) {
  return {
    /* Styles applied to the select component `root` class. */
    root: {},

    /* Styles applied to the select component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE 11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      },
      '&[multiple]': {
        height: 'auto'
      },
      '&:not([multiple]) option, &:not([multiple]) optgroup': {
        backgroundColor: theme.palette.background.paper
      },
      '&&': {
        paddingRight: 24
      }
    },

    /* Styles applied to the select component if `variant="filled"`. */
    filled: {
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component if `variant="outlined"`. */
    outlined: {
      borderRadius: theme.shape.borderRadius,
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component `selectMenu` class. */
    selectMenu: {
      height: 'auto',
      // Resets for multpile select with chips
      minHeight: '1.1876em',
      // Required for select\text-field height consistency
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },

    /* Pseudo-class applied to the select component `disabled` class. */
    disabled: {},

    /* Styles applied to the icon component. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      pointerEvents: 'none',
      // Don't block pointer events on the select under the icon.
      color: theme.palette.action.active,
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the icon component if the popup is open. */
    iconOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the icon component if `variant="filled"`. */
    iconFilled: {
      right: 7
    },

    /* Styles applied to the icon component if `variant="outlined"`. */
    iconOutlined: {
      right: 7
    },

    /* Styles applied to the underlying native input component. */
    nativeInput: {
      bottom: 0,
      left: 0,
      position: 'absolute',
      opacity: 0,
      pointerEvents: 'none',
      width: '100%'
    }
  };
};
var defaultInput = /*#__PURE__*/React$2.createElement(Input$1, null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */

var NativeSelect = /*#__PURE__*/React$2.forwardRef(function NativeSelect(props, ref) {
  var children = props.children,
      classes = props.classes,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? ArrowDropDownIcon : _props$IconComponent,
      _props$input = props.input,
      input = _props$input === void 0 ? defaultInput : _props$input,
      inputProps = props.inputProps;
      props.variant;
      var other = _objectWithoutProperties(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);

  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  return /*#__PURE__*/React$2.cloneElement(input, _extends$3({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: NativeSelectInput$1,
    inputProps: _extends$3({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? NativeSelect.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value. The DOM API casts this to a string.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
NativeSelect.muiName = 'Select';
withStyles(styles$8, {
  name: 'MuiNativeSelect'
})(NativeSelect);

var styles$7 = styles$8;

var _ref = /*#__PURE__*/React$2.createElement(Input$1, null);

var _ref2 = /*#__PURE__*/React$2.createElement(FilledInput$1, null);

var Select = /*#__PURE__*/React$2.forwardRef(function Select(props, ref) {
  var _props$autoWidth = props.autoWidth,
      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
      children = props.children,
      classes = props.classes,
      _props$displayEmpty = props.displayEmpty,
      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? ArrowDropDownIcon : _props$IconComponent,
      id = props.id,
      input = props.input,
      inputProps = props.inputProps,
      label = props.label,
      labelId = props.labelId,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      MenuProps = props.MenuProps,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$native = props.native,
      native = _props$native === void 0 ? false : _props$native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      _props$variant = props.variant,
      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);

  var inputComponent = native ? NativeSelectInput$1 : SelectInput$1;
  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  var variant = fcs.variant || variantProps;
  var InputComponent = input || {
    standard: _ref,
    outlined: /*#__PURE__*/React$2.createElement(OutlinedInput$1, {
      label: label,
      labelWidth: labelWidth
    }),
    filled: _ref2
  }[variant];
  return /*#__PURE__*/React$2.cloneElement(InputComponent, _extends$3({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: _extends$3({
      children: children,
      IconComponent: IconComponent,
      variant: variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: multiple
    }, native ? {
      id: id
    } : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      labelId: labelId,
      MenuProps: MenuProps,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: _extends$3({
        id: id
      }, SelectDisplayProps)
    }, inputProps, {
      classes: inputProps ? mergeClasses({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Select.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
   * You can only use it when the `native` prop is `false` (default).
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  label: PropTypes.node,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  labelWidth: PropTypes.number,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: PropTypes.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * The input value. Providing an empty string will select no options.
   * This prop is required when the `native` prop is `false` (default).
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
Select.muiName = 'Select';
var Select$1 = withStyles(styles$7, {
  name: 'MuiSelect'
})(Select);

var variantComponent = {
  standard: Input$1,
  filled: FilledInput$1,
  outlined: OutlinedInput$1
};
var styles$6 = {
  /* Styles applied to the root element. */
  root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */

var TextField = /*#__PURE__*/React$2.forwardRef(function TextField(props, ref) {
  var autoComplete = props.autoComplete,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      FormHelperTextProps = props.FormHelperTextProps,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      helperText = props.helperText,
      hiddenLabel = props.hiddenLabel,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      maxRows = props.maxRows,
      minRows = props.minRows,
      _props$select = props.select,
      select = _props$select === void 0 ? false : _props$select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "maxRows", "minRows", "select", "SelectProps", "type", "value", "variant"]);

  if (process.env.NODE_ENV !== 'production') {
    if (select && !children) {
      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }

  var InputMore = {};

  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }

    if (label) {
      var _InputLabelProps$requ;

      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
      InputMore.label = /*#__PURE__*/React$2.createElement(React$2.Fragment, null, label, displayRequired && "\xA0*");
    }
  }

  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }

    InputMore['aria-describedby'] = undefined;
  }

  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  var InputComponent = variantComponent[variant];
  var InputElement = /*#__PURE__*/React$2.createElement(InputComponent, _extends$3({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    maxRows: maxRows,
    minRows: minRows,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return /*#__PURE__*/React$2.createElement(FormControl$1, _extends$3({
    className: clsx(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    ref: ref,
    required: required,
    color: color,
    variant: variant
  }, other), label && /*#__PURE__*/React$2.createElement(InputLabel$1, _extends$3({
    htmlFor: id,
    id: inputLabelId
  }, InputLabelProps), label), select ? /*#__PURE__*/React$2.createElement(Select$1, _extends$3({
    "aria-describedby": helperTextId,
    id: id,
    labelId: inputLabelId,
    value: value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/React$2.createElement(FormHelperText$1, _extends$3({
    id: helperTextId
  }, FormHelperTextProps), helperText));
});
process.env.NODE_ENV !== "production" ? TextField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default value of the `input` element.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The helper text content.
   */
  helperText: PropTypes.node,

  /**
   * @ignore
   */
  hiddenLabel: PropTypes.bool,

  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,

  /**
   * Props applied to the [`InputLabel`](/api/input-label/) element.
   */
  InputLabelProps: PropTypes.object,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/api/filled-input/),
   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * The label content.
   */
  label: PropTypes.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   * @deprecated Use `minRows` instead.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: PropTypes.bool,

  /**
   * Props applied to the [`Select`](/api/select/) element.
   */
  SelectProps: PropTypes.object,

  /**
   * The size of the text field.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var TextField$1 = withStyles(styles$6, {
  name: 'MuiTextField'
})(TextField);

var styles$5 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/React$2.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/React$2.createElement(ButtonBase$1, _extends$3({
    className: clsx(classes.root, className, color !== 'default' && classes["color".concat(capitalize(color))], disabled && classes.disabled, size === "small" && classes["size".concat(capitalize(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/React$2.createElement("span", {
    className: classes.label
  }, children));
});
process.env.NODE_ENV !== "production" ? IconButton.propTypes = {
  /**
   * The icon element.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var found = React$2.Children.toArray(props.children).some(function (child) {
      return /*#__PURE__*/React$2.isValidElement(child) && child.props.onClick;
    });

    if (found) {
      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['start', 'end', false]),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium'])
} : void 0;
var IconButton$1 = withStyles(styles$5, {
  name: 'MuiIconButton'
})(IconButton);

var styles$4 = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },

  /* Styles applied to the root element if `variant="filled"`. */
  filled: {
    '&$positionStart:not($hiddenLabel)': {
      marginTop: 16
    }
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  },

  /* Styles applied to the root element if `disablePointerEvents=true`. */
  disablePointerEvents: {
    pointerEvents: 'none'
  },

  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
  hiddenLabel: {},

  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
  marginDense: {}
};
var InputAdornment = /*#__PURE__*/React$2.forwardRef(function InputAdornment(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disablePointer = props.disablePointerEvents,
      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      position = props.position,
      variantProp = props.variant,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);

  var muiFormControl = useFormControl$1() || {};
  var variant = variantProp;

  if (variantProp && muiFormControl.variant) {
    if (process.env.NODE_ENV !== 'production') {
      if (variantProp === muiFormControl.variant) {
        console.error('Material-UI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
      }
    }
  }

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  return /*#__PURE__*/React$2.createElement(FormControlContext$1.Provider, {
    value: null
  }, /*#__PURE__*/React$2.createElement(Component, _extends$3({
    className: clsx(classes.root, className, position === 'end' ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, muiFormControl.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/React$2.createElement(Typography$1, {
    color: "textSecondary"
  }, children) : children));
});
process.env.NODE_ENV !== "production" ? InputAdornment.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */
  disablePointerEvents: PropTypes.bool,

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * @ignore
   */
  muiFormControl: PropTypes.object,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(['start', 'end']).isRequired,

  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
var InputAdornment$1 = withStyles(styles$4, {
  name: 'MuiInputAdornment'
})(InputAdornment);

var Rifm =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$2(Rifm, _React$Component);

  function Rifm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._state = null;
    _this._del = false;

    _this._handleChange = function (evt) {
      if (process.env.NODE_ENV !== 'production') {
        if (evt.target.type === 'number') {
          console.error('Rifm does not support input type=number, use type=tel instead.');
          return;
        }
      } // FUTURE: use evt.nativeEvent.inputType for del event, see comments at onkeydown


      var stateValue = _this.state.value;
      var value = evt.target.value;
      var input = evt.target;
      var op = value.length > stateValue.length;
      var del = _this._del;

      var noOp = stateValue === _this.props.format(value);

      _this.setState({
        value: value,
        local: true
      }, function () {
        var selectionStart = input.selectionStart;
        var refuse = _this.props.refuse || /[^\d]+/g;
        var before = value.substr(0, selectionStart).replace(refuse, '');
        _this._state = {
          input: input,
          before: before,
          op: op,
          di: del && noOp,
          del: del
        };

        if (_this.props.replace && _this.props.replace(stateValue) && op && !noOp) {
          var start = -1;

          for (var i = 0; i !== before.length; ++i) {
            start = Math.max(start, value.toLowerCase().indexOf(before[i].toLowerCase(), start + 1));
          }

          var c = value.substr(start + 1).replace(refuse, '')[0];
          start = value.indexOf(c, start + 1);
          value = "" + value.substr(0, start) + value.substr(start + 1);
        }

        var fv = _this.props.format(value);

        if (stateValue === fv) {
          _this.setState({
            value: value
          });
        } else {
          _this.props.onChange(fv);
        }
      });
    };

    _this._hKD = function (evt) {
      if (evt.code === 'Delete') {
        _this._del = true;
      }
    };

    _this._hKU = function (evt) {
      if (evt.code === 'Delete') {
        _this._del = false;
      }
    };

    _this.state = {
      value: props.value,
      local: true
    };
    return _this;
  }

  Rifm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    return {
      value: state.local ? state.value : props.value,
      local: false
    };
  };

  var _proto = Rifm.prototype;

  _proto.render = function render() {
    var _handleChange = this._handleChange,
        value = this.state.value,
        children = this.props.children;
    return children({
      value: value,
      onChange: _handleChange
    });
  } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this._hKD);
    document.removeEventListener('keyup', this._hKU);
  } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
  ;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this._hKD);
    document.addEventListener('keyup', this._hKU);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _state = this._state;

    if (_state) {
      var value = this.state.value;
      var start = -1;

      for (var i = 0; i !== _state.before.length; ++i) {
        start = Math.max(start, value.toLowerCase().indexOf(_state.before[i].toLowerCase(), start + 1));
      } // format usually looks better without this


      if (this.props.replace && (_state.op || _state.del && !_state.di)) {
        while (value[start + 1] && (this.props.refuse || /[^\d]+/).test(value[start + 1])) {
          start += 1;
        }
      }

      _state.input.selectionStart = _state.input.selectionEnd = start + 1 + (_state.di ? 1 : 0);
    }

    this._state = null;
  };

  return Rifm;
}(Component);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$2(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

var useStyles$7 = makeStyles(function (theme) {
  return {
    day: {
      width: 36,
      height: 36,
      fontSize: theme.typography.caption.fontSize,
      margin: '0 2px',
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightMedium,
      padding: 0
    },
    hidden: {
      opacity: 0,
      pointerEvents: 'none'
    },
    current: {
      color: theme.palette.primary.main,
      fontWeight: 600
    },
    daySelected: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      }
    },
    dayDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersDay'
});
var Day = function Day(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      hidden = _ref.hidden,
      current = _ref.current,
      selected = _ref.selected,
      other = _objectWithoutProperties(_ref, ["children", "disabled", "hidden", "current", "selected"]);

  var classes = useStyles$7();
  var className = clsx(classes.day, hidden && classes.hidden, current && classes.current, selected && classes.daySelected, disabled && classes.dayDisabled);
  return createElement(IconButton$1, _extends$3({
    className: className,
    tabIndex: hidden || disabled ? -1 : 0
  }, other), createElement(Typography$1, {
    variant: "body2",
    color: "inherit"
  }, children));
};
Day.displayName = 'Day';
process.env.NODE_ENV !== "production" ? Day.propTypes = {
  current: propTypes_8,
  disabled: propTypes_8,
  hidden: propTypes_8,
  selected: propTypes_8
} : void 0;
Day.defaultProps = {
  disabled: false,
  hidden: false,
  current: false,
  selected: false
};

var Day$1 = Day;

var SIZE = 44;
var styles$3 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },

    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = /*#__PURE__*/React$2.forwardRef(function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/React$2.createElement("div", _extends$3({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: _extends$3({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/React$2.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/React$2.createElement("circle", {
    className: clsx(classes.circle, disableShrink && classes.circleDisableShrink, {
      'determinate': classes.circleDeterminate,
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
process.env.NODE_ENV !== "production" ? CircularProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary']),

  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */
  disableShrink: chainPropTypes(PropTypes.bool, function (props) {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('Material-UI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }

    return null;
  }),

  /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The thickness of the circle.
   */
  thickness: PropTypes.number,

  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: chainPropTypes(PropTypes.oneOf(['determinate', 'indeterminate', 'static']), function (props) {
    var variant = props.variant;

    if (variant === 'static') {
      throw new Error('Material-UI: `variant="static"` was deprecated. Use `variant="determinate"` instead.');
    }

    return null;
  })
} : void 0;
var CircularProgress$1 = withStyles(styles$3, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress);

var findClosestEnabledDate = function findClosestEnabledDate(_ref) {
  var date = _ref.date,
      utils = _ref.utils,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      disableFuture = _ref.disableFuture,
      disablePast = _ref.disablePast,
      shouldDisableDate = _ref.shouldDisableDate;
  var today = utils.startOfDay(utils.date());

  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }

  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }

  var forward = date;
  var backward = date;

  if (utils.isBefore(date, minDate)) {
    forward = utils.date(minDate);
    backward = null;
  }

  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = utils.date(maxDate);
    }

    forward = null;
  }

  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }

    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }

    if (forward) {
      if (!shouldDisableDate(forward)) {
        return forward;
      }

      forward = utils.addDays(forward, 1);
    }

    if (backward) {
      if (!shouldDisableDate(backward)) {
        return backward;
      }

      backward = utils.addDays(backward, -1);
    }
  } // fallback to today if no enabled days


  return utils.date();
};
var isYearOnlyView = function isYearOnlyView(views) {
  return views.length === 1 && views[0] === 'year';
};
var isYearAndMonthViews = function isYearAndMonthViews(views) {
  return views.length === 2 && arrayIncludes(views, 'month') && arrayIncludes(views, 'year');
};
var getFormatByViews = function getFormatByViews(views, utils) {
  if (isYearOnlyView(views)) {
    return utils.yearFormat;
  }

  if (isYearAndMonthViews(views)) {
    return utils.yearMonthFormat;
  }

  return utils.dateFormat;
};

var DayWrapper = function DayWrapper(_ref) {
  var children = _ref.children,
      value = _ref.value,
      disabled = _ref.disabled,
      onSelect = _ref.onSelect,
      dayInCurrentMonth = _ref.dayInCurrentMonth,
      other = _objectWithoutProperties(_ref, ["children", "value", "disabled", "onSelect", "dayInCurrentMonth"]);

  var handleClick = useCallback(function () {
    return onSelect(value);
  }, [onSelect, value]);
  return createElement("div", _extends$3({
    role: "presentation",
    onClick: dayInCurrentMonth && !disabled ? handleClick : undefined,
    onKeyPress: dayInCurrentMonth && !disabled ? handleClick : undefined
  }, other), children);
};

var animationDuration = 350;
var useStyles$6 = makeStyles(function (theme) {
  var slideTransition = theme.transitions.create('transform', {
    duration: animationDuration,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return {
    transitionContainer: {
      display: 'block',
      position: 'relative',
      '& > *': {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0
      }
    },
    'slideEnter-left': {
      willChange: 'transform',
      transform: 'translate(100%)'
    },
    'slideEnter-right': {
      willChange: 'transform',
      transform: 'translate(-100%)'
    },
    slideEnterActive: {
      transform: 'translate(0%)',
      transition: slideTransition
    },
    slideExit: {
      transform: 'translate(0%)'
    },
    'slideExitActiveLeft-left': {
      willChange: 'transform',
      transform: 'translate(-200%)',
      transition: slideTransition
    },
    'slideExitActiveLeft-right': {
      willChange: 'transform',
      transform: 'translate(200%)',
      transition: slideTransition
    }
  };
}, {
  name: 'MuiPickersSlideTransition'
});

var SlideTransition = function SlideTransition(_ref) {
  var children = _ref.children,
      transKey = _ref.transKey,
      slideDirection = _ref.slideDirection,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className;
  var classes = useStyles$6();
  var transitionClasses = {
    exit: classes.slideExit,
    enterActive: classes.slideEnterActive,
    // @ts-ignore
    enter: classes['slideEnter-' + slideDirection],
    // @ts-ignore
    exitActive: classes['slideExitActiveLeft-' + slideDirection]
  };
  return createElement(TransitionGroup$1, {
    className: clsx(classes.transitionContainer, className),
    childFactory: function childFactory(element) {
      return cloneElement(element, {
        classNames: transitionClasses
      });
    }
  }, createElement(CSSTransition$1, {
    mountOnEnter: true,
    unmountOnExit: true,
    key: transKey + slideDirection,
    timeout: animationDuration,
    classNames: transitionClasses,
    children: children
  }));
};

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return React__default.createElement(SvgIcon$1, props, React__default.createElement("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  }), React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
};

var ArrowRightIcon = function ArrowRightIcon(props) {
  return React__default.createElement(SvgIcon$1, props, React__default.createElement("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  }), React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
};

var useStyles$1$3 = makeStyles(function (theme) {
  return {
    switchHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1)
    },
    transitionContainer: {
      width: '100%',
      overflow: 'hidden',
      height: 23
    },
    iconButton: {
      zIndex: 1,
      backgroundColor: theme.palette.background.paper
    },
    daysHeader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxHeight: 16
    },
    dayLabel: {
      width: 36,
      margin: '0 2px',
      textAlign: 'center',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersCalendarHeader'
});
var CalendarHeader = function CalendarHeader(_ref) {
  var currentMonth = _ref.currentMonth,
      onMonthChange = _ref.onMonthChange,
      leftArrowIcon = _ref.leftArrowIcon,
      rightArrowIcon = _ref.rightArrowIcon,
      leftArrowButtonProps = _ref.leftArrowButtonProps,
      rightArrowButtonProps = _ref.rightArrowButtonProps,
      disablePrevMonth = _ref.disablePrevMonth,
      disableNextMonth = _ref.disableNextMonth,
      slideDirection = _ref.slideDirection;
  var utils = useUtils();
  var classes = useStyles$1$3();
  var theme = useTheme();
  var rtl = theme.direction === 'rtl';

  var selectNextMonth = function selectNextMonth() {
    return onMonthChange(utils.getNextMonth(currentMonth), 'left');
  };

  var selectPreviousMonth = function selectPreviousMonth() {
    return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
  };

  return createElement("div", null, createElement("div", {
    className: classes.switchHeader
  }, createElement(IconButton$1, _extends$3({}, leftArrowButtonProps, {
    disabled: disablePrevMonth,
    onClick: selectPreviousMonth,
    className: classes.iconButton
  }), rtl ? rightArrowIcon : leftArrowIcon), createElement(SlideTransition, {
    slideDirection: slideDirection,
    transKey: currentMonth.toString(),
    className: classes.transitionContainer
  }, createElement(Typography$1, {
    align: "center",
    variant: "body1"
  }, utils.getCalendarHeaderText(currentMonth))), createElement(IconButton$1, _extends$3({}, rightArrowButtonProps, {
    disabled: disableNextMonth,
    onClick: selectNextMonth,
    className: classes.iconButton
  }), rtl ? leftArrowIcon : rightArrowIcon)), createElement("div", {
    className: classes.daysHeader
  }, utils.getWeekdays().map(function (day, index) {
    return createElement(Typography$1, {
      key: index // eslint-disable-line react/no-array-index-key
      ,
      variant: "caption",
      className: classes.dayLabel
    }, day);
  })));
};
CalendarHeader.displayName = 'CalendarHeader';
process.env.NODE_ENV !== "production" ? CalendarHeader.propTypes = {
  leftArrowIcon: propTypes_7,
  rightArrowIcon: propTypes_7,
  disablePrevMonth: propTypes_8,
  disableNextMonth: propTypes_8
} : void 0;
CalendarHeader.defaultProps = {
  leftArrowIcon: createElement(ArrowLeftIcon, null),
  rightArrowIcon: createElement(ArrowRightIcon, null),
  disablePrevMonth: false,
  disableNextMonth: false
};

var withUtils = function withUtils() {
  return function (Component) {
    var WithUtils = function WithUtils(props) {
      var utils = useUtils();
      return createElement(Component, _extends$3({
        utils: utils
      }, props));
    };

    WithUtils.displayName = "WithUtils(".concat(Component.displayName || Component.name, ")");
    return WithUtils;
  };
};

var KeyDownListener = function KeyDownListener(_ref) {
  var onKeyDown = _ref.onKeyDown;
  useEffect(function () {
    window.addEventListener('keydown', onKeyDown);
    return function () {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
  return null;
};

var Calendar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Calendar, _React$Component);

  function Calendar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      slideDirection: 'left',
      currentMonth: _this.props.utils.startOfMonth(_this.props.date),
      loadingQueue: 0
    };

    _this.pushToLoadingQueue = function () {
      var loadingQueue = _this.state.loadingQueue + 1;

      _this.setState({
        loadingQueue: loadingQueue
      });
    };

    _this.popFromLoadingQueue = function () {
      var loadingQueue = _this.state.loadingQueue;
      loadingQueue = loadingQueue <= 0 ? 0 : loadingQueue - 1;

      _this.setState({
        loadingQueue: loadingQueue
      });
    };

    _this.handleChangeMonth = function (newMonth, slideDirection) {
      _this.setState({
        currentMonth: newMonth,
        slideDirection: slideDirection
      });

      if (_this.props.onMonthChange) {
        var returnVal = _this.props.onMonthChange(newMonth);

        if (returnVal) {
          _this.pushToLoadingQueue();

          returnVal.then(function () {
            _this.popFromLoadingQueue();
          });
        }
      }
    };

    _this.validateMinMaxDate = function (day) {
      var _this$props = _this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          utils = _this$props.utils,
          disableFuture = _this$props.disableFuture,
          disablePast = _this$props.disablePast;
      var now = utils.date();
      return Boolean(disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate)));
    };

    _this.shouldDisablePrevMonth = function () {
      var _this$props2 = _this.props,
          utils = _this$props2.utils,
          disablePast = _this$props2.disablePast,
          minDate = _this$props2.minDate;
      var now = utils.date();
      var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utils.date(minDate)) ? now : utils.date(minDate));
      return !utils.isBefore(firstEnabledMonth, _this.state.currentMonth);
    };

    _this.shouldDisableNextMonth = function () {
      var _this$props3 = _this.props,
          utils = _this$props3.utils,
          disableFuture = _this$props3.disableFuture,
          maxDate = _this$props3.maxDate;
      var now = utils.date();
      var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utils.date(maxDate)) ? now : utils.date(maxDate));
      return !utils.isAfter(lastEnabledMonth, _this.state.currentMonth);
    };

    _this.shouldDisableDate = function (day) {
      var shouldDisableDate = _this.props.shouldDisableDate;
      return _this.validateMinMaxDate(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
    };

    _this.handleDaySelect = function (day) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props4 = _this.props,
          date = _this$props4.date,
          utils = _this$props4.utils;

      _this.props.onChange(utils.mergeDateAndTime(day, date), isFinish);
    };

    _this.moveToDay = function (day) {
      var utils = _this.props.utils;

      if (day && !_this.shouldDisableDate(day)) {
        if (utils.getMonth(day) !== utils.getMonth(_this.state.currentMonth)) {
          _this.handleChangeMonth(utils.startOfMonth(day), 'left');
        }

        _this.handleDaySelect(day, false);
      }
    };

    _this.handleKeyDown = function (event) {
      var _this$props5 = _this.props,
          theme = _this$props5.theme,
          date = _this$props5.date,
          utils = _this$props5.utils;
      runKeyHandler(event, {
        ArrowUp: function ArrowUp() {
          return _this.moveToDay(utils.addDays(date, -7));
        },
        ArrowDown: function ArrowDown() {
          return _this.moveToDay(utils.addDays(date, 7));
        },
        ArrowLeft: function ArrowLeft() {
          return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? -1 : 1));
        },
        ArrowRight: function ArrowRight() {
          return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? 1 : -1));
        }
      });
    };

    _this.renderWeeks = function () {
      var _this$props6 = _this.props,
          utils = _this$props6.utils,
          classes = _this$props6.classes;
      var weeks = utils.getWeekArray(_this.state.currentMonth);
      return weeks.map(function (week) {
        return createElement("div", {
          key: "week-".concat(week[0].toString()),
          className: classes.week
        }, _this.renderDays(week));
      });
    };

    _this.renderDays = function (week) {
      var _this$props7 = _this.props,
          date = _this$props7.date,
          renderDay = _this$props7.renderDay,
          utils = _this$props7.utils;
      var now = utils.date();
      var selectedDate = utils.startOfDay(date);
      var currentMonthNumber = utils.getMonth(_this.state.currentMonth);
      return week.map(function (day) {
        var disabled = _this.shouldDisableDate(day);

        var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
        var dayComponent = createElement(Day$1, {
          disabled: disabled,
          current: utils.isSameDay(day, now),
          hidden: !isDayInCurrentMonth,
          selected: utils.isSameDay(selectedDate, day)
        }, utils.getDayText(day));

        if (renderDay) {
          dayComponent = renderDay(day, selectedDate, isDayInCurrentMonth, dayComponent);
        }

        return createElement(DayWrapper, {
          value: day,
          key: day.toString(),
          disabled: disabled,
          dayInCurrentMonth: isDayInCurrentMonth,
          onSelect: _this.handleDaySelect
        }, dayComponent);
      });
    };

    return _this;
  }

  _createClass(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props8 = this.props,
          date = _this$props8.date,
          minDate = _this$props8.minDate,
          maxDate = _this$props8.maxDate,
          utils = _this$props8.utils,
          disablePast = _this$props8.disablePast,
          disableFuture = _this$props8.disableFuture;

      if (this.shouldDisableDate(date)) {
        var closestEnabledDate = findClosestEnabledDate({
          date: date,
          utils: utils,
          minDate: utils.date(minDate),
          maxDate: utils.date(maxDate),
          disablePast: Boolean(disablePast),
          disableFuture: Boolean(disableFuture),
          shouldDisableDate: this.shouldDisableDate
        });
        this.handleDaySelect(closestEnabledDate, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          currentMonth = _this$state.currentMonth,
          slideDirection = _this$state.slideDirection;
      var _this$props9 = this.props,
          classes = _this$props9.classes,
          allowKeyboardControl = _this$props9.allowKeyboardControl,
          leftArrowButtonProps = _this$props9.leftArrowButtonProps,
          leftArrowIcon = _this$props9.leftArrowIcon,
          rightArrowButtonProps = _this$props9.rightArrowButtonProps,
          rightArrowIcon = _this$props9.rightArrowIcon,
          loadingIndicator = _this$props9.loadingIndicator;
      var loadingElement = loadingIndicator ? loadingIndicator : createElement(CircularProgress$1, null);
      return createElement(Fragment, null, allowKeyboardControl && this.context !== 'static' && createElement(KeyDownListener, {
        onKeyDown: this.handleKeyDown
      }), createElement(CalendarHeader, {
        currentMonth: currentMonth,
        slideDirection: slideDirection,
        onMonthChange: this.handleChangeMonth,
        leftArrowIcon: leftArrowIcon,
        leftArrowButtonProps: leftArrowButtonProps,
        rightArrowIcon: rightArrowIcon,
        rightArrowButtonProps: rightArrowButtonProps,
        disablePrevMonth: this.shouldDisablePrevMonth(),
        disableNextMonth: this.shouldDisableNextMonth()
      }), createElement(SlideTransition, {
        slideDirection: slideDirection,
        transKey: currentMonth.toString(),
        className: classes.transitionContainer
      }, createElement(Fragment, null, this.state.loadingQueue > 0 && createElement("div", {
        className: classes.progressContainer
      }, loadingElement) || createElement("div", null, this.renderWeeks()))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var utils = nextProps.utils,
          nextDate = nextProps.date;

      if (!utils.isEqual(nextDate, state.lastDate)) {
        var nextMonth = utils.getMonth(nextDate);
        var lastDate = state.lastDate || nextDate;
        var lastMonth = utils.getMonth(lastDate);
        return {
          lastDate: nextDate,
          currentMonth: nextProps.utils.startOfMonth(nextDate),
          // prettier-ignore
          slideDirection: nextMonth === lastMonth ? state.slideDirection : utils.isAfterDay(nextDate, lastDate) ? 'left' : 'right'
        };
      }

      return null;
    }
  }]);

  return Calendar;
}(Component);
Calendar.contextType = VariantContext;
process.env.NODE_ENV !== "production" ? Calendar.propTypes = {
  renderDay: propTypes_1,
  shouldDisableDate: propTypes_1,
  allowKeyboardControl: propTypes_8
} : void 0;
Calendar.defaultProps = {
  minDate: new Date('1900-01-01'),
  maxDate: new Date('2100-01-01'),
  disablePast: false,
  disableFuture: false,
  allowKeyboardControl: true
};
var styles$2 = function styles(theme) {
  return {
    transitionContainer: {
      minHeight: 36 * 6,
      marginTop: theme.spacing(1.5)
    },
    progressContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    week: {
      display: 'flex',
      justifyContent: 'center'
    }
  };
};
var Calendar$1 = withStyles(styles$2, {
  name: 'MuiPickersCalendar',
  withTheme: true
})(withUtils()(Calendar));

var ClockType;

(function (ClockType) {
  ClockType["HOURS"] = "hours";
  ClockType["MINUTES"] = "minutes";
  ClockType["SECONDS"] = "seconds";
})(ClockType || (ClockType = {}));

var ClockType$1 = ClockType;

var ClockPointer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ClockPointer, _React$Component);

  function ClockPointer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ClockPointer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ClockPointer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      toAnimateTransform: false,
      previousType: undefined
    };

    _this.getAngleStyle = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          isInner = _this$props.isInner,
          type = _this$props.type;
      var max = type === ClockType$1.HOURS ? 12 : 60;
      var angle = 360 / max * value;

      if (type === ClockType$1.HOURS && value > 12) {
        angle -= 360; // round up angle to max 360 degrees
      }

      return {
        height: isInner ? '26%' : '40%',
        transform: "rotateZ(".concat(angle, "deg)")
      };
    };

    return _this;
  }

  _createClass(ClockPointer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          hasSelected = _this$props2.hasSelected;
      return createElement("div", {
        style: this.getAngleStyle(),
        className: clsx(classes.pointer, this.state.toAnimateTransform && classes.animateTransform)
      }, createElement("div", {
        className: clsx(classes.thumb, hasSelected && classes.noPoint)
      }));
    }
  }]);

  return ClockPointer;
}(Component);

ClockPointer.getDerivedStateFromProps = function (nextProps, state) {
  if (nextProps.type !== state.previousType) {
    return {
      toAnimateTransform: true,
      previousType: nextProps.type
    };
  }

  return {
    toAnimateTransform: false,
    previousType: nextProps.type
  };
};

var styles$1 = function styles(theme) {
  return createStyles({
    pointer: {
      width: 2,
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      left: 'calc(50% - 1px)',
      bottom: '50%',
      transformOrigin: 'center bottom 0px'
    },
    animateTransform: {
      transition: theme.transitions.create(['transform', 'height'])
    },
    thumb: {
      width: 4,
      height: 4,
      backgroundColor: theme.palette.primary.contrastText,
      borderRadius: '100%',
      position: 'absolute',
      top: -21,
      left: -15,
      border: "14px solid ".concat(theme.palette.primary.main),
      boxSizing: 'content-box'
    },
    noPoint: {
      backgroundColor: theme.palette.primary.main
    }
  });
};
var ClockPointer$1 = withStyles(styles$1, {
  name: 'MuiPickersClockPointer'
})(ClockPointer);

var center = {
  x: 260 / 2,
  y: 260 / 2
};
var basePoint = {
  x: center.x,
  y: 0
};
var cx = basePoint.x - center.x;
var cy = basePoint.y - center.y;

var rad2deg = function rad2deg(rad) {
  return rad * 57.29577951308232;
};

var getAngleValue = function getAngleValue(step, offsetX, offsetY) {
  var x = offsetX - center.x;
  var y = offsetY - center.y;
  var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
  var deg = rad2deg(atan);
  deg = Math.round(deg / step) * step;
  deg %= 360;
  var value = Math.floor(deg / step) || 0;
  var delta = Math.pow(x, 2) + Math.pow(y, 2);
  var distance = Math.sqrt(delta);
  return {
    value: value,
    distance: distance
  };
};

var getHours = function getHours(offsetX, offsetY, ampm) {
  var _getAngleValue = getAngleValue(30, offsetX, offsetY),
      value = _getAngleValue.value,
      distance = _getAngleValue.distance;

  value = value || 12;

  if (!ampm) {
    if (distance < 90) {
      value += 12;
      value %= 24;
    }
  } else {
    value %= 12;
  }

  return value;
};
var getMinutes = function getMinutes(offsetX, offsetY) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var angleStep = step * 6;

  var _getAngleValue2 = getAngleValue(angleStep, offsetX, offsetY),
      value = _getAngleValue2.value;

  value = value * step % 60;
  return value;
};
var getMeridiem = function getMeridiem(date, utils) {
  return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
var convertToMeridiem = function convertToMeridiem(time, meridiem, ampm, utils) {
  if (ampm) {
    var currentMeridiem = utils.getHours(time) >= 12 ? 'pm' : 'am';

    if (currentMeridiem !== meridiem) {
      var hours = meridiem === 'am' ? utils.getHours(time) - 12 : utils.getHours(time) + 12;
      return utils.setHours(time, hours);
    }
  }

  return time;
};

var Clock =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Clock, _React$Component);

  function Clock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Clock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Clock)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.isMoving = false;

    _this.handleTouchMove = function (e) {
      _this.isMoving = true;

      _this.setTime(e);
    };

    _this.handleTouchEnd = function (e) {
      if (_this.isMoving) {
        _this.setTime(e, true);

        _this.isMoving = false;
      }
    };

    _this.handleMove = function (e) {
      e.preventDefault();
      e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari

      var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;

      if (isButtonPressed) {
        _this.setTime(e.nativeEvent, false);
      }
    };

    _this.handleMouseUp = function (e) {
      if (_this.isMoving) {
        _this.isMoving = false;
      }

      _this.setTime(e.nativeEvent, true);
    };

    _this.hasSelected = function () {
      var _this$props = _this.props,
          type = _this$props.type,
          value = _this$props.value;

      if (type === ClockType$1.HOURS) {
        return true;
      }

      return value % 5 === 0;
    };

    return _this;
  }

  _createClass(Clock, [{
    key: "setTime",
    value: function setTime(e) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var offsetX = e.offsetX,
          offsetY = e.offsetY;

      if (typeof offsetX === 'undefined') {
        var rect = e.target.getBoundingClientRect();
        offsetX = e.changedTouches[0].clientX - rect.left;
        offsetY = e.changedTouches[0].clientY - rect.top;
      }

      var value = this.props.type === ClockType$1.SECONDS || this.props.type === ClockType$1.MINUTES ? getMinutes(offsetX, offsetY, this.props.minutesStep) : getHours(offsetX, offsetY, Boolean(this.props.ampm));
      this.props.onChange(value, isFinish);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          value = _this$props2.value,
          children = _this$props2.children,
          type = _this$props2.type,
          ampm = _this$props2.ampm;
      var isPointerInner = !ampm && type === ClockType$1.HOURS && (value < 1 || value > 12);
      return createElement("div", {
        className: classes.container
      }, createElement("div", {
        className: classes.clock
      }, createElement("div", {
        role: "menu",
        tabIndex: -1,
        className: classes.squareMask,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        onMouseUp: this.handleMouseUp,
        onMouseMove: this.handleMove
      }), createElement("div", {
        className: classes.pin
      }), createElement(ClockPointer$1, {
        type: type,
        value: value,
        isInner: isPointerInner,
        hasSelected: this.hasSelected()
      }), children));
    }
  }]);

  return Clock;
}(Component);
process.env.NODE_ENV !== "production" ? Clock.propTypes = {
  type: propTypes_10(Object.keys(ClockType$1).map(function (key) {
    return ClockType$1[key];
  })).isRequired,
  value: propTypes_11.isRequired,
  onChange: propTypes_1.isRequired,
  children: propTypes_6(propTypes_7).isRequired,
  ampm: propTypes_8,
  minutesStep: propTypes_11,
  innerRef: propTypes_12
} : void 0;
Clock.defaultProps = {
  ampm: false,
  minutesStep: 1
};
var styles$1$1 = function styles(theme) {
  return createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(1), "px")
    },
    clock: {
      backgroundColor: 'rgba(0,0,0,.07)',
      borderRadius: '50%',
      height: 260,
      width: 260,
      position: 'relative',
      pointerEvents: 'none'
    },
    squareMask: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      pointerEvents: 'auto',
      outline: 'none',
      touchActions: 'none',
      userSelect: 'none',
      '&:active': {
        cursor: 'move'
      }
    },
    pin: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  });
};
var Clock$1 = withStyles(styles$1$1, {
  name: 'MuiPickersClock'
})(Clock);

var positions = {
  0: [0, 40],
  1: [55, 19.6],
  2: [94.4, 59.5],
  3: [109, 114],
  4: [94.4, 168.5],
  5: [54.5, 208.4],
  6: [0, 223],
  7: [-54.5, 208.4],
  8: [-94.4, 168.5],
  9: [-109, 114],
  10: [-94.4, 59.5],
  11: [-54.5, 19.6],
  12: [0, 5],
  13: [36.9, 49.9],
  14: [64, 77],
  15: [74, 114],
  16: [64, 151],
  17: [37, 178],
  18: [0, 188],
  19: [-37, 178],
  20: [-64, 151],
  21: [-74, 114],
  22: [-64, 77],
  23: [-37, 50]
};
var useStyles$5 = makeStyles(function (theme) {
  var size = theme.spacing(4);
  return {
    clockNumber: {
      width: size,
      height: 32,
      userSelect: 'none',
      position: 'absolute',
      left: "calc((100% - ".concat(typeof size === 'number' ? "".concat(size, "px") : size, ") / 2)"),
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint
    },
    clockNumberSelected: {
      color: theme.palette.primary.contrastText
    }
  };
}, {
  name: 'MuiPickersClockNumber'
});
var ClockNumber = function ClockNumber(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      index = _ref.index,
      isInner = _ref.isInner;
  var classes = useStyles$5();
  var className = clsx(classes.clockNumber, selected && classes.clockNumberSelected);
  var transformStyle = useMemo(function () {
    var position = positions[index];
    return {
      transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
    };
  }, [index]);
  return createElement(Typography$1, {
    component: "span",
    className: className,
    variant: isInner ? 'body2' : 'body1',
    style: transformStyle,
    children: label
  });
};

var getHourNumbers = function getHourNumbers(_ref) {
  var ampm = _ref.ampm,
      utils = _ref.utils,
      date = _ref.date;
  var currentHours = utils.getHours(date);
  var hourNumbers = [];
  var startHour = ampm ? 1 : 0;
  var endHour = ampm ? 12 : 23;

  var isSelected = function isSelected(hour) {
    if (ampm) {
      if (hour === 12) {
        return currentHours === 12 || currentHours === 0;
      }

      return currentHours === hour || currentHours - 12 === hour;
    }

    return currentHours === hour;
  };

  for (var hour = startHour; hour <= endHour; hour += 1) {
    var label = hour.toString();

    if (hour === 0) {
      label = '00';
    }

    var props = {
      index: hour,
      label: utils.formatNumber(label),
      selected: isSelected(hour),
      isInner: !ampm && (hour === 0 || hour > 12)
    };
    hourNumbers.push(createElement(ClockNumber, _extends$3({
      key: hour
    }, props)));
  }

  return hourNumbers;
};
var getMinutesNumbers = function getMinutesNumbers(_ref2) {
  var value = _ref2.value,
      utils = _ref2.utils;
  var f = utils.formatNumber;
  return [createElement(ClockNumber, {
    label: f('00'),
    selected: value === 0,
    index: 12,
    key: 12
  }), createElement(ClockNumber, {
    label: f('05'),
    selected: value === 5,
    index: 1,
    key: 1
  }), createElement(ClockNumber, {
    label: f('10'),
    selected: value === 10,
    index: 2,
    key: 2
  }), createElement(ClockNumber, {
    label: f('15'),
    selected: value === 15,
    index: 3,
    key: 3
  }), createElement(ClockNumber, {
    label: f('20'),
    selected: value === 20,
    index: 4,
    key: 4
  }), createElement(ClockNumber, {
    label: f('25'),
    selected: value === 25,
    index: 5,
    key: 5
  }), createElement(ClockNumber, {
    label: f('30'),
    selected: value === 30,
    index: 6,
    key: 6
  }), createElement(ClockNumber, {
    label: f('35'),
    selected: value === 35,
    index: 7,
    key: 7
  }), createElement(ClockNumber, {
    label: f('40'),
    selected: value === 40,
    index: 8,
    key: 8
  }), createElement(ClockNumber, {
    label: f('45'),
    selected: value === 45,
    index: 9,
    key: 9
  }), createElement(ClockNumber, {
    label: f('50'),
    selected: value === 50,
    index: 10,
    key: 10
  }), createElement(ClockNumber, {
    label: f('55'),
    selected: value === 55,
    index: 11,
    key: 11
  })];
};

var ClockView = function ClockView(_ref) {
  var type = _ref.type,
      onHourChange = _ref.onHourChange,
      onMinutesChange = _ref.onMinutesChange,
      onSecondsChange = _ref.onSecondsChange,
      ampm = _ref.ampm,
      date = _ref.date,
      minutesStep = _ref.minutesStep;
  var utils = useUtils();
  var viewProps = useMemo(function () {
    switch (type) {
      case ClockType$1.HOURS:
        return {
          value: utils.getHours(date),
          children: getHourNumbers({
            date: date,
            utils: utils,
            ampm: Boolean(ampm)
          }),
          onChange: function onChange(value, isFinish) {
            var currentMeridiem = getMeridiem(date, utils);
            var updatedTimeWithMeridiem = convertToMeridiem(utils.setHours(date, value), currentMeridiem, Boolean(ampm), utils);
            onHourChange(updatedTimeWithMeridiem, isFinish);
          }
        };

      case ClockType$1.MINUTES:
        var minutesValue = utils.getMinutes(date);
        return {
          value: minutesValue,
          children: getMinutesNumbers({
            value: minutesValue,
            utils: utils
          }),
          onChange: function onChange(value, isFinish) {
            var updatedTime = utils.setMinutes(date, value);
            onMinutesChange(updatedTime, isFinish);
          }
        };

      case ClockType$1.SECONDS:
        var secondsValue = utils.getSeconds(date);
        return {
          value: secondsValue,
          children: getMinutesNumbers({
            value: secondsValue,
            utils: utils
          }),
          onChange: function onChange(value, isFinish) {
            var updatedTime = utils.setSeconds(date, value);
            onSecondsChange(updatedTime, isFinish);
          }
        };

      default:
        throw new Error('You must provide the type for TimePickerView');
    }
  }, [ampm, date, onHourChange, onMinutesChange, onSecondsChange, type, utils]);
  return createElement(Clock$1, _extends$3({
    type: type,
    ampm: ampm,
    minutesStep: minutesStep
  }, viewProps));
};
ClockView.displayName = 'TimePickerView';
process.env.NODE_ENV !== "production" ? ClockView.propTypes = {
  date: propTypes_3.isRequired,
  onHourChange: propTypes_1.isRequired,
  onMinutesChange: propTypes_1.isRequired,
  onSecondsChange: propTypes_1.isRequired,
  ampm: propTypes_8,
  minutesStep: propTypes_11,
  type: propTypes_10(Object.keys(ClockType$1).map(function (key) {
    return ClockType$1[key];
  })).isRequired
} : void 0;
ClockView.defaultProps = {
  ampm: true,
  minutesStep: 1
};
memo(ClockView);

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
propTypes_2([propTypes_3, propTypes_4, propTypes_11, propTypes_13(Date)]);
propTypes_10(['year', 'month', 'day']);
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */

var timePickerDefaultProps = {
  ampm: true,
  invalidDateMessage: 'Invalid Time Format'
};
var datePickerDefaultProps = {
  minDate: new Date('1900-01-01'),
  maxDate: new Date('2100-01-01'),
  invalidDateMessage: 'Invalid Date Format',
  minDateMessage: 'Date should not be before minimal date',
  maxDateMessage: 'Date should not be after maximal date',
  allowKeyboardControl: true
};
_objectSpread$3({}, timePickerDefaultProps, {}, datePickerDefaultProps, {
  showTabs: true
});

function useViews(views, openTo, onChange) {
  var _React$useState = useState(openTo && arrayIncludes(views, openTo) ? openTo : views[0]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openView = _React$useState2[0],
      setOpenView = _React$useState2[1];

  var handleChangeAndOpenNext = useCallback(function (date, isFinish) {
    var nextViewToOpen = views[views.indexOf(openView) + 1];

    if (isFinish && nextViewToOpen) {
      // do not close picker if needs to show next view
      onChange(date, false);
      setOpenView(nextViewToOpen);
      return;
    }

    onChange(date, Boolean(isFinish));
  }, [onChange, openView, views]);
  return {
    handleChangeAndOpenNext: handleChangeAndOpenNext,
    openView: openView,
    setOpenView: setOpenView
  };
}

var useStyles$2 = makeStyles(function (theme) {
  return {
    root: {
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      outline: 'none',
      '&:focus': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    yearSelected: {
      margin: '10px 0',
      fontWeight: theme.typography.fontWeightMedium
    },
    yearDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersYear'
});
var Year = function Year(_ref) {
  var onSelect = _ref.onSelect,
      forwardedRef = _ref.forwardedRef,
      value = _ref.value,
      selected = _ref.selected,
      disabled = _ref.disabled,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["onSelect", "forwardedRef", "value", "selected", "disabled", "children"]);

  var classes = useStyles$2();
  var handleClick = useCallback(function () {
    return onSelect(value);
  }, [onSelect, value]);
  return createElement(Typography$1, _extends$3({
    role: "button",
    component: "div",
    tabIndex: disabled ? -1 : 0,
    onClick: handleClick,
    onKeyPress: handleClick,
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    children: children,
    ref: forwardedRef,
    className: clsx(classes.root, selected && classes.yearSelected, disabled && classes.yearDisabled)
  }, other));
};
Year.displayName = 'Year';
var Year$1 = forwardRef(function (props, ref) {
  return createElement(Year, _extends$3({}, props, {
    forwardedRef: ref
  }));
});

var useStyles$1$2 = makeStyles({
  container: {
    height: 300,
    overflowY: 'auto'
  }
}, {
  name: 'MuiPickersYearSelection'
});
var YearSelection = function YearSelection(_ref) {
  var date = _ref.date,
      onChange = _ref.onChange,
      onYearChange = _ref.onYearChange,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      animateYearScrolling = _ref.animateYearScrolling;
  var utils = useUtils();
  var classes = useStyles$1$2();
  var currentVariant = useContext(VariantContext);
  var selectedYearRef = useRef(null);
  useEffect(function () {
    if (selectedYearRef.current && selectedYearRef.current.scrollIntoView) {
      try {
        selectedYearRef.current.scrollIntoView({
          block: currentVariant === 'static' ? 'nearest' : 'center',
          behavior: animateYearScrolling ? 'smooth' : 'auto'
        });
      } catch (e) {
        // call without arguments in case when scrollIntoView works improperly (e.g. Firefox 52-57)
        selectedYearRef.current.scrollIntoView();
      }
    }
  }, []); // eslint-disable-line

  var currentYear = utils.getYear(date);
  var onYearSelect = useCallback(function (year) {
    var newDate = utils.setYear(date, year);

    if (onYearChange) {
      onYearChange(newDate);
    }

    onChange(newDate, true);
  }, [date, onChange, onYearChange, utils]);
  return createElement("div", {
    className: classes.container
  }, utils.getYearRange(minDate, maxDate).map(function (year) {
    var yearNumber = utils.getYear(year);
    var selected = yearNumber === currentYear;
    return createElement(Year$1, {
      key: utils.getYearText(year),
      selected: selected,
      value: yearNumber,
      onSelect: onYearSelect,
      ref: selected ? selectedYearRef : undefined,
      disabled: Boolean(disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date()))
    }, utils.getYearText(year));
  }));
};

var useStyles$2$1 = makeStyles(function (theme) {
  return {
    root: {
      flex: '1 0 33.33%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      outline: 'none',
      height: 75,
      transition: theme.transitions.create('font-size', {
        duration: '100ms'
      }),
      '&:focus': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    monthSelected: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium
    },
    monthDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersMonth'
});
var Month = function Month(_ref) {
  var selected = _ref.selected,
      onSelect = _ref.onSelect,
      disabled = _ref.disabled,
      value = _ref.value,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["selected", "onSelect", "disabled", "value", "children"]);

  var classes = useStyles$2$1();
  var handleSelection = useCallback(function () {
    onSelect(value);
  }, [onSelect, value]);
  return createElement(Typography$1, _extends$3({
    role: "button",
    component: "div",
    className: clsx(classes.root, selected && classes.monthSelected, disabled && classes.monthDisabled),
    tabIndex: disabled ? -1 : 0,
    onClick: handleSelection,
    onKeyPress: handleSelection,
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    children: children
  }, other));
};
Month.displayName = 'Month';

var useStyles$3 = makeStyles({
  container: {
    width: 310,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch'
  }
}, {
  name: 'MuiPickersMonthSelection'
});
var MonthSelection = function MonthSelection(_ref) {
  var disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      date = _ref.date,
      onMonthChange = _ref.onMonthChange,
      onChange = _ref.onChange;
  var utils = useUtils();
  var classes = useStyles$3();
  var currentMonth = utils.getMonth(date);

  var shouldDisableMonth = function shouldDisableMonth(month) {
    var now = utils.date();
    var utilMinDate = utils.date(minDate);
    var utilMaxDate = utils.date(maxDate);
    var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
    var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
    var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
    var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
    return isBeforeFirstEnabled || isAfterLastEnabled;
  };

  var onMonthSelect = useCallback(function (month) {
    var newDate = utils.setMonth(date, month);
    onChange(newDate, true);

    if (onMonthChange) {
      onMonthChange(newDate);
    }
  }, [date, onChange, onMonthChange, utils]);
  return createElement("div", {
    className: classes.container
  }, utils.getMonthArray(date).map(function (month) {
    var monthNumber = utils.getMonth(month);
    var monthText = utils.format(month, 'MMM');
    return createElement(Month, {
      key: monthText,
      value: monthNumber,
      selected: monthNumber === currentMonth,
      onSelect: onMonthSelect,
      disabled: shouldDisableMonth(month)
    }, monthText);
  }));
};

var getOrientation = function getOrientation() {
  if (typeof window === 'undefined') {
    return 'portrait';
  }

  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
    return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
  } // Support IOS safari


  if (window.orientation) {
    return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
  }

  return 'portrait';
};

function useIsLandscape(customOrientation) {
  var _React$useState = useState(getOrientation()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      orientation = _React$useState2[0],
      setOrientation = _React$useState2[1];

  var eventHandler = useCallback(function () {
    return setOrientation(getOrientation());
  }, []);
  useIsomorphicEffect(function () {
    window.addEventListener('orientationchange', eventHandler);
    return function () {
      return window.removeEventListener('orientationchange', eventHandler);
    };
  }, [eventHandler]);
  var orientationToUse = customOrientation || orientation;
  return orientationToUse === 'landscape';
}

function ownKeys$1$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$2(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var viewsMap = {
  year: YearSelection,
  month: MonthSelection,
  date: Calendar$1,
  hours: ClockView,
  minutes: ClockView,
  seconds: ClockView
};
var useStyles$4 = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  containerLandscape: {
    flexDirection: 'row'
  },
  pickerView: {
    overflowX: 'hidden',
    minHeight: VIEW_HEIGHT,
    minWidth: DIALOG_WIDTH,
    maxWidth: DIALOG_WIDTH_WIDER,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  pickerViewLandscape: {
    padding: '0 8px'
  }
}, {
  name: 'MuiPickersBasePicker'
});
var Picker = function Picker(_ref) {
  var date = _ref.date,
      views = _ref.views,
      disableToolbar = _ref.disableToolbar,
      onChange = _ref.onChange,
      openTo = _ref.openTo,
      unparsedMinDate = _ref.minDate,
      unparsedMaxDate = _ref.maxDate,
      ToolbarComponent = _ref.ToolbarComponent,
      orientation = _ref.orientation,
      rest = _objectWithoutProperties(_ref, ["date", "views", "disableToolbar", "onChange", "openTo", "minDate", "maxDate", "ToolbarComponent", "orientation"]);

  var utils = useUtils();
  var classes = useStyles$4();
  var isLandscape = useIsLandscape(orientation);

  var _useViews = useViews(views, openTo, onChange),
      openView = _useViews.openView,
      setOpenView = _useViews.setOpenView,
      handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;

  var minDate = useMemo(function () {
    return utils.date(unparsedMinDate);
  }, [unparsedMinDate, utils]);
  var maxDate = useMemo(function () {
    return utils.date(unparsedMaxDate);
  }, [unparsedMaxDate, utils]);
  return createElement("div", {
    className: clsx(classes.container, isLandscape && classes.containerLandscape)
  }, !disableToolbar && createElement(ToolbarComponent, _extends$3({}, rest, {
    views: views,
    isLandscape: isLandscape,
    date: date,
    onChange: onChange,
    setOpenView: setOpenView,
    openView: openView
  })), createElement("div", {
    className: clsx(classes.pickerView, isLandscape && classes.pickerViewLandscape)
  }, openView === 'year' && createElement(YearSelection, _extends$3({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), openView === 'month' && createElement(MonthSelection, _extends$3({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), openView === 'date' && createElement(Calendar$1, _extends$3({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), (openView === 'hours' || openView === 'minutes' || openView === 'seconds') && createElement(ClockView, _extends$3({}, rest, {
    date: date,
    type: openView,
    onHourChange: handleChangeAndOpenNext,
    onMinutesChange: handleChangeAndOpenNext,
    onSecondsChange: handleChangeAndOpenNext
  }))));
};
Picker.defaultProps = _objectSpread$1$2({}, datePickerDefaultProps, {
  views: Object.keys(viewsMap)
});

var useStyles$1 = makeStyles(function (theme) {
  var textColor = theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background["default"]);
  return {
    toolbarTxt: {
      color: fade(textColor, 0.54)
    },
    toolbarBtnSelected: {
      color: textColor
    }
  };
}, {
  name: 'MuiPickersToolbarText'
});

var ToolbarText = function ToolbarText(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      other = _objectWithoutProperties(_ref, ["selected", "label", "className"]);

  var classes = useStyles$1();
  return createElement(Typography$1, _extends$3({
    children: label,
    className: clsx(classes.toolbarTxt, className, selected && classes.toolbarBtnSelected)
  }, other));
};

var ToolbarButton = function ToolbarButton(_ref) {
  var classes = _ref.classes,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      label = _ref.label,
      selected = _ref.selected,
      variant = _ref.variant,
      align = _ref.align,
      typographyClassName = _ref.typographyClassName,
      other = _objectWithoutProperties(_ref, ["classes", "className", "label", "selected", "variant", "align", "typographyClassName"]);

  return createElement(Button$1, _extends$3({
    variant: "text",
    className: clsx(classes.toolbarBtn, className)
  }, other), createElement(ToolbarText, {
    align: align,
    className: typographyClassName,
    variant: variant,
    label: label,
    selected: selected
  }));
};

process.env.NODE_ENV !== "production" ? ToolbarButton.propTypes = {
  selected: propTypes_8.isRequired,
  label: propTypes_4.isRequired,
  classes: propTypes_12.isRequired,
  className: propTypes_4,
  innerRef: propTypes_12
} : void 0;
ToolbarButton.defaultProps = {
  className: ''
};
var styles = createStyles({
  toolbarBtn: {
    padding: 0,
    minWidth: '16px',
    textTransform: 'none'
  }
});
var ToolbarButton$1 = withStyles(styles, {
  name: 'MuiPickersToolbarButton'
})(ToolbarButton);

var useStyles$1$1 = makeStyles(function (theme) {
  return {
    toolbar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      height: 100,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"]
    },
    toolbarLandscape: {
      height: 'auto',
      maxWidth: 150,
      padding: 8,
      justifyContent: 'flex-start'
    }
  };
}, {
  name: 'MuiPickersToolbar'
});

var PickerToolbar = function PickerToolbar(_ref) {
  var children = _ref.children,
      isLandscape = _ref.isLandscape,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      other = _objectWithoutProperties(_ref, ["children", "isLandscape", "className"]);

  var classes = useStyles$1$1();
  return createElement(Toolbar$1, _extends$3({
    className: clsx(classes.toolbar, className, isLandscape && classes.toolbarLandscape)
  }, other), children);
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var PureDateInput = function PureDateInput(_ref) {
  var inputValue = _ref.inputValue,
      inputVariant = _ref.inputVariant,
      validationError = _ref.validationError,
      InputProps = _ref.InputProps,
      onOpen = _ref.openPicker,
      _ref$TextFieldCompone = _ref.TextFieldComponent,
      TextFieldComponent = _ref$TextFieldCompone === void 0 ? TextField$1 : _ref$TextFieldCompone,
      other = _objectWithoutProperties(_ref, ["inputValue", "inputVariant", "validationError", "InputProps", "openPicker", "TextFieldComponent"]);

  var PureDateInputProps = useMemo(function () {
    return _objectSpread$2({}, InputProps, {
      readOnly: true
    });
  }, [InputProps]);
  return createElement(TextFieldComponent, _extends$3({
    error: Boolean(validationError),
    helperText: validationError
  }, other, {
    // do not overridable
    onClick: onOpen,
    value: inputValue,
    variant: inputVariant,
    InputProps: PureDateInputProps,
    onKeyDown: function onKeyDown(e) {
      // space
      if (e.keyCode === 32) {
        e.stopPropagation();
        onOpen();
      }
    }
  }));
};
PureDateInput.displayName = 'PureDateInput';

var KeyboardIcon = function KeyboardIcon(props) {
  return React__default.createElement(SvgIcon$1, props, React__default.createElement("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
  }), React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
};

var getDisplayDate = function getDisplayDate(value, format, utils, isEmpty, _ref) {
  var invalidLabel = _ref.invalidLabel,
      emptyLabel = _ref.emptyLabel,
      labelFunc = _ref.labelFunc;
  var date = utils.date(value);

  if (labelFunc) {
    return labelFunc(isEmpty ? null : date, invalidLabel);
  }

  if (isEmpty) {
    return emptyLabel || '';
  }

  return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
};

var getComparisonMaxDate = function getComparisonMaxDate(utils, strictCompareDates, date) {
  if (strictCompareDates) {
    return date;
  }

  return utils.endOfDay(date);
};

var getComparisonMinDate = function getComparisonMinDate(utils, strictCompareDates, date) {
  if (strictCompareDates) {
    return date;
  }

  return utils.startOfDay(date);
};

var validate = function validate(value, utils, _ref2) {
  var maxDate = _ref2.maxDate,
      minDate = _ref2.minDate,
      disablePast = _ref2.disablePast,
      disableFuture = _ref2.disableFuture,
      maxDateMessage = _ref2.maxDateMessage,
      minDateMessage = _ref2.minDateMessage,
      invalidDateMessage = _ref2.invalidDateMessage,
      strictCompareDates = _ref2.strictCompareDates;
  var parsedValue = utils.date(value); // if null - do not show error

  if (value === null) {
    return '';
  }

  if (!utils.isValid(value)) {
    return invalidDateMessage;
  }

  if (maxDate && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date(maxDate)))) {
    return maxDateMessage;
  }

  if (disableFuture && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date()))) {
    return maxDateMessage;
  }

  if (minDate && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date(minDate)))) {
    return minDateMessage;
  }

  if (disablePast && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date()))) {
    return minDateMessage;
  }

  return '';
};
function makeMaskFromFormat(format, numberMaskChar) {
  return format.replace(/[a-z]/gi, numberMaskChar);
}
var maskedDateFormatter = function maskedDateFormatter(mask, numberMaskChar, refuse) {
  return function (value) {
    var result = '';
    var parsed = value.replace(refuse, '');

    if (parsed === '') {
      return parsed;
    }

    var i = 0;
    var n = 0;

    while (i < mask.length) {
      var maskChar = mask[i];

      if (maskChar === numberMaskChar && n < parsed.length) {
        var parsedChar = parsed[n];
        result += parsedChar;
        n += 1;
      } else {
        result += maskChar;
      }

      i += 1;
    }

    return result;
  };
};

function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var KeyboardDateInput = function KeyboardDateInput(_ref) {
  var inputValue = _ref.inputValue,
      inputVariant = _ref.inputVariant,
      validationError = _ref.validationError,
      KeyboardButtonProps = _ref.KeyboardButtonProps,
      InputAdornmentProps = _ref.InputAdornmentProps,
      onOpen = _ref.openPicker,
      onChange = _ref.onChange,
      InputProps = _ref.InputProps,
      mask = _ref.mask,
      _ref$maskChar = _ref.maskChar,
      maskChar = _ref$maskChar === void 0 ? '_' : _ref$maskChar,
      _ref$refuse = _ref.refuse,
      refuse = _ref$refuse === void 0 ? /[^\d]+/gi : _ref$refuse,
      format = _ref.format,
      keyboardIcon = _ref.keyboardIcon,
      disabled = _ref.disabled,
      rifmFormatter = _ref.rifmFormatter,
      _ref$TextFieldCompone = _ref.TextFieldComponent,
      TextFieldComponent = _ref$TextFieldCompone === void 0 ? TextField$1 : _ref$TextFieldCompone,
      other = _objectWithoutProperties(_ref, ["inputValue", "inputVariant", "validationError", "KeyboardButtonProps", "InputAdornmentProps", "openPicker", "onChange", "InputProps", "mask", "maskChar", "refuse", "format", "keyboardIcon", "disabled", "rifmFormatter", "TextFieldComponent"]);

  var inputMask = mask || makeMaskFromFormat(format, maskChar); // prettier-ignore

  var formatter = useMemo(function () {
    return maskedDateFormatter(inputMask, maskChar, refuse);
  }, [inputMask, maskChar, refuse]);
  var position = InputAdornmentProps && InputAdornmentProps.position ? InputAdornmentProps.position : 'end';

  var handleChange = function handleChange(text) {
    var finalString = text === '' || text === inputMask ? null : text;
    onChange(finalString);
  };

  return createElement(Rifm, {
    key: inputMask,
    value: inputValue,
    onChange: handleChange,
    refuse: refuse,
    format: rifmFormatter || formatter
  }, function (_ref2) {
    var onChange = _ref2.onChange,
        value = _ref2.value;
    return createElement(TextFieldComponent, _extends$3({
      disabled: disabled,
      error: Boolean(validationError),
      helperText: validationError
    }, other, {
      value: value,
      onChange: onChange,
      variant: inputVariant,
      InputProps: _objectSpread$1$1({}, InputProps, _defineProperty({}, "".concat(position, "Adornment"), createElement(InputAdornment$1, _extends$3({
        position: position
      }, InputAdornmentProps), createElement(IconButton$1, _extends$3({
        disabled: disabled
      }, KeyboardButtonProps, {
        onClick: onOpen
      }), keyboardIcon))))
    }));
  });
};
KeyboardDateInput.defaultProps = {
  keyboardIcon: createElement(KeyboardIcon, null)
};

function useOpenState(_ref) {
  var open = _ref.open,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose;
  var setIsOpenState = null;

  if (open === undefined || open === null) {
    // The component is uncontrolled, so we need to give it its own state.
    var _useState = useState(false);

    var _useState2 = _slicedToArray(_useState, 2);

    open = _useState2[0];
    setIsOpenState = _useState2[1];
  } // prettier-ignore


  var setIsOpen = useCallback(function (newIsOpen) {
    setIsOpenState && setIsOpenState(newIsOpen);
    return newIsOpen ? onOpen && onOpen() : onClose && onClose();
  }, [onOpen, onClose, setIsOpenState]);
  return {
    isOpen: open,
    setIsOpen: setIsOpen
  };
}

var useValueToDate = function useValueToDate(utils, _ref) {
  var value = _ref.value,
      initialFocusedDate = _ref.initialFocusedDate;
  var nowRef = useRef(utils.date());
  var date = utils.date(value || initialFocusedDate || nowRef.current);
  return date && utils.isValid(date) ? date : nowRef.current;
};

function useDateValues(props, options) {
  var utils = useUtils();
  var date = useValueToDate(utils, props);
  var format = props.format || options.getDefaultFormat();
  return {
    date: date,
    format: format
  };
}

function usePickerState(props, options) {
  var autoOk = props.autoOk,
      disabled = props.disabled,
      readOnly = props.readOnly,
      onAccept = props.onAccept,
      _onChange = props.onChange,
      onError = props.onError,
      value = props.value,
      variant = props.variant;
  var utils = useUtils();

  var _useOpenState = useOpenState(props),
      isOpen = _useOpenState.isOpen,
      setIsOpen = _useOpenState.setIsOpen;

  var _useDateValues = useDateValues(props, options),
      date = _useDateValues.date,
      format = _useDateValues.format;

  var _useState = useState(date),
      _useState2 = _slicedToArray(_useState, 2),
      pickerDate = _useState2[0],
      setPickerDate = _useState2[1];

  useEffect(function () {
    // if value was changed in closed state - treat it as accepted
    if (!isOpen && !utils.isEqual(pickerDate, date)) {
      setPickerDate(date);
    }
  }, [date, isOpen, pickerDate, utils]);
  var acceptDate = useCallback(function (acceptedDate) {
    _onChange(acceptedDate);

    if (onAccept) {
      onAccept(acceptedDate);
    }

    setIsOpen(false);
  }, [onAccept, _onChange, setIsOpen]);
  var wrapperProps = useMemo(function () {
    return {
      format: format,
      open: isOpen,
      onClear: function onClear() {
        return acceptDate(null);
      },
      onAccept: function onAccept() {
        return acceptDate(pickerDate);
      },
      onSetToday: function onSetToday() {
        return setPickerDate(utils.date());
      },
      onDismiss: function onDismiss() {
        setIsOpen(false);
      }
    };
  }, [acceptDate, format, isOpen, pickerDate, setIsOpen, utils]);
  var pickerProps = useMemo(function () {
    return {
      date: pickerDate,
      onChange: function onChange(newDate) {
        var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        setPickerDate(newDate);

        if (isFinish && autoOk) {
          acceptDate(newDate);
          return;
        } // simulate autoOk, but do not close the modal


        if (variant === 'inline' || variant === 'static') {
          _onChange(newDate);

          onAccept && onAccept(newDate);
        }
      }
    };
  }, [acceptDate, autoOk, onAccept, _onChange, pickerDate, variant]);
  var validationError = validate(value, utils, props);
  useEffect(function () {
    if (onError) {
      onError(validationError, value);
    }
  }, [onError, validationError, value]);
  var inputValue = getDisplayDate(date, format, utils, value === null, props);
  var inputProps = useMemo(function () {
    return {
      inputValue: inputValue,
      validationError: validationError,
      openPicker: function openPicker() {
        return !readOnly && !disabled && setIsOpen(true);
      }
    };
  }, [disabled, inputValue, readOnly, setIsOpen, validationError]);
  var pickerState = {
    pickerProps: pickerProps,
    inputProps: inputProps,
    wrapperProps: wrapperProps
  };
  useDebugValue(pickerState);
  return pickerState;
}

function ownKeys$2$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2$1(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseInputString(value, utils, format) {
  try {
    return utils.parse(value, format);
  } catch (_unused) {
    return null;
  }
}

function useKeyboardPickerState(props, options) {
  var _props$format = props.format,
      format = _props$format === void 0 ? options.getDefaultFormat() : _props$format,
      inputValue = props.inputValue,
      _onChange = props.onChange,
      value = props.value;
  var utils = useUtils();
  var displayDate = getDisplayDate(value, format, utils, value === null, props);

  var _useState = useState(displayDate),
      _useState2 = _slicedToArray(_useState, 2),
      innerInputValue = _useState2[0],
      setInnerInputValue = _useState2[1];

  var dateValue = inputValue ? parseInputString(inputValue, utils, format) : value;
  useEffect(function () {
    if (value === null || utils.isValid(value)) {
      setInnerInputValue(displayDate);
    }
  }, [displayDate, setInnerInputValue, utils, value]);
  var handleKeyboardChange = useCallback(function (date) {
    _onChange(date, date === null ? null : utils.format(date, format));
  }, [format, _onChange, utils]);

  var _usePickerState = usePickerState( // Extend props interface
  _objectSpread$2$1({}, props, {
    value: dateValue,
    onChange: handleKeyboardChange
  }), options),
      innerInputProps = _usePickerState.inputProps,
      wrapperProps = _usePickerState.wrapperProps,
      pickerProps = _usePickerState.pickerProps;

  var inputProps = useMemo(function () {
    return _objectSpread$2$1({}, innerInputProps, {
      // reuse validation and open/close logic
      format: wrapperProps.format,
      inputValue: inputValue || innerInputValue,
      onChange: function onChange(value) {
        setInnerInputValue(value || '');
        var date = value === null ? null : utils.parse(value, wrapperProps.format);

        _onChange(date, value);
      }
    });
  }, [innerInputProps, innerInputValue, inputValue, _onChange, utils, wrapperProps.format]);
  return {
    inputProps: inputProps,
    wrapperProps: wrapperProps,
    pickerProps: pickerProps
  };
}

function makePickerWithState(_ref) {
  var Input = _ref.Input,
      useState = _ref.useState,
      useOptions = _ref.useOptions,
      getCustomProps = _ref.getCustomProps,
      DefaultToolbarComponent = _ref.DefaultToolbarComponent;

  function PickerWithState(props) {
    var allowKeyboardControl = props.allowKeyboardControl,
        ampm = props.ampm,
        animateYearScrolling = props.animateYearScrolling;
        props.autoOk;
        var dateRangeIcon = props.dateRangeIcon,
        disableFuture = props.disableFuture,
        disablePast = props.disablePast,
        disableToolbar = props.disableToolbar;
        props.emptyLabel;
        props.format;
        props.forwardedRef;
        var hideTabs = props.hideTabs;
        props.initialFocusedDate;
        props.invalidDateMessage;
        props.invalidLabel;
        props.labelFunc;
        var leftArrowButtonProps = props.leftArrowButtonProps,
        leftArrowIcon = props.leftArrowIcon,
        loadingIndicator = props.loadingIndicator,
        maxDate = props.maxDate;
        props.maxDateMessage;
        var minDate = props.minDate;
        props.minDateMessage;
        var minutesStep = props.minutesStep;
        props.onAccept;
        props.onChange;
        props.onClose;
        var onMonthChange = props.onMonthChange;
        props.onOpen;
        var onYearChange = props.onYearChange,
        openTo = props.openTo,
        orientation = props.orientation,
        renderDay = props.renderDay,
        rightArrowButtonProps = props.rightArrowButtonProps,
        rightArrowIcon = props.rightArrowIcon,
        shouldDisableDate = props.shouldDisableDate,
        strictCompareDates = props.strictCompareDates,
        timeIcon = props.timeIcon,
        _props$ToolbarCompone = props.ToolbarComponent,
        ToolbarComponent = _props$ToolbarCompone === void 0 ? DefaultToolbarComponent : _props$ToolbarCompone;
        props.value;
        var variant = props.variant,
        views = props.views,
        other = _objectWithoutProperties(props, ["allowKeyboardControl", "ampm", "animateYearScrolling", "autoOk", "dateRangeIcon", "disableFuture", "disablePast", "disableToolbar", "emptyLabel", "format", "forwardedRef", "hideTabs", "initialFocusedDate", "invalidDateMessage", "invalidLabel", "labelFunc", "leftArrowButtonProps", "leftArrowIcon", "loadingIndicator", "maxDate", "maxDateMessage", "minDate", "minDateMessage", "minutesStep", "onAccept", "onChange", "onClose", "onMonthChange", "onOpen", "onYearChange", "openTo", "orientation", "renderDay", "rightArrowButtonProps", "rightArrowIcon", "shouldDisableDate", "strictCompareDates", "timeIcon", "ToolbarComponent", "value", "variant", "views"]);

    var injectedProps = getCustomProps ? getCustomProps(props) : {};
    var options = useOptions(props);

    var _useState = useState(props, options),
        pickerProps = _useState.pickerProps,
        inputProps = _useState.inputProps,
        wrapperProps = _useState.wrapperProps;

    return createElement(Wrapper, _extends$3({
      variant: variant,
      InputComponent: Input,
      DateInputProps: inputProps
    }, injectedProps, wrapperProps, other), createElement(Picker, _extends$3({}, pickerProps, {
      allowKeyboardControl: allowKeyboardControl,
      ampm: ampm,
      animateYearScrolling: animateYearScrolling,
      dateRangeIcon: dateRangeIcon,
      disableFuture: disableFuture,
      disablePast: disablePast,
      disableToolbar: disableToolbar,
      hideTabs: hideTabs,
      leftArrowButtonProps: leftArrowButtonProps,
      leftArrowIcon: leftArrowIcon,
      loadingIndicator: loadingIndicator,
      maxDate: maxDate,
      minDate: minDate,
      minutesStep: minutesStep,
      onMonthChange: onMonthChange,
      onYearChange: onYearChange,
      openTo: openTo,
      orientation: orientation,
      renderDay: renderDay,
      rightArrowButtonProps: rightArrowButtonProps,
      rightArrowIcon: rightArrowIcon,
      shouldDisableDate: shouldDisableDate,
      strictCompareDates: strictCompareDates,
      timeIcon: timeIcon,
      ToolbarComponent: ToolbarComponent,
      views: views
    })));
  }

  return PickerWithState;
}

var useStyles = makeStyles({
  toolbar: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  toolbarLandscape: {
    padding: 16
  },
  dateLandscape: {
    marginRight: 16
  }
}, {
  name: 'MuiPickersDatePickerRoot'
});
var DatePickerToolbar = function DatePickerToolbar(_ref) {
  var date = _ref.date,
      views = _ref.views,
      setOpenView = _ref.setOpenView,
      isLandscape = _ref.isLandscape,
      openView = _ref.openView;
  var utils = useUtils();
  var classes = useStyles();
  var isYearOnly = useMemo(function () {
    return isYearOnlyView(views);
  }, [views]);
  var isYearAndMonth = useMemo(function () {
    return isYearAndMonthViews(views);
  }, [views]);
  return createElement(PickerToolbar, {
    isLandscape: isLandscape,
    className: clsx(!isYearOnly && classes.toolbar, isLandscape && classes.toolbarLandscape)
  }, createElement(ToolbarButton$1, {
    variant: isYearOnly ? 'h3' : 'subtitle1',
    onClick: function onClick() {
      return setOpenView('year');
    },
    selected: openView === 'year',
    label: utils.getYearText(date)
  }), !isYearOnly && !isYearAndMonth && createElement(ToolbarButton$1, {
    variant: "h4",
    selected: openView === 'date',
    onClick: function onClick() {
      return setOpenView('date');
    },
    align: isLandscape ? 'left' : 'center',
    label: utils.getDatePickerHeaderText(date),
    className: clsx(isLandscape && classes.dateLandscape)
  }), isYearAndMonth && createElement(ToolbarButton$1, {
    variant: "h4",
    onClick: function onClick() {
      return setOpenView('month');
    },
    selected: openView === 'month',
    label: utils.getMonthText(date)
  }));
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultProps = _objectSpread$1({}, datePickerDefaultProps, {
  openTo: 'date',
  views: ['year', 'date']
});

function useOptions(props) {
  var utils = useUtils();
  return {
    getDefaultFormat: function getDefaultFormat() {
      return getFormatByViews(props.views, utils);
    }
  };
}

var DatePicker = makePickerWithState({
  useOptions: useOptions,
  Input: PureDateInput,
  useState: usePickerState,
  DefaultToolbarComponent: DatePickerToolbar
});
var KeyboardDatePicker = makePickerWithState({
  useOptions: useOptions,
  Input: KeyboardDateInput,
  useState: useKeyboardPickerState,
  DefaultToolbarComponent: DatePickerToolbar
});
DatePicker.defaultProps = defaultProps;
KeyboardDatePicker.defaultProps = defaultProps;

var css_248z$8 = ".MuiDialog-root {\n  z-index: 9999 !important; }\n\n.MuiInputAdornment-root .MuiIconButton-root {\n  color: #000 !important;\n  padding: 0px; }\n";
styleInject(css_248z$8);

function Datepicker(_ref) {
  var value = _ref.value,
      change = _ref.change,
      disabled = _ref.disabled;
  var theme = createTheme({
    palette: {
      type: "dark"
    },
    overrides: {
      MuiInputBase: {
        input: {
          padding: "inherit"
        },
        formControl: {
          boxSizing: "border-box",
          outline: "0",
          border: "0",
          borderRadius: "4px",
          textOverflow: "ellipsis",
          background: "#fff",
          minHeight: "36px",
          color: "#000",
          padding: "0 7px",
          fontSize: "13px"
        }
      }
    }
  });
  return /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils
  }, /*#__PURE__*/React__default.createElement(KeyboardDatePicker, {
    className: "date-picker-dialog",
    format: "MM/dd/yyyy",
    value: value,
    disablePast: true,
    disabled: disabled,
    onChange: change,
    KeyboardButtonProps: {
      "aria-label": "change date"
    },
    autoOk: true,
    InputProps: {
      disableUnderline: true,
      placeholder: "Select date",
      disabled: disabled
    },
    keyboardIcon: /*#__PURE__*/React__default.createElement(Icon, {
      name: "calendar",
      color: "#1D1C38"
    })
  })));
}
Datepicker.defaultProps = {
  disabled: false,
  value: new Date()
};
Datepicker.propTypes = {
  value: PropTypes.instanceOf(Date),
  change: PropTypes.func,
  disabled: PropTypes.bool
};

var css_248z$7 = "* {\n  margin: 0;\n  padding: 0;\n  list-style-type: none; }\n\n* {\n  scrollbar-width: none;\n  /* Firefox */\n  -ms-overflow-style: none;\n  /* IE 10+ */ }\n  * ::-webkit-scrollbar-track {\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    background-color: transparent; }\n  * ::-webkit-scrollbar {\n    width: 3px !important;\n    background-color: transparent; }\n  * ::-webkit-scrollbar-thumb {\n    background-color: transparent; }\n\n.on-scrollbar {\n  scrollbar-width: thin;\n  -ms-overflow-style: none; }\n  .on-scrollbar::-webkit-scrollbar {\n    width: 3px !important;\n    height: 3px !important;\n    background-color: #fff; }\n  .on-scrollbar::-webkit-scrollbar-thumb {\n    background-color: #dadada !important; }\n\n.templete_navigation_frame_wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  align-items: flex-start; }\n  .templete_navigation_frame_wrapper .template_navigation_frame_panel_viewer {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    height: 100%;\n    flex-basis: 90%;\n    position: relative;\n    padding-left: 130px; }\n    @media (max-width: 769px) {\n      .templete_navigation_frame_wrapper .template_navigation_frame_panel_viewer {\n        width: 100%;\n        left: 0;\n        padding-left: 0;\n        justify-content: center; } }\n  .templete_navigation_frame_wrapper .template_navigation_steps_wrapper {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n    gap: 7px;\n    flex-basis: 10%;\n    align-items: flex-start; }\n    @media (max-width: 769px) {\n      .templete_navigation_frame_wrapper .template_navigation_steps_wrapper {\n        justify-content: flex-end;\n        bottom: 3em;\n        position: relative; } }\n    .templete_navigation_frame_wrapper .template_navigation_steps_wrapper .step__selector__wrapper {\n      display: flex;\n      align-items: center;\n      gap: 1em;\n      line-height: 20px;\n      font-size: 12px;\n      gap: 2em; }\n      .templete_navigation_frame_wrapper .template_navigation_steps_wrapper .step__selector__wrapper .step__selector {\n        width: 10px;\n        height: 10px;\n        background: #dadada;\n        border-radius: 50%; }\n      .templete_navigation_frame_wrapper .template_navigation_steps_wrapper .step__selector__wrapper .selected {\n        background: var(--blue) !important; }\n";
styleInject(css_248z$7);

var TemplateNavigationForm = function TemplateNavigationForm(props) {
  var selectedCategoryIndex = get(props, "templateStructure", []).findIndex(function (category) {
    return category._id === props.selectorCategoryId;
  });
  var stepsClickedAllowed = props.stepsClickedAllowed;

  var getIndexOfCurrentSelectedCategory = function getIndexOfCurrentSelectedCategory(indexOfCategory) {
    if (indexOfCategory <= selectedCategoryIndex) {
      return "selected";
    }

    return "";
  };

  var renderTemplateStructure = function renderTemplateStructure() {
    return props.templateStructure[selectedCategoryIndex].template;
  };

  var _onCategorySelected = function _onCategorySelected(rotator) {
    props.onCategorySelect(rotator);
  };

  useEffect(function () {
    props.brandingColor && document.documentElement.style.setProperty("--blue", props.brandingColor) || null;
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "templete_navigation_frame_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "template_navigation_frame_panel_viewer"
  }, renderTemplateStructure()), props.showSteps && /*#__PURE__*/React__default.createElement("div", {
    className: "template_navigation_steps_wrapper"
  }, props.templateStructure.map(function (template, rotator) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "step__selector__wrapper",
      key: rotator
    }, /*#__PURE__*/React__default.createElement("div", {
      onClick: function onClick() {
        return stepsClickedAllowed && _onCategorySelected(rotator);
      },
      className: "".concat(getIndexOfCurrentSelectedCategory(rotator), " step__selector")
    }), props.showStepName && /*#__PURE__*/React__default.createElement("div", {
      className: "step__name",
      onClick: function onClick() {
        return _onCategorySelected(rotator);
      }
    }, template.category__name) || null);
  })) || null);
};

TemplateNavigationForm.propTypes = {
  showSteps: false,
  stepsClickedAllowed: false,
  brandingColor: "#04d2c6"
};
TemplateNavigationForm.propTypes = {
  selectorCategoryId: PropTypes.string,
  templateStructure: PropTypes.arrayOf(PropTypes.object),
  onCategorySelect: PropTypes.func,
  stepsClickedAllowed: PropTypes.bool,
  showSteps: PropTypes.bool,
  showStepName: PropTypes.bool,
  brandingColor: PropTypes.string
};

var css_248z$6 = "* {\n  margin: 0;\n  padding: 0;\n  list-style-type: none; }\n\n* {\n  scrollbar-width: none;\n  /* Firefox */\n  -ms-overflow-style: none;\n  /* IE 10+ */ }\n  * ::-webkit-scrollbar-track {\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    background-color: transparent; }\n  * ::-webkit-scrollbar {\n    width: 3px !important;\n    background-color: transparent; }\n  * ::-webkit-scrollbar-thumb {\n    background-color: transparent; }\n\n.on-scrollbar {\n  scrollbar-width: thin;\n  -ms-overflow-style: none; }\n  .on-scrollbar::-webkit-scrollbar {\n    width: 3px !important;\n    height: 3px !important;\n    background-color: #fff; }\n  .on-scrollbar::-webkit-scrollbar-thumb {\n    background-color: #dadada !important; }\n\n.selector__wrapper__calander, .peek__static__calander .calander__header span.header__button, .peek__static__calander table td.calander__selected_date_block span {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n  width: 19px;\n  height: 19px;\n  background: var(--blue);\n  color: #ffffff;\n  font-weight: bolder;\n  border-radius: 50%;\n  cursor: pointer; }\n\n.peek__static__calander {\n  background: #ffffff;\n  max-width: 300px;\n  border-radius: 4px;\n  padding: 16px 15px 22px;\n  box-sizing: border-box;\n  user-select: none;\n  /* supported by Chrome and Opera */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  box-shadow: 0px 10px 60px rgba(0, 0, 0, 0.1);\n  border-radius: 13px; }\n  @media (max-width: 769px) {\n    .peek__static__calander {\n      width: 100%;\n      max-width: 100%; } }\n  .peek__static__calander .calander__header {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: 16px; }\n    .peek__static__calander .calander__header .header__month__name {\n      font-weight: 700;\n      font-size: 14px;\n      line-height: 17px;\n      color: #383838; }\n    .peek__static__calander .calander__header .header__button__wrapper {\n      display: flex;\n      align-items: center;\n      flex-direction: row;\n      gap: 9px; }\n    .peek__static__calander .calander__header span.header__button {\n      padding: 10px 4px; }\n  .peek__static__calander .cell_value, .peek__static__calander table th, .peek__static__calander table td {\n    font-size: 11px;\n    line-height: 13px;\n    font-weight: 400;\n    flex-basis: 10%;\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    color: #1d1c38; }\n    .peek__static__calander .cell_value span.__span__wrapper, .peek__static__calander table th span.__span__wrapper, .peek__static__calander table td span.__span__wrapper {\n      text-align: center;\n      width: 100%; }\n  .peek__static__calander table {\n    width: 100%;\n    height: 179px; }\n    .peek__static__calander table .calander__row {\n      display: flex;\n      align-items: center;\n      flex-direction: row;\n      justify-content: space-between;\n      box-sizing: border-box;\n      height: 22px; }\n    .peek__static__calander table th {\n      color: #383838;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 1.2px; }\n      @media (max-width: 769px) {\n        .peek__static__calander table th {\n          color: rgba(60, 60, 67, 0.3); } }\n    .peek__static__calander table td.disabled__calander__cell {\n      color: #979797;\n      cursor: not-allowed;\n      pointer-events: none; }\n    @media (max-width: 769px) {\n      .peek__static__calander table td.calander__selected_date_block {\n        padding: 0.8em 0; } }\n    .peek__static__calander table td {\n      cursor: pointer;\n      padding: 7px 3px; }\n";
styleInject(css_248z$6);

var StaticCalander = function StaticCalander(props) {
  var _date = props._date;

  var _useState = useState(new Date(_date)),
      _useState2 = _slicedToArray$1(_useState, 2),
      currentMonth = _useState2[0],
      setCurrentMonth = _useState2[1];

  var _useState3 = useState(new Date(_date)),
      _useState4 = _slicedToArray$1(_useState3, 2),
      selectedDate = _useState4[0],
      setSelectedDate = _useState4[1];

  var __renderHeader = function __renderHeader() {
    var DateFormat = "MMM yyyy";
    return /*#__PURE__*/React__default.createElement("div", {
      className: "calander__header row flexMiddle"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "header__month__name"
    }, format(currentMonth, DateFormat)), /*#__PURE__*/React__default.createElement("div", {
      className: "header__button__wrapper"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "header__button",
      onClick: function onClick() {
        return __goToPrevMonth();
      }
    }, /*#__PURE__*/React__default.createElement(MemoSvgChevronLeft, null)), /*#__PURE__*/React__default.createElement("span", {
      className: "header__button",
      onClick: function onClick() {
        return __goToNextMonth();
      }
    }, /*#__PURE__*/React__default.createElement(MemoSvgChevronRight, null))));
  };

  var __renderDays = function __renderDays() {
    var DateFormat = "E";
    var __days = [];

    var __startDate = startOfWeek(currentMonth);

    for (var i = 0; i < 7; i++) {
      __days.push( /*#__PURE__*/React__default.createElement("th", {
        key: "header_".concat(i),
        className: "calander__column calander__cell"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "__span__wrapper"
      }, format(addDays(__startDate, i), DateFormat))));
    }

    return /*#__PURE__*/React__default.createElement("tr", {
      className: "calander__row",
      key: "tr_".concat(Math.random()).concat(new Date().getTime())
    }, __days);
  };

  var __renderDateBox = function __renderDateBox() {
    var disabledPast = props.disabledPast;
    var monthStart = startOfMonth(currentMonth);
    var monthEnd = endOfMonth(monthStart);
    var startDate = startOfWeek(monthStart);
    var endDate = endOfWeek(monthEnd);
    var __dateFormat = "d";
    var __rows = [];
    var __days = [];
    var __day = startDate;
    var __formattedDate = "";

    while (__day <= endDate) {
      var _loop = function _loop(i) {
        __formattedDate = format(__day, __dateFormat);
        var __clonedValue = __day;

        var __customClassName = isSameDay(__day, selectedDate) && "calander__selected_date_block" || "";

        var _isPast = isPast(__day);

        var _customClassName = (!isSameMonth(__day, monthStart) || disabledPast && _isPast) && "disabled__calander__cell" || "";

        var __date_html = /*#__PURE__*/React__default.createElement("td", {
          key: i,
          className: "calander__column calander__cell ".concat(_customClassName, "  ").concat(__customClassName)
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "__span__wrapper",
          onClick: function onClick() {
            return __onDateSelected(__clonedValue);
          }
        }, __formattedDate));

        __days.push(__date_html);

        __day = addDays(__day, 1);
      };

      for (var i = 0; i < 7; i++) {
        _loop(i);
      }

      var __daysWrapper = /*#__PURE__*/React__default.createElement("tr", {
        className: "calander__row"
      }, __days);

      __rows.push(__daysWrapper);

      __days = [];
    }

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, __rows);
  };

  var __onDateSelected = function __onDateSelected(day) {
    var handleDateChange = props.handleDateChange;
    setSelectedDate(day);
    handleDateChange(day);
  };

  var __goToNextMonth = function __goToNextMonth() {
    var newMonth = addMonths(currentMonth, 1);
    setCurrentMonth(newMonth);
  };

  var __goToPrevMonth = function __goToPrevMonth() {
    var newMonth = subMonths(currentMonth, 1);
    setCurrentMonth(newMonth);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "peek__static__calander"
  }, __renderHeader(), /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("tbody", null, __renderDays(), __renderDateBox())));
};

StaticCalander.defaultProps = {
  _date: new Date()
};
StaticCalander.propTypes = {
  disabledPast: PropTypes.bool,
  _date: PropTypes.date,
  handleDateChange: PropTypes.func
};

var css_248z$5 = ".chip, .listing__info__tile .thumbnail__wrapper span.tag, .listing__info__tile .thumbnail__wrapper span.price {\n  padding: 7px 15px;\n  background: #fff;\n  border-radius: 35px;\n  box-sizing: border-box;\n  font-size: 10px;\n  line-height: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  letter-spacing: 0.02em; }\n\n.listing__info__tile {\n  width: 100% !important;\n  height: auto !important;\n  border-radius: 5px;\n  box-sizing: border-box;\n  display: flex;\n  color: #1d1c38;\n  flex-direction: column;\n  box-shadow: 0px 2px 5px #ebeff1, 0px 0px 20px #ebeff1;\n  font-family: \"Roboto-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\";\n  position: relative; }\n  @media screen and (max-width: 799px) {\n    .listing__info__tile {\n      max-width: 48%; } }\n  @media screen and (max-width: 600px) {\n    .listing__info__tile {\n      max-width: 100%; } }\n  .listing__info__tile.is_active {\n    border: 1px solid var(--blue); }\n  .listing__info__tile .thumbnail__container {\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    background: #d2d2d2;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    border-radius: 5px 5px 0px 0px;\n    object-fit: cover;\n    position: relative; }\n  .listing__info__tile .thumbnail__wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 66.66588%; }\n    .listing__info__tile .thumbnail__wrapper img {\n      position: absolute;\n      top: 0%;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover; }\n    .listing__info__tile .thumbnail__wrapper span.tag {\n      top: 8px;\n      position: absolute;\n      left: 8px;\n      color: #fff; }\n    .listing__info__tile .thumbnail__wrapper span.price {\n      position: absolute;\n      bottom: 8px;\n      left: 8px; }\n  .listing__info__tile .listing_information_wrapper {\n    width: 100%;\n    gap: 18.44px;\n    display: flex;\n    flex-direction: column;\n    padding: 1em;\n    box-sizing: border-box; }\n    .listing__info__tile .listing_information_wrapper .address_wrapper {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: block !important;\n      font-weight: 500; }\n  .listing__info__tile .addon__information {\n    display: flex;\n    box-sizing: border-box;\n    justify-content: space-between; }\n    .listing__info__tile .addon__information .bath_bed_info {\n      display: flex;\n      flex-direction: row;\n      gap: 20px; }\n      .listing__info__tile .addon__information .bath_bed_info .bedroom_unit_wrapper {\n        display: flex;\n        gap: 7px; }\n        .listing__info__tile .addon__information .bath_bed_info .bedroom_unit_wrapper .value {\n          color: #1d1c38; }\n        .listing__info__tile .addon__information .bath_bed_info .bedroom_unit_wrapper:first-child span:first-child {\n          font-size: 20px; }\n        .listing__info__tile .addon__information .bath_bed_info .bedroom_unit_wrapper span {\n          display: flex;\n          align-items: center;\n          color: var(--blue); }\n    .listing__info__tile .addon__information button {\n      border: 1px solid #1d1c38;\n      box-sizing: border-box;\n      border-radius: 5px;\n      background: transparent;\n      padding: 7px 13px;\n      justify-content: space-around;\n      column-gap: 10px;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 12px;\n      letter-spacing: 0em;\n      height: 24px;\n      display: flex;\n      align-items: center;\n      cursor: pointer; }\n  .listing__info__tile .listing__amenities__wrapper {\n    max-height: 219px;\n    min-width: 130px;\n    position: absolute;\n    overflow: auto;\n    padding: 1em;\n    bottom: 5em;\n    right: 1em;\n    background: #ffffff;\n    /* box-shadow-m */\n    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.25);\n    border-radius: 5px;\n    font-size: 10px;\n    line-height: 16px;\n    gap: 1em;\n    display: flex;\n    flex-direction: column; }\n    .listing__info__tile .listing__amenities__wrapper ul {\n      padding-left: 1em; }\n\nli.amenities_list {\n  display: flex;\n  gap: 6px;\n  align-items: center; }\n";
styleInject(css_248z$5);

var img = "data:image/png;base64,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";

var ListingTile = function ListingTile(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      showAmenties = _useState2[0],
      setShowAmenities = _useState2[1];

  var absolute_rgb = getComputedStyle(document.documentElement).getPropertyValue("--blue");
  var rgbaColor = absolute_rgb.toString().replace("#", "").trim().convertToRGB();
  rgbaColor.push(0.5);

  var getStatus = function getStatus() {
    var _props$data = props.data,
        is_archived = _props$data.is_archived,
        is_sales_listing = _props$data.is_sales_listing,
        is_coming_soon = _props$data.is_coming_soon;

    if (is_archived || is_coming_soon) {
      if (is_archived && is_sales_listing) {
        return "Sold";
      }

      if (is_archived) {
        return "Rented";
      }
    }

    if (is_coming_soon) {
      return "Coming soon";
    }

    return "";
  };

  var showRentFlag = function showRentFlag() {
    if (get(props, "data.is_sales_listing", false)) {
      return get(props, "data.price", 0) !== 0;
    }

    return get(props, "data.rent", 0) !== 0;
  };

  var thumbnailUrl = encodeURI(process.env.imageBasePath + props.data.thumbnails[0]);
  var address = get(props, "data.building.formatted_address", "").split(",")[0];
  return /*#__PURE__*/React__default.createElement("div", {
    className: ["listing__info__tile", get(props, "selectedListingId", "") === get(props.data, "_id", "") && "is_active"].join(" "),
    onClick: function onClick() {
      return props.onClick && props.onClick();
    },
    title: "".concat(get(props.data, "building.alternate_name", ""), " ").concat(get(props.data, "building.alternate_name", "") && "(" || "", " ").concat(address, " ").concat(get(props.data, "building.alternate_name", "") && ")" || "", ", ").concat(get(props.data, "unit", ""))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "thumbnail__container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "thumbnail__wrapper"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(thumbnailUrl),
    onError: function onError(e) {
      e.target.src = img;
    },
    alt: "image__path"
  }), showRentFlag() && /*#__PURE__*/React__default.createElement("span", {
    className: "price"
  }, !get(props, "data.is_sales_listing", false) && "".concat(API$1.convertIntoCurrency(get(props, "data.rent", 0)), "/mo") || API$1.convertIntoCurrency(get(props, "data.price", 0))) || null, props.showStatus && getStatus() && /*#__PURE__*/React__default.createElement("span", {
    className: "tag",
    style: {
      backgroundColor: "rgba(".concat(rgbaColor.join(), ")")
    }
  }, getStatus()) || null)), /*#__PURE__*/React__default.createElement("div", {
    className: "listing_information_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "address_wrapper"
  }, get(props.data, "building.alternate_name", ""), "\xA0", "".concat(get(props.data, "building.alternate_name", "") && "(" || "", " ").concat(address, " ").concat(get(props.data, "building.alternate_name", "") && ")" || ""), get(props.data, "unit", "") && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, ",\xA0 ") || "", get(props.data, "unit", "")), /*#__PURE__*/React__default.createElement("div", {
    className: "addon__information"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bath_bed_info"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bedroom_unit_wrapper"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(MemoSvgBeds, null)), /*#__PURE__*/React__default.createElement("span", {
    className: "value"
  }, get(props, "data.bedroom_unit", 0))), /*#__PURE__*/React__default.createElement("div", {
    className: "bedroom_unit_wrapper"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(MemoSvgBaths, null)), /*#__PURE__*/React__default.createElement("span", {
    className: "value"
  }, get(props, "data.bathroom_unit", 0)))), /*#__PURE__*/React__default.createElement("div", null, get(props, "data.amenities", []).length + get(props, "data.building_amenities", []).length && /*#__PURE__*/React__default.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      setShowAmenities(function (showAmenties) {
        return !showAmenties;
      });
    }
  }, /*#__PURE__*/React__default.createElement(MemoSvgStar, null), get(props, "data.amenities", []).length + get(props, "data.building_amenities", []).length && get(props, "data.amenities", []).length + get(props, "data.building_amenities", []).length || null, " Amenities") || null))), showAmenties && /*#__PURE__*/React__default.createElement("div", {
    className: "listing__amenities__wrapper"
  }, get(props, "data.amenities", []).length && /*#__PURE__*/React__default.createElement("div", {
    className: "listing__amenity_list"
  }, /*#__PURE__*/React__default.createElement("span", null, "In-unit amenities: "), /*#__PURE__*/React__default.createElement("ul", null, get(props, "data.amenities", []).map(function (amenity, key) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: "amenities_list",
      key: key
    }, /*#__PURE__*/React__default.createElement("span", null, "\u2022"), /*#__PURE__*/React__default.createElement("span", null, amenity));
  }))) || null, get(props, "data.building_amenities", []).length && /*#__PURE__*/React__default.createElement("div", {
    className: "listing__amenity_list"
  }, /*#__PURE__*/React__default.createElement("span", null, "Property amenities: "), /*#__PURE__*/React__default.createElement("ul", null, get(props, "data.building_amenities", []).map(function (amenity, index) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: "amenities_list",
      key: index
    }, /*#__PURE__*/React__default.createElement("span", null, "\u2022"), /*#__PURE__*/React__default.createElement("span", null, amenity));
  }))) || null) || null);
};

ListingTile.defaultProps = {
  showStatus: true
};
ListingTile.propTypes = {
  data: PropTypes.object.isRequired,
  showStatus: PropTypes.bool,
  selectedListingId: PropTypes.string,
  onClick: PropTypes.func
};
var ListingTile$1 = /*#__PURE__*/React__default.memo(ListingTile);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditListingWrapper = /*#__PURE__*/function (_Component) {
  _inherits$1(EditListingWrapper, _Component);

  var _super = _createSuper$1(EditListingWrapper);

  function EditListingWrapper(props) {
    var _this;

    _classCallCheck$1(this, EditListingWrapper);

    _this = _super.call(this, props);
    _this.modalWidth = 153;
    return _this;
  }

  _createClass$1(EditListingWrapper, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(Portal$2, {
        nodename: "edit_listing"
      }, /*#__PURE__*/React__default.createElement("aside", {
        role: "dialog",
        tabIndex: "-1",
        "aria-modal": "true",
        className: "edit-modal-cover"
      }, /*#__PURE__*/React__default.createElement(EditListing, {
        selectedData: this.props.selectedData,
        uploadToS3: this.props.uploadToS3,
        deleteFromS3: this.props.deleteFromS3,
        openEditListing: this.props.openEditListing,
        onChange: this.props.onChange
      })));
    }
  }]);

  return EditListingWrapper;
}(Component);

EditListingWrapper.propTypes = {
  selectedData: PropTypes.object,
  uploadToS3: PropTypes.func,
  deleteFromS3: PropTypes.func,
  openEditListing: PropTypes.func.isRequired,
  onChange: PropTypes.func
};

var css_248z$4 = ".webviewer__wrapper {\n  width: 100%;\n  height: 100%;\n  border-radius: 6px;\n  box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1; }\n  .webviewer__wrapper embed {\n    width: 100%;\n    height: 100%;\n    border-radius: 6px; }\n\n.webviewer__wrapper__fullscreen {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1; }\n  .webviewer__wrapper__fullscreen embed {\n    width: 100%;\n    height: 100%;\n    border-radius: 6px; }\n";
styleInject(css_248z$4);

var cancelFullScreen = function cancelFullScreen() {
  if (document.cancelFullScreen) {
    document.cancelFullScreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  }
};

var gotoFullScreen = function gotoFullScreen() {
  if (document.fullScreenElement && document.fullScreenElement !== null || !document.mozFullScreen && !document.webkitIsFullScreen) {
    if (document.documentElement.requestFullScreen) {
      document.documentElement.requestFullScreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullScreen) {
      document.documentElement.webkitRequestFullScreen();
    }
  }
};

var WebviewerWrapper = function WebviewerWrapper(props) {
  var isFullScreen = false;

  var _useState = useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      token = _useState2[0],
      setToken = _useState2[1];

  var fullScreenWrapper = useCallback(function () {
    if (!isFullScreen) {
      isFullScreen = true;

      if (!(API.getBrowserName().toLowerCase() === "safari")) {
        var documentElement = document.getElementById("webviewer__wrapper__");
        documentElement.className = "webviewer__wrapper__fullscreen";
      }

      gotoFullScreen();
    } else {
      isFullScreen = false;

      if (!(API.getBrowserName().toLowerCase() === "safari")) {
        var _documentElement = document.getElementById("webviewer__wrapper__");

        _documentElement.className = "webviewer__wrapper";
      }

      cancelFullScreen();
    }
  }, []);

  var attachedEventForFullScreenToggle = function attachedEventForFullScreenToggle() {
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
    eventer(messageEvent, function (e) {
      if (e.data === "fullscreen_button_clicked" || e.message === "fullscreen_button_clicked") {
        fullScreenWrapper();
      }
    }, false);
  };

  useEffect(function () {
    attachedEventForFullScreenToggle(); // eslint-disable-next-line no-undef

    var requestObject = new HttpService(process.env.baseAPIPath);

    if (!props.hasToken) {
      requestObject.get("listings/get_listing_webviewer_token?listing_id=".concat(props.listing_id, "&origin=website"), function (response) {
        if (get(response, "data.success", false)) {
          var generatedToken = get(response, "data.data.token", false);
          setToken(generatedToken);
        }
      });
    } else {
      setToken(props.listing_id);
    }

    return function () {
      var eventMethod = window.addEventListener ? "removeEventListener" : "removeEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
      eventer(messageEvent, function (e) {
        if (e.data === "fullscreen_button_clicked" || e.message === "fullscreen_button_clicked") {
          fullScreenWrapper();
        }
      }, false);
    };
  }, [props.listing_id]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "webviewer__wrapper",
    title: "webviewer__wrapper",
    id: "webviewer__wrapper__"
  }, token && /*#__PURE__*/React__default.createElement("embed", {
    src: "".concat(process.env.listingsAppUrl, "viewer?token=").concat(token, "&showListingDetails=").concat(props.showListingsDetails, "&isModal=true&inModalBackButtonOff=").concat(props.inModalBackButtonOff, "&is_amenity=").concat(props.isAmenity)
  }) || null);
};

WebviewerWrapper.defaultProps = {
  hasToken: false,
  showListingsDetails: false,
  inModalBackButtonOff: false,
  isAmenity: false
};
WebviewerWrapper.propTypes = {
  listing_id: PropTypes.string.isRequired,
  hasToken: PropTypes.bool,
  showListingsDetails: PropTypes.bool,
  inModalBackButtonOff: PropTypes.bool,
  isAmenity: PropTypes.bool
};

var css_248z$3 = ".chip__wrapper {\n  font-family: Roboto;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 15px;\n  letter-spacing: 0em;\n  text-align: center;\n  padding: 6px 40px;\n  background: #FFFFFF;\n  box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1;\n  border-radius: 20px;\n  box-sizing: border-box;\n  cursor: pointer; }\n\n.isSelected {\n  border: solid 1px var(--blue); }\n";
styleInject(css_248z$3);

var Chip = function Chip(props) {
  return /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(props.isSelected && "isSelected" || "", " chip__wrapper"),
    onClick: function onClick() {
      return props.clickCallback && props.clickCallback();
    }
  }, props.label);
};

Chip.defaultProps = {
  isSelected: false
};
Chip.propTypes = {
  label: PropTypes.string.isRequired,
  clickCallback: PropTypes.func,
  isSelected: PropTypes.bool
};

var css_248z$2 = ".charot, .slider .right_amenity, .slider .left_amenity {\n  position: absolute;\n  cursor: pointer;\n  color: #04D2C6;\n  font-size: 1.5em;\n  background-color: #fff;\n  z-index: 1; }\n\n.slider {\n  width: auto;\n  line-height: 33px;\n  border-radius: 15px;\n  background-color: #fff;\n  display: flex;\n  overflow: auto;\n  position: relative;\n  background: #FFFFFF;\n  box-shadow: 0px 2px 5px #EBEFF1, 0px 0px 20px #EBEFF1;\n  border-radius: 50px;\n  padding: 0 1em;\n  justify-content: flex-start;\n  align-items: flex-end; }\n  .slider .right_amenity {\n    right: 1em; }\n  .slider .amenities_div {\n    display: flex;\n    flex-basis: 95%;\n    overflow: auto;\n    overflow-x: hidden;\n    gap: 20px; }\n    .slider .amenities_div .amenity_name {\n      position: relative;\n      font-family: Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n      font-style: normal;\n      font-weight: normal;\n      font-size: 15px;\n      line-height: 18px;\n      color: #1D1C38;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n      flex-shrink: 0;\n      flex-grow: 0.04;\n      text-transform: capitalize; }\n      .slider .amenities_div .amenity_name .bar_indicator {\n        width: 35px;\n        height: 3px;\n        position: absolute; }\n    .slider .amenities_div .selected {\n      border-top: 2px solid #04D2C6; }\n";
styleInject(css_248z$2);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Slider = /*#__PURE__*/function (_Component) {
  _inherits$1(Slider, _Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck$1(this, Slider);

    _this = _super.call(this, props);
    _this.state = {
      leftScroll: 0,
      showRightScroll: false,
      amenity: get$1(_this.props, "firstAmenity", "")
    };
    _this.sliderRef = /*#__PURE__*/React__default.createRef();
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized$3(_this));
    _this.resetAmenitySelection = _this.resetAmenitySelection.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$1(Slider, [{
    key: "convertToLowerCase",
    value: function convertToLowerCase() {
      var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      string = string && string.toLowerCase() || "";
      string = string.charAt(0).toUpperCase() + string.slice(1);
      return string;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (get$1(this.props, "data", false).length > 0) {
        if (this.sliderRef && this.sliderRef.current) {
          var scrollWidth = parseInt(this.sliderRef.current.scrollWidth);
          var clientWidth = parseInt(this.sliderRef.current.clientWidth);
          var scrollLeft = parseInt(this.sliderRef.current.scrollLeft);

          if (scrollWidth !== clientWidth && scrollLeft === 0) {
            this.setState({
              showRightScroll: true
            });
          }
        }
      }
    }
  }, {
    key: "resetAmenitySelection",
    value: function resetAmenitySelection() {
      this.setState({
        amenity: ""
      });
    }
  }, {
    key: "onSelect",
    value: function onSelect(key) {
      var _this2 = this;

      this.props.data.forEach(function (amenity, index) {
        if (parseInt(key) === index) {
          _this2.props.onChange(index);

          _this2.setState({
            amenity: amenity[_this2.props.amenityKey]
          });
        }
      });
    }
  }, {
    key: "scrollToLeft",
    value: function scrollToLeft() {
      var parent = this.sliderRef.current;
      parent.scrollLeft = parent.scrollLeft + 200;
      var scrollToLeft = parent.scrollLeft;
      this.setState({
        leftScroll: scrollToLeft
      });
      var clientWidth = Math.ceil(parent.clientWidth);
      var scrollWidth = Math.ceil(parent.scrollWidth);

      if (parseInt(scrollToLeft) + clientWidth === scrollWidth) {
        this.setState({
          showRightScroll: false
        });
      }
    }
  }, {
    key: "scrollToRight",
    value: function scrollToRight() {
      var parent = this.sliderRef.current;
      parent.scrollLeft = parent.scrollLeft - 200;
      var scrollToLeft = parent.scrollLeft;
      this.setState({
        leftScroll: scrollToLeft
      });
      var clientWidth = Math.ceil(parent.clientWidth);
      var scrollWidth = Math.ceil(parent.scrollWidth);

      if (parseInt(scrollToLeft) + clientWidth !== scrollWidth) {
        this.setState({
          showRightScroll: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, get$1(this.props, "data", false).length > 0 && get$1(this.props, "amenityKey", false) && /*#__PURE__*/React__default.createElement("div", {
        className: "slider"
      }, this.state.leftScroll !== 0 && /*#__PURE__*/React__default.createElement("span", {
        style: {
          color: this.props.selectorColor || "#04D2C6"
        },
        onClick: function onClick() {
          return _this3.scrollToRight();
        },
        className: "left_amenity"
      }, /*#__PURE__*/React__default.createElement(MemoSvgChevronLeft, null)) || null, /*#__PURE__*/React__default.createElement("div", {
        className: "amenities_div",
        ref: this.sliderRef
      }, this.props.data.map(function (amenity, index) {
        return /*#__PURE__*/React__default.createElement("span", {
          key: index,
          onClick: function onClick() {
            _this3.onSelect(index);
          },
          className: "amenity_name"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "bar_indicator",
          style: {
            backgroundColor: _this3.state.amenity === amenity[_this3.props.amenityKey] ? _this3.props.selectorColor || "#04D2C6" : ""
          }
        }), /*#__PURE__*/React__default.createElement("span", {
          style: {
            padding: 10
          }
        }, _this3.convertToLowerCase(amenity[_this3.props.amenityKey])));
      })), this.state.showRightScroll && /*#__PURE__*/React__default.createElement("span", {
        style: {
          color: this.props.selectorColor || "#04D2C6"
        },
        onClick: function onClick() {
          return _this3.scrollToLeft();
        },
        className: "right_amenity"
      }, /*#__PURE__*/React__default.createElement(MemoSvgChevronRight, null)) || null) || null);
    }
  }]);

  return Slider;
}(Component);
Slider.propTypes = {
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  amenityKey: PropTypes.string,
  selectorColor: PropTypes.string,
  firstAmenity: PropTypes.string
};

var css_248z$1 = ".piiq.card {\n  width: inherit;\n  height: inherit;\n  background: white;\n  overflow: hidden;\n  position: absolute;\n  width: 106%;\n  height: 100%;\n  left: -3%;\n  right: -3%;\n  top: 0;\n  bottom: 0;\n  z-index: 99;\n  min-height: 265px;\n  padding: 15px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; }\n  .piiq.card .header {\n    height: 30px;\n    width: 100%;\n    border-radius: 15px;\n    position: relative;\n    overflow: hidden; }\n  .piiq.card .layout_dots {\n    padding: 10px 0;\n    display: flex;\n    justify-content: flex-end;\n    width: 100%; }\n    .piiq.card .layout_dots .all_dots {\n      display: flex; }\n      .piiq.card .layout_dots .all_dots .dots {\n        position: relative;\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        margin: 0 10px;\n        overflow: hidden; }\n        .piiq.card .layout_dots .all_dots .dots:last-child {\n          margin-right: 0; }\n  .piiq.card .blocks {\n    display: flex;\n    flex-direction: column;\n    width: 100%; }\n    .piiq.card .blocks .block {\n      height: 30px;\n      margin: 5px 0;\n      width: 100%;\n      border-radius: 5px;\n      position: relative;\n      overflow: hidden; }\n  .piiq.card .animatedLine {\n    animation: shine 1s linear infinite alternate; }\n\n@keyframes shine {\n  0% {\n    background-color: #d9d9d9; }\n  100% {\n    background-color: #f0f3f5; } }\n  .piiq.card .stripe_wrapper {\n    height: 1em;\n    border-radius: 10px;\n    width: 100%;\n    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);\n    overflow: hidden;\n    position: relative; }\n    .piiq.card .stripe_wrapper .stripe_box {\n      width: 2000px;\n      height: 1em;\n      background-image: repeating-linear-gradient(45deg, transparent, transparent 40px, #d6d6d6 40px, #d6d6d6 80px);\n      animation: slideLeft 30s linear infinite forwards; }\n  .piiq.card .loading_text {\n    text-align: center;\n    padding-top: 10px;\n    font-size: 14px;\n    display: inline-flex; }\n    .piiq.card .loading_text .dotsAnim {\n      position: relative; }\n      .piiq.card .loading_text .dotsAnim .dot_1, .piiq.card .loading_text .dotsAnim .dot_2, .piiq.card .loading_text .dotsAnim .dot_3 {\n        opacity: 0;\n        animation: showHideOpacity 3s linear infinite;\n        position: absolute;\n        bottom: -4px; }\n      .piiq.card .loading_text .dotsAnim .dot_1 {\n        left: 5px; }\n      .piiq.card .loading_text .dotsAnim .dot_2 {\n        animation-delay: 0.5s;\n        left: 10px; }\n      .piiq.card .loading_text .dotsAnim .dot_3 {\n        animation-delay: 1s;\n        left: 15px; }\n\n@keyframes showHideOpacity {\n  0% {\n    opacity: 0; }\n  33% {\n    opacity: 1; } }\n\n@keyframes slideLeft {\n  from {\n    background-position-x: 325px; }\n  to {\n    background-position-x: 2000px; } }\n\n.only_stripe.stripe_wrapper {\n  height: 1em;\n  border-radius: 10px;\n  width: 100%;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n  position: absolute;\n  max-width: 60%; }\n  .only_stripe.stripe_wrapper .stripe_box {\n    width: 2000px;\n    height: 1em;\n    background-image: repeating-linear-gradient(45deg, transparent, transparent 40px, #d6d6d6 40px, #d6d6d6 80px);\n    animation: slideLeft 30s linear infinite forwards; }\n";
styleInject(css_248z$1);

var Loader = function Loader(props) {
  var dotCount = Array(get(props, "layout_dot_count", 0)).fill(0);
  var blockCount = Array(get(props, "blocks_count", 0)).fill(0);
  return !get(props, "onlyStripe", true) && /*#__PURE__*/React__default.createElement("div", {
    className: "piiq card"
  }, get(props, "skeletonLoader", true) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, get(props, "show_search_block", true) && /*#__PURE__*/React__default.createElement("div", {
    className: "header animatedLine"
  }) || null, get(props, "allow_layout_dots", true) && /*#__PURE__*/React__default.createElement("div", {
    className: "layout_dots"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "all_dots"
  }, dotCount.map(function () {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "dots animatedLine"
    });
  }))) || null, /*#__PURE__*/React__default.createElement("div", {
    className: "blocks"
  }, blockCount.map(function () {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "block animatedLine"
    });
  }))) || null, !get(props, "skeletonLoader", true) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "stripe_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "stripe_box"
  })), get(props, "progress_bar_text", "Loading") && /*#__PURE__*/React__default.createElement("span", {
    className: "loading_text"
  }, get(props, "progress_bar_text", "Loading"), get(props, "show_loading_dots", false) && /*#__PURE__*/React__default.createElement("div", {
    className: "dotsAnim"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "dot_1"
  }, "\u2022"), /*#__PURE__*/React__default.createElement("span", {
    className: "dot_2"
  }, "\u2022"), /*#__PURE__*/React__default.createElement("span", {
    className: "dot_3"
  }, "\u2022")) || null) || null) || null) || /*#__PURE__*/React__default.createElement("div", {
    className: "stripe_wrapper only_stripe"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "stripe_box"
  }));
};
Loader.defaultProps = {
  show_search_block: false,
  allow_layout_dots: false,
  blocks_count: 4,
  layout_dot_count: 3,
  skeletonLoader: false,
  progress_bar_text: "Loading",
  show_loading_dots: false,
  onlyStripe: true
};

var css_248z = ".nearby__input_wrapper {\n  max-width: 250px; }\n  .nearby__input_wrapper .listing-input.input-description {\n    font-size: 14px;\n    line-height: 14px; }\n  .nearby__input_wrapper .autocomplete-dropdown-container {\n    max-width: 250px;\n    box-sizing: border-box; }\n    .nearby__input_wrapper .autocomplete-dropdown-container .loading__text {\n      font-size: 12px; }\n";
styleInject(css_248z);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var GoogleSearch = function GoogleSearch(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude,
      title = _ref.title,
      onAddressSelect = _ref.onAddressSelect,
      initialObj = _ref.initialObj;

  var _useState = useState(initialObj),
      _useState2 = _slicedToArray$1(_useState, 2),
      searchVal = _useState2[0],
      setSearchVal = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      isAddressLoading = _useState4[0],
      setIsAddressLoading = _useState4[1];

  function getPostalSuggestions(suggestions) {
    var suggestionsList = [];

    if (suggestions && suggestions.length > 0) {
      suggestions.map(function (suggestion) {
        if (!suggestion.types.includes("route") || get$1(suggestion, "place_id", "")) {
          suggestionsList.push(suggestion);
        }
      });
    }

    return suggestionsList;
  }

  function getInputIcon() {
    var iconObj = {
      "Grocery": /*#__PURE__*/React__default.createElement(MemoSvgShoppingCart, null),
      "Park": /*#__PURE__*/React__default.createElement(MemoSvgSun, null),
      "Gym": /*#__PURE__*/React__default.createElement(MemoSvgGym, null)
    };
    return iconObj[title];
  }

  function handleChange(address) {
    setSearchVal(_objectSpread(_objectSpread({}, searchVal), {}, {
      name: address
    }));
  }

  function generateRoute(mode, targetLatitude, targetLongitude, googleApiKey) {
    return "https://router.hereapi.com/v8/routes?transportMode=".concat(mode, "&origin=").concat(latitude, ",").concat(longitude, "&destination=").concat(targetLatitude, ",").concat(targetLongitude, "&return=summary&apiKey=").concat(googleApiKey);
  }

  function callWalkCarDistance(route) {
    return fetch(route, {
      method: "GET",
      "Content-Type": "application/json"
    }).then(function (res) {
      return res.json();
    });
  }

  function getWalkCarDuration(data) {
    var routeData = data && data.routes && data.routes.length && data.routes[0] || null;
    var sectionData = routeData && routeData.sections && routeData.sections.length && routeData.sections[0] || null;
    var summary = sectionData && sectionData.summary || null;
    return summary;
  }

  function handleSelect(address) {
    setIsAddressLoading(true);
    var modifiedAddress = address.split(",")[0];
    setSearchVal(_objectSpread(_objectSpread({}, searchVal), {}, {
      name: modifiedAddress
    }));
    dist_3(address).then(function (results) {
      dist_1(results[0]).then(function (res) {
        // eslint-disable-next-line no-undef
        var googleApiKey = process.env.hereApiKey;
        var configRouteWalk = generateRoute("pedestrian", res.lat, res.lng, googleApiKey);
        var configRouteCar = generateRoute("car", res.lat, res.lng, googleApiKey);
        Promise.all([callWalkCarDistance(configRouteWalk), callWalkCarDistance(configRouteCar)]).then(function (response) {
          var _response = _slicedToArray$1(response, 2),
              walkDistance = _response[0],
              carDistance = _response[1];

          walkDistance = getWalkCarDuration(walkDistance);
          carDistance = getWalkCarDuration(carDistance);
          var nearbyData = {
            name: modifiedAddress,
            driving_duration: carDistance.duration,
            walking_duration: walkDistance.duration,
            latitude: JSON.stringify(res.lat),
            longitude: JSON.stringify(res.lng)
          };
          var nearbyDataPayload = {
            name: modifiedAddress,
            latitude: JSON.stringify(res.lat),
            longitude: JSON.stringify(res.lng)
          };
          setSearchVal(nearbyData);
          onAddressSelect(nearbyDataPayload);
          setIsAddressLoading(false);
        })["catch"](function (err) {
          window.console.log(err);
          window.postMessage({
            type: "notification",
            msg: "Error while fetching distance data"
          });
          var nearbyData = {
            name: modifiedAddress,
            driving_duration: "",
            walking_duration: "",
            latitude: JSON.stringify(res.lat),
            longitude: JSON.stringify(res.lng)
          };
          var nearbyDataPayload = {
            name: modifiedAddress,
            latitude: JSON.stringify(res.lat),
            longitude: JSON.stringify(res.lng)
          };
          setSearchVal(nearbyData);
          onAddressSelect(nearbyDataPayload);
          setIsAddressLoading(false);
        });
      })["catch"](function (err) {
        return window.console.log(err);
      });
    })["catch"](function (err) {
      return window.console.log(err);
    });
  }

  function getMin(duration) {
    return API.timeConvertor(duration);
  }

  return /*#__PURE__*/React__default.createElement("section", {
    className: "nearby__input_wrapper"
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "",
    className: "nearby__label"
  }, title), /*#__PURE__*/React__default.createElement("span", {
    className: "nearby__input"
  }, /*#__PURE__*/React__default.createElement(PlacesAutocomplete, {
    value: searchVal.name,
    onChange: handleChange,
    onSelect: handleSelect,
    debounce: 750,
    searchOptions: {
      componentRestrictions: {
        country: API.countryCodes
      }
    }
  }, function (_ref2) {
    var getInputProps = _ref2.getInputProps,
        suggestions = _ref2.suggestions,
        getSuggestionItemProps = _ref2.getSuggestionItemProps,
        loading = _ref2.loading;
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
      className: "listing-span"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "listing-input-icon"
    }, getInputIcon()), /*#__PURE__*/React__default.createElement("input", _extends$4({}, getInputProps({
      placeholder: title,
      className: "location-search-input"
    }), {
      className: "listing-input"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "autocomplete-dropdown-container"
    }, loading && /*#__PURE__*/React__default.createElement("div", {
      className: "loading__text"
    }, "Loading..."), getPostalSuggestions(suggestions) && getPostalSuggestions(suggestions).map(function (suggestion, index) {
      var className = suggestion.active ? "suggestion-item--active" : "suggestion-item";
      var style = suggestion.active ? {
        backgroundColor: "#fafafa",
        cursor: "pointer"
      } : {
        backgroundColor: "#ffffff",
        cursor: "pointer"
      };
      return /*#__PURE__*/React__default.createElement("div", _extends$4({}, getSuggestionItemProps(suggestion, {
        className: className,
        style: style
      }), {
        key: index
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "listing-input input-description"
      }, suggestion.description));
    })));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "nearby__distance"
  }, isAddressLoading && /*#__PURE__*/React__default.createElement(Loader, null) || /*#__PURE__*/React__default.createElement("div", {
    className: "nearby__icons"
  }, searchVal.driving_duration && /*#__PURE__*/React__default.createElement("span", {
    className: "nearby__drive"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React__default.createElement(MemoSvgDrive, null)), getMin(searchVal.driving_duration)) || null, searchVal.walking_duration && /*#__PURE__*/React__default.createElement("span", {
    className: "nearby__walk"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React__default.createElement(MemoSvgWalk, null)), getMin(searchVal.walking_duration)) || null)));
};

GoogleSearch.propTypes = {
  latitude: PropTypes.string,
  longitude: PropTypes.string,
  title: PropTypes.string,
  onAddressSelect: PropTypes.func,
  initialObj: PropTypes.object
};

String.prototype.convertToRGB = function () {
  var aRgbHex = this.match(/.{1,2}/g);
  var rgb = [parseInt(aRgbHex[0], 16), parseInt(aRgbHex[1], 16), parseInt(aRgbHex[2], 16)];
  return rgb;
};

(function () {
  var handleScroll = function handleScroll(e) {
    var timeInterval = 2000;

    if (e.target.classList) {
      if (e.target.classList.contains("on-scrollbar") === false) {
        e.target.classList.add("on-scrollbar");
      } else {
        var setT = setTimeout(function () {
          clearTimeout(setT);
          e.target.classList.remove("on-scrollbar");
        }, timeInterval);
      }
    } else {
      var elem = e.target.querySelector("body");

      if (elem) {
        elem.style.overflowX = "hidden";

        if (elem.scrollHeight - elem.scrollTop !== elem.clientHeight) {
          return;
        }

        if (elem.classList.contains("on-scrollbar") === false) {
          elem.classList.add("on-scrollbar");
        } else {
          var _setT = setTimeout(function () {
            clearTimeout(_setT);
            elem.classList.remove("on-scrollbar");
          }, timeInterval);
        }
      }
    }
  };

  window.addEventListener("scroll", handleScroll, true);
})();

export { API, Accordion, ActionMenu, Slider as AmenitySlider, Button$2 as Button, CheckBox$1 as CheckBox, Chip, ColorPicker$1 as ColorPicker, DataList$1 as DataList, DataTitle$1 as DataTitle, Datepicker, DeletePromotionDialog, ListingViews$1 as DonutChartForViewSource, Dropdown$1 as Dropdown, EditListing, EditListingWrapper, EditProfileCard, ErrorHandler, FileUploader, GoogleSearch, Grid, HttpService, Icon, Input$2 as Input, ListingTile$1 as ListingTile, ListingsDetails, loader as Loader, Login, MultipleSelect, NamedProfile, NotificationWrapper, PassiveSearchField$1 as PassiveSearchField, PeekBarChart$1 as PeekBarChart, PeekPieChart, Portal$2 as Portal, Profile, ProfileCard, PromoteDialog, RadioSelector, ResetPassword$1 as ResetPassword, SearchbarSuggestion$1 as SearchbarSuggestion, Sensex, SimpleBarChart, SkeletonLoader, Spinner, StackedBarChart, StaticCalander, SymboledTextField$1 as SymboledTextField, Tab$1 as Tab, Tabs as TabsContainer, TemplateNavigationForm, TextArea, TextField$3 as TextField, TimeSeries$1 as TimeSeries, Toggle$1 as Toggle, WebviewerWrapper, WelcomeOnBoard, copyTextToClipboard };
